var Pve = Object.defineProperty, Nve = Object.defineProperties;
var Tve = Object.getOwnPropertyDescriptors;
var dS = Object.getOwnPropertySymbols;
var oB = Object.prototype.hasOwnProperty, iB = Object.prototype.propertyIsEnumerable;
var Ek = (e, t, n) => t in e ? Pve(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Fe = (e, t) => {
  for (var n in t || (t = {}))
    oB.call(t, n) && Ek(e, n, t[n]);
  if (dS)
    for (var n of dS(t))
      iB.call(t, n) && Ek(e, n, t[n]);
  return e;
}, Xn = (e, t) => Nve(e, Tve(t));
var u0 = (e, t) => {
  var n = {};
  for (var r in e)
    oB.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && dS)
    for (var r of dS(e))
      t.indexOf(r) < 0 && iB.call(e, r) && (n[r] = e[r]);
  return n;
};
var Er = (e, t, n) => Ek(e, typeof t != "symbol" ? t + "" : t, n);
var st = (e, t, n) => new Promise((r, a) => {
  var o = (u) => {
    try {
      c(n.next(u));
    } catch (f) {
      a(f);
    }
  }, s = (u) => {
    try {
      c(n.throw(u));
    } catch (f) {
      a(f);
    }
  }, c = (u) => u.done ? r(u.value) : Promise.resolve(u.value).then(o, s);
  c((n = n.apply(e, t)).next());
});
import * as k from "react";
import vo, { createElement as M0, isValidElement as b7, cloneElement as fS, createContext as LJ, useContext as Zp, useState as mt, useRef as Yo, useEffect as mn, forwardRef as vR, useLayoutEffect as $J, useMemo as k0, useCallback as Yi, Component as Nc, Fragment as UN } from "react";
import { useDispatch as Jo, useSelector as wr, connect as V6 } from "react-redux";
function Ove(e, t) {
  for (var n = 0; n < t.length; n++) {
    const r = t[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const a in r)
        if (a !== "default" && !(a in e)) {
          const o = Object.getOwnPropertyDescriptor(r, a);
          o && Object.defineProperty(e, a, o.get ? o : {
            enumerable: !0,
            get: () => r[a]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function Ki(e) {
  "@babel/helpers - typeof";
  return Ki = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ki(e);
}
function Fu(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Rve(e, t) {
  if (Ki(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ki(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function jJ(e) {
  var t = Rve(e, "string");
  return Ki(t) == "symbol" ? t : t + "";
}
function sB(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, jJ(r.key), r);
  }
}
function Bu(e, t, n) {
  return t && sB(e.prototype, t), n && sB(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Am(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function GN(e, t) {
  return GN = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, GN(e, t);
}
function E_(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && GN(e, t);
}
function E2(e, t) {
  if (t && (Ki(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Am(e);
}
function Ac(e) {
  return Ac = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Ac(e);
}
function fs(e, t, n) {
  return (t = jJ(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function FJ(e) {
  if (Array.isArray(e)) return e;
}
function BJ(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function zN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function gR(e, t) {
  if (e) {
    if (typeof e == "string") return zN(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? zN(e, t) : void 0;
  }
}
function VJ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mve(e) {
  return FJ(e) || BJ(e) || gR(e) || VJ();
}
function lB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function uB(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lB(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Dve = {
  type: "logger",
  log: function(t) {
    this.output("log", t);
  },
  warn: function(t) {
    this.output("warn", t);
  },
  error: function(t) {
    this.output("error", t);
  },
  output: function(t, n) {
    console && console[t] && console[t].apply(console, n);
  }
}, Lve = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Fu(this, e), this.init(t, n);
  }
  return Bu(e, [{
    key: "init",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = r.prefix || "i18next:", this.logger = n || Dve, this.options = r, this.debug = r.debug;
    }
  }, {
    key: "setDebug",
    value: function(n) {
      this.debug = n;
    }
  }, {
    key: "log",
    value: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return this.forward(r, "log", "", !0);
    }
  }, {
    key: "warn",
    value: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return this.forward(r, "warn", "", !0);
    }
  }, {
    key: "error",
    value: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return this.forward(r, "error", "");
    }
  }, {
    key: "deprecate",
    value: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return this.forward(r, "warn", "WARNING DEPRECATED: ", !0);
    }
  }, {
    key: "forward",
    value: function(n, r, a, o) {
      return o && !this.debug ? null : (typeof n[0] == "string" && (n[0] = "".concat(a).concat(this.prefix, " ").concat(n[0])), this.logger[r](n));
    }
  }, {
    key: "create",
    value: function(n) {
      return new e(this.logger, uB(uB({}, {
        prefix: "".concat(this.prefix, ":").concat(n, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function(n) {
      return n = n || this.options, n.prefix = n.prefix || this.prefix, new e(this.logger, n);
    }
  }]), e;
}(), Ef = new Lve(), Dm = function() {
  function e() {
    Fu(this, e), this.observers = {};
  }
  return Bu(e, [{
    key: "on",
    value: function(n, r) {
      var a = this;
      return n.split(" ").forEach(function(o) {
        a.observers[o] = a.observers[o] || [], a.observers[o].push(r);
      }), this;
    }
  }, {
    key: "off",
    value: function(n, r) {
      if (this.observers[n]) {
        if (!r) {
          delete this.observers[n];
          return;
        }
        this.observers[n] = this.observers[n].filter(function(a) {
          return a !== r;
        });
      }
    }
  }, {
    key: "emit",
    value: function(n) {
      for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
        a[o - 1] = arguments[o];
      if (this.observers[n]) {
        var s = [].concat(this.observers[n]);
        s.forEach(function(u) {
          u.apply(void 0, a);
        });
      }
      if (this.observers["*"]) {
        var c = [].concat(this.observers["*"]);
        c.forEach(function(u) {
          u.apply(u, [n].concat(a));
        });
      }
    }
  }]), e;
}();
function K3() {
  var e, t, n = new Promise(function(r, a) {
    e = r, t = a;
  });
  return n.resolve = e, n.reject = t, n;
}
function cB(e) {
  return e == null ? "" : "" + e;
}
function $ve(e, t, n) {
  e.forEach(function(r) {
    t[r] && (n[r] = t[r]);
  });
}
function yR(e, t, n) {
  function r(c) {
    return c && c.indexOf("###") > -1 ? c.replace(/###/g, ".") : c;
  }
  function a() {
    return !e || typeof e == "string";
  }
  for (var o = typeof t != "string" ? [].concat(t) : t.split("."); o.length > 1; ) {
    if (a()) return {};
    var s = r(o.shift());
    !e[s] && n && (e[s] = new n()), Object.prototype.hasOwnProperty.call(e, s) ? e = e[s] : e = {};
  }
  return a() ? {} : {
    obj: e,
    k: r(o.shift())
  };
}
function dB(e, t, n) {
  var r = yR(e, t, Object), a = r.obj, o = r.k;
  a[o] = n;
}
function jve(e, t, n, r) {
  var a = yR(e, t, Object), o = a.obj, s = a.k;
  o[s] = o[s] || [], o[s].push(n);
}
function _7(e, t) {
  var n = yR(e, t), r = n.obj, a = n.k;
  if (r)
    return r[a];
}
function Fve(e, t, n) {
  var r = _7(e, n);
  return r !== void 0 ? r : _7(t, n);
}
function UJ(e, t, n) {
  for (var r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? typeof e[r] == "string" || e[r] instanceof String || typeof t[r] == "string" || t[r] instanceof String ? n && (e[r] = t[r]) : UJ(e[r], t[r], n) : e[r] = t[r]);
  return e;
}
function iy(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var Bve = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function Vve(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, function(t) {
    return Bve[t];
  }) : e;
}
var U6 = typeof window != "undefined" && window.navigator && typeof window.navigator.userAgentData == "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1, Uve = [" ", ",", "?", "!", ";"];
function Gve(e, t, n) {
  t = t || "", n = n || "";
  var r = Uve.filter(function(c) {
    return t.indexOf(c) < 0 && n.indexOf(c) < 0;
  });
  if (r.length === 0) return !0;
  var a = new RegExp("(".concat(r.map(function(c) {
    return c === "?" ? "\\?" : c;
  }).join("|"), ")")), o = !a.test(e);
  if (!o) {
    var s = e.indexOf(n);
    s > 0 && !a.test(e.substring(0, s)) && (o = !0);
  }
  return o;
}
function C7(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (e) {
    if (e[t]) return e[t];
    for (var r = t.split(n), a = e, o = 0; o < r.length; ++o) {
      if (!a || typeof a[r[o]] == "string" && o + 1 < r.length)
        return;
      if (a[r[o]] === void 0) {
        for (var s = 2, c = r.slice(o, o + s).join(n), u = a[c]; u === void 0 && r.length > o + s; )
          s++, c = r.slice(o, o + s).join(n), u = a[c];
        if (u === void 0) return;
        if (u === null) return null;
        if (t.endsWith(c)) {
          if (typeof u == "string") return u;
          if (c && typeof u[c] == "string") return u[c];
        }
        var f = r.slice(o + s).join(n);
        return f ? C7(u, f, n) : void 0;
      }
      a = a[r[o]];
    }
    return a;
  }
}
function fB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function pS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fB(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function zve(e) {
  var t = Hve();
  return function() {
    var r = Ac(e), a;
    if (t) {
      var o = Ac(this).constructor;
      a = Reflect.construct(r, arguments, o);
    } else
      a = r.apply(this, arguments);
    return E2(this, a);
  };
}
function Hve() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch (e) {
    return !1;
  }
}
var Wve = function(e) {
  E_(n, e);
  var t = zve(n);
  function n(r) {
    var a, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    return Fu(this, n), a = t.call(this), U6 && Dm.call(Am(a)), a.data = r || {}, a.options = o, a.options.keySeparator === void 0 && (a.options.keySeparator = "."), a.options.ignoreJSONStructure === void 0 && (a.options.ignoreJSONStructure = !0), a;
  }
  return Bu(n, [{
    key: "addNamespaces",
    value: function(a) {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }
  }, {
    key: "removeNamespaces",
    value: function(a) {
      var o = this.options.ns.indexOf(a);
      o > -1 && this.options.ns.splice(o, 1);
    }
  }, {
    key: "getResource",
    value: function(a, o, s) {
      var c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, u = c.keySeparator !== void 0 ? c.keySeparator : this.options.keySeparator, f = c.ignoreJSONStructure !== void 0 ? c.ignoreJSONStructure : this.options.ignoreJSONStructure, m = [a, o];
      s && typeof s != "string" && (m = m.concat(s)), s && typeof s == "string" && (m = m.concat(u ? s.split(u) : s)), a.indexOf(".") > -1 && (m = a.split("."));
      var v = _7(this.data, m);
      return v || !f || typeof s != "string" ? v : C7(this.data && this.data[a] && this.data[a][o], s, u);
    }
  }, {
    key: "addResource",
    value: function(a, o, s, c) {
      var u = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: !1
      }, f = u.keySeparator !== void 0 ? u.keySeparator : this.options.keySeparator, m = [a, o];
      s && (m = m.concat(f ? s.split(f) : s)), a.indexOf(".") > -1 && (m = a.split("."), c = o, o = m[1]), this.addNamespaces(o), dB(this.data, m, c), u.silent || this.emit("added", a, o, s, c);
    }
  }, {
    key: "addResources",
    value: function(a, o, s) {
      var c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: !1
      };
      for (var u in s)
        (typeof s[u] == "string" || Object.prototype.toString.apply(s[u]) === "[object Array]") && this.addResource(a, o, u, s[u], {
          silent: !0
        });
      c.silent || this.emit("added", a, o, s);
    }
  }, {
    key: "addResourceBundle",
    value: function(a, o, s, c, u) {
      var f = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: !1
      }, m = [a, o];
      a.indexOf(".") > -1 && (m = a.split("."), c = s, s = o, o = m[1]), this.addNamespaces(o);
      var v = _7(this.data, m) || {};
      c ? UJ(v, s, u) : v = pS(pS({}, v), s), dB(this.data, m, v), f.silent || this.emit("added", a, o, s);
    }
  }, {
    key: "removeResourceBundle",
    value: function(a, o) {
      this.hasResourceBundle(a, o) && delete this.data[a][o], this.removeNamespaces(o), this.emit("removed", a, o);
    }
  }, {
    key: "hasResourceBundle",
    value: function(a, o) {
      return this.getResource(a, o) !== void 0;
    }
  }, {
    key: "getResourceBundle",
    value: function(a, o) {
      return o || (o = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? pS(pS({}, {}), this.getResource(a, o)) : this.getResource(a, o);
    }
  }, {
    key: "getDataByLanguage",
    value: function(a) {
      return this.data[a];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function(a) {
      var o = this.getDataByLanguage(a), s = o && Object.keys(o) || [];
      return !!s.find(function(c) {
        return o[c] && Object.keys(o[c]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      return this.data;
    }
  }]), n;
}(Dm), GJ = {
  processors: {},
  addPostProcessor: function(t) {
    this.processors[t.name] = t;
  },
  handle: function(t, n, r, a, o) {
    var s = this;
    return t.forEach(function(c) {
      s.processors[c] && (n = s.processors[c].process(n, r, a, o));
    }), n;
  }
};
function pB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function il(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pB(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Zve(e) {
  var t = Yve();
  return function() {
    var r = Ac(e), a;
    if (t) {
      var o = Ac(this).constructor;
      a = Reflect.construct(r, arguments, o);
    } else
      a = r.apply(this, arguments);
    return E2(this, a);
  };
}
function Yve() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch (e) {
    return !1;
  }
}
var hB = {}, mB = function(e) {
  E_(n, e);
  var t = Zve(n);
  function n(r) {
    var a, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Fu(this, n), a = t.call(this), U6 && Dm.call(Am(a)), $ve(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], r, Am(a)), a.options = o, a.options.keySeparator === void 0 && (a.options.keySeparator = "."), a.logger = Ef.create("translator"), a;
  }
  return Bu(n, [{
    key: "changeLanguage",
    value: function(a) {
      a && (this.language = a);
    }
  }, {
    key: "exists",
    value: function(a) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      if (a == null)
        return !1;
      var s = this.resolve(a, o);
      return s && s.res !== void 0;
    }
  }, {
    key: "extractFromKey",
    value: function(a, o) {
      var s = o.nsSeparator !== void 0 ? o.nsSeparator : this.options.nsSeparator;
      s === void 0 && (s = ":");
      var c = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, u = o.ns || this.options.defaultNS || [], f = s && a.indexOf(s) > -1, m = !this.options.userDefinedKeySeparator && !o.keySeparator && !this.options.userDefinedNsSeparator && !o.nsSeparator && !Gve(a, s, c);
      if (f && !m) {
        var v = a.match(this.interpolator.nestingRegexp);
        if (v && v.length > 0)
          return {
            key: a,
            namespaces: u
          };
        var y = a.split(s);
        (s !== c || s === c && this.options.ns.indexOf(y[0]) > -1) && (u = y.shift()), a = y.join(c);
      }
      return typeof u == "string" && (u = [u]), {
        key: a,
        namespaces: u
      };
    }
  }, {
    key: "translate",
    value: function(a, o, s) {
      var c = this;
      if (Ki(o) !== "object" && this.options.overloadTranslationOptionHandler && (o = this.options.overloadTranslationOptionHandler(arguments)), Ki(o) === "object" && (o = il({}, o)), o || (o = {}), a == null) return "";
      Array.isArray(a) || (a = [String(a)]);
      var u = o.returnDetails !== void 0 ? o.returnDetails : this.options.returnDetails, f = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, m = this.extractFromKey(a[a.length - 1], o), v = m.key, y = m.namespaces, b = y[y.length - 1], S = o.lng || this.language, x = o.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (S && S.toLowerCase() === "cimode") {
        if (x) {
          var E = o.nsSeparator || this.options.nsSeparator;
          return u ? {
            res: "".concat(b).concat(E).concat(v),
            usedKey: v,
            exactUsedKey: v,
            usedLng: S,
            usedNS: b
          } : "".concat(b).concat(E).concat(v);
        }
        return u ? {
          res: v,
          usedKey: v,
          exactUsedKey: v,
          usedLng: S,
          usedNS: b
        } : v;
      }
      var N = this.resolve(a, o), R = N && N.res, O = N && N.usedKey || v, D = N && N.exactUsedKey || v, $ = Object.prototype.toString.apply(R), B = ["[object Number]", "[object Function]", "[object RegExp]"], G = o.joinArrays !== void 0 ? o.joinArrays : this.options.joinArrays, Z = !this.i18nFormat || this.i18nFormat.handleAsObject, K = typeof R != "string" && typeof R != "boolean" && typeof R != "number";
      if (Z && R && K && B.indexOf($) < 0 && !(typeof G == "string" && $ === "[object Array]")) {
        if (!o.returnObjects && !this.options.returnObjects) {
          this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
          var q = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(O, R, il(il({}, o), {}, {
            ns: y
          })) : "key '".concat(v, " (").concat(this.language, ")' returned an object instead of string.");
          return u ? (N.res = q, N) : q;
        }
        if (f) {
          var pe = $ === "[object Array]", he = pe ? [] : {}, _e = pe ? D : O;
          for (var ge in R)
            if (Object.prototype.hasOwnProperty.call(R, ge)) {
              var Y = "".concat(_e).concat(f).concat(ge);
              he[ge] = this.translate(Y, il(il({}, o), {
                joinArrays: !1,
                ns: y
              })), he[ge] === Y && (he[ge] = R[ge]);
            }
          R = he;
        }
      } else if (Z && typeof G == "string" && $ === "[object Array]")
        R = R.join(G), R && (R = this.extendTranslation(R, a, o, s));
      else {
        var ee = !1, oe = !1, me = o.count !== void 0 && typeof o.count != "string", xe = n.hasDefaultValue(o), X = me ? this.pluralResolver.getSuffix(S, o.count, o) : "", ye = o["defaultValue".concat(X)] || o.defaultValue;
        !this.isValidLookup(R) && xe && (ee = !0, R = ye), this.isValidLookup(R) || (oe = !0, R = v);
        var ce = o.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey, se = ce && oe ? void 0 : R, Ie = xe && ye !== R && this.options.updateMissing;
        if (oe || ee || Ie) {
          if (this.logger.log(Ie ? "updateKey" : "missingKey", S, b, v, Ie ? ye : R), f) {
            var Le = this.resolve(v, il(il({}, o), {}, {
              keySeparator: !1
            }));
            Le && Le.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          var ie = [], $e = this.languageUtils.getFallbackCodes(this.options.fallbackLng, o.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && $e && $e[0])
            for (var we = 0; we < $e.length; we++)
              ie.push($e[we]);
          else this.options.saveMissingTo === "all" ? ie = this.languageUtils.toResolveHierarchy(o.lng || this.language) : ie.push(o.lng || this.language);
          var Ne = function(le, be, He) {
            var Ae = xe && He !== R ? He : se;
            c.options.missingKeyHandler ? c.options.missingKeyHandler(le, b, be, Ae, Ie, o) : c.backendConnector && c.backendConnector.saveMissing && c.backendConnector.saveMissing(le, b, be, Ae, Ie, o), c.emit("missingKey", le, b, be, R);
          };
          this.options.saveMissing && (this.options.saveMissingPlurals && me ? ie.forEach(function(Ee) {
            c.pluralResolver.getSuffixes(Ee, o).forEach(function(le) {
              Ne([Ee], v + le, o["defaultValue".concat(le)] || ye);
            });
          }) : Ne(ie, v, ye));
        }
        R = this.extendTranslation(R, a, o, N, s), oe && R === v && this.options.appendNamespaceToMissingKey && (R = "".concat(b, ":").concat(v)), (oe || ee) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? R = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(b, ":").concat(v) : v, ee ? R : void 0) : R = this.options.parseMissingKeyHandler(R));
      }
      return u ? (N.res = R, N) : R;
    }
  }, {
    key: "extendTranslation",
    value: function(a, o, s, c, u) {
      var f = this;
      if (this.i18nFormat && this.i18nFormat.parse)
        a = this.i18nFormat.parse(a, il(il({}, this.options.interpolation.defaultVariables), s), c.usedLng, c.usedNS, c.usedKey, {
          resolved: c
        });
      else if (!s.skipInterpolation) {
        s.interpolation && this.interpolator.init(il(il({}, s), {
          interpolation: il(il({}, this.options.interpolation), s.interpolation)
        }));
        var m = typeof a == "string" && (s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables), v;
        if (m) {
          var y = a.match(this.interpolator.nestingRegexp);
          v = y && y.length;
        }
        var b = s.replace && typeof s.replace != "string" ? s.replace : s;
        if (this.options.interpolation.defaultVariables && (b = il(il({}, this.options.interpolation.defaultVariables), b)), a = this.interpolator.interpolate(a, b, s.lng || this.language, s), m) {
          var S = a.match(this.interpolator.nestingRegexp), x = S && S.length;
          v < x && (s.nest = !1);
        }
        !s.lng && this.options.compatibilityAPI !== "v1" && c && c.res && (s.lng = c.usedLng), s.nest !== !1 && (a = this.interpolator.nest(a, function() {
          for (var R = arguments.length, O = new Array(R), D = 0; D < R; D++)
            O[D] = arguments[D];
          return u && u[0] === O[0] && !s.context ? (f.logger.warn("It seems you are nesting recursively key: ".concat(O[0], " in key: ").concat(o[0])), null) : f.translate.apply(f, O.concat([o]));
        }, s)), s.interpolation && this.interpolator.reset();
      }
      var E = s.postProcess || this.options.postProcess, N = typeof E == "string" ? [E] : E;
      return a != null && N && N.length && s.applyPostProcessor !== !1 && (a = GJ.handle(N, a, o, this.options && this.options.postProcessPassResolved ? il({
        i18nResolved: c
      }, s) : s, this)), a;
    }
  }, {
    key: "resolve",
    value: function(a) {
      var o = this, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c, u, f, m, v;
      return typeof a == "string" && (a = [a]), a.forEach(function(y) {
        if (!o.isValidLookup(c)) {
          var b = o.extractFromKey(y, s), S = b.key;
          u = S;
          var x = b.namespaces;
          o.options.fallbackNS && (x = x.concat(o.options.fallbackNS));
          var E = s.count !== void 0 && typeof s.count != "string", N = E && !s.ordinal && s.count === 0 && o.pluralResolver.shouldUseIntlApi(), R = s.context !== void 0 && (typeof s.context == "string" || typeof s.context == "number") && s.context !== "", O = s.lngs ? s.lngs : o.languageUtils.toResolveHierarchy(s.lng || o.language, s.fallbackLng);
          x.forEach(function(D) {
            o.isValidLookup(c) || (v = D, !hB["".concat(O[0], "-").concat(D)] && o.utils && o.utils.hasLoadedNamespace && !o.utils.hasLoadedNamespace(v) && (hB["".concat(O[0], "-").concat(D)] = !0, o.logger.warn('key "'.concat(u, '" for languages "').concat(O.join(", "), `" won't get resolved as namespace "`).concat(v, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), O.forEach(function($) {
              if (!o.isValidLookup(c)) {
                m = $;
                var B = [S];
                if (o.i18nFormat && o.i18nFormat.addLookupKeys)
                  o.i18nFormat.addLookupKeys(B, S, $, D, s);
                else {
                  var G;
                  E && (G = o.pluralResolver.getSuffix($, s.count, s));
                  var Z = "".concat(o.options.pluralSeparator, "zero");
                  if (E && (B.push(S + G), N && B.push(S + Z)), R) {
                    var K = "".concat(S).concat(o.options.contextSeparator).concat(s.context);
                    B.push(K), E && (B.push(K + G), N && B.push(K + Z));
                  }
                }
                for (var q; q = B.pop(); )
                  o.isValidLookup(c) || (f = q, c = o.getResource($, D, q, s));
              }
            }));
          });
        }
      }), {
        res: c,
        usedKey: u,
        exactUsedKey: f,
        usedLng: m,
        usedNS: v
      };
    }
  }, {
    key: "isValidLookup",
    value: function(a) {
      return a !== void 0 && !(!this.options.returnNull && a === null) && !(!this.options.returnEmptyString && a === "");
    }
  }, {
    key: "getResource",
    value: function(a, o, s) {
      var c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(a, o, s, c) : this.resourceStore.getResource(a, o, s, c);
    }
  }], [{
    key: "hasDefaultValue",
    value: function(a) {
      var o = "defaultValue";
      for (var s in a)
        if (Object.prototype.hasOwnProperty.call(a, s) && o === s.substring(0, o.length) && a[s] !== void 0)
          return !0;
      return !1;
    }
  }]), n;
}(Dm);
function Ik(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var vB = function() {
  function e(t) {
    Fu(this, e), this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Ef.create("languageUtils");
  }
  return Bu(e, [{
    key: "getScriptPartFromCode",
    value: function(n) {
      if (!n || n.indexOf("-") < 0) return null;
      var r = n.split("-");
      return r.length === 2 || (r.pop(), r[r.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(r.join("-"));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function(n) {
      if (!n || n.indexOf("-") < 0) return n;
      var r = n.split("-");
      return this.formatLanguageCode(r[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function(n) {
      if (typeof n == "string" && n.indexOf("-") > -1) {
        var r = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"], a = n.split("-");
        return this.options.lowerCaseLng ? a = a.map(function(o) {
          return o.toLowerCase();
        }) : a.length === 2 ? (a[0] = a[0].toLowerCase(), a[1] = a[1].toUpperCase(), r.indexOf(a[1].toLowerCase()) > -1 && (a[1] = Ik(a[1].toLowerCase()))) : a.length === 3 && (a[0] = a[0].toLowerCase(), a[1].length === 2 && (a[1] = a[1].toUpperCase()), a[0] !== "sgn" && a[2].length === 2 && (a[2] = a[2].toUpperCase()), r.indexOf(a[1].toLowerCase()) > -1 && (a[1] = Ik(a[1].toLowerCase())), r.indexOf(a[2].toLowerCase()) > -1 && (a[2] = Ik(a[2].toLowerCase()))), a.join("-");
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? n.toLowerCase() : n;
    }
  }, {
    key: "isSupportedCode",
    value: function(n) {
      return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (n = this.getLanguagePartFromCode(n)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(n) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function(n) {
      var r = this;
      if (!n) return null;
      var a;
      return n.forEach(function(o) {
        if (!a) {
          var s = r.formatLanguageCode(o);
          (!r.options.supportedLngs || r.isSupportedCode(s)) && (a = s);
        }
      }), !a && this.options.supportedLngs && n.forEach(function(o) {
        if (!a) {
          var s = r.getLanguagePartFromCode(o);
          if (r.isSupportedCode(s)) return a = s;
          a = r.options.supportedLngs.find(function(c) {
            if (c === s) return c;
            if (!(c.indexOf("-") < 0 && s.indexOf("-") < 0) && c.indexOf(s) === 0)
              return c;
          });
        }
      }), a || (a = this.getFallbackCodes(this.options.fallbackLng)[0]), a;
    }
  }, {
    key: "getFallbackCodes",
    value: function(n, r) {
      if (!n) return [];
      if (typeof n == "function" && (n = n(r)), typeof n == "string" && (n = [n]), Object.prototype.toString.apply(n) === "[object Array]") return n;
      if (!r) return n.default || [];
      var a = n[r];
      return a || (a = n[this.getScriptPartFromCode(r)]), a || (a = n[this.formatLanguageCode(r)]), a || (a = n[this.getLanguagePartFromCode(r)]), a || (a = n.default), a || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function(n, r) {
      var a = this, o = this.getFallbackCodes(r || this.options.fallbackLng || [], n), s = [], c = function(f) {
        f && (a.isSupportedCode(f) ? s.push(f) : a.logger.warn("rejecting language code not found in supportedLngs: ".concat(f)));
      };
      return typeof n == "string" && n.indexOf("-") > -1 ? (this.options.load !== "languageOnly" && c(this.formatLanguageCode(n)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && c(this.getScriptPartFromCode(n)), this.options.load !== "currentOnly" && c(this.getLanguagePartFromCode(n))) : typeof n == "string" && c(this.formatLanguageCode(n)), o.forEach(function(u) {
        s.indexOf(u) < 0 && c(a.formatLanguageCode(u));
      }), s;
    }
  }]), e;
}(), Xve = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Kve = {
  1: function(t) {
    return +(t > 1);
  },
  2: function(t) {
    return +(t != 1);
  },
  3: function(t) {
    return 0;
  },
  4: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  5: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5;
  },
  6: function(t) {
    return t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2;
  },
  7: function(t) {
    return t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  8: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3;
  },
  9: function(t) {
    return +(t >= 2);
  },
  10: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4;
  },
  11: function(t) {
    return t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3;
  },
  12: function(t) {
    return +(t % 10 != 1 || t % 100 == 11);
  },
  13: function(t) {
    return +(t !== 0);
  },
  14: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3;
  },
  15: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  16: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2;
  },
  17: function(t) {
    return t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1;
  },
  18: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : 2;
  },
  19: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3;
  },
  20: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2;
  },
  21: function(t) {
    return t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0;
  },
  22: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3;
  }
}, qve = ["v1", "v2", "v3"], gB = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function Jve() {
  var e = {};
  return Xve.forEach(function(t) {
    t.lngs.forEach(function(n) {
      e[n] = {
        numbers: t.nr,
        plurals: Kve[t.fc]
      };
    });
  }), e;
}
var Qve = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Fu(this, e), this.languageUtils = t, this.options = n, this.logger = Ef.create("pluralResolver"), (!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl == "undefined" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Jve();
  }
  return Bu(e, [{
    key: "addRule",
    value: function(n, r) {
      this.rules[n] = r;
    }
  }, {
    key: "getRule",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (this.shouldUseIntlApi())
        try {
          return new Intl.PluralRules(n, {
            type: r.ordinal ? "ordinal" : "cardinal"
          });
        } catch (a) {
          return;
        }
      return this.rules[n] || this.rules[this.languageUtils.getLanguagePartFromCode(n)];
    }
  }, {
    key: "needsPlural",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = this.getRule(n, r);
      return this.shouldUseIntlApi() ? a && a.resolvedOptions().pluralCategories.length > 1 : a && a.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function(n, r) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this.getSuffixes(n, a).map(function(o) {
        return "".concat(r).concat(o);
      });
    }
  }, {
    key: "getSuffixes",
    value: function(n) {
      var r = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = this.getRule(n, a);
      return o ? this.shouldUseIntlApi() ? o.resolvedOptions().pluralCategories.sort(function(s, c) {
        return gB[s] - gB[c];
      }).map(function(s) {
        return "".concat(r.options.prepend).concat(s);
      }) : o.numbers.map(function(s) {
        return r.getSuffix(n, s, a);
      }) : [];
    }
  }, {
    key: "getSuffix",
    value: function(n, r) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = this.getRule(n, a);
      return o ? this.shouldUseIntlApi() ? "".concat(this.options.prepend).concat(o.select(r)) : this.getSuffixRetroCompatible(o, r) : (this.logger.warn("no plural rule found for: ".concat(n)), "");
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function(n, r) {
      var a = this, o = n.noAbs ? n.plurals(r) : n.plurals(Math.abs(r)), s = n.numbers[o];
      this.options.simplifyPluralSuffix && n.numbers.length === 2 && n.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
      var c = function() {
        return a.options.prepend && s.toString() ? a.options.prepend + s.toString() : s.toString();
      };
      return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? "_plural_".concat(s.toString()) : c() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && n.numbers.length === 2 && n.numbers[0] === 1 ? c() : this.options.prepend && o.toString() ? this.options.prepend + o.toString() : o.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function() {
      return !qve.includes(this.options.compatibilityJSON);
    }
  }]), e;
}();
function yB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yB(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function bB(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, o = Fve(e, t, n);
  return !o && a && typeof n == "string" && (o = C7(e, n, r), o === void 0 && (o = C7(t, n, r))), o;
}
var e0e = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Fu(this, e), this.logger = Ef.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function(n) {
      return n;
    }, this.init(t);
  }
  return Bu(e, [{
    key: "init",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      n.interpolation || (n.interpolation = {
        escapeValue: !0
      });
      var r = n.interpolation;
      this.escape = r.escape !== void 0 ? r.escape : Vve, this.escapeValue = r.escapeValue !== void 0 ? r.escapeValue : !0, this.useRawValueToEscape = r.useRawValueToEscape !== void 0 ? r.useRawValueToEscape : !1, this.prefix = r.prefix ? iy(r.prefix) : r.prefixEscaped || "{{", this.suffix = r.suffix ? iy(r.suffix) : r.suffixEscaped || "}}", this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",", this.unescapePrefix = r.unescapeSuffix ? "" : r.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : r.unescapeSuffix || "", this.nestingPrefix = r.nestingPrefix ? iy(r.nestingPrefix) : r.nestingPrefixEscaped || iy("$t("), this.nestingSuffix = r.nestingSuffix ? iy(r.nestingSuffix) : r.nestingSuffixEscaped || iy(")"), this.nestingOptionsSeparator = r.nestingOptionsSeparator ? r.nestingOptionsSeparator : r.nestingOptionsSeparator || ",", this.maxReplaces = r.maxReplaces ? r.maxReplaces : 1e3, this.alwaysFormat = r.alwaysFormat !== void 0 ? r.alwaysFormat : !1, this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function() {
      this.options && this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function() {
      var n = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(n, "g");
      var r = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(r, "g");
      var a = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(a, "g");
    }
  }, {
    key: "interpolate",
    value: function(n, r, a, o) {
      var s = this, c, u, f, m = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function v(E) {
        return E.replace(/\$/g, "$$$$");
      }
      var y = function(N) {
        if (N.indexOf(s.formatSeparator) < 0) {
          var R = bB(r, m, N, s.options.keySeparator, s.options.ignoreJSONStructure);
          return s.alwaysFormat ? s.format(R, void 0, a, sd(sd(sd({}, o), r), {}, {
            interpolationkey: N
          })) : R;
        }
        var O = N.split(s.formatSeparator), D = O.shift().trim(), $ = O.join(s.formatSeparator).trim();
        return s.format(bB(r, m, D, s.options.keySeparator, s.options.ignoreJSONStructure), $, a, sd(sd(sd({}, o), r), {}, {
          interpolationkey: D
        }));
      };
      this.resetRegExp();
      var b = o && o.missingInterpolationHandler || this.options.missingInterpolationHandler, S = o && o.interpolation && o.interpolation.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables, x = [{
        regex: this.regexpUnescape,
        safeValue: function(N) {
          return v(N);
        }
      }, {
        regex: this.regexp,
        safeValue: function(N) {
          return s.escapeValue ? v(s.escape(N)) : v(N);
        }
      }];
      return x.forEach(function(E) {
        for (f = 0; c = E.regex.exec(n); ) {
          var N = c[1].trim();
          if (u = y(N), u === void 0)
            if (typeof b == "function") {
              var R = b(n, c, o);
              u = typeof R == "string" ? R : "";
            } else if (o && Object.prototype.hasOwnProperty.call(o, N))
              u = "";
            else if (S) {
              u = c[0];
              continue;
            } else
              s.logger.warn("missed to pass in variable ".concat(N, " for interpolating ").concat(n)), u = "";
          else typeof u != "string" && !s.useRawValueToEscape && (u = cB(u));
          var O = E.safeValue(u);
          if (n = n.replace(c[0], O), S ? (E.regex.lastIndex += u.length, E.regex.lastIndex -= c[0].length) : E.regex.lastIndex = 0, f++, f >= s.maxReplaces)
            break;
        }
      }), n;
    }
  }, {
    key: "nest",
    value: function(n, r) {
      var a = this, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, c, u;
      function f(b, S) {
        var x = this.nestingOptionsSeparator;
        if (b.indexOf(x) < 0) return b;
        var E = b.split(new RegExp("".concat(x, "[ ]*{"))), N = "{".concat(E[1]);
        b = E[0], N = this.interpolate(N, u);
        var R = N.match(/'/g), O = N.match(/"/g);
        (R && R.length % 2 === 0 && !O || O.length % 2 !== 0) && (N = N.replace(/'/g, '"'));
        try {
          u = JSON.parse(N), S && (u = sd(sd({}, S), u));
        } catch (D) {
          return this.logger.warn("failed parsing options string in nesting for key ".concat(b), D), "".concat(b).concat(x).concat(N);
        }
        return delete u.defaultValue, b;
      }
      for (; s = this.nestingRegexp.exec(n); ) {
        var m = [];
        u = sd({}, o), u = u.replace && typeof u.replace != "string" ? u.replace : u, u.applyPostProcessor = !1, delete u.defaultValue;
        var v = !1;
        if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
          var y = s[1].split(this.formatSeparator).map(function(b) {
            return b.trim();
          });
          s[1] = y.shift(), m = y, v = !0;
        }
        if (c = r(f.call(this, s[1].trim(), u), u), c && s[0] === n && typeof c != "string") return c;
        typeof c != "string" && (c = cB(c)), c || (this.logger.warn("missed to resolve ".concat(s[1], " for nesting ").concat(n)), c = ""), v && (c = m.reduce(function(b, S) {
          return a.format(b, S, o.lng, sd(sd({}, o), {}, {
            interpolationkey: s[1].trim()
          }));
        }, c.trim())), n = n.replace(s[0], c), this.regexp.lastIndex = 0;
      }
      return n;
    }
  }]), e;
}();
function _B(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ep(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _B(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _B(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function t0e(e) {
  var t = e.toLowerCase().trim(), n = {};
  if (e.indexOf("(") > -1) {
    var r = e.split("(");
    t = r[0].toLowerCase().trim();
    var a = r[1].substring(0, r[1].length - 1);
    if (t === "currency" && a.indexOf(":") < 0)
      n.currency || (n.currency = a.trim());
    else if (t === "relativetime" && a.indexOf(":") < 0)
      n.range || (n.range = a.trim());
    else {
      var o = a.split(";");
      o.forEach(function(s) {
        if (s) {
          var c = s.split(":"), u = Mve(c), f = u[0], m = u.slice(1), v = m.join(":").trim().replace(/^'+|'+$/g, "");
          n[f.trim()] || (n[f.trim()] = v), v === "false" && (n[f.trim()] = !1), v === "true" && (n[f.trim()] = !0), isNaN(v) || (n[f.trim()] = parseInt(v, 10));
        }
      });
    }
  }
  return {
    formatName: t,
    formatOptions: n
  };
}
function sy(e) {
  var t = {};
  return function(r, a, o) {
    var s = a + JSON.stringify(o), c = t[s];
    return c || (c = e(a, o), t[s] = c), c(r);
  };
}
var n0e = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Fu(this, e), this.logger = Ef.create("formatter"), this.options = t, this.formats = {
      number: sy(function(n, r) {
        var a = new Intl.NumberFormat(n, Ep({}, r));
        return function(o) {
          return a.format(o);
        };
      }),
      currency: sy(function(n, r) {
        var a = new Intl.NumberFormat(n, Ep(Ep({}, r), {}, {
          style: "currency"
        }));
        return function(o) {
          return a.format(o);
        };
      }),
      datetime: sy(function(n, r) {
        var a = new Intl.DateTimeFormat(n, Ep({}, r));
        return function(o) {
          return a.format(o);
        };
      }),
      relativetime: sy(function(n, r) {
        var a = new Intl.RelativeTimeFormat(n, Ep({}, r));
        return function(o) {
          return a.format(o, r.range || "day");
        };
      }),
      list: sy(function(n, r) {
        var a = new Intl.ListFormat(n, Ep({}, r));
        return function(o) {
          return a.format(o);
        };
      })
    }, this.init(t);
  }
  return Bu(e, [{
    key: "init",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      }, a = r.interpolation;
      this.formatSeparator = a.formatSeparator ? a.formatSeparator : a.formatSeparator || ",";
    }
  }, {
    key: "add",
    value: function(n, r) {
      this.formats[n.toLowerCase().trim()] = r;
    }
  }, {
    key: "addCached",
    value: function(n, r) {
      this.formats[n.toLowerCase().trim()] = sy(r);
    }
  }, {
    key: "format",
    value: function(n, r, a) {
      var o = this, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, c = r.split(this.formatSeparator), u = c.reduce(function(f, m) {
        var v = t0e(m), y = v.formatName, b = v.formatOptions;
        if (o.formats[y]) {
          var S = f;
          try {
            var x = s && s.formatParams && s.formatParams[s.interpolationkey] || {}, E = x.locale || x.lng || s.locale || s.lng || a;
            S = o.formats[y](f, E, Ep(Ep(Ep({}, b), s), x));
          } catch (N) {
            o.logger.warn(N);
          }
          return S;
        } else
          o.logger.warn("there was no format function for ".concat(y));
        return f;
      }, n);
      return u;
    }
  }]), e;
}();
function CB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function wB(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? CB(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : CB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function r0e(e) {
  var t = a0e();
  return function() {
    var r = Ac(e), a;
    if (t) {
      var o = Ac(this).constructor;
      a = Reflect.construct(r, arguments, o);
    } else
      a = r.apply(this, arguments);
    return E2(this, a);
  };
}
function a0e() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch (e) {
    return !1;
  }
}
function o0e(e, t) {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
}
var i0e = function(e) {
  E_(n, e);
  var t = r0e(n);
  function n(r, a, o) {
    var s, c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return Fu(this, n), s = t.call(this), U6 && Dm.call(Am(s)), s.backend = r, s.store = a, s.services = o, s.languageUtils = o.languageUtils, s.options = c, s.logger = Ef.create("backendConnector"), s.waitingReads = [], s.maxParallelReads = c.maxParallelReads || 10, s.readingCalls = 0, s.maxRetries = c.maxRetries >= 0 ? c.maxRetries : 5, s.retryTimeout = c.retryTimeout >= 1 ? c.retryTimeout : 350, s.state = {}, s.queue = [], s.backend && s.backend.init && s.backend.init(o, c.backend, c), s;
  }
  return Bu(n, [{
    key: "queueLoad",
    value: function(a, o, s, c) {
      var u = this, f = {}, m = {}, v = {}, y = {};
      return a.forEach(function(b) {
        var S = !0;
        o.forEach(function(x) {
          var E = "".concat(b, "|").concat(x);
          !s.reload && u.store.hasResourceBundle(b, x) ? u.state[E] = 2 : u.state[E] < 0 || (u.state[E] === 1 ? m[E] === void 0 && (m[E] = !0) : (u.state[E] = 1, S = !1, m[E] === void 0 && (m[E] = !0), f[E] === void 0 && (f[E] = !0), y[x] === void 0 && (y[x] = !0)));
        }), S || (v[b] = !0);
      }), (Object.keys(f).length || Object.keys(m).length) && this.queue.push({
        pending: m,
        pendingCount: Object.keys(m).length,
        loaded: {},
        errors: [],
        callback: c
      }), {
        toLoad: Object.keys(f),
        pending: Object.keys(m),
        toLoadLanguages: Object.keys(v),
        toLoadNamespaces: Object.keys(y)
      };
    }
  }, {
    key: "loaded",
    value: function(a, o, s) {
      var c = a.split("|"), u = c[0], f = c[1];
      o && this.emit("failedLoading", u, f, o), s && this.store.addResourceBundle(u, f, s), this.state[a] = o ? -1 : 2;
      var m = {};
      this.queue.forEach(function(v) {
        jve(v.loaded, [u], f), o0e(v, a), o && v.errors.push(o), v.pendingCount === 0 && !v.done && (Object.keys(v.loaded).forEach(function(y) {
          m[y] || (m[y] = {});
          var b = v.loaded[y];
          b.length && b.forEach(function(S) {
            m[y][S] === void 0 && (m[y][S] = !0);
          });
        }), v.done = !0, v.errors.length ? v.callback(v.errors) : v.callback());
      }), this.emit("loaded", m), this.queue = this.queue.filter(function(v) {
        return !v.done;
      });
    }
  }, {
    key: "read",
    value: function(a, o, s) {
      var c = this, u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, f = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, m = arguments.length > 5 ? arguments[5] : void 0;
      if (!a.length) return m(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: a,
          ns: o,
          fcName: s,
          tried: u,
          wait: f,
          callback: m
        });
        return;
      }
      this.readingCalls++;
      var v = function(x, E) {
        if (c.readingCalls--, c.waitingReads.length > 0) {
          var N = c.waitingReads.shift();
          c.read(N.lng, N.ns, N.fcName, N.tried, N.wait, N.callback);
        }
        if (x && E && u < c.maxRetries) {
          setTimeout(function() {
            c.read.call(c, a, o, s, u + 1, f * 2, m);
          }, f);
          return;
        }
        m(x, E);
      }, y = this.backend[s].bind(this.backend);
      if (y.length === 2) {
        try {
          var b = y(a, o);
          b && typeof b.then == "function" ? b.then(function(S) {
            return v(null, S);
          }).catch(v) : v(null, b);
        } catch (S) {
          v(S);
        }
        return;
      }
      return y(a, o, v);
    }
  }, {
    key: "prepareLoading",
    value: function(a, o) {
      var s = this, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, u = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend)
        return this.logger.warn("No backend was added via i18next.use. Will not load resources."), u && u();
      typeof a == "string" && (a = this.languageUtils.toResolveHierarchy(a)), typeof o == "string" && (o = [o]);
      var f = this.queueLoad(a, o, c, u);
      if (!f.toLoad.length)
        return f.pending.length || u(), null;
      f.toLoad.forEach(function(m) {
        s.loadOne(m);
      });
    }
  }, {
    key: "load",
    value: function(a, o, s) {
      this.prepareLoading(a, o, {}, s);
    }
  }, {
    key: "reload",
    value: function(a, o, s) {
      this.prepareLoading(a, o, {
        reload: !0
      }, s);
    }
  }, {
    key: "loadOne",
    value: function(a) {
      var o = this, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", c = a.split("|"), u = c[0], f = c[1];
      this.read(u, f, "read", void 0, void 0, function(m, v) {
        m && o.logger.warn("".concat(s, "loading namespace ").concat(f, " for language ").concat(u, " failed"), m), !m && v && o.logger.log("".concat(s, "loaded namespace ").concat(f, " for language ").concat(u), v), o.loaded(a, m, v);
      });
    }
  }, {
    key: "saveMissing",
    value: function(a, o, s, c, u) {
      var f = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, m = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : function() {
      };
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(o)) {
        this.logger.warn('did not save key "'.concat(s, '" as the namespace "').concat(o, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      if (!(s == null || s === "")) {
        if (this.backend && this.backend.create) {
          var v = wB(wB({}, f), {}, {
            isUpdate: u
          }), y = this.backend.create.bind(this.backend);
          if (y.length < 6)
            try {
              var b;
              y.length === 5 ? b = y(a, o, s, c, v) : b = y(a, o, s, c), b && typeof b.then == "function" ? b.then(function(S) {
                return m(null, S);
              }).catch(m) : m(null, b);
            } catch (S) {
              m(S);
            }
          else
            y(a, o, s, c, m, v);
        }
        !a || !a[0] || this.store.addResource(a[0], o, s, c);
      }
    }
  }]), n;
}(Dm);
function SB() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !0,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(t) {
      var n = {};
      if (Ki(t[1]) === "object" && (n = t[1]), typeof t[1] == "string" && (n.defaultValue = t[1]), typeof t[2] == "string" && (n.tDescription = t[2]), Ki(t[2]) === "object" || Ki(t[3]) === "object") {
        var r = t[3] || t[2];
        Object.keys(r).forEach(function(a) {
          n[a] = r[a];
        });
      }
      return n;
    },
    interpolation: {
      escapeValue: !0,
      format: function(t, n, r, a) {
        return t;
      },
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function xB(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function EB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function pf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? EB(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : EB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function s0e(e) {
  var t = l0e();
  return function() {
    var r = Ac(e), a;
    if (t) {
      var o = Ac(this).constructor;
      a = Reflect.construct(r, arguments, o);
    } else
      a = r.apply(this, arguments);
    return E2(this, a);
  };
}
function l0e() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch (e) {
    return !1;
  }
}
function hS() {
}
function u0e(e) {
  var t = Object.getOwnPropertyNames(Object.getPrototypeOf(e));
  t.forEach(function(n) {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
}
var w7 = function(e) {
  E_(n, e);
  var t = s0e(n);
  function n() {
    var r, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 ? arguments[1] : void 0;
    if (Fu(this, n), r = t.call(this), U6 && Dm.call(Am(r)), r.options = xB(a), r.services = {}, r.logger = Ef, r.modules = {
      external: []
    }, u0e(Am(r)), o && !r.isInitialized && !a.isClone) {
      if (!r.options.initImmediate)
        return r.init(a, o), E2(r, Am(r));
      setTimeout(function() {
        r.init(a, o);
      }, 0);
    }
    return r;
  }
  return Bu(n, [{
    key: "init",
    value: function() {
      var a = this, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = arguments.length > 1 ? arguments[1] : void 0;
      typeof o == "function" && (s = o, o = {}), !o.defaultNS && o.defaultNS !== !1 && o.ns && (typeof o.ns == "string" ? o.defaultNS = o.ns : o.ns.indexOf("translation") < 0 && (o.defaultNS = o.ns[0]));
      var c = SB();
      this.options = pf(pf(pf({}, c), this.options), xB(o)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = pf(pf({}, c.interpolation), this.options.interpolation)), o.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = o.keySeparator), o.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = o.nsSeparator);
      function u(N) {
        return N ? typeof N == "function" ? new N() : N : null;
      }
      if (!this.options.isClone) {
        this.modules.logger ? Ef.init(u(this.modules.logger), this.options) : Ef.init(null, this.options);
        var f;
        this.modules.formatter ? f = this.modules.formatter : typeof Intl != "undefined" && (f = n0e);
        var m = new vB(this.options);
        this.store = new Wve(this.options.resources, this.options);
        var v = this.services;
        v.logger = Ef, v.resourceStore = this.store, v.languageUtils = m, v.pluralResolver = new Qve(m, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        }), f && (!this.options.interpolation.format || this.options.interpolation.format === c.interpolation.format) && (v.formatter = u(f), v.formatter.init(v, this.options), this.options.interpolation.format = v.formatter.format.bind(v.formatter)), v.interpolator = new e0e(this.options), v.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        }, v.backendConnector = new i0e(u(this.modules.backend), v.resourceStore, v, this.options), v.backendConnector.on("*", function(N) {
          for (var R = arguments.length, O = new Array(R > 1 ? R - 1 : 0), D = 1; D < R; D++)
            O[D - 1] = arguments[D];
          a.emit.apply(a, [N].concat(O));
        }), this.modules.languageDetector && (v.languageDetector = u(this.modules.languageDetector), v.languageDetector.init && v.languageDetector.init(v, this.options.detection, this.options)), this.modules.i18nFormat && (v.i18nFormat = u(this.modules.i18nFormat), v.i18nFormat.init && v.i18nFormat.init(this)), this.translator = new mB(this.services, this.options), this.translator.on("*", function(N) {
          for (var R = arguments.length, O = new Array(R > 1 ? R - 1 : 0), D = 1; D < R; D++)
            O[D - 1] = arguments[D];
          a.emit.apply(a, [N].concat(O));
        }), this.modules.external.forEach(function(N) {
          N.init && N.init(a);
        });
      }
      if (this.format = this.options.interpolation.format, s || (s = hS), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var y = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        y.length > 0 && y[0] !== "dev" && (this.options.lng = y[0]);
      }
      !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined");
      var b = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
      b.forEach(function(N) {
        a[N] = function() {
          var R;
          return (R = a.store)[N].apply(R, arguments);
        };
      });
      var S = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
      S.forEach(function(N) {
        a[N] = function() {
          var R;
          return (R = a.store)[N].apply(R, arguments), a;
        };
      });
      var x = K3(), E = function() {
        var R = function(D, $) {
          a.isInitialized && !a.initializedStoreOnce && a.logger.warn("init: i18next is already initialized. You should call init just once!"), a.isInitialized = !0, a.options.isClone || a.logger.log("initialized", a.options), a.emit("initialized", a.options), x.resolve($), s(D, $);
        };
        if (a.languages && a.options.compatibilityAPI !== "v1" && !a.isInitialized) return R(null, a.t.bind(a));
        a.changeLanguage(a.options.lng, R);
      };
      return this.options.resources || !this.options.initImmediate ? E() : setTimeout(E, 0), x;
    }
  }, {
    key: "loadResources",
    value: function(a) {
      var o = this, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : hS, c = s, u = typeof a == "string" ? a : this.language;
      if (typeof a == "function" && (c = a), !this.options.resources || this.options.partialBundledLanguages) {
        if (u && u.toLowerCase() === "cimode") return c();
        var f = [], m = function(b) {
          if (b) {
            var S = o.services.languageUtils.toResolveHierarchy(b);
            S.forEach(function(x) {
              f.indexOf(x) < 0 && f.push(x);
            });
          }
        };
        if (u)
          m(u);
        else {
          var v = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          v.forEach(function(y) {
            return m(y);
          });
        }
        this.options.preload && this.options.preload.forEach(function(y) {
          return m(y);
        }), this.services.backendConnector.load(f, this.options.ns, function(y) {
          !y && !o.resolvedLanguage && o.language && o.setResolvedLanguage(o.language), c(y);
        });
      } else
        c(null);
    }
  }, {
    key: "reloadResources",
    value: function(a, o, s) {
      var c = K3();
      return a || (a = this.languages), o || (o = this.options.ns), s || (s = hS), this.services.backendConnector.reload(a, o, function(u) {
        c.resolve(), s(u);
      }), c;
    }
  }, {
    key: "use",
    value: function(a) {
      if (!a) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!a.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      return a.type === "backend" && (this.modules.backend = a), (a.type === "logger" || a.log && a.warn && a.error) && (this.modules.logger = a), a.type === "languageDetector" && (this.modules.languageDetector = a), a.type === "i18nFormat" && (this.modules.i18nFormat = a), a.type === "postProcessor" && GJ.addPostProcessor(a), a.type === "formatter" && (this.modules.formatter = a), a.type === "3rdParty" && this.modules.external.push(a), this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function(a) {
      if (!(!a || !this.languages) && !(["cimode", "dev"].indexOf(a) > -1))
        for (var o = 0; o < this.languages.length; o++) {
          var s = this.languages[o];
          if (!(["cimode", "dev"].indexOf(s) > -1) && this.store.hasLanguageSomeTranslations(s)) {
            this.resolvedLanguage = s;
            break;
          }
        }
    }
  }, {
    key: "changeLanguage",
    value: function(a, o) {
      var s = this;
      this.isLanguageChangingTo = a;
      var c = K3();
      this.emit("languageChanging", a);
      var u = function(y) {
        s.language = y, s.languages = s.services.languageUtils.toResolveHierarchy(y), s.resolvedLanguage = void 0, s.setResolvedLanguage(y);
      }, f = function(y, b) {
        b ? (u(b), s.translator.changeLanguage(b), s.isLanguageChangingTo = void 0, s.emit("languageChanged", b), s.logger.log("languageChanged", b)) : s.isLanguageChangingTo = void 0, c.resolve(function() {
          return s.t.apply(s, arguments);
        }), o && o(y, function() {
          return s.t.apply(s, arguments);
        });
      }, m = function(y) {
        !a && !y && s.services.languageDetector && (y = []);
        var b = typeof y == "string" ? y : s.services.languageUtils.getBestMatchFromCodes(y);
        b && (s.language || u(b), s.translator.language || s.translator.changeLanguage(b), s.services.languageDetector && s.services.languageDetector.cacheUserLanguage && s.services.languageDetector.cacheUserLanguage(b)), s.loadResources(b, function(S) {
          f(S, b);
        });
      };
      return !a && this.services.languageDetector && !this.services.languageDetector.async ? m(this.services.languageDetector.detect()) : !a && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(m) : this.services.languageDetector.detect(m) : m(a), c;
    }
  }, {
    key: "getFixedT",
    value: function(a, o, s) {
      var c = this, u = function f(m, v) {
        var y;
        if (Ki(v) !== "object") {
          for (var b = arguments.length, S = new Array(b > 2 ? b - 2 : 0), x = 2; x < b; x++)
            S[x - 2] = arguments[x];
          y = c.options.overloadTranslationOptionHandler([m, v].concat(S));
        } else
          y = pf({}, v);
        y.lng = y.lng || f.lng, y.lngs = y.lngs || f.lngs, y.ns = y.ns || f.ns, y.keyPrefix = y.keyPrefix || s || f.keyPrefix;
        var E = c.options.keySeparator || ".", N;
        return y.keyPrefix && Array.isArray(m) ? N = m.map(function(R) {
          return "".concat(y.keyPrefix).concat(E).concat(R);
        }) : N = y.keyPrefix ? "".concat(y.keyPrefix).concat(E).concat(m) : m, c.t(N, y);
      };
      return typeof a == "string" ? u.lng = a : u.lngs = a, u.ns = o, u.keyPrefix = s, u;
    }
  }, {
    key: "t",
    value: function() {
      var a;
      return this.translator && (a = this.translator).translate.apply(a, arguments);
    }
  }, {
    key: "exists",
    value: function() {
      var a;
      return this.translator && (a = this.translator).exists.apply(a, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function(a) {
      this.options.defaultNS = a;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function(a) {
      var o = this, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized)
        return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
      if (!this.languages || !this.languages.length)
        return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
      var c = s.lng || this.resolvedLanguage || this.languages[0], u = this.options ? this.options.fallbackLng : !1, f = this.languages[this.languages.length - 1];
      if (c.toLowerCase() === "cimode") return !0;
      var m = function(b, S) {
        var x = o.services.backendConnector.state["".concat(b, "|").concat(S)];
        return x === -1 || x === 2;
      };
      if (s.precheck) {
        var v = s.precheck(this, m);
        if (v !== void 0) return v;
      }
      return !!(this.hasResourceBundle(c, a) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || m(c, a) && (!u || m(f, a)));
    }
  }, {
    key: "loadNamespaces",
    value: function(a, o) {
      var s = this, c = K3();
      return this.options.ns ? (typeof a == "string" && (a = [a]), a.forEach(function(u) {
        s.options.ns.indexOf(u) < 0 && s.options.ns.push(u);
      }), this.loadResources(function(u) {
        c.resolve(), o && o(u);
      }), c) : (o && o(), Promise.resolve());
    }
  }, {
    key: "loadLanguages",
    value: function(a, o) {
      var s = K3();
      typeof a == "string" && (a = [a]);
      var c = this.options.preload || [], u = a.filter(function(f) {
        return c.indexOf(f) < 0;
      });
      return u.length ? (this.options.preload = c.concat(u), this.loadResources(function(f) {
        s.resolve(), o && o(f);
      }), s) : (o && o(), Promise.resolve());
    }
  }, {
    key: "dir",
    value: function(a) {
      if (a || (a = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !a) return "rtl";
      var o = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], s = this.services && this.services.languageUtils || new vB(SB());
      return o.indexOf(s.getLanguagePartFromCode(a)) > -1 || a.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
  }, {
    key: "cloneInstance",
    value: function() {
      var a = this, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : hS, c = pf(pf(pf({}, this.options), o), {
        isClone: !0
      }), u = new n(c);
      (o.debug !== void 0 || o.prefix !== void 0) && (u.logger = u.logger.clone(o));
      var f = ["store", "services", "language"];
      return f.forEach(function(m) {
        u[m] = a[m];
      }), u.services = pf({}, this.services), u.services.utils = {
        hasLoadedNamespace: u.hasLoadedNamespace.bind(u)
      }, u.translator = new mB(u.services, u.options), u.translator.on("*", function(m) {
        for (var v = arguments.length, y = new Array(v > 1 ? v - 1 : 0), b = 1; b < v; b++)
          y[b - 1] = arguments[b];
        u.emit.apply(u, [m].concat(y));
      }), u.init(c, s), u.translator.options = u.options, u.translator.backendConnector.services.utils = {
        hasLoadedNamespace: u.hasLoadedNamespace.bind(u)
      }, u;
    }
  }, {
    key: "toJSON",
    value: function() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]), n;
}(Dm);
fs(w7, "createInstance", function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
  return new w7(e, t);
});
var ca = w7.createInstance();
ca.createInstance = w7.createInstance;
ca.createInstance;
ca.dir;
ca.init;
ca.loadResources;
ca.reloadResources;
ca.use;
ca.changeLanguage;
ca.getFixedT;
var Ip = ca.t;
ca.exists;
ca.setDefaultNamespace;
ca.hasLoadedNamespace;
ca.loadNamespaces;
ca.loadLanguages;
function c0e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
function Vu(e, t) {
  if (e == null) return {};
  var n, r, a = c0e(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (r = 0; r < o.length; r++) n = o[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (a[n] = e[n]);
  }
  return a;
}
var Nu = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Mt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var d0e = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
};
const f0e = /* @__PURE__ */ Mt(d0e);
var p0e = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function IB(e) {
  var t = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, n = e.match(/<\/?([^\s]+?)[/\s>]/);
  if (n && (t.name = n[1], (f0e[n[1]] || e.charAt(e.length - 2) === "/") && (t.voidElement = !0), t.name.startsWith("!--"))) {
    var r = e.indexOf("-->");
    return { type: "comment", comment: r !== -1 ? e.slice(4, r) : "" };
  }
  for (var a = new RegExp(p0e), o = null; (o = a.exec(e)) !== null; ) if (o[0].trim()) if (o[1]) {
    var s = o[1].trim(), c = [s, ""];
    s.indexOf("=") > -1 && (c = s.split("=")), t.attrs[c[0]] = c[1], a.lastIndex--;
  } else o[2] && (t.attrs[o[2]] = o[3].trim().substring(1, o[3].length - 1));
  return t;
}
var h0e = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, m0e = /^\s*$/, v0e = /* @__PURE__ */ Object.create(null);
function zJ(e, t) {
  switch (t.type) {
    case "text":
      return e + t.content;
    case "tag":
      return e += "<" + t.name + (t.attrs ? function(n) {
        var r = [];
        for (var a in n) r.push(a + '="' + n[a] + '"');
        return r.length ? " " + r.join(" ") : "";
      }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce(zJ, "") + "</" + t.name + ">";
    case "comment":
      return e + "<!--" + t.comment + "-->";
  }
}
var g0e = { parse: function(e, t) {
  t || (t = {}), t.components || (t.components = v0e);
  var n, r = [], a = [], o = -1, s = !1;
  if (e.indexOf("<") !== 0) {
    var c = e.indexOf("<");
    r.push({ type: "text", content: c === -1 ? e : e.substring(0, c) });
  }
  return e.replace(h0e, function(u, f) {
    if (s) {
      if (u !== "</" + n.name + ">") return;
      s = !1;
    }
    var m, v = u.charAt(1) !== "/", y = u.startsWith("<!--"), b = f + u.length, S = e.charAt(b);
    if (y) {
      var x = IB(u);
      return o < 0 ? (r.push(x), r) : ((m = a[o]).children.push(x), r);
    }
    if (v && (o++, (n = IB(u)).type === "tag" && t.components[n.name] && (n.type = "component", s = !0), n.voidElement || s || !S || S === "<" || n.children.push({ type: "text", content: e.slice(b, e.indexOf("<", b)) }), o === 0 && r.push(n), (m = a[o - 1]) && m.children.push(n), a[o] = n), (!v || n.voidElement) && (o > -1 && (n.voidElement || n.name === u.slice(2, -1)) && (o--, n = o === -1 ? r : a[o]), !s && S !== "<" && S)) {
      m = o === -1 ? r : a[o].children;
      var E = e.indexOf("<", b), N = e.slice(b, E === -1 ? void 0 : E);
      m0e.test(N) && (N = " "), (E > -1 && o + m.length >= 0 || N !== " ") && m.push({ type: "text", content: N });
    }
  }), r;
}, stringify: function(e) {
  return e.reduce(function(t, n) {
    return t + zJ("", n);
  }, "");
} };
function Ox() {
  if (console && console.warn) {
    for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    typeof n[0] == "string" && (n[0] = "react-i18next:: ".concat(n[0])), (e = console).warn.apply(e, n);
  }
}
var kB = {};
function S7() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  typeof t[0] == "string" && kB[t[0]] || (typeof t[0] == "string" && (kB[t[0]] = /* @__PURE__ */ new Date()), Ox.apply(void 0, t));
}
var HJ = function(t, n) {
  return function() {
    if (t.isInitialized)
      n();
    else {
      var r = function a() {
        setTimeout(function() {
          t.off("initialized", a);
        }, 0), n();
      };
      t.on("initialized", r);
    }
  };
};
function AB(e, t, n) {
  e.loadNamespaces(t, HJ(e, n));
}
function PB(e, t, n, r) {
  typeof n == "string" && (n = [n]), n.forEach(function(a) {
    e.options.ns.indexOf(a) < 0 && e.options.ns.push(a);
  }), e.loadLanguages(t, HJ(e, r));
}
function y0e(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = t.languages[0], a = t.options ? t.options.fallbackLng : !1, o = t.languages[t.languages.length - 1];
  if (r.toLowerCase() === "cimode") return !0;
  var s = function(u, f) {
    var m = t.services.backendConnector.state["".concat(u, "|").concat(f)];
    return m === -1 || m === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !s(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(r, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || s(r, e) && (!a || s(o, e)));
}
function b0e(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!t.languages || !t.languages.length)
    return S7("i18n.languages were undefined or empty", t.languages), !0;
  var r = t.options.ignoreJSONStructure !== void 0;
  return r ? t.hasLoadedNamespace(e, {
    lng: n.lng,
    precheck: function(o, s) {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !s(o.isLanguageChangingTo, e)) return !1;
    }
  }) : y0e(e, t, n);
}
function _0e(e) {
  return e.displayName || e.name || (typeof e == "string" && e.length > 0 ? e : "Unknown");
}
var C0e = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, w0e = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, S0e = function(t) {
  return w0e[t];
}, x0e = function(t) {
  return t.replace(C0e, S0e);
};
function NB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function TB(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? NB(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : NB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var HN = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: x0e
};
function E0e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  HN = TB(TB({}, HN), e);
}
function WJ() {
  return HN;
}
var ZJ;
function I0e(e) {
  ZJ = e;
}
function bR() {
  return ZJ;
}
var k0e = ["format"], A0e = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
function OB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Zi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? OB(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : OB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kk(e, t) {
  if (!e) return !1;
  var n = e.props ? e.props.children : e.children;
  return t ? n.length > 0 : !!n;
}
function Ak(e) {
  return e ? e.props ? e.props.children : e.children : [];
}
function P0e(e) {
  return Object.prototype.toString.call(e) !== "[object Array]" ? !1 : e.every(function(t) {
    return b7(t);
  });
}
function y4(e) {
  return Array.isArray(e) ? e : [e];
}
function N0e(e, t) {
  var n = Zi({}, t);
  return n.props = Object.assign(e.props, t.props), n;
}
function YJ(e, t) {
  if (!e) return "";
  var n = "", r = y4(e), a = t.transSupportBasicHtmlNodes && t.transKeepBasicHtmlNodesFor ? t.transKeepBasicHtmlNodesFor : [];
  return r.forEach(function(o, s) {
    if (typeof o == "string")
      n += "".concat(o);
    else if (b7(o)) {
      var c = Object.keys(o.props).length, u = a.indexOf(o.type) > -1, f = o.props.children;
      if (!f && u && c === 0)
        n += "<".concat(o.type, "/>");
      else if (!f && (!u || c !== 0))
        n += "<".concat(s, "></").concat(s, ">");
      else if (o.props.i18nIsDynamicList)
        n += "<".concat(s, "></").concat(s, ">");
      else if (u && c === 1 && typeof f == "string")
        n += "<".concat(o.type, ">").concat(f, "</").concat(o.type, ">");
      else {
        var m = YJ(f, t);
        n += "<".concat(s, ">").concat(m, "</").concat(s, ">");
      }
    } else if (o === null)
      Ox("Trans: the passed in value is invalid - seems you passed in a null child.");
    else if (Ki(o) === "object") {
      var v = o.format, y = Vu(o, k0e), b = Object.keys(y);
      if (b.length === 1) {
        var S = v ? "".concat(b[0], ", ").concat(v) : b[0];
        n += "{{".concat(S, "}}");
      } else
        Ox("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", o);
    } else
      Ox("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", o);
  }), n;
}
function T0e(e, t, n, r, a, o) {
  if (t === "") return [];
  var s = r.transKeepBasicHtmlNodesFor || [], c = t && new RegExp(s.join("|")).test(t);
  if (!e && !c) return [t];
  var u = {};
  function f(E) {
    var N = y4(E);
    N.forEach(function(R) {
      typeof R != "string" && (kk(R) ? f(Ak(R)) : Ki(R) === "object" && !b7(R) && Object.assign(u, R));
    });
  }
  f(e);
  var m = g0e.parse("<0>".concat(t, "</0>")), v = Zi(Zi({}, u), a);
  function y(E, N, R) {
    var O = Ak(E), D = S(O, N.children, R);
    return P0e(O) && D.length === 0 ? O : D;
  }
  function b(E, N, R, O, D) {
    E.dummy && (E.children = N), R.push(fS(E, Zi(Zi({}, E.props), {}, {
      key: O
    }), D ? void 0 : N));
  }
  function S(E, N, R) {
    var O = y4(E), D = y4(N);
    return D.reduce(function($, B, G) {
      var Z = B.children && B.children[0] && B.children[0].content && n.services.interpolator.interpolate(B.children[0].content, v, n.language);
      if (B.type === "tag") {
        var K = O[parseInt(B.name, 10)];
        !K && R.length === 1 && R[0][B.name] && (K = R[0][B.name]), K || (K = {});
        var q = Object.keys(B.attrs).length !== 0 ? N0e({
          props: B.attrs
        }, K) : K, pe = b7(q), he = pe && kk(B, !0) && !B.voidElement, _e = c && Ki(q) === "object" && q.dummy && !pe, ge = Ki(e) === "object" && e !== null && Object.hasOwnProperty.call(e, B.name);
        if (typeof q == "string") {
          var Y = n.services.interpolator.interpolate(q, v, n.language);
          $.push(Y);
        } else if (kk(q) || he) {
          var ee = y(q, B, R);
          b(q, ee, $, G);
        } else if (_e) {
          var oe = S(O, B.children, R);
          $.push(fS(q, Zi(Zi({}, q.props), {}, {
            key: G
          }), oe));
        } else if (Number.isNaN(parseFloat(B.name)))
          if (ge) {
            var me = y(q, B, R);
            b(q, me, $, G, B.voidElement);
          } else if (r.transSupportBasicHtmlNodes && s.indexOf(B.name) > -1)
            if (B.voidElement)
              $.push(M0(B.name, {
                key: "".concat(B.name, "-").concat(G)
              }));
            else {
              var xe = S(O, B.children, R);
              $.push(M0(B.name, {
                key: "".concat(B.name, "-").concat(G)
              }, xe));
            }
          else if (B.voidElement)
            $.push("<".concat(B.name, " />"));
          else {
            var X = S(O, B.children, R);
            $.push("<".concat(B.name, ">").concat(X, "</").concat(B.name, ">"));
          }
        else if (Ki(q) === "object" && !pe) {
          var ye = B.children[0] ? Z : null;
          ye && $.push(ye);
        } else B.children.length === 1 && Z ? $.push(fS(q, Zi(Zi({}, q.props), {}, {
          key: G
        }), Z)) : $.push(fS(q, Zi(Zi({}, q.props), {}, {
          key: G
        })));
      } else if (B.type === "text") {
        var ce = r.transWrapTextNodes, se = o ? r.unescape(n.services.interpolator.interpolate(B.content, v, n.language)) : n.services.interpolator.interpolate(B.content, v, n.language);
        ce ? $.push(M0(ce, {
          key: "".concat(B.name, "-").concat(G)
        }, se)) : $.push(se);
      }
      return $;
    }, []);
  }
  var x = S([{
    dummy: !0,
    children: e || []
  }], m, y4(e || []));
  return Ak(x[0]);
}
function O0e(e) {
  var t = e.children, n = e.count, r = e.parent, a = e.i18nKey, o = e.context, s = e.tOptions, c = s === void 0 ? {} : s, u = e.values, f = e.defaults, m = e.components, v = e.ns, y = e.i18n, b = e.t, S = e.shouldUnescape, x = Vu(e, A0e), E = y || bR();
  if (!E)
    return S7("You will need to pass in an i18next instance by using i18nextReactModule"), t;
  var N = b || E.t.bind(E) || function(he) {
    return he;
  };
  o && (c.context = o);
  var R = Zi(Zi({}, WJ()), E.options && E.options.react), O = v || N.ns || E.options && E.options.defaultNS;
  O = typeof O == "string" ? [O] : O || ["translation"];
  var D = f || YJ(t, R) || R.transEmptyNodeValue || a, $ = R.hashTransKey, B = a || ($ ? $(D) : D), G = u ? c.interpolation : {
    interpolation: Zi(Zi({}, c.interpolation), {}, {
      prefix: "#$?",
      suffix: "?$#"
    })
  }, Z = Zi(Zi(Zi(Zi({}, c), {}, {
    count: n
  }, u), G), {}, {
    defaultValue: D,
    ns: O
  }), K = B ? N(B, Z) : D, q = T0e(m || t, K, E, R, Z, S), pe = r !== void 0 ? r : R.defaultTransParent;
  return pe ? M0(pe, x, q) : q;
}
var R0e = {
  type: "3rdParty",
  init: function(t) {
    E0e(t.options.react), I0e(t);
  }
}, XJ = LJ(), M0e = function() {
  function e() {
    Fu(this, e), this.usedNamespaces = {};
  }
  return Bu(e, [{
    key: "addUsedNamespaces",
    value: function(n) {
      var r = this;
      n.forEach(function(a) {
        r.usedNamespaces[a] || (r.usedNamespaces[a] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
}(), D0e = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
function RB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function L0e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? RB(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : RB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ia(e) {
  var t = e.children, n = e.count, r = e.parent, a = e.i18nKey, o = e.context, s = e.tOptions, c = s === void 0 ? {} : s, u = e.values, f = e.defaults, m = e.components, v = e.ns, y = e.i18n, b = e.t, S = e.shouldUnescape, x = Vu(e, D0e), E = Zp(XJ) || {}, N = E.i18n, R = E.defaultNS, O = y || N || bR(), D = b || O && O.t.bind(O);
  return O0e(L0e({
    children: t,
    count: n,
    parent: r,
    i18nKey: a,
    context: o,
    tOptions: c,
    values: u,
    defaults: f,
    components: m,
    ns: v || D && D.ns || R || O && O.options && O.options.defaultNS,
    i18n: O,
    t: b,
    shouldUnescape: S
  }, x));
}
function $0e(e, t) {
  var n = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, a, o, s, c = [], u = !0, f = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        u = !1;
      } else for (; !(u = (r = o.call(n)).done) && (c.push(r.value), c.length !== t); u = !0) ;
    } catch (m) {
      f = !0, a = m;
    } finally {
      try {
        if (!u && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (f) throw a;
      }
    }
    return c;
  }
}
function Sd(e, t) {
  return FJ(e) || $0e(e, t) || gR(e, t) || VJ();
}
function MB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Pk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? MB(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : MB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var j0e = function(t, n) {
  var r = Yo();
  return mn(function() {
    r.current = t;
  }, [t, n]), r.current;
};
function tn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.i18n, r = Zp(XJ) || {}, a = r.i18n, o = r.defaultNS, s = n || a || bR();
  if (s && !s.reportNamespaces && (s.reportNamespaces = new M0e()), !s) {
    S7("You will need to pass in an i18next instance by using initReactI18next");
    var c = function(K, q) {
      return typeof q == "string" ? q : q && Ki(q) === "object" && typeof q.defaultValue == "string" ? q.defaultValue : Array.isArray(K) ? K[K.length - 1] : K;
    }, u = [c, {}, !1];
    return u.t = c, u.i18n = {}, u.ready = !1, u;
  }
  s.options.react && s.options.react.wait !== void 0 && S7("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var f = Pk(Pk(Pk({}, WJ()), s.options.react), t), m = f.useSuspense, v = f.keyPrefix, y = o || s.options && s.options.defaultNS;
  y = typeof y == "string" ? [y] : y || ["translation"], s.reportNamespaces.addUsedNamespaces && s.reportNamespaces.addUsedNamespaces(y);
  var b = (s.isInitialized || s.initializedStoreOnce) && y.every(function(Z) {
    return b0e(Z, s, f);
  });
  function S() {
    return s.getFixedT(t.lng || null, f.nsMode === "fallback" ? y : y[0], v);
  }
  var x = mt(S), E = Sd(x, 2), N = E[0], R = E[1], O = y.join();
  t.lng && (O = "".concat(t.lng).concat(O));
  var D = j0e(O), $ = Yo(!0);
  mn(function() {
    var Z = f.bindI18n, K = f.bindI18nStore;
    $.current = !0, !b && !m && (t.lng ? PB(s, t.lng, y, function() {
      $.current && R(S);
    }) : AB(s, y, function() {
      $.current && R(S);
    })), b && D && D !== O && $.current && R(S);
    function q() {
      $.current && R(S);
    }
    return Z && s && s.on(Z, q), K && s && s.store.on(K, q), function() {
      $.current = !1, Z && s && Z.split(" ").forEach(function(pe) {
        return s.off(pe, q);
      }), K && s && K.split(" ").forEach(function(pe) {
        return s.store.off(pe, q);
      });
    };
  }, [s, O]);
  var B = Yo(!0);
  mn(function() {
    $.current && !B.current && R(S), B.current = !1;
  }, [s, v]);
  var G = [N, s, b];
  if (G.t = N, G.i18n = s, G.ready = b, b || !b && !m) return G;
  throw new Promise(function(Z) {
    t.lng ? PB(s, t.lng, y, function() {
      return Z();
    }) : AB(s, y, function() {
      return Z();
    });
  });
}
var F0e = ["forwardedRef"];
function DB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function mS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? DB(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : DB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function o1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(r) {
    function a(s) {
      var c = s.forwardedRef, u = Vu(s, F0e), f = tn(e, mS(mS({}, u), {}, {
        keyPrefix: t.keyPrefix
      })), m = Sd(f, 3), v = m[0], y = m[1], b = m[2], S = mS(mS({}, u), {}, {
        t: v,
        i18n: y,
        tReady: b
      });
      return t.withRef && c ? S.ref = c : !t.withRef && c && (S.forwardedRef = c), M0(r, S);
    }
    a.displayName = "withI18nextTranslation(".concat(_0e(r), ")"), a.WrappedComponent = r;
    var o = function(c, u) {
      return M0(a, Object.assign({}, c, {
        forwardedRef: u
      }));
    };
    return t.withRef ? vR(o) : a;
  };
}
var KJ = [], B0e = KJ.forEach, V0e = KJ.slice;
function U0e(e) {
  return B0e.call(V0e.call(arguments, 1), function(t) {
    if (t)
      for (var n in t)
        e[n] === void 0 && (e[n] = t[n]);
  }), e;
}
var LB = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, G0e = function(t, n, r) {
  var a = r || {};
  a.path = a.path || "/";
  var o = encodeURIComponent(n), s = "".concat(t, "=").concat(o);
  if (a.maxAge > 0) {
    var c = a.maxAge - 0;
    if (Number.isNaN(c)) throw new Error("maxAge should be a Number");
    s += "; Max-Age=".concat(Math.floor(c));
  }
  if (a.domain) {
    if (!LB.test(a.domain))
      throw new TypeError("option domain is invalid");
    s += "; Domain=".concat(a.domain);
  }
  if (a.path) {
    if (!LB.test(a.path))
      throw new TypeError("option path is invalid");
    s += "; Path=".concat(a.path);
  }
  if (a.expires) {
    if (typeof a.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    s += "; Expires=".concat(a.expires.toUTCString());
  }
  if (a.httpOnly && (s += "; HttpOnly"), a.secure && (s += "; Secure"), a.sameSite) {
    var u = typeof a.sameSite == "string" ? a.sameSite.toLowerCase() : a.sameSite;
    switch (u) {
      case !0:
        s += "; SameSite=Strict";
        break;
      case "lax":
        s += "; SameSite=Lax";
        break;
      case "strict":
        s += "; SameSite=Strict";
        break;
      case "none":
        s += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return s;
}, $B = {
  create: function(t, n, r, a) {
    var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    r && (o.expires = /* @__PURE__ */ new Date(), o.expires.setTime(o.expires.getTime() + r * 60 * 1e3)), a && (o.domain = a), document.cookie = G0e(t, encodeURIComponent(n), o);
  },
  read: function(t) {
    for (var n = "".concat(t, "="), r = document.cookie.split(";"), a = 0; a < r.length; a++) {
      for (var o = r[a]; o.charAt(0) === " "; ) o = o.substring(1, o.length);
      if (o.indexOf(n) === 0) return o.substring(n.length, o.length);
    }
    return null;
  },
  remove: function(t) {
    this.create(t, "", -1);
  }
}, z0e = {
  name: "cookie",
  lookup: function(t) {
    var n;
    if (t.lookupCookie && typeof document != "undefined") {
      var r = $B.read(t.lookupCookie);
      r && (n = r);
    }
    return n;
  },
  cacheUserLanguage: function(t, n) {
    n.lookupCookie && typeof document != "undefined" && $B.create(n.lookupCookie, t, n.cookieMinutes, n.cookieDomain, n.cookieOptions);
  }
}, H0e = {
  name: "querystring",
  lookup: function(t) {
    var n;
    if (typeof window != "undefined") {
      var r = window.location.search;
      !window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1 && (r = window.location.hash.substring(window.location.hash.indexOf("?")));
      for (var a = r.substring(1), o = a.split("&"), s = 0; s < o.length; s++) {
        var c = o[s].indexOf("=");
        if (c > 0) {
          var u = o[s].substring(0, c);
          u === t.lookupQuerystring && (n = o[s].substring(c + 1));
        }
      }
    }
    return n;
  }
}, q3 = null, jB = function() {
  if (q3 !== null) return q3;
  try {
    q3 = window !== "undefined" && window.localStorage !== null;
    var t = "i18next.translate.boo";
    window.localStorage.setItem(t, "foo"), window.localStorage.removeItem(t);
  } catch (n) {
    q3 = !1;
  }
  return q3;
}, W0e = {
  name: "localStorage",
  lookup: function(t) {
    var n;
    if (t.lookupLocalStorage && jB()) {
      var r = window.localStorage.getItem(t.lookupLocalStorage);
      r && (n = r);
    }
    return n;
  },
  cacheUserLanguage: function(t, n) {
    n.lookupLocalStorage && jB() && window.localStorage.setItem(n.lookupLocalStorage, t);
  }
}, J3 = null, FB = function() {
  if (J3 !== null) return J3;
  try {
    J3 = window !== "undefined" && window.sessionStorage !== null;
    var t = "i18next.translate.boo";
    window.sessionStorage.setItem(t, "foo"), window.sessionStorage.removeItem(t);
  } catch (n) {
    J3 = !1;
  }
  return J3;
}, Z0e = {
  name: "sessionStorage",
  lookup: function(t) {
    var n;
    if (t.lookupSessionStorage && FB()) {
      var r = window.sessionStorage.getItem(t.lookupSessionStorage);
      r && (n = r);
    }
    return n;
  },
  cacheUserLanguage: function(t, n) {
    n.lookupSessionStorage && FB() && window.sessionStorage.setItem(n.lookupSessionStorage, t);
  }
}, Y0e = {
  name: "navigator",
  lookup: function(t) {
    var n = [];
    if (typeof navigator != "undefined") {
      if (navigator.languages)
        for (var r = 0; r < navigator.languages.length; r++)
          n.push(navigator.languages[r]);
      navigator.userLanguage && n.push(navigator.userLanguage), navigator.language && n.push(navigator.language);
    }
    return n.length > 0 ? n : void 0;
  }
}, X0e = {
  name: "htmlTag",
  lookup: function(t) {
    var n, r = t.htmlTag || (typeof document != "undefined" ? document.documentElement : null);
    return r && typeof r.getAttribute == "function" && (n = r.getAttribute("lang")), n;
  }
}, K0e = {
  name: "path",
  lookup: function(t) {
    var n;
    if (typeof window != "undefined") {
      var r = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (r instanceof Array)
        if (typeof t.lookupFromPathIndex == "number") {
          if (typeof r[t.lookupFromPathIndex] != "string")
            return;
          n = r[t.lookupFromPathIndex].replace("/", "");
        } else
          n = r[0].replace("/", "");
    }
    return n;
  }
}, q0e = {
  name: "subdomain",
  lookup: function(t) {
    var n = typeof t.lookupFromSubdomainIndex == "number" ? t.lookupFromSubdomainIndex + 1 : 1, r = typeof window != "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (r)
      return r[n];
  }
};
function J0e() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: function(t) {
      return t;
    }
  };
}
var qJ = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Fu(this, e), this.type = "languageDetector", this.detectors = {}, this.init(t, n);
  }
  return Bu(e, [{
    key: "init",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = n || {
        languageUtils: {}
      }, this.options = U0e(r, this.options || {}, J0e()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = function(o) {
        return o.replace("-", "_");
      }), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = a, this.addDetector(z0e), this.addDetector(H0e), this.addDetector(W0e), this.addDetector(Z0e), this.addDetector(Y0e), this.addDetector(X0e), this.addDetector(K0e), this.addDetector(q0e);
    }
  }, {
    key: "addDetector",
    value: function(n) {
      return this.detectors[n.name] = n, this;
    }
  }, {
    key: "detect",
    value: function(n) {
      var r = this;
      n || (n = this.options.order);
      var a = [];
      return n.forEach(function(o) {
        if (r.detectors[o]) {
          var s = r.detectors[o].lookup(r.options);
          s && typeof s == "string" && (s = [s]), s && (a = a.concat(s));
        }
      }), a = a.map(function(o) {
        return r.options.convertDetectedLanguage(o);
      }), this.services.languageUtils.getBestMatchFromCodes ? a : a.length > 0 ? a[0] : null;
    }
  }, {
    key: "cacheUserLanguage",
    value: function(n, r) {
      var a = this;
      r || (r = this.options.caches), r && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(n) > -1 || r.forEach(function(o) {
        a.detectors[o] && a.detectors[o].cacheUserLanguage(n, a.options);
      }));
    }
  }]), e;
}();
qJ.type = "languageDetector";
function WN(e) {
  "@babel/helpers - typeof";
  return WN = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, WN(e);
}
function JJ() {
  return typeof XMLHttpRequest == "function" || (typeof XMLHttpRequest == "undefined" ? "undefined" : WN(XMLHttpRequest)) === "object";
}
function Q0e(e) {
  return !!e && typeof e.then == "function";
}
function e1e(e) {
  return Q0e(e) ? e : Promise.resolve(e);
}
function t1e(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var ZN = { exports: {} }, vS = { exports: {} }, BB;
function n1e() {
  return BB || (BB = 1, function(e, t) {
    var n = typeof globalThis != "undefined" && globalThis || typeof self != "undefined" && self || typeof Nu != "undefined" && Nu, r = function() {
      function o() {
        this.fetch = !1, this.DOMException = n.DOMException;
      }
      return o.prototype = n, new o();
    }();
    (function(o) {
      (function(s) {
        var c = typeof o != "undefined" && o || typeof self != "undefined" && self || typeof c != "undefined" && c, u = {
          searchParams: "URLSearchParams" in c,
          iterable: "Symbol" in c && "iterator" in Symbol,
          blob: "FileReader" in c && "Blob" in c && function() {
            try {
              return new Blob(), !0;
            } catch (Y) {
              return !1;
            }
          }(),
          formData: "FormData" in c,
          arrayBuffer: "ArrayBuffer" in c
        };
        function f(Y) {
          return Y && DataView.prototype.isPrototypeOf(Y);
        }
        if (u.arrayBuffer)
          var m = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], v = ArrayBuffer.isView || function(Y) {
            return Y && m.indexOf(Object.prototype.toString.call(Y)) > -1;
          };
        function y(Y) {
          if (typeof Y != "string" && (Y = String(Y)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(Y) || Y === "")
            throw new TypeError('Invalid character in header field name: "' + Y + '"');
          return Y.toLowerCase();
        }
        function b(Y) {
          return typeof Y != "string" && (Y = String(Y)), Y;
        }
        function S(Y) {
          var ee = {
            next: function() {
              var oe = Y.shift();
              return { done: oe === void 0, value: oe };
            }
          };
          return u.iterable && (ee[Symbol.iterator] = function() {
            return ee;
          }), ee;
        }
        function x(Y) {
          this.map = {}, Y instanceof x ? Y.forEach(function(ee, oe) {
            this.append(oe, ee);
          }, this) : Array.isArray(Y) ? Y.forEach(function(ee) {
            this.append(ee[0], ee[1]);
          }, this) : Y && Object.getOwnPropertyNames(Y).forEach(function(ee) {
            this.append(ee, Y[ee]);
          }, this);
        }
        x.prototype.append = function(Y, ee) {
          Y = y(Y), ee = b(ee);
          var oe = this.map[Y];
          this.map[Y] = oe ? oe + ", " + ee : ee;
        }, x.prototype.delete = function(Y) {
          delete this.map[y(Y)];
        }, x.prototype.get = function(Y) {
          return Y = y(Y), this.has(Y) ? this.map[Y] : null;
        }, x.prototype.has = function(Y) {
          return this.map.hasOwnProperty(y(Y));
        }, x.prototype.set = function(Y, ee) {
          this.map[y(Y)] = b(ee);
        }, x.prototype.forEach = function(Y, ee) {
          for (var oe in this.map)
            this.map.hasOwnProperty(oe) && Y.call(ee, this.map[oe], oe, this);
        }, x.prototype.keys = function() {
          var Y = [];
          return this.forEach(function(ee, oe) {
            Y.push(oe);
          }), S(Y);
        }, x.prototype.values = function() {
          var Y = [];
          return this.forEach(function(ee) {
            Y.push(ee);
          }), S(Y);
        }, x.prototype.entries = function() {
          var Y = [];
          return this.forEach(function(ee, oe) {
            Y.push([oe, ee]);
          }), S(Y);
        }, u.iterable && (x.prototype[Symbol.iterator] = x.prototype.entries);
        function E(Y) {
          if (Y.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          Y.bodyUsed = !0;
        }
        function N(Y) {
          return new Promise(function(ee, oe) {
            Y.onload = function() {
              ee(Y.result);
            }, Y.onerror = function() {
              oe(Y.error);
            };
          });
        }
        function R(Y) {
          var ee = new FileReader(), oe = N(ee);
          return ee.readAsArrayBuffer(Y), oe;
        }
        function O(Y) {
          var ee = new FileReader(), oe = N(ee);
          return ee.readAsText(Y), oe;
        }
        function D(Y) {
          for (var ee = new Uint8Array(Y), oe = new Array(ee.length), me = 0; me < ee.length; me++)
            oe[me] = String.fromCharCode(ee[me]);
          return oe.join("");
        }
        function $(Y) {
          if (Y.slice)
            return Y.slice(0);
          var ee = new Uint8Array(Y.byteLength);
          return ee.set(new Uint8Array(Y)), ee.buffer;
        }
        function B() {
          return this.bodyUsed = !1, this._initBody = function(Y) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = Y, Y ? typeof Y == "string" ? this._bodyText = Y : u.blob && Blob.prototype.isPrototypeOf(Y) ? this._bodyBlob = Y : u.formData && FormData.prototype.isPrototypeOf(Y) ? this._bodyFormData = Y : u.searchParams && URLSearchParams.prototype.isPrototypeOf(Y) ? this._bodyText = Y.toString() : u.arrayBuffer && u.blob && f(Y) ? (this._bodyArrayBuffer = $(Y.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : u.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(Y) || v(Y)) ? this._bodyArrayBuffer = $(Y) : this._bodyText = Y = Object.prototype.toString.call(Y) : this._bodyText = "", this.headers.get("content-type") || (typeof Y == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : u.searchParams && URLSearchParams.prototype.isPrototypeOf(Y) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, u.blob && (this.blob = function() {
            var Y = E(this);
            if (Y)
              return Y;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var Y = E(this);
              return Y || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else
              return this.blob().then(R);
          }), this.text = function() {
            var Y = E(this);
            if (Y)
              return Y;
            if (this._bodyBlob)
              return O(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(D(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, u.formData && (this.formData = function() {
            return this.text().then(q);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var G = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function Z(Y) {
          var ee = Y.toUpperCase();
          return G.indexOf(ee) > -1 ? ee : Y;
        }
        function K(Y, ee) {
          if (!(this instanceof K))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          ee = ee || {};
          var oe = ee.body;
          if (Y instanceof K) {
            if (Y.bodyUsed)
              throw new TypeError("Already read");
            this.url = Y.url, this.credentials = Y.credentials, ee.headers || (this.headers = new x(Y.headers)), this.method = Y.method, this.mode = Y.mode, this.signal = Y.signal, !oe && Y._bodyInit != null && (oe = Y._bodyInit, Y.bodyUsed = !0);
          } else
            this.url = String(Y);
          if (this.credentials = ee.credentials || this.credentials || "same-origin", (ee.headers || !this.headers) && (this.headers = new x(ee.headers)), this.method = Z(ee.method || this.method || "GET"), this.mode = ee.mode || this.mode || null, this.signal = ee.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && oe)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(oe), (this.method === "GET" || this.method === "HEAD") && (ee.cache === "no-store" || ee.cache === "no-cache")) {
            var me = /([?&])_=[^&]*/;
            if (me.test(this.url))
              this.url = this.url.replace(me, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var xe = /\?/;
              this.url += (xe.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        K.prototype.clone = function() {
          return new K(this, { body: this._bodyInit });
        };
        function q(Y) {
          var ee = new FormData();
          return Y.trim().split("&").forEach(function(oe) {
            if (oe) {
              var me = oe.split("="), xe = me.shift().replace(/\+/g, " "), X = me.join("=").replace(/\+/g, " ");
              ee.append(decodeURIComponent(xe), decodeURIComponent(X));
            }
          }), ee;
        }
        function pe(Y) {
          var ee = new x(), oe = Y.replace(/\r?\n[\t ]+/g, " ");
          return oe.split("\r").map(function(me) {
            return me.indexOf(`
`) === 0 ? me.substr(1, me.length) : me;
          }).forEach(function(me) {
            var xe = me.split(":"), X = xe.shift().trim();
            if (X) {
              var ye = xe.join(":").trim();
              ee.append(X, ye);
            }
          }), ee;
        }
        B.call(K.prototype);
        function he(Y, ee) {
          if (!(this instanceof he))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          ee || (ee = {}), this.type = "default", this.status = ee.status === void 0 ? 200 : ee.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = ee.statusText === void 0 ? "" : "" + ee.statusText, this.headers = new x(ee.headers), this.url = ee.url || "", this._initBody(Y);
        }
        B.call(he.prototype), he.prototype.clone = function() {
          return new he(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new x(this.headers),
            url: this.url
          });
        }, he.error = function() {
          var Y = new he(null, { status: 0, statusText: "" });
          return Y.type = "error", Y;
        };
        var _e = [301, 302, 303, 307, 308];
        he.redirect = function(Y, ee) {
          if (_e.indexOf(ee) === -1)
            throw new RangeError("Invalid status code");
          return new he(null, { status: ee, headers: { location: Y } });
        }, s.DOMException = c.DOMException;
        try {
          new s.DOMException();
        } catch (Y) {
          s.DOMException = function(ee, oe) {
            this.message = ee, this.name = oe;
            var me = Error(ee);
            this.stack = me.stack;
          }, s.DOMException.prototype = Object.create(Error.prototype), s.DOMException.prototype.constructor = s.DOMException;
        }
        function ge(Y, ee) {
          return new Promise(function(oe, me) {
            var xe = new K(Y, ee);
            if (xe.signal && xe.signal.aborted)
              return me(new s.DOMException("Aborted", "AbortError"));
            var X = new XMLHttpRequest();
            function ye() {
              X.abort();
            }
            X.onload = function() {
              var se = {
                status: X.status,
                statusText: X.statusText,
                headers: pe(X.getAllResponseHeaders() || "")
              };
              se.url = "responseURL" in X ? X.responseURL : se.headers.get("X-Request-URL");
              var Ie = "response" in X ? X.response : X.responseText;
              setTimeout(function() {
                oe(new he(Ie, se));
              }, 0);
            }, X.onerror = function() {
              setTimeout(function() {
                me(new TypeError("Network request failed"));
              }, 0);
            }, X.ontimeout = function() {
              setTimeout(function() {
                me(new TypeError("Network request failed"));
              }, 0);
            }, X.onabort = function() {
              setTimeout(function() {
                me(new s.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function ce(se) {
              try {
                return se === "" && c.location.href ? c.location.href : se;
              } catch (Ie) {
                return se;
              }
            }
            X.open(xe.method, ce(xe.url), !0), xe.credentials === "include" ? X.withCredentials = !0 : xe.credentials === "omit" && (X.withCredentials = !1), "responseType" in X && (u.blob ? X.responseType = "blob" : u.arrayBuffer && xe.headers.get("Content-Type") && xe.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && (X.responseType = "arraybuffer")), ee && typeof ee.headers == "object" && !(ee.headers instanceof x) ? Object.getOwnPropertyNames(ee.headers).forEach(function(se) {
              X.setRequestHeader(se, b(ee.headers[se]));
            }) : xe.headers.forEach(function(se, Ie) {
              X.setRequestHeader(Ie, se);
            }), xe.signal && (xe.signal.addEventListener("abort", ye), X.onreadystatechange = function() {
              X.readyState === 4 && xe.signal.removeEventListener("abort", ye);
            }), X.send(typeof xe._bodyInit == "undefined" ? null : xe._bodyInit);
          });
        }
        return ge.polyfill = !0, c.fetch || (c.fetch = ge, c.Headers = x, c.Request = K, c.Response = he), s.Headers = x, s.Request = K, s.Response = he, s.fetch = ge, s;
      })({});
    })(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
    var a = n.fetch ? n : r;
    t = a.fetch, t.default = a.fetch, t.fetch = a.fetch, t.Headers = a.Headers, t.Request = a.Request, t.Response = a.Response, e.exports = t;
  }(vS, vS.exports)), vS.exports;
}
(function(e, t) {
  var n;
  if (typeof fetch == "function" && (typeof Nu != "undefined" && Nu.fetch ? n = Nu.fetch : typeof window != "undefined" && window.fetch ? n = window.fetch : n = fetch), typeof t1e != "undefined" && typeof window == "undefined") {
    var r = n || n1e();
    r.default && (r = r.default), t.default = r, e.exports = t.default;
  }
})(ZN, ZN.exports);
var QJ = ZN.exports;
const eQ = /* @__PURE__ */ Mt(QJ), VB = /* @__PURE__ */ Ove({
  __proto__: null,
  default: eQ
}, [QJ]);
function UB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function GB(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? UB(Object(n), !0).forEach(function(r) {
      r1e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : UB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function r1e(e, t, n) {
  return (t = a1e(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function a1e(e) {
  var t = o1e(e, "string");
  return K0(t) == "symbol" ? t : t + "";
}
function o1e(e, t) {
  if (K0(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (K0(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function K0(e) {
  "@babel/helpers - typeof";
  return K0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, K0(e);
}
var Dp;
typeof fetch == "function" && (typeof global != "undefined" && global.fetch ? Dp = global.fetch : typeof window != "undefined" && window.fetch ? Dp = window.fetch : Dp = fetch);
var n_;
JJ() && (typeof global != "undefined" && global.XMLHttpRequest ? n_ = global.XMLHttpRequest : typeof window != "undefined" && window.XMLHttpRequest && (n_ = window.XMLHttpRequest));
var x7;
typeof ActiveXObject == "function" && (typeof global != "undefined" && global.ActiveXObject ? x7 = global.ActiveXObject : typeof window != "undefined" && window.ActiveXObject && (x7 = window.ActiveXObject));
!Dp && VB && !n_ && !x7 && (Dp = eQ || VB);
typeof Dp != "function" && (Dp = void 0);
var YN = function(t, n) {
  if (n && K0(n) === "object") {
    var r = "";
    for (var a in n)
      r += "&" + encodeURIComponent(a) + "=" + encodeURIComponent(n[a]);
    if (!r) return t;
    t = t + (t.indexOf("?") !== -1 ? "&" : "?") + r.slice(1);
  }
  return t;
}, zB = function(t, n, r, a) {
  var o = function(u) {
    if (!u.ok) return r(u.statusText || "Error", {
      status: u.status
    });
    u.text().then(function(f) {
      r(null, {
        status: u.status,
        data: f
      });
    }).catch(r);
  };
  if (a) {
    var s = a(t, n);
    if (s instanceof Promise) {
      s.then(o).catch(r);
      return;
    }
  }
  typeof fetch == "function" ? fetch(t, n).then(o).catch(r) : Dp(t, n).then(o).catch(r);
}, HB = !1, i1e = function(t, n, r, a) {
  t.queryStringParams && (n = YN(n, t.queryStringParams));
  var o = GB({}, typeof t.customHeaders == "function" ? t.customHeaders() : t.customHeaders);
  typeof window == "undefined" && typeof global != "undefined" && typeof global.process != "undefined" && global.process.versions && global.process.versions.node && (o["User-Agent"] = "i18next-http-backend (node/".concat(global.process.version, "; ").concat(global.process.platform, " ").concat(global.process.arch, ")")), r && (o["Content-Type"] = "application/json");
  var s = typeof t.requestOptions == "function" ? t.requestOptions(r) : t.requestOptions, c = GB({
    method: r ? "POST" : "GET",
    body: r ? t.stringify(r) : void 0,
    headers: o
  }, HB ? {} : s), u = typeof t.alternateFetch == "function" && t.alternateFetch.length >= 1 ? t.alternateFetch : void 0;
  try {
    zB(n, c, a, u);
  } catch (f) {
    if (!s || Object.keys(s).length === 0 || !f.message || f.message.indexOf("not implemented") < 0)
      return a(f);
    try {
      Object.keys(s).forEach(function(m) {
        delete c[m];
      }), zB(n, c, a, u), HB = !0;
    } catch (m) {
      a(m);
    }
  }
}, s1e = function(t, n, r, a) {
  r && K0(r) === "object" && (r = YN("", r).slice(1)), t.queryStringParams && (n = YN(n, t.queryStringParams));
  try {
    var o;
    n_ ? o = new n_() : o = new x7("MSXML2.XMLHTTP.3.0"), o.open(r ? "POST" : "GET", n, 1), t.crossDomain || o.setRequestHeader("X-Requested-With", "XMLHttpRequest"), o.withCredentials = !!t.withCredentials, r && o.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), o.overrideMimeType && o.overrideMimeType("application/json");
    var s = t.customHeaders;
    if (s = typeof s == "function" ? s() : s, s)
      for (var c in s)
        o.setRequestHeader(c, s[c]);
    o.onreadystatechange = function() {
      o.readyState > 3 && a(o.status >= 400 ? o.statusText : null, {
        status: o.status,
        data: o.responseText
      });
    }, o.send(r);
  } catch (u) {
    console && console.log(u);
  }
}, l1e = function(t, n, r, a) {
  if (typeof r == "function" && (a = r, r = void 0), a = a || function() {
  }, Dp && n.indexOf("file:") !== 0)
    return i1e(t, n, r, a);
  if (JJ() || typeof ActiveXObject == "function")
    return s1e(t, n, r, a);
  a(new Error("No fetch and no xhr implementation found!"));
};
function r2(e) {
  "@babel/helpers - typeof";
  return r2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, r2(e);
}
function WB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Nk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? WB(Object(n), !0).forEach(function(r) {
      tQ(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : WB(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function u1e(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function c1e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, nQ(r.key), r);
  }
}
function d1e(e, t, n) {
  return t && c1e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function tQ(e, t, n) {
  return (t = nQ(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nQ(e) {
  var t = f1e(e, "string");
  return r2(t) == "symbol" ? t : t + "";
}
function f1e(e, t) {
  if (r2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (r2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var p1e = function() {
  return {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
    addPath: "/locales/add/{{lng}}/{{ns}}",
    parse: function(n) {
      return JSON.parse(n);
    },
    stringify: JSON.stringify,
    parsePayload: function(n, r, a) {
      return tQ({}, r, a || "");
    },
    parseLoadPayload: function(n, r) {
    },
    request: l1e,
    reloadInterval: typeof window != "undefined" ? !1 : 60 * 60 * 1e3,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: !1,
    withCredentials: !1,
    overrideMimeType: !1,
    requestOptions: {
      mode: "cors",
      credentials: "same-origin",
      cache: "default"
    }
  };
}, rQ = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    u1e(this, e), this.services = t, this.options = n, this.allOptions = r, this.type = "backend", this.init(t, n, r);
  }
  return d1e(e, [{
    key: "init",
    value: function(n) {
      var r = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (this.services = n, this.options = Nk(Nk(Nk({}, p1e()), this.options || {}), a), this.allOptions = o, this.services && this.options.reloadInterval) {
        var s = setInterval(function() {
          return r.reload();
        }, this.options.reloadInterval);
        r2(s) === "object" && typeof s.unref == "function" && s.unref();
      }
    }
  }, {
    key: "readMulti",
    value: function(n, r, a) {
      this._readAny(n, n, r, r, a);
    }
  }, {
    key: "read",
    value: function(n, r, a) {
      this._readAny([n], n, [r], r, a);
    }
  }, {
    key: "_readAny",
    value: function(n, r, a, o, s) {
      var c = this, u = this.options.loadPath;
      typeof this.options.loadPath == "function" && (u = this.options.loadPath(n, a)), u = e1e(u), u.then(function(f) {
        if (!f) return s(null, {});
        var m = c.services.interpolator.interpolate(f, {
          lng: n.join("+"),
          ns: a.join("+")
        });
        c.loadUrl(m, s, r, o);
      });
    }
  }, {
    key: "loadUrl",
    value: function(n, r, a, o) {
      var s = this, c = typeof a == "string" ? [a] : a, u = typeof o == "string" ? [o] : o, f = this.options.parseLoadPayload(c, u);
      this.options.request(this.options, n, f, function(m, v) {
        if (v && (v.status >= 500 && v.status < 600 || !v.status)) return r("failed loading " + n + "; status code: " + v.status, !0);
        if (v && v.status >= 400 && v.status < 500) return r("failed loading " + n + "; status code: " + v.status, !1);
        if (!v && m && m.message && m.message.toLowerCase().indexOf("failed") > -1 && (m.message.indexOf("fetch") > -1 || m.message.toLowerCase().indexOf("network") > -1)) return r("failed loading " + n + ": " + m.message, !0);
        if (m) return r(m, !1);
        var y, b;
        try {
          typeof v.data == "string" ? y = s.options.parse(v.data, a, o) : y = v.data;
        } catch (S) {
          b = "failed parsing " + n + " to json";
        }
        if (b) return r(b, !1);
        r(null, y);
      });
    }
  }, {
    key: "create",
    value: function(n, r, a, o, s) {
      var c = this;
      if (this.options.addPath) {
        typeof n == "string" && (n = [n]);
        var u = this.options.parsePayload(r, a, o), f = 0, m = [], v = [];
        n.forEach(function(y) {
          var b = c.options.addPath;
          typeof c.options.addPath == "function" && (b = c.options.addPath(y, r));
          var S = c.services.interpolator.interpolate(b, {
            lng: y,
            ns: r
          });
          c.options.request(c.options, S, u, function(x, E) {
            f += 1, m.push(x), v.push(E), f === n.length && typeof s == "function" && s(m, v);
          });
        });
      }
    }
  }, {
    key: "reload",
    value: function() {
      var n = this, r = this.services, a = r.backendConnector, o = r.languageUtils, s = r.logger, c = a.language;
      if (!(c && c.toLowerCase() === "cimode")) {
        var u = [], f = function(v) {
          var y = o.toResolveHierarchy(v);
          y.forEach(function(b) {
            u.indexOf(b) < 0 && u.push(b);
          });
        };
        f(c), this.allOptions.preload && this.allOptions.preload.forEach(function(m) {
          return f(m);
        }), u.forEach(function(m) {
          n.allOptions.ns.forEach(function(v) {
            a.read(m, v, "read", null, null, function(y, b) {
              y && s.warn("loading namespace ".concat(v, " for language ").concat(m, " failed"), y), !y && b && s.log("loaded namespace ".concat(v, " for language ").concat(m), b), a.loaded("".concat(m, "|").concat(v), y, b);
            });
          });
        });
      }
    }
  }]);
}();
rQ.type = "backend";
ca.use(qJ).use(rQ).use(R0e).init({
  returnEmptyString: !1,
  interpolation: {
    escapeValue: !1,
    prefix: "{{",
    suffix: "}}"
  },
  nsSeparator: !1,
  keySeparator: !1,
  fallbackLng: !1,
  ns: ["translations"],
  defaultNS: "translations",
  updateMissing: !0,
  react: {
    wait: !0,
    bindI18n: "languageChanged loaded",
    useSuspense: !1
  },
  backend: {
    loadPath: "/cleeng-translations/{{lng}}/{{ns}}.json"
  },
  returnNull: !1
});
var XN = { exports: {} }, Q3 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ZB;
function h1e() {
  if (ZB) return Q3;
  ZB = 1;
  var e = vo, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(c, u, f) {
    var m, v = {}, y = null, b = null;
    f !== void 0 && (y = "" + f), u.key !== void 0 && (y = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (m in u) r.call(u, m) && !o.hasOwnProperty(m) && (v[m] = u[m]);
    if (c && c.defaultProps) for (m in u = c.defaultProps, u) v[m] === void 0 && (v[m] = u[m]);
    return { $$typeof: t, type: c, key: y, ref: b, props: v, _owner: a.current };
  }
  return Q3.Fragment = n, Q3.jsx = s, Q3.jsxs = s, Q3;
}
var e4 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var YB;
function m1e() {
  return YB || (YB = 1, process.env.NODE_ENV !== "production" && function() {
    var e = vo, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), c = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), S = Symbol.iterator, x = "@@iterator";
    function E(Ce) {
      if (Ce === null || typeof Ce != "object")
        return null;
      var pt = S && Ce[S] || Ce[x];
      return typeof pt == "function" ? pt : null;
    }
    var N = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(Ce) {
      {
        for (var pt = arguments.length, Nt = new Array(pt > 1 ? pt - 1 : 0), Vt = 1; Vt < pt; Vt++)
          Nt[Vt - 1] = arguments[Vt];
        O("error", Ce, Nt);
      }
    }
    function O(Ce, pt, Nt) {
      {
        var Vt = N.ReactDebugCurrentFrame, Mn = Vt.getStackAddendum();
        Mn !== "" && (pt += "%s", Nt = Nt.concat([Mn]));
        var Dn = Nt.map(function(vn) {
          return String(vn);
        });
        Dn.unshift("Warning: " + pt), Function.prototype.apply.call(console[Ce], console, Dn);
      }
    }
    var D = !1, $ = !1, B = !1, G = !1, Z = !1, K;
    K = Symbol.for("react.module.reference");
    function q(Ce) {
      return !!(typeof Ce == "string" || typeof Ce == "function" || Ce === r || Ce === o || Z || Ce === a || Ce === f || Ce === m || G || Ce === b || D || $ || B || typeof Ce == "object" && Ce !== null && (Ce.$$typeof === y || Ce.$$typeof === v || Ce.$$typeof === s || Ce.$$typeof === c || Ce.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Ce.$$typeof === K || Ce.getModuleId !== void 0));
    }
    function pe(Ce, pt, Nt) {
      var Vt = Ce.displayName;
      if (Vt)
        return Vt;
      var Mn = pt.displayName || pt.name || "";
      return Mn !== "" ? Nt + "(" + Mn + ")" : Nt;
    }
    function he(Ce) {
      return Ce.displayName || "Context";
    }
    function _e(Ce) {
      if (Ce == null)
        return null;
      if (typeof Ce.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Ce == "function")
        return Ce.displayName || Ce.name || null;
      if (typeof Ce == "string")
        return Ce;
      switch (Ce) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case f:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof Ce == "object")
        switch (Ce.$$typeof) {
          case c:
            var pt = Ce;
            return he(pt) + ".Consumer";
          case s:
            var Nt = Ce;
            return he(Nt._context) + ".Provider";
          case u:
            return pe(Ce, Ce.render, "ForwardRef");
          case v:
            var Vt = Ce.displayName || null;
            return Vt !== null ? Vt : _e(Ce.type) || "Memo";
          case y: {
            var Mn = Ce, Dn = Mn._payload, vn = Mn._init;
            try {
              return _e(vn(Dn));
            } catch (Hn) {
              return null;
            }
          }
        }
      return null;
    }
    var ge = Object.assign, Y = 0, ee, oe, me, xe, X, ye, ce;
    function se() {
    }
    se.__reactDisabledLog = !0;
    function Ie() {
      {
        if (Y === 0) {
          ee = console.log, oe = console.info, me = console.warn, xe = console.error, X = console.group, ye = console.groupCollapsed, ce = console.groupEnd;
          var Ce = {
            configurable: !0,
            enumerable: !0,
            value: se,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Ce,
            log: Ce,
            warn: Ce,
            error: Ce,
            group: Ce,
            groupCollapsed: Ce,
            groupEnd: Ce
          });
        }
        Y++;
      }
    }
    function Le() {
      {
        if (Y--, Y === 0) {
          var Ce = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ge({}, Ce, {
              value: ee
            }),
            info: ge({}, Ce, {
              value: oe
            }),
            warn: ge({}, Ce, {
              value: me
            }),
            error: ge({}, Ce, {
              value: xe
            }),
            group: ge({}, Ce, {
              value: X
            }),
            groupCollapsed: ge({}, Ce, {
              value: ye
            }),
            groupEnd: ge({}, Ce, {
              value: ce
            })
          });
        }
        Y < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ie = N.ReactCurrentDispatcher, $e;
    function we(Ce, pt, Nt) {
      {
        if ($e === void 0)
          try {
            throw Error();
          } catch (Mn) {
            var Vt = Mn.stack.trim().match(/\n( *(at )?)/);
            $e = Vt && Vt[1] || "";
          }
        return `
` + $e + Ce;
      }
    }
    var Ne = !1, Ee;
    {
      var le = typeof WeakMap == "function" ? WeakMap : Map;
      Ee = new le();
    }
    function be(Ce, pt) {
      if (!Ce || Ne)
        return "";
      {
        var Nt = Ee.get(Ce);
        if (Nt !== void 0)
          return Nt;
      }
      var Vt;
      Ne = !0;
      var Mn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Dn;
      Dn = ie.current, ie.current = null, Ie();
      try {
        if (pt) {
          var vn = function() {
            throw Error();
          };
          if (Object.defineProperty(vn.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(vn, []);
            } catch (Ra) {
              Vt = Ra;
            }
            Reflect.construct(Ce, [], vn);
          } else {
            try {
              vn.call();
            } catch (Ra) {
              Vt = Ra;
            }
            Ce.call(vn.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ra) {
            Vt = Ra;
          }
          Ce();
        }
      } catch (Ra) {
        if (Ra && Vt && typeof Ra.stack == "string") {
          for (var Hn = Ra.stack.split(`
`), Ja = Vt.stack.split(`
`), Qr = Hn.length - 1, sa = Ja.length - 1; Qr >= 1 && sa >= 0 && Hn[Qr] !== Ja[sa]; )
            sa--;
          for (; Qr >= 1 && sa >= 0; Qr--, sa--)
            if (Hn[Qr] !== Ja[sa]) {
              if (Qr !== 1 || sa !== 1)
                do
                  if (Qr--, sa--, sa < 0 || Hn[Qr] !== Ja[sa]) {
                    var gi = `
` + Hn[Qr].replace(" at new ", " at ");
                    return Ce.displayName && gi.includes("<anonymous>") && (gi = gi.replace("<anonymous>", Ce.displayName)), typeof Ce == "function" && Ee.set(Ce, gi), gi;
                  }
                while (Qr >= 1 && sa >= 0);
              break;
            }
        }
      } finally {
        Ne = !1, ie.current = Dn, Le(), Error.prepareStackTrace = Mn;
      }
      var Cs = Ce ? Ce.displayName || Ce.name : "", tr = Cs ? we(Cs) : "";
      return typeof Ce == "function" && Ee.set(Ce, tr), tr;
    }
    function He(Ce, pt, Nt) {
      return be(Ce, !1);
    }
    function Ae(Ce) {
      var pt = Ce.prototype;
      return !!(pt && pt.isReactComponent);
    }
    function it(Ce, pt, Nt) {
      if (Ce == null)
        return "";
      if (typeof Ce == "function")
        return be(Ce, Ae(Ce));
      if (typeof Ce == "string")
        return we(Ce);
      switch (Ce) {
        case f:
          return we("Suspense");
        case m:
          return we("SuspenseList");
      }
      if (typeof Ce == "object")
        switch (Ce.$$typeof) {
          case u:
            return He(Ce.render);
          case v:
            return it(Ce.type, pt, Nt);
          case y: {
            var Vt = Ce, Mn = Vt._payload, Dn = Vt._init;
            try {
              return it(Dn(Mn), pt, Nt);
            } catch (vn) {
            }
          }
        }
      return "";
    }
    var ut = Object.prototype.hasOwnProperty, St = {}, sn = N.ReactDebugCurrentFrame;
    function zn(Ce) {
      if (Ce) {
        var pt = Ce._owner, Nt = it(Ce.type, Ce._source, pt ? pt.type : null);
        sn.setExtraStackFrame(Nt);
      } else
        sn.setExtraStackFrame(null);
    }
    function dn(Ce, pt, Nt, Vt, Mn) {
      {
        var Dn = Function.call.bind(ut);
        for (var vn in Ce)
          if (Dn(Ce, vn)) {
            var Hn = void 0;
            try {
              if (typeof Ce[vn] != "function") {
                var Ja = Error((Vt || "React class") + ": " + Nt + " type `" + vn + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Ce[vn] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ja.name = "Invariant Violation", Ja;
              }
              Hn = Ce[vn](pt, vn, Vt, Nt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Qr) {
              Hn = Qr;
            }
            Hn && !(Hn instanceof Error) && (zn(Mn), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Vt || "React class", Nt, vn, typeof Hn), zn(null)), Hn instanceof Error && !(Hn.message in St) && (St[Hn.message] = !0, zn(Mn), R("Failed %s type: %s", Nt, Hn.message), zn(null));
          }
      }
    }
    var $t = Array.isArray;
    function qt(Ce) {
      return $t(Ce);
    }
    function fn(Ce) {
      {
        var pt = typeof Symbol == "function" && Symbol.toStringTag, Nt = pt && Ce[Symbol.toStringTag] || Ce.constructor.name || "Object";
        return Nt;
      }
    }
    function At(Ce) {
      try {
        return Wt(Ce), !1;
      } catch (pt) {
        return !0;
      }
    }
    function Wt(Ce) {
      return "" + Ce;
    }
    function Xr(Ce) {
      if (At(Ce))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", fn(Ce)), Wt(Ce);
    }
    var Kn = N.ReactCurrentOwner, Sr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, jo, ei, tt;
    tt = {};
    function bt(Ce) {
      if (ut.call(Ce, "ref")) {
        var pt = Object.getOwnPropertyDescriptor(Ce, "ref").get;
        if (pt && pt.isReactWarning)
          return !1;
      }
      return Ce.ref !== void 0;
    }
    function rn(Ce) {
      if (ut.call(Ce, "key")) {
        var pt = Object.getOwnPropertyDescriptor(Ce, "key").get;
        if (pt && pt.isReactWarning)
          return !1;
      }
      return Ce.key !== void 0;
    }
    function Rn(Ce, pt) {
      if (typeof Ce.ref == "string" && Kn.current && pt && Kn.current.stateNode !== pt) {
        var Nt = _e(Kn.current.type);
        tt[Nt] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _e(Kn.current.type), Ce.ref), tt[Nt] = !0);
      }
    }
    function Cn(Ce, pt) {
      {
        var Nt = function() {
          jo || (jo = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", pt));
        };
        Nt.isReactWarning = !0, Object.defineProperty(Ce, "key", {
          get: Nt,
          configurable: !0
        });
      }
    }
    function Qn(Ce, pt) {
      {
        var Nt = function() {
          ei || (ei = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", pt));
        };
        Nt.isReactWarning = !0, Object.defineProperty(Ce, "ref", {
          get: Nt,
          configurable: !0
        });
      }
    }
    var er = function(Ce, pt, Nt, Vt, Mn, Dn, vn) {
      var Hn = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: Ce,
        key: pt,
        ref: Nt,
        props: vn,
        // Record the component responsible for creating this element.
        _owner: Dn
      };
      return Hn._store = {}, Object.defineProperty(Hn._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Hn, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Vt
      }), Object.defineProperty(Hn, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Mn
      }), Object.freeze && (Object.freeze(Hn.props), Object.freeze(Hn)), Hn;
    };
    function oo(Ce, pt, Nt, Vt, Mn) {
      {
        var Dn, vn = {}, Hn = null, Ja = null;
        Nt !== void 0 && (Xr(Nt), Hn = "" + Nt), rn(pt) && (Xr(pt.key), Hn = "" + pt.key), bt(pt) && (Ja = pt.ref, Rn(pt, Mn));
        for (Dn in pt)
          ut.call(pt, Dn) && !Sr.hasOwnProperty(Dn) && (vn[Dn] = pt[Dn]);
        if (Ce && Ce.defaultProps) {
          var Qr = Ce.defaultProps;
          for (Dn in Qr)
            vn[Dn] === void 0 && (vn[Dn] = Qr[Dn]);
        }
        if (Hn || Ja) {
          var sa = typeof Ce == "function" ? Ce.displayName || Ce.name || "Unknown" : Ce;
          Hn && Cn(vn, sa), Ja && Qn(vn, sa);
        }
        return er(Ce, Hn, Ja, Mn, Vt, Kn.current, vn);
      }
    }
    var Lr = N.ReactCurrentOwner, ia = N.ReactDebugCurrentFrame;
    function ir(Ce) {
      if (Ce) {
        var pt = Ce._owner, Nt = it(Ce.type, Ce._source, pt ? pt.type : null);
        ia.setExtraStackFrame(Nt);
      } else
        ia.setExtraStackFrame(null);
    }
    var xr;
    xr = !1;
    function wo(Ce) {
      return typeof Ce == "object" && Ce !== null && Ce.$$typeof === t;
    }
    function es() {
      {
        if (Lr.current) {
          var Ce = _e(Lr.current.type);
          if (Ce)
            return `

Check the render method of \`` + Ce + "`.";
        }
        return "";
      }
    }
    function ti(Ce) {
      return "";
    }
    var bs = {};
    function _s(Ce) {
      {
        var pt = es();
        if (!pt) {
          var Nt = typeof Ce == "string" ? Ce : Ce.displayName || Ce.name;
          Nt && (pt = `

Check the top-level render call using <` + Nt + ">.");
        }
        return pt;
      }
    }
    function ni(Ce, pt) {
      {
        if (!Ce._store || Ce._store.validated || Ce.key != null)
          return;
        Ce._store.validated = !0;
        var Nt = _s(pt);
        if (bs[Nt])
          return;
        bs[Nt] = !0;
        var Vt = "";
        Ce && Ce._owner && Ce._owner !== Lr.current && (Vt = " It was passed a child from " + _e(Ce._owner.type) + "."), ir(Ce), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Nt, Vt), ir(null);
      }
    }
    function Ka(Ce, pt) {
      {
        if (typeof Ce != "object")
          return;
        if (qt(Ce))
          for (var Nt = 0; Nt < Ce.length; Nt++) {
            var Vt = Ce[Nt];
            wo(Vt) && ni(Vt, pt);
          }
        else if (wo(Ce))
          Ce._store && (Ce._store.validated = !0);
        else if (Ce) {
          var Mn = E(Ce);
          if (typeof Mn == "function" && Mn !== Ce.entries)
            for (var Dn = Mn.call(Ce), vn; !(vn = Dn.next()).done; )
              wo(vn.value) && ni(vn.value, pt);
        }
      }
    }
    function So(Ce) {
      {
        var pt = Ce.type;
        if (pt == null || typeof pt == "string")
          return;
        var Nt;
        if (typeof pt == "function")
          Nt = pt.propTypes;
        else if (typeof pt == "object" && (pt.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        pt.$$typeof === v))
          Nt = pt.propTypes;
        else
          return;
        if (Nt) {
          var Vt = _e(pt);
          dn(Nt, Ce.props, "prop", Vt, Ce);
        } else if (pt.PropTypes !== void 0 && !xr) {
          xr = !0;
          var Mn = _e(pt);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Mn || "Unknown");
        }
        typeof pt.getDefaultProps == "function" && !pt.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Fo(Ce) {
      {
        for (var pt = Object.keys(Ce.props), Nt = 0; Nt < pt.length; Nt++) {
          var Vt = pt[Nt];
          if (Vt !== "children" && Vt !== "key") {
            ir(Ce), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Vt), ir(null);
            break;
          }
        }
        Ce.ref !== null && (ir(Ce), R("Invalid attribute `ref` supplied to `React.Fragment`."), ir(null));
      }
    }
    var Pa = {};
    function ri(Ce, pt, Nt, Vt, Mn, Dn) {
      {
        var vn = q(Ce);
        if (!vn) {
          var Hn = "";
          (Ce === void 0 || typeof Ce == "object" && Ce !== null && Object.keys(Ce).length === 0) && (Hn += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ja = ti();
          Ja ? Hn += Ja : Hn += es();
          var Qr;
          Ce === null ? Qr = "null" : qt(Ce) ? Qr = "array" : Ce !== void 0 && Ce.$$typeof === t ? (Qr = "<" + (_e(Ce.type) || "Unknown") + " />", Hn = " Did you accidentally export a JSX literal instead of a component?") : Qr = typeof Ce, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Qr, Hn);
        }
        var sa = oo(Ce, pt, Nt, Mn, Dn);
        if (sa == null)
          return sa;
        if (vn) {
          var gi = pt.children;
          if (gi !== void 0)
            if (Vt)
              if (qt(gi)) {
                for (var Cs = 0; Cs < gi.length; Cs++)
                  Ka(gi[Cs], Ce);
                Object.freeze && Object.freeze(gi);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ka(gi, Ce);
        }
        if (ut.call(pt, "key")) {
          var tr = _e(Ce), Ra = Object.keys(pt).filter(function(Gs) {
            return Gs !== "key";
          }), Eo = Ra.length > 0 ? "{key: someKey, " + Ra.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Pa[tr + Eo]) {
            var Vn = Ra.length > 0 ? "{" + Ra.join(": ..., ") + ": ...}" : "{}";
            R(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Eo, tr, Vn, tr), Pa[tr + Eo] = !0;
          }
        }
        return Ce === r ? Fo(sa) : So(sa), sa;
      }
    }
    function xo(Ce, pt, Nt) {
      return ri(Ce, pt, Nt, !0);
    }
    function qa(Ce, pt, Nt) {
      return ri(Ce, pt, Nt, !1);
    }
    var ml = qa, bu = xo;
    e4.Fragment = r, e4.jsx = ml, e4.jsxs = bu;
  }()), e4;
}
process.env.NODE_ENV === "production" ? XN.exports = h1e() : XN.exports = m1e();
var C = XN.exports, KN = { exports: {} }, gS = { exports: {} }, ga = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var XB;
function v1e() {
  if (XB) return ga;
  XB = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, E = e ? Symbol.for("react.fundamental") : 60117, N = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
  function O($) {
    if (typeof $ == "object" && $ !== null) {
      var B = $.$$typeof;
      switch (B) {
        case t:
          switch ($ = $.type, $) {
            case u:
            case f:
            case r:
            case o:
            case a:
            case v:
              return $;
            default:
              switch ($ = $ && $.$$typeof, $) {
                case c:
                case m:
                case S:
                case b:
                case s:
                  return $;
                default:
                  return B;
              }
          }
        case n:
          return B;
      }
    }
  }
  function D($) {
    return O($) === f;
  }
  return ga.AsyncMode = u, ga.ConcurrentMode = f, ga.ContextConsumer = c, ga.ContextProvider = s, ga.Element = t, ga.ForwardRef = m, ga.Fragment = r, ga.Lazy = S, ga.Memo = b, ga.Portal = n, ga.Profiler = o, ga.StrictMode = a, ga.Suspense = v, ga.isAsyncMode = function($) {
    return D($) || O($) === u;
  }, ga.isConcurrentMode = D, ga.isContextConsumer = function($) {
    return O($) === c;
  }, ga.isContextProvider = function($) {
    return O($) === s;
  }, ga.isElement = function($) {
    return typeof $ == "object" && $ !== null && $.$$typeof === t;
  }, ga.isForwardRef = function($) {
    return O($) === m;
  }, ga.isFragment = function($) {
    return O($) === r;
  }, ga.isLazy = function($) {
    return O($) === S;
  }, ga.isMemo = function($) {
    return O($) === b;
  }, ga.isPortal = function($) {
    return O($) === n;
  }, ga.isProfiler = function($) {
    return O($) === o;
  }, ga.isStrictMode = function($) {
    return O($) === a;
  }, ga.isSuspense = function($) {
    return O($) === v;
  }, ga.isValidElementType = function($) {
    return typeof $ == "string" || typeof $ == "function" || $ === r || $ === f || $ === o || $ === a || $ === v || $ === y || typeof $ == "object" && $ !== null && ($.$$typeof === S || $.$$typeof === b || $.$$typeof === s || $.$$typeof === c || $.$$typeof === m || $.$$typeof === E || $.$$typeof === N || $.$$typeof === R || $.$$typeof === x);
  }, ga.typeOf = O, ga;
}
var ya = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var KB;
function g1e() {
  return KB || (KB = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, E = e ? Symbol.for("react.fundamental") : 60117, N = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
    function O(be) {
      return typeof be == "string" || typeof be == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      be === r || be === f || be === o || be === a || be === v || be === y || typeof be == "object" && be !== null && (be.$$typeof === S || be.$$typeof === b || be.$$typeof === s || be.$$typeof === c || be.$$typeof === m || be.$$typeof === E || be.$$typeof === N || be.$$typeof === R || be.$$typeof === x);
    }
    function D(be) {
      if (typeof be == "object" && be !== null) {
        var He = be.$$typeof;
        switch (He) {
          case t:
            var Ae = be.type;
            switch (Ae) {
              case u:
              case f:
              case r:
              case o:
              case a:
              case v:
                return Ae;
              default:
                var it = Ae && Ae.$$typeof;
                switch (it) {
                  case c:
                  case m:
                  case S:
                  case b:
                  case s:
                    return it;
                  default:
                    return He;
                }
            }
          case n:
            return He;
        }
      }
    }
    var $ = u, B = f, G = c, Z = s, K = t, q = m, pe = r, he = S, _e = b, ge = n, Y = o, ee = a, oe = v, me = !1;
    function xe(be) {
      return me || (me = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), X(be) || D(be) === u;
    }
    function X(be) {
      return D(be) === f;
    }
    function ye(be) {
      return D(be) === c;
    }
    function ce(be) {
      return D(be) === s;
    }
    function se(be) {
      return typeof be == "object" && be !== null && be.$$typeof === t;
    }
    function Ie(be) {
      return D(be) === m;
    }
    function Le(be) {
      return D(be) === r;
    }
    function ie(be) {
      return D(be) === S;
    }
    function $e(be) {
      return D(be) === b;
    }
    function we(be) {
      return D(be) === n;
    }
    function Ne(be) {
      return D(be) === o;
    }
    function Ee(be) {
      return D(be) === a;
    }
    function le(be) {
      return D(be) === v;
    }
    ya.AsyncMode = $, ya.ConcurrentMode = B, ya.ContextConsumer = G, ya.ContextProvider = Z, ya.Element = K, ya.ForwardRef = q, ya.Fragment = pe, ya.Lazy = he, ya.Memo = _e, ya.Portal = ge, ya.Profiler = Y, ya.StrictMode = ee, ya.Suspense = oe, ya.isAsyncMode = xe, ya.isConcurrentMode = X, ya.isContextConsumer = ye, ya.isContextProvider = ce, ya.isElement = se, ya.isForwardRef = Ie, ya.isFragment = Le, ya.isLazy = ie, ya.isMemo = $e, ya.isPortal = we, ya.isProfiler = Ne, ya.isStrictMode = Ee, ya.isSuspense = le, ya.isValidElementType = O, ya.typeOf = D;
  }()), ya;
}
var qB;
function _R() {
  return qB || (qB = 1, process.env.NODE_ENV === "production" ? gS.exports = v1e() : gS.exports = g1e()), gS.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Tk, JB;
function y1e() {
  if (JB) return Tk;
  JB = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, c = 0; c < 10; c++)
        s["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(s).map(function(m) {
        return s[m];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        f[m] = m;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch (m) {
      return !1;
    }
  }
  return Tk = a() ? Object.assign : function(o, s) {
    for (var c, u = r(o), f, m = 1; m < arguments.length; m++) {
      c = Object(arguments[m]);
      for (var v in c)
        t.call(c, v) && (u[v] = c[v]);
      if (e) {
        f = e(c);
        for (var y = 0; y < f.length; y++)
          n.call(c, f[y]) && (u[f[y]] = c[f[y]]);
      }
    }
    return u;
  }, Tk;
}
var Ok, QB;
function CR() {
  if (QB) return Ok;
  QB = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ok = e, Ok;
}
var Rk, eV;
function aQ() {
  return eV || (eV = 1, Rk = Function.call.bind(Object.prototype.hasOwnProperty)), Rk;
}
var Mk, tV;
function b1e() {
  if (tV) return Mk;
  tV = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = CR(), n = {}, r = aQ();
    e = function(o) {
      var s = "Warning: " + o;
      typeof console != "undefined" && console.error(s);
      try {
        throw new Error(s);
      } catch (c) {
      }
    };
  }
  function a(o, s, c, u, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var m in o)
        if (r(o, m)) {
          var v;
          try {
            if (typeof o[m] != "function") {
              var y = Error(
                (u || "React class") + ": " + c + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw y.name = "Invariant Violation", y;
            }
            v = o[m](s, m, u, c, null, t);
          } catch (S) {
            v = S;
          }
          if (v && !(v instanceof Error) && e(
            (u || "React class") + ": type specification of " + c + " `" + m + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof v + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), v instanceof Error && !(v.message in n)) {
            n[v.message] = !0;
            var b = f ? f() : "";
            e(
              "Failed " + c + " type: " + v.message + (b != null ? b : "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Mk = a, Mk;
}
var Dk, nV;
function _1e() {
  if (nV) return Dk;
  nV = 1;
  var e = _R(), t = y1e(), n = CR(), r = aQ(), a = b1e(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(c) {
    var u = "Warning: " + c;
    typeof console != "undefined" && console.error(u);
    try {
      throw new Error(u);
    } catch (f) {
    }
  });
  function s() {
    return null;
  }
  return Dk = function(c, u) {
    var f = typeof Symbol == "function" && Symbol.iterator, m = "@@iterator";
    function v(X) {
      var ye = X && (f && X[f] || X[m]);
      if (typeof ye == "function")
        return ye;
    }
    var y = "<<anonymous>>", b = {
      array: N("array"),
      bigint: N("bigint"),
      bool: N("boolean"),
      func: N("function"),
      number: N("number"),
      object: N("object"),
      string: N("string"),
      symbol: N("symbol"),
      any: R(),
      arrayOf: O,
      element: D(),
      elementType: $(),
      instanceOf: B,
      node: q(),
      objectOf: Z,
      oneOf: G,
      oneOfType: K,
      shape: he,
      exact: _e
    };
    function S(X, ye) {
      return X === ye ? X !== 0 || 1 / X === 1 / ye : X !== X && ye !== ye;
    }
    function x(X, ye) {
      this.message = X, this.data = ye && typeof ye == "object" ? ye : {}, this.stack = "";
    }
    x.prototype = Error.prototype;
    function E(X) {
      if (process.env.NODE_ENV !== "production")
        var ye = {}, ce = 0;
      function se(Le, ie, $e, we, Ne, Ee, le) {
        if (we = we || y, Ee = Ee || $e, le !== n) {
          if (u) {
            var be = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw be.name = "Invariant Violation", be;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var He = we + ":" + $e;
            !ye[He] && // Avoid spamming the console because they are often not actionable except for lib authors
            ce < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + Ee + "` prop on `" + we + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ye[He] = !0, ce++);
          }
        }
        return ie[$e] == null ? Le ? ie[$e] === null ? new x("The " + Ne + " `" + Ee + "` is marked as required " + ("in `" + we + "`, but its value is `null`.")) : new x("The " + Ne + " `" + Ee + "` is marked as required in " + ("`" + we + "`, but its value is `undefined`.")) : null : X(ie, $e, we, Ne, Ee);
      }
      var Ie = se.bind(null, !1);
      return Ie.isRequired = se.bind(null, !0), Ie;
    }
    function N(X) {
      function ye(ce, se, Ie, Le, ie, $e) {
        var we = ce[se], Ne = ee(we);
        if (Ne !== X) {
          var Ee = oe(we);
          return new x(
            "Invalid " + Le + " `" + ie + "` of type " + ("`" + Ee + "` supplied to `" + Ie + "`, expected ") + ("`" + X + "`."),
            { expectedType: X }
          );
        }
        return null;
      }
      return E(ye);
    }
    function R() {
      return E(s);
    }
    function O(X) {
      function ye(ce, se, Ie, Le, ie) {
        if (typeof X != "function")
          return new x("Property `" + ie + "` of component `" + Ie + "` has invalid PropType notation inside arrayOf.");
        var $e = ce[se];
        if (!Array.isArray($e)) {
          var we = ee($e);
          return new x("Invalid " + Le + " `" + ie + "` of type " + ("`" + we + "` supplied to `" + Ie + "`, expected an array."));
        }
        for (var Ne = 0; Ne < $e.length; Ne++) {
          var Ee = X($e, Ne, Ie, Le, ie + "[" + Ne + "]", n);
          if (Ee instanceof Error)
            return Ee;
        }
        return null;
      }
      return E(ye);
    }
    function D() {
      function X(ye, ce, se, Ie, Le) {
        var ie = ye[ce];
        if (!c(ie)) {
          var $e = ee(ie);
          return new x("Invalid " + Ie + " `" + Le + "` of type " + ("`" + $e + "` supplied to `" + se + "`, expected a single ReactElement."));
        }
        return null;
      }
      return E(X);
    }
    function $() {
      function X(ye, ce, se, Ie, Le) {
        var ie = ye[ce];
        if (!e.isValidElementType(ie)) {
          var $e = ee(ie);
          return new x("Invalid " + Ie + " `" + Le + "` of type " + ("`" + $e + "` supplied to `" + se + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return E(X);
    }
    function B(X) {
      function ye(ce, se, Ie, Le, ie) {
        if (!(ce[se] instanceof X)) {
          var $e = X.name || y, we = xe(ce[se]);
          return new x("Invalid " + Le + " `" + ie + "` of type " + ("`" + we + "` supplied to `" + Ie + "`, expected ") + ("instance of `" + $e + "`."));
        }
        return null;
      }
      return E(ye);
    }
    function G(X) {
      if (!Array.isArray(X))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function ye(ce, se, Ie, Le, ie) {
        for (var $e = ce[se], we = 0; we < X.length; we++)
          if (S($e, X[we]))
            return null;
        var Ne = JSON.stringify(X, function(le, be) {
          var He = oe(be);
          return He === "symbol" ? String(be) : be;
        });
        return new x("Invalid " + Le + " `" + ie + "` of value `" + String($e) + "` " + ("supplied to `" + Ie + "`, expected one of " + Ne + "."));
      }
      return E(ye);
    }
    function Z(X) {
      function ye(ce, se, Ie, Le, ie) {
        if (typeof X != "function")
          return new x("Property `" + ie + "` of component `" + Ie + "` has invalid PropType notation inside objectOf.");
        var $e = ce[se], we = ee($e);
        if (we !== "object")
          return new x("Invalid " + Le + " `" + ie + "` of type " + ("`" + we + "` supplied to `" + Ie + "`, expected an object."));
        for (var Ne in $e)
          if (r($e, Ne)) {
            var Ee = X($e, Ne, Ie, Le, ie + "." + Ne, n);
            if (Ee instanceof Error)
              return Ee;
          }
        return null;
      }
      return E(ye);
    }
    function K(X) {
      if (!Array.isArray(X))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var ye = 0; ye < X.length; ye++) {
        var ce = X[ye];
        if (typeof ce != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + me(ce) + " at index " + ye + "."
          ), s;
      }
      function se(Ie, Le, ie, $e, we) {
        for (var Ne = [], Ee = 0; Ee < X.length; Ee++) {
          var le = X[Ee], be = le(Ie, Le, ie, $e, we, n);
          if (be == null)
            return null;
          be.data && r(be.data, "expectedType") && Ne.push(be.data.expectedType);
        }
        var He = Ne.length > 0 ? ", expected one of type [" + Ne.join(", ") + "]" : "";
        return new x("Invalid " + $e + " `" + we + "` supplied to " + ("`" + ie + "`" + He + "."));
      }
      return E(se);
    }
    function q() {
      function X(ye, ce, se, Ie, Le) {
        return ge(ye[ce]) ? null : new x("Invalid " + Ie + " `" + Le + "` supplied to " + ("`" + se + "`, expected a ReactNode."));
      }
      return E(X);
    }
    function pe(X, ye, ce, se, Ie) {
      return new x(
        (X || "React class") + ": " + ye + " type `" + ce + "." + se + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Ie + "`."
      );
    }
    function he(X) {
      function ye(ce, se, Ie, Le, ie) {
        var $e = ce[se], we = ee($e);
        if (we !== "object")
          return new x("Invalid " + Le + " `" + ie + "` of type `" + we + "` " + ("supplied to `" + Ie + "`, expected `object`."));
        for (var Ne in X) {
          var Ee = X[Ne];
          if (typeof Ee != "function")
            return pe(Ie, Le, ie, Ne, oe(Ee));
          var le = Ee($e, Ne, Ie, Le, ie + "." + Ne, n);
          if (le)
            return le;
        }
        return null;
      }
      return E(ye);
    }
    function _e(X) {
      function ye(ce, se, Ie, Le, ie) {
        var $e = ce[se], we = ee($e);
        if (we !== "object")
          return new x("Invalid " + Le + " `" + ie + "` of type `" + we + "` " + ("supplied to `" + Ie + "`, expected `object`."));
        var Ne = t({}, ce[se], X);
        for (var Ee in Ne) {
          var le = X[Ee];
          if (r(X, Ee) && typeof le != "function")
            return pe(Ie, Le, ie, Ee, oe(le));
          if (!le)
            return new x(
              "Invalid " + Le + " `" + ie + "` key `" + Ee + "` supplied to `" + Ie + "`.\nBad object: " + JSON.stringify(ce[se], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(X), null, "  ")
            );
          var be = le($e, Ee, Ie, Le, ie + "." + Ee, n);
          if (be)
            return be;
        }
        return null;
      }
      return E(ye);
    }
    function ge(X) {
      switch (typeof X) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !X;
        case "object":
          if (Array.isArray(X))
            return X.every(ge);
          if (X === null || c(X))
            return !0;
          var ye = v(X);
          if (ye) {
            var ce = ye.call(X), se;
            if (ye !== X.entries) {
              for (; !(se = ce.next()).done; )
                if (!ge(se.value))
                  return !1;
            } else
              for (; !(se = ce.next()).done; ) {
                var Ie = se.value;
                if (Ie && !ge(Ie[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Y(X, ye) {
      return X === "symbol" ? !0 : ye ? ye["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ye instanceof Symbol : !1;
    }
    function ee(X) {
      var ye = typeof X;
      return Array.isArray(X) ? "array" : X instanceof RegExp ? "object" : Y(ye, X) ? "symbol" : ye;
    }
    function oe(X) {
      if (typeof X == "undefined" || X === null)
        return "" + X;
      var ye = ee(X);
      if (ye === "object") {
        if (X instanceof Date)
          return "date";
        if (X instanceof RegExp)
          return "regexp";
      }
      return ye;
    }
    function me(X) {
      var ye = oe(X);
      switch (ye) {
        case "array":
        case "object":
          return "an " + ye;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ye;
        default:
          return ye;
      }
    }
    function xe(X) {
      return !X.constructor || !X.constructor.name ? y : X.constructor.name;
    }
    return b.checkPropTypes = a, b.resetWarningCache = a.resetWarningCache, b.PropTypes = b, b;
  }, Dk;
}
var Lk, rV;
function C1e() {
  if (rV) return Lk;
  rV = 1;
  var e = CR();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Lk = function() {
    function r(s, c, u, f, m, v) {
      if (v !== e) {
        var y = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw y.name = "Invariant Violation", y;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Lk;
}
if (process.env.NODE_ENV !== "production") {
  var w1e = _R(), S1e = !0;
  KN.exports = _1e()(w1e.isElement, S1e);
} else
  KN.exports = C1e()();
var _c = KN.exports;
const de = /* @__PURE__ */ Mt(_c);
var qN = { exports: {} }, ba = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aV;
function x1e() {
  if (aV) return ba;
  aV = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), S;
  S = Symbol.for("react.module.reference");
  function x(E) {
    if (typeof E == "object" && E !== null) {
      var N = E.$$typeof;
      switch (N) {
        case e:
          switch (E = E.type, E) {
            case n:
            case a:
            case r:
            case f:
            case m:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case c:
                case s:
                case u:
                case y:
                case v:
                case o:
                  return E;
                default:
                  return N;
              }
          }
        case t:
          return N;
      }
    }
  }
  return ba.ContextConsumer = s, ba.ContextProvider = o, ba.Element = e, ba.ForwardRef = u, ba.Fragment = n, ba.Lazy = y, ba.Memo = v, ba.Portal = t, ba.Profiler = a, ba.StrictMode = r, ba.Suspense = f, ba.SuspenseList = m, ba.isAsyncMode = function() {
    return !1;
  }, ba.isConcurrentMode = function() {
    return !1;
  }, ba.isContextConsumer = function(E) {
    return x(E) === s;
  }, ba.isContextProvider = function(E) {
    return x(E) === o;
  }, ba.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === e;
  }, ba.isForwardRef = function(E) {
    return x(E) === u;
  }, ba.isFragment = function(E) {
    return x(E) === n;
  }, ba.isLazy = function(E) {
    return x(E) === y;
  }, ba.isMemo = function(E) {
    return x(E) === v;
  }, ba.isPortal = function(E) {
    return x(E) === t;
  }, ba.isProfiler = function(E) {
    return x(E) === a;
  }, ba.isStrictMode = function(E) {
    return x(E) === r;
  }, ba.isSuspense = function(E) {
    return x(E) === f;
  }, ba.isSuspenseList = function(E) {
    return x(E) === m;
  }, ba.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === n || E === a || E === r || E === f || E === m || E === b || typeof E == "object" && E !== null && (E.$$typeof === y || E.$$typeof === v || E.$$typeof === o || E.$$typeof === s || E.$$typeof === u || E.$$typeof === S || E.getModuleId !== void 0);
  }, ba.typeOf = x, ba;
}
var _a = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oV;
function E1e() {
  return oV || (oV = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), S = !1, x = !1, E = !1, N = !1, R = !1, O;
    O = Symbol.for("react.module.reference");
    function D(Ae) {
      return !!(typeof Ae == "string" || typeof Ae == "function" || Ae === n || Ae === a || R || Ae === r || Ae === f || Ae === m || N || Ae === b || S || x || E || typeof Ae == "object" && Ae !== null && (Ae.$$typeof === y || Ae.$$typeof === v || Ae.$$typeof === o || Ae.$$typeof === s || Ae.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Ae.$$typeof === O || Ae.getModuleId !== void 0));
    }
    function $(Ae) {
      if (typeof Ae == "object" && Ae !== null) {
        var it = Ae.$$typeof;
        switch (it) {
          case e:
            var ut = Ae.type;
            switch (ut) {
              case n:
              case a:
              case r:
              case f:
              case m:
                return ut;
              default:
                var St = ut && ut.$$typeof;
                switch (St) {
                  case c:
                  case s:
                  case u:
                  case y:
                  case v:
                  case o:
                    return St;
                  default:
                    return it;
                }
            }
          case t:
            return it;
        }
      }
    }
    var B = s, G = o, Z = e, K = u, q = n, pe = y, he = v, _e = t, ge = a, Y = r, ee = f, oe = m, me = !1, xe = !1;
    function X(Ae) {
      return me || (me = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ye(Ae) {
      return xe || (xe = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ce(Ae) {
      return $(Ae) === s;
    }
    function se(Ae) {
      return $(Ae) === o;
    }
    function Ie(Ae) {
      return typeof Ae == "object" && Ae !== null && Ae.$$typeof === e;
    }
    function Le(Ae) {
      return $(Ae) === u;
    }
    function ie(Ae) {
      return $(Ae) === n;
    }
    function $e(Ae) {
      return $(Ae) === y;
    }
    function we(Ae) {
      return $(Ae) === v;
    }
    function Ne(Ae) {
      return $(Ae) === t;
    }
    function Ee(Ae) {
      return $(Ae) === a;
    }
    function le(Ae) {
      return $(Ae) === r;
    }
    function be(Ae) {
      return $(Ae) === f;
    }
    function He(Ae) {
      return $(Ae) === m;
    }
    _a.ContextConsumer = B, _a.ContextProvider = G, _a.Element = Z, _a.ForwardRef = K, _a.Fragment = q, _a.Lazy = pe, _a.Memo = he, _a.Portal = _e, _a.Profiler = ge, _a.StrictMode = Y, _a.Suspense = ee, _a.SuspenseList = oe, _a.isAsyncMode = X, _a.isConcurrentMode = ye, _a.isContextConsumer = ce, _a.isContextProvider = se, _a.isElement = Ie, _a.isForwardRef = Le, _a.isFragment = ie, _a.isLazy = $e, _a.isMemo = we, _a.isPortal = Ne, _a.isProfiler = Ee, _a.isStrictMode = le, _a.isSuspense = be, _a.isSuspenseList = He, _a.isValidElementType = D, _a.typeOf = $;
  }()), _a;
}
process.env.NODE_ENV === "production" ? qN.exports = x1e() : qN.exports = E1e();
var wR = qN.exports;
function I1e(e) {
  function t(ce, se, Ie, Le, ie) {
    for (var $e = 0, we = 0, Ne = 0, Ee = 0, le, be, He = 0, Ae = 0, it, ut = it = le = 0, St = 0, sn = 0, zn = 0, dn = 0, $t = Ie.length, qt = $t - 1, fn, At = "", Wt = "", Xr = "", Kn = "", Sr; St < $t; ) {
      if (be = Ie.charCodeAt(St), St === qt && we + Ee + Ne + $e !== 0 && (we !== 0 && (be = we === 47 ? 10 : 47), Ee = Ne = $e = 0, $t++, qt++), we + Ee + Ne + $e === 0) {
        if (St === qt && (0 < sn && (At = At.replace(y, "")), 0 < At.trim().length)) {
          switch (be) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              At += Ie.charAt(St);
          }
          be = 59;
        }
        switch (be) {
          case 123:
            for (At = At.trim(), le = At.charCodeAt(0), it = 1, dn = ++St; St < $t; ) {
              switch (be = Ie.charCodeAt(St)) {
                case 123:
                  it++;
                  break;
                case 125:
                  it--;
                  break;
                case 47:
                  switch (be = Ie.charCodeAt(St + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (ut = St + 1; ut < qt; ++ut)
                          switch (Ie.charCodeAt(ut)) {
                            case 47:
                              if (be === 42 && Ie.charCodeAt(ut - 1) === 42 && St + 2 !== ut) {
                                St = ut + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (be === 47) {
                                St = ut + 1;
                                break e;
                              }
                          }
                        St = ut;
                      }
                  }
                  break;
                case 91:
                  be++;
                case 40:
                  be++;
                case 34:
                case 39:
                  for (; St++ < qt && Ie.charCodeAt(St) !== be; )
                    ;
              }
              if (it === 0) break;
              St++;
            }
            switch (it = Ie.substring(dn, St), le === 0 && (le = (At = At.replace(v, "").trim()).charCodeAt(0)), le) {
              case 64:
                switch (0 < sn && (At = At.replace(y, "")), be = At.charCodeAt(1), be) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    sn = se;
                    break;
                  default:
                    sn = ee;
                }
                if (it = t(se, sn, it, be, ie + 1), dn = it.length, 0 < me && (sn = n(ee, At, zn), Sr = c(3, it, sn, se, _e, he, dn, be, ie, Le), At = sn.join(""), Sr !== void 0 && (dn = (it = Sr.trim()).length) === 0 && (be = 0, it = "")), 0 < dn) switch (be) {
                  case 115:
                    At = At.replace(B, s);
                  case 100:
                  case 109:
                  case 45:
                    it = At + "{" + it + "}";
                    break;
                  case 107:
                    At = At.replace(R, "$1 $2"), it = At + "{" + it + "}", it = Y === 1 || Y === 2 && o("@" + it, 3) ? "@-webkit-" + it + "@" + it : "@" + it;
                    break;
                  default:
                    it = At + it, Le === 112 && (it = (Wt += it, ""));
                }
                else it = "";
                break;
              default:
                it = t(se, n(se, At, zn), it, Le, ie + 1);
            }
            Xr += it, it = zn = sn = ut = le = 0, At = "", be = Ie.charCodeAt(++St);
            break;
          case 125:
          case 59:
            if (At = (0 < sn ? At.replace(y, "") : At).trim(), 1 < (dn = At.length)) switch (ut === 0 && (le = At.charCodeAt(0), le === 45 || 96 < le && 123 > le) && (dn = (At = At.replace(" ", ":")).length), 0 < me && (Sr = c(1, At, se, ce, _e, he, Wt.length, Le, ie, Le)) !== void 0 && (dn = (At = Sr.trim()).length) === 0 && (At = "\0\0"), le = At.charCodeAt(0), be = At.charCodeAt(1), le) {
              case 0:
                break;
              case 64:
                if (be === 105 || be === 99) {
                  Kn += At + Ie.charAt(St);
                  break;
                }
              default:
                At.charCodeAt(dn - 1) !== 58 && (Wt += a(At, le, be, At.charCodeAt(2)));
            }
            zn = sn = ut = le = 0, At = "", be = Ie.charCodeAt(++St);
        }
      }
      switch (be) {
        case 13:
        case 10:
          we === 47 ? we = 0 : 1 + le === 0 && Le !== 107 && 0 < At.length && (sn = 1, At += "\0"), 0 < me * X && c(0, At, se, ce, _e, he, Wt.length, Le, ie, Le), he = 1, _e++;
          break;
        case 59:
        case 125:
          if (we + Ee + Ne + $e === 0) {
            he++;
            break;
          }
        default:
          switch (he++, fn = Ie.charAt(St), be) {
            case 9:
            case 32:
              if (Ee + $e + we === 0) switch (He) {
                case 44:
                case 58:
                case 9:
                case 32:
                  fn = "";
                  break;
                default:
                  be !== 32 && (fn = " ");
              }
              break;
            case 0:
              fn = "\\0";
              break;
            case 12:
              fn = "\\f";
              break;
            case 11:
              fn = "\\v";
              break;
            case 38:
              Ee + we + $e === 0 && (sn = zn = 1, fn = "\f" + fn);
              break;
            case 108:
              if (Ee + we + $e + ge === 0 && 0 < ut) switch (St - ut) {
                case 2:
                  He === 112 && Ie.charCodeAt(St - 3) === 58 && (ge = He);
                case 8:
                  Ae === 111 && (ge = Ae);
              }
              break;
            case 58:
              Ee + we + $e === 0 && (ut = St);
              break;
            case 44:
              we + Ne + Ee + $e === 0 && (sn = 1, fn += "\r");
              break;
            case 34:
            case 39:
              we === 0 && (Ee = Ee === be ? 0 : Ee === 0 ? be : Ee);
              break;
            case 91:
              Ee + we + Ne === 0 && $e++;
              break;
            case 93:
              Ee + we + Ne === 0 && $e--;
              break;
            case 41:
              Ee + we + $e === 0 && Ne--;
              break;
            case 40:
              if (Ee + we + $e === 0) {
                if (le === 0) switch (2 * He + 3 * Ae) {
                  case 533:
                    break;
                  default:
                    le = 1;
                }
                Ne++;
              }
              break;
            case 64:
              we + Ne + Ee + $e + ut + it === 0 && (it = 1);
              break;
            case 42:
            case 47:
              if (!(0 < Ee + $e + Ne)) switch (we) {
                case 0:
                  switch (2 * be + 3 * Ie.charCodeAt(St + 1)) {
                    case 235:
                      we = 47;
                      break;
                    case 220:
                      dn = St, we = 42;
                  }
                  break;
                case 42:
                  be === 47 && He === 42 && dn + 2 !== St && (Ie.charCodeAt(dn + 2) === 33 && (Wt += Ie.substring(dn, St + 1)), fn = "", we = 0);
              }
          }
          we === 0 && (At += fn);
      }
      Ae = He, He = be, St++;
    }
    if (dn = Wt.length, 0 < dn) {
      if (sn = se, 0 < me && (Sr = c(2, Wt, sn, ce, _e, he, dn, Le, ie, Le), Sr !== void 0 && (Wt = Sr).length === 0)) return Kn + Wt + Xr;
      if (Wt = sn.join(",") + "{" + Wt + "}", Y * ge !== 0) {
        switch (Y !== 2 || o(Wt, 2) || (ge = 0), ge) {
          case 111:
            Wt = Wt.replace(D, ":-moz-$1") + Wt;
            break;
          case 112:
            Wt = Wt.replace(O, "::-webkit-input-$1") + Wt.replace(O, "::-moz-$1") + Wt.replace(O, ":-ms-input-$1") + Wt;
        }
        ge = 0;
      }
    }
    return Kn + Wt + Xr;
  }
  function n(ce, se, Ie) {
    var Le = se.trim().split(E);
    se = Le;
    var ie = Le.length, $e = ce.length;
    switch ($e) {
      case 0:
      case 1:
        var we = 0;
        for (ce = $e === 0 ? "" : ce[0] + " "; we < ie; ++we)
          se[we] = r(ce, se[we], Ie).trim();
        break;
      default:
        var Ne = we = 0;
        for (se = []; we < ie; ++we)
          for (var Ee = 0; Ee < $e; ++Ee)
            se[Ne++] = r(ce[Ee] + " ", Le[we], Ie).trim();
    }
    return se;
  }
  function r(ce, se, Ie) {
    var Le = se.charCodeAt(0);
    switch (33 > Le && (Le = (se = se.trim()).charCodeAt(0)), Le) {
      case 38:
        return se.replace(N, "$1" + ce.trim());
      case 58:
        return ce.trim() + se.replace(N, "$1" + ce.trim());
      default:
        if (0 < 1 * Ie && 0 < se.indexOf("\f")) return se.replace(N, (ce.charCodeAt(0) === 58 ? "" : "$1") + ce.trim());
    }
    return ce + se;
  }
  function a(ce, se, Ie, Le) {
    var ie = ce + ";", $e = 2 * se + 3 * Ie + 4 * Le;
    if ($e === 944) {
      ce = ie.indexOf(":", 9) + 1;
      var we = ie.substring(ce, ie.length - 1).trim();
      return we = ie.substring(0, ce).trim() + we + ";", Y === 1 || Y === 2 && o(we, 1) ? "-webkit-" + we + we : we;
    }
    if (Y === 0 || Y === 2 && !o(ie, 1)) return ie;
    switch ($e) {
      case 1015:
        return ie.charCodeAt(10) === 97 ? "-webkit-" + ie + ie : ie;
      case 951:
        return ie.charCodeAt(3) === 116 ? "-webkit-" + ie + ie : ie;
      case 963:
        return ie.charCodeAt(5) === 110 ? "-webkit-" + ie + ie : ie;
      case 1009:
        if (ie.charCodeAt(4) !== 100) break;
      case 969:
      case 942:
        return "-webkit-" + ie + ie;
      case 978:
        return "-webkit-" + ie + "-moz-" + ie + ie;
      case 1019:
      case 983:
        return "-webkit-" + ie + "-moz-" + ie + "-ms-" + ie + ie;
      case 883:
        if (ie.charCodeAt(8) === 45) return "-webkit-" + ie + ie;
        if (0 < ie.indexOf("image-set(", 11)) return ie.replace(pe, "$1-webkit-$2") + ie;
        break;
      case 932:
        if (ie.charCodeAt(4) === 45) switch (ie.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + ie.replace("-grow", "") + "-webkit-" + ie + "-ms-" + ie.replace("grow", "positive") + ie;
          case 115:
            return "-webkit-" + ie + "-ms-" + ie.replace("shrink", "negative") + ie;
          case 98:
            return "-webkit-" + ie + "-ms-" + ie.replace("basis", "preferred-size") + ie;
        }
        return "-webkit-" + ie + "-ms-" + ie + ie;
      case 964:
        return "-webkit-" + ie + "-ms-flex-" + ie + ie;
      case 1023:
        if (ie.charCodeAt(8) !== 99) break;
        return we = ie.substring(ie.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + we + "-webkit-" + ie + "-ms-flex-pack" + we + ie;
      case 1005:
        return S.test(ie) ? ie.replace(b, ":-webkit-") + ie.replace(b, ":-moz-") + ie : ie;
      case 1e3:
        switch (we = ie.substring(13).trim(), se = we.indexOf("-") + 1, we.charCodeAt(0) + we.charCodeAt(se)) {
          case 226:
            we = ie.replace($, "tb");
            break;
          case 232:
            we = ie.replace($, "tb-rl");
            break;
          case 220:
            we = ie.replace($, "lr");
            break;
          default:
            return ie;
        }
        return "-webkit-" + ie + "-ms-" + we + ie;
      case 1017:
        if (ie.indexOf("sticky", 9) === -1) break;
      case 975:
        switch (se = (ie = ce).length - 10, we = (ie.charCodeAt(se) === 33 ? ie.substring(0, se) : ie).substring(ce.indexOf(":", 7) + 1).trim(), $e = we.charCodeAt(0) + (we.charCodeAt(7) | 0)) {
          case 203:
            if (111 > we.charCodeAt(8)) break;
          case 115:
            ie = ie.replace(we, "-webkit-" + we) + ";" + ie;
            break;
          case 207:
          case 102:
            ie = ie.replace(we, "-webkit-" + (102 < $e ? "inline-" : "") + "box") + ";" + ie.replace(we, "-webkit-" + we) + ";" + ie.replace(we, "-ms-" + we + "box") + ";" + ie;
        }
        return ie + ";";
      case 938:
        if (ie.charCodeAt(5) === 45) switch (ie.charCodeAt(6)) {
          case 105:
            return we = ie.replace("-items", ""), "-webkit-" + ie + "-webkit-box-" + we + "-ms-flex-" + we + ie;
          case 115:
            return "-webkit-" + ie + "-ms-flex-item-" + ie.replace(Z, "") + ie;
          default:
            return "-webkit-" + ie + "-ms-flex-line-pack" + ie.replace("align-content", "").replace(Z, "") + ie;
        }
        break;
      case 973:
      case 989:
        if (ie.charCodeAt(3) !== 45 || ie.charCodeAt(4) === 122) break;
      case 931:
      case 953:
        if (q.test(ce) === !0) return (we = ce.substring(ce.indexOf(":") + 1)).charCodeAt(0) === 115 ? a(ce.replace("stretch", "fill-available"), se, Ie, Le).replace(":fill-available", ":stretch") : ie.replace(we, "-webkit-" + we) + ie.replace(we, "-moz-" + we.replace("fill-", "")) + ie;
        break;
      case 962:
        if (ie = "-webkit-" + ie + (ie.charCodeAt(5) === 102 ? "-ms-" + ie : "") + ie, Ie + Le === 211 && ie.charCodeAt(13) === 105 && 0 < ie.indexOf("transform", 10)) return ie.substring(0, ie.indexOf(";", 27) + 1).replace(x, "$1-webkit-$2") + ie;
    }
    return ie;
  }
  function o(ce, se) {
    var Ie = ce.indexOf(se === 1 ? ":" : "{"), Le = ce.substring(0, se !== 3 ? Ie : 10);
    return Ie = ce.substring(Ie + 1, ce.length - 1), xe(se !== 2 ? Le : Le.replace(K, "$1"), Ie, se);
  }
  function s(ce, se) {
    var Ie = a(se, se.charCodeAt(0), se.charCodeAt(1), se.charCodeAt(2));
    return Ie !== se + ";" ? Ie.replace(G, " or ($1)").substring(4) : "(" + se + ")";
  }
  function c(ce, se, Ie, Le, ie, $e, we, Ne, Ee, le) {
    for (var be = 0, He = se, Ae; be < me; ++be)
      switch (Ae = oe[be].call(m, ce, He, Ie, Le, ie, $e, we, Ne, Ee, le)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          He = Ae;
      }
    if (He !== se) return He;
  }
  function u(ce) {
    switch (ce) {
      case void 0:
      case null:
        me = oe.length = 0;
        break;
      default:
        if (typeof ce == "function") oe[me++] = ce;
        else if (typeof ce == "object") for (var se = 0, Ie = ce.length; se < Ie; ++se)
          u(ce[se]);
        else X = !!ce | 0;
    }
    return u;
  }
  function f(ce) {
    return ce = ce.prefix, ce !== void 0 && (xe = null, ce ? typeof ce != "function" ? Y = 1 : (Y = 2, xe = ce) : Y = 0), f;
  }
  function m(ce, se) {
    var Ie = ce;
    if (33 > Ie.charCodeAt(0) && (Ie = Ie.trim()), ye = Ie, Ie = [ye], 0 < me) {
      var Le = c(-1, se, Ie, Ie, _e, he, 0, 0, 0, 0);
      Le !== void 0 && typeof Le == "string" && (se = Le);
    }
    var ie = t(ee, Ie, se, 0, 0);
    return 0 < me && (Le = c(-2, ie, Ie, Ie, _e, he, ie.length, 0, 0, 0), Le !== void 0 && (ie = Le)), ye = "", ge = 0, he = _e = 1, ie;
  }
  var v = /^\0+/g, y = /[\0\r\f]/g, b = /: */g, S = /zoo|gra/, x = /([,: ])(transform)/g, E = /,\r+?/g, N = /([\t\r\n ])*\f?&/g, R = /@(k\w+)\s*(\S*)\s*/, O = /::(place)/g, D = /:(read-only)/g, $ = /[svh]\w+-[tblr]{2}/, B = /\(\s*(.*)\s*\)/g, G = /([\s\S]*?);/g, Z = /-self|flex-/g, K = /[^]*?(:[rp][el]a[\w-]+)[^]*/, q = /stretch|:\s*\w+\-(?:conte|avail)/, pe = /([^-])(image-set\()/, he = 1, _e = 1, ge = 0, Y = 1, ee = [], oe = [], me = 0, xe = null, X = 0, ye = "";
  return m.use = u, m.set = f, e !== void 0 && f(e), m;
}
var k1e = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function oQ(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var A1e = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, iV = /* @__PURE__ */ oQ(
  function(e) {
    return A1e.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), SR = _R(), P1e = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, N1e = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, T1e = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, iQ = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, xR = {};
xR[SR.ForwardRef] = T1e;
xR[SR.Memo] = iQ;
function sV(e) {
  return SR.isMemo(e) ? iQ : xR[e.$$typeof] || P1e;
}
var O1e = Object.defineProperty, R1e = Object.getOwnPropertyNames, lV = Object.getOwnPropertySymbols, M1e = Object.getOwnPropertyDescriptor, D1e = Object.getPrototypeOf, uV = Object.prototype;
function sQ(e, t, n) {
  if (typeof t != "string") {
    if (uV) {
      var r = D1e(t);
      r && r !== uV && sQ(e, r, n);
    }
    var a = R1e(t);
    lV && (a = a.concat(lV(t)));
    for (var o = sV(e), s = sV(t), c = 0; c < a.length; ++c) {
      var u = a[c];
      if (!N1e[u] && !(n && n[u]) && !(s && s[u]) && !(o && o[u])) {
        var f = M1e(t, u);
        try {
          O1e(e, u, f);
        } catch (m) {
        }
      }
    }
  }
  return e;
}
var L1e = sQ;
const $1e = /* @__PURE__ */ Mt(L1e);
function Cd() {
  return (Cd = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var cV = function(e, t) {
  for (var n = [e[0]], r = 0, a = t.length; r < a; r += 1) n.push(t[r], e[r + 1]);
  return n;
}, JN = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !wR.typeOf(e);
}, E7 = Object.freeze([]), Pm = Object.freeze({});
function a2(e) {
  return typeof e == "function";
}
function QN(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function ER(e) {
  return e && typeof e.styledComponentId == "string";
}
var o2 = typeof process != "undefined" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", IR = typeof window != "undefined" && "HTMLElement" in window, j1e = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process != "undefined" && process.env !== void 0 && (process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production")), F1e = {}, B1e = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
` } : {};
function V1e() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1) t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
  return t.forEach(function(a) {
    e = e.replace(/%[a-z]/, a);
  }), e;
}
function Lp(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : "")) : new Error(V1e.apply(void 0, [B1e[e]].concat(n)).trim());
}
var U1e = function() {
  function e(n) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = n;
  }
  var t = e.prototype;
  return t.indexOfGroup = function(n) {
    for (var r = 0, a = 0; a < n; a++) r += this.groupSizes[a];
    return r;
  }, t.insertRules = function(n, r) {
    if (n >= this.groupSizes.length) {
      for (var a = this.groupSizes, o = a.length, s = o; n >= s; ) (s <<= 1) < 0 && Lp(16, "" + n);
      this.groupSizes = new Uint32Array(s), this.groupSizes.set(a), this.length = s;
      for (var c = o; c < s; c++) this.groupSizes[c] = 0;
    }
    for (var u = this.indexOfGroup(n + 1), f = 0, m = r.length; f < m; f++) this.tag.insertRule(u, r[f]) && (this.groupSizes[n]++, u++);
  }, t.clearGroup = function(n) {
    if (n < this.length) {
      var r = this.groupSizes[n], a = this.indexOfGroup(n), o = a + r;
      this.groupSizes[n] = 0;
      for (var s = a; s < o; s++) this.tag.deleteRule(a);
    }
  }, t.getGroup = function(n) {
    var r = "";
    if (n >= this.length || this.groupSizes[n] === 0) return r;
    for (var a = this.groupSizes[n], o = this.indexOfGroup(n), s = o + a, c = o; c < s; c++) r += this.tag.getRule(c) + `/*!sc*/
`;
    return r;
  }, e;
}(), Rx = /* @__PURE__ */ new Map(), I7 = /* @__PURE__ */ new Map(), N4 = 1, yS = function(e) {
  if (Rx.has(e)) return Rx.get(e);
  for (; I7.has(N4); ) N4++;
  var t = N4++;
  return process.env.NODE_ENV !== "production" && ((0 | t) < 0 || t > 1 << 30) && Lp(16, "" + t), Rx.set(e, t), I7.set(t, e), t;
}, G1e = function(e) {
  return I7.get(e);
}, z1e = function(e, t) {
  t >= N4 && (N4 = t + 1), Rx.set(e, t), I7.set(t, e);
}, H1e = "style[" + o2 + '][data-styled-version="5.3.11"]', W1e = new RegExp("^" + o2 + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), Z1e = function(e, t, n) {
  for (var r, a = n.split(","), o = 0, s = a.length; o < s; o++) (r = a[o]) && e.registerName(t, r);
}, Y1e = function(e, t) {
  for (var n = (t.textContent || "").split(`/*!sc*/
`), r = [], a = 0, o = n.length; a < o; a++) {
    var s = n[a].trim();
    if (s) {
      var c = s.match(W1e);
      if (c) {
        var u = 0 | parseInt(c[1], 10), f = c[2];
        u !== 0 && (z1e(f, u), Z1e(e, f, c[3]), e.getTag().insertRules(u, r)), r.length = 0;
      } else r.push(s);
    }
  }
}, X1e = function() {
  return typeof __webpack_nonce__ != "undefined" ? __webpack_nonce__ : null;
}, lQ = function(e) {
  var t = document.head, n = e || t, r = document.createElement("style"), a = function(c) {
    for (var u = c.childNodes, f = u.length; f >= 0; f--) {
      var m = u[f];
      if (m && m.nodeType === 1 && m.hasAttribute(o2)) return m;
    }
  }(n), o = a !== void 0 ? a.nextSibling : null;
  r.setAttribute(o2, "active"), r.setAttribute("data-styled-version", "5.3.11");
  var s = X1e();
  return s && r.setAttribute("nonce", s), n.insertBefore(r, o), r;
}, K1e = function() {
  function e(n) {
    var r = this.element = lQ(n);
    r.appendChild(document.createTextNode("")), this.sheet = function(a) {
      if (a.sheet) return a.sheet;
      for (var o = document.styleSheets, s = 0, c = o.length; s < c; s++) {
        var u = o[s];
        if (u.ownerNode === a) return u;
      }
      Lp(17);
    }(r), this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    try {
      return this.sheet.insertRule(r, n), this.length++, !0;
    } catch (a) {
      return !1;
    }
  }, t.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, t.getRule = function(n) {
    var r = this.sheet.cssRules[n];
    return r !== void 0 && typeof r.cssText == "string" ? r.cssText : "";
  }, e;
}(), q1e = function() {
  function e(n) {
    var r = this.element = lQ(n);
    this.nodes = r.childNodes, this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    if (n <= this.length && n >= 0) {
      var a = document.createTextNode(r), o = this.nodes[n];
      return this.element.insertBefore(a, o || null), this.length++, !0;
    }
    return !1;
  }, t.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, e;
}(), J1e = function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    return n <= this.length && (this.rules.splice(n, 0, r), this.length++, !0);
  }, t.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, e;
}(), dV = IR, Q1e = { isServer: !IR, useCSSOMInjection: !j1e }, k7 = function() {
  function e(n, r, a) {
    n === void 0 && (n = Pm), r === void 0 && (r = {}), this.options = Cd({}, Q1e, {}, n), this.gs = r, this.names = new Map(a), this.server = !!n.isServer, !this.server && IR && dV && (dV = !1, function(o) {
      for (var s = document.querySelectorAll(H1e), c = 0, u = s.length; c < u; c++) {
        var f = s[c];
        f && f.getAttribute(o2) !== "active" && (Y1e(o, f), f.parentNode && f.parentNode.removeChild(f));
      }
    }(this));
  }
  e.registerId = function(n) {
    return yS(n);
  };
  var t = e.prototype;
  return t.reconstructWithOptions = function(n, r) {
    return r === void 0 && (r = !0), new e(Cd({}, this.options, {}, n), this.gs, r && this.names || void 0);
  }, t.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, t.getTag = function() {
    return this.tag || (this.tag = (a = (r = this.options).isServer, o = r.useCSSOMInjection, s = r.target, n = a ? new J1e(s) : o ? new K1e(s) : new q1e(s), new U1e(n)));
    var n, r, a, o, s;
  }, t.hasNameForId = function(n, r) {
    return this.names.has(n) && this.names.get(n).has(r);
  }, t.registerName = function(n, r) {
    if (yS(n), this.names.has(n)) this.names.get(n).add(r);
    else {
      var a = /* @__PURE__ */ new Set();
      a.add(r), this.names.set(n, a);
    }
  }, t.insertRules = function(n, r, a) {
    this.registerName(n, r), this.getTag().insertRules(yS(n), a);
  }, t.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, t.clearRules = function(n) {
    this.getTag().clearGroup(yS(n)), this.clearNames(n);
  }, t.clearTag = function() {
    this.tag = void 0;
  }, t.toString = function() {
    return function(n) {
      for (var r = n.getTag(), a = r.length, o = "", s = 0; s < a; s++) {
        var c = G1e(s);
        if (c !== void 0) {
          var u = n.names.get(c), f = r.getGroup(s);
          if (u && f && u.size) {
            var m = o2 + ".g" + s + '[id="' + c + '"]', v = "";
            u !== void 0 && u.forEach(function(y) {
              y.length > 0 && (v += y + ",");
            }), o += "" + f + m + '{content:"' + v + `"}/*!sc*/
`;
          }
        }
      }
      return o;
    }(this);
  }, e;
}(), ege = /(a)(d)/gi, fV = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function eT(e) {
  var t, n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) n = fV(t % 52) + n;
  return (fV(t % 52) + n).replace(ege, "$1-$2");
}
var A0 = function(e, t) {
  for (var n = t.length; n; ) e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, uQ = function(e) {
  return A0(5381, e);
};
function cQ(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (a2(n) && !ER(n)) return !1;
  }
  return !0;
}
var tge = uQ("5.3.11"), nge = function() {
  function e(t, n, r) {
    this.rules = t, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (r === void 0 || r.isStatic) && cQ(t), this.componentId = n, this.baseHash = A0(tge, n), this.baseStyle = r, k7.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, r) {
    var a = this.componentId, o = [];
    if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(t, n, r)), this.isStatic && !r.hash) if (this.staticRulesId && n.hasNameForId(a, this.staticRulesId)) o.push(this.staticRulesId);
    else {
      var s = q0(this.rules, t, n, r).join(""), c = eT(A0(this.baseHash, s) >>> 0);
      if (!n.hasNameForId(a, c)) {
        var u = r(s, "." + c, void 0, a);
        n.insertRules(a, c, u);
      }
      o.push(c), this.staticRulesId = c;
    }
    else {
      for (var f = this.rules.length, m = A0(this.baseHash, r.hash), v = "", y = 0; y < f; y++) {
        var b = this.rules[y];
        if (typeof b == "string") v += b, process.env.NODE_ENV !== "production" && (m = A0(m, b + y));
        else if (b) {
          var S = q0(b, t, n, r), x = Array.isArray(S) ? S.join("") : S;
          m = A0(m, x + y), v += x;
        }
      }
      if (v) {
        var E = eT(m >>> 0);
        if (!n.hasNameForId(a, E)) {
          var N = r(v, "." + E, void 0, a);
          n.insertRules(a, E, N);
        }
        o.push(E);
      }
    }
    return o.join(" ");
  }, e;
}(), rge = /^\s*\/\/.*$/gm, age = [":", "[", ".", "#"];
function oge(e) {
  var t, n, r, a, o = Pm, s = o.options, c = s === void 0 ? Pm : s, u = o.plugins, f = u === void 0 ? E7 : u, m = new I1e(c), v = [], y = /* @__PURE__ */ function(x) {
    function E(N) {
      if (N) try {
        x(N + "}");
      } catch (R) {
      }
    }
    return function(N, R, O, D, $, B, G, Z, K, q) {
      switch (N) {
        case 1:
          if (K === 0 && R.charCodeAt(0) === 64) return x(R + ";"), "";
          break;
        case 2:
          if (Z === 0) return R + "/*|*/";
          break;
        case 3:
          switch (Z) {
            case 102:
            case 112:
              return x(O[0] + R), "";
            default:
              return R + (q === 0 ? "/*|*/" : "");
          }
        case -2:
          R.split("/*|*/}").forEach(E);
      }
    };
  }(function(x) {
    v.push(x);
  }), b = function(x, E, N) {
    return E === 0 && age.indexOf(N[n.length]) !== -1 || N.match(a) ? x : "." + t;
  };
  function S(x, E, N, R) {
    R === void 0 && (R = "&");
    var O = x.replace(rge, ""), D = E && N ? N + " " + E + " { " + O + " }" : O;
    return t = R, n = E, r = new RegExp("\\" + n + "\\b", "g"), a = new RegExp("(\\" + n + "\\b){2,}"), m(N || !E ? "" : E, D);
  }
  return m.use([].concat(f, [function(x, E, N) {
    x === 2 && N.length && N[0].lastIndexOf(n) > 0 && (N[0] = N[0].replace(r, b));
  }, y, function(x) {
    if (x === -2) {
      var E = v;
      return v = [], E;
    }
  }])), S.hash = f.length ? f.reduce(function(x, E) {
    return E.name || Lp(15), A0(x, E.name);
  }, 5381).toString() : "", S;
}
var dQ = vo.createContext();
dQ.Consumer;
var fQ = vo.createContext(), ige = (fQ.Consumer, new k7()), tT = oge();
function pQ() {
  return Zp(dQ) || ige;
}
function hQ() {
  return Zp(fQ) || tT;
}
var mQ = function() {
  function e(t, n) {
    var r = this;
    this.inject = function(a, o) {
      o === void 0 && (o = tT);
      var s = r.name + o.hash;
      a.hasNameForId(r.id, s) || a.insertRules(r.id, s, o(r.rules, s, "@keyframes"));
    }, this.toString = function() {
      return Lp(12, String(r.name));
    }, this.name = t, this.id = "sc-keyframes-" + t, this.rules = n;
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = tT), this.name + t.hash;
  }, e;
}(), sge = /([A-Z])/, lge = /([A-Z])/g, uge = /^ms-/, cge = function(e) {
  return "-" + e.toLowerCase();
};
function pV(e) {
  return sge.test(e) ? e.replace(lge, cge).replace(uge, "-ms-") : e;
}
var hV = function(e) {
  return e == null || e === !1 || e === "";
};
function q0(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var a, o = [], s = 0, c = e.length; s < c; s += 1) (a = q0(e[s], t, n, r)) !== "" && (Array.isArray(a) ? o.push.apply(o, a) : o.push(a));
    return o;
  }
  if (hV(e)) return "";
  if (ER(e)) return "." + e.styledComponentId;
  if (a2(e)) {
    if (typeof (f = e) != "function" || f.prototype && f.prototype.isReactComponent || !t) return e;
    var u = e(t);
    return process.env.NODE_ENV !== "production" && wR.isElement(u) && console.warn(QN(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), q0(u, t, n, r);
  }
  var f;
  return e instanceof mQ ? n ? (e.inject(n, r), e.getName(r)) : e : JN(e) ? function m(v, y) {
    var b, S, x = [];
    for (var E in v) v.hasOwnProperty(E) && !hV(v[E]) && (Array.isArray(v[E]) && v[E].isCss || a2(v[E]) ? x.push(pV(E) + ":", v[E], ";") : JN(v[E]) ? x.push.apply(x, m(v[E], E)) : x.push(pV(E) + ": " + (b = E, (S = v[E]) == null || typeof S == "boolean" || S === "" ? "" : typeof S != "number" || S === 0 || b in k1e || b.startsWith("--") ? String(S).trim() : S + "px") + ";"));
    return y ? [y + " {"].concat(x, ["}"]) : x;
  }(e) : e.toString();
}
var mV = function(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function ot(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return a2(e) || JN(e) ? mV(q0(cV(E7, [e].concat(n)))) : n.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : mV(q0(cV(e, n)));
}
var vV = /invalid hook call/i, bS = /* @__PURE__ */ new Set(), vQ = function(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var n = "The component " + e + (t ? ' with the id of "' + t + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, r = console.error;
    try {
      var a = !0;
      console.error = function(o) {
        if (vV.test(o)) a = !1, bS.delete(n);
        else {
          for (var s = arguments.length, c = new Array(s > 1 ? s - 1 : 0), u = 1; u < s; u++) c[u - 1] = arguments[u];
          r.apply(void 0, [o].concat(c));
        }
      }, Yo(), a && !bS.has(n) && (console.warn(n), bS.add(n));
    } catch (o) {
      vV.test(o.message) && bS.delete(n);
    } finally {
      console.error = r;
    }
  }
}, gQ = function(e, t, n) {
  return n === void 0 && (n = Pm), e.theme !== n.theme && e.theme || t || n.theme;
}, dge = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, fge = /(^-|-$)/g;
function $k(e) {
  return e.replace(dge, "-").replace(fge, "");
}
var kR = function(e) {
  return eT(uQ(e) >>> 0);
};
function _S(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var nT = function(e) {
  return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
}, pge = function(e) {
  return e !== "__proto__" && e !== "constructor" && e !== "prototype";
};
function hge(e, t, n) {
  var r = e[n];
  nT(t) && nT(r) ? yQ(r, t) : e[n] = t;
}
function yQ(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  for (var a = 0, o = n; a < o.length; a++) {
    var s = o[a];
    if (nT(s)) for (var c in s) pge(c) && hge(e, s[c], c);
  }
  return e;
}
var r_ = vo.createContext();
r_.Consumer;
function bQ(e) {
  var t = Zp(r_), n = k0(function() {
    return function(r, a) {
      if (!r) return Lp(14);
      if (a2(r)) {
        var o = r(a);
        return process.env.NODE_ENV === "production" || o !== null && !Array.isArray(o) && typeof o == "object" ? o : Lp(7);
      }
      return Array.isArray(r) || typeof r != "object" ? Lp(8) : a ? Cd({}, a, {}, r) : r;
    }(e.theme, t);
  }, [e.theme, t]);
  return e.children ? vo.createElement(r_.Provider, { value: n }, e.children) : null;
}
var jk = {};
function _Q(e, t, n) {
  var r = ER(e), a = !_S(e), o = t.attrs, s = o === void 0 ? E7 : o, c = t.componentId, u = c === void 0 ? function(R, O) {
    var D = typeof R != "string" ? "sc" : $k(R);
    jk[D] = (jk[D] || 0) + 1;
    var $ = D + "-" + kR("5.3.11" + D + jk[D]);
    return O ? O + "-" + $ : $;
  }(t.displayName, t.parentComponentId) : c, f = t.displayName, m = f === void 0 ? function(R) {
    return _S(R) ? "styled." + R : "Styled(" + QN(R) + ")";
  }(e) : f, v = t.displayName && t.componentId ? $k(t.displayName) + "-" + t.componentId : t.componentId || u, y = r && e.attrs ? Array.prototype.concat(e.attrs, s).filter(Boolean) : s, b = t.shouldForwardProp;
  r && e.shouldForwardProp && (b = t.shouldForwardProp ? function(R, O, D) {
    return e.shouldForwardProp(R, O, D) && t.shouldForwardProp(R, O, D);
  } : e.shouldForwardProp);
  var S, x = new nge(n, v, r ? e.componentStyle : void 0), E = x.isStatic && s.length === 0, N = function(R, O) {
    return function(D, $, B, G) {
      var Z = D.attrs, K = D.componentStyle, q = D.defaultProps, pe = D.foldedComponentIds, he = D.shouldForwardProp, _e = D.styledComponentId, ge = D.target, Y = function(Le, ie, $e) {
        Le === void 0 && (Le = Pm);
        var we = Cd({}, ie, { theme: Le }), Ne = {};
        return $e.forEach(function(Ee) {
          var le, be, He, Ae = Ee;
          for (le in a2(Ae) && (Ae = Ae(we)), Ae) we[le] = Ne[le] = le === "className" ? (be = Ne[le], He = Ae[le], be && He ? be + " " + He : be || He) : Ae[le];
        }), [we, Ne];
      }(gQ($, Zp(r_), q) || Pm, $, Z), ee = Y[0], oe = Y[1], me = function(Le, ie, $e, we) {
        var Ne = pQ(), Ee = hQ(), le = ie ? Le.generateAndInjectStyles(Pm, Ne, Ee) : Le.generateAndInjectStyles($e, Ne, Ee);
        return process.env.NODE_ENV !== "production" && !ie && we && we(le), le;
      }(K, G, ee, process.env.NODE_ENV !== "production" ? D.warnTooManyClasses : void 0), xe = B, X = oe.$as || $.$as || oe.as || $.as || ge, ye = _S(X), ce = oe !== $ ? Cd({}, $, {}, oe) : $, se = {};
      for (var Ie in ce) Ie[0] !== "$" && Ie !== "as" && (Ie === "forwardedAs" ? se.as = ce[Ie] : (he ? he(Ie, iV, X) : !ye || iV(Ie)) && (se[Ie] = ce[Ie]));
      return $.style && oe.style !== $.style && (se.style = Cd({}, $.style, {}, oe.style)), se.className = Array.prototype.concat(pe, _e, me !== _e ? me : null, $.className, oe.className).filter(Boolean).join(" "), se.ref = xe, M0(X, se);
    }(S, R, O, E);
  };
  return N.displayName = m, (S = vo.forwardRef(N)).attrs = y, S.componentStyle = x, S.displayName = m, S.shouldForwardProp = b, S.foldedComponentIds = r ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : E7, S.styledComponentId = v, S.target = r ? e.target : e, S.withComponent = function(R) {
    var O = t.componentId, D = function(B, G) {
      if (B == null) return {};
      var Z, K, q = {}, pe = Object.keys(B);
      for (K = 0; K < pe.length; K++) Z = pe[K], G.indexOf(Z) >= 0 || (q[Z] = B[Z]);
      return q;
    }(t, ["componentId"]), $ = O && O + "-" + (_S(R) ? R : $k(QN(R)));
    return _Q(R, Cd({}, D, { attrs: y, componentId: $ }), n);
  }, Object.defineProperty(S, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(R) {
    this._foldedDefaultProps = r ? yQ({}, e.defaultProps, R) : R;
  } }), process.env.NODE_ENV !== "production" && (vQ(m, v), S.warnTooManyClasses = /* @__PURE__ */ function(R, O) {
    var D = {}, $ = !1;
    return function(B) {
      if (!$ && (D[B] = !0, Object.keys(D).length >= 200)) {
        var G = O ? ' with the id of "' + O + '"' : "";
        console.warn("Over 200 classes were generated for component " + R + G + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), $ = !0, D = {};
      }
    };
  }(m, v)), Object.defineProperty(S, "toString", { value: function() {
    return "." + S.styledComponentId;
  } }), a && $1e(S, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), S;
}
var rT = function(e) {
  return function t(n, r, a) {
    if (a === void 0 && (a = Pm), !wR.isValidElementType(r)) return Lp(1, String(r));
    var o = function() {
      return n(r, a, ot.apply(void 0, arguments));
    };
    return o.withConfig = function(s) {
      return t(n, r, Cd({}, a, {}, s));
    }, o.attrs = function(s) {
      return t(n, r, Cd({}, a, { attrs: Array.prototype.concat(a.attrs, s).filter(Boolean) }));
    }, o;
  }(_Q, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e) {
  rT[e] = rT(e);
});
var mge = function() {
  function e(n, r) {
    this.rules = n, this.componentId = r, this.isStatic = cQ(n), k7.registerId(this.componentId + 1);
  }
  var t = e.prototype;
  return t.createStyles = function(n, r, a, o) {
    var s = o(q0(this.rules, r, a, o).join(""), ""), c = this.componentId + n;
    a.insertRules(c, c, s);
  }, t.removeStyles = function(n, r) {
    r.clearRules(this.componentId + n);
  }, t.renderStyles = function(n, r, a, o) {
    n > 2 && k7.registerId(this.componentId + n), this.removeStyles(n, a), this.createStyles(n, r, a, o);
  }, e;
}();
function vge(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  var a = ot.apply(void 0, [e].concat(n)), o = "sc-global-" + kR(JSON.stringify(a)), s = new mge(a, o);
  function c(f) {
    var m = pQ(), v = hQ(), y = Zp(r_), b = Yo(m.allocateGSInstance(o)).current;
    return process.env.NODE_ENV !== "production" && vo.Children.count(f.children) && console.warn("The global style component " + o + " was given child JSX. createGlobalStyle does not render children."), process.env.NODE_ENV !== "production" && a.some(function(S) {
      return typeof S == "string" && S.indexOf("@import") !== -1;
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), m.server && u(b, f, m, y, v), $J(function() {
      if (!m.server) return u(b, f, m, y, v), function() {
        return s.removeStyles(b, m);
      };
    }, [b, f, m, y, v]), null;
  }
  function u(f, m, v, y, b) {
    if (s.isStatic) s.renderStyles(f, F1e, v, b);
    else {
      var S = Cd({}, m, { theme: gQ(m, y, c.defaultProps) });
      s.renderStyles(f, S, v, b);
    }
  }
  return process.env.NODE_ENV !== "production" && vQ(o), vo.memo(c);
}
function AR(e) {
  process.env.NODE_ENV !== "production" && typeof navigator != "undefined" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  var a = ot.apply(void 0, [e].concat(n)).join(""), o = kR(a);
  return new mQ(o, a);
}
process.env.NODE_ENV !== "production" && typeof navigator != "undefined" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window != "undefined" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const W = rT;
function $s(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var gge = typeof Symbol == "function" && Symbol.observable || "@@observable", gV = gge, Fk = () => Math.random().toString(36).substring(7).split("").join("."), yge = {
  INIT: `@@redux/INIT${/* @__PURE__ */ Fk()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ Fk()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${Fk()}`
}, D0 = yge;
function I_(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function bge(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (wge(e))
    return "date";
  if (Cge(e))
    return "error";
  const n = _ge(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function _ge(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function Cge(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function wge(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function vm(e) {
  let t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = bge(e)), t;
}
function CQ(e, t, n) {
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? $s(2) : `Expected the root reducer to be a function. Instead, received: '${vm(e)}'`);
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? $s(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n == "undefined" && (n = t, t = void 0), typeof n != "undefined") {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? $s(1) : `Expected the enhancer to be a function. Instead, received: '${vm(n)}'`);
    return n(CQ)(e, t);
  }
  let r = e, a = t, o = /* @__PURE__ */ new Map(), s = o, c = 0, u = !1;
  function f() {
    s === o && (s = /* @__PURE__ */ new Map(), o.forEach((E, N) => {
      s.set(N, E);
    }));
  }
  function m() {
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? $s(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return a;
  }
  function v(E) {
    if (typeof E != "function")
      throw new Error(process.env.NODE_ENV === "production" ? $s(4) : `Expected the listener to be a function. Instead, received: '${vm(E)}'`);
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? $s(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    let N = !0;
    f();
    const R = c++;
    return s.set(R, E), function() {
      if (N) {
        if (u)
          throw new Error(process.env.NODE_ENV === "production" ? $s(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        N = !1, f(), s.delete(R), o = null;
      }
    };
  }
  function y(E) {
    if (!I_(E))
      throw new Error(process.env.NODE_ENV === "production" ? $s(7) : `Actions must be plain objects. Instead, the actual type was: '${vm(E)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    if (typeof E.type == "undefined")
      throw new Error(process.env.NODE_ENV === "production" ? $s(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (typeof E.type != "string")
      throw new Error(process.env.NODE_ENV === "production" ? $s(17) : `Action "type" property must be a string. Instead, the actual type was: '${vm(E.type)}'. Value was: '${E.type}' (stringified)`);
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? $s(9) : "Reducers may not dispatch actions.");
    try {
      u = !0, a = r(a, E);
    } finally {
      u = !1;
    }
    return (o = s).forEach((R) => {
      R();
    }), E;
  }
  function b(E) {
    if (typeof E != "function")
      throw new Error(process.env.NODE_ENV === "production" ? $s(10) : `Expected the nextReducer to be a function. Instead, received: '${vm(E)}`);
    r = E, y({
      type: D0.REPLACE
    });
  }
  function S() {
    const E = v;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(N) {
        if (typeof N != "object" || N === null)
          throw new Error(process.env.NODE_ENV === "production" ? $s(11) : `Expected the observer to be an object. Instead, received: '${vm(N)}'`);
        function R() {
          const D = N;
          D.next && D.next(m());
        }
        return R(), {
          unsubscribe: E(R)
        };
      },
      [gV]() {
        return this;
      }
    };
  }
  return y({
    type: D0.INIT
  }), {
    dispatch: y,
    subscribe: v,
    getState: m,
    replaceReducer: b,
    [gV]: S
  };
}
function yV(e) {
  typeof console != "undefined" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch (t) {
  }
}
function Sge(e, t, n, r) {
  const a = Object.keys(t), o = n && n.type === D0.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (a.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!I_(e))
    return `The ${o} has unexpected type of "${vm(e)}". Expected argument to be an object with the following keys: "${a.join('", "')}"`;
  const s = Object.keys(e).filter((c) => !t.hasOwnProperty(c) && !r[c]);
  if (s.forEach((c) => {
    r[c] = !0;
  }), !(n && n.type === D0.REPLACE) && s.length > 0)
    return `Unexpected ${s.length > 1 ? "keys" : "key"} "${s.join('", "')}" found in ${o}. Expected to find one of the known reducer keys instead: "${a.join('", "')}". Unexpected keys will be ignored.`;
}
function xge(e) {
  Object.keys(e).forEach((t) => {
    const n = e[t];
    if (typeof n(void 0, {
      type: D0.INIT
    }) == "undefined")
      throw new Error(process.env.NODE_ENV === "production" ? $s(12) : `The slice reducer for key "${t}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof n(void 0, {
      type: D0.PROBE_UNKNOWN_ACTION()
    }) == "undefined")
      throw new Error(process.env.NODE_ENV === "production" ? $s(13) : `The slice reducer for key "${t}" returned undefined when probed with a random type. Don't try to handle '${D0.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function wQ(e) {
  const t = Object.keys(e), n = {};
  for (let s = 0; s < t.length; s++) {
    const c = t[s];
    process.env.NODE_ENV !== "production" && typeof e[c] == "undefined" && yV(`No reducer provided for key "${c}"`), typeof e[c] == "function" && (n[c] = e[c]);
  }
  const r = Object.keys(n);
  let a;
  process.env.NODE_ENV !== "production" && (a = {});
  let o;
  try {
    xge(n);
  } catch (s) {
    o = s;
  }
  return function(c = {}, u) {
    if (o)
      throw o;
    if (process.env.NODE_ENV !== "production") {
      const v = Sge(c, n, u, a);
      v && yV(v);
    }
    let f = !1;
    const m = {};
    for (let v = 0; v < r.length; v++) {
      const y = r[v], b = n[y], S = c[y], x = b(S, u);
      if (typeof x == "undefined") {
        const E = u && u.type;
        throw new Error(process.env.NODE_ENV === "production" ? $s(14) : `When called with an action of type ${E ? `"${String(E)}"` : "(unknown type)"}, the slice reducer for key "${y}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      m[y] = x, f = f || x !== S;
    }
    return f = f || r.length !== Object.keys(c).length, f ? m : c;
  };
}
function A7(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, n) => (...r) => t(n(...r)));
}
function Ege(...e) {
  return (t) => (n, r) => {
    const a = t(n, r);
    let o = () => {
      throw new Error(process.env.NODE_ENV === "production" ? $s(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const s = {
      getState: a.getState,
      dispatch: (u, ...f) => o(u, ...f)
    }, c = e.map((u) => u(s));
    return o = A7(...c)(a.dispatch), Xn(Fe({}, a), {
      dispatch: o
    });
  };
}
function SQ(e) {
  return I_(e) && "type" in e && typeof e.type == "string";
}
var xQ = Symbol.for("immer-nothing"), bV = Symbol.for("immer-draftable"), Du = Symbol.for("immer-state"), Ige = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function uu(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = Ige[e], r = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var i2 = Object.getPrototypeOf;
function J0(e) {
  return !!e && !!e[Du];
}
function Vp(e) {
  var t;
  return e ? EQ(e) || Array.isArray(e) || !!e[bV] || !!((t = e.constructor) != null && t[bV]) || z6(e) || H6(e) : !1;
}
var kge = Object.prototype.constructor.toString();
function EQ(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = i2(e);
  if (t === null)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === kge;
}
function P7(e, t) {
  G6(e) === 0 ? Reflect.ownKeys(e).forEach((n) => {
    t(n, e[n], e);
  }) : e.forEach((n, r) => t(r, n, e));
}
function G6(e) {
  const t = e[Du];
  return t ? t.type_ : Array.isArray(e) ? 1 : z6(e) ? 2 : H6(e) ? 3 : 0;
}
function aT(e, t) {
  return G6(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function IQ(e, t, n) {
  const r = G6(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function Age(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function z6(e) {
  return e instanceof Map;
}
function H6(e) {
  return e instanceof Set;
}
function S0(e) {
  return e.copy_ || e.base_;
}
function oT(e, t) {
  if (z6(e))
    return new Map(e);
  if (H6(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const n = EQ(e);
  if (t === !0 || t === "class_only" && !n) {
    const r = Object.getOwnPropertyDescriptors(e);
    delete r[Du];
    let a = Reflect.ownKeys(r);
    for (let o = 0; o < a.length; o++) {
      const s = a[o], c = r[s];
      c.writable === !1 && (c.writable = !0, c.configurable = !0), (c.get || c.set) && (r[s] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: c.enumerable,
        value: e[s]
      });
    }
    return Object.create(i2(e), r);
  } else {
    const r = i2(e);
    if (r !== null && n)
      return Fe({}, e);
    const a = Object.create(r);
    return Object.assign(a, e);
  }
}
function PR(e, t = !1) {
  return W6(e) || J0(e) || !Vp(e) || (G6(e) > 1 && (e.set = e.add = e.clear = e.delete = Pge), Object.freeze(e), t && Object.entries(e).forEach(([n, r]) => PR(r, !0))), e;
}
function Pge() {
  uu(2);
}
function W6(e) {
  return Object.isFrozen(e);
}
var Nge = {};
function Q0(e) {
  const t = Nge[e];
  return t || uu(0, e), t;
}
var a_;
function kQ() {
  return a_;
}
function Tge(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function _V(e, t) {
  t && (Q0("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function iT(e) {
  sT(e), e.drafts_.forEach(Oge), e.drafts_ = null;
}
function sT(e) {
  e === a_ && (a_ = e.parent_);
}
function CV(e) {
  return a_ = Tge(a_, e);
}
function Oge(e) {
  const t = e[Du];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function wV(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[Du].modified_ && (iT(t), uu(4)), Vp(e) && (e = N7(t, e), t.parent_ || T7(t, e)), t.patches_ && Q0("Patches").generateReplacementPatches_(
    n[Du].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = N7(t, n, []), iT(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== xQ ? e : void 0;
}
function N7(e, t, n) {
  if (W6(t))
    return t;
  const r = t[Du];
  if (!r)
    return P7(
      t,
      (a, o) => SV(e, r, t, a, o, n)
    ), t;
  if (r.scope_ !== e)
    return t;
  if (!r.modified_)
    return T7(e, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const a = r.copy_;
    let o = a, s = !1;
    r.type_ === 3 && (o = new Set(a), a.clear(), s = !0), P7(
      o,
      (c, u) => SV(e, r, a, c, u, n, s)
    ), T7(e, a, !1), n && e.patches_ && Q0("Patches").generatePatches_(
      r,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return r.copy_;
}
function SV(e, t, n, r, a, o, s) {
  if (process.env.NODE_ENV !== "production" && a === n && uu(5), J0(a)) {
    const c = o && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !aT(t.assigned_, r) ? o.concat(r) : void 0, u = N7(e, a, c);
    if (IQ(n, r, u), J0(u))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else s && n.add(a);
  if (Vp(a) && !W6(a)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    N7(e, a), (!t || !t.scope_.parent_) && typeof r != "symbol" && Object.prototype.propertyIsEnumerable.call(n, r) && T7(e, a);
  }
}
function T7(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && PR(t, n);
}
function Rge(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : kQ(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let a = r, o = NR;
  n && (a = [r], o = o_);
  const { revoke: s, proxy: c } = Proxy.revocable(a, o);
  return r.draft_ = c, r.revoke_ = s, c;
}
var NR = {
  get(e, t) {
    if (t === Du)
      return e;
    const n = S0(e);
    if (!aT(n, t))
      return Mge(e, n, t);
    const r = n[t];
    return e.finalized_ || !Vp(r) ? r : r === Bk(e.base_, t) ? (Vk(e), e.copy_[t] = uT(r, e)) : r;
  },
  has(e, t) {
    return t in S0(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(S0(e));
  },
  set(e, t, n) {
    const r = AQ(S0(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const a = Bk(S0(e), t), o = a == null ? void 0 : a[Du];
      if (o && o.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (Age(n, a) && (n !== void 0 || aT(e.base_, t)))
        return !0;
      Vk(e), lT(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return Bk(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, Vk(e), lT(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = S0(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    uu(11);
  },
  getPrototypeOf(e) {
    return i2(e.base_);
  },
  setPrototypeOf() {
    uu(12);
  }
}, o_ = {};
P7(NR, (e, t) => {
  o_[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
o_.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && uu(13), o_.set.call(this, e, t, void 0);
};
o_.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && uu(14), NR.set.call(this, e[0], t, n, e[0]);
};
function Bk(e, t) {
  const n = e[Du];
  return (n ? S0(n) : e)[t];
}
function Mge(e, t, n) {
  var a;
  const r = AQ(t, n);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (a = r.get) == null ? void 0 : a.call(e.draft_)
  ) : void 0;
}
function AQ(e, t) {
  if (!(t in e))
    return;
  let n = i2(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = i2(n);
  }
}
function lT(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && lT(e.parent_));
}
function Vk(e) {
  e.copy_ || (e.copy_ = oT(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var Dge = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const o = n;
        n = t;
        const s = this;
        return function(u = o, ...f) {
          return s.produce(u, (m) => n.call(this, m, ...f));
        };
      }
      typeof n != "function" && uu(6), r !== void 0 && typeof r != "function" && uu(7);
      let a;
      if (Vp(t)) {
        const o = CV(this), s = uT(t, void 0);
        let c = !0;
        try {
          a = n(s), c = !1;
        } finally {
          c ? iT(o) : sT(o);
        }
        return _V(o, r), wV(a, o);
      } else if (!t || typeof t != "object") {
        if (a = n(t), a === void 0 && (a = t), a === xQ && (a = void 0), this.autoFreeze_ && PR(a, !0), r) {
          const o = [], s = [];
          Q0("Patches").generateReplacementPatches_(t, a, o, s), r(o, s);
        }
        return a;
      } else
        uu(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (s, ...c) => this.produceWithPatches(s, (u) => t(u, ...c));
      let r, a;
      return [this.produce(t, n, (s, c) => {
        r = s, a = c;
      }), r, a];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    Vp(e) || uu(8), J0(e) && (e = Lge(e));
    const t = CV(this), n = uT(e, void 0);
    return n[Du].isManual_ = !0, sT(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[Du];
    (!n || !n.isManual_) && uu(9);
    const { scope_: r } = n;
    return _V(r, t), wV(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const a = t[n];
      if (a.path.length === 0 && a.op === "replace") {
        e = a.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = Q0("Patches").applyPatches_;
    return J0(e) ? r(e, t) : this.produce(
      e,
      (a) => r(a, t)
    );
  }
};
function uT(e, t) {
  const n = z6(e) ? Q0("MapSet").proxyMap_(e, t) : H6(e) ? Q0("MapSet").proxySet_(e, t) : Rge(e, t);
  return (t ? t.scope_ : kQ()).drafts_.push(n), n;
}
function Lge(e) {
  return J0(e) || uu(10, e), PQ(e);
}
function PQ(e) {
  if (!Vp(e) || W6(e))
    return e;
  const t = e[Du];
  let n;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = oT(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    n = oT(e, !0);
  return P7(n, (r, a) => {
    IQ(n, r, PQ(a));
  }), t && (t.finalized_ = !1), n;
}
var Lu = new Dge(), NQ = Lu.produce;
Lu.produceWithPatches.bind(
  Lu
);
Lu.setAutoFreeze.bind(Lu);
Lu.setUseStrictShallowCopy.bind(Lu);
Lu.applyPatches.bind(Lu);
Lu.createDraft.bind(Lu);
Lu.finishDraft.bind(Lu);
function TQ(e) {
  return ({ dispatch: n, getState: r }) => (a) => (o) => typeof o == "function" ? o(n, r, e) : a(o);
}
var $ge = TQ(), jge = TQ, Fge = typeof window != "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? A7 : A7.apply(null, arguments);
}, OQ = (e) => e && typeof e.match == "function";
function cl(e, t) {
  function n(...r) {
    if (t) {
      let a = t(...r);
      if (!a)
        throw new Error(process.env.NODE_ENV === "production" ? ja(0) : "prepareAction did not return an object");
      return Fe(Fe({
        type: e,
        payload: a.payload
      }, "meta" in a && {
        meta: a.meta
      }), "error" in a && {
        error: a.error
      });
    }
    return {
      type: e,
      payload: r[0]
    };
  }
  return n.toString = () => `${e}`, n.type = e, n.match = (r) => SQ(r) && r.type === e, n;
}
function Bge(e) {
  return typeof e == "function" && "type" in e && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  OQ(e);
}
function Vge(e) {
  const t = e ? `${e}`.split("/") : [], n = t[t.length - 1] || "actionCreator";
  return `Detected an action creator with type "${e || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${n}())\` instead of \`dispatch(${n})\`. This is necessary even if the action has no payload.`;
}
function Uge(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (n) => (r) => n(r);
  const {
    isActionCreator: t = Bge
  } = e;
  return () => (n) => (r) => (t(r) && console.warn(Vge(r.type)), n(r));
}
function RQ(e, t) {
  let n = 0;
  return {
    measureTime(r) {
      const a = Date.now();
      try {
        return r();
      } finally {
        const o = Date.now();
        n += o - a;
      }
    },
    warnIfExceeded() {
      n > e && console.warn(`${t} took ${n}ms, which is more than the warning threshold of ${e}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var MQ = class b4 extends Array {
  constructor(...t) {
    super(...t), Object.setPrototypeOf(this, b4.prototype);
  }
  static get [Symbol.species]() {
    return b4;
  }
  concat(...t) {
    return super.concat.apply(this, t);
  }
  prepend(...t) {
    return t.length === 1 && Array.isArray(t[0]) ? new b4(...t[0].concat(this)) : new b4(...t.concat(this));
  }
};
function xV(e) {
  return Vp(e) ? NQ(e, () => {
  }) : e;
}
function EV(e, t, n) {
  if (e.has(t)) {
    let a = e.get(t);
    return n.update && (a = n.update(a, t, e), e.set(t, a)), a;
  }
  if (!n.insert) throw new Error(process.env.NODE_ENV === "production" ? ja(10) : "No insert provided for key not already in map");
  const r = n.insert(t, e);
  return e.set(t, r), r;
}
function Gge(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function zge(e, t, n) {
  const r = DQ(e, t, n);
  return {
    detectMutations() {
      return LQ(e, t, r, n);
    }
  };
}
function DQ(e, t = [], n, r = "", a = /* @__PURE__ */ new Set()) {
  const o = {
    value: n
  };
  if (!e(n) && !a.has(n)) {
    a.add(n), o.children = {};
    for (const s in n) {
      const c = r ? r + "." + s : s;
      t.length && t.indexOf(c) !== -1 || (o.children[s] = DQ(e, t, n[s], c));
    }
  }
  return o;
}
function LQ(e, t = [], n, r, a = !1, o = "") {
  const s = n ? n.value : void 0, c = s === r;
  if (a && !c && !Number.isNaN(r))
    return {
      wasMutated: !0,
      path: o
    };
  if (e(s) || e(r))
    return {
      wasMutated: !1
    };
  const u = {};
  for (let m in n.children)
    u[m] = !0;
  for (let m in r)
    u[m] = !0;
  const f = t.length > 0;
  for (let m in u) {
    const v = o ? o + "." + m : m;
    if (f && t.some((S) => S instanceof RegExp ? S.test(v) : v === S))
      continue;
    const y = LQ(e, t, n.children[m], r[m], c, v);
    if (y.wasMutated)
      return y;
  }
  return {
    wasMutated: !1
  };
}
function Hge(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (t) => (n) => t(n);
  {
    let t = function(c, u, f, m) {
      return JSON.stringify(c, n(u, m), f);
    }, n = function(c, u) {
      let f = [], m = [];
      return u || (u = function(v, y) {
        return f[0] === y ? "[Circular ~]" : "[Circular ~." + m.slice(0, f.indexOf(y)).join(".") + "]";
      }), function(v, y) {
        if (f.length > 0) {
          var b = f.indexOf(this);
          ~b ? f.splice(b + 1) : f.push(this), ~b ? m.splice(b, 1 / 0, v) : m.push(v), ~f.indexOf(y) && (y = u.call(this, v, y));
        } else f.push(y);
        return c == null ? y : c.call(this, v, y);
      };
    }, {
      isImmutable: r = Gge,
      ignoredPaths: a,
      warnAfter: o = 32
    } = e;
    const s = zge.bind(null, r, a);
    return ({
      getState: c
    }) => {
      let u = c(), f = s(u), m;
      return (v) => (y) => {
        const b = RQ(o, "ImmutableStateInvariantMiddleware");
        b.measureTime(() => {
          if (u = c(), m = f.detectMutations(), f = s(u), m.wasMutated)
            throw new Error(process.env.NODE_ENV === "production" ? ja(19) : `A state mutation was detected between dispatches, in the path '${m.path || ""}'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        });
        const S = v(y);
        return b.measureTime(() => {
          if (u = c(), m = f.detectMutations(), f = s(u), m.wasMutated)
            throw new Error(process.env.NODE_ENV === "production" ? ja(20) : `A state mutation was detected inside a dispatch, in the path: ${m.path || ""}. Take a look at the reducer(s) handling the action ${t(y)}. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        }), b.warnIfExceeded(), S;
      };
    };
  }
}
function $Q(e) {
  const t = typeof e;
  return e == null || t === "string" || t === "boolean" || t === "number" || Array.isArray(e) || I_(e);
}
function cT(e, t = "", n = $Q, r, a = [], o) {
  let s;
  if (!n(e))
    return {
      keyPath: t || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || o != null && o.has(e)) return !1;
  const c = r != null ? r(e) : Object.entries(e), u = a.length > 0;
  for (const [f, m] of c) {
    const v = t ? t + "." + f : f;
    if (!(u && a.some((b) => b instanceof RegExp ? b.test(v) : v === b))) {
      if (!n(m))
        return {
          keyPath: v,
          value: m
        };
      if (typeof m == "object" && (s = cT(m, v, n, r, a, o), s))
        return s;
    }
  }
  return o && jQ(e) && o.add(e), !1;
}
function jQ(e) {
  if (!Object.isFrozen(e)) return !1;
  for (const t of Object.values(e))
    if (!(typeof t != "object" || t === null) && !jQ(t))
      return !1;
  return !0;
}
function Wge(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (t) => (n) => t(n);
  {
    const {
      isSerializable: t = $Q,
      getEntries: n,
      ignoredActions: r = [],
      ignoredActionPaths: a = ["meta.arg", "meta.baseQueryMeta"],
      ignoredPaths: o = [],
      warnAfter: s = 32,
      ignoreState: c = !1,
      ignoreActions: u = !1,
      disableCache: f = !1
    } = e, m = !f && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
    return (v) => (y) => (b) => {
      if (!SQ(b))
        return y(b);
      const S = y(b), x = RQ(s, "SerializableStateInvariantMiddleware");
      return !u && !(r.length && r.indexOf(b.type) !== -1) && x.measureTime(() => {
        const E = cT(b, "", t, n, a, m);
        if (E) {
          const {
            keyPath: N,
            value: R
          } = E;
          console.error(`A non-serializable value was detected in an action, in the path: \`${N}\`. Value:`, R, `
Take a look at the logic that dispatched this action: `, b, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
        }
      }), c || (x.measureTime(() => {
        const E = v.getState(), N = cT(E, "", t, n, o, m);
        if (N) {
          const {
            keyPath: R,
            value: O
          } = N;
          console.error(`A non-serializable value was detected in the state, in the path: \`${R}\`. Value:`, O, `
Take a look at the reducer(s) handling this action type: ${b.type}.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
        }
      }), x.warnIfExceeded()), S;
    };
  }
}
function CS(e) {
  return typeof e == "boolean";
}
var Zge = () => function(t) {
  const {
    thunk: n = !0,
    immutableCheck: r = !0,
    serializableCheck: a = !0,
    actionCreatorCheck: o = !0
  } = t != null ? t : {};
  let s = new MQ();
  if (n && (CS(n) ? s.push($ge) : s.push(jge(n.extraArgument))), process.env.NODE_ENV !== "production") {
    if (r) {
      let c = {};
      CS(r) || (c = r), s.unshift(Hge(c));
    }
    if (a) {
      let c = {};
      CS(a) || (c = a), s.push(Wge(c));
    }
    if (o) {
      let c = {};
      CS(o) || (c = o), s.unshift(Uge(c));
    }
  }
  return s;
}, Yge = "RTK_autoBatch", FQ = (e) => (t) => {
  setTimeout(t, e);
}, Xge = typeof window != "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : FQ(10), Kge = (e = {
  type: "raf"
}) => (t) => (...n) => {
  const r = t(...n);
  let a = !0, o = !1, s = !1;
  const c = /* @__PURE__ */ new Set(), u = e.type === "tick" ? queueMicrotask : e.type === "raf" ? Xge : e.type === "callback" ? e.queueNotification : FQ(e.timeout), f = () => {
    s = !1, o && (o = !1, c.forEach((m) => m()));
  };
  return Object.assign({}, r, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(m) {
      const v = () => a && m(), y = r.subscribe(v);
      return c.add(m), () => {
        y(), c.delete(m);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(m) {
      var v;
      try {
        return a = !((v = m == null ? void 0 : m.meta) != null && v[Yge]), o = !a, o && (s || (s = !0, u(f))), r.dispatch(m);
      } finally {
        a = !0;
      }
    }
  });
}, qge = (e) => function(n) {
  const {
    autoBatch: r = !0
  } = n != null ? n : {};
  let a = new MQ(e);
  return r && a.push(Kge(typeof r == "object" ? r : void 0)), a;
};
function Jge(e) {
  const t = Zge(), {
    reducer: n = void 0,
    middleware: r,
    devTools: a = !0,
    preloadedState: o = void 0,
    enhancers: s = void 0
  } = e || {};
  let c;
  if (typeof n == "function")
    c = n;
  else if (I_(n))
    c = wQ(n);
  else
    throw new Error(process.env.NODE_ENV === "production" ? ja(1) : "`reducer` is a required argument, and must be a function or an object of functions that can be passed to combineReducers");
  if (process.env.NODE_ENV !== "production" && r && typeof r != "function")
    throw new Error(process.env.NODE_ENV === "production" ? ja(2) : "`middleware` field must be a callback");
  let u;
  if (typeof r == "function") {
    if (u = r(t), process.env.NODE_ENV !== "production" && !Array.isArray(u))
      throw new Error(process.env.NODE_ENV === "production" ? ja(3) : "when using a middleware builder function, an array of middleware must be returned");
  } else
    u = t();
  if (process.env.NODE_ENV !== "production" && u.some((S) => typeof S != "function"))
    throw new Error(process.env.NODE_ENV === "production" ? ja(4) : "each middleware provided to configureStore must be a function");
  let f = A7;
  a && (f = Fge(Fe({
    // Enable capture of stack traces for dispatched Redux actions
    trace: process.env.NODE_ENV !== "production"
  }, typeof a == "object" && a)));
  const m = Ege(...u), v = qge(m);
  if (process.env.NODE_ENV !== "production" && s && typeof s != "function")
    throw new Error(process.env.NODE_ENV === "production" ? ja(5) : "`enhancers` field must be a callback");
  let y = typeof s == "function" ? s(v) : v();
  if (process.env.NODE_ENV !== "production" && !Array.isArray(y))
    throw new Error(process.env.NODE_ENV === "production" ? ja(6) : "`enhancers` callback must return an array");
  if (process.env.NODE_ENV !== "production" && y.some((S) => typeof S != "function"))
    throw new Error(process.env.NODE_ENV === "production" ? ja(7) : "each enhancer provided to configureStore must be a function");
  process.env.NODE_ENV !== "production" && u.length && !y.includes(m) && console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
  const b = f(...y);
  return CQ(c, o, b);
}
function BQ(e) {
  const t = {}, n = [];
  let r;
  const a = {
    addCase(o, s) {
      if (process.env.NODE_ENV !== "production") {
        if (n.length > 0)
          throw new Error(process.env.NODE_ENV === "production" ? ja(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (r)
          throw new Error(process.env.NODE_ENV === "production" ? ja(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const c = typeof o == "string" ? o : o.type;
      if (!c)
        throw new Error(process.env.NODE_ENV === "production" ? ja(28) : "`builder.addCase` cannot be called with an empty action type");
      if (c in t)
        throw new Error(process.env.NODE_ENV === "production" ? ja(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${c}'`);
      return t[c] = s, a;
    },
    addMatcher(o, s) {
      if (process.env.NODE_ENV !== "production" && r)
        throw new Error(process.env.NODE_ENV === "production" ? ja(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return n.push({
        matcher: o,
        reducer: s
      }), a;
    },
    addDefaultCase(o) {
      if (process.env.NODE_ENV !== "production" && r)
        throw new Error(process.env.NODE_ENV === "production" ? ja(31) : "`builder.addDefaultCase` can only be called once");
      return r = o, a;
    }
  };
  return e(a), [t, n, r];
}
function Qge(e) {
  return typeof e == "function";
}
function k_(e, t) {
  if (process.env.NODE_ENV !== "production" && typeof t == "object")
    throw new Error(process.env.NODE_ENV === "production" ? ja(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [n, r, a] = BQ(t), o;
  if (Qge(e))
    o = () => xV(e());
  else {
    const c = xV(e);
    o = () => c;
  }
  function s(c = o(), u) {
    let f = [n[u.type], ...r.filter(({
      matcher: m
    }) => m(u)).map(({
      reducer: m
    }) => m)];
    return f.filter((m) => !!m).length === 0 && (f = [a]), f.reduce((m, v) => {
      if (v)
        if (J0(m)) {
          const b = v(m, u);
          return b === void 0 ? m : b;
        } else {
          if (Vp(m))
            return NQ(m, (y) => v(y, u));
          {
            const y = v(m, u);
            if (y === void 0) {
              if (m === null)
                return m;
              throw new Error(process.env.NODE_ENV === "production" ? ja(9) : "A case reducer on a non-draftable value must not return undefined");
            }
            return y;
          }
        }
      return m;
    }, c);
  }
  return s.getInitialState = o, s;
}
var eye = (e, t) => OQ(e) ? e.match(t) : e(t);
function tye(...e) {
  return (t) => e.some((n) => eye(n, t));
}
var nye = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", rye = (e = 21) => {
  let t = "", n = e;
  for (; n--; )
    t += nye[Math.random() * 64 | 0];
  return t;
}, aye = ["name", "message", "stack", "code"], Uk = class {
  constructor(e, t) {
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    Er(this, "_type");
    this.payload = e, this.meta = t;
  }
}, IV = class {
  constructor(e, t) {
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    Er(this, "_type");
    this.payload = e, this.meta = t;
  }
}, oye = (e) => {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const n of aye)
      typeof e[n] == "string" && (t[n] = e[n]);
    return t;
  }
  return {
    message: String(e)
  };
}, Do = /* @__PURE__ */ (() => {
  function e(t, n, r) {
    const a = cl(t + "/fulfilled", (u, f, m, v) => ({
      payload: u,
      meta: Xn(Fe({}, v || {}), {
        arg: m,
        requestId: f,
        requestStatus: "fulfilled"
      })
    })), o = cl(t + "/pending", (u, f, m) => ({
      payload: void 0,
      meta: Xn(Fe({}, m || {}), {
        arg: f,
        requestId: u,
        requestStatus: "pending"
      })
    })), s = cl(t + "/rejected", (u, f, m, v, y) => ({
      payload: v,
      error: (r && r.serializeError || oye)(u || "Rejected"),
      meta: Xn(Fe({}, y || {}), {
        arg: m,
        requestId: f,
        rejectedWithValue: !!v,
        requestStatus: "rejected",
        aborted: (u == null ? void 0 : u.name) === "AbortError",
        condition: (u == null ? void 0 : u.name) === "ConditionError"
      })
    }));
    function c(u) {
      return (f, m, v) => {
        const y = r != null && r.idGenerator ? r.idGenerator(u) : rye(), b = new AbortController();
        let S, x;
        function E(R) {
          x = R, b.abort();
        }
        const N = function() {
          return st(this, null, function* () {
            var D, $;
            let R;
            try {
              let B = (D = r == null ? void 0 : r.condition) == null ? void 0 : D.call(r, u, {
                getState: m,
                extra: v
              });
              if (iye(B) && (B = yield B), B === !1 || b.signal.aborted)
                throw {
                  name: "ConditionError",
                  message: "Aborted due to condition callback returning false."
                };
              const G = new Promise((Z, K) => {
                S = () => {
                  K({
                    name: "AbortError",
                    message: x || "Aborted"
                  });
                }, b.signal.addEventListener("abort", S);
              });
              f(o(y, u, ($ = r == null ? void 0 : r.getPendingMeta) == null ? void 0 : $.call(r, {
                requestId: y,
                arg: u
              }, {
                getState: m,
                extra: v
              }))), R = yield Promise.race([G, Promise.resolve(n(u, {
                dispatch: f,
                getState: m,
                extra: v,
                requestId: y,
                signal: b.signal,
                abort: E,
                rejectWithValue: (Z, K) => new Uk(Z, K),
                fulfillWithValue: (Z, K) => new IV(Z, K)
              })).then((Z) => {
                if (Z instanceof Uk)
                  throw Z;
                return Z instanceof IV ? a(Z.payload, y, u, Z.meta) : a(Z, y, u);
              })]);
            } catch (B) {
              R = B instanceof Uk ? s(null, y, u, B.payload, B.meta) : s(B, y, u);
            } finally {
              S && b.signal.removeEventListener("abort", S);
            }
            return r && !r.dispatchConditionRejection && s.match(R) && R.meta.condition || f(R), R;
          });
        }();
        return Object.assign(N, {
          abort: E,
          requestId: y,
          arg: u,
          unwrap() {
            return N.then(Mx);
          }
        });
      };
    }
    return Object.assign(c, {
      pending: o,
      rejected: s,
      fulfilled: a,
      settled: tye(s, a),
      typePrefix: t
    });
  }
  return e.withTypes = () => e, e;
})();
function Mx(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function iye(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var sye = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function lye(e, t) {
  return `${e}/${t}`;
}
function uye({
  creators: e
} = {}) {
  var n;
  const t = (n = e == null ? void 0 : e.asyncThunk) == null ? void 0 : n[sye];
  return function(a) {
    const {
      name: o,
      reducerPath: s = o
    } = a;
    if (!o)
      throw new Error(process.env.NODE_ENV === "production" ? ja(11) : "`name` is a required option for createSlice");
    typeof process != "undefined" && process.env.NODE_ENV === "development" && a.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const c = (typeof a.reducers == "function" ? a.reducers(dye()) : a.reducers) || {}, u = Object.keys(c), f = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, m = {
      addCase(O, D) {
        const $ = typeof O == "string" ? O : O.type;
        if (!$)
          throw new Error(process.env.NODE_ENV === "production" ? ja(12) : "`context.addCase` cannot be called with an empty action type");
        if ($ in f.sliceCaseReducersByType)
          throw new Error(process.env.NODE_ENV === "production" ? ja(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + $);
        return f.sliceCaseReducersByType[$] = D, m;
      },
      addMatcher(O, D) {
        return f.sliceMatchers.push({
          matcher: O,
          reducer: D
        }), m;
      },
      exposeAction(O, D) {
        return f.actionCreators[O] = D, m;
      },
      exposeCaseReducer(O, D) {
        return f.sliceCaseReducersByName[O] = D, m;
      }
    };
    u.forEach((O) => {
      const D = c[O], $ = {
        reducerName: O,
        type: lye(o, O),
        createNotation: typeof a.reducers == "function"
      };
      pye(D) ? mye($, D, m, t) : fye($, D, m);
    });
    function v() {
      if (process.env.NODE_ENV !== "production" && typeof a.extraReducers == "object")
        throw new Error(process.env.NODE_ENV === "production" ? ja(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [O = {}, D = [], $ = void 0] = typeof a.extraReducers == "function" ? BQ(a.extraReducers) : [a.extraReducers], B = Fe(Fe({}, O), f.sliceCaseReducersByType);
      return k_(a.initialState, (G) => {
        for (let Z in B)
          G.addCase(Z, B[Z]);
        for (let Z of f.sliceMatchers)
          G.addMatcher(Z.matcher, Z.reducer);
        for (let Z of D)
          G.addMatcher(Z.matcher, Z.reducer);
        $ && G.addDefaultCase($);
      });
    }
    const y = (O) => O, b = /* @__PURE__ */ new Map();
    let S;
    function x(O, D) {
      return S || (S = v()), S(O, D);
    }
    function E() {
      return S || (S = v()), S.getInitialState();
    }
    function N(O, D = !1) {
      function $(G) {
        let Z = G[O];
        if (typeof Z == "undefined") {
          if (D)
            Z = E();
          else if (process.env.NODE_ENV !== "production")
            throw new Error(process.env.NODE_ENV === "production" ? ja(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return Z;
      }
      function B(G = y) {
        const Z = EV(b, D, {
          insert: () => /* @__PURE__ */ new WeakMap()
        });
        return EV(Z, G, {
          insert: () => {
            var q;
            const K = {};
            for (const [pe, he] of Object.entries((q = a.selectors) != null ? q : {}))
              K[pe] = cye(he, G, E, D);
            return K;
          }
        });
      }
      return {
        reducerPath: O,
        getSelectors: B,
        get selectors() {
          return B($);
        },
        selectSlice: $
      };
    }
    const R = Xn(Fe({
      name: o,
      reducer: x,
      actions: f.actionCreators,
      caseReducers: f.sliceCaseReducersByName,
      getInitialState: E
    }, N(s)), {
      injectInto(O, B = {}) {
        var G = B, {
          reducerPath: D
        } = G, $ = u0(G, [
          "reducerPath"
        ]);
        const Z = D != null ? D : s;
        return O.inject({
          reducerPath: Z,
          reducer: x
        }, $), Fe(Fe({}, R), N(Z, !0));
      }
    });
    return R;
  };
}
function cye(e, t, n, r) {
  function a(o, ...s) {
    let c = t(o);
    if (typeof c == "undefined") {
      if (r)
        c = n();
      else if (process.env.NODE_ENV !== "production")
        throw new Error(process.env.NODE_ENV === "production" ? ja(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return e(c, ...s);
  }
  return a.unwrapped = e, a;
}
var hs = /* @__PURE__ */ uye();
function dye() {
  function e(t, n) {
    return Fe({
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t
    }, n);
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...n) {
          return t(...n);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, n) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: n
      };
    },
    asyncThunk: e
  };
}
function fye({
  type: e,
  reducerName: t,
  createNotation: n
}, r, a) {
  let o, s;
  if ("reducer" in r) {
    if (n && !hye(r))
      throw new Error(process.env.NODE_ENV === "production" ? ja(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    o = r.reducer, s = r.prepare;
  } else
    o = r;
  a.addCase(e, o).exposeCaseReducer(t, o).exposeAction(t, s ? cl(e, s) : cl(e));
}
function pye(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function hye(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function mye({
  type: e,
  reducerName: t
}, n, r, a) {
  if (!a)
    throw new Error(process.env.NODE_ENV === "production" ? ja(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: o,
    fulfilled: s,
    pending: c,
    rejected: u,
    settled: f,
    options: m
  } = n, v = a(e, o, m);
  r.exposeAction(t, v), s && r.addCase(v.fulfilled, s), c && r.addCase(v.pending, c), u && r.addCase(v.rejected, u), f && r.addMatcher(v.settled, f), r.exposeCaseReducer(t, {
    fulfilled: s || wS,
    pending: c || wS,
    rejected: u || wS,
    settled: f || wS
  });
}
function wS() {
}
function ja(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
const VQ = "SET_DATA", vye = cl(VQ), UQ = "REMOVE_DATA", gye = cl(UQ), yye = {
  CLEENG_OFFER_ID: "",
  CLEENG_PUBLISHER_ID: "",
  CLEENG_AUTH_TOKEN: "",
  CLEENG_ORDER_ID: "",
  CLEENG_PAYMENT_METHOD_ID: "",
  CLEENG_CUSTOMER_EMAIL: "",
  CLEENG_HOSTED: "",
  CLEENG_HEADER_OFF: ""
}, bye = k_(yye, (e) => {
  e.addCase(VQ, (t, n) => {
    t[n.payload.name] = n.payload.value;
  }), e.addCase(UQ, (t, n) => {
    t[n.payload.name] = "";
  });
}), kV = {
  isGift: !1,
  recipientEmail: { value: "", error: "", translationKey: "" },
  confirmRecipientEmail: { value: "", error: "", translationKey: "" },
  deliveryDate: { value: "", error: "", translationKey: "" },
  deliveryTime: { value: "", error: "", translationKey: "" },
  message: { value: "" }
}, GQ = hs({
  name: "deliveryDetails",
  initialState: kV,
  reducers: (e) => ({
    setIsGift: e.reducer((t, n) => {
      t.isGift = n.payload;
    }),
    setFieldValue: e.reducer(
      (t, n) => {
        const {
          payload: { name: r, value: a }
        } = n;
        t[r].value = a;
      }
    ),
    setFieldError: e.reducer(
      (t, n) => {
        const {
          payload: { name: r, error: a, translationKey: o }
        } = n;
        t[r].error = a, t[r].translationKey = o;
      }
    ),
    resetDeliveryDetailsState: e.reducer(() => kV)
  })
}), {
  setIsGift: Gk,
  setFieldValue: ly,
  setFieldError: s2,
  resetDeliveryDetailsState: zQ
} = GQ.actions, I2 = (e) => e.deliveryDetails, _ye = GQ.reducer;
var O7 = { exports: {} };
O7.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", a = 800, o = 16, s = 9007199254740991, c = "[object Arguments]", u = "[object Array]", f = "[object AsyncFunction]", m = "[object Boolean]", v = "[object Date]", y = "[object Error]", b = "[object Function]", S = "[object GeneratorFunction]", x = "[object Map]", E = "[object Number]", N = "[object Null]", R = "[object Object]", O = "[object Proxy]", D = "[object RegExp]", $ = "[object Set]", B = "[object String]", G = "[object Undefined]", Z = "[object WeakMap]", K = "[object ArrayBuffer]", q = "[object DataView]", pe = "[object Float32Array]", he = "[object Float64Array]", _e = "[object Int8Array]", ge = "[object Int16Array]", Y = "[object Int32Array]", ee = "[object Uint8Array]", oe = "[object Uint8ClampedArray]", me = "[object Uint16Array]", xe = "[object Uint32Array]", X = /[\\^$.*+?()[\]{}|]/g, ye = /^\[object .+?Constructor\]$/, ce = /^(?:0|[1-9]\d*)$/, se = {};
  se[pe] = se[he] = se[_e] = se[ge] = se[Y] = se[ee] = se[oe] = se[me] = se[xe] = !0, se[c] = se[u] = se[K] = se[m] = se[q] = se[v] = se[y] = se[b] = se[x] = se[E] = se[R] = se[D] = se[$] = se[B] = se[Z] = !1;
  var Ie = typeof Nu == "object" && Nu && Nu.Object === Object && Nu, Le = typeof self == "object" && self && self.Object === Object && self, ie = Ie || Le || Function("return this")(), $e = t && !t.nodeType && t, we = $e && !0 && e && !e.nodeType && e, Ne = we && we.exports === $e, Ee = Ne && Ie.process, le = function() {
    try {
      var ue = we && we.require && we.require("util").types;
      return ue || Ee && Ee.binding && Ee.binding("util");
    } catch (De) {
    }
  }(), be = le && le.isTypedArray;
  function He(ue, De, qe) {
    switch (qe.length) {
      case 0:
        return ue.call(De);
      case 1:
        return ue.call(De, qe[0]);
      case 2:
        return ue.call(De, qe[0], qe[1]);
      case 3:
        return ue.call(De, qe[0], qe[1], qe[2]);
    }
    return ue.apply(De, qe);
  }
  function Ae(ue, De) {
    for (var qe = -1, Xt = Array(ue); ++qe < ue; )
      Xt[qe] = De(qe);
    return Xt;
  }
  function it(ue) {
    return function(De) {
      return ue(De);
    };
  }
  function ut(ue, De) {
    return ue == null ? void 0 : ue[De];
  }
  function St(ue, De) {
    return function(qe) {
      return ue(De(qe));
    };
  }
  var sn = Array.prototype, zn = Function.prototype, dn = Object.prototype, $t = ie["__core-js_shared__"], qt = zn.toString, fn = dn.hasOwnProperty, At = function() {
    var ue = /[^.]+$/.exec($t && $t.keys && $t.keys.IE_PROTO || "");
    return ue ? "Symbol(src)_1." + ue : "";
  }(), Wt = dn.toString, Xr = qt.call(Object), Kn = RegExp(
    "^" + qt.call(fn).replace(X, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Sr = Ne ? ie.Buffer : void 0, jo = ie.Symbol, ei = ie.Uint8Array;
  Sr && Sr.allocUnsafe;
  var tt = St(Object.getPrototypeOf, Object), bt = Object.create, rn = dn.propertyIsEnumerable, Rn = sn.splice, Cn = jo ? jo.toStringTag : void 0, Qn = function() {
    try {
      var ue = io(Object, "defineProperty");
      return ue({}, "", {}), ue;
    } catch (De) {
    }
  }(), er = Sr ? Sr.isBuffer : void 0, oo = Math.max, Lr = Date.now, ia = io(ie, "Map"), ir = io(Object, "create"), xr = /* @__PURE__ */ function() {
    function ue() {
    }
    return function(De) {
      if (!oi(De))
        return {};
      if (bt)
        return bt(De);
      ue.prototype = De;
      var qe = new ue();
      return ue.prototype = void 0, qe;
    };
  }();
  function wo(ue) {
    var De = -1, qe = ue == null ? 0 : ue.length;
    for (this.clear(); ++De < qe; ) {
      var Xt = ue[De];
      this.set(Xt[0], Xt[1]);
    }
  }
  function es() {
    this.__data__ = ir ? ir(null) : {}, this.size = 0;
  }
  function ti(ue) {
    var De = this.has(ue) && delete this.__data__[ue];
    return this.size -= De ? 1 : 0, De;
  }
  function bs(ue) {
    var De = this.__data__;
    if (ir) {
      var qe = De[ue];
      return qe === r ? void 0 : qe;
    }
    return fn.call(De, ue) ? De[ue] : void 0;
  }
  function _s(ue) {
    var De = this.__data__;
    return ir ? De[ue] !== void 0 : fn.call(De, ue);
  }
  function ni(ue, De) {
    var qe = this.__data__;
    return this.size += this.has(ue) ? 0 : 1, qe[ue] = ir && De === void 0 ? r : De, this;
  }
  wo.prototype.clear = es, wo.prototype.delete = ti, wo.prototype.get = bs, wo.prototype.has = _s, wo.prototype.set = ni;
  function Ka(ue) {
    var De = -1, qe = ue == null ? 0 : ue.length;
    for (this.clear(); ++De < qe; ) {
      var Xt = ue[De];
      this.set(Xt[0], Xt[1]);
    }
  }
  function So() {
    this.__data__ = [], this.size = 0;
  }
  function Fo(ue) {
    var De = this.__data__, qe = Cs(De, ue);
    if (qe < 0)
      return !1;
    var Xt = De.length - 1;
    return qe == Xt ? De.pop() : Rn.call(De, qe, 1), --this.size, !0;
  }
  function Pa(ue) {
    var De = this.__data__, qe = Cs(De, ue);
    return qe < 0 ? void 0 : De[qe][1];
  }
  function ri(ue) {
    return Cs(this.__data__, ue) > -1;
  }
  function xo(ue, De) {
    var qe = this.__data__, Xt = Cs(qe, ue);
    return Xt < 0 ? (++this.size, qe.push([ue, De])) : qe[Xt][1] = De, this;
  }
  Ka.prototype.clear = So, Ka.prototype.delete = Fo, Ka.prototype.get = Pa, Ka.prototype.has = ri, Ka.prototype.set = xo;
  function qa(ue) {
    var De = -1, qe = ue == null ? 0 : ue.length;
    for (this.clear(); ++De < qe; ) {
      var Xt = ue[De];
      this.set(Xt[0], Xt[1]);
    }
  }
  function ml() {
    this.size = 0, this.__data__ = {
      hash: new wo(),
      map: new (ia || Ka)(),
      string: new wo()
    };
  }
  function bu(ue) {
    var De = Io(this, ue).delete(ue);
    return this.size -= De ? 1 : 0, De;
  }
  function Ce(ue) {
    return Io(this, ue).get(ue);
  }
  function pt(ue) {
    return Io(this, ue).has(ue);
  }
  function Nt(ue, De) {
    var qe = Io(this, ue), Xt = qe.size;
    return qe.set(ue, De), this.size += qe.size == Xt ? 0 : 1, this;
  }
  qa.prototype.clear = ml, qa.prototype.delete = bu, qa.prototype.get = Ce, qa.prototype.has = pt, qa.prototype.set = Nt;
  function Vt(ue) {
    var De = this.__data__ = new Ka(ue);
    this.size = De.size;
  }
  function Mn() {
    this.__data__ = new Ka(), this.size = 0;
  }
  function Dn(ue) {
    var De = this.__data__, qe = De.delete(ue);
    return this.size = De.size, qe;
  }
  function vn(ue) {
    return this.__data__.get(ue);
  }
  function Hn(ue) {
    return this.__data__.has(ue);
  }
  function Ja(ue, De) {
    var qe = this.__data__;
    if (qe instanceof Ka) {
      var Xt = qe.__data__;
      if (!ia || Xt.length < n - 1)
        return Xt.push([ue, De]), this.size = ++qe.size, this;
      qe = this.__data__ = new qa(Xt);
    }
    return qe.set(ue, De), this.size = qe.size, this;
  }
  Vt.prototype.clear = Mn, Vt.prototype.delete = Dn, Vt.prototype.get = vn, Vt.prototype.has = Hn, Vt.prototype.set = Ja;
  function Qr(ue, De) {
    var qe = ns(ue), Xt = !qe && Ua(ue), sr = !qe && !Xt && so(ue), Ur = !qe && !Xt && !sr && lv(ue), ha = qe || Xt || sr || Ur, nr = ha ? Ae(ue.length, String) : [], ea = nr.length;
    for (var Ri in ue)
      ha && // Safari 9 has enumerable `arguments.length` in strict mode.
      (Ri == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      sr && (Ri == "offset" || Ri == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Ur && (Ri == "buffer" || Ri == "byteLength" || Ri == "byteOffset") || // Skip index properties.
      _u(Ri, ea)) || nr.push(Ri);
    return nr;
  }
  function sa(ue, De, qe) {
    (qe !== void 0 && !Hu(ue[De], qe) || qe === void 0 && !(De in ue)) && tr(ue, De, qe);
  }
  function gi(ue, De, qe) {
    var Xt = ue[De];
    (!(fn.call(ue, De) && Hu(Xt, qe)) || qe === void 0 && !(De in ue)) && tr(ue, De, qe);
  }
  function Cs(ue, De) {
    for (var qe = ue.length; qe--; )
      if (Hu(ue[qe][0], De))
        return qe;
    return -1;
  }
  function tr(ue, De, qe) {
    De == "__proto__" && Qn ? Qn(ue, De, {
      configurable: !0,
      enumerable: !0,
      value: qe,
      writable: !0
    }) : ue[De] = qe;
  }
  var Ra = Ln();
  function Eo(ue) {
    return ue == null ? ue === void 0 ? G : N : Cn && Cn in Object(ue) ? ai(ue) : oh(ue);
  }
  function Vn(ue) {
    return lo(ue) && Eo(ue) == c;
  }
  function Gs(ue) {
    if (!oi(ue) || ts(ue))
      return !1;
    var De = Vr(ue) ? Kn : ye;
    return De.test(In(ue));
  }
  function jf(ue) {
    return lo(ue) && m1(ue.length) && !!se[Eo(ue)];
  }
  function Ff(ue) {
    if (!oi(ue))
      return Mc(ue);
    var De = Ar(ue), qe = [];
    for (var Xt in ue)
      Xt == "constructor" && (De || !fn.call(ue, Xt)) || qe.push(Xt);
    return qe;
  }
  function zu(ue, De, qe, Xt, sr) {
    ue !== De && Ra(De, function(Ur, ha) {
      if (sr || (sr = new Vt()), oi(Ur))
        ws(ue, De, ha, qe, zu, Xt, sr);
      else {
        var nr = Xt ? Xt(vr(ue, ha), Ur, ha + "", ue, De, sr) : void 0;
        nr === void 0 && (nr = Ur), sa(ue, ha, nr);
      }
    }, ih);
  }
  function ws(ue, De, qe, Xt, sr, Ur, ha) {
    var nr = vr(ue, qe), ea = vr(De, qe), Ri = ha.get(ea);
    if (Ri) {
      sa(ue, qe, Ri);
      return;
    }
    var Mi = Ur ? Ur(nr, ea, qe + "", ue, De, ha) : void 0, $l = Mi === void 0;
    if ($l) {
      var Dc = ns(ea), sh = !Dc && so(ea), as = !Dc && !sh && lv(ea);
      Mi = ea, Dc || sh || as ? ns(nr) ? Mi = nr : Vf(nr) ? Mi = xa(nr) : sh ? ($l = !1, Mi = ah(ea)) : as ? ($l = !1, Mi = qn(ea)) : Mi = [] : Wu(ea) || Ua(ea) ? (Mi = nr, Ua(nr) ? Mi = Ld(nr) : (!oi(nr) || Vr(nr)) && (Mi = yi(ea))) : $l = !1;
    }
    $l && (ha.set(ea, Mi), sr(Mi, ea, Xt, Ur, ha), ha.delete(ea)), sa(ue, qe, Mi);
  }
  function Bf(ue, De) {
    return Cu(Dd(ue, De, $d), ue + "");
  }
  var Oi = Qn ? function(ue, De) {
    return Qn(ue, "toString", {
      configurable: !0,
      enumerable: !1,
      value: Uf(De),
      writable: !0
    });
  } : $d;
  function ah(ue, De) {
    return ue.slice();
  }
  function Pt(ue) {
    var De = new ue.constructor(ue.byteLength);
    return new ei(De).set(new ei(ue)), De;
  }
  function qn(ue, De) {
    var qe = Pt(ue.buffer);
    return new ue.constructor(qe, ue.byteOffset, ue.length);
  }
  function xa(ue, De) {
    var qe = -1, Xt = ue.length;
    for (De || (De = Array(Xt)); ++qe < Xt; )
      De[qe] = ue[qe];
    return De;
  }
  function $r(ue, De, qe, Xt) {
    var sr = !qe;
    qe || (qe = {});
    for (var Ur = -1, ha = De.length; ++Ur < ha; ) {
      var nr = De[Ur], ea = void 0;
      ea === void 0 && (ea = ue[nr]), sr ? tr(qe, nr, ea) : gi(qe, nr, ea);
    }
    return qe;
  }
  function Qa(ue) {
    return Bf(function(De, qe) {
      var Xt = -1, sr = qe.length, Ur = sr > 1 ? qe[sr - 1] : void 0, ha = sr > 2 ? qe[2] : void 0;
      for (Ur = ue.length > 3 && typeof Ur == "function" ? (sr--, Ur) : void 0, ha && Ss(qe[0], qe[1], ha) && (Ur = sr < 3 ? void 0 : Ur, sr = 1), De = Object(De); ++Xt < sr; ) {
        var nr = qe[Xt];
        nr && ue(De, nr, Xt, Ur);
      }
      return De;
    });
  }
  function Ln(ue) {
    return function(De, qe, Xt) {
      for (var sr = -1, Ur = Object(De), ha = Xt(De), nr = ha.length; nr--; ) {
        var ea = ha[++sr];
        if (qe(Ur[ea], ea, Ur) === !1)
          break;
      }
      return De;
    };
  }
  function Io(ue, De) {
    var qe = ue.__data__;
    return xs(De) ? qe[typeof De == "string" ? "string" : "hash"] : qe.map;
  }
  function io(ue, De) {
    var qe = ut(ue, De);
    return Gs(qe) ? qe : void 0;
  }
  function ai(ue) {
    var De = fn.call(ue, Cn), qe = ue[Cn];
    try {
      ue[Cn] = void 0;
      var Xt = !0;
    } catch (Ur) {
    }
    var sr = Wt.call(ue);
    return Xt && (De ? ue[Cn] = qe : delete ue[Cn]), sr;
  }
  function yi(ue) {
    return typeof ue.constructor == "function" && !Ar(ue) ? xr(tt(ue)) : {};
  }
  function _u(ue, De) {
    var qe = typeof ue;
    return De = De == null ? s : De, !!De && (qe == "number" || qe != "symbol" && ce.test(ue)) && ue > -1 && ue % 1 == 0 && ue < De;
  }
  function Ss(ue, De, qe) {
    if (!oi(qe))
      return !1;
    var Xt = typeof De;
    return (Xt == "number" ? rs(qe) && _u(De, qe.length) : Xt == "string" && De in qe) ? Hu(qe[De], ue) : !1;
  }
  function xs(ue) {
    var De = typeof ue;
    return De == "string" || De == "number" || De == "symbol" || De == "boolean" ? ue !== "__proto__" : ue === null;
  }
  function ts(ue) {
    return !!At && At in ue;
  }
  function Ar(ue) {
    var De = ue && ue.constructor, qe = typeof De == "function" && De.prototype || dn;
    return ue === qe;
  }
  function Mc(ue) {
    var De = [];
    if (ue != null)
      for (var qe in Object(ue))
        De.push(qe);
    return De;
  }
  function oh(ue) {
    return Wt.call(ue);
  }
  function Dd(ue, De, qe) {
    return De = oo(De === void 0 ? ue.length - 1 : De, 0), function() {
      for (var Xt = arguments, sr = -1, Ur = oo(Xt.length - De, 0), ha = Array(Ur); ++sr < Ur; )
        ha[sr] = Xt[De + sr];
      sr = -1;
      for (var nr = Array(De + 1); ++sr < De; )
        nr[sr] = Xt[sr];
      return nr[De] = qe(ha), He(ue, this, nr);
    };
  }
  function vr(ue, De) {
    if (!(De === "constructor" && typeof ue[De] == "function") && De != "__proto__")
      return ue[De];
  }
  var Cu = vl(Oi);
  function vl(ue) {
    var De = 0, qe = 0;
    return function() {
      var Xt = Lr(), sr = o - (Xt - qe);
      if (qe = Xt, sr > 0) {
        if (++De >= a)
          return arguments[0];
      } else
        De = 0;
      return ue.apply(void 0, arguments);
    };
  }
  function In(ue) {
    if (ue != null) {
      try {
        return qt.call(ue);
      } catch (De) {
      }
      try {
        return ue + "";
      } catch (De) {
      }
    }
    return "";
  }
  function Hu(ue, De) {
    return ue === De || ue !== ue && De !== De;
  }
  var Ua = Vn(/* @__PURE__ */ function() {
    return arguments;
  }()) ? Vn : function(ue) {
    return lo(ue) && fn.call(ue, "callee") && !rn.call(ue, "callee");
  }, ns = Array.isArray;
  function rs(ue) {
    return ue != null && m1(ue.length) && !Vr(ue);
  }
  function Vf(ue) {
    return lo(ue) && rs(ue);
  }
  var so = er || jd;
  function Vr(ue) {
    if (!oi(ue))
      return !1;
    var De = Eo(ue);
    return De == b || De == S || De == f || De == O;
  }
  function m1(ue) {
    return typeof ue == "number" && ue > -1 && ue % 1 == 0 && ue <= s;
  }
  function oi(ue) {
    var De = typeof ue;
    return ue != null && (De == "object" || De == "function");
  }
  function lo(ue) {
    return ue != null && typeof ue == "object";
  }
  function Wu(ue) {
    if (!lo(ue) || Eo(ue) != R)
      return !1;
    var De = tt(ue);
    if (De === null)
      return !0;
    var qe = fn.call(De, "constructor") && De.constructor;
    return typeof qe == "function" && qe instanceof qe && qt.call(qe) == Xr;
  }
  var lv = be ? it(be) : jf;
  function Ld(ue) {
    return $r(ue, ih(ue));
  }
  function ih(ue) {
    return rs(ue) ? Qr(ue) : Ff(ue);
  }
  var v1 = Qa(function(ue, De, qe) {
    zu(ue, De, qe);
  });
  function Uf(ue) {
    return function() {
      return ue;
    };
  }
  function $d(ue) {
    return ue;
  }
  function jd() {
    return !1;
  }
  e.exports = v1;
})(O7, O7.exports);
var Cye = O7.exports;
const HQ = /* @__PURE__ */ Mt(Cye);
function dT(e) {
  this.message = e;
}
dT.prototype = new Error(), dT.prototype.name = "InvalidCharacterError";
var AV = typeof window != "undefined" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new dT("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var n, r, a = 0, o = 0, s = ""; r = t.charAt(o++); ~r && (n = a % 4 ? 64 * n + r : r, a++ % 4) ? s += String.fromCharCode(255 & n >> (-2 * a & 6)) : 0) r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r);
  return s;
};
function wye(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(n) {
      return decodeURIComponent(AV(n).replace(/(.)/g, function(r, a) {
        var o = a.charCodeAt(0).toString(16).toUpperCase();
        return o.length < 2 && (o = "0" + o), "%" + o;
      }));
    }(t);
  } catch (n) {
    return AV(t);
  }
}
function R7(e) {
  this.message = e;
}
function qi(e, t) {
  if (typeof e != "string") throw new R7("Invalid token specified");
  var n = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(wye(e.split(".")[n]));
  } catch (r) {
    throw new R7("Invalid token specified: " + r.message);
  }
}
R7.prototype = new Error(), R7.prototype.name = "InvalidTokenError";
const t4 = {
  DEVELOPMENT: "",
  STAGING: "https://hc0f1jaa70.execute-api.eu-west-1.amazonaws.com/staging",
  SANDBOX: "https://mediastoreapi-sandbox.cleeng.com",
  PRODUCTION: "https://mediastoreapi.cleeng.com"
}, or = () => {
  switch (En("CLEENG_ENVIRONMENT")) {
    case "development":
      return t4.DEVELOPMENT;
    case "staging":
      return t4.STAGING;
    case "sandbox":
      return t4.SANDBOX;
    case "production":
      return t4.PRODUCTION;
    default:
      return t4.SANDBOX;
  }
}, TR = () => st(void 0, null, function* () {
  const e = or(), { customerId: t } = qi(En("CLEENG_AUTH_TOKEN")), n = `${e}/customers/${t}/capture/status`;
  return Mr(n, {
    method: "GET"
  }).then((r) => r.json());
}), l2 = () => st(void 0, null, function* () {
  const e = or(), { customerId: t } = qi(En("CLEENG_AUTH_TOKEN")), n = `${e}/customers/${t}/consents`;
  return Mr(n, {
    method: "GET"
  }).then((r) => r.json());
});
class Sye {
  constructor() {
    this.isAuthenticated = !1, this.myAccount = {
      mainPage: "/my-account/plan-details",
      loginPage: "/my-account/login"
    }, this.checkout = {
      mainPage: "/offer",
      loginPage: "/login"
    }, this.capturePage = "/capture", this.consentsPage = "/consents";
  }
  login(t = !1, n = !1, r, a, o, s = (f) => f, c = [], u = (f) => f) {
    this.isAuthenticated = !0;
    const { customerId: f } = qi(a);
    Ba("CLEENG_CUSTOMER_ID", f), Ba("CLEENG_AUTH_TOKEN", a), Ba("CLEENG_REFRESH_TOKEN", o), Ba("CLEENG_CUSTOMER_EMAIL", r), s && s.apply(this, c);
    const m = t ? this.myAccount.mainPage : this.checkout.mainPage;
    let v = !1, y = !1, b = {};
    const S = l2().then((E) => {
      const { consents: N } = E.responseData;
      v = n ? !1 : N.some(
        (R) => R.newestVersion > R.version || R.needsUpdate === !0
      );
    }), x = TR().then((E) => {
      E.responseData.shouldCaptureBeDisplayed === !0 && (y = !0, b = Xn(Fe({}, b), {
        settings: E.responseData.settings
      }));
    });
    Promise.allSettled([S, x]).then(() => {
      b = Xn(Fe({}, b), {
        redirectUrl: [
          y ? this.capturePage : null,
          v ? this.consentsPage : null,
          m
        ].filter(Boolean)
      });
    }), u();
  }
  logout(t = (n) => n) {
    this.isAuthenticated = !1, Pl("CLEENG_AUTH_TOKEN"), Pl("CLEENG_REFRESH_TOKEN"), Pl("CLEENG_ORDER_ID"), Pl("CLEENG_CHECKOUT_PP_SUCCESS"), Pl("CLEENG_CHECKOUT_PP_CANCEL"), Pl("CLEENG_CHECKOUT_PP_ERROR"), Pl("CLEENG_MYACCOUNT_PP_SUCCESS"), Pl("CLEENG_MYACCOUNT_PP_CANCEL"), Pl("CLEENG_MYACCOUNT_PP_ERROR"), Pl("CLEENG_CUSTOMER_EMAIL"), Pl("CLEENG_CUSTOMER_ID"), Pl("CLEENG_ENVIRONMENT"), Pl("CLEENG_PUBLISHER_ID"), t();
  }
  isLogged() {
    const t = En("CLEENG_AUTH_TOKEN"), n = En("CLEENG_REFRESH_TOKEN");
    if (!t)
      return this.isAuthenticated = !!n, this.isAuthenticated;
    const r = qi(t);
    return Date.now() / 1e3 > r.exp && !n ? this.logout() : this.isAuthenticated = !0, this.isAuthenticated;
  }
}
const Ec = new Sye(), ur = (e, t) => {
  window.dispatchEvent(
    new CustomEvent(e, {
      detail: t
    })
  );
}, M7 = "MSSDK:purchase-successful", WQ = "MSSDK:purchase-failed", xye = "MSSDK:Adyen-error", fT = "MSSDK:update-payment-details-successful", pT = "MSSDK:update-payment-details-failed", Eye = "MSSDK:remove-payment-details-button-clicked", Iye = "MSSDK:redeem-button-clicked", kye = "MSSDK:redeem-coupon-button-clicked", Aye = "MSSDK:redeem-coupon-success", Pye = "MSSDK:redeem-coupon-failed", Nye = "MSSDK:Purchase-loaded", Tye = "MSSDK:edit-payment-button-clicked", OR = "MSSDK:switch-popup-action-successful", D7 = "MSSDK:switch-popup-action-failed", Oye = "MSSDK:cancel-switch-action-triggered", Rye = "MSSDK:cancel-switch-action-successful", PV = "MSSDK:cancel-switch-action-failed", Mye = "MSSDK:cancel-switch-action-cancelled", Dye = "MSSDK:cancel-switch-button-clicked", Lye = "MSSDK:switch-button-clicked", i_ = "MSSDK:auth-failed", $ye = "MSSDK:good-news-page", jye = "MSSDK:payment-page", Fye = "MSSDK:unsubscribe-action-confirmed", Z6 = "5.5.5", ZQ = "CLEENG_AUTH_TOKEN", YQ = "CLEENG_REFRESH_TOKEN", Bye = "CLEENG_ENVIRONMENT", XQ = () => En(ZQ), Vye = () => En(YQ), RR = () => En(Bye);
let _4 = !1, NV = !1;
const Uye = () => {
  const e = XQ();
  if (e) {
    const t = qi(e);
    return Date.now() / 1e3 > t.exp;
  }
  return !0;
}, Gye = () => st(void 0, null, function* () {
  const e = or(), t = RR();
  _4 = !0;
  const r = yield (yield fetch(`${e}/auths/refresh_token`, {
    method: "POST",
    body: JSON.stringify({ refreshToken: En("CLEENG_REFRESH_TOKEN") }),
    headers: Fe({
      Accept: "application/json",
      "Content-Type": "application/json"
    }, t === "production" && {
      "X-Requested-By": `mediastore-sdk@${Z6}`
    })
  })).json();
  Ba(ZQ, r.responseData.jwt), Ba(YQ, r.responseData.refreshToken);
}), TV = (e, t) => {
  const n = XQ(), r = RR();
  let a = t;
  return n != null && (a = HQ({}, t, {
    headers: Fe({
      Authorization: `Bearer ${n}`,
      Accept: "application/json",
      "Content-Type": "application/json"
    }, r === "production" && {
      "X-Requested-By": `mediastore-sdk@${Z6}`
    })
  })), window.fetch(e, a);
}, Mr = (n, ...r) => st(void 0, [n, ...r], function* (e, t = {}) {
  const a = Uye(), o = Vye();
  if (a && !o && (ur(i_), Ec.logout()), a && o)
    if (!_4)
      yield Gye().then(() => {
        _4 = !1;
      }).catch(() => (_4 = !1, NV = !0, ur(i_), Ec.logout(), new Promise((s, c) => c())));
    else
      return new Promise((s, c) => {
        const u = () => {
          if (NV) {
            c();
            return;
          }
          if (!_4) {
            s(TV(e, t));
            return;
          }
          setTimeout(() => {
            u();
          }, 500);
        };
        u();
      });
  return TV(e, t);
}), Y6 = (n, ...r) => st(void 0, [n, ...r], function* (e, t = {}) {
  const a = RR(), o = HQ({}, t, {
    headers: Fe({
      Accept: "application/json",
      "Content-Type": "application/json"
    }, a === "production" && {
      "X-Requested-By": `mediastore-sdk@${Z6}`
    })
  });
  return window.fetch(e, o);
}), zye = (e, t) => {
  const n = or(), { customerId: r } = qi(
    En("CLEENG_AUTH_TOKEN")
  ), a = `${n}/orders`;
  return Mr(a, {
    method: "POST",
    body: JSON.stringify({
      offerId: e,
      customerId: r,
      paymentMethodId: 0,
      buyAsAGift: t
    })
  }).then((o) => st(void 0, null, function* () {
    const { responseData: s, errors: c } = yield o.json();
    if (!o.ok)
      throw new Error(c[0]);
    return s;
  })).catch((o) => {
    throw new Error(o);
  });
}, L7 = () => {
  const e = or(), { customerId: t } = qi(En("CLEENG_AUTH_TOKEN")), n = `${e}/customers/${t}`;
  return Mr(n, {
    method: "GET"
  }).then((r) => r.json());
}, Hye = (e) => st(void 0, null, function* () {
  const t = or();
  let n = En("CLEENG_CUSTOMER_EMAIL") || null;
  if (!n) {
    const a = yield L7();
    a.responseData && (n = a.responseData.email);
  }
  const r = `${t}/offers/${e}/customers/${n}`;
  return Y6(r, {}).then((a) => st(void 0, null, function* () {
    const { responseData: o, errors: s } = yield a.json();
    if (!a.ok)
      throw new Error(s[0]);
    return o;
  })).catch((a) => {
    throw new Error(a);
  });
}), Wye = (e, t, n) => st(void 0, null, function* () {
  const a = `${or()}/auths`;
  try {
    const o = yield Y6(a, {
      method: "POST",
      body: JSON.stringify(Fe({
        email: e,
        password: t
      }, n))
    }), s = yield o.json();
    return Fe({
      status: o.status
    }, s);
  } catch (o) {
    return o;
  }
}), Zye = (e, t, n, r, a, o) => st(void 0, null, function* () {
  const s = `${or()}/customers`;
  try {
    const c = yield Y6(s, {
      method: "POST",
      body: JSON.stringify({
        email: e,
        password: t,
        publisherId: n,
        locale: r,
        country: a,
        currency: o
      })
    }), u = yield c.json();
    return Fe({
      status: c.status
    }, u);
  } catch (c) {
    return c;
  }
}), KQ = (e, t = "", n) => st(void 0, null, function* () {
  const a = `${or()}/customers/passwords`;
  try {
    const o = yield Y6(a, {
      method: "PUT",
      body: JSON.stringify({
        publisherId: t,
        customerEmail: e,
        resetUrl: n
      })
    }), s = yield o.json();
    return s.message ? Xn(Fe({}, s), {
      errors: [s.message]
    }) : Fe({
      status: o.status
    }, s);
  } catch (o) {
    return {
      errors: [o.message]
    };
  }
}), $7 = ({ queryParams: e, isMyAccount: t }) => {
  const {
    publisherConfig: { adyenConfiguration: n }
  } = Mo.getState(), { myaccountReturnUrl: r, checkoutReturnUrl: a } = n != null ? n : {}, o = (s) => {
    const c = new URLSearchParams(e).toString();
    return `${s}${new URL(s).search ? "&" : "?"}${c}`;
  };
  return t && r ? o(r) : !t && a ? o(a) : e ? o(window.location.href) : window.location.href;
}, Yye = (e, t, n) => st(void 0, null, function* () {
  const r = or(), a = parseInt(En("CLEENG_ORDER_ID") || "0", 10), o = `${r}/connectors/adyen/initial-payment`, {
    publisherConfig: { enable3DSRedirectFlow: s }
  } = Mo.getState();
  try {
    return (yield Mr(o, {
      method: "POST",
      body: JSON.stringify({
        orderId: a,
        paymentMethod: e,
        browserInfo: t,
        billingAddress: n,
        origin: window.location.origin,
        returnUrl: $7({ queryParams: { orderId: a } }),
        enable3DSRedirectFlow: s
      })
    })).json();
  } catch (c) {
    return c;
  }
}), Xye = () => st(void 0, null, function* () {
  const e = or(), t = parseInt(En("CLEENG_ORDER_ID") || "0", 10), n = `${e}/payments`;
  return Mr(n, {
    method: "POST",
    body: JSON.stringify({ orderId: t })
  }).then((r) => st(void 0, null, function* () {
    const { responseData: a, errors: o } = yield r.json();
    if (!r.ok)
      throw new Error(o[0]);
    return a;
  })).catch((r) => {
    throw new Error(r);
  });
}), MR = (e, t) => {
  const r = `${or()}/orders/${e}`;
  return Mr(r, {
    method: "PATCH",
    body: JSON.stringify(Fe({}, t))
  }).then((a) => st(void 0, null, function* () {
    const { responseData: o, errors: s } = yield a.json();
    if (!a.ok)
      throw new Error(s[0]);
    return o;
  })).catch((a) => {
    throw new Error(a);
  });
}, Kye = () => st(void 0, null, function* () {
  const e = or(), { customerId: t } = qi(
    En("CLEENG_AUTH_TOKEN")
  ), n = `${e}/customers/${t}/payment_details`;
  return Mr(n, {
    method: "GET"
  }).then((r) => st(void 0, null, function* () {
    const { responseData: a, errors: o } = yield r.json();
    if (!r.ok)
      throw new Error(o[0]);
    return a;
  })).catch((r) => {
    throw new Error(r);
  });
}), qye = () => st(void 0, null, function* () {
  const e = or(), { customerId: t } = qi(
    En("CLEENG_AUTH_TOKEN")
  ), n = `${e}/customers/${t}/offers`;
  return Mr(n, {
    method: "GET"
  }).then((r) => st(void 0, null, function* () {
    const { responseData: a, errors: o } = yield r.json();
    if (!r.ok)
      throw new Error(o[0]);
    return a;
  })).catch((r) => {
    throw new Error(r);
  });
}), Jye = (e = 50, t = 0) => st(void 0, null, function* () {
  const n = or(), { customerId: r } = qi(
    En("CLEENG_AUTH_TOKEN")
  ), a = `${n}/customers/${r}/transactions?limit=${e}&offset=${t}`;
  return Mr(a, {
    method: "GET"
  }).then((o) => st(void 0, null, function* () {
    const { responseData: s, errors: c } = yield o.json();
    if (!o.ok)
      throw new Error(c[0]);
    return s;
  })).catch((o) => {
    throw new Error(o);
  });
}), Qye = () => st(void 0, null, function* () {
  const e = or(), t = parseInt(En("CLEENG_ORDER_ID") || "0", 10), n = `${e}/connectors/paypal/v1/tokens`, r = {
    successUrl: En("CLEENG_CHECKOUT_PP_SUCCESS") || `${window.location.origin}/thankyou`,
    cancelUrl: En("CLEENG_CHECKOUT_PP_CANCEL") || `${window.location.origin}/offer`,
    errorUrl: En("CLEENG_CHECKOUT_PP_ERROR") || `${window.location.origin}/offer`
  };
  try {
    return (yield Mr(n, {
      method: "POST",
      body: JSON.stringify(Fe({ orderId: t }, r))
    })).json();
  } catch (a) {
    return a;
  }
}), e2e = (e) => st(void 0, null, function* () {
  const t = or(), { customerId: n } = qi(En("CLEENG_AUTH_TOKEN")), r = `${t}/customers/${n}/subscription_switches/${e}/availability`;
  return Mr(r, {
    method: "GET"
  }).then((a) => st(void 0, null, function* () {
    const { responseData: o, errors: s } = yield a.json();
    if (!a.ok)
      throw new Error(s[0]);
    return o;
  })).catch((a) => {
    throw new Error(a);
  });
}), DR = (e, t, n) => st(void 0, null, function* () {
  const r = or(), { customerId: a } = qi(En("CLEENG_AUTH_TOKEN")), o = `${r}/customers/${a}/subscription_switches/${e}`;
  return Mr(o, {
    method: "POST",
    body: JSON.stringify({
      toOfferId: t,
      switchDirection: n
    })
  }).then((s) => s.json());
}), t2e = (e, t) => st(void 0, null, function* () {
  const n = or(), { customerId: r } = qi(En("CLEENG_AUTH_TOKEN")), a = `${n}/customers/${r}/subscriptions/${e}`, o = yield Mr(a, {
    method: "PATCH",
    body: JSON.stringify({ couponCode: t })
  }), s = yield o.json();
  return Fe({
    status: o.status
  }, s);
}), X6 = (e) => st(void 0, null, function* () {
  const t = or(), { customerId: n } = qi(En("CLEENG_AUTH_TOKEN")), r = `${t}/customers/${n}/capture`, a = {
    firstName: e.firstName || null,
    lastName: e.lastName || null,
    address: e.address || null,
    address2: e.address2 || null,
    city: e.city || null,
    state: e.state || null,
    postCode: e.postCode || null,
    country: e.country || null,
    email: e.email || null,
    birthDate: e.birthDate || null,
    companyName: e.companyName || null,
    phoneNumber: e.phoneNumber || null,
    customAnswers: e.customAnswers || null
  }, o = yield Mr(r, {
    method: "PUT",
    body: JSON.stringify(a)
  }), s = yield o.json();
  return Fe({
    status: o.status
  }, s);
}), K6 = (e, t, n = null) => st(void 0, null, function* () {
  const r = or(), { customerId: a } = qi(En("CLEENG_AUTH_TOKEN")), o = `${r}/customers/${a}/consents`;
  let s;
  n ? s = n : s = t.map((c, u) => ({
    name: c.name,
    version: c.version,
    state: e[u] ? "accepted" : "declined"
  }));
  try {
    return yield (yield Mr(o, {
      method: "PUT",
      body: JSON.stringify({ consents: s })
    })).json();
  } catch (c) {
    return {
      errors: [c.message]
    };
  }
}), j7 = () => {
  const e = or();
  return Mr(`${e}/payment-methods`, {
    method: "GET"
  }).then((t) => t.json());
}, n2e = (e) => {
  const t = or();
  return fetch(`${t}/publishers/${e}/consents`, {
    method: "GET"
  }).then((n) => st(void 0, null, function* () {
    const { responseData: r, errors: a } = yield n.json();
    if (!n.ok)
      throw new Error(a[0]);
    return r;
  })).catch((n) => {
    throw new Error(n);
  });
}, r2e = (e) => {
  const n = `${or()}/orders/${e}`;
  return Mr(n, {
    method: "GET"
  }).then((r) => st(void 0, null, function* () {
    const { responseData: a, errors: o } = yield r.json();
    if (!r.ok)
      throw new Error(o[0]);
    return a;
  })).catch((r) => {
    throw new Error(r);
  });
}, qQ = (e) => {
  const n = `${or()}/subscription_switches/${e}`;
  return Mr(n, {
    method: "PATCH",
    body: JSON.stringify({ status: "cancelled" })
  }).then((r) => r.json());
}, a2e = (e) => st(void 0, null, function* () {
  const n = `${or()}/subscription_switches/${e}`;
  return Mr(n, {
    method: "GET"
  }).then((r) => st(void 0, null, function* () {
    const { responseData: a, errors: o } = yield r.json();
    if (!r.ok)
      throw new Error(o[0]);
    return a;
  })).catch((r) => {
    throw new Error(r);
  });
}), o2e = (e) => st(void 0, null, function* () {
  const n = `${or()}/connectors/paypal/v1/payment_details/tokens`, r = {
    successUrl: En("CLEENG_MYACCOUNT_PP_SUCCESS") ? `${En("CLEENG_MYACCOUNT_PP_SUCCESS")}` : `${window.location.origin}/my-account/payment-info`,
    cancelUrl: En("CLEENG_MYACCOUNT_PP_CANCEL") || `${window.location.origin}/my-account/payment-info`,
    errorUrl: En("CLEENG_MYACCOUNT_PP_ERROR") || `${window.location.origin}/my-account/payment-info`
  };
  try {
    return (yield Mr(n, {
      method: "POST",
      body: JSON.stringify(Xn(Fe({}, r), { paymentMethodId: e }))
    })).json();
  } catch (a) {
    return a;
  }
}), i2e = (e, t) => st(void 0, null, function* () {
  const r = `${or()}/connectors/adyen/initial-payment/finalize`;
  return Mr(r, {
    method: "POST",
    body: JSON.stringify({
      orderId: e,
      details: t
    })
  }).then((a) => st(void 0, null, function* () {
    const { responseData: o, errors: s } = yield a.json();
    if (!a.ok)
      throw new Error(s[0]);
    return o;
  })).catch((a) => {
    throw new Error(a);
  });
}), s2e = (e, t) => st(void 0, null, function* () {
  const r = `${or()}/connectors/adyen/payment-details/finalize`;
  return Mr(r, {
    method: "POST",
    body: JSON.stringify({
      details: t,
      paymentMethodId: e
    })
  }).then((a) => st(void 0, null, function* () {
    const { responseData: o, errors: s } = yield a.json();
    if (!a.ok)
      throw new Error(s[0]);
    return o;
  })).catch((a) => {
    throw new Error(a);
  });
}), l2e = () => st(void 0, null, function* () {
  const t = `${or()}/offers?pageLimit=100`;
  return Mr(t, {
    method: "GET"
  }).then((n) => st(void 0, null, function* () {
    const { responseData: r, errors: a } = yield n.json();
    if (!n.ok)
      throw new Error(a[0]);
    return r;
  })).catch((n) => {
    throw new Error(n);
  });
}), u2e = (e) => st(void 0, null, function* () {
  const n = `${or()}/v2/offers/${e}`;
  return Mr(n, {
    method: "GET"
  }).then((r) => st(void 0, null, function* () {
    const { responseData: a, errors: o } = yield r.json();
    if (!r.ok)
      throw new Error(o[0]);
    return a;
  })).catch((r) => {
    throw new Error(r);
  });
}), c2e = (e) => st(void 0, null, function* () {
  const n = `${or()}/gifts/${e}`;
  return Mr(n, {
    method: "GET"
  }).then((r) => st(void 0, null, function* () {
    const { responseData: a, errors: o } = yield r.json();
    if (!r.ok)
      throw new Error(o[0]);
    return a;
  })).catch((r) => {
    throw new Error(r);
  });
}), d2e = (e, t) => {
  const r = `${or()}/gifts/${e}`;
  return Mr(r, {
    method: "PATCH",
    body: JSON.stringify(Fe({}, t))
  }).then((a) => st(void 0, null, function* () {
    const { responseData: o, errors: s } = yield a.json();
    if (!a.ok)
      throw new Error(s[0]);
    return o;
  })).catch((a) => {
    throw new Error(a);
  });
}, f2e = (e) => st(void 0, null, function* () {
  const n = `${or()}/gifts/verification/${e}`;
  return Mr(n, {
    method: "GET"
  }).then((r) => st(void 0, null, function* () {
    const { responseData: a, errors: o } = yield r.json();
    if (!r.ok)
      throw new Error(o[0]);
    return a;
  })).catch((r) => {
    throw new Error(r);
  });
}), p2e = (e) => st(void 0, null, function* () {
  const n = `${or()}/gifts/redeem/${e}`;
  return Mr(n, {
    method: "POST"
  }).then((r) => st(void 0, null, function* () {
    const { responseData: a, errors: o } = yield r.json();
    if (!r.ok)
      throw new Error(o[0]);
    return a;
  })).catch((r) => {
    throw new Error(r);
  });
}), h2e = (e) => st(void 0, null, function* () {
  const n = `${or()}/customers/retention_actions/${e}`;
  return Mr(n, {
    method: "GET"
  }).then((r) => st(void 0, null, function* () {
    const { responseData: a, errors: o } = yield r.json();
    if (!r.ok)
      throw new Error(o[0]);
    return a;
  })).catch((r) => {
    throw new Error(r);
  });
}), m2e = (e) => st(void 0, null, function* () {
  const n = `${or()}/customers/retention_actions`;
  return Mr(n, {
    method: "POST",
    body: JSON.stringify({
      offerId: e
    })
  }).then((r) => st(void 0, null, function* () {
    const { responseData: a, errors: o } = yield r.json();
    if (!r.ok)
      throw new Error(o[0]);
    return a;
  })).catch((r) => {
    throw new Error(r);
  });
}), v2e = {
  loading: !1,
  paymentDetails: null,
  error: null
}, T4 = Do(
  "finalizeAddPaymentDetails",
  (a, o) => st(void 0, [a, o], function* ({ paymentMethodId: e, details: t }, { getState: n, rejectWithValue: r }) {
    const {
      paymentMethods: { selectedPaymentMethod: s }
    } = n();
    try {
      const { paymentDetails: c } = yield s2e(
        e || (s == null ? void 0 : s.id),
        t
      );
      return c;
    } catch (c) {
      return r(c.message);
    }
  })
), g2e = hs({
  name: "finalizeAddPaymentDetails",
  initialState: v2e,
  extraReducers: (e) => {
    e.addCase(T4.pending, (t) => {
      t.loading = !0;
    }), e.addCase(
      T4.fulfilled,
      (t, { payload: n }) => {
        t.loading = !1, t.paymentDetails = n, t.error = null, ur(fT, {
          payload: n
        });
      }
    ), e.addCase(
      T4.rejected,
      (t, { payload: n }) => {
        t.loading = !1, t.error = n, ur(pT, {
          payload: n
        });
      }
    );
  }
}), y2e = g2e.reducer, b2e = {
  loading: !1,
  payment: {
    paymentMethod: null,
    currency: null
  },
  error: null,
  shouldShowFinalizePaymentComponent: !1
}, O4 = Do(
  "finalizeInitialPayment",
  (r, a) => st(void 0, [r, a], function* ({ orderId: e, details: t }, { rejectWithValue: n }) {
    try {
      const { payment: o } = yield i2e(e, t);
      return o;
    } catch (o) {
      return n(o.message);
    }
  })
), JQ = hs({
  name: "finalizeInitialPayment",
  initialState: b2e,
  reducers: (e) => ({
    setShouldShowFinalizePaymentComponent: e.reducer(
      (t, n) => {
        t.shouldShowFinalizePaymentComponent = n.payload;
      }
    )
  }),
  extraReducers: (e) => {
    e.addCase(O4.pending, (t) => {
      t.loading = !0;
    }), e.addCase(
      O4.fulfilled,
      (t, { payload: n }) => {
        t.loading = !1, t.error = null, t.payment = n, t.shouldShowFinalizePaymentComponent = !0, ur(M7, {
          payload: n
        });
      }
    ), e.addCase(
      O4.rejected,
      (t, { payload: n }) => {
        t.loading = !1, n && (t.error = n), t.shouldShowFinalizePaymentComponent = !0, ur(WQ, {
          payload: n
        });
      }
    );
  }
}), _2e = (e) => e.finalizeInitialPayment, { setShouldShowFinalizePaymentComponent: hT } = JQ.actions, C2e = JQ.reducer, w2e = {
  gift: {},
  verifiedGift: {},
  loading: !1,
  error: null,
  isUpdateLoading: !1,
  isVerifyLoading: !1,
  isRedeemLoading: !1
}, Dx = Do("gift/fetchGift", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    return yield c2e(e);
  } catch (a) {
    return t(a.message);
  }
})), Lx = Do("gift/updateGift", (r, a) => st(void 0, [r, a], function* ({ id: e, payload: t }, { rejectWithValue: n }) {
  try {
    return yield d2e(e, t);
  } catch (o) {
    return n(o.message);
  }
})), $x = Do("gift/verifyGift", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    return yield f2e(e);
  } catch (a) {
    return t(a.message);
  }
})), jx = Do("gift/redeemGift", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    return yield p2e(e);
  } catch (a) {
    return t(a.message);
  }
})), S2e = hs({
  name: "gift",
  initialState: w2e,
  reducers: () => ({}),
  extraReducers: (e) => {
    e.addCase(Dx.pending, (t) => {
      t.loading = !0;
    }), e.addCase(Dx.fulfilled, (t, n) => {
      t.loading = !1, t.gift = n.payload;
    }), e.addCase(Dx.rejected, (t, n) => {
      t.loading = !1, n.payload && (t.error = n.payload);
    }), e.addCase(Lx.pending, (t) => {
      t.isUpdateLoading = !0;
    }), e.addCase(Lx.fulfilled, (t, n) => {
      t.isUpdateLoading = !1, t.gift = n.payload;
    }), e.addCase(Lx.rejected, (t, n) => {
      t.isUpdateLoading = !1, n.payload && (t.error = n.payload);
    }), e.addCase($x.pending, (t) => {
      t.isVerifyLoading = !0;
    }), e.addCase($x.fulfilled, (t, n) => {
      t.isVerifyLoading = !1, t.error = "", t.verifiedGift = n.payload;
    }), e.addCase($x.rejected, (t, n) => {
      t.isVerifyLoading = !1, t.verifiedGift = {}, n.payload && (t.error = "Provided gift code is invalid. Please provide a valid code and try again.");
    }), e.addCase(jx.pending, (t) => {
      t.isRedeemLoading = !0;
    }), e.addCase(jx.fulfilled, (t) => {
      t.isRedeemLoading = !1;
    }), e.addCase(jx.rejected, (t, n) => {
      t.isRedeemLoading = !1, n.payload && (t.error = n.payload);
    });
  }
}), q6 = (e) => e.gift, x2e = S2e.reducer, Nm = {
  editPassword: "editPassword",
  paymentDetails: "paymentDetails",
  updateSubscription: "updateSubscription",
  switchPlan: "switchPlan",
  cancelSwitch: "cancelSwitch",
  cancelPause: "cancelPause",
  resumeSubscription: "resumeSubscription"
}, QQ = "SHOW_INNER_POPUP", E2e = cl(QQ), eee = "HIDE_INNER_POPUP", I2e = cl(eee), k2e = {
  isOpen: !1,
  type: "",
  data: {}
}, A2e = k_(k2e, (e) => {
  e.addCase(QQ, (t, n) => {
    t.isOpen = !0, t.type = n.payload.type, t.data = n.payload.data;
  }), e.addCase(eee, (t) => {
    t.isOpen = !1, t.type = "", t.data = {};
  });
}), R4 = {
  planDetails: "planDetails",
  paymentInfo: "paymentInfo",
  updateProfile: "updateProfile"
}, P2e = {
  activeTab: R4.planDetails
}, tee = hs({
  name: "myaccount",
  initialState: P2e,
  reducers: (e) => ({
    setActiveTab: e.reducer((t, { payload: n }) => {
      t.activeTab = n;
    })
  })
}), { setActiveTab: LR } = tee.actions, N2e = tee.reducer, T2e = {
  offer: {},
  offerV2: {},
  loading: !1,
  error: null,
  isOfferFree: !1
}, M4 = Do("offer/fetchOffer", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    return yield Hye(e);
  } catch (a) {
    return t(a.message);
  }
})), D4 = Do("offer/fetchOfferV2", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    return yield u2e(e);
  } catch (a) {
    return t(a.message);
  }
})), nee = hs({
  name: "offer",
  initialState: T2e,
  reducers: (e) => ({
    setFreeOffer: e.reducer((t, n) => {
      t.isOfferFree = n.payload;
    })
  }),
  extraReducers: (e) => {
    e.addCase(M4.pending, (t) => {
      t.loading = !0;
    }), e.addCase(M4.fulfilled, (t, n) => {
      t.loading = !1, t.offer = n.payload;
    }), e.addCase(M4.rejected, (t, n) => {
      t.loading = !1, n.payload && (t.error = n.payload);
    }), e.addCase(D4.pending, (t) => {
      t.loading = !0;
    }), e.addCase(D4.fulfilled, (t, n) => {
      t.loading = !1, t.offerV2 = n.payload;
    }), e.addCase(D4.rejected, (t, n) => {
      t.loading = !1, n.payload && (t.error = n.payload);
    });
  }
}), k2 = (e) => e.offer, A_ = (e) => e.offer.offer, { setFreeOffer: O2e } = nee.actions, R2e = nee.reducer, M2e = {
  offers: [],
  pauseOffers: [],
  pauseOffersIDs: [],
  loading: !1,
  error: null
}, Wy = Do("offers/fetchOffers", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    return yield l2e();
  } catch (a) {
    return t(a.message);
  }
})), D2e = hs({
  name: "offers",
  initialState: M2e,
  reducers: () => ({}),
  extraReducers: (e) => {
    e.addCase(Wy.pending, (t) => {
      t.loading = !0;
    }), e.addCase(Wy.fulfilled, (t, { payload: n }) => {
      t.loading = !1, t.offers = n, t.pauseOffers = n.filter(
        ({ externalProperties: r }) => r.PAUSE_OFFER === "true"
      ), t.pauseOffersIDs = n.filter(
        ({ externalProperties: r }) => r.PAUSE_OFFER === "true"
      ).map((r) => r.longId);
    }), e.addCase(Wy.rejected, (t, { payload: n }) => {
      t.loading = !1, t.error = n;
    });
  }
}), J6 = (e) => e.offers, L2e = D2e.reducer, $2e = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDE2Ij48cGF0aCBkPSJNMTUsMTJhMywzLDAsMSwxLTMtM0EzLDMsMCwwLDEsMTUsMTJabTktLjQ0OVMxOS43NDgsMjAsMTIuMDE1LDIwQzQuODM1LDIwLDAsMTEuNTUxLDAsMTEuNTUxUzQuNDQ2LDQsMTIuMDE1LDRDMTkuNzA5LDQsMjQsMTEuNTUxLDI0LDExLjU1MVpNMTcsMTJhNSw1LDAsMSwwLTUsNUE1LjAwNiw1LjAwNiwwLDAsMCwxNywxMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTQpIi8+PC9zdmc+", j2e = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDIwIj48cGF0aCBkPSJNMTEuODg1LDE0Ljk4OGwzLjEtMy4xTDE1LDEyYTMsMywwLDAsMS0zLDNsLS4xMTUtLjAxMlptOC4wNDgtOC4wMzItMy4yNzQsMy4yNjhBNC45NTIsNC45NTIsMCwwLDEsMTcsMTJhNS4wMDYsNS4wMDYsMCwwLDEtNSw1LDQuOTUxLDQuOTUxLDAsMCwxLTEuNzg1LS4zNDRMNy44MzgsMTkuMDI4QTkuOTI3LDkuOTI3LDAsMCwwLDEyLjAxNSwyMEMxOS43NDgsMjAsMjQsMTEuNTUxLDI0LDExLjU1MWExOC4xLDE4LjEsMCwwLDAtNC4wNjctNC41OTVaTTIxLjM2NCwzLjQyLDIuNzQ1LDIyLDEuMzYzLDIwLjU3OGwzLjQ1NS0zLjQ0N0EyMi41NjksMjIuNTY5LDAsMCwxLDAsMTEuNTUxUzQuNDQ2LDQsMTIuMDE1LDRBMTEuNzI3LDExLjcyNywwLDAsMSwxNi45LDUuMDc1TDE5Ljk4MiwybDEuMzgyLDEuNDJaTTcuNjEzLDE0LjM0MmwxLjUxOS0xLjUxNUEyLjkzOCwyLjkzOCwwLDAsMSw5LDEyYTMsMywwLDAsMSwzLTMsMi45MSwyLjkxLDAsMCwxLC44MzMuMTM0bDEuNTE4LTEuNTE1QTQuOTA2LDQuOTA2LDAsMCwwLDEyLDdhNS4wMDYsNS4wMDYsMCwwLDAtNSw1QTQuOTExLDQuOTExLDAsMCwwLDcuNjEzLDE0LjM0MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTIpIi8+PC9zdmc+", F7 = {
  smallest: 480,
  small: 768,
  medium: 1024,
  average: 1200,
  big: 1280,
  bigger: 1440,
  largest: 1920
}, pr = Object.keys(F7).reduce((e, t) => (e[t] = (n, ...r) => ot`
    @media only screen and (max-width: ${F7[t]}px) {
      ${ot(n, ...r)}
    }
  `, e), {}), Zr = Object.keys(F7).reduce((e, t) => (e[t] = (n, ...r) => ot`
    @media only screen and (min-width: ${F7[t]}px) {
      ${ot(n, ...r)}
    }
  `, e), {}), F2e = W.div`
  display: flex;
  flex-direction: column;
  position: relative;

  padding: 10px;
  width: 100%;
`, ree = W.label.attrs(() => ({
  className: "msd__input__label"
}))`
  position: absolute;
  inset-block-start: 17px;
  inset-inline-start: 14px;

  margin: 0;
  padding-inline: 3px;

  color: ${({ theme: e }) => e.FontColor};
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;

  ${(e) => e.$withIcon && ot`
      inset-inline-start: 40px;
    `}

  &::after {
    position: absolute;
    content: '';
    inset-block-start: 0;
    inset-inline-start: 0;

    width: 100%;
    height: 15px;

    background: ${({ theme: e }) => e.BackgroundColor};

    z-index: -1;
    opacity: 0;
  }

  ${(e) => e.$hasValue && ot`
      transform: translate(0, -25px) scaleY(0.9);
      &::after {
        opacity: 1;
      }
    `}

  ${(e) => e.$hasValue && e.$withIcon && ot`
      transform: translate(-26px, -25px) scaleY(0.9);
    `}
`, B2e = W.div.attrs(() => ({
  className: "msd__input__wrapper"
}))`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  padding: 13px 0 14px;

  background: transparent;
  border: 1px solid #b7bfca;
  transition: 0.2s ease-in-out;

  &:focus-within {
    border-color: ${({ theme: e }) => e.ConfirmColor};
    ${ree} {
      color: ${({ theme: e }) => e.ConfirmColor};
      transform: translate(0, -25px) scaleY(0.9);
      &::after {
        opacity: 1;
      }
    }
  }
`, V2e = W.input.attrs(() => ({
  className: "msd__input"
}))`
  flex-grow: 1;
  position: relative;
  width: auto;

  margin: 0 15px;

  color: ${({ theme: e }) => e.FontColor};
  background: transparent;
  border: none;
  outline: none;

  font-size: 15px;
  line-height: 1.3;

  &:focus + label {
    transform: translate(0, -25px) scaleY(0.9);
    color: ${({ theme: e }) => e.ConfirmColor};
    ${(e) => e.$withIcon && ot`
        transform: translate(-26px, -25px) scaleY(0.9);
      `}
    &::after {
      opacity: 1;
    }
  }

  ${(e) => e.$floatingLabels === !1 && ot`
      & + label {
        transform: translate(0, -25px) scaleY(0.9);
        &::after {
          opacity: 1;
        }
      }
    `}

  ${pr.small`
    width: 100%;
  `}

  ${(e) => e.type === "date" && ot`
      text-transform: uppercase;
      &::-webkit-inner-spin-button,
      &::-webkit-calendar-picker-indicator {
        display: none;
        -webkit-appearance: none;
      }
      & + label {
        transform: translate(-26px, -25px) scaleY(0.9);
        &::after {
          opacity: 1;
        }
      }
    `}
`, aee = W.div.attrs(() => ({
  className: "msd__error"
}))`
  width: 100%;
  height: 13px;
  margin-top: 8px;

  content: '';
  color: ${({ theme: e }) => e.ErrorColor};
  transition: 0.2s ease-in-out;

  ${(e) => e.$passwordStrength && ot`
      color: ${e.theme.PasswordStrengthColors[e.passwordStrength]};
    `}

  font-size: 13px;
  text-align: start;
`, OV = W.img.attrs(() => ({
  className: "msd__icon--password"
}))`
  height: 20px;
  width: 20px;
  filter: ${({ theme: e }) => e.TextFieldBorderFilter};
`, U2e = W.button`
  background: transparent;
  border: none;
  border-radius: 50%;
  display: flex;
  padding: 0;
  position: relative;
  margin-inline-end: 15px;
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transform: scale(1.5);
    height: 100%;
    background-color: rgba(0, 0, 0, 0.08);
    z-index: 0;
    content: '';
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  &:hover::after,
  &:focus::after {
    opacity: 1;
  }
`, G2e = W.span.attrs(() => ({
  className: "msd__icon__required--error"
}))`
  display: block;
  position: absolute;
  right: 16px;
  height: 9px;
  font-size: 12px;
  line-height: 12px;
  top: 50%;
  color: ${({ theme: e }) => e.ErrorColor};
  transform: translate(0, -50%);
  z-index: 1;
`, Q6 = ({
  type: e,
  placeholder: t,
  value: n,
  onChange: r,
  onBlur: a,
  error: o,
  showVisibilityIcon: s,
  handleClickShowPassword: c,
  showPassword: u,
  passwordStrength: f,
  ariaRequired: m,
  ariaInvalid: v,
  icon: y,
  required: b,
  floatingLabels: S,
  reference: x
}) => /* @__PURE__ */ C.jsx(bQ, { theme: Dee, children: /* @__PURE__ */ C.jsxs(F2e, { children: [
  /* @__PURE__ */ C.jsxs(B2e, { children: [
    b && /* @__PURE__ */ C.jsx(G2e, { children: "*" }),
    /* @__PURE__ */ C.jsx(
      V2e,
      {
        "data-testid": "input",
        id: t,
        autoComplete: "off",
        value: n,
        onChange: (E) => r(E.target.value),
        type: e,
        onBlur: a,
        ref: x,
        "aria-required": m,
        "aria-invalid": v,
        $withIcon: y,
        $floatingLabels: S
      }
    ),
    /* @__PURE__ */ C.jsx(
      ree,
      {
        "data-testid": "input-label",
        htmlFor: t,
        $hasValue: n,
        $withIcon: y,
        children: t
      }
    ),
    s && /* @__PURE__ */ C.jsx(
      U2e,
      {
        "data-testid": "input-visibility-icon",
        onClick: c,
        tabIndex: "0",
        "aria-label": "toggle password visibility",
        type: "button",
        children: u ? /* @__PURE__ */ C.jsx(OV, { src: j2e, alt: "" }) : /* @__PURE__ */ C.jsx(OV, { src: $2e, alt: "" })
      }
    )
  ] }),
  /* @__PURE__ */ C.jsx(
    aee,
    {
      $passwordStrength: f,
      id: `${t}-desc`,
      children: o
    }
  )
] }) });
Q6.propTypes = {
  placeholder: de.string,
  type: de.oneOf(["text", "password", "date", "email"]),
  value: de.string,
  onChange: de.func,
  onBlur: de.func,
  error: de.string,
  showVisibilityIcon: de.bool,
  handleClickShowPassword: de.func,
  showPassword: de.bool,
  passwordStrength: de.oneOf([
    "Weak",
    "Fair",
    "Good",
    "Strong",
    "NotValid",
    ""
  ]),
  ariaRequired: de.bool,
  ariaInvalid: de.bool,
  icon: de.elementType,
  required: de.bool,
  floatingLabels: de.bool,
  reference: de.oneOfType([de.func, de.shape()])
};
Q6.defaultProps = {
  placeholder: "",
  type: "text",
  onChange: () => null,
  onBlur: () => null,
  error: "",
  value: "",
  showVisibilityIcon: !1,
  handleClickShowPassword: () => null,
  showPassword: !1,
  passwordStrength: "",
  ariaRequired: !1,
  ariaInvalid: !1,
  icon: null,
  required: !1,
  floatingLabels: !0,
  reference: () => null
};
const z2e = "fail", L4 = "success", RV = {
  order: {
    billingAddress: "",
    country: "",
    couponId: "",
    currency: "EUR",
    customer: { locale: "", email: "" },
    customerId: 0,
    discount: { applied: !1, type: "", periods: 0 },
    expirationDate: 0,
    id: 0,
    offer: {
      title: "",
      description: "",
      price: 0,
      currency: ""
    },
    offerId: "",
    paymentMethodId: 0,
    priceBreakdown: {
      customerServiceFee: 0,
      discountAmount: 0,
      discountedPrice: 0,
      offerPrice: 0,
      paymentMethodFee: 0,
      taxValue: 0
    },
    publisherId: 0,
    requiredPaymentDetails: !1,
    taxBreakdown: "",
    taxRate: 0,
    totalPrice: 0,
    buyAsAGift: !1
  },
  loading: !0,
  error: "",
  couponDetails: {
    couponCode: "",
    showMessage: !1,
    message: "",
    messageType: L4,
    translationKey: ""
  },
  isCouponLoading: !1,
  isUpdateLoading: !1
}, $4 = Do("order/createOrder", (r, a) => st(void 0, [r, a], function* ({ offerId: e, buyAsAGift: t }, { rejectWithValue: n }) {
  try {
    const { order: o } = yield zye(e, t);
    return o;
  } catch (o) {
    return n(o.message);
  }
})), xd = Do("order/updateOrder", (r, a) => st(void 0, [r, a], function* ({ id: e, payload: t }, { rejectWithValue: n }) {
  try {
    const { order: o } = yield MR(e, t);
    return o;
  } catch (o) {
    return n(o.message);
  }
})), Zy = Do("order/updateCoupon", (r, a) => st(void 0, [r, a], function* ({ id: e, couponCode: t }, { rejectWithValue: n }) {
  try {
    const { order: o } = yield MR(e, { couponCode: t });
    return o;
  } catch (o) {
    return n(o.message);
  }
})), Fx = Do("order/getOrder", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    const { order: a } = yield r2e(e);
    return a;
  } catch (a) {
    return t(a.message);
  }
})), oee = hs({
  name: "order",
  initialState: RV,
  reducers: (e) => ({
    clearOrder: e.reducer(() => RV),
    setOrderCouponMessage: e.reducer(
      (t, n) => {
        t.couponDetails = Fe(Fe({}, t.couponDetails), n.payload);
      }
    ),
    clearOrderCouponMessage: e.reducer((t) => {
      const { couponDetails: n } = t;
      t.couponDetails = Xn(Fe({}, n), {
        showMessage: !1,
        message: "",
        messageType: L4,
        translationKey: ""
      });
    })
  }),
  extraReducers: (e) => {
    e.addCase($4.pending, (t) => {
      t.loading = !0;
    }), e.addCase($4.fulfilled, (t, n) => {
      t.loading = !1, t.order = n.payload;
    }), e.addCase($4.rejected, (t, { payload: n }) => {
      t.loading = !1, n && (t.error = n);
    }), e.addCase(Fx.pending, (t) => {
      t.loading = !0;
    }), e.addCase(Fx.fulfilled, (t, n) => {
      t.loading = !1, t.order = n.payload;
    }), e.addCase(Fx.rejected, (t) => {
      t.loading = !0;
    }), e.addCase(Zy.pending, (t, n) => {
      t.isCouponLoading = !0;
      const { couponCode: r } = n.meta.arg;
      t.couponDetails = {
        couponCode: r || "",
        showMessage: !1,
        message: "",
        messageType: L4,
        translationKey: ""
      };
    }), e.addCase(Zy.fulfilled, (t, n) => {
      t.isCouponLoading = !1, t.order = n.payload;
      const { couponCode: r } = n.meta.arg;
      t.couponDetails = {
        couponCode: r || "",
        showMessage: !!r,
        message: r ? "Your coupon has been applied!" : "",
        messageType: L4,
        translationKey: "coupon-input.success"
      };
    }), e.addCase(Zy.rejected, (t, n) => {
      t.isCouponLoading = !1;
      const { couponCode: r } = n.meta.arg;
      t.couponDetails = {
        couponCode: r || "",
        showMessage: !0,
        message: "This is not a valid coupon code for this offer. Please check the code on your coupon and try again.",
        messageType: z2e,
        translationKey: "coupon-input.error"
      };
    }), e.addCase(xd.pending, (t) => {
      t.isUpdateLoading = !0;
    }), e.addCase(xd.fulfilled, (t, n) => {
      t.isUpdateLoading = !1, t.order = n.payload;
    }), e.addCase(xd.rejected, (t, { payload: n }) => {
      t.isUpdateLoading = !1, n && (t.error = n);
    });
  }
}), { clearOrder: H2e, setOrderCouponMessage: W2e, clearOrderCouponMessage: Z2e } = oee.actions, iee = (e) => e.order, Bm = (e) => e.order.order, Y2e = oee.reducer, X2e = {
  loading: !1,
  error: null
}, j4 = Do("payment/submitPaymentWithoutDetails", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    return yield Xye();
  } catch (a) {
    return t(a.message);
  }
})), K2e = hs({
  name: "paymentSlice",
  initialState: X2e,
  reducers: () => ({}),
  extraReducers: (e) => {
    e.addCase(j4.pending, (t) => {
      t.loading = !0;
    }), e.addCase(j4.fulfilled, (t) => {
      t.loading = !1;
    }), e.addCase(
      j4.rejected,
      (t, { payload: n }) => {
        t.loading = !1, n != null && n.includes("Order doesn't have paymentMethodId") ? t.error = {
          message: "Unable to proceed, because of wrong offer settings. Please, contact the owner of the offer",
          translationKey: "free-offer.error.wrong-offer-settings"
        } : t.error = {
          message: "Oops, something went wrong! Please, reload the page and try again",
          translationKey: "free-offer.error.something-went-wrong"
        };
      }
    );
  }
}), q2e = (e) => e.payment, J2e = K2e.reducer, Q2e = {
  paymentDetails: [],
  activeOrBoundPaymentDetails: [],
  loading: !0,
  error: null
}, Tm = Do("paymentDetails", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    return yield Kye();
  } catch (a) {
    return t(a.message);
  }
})), ebe = hs({
  name: "paymentDetails",
  initialState: Q2e,
  reducers: () => ({}),
  extraReducers: (e) => {
    e.addCase(Tm.pending, (t) => {
      t.loading = !0;
    }), e.addCase(Tm.fulfilled, (t, { payload: n }) => {
      t.loading = !1, t.paymentDetails = n == null ? void 0 : n.paymentDetails, t.activeOrBoundPaymentDetails = n == null ? void 0 : n.paymentDetails.filter(
        (r) => r.active || r.bound
      );
    }), e.addCase(Tm.rejected, (t, n) => {
      t.loading = !1, n.payload && (t.error = n.payload);
    });
  }
}), tbe = (e) => e.paymentDetails, nbe = ebe.reducer, rbe = {
  selectedPaymentMethod: {}
}, see = hs({
  name: "paymentMethods",
  initialState: rbe,
  reducers: (e) => ({
    setSelectedPaymentMethod: e.reducer(
      (t, n) => {
        t.selectedPaymentMethod = n.payload;
      }
    )
  })
}), abe = (e) => e.paymentMethods, { setSelectedPaymentMethod: lee } = see.actions, obe = see.reducer, MV = {
  currentPlan: {
    data: [],
    loading: !1,
    error: null
  },
  offerToSwitch: {},
  updateList: !1,
  switchSettings: {
    data: {},
    loading: !1,
    error: null
  },
  switchDetails: {
    data: {},
    loading: !1,
    error: null
  }
}, L0 = Do("plan/fetchCustomerOffers", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    const { items: a } = yield qye();
    return a;
  } catch (a) {
    return t(a.message);
  }
})), Yy = Do(
  "plan/fetchPendingSwitches",
  (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
    try {
      return (yield Promise.all(
        e.map((c) => st(void 0, [c], function* ({ pendingSwitchId: s }) {
          return yield a2e(s);
        }))
      )).reduce(
        (s, c) => Xn(Fe({}, s), { [c.id]: c }),
        {}
      );
    } catch (a) {
      return t(a.message);
    }
  })
), Xy = Do("plan/fetchAvailableSwitches", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    return (yield Promise.all(
      e.map((c) => st(void 0, [c], function* ({ offerId: s }) {
        const u = yield e2e(s);
        return { offerId: s, switches: u };
      }))
    )).reduce(
      (s, c) => Xn(Fe({}, s), {
        [c.offerId]: c.switches
      }),
      {}
    );
  } catch (a) {
    return t(a.message);
  }
})), uee = hs({
  name: "plan",
  initialState: MV,
  reducers: (e) => ({
    setOfferToSwitch: e.reducer(
      (t, { payload: n }) => {
        t.offerToSwitch = n;
      }
    ),
    resetOfferToSwitch: e.reducer((t) => {
      t.offerToSwitch = MV.offerToSwitch;
    }),
    updateList: e.reducer((t) => {
      t.updateList = !t.updateList;
    }),
    setSwitchDetails: e.reducer(
      (t, { payload: n }) => {
        const { details: r, type: a } = n;
        a === "delete" ? delete t.switchDetails.data[r.pendingSwitchId] : t.switchDetails.data = Object.assign(
          t.switchDetails.data,
          r
        );
      }
    )
  }),
  extraReducers: (e) => {
    e.addCase(L0.pending, (t) => {
      t.currentPlan.loading = !0;
    }), e.addCase(L0.fulfilled, (t, n) => {
      t.currentPlan.loading = !1, t.currentPlan.data = n.payload;
    }), e.addCase(L0.rejected, (t, n) => {
      t.currentPlan.loading = !1, t.currentPlan.error = n.payload;
    }), e.addCase(Yy.pending, (t) => {
      t.switchDetails.loading = !0;
    }), e.addCase(Yy.fulfilled, (t, n) => {
      t.switchDetails.loading = !1, t.switchDetails.data = n.payload;
    }), e.addCase(Yy.rejected, (t, n) => {
      t.switchDetails.loading = !1, t.switchDetails.error = n.payload;
    }), e.addCase(Xy.pending, (t) => {
      t.switchSettings.loading = !0;
    }), e.addCase(Xy.fulfilled, (t, n) => {
      t.switchSettings.loading = !1, t.switchSettings.data = n.payload;
    }), e.addCase(Xy.rejected, (t, n) => {
      t.switchSettings.loading = !1, t.switchSettings.error = n.payload;
    });
  }
}), DV = (e) => e.plan, $R = (e) => e.plan.currentPlan, cee = (e) => e.plan.switchSettings, dee = (e) => e.plan.switchDetails, {
  setOfferToSwitch: P_,
  resetOfferToSwitch: fee,
  updateList: Pd,
  setSwitchDetails: pee
} = uee.actions, ibe = uee.reducer, hee = "SHOW_POPUP", sbe = cl(hee), mee = "HIDE_POPUP", lbe = cl(mee), ube = {
  isPopupShown: !1,
  popupType: "",
  consents: []
}, cbe = k_(ube, (e) => {
  e.addCase(hee, (t, n) => {
    t.isPopupShown = !0, t.popupType = n.payload.type, t.consents = n.payload.consents;
  }), e.addCase(mee, (t) => {
    t.isPopupShown = !1;
  });
}), su = {
  UPDATE_SUBSCRIPTION_POPUP: "updateSubscription",
  SWITCH_PLAN_POPUP: "switchPlan",
  PAUSE_SUBSCRIPTION_POPUP: "pauseSubscription",
  RESUME_SUBSCRIPTION_POPUP: "resumeSubscription",
  CANCEL_SWITCH_POPUP: "cancelSwitch",
  CANCEL_PAUSE_POPUP: "cancelPause",
  EDIT_DELIVERY_DETAILS_POPUP: "editDeliveryDetails"
}, js = {
  PAYMENT_DETAILS_UPDATE: "PAYMENT_DETAILS_UPDATE",
  DELETE_PAYMENT_DETAILS: "DELETE_PAYMENT_DETAILS",
  FINALIZE_ADYEN: "FINALIZE_ADYEN",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR"
}, SS = {
  isOpen: !1,
  isLoading: !1,
  currentType: null,
  updateSubscription: null,
  switchPlan: null,
  pauseSubscription: null,
  cancelSwitch: null,
  cancelPause: null,
  resumeSubscription: null,
  editDeliveryDetails: {
    giftId: null,
    offerId: "",
    offerTitle: ""
  },
  paymentDetails: {
    isOpen: !1,
    isLoading: !1,
    step: js.PAYMENT_DETAILS_UPDATE,
    initPaymentMethod: null
  }
}, vee = hs({
  name: "popupManager",
  initialState: SS,
  reducers: (e) => ({
    updatePaymentDetailsPopup: e.reducer(
      (t, n) => {
        t.paymentDetails = Fe(Fe({}, t.paymentDetails), n.payload);
      }
    ),
    resetPaymentDetailsPopupState: e.reducer((t) => {
      t.paymentDetails = SS.paymentDetails;
    }),
    showPopup: e.reducer(
      (t, n) => {
        t.currentType && (t[t.currentType] = SS[t.currentType], t.currentType = null), t.isOpen = !0, t.currentType = n.payload.type, t[n.payload.type] = n.payload.data;
      }
    ),
    hidePopup: e.reducer(() => SS)
  })
}), dbe = (e) => e.popupManager.paymentDetails, fbe = (e) => e.popupManager.editDeliveryDetails, N_ = (e) => ({
  isOpen: e.popupManager.isOpen,
  isLoading: e.popupManager.isLoading,
  currentType: e.popupManager.currentType
}), jR = (e) => {
  var t;
  return (t = e.popupManager.updateSubscription) == null ? void 0 : t.offerData;
}, pbe = (e) => e.popupManager, {
  updatePaymentDetailsPopup: pi,
  resetPaymentDetailsPopupState: gee,
  showPopup: Ed,
  hidePopup: Za
} = vee.actions, hbe = vee.reducer, mbe = {
  publisherId: "",
  offerId: "",
  paymentMethods: [],
  visiblePaymentMethods: [],
  hiddenPaymentMethods: [],
  isPayPalHidden: !1,
  adyenConfiguration: null,
  displayGracePeriodError: !1,
  termsUrl: "",
  resetUrl: "",
  enable3DSRedirectFlow: !1
}, yee = hs({
  name: "publisherConfig",
  initialState: mbe,
  reducers: (e) => ({
    init: e.reducer((t, n) => Fe(Fe({}, t), n.payload)),
    updatePaymentMethods: e.reducer((t, n) => {
      t.paymentMethods = n.payload;
    }),
    updateHiddenPaymentMethods: e.reducer(
      (t, n) => {
        t.hiddenPaymentMethods = n.payload;
      }
    )
  })
}), vbe = (e) => e.publisherConfig.adyenConfiguration, FR = (e) => e.publisherConfig, gbe = (e) => e.publisherConfig.displayGracePeriodError, bee = (e) => e.publisherConfig.termsUrl, { init: $u, updatePaymentMethods: _ee, updateHiddenPaymentMethods: ybe } = yee.actions, bbe = yee.reducer, _be = {
  publisherConsents: [],
  checked: [],
  loading: !1,
  error: null
}, Bx = Do("publisherConsents", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    const { consents: a } = yield n2e(e);
    return a;
  } catch (a) {
    return t(a.message);
  }
})), Cee = hs({
  name: "publisherConsents",
  initialState: _be,
  reducers: (e) => ({
    setChecked: e.reducer((t, { payload: n }) => {
      t.checked[n] = !t.checked[n];
    })
  }),
  extraReducers: (e) => {
    e.addCase(Bx.pending, (t) => {
      t.loading = !0;
    }), e.addCase(Bx.fulfilled, (t, { payload: n }) => {
      t.publisherConsents = n, t.checked = new Array(n.length).fill(!1), t.loading = !1;
    }), e.addCase(Bx.rejected, (t, { payload: n }) => {
      n && n.includes("Invalid param publisherId") ? t.error = "noPublisherId" : t.error = n, t.loading = !1;
    });
  }
}), { setChecked: LV } = Cee.actions, Cbe = Cee.reducer, $V = {
  error: null,
  isLoading: !1,
  isApplyLoading: !1,
  retentionActions: {
    type: "",
    offerId: "",
    extensionDetails: { periodUnit: "", amount: 0 },
    downgradeDetails: { offers: [] },
    pauseDetails: {}
  }
}, Vx = Do("fetchRetentionActions", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    return yield h2e(e);
  } catch (a) {
    return t(a.message);
  }
})), Ux = Do("fetchApplyRetentionAction", (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
  try {
    return yield m2e(e);
  } catch (a) {
    return t(a.message);
  }
})), wbe = hs({
  name: "retentionActions",
  initialState: $V,
  reducers: () => ({}),
  extraReducers: (e) => {
    e.addCase(Vx.pending, (t) => {
      t.isLoading = !0, t.retentionActions = $V.retentionActions;
    }), e.addCase(Vx.fulfilled, (t, n) => {
      var a;
      const r = (a = n.meta) == null ? void 0 : a.arg;
      t.isLoading = !1, t.retentionActions = Xn(Fe({}, n.payload), { offerId: r });
    }), e.addCase(Vx.rejected, (t, n) => {
      t.isLoading = !1, n.payload && (t.error = n.payload);
    }), e.addCase(Ux.pending, (t) => {
      t.isApplyLoading = !0;
    }), e.addCase(Ux.fulfilled, (t) => {
      t.isApplyLoading = !1;
    }), e.addCase(Ux.rejected, (t, n) => {
      t.isApplyLoading = !1, n.payload && (t.error = n.payload);
    });
  }
}), wee = (e) => e.retentionActions, Sbe = (e) => e.retentionActions.retentionActions, xbe = (e) => e.retentionActions.isLoading, Ebe = wbe.reducer, mT = 3, Ibe = {
  transactions: [],
  error: [],
  showToggleButton: !1,
  loading: !1,
  isListExpanded: !1
}, Gx = Do(
  "transactions/listCustomerTransactions",
  (n, r) => st(void 0, [n, r], function* (e, { rejectWithValue: t }) {
    try {
      const { items: a } = yield Jye();
      return a;
    } catch (a) {
      return t(a.message);
    }
  })
), See = hs({
  name: "transactions",
  initialState: Ibe,
  reducers: (e) => ({
    toggleTransactionList: e.reducer((t) => {
      t.isListExpanded = !t.isListExpanded;
    }),
    removePausedTransactions: e.reducer((t, { payload: n }) => {
      t.transactions = t.transactions.filter(
        ({ offerId: r }) => !n.includes(r)
      ), t.showToggleButton = t.transactions.length > mT;
    })
  }),
  extraReducers: (e) => {
    e.addCase(Gx.pending, (t) => {
      t.loading = !0;
    }), e.addCase(
      Gx.fulfilled,
      (t, { payload: n }) => {
        t.loading = !1, t.transactions = n, t.showToggleButton = n.length > mT;
      }
    ), e.addCase(
      Gx.rejected,
      (t, { payload: n }) => {
        t.loading = !1, t.error = n;
      }
    );
  }
}), { toggleTransactionList: kbe, removePausedTransactions: Abe } = See.actions, Pbe = See.reducer, xee = (e) => {
  const t = or(), { customerId: n } = qi(En("CLEENG_AUTH_TOKEN")), r = `${t}/customers/${n}/subscriptions`;
  return Mr(r, {
    method: "PATCH",
    body: JSON.stringify(Fe({}, e))
  }).then((a) => a.json());
}, Nbe = {
  loading: !1,
  error: null
}, zx = Do(
  "unsubscribe/fetchUnsubscribe",
  (a, o) => st(void 0, [a, o], function* ({ offerId: e, isPauseActive: t, checkedReason: n }, { rejectWithValue: r }) {
    try {
      return yield xee({
        offerId: e,
        status: t ? "terminated" : "cancelled",
        cancellationReason: n
      });
    } catch (s) {
      return r(s.message);
    }
  })
), Tbe = hs({
  name: "unsubscribe",
  initialState: Nbe,
  reducers: () => ({}),
  extraReducers: (e) => {
    e.addCase(zx.pending, (t) => {
      t.loading = !0;
    }), e.addCase(zx.fulfilled, (t) => {
      t.loading = !1;
    }), e.addCase(zx.rejected, (t, { payload: n }) => {
      t.loading = !1, n && (t.error = n);
    });
  }
}), Eee = (e) => e.unsubscribe, Obe = Tbe.reducer, Iee = "SET_CURRENT_USER", kee = cl(Iee), Aee = "SET_USER_CAPTURE", Rbe = cl(Aee), Pee = "UPDATE_CAPTURE_OPTION", Mbe = cl(Pee), Nee = "SET_CONSENTS", B7 = cl(Nee), Tee = "SET_CONSENTS_ERROR", Dbe = cl(Tee), Lbe = {
  user: null,
  capture: null,
  consents: [],
  consentsError: ""
}, $be = k_(Lbe, (e) => {
  e.addCase(Iee, (t, n) => {
    t.user = n.payload;
  }), e.addCase(Aee, (t, n) => {
    t.capture = n.payload;
  }), e.addCase(Pee, (t, n) => {
    const r = Xn(Fe({}, t.capture), {
      settings: t.capture.settings.map((a) => a.key === n.payload.key ? Xn(Fe({}, a), { answer: n.payload.value }) : a)
    });
    t.capture = r;
  }), e.addCase(Nee, (t, n) => {
    t.consents = n.payload;
  }), e.addCase(Tee, (t, n) => {
    t.consentsError = n.payload;
  });
}), jbe = wQ({
  appConfig: bye,
  deliveryDetails: _ye,
  finalizeAddPaymentDetails: y2e,
  finalizeInitialPayment: C2e,
  gift: x2e,
  innerPopup: A2e,
  myaccount: N2e,
  offer: R2e,
  offers: L2e,
  order: Y2e,
  payment: J2e,
  paymentDetails: nbe,
  paymentMethods: obe,
  plan: ibe,
  // removed planDetails - to be checked if was needed
  popup: cbe,
  popupManager: hbe,
  publisherConfig: bbe,
  publisherConsents: Cbe,
  retentionActions: Ebe,
  transactions: Pbe,
  unsubscribe: Obe,
  userProfile: $be
}), Fbe = (e, t) => jbe(t.type === "USER_LOGOUT" ? void 0 : e, t), Mo = Jge({
  reducer: Fbe
}), Va = Jo, Ot = wr, BR = () => {
  try {
    return localStorage.setItem("CLEENG_LS", "yes"), localStorage.getItem("CLEENG_LS") === "yes" ? (localStorage.removeItem("CLEENG_LS"), !0) : !1;
  } catch (e) {
    return !1;
  }
}, En = (e) => {
  const t = BR() ? localStorage.getItem(e) : Mo.getState().appConfig[e];
  return !t && e === "CLEENG_AUTH_TOKEN" ? (console.error(
    "Unable to get CLEENG_AUTH_TOKEN from local storage or redux store"
  ), null) : t;
}, Ba = (e, t) => BR() ? localStorage.setItem(e, t) : Mo.dispatch(vye({ name: e, value: t })), Pl = (e) => BR() ? localStorage.removeItem(e) : Mo.dispatch(gye({ name: e })), Bbe = (e) => e ? (Ba("CLEENG_AUTH_TOKEN", e), !0) : !1, Vbe = (e) => e ? (Ba("CLEENG_REFRESH_TOKEN", e), !0) : !1, Ube = (e) => e ? (Ba("CLEENG_PUBLISHER_ID", e), Mo.dispatch($u({ publisherId: e })), !0) : !1, Gbe = (e) => e ? (Ba("CLEENG_OFFER_ID", e), !0) : !1, zbe = (e) => e ? (Ba("CLEENG_ENVIRONMENT", e), !0) : !1, Hbe = (e) => {
  if (e) {
    const { successUrl: t, cancelUrl: n, errorUrl: r } = e;
    return Ba("CLEENG_CHECKOUT_PP_SUCCESS", t), Ba("CLEENG_CHECKOUT_PP_CANCEL", n), Ba("CLEENG_CHECKOUT_PP_ERROR", r), !0;
  }
  return !1;
}, Wbe = (e) => {
  if (e) {
    const { successUrl: t, cancelUrl: n, errorUrl: r } = e;
    return Ba("CLEENG_MYACCOUNT_PP_SUCCESS", t), Ba("CLEENG_MYACCOUNT_PP_CANCEL", n), Ba("CLEENG_MYACCOUNT_PP_ERROR", r), !0;
  }
  return !1;
}, Zbe = (e) => e ? (Ba("CLEENG_MY_ACCOUNT_URL", e), !0) : !1, Ybe = (e) => e ? (Ba("CLEENG_OFFER_SELECTION_URL", e), !0) : !1, Xbe = (e) => e ? (Ba("CLEENG_TERMS_URL", e), Mo.dispatch($u({ termsUrl: e })), !0) : !1, Kbe = (e) => e ? (Mo.dispatch($u({ resetUrl: e })), !0) : !1, qbe = (e) => {
  const t = JSON.stringify(e);
  return e ? (Ba("CLEENG_THEME", t), !0) : !1;
}, jV = () => {
  const e = En("CLEENG_THEME");
  return e ? JSON.parse(e) : !1;
}, Jbe = (e) => (Mo.dispatch(
  $u({
    visiblePaymentMethods: e
  })
), !0), Qbe = () => (Mo.dispatch(
  $u({
    isPayPalHidden: !0
  })
), !0), e3e = (e) => (Mo.dispatch(ybe(e)), !0), t3e = () => (Mo.dispatch(
  $u({
    enable3DSRedirectFlow: !0
  })
), !0), n3e = (e) => st(void 0, null, function* () {
  const t = window.location.origin;
  if (!ca.hasResourceBundle(e, "translations")) {
    const n = yield fetch(
      `${t}/cleeng-translations/${e}/translations.json`
    ).then((r) => r.json()).catch(() => {
    });
    ca.addResourceBundle(e, "translations", n, !0, !0);
  }
  return ca.changeLanguage(e), !0;
}), wht = {
  setPublisher: Ube,
  setOffer: Gbe,
  setEnvironment: zbe,
  setTheme: qbe,
  setCheckoutPayPalUrls: Hbe,
  setMyAccountPayPalUrls: Wbe,
  setMyAccountUrl: Zbe,
  setOfferSelectionUrl: Ybe,
  setJWT: Bbe,
  setRefreshToken: Vbe,
  setTermsUrl: Xbe,
  setResetUrl: Kbe,
  setHidePayPal: Qbe,
  setVisibleAdyenPaymentMethods: Jbe,
  setHiddenPaymentMethods: e3e,
  setLanguage: n3e,
  setEnable3DSRedirectFlow: t3e
}, {
  backgroundColor: r3e,
  loaderColor: a3e,
  successColor: o3e,
  errorColor: i3e,
  fontColor: s3e,
  cardColor: l3e,
  primaryColor: u3e,
  secondaryColor: c3e,
  logoUrl: d3e
} = typeof jV == "function" && jV() || {}, Oee = "#7B849D", FV = "#F2F5FC", f3e = "#ffc439", Br = r3e || "#F8FAFD", VR = l3e || "#ffffff", Et = s3e || "#515364", An = o3e || "#4EB7A1", wa = i3e || "#CB4477", e8 = u3e || Et, p3e = c3e || Br, h3e = a3e || "#eeeff2", Ree = "#BCC3CD", Gn = "#D3DBE6", cu = "#FFFFFF", u2 = "#b7bfca", m3e = "invert(87%) sepia(14%) saturate(243%) hue-rotate(213deg) brightness(96%) contrast(80%)", Vm = "#80b4ea", v3e = "#00112c", g3e = d3e || "", y3e = {
  Weak: "#ea753c",
  Fair: "#e7ca27",
  Good: "#5da3bd",
  Strong: "#5db98f",
  NotValid: "#CB4477"
}, UR = "25px", t8 = "16px", n8 = "14px", A2 = "12px", i1 = "11px", Mee = "9px", Nd = "700", Yp = "600", b3e = "300", Dee = {
  FontColor: Et,
  BackgroundColor: Br,
  ConfirmColor: An,
  ErrorColor: wa,
  TextFieldBorderFilter: m3e,
  PasswordStrengthColors: y3e
}, _3e = W.div.attrs(() => ({
  className: "msd__account__card"
}))`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  position: relative;
  width: 100%;

  padding: 18px;
  border-radius: 12px;

  margin-bottom: 32px;

  background-color: ${VR};

  ${(e) => e.$withShadow && ot`
      box-shadow: 0px 3px 50px #0000001f;
    `}
  ${(e) => e.$withBorder && ot`
      border: 1px solid #d3dbe6;
    `}
`, Uu = ({ as: e, className: t, children: n, withShadow: r, withBorder: a }) => /* @__PURE__ */ C.jsx(
  _3e,
  {
    as: e,
    $withShadow: r,
    className: t,
    $withBorder: a,
    children: n
  }
);
Uu.propTypes = {
  as: de.string,
  children: de.node,
  withShadow: de.bool,
  className: de.string,
  withBorder: de.bool
};
Uu.defaultProps = {
  as: "article",
  children: "",
  withShadow: !1,
  className: "",
  withBorder: !1
};
const C3e = AR`
  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.5);
  }
`, w3e = W.div.attrs(() => ({
  className: "msd__spinner"
}))`
  margin: 0 auto;
  position: relative;
  width: 64px;
  height: 64px;
  ${(e) => e.$isMyAccount && ot`
      margin: 50px auto;
    `};

  ${(e) => e.$centered && ot`
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `}

  & div {
    position: absolute;
    width: 5px;
    height: 5px;
    background: ${(e) => e.$color ? e.$color : "#d4d4d4"};
    border-radius: 50%;
    animation: ${C3e} 1.2s linear infinite;
    ${(e) => e.$isMyAccount && ot`
        background: ${Et};
      `};
  }

  & div:nth-child(1) {
    animation-delay: 0s;
    top: 29px;
    left: 53px;
  }

  & div:nth-child(2) {
    animation-delay: -0.1s;
    top: 18px;
    left: 50px;
  }

  & div:nth-child(3) {
    animation-delay: -0.2s;
    top: 9px;
    left: 41px;
  }

  & div:nth-child(4) {
    animation-delay: -0.3s;
    top: 6px;
    left: 29px;
  }

  & div:nth-child(5) {
    animation-delay: -0.4s;
    top: 9px;
    left: 18px;
  }

  & div:nth-child(6) {
    animation-delay: -0.5s;
    top: 18px;
    left: 9px;
  }

  & div:nth-child(7) {
    animation-delay: -0.6s;
    top: 29px;
    left: 6px;
  }

  & div:nth-child(8) {
    animation-delay: -0.7s;
    top: 41px;
    left: 9px;
  }

  & div:nth-child(9) {
    animation-delay: -0.8s;
    top: 50px;
    left: 18px;
  }

  & div:nth-child(10) {
    animation-delay: -0.9s;
    top: 53px;
    left: 29px;
  }

  & div:nth-child(11) {
    animation-delay: -1s;
    top: 50px;
    left: 41px;
  }

  & div:nth-child(12) {
    animation-delay: -1.1s;
    top: 41px;
    left: 50px;
  }

  ${(e) => e.$buttonLoader && ot`
      width: 18px;
      height: 18px;
      transform: scale(0.4) translate(-20px, -25px);
    `}

  ${(e) => e.$smallLoader && ot`
      position: absolute;
      right: 0;
      top: 0;

      height: 11px;
      width: 13px;
      transform: translateY(100%) translateX(-100%) scale(0.3);
    `}
`, cr = ({
  buttonLoader: e,
  smallLoader: t,
  centered: n,
  color: r,
  isMyAccount: a
}) => /* @__PURE__ */ C.jsxs(
  w3e,
  {
    $buttonLoader: e,
    $smallLoader: t,
    $centered: n,
    $color: r,
    $isMyAccount: a,
    children: [
      /* @__PURE__ */ C.jsx("div", {}),
      /* @__PURE__ */ C.jsx("div", {}),
      /* @__PURE__ */ C.jsx("div", {}),
      /* @__PURE__ */ C.jsx("div", {}),
      /* @__PURE__ */ C.jsx("div", {}),
      /* @__PURE__ */ C.jsx("div", {}),
      /* @__PURE__ */ C.jsx("div", {}),
      /* @__PURE__ */ C.jsx("div", {}),
      /* @__PURE__ */ C.jsx("div", {}),
      /* @__PURE__ */ C.jsx("div", {}),
      /* @__PURE__ */ C.jsx("div", {}),
      /* @__PURE__ */ C.jsx("div", {})
    ]
  }
);
cr.propTypes = {
  buttonLoader: de.bool,
  smallLoader: de.bool,
  centered: de.bool,
  color: de.string,
  isMyAccount: de.bool
};
cr.defaultProps = {
  buttonLoader: !1,
  smallLoader: !1,
  centered: !1,
  color: null,
  isMyAccount: !1
};
const S3e = W.button.attrs((e) => ({
  className: `msd__button msd__button--${e.$theme}`
}))`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  min-width: min-content;

  border-radius: 30px;
  outline: 0;
  border: none;

  text-align: center;
  text-decoration: none;
  letter-spacing: 0.025em;
  font-size: 13px;
  padding: 12px 25px;
  font-weight: 600;
  line-height: initial;

  transition: opacity 0.1s ease-in-out;
  cursor: pointer;

  &:active {
    outline: none;
  }

  &:focus {
    outline: 1px solid ${Vm};
  }

  &:disabled {
    &:hover {
      cursor: not-allowed;
    }
  }

  ${(e) => e.$size === "big" && ot`
      padding: 20px;
      font-size: 16px;
      font-weight: 400;
    `}

  ${(e) => e.$size === "normal" && ot`
      padding: 12px 25px;
      font-size: 13px;
      font-weight: 600;
    `}

  ${(e) => e.$theme === "confirm" && ot`
        color: ${cu};
        background-color: ${An};
        opacity: 0.9;
        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 1;
        }
      ` || e.$theme === "primary" && ot`
        color: ${cu};
        background-color: ${e8};
        opacity: 0.9;
        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 1;
        }
      ` || e.$theme === "paypal" && ot`
        color: ${cu};
        background-color: ${f3e};
        opacity: 0.9;
        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 1;
        }
      ` || e.$theme === "danger" && ot`
        color: ${cu};
        background-color: ${wa};
        opacity: 0.9;
        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 1;
        }
      ` || e.$theme === "payment" && ot`
        height: 48px;
        width: 30%;
        min-width: max-content;

        padding: 15px;
        border-radius: 6px;

        color: ${cu};
        background-color: ${v3e};

        font-size: 14px;

        ${pr.small`
          width: 100%;
        `}

        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 0.9;
        }
      ` || e.$theme === "secondary" && ot`
        background-color: ${p3e};
        border: 1px solid ${Br};
        color: ${Et};
        &:hover,
        &:focus,
        &:active {
          cursor: pointer;
          background-color: ${Gn};
          border: 1px solid ${Gn};
        }
      ` || e.$theme === "simple" && ot`
        background-color: transparent;
        border: 1px solid ${Gn};
        color: ${Et};
        &:not(:disabled):hover,
        &:focus {
          cursor: pointer;
          background-color: ${Br};
        }
        &:active {
          border: 1px solid ${Gn};
        }
      ` || e.$theme === "navLink" && ot`
        position: absolute;
        top: 50%;
        left: 35px;

        height: auto;
        width: auto;
        border-radius: none;
        padding: 0;

        transform: translateY(-45%);
        background-color: transparent;
        color: ${Et};
        font-size: 16px;
        letter-spacing: 0.025em;
        font-weight: 500;

        &::before {
          content: '<';
          margin-right: 10px;
        }
        &:hover,
        &:focus {
          font-weight: 700;
          text-decoration: none;
        }
        ${pr.small`
          top: 15px;
          left: 10px;
        `}
      ` || e.$theme === "link" && ot`
        display: inline-block;

        width: auto;
        height: auto;
        padding: 0px;

        border-radius: none;
        background-color: transparent;
        color: ${Et};

        text-decoration: underline;
        letter-spacing: 0.025em;
        font-weight: 300;
        font-size: 12px;

        &:hover,
        &:focus {
          background-color: transparent;
          font-weight: bold;
        }
      `}

  ${(e) => e.$fontWeight && ot`
      font-weight: ${e.$fontWeight};
    `}
  ${(e) => e.$fontSize && ot`
      font-size: ${e.$fontSize};
    `}
  ${(e) => e.$margin && ot`
      margin: ${e.$margin};
    `}
  ${(e) => e.$width && ot`
      width: ${e.$width};
    `}
  ${(e) => e.disabled && ot`
      filter: opacity(0.7);
    `}
  ${(e) => e.$padding && ot`
      padding: ${e.$padding};
    `}
  ${(e) => e.$icon && ot`
      &::before {
        position: absolute;
        display: inline-block;

        width: 20px;
        height: 20px;
        left: 15px;
        top: 50%;
        transform: translateY(-50%);
        content: url(${e.$icon});
      }
    `}
`, x3e = {
  BIG: "big",
  NORMAL: "normal"
}, Lee = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SIMPLE: "simple",
  NAVLINK: "navLink",
  LINK: "link",
  PAYMENT: "payment",
  CONFIRM: "confirm",
  PAYPAL: "paypal",
  DANGER: "danger"
}, zt = ({
  type: e,
  onClickFn: t,
  disabled: n,
  children: r,
  label: a,
  size: o,
  theme: s,
  fontSize: c,
  margin: u,
  fontWeight: f,
  width: m,
  icon: v,
  padding: y,
  className: b,
  testid: S
}) => {
  const x = {
    type: e,
    onClick: t
  };
  return /* @__PURE__ */ C.jsx(
    S3e,
    Xn(Fe({}, x), {
      disabled: n,
      "aria-label": a,
      $size: o,
      $theme: s,
      $fontSize: c,
      $margin: u,
      $fontWeight: f,
      $width: m,
      $icon: v,
      $padding: y,
      className: b,
      "data-testid": S,
      children: r
    })
  );
};
zt.propTypes = {
  size: de.oneOf(Object.values(x3e)),
  theme: de.oneOf(Object.values(Lee)),
  children: de.oneOfType([
    de.string,
    de.element,
    de.node
  ]),
  type: de.string,
  onClickFn: de.func,
  disabled: de.bool,
  label: de.string,
  fontSize: de.string,
  margin: de.string,
  fontWeight: de.string,
  width: de.string,
  icon: de.string,
  padding: de.string,
  className: de.string,
  testid: de.string
};
zt.defaultProps = {
  size: null,
  theme: Lee.PRIMARY,
  children: "",
  type: "button",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClickFn: () => {
  },
  disabled: !1,
  label: null,
  fontSize: null,
  margin: null,
  fontWeight: null,
  width: null,
  icon: null,
  padding: null,
  className: "",
  testid: null
};
const E3e = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24" }, e), /* @__PURE__ */ k.createElement("title", null, "Close icon"), /* @__PURE__ */ k.createElement("path", { d: "M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" })), I3e = W.form.attrs(() => ({
  className: "msd__coupon-input__wrapper",
  "data-testid": "inputcomponent"
}))`
  display: flex;
  flex-direction: column;

  max-width: 300px;

  ${(e) => e.$isOpen && e.$fullWidth && ot`
      max-width: 100%;
      width: 100%;
    `};
`, k3e = W.div.attrs(() => ({
  className: "msd__coupon-input__message"
}))`
  color: ${(e) => e.$messageType === L4 ? An : wa};
  border-radius: 5px;

  font-size: 12px;

  opacity: ${(e) => e.$showMessage ? 1 : 0};
  transition: opacity 250ms linear;
`, A3e = W.div.attrs(() => ({
  className: "msd__coupon-input__wrapper--inner"
}))`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 8px;

  border: 1px solid ${Gn};
  border-radius: 30px;

  background: white;

  ${(e) => e.$isFocused && ot`
      outline: 1px solid ${Vm};
    `}
`, P3e = W.input.attrs(() => ({
  className: "msd__coupon-input__input",
  role: "input"
}))`
  flex-grow: 1;
  position: relative;
  border: none;
  outline: none;

  font-size: 15px;
  line-height: 1.3;

  width: 198px;
  max-width: 198px;
  inset-inline-start: 37px;
  padding-right: 35px;

  ${pr.small`
        width: 100%;
        max-width: 100%;
      `}

  ${(e) => e.$fullWidth && ot`
      width: 100%;
      max-width: 100%;
    `}

  ${(e) => e.readOnly && ot`
      opacity: 0.5;
    `}
`, N3e = W.button.attrs(() => ({
  className: "msd__coupon-input__close"
}))`
  position: absolute;
  height: 22px;
  width: 22px;
  top: 50%;
  inset-inline-start: 7px;
  transform: translate(0, -50%);
  background-color: ${e8};
  padding: 0;
  border: 0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    transform: scale(0.3);
    fill: ${cu};
  }

  &:focus {
    outline: 1px solid ${Vm};
  }
`, $ee = ({
  value: e,
  fullWidth: t,
  couponDetails: n,
  onSubmit: r,
  onChange: a,
  onInputToggle: o,
  couponLoading: s,
  source: c
}) => {
  const [u, f] = mt(!1), [m, v] = mt(!1), [y, b] = mt(!1), S = Va(), x = Yo(null), { t: E } = tn(), { showMessage: N, message: R, messageType: O, translationKey: D } = n, $ = () => st(void 0, null, function* () {
    u ? (ur(Iye, { coupon: e, source: c }), yield r(e)) : (ur(kye, { source: c }), o && o(), f(!0));
  }), B = () => {
    u && (f(!1), o && o(), a(""), S(Z2e()));
  };
  return mn(() => {
    N && (f(!0), b(!0));
  }, [N]), mn(() => {
    e === "" && b(!1);
  }, [e]), mn(() => {
    b(N);
  }, [N]), mn(() => {
    x.current && x.current.focus();
  }, [u]), /* @__PURE__ */ C.jsxs(
    I3e,
    {
      $isOpen: u,
      $fullWidth: t,
      onSubmit: (G) => st(void 0, null, function* () {
        G.preventDefault(), yield $();
      }),
      children: [
        /* @__PURE__ */ C.jsxs(A3e, { $isFocused: m, children: [
          u && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
            /* @__PURE__ */ C.jsx(
              N3e,
              {
                type: "button",
                "aria-label": E("coupon-input.clear-coupon", "Clear coupon code"),
                onClick: B,
                "data-testid": "closeRedeemCouponButton",
                children: /* @__PURE__ */ C.jsx(E3e, {})
              }
            ),
            /* @__PURE__ */ C.jsx(
              P3e,
              {
                type: "text",
                placeholder: E("coupon-input.placeholder", "Your coupon"),
                autoComplete: "off",
                value: e,
                ref: x,
                readOnly: s,
                $fullWidth: t,
                onChange: (G) => a(G.target.value),
                onFocus: () => {
                  v(!0);
                },
                onBlur: () => v(!1),
                "aria-label": E("coupon-input.placeholder", "Your coupon"),
                "aria-required": !1
              }
            )
          ] }),
          /* @__PURE__ */ C.jsxs(zt, { type: "submit", width: "auto", testid: "redeem-btn", children: [
            s && /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }),
            !s && u && E("coupon-input.redeem", "Redeem"),
            !s && !u && E("coupon-input.redeem-coupon", "Redeem coupon")
          ] })
        ] }),
        y && u && /* @__PURE__ */ C.jsx(k3e, { $showMessage: !0, $messageType: O, children: E(D || "", R) })
      ]
    }
  );
};
var vT = { exports: {} }, ru = {}, xS = { exports: {} }, zk = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var BV;
function T3e() {
  return BV || (BV = 1, function(e) {
    function t(me, xe) {
      var X = me.length;
      me.push(xe);
      e: for (; 0 < X; ) {
        var ye = X - 1 >>> 1, ce = me[ye];
        if (0 < a(ce, xe)) me[ye] = xe, me[X] = ce, X = ye;
        else break e;
      }
    }
    function n(me) {
      return me.length === 0 ? null : me[0];
    }
    function r(me) {
      if (me.length === 0) return null;
      var xe = me[0], X = me.pop();
      if (X !== xe) {
        me[0] = X;
        e: for (var ye = 0, ce = me.length, se = ce >>> 1; ye < se; ) {
          var Ie = 2 * (ye + 1) - 1, Le = me[Ie], ie = Ie + 1, $e = me[ie];
          if (0 > a(Le, X)) ie < ce && 0 > a($e, Le) ? (me[ye] = $e, me[ie] = X, ye = ie) : (me[ye] = Le, me[Ie] = X, ye = Ie);
          else if (ie < ce && 0 > a($e, X)) me[ye] = $e, me[ie] = X, ye = ie;
          else break e;
        }
      }
      return xe;
    }
    function a(me, xe) {
      var X = me.sortIndex - xe.sortIndex;
      return X !== 0 ? X : me.id - xe.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var o = performance;
      e.unstable_now = function() {
        return o.now();
      };
    } else {
      var s = Date, c = s.now();
      e.unstable_now = function() {
        return s.now() - c;
      };
    }
    var u = [], f = [], m = 1, v = null, y = 3, b = !1, S = !1, x = !1, E = typeof setTimeout == "function" ? setTimeout : null, N = typeof clearTimeout == "function" ? clearTimeout : null, R = typeof setImmediate != "undefined" ? setImmediate : null;
    typeof navigator != "undefined" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function O(me) {
      for (var xe = n(f); xe !== null; ) {
        if (xe.callback === null) r(f);
        else if (xe.startTime <= me) r(f), xe.sortIndex = xe.expirationTime, t(u, xe);
        else break;
        xe = n(f);
      }
    }
    function D(me) {
      if (x = !1, O(me), !S) if (n(u) !== null) S = !0, ee($);
      else {
        var xe = n(f);
        xe !== null && oe(D, xe.startTime - me);
      }
    }
    function $(me, xe) {
      S = !1, x && (x = !1, N(Z), Z = -1), b = !0;
      var X = y;
      try {
        for (O(xe), v = n(u); v !== null && (!(v.expirationTime > xe) || me && !pe()); ) {
          var ye = v.callback;
          if (typeof ye == "function") {
            v.callback = null, y = v.priorityLevel;
            var ce = ye(v.expirationTime <= xe);
            xe = e.unstable_now(), typeof ce == "function" ? v.callback = ce : v === n(u) && r(u), O(xe);
          } else r(u);
          v = n(u);
        }
        if (v !== null) var se = !0;
        else {
          var Ie = n(f);
          Ie !== null && oe(D, Ie.startTime - xe), se = !1;
        }
        return se;
      } finally {
        v = null, y = X, b = !1;
      }
    }
    var B = !1, G = null, Z = -1, K = 5, q = -1;
    function pe() {
      return !(e.unstable_now() - q < K);
    }
    function he() {
      if (G !== null) {
        var me = e.unstable_now();
        q = me;
        var xe = !0;
        try {
          xe = G(!0, me);
        } finally {
          xe ? _e() : (B = !1, G = null);
        }
      } else B = !1;
    }
    var _e;
    if (typeof R == "function") _e = function() {
      R(he);
    };
    else if (typeof MessageChannel != "undefined") {
      var ge = new MessageChannel(), Y = ge.port2;
      ge.port1.onmessage = he, _e = function() {
        Y.postMessage(null);
      };
    } else _e = function() {
      E(he, 0);
    };
    function ee(me) {
      G = me, B || (B = !0, _e());
    }
    function oe(me, xe) {
      Z = E(function() {
        me(e.unstable_now());
      }, xe);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(me) {
      me.callback = null;
    }, e.unstable_continueExecution = function() {
      S || b || (S = !0, ee($));
    }, e.unstable_forceFrameRate = function(me) {
      0 > me || 125 < me ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : K = 0 < me ? Math.floor(1e3 / me) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return y;
    }, e.unstable_getFirstCallbackNode = function() {
      return n(u);
    }, e.unstable_next = function(me) {
      switch (y) {
        case 1:
        case 2:
        case 3:
          var xe = 3;
          break;
        default:
          xe = y;
      }
      var X = y;
      y = xe;
      try {
        return me();
      } finally {
        y = X;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(me, xe) {
      switch (me) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          me = 3;
      }
      var X = y;
      y = me;
      try {
        return xe();
      } finally {
        y = X;
      }
    }, e.unstable_scheduleCallback = function(me, xe, X) {
      var ye = e.unstable_now();
      switch (typeof X == "object" && X !== null ? (X = X.delay, X = typeof X == "number" && 0 < X ? ye + X : ye) : X = ye, me) {
        case 1:
          var ce = -1;
          break;
        case 2:
          ce = 250;
          break;
        case 5:
          ce = 1073741823;
          break;
        case 4:
          ce = 1e4;
          break;
        default:
          ce = 5e3;
      }
      return ce = X + ce, me = { id: m++, callback: xe, priorityLevel: me, startTime: X, expirationTime: ce, sortIndex: -1 }, X > ye ? (me.sortIndex = X, t(f, me), n(u) === null && me === n(f) && (x ? (N(Z), Z = -1) : x = !0, oe(D, X - ye))) : (me.sortIndex = ce, t(u, me), S || b || (S = !0, ee($))), me;
    }, e.unstable_shouldYield = pe, e.unstable_wrapCallback = function(me) {
      var xe = y;
      return function() {
        var X = y;
        y = xe;
        try {
          return me.apply(this, arguments);
        } finally {
          y = X;
        }
      };
    };
  }(zk)), zk;
}
var Hk = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var VV;
function O3e() {
  return VV || (VV = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = !1, n = !1, r = 5;
      function a(tt, bt) {
        var rn = tt.length;
        tt.push(bt), c(tt, bt, rn);
      }
      function o(tt) {
        return tt.length === 0 ? null : tt[0];
      }
      function s(tt) {
        if (tt.length === 0)
          return null;
        var bt = tt[0], rn = tt.pop();
        return rn !== bt && (tt[0] = rn, u(tt, rn, 0)), bt;
      }
      function c(tt, bt, rn) {
        for (var Rn = rn; Rn > 0; ) {
          var Cn = Rn - 1 >>> 1, Qn = tt[Cn];
          if (f(Qn, bt) > 0)
            tt[Cn] = bt, tt[Rn] = Qn, Rn = Cn;
          else
            return;
        }
      }
      function u(tt, bt, rn) {
        for (var Rn = rn, Cn = tt.length, Qn = Cn >>> 1; Rn < Qn; ) {
          var er = (Rn + 1) * 2 - 1, oo = tt[er], Lr = er + 1, ia = tt[Lr];
          if (f(oo, bt) < 0)
            Lr < Cn && f(ia, oo) < 0 ? (tt[Rn] = ia, tt[Lr] = bt, Rn = Lr) : (tt[Rn] = oo, tt[er] = bt, Rn = er);
          else if (Lr < Cn && f(ia, bt) < 0)
            tt[Rn] = ia, tt[Lr] = bt, Rn = Lr;
          else
            return;
        }
      }
      function f(tt, bt) {
        var rn = tt.sortIndex - bt.sortIndex;
        return rn !== 0 ? rn : tt.id - bt.id;
      }
      var m = 1, v = 2, y = 3, b = 4, S = 5;
      function x(tt, bt) {
      }
      var E = typeof performance == "object" && typeof performance.now == "function";
      if (E) {
        var N = performance;
        e.unstable_now = function() {
          return N.now();
        };
      } else {
        var R = Date, O = R.now();
        e.unstable_now = function() {
          return R.now() - O;
        };
      }
      var D = 1073741823, $ = -1, B = 250, G = 5e3, Z = 1e4, K = D, q = [], pe = [], he = 1, _e = null, ge = y, Y = !1, ee = !1, oe = !1, me = typeof setTimeout == "function" ? setTimeout : null, xe = typeof clearTimeout == "function" ? clearTimeout : null, X = typeof setImmediate != "undefined" ? setImmediate : null;
      typeof navigator != "undefined" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function ye(tt) {
        for (var bt = o(pe); bt !== null; ) {
          if (bt.callback === null)
            s(pe);
          else if (bt.startTime <= tt)
            s(pe), bt.sortIndex = bt.expirationTime, a(q, bt);
          else
            return;
          bt = o(pe);
        }
      }
      function ce(tt) {
        if (oe = !1, ye(tt), !ee)
          if (o(q) !== null)
            ee = !0, Xr(se);
          else {
            var bt = o(pe);
            bt !== null && Kn(ce, bt.startTime - tt);
          }
      }
      function se(tt, bt) {
        ee = !1, oe && (oe = !1, Sr()), Y = !0;
        var rn = ge;
        try {
          var Rn;
          if (!n) return Ie(tt, bt);
        } finally {
          _e = null, ge = rn, Y = !1;
        }
      }
      function Ie(tt, bt) {
        var rn = bt;
        for (ye(rn), _e = o(q); _e !== null && !t && !(_e.expirationTime > rn && (!tt || zn())); ) {
          var Rn = _e.callback;
          if (typeof Rn == "function") {
            _e.callback = null, ge = _e.priorityLevel;
            var Cn = _e.expirationTime <= rn, Qn = Rn(Cn);
            rn = e.unstable_now(), typeof Qn == "function" ? _e.callback = Qn : _e === o(q) && s(q), ye(rn);
          } else
            s(q);
          _e = o(q);
        }
        if (_e !== null)
          return !0;
        var er = o(pe);
        return er !== null && Kn(ce, er.startTime - rn), !1;
      }
      function Le(tt, bt) {
        switch (tt) {
          case m:
          case v:
          case y:
          case b:
          case S:
            break;
          default:
            tt = y;
        }
        var rn = ge;
        ge = tt;
        try {
          return bt();
        } finally {
          ge = rn;
        }
      }
      function ie(tt) {
        var bt;
        switch (ge) {
          case m:
          case v:
          case y:
            bt = y;
            break;
          default:
            bt = ge;
            break;
        }
        var rn = ge;
        ge = bt;
        try {
          return tt();
        } finally {
          ge = rn;
        }
      }
      function $e(tt) {
        var bt = ge;
        return function() {
          var rn = ge;
          ge = bt;
          try {
            return tt.apply(this, arguments);
          } finally {
            ge = rn;
          }
        };
      }
      function we(tt, bt, rn) {
        var Rn = e.unstable_now(), Cn;
        if (typeof rn == "object" && rn !== null) {
          var Qn = rn.delay;
          typeof Qn == "number" && Qn > 0 ? Cn = Rn + Qn : Cn = Rn;
        } else
          Cn = Rn;
        var er;
        switch (tt) {
          case m:
            er = $;
            break;
          case v:
            er = B;
            break;
          case S:
            er = K;
            break;
          case b:
            er = Z;
            break;
          case y:
          default:
            er = G;
            break;
        }
        var oo = Cn + er, Lr = {
          id: he++,
          callback: bt,
          priorityLevel: tt,
          startTime: Cn,
          expirationTime: oo,
          sortIndex: -1
        };
        return Cn > Rn ? (Lr.sortIndex = Cn, a(pe, Lr), o(q) === null && Lr === o(pe) && (oe ? Sr() : oe = !0, Kn(ce, Cn - Rn))) : (Lr.sortIndex = oo, a(q, Lr), !ee && !Y && (ee = !0, Xr(se))), Lr;
      }
      function Ne() {
      }
      function Ee() {
        !ee && !Y && (ee = !0, Xr(se));
      }
      function le() {
        return o(q);
      }
      function be(tt) {
        tt.callback = null;
      }
      function He() {
        return ge;
      }
      var Ae = !1, it = null, ut = -1, St = r, sn = -1;
      function zn() {
        var tt = e.unstable_now() - sn;
        return !(tt < St);
      }
      function dn() {
      }
      function $t(tt) {
        if (tt < 0 || tt > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        tt > 0 ? St = Math.floor(1e3 / tt) : St = r;
      }
      var qt = function() {
        if (it !== null) {
          var tt = e.unstable_now();
          sn = tt;
          var bt = !0, rn = !0;
          try {
            rn = it(bt, tt);
          } finally {
            rn ? fn() : (Ae = !1, it = null);
          }
        } else
          Ae = !1;
      }, fn;
      if (typeof X == "function")
        fn = function() {
          X(qt);
        };
      else if (typeof MessageChannel != "undefined") {
        var At = new MessageChannel(), Wt = At.port2;
        At.port1.onmessage = qt, fn = function() {
          Wt.postMessage(null);
        };
      } else
        fn = function() {
          me(qt, 0);
        };
      function Xr(tt) {
        it = tt, Ae || (Ae = !0, fn());
      }
      function Kn(tt, bt) {
        ut = me(function() {
          tt(e.unstable_now());
        }, bt);
      }
      function Sr() {
        xe(ut), ut = -1;
      }
      var jo = dn, ei = null;
      e.unstable_IdlePriority = S, e.unstable_ImmediatePriority = m, e.unstable_LowPriority = b, e.unstable_NormalPriority = y, e.unstable_Profiling = ei, e.unstable_UserBlockingPriority = v, e.unstable_cancelCallback = be, e.unstable_continueExecution = Ee, e.unstable_forceFrameRate = $t, e.unstable_getCurrentPriorityLevel = He, e.unstable_getFirstCallbackNode = le, e.unstable_next = ie, e.unstable_pauseExecution = Ne, e.unstable_requestPaint = jo, e.unstable_runWithPriority = Le, e.unstable_scheduleCallback = we, e.unstable_shouldYield = zn, e.unstable_wrapCallback = $e, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(Hk)), Hk;
}
var UV;
function jee() {
  return UV || (UV = 1, process.env.NODE_ENV === "production" ? xS.exports = T3e() : xS.exports = O3e()), xS.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var GV;
function R3e() {
  if (GV) return ru;
  GV = 1;
  var e = vo, t = jee();
  function n(d) {
    for (var p = "https://reactjs.org/docs/error-decoder.html?invariant=" + d, _ = 1; _ < arguments.length; _++) p += "&args[]=" + encodeURIComponent(arguments[_]);
    return "Minified React error #" + d + "; visit " + p + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = /* @__PURE__ */ new Set(), a = {};
  function o(d, p) {
    s(d, p), s(d + "Capture", p);
  }
  function s(d, p) {
    for (a[d] = p, d = 0; d < p.length; d++) r.add(p[d]);
  }
  var c = !(typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined"), u = Object.prototype.hasOwnProperty, f = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, m = {}, v = {};
  function y(d) {
    return u.call(v, d) ? !0 : u.call(m, d) ? !1 : f.test(d) ? v[d] = !0 : (m[d] = !0, !1);
  }
  function b(d, p, _, I) {
    if (_ !== null && _.type === 0) return !1;
    switch (typeof p) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return I ? !1 : _ !== null ? !_.acceptsBooleans : (d = d.toLowerCase().slice(0, 5), d !== "data-" && d !== "aria-");
      default:
        return !1;
    }
  }
  function S(d, p, _, I) {
    if (p === null || typeof p == "undefined" || b(d, p, _, I)) return !0;
    if (I) return !1;
    if (_ !== null) switch (_.type) {
      case 3:
        return !p;
      case 4:
        return p === !1;
      case 5:
        return isNaN(p);
      case 6:
        return isNaN(p) || 1 > p;
    }
    return !1;
  }
  function x(d, p, _, I, M, j, z) {
    this.acceptsBooleans = p === 2 || p === 3 || p === 4, this.attributeName = I, this.attributeNamespace = M, this.mustUseProperty = _, this.propertyName = d, this.type = p, this.sanitizeURL = j, this.removeEmptyString = z;
  }
  var E = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(d) {
    E[d] = new x(d, 0, !1, d, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(d) {
    var p = d[0];
    E[p] = new x(p, 1, !1, d[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(d) {
    E[d] = new x(d, 2, !1, d.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(d) {
    E[d] = new x(d, 2, !1, d, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(d) {
    E[d] = new x(d, 3, !1, d.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(d) {
    E[d] = new x(d, 3, !0, d, null, !1, !1);
  }), ["capture", "download"].forEach(function(d) {
    E[d] = new x(d, 4, !1, d, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(d) {
    E[d] = new x(d, 6, !1, d, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(d) {
    E[d] = new x(d, 5, !1, d.toLowerCase(), null, !1, !1);
  });
  var N = /[\-:]([a-z])/g;
  function R(d) {
    return d[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(d) {
    var p = d.replace(
      N,
      R
    );
    E[p] = new x(p, 1, !1, d, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(d) {
    var p = d.replace(N, R);
    E[p] = new x(p, 1, !1, d, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(d) {
    var p = d.replace(N, R);
    E[p] = new x(p, 1, !1, d, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(d) {
    E[d] = new x(d, 1, !1, d.toLowerCase(), null, !1, !1);
  }), E.xlinkHref = new x("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(d) {
    E[d] = new x(d, 1, !1, d.toLowerCase(), null, !0, !0);
  });
  function O(d, p, _, I) {
    var M = E.hasOwnProperty(p) ? E[p] : null;
    (M !== null ? M.type !== 0 : I || !(2 < p.length) || p[0] !== "o" && p[0] !== "O" || p[1] !== "n" && p[1] !== "N") && (S(p, _, M, I) && (_ = null), I || M === null ? y(p) && (_ === null ? d.removeAttribute(p) : d.setAttribute(p, "" + _)) : M.mustUseProperty ? d[M.propertyName] = _ === null ? M.type === 3 ? !1 : "" : _ : (p = M.attributeName, I = M.attributeNamespace, _ === null ? d.removeAttribute(p) : (M = M.type, _ = M === 3 || M === 4 && _ === !0 ? "" : "" + _, I ? d.setAttributeNS(I, p, _) : d.setAttribute(p, _))));
  }
  var D = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $ = Symbol.for("react.element"), B = Symbol.for("react.portal"), G = Symbol.for("react.fragment"), Z = Symbol.for("react.strict_mode"), K = Symbol.for("react.profiler"), q = Symbol.for("react.provider"), pe = Symbol.for("react.context"), he = Symbol.for("react.forward_ref"), _e = Symbol.for("react.suspense"), ge = Symbol.for("react.suspense_list"), Y = Symbol.for("react.memo"), ee = Symbol.for("react.lazy"), oe = Symbol.for("react.offscreen"), me = Symbol.iterator;
  function xe(d) {
    return d === null || typeof d != "object" ? null : (d = me && d[me] || d["@@iterator"], typeof d == "function" ? d : null);
  }
  var X = Object.assign, ye;
  function ce(d) {
    if (ye === void 0) try {
      throw Error();
    } catch (_) {
      var p = _.stack.trim().match(/\n( *(at )?)/);
      ye = p && p[1] || "";
    }
    return `
` + ye + d;
  }
  var se = !1;
  function Ie(d, p) {
    if (!d || se) return "";
    se = !0;
    var _ = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (p) if (p = function() {
        throw Error();
      }, Object.defineProperty(p.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(p, []);
        } catch (Xe) {
          var I = Xe;
        }
        Reflect.construct(d, [], p);
      } else {
        try {
          p.call();
        } catch (Xe) {
          I = Xe;
        }
        d.call(p.prototype);
      }
      else {
        try {
          throw Error();
        } catch (Xe) {
          I = Xe;
        }
        d();
      }
    } catch (Xe) {
      if (Xe && I && typeof Xe.stack == "string") {
        for (var M = Xe.stack.split(`
`), j = I.stack.split(`
`), z = M.length - 1, ve = j.length - 1; 1 <= z && 0 <= ve && M[z] !== j[ve]; ) ve--;
        for (; 1 <= z && 0 <= ve; z--, ve--) if (M[z] !== j[ve]) {
          if (z !== 1 || ve !== 1)
            do
              if (z--, ve--, 0 > ve || M[z] !== j[ve]) {
                var ke = `
` + M[z].replace(" at new ", " at ");
                return d.displayName && ke.includes("<anonymous>") && (ke = ke.replace("<anonymous>", d.displayName)), ke;
              }
            while (1 <= z && 0 <= ve);
          break;
        }
      }
    } finally {
      se = !1, Error.prepareStackTrace = _;
    }
    return (d = d ? d.displayName || d.name : "") ? ce(d) : "";
  }
  function Le(d) {
    switch (d.tag) {
      case 5:
        return ce(d.type);
      case 16:
        return ce("Lazy");
      case 13:
        return ce("Suspense");
      case 19:
        return ce("SuspenseList");
      case 0:
      case 2:
      case 15:
        return d = Ie(d.type, !1), d;
      case 11:
        return d = Ie(d.type.render, !1), d;
      case 1:
        return d = Ie(d.type, !0), d;
      default:
        return "";
    }
  }
  function ie(d) {
    if (d == null) return null;
    if (typeof d == "function") return d.displayName || d.name || null;
    if (typeof d == "string") return d;
    switch (d) {
      case G:
        return "Fragment";
      case B:
        return "Portal";
      case K:
        return "Profiler";
      case Z:
        return "StrictMode";
      case _e:
        return "Suspense";
      case ge:
        return "SuspenseList";
    }
    if (typeof d == "object") switch (d.$$typeof) {
      case pe:
        return (d.displayName || "Context") + ".Consumer";
      case q:
        return (d._context.displayName || "Context") + ".Provider";
      case he:
        var p = d.render;
        return d = d.displayName, d || (d = p.displayName || p.name || "", d = d !== "" ? "ForwardRef(" + d + ")" : "ForwardRef"), d;
      case Y:
        return p = d.displayName || null, p !== null ? p : ie(d.type) || "Memo";
      case ee:
        p = d._payload, d = d._init;
        try {
          return ie(d(p));
        } catch (_) {
        }
    }
    return null;
  }
  function $e(d) {
    var p = d.type;
    switch (d.tag) {
      case 24:
        return "Cache";
      case 9:
        return (p.displayName || "Context") + ".Consumer";
      case 10:
        return (p._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return d = p.render, d = d.displayName || d.name || "", p.displayName || (d !== "" ? "ForwardRef(" + d + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return p;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return ie(p);
      case 8:
        return p === Z ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof p == "function") return p.displayName || p.name || null;
        if (typeof p == "string") return p;
    }
    return null;
  }
  function we(d) {
    switch (typeof d) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return d;
      case "object":
        return d;
      default:
        return "";
    }
  }
  function Ne(d) {
    var p = d.type;
    return (d = d.nodeName) && d.toLowerCase() === "input" && (p === "checkbox" || p === "radio");
  }
  function Ee(d) {
    var p = Ne(d) ? "checked" : "value", _ = Object.getOwnPropertyDescriptor(d.constructor.prototype, p), I = "" + d[p];
    if (!d.hasOwnProperty(p) && typeof _ != "undefined" && typeof _.get == "function" && typeof _.set == "function") {
      var M = _.get, j = _.set;
      return Object.defineProperty(d, p, { configurable: !0, get: function() {
        return M.call(this);
      }, set: function(z) {
        I = "" + z, j.call(this, z);
      } }), Object.defineProperty(d, p, { enumerable: _.enumerable }), { getValue: function() {
        return I;
      }, setValue: function(z) {
        I = "" + z;
      }, stopTracking: function() {
        d._valueTracker = null, delete d[p];
      } };
    }
  }
  function le(d) {
    d._valueTracker || (d._valueTracker = Ee(d));
  }
  function be(d) {
    if (!d) return !1;
    var p = d._valueTracker;
    if (!p) return !0;
    var _ = p.getValue(), I = "";
    return d && (I = Ne(d) ? d.checked ? "true" : "false" : d.value), d = I, d !== _ ? (p.setValue(d), !0) : !1;
  }
  function He(d) {
    if (d = d || (typeof document != "undefined" ? document : void 0), typeof d == "undefined") return null;
    try {
      return d.activeElement || d.body;
    } catch (p) {
      return d.body;
    }
  }
  function Ae(d, p) {
    var _ = p.checked;
    return X({}, p, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: _ != null ? _ : d._wrapperState.initialChecked });
  }
  function it(d, p) {
    var _ = p.defaultValue == null ? "" : p.defaultValue, I = p.checked != null ? p.checked : p.defaultChecked;
    _ = we(p.value != null ? p.value : _), d._wrapperState = { initialChecked: I, initialValue: _, controlled: p.type === "checkbox" || p.type === "radio" ? p.checked != null : p.value != null };
  }
  function ut(d, p) {
    p = p.checked, p != null && O(d, "checked", p, !1);
  }
  function St(d, p) {
    ut(d, p);
    var _ = we(p.value), I = p.type;
    if (_ != null) I === "number" ? (_ === 0 && d.value === "" || d.value != _) && (d.value = "" + _) : d.value !== "" + _ && (d.value = "" + _);
    else if (I === "submit" || I === "reset") {
      d.removeAttribute("value");
      return;
    }
    p.hasOwnProperty("value") ? zn(d, p.type, _) : p.hasOwnProperty("defaultValue") && zn(d, p.type, we(p.defaultValue)), p.checked == null && p.defaultChecked != null && (d.defaultChecked = !!p.defaultChecked);
  }
  function sn(d, p, _) {
    if (p.hasOwnProperty("value") || p.hasOwnProperty("defaultValue")) {
      var I = p.type;
      if (!(I !== "submit" && I !== "reset" || p.value !== void 0 && p.value !== null)) return;
      p = "" + d._wrapperState.initialValue, _ || p === d.value || (d.value = p), d.defaultValue = p;
    }
    _ = d.name, _ !== "" && (d.name = ""), d.defaultChecked = !!d._wrapperState.initialChecked, _ !== "" && (d.name = _);
  }
  function zn(d, p, _) {
    (p !== "number" || He(d.ownerDocument) !== d) && (_ == null ? d.defaultValue = "" + d._wrapperState.initialValue : d.defaultValue !== "" + _ && (d.defaultValue = "" + _));
  }
  var dn = Array.isArray;
  function $t(d, p, _, I) {
    if (d = d.options, p) {
      p = {};
      for (var M = 0; M < _.length; M++) p["$" + _[M]] = !0;
      for (_ = 0; _ < d.length; _++) M = p.hasOwnProperty("$" + d[_].value), d[_].selected !== M && (d[_].selected = M), M && I && (d[_].defaultSelected = !0);
    } else {
      for (_ = "" + we(_), p = null, M = 0; M < d.length; M++) {
        if (d[M].value === _) {
          d[M].selected = !0, I && (d[M].defaultSelected = !0);
          return;
        }
        p !== null || d[M].disabled || (p = d[M]);
      }
      p !== null && (p.selected = !0);
    }
  }
  function qt(d, p) {
    if (p.dangerouslySetInnerHTML != null) throw Error(n(91));
    return X({}, p, { value: void 0, defaultValue: void 0, children: "" + d._wrapperState.initialValue });
  }
  function fn(d, p) {
    var _ = p.value;
    if (_ == null) {
      if (_ = p.children, p = p.defaultValue, _ != null) {
        if (p != null) throw Error(n(92));
        if (dn(_)) {
          if (1 < _.length) throw Error(n(93));
          _ = _[0];
        }
        p = _;
      }
      p == null && (p = ""), _ = p;
    }
    d._wrapperState = { initialValue: we(_) };
  }
  function At(d, p) {
    var _ = we(p.value), I = we(p.defaultValue);
    _ != null && (_ = "" + _, _ !== d.value && (d.value = _), p.defaultValue == null && d.defaultValue !== _ && (d.defaultValue = _)), I != null && (d.defaultValue = "" + I);
  }
  function Wt(d) {
    var p = d.textContent;
    p === d._wrapperState.initialValue && p !== "" && p !== null && (d.value = p);
  }
  function Xr(d) {
    switch (d) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Kn(d, p) {
    return d == null || d === "http://www.w3.org/1999/xhtml" ? Xr(p) : d === "http://www.w3.org/2000/svg" && p === "foreignObject" ? "http://www.w3.org/1999/xhtml" : d;
  }
  var Sr, jo = function(d) {
    return typeof MSApp != "undefined" && MSApp.execUnsafeLocalFunction ? function(p, _, I, M) {
      MSApp.execUnsafeLocalFunction(function() {
        return d(p, _, I, M);
      });
    } : d;
  }(function(d, p) {
    if (d.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in d) d.innerHTML = p;
    else {
      for (Sr = Sr || document.createElement("div"), Sr.innerHTML = "<svg>" + p.valueOf().toString() + "</svg>", p = Sr.firstChild; d.firstChild; ) d.removeChild(d.firstChild);
      for (; p.firstChild; ) d.appendChild(p.firstChild);
    }
  });
  function ei(d, p) {
    if (p) {
      var _ = d.firstChild;
      if (_ && _ === d.lastChild && _.nodeType === 3) {
        _.nodeValue = p;
        return;
      }
    }
    d.textContent = p;
  }
  var tt = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, bt = ["Webkit", "ms", "Moz", "O"];
  Object.keys(tt).forEach(function(d) {
    bt.forEach(function(p) {
      p = p + d.charAt(0).toUpperCase() + d.substring(1), tt[p] = tt[d];
    });
  });
  function rn(d, p, _) {
    return p == null || typeof p == "boolean" || p === "" ? "" : _ || typeof p != "number" || p === 0 || tt.hasOwnProperty(d) && tt[d] ? ("" + p).trim() : p + "px";
  }
  function Rn(d, p) {
    d = d.style;
    for (var _ in p) if (p.hasOwnProperty(_)) {
      var I = _.indexOf("--") === 0, M = rn(_, p[_], I);
      _ === "float" && (_ = "cssFloat"), I ? d.setProperty(_, M) : d[_] = M;
    }
  }
  var Cn = X({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Qn(d, p) {
    if (p) {
      if (Cn[d] && (p.children != null || p.dangerouslySetInnerHTML != null)) throw Error(n(137, d));
      if (p.dangerouslySetInnerHTML != null) {
        if (p.children != null) throw Error(n(60));
        if (typeof p.dangerouslySetInnerHTML != "object" || !("__html" in p.dangerouslySetInnerHTML)) throw Error(n(61));
      }
      if (p.style != null && typeof p.style != "object") throw Error(n(62));
    }
  }
  function er(d, p) {
    if (d.indexOf("-") === -1) return typeof p.is == "string";
    switch (d) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var oo = null;
  function Lr(d) {
    return d = d.target || d.srcElement || window, d.correspondingUseElement && (d = d.correspondingUseElement), d.nodeType === 3 ? d.parentNode : d;
  }
  var ia = null, ir = null, xr = null;
  function wo(d) {
    if (d = _v(d)) {
      if (typeof ia != "function") throw Error(n(280));
      var p = d.stateNode;
      p && (p = hn(p), ia(d.stateNode, d.type, p));
    }
  }
  function es(d) {
    ir ? xr ? xr.push(d) : xr = [d] : ir = d;
  }
  function ti() {
    if (ir) {
      var d = ir, p = xr;
      if (xr = ir = null, wo(d), p) for (d = 0; d < p.length; d++) wo(p[d]);
    }
  }
  function bs(d, p) {
    return d(p);
  }
  function _s() {
  }
  var ni = !1;
  function Ka(d, p, _) {
    if (ni) return d(p, _);
    ni = !0;
    try {
      return bs(d, p, _);
    } finally {
      ni = !1, (ir !== null || xr !== null) && (_s(), ti());
    }
  }
  function So(d, p) {
    var _ = d.stateNode;
    if (_ === null) return null;
    var I = hn(_);
    if (I === null) return null;
    _ = I[p];
    e: switch (p) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (I = !I.disabled) || (d = d.type, I = !(d === "button" || d === "input" || d === "select" || d === "textarea")), d = !I;
        break e;
      default:
        d = !1;
    }
    if (d) return null;
    if (_ && typeof _ != "function") throw Error(n(231, p, typeof _));
    return _;
  }
  var Fo = !1;
  if (c) try {
    var Pa = {};
    Object.defineProperty(Pa, "passive", { get: function() {
      Fo = !0;
    } }), window.addEventListener("test", Pa, Pa), window.removeEventListener("test", Pa, Pa);
  } catch (d) {
    Fo = !1;
  }
  function ri(d, p, _, I, M, j, z, ve, ke) {
    var Xe = Array.prototype.slice.call(arguments, 3);
    try {
      p.apply(_, Xe);
    } catch (gt) {
      this.onError(gt);
    }
  }
  var xo = !1, qa = null, ml = !1, bu = null, Ce = { onError: function(d) {
    xo = !0, qa = d;
  } };
  function pt(d, p, _, I, M, j, z, ve, ke) {
    xo = !1, qa = null, ri.apply(Ce, arguments);
  }
  function Nt(d, p, _, I, M, j, z, ve, ke) {
    if (pt.apply(this, arguments), xo) {
      if (xo) {
        var Xe = qa;
        xo = !1, qa = null;
      } else throw Error(n(198));
      ml || (ml = !0, bu = Xe);
    }
  }
  function Vt(d) {
    var p = d, _ = d;
    if (d.alternate) for (; p.return; ) p = p.return;
    else {
      d = p;
      do
        p = d, p.flags & 4098 && (_ = p.return), d = p.return;
      while (d);
    }
    return p.tag === 3 ? _ : null;
  }
  function Mn(d) {
    if (d.tag === 13) {
      var p = d.memoizedState;
      if (p === null && (d = d.alternate, d !== null && (p = d.memoizedState)), p !== null) return p.dehydrated;
    }
    return null;
  }
  function Dn(d) {
    if (Vt(d) !== d) throw Error(n(188));
  }
  function vn(d) {
    var p = d.alternate;
    if (!p) {
      if (p = Vt(d), p === null) throw Error(n(188));
      return p !== d ? null : d;
    }
    for (var _ = d, I = p; ; ) {
      var M = _.return;
      if (M === null) break;
      var j = M.alternate;
      if (j === null) {
        if (I = M.return, I !== null) {
          _ = I;
          continue;
        }
        break;
      }
      if (M.child === j.child) {
        for (j = M.child; j; ) {
          if (j === _) return Dn(M), d;
          if (j === I) return Dn(M), p;
          j = j.sibling;
        }
        throw Error(n(188));
      }
      if (_.return !== I.return) _ = M, I = j;
      else {
        for (var z = !1, ve = M.child; ve; ) {
          if (ve === _) {
            z = !0, _ = M, I = j;
            break;
          }
          if (ve === I) {
            z = !0, I = M, _ = j;
            break;
          }
          ve = ve.sibling;
        }
        if (!z) {
          for (ve = j.child; ve; ) {
            if (ve === _) {
              z = !0, _ = j, I = M;
              break;
            }
            if (ve === I) {
              z = !0, I = j, _ = M;
              break;
            }
            ve = ve.sibling;
          }
          if (!z) throw Error(n(189));
        }
      }
      if (_.alternate !== I) throw Error(n(190));
    }
    if (_.tag !== 3) throw Error(n(188));
    return _.stateNode.current === _ ? d : p;
  }
  function Hn(d) {
    return d = vn(d), d !== null ? Ja(d) : null;
  }
  function Ja(d) {
    if (d.tag === 5 || d.tag === 6) return d;
    for (d = d.child; d !== null; ) {
      var p = Ja(d);
      if (p !== null) return p;
      d = d.sibling;
    }
    return null;
  }
  var Qr = t.unstable_scheduleCallback, sa = t.unstable_cancelCallback, gi = t.unstable_shouldYield, Cs = t.unstable_requestPaint, tr = t.unstable_now, Ra = t.unstable_getCurrentPriorityLevel, Eo = t.unstable_ImmediatePriority, Vn = t.unstable_UserBlockingPriority, Gs = t.unstable_NormalPriority, jf = t.unstable_LowPriority, Ff = t.unstable_IdlePriority, zu = null, ws = null;
  function Bf(d) {
    if (ws && typeof ws.onCommitFiberRoot == "function") try {
      ws.onCommitFiberRoot(zu, d, void 0, (d.current.flags & 128) === 128);
    } catch (p) {
    }
  }
  var Oi = Math.clz32 ? Math.clz32 : qn, ah = Math.log, Pt = Math.LN2;
  function qn(d) {
    return d >>>= 0, d === 0 ? 32 : 31 - (ah(d) / Pt | 0) | 0;
  }
  var xa = 64, $r = 4194304;
  function Qa(d) {
    switch (d & -d) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return d & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return d & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return d;
    }
  }
  function Ln(d, p) {
    var _ = d.pendingLanes;
    if (_ === 0) return 0;
    var I = 0, M = d.suspendedLanes, j = d.pingedLanes, z = _ & 268435455;
    if (z !== 0) {
      var ve = z & ~M;
      ve !== 0 ? I = Qa(ve) : (j &= z, j !== 0 && (I = Qa(j)));
    } else z = _ & ~M, z !== 0 ? I = Qa(z) : j !== 0 && (I = Qa(j));
    if (I === 0) return 0;
    if (p !== 0 && p !== I && !(p & M) && (M = I & -I, j = p & -p, M >= j || M === 16 && (j & 4194240) !== 0)) return p;
    if (I & 4 && (I |= _ & 16), p = d.entangledLanes, p !== 0) for (d = d.entanglements, p &= I; 0 < p; ) _ = 31 - Oi(p), M = 1 << _, I |= d[_], p &= ~M;
    return I;
  }
  function Io(d, p) {
    switch (d) {
      case 1:
      case 2:
      case 4:
        return p + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return p + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function io(d, p) {
    for (var _ = d.suspendedLanes, I = d.pingedLanes, M = d.expirationTimes, j = d.pendingLanes; 0 < j; ) {
      var z = 31 - Oi(j), ve = 1 << z, ke = M[z];
      ke === -1 ? (!(ve & _) || ve & I) && (M[z] = Io(ve, p)) : ke <= p && (d.expiredLanes |= ve), j &= ~ve;
    }
  }
  function ai(d) {
    return d = d.pendingLanes & -1073741825, d !== 0 ? d : d & 1073741824 ? 1073741824 : 0;
  }
  function yi() {
    var d = xa;
    return xa <<= 1, !(xa & 4194240) && (xa = 64), d;
  }
  function _u(d) {
    for (var p = [], _ = 0; 31 > _; _++) p.push(d);
    return p;
  }
  function Ss(d, p, _) {
    d.pendingLanes |= p, p !== 536870912 && (d.suspendedLanes = 0, d.pingedLanes = 0), d = d.eventTimes, p = 31 - Oi(p), d[p] = _;
  }
  function xs(d, p) {
    var _ = d.pendingLanes & ~p;
    d.pendingLanes = p, d.suspendedLanes = 0, d.pingedLanes = 0, d.expiredLanes &= p, d.mutableReadLanes &= p, d.entangledLanes &= p, p = d.entanglements;
    var I = d.eventTimes;
    for (d = d.expirationTimes; 0 < _; ) {
      var M = 31 - Oi(_), j = 1 << M;
      p[M] = 0, I[M] = -1, d[M] = -1, _ &= ~j;
    }
  }
  function ts(d, p) {
    var _ = d.entangledLanes |= p;
    for (d = d.entanglements; _; ) {
      var I = 31 - Oi(_), M = 1 << I;
      M & p | d[I] & p && (d[I] |= p), _ &= ~M;
    }
  }
  var Ar = 0;
  function Mc(d) {
    return d &= -d, 1 < d ? 4 < d ? d & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var oh, Dd, vr, Cu, vl, In = !1, Hu = [], Ua = null, ns = null, rs = null, Vf = /* @__PURE__ */ new Map(), so = /* @__PURE__ */ new Map(), Vr = [], m1 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function oi(d, p) {
    switch (d) {
      case "focusin":
      case "focusout":
        Ua = null;
        break;
      case "dragenter":
      case "dragleave":
        ns = null;
        break;
      case "mouseover":
      case "mouseout":
        rs = null;
        break;
      case "pointerover":
      case "pointerout":
        Vf.delete(p.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        so.delete(p.pointerId);
    }
  }
  function lo(d, p, _, I, M, j) {
    return d === null || d.nativeEvent !== j ? (d = { blockedOn: p, domEventName: _, eventSystemFlags: I, nativeEvent: j, targetContainers: [M] }, p !== null && (p = _v(p), p !== null && Dd(p)), d) : (d.eventSystemFlags |= I, p = d.targetContainers, M !== null && p.indexOf(M) === -1 && p.push(M), d);
  }
  function Wu(d, p, _, I, M) {
    switch (p) {
      case "focusin":
        return Ua = lo(Ua, d, p, _, I, M), !0;
      case "dragenter":
        return ns = lo(ns, d, p, _, I, M), !0;
      case "mouseover":
        return rs = lo(rs, d, p, _, I, M), !0;
      case "pointerover":
        var j = M.pointerId;
        return Vf.set(j, lo(Vf.get(j) || null, d, p, _, I, M)), !0;
      case "gotpointercapture":
        return j = M.pointerId, so.set(j, lo(so.get(j) || null, d, p, _, I, M)), !0;
    }
    return !1;
  }
  function lv(d) {
    var p = Fl(d.target);
    if (p !== null) {
      var _ = Vt(p);
      if (_ !== null) {
        if (p = _.tag, p === 13) {
          if (p = Mn(_), p !== null) {
            d.blockedOn = p, vl(d.priority, function() {
              vr(_);
            });
            return;
          }
        } else if (p === 3 && _.stateNode.current.memoizedState.isDehydrated) {
          d.blockedOn = _.tag === 3 ? _.stateNode.containerInfo : null;
          return;
        }
      }
    }
    d.blockedOn = null;
  }
  function Ld(d) {
    if (d.blockedOn !== null) return !1;
    for (var p = d.targetContainers; 0 < p.length; ) {
      var _ = Ur(d.domEventName, d.eventSystemFlags, p[0], d.nativeEvent);
      if (_ === null) {
        _ = d.nativeEvent;
        var I = new _.constructor(_.type, _);
        oo = I, _.target.dispatchEvent(I), oo = null;
      } else return p = _v(_), p !== null && Dd(p), d.blockedOn = _, !1;
      p.shift();
    }
    return !0;
  }
  function ih(d, p, _) {
    Ld(d) && _.delete(p);
  }
  function v1() {
    In = !1, Ua !== null && Ld(Ua) && (Ua = null), ns !== null && Ld(ns) && (ns = null), rs !== null && Ld(rs) && (rs = null), Vf.forEach(ih), so.forEach(ih);
  }
  function Uf(d, p) {
    d.blockedOn === p && (d.blockedOn = null, In || (In = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, v1)));
  }
  function $d(d) {
    function p(M) {
      return Uf(M, d);
    }
    if (0 < Hu.length) {
      Uf(Hu[0], d);
      for (var _ = 1; _ < Hu.length; _++) {
        var I = Hu[_];
        I.blockedOn === d && (I.blockedOn = null);
      }
    }
    for (Ua !== null && Uf(Ua, d), ns !== null && Uf(ns, d), rs !== null && Uf(rs, d), Vf.forEach(p), so.forEach(p), _ = 0; _ < Vr.length; _++) I = Vr[_], I.blockedOn === d && (I.blockedOn = null);
    for (; 0 < Vr.length && (_ = Vr[0], _.blockedOn === null); ) lv(_), _.blockedOn === null && Vr.shift();
  }
  var jd = D.ReactCurrentBatchConfig, ue = !0;
  function De(d, p, _, I) {
    var M = Ar, j = jd.transition;
    jd.transition = null;
    try {
      Ar = 1, Xt(d, p, _, I);
    } finally {
      Ar = M, jd.transition = j;
    }
  }
  function qe(d, p, _, I) {
    var M = Ar, j = jd.transition;
    jd.transition = null;
    try {
      Ar = 4, Xt(d, p, _, I);
    } finally {
      Ar = M, jd.transition = j;
    }
  }
  function Xt(d, p, _, I) {
    if (ue) {
      var M = Ur(d, p, _, I);
      if (M === null) A1(d, p, I, sr, _), oi(d, I);
      else if (Wu(M, d, p, _, I)) I.stopPropagation();
      else if (oi(d, I), p & 4 && -1 < m1.indexOf(d)) {
        for (; M !== null; ) {
          var j = _v(M);
          if (j !== null && oh(j), j = Ur(d, p, _, I), j === null && A1(d, p, I, sr, _), j === M) break;
          M = j;
        }
        M !== null && I.stopPropagation();
      } else A1(d, p, I, null, _);
    }
  }
  var sr = null;
  function Ur(d, p, _, I) {
    if (sr = null, d = Lr(I), d = Fl(d), d !== null) if (p = Vt(d), p === null) d = null;
    else if (_ = p.tag, _ === 13) {
      if (d = Mn(p), d !== null) return d;
      d = null;
    } else if (_ === 3) {
      if (p.stateNode.current.memoizedState.isDehydrated) return p.tag === 3 ? p.stateNode.containerInfo : null;
      d = null;
    } else p !== d && (d = null);
    return sr = d, null;
  }
  function ha(d) {
    switch (d) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Ra()) {
          case Eo:
            return 1;
          case Vn:
            return 4;
          case Gs:
          case jf:
            return 16;
          case Ff:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var nr = null, ea = null, Ri = null;
  function Mi() {
    if (Ri) return Ri;
    var d, p = ea, _ = p.length, I, M = "value" in nr ? nr.value : nr.textContent, j = M.length;
    for (d = 0; d < _ && p[d] === M[d]; d++) ;
    var z = _ - d;
    for (I = 1; I <= z && p[_ - I] === M[j - I]; I++) ;
    return Ri = M.slice(d, 1 < I ? 1 - I : void 0);
  }
  function $l(d) {
    var p = d.keyCode;
    return "charCode" in d ? (d = d.charCode, d === 0 && p === 13 && (d = 13)) : d = p, d === 10 && (d = 13), 32 <= d || d === 13 ? d : 0;
  }
  function Dc() {
    return !0;
  }
  function sh() {
    return !1;
  }
  function as(d) {
    function p(_, I, M, j, z) {
      this._reactName = _, this._targetInst = M, this.type = I, this.nativeEvent = j, this.target = z, this.currentTarget = null;
      for (var ve in d) d.hasOwnProperty(ve) && (_ = d[ve], this[ve] = _ ? _(j) : j[ve]);
      return this.isDefaultPrevented = (j.defaultPrevented != null ? j.defaultPrevented : j.returnValue === !1) ? Dc : sh, this.isPropagationStopped = sh, this;
    }
    return X(p.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var _ = this.nativeEvent;
      _ && (_.preventDefault ? _.preventDefault() : typeof _.returnValue != "unknown" && (_.returnValue = !1), this.isDefaultPrevented = Dc);
    }, stopPropagation: function() {
      var _ = this.nativeEvent;
      _ && (_.stopPropagation ? _.stopPropagation() : typeof _.cancelBubble != "unknown" && (_.cancelBubble = !0), this.isPropagationStopped = Dc);
    }, persist: function() {
    }, isPersistent: Dc }), p;
  }
  var Fd = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(d) {
    return d.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, g1 = as(Fd), lh = X({}, Fd, { view: 0, detail: 0 }), yC = as(lh), y1, Y2, uv, bi = X({}, lh, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: J2, button: 0, buttons: 0, relatedTarget: function(d) {
    return d.relatedTarget === void 0 ? d.fromElement === d.srcElement ? d.toElement : d.fromElement : d.relatedTarget;
  }, movementX: function(d) {
    return "movementX" in d ? d.movementX : (d !== uv && (uv && d.type === "mousemove" ? (y1 = d.screenX - uv.screenX, Y2 = d.screenY - uv.screenY) : Y2 = y1 = 0, uv = d), y1);
  }, movementY: function(d) {
    return "movementY" in d ? d.movementY : Y2;
  } }), b1 = as(bi), bC = X({}, bi, { dataTransfer: 0 }), _C = as(bC), e9 = X({}, lh, { relatedTarget: 0 }), Bd = as(e9), X2 = X({}, Fd, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), CC = as(X2), t9 = X({}, Fd, { clipboardData: function(d) {
    return "clipboardData" in d ? d.clipboardData : window.clipboardData;
  } }), n9 = as(t9), r9 = X({}, Fd, { data: 0 }), K2 = as(r9), q2 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, wC = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, SC = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function xC(d) {
    var p = this.nativeEvent;
    return p.getModifierState ? p.getModifierState(d) : (d = SC[d]) ? !!p[d] : !1;
  }
  function J2() {
    return xC;
  }
  var Lc = X({}, lh, { key: function(d) {
    if (d.key) {
      var p = q2[d.key] || d.key;
      if (p !== "Unidentified") return p;
    }
    return d.type === "keypress" ? (d = $l(d), d === 13 ? "Enter" : String.fromCharCode(d)) : d.type === "keydown" || d.type === "keyup" ? wC[d.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: J2, charCode: function(d) {
    return d.type === "keypress" ? $l(d) : 0;
  }, keyCode: function(d) {
    return d.type === "keydown" || d.type === "keyup" ? d.keyCode : 0;
  }, which: function(d) {
    return d.type === "keypress" ? $l(d) : d.type === "keydown" || d.type === "keyup" ? d.keyCode : 0;
  } }), a9 = as(Lc), Q2 = X({}, bi, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), _1 = as(Q2), eb = X({}, lh, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: J2 }), o9 = as(eb), C1 = X({}, Fd, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), EC = as(C1), zs = X({}, bi, {
    deltaX: function(d) {
      return "deltaX" in d ? d.deltaX : "wheelDeltaX" in d ? -d.wheelDeltaX : 0;
    },
    deltaY: function(d) {
      return "deltaY" in d ? d.deltaY : "wheelDeltaY" in d ? -d.wheelDeltaY : "wheelDelta" in d ? -d.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), $c = as(zs), Bo = [9, 13, 27, 32], wu = c && "CompositionEvent" in window, Gf = null;
  c && "documentMode" in document && (Gf = document.documentMode);
  var w1 = c && "TextEvent" in window && !Gf, IC = c && (!wu || Gf && 8 < Gf && 11 >= Gf), uh = " ", kC = !1;
  function AC(d, p) {
    switch (d) {
      case "keyup":
        return Bo.indexOf(p.keyCode) !== -1;
      case "keydown":
        return p.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function S1(d) {
    return d = d.detail, typeof d == "object" && "data" in d ? d.data : null;
  }
  var ch = !1;
  function i9(d, p) {
    switch (d) {
      case "compositionend":
        return S1(p);
      case "keypress":
        return p.which !== 32 ? null : (kC = !0, uh);
      case "textInput":
        return d = p.data, d === uh && kC ? null : d;
      default:
        return null;
    }
  }
  function s9(d, p) {
    if (ch) return d === "compositionend" || !wu && AC(d, p) ? (d = Mi(), Ri = ea = nr = null, ch = !1, d) : null;
    switch (d) {
      case "paste":
        return null;
      case "keypress":
        if (!(p.ctrlKey || p.altKey || p.metaKey) || p.ctrlKey && p.altKey) {
          if (p.char && 1 < p.char.length) return p.char;
          if (p.which) return String.fromCharCode(p.which);
        }
        return null;
      case "compositionend":
        return IC && p.locale !== "ko" ? null : p.data;
      default:
        return null;
    }
  }
  var PC = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function NC(d) {
    var p = d && d.nodeName && d.nodeName.toLowerCase();
    return p === "input" ? !!PC[d.type] : p === "textarea";
  }
  function TC(d, p, _, I) {
    es(I), p = gv(p, "onChange"), 0 < p.length && (_ = new g1("onChange", "change", null, _, I), d.push({ event: _, listeners: p }));
  }
  var cv = null, dh = null;
  function fh(d) {
    k1(d, 0);
  }
  function ph(d) {
    var p = mh(d);
    if (be(p)) return d;
  }
  function OC(d, p) {
    if (d === "change") return p;
  }
  var tb = !1;
  if (c) {
    var nb;
    if (c) {
      var rb = "oninput" in document;
      if (!rb) {
        var RC = document.createElement("div");
        RC.setAttribute("oninput", "return;"), rb = typeof RC.oninput == "function";
      }
      nb = rb;
    } else nb = !1;
    tb = nb && (!document.documentMode || 9 < document.documentMode);
  }
  function MC() {
    cv && (cv.detachEvent("onpropertychange", DC), dh = cv = null);
  }
  function DC(d) {
    if (d.propertyName === "value" && ph(dh)) {
      var p = [];
      TC(p, dh, d, Lr(d)), Ka(fh, p);
    }
  }
  function l9(d, p, _) {
    d === "focusin" ? (MC(), cv = p, dh = _, cv.attachEvent("onpropertychange", DC)) : d === "focusout" && MC();
  }
  function u9(d) {
    if (d === "selectionchange" || d === "keyup" || d === "keydown") return ph(dh);
  }
  function c9(d, p) {
    if (d === "click") return ph(p);
  }
  function LC(d, p) {
    if (d === "input" || d === "change") return ph(p);
  }
  function d9(d, p) {
    return d === p && (d !== 0 || 1 / d === 1 / p) || d !== d && p !== p;
  }
  var jl = typeof Object.is == "function" ? Object.is : d9;
  function dv(d, p) {
    if (jl(d, p)) return !0;
    if (typeof d != "object" || d === null || typeof p != "object" || p === null) return !1;
    var _ = Object.keys(d), I = Object.keys(p);
    if (_.length !== I.length) return !1;
    for (I = 0; I < _.length; I++) {
      var M = _[I];
      if (!u.call(p, M) || !jl(d[M], p[M])) return !1;
    }
    return !0;
  }
  function $C(d) {
    for (; d && d.firstChild; ) d = d.firstChild;
    return d;
  }
  function jC(d, p) {
    var _ = $C(d);
    d = 0;
    for (var I; _; ) {
      if (_.nodeType === 3) {
        if (I = d + _.textContent.length, d <= p && I >= p) return { node: _, offset: p - d };
        d = I;
      }
      e: {
        for (; _; ) {
          if (_.nextSibling) {
            _ = _.nextSibling;
            break e;
          }
          _ = _.parentNode;
        }
        _ = void 0;
      }
      _ = $C(_);
    }
  }
  function FC(d, p) {
    return d && p ? d === p ? !0 : d && d.nodeType === 3 ? !1 : p && p.nodeType === 3 ? FC(d, p.parentNode) : "contains" in d ? d.contains(p) : d.compareDocumentPosition ? !!(d.compareDocumentPosition(p) & 16) : !1 : !1;
  }
  function x1() {
    for (var d = window, p = He(); p instanceof d.HTMLIFrameElement; ) {
      try {
        var _ = typeof p.contentWindow.location.href == "string";
      } catch (I) {
        _ = !1;
      }
      if (_) d = p.contentWindow;
      else break;
      p = He(d.document);
    }
    return p;
  }
  function jc(d) {
    var p = d && d.nodeName && d.nodeName.toLowerCase();
    return p && (p === "input" && (d.type === "text" || d.type === "search" || d.type === "tel" || d.type === "url" || d.type === "password") || p === "textarea" || d.contentEditable === "true");
  }
  function E1(d) {
    var p = x1(), _ = d.focusedElem, I = d.selectionRange;
    if (p !== _ && _ && _.ownerDocument && FC(_.ownerDocument.documentElement, _)) {
      if (I !== null && jc(_)) {
        if (p = I.start, d = I.end, d === void 0 && (d = p), "selectionStart" in _) _.selectionStart = p, _.selectionEnd = Math.min(d, _.value.length);
        else if (d = (p = _.ownerDocument || document) && p.defaultView || window, d.getSelection) {
          d = d.getSelection();
          var M = _.textContent.length, j = Math.min(I.start, M);
          I = I.end === void 0 ? j : Math.min(I.end, M), !d.extend && j > I && (M = I, I = j, j = M), M = jC(_, j);
          var z = jC(
            _,
            I
          );
          M && z && (d.rangeCount !== 1 || d.anchorNode !== M.node || d.anchorOffset !== M.offset || d.focusNode !== z.node || d.focusOffset !== z.offset) && (p = p.createRange(), p.setStart(M.node, M.offset), d.removeAllRanges(), j > I ? (d.addRange(p), d.extend(z.node, z.offset)) : (p.setEnd(z.node, z.offset), d.addRange(p)));
        }
      }
      for (p = [], d = _; d = d.parentNode; ) d.nodeType === 1 && p.push({ element: d, left: d.scrollLeft, top: d.scrollTop });
      for (typeof _.focus == "function" && _.focus(), _ = 0; _ < p.length; _++) d = p[_], d.element.scrollLeft = d.left, d.element.scrollTop = d.top;
    }
  }
  var BC = c && "documentMode" in document && 11 >= document.documentMode, Su = null, ab = null, fv = null, ob = !1;
  function VC(d, p, _) {
    var I = _.window === _ ? _.document : _.nodeType === 9 ? _ : _.ownerDocument;
    ob || Su == null || Su !== He(I) || (I = Su, "selectionStart" in I && jc(I) ? I = { start: I.selectionStart, end: I.selectionEnd } : (I = (I.ownerDocument && I.ownerDocument.defaultView || window).getSelection(), I = { anchorNode: I.anchorNode, anchorOffset: I.anchorOffset, focusNode: I.focusNode, focusOffset: I.focusOffset }), fv && dv(fv, I) || (fv = I, I = gv(ab, "onSelect"), 0 < I.length && (p = new g1("onSelect", "select", null, p, _), d.push({ event: p, listeners: I }), p.target = Su)));
  }
  function I1(d, p) {
    var _ = {};
    return _[d.toLowerCase()] = p.toLowerCase(), _["Webkit" + d] = "webkit" + p, _["Moz" + d] = "moz" + p, _;
  }
  var zf = { animationend: I1("Animation", "AnimationEnd"), animationiteration: I1("Animation", "AnimationIteration"), animationstart: I1("Animation", "AnimationStart"), transitionend: I1("Transition", "TransitionEnd") }, ib = {}, sb = {};
  c && (sb = document.createElement("div").style, "AnimationEvent" in window || (delete zf.animationend.animation, delete zf.animationiteration.animation, delete zf.animationstart.animation), "TransitionEvent" in window || delete zf.transitionend.transition);
  function _i(d) {
    if (ib[d]) return ib[d];
    if (!zf[d]) return d;
    var p = zf[d], _;
    for (_ in p) if (p.hasOwnProperty(_) && _ in sb) return ib[d] = p[_];
    return d;
  }
  var lb = _i("animationend"), UC = _i("animationiteration"), GC = _i("animationstart"), zC = _i("transitionend"), HC = /* @__PURE__ */ new Map(), WC = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Fc(d, p) {
    HC.set(d, p), o(p, [d]);
  }
  for (var pv = 0; pv < WC.length; pv++) {
    var Hf = WC[pv], f9 = Hf.toLowerCase(), hv = Hf[0].toUpperCase() + Hf.slice(1);
    Fc(f9, "on" + hv);
  }
  Fc(lb, "onAnimationEnd"), Fc(UC, "onAnimationIteration"), Fc(GC, "onAnimationStart"), Fc("dblclick", "onDoubleClick"), Fc("focusin", "onFocus"), Fc("focusout", "onBlur"), Fc(zC, "onTransitionEnd"), s("onMouseEnter", ["mouseout", "mouseover"]), s("onMouseLeave", ["mouseout", "mouseover"]), s("onPointerEnter", ["pointerout", "pointerover"]), s("onPointerLeave", ["pointerout", "pointerover"]), o("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), o("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), o("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), o("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), o("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), o("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var mv = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), p9 = new Set("cancel close invalid load scroll toggle".split(" ").concat(mv));
  function ZC(d, p, _) {
    var I = d.type || "unknown-event";
    d.currentTarget = _, Nt(I, p, void 0, d), d.currentTarget = null;
  }
  function k1(d, p) {
    p = (p & 4) !== 0;
    for (var _ = 0; _ < d.length; _++) {
      var I = d[_], M = I.event;
      I = I.listeners;
      e: {
        var j = void 0;
        if (p) for (var z = I.length - 1; 0 <= z; z--) {
          var ve = I[z], ke = ve.instance, Xe = ve.currentTarget;
          if (ve = ve.listener, ke !== j && M.isPropagationStopped()) break e;
          ZC(M, ve, Xe), j = ke;
        }
        else for (z = 0; z < I.length; z++) {
          if (ve = I[z], ke = ve.instance, Xe = ve.currentTarget, ve = ve.listener, ke !== j && M.isPropagationStopped()) break e;
          ZC(M, ve, Xe), j = ke;
        }
      }
    }
    if (ml) throw d = bu, ml = !1, bu = null, d;
  }
  function Ea(d, p) {
    var _ = p[mb];
    _ === void 0 && (_ = p[mb] = /* @__PURE__ */ new Set());
    var I = d + "__bubble";
    _.has(I) || (YC(p, d, 2, !1), _.add(I));
  }
  function Vd(d, p, _) {
    var I = 0;
    p && (I |= 4), YC(_, d, I, p);
  }
  var Bc = "_reactListening" + Math.random().toString(36).slice(2);
  function hh(d) {
    if (!d[Bc]) {
      d[Bc] = !0, r.forEach(function(_) {
        _ !== "selectionchange" && (p9.has(_) || Vd(_, !1, d), Vd(_, !0, d));
      });
      var p = d.nodeType === 9 ? d : d.ownerDocument;
      p === null || p[Bc] || (p[Bc] = !0, Vd("selectionchange", !1, p));
    }
  }
  function YC(d, p, _, I) {
    switch (ha(p)) {
      case 1:
        var M = De;
        break;
      case 4:
        M = qe;
        break;
      default:
        M = Xt;
    }
    _ = M.bind(null, p, _, d), M = void 0, !Fo || p !== "touchstart" && p !== "touchmove" && p !== "wheel" || (M = !0), I ? M !== void 0 ? d.addEventListener(p, _, { capture: !0, passive: M }) : d.addEventListener(p, _, !0) : M !== void 0 ? d.addEventListener(p, _, { passive: M }) : d.addEventListener(p, _, !1);
  }
  function A1(d, p, _, I, M) {
    var j = I;
    if (!(p & 1) && !(p & 2) && I !== null) e: for (; ; ) {
      if (I === null) return;
      var z = I.tag;
      if (z === 3 || z === 4) {
        var ve = I.stateNode.containerInfo;
        if (ve === M || ve.nodeType === 8 && ve.parentNode === M) break;
        if (z === 4) for (z = I.return; z !== null; ) {
          var ke = z.tag;
          if ((ke === 3 || ke === 4) && (ke = z.stateNode.containerInfo, ke === M || ke.nodeType === 8 && ke.parentNode === M)) return;
          z = z.return;
        }
        for (; ve !== null; ) {
          if (z = Fl(ve), z === null) return;
          if (ke = z.tag, ke === 5 || ke === 6) {
            I = j = z;
            continue e;
          }
          ve = ve.parentNode;
        }
      }
      I = I.return;
    }
    Ka(function() {
      var Xe = j, gt = Lr(_), _t = [];
      e: {
        var ht = HC.get(d);
        if (ht !== void 0) {
          var Ut = g1, Jt = d;
          switch (d) {
            case "keypress":
              if ($l(_) === 0) break e;
            case "keydown":
            case "keyup":
              Ut = a9;
              break;
            case "focusin":
              Jt = "focus", Ut = Bd;
              break;
            case "focusout":
              Jt = "blur", Ut = Bd;
              break;
            case "beforeblur":
            case "afterblur":
              Ut = Bd;
              break;
            case "click":
              if (_.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Ut = b1;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Ut = _C;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Ut = o9;
              break;
            case lb:
            case UC:
            case GC:
              Ut = CC;
              break;
            case zC:
              Ut = EC;
              break;
            case "scroll":
              Ut = yC;
              break;
            case "wheel":
              Ut = $c;
              break;
            case "copy":
            case "cut":
            case "paste":
              Ut = n9;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Ut = _1;
          }
          var nn = (p & 4) !== 0, Po = !nn && d === "scroll", Be = nn ? ht !== null ? ht + "Capture" : null : ht;
          nn = [];
          for (var Re = Xe, Ge; Re !== null; ) {
            Ge = Re;
            var xt = Ge.stateNode;
            if (Ge.tag === 5 && xt !== null && (Ge = xt, Be !== null && (xt = So(Re, Be), xt != null && nn.push(vv(Re, xt, Ge)))), Po) break;
            Re = Re.return;
          }
          0 < nn.length && (ht = new Ut(ht, Jt, null, _, gt), _t.push({ event: ht, listeners: nn }));
        }
      }
      if (!(p & 7)) {
        e: {
          if (ht = d === "mouseover" || d === "pointerover", Ut = d === "mouseout" || d === "pointerout", ht && _ !== oo && (Jt = _.relatedTarget || _.fromElement) && (Fl(Jt) || Jt[Vc])) break e;
          if ((Ut || ht) && (ht = gt.window === gt ? gt : (ht = gt.ownerDocument) ? ht.defaultView || ht.parentWindow : window, Ut ? (Jt = _.relatedTarget || _.toElement, Ut = Xe, Jt = Jt ? Fl(Jt) : null, Jt !== null && (Po = Vt(Jt), Jt !== Po || Jt.tag !== 5 && Jt.tag !== 6) && (Jt = null)) : (Ut = null, Jt = Xe), Ut !== Jt)) {
            if (nn = b1, xt = "onMouseLeave", Be = "onMouseEnter", Re = "mouse", (d === "pointerout" || d === "pointerover") && (nn = _1, xt = "onPointerLeave", Be = "onPointerEnter", Re = "pointer"), Po = Ut == null ? ht : mh(Ut), Ge = Jt == null ? ht : mh(Jt), ht = new nn(xt, Re + "leave", Ut, _, gt), ht.target = Po, ht.relatedTarget = Ge, xt = null, Fl(gt) === Xe && (nn = new nn(Be, Re + "enter", Jt, _, gt), nn.target = Ge, nn.relatedTarget = Po, xt = nn), Po = xt, Ut && Jt) t: {
              for (nn = Ut, Be = Jt, Re = 0, Ge = nn; Ge; Ge = Wf(Ge)) Re++;
              for (Ge = 0, xt = Be; xt; xt = Wf(xt)) Ge++;
              for (; 0 < Re - Ge; ) nn = Wf(nn), Re--;
              for (; 0 < Ge - Re; ) Be = Wf(Be), Ge--;
              for (; Re--; ) {
                if (nn === Be || Be !== null && nn === Be.alternate) break t;
                nn = Wf(nn), Be = Wf(Be);
              }
              nn = null;
            }
            else nn = null;
            Ut !== null && ub(_t, ht, Ut, nn, !1), Jt !== null && Po !== null && ub(_t, Po, Jt, nn, !0);
          }
        }
        e: {
          if (ht = Xe ? mh(Xe) : window, Ut = ht.nodeName && ht.nodeName.toLowerCase(), Ut === "select" || Ut === "input" && ht.type === "file") var on = OC;
          else if (NC(ht)) if (tb) on = LC;
          else {
            on = u9;
            var bn = l9;
          }
          else (Ut = ht.nodeName) && Ut.toLowerCase() === "input" && (ht.type === "checkbox" || ht.type === "radio") && (on = c9);
          if (on && (on = on(d, Xe))) {
            TC(_t, on, _, gt);
            break e;
          }
          bn && bn(d, ht, Xe), d === "focusout" && (bn = ht._wrapperState) && bn.controlled && ht.type === "number" && zn(ht, "number", ht.value);
        }
        switch (bn = Xe ? mh(Xe) : window, d) {
          case "focusin":
            (NC(bn) || bn.contentEditable === "true") && (Su = bn, ab = Xe, fv = null);
            break;
          case "focusout":
            fv = ab = Su = null;
            break;
          case "mousedown":
            ob = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            ob = !1, VC(_t, _, gt);
            break;
          case "selectionchange":
            if (BC) break;
          case "keydown":
          case "keyup":
            VC(_t, _, gt);
        }
        var Qt;
        if (wu) e: {
          switch (d) {
            case "compositionstart":
              var wn = "onCompositionStart";
              break e;
            case "compositionend":
              wn = "onCompositionEnd";
              break e;
            case "compositionupdate":
              wn = "onCompositionUpdate";
              break e;
          }
          wn = void 0;
        }
        else ch ? AC(d, _) && (wn = "onCompositionEnd") : d === "keydown" && _.keyCode === 229 && (wn = "onCompositionStart");
        wn && (IC && _.locale !== "ko" && (ch || wn !== "onCompositionStart" ? wn === "onCompositionEnd" && ch && (Qt = Mi()) : (nr = gt, ea = "value" in nr ? nr.value : nr.textContent, ch = !0)), bn = gv(Xe, wn), 0 < bn.length && (wn = new K2(wn, d, null, _, gt), _t.push({ event: wn, listeners: bn }), Qt ? wn.data = Qt : (Qt = S1(_), Qt !== null && (wn.data = Qt)))), (Qt = w1 ? i9(d, _) : s9(d, _)) && (Xe = gv(Xe, "onBeforeInput"), 0 < Xe.length && (gt = new K2("onBeforeInput", "beforeinput", null, _, gt), _t.push({ event: gt, listeners: Xe }), gt.data = Qt));
      }
      k1(_t, p);
    });
  }
  function vv(d, p, _) {
    return { instance: d, listener: p, currentTarget: _ };
  }
  function gv(d, p) {
    for (var _ = p + "Capture", I = []; d !== null; ) {
      var M = d, j = M.stateNode;
      M.tag === 5 && j !== null && (M = j, j = So(d, _), j != null && I.unshift(vv(d, j, M)), j = So(d, p), j != null && I.push(vv(d, j, M))), d = d.return;
    }
    return I;
  }
  function Wf(d) {
    if (d === null) return null;
    do
      d = d.return;
    while (d && d.tag !== 5);
    return d || null;
  }
  function ub(d, p, _, I, M) {
    for (var j = p._reactName, z = []; _ !== null && _ !== I; ) {
      var ve = _, ke = ve.alternate, Xe = ve.stateNode;
      if (ke !== null && ke === I) break;
      ve.tag === 5 && Xe !== null && (ve = Xe, M ? (ke = So(_, j), ke != null && z.unshift(vv(_, ke, ve))) : M || (ke = So(_, j), ke != null && z.push(vv(_, ke, ve)))), _ = _.return;
    }
    z.length !== 0 && d.push({ event: p, listeners: z });
  }
  var cb = /\r\n?/g, h9 = /\u0000|\uFFFD/g;
  function db(d) {
    return (typeof d == "string" ? d : "" + d).replace(cb, `
`).replace(h9, "");
  }
  function P1(d, p, _) {
    if (p = db(p), db(d) !== p && _) throw Error(n(425));
  }
  function N1() {
  }
  var fb = null, Zf = null;
  function yv(d, p) {
    return d === "textarea" || d === "noscript" || typeof p.children == "string" || typeof p.children == "number" || typeof p.dangerouslySetInnerHTML == "object" && p.dangerouslySetInnerHTML !== null && p.dangerouslySetInnerHTML.__html != null;
  }
  var Yf = typeof setTimeout == "function" ? setTimeout : void 0, XC = typeof clearTimeout == "function" ? clearTimeout : void 0, pb = typeof Promise == "function" ? Promise : void 0, hb = typeof queueMicrotask == "function" ? queueMicrotask : typeof pb != "undefined" ? function(d) {
    return pb.resolve(null).then(d).catch(m9);
  } : Yf;
  function m9(d) {
    setTimeout(function() {
      throw d;
    });
  }
  function Ud(d, p) {
    var _ = p, I = 0;
    do {
      var M = _.nextSibling;
      if (d.removeChild(_), M && M.nodeType === 8) if (_ = M.data, _ === "/$") {
        if (I === 0) {
          d.removeChild(M), $d(p);
          return;
        }
        I--;
      } else _ !== "$" && _ !== "$?" && _ !== "$!" || I++;
      _ = M;
    } while (_);
    $d(p);
  }
  function xu(d) {
    for (; d != null; d = d.nextSibling) {
      var p = d.nodeType;
      if (p === 1 || p === 3) break;
      if (p === 8) {
        if (p = d.data, p === "$" || p === "$!" || p === "$?") break;
        if (p === "/$") return null;
      }
    }
    return d;
  }
  function bv(d) {
    d = d.previousSibling;
    for (var p = 0; d; ) {
      if (d.nodeType === 8) {
        var _ = d.data;
        if (_ === "$" || _ === "$!" || _ === "$?") {
          if (p === 0) return d;
          p--;
        } else _ === "/$" && p++;
      }
      d = d.previousSibling;
    }
    return null;
  }
  var Gd = Math.random().toString(36).slice(2), Zu = "__reactFiber$" + Gd, Xf = "__reactProps$" + Gd, Vc = "__reactContainer$" + Gd, mb = "__reactEvents$" + Gd, v9 = "__reactListeners$" + Gd, vb = "__reactHandles$" + Gd;
  function Fl(d) {
    var p = d[Zu];
    if (p) return p;
    for (var _ = d.parentNode; _; ) {
      if (p = _[Vc] || _[Zu]) {
        if (_ = p.alternate, p.child !== null || _ !== null && _.child !== null) for (d = bv(d); d !== null; ) {
          if (_ = d[Zu]) return _;
          d = bv(d);
        }
        return p;
      }
      d = _, _ = d.parentNode;
    }
    return null;
  }
  function _v(d) {
    return d = d[Zu] || d[Vc], !d || d.tag !== 5 && d.tag !== 6 && d.tag !== 13 && d.tag !== 3 ? null : d;
  }
  function mh(d) {
    if (d.tag === 5 || d.tag === 6) return d.stateNode;
    throw Error(n(33));
  }
  function hn(d) {
    return d[Xf] || null;
  }
  var zd = [], Ma = -1;
  function Yn(d) {
    return { current: d };
  }
  function Kr(d) {
    0 > Ma || (d.current = zd[Ma], zd[Ma] = null, Ma--);
  }
  function ta(d, p) {
    Ma++, zd[Ma] = d.current, d.current = p;
  }
  var Yu = {}, $n = Yn(Yu), uo = Yn(!1), Hs = Yu;
  function Bl(d, p) {
    var _ = d.type.contextTypes;
    if (!_) return Yu;
    var I = d.stateNode;
    if (I && I.__reactInternalMemoizedUnmaskedChildContext === p) return I.__reactInternalMemoizedMaskedChildContext;
    var M = {}, j;
    for (j in _) M[j] = p[j];
    return I && (d = d.stateNode, d.__reactInternalMemoizedUnmaskedChildContext = p, d.__reactInternalMemoizedMaskedChildContext = M), M;
  }
  function Ga(d) {
    return d = d.childContextTypes, d != null;
  }
  function Vl() {
    Kr(uo), Kr($n);
  }
  function Hd(d, p, _) {
    if ($n.current !== Yu) throw Error(n(168));
    ta($n, p), ta(uo, _);
  }
  function Cv(d, p, _) {
    var I = d.stateNode;
    if (p = p.childContextTypes, typeof I.getChildContext != "function") return _;
    I = I.getChildContext();
    for (var M in I) if (!(M in p)) throw Error(n(108, $e(d) || "Unknown", M));
    return X({}, _, I);
  }
  function T1(d) {
    return d = (d = d.stateNode) && d.__reactInternalMemoizedMergedChildContext || Yu, Hs = $n.current, ta($n, d), ta(uo, uo.current), !0;
  }
  function KC(d, p, _) {
    var I = d.stateNode;
    if (!I) throw Error(n(169));
    _ ? (d = Cv(d, p, Hs), I.__reactInternalMemoizedMergedChildContext = d, Kr(uo), Kr($n), ta($n, d)) : Kr(uo), ta(uo, _);
  }
  var gl = null, Ci = !1, wv = !1;
  function gb(d) {
    gl === null ? gl = [d] : gl.push(d);
  }
  function yb(d) {
    Ci = !0, gb(d);
  }
  function Ws() {
    if (!wv && gl !== null) {
      wv = !0;
      var d = 0, p = Ar;
      try {
        var _ = gl;
        for (Ar = 1; d < _.length; d++) {
          var I = _[d];
          do
            I = I(!0);
          while (I !== null);
        }
        gl = null, Ci = !1;
      } catch (M) {
        throw gl !== null && (gl = gl.slice(d + 1)), Qr(Eo, Ws), M;
      } finally {
        Ar = p, wv = !1;
      }
    }
    return null;
  }
  var Wd = [], Zs = 0, Kf = null, vh = 0, Ys = [], os = 0, Ul = null, Di = 1, Uc = "";
  function yl(d, p) {
    Wd[Zs++] = vh, Wd[Zs++] = Kf, Kf = d, vh = p;
  }
  function bb(d, p, _) {
    Ys[os++] = Di, Ys[os++] = Uc, Ys[os++] = Ul, Ul = d;
    var I = Di;
    d = Uc;
    var M = 32 - Oi(I) - 1;
    I &= ~(1 << M), _ += 1;
    var j = 32 - Oi(p) + M;
    if (30 < j) {
      var z = M - M % 5;
      j = (I & (1 << z) - 1).toString(32), I >>= z, M -= z, Di = 1 << 32 - Oi(p) + M | _ << M | I, Uc = j + d;
    } else Di = 1 << j | _ << M | I, Uc = d;
  }
  function O1(d) {
    d.return !== null && (yl(d, 1), bb(d, 1, 0));
  }
  function _b(d) {
    for (; d === Kf; ) Kf = Wd[--Zs], Wd[Zs] = null, vh = Wd[--Zs], Wd[Zs] = null;
    for (; d === Ul; ) Ul = Ys[--os], Ys[os] = null, Uc = Ys[--os], Ys[os] = null, Di = Ys[--os], Ys[os] = null;
  }
  var bl = null, Xs = null, Da = !1, Gl = null;
  function Cb(d, p) {
    var _ = ql(5, null, null, 0);
    _.elementType = "DELETED", _.stateNode = p, _.return = d, p = d.deletions, p === null ? (d.deletions = [_], d.flags |= 16) : p.push(_);
  }
  function qC(d, p) {
    switch (d.tag) {
      case 5:
        var _ = d.type;
        return p = p.nodeType !== 1 || _.toLowerCase() !== p.nodeName.toLowerCase() ? null : p, p !== null ? (d.stateNode = p, bl = d, Xs = xu(p.firstChild), !0) : !1;
      case 6:
        return p = d.pendingProps === "" || p.nodeType !== 3 ? null : p, p !== null ? (d.stateNode = p, bl = d, Xs = null, !0) : !1;
      case 13:
        return p = p.nodeType !== 8 ? null : p, p !== null ? (_ = Ul !== null ? { id: Di, overflow: Uc } : null, d.memoizedState = { dehydrated: p, treeContext: _, retryLane: 1073741824 }, _ = ql(18, null, null, 0), _.stateNode = p, _.return = d, d.child = _, bl = d, Xs = null, !0) : !1;
      default:
        return !1;
    }
  }
  function R1(d) {
    return (d.mode & 1) !== 0 && (d.flags & 128) === 0;
  }
  function M1(d) {
    if (Da) {
      var p = Xs;
      if (p) {
        var _ = p;
        if (!qC(d, p)) {
          if (R1(d)) throw Error(n(418));
          p = xu(_.nextSibling);
          var I = bl;
          p && qC(d, p) ? Cb(I, _) : (d.flags = d.flags & -4097 | 2, Da = !1, bl = d);
        }
      } else {
        if (R1(d)) throw Error(n(418));
        d.flags = d.flags & -4097 | 2, Da = !1, bl = d;
      }
    }
  }
  function JC(d) {
    for (d = d.return; d !== null && d.tag !== 5 && d.tag !== 3 && d.tag !== 13; ) d = d.return;
    bl = d;
  }
  function D1(d) {
    if (d !== bl) return !1;
    if (!Da) return JC(d), Da = !0, !1;
    var p;
    if ((p = d.tag !== 3) && !(p = d.tag !== 5) && (p = d.type, p = p !== "head" && p !== "body" && !yv(d.type, d.memoizedProps)), p && (p = Xs)) {
      if (R1(d)) throw QC(), Error(n(418));
      for (; p; ) Cb(d, p), p = xu(p.nextSibling);
    }
    if (JC(d), d.tag === 13) {
      if (d = d.memoizedState, d = d !== null ? d.dehydrated : null, !d) throw Error(n(317));
      e: {
        for (d = d.nextSibling, p = 0; d; ) {
          if (d.nodeType === 8) {
            var _ = d.data;
            if (_ === "/$") {
              if (p === 0) {
                Xs = xu(d.nextSibling);
                break e;
              }
              p--;
            } else _ !== "$" && _ !== "$!" && _ !== "$?" || p++;
          }
          d = d.nextSibling;
        }
        Xs = null;
      }
    } else Xs = bl ? xu(d.stateNode.nextSibling) : null;
    return !0;
  }
  function QC() {
    for (var d = Xs; d; ) d = xu(d.nextSibling);
  }
  function eo() {
    Xs = bl = null, Da = !1;
  }
  function wb(d) {
    Gl === null ? Gl = [d] : Gl.push(d);
  }
  var L1 = D.ReactCurrentBatchConfig;
  function qf(d, p, _) {
    if (d = _.ref, d !== null && typeof d != "function" && typeof d != "object") {
      if (_._owner) {
        if (_ = _._owner, _) {
          if (_.tag !== 1) throw Error(n(309));
          var I = _.stateNode;
        }
        if (!I) throw Error(n(147, d));
        var M = I, j = "" + d;
        return p !== null && p.ref !== null && typeof p.ref == "function" && p.ref._stringRef === j ? p.ref : (p = function(z) {
          var ve = M.refs;
          z === null ? delete ve[j] : ve[j] = z;
        }, p._stringRef = j, p);
      }
      if (typeof d != "string") throw Error(n(284));
      if (!_._owner) throw Error(n(290, d));
    }
    return d;
  }
  function Xu(d, p) {
    throw d = Object.prototype.toString.call(p), Error(n(31, d === "[object Object]" ? "object with keys {" + Object.keys(p).join(", ") + "}" : d));
  }
  function e5(d) {
    var p = d._init;
    return p(d._payload);
  }
  function $1(d) {
    function p(Be, Re) {
      if (d) {
        var Ge = Be.deletions;
        Ge === null ? (Be.deletions = [Re], Be.flags |= 16) : Ge.push(Re);
      }
    }
    function _(Be, Re) {
      if (!d) return null;
      for (; Re !== null; ) p(Be, Re), Re = Re.sibling;
      return null;
    }
    function I(Be, Re) {
      for (Be = /* @__PURE__ */ new Map(); Re !== null; ) Re.key !== null ? Be.set(Re.key, Re) : Be.set(Re.index, Re), Re = Re.sibling;
      return Be;
    }
    function M(Be, Re) {
      return Be = ef(Be, Re), Be.index = 0, Be.sibling = null, Be;
    }
    function j(Be, Re, Ge) {
      return Be.index = Ge, d ? (Ge = Be.alternate, Ge !== null ? (Ge = Ge.index, Ge < Re ? (Be.flags |= 2, Re) : Ge) : (Be.flags |= 2, Re)) : (Be.flags |= 1048576, Re);
    }
    function z(Be) {
      return d && Be.alternate === null && (Be.flags |= 2), Be;
    }
    function ve(Be, Re, Ge, xt) {
      return Re === null || Re.tag !== 6 ? (Re = xg(Ge, Be.mode, xt), Re.return = Be, Re) : (Re = M(Re, Ge), Re.return = Be, Re);
    }
    function ke(Be, Re, Ge, xt) {
      var on = Ge.type;
      return on === G ? gt(Be, Re, Ge.props.children, xt, Ge.key) : Re !== null && (Re.elementType === on || typeof on == "object" && on !== null && on.$$typeof === ee && e5(on) === Re.type) ? (xt = M(Re, Ge.props), xt.ref = qf(Be, Re, Ge), xt.return = Be, xt) : (xt = wg(Ge.type, Ge.key, Ge.props, null, Be.mode, xt), xt.ref = qf(Be, Re, Ge), xt.return = Be, xt);
    }
    function Xe(Be, Re, Ge, xt) {
      return Re === null || Re.tag !== 4 || Re.stateNode.containerInfo !== Ge.containerInfo || Re.stateNode.implementation !== Ge.implementation ? (Re = Bv(Ge, Be.mode, xt), Re.return = Be, Re) : (Re = M(Re, Ge.children || []), Re.return = Be, Re);
    }
    function gt(Be, Re, Ge, xt, on) {
      return Re === null || Re.tag !== 7 ? (Re = fp(Ge, Be.mode, xt, on), Re.return = Be, Re) : (Re = M(Re, Ge), Re.return = Be, Re);
    }
    function _t(Be, Re, Ge) {
      if (typeof Re == "string" && Re !== "" || typeof Re == "number") return Re = xg("" + Re, Be.mode, Ge), Re.return = Be, Re;
      if (typeof Re == "object" && Re !== null) {
        switch (Re.$$typeof) {
          case $:
            return Ge = wg(Re.type, Re.key, Re.props, null, Be.mode, Ge), Ge.ref = qf(Be, null, Re), Ge.return = Be, Ge;
          case B:
            return Re = Bv(Re, Be.mode, Ge), Re.return = Be, Re;
          case ee:
            var xt = Re._init;
            return _t(Be, xt(Re._payload), Ge);
        }
        if (dn(Re) || xe(Re)) return Re = fp(Re, Be.mode, Ge, null), Re.return = Be, Re;
        Xu(Be, Re);
      }
      return null;
    }
    function ht(Be, Re, Ge, xt) {
      var on = Re !== null ? Re.key : null;
      if (typeof Ge == "string" && Ge !== "" || typeof Ge == "number") return on !== null ? null : ve(Be, Re, "" + Ge, xt);
      if (typeof Ge == "object" && Ge !== null) {
        switch (Ge.$$typeof) {
          case $:
            return Ge.key === on ? ke(Be, Re, Ge, xt) : null;
          case B:
            return Ge.key === on ? Xe(Be, Re, Ge, xt) : null;
          case ee:
            return on = Ge._init, ht(
              Be,
              Re,
              on(Ge._payload),
              xt
            );
        }
        if (dn(Ge) || xe(Ge)) return on !== null ? null : gt(Be, Re, Ge, xt, null);
        Xu(Be, Ge);
      }
      return null;
    }
    function Ut(Be, Re, Ge, xt, on) {
      if (typeof xt == "string" && xt !== "" || typeof xt == "number") return Be = Be.get(Ge) || null, ve(Re, Be, "" + xt, on);
      if (typeof xt == "object" && xt !== null) {
        switch (xt.$$typeof) {
          case $:
            return Be = Be.get(xt.key === null ? Ge : xt.key) || null, ke(Re, Be, xt, on);
          case B:
            return Be = Be.get(xt.key === null ? Ge : xt.key) || null, Xe(Re, Be, xt, on);
          case ee:
            var bn = xt._init;
            return Ut(Be, Re, Ge, bn(xt._payload), on);
        }
        if (dn(xt) || xe(xt)) return Be = Be.get(Ge) || null, gt(Re, Be, xt, on, null);
        Xu(Re, xt);
      }
      return null;
    }
    function Jt(Be, Re, Ge, xt) {
      for (var on = null, bn = null, Qt = Re, wn = Re = 0, ci = null; Qt !== null && wn < Ge.length; wn++) {
        Qt.index > wn ? (ci = Qt, Qt = null) : ci = Qt.sibling;
        var Gr = ht(Be, Qt, Ge[wn], xt);
        if (Gr === null) {
          Qt === null && (Qt = ci);
          break;
        }
        d && Qt && Gr.alternate === null && p(Be, Qt), Re = j(Gr, Re, wn), bn === null ? on = Gr : bn.sibling = Gr, bn = Gr, Qt = ci;
      }
      if (wn === Ge.length) return _(Be, Qt), Da && yl(Be, wn), on;
      if (Qt === null) {
        for (; wn < Ge.length; wn++) Qt = _t(Be, Ge[wn], xt), Qt !== null && (Re = j(Qt, Re, wn), bn === null ? on = Qt : bn.sibling = Qt, bn = Qt);
        return Da && yl(Be, wn), on;
      }
      for (Qt = I(Be, Qt); wn < Ge.length; wn++) ci = Ut(Qt, Be, wn, Ge[wn], xt), ci !== null && (d && ci.alternate !== null && Qt.delete(ci.key === null ? wn : ci.key), Re = j(ci, Re, wn), bn === null ? on = ci : bn.sibling = ci, bn = ci);
      return d && Qt.forEach(function(Xc) {
        return p(Be, Xc);
      }), Da && yl(Be, wn), on;
    }
    function nn(Be, Re, Ge, xt) {
      var on = xe(Ge);
      if (typeof on != "function") throw Error(n(150));
      if (Ge = on.call(Ge), Ge == null) throw Error(n(151));
      for (var bn = on = null, Qt = Re, wn = Re = 0, ci = null, Gr = Ge.next(); Qt !== null && !Gr.done; wn++, Gr = Ge.next()) {
        Qt.index > wn ? (ci = Qt, Qt = null) : ci = Qt.sibling;
        var Xc = ht(Be, Qt, Gr.value, xt);
        if (Xc === null) {
          Qt === null && (Qt = ci);
          break;
        }
        d && Qt && Xc.alternate === null && p(Be, Qt), Re = j(Xc, Re, wn), bn === null ? on = Xc : bn.sibling = Xc, bn = Xc, Qt = ci;
      }
      if (Gr.done) return _(
        Be,
        Qt
      ), Da && yl(Be, wn), on;
      if (Qt === null) {
        for (; !Gr.done; wn++, Gr = Ge.next()) Gr = _t(Be, Gr.value, xt), Gr !== null && (Re = j(Gr, Re, wn), bn === null ? on = Gr : bn.sibling = Gr, bn = Gr);
        return Da && yl(Be, wn), on;
      }
      for (Qt = I(Be, Qt); !Gr.done; wn++, Gr = Ge.next()) Gr = Ut(Qt, Be, wn, Gr.value, xt), Gr !== null && (d && Gr.alternate !== null && Qt.delete(Gr.key === null ? wn : Gr.key), Re = j(Gr, Re, wn), bn === null ? on = Gr : bn.sibling = Gr, bn = Gr);
      return d && Qt.forEach(function(M9) {
        return p(Be, M9);
      }), Da && yl(Be, wn), on;
    }
    function Po(Be, Re, Ge, xt) {
      if (typeof Ge == "object" && Ge !== null && Ge.type === G && Ge.key === null && (Ge = Ge.props.children), typeof Ge == "object" && Ge !== null) {
        switch (Ge.$$typeof) {
          case $:
            e: {
              for (var on = Ge.key, bn = Re; bn !== null; ) {
                if (bn.key === on) {
                  if (on = Ge.type, on === G) {
                    if (bn.tag === 7) {
                      _(Be, bn.sibling), Re = M(bn, Ge.props.children), Re.return = Be, Be = Re;
                      break e;
                    }
                  } else if (bn.elementType === on || typeof on == "object" && on !== null && on.$$typeof === ee && e5(on) === bn.type) {
                    _(Be, bn.sibling), Re = M(bn, Ge.props), Re.ref = qf(Be, bn, Ge), Re.return = Be, Be = Re;
                    break e;
                  }
                  _(Be, bn);
                  break;
                } else p(Be, bn);
                bn = bn.sibling;
              }
              Ge.type === G ? (Re = fp(Ge.props.children, Be.mode, xt, Ge.key), Re.return = Be, Be = Re) : (xt = wg(Ge.type, Ge.key, Ge.props, null, Be.mode, xt), xt.ref = qf(Be, Re, Ge), xt.return = Be, Be = xt);
            }
            return z(Be);
          case B:
            e: {
              for (bn = Ge.key; Re !== null; ) {
                if (Re.key === bn) if (Re.tag === 4 && Re.stateNode.containerInfo === Ge.containerInfo && Re.stateNode.implementation === Ge.implementation) {
                  _(Be, Re.sibling), Re = M(Re, Ge.children || []), Re.return = Be, Be = Re;
                  break e;
                } else {
                  _(Be, Re);
                  break;
                }
                else p(Be, Re);
                Re = Re.sibling;
              }
              Re = Bv(Ge, Be.mode, xt), Re.return = Be, Be = Re;
            }
            return z(Be);
          case ee:
            return bn = Ge._init, Po(Be, Re, bn(Ge._payload), xt);
        }
        if (dn(Ge)) return Jt(Be, Re, Ge, xt);
        if (xe(Ge)) return nn(Be, Re, Ge, xt);
        Xu(Be, Ge);
      }
      return typeof Ge == "string" && Ge !== "" || typeof Ge == "number" ? (Ge = "" + Ge, Re !== null && Re.tag === 6 ? (_(Be, Re.sibling), Re = M(Re, Ge), Re.return = Be, Be = Re) : (_(Be, Re), Re = xg(Ge, Be.mode, xt), Re.return = Be, Be = Re), z(Be)) : _(Be, Re);
    }
    return Po;
  }
  var gh = $1(!0), t5 = $1(!1), Gc = Yn(null), ii = null, Dt = null, zl = null;
  function _l() {
    zl = Dt = ii = null;
  }
  function Sb(d) {
    var p = Gc.current;
    Kr(Gc), d._currentValue = p;
  }
  function xb(d, p, _) {
    for (; d !== null; ) {
      var I = d.alternate;
      if ((d.childLanes & p) !== p ? (d.childLanes |= p, I !== null && (I.childLanes |= p)) : I !== null && (I.childLanes & p) !== p && (I.childLanes |= p), d === _) break;
      d = d.return;
    }
  }
  function yh(d, p) {
    ii = d, zl = Dt = null, d = d.dependencies, d !== null && d.firstContext !== null && (d.lanes & p && (Js = !0), d.firstContext = null);
  }
  function Hl(d) {
    var p = d._currentValue;
    if (zl !== d) if (d = { context: d, memoizedValue: p, next: null }, Dt === null) {
      if (ii === null) throw Error(n(308));
      Dt = d, ii.dependencies = { lanes: 0, firstContext: d };
    } else Dt = Dt.next = d;
    return p;
  }
  var Jf = null;
  function Vo(d) {
    Jf === null ? Jf = [d] : Jf.push(d);
  }
  function n5(d, p, _, I) {
    var M = p.interleaved;
    return M === null ? (_.next = _, Vo(p)) : (_.next = M.next, M.next = _), p.interleaved = _, zc(d, I);
  }
  function zc(d, p) {
    d.lanes |= p;
    var _ = d.alternate;
    for (_ !== null && (_.lanes |= p), _ = d, d = d.return; d !== null; ) d.childLanes |= p, _ = d.alternate, _ !== null && (_.childLanes |= p), _ = d, d = d.return;
    return _.tag === 3 ? _.stateNode : null;
  }
  var Zd = !1;
  function j1(d) {
    d.updateQueue = { baseState: d.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function bh(d, p) {
    d = d.updateQueue, p.updateQueue === d && (p.updateQueue = { baseState: d.baseState, firstBaseUpdate: d.firstBaseUpdate, lastBaseUpdate: d.lastBaseUpdate, shared: d.shared, effects: d.effects });
  }
  function Ks(d, p) {
    return { eventTime: d, lane: p, tag: 0, payload: null, callback: null, next: null };
  }
  function Yd(d, p, _) {
    var I = d.updateQueue;
    if (I === null) return null;
    if (I = I.shared, gr & 2) {
      var M = I.pending;
      return M === null ? p.next = p : (p.next = M.next, M.next = p), I.pending = p, zc(d, _);
    }
    return M = I.interleaved, M === null ? (p.next = p, Vo(I)) : (p.next = M.next, M.next = p), I.interleaved = p, zc(d, _);
  }
  function F1(d, p, _) {
    if (p = p.updateQueue, p !== null && (p = p.shared, (_ & 4194240) !== 0)) {
      var I = p.lanes;
      I &= d.pendingLanes, _ |= I, p.lanes = _, ts(d, _);
    }
  }
  function r5(d, p) {
    var _ = d.updateQueue, I = d.alternate;
    if (I !== null && (I = I.updateQueue, _ === I)) {
      var M = null, j = null;
      if (_ = _.firstBaseUpdate, _ !== null) {
        do {
          var z = { eventTime: _.eventTime, lane: _.lane, tag: _.tag, payload: _.payload, callback: _.callback, next: null };
          j === null ? M = j = z : j = j.next = z, _ = _.next;
        } while (_ !== null);
        j === null ? M = j = p : j = j.next = p;
      } else M = j = p;
      _ = { baseState: I.baseState, firstBaseUpdate: M, lastBaseUpdate: j, shared: I.shared, effects: I.effects }, d.updateQueue = _;
      return;
    }
    d = _.lastBaseUpdate, d === null ? _.firstBaseUpdate = p : d.next = p, _.lastBaseUpdate = p;
  }
  function B1(d, p, _, I) {
    var M = d.updateQueue;
    Zd = !1;
    var j = M.firstBaseUpdate, z = M.lastBaseUpdate, ve = M.shared.pending;
    if (ve !== null) {
      M.shared.pending = null;
      var ke = ve, Xe = ke.next;
      ke.next = null, z === null ? j = Xe : z.next = Xe, z = ke;
      var gt = d.alternate;
      gt !== null && (gt = gt.updateQueue, ve = gt.lastBaseUpdate, ve !== z && (ve === null ? gt.firstBaseUpdate = Xe : ve.next = Xe, gt.lastBaseUpdate = ke));
    }
    if (j !== null) {
      var _t = M.baseState;
      z = 0, gt = Xe = ke = null, ve = j;
      do {
        var ht = ve.lane, Ut = ve.eventTime;
        if ((I & ht) === ht) {
          gt !== null && (gt = gt.next = {
            eventTime: Ut,
            lane: 0,
            tag: ve.tag,
            payload: ve.payload,
            callback: ve.callback,
            next: null
          });
          e: {
            var Jt = d, nn = ve;
            switch (ht = p, Ut = _, nn.tag) {
              case 1:
                if (Jt = nn.payload, typeof Jt == "function") {
                  _t = Jt.call(Ut, _t, ht);
                  break e;
                }
                _t = Jt;
                break e;
              case 3:
                Jt.flags = Jt.flags & -65537 | 128;
              case 0:
                if (Jt = nn.payload, ht = typeof Jt == "function" ? Jt.call(Ut, _t, ht) : Jt, ht == null) break e;
                _t = X({}, _t, ht);
                break e;
              case 2:
                Zd = !0;
            }
          }
          ve.callback !== null && ve.lane !== 0 && (d.flags |= 64, ht = M.effects, ht === null ? M.effects = [ve] : ht.push(ve));
        } else Ut = { eventTime: Ut, lane: ht, tag: ve.tag, payload: ve.payload, callback: ve.callback, next: null }, gt === null ? (Xe = gt = Ut, ke = _t) : gt = gt.next = Ut, z |= ht;
        if (ve = ve.next, ve === null) {
          if (ve = M.shared.pending, ve === null) break;
          ht = ve, ve = ht.next, ht.next = null, M.lastBaseUpdate = ht, M.shared.pending = null;
        }
      } while (!0);
      if (gt === null && (ke = _t), M.baseState = ke, M.firstBaseUpdate = Xe, M.lastBaseUpdate = gt, p = M.shared.interleaved, p !== null) {
        M = p;
        do
          z |= M.lane, M = M.next;
        while (M !== p);
      } else j === null && (M.shared.lanes = 0);
      lp |= z, d.lanes = z, d.memoizedState = _t;
    }
  }
  function a5(d, p, _) {
    if (d = p.effects, p.effects = null, d !== null) for (p = 0; p < d.length; p++) {
      var I = d[p], M = I.callback;
      if (M !== null) {
        if (I.callback = null, I = _, typeof M != "function") throw Error(n(191, M));
        M.call(I);
      }
    }
  }
  var Sv = {}, Eu = Yn(Sv), _h = Yn(Sv), xv = Yn(Sv);
  function Qf(d) {
    if (d === Sv) throw Error(n(174));
    return d;
  }
  function Eb(d, p) {
    switch (ta(xv, p), ta(_h, d), ta(Eu, Sv), d = p.nodeType, d) {
      case 9:
      case 11:
        p = (p = p.documentElement) ? p.namespaceURI : Kn(null, "");
        break;
      default:
        d = d === 8 ? p.parentNode : p, p = d.namespaceURI || null, d = d.tagName, p = Kn(p, d);
    }
    Kr(Eu), ta(Eu, p);
  }
  function Ch() {
    Kr(Eu), Kr(_h), Kr(xv);
  }
  function o5(d) {
    Qf(xv.current);
    var p = Qf(Eu.current), _ = Kn(p, d.type);
    p !== _ && (ta(_h, d), ta(Eu, _));
  }
  function Ib(d) {
    _h.current === d && (Kr(Eu), Kr(_h));
  }
  var za = Yn(0);
  function V1(d) {
    for (var p = d; p !== null; ) {
      if (p.tag === 13) {
        var _ = p.memoizedState;
        if (_ !== null && (_ = _.dehydrated, _ === null || _.data === "$?" || _.data === "$!")) return p;
      } else if (p.tag === 19 && p.memoizedProps.revealOrder !== void 0) {
        if (p.flags & 128) return p;
      } else if (p.child !== null) {
        p.child.return = p, p = p.child;
        continue;
      }
      if (p === d) break;
      for (; p.sibling === null; ) {
        if (p.return === null || p.return === d) return null;
        p = p.return;
      }
      p.sibling.return = p.return, p = p.sibling;
    }
    return null;
  }
  var U1 = [];
  function kb() {
    for (var d = 0; d < U1.length; d++) U1[d]._workInProgressVersionPrimary = null;
    U1.length = 0;
  }
  var G1 = D.ReactCurrentDispatcher, Ev = D.ReactCurrentBatchConfig, an = 0, ln = null, jn = null, dr = null, Cl = !1, wh = !1, Iv = 0, g9 = 0;
  function is() {
    throw Error(n(321));
  }
  function kv(d, p) {
    if (p === null) return !1;
    for (var _ = 0; _ < p.length && _ < d.length; _++) if (!jl(d[_], p[_])) return !1;
    return !0;
  }
  function dt(d, p, _, I, M, j) {
    if (an = j, ln = p, p.memoizedState = null, p.updateQueue = null, p.lanes = 0, G1.current = d === null || d.memoizedState === null ? y9 : Na, d = _(I, M), wh) {
      j = 0;
      do {
        if (wh = !1, Iv = 0, 25 <= j) throw Error(n(301));
        j += 1, dr = jn = null, p.updateQueue = null, G1.current = ag, d = _(I, M);
      } while (wh);
    }
    if (G1.current = ss, p = jn !== null && jn.next !== null, an = 0, dr = jn = ln = null, Cl = !1, p) throw Error(n(300));
    return d;
  }
  function Uo() {
    var d = Iv !== 0;
    return Iv = 0, d;
  }
  function cn() {
    var d = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return dr === null ? ln.memoizedState = dr = d : dr = dr.next = d, dr;
  }
  function Li() {
    if (jn === null) {
      var d = ln.alternate;
      d = d !== null ? d.memoizedState : null;
    } else d = jn.next;
    var p = dr === null ? ln.memoizedState : dr.next;
    if (p !== null) dr = p, jn = d;
    else {
      if (d === null) throw Error(n(310));
      jn = d, d = { memoizedState: jn.memoizedState, baseState: jn.baseState, baseQueue: jn.baseQueue, queue: jn.queue, next: null }, dr === null ? ln.memoizedState = dr = d : dr = dr.next = d;
    }
    return dr;
  }
  function wl(d, p) {
    return typeof p == "function" ? p(d) : p;
  }
  function Hc(d) {
    var p = Li(), _ = p.queue;
    if (_ === null) throw Error(n(311));
    _.lastRenderedReducer = d;
    var I = jn, M = I.baseQueue, j = _.pending;
    if (j !== null) {
      if (M !== null) {
        var z = M.next;
        M.next = j.next, j.next = z;
      }
      I.baseQueue = M = j, _.pending = null;
    }
    if (M !== null) {
      j = M.next, I = I.baseState;
      var ve = z = null, ke = null, Xe = j;
      do {
        var gt = Xe.lane;
        if ((an & gt) === gt) ke !== null && (ke = ke.next = { lane: 0, action: Xe.action, hasEagerState: Xe.hasEagerState, eagerState: Xe.eagerState, next: null }), I = Xe.hasEagerState ? Xe.eagerState : d(I, Xe.action);
        else {
          var _t = {
            lane: gt,
            action: Xe.action,
            hasEagerState: Xe.hasEagerState,
            eagerState: Xe.eagerState,
            next: null
          };
          ke === null ? (ve = ke = _t, z = I) : ke = ke.next = _t, ln.lanes |= gt, lp |= gt;
        }
        Xe = Xe.next;
      } while (Xe !== null && Xe !== j);
      ke === null ? z = I : ke.next = ve, jl(I, p.memoizedState) || (Js = !0), p.memoizedState = I, p.baseState = z, p.baseQueue = ke, _.lastRenderedState = I;
    }
    if (d = _.interleaved, d !== null) {
      M = d;
      do
        j = M.lane, ln.lanes |= j, lp |= j, M = M.next;
      while (M !== d);
    } else M === null && (_.lanes = 0);
    return [p.memoizedState, _.dispatch];
  }
  function Wl(d) {
    var p = Li(), _ = p.queue;
    if (_ === null) throw Error(n(311));
    _.lastRenderedReducer = d;
    var I = _.dispatch, M = _.pending, j = p.memoizedState;
    if (M !== null) {
      _.pending = null;
      var z = M = M.next;
      do
        j = d(j, z.action), z = z.next;
      while (z !== M);
      jl(j, p.memoizedState) || (Js = !0), p.memoizedState = j, p.baseQueue === null && (p.baseState = j), _.lastRenderedState = j;
    }
    return [j, I];
  }
  function Sh() {
  }
  function ep(d, p) {
    var _ = ln, I = Li(), M = p(), j = !jl(I.memoizedState, M);
    if (j && (I.memoizedState = M, Js = !0), I = I.queue, Av(H1.bind(null, _, I, d), [d]), I.getSnapshot !== p || j || dr !== null && dr.memoizedState.tag & 1) {
      if (_.flags |= 2048, tp(9, z1.bind(null, _, I, M, p), void 0, null), fo === null) throw Error(n(349));
      an & 30 || xh(_, p, M);
    }
    return M;
  }
  function xh(d, p, _) {
    d.flags |= 16384, d = { getSnapshot: p, value: _ }, p = ln.updateQueue, p === null ? (p = { lastEffect: null, stores: null }, ln.updateQueue = p, p.stores = [d]) : (_ = p.stores, _ === null ? p.stores = [d] : _.push(d));
  }
  function z1(d, p, _, I) {
    p.value = _, p.getSnapshot = I, W1(p) && Z1(d);
  }
  function H1(d, p, _) {
    return _(function() {
      W1(p) && Z1(d);
    });
  }
  function W1(d) {
    var p = d.getSnapshot;
    d = d.value;
    try {
      var _ = p();
      return !jl(d, _);
    } catch (I) {
      return !0;
    }
  }
  function Z1(d) {
    var p = zc(d, 1);
    p !== null && to(p, d, 1, -1);
  }
  function Y1(d) {
    var p = cn();
    return typeof d == "function" && (d = d()), p.memoizedState = p.baseState = d, d = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: wl, lastRenderedState: d }, p.queue = d, d = d.dispatch = Pv.bind(null, ln, d), [p.memoizedState, d];
  }
  function tp(d, p, _, I) {
    return d = { tag: d, create: p, destroy: _, deps: I, next: null }, p = ln.updateQueue, p === null ? (p = { lastEffect: null, stores: null }, ln.updateQueue = p, p.lastEffect = d.next = d) : (_ = p.lastEffect, _ === null ? p.lastEffect = d.next = d : (I = _.next, _.next = d, d.next = I, p.lastEffect = d)), d;
  }
  function X1() {
    return Li().memoizedState;
  }
  function Eh(d, p, _, I) {
    var M = cn();
    ln.flags |= d, M.memoizedState = tp(1 | p, _, void 0, I === void 0 ? null : I);
  }
  function Ih(d, p, _, I) {
    var M = Li();
    I = I === void 0 ? null : I;
    var j = void 0;
    if (jn !== null) {
      var z = jn.memoizedState;
      if (j = z.destroy, I !== null && kv(I, z.deps)) {
        M.memoizedState = tp(p, _, j, I);
        return;
      }
    }
    ln.flags |= d, M.memoizedState = tp(1 | p, _, j, I);
  }
  function K1(d, p) {
    return Eh(8390656, 8, d, p);
  }
  function Av(d, p) {
    return Ih(2048, 8, d, p);
  }
  function q1(d, p) {
    return Ih(4, 2, d, p);
  }
  function J1(d, p) {
    return Ih(4, 4, d, p);
  }
  function Q1(d, p) {
    if (typeof p == "function") return d = d(), p(d), function() {
      p(null);
    };
    if (p != null) return d = d(), p.current = d, function() {
      p.current = null;
    };
  }
  function eg(d, p, _) {
    return _ = _ != null ? _.concat([d]) : null, Ih(4, 4, Q1.bind(null, p, d), _);
  }
  function kh() {
  }
  function np(d, p) {
    var _ = Li();
    p = p === void 0 ? null : p;
    var I = _.memoizedState;
    return I !== null && p !== null && kv(p, I[1]) ? I[0] : (_.memoizedState = [d, p], d);
  }
  function tg(d, p) {
    var _ = Li();
    p = p === void 0 ? null : p;
    var I = _.memoizedState;
    return I !== null && p !== null && kv(p, I[1]) ? I[0] : (d = d(), _.memoizedState = [d, p], d);
  }
  function ng(d, p, _) {
    return an & 21 ? (jl(_, p) || (_ = yi(), ln.lanes |= _, lp |= _, d.baseState = !0), p) : (d.baseState && (d.baseState = !1, Js = !0), d.memoizedState = _);
  }
  function Ab(d, p) {
    var _ = Ar;
    Ar = _ !== 0 && 4 > _ ? _ : 4, d(!0);
    var I = Ev.transition;
    Ev.transition = {};
    try {
      d(!1), p();
    } finally {
      Ar = _, Ev.transition = I;
    }
  }
  function rg() {
    return Li().memoizedState;
  }
  function i5(d, p, _) {
    var I = Yc(d);
    if (_ = { lane: I, action: _, hasEagerState: !1, eagerState: null, next: null }, Pb(d)) Ah(p, _);
    else if (_ = n5(d, p, _, I), _ !== null) {
      var M = xi();
      to(_, d, I, M), Xd(_, p, I);
    }
  }
  function Pv(d, p, _) {
    var I = Yc(d), M = { lane: I, action: _, hasEagerState: !1, eagerState: null, next: null };
    if (Pb(d)) Ah(p, M);
    else {
      var j = d.alternate;
      if (d.lanes === 0 && (j === null || j.lanes === 0) && (j = p.lastRenderedReducer, j !== null)) try {
        var z = p.lastRenderedState, ve = j(z, _);
        if (M.hasEagerState = !0, M.eagerState = ve, jl(ve, z)) {
          var ke = p.interleaved;
          ke === null ? (M.next = M, Vo(p)) : (M.next = ke.next, ke.next = M), p.interleaved = M;
          return;
        }
      } catch (Xe) {
      } finally {
      }
      _ = n5(d, p, M, I), _ !== null && (M = xi(), to(_, d, I, M), Xd(_, p, I));
    }
  }
  function Pb(d) {
    var p = d.alternate;
    return d === ln || p !== null && p === ln;
  }
  function Ah(d, p) {
    wh = Cl = !0;
    var _ = d.pending;
    _ === null ? p.next = p : (p.next = _.next, _.next = p), d.pending = p;
  }
  function Xd(d, p, _) {
    if (_ & 4194240) {
      var I = p.lanes;
      I &= d.pendingLanes, _ |= I, p.lanes = _, ts(d, _);
    }
  }
  var ss = { readContext: Hl, useCallback: is, useContext: is, useEffect: is, useImperativeHandle: is, useInsertionEffect: is, useLayoutEffect: is, useMemo: is, useReducer: is, useRef: is, useState: is, useDebugValue: is, useDeferredValue: is, useTransition: is, useMutableSource: is, useSyncExternalStore: is, useId: is, unstable_isNewReconciler: !1 }, y9 = { readContext: Hl, useCallback: function(d, p) {
    return cn().memoizedState = [d, p === void 0 ? null : p], d;
  }, useContext: Hl, useEffect: K1, useImperativeHandle: function(d, p, _) {
    return _ = _ != null ? _.concat([d]) : null, Eh(
      4194308,
      4,
      Q1.bind(null, p, d),
      _
    );
  }, useLayoutEffect: function(d, p) {
    return Eh(4194308, 4, d, p);
  }, useInsertionEffect: function(d, p) {
    return Eh(4, 2, d, p);
  }, useMemo: function(d, p) {
    var _ = cn();
    return p = p === void 0 ? null : p, d = d(), _.memoizedState = [d, p], d;
  }, useReducer: function(d, p, _) {
    var I = cn();
    return p = _ !== void 0 ? _(p) : p, I.memoizedState = I.baseState = p, d = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: d, lastRenderedState: p }, I.queue = d, d = d.dispatch = i5.bind(null, ln, d), [I.memoizedState, d];
  }, useRef: function(d) {
    var p = cn();
    return d = { current: d }, p.memoizedState = d;
  }, useState: Y1, useDebugValue: kh, useDeferredValue: function(d) {
    return cn().memoizedState = d;
  }, useTransition: function() {
    var d = Y1(!1), p = d[0];
    return d = Ab.bind(null, d[1]), cn().memoizedState = d, [p, d];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(d, p, _) {
    var I = ln, M = cn();
    if (Da) {
      if (_ === void 0) throw Error(n(407));
      _ = _();
    } else {
      if (_ = p(), fo === null) throw Error(n(349));
      an & 30 || xh(I, p, _);
    }
    M.memoizedState = _;
    var j = { value: _, getSnapshot: p };
    return M.queue = j, K1(H1.bind(
      null,
      I,
      j,
      d
    ), [d]), I.flags |= 2048, tp(9, z1.bind(null, I, j, _, p), void 0, null), _;
  }, useId: function() {
    var d = cn(), p = fo.identifierPrefix;
    if (Da) {
      var _ = Uc, I = Di;
      _ = (I & ~(1 << 32 - Oi(I) - 1)).toString(32) + _, p = ":" + p + "R" + _, _ = Iv++, 0 < _ && (p += "H" + _.toString(32)), p += ":";
    } else _ = g9++, p = ":" + p + "r" + _.toString(32) + ":";
    return d.memoizedState = p;
  }, unstable_isNewReconciler: !1 }, Na = {
    readContext: Hl,
    useCallback: np,
    useContext: Hl,
    useEffect: Av,
    useImperativeHandle: eg,
    useInsertionEffect: q1,
    useLayoutEffect: J1,
    useMemo: tg,
    useReducer: Hc,
    useRef: X1,
    useState: function() {
      return Hc(wl);
    },
    useDebugValue: kh,
    useDeferredValue: function(d) {
      var p = Li();
      return ng(p, jn.memoizedState, d);
    },
    useTransition: function() {
      var d = Hc(wl)[0], p = Li().memoizedState;
      return [d, p];
    },
    useMutableSource: Sh,
    useSyncExternalStore: ep,
    useId: rg,
    unstable_isNewReconciler: !1
  }, ag = { readContext: Hl, useCallback: np, useContext: Hl, useEffect: Av, useImperativeHandle: eg, useInsertionEffect: q1, useLayoutEffect: J1, useMemo: tg, useReducer: Wl, useRef: X1, useState: function() {
    return Wl(wl);
  }, useDebugValue: kh, useDeferredValue: function(d) {
    var p = Li();
    return jn === null ? p.memoizedState = d : ng(p, jn.memoizedState, d);
  }, useTransition: function() {
    var d = Wl(wl)[0], p = Li().memoizedState;
    return [d, p];
  }, useMutableSource: Sh, useSyncExternalStore: ep, useId: rg, unstable_isNewReconciler: !1 };
  function qs(d, p) {
    if (d && d.defaultProps) {
      p = X({}, p), d = d.defaultProps;
      for (var _ in d) p[_] === void 0 && (p[_] = d[_]);
      return p;
    }
    return p;
  }
  function rp(d, p, _, I) {
    p = d.memoizedState, _ = _(I, p), _ = _ == null ? p : X({}, p, _), d.memoizedState = _, d.lanes === 0 && (d.updateQueue.baseState = _);
  }
  var ap = { isMounted: function(d) {
    return (d = d._reactInternals) ? Vt(d) === d : !1;
  }, enqueueSetState: function(d, p, _) {
    d = d._reactInternals;
    var I = xi(), M = Yc(d), j = Ks(I, M);
    j.payload = p, _ != null && (j.callback = _), p = Yd(d, j, M), p !== null && (to(p, d, M, I), F1(p, d, M));
  }, enqueueReplaceState: function(d, p, _) {
    d = d._reactInternals;
    var I = xi(), M = Yc(d), j = Ks(I, M);
    j.tag = 1, j.payload = p, _ != null && (j.callback = _), p = Yd(d, j, M), p !== null && (to(p, d, M, I), F1(p, d, M));
  }, enqueueForceUpdate: function(d, p) {
    d = d._reactInternals;
    var _ = xi(), I = Yc(d), M = Ks(_, I);
    M.tag = 2, p != null && (M.callback = p), p = Yd(d, M, I), p !== null && (to(p, d, I, _), F1(p, d, I));
  } };
  function s5(d, p, _, I, M, j, z) {
    return d = d.stateNode, typeof d.shouldComponentUpdate == "function" ? d.shouldComponentUpdate(I, j, z) : p.prototype && p.prototype.isPureReactComponent ? !dv(_, I) || !dv(M, j) : !0;
  }
  function l5(d, p, _) {
    var I = !1, M = Yu, j = p.contextType;
    return typeof j == "object" && j !== null ? j = Hl(j) : (M = Ga(p) ? Hs : $n.current, I = p.contextTypes, j = (I = I != null) ? Bl(d, M) : Yu), p = new p(_, j), d.memoizedState = p.state !== null && p.state !== void 0 ? p.state : null, p.updater = ap, d.stateNode = p, p._reactInternals = d, I && (d = d.stateNode, d.__reactInternalMemoizedUnmaskedChildContext = M, d.__reactInternalMemoizedMaskedChildContext = j), p;
  }
  function u5(d, p, _, I) {
    d = p.state, typeof p.componentWillReceiveProps == "function" && p.componentWillReceiveProps(_, I), typeof p.UNSAFE_componentWillReceiveProps == "function" && p.UNSAFE_componentWillReceiveProps(_, I), p.state !== d && ap.enqueueReplaceState(p, p.state, null);
  }
  function Nb(d, p, _, I) {
    var M = d.stateNode;
    M.props = _, M.state = d.memoizedState, M.refs = {}, j1(d);
    var j = p.contextType;
    typeof j == "object" && j !== null ? M.context = Hl(j) : (j = Ga(p) ? Hs : $n.current, M.context = Bl(d, j)), M.state = d.memoizedState, j = p.getDerivedStateFromProps, typeof j == "function" && (rp(d, p, j, _), M.state = d.memoizedState), typeof p.getDerivedStateFromProps == "function" || typeof M.getSnapshotBeforeUpdate == "function" || typeof M.UNSAFE_componentWillMount != "function" && typeof M.componentWillMount != "function" || (p = M.state, typeof M.componentWillMount == "function" && M.componentWillMount(), typeof M.UNSAFE_componentWillMount == "function" && M.UNSAFE_componentWillMount(), p !== M.state && ap.enqueueReplaceState(M, M.state, null), B1(d, _, M, I), M.state = d.memoizedState), typeof M.componentDidMount == "function" && (d.flags |= 4194308);
  }
  function Kd(d, p) {
    try {
      var _ = "", I = p;
      do
        _ += Le(I), I = I.return;
      while (I);
      var M = _;
    } catch (j) {
      M = `
Error generating stack: ` + j.message + `
` + j.stack;
    }
    return { value: d, source: p, stack: M, digest: null };
  }
  function Tb(d, p, _) {
    return { value: d, source: null, stack: _ != null ? _ : null, digest: p != null ? p : null };
  }
  function Nv(d, p) {
    try {
      console.error(p.value);
    } catch (_) {
      setTimeout(function() {
        throw _;
      });
    }
  }
  var c5 = typeof WeakMap == "function" ? WeakMap : Map;
  function d5(d, p, _) {
    _ = Ks(-1, _), _.tag = 3, _.payload = { element: null };
    var I = p.value;
    return _.callback = function() {
      vg || (vg = !0, Bb = I), Nv(d, p);
    }, _;
  }
  function f5(d, p, _) {
    _ = Ks(-1, _), _.tag = 3;
    var I = d.type.getDerivedStateFromError;
    if (typeof I == "function") {
      var M = p.value;
      _.payload = function() {
        return I(M);
      }, _.callback = function() {
        Nv(d, p);
      };
    }
    var j = d.stateNode;
    return j !== null && typeof j.componentDidCatch == "function" && (_.callback = function() {
      Nv(d, p), typeof I != "function" && (Xl === null ? Xl = /* @__PURE__ */ new Set([this]) : Xl.add(this));
      var z = p.stack;
      this.componentDidCatch(p.value, { componentStack: z !== null ? z : "" });
    }), _;
  }
  function Tv(d, p, _) {
    var I = d.pingCache;
    if (I === null) {
      I = d.pingCache = new c5();
      var M = /* @__PURE__ */ new Set();
      I.set(p, M);
    } else M = I.get(p), M === void 0 && (M = /* @__PURE__ */ new Set(), I.set(p, M));
    M.has(_) || (M.add(_), d = A9.bind(null, d, p, _), p.then(d, d));
  }
  function p5(d) {
    do {
      var p;
      if ((p = d.tag === 13) && (p = d.memoizedState, p = p !== null ? p.dehydrated !== null : !0), p) return d;
      d = d.return;
    } while (d !== null);
    return null;
  }
  function Ob(d, p, _, I, M) {
    return d.mode & 1 ? (d.flags |= 65536, d.lanes = M, d) : (d === p ? d.flags |= 65536 : (d.flags |= 128, _.flags |= 131072, _.flags &= -52805, _.tag === 1 && (_.alternate === null ? _.tag = 17 : (p = Ks(-1, 1), p.tag = 2, Yd(_, p, 1))), _.lanes |= 1), d);
  }
  var h5 = D.ReactCurrentOwner, Js = !1;
  function ko(d, p, _, I) {
    p.child = d === null ? t5(p, null, _, I) : gh(p, d.child, _, I);
  }
  function Ph(d, p, _, I, M) {
    _ = _.render;
    var j = p.ref;
    return yh(p, M), I = dt(d, p, _, I, j, M), _ = Uo(), d !== null && !Js ? (p.updateQueue = d.updateQueue, p.flags &= -2053, d.lanes &= ~M, Ao(d, p, M)) : (Da && _ && O1(p), p.flags |= 1, ko(d, p, I, M), p.child);
  }
  function qd(d, p, _, I, M) {
    if (d === null) {
      var j = _.type;
      return typeof j == "function" && !Hb(j) && j.defaultProps === void 0 && _.compare === null && _.defaultProps === void 0 ? (p.tag = 15, p.type = j, og(d, p, j, I, M)) : (d = wg(_.type, null, I, p, p.mode, M), d.ref = p.ref, d.return = p, p.child = d);
    }
    if (j = d.child, !(d.lanes & M)) {
      var z = j.memoizedProps;
      if (_ = _.compare, _ = _ !== null ? _ : dv, _(z, I) && d.ref === p.ref) return Ao(d, p, M);
    }
    return p.flags |= 1, d = ef(j, I), d.ref = p.ref, d.return = p, p.child = d;
  }
  function og(d, p, _, I, M) {
    if (d !== null) {
      var j = d.memoizedProps;
      if (dv(j, I) && d.ref === p.ref) if (Js = !1, p.pendingProps = I = j, (d.lanes & M) !== 0) d.flags & 131072 && (Js = !0);
      else return p.lanes = d.lanes, Ao(d, p, M);
    }
    return Wn(d, p, _, I, M);
  }
  function Qs(d, p, _) {
    var I = p.pendingProps, M = I.children, j = d !== null ? d.memoizedState : null;
    if (I.mode === "hidden") if (!(p.mode & 1)) p.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, ta(Fh, el), el |= _;
    else {
      if (!(_ & 1073741824)) return d = j !== null ? j.baseLanes | _ : _, p.lanes = p.childLanes = 1073741824, p.memoizedState = { baseLanes: d, cachePool: null, transitions: null }, p.updateQueue = null, ta(Fh, el), el |= d, null;
      p.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, I = j !== null ? j.baseLanes : _, ta(Fh, el), el |= I;
    }
    else j !== null ? (I = j.baseLanes | _, p.memoizedState = null) : I = _, ta(Fh, el), el |= I;
    return ko(d, p, M, _), p.child;
  }
  function op(d, p) {
    var _ = p.ref;
    (d === null && _ !== null || d !== null && d.ref !== _) && (p.flags |= 512, p.flags |= 2097152);
  }
  function Wn(d, p, _, I, M) {
    var j = Ga(_) ? Hs : $n.current;
    return j = Bl(p, j), yh(p, M), _ = dt(d, p, _, I, j, M), I = Uo(), d !== null && !Js ? (p.updateQueue = d.updateQueue, p.flags &= -2053, d.lanes &= ~M, Ao(d, p, M)) : (Da && I && O1(p), p.flags |= 1, ko(d, p, _, M), p.child);
  }
  function Ov(d, p, _, I, M) {
    if (Ga(_)) {
      var j = !0;
      T1(p);
    } else j = !1;
    if (yh(p, M), p.stateNode === null) Mv(d, p), l5(p, _, I), Nb(p, _, I, M), I = !0;
    else if (d === null) {
      var z = p.stateNode, ve = p.memoizedProps;
      z.props = ve;
      var ke = z.context, Xe = _.contextType;
      typeof Xe == "object" && Xe !== null ? Xe = Hl(Xe) : (Xe = Ga(_) ? Hs : $n.current, Xe = Bl(p, Xe));
      var gt = _.getDerivedStateFromProps, _t = typeof gt == "function" || typeof z.getSnapshotBeforeUpdate == "function";
      _t || typeof z.UNSAFE_componentWillReceiveProps != "function" && typeof z.componentWillReceiveProps != "function" || (ve !== I || ke !== Xe) && u5(p, z, I, Xe), Zd = !1;
      var ht = p.memoizedState;
      z.state = ht, B1(p, I, z, M), ke = p.memoizedState, ve !== I || ht !== ke || uo.current || Zd ? (typeof gt == "function" && (rp(p, _, gt, I), ke = p.memoizedState), (ve = Zd || s5(p, _, ve, I, ht, ke, Xe)) ? (_t || typeof z.UNSAFE_componentWillMount != "function" && typeof z.componentWillMount != "function" || (typeof z.componentWillMount == "function" && z.componentWillMount(), typeof z.UNSAFE_componentWillMount == "function" && z.UNSAFE_componentWillMount()), typeof z.componentDidMount == "function" && (p.flags |= 4194308)) : (typeof z.componentDidMount == "function" && (p.flags |= 4194308), p.memoizedProps = I, p.memoizedState = ke), z.props = I, z.state = ke, z.context = Xe, I = ve) : (typeof z.componentDidMount == "function" && (p.flags |= 4194308), I = !1);
    } else {
      z = p.stateNode, bh(d, p), ve = p.memoizedProps, Xe = p.type === p.elementType ? ve : qs(p.type, ve), z.props = Xe, _t = p.pendingProps, ht = z.context, ke = _.contextType, typeof ke == "object" && ke !== null ? ke = Hl(ke) : (ke = Ga(_) ? Hs : $n.current, ke = Bl(p, ke));
      var Ut = _.getDerivedStateFromProps;
      (gt = typeof Ut == "function" || typeof z.getSnapshotBeforeUpdate == "function") || typeof z.UNSAFE_componentWillReceiveProps != "function" && typeof z.componentWillReceiveProps != "function" || (ve !== _t || ht !== ke) && u5(p, z, I, ke), Zd = !1, ht = p.memoizedState, z.state = ht, B1(p, I, z, M);
      var Jt = p.memoizedState;
      ve !== _t || ht !== Jt || uo.current || Zd ? (typeof Ut == "function" && (rp(p, _, Ut, I), Jt = p.memoizedState), (Xe = Zd || s5(p, _, Xe, I, ht, Jt, ke) || !1) ? (gt || typeof z.UNSAFE_componentWillUpdate != "function" && typeof z.componentWillUpdate != "function" || (typeof z.componentWillUpdate == "function" && z.componentWillUpdate(I, Jt, ke), typeof z.UNSAFE_componentWillUpdate == "function" && z.UNSAFE_componentWillUpdate(I, Jt, ke)), typeof z.componentDidUpdate == "function" && (p.flags |= 4), typeof z.getSnapshotBeforeUpdate == "function" && (p.flags |= 1024)) : (typeof z.componentDidUpdate != "function" || ve === d.memoizedProps && ht === d.memoizedState || (p.flags |= 4), typeof z.getSnapshotBeforeUpdate != "function" || ve === d.memoizedProps && ht === d.memoizedState || (p.flags |= 1024), p.memoizedProps = I, p.memoizedState = Jt), z.props = I, z.state = Jt, z.context = ke, I = Xe) : (typeof z.componentDidUpdate != "function" || ve === d.memoizedProps && ht === d.memoizedState || (p.flags |= 4), typeof z.getSnapshotBeforeUpdate != "function" || ve === d.memoizedProps && ht === d.memoizedState || (p.flags |= 1024), I = !1);
    }
    return ig(d, p, _, I, j, M);
  }
  function ig(d, p, _, I, M, j) {
    op(d, p);
    var z = (p.flags & 128) !== 0;
    if (!I && !z) return M && KC(p, _, !1), Ao(d, p, j);
    I = p.stateNode, h5.current = p;
    var ve = z && typeof _.getDerivedStateFromError != "function" ? null : I.render();
    return p.flags |= 1, d !== null && z ? (p.child = gh(p, d.child, null, j), p.child = gh(p, null, ve, j)) : ko(d, p, ve, j), p.memoizedState = I.state, M && KC(p, _, !0), p.child;
  }
  function b9(d) {
    var p = d.stateNode;
    p.pendingContext ? Hd(d, p.pendingContext, p.pendingContext !== p.context) : p.context && Hd(d, p.context, !1), Eb(d, p.containerInfo);
  }
  function m5(d, p, _, I, M) {
    return eo(), wb(M), p.flags |= 256, ko(d, p, _, I), p.child;
  }
  var Rv = { dehydrated: null, treeContext: null, retryLane: 0 };
  function ip(d) {
    return { baseLanes: d, cachePool: null, transitions: null };
  }
  function v5(d, p, _) {
    var I = p.pendingProps, M = za.current, j = !1, z = (p.flags & 128) !== 0, ve;
    if ((ve = z) || (ve = d !== null && d.memoizedState === null ? !1 : (M & 2) !== 0), ve ? (j = !0, p.flags &= -129) : (d === null || d.memoizedState !== null) && (M |= 1), ta(za, M & 1), d === null)
      return M1(p), d = p.memoizedState, d !== null && (d = d.dehydrated, d !== null) ? (p.mode & 1 ? d.data === "$!" ? p.lanes = 8 : p.lanes = 1073741824 : p.lanes = 1, null) : (z = I.children, d = I.fallback, j ? (I = p.mode, j = p.child, z = { mode: "hidden", children: z }, !(I & 1) && j !== null ? (j.childLanes = 0, j.pendingProps = z) : j = Sg(z, I, 0, null), d = fp(d, I, _, null), j.return = p, d.return = p, j.sibling = d, p.child = j, p.child.memoizedState = ip(_), p.memoizedState = Rv, d) : sg(p, z));
    if (M = d.memoizedState, M !== null && (ve = M.dehydrated, ve !== null)) return Rb(d, p, z, I, ve, M, _);
    if (j) {
      j = I.fallback, z = p.mode, M = d.child, ve = M.sibling;
      var ke = { mode: "hidden", children: I.children };
      return !(z & 1) && p.child !== M ? (I = p.child, I.childLanes = 0, I.pendingProps = ke, p.deletions = null) : (I = ef(M, ke), I.subtreeFlags = M.subtreeFlags & 14680064), ve !== null ? j = ef(ve, j) : (j = fp(j, z, _, null), j.flags |= 2), j.return = p, I.return = p, I.sibling = j, p.child = I, I = j, j = p.child, z = d.child.memoizedState, z = z === null ? ip(_) : { baseLanes: z.baseLanes | _, cachePool: null, transitions: z.transitions }, j.memoizedState = z, j.childLanes = d.childLanes & ~_, p.memoizedState = Rv, I;
    }
    return j = d.child, d = j.sibling, I = ef(j, { mode: "visible", children: I.children }), !(p.mode & 1) && (I.lanes = _), I.return = p, I.sibling = null, d !== null && (_ = p.deletions, _ === null ? (p.deletions = [d], p.flags |= 16) : _.push(d)), p.child = I, p.memoizedState = null, I;
  }
  function sg(d, p) {
    return p = Sg({ mode: "visible", children: p }, d.mode, 0, null), p.return = d, d.child = p;
  }
  function lg(d, p, _, I) {
    return I !== null && wb(I), gh(p, d.child, null, _), d = sg(p, p.pendingProps.children), d.flags |= 2, p.memoizedState = null, d;
  }
  function Rb(d, p, _, I, M, j, z) {
    if (_)
      return p.flags & 256 ? (p.flags &= -257, I = Tb(Error(n(422))), lg(d, p, z, I)) : p.memoizedState !== null ? (p.child = d.child, p.flags |= 128, null) : (j = I.fallback, M = p.mode, I = Sg({ mode: "visible", children: I.children }, M, 0, null), j = fp(j, M, z, null), j.flags |= 2, I.return = p, j.return = p, I.sibling = j, p.child = I, p.mode & 1 && gh(p, d.child, null, z), p.child.memoizedState = ip(z), p.memoizedState = Rv, j);
    if (!(p.mode & 1)) return lg(d, p, z, null);
    if (M.data === "$!") {
      if (I = M.nextSibling && M.nextSibling.dataset, I) var ve = I.dgst;
      return I = ve, j = Error(n(419)), I = Tb(j, I, void 0), lg(d, p, z, I);
    }
    if (ve = (z & d.childLanes) !== 0, Js || ve) {
      if (I = fo, I !== null) {
        switch (z & -z) {
          case 4:
            M = 2;
            break;
          case 16:
            M = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            M = 32;
            break;
          case 536870912:
            M = 268435456;
            break;
          default:
            M = 0;
        }
        M = M & (I.suspendedLanes | z) ? 0 : M, M !== 0 && M !== j.retryLane && (j.retryLane = M, zc(d, M), to(I, d, M, -1));
      }
      return Fv(), I = Tb(Error(n(421))), lg(d, p, z, I);
    }
    return M.data === "$?" ? (p.flags |= 128, p.child = d.child, p = zb.bind(null, d), M._reactRetry = p, null) : (d = j.treeContext, Xs = xu(M.nextSibling), bl = p, Da = !0, Gl = null, d !== null && (Ys[os++] = Di, Ys[os++] = Uc, Ys[os++] = Ul, Di = d.id, Uc = d.overflow, Ul = p), p = sg(p, I.children), p.flags |= 4096, p);
  }
  function g5(d, p, _) {
    d.lanes |= p;
    var I = d.alternate;
    I !== null && (I.lanes |= p), xb(d.return, p, _);
  }
  function ug(d, p, _, I, M) {
    var j = d.memoizedState;
    j === null ? d.memoizedState = { isBackwards: p, rendering: null, renderingStartTime: 0, last: I, tail: _, tailMode: M } : (j.isBackwards = p, j.rendering = null, j.renderingStartTime = 0, j.last = I, j.tail = _, j.tailMode = M);
  }
  function Mb(d, p, _) {
    var I = p.pendingProps, M = I.revealOrder, j = I.tail;
    if (ko(d, p, I.children, _), I = za.current, I & 2) I = I & 1 | 2, p.flags |= 128;
    else {
      if (d !== null && d.flags & 128) e: for (d = p.child; d !== null; ) {
        if (d.tag === 13) d.memoizedState !== null && g5(d, _, p);
        else if (d.tag === 19) g5(d, _, p);
        else if (d.child !== null) {
          d.child.return = d, d = d.child;
          continue;
        }
        if (d === p) break e;
        for (; d.sibling === null; ) {
          if (d.return === null || d.return === p) break e;
          d = d.return;
        }
        d.sibling.return = d.return, d = d.sibling;
      }
      I &= 1;
    }
    if (ta(za, I), !(p.mode & 1)) p.memoizedState = null;
    else switch (M) {
      case "forwards":
        for (_ = p.child, M = null; _ !== null; ) d = _.alternate, d !== null && V1(d) === null && (M = _), _ = _.sibling;
        _ = M, _ === null ? (M = p.child, p.child = null) : (M = _.sibling, _.sibling = null), ug(p, !1, M, _, j);
        break;
      case "backwards":
        for (_ = null, M = p.child, p.child = null; M !== null; ) {
          if (d = M.alternate, d !== null && V1(d) === null) {
            p.child = M;
            break;
          }
          d = M.sibling, M.sibling = _, _ = M, M = d;
        }
        ug(p, !0, _, null, j);
        break;
      case "together":
        ug(p, !1, null, null, void 0);
        break;
      default:
        p.memoizedState = null;
    }
    return p.child;
  }
  function Mv(d, p) {
    !(p.mode & 1) && d !== null && (d.alternate = null, p.alternate = null, p.flags |= 2);
  }
  function Ao(d, p, _) {
    if (d !== null && (p.dependencies = d.dependencies), lp |= p.lanes, !(_ & p.childLanes)) return null;
    if (d !== null && p.child !== d.child) throw Error(n(153));
    if (p.child !== null) {
      for (d = p.child, _ = ef(d, d.pendingProps), p.child = _, _.return = p; d.sibling !== null; ) d = d.sibling, _ = _.sibling = ef(d, d.pendingProps), _.return = p;
      _.sibling = null;
    }
    return p.child;
  }
  function Wc(d, p, _) {
    switch (p.tag) {
      case 3:
        b9(p), eo();
        break;
      case 5:
        o5(p);
        break;
      case 1:
        Ga(p.type) && T1(p);
        break;
      case 4:
        Eb(p, p.stateNode.containerInfo);
        break;
      case 10:
        var I = p.type._context, M = p.memoizedProps.value;
        ta(Gc, I._currentValue), I._currentValue = M;
        break;
      case 13:
        if (I = p.memoizedState, I !== null)
          return I.dehydrated !== null ? (ta(za, za.current & 1), p.flags |= 128, null) : _ & p.child.childLanes ? v5(d, p, _) : (ta(za, za.current & 1), d = Ao(d, p, _), d !== null ? d.sibling : null);
        ta(za, za.current & 1);
        break;
      case 19:
        if (I = (_ & p.childLanes) !== 0, d.flags & 128) {
          if (I) return Mb(d, p, _);
          p.flags |= 128;
        }
        if (M = p.memoizedState, M !== null && (M.rendering = null, M.tail = null, M.lastEffect = null), ta(za, za.current), I) break;
        return null;
      case 22:
      case 23:
        return p.lanes = 0, Qs(d, p, _);
    }
    return Ao(d, p, _);
  }
  var Ku, Nh, Th, Zl;
  Ku = function(d, p) {
    for (var _ = p.child; _ !== null; ) {
      if (_.tag === 5 || _.tag === 6) d.appendChild(_.stateNode);
      else if (_.tag !== 4 && _.child !== null) {
        _.child.return = _, _ = _.child;
        continue;
      }
      if (_ === p) break;
      for (; _.sibling === null; ) {
        if (_.return === null || _.return === p) return;
        _ = _.return;
      }
      _.sibling.return = _.return, _ = _.sibling;
    }
  }, Nh = function() {
  }, Th = function(d, p, _, I) {
    var M = d.memoizedProps;
    if (M !== I) {
      d = p.stateNode, Qf(Eu.current);
      var j = null;
      switch (_) {
        case "input":
          M = Ae(d, M), I = Ae(d, I), j = [];
          break;
        case "select":
          M = X({}, M, { value: void 0 }), I = X({}, I, { value: void 0 }), j = [];
          break;
        case "textarea":
          M = qt(d, M), I = qt(d, I), j = [];
          break;
        default:
          typeof M.onClick != "function" && typeof I.onClick == "function" && (d.onclick = N1);
      }
      Qn(_, I);
      var z;
      _ = null;
      for (Xe in M) if (!I.hasOwnProperty(Xe) && M.hasOwnProperty(Xe) && M[Xe] != null) if (Xe === "style") {
        var ve = M[Xe];
        for (z in ve) ve.hasOwnProperty(z) && (_ || (_ = {}), _[z] = "");
      } else Xe !== "dangerouslySetInnerHTML" && Xe !== "children" && Xe !== "suppressContentEditableWarning" && Xe !== "suppressHydrationWarning" && Xe !== "autoFocus" && (a.hasOwnProperty(Xe) ? j || (j = []) : (j = j || []).push(Xe, null));
      for (Xe in I) {
        var ke = I[Xe];
        if (ve = M != null ? M[Xe] : void 0, I.hasOwnProperty(Xe) && ke !== ve && (ke != null || ve != null)) if (Xe === "style") if (ve) {
          for (z in ve) !ve.hasOwnProperty(z) || ke && ke.hasOwnProperty(z) || (_ || (_ = {}), _[z] = "");
          for (z in ke) ke.hasOwnProperty(z) && ve[z] !== ke[z] && (_ || (_ = {}), _[z] = ke[z]);
        } else _ || (j || (j = []), j.push(
          Xe,
          _
        )), _ = ke;
        else Xe === "dangerouslySetInnerHTML" ? (ke = ke ? ke.__html : void 0, ve = ve ? ve.__html : void 0, ke != null && ve !== ke && (j = j || []).push(Xe, ke)) : Xe === "children" ? typeof ke != "string" && typeof ke != "number" || (j = j || []).push(Xe, "" + ke) : Xe !== "suppressContentEditableWarning" && Xe !== "suppressHydrationWarning" && (a.hasOwnProperty(Xe) ? (ke != null && Xe === "onScroll" && Ea("scroll", d), j || ve === ke || (j = [])) : (j = j || []).push(Xe, ke));
      }
      _ && (j = j || []).push("style", _);
      var Xe = j;
      (p.updateQueue = Xe) && (p.flags |= 4);
    }
  }, Zl = function(d, p, _, I) {
    _ !== I && (p.flags |= 4);
  };
  function co(d, p) {
    if (!Da) switch (d.tailMode) {
      case "hidden":
        p = d.tail;
        for (var _ = null; p !== null; ) p.alternate !== null && (_ = p), p = p.sibling;
        _ === null ? d.tail = null : _.sibling = null;
        break;
      case "collapsed":
        _ = d.tail;
        for (var I = null; _ !== null; ) _.alternate !== null && (I = _), _ = _.sibling;
        I === null ? p || d.tail === null ? d.tail = null : d.tail.sibling = null : I.sibling = null;
    }
  }
  function ls(d) {
    var p = d.alternate !== null && d.alternate.child === d.child, _ = 0, I = 0;
    if (p) for (var M = d.child; M !== null; ) _ |= M.lanes | M.childLanes, I |= M.subtreeFlags & 14680064, I |= M.flags & 14680064, M.return = d, M = M.sibling;
    else for (M = d.child; M !== null; ) _ |= M.lanes | M.childLanes, I |= M.subtreeFlags, I |= M.flags, M.return = d, M = M.sibling;
    return d.subtreeFlags |= I, d.childLanes = _, p;
  }
  function _9(d, p, _) {
    var I = p.pendingProps;
    switch (_b(p), p.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return ls(p), null;
      case 1:
        return Ga(p.type) && Vl(), ls(p), null;
      case 3:
        return I = p.stateNode, Ch(), Kr(uo), Kr($n), kb(), I.pendingContext && (I.context = I.pendingContext, I.pendingContext = null), (d === null || d.child === null) && (D1(p) ? p.flags |= 4 : d === null || d.memoizedState.isDehydrated && !(p.flags & 256) || (p.flags |= 1024, Gl !== null && (Vb(Gl), Gl = null))), Nh(d, p), ls(p), null;
      case 5:
        Ib(p);
        var M = Qf(xv.current);
        if (_ = p.type, d !== null && p.stateNode != null) Th(d, p, _, I, M), d.ref !== p.ref && (p.flags |= 512, p.flags |= 2097152);
        else {
          if (!I) {
            if (p.stateNode === null) throw Error(n(166));
            return ls(p), null;
          }
          if (d = Qf(Eu.current), D1(p)) {
            I = p.stateNode, _ = p.type;
            var j = p.memoizedProps;
            switch (I[Zu] = p, I[Xf] = j, d = (p.mode & 1) !== 0, _) {
              case "dialog":
                Ea("cancel", I), Ea("close", I);
                break;
              case "iframe":
              case "object":
              case "embed":
                Ea("load", I);
                break;
              case "video":
              case "audio":
                for (M = 0; M < mv.length; M++) Ea(mv[M], I);
                break;
              case "source":
                Ea("error", I);
                break;
              case "img":
              case "image":
              case "link":
                Ea(
                  "error",
                  I
                ), Ea("load", I);
                break;
              case "details":
                Ea("toggle", I);
                break;
              case "input":
                it(I, j), Ea("invalid", I);
                break;
              case "select":
                I._wrapperState = { wasMultiple: !!j.multiple }, Ea("invalid", I);
                break;
              case "textarea":
                fn(I, j), Ea("invalid", I);
            }
            Qn(_, j), M = null;
            for (var z in j) if (j.hasOwnProperty(z)) {
              var ve = j[z];
              z === "children" ? typeof ve == "string" ? I.textContent !== ve && (j.suppressHydrationWarning !== !0 && P1(I.textContent, ve, d), M = ["children", ve]) : typeof ve == "number" && I.textContent !== "" + ve && (j.suppressHydrationWarning !== !0 && P1(
                I.textContent,
                ve,
                d
              ), M = ["children", "" + ve]) : a.hasOwnProperty(z) && ve != null && z === "onScroll" && Ea("scroll", I);
            }
            switch (_) {
              case "input":
                le(I), sn(I, j, !0);
                break;
              case "textarea":
                le(I), Wt(I);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof j.onClick == "function" && (I.onclick = N1);
            }
            I = M, p.updateQueue = I, I !== null && (p.flags |= 4);
          } else {
            z = M.nodeType === 9 ? M : M.ownerDocument, d === "http://www.w3.org/1999/xhtml" && (d = Xr(_)), d === "http://www.w3.org/1999/xhtml" ? _ === "script" ? (d = z.createElement("div"), d.innerHTML = "<script><\/script>", d = d.removeChild(d.firstChild)) : typeof I.is == "string" ? d = z.createElement(_, { is: I.is }) : (d = z.createElement(_), _ === "select" && (z = d, I.multiple ? z.multiple = !0 : I.size && (z.size = I.size))) : d = z.createElementNS(d, _), d[Zu] = p, d[Xf] = I, Ku(d, p, !1, !1), p.stateNode = d;
            e: {
              switch (z = er(_, I), _) {
                case "dialog":
                  Ea("cancel", d), Ea("close", d), M = I;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Ea("load", d), M = I;
                  break;
                case "video":
                case "audio":
                  for (M = 0; M < mv.length; M++) Ea(mv[M], d);
                  M = I;
                  break;
                case "source":
                  Ea("error", d), M = I;
                  break;
                case "img":
                case "image":
                case "link":
                  Ea(
                    "error",
                    d
                  ), Ea("load", d), M = I;
                  break;
                case "details":
                  Ea("toggle", d), M = I;
                  break;
                case "input":
                  it(d, I), M = Ae(d, I), Ea("invalid", d);
                  break;
                case "option":
                  M = I;
                  break;
                case "select":
                  d._wrapperState = { wasMultiple: !!I.multiple }, M = X({}, I, { value: void 0 }), Ea("invalid", d);
                  break;
                case "textarea":
                  fn(d, I), M = qt(d, I), Ea("invalid", d);
                  break;
                default:
                  M = I;
              }
              Qn(_, M), ve = M;
              for (j in ve) if (ve.hasOwnProperty(j)) {
                var ke = ve[j];
                j === "style" ? Rn(d, ke) : j === "dangerouslySetInnerHTML" ? (ke = ke ? ke.__html : void 0, ke != null && jo(d, ke)) : j === "children" ? typeof ke == "string" ? (_ !== "textarea" || ke !== "") && ei(d, ke) : typeof ke == "number" && ei(d, "" + ke) : j !== "suppressContentEditableWarning" && j !== "suppressHydrationWarning" && j !== "autoFocus" && (a.hasOwnProperty(j) ? ke != null && j === "onScroll" && Ea("scroll", d) : ke != null && O(d, j, ke, z));
              }
              switch (_) {
                case "input":
                  le(d), sn(d, I, !1);
                  break;
                case "textarea":
                  le(d), Wt(d);
                  break;
                case "option":
                  I.value != null && d.setAttribute("value", "" + we(I.value));
                  break;
                case "select":
                  d.multiple = !!I.multiple, j = I.value, j != null ? $t(d, !!I.multiple, j, !1) : I.defaultValue != null && $t(
                    d,
                    !!I.multiple,
                    I.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof M.onClick == "function" && (d.onclick = N1);
              }
              switch (_) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  I = !!I.autoFocus;
                  break e;
                case "img":
                  I = !0;
                  break e;
                default:
                  I = !1;
              }
            }
            I && (p.flags |= 4);
          }
          p.ref !== null && (p.flags |= 512, p.flags |= 2097152);
        }
        return ls(p), null;
      case 6:
        if (d && p.stateNode != null) Zl(d, p, d.memoizedProps, I);
        else {
          if (typeof I != "string" && p.stateNode === null) throw Error(n(166));
          if (_ = Qf(xv.current), Qf(Eu.current), D1(p)) {
            if (I = p.stateNode, _ = p.memoizedProps, I[Zu] = p, (j = I.nodeValue !== _) && (d = bl, d !== null)) switch (d.tag) {
              case 3:
                P1(I.nodeValue, _, (d.mode & 1) !== 0);
                break;
              case 5:
                d.memoizedProps.suppressHydrationWarning !== !0 && P1(I.nodeValue, _, (d.mode & 1) !== 0);
            }
            j && (p.flags |= 4);
          } else I = (_.nodeType === 9 ? _ : _.ownerDocument).createTextNode(I), I[Zu] = p, p.stateNode = I;
        }
        return ls(p), null;
      case 13:
        if (Kr(za), I = p.memoizedState, d === null || d.memoizedState !== null && d.memoizedState.dehydrated !== null) {
          if (Da && Xs !== null && p.mode & 1 && !(p.flags & 128)) QC(), eo(), p.flags |= 98560, j = !1;
          else if (j = D1(p), I !== null && I.dehydrated !== null) {
            if (d === null) {
              if (!j) throw Error(n(318));
              if (j = p.memoizedState, j = j !== null ? j.dehydrated : null, !j) throw Error(n(317));
              j[Zu] = p;
            } else eo(), !(p.flags & 128) && (p.memoizedState = null), p.flags |= 4;
            ls(p), j = !1;
          } else Gl !== null && (Vb(Gl), Gl = null), j = !0;
          if (!j) return p.flags & 65536 ? p : null;
        }
        return p.flags & 128 ? (p.lanes = _, p) : (I = I !== null, I !== (d !== null && d.memoizedState !== null) && I && (p.child.flags |= 8192, p.mode & 1 && (d === null || za.current & 1 ? li === 0 && (li = 3) : Fv())), p.updateQueue !== null && (p.flags |= 4), ls(p), null);
      case 4:
        return Ch(), Nh(d, p), d === null && hh(p.stateNode.containerInfo), ls(p), null;
      case 10:
        return Sb(p.type._context), ls(p), null;
      case 17:
        return Ga(p.type) && Vl(), ls(p), null;
      case 19:
        if (Kr(za), j = p.memoizedState, j === null) return ls(p), null;
        if (I = (p.flags & 128) !== 0, z = j.rendering, z === null) if (I) co(j, !1);
        else {
          if (li !== 0 || d !== null && d.flags & 128) for (d = p.child; d !== null; ) {
            if (z = V1(d), z !== null) {
              for (p.flags |= 128, co(j, !1), I = z.updateQueue, I !== null && (p.updateQueue = I, p.flags |= 4), p.subtreeFlags = 0, I = _, _ = p.child; _ !== null; ) j = _, d = I, j.flags &= 14680066, z = j.alternate, z === null ? (j.childLanes = 0, j.lanes = d, j.child = null, j.subtreeFlags = 0, j.memoizedProps = null, j.memoizedState = null, j.updateQueue = null, j.dependencies = null, j.stateNode = null) : (j.childLanes = z.childLanes, j.lanes = z.lanes, j.child = z.child, j.subtreeFlags = 0, j.deletions = null, j.memoizedProps = z.memoizedProps, j.memoizedState = z.memoizedState, j.updateQueue = z.updateQueue, j.type = z.type, d = z.dependencies, j.dependencies = d === null ? null : { lanes: d.lanes, firstContext: d.firstContext }), _ = _.sibling;
              return ta(za, za.current & 1 | 2), p.child;
            }
            d = d.sibling;
          }
          j.tail !== null && tr() > Vh && (p.flags |= 128, I = !0, co(j, !1), p.lanes = 4194304);
        }
        else {
          if (!I) if (d = V1(z), d !== null) {
            if (p.flags |= 128, I = !0, _ = d.updateQueue, _ !== null && (p.updateQueue = _, p.flags |= 4), co(j, !0), j.tail === null && j.tailMode === "hidden" && !z.alternate && !Da) return ls(p), null;
          } else 2 * tr() - j.renderingStartTime > Vh && _ !== 1073741824 && (p.flags |= 128, I = !0, co(j, !1), p.lanes = 4194304);
          j.isBackwards ? (z.sibling = p.child, p.child = z) : (_ = j.last, _ !== null ? _.sibling = z : p.child = z, j.last = z);
        }
        return j.tail !== null ? (p = j.tail, j.rendering = p, j.tail = p.sibling, j.renderingStartTime = tr(), p.sibling = null, _ = za.current, ta(za, I ? _ & 1 | 2 : _ & 1), p) : (ls(p), null);
      case 22:
      case 23:
        return _g(), I = p.memoizedState !== null, d !== null && d.memoizedState !== null !== I && (p.flags |= 8192), I && p.mode & 1 ? el & 1073741824 && (ls(p), p.subtreeFlags & 6 && (p.flags |= 8192)) : ls(p), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(n(156, p.tag));
  }
  function C9(d, p) {
    switch (_b(p), p.tag) {
      case 1:
        return Ga(p.type) && Vl(), d = p.flags, d & 65536 ? (p.flags = d & -65537 | 128, p) : null;
      case 3:
        return Ch(), Kr(uo), Kr($n), kb(), d = p.flags, d & 65536 && !(d & 128) ? (p.flags = d & -65537 | 128, p) : null;
      case 5:
        return Ib(p), null;
      case 13:
        if (Kr(za), d = p.memoizedState, d !== null && d.dehydrated !== null) {
          if (p.alternate === null) throw Error(n(340));
          eo();
        }
        return d = p.flags, d & 65536 ? (p.flags = d & -65537 | 128, p) : null;
      case 19:
        return Kr(za), null;
      case 4:
        return Ch(), null;
      case 10:
        return Sb(p.type._context), null;
      case 22:
      case 23:
        return _g(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Oh = !1, $i = !1, cg = typeof WeakSet == "function" ? WeakSet : Set, Zt = null;
  function Rh(d, p) {
    var _ = d.ref;
    if (_ !== null) if (typeof _ == "function") try {
      _(null);
    } catch (I) {
      po(d, p, I);
    }
    else _.current = null;
  }
  function Db(d, p, _) {
    try {
      _();
    } catch (I) {
      po(d, p, I);
    }
  }
  var dg = !1;
  function w9(d, p) {
    if (fb = ue, d = x1(), jc(d)) {
      if ("selectionStart" in d) var _ = { start: d.selectionStart, end: d.selectionEnd };
      else e: {
        _ = (_ = d.ownerDocument) && _.defaultView || window;
        var I = _.getSelection && _.getSelection();
        if (I && I.rangeCount !== 0) {
          _ = I.anchorNode;
          var M = I.anchorOffset, j = I.focusNode;
          I = I.focusOffset;
          try {
            _.nodeType, j.nodeType;
          } catch (xt) {
            _ = null;
            break e;
          }
          var z = 0, ve = -1, ke = -1, Xe = 0, gt = 0, _t = d, ht = null;
          t: for (; ; ) {
            for (var Ut; _t !== _ || M !== 0 && _t.nodeType !== 3 || (ve = z + M), _t !== j || I !== 0 && _t.nodeType !== 3 || (ke = z + I), _t.nodeType === 3 && (z += _t.nodeValue.length), (Ut = _t.firstChild) !== null; )
              ht = _t, _t = Ut;
            for (; ; ) {
              if (_t === d) break t;
              if (ht === _ && ++Xe === M && (ve = z), ht === j && ++gt === I && (ke = z), (Ut = _t.nextSibling) !== null) break;
              _t = ht, ht = _t.parentNode;
            }
            _t = Ut;
          }
          _ = ve === -1 || ke === -1 ? null : { start: ve, end: ke };
        } else _ = null;
      }
      _ = _ || { start: 0, end: 0 };
    } else _ = null;
    for (Zf = { focusedElem: d, selectionRange: _ }, ue = !1, Zt = p; Zt !== null; ) if (p = Zt, d = p.child, (p.subtreeFlags & 1028) !== 0 && d !== null) d.return = p, Zt = d;
    else for (; Zt !== null; ) {
      p = Zt;
      try {
        var Jt = p.alternate;
        if (p.flags & 1024) switch (p.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (Jt !== null) {
              var nn = Jt.memoizedProps, Po = Jt.memoizedState, Be = p.stateNode, Re = Be.getSnapshotBeforeUpdate(p.elementType === p.type ? nn : qs(p.type, nn), Po);
              Be.__reactInternalSnapshotBeforeUpdate = Re;
            }
            break;
          case 3:
            var Ge = p.stateNode.containerInfo;
            Ge.nodeType === 1 ? Ge.textContent = "" : Ge.nodeType === 9 && Ge.documentElement && Ge.removeChild(Ge.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(n(163));
        }
      } catch (xt) {
        po(p, p.return, xt);
      }
      if (d = p.sibling, d !== null) {
        d.return = p.return, Zt = d;
        break;
      }
      Zt = p.return;
    }
    return Jt = dg, dg = !1, Jt;
  }
  function Mh(d, p, _) {
    var I = p.updateQueue;
    if (I = I !== null ? I.lastEffect : null, I !== null) {
      var M = I = I.next;
      do {
        if ((M.tag & d) === d) {
          var j = M.destroy;
          M.destroy = void 0, j !== void 0 && Db(p, _, j);
        }
        M = M.next;
      } while (M !== I);
    }
  }
  function fg(d, p) {
    if (p = p.updateQueue, p = p !== null ? p.lastEffect : null, p !== null) {
      var _ = p = p.next;
      do {
        if ((_.tag & d) === d) {
          var I = _.create;
          _.destroy = I();
        }
        _ = _.next;
      } while (_ !== p);
    }
  }
  function pg(d) {
    var p = d.ref;
    if (p !== null) {
      var _ = d.stateNode;
      switch (d.tag) {
        case 5:
          d = _;
          break;
        default:
          d = _;
      }
      typeof p == "function" ? p(d) : p.current = d;
    }
  }
  function y5(d) {
    var p = d.alternate;
    p !== null && (d.alternate = null, y5(p)), d.child = null, d.deletions = null, d.sibling = null, d.tag === 5 && (p = d.stateNode, p !== null && (delete p[Zu], delete p[Xf], delete p[mb], delete p[v9], delete p[vb])), d.stateNode = null, d.return = null, d.dependencies = null, d.memoizedProps = null, d.memoizedState = null, d.pendingProps = null, d.stateNode = null, d.updateQueue = null;
  }
  function Lb(d) {
    return d.tag === 5 || d.tag === 3 || d.tag === 4;
  }
  function b5(d) {
    e: for (; ; ) {
      for (; d.sibling === null; ) {
        if (d.return === null || Lb(d.return)) return null;
        d = d.return;
      }
      for (d.sibling.return = d.return, d = d.sibling; d.tag !== 5 && d.tag !== 6 && d.tag !== 18; ) {
        if (d.flags & 2 || d.child === null || d.tag === 4) continue e;
        d.child.return = d, d = d.child;
      }
      if (!(d.flags & 2)) return d.stateNode;
    }
  }
  function Dv(d, p, _) {
    var I = d.tag;
    if (I === 5 || I === 6) d = d.stateNode, p ? _.nodeType === 8 ? _.parentNode.insertBefore(d, p) : _.insertBefore(d, p) : (_.nodeType === 8 ? (p = _.parentNode, p.insertBefore(d, _)) : (p = _, p.appendChild(d)), _ = _._reactRootContainer, _ != null || p.onclick !== null || (p.onclick = N1));
    else if (I !== 4 && (d = d.child, d !== null)) for (Dv(d, p, _), d = d.sibling; d !== null; ) Dv(d, p, _), d = d.sibling;
  }
  function Dh(d, p, _) {
    var I = d.tag;
    if (I === 5 || I === 6) d = d.stateNode, p ? _.insertBefore(d, p) : _.appendChild(d);
    else if (I !== 4 && (d = d.child, d !== null)) for (Dh(d, p, _), d = d.sibling; d !== null; ) Dh(d, p, _), d = d.sibling;
  }
  var Ha = null, wi = !1;
  function Es(d, p, _) {
    for (_ = _.child; _ !== null; ) Lh(d, p, _), _ = _.sibling;
  }
  function Lh(d, p, _) {
    if (ws && typeof ws.onCommitFiberUnmount == "function") try {
      ws.onCommitFiberUnmount(zu, _);
    } catch (ve) {
    }
    switch (_.tag) {
      case 5:
        $i || Rh(_, p);
      case 6:
        var I = Ha, M = wi;
        Ha = null, Es(d, p, _), Ha = I, wi = M, Ha !== null && (wi ? (d = Ha, _ = _.stateNode, d.nodeType === 8 ? d.parentNode.removeChild(_) : d.removeChild(_)) : Ha.removeChild(_.stateNode));
        break;
      case 18:
        Ha !== null && (wi ? (d = Ha, _ = _.stateNode, d.nodeType === 8 ? Ud(d.parentNode, _) : d.nodeType === 1 && Ud(d, _), $d(d)) : Ud(Ha, _.stateNode));
        break;
      case 4:
        I = Ha, M = wi, Ha = _.stateNode.containerInfo, wi = !0, Es(d, p, _), Ha = I, wi = M;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!$i && (I = _.updateQueue, I !== null && (I = I.lastEffect, I !== null))) {
          M = I = I.next;
          do {
            var j = M, z = j.destroy;
            j = j.tag, z !== void 0 && (j & 2 || j & 4) && Db(_, p, z), M = M.next;
          } while (M !== I);
        }
        Es(d, p, _);
        break;
      case 1:
        if (!$i && (Rh(_, p), I = _.stateNode, typeof I.componentWillUnmount == "function")) try {
          I.props = _.memoizedProps, I.state = _.memoizedState, I.componentWillUnmount();
        } catch (ve) {
          po(_, p, ve);
        }
        Es(d, p, _);
        break;
      case 21:
        Es(d, p, _);
        break;
      case 22:
        _.mode & 1 ? ($i = (I = $i) || _.memoizedState !== null, Es(d, p, _), $i = I) : Es(d, p, _);
        break;
      default:
        Es(d, p, _);
    }
  }
  function $h(d) {
    var p = d.updateQueue;
    if (p !== null) {
      d.updateQueue = null;
      var _ = d.stateNode;
      _ === null && (_ = d.stateNode = new cg()), p.forEach(function(I) {
        var M = P9.bind(null, d, I);
        _.has(I) || (_.add(I), I.then(M, M));
      });
    }
  }
  function Si(d, p) {
    var _ = p.deletions;
    if (_ !== null) for (var I = 0; I < _.length; I++) {
      var M = _[I];
      try {
        var j = d, z = p, ve = z;
        e: for (; ve !== null; ) {
          switch (ve.tag) {
            case 5:
              Ha = ve.stateNode, wi = !1;
              break e;
            case 3:
              Ha = ve.stateNode.containerInfo, wi = !0;
              break e;
            case 4:
              Ha = ve.stateNode.containerInfo, wi = !0;
              break e;
          }
          ve = ve.return;
        }
        if (Ha === null) throw Error(n(160));
        Lh(j, z, M), Ha = null, wi = !1;
        var ke = M.alternate;
        ke !== null && (ke.return = null), M.return = null;
      } catch (Xe) {
        po(M, p, Xe);
      }
    }
    if (p.subtreeFlags & 12854) for (p = p.child; p !== null; ) _5(p, d), p = p.sibling;
  }
  function _5(d, p) {
    var _ = d.alternate, I = d.flags;
    switch (d.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (Si(p, d), qu(d), I & 4) {
          try {
            Mh(3, d, d.return), fg(3, d);
          } catch (nn) {
            po(d, d.return, nn);
          }
          try {
            Mh(5, d, d.return);
          } catch (nn) {
            po(d, d.return, nn);
          }
        }
        break;
      case 1:
        Si(p, d), qu(d), I & 512 && _ !== null && Rh(_, _.return);
        break;
      case 5:
        if (Si(p, d), qu(d), I & 512 && _ !== null && Rh(_, _.return), d.flags & 32) {
          var M = d.stateNode;
          try {
            ei(M, "");
          } catch (nn) {
            po(d, d.return, nn);
          }
        }
        if (I & 4 && (M = d.stateNode, M != null)) {
          var j = d.memoizedProps, z = _ !== null ? _.memoizedProps : j, ve = d.type, ke = d.updateQueue;
          if (d.updateQueue = null, ke !== null) try {
            ve === "input" && j.type === "radio" && j.name != null && ut(M, j), er(ve, z);
            var Xe = er(ve, j);
            for (z = 0; z < ke.length; z += 2) {
              var gt = ke[z], _t = ke[z + 1];
              gt === "style" ? Rn(M, _t) : gt === "dangerouslySetInnerHTML" ? jo(M, _t) : gt === "children" ? ei(M, _t) : O(M, gt, _t, Xe);
            }
            switch (ve) {
              case "input":
                St(M, j);
                break;
              case "textarea":
                At(M, j);
                break;
              case "select":
                var ht = M._wrapperState.wasMultiple;
                M._wrapperState.wasMultiple = !!j.multiple;
                var Ut = j.value;
                Ut != null ? $t(M, !!j.multiple, Ut, !1) : ht !== !!j.multiple && (j.defaultValue != null ? $t(
                  M,
                  !!j.multiple,
                  j.defaultValue,
                  !0
                ) : $t(M, !!j.multiple, j.multiple ? [] : "", !1));
            }
            M[Xf] = j;
          } catch (nn) {
            po(d, d.return, nn);
          }
        }
        break;
      case 6:
        if (Si(p, d), qu(d), I & 4) {
          if (d.stateNode === null) throw Error(n(162));
          M = d.stateNode, j = d.memoizedProps;
          try {
            M.nodeValue = j;
          } catch (nn) {
            po(d, d.return, nn);
          }
        }
        break;
      case 3:
        if (Si(p, d), qu(d), I & 4 && _ !== null && _.memoizedState.isDehydrated) try {
          $d(p.containerInfo);
        } catch (nn) {
          po(d, d.return, nn);
        }
        break;
      case 4:
        Si(p, d), qu(d);
        break;
      case 13:
        Si(p, d), qu(d), M = d.child, M.flags & 8192 && (j = M.memoizedState !== null, M.stateNode.isHidden = j, !j || M.alternate !== null && M.alternate.memoizedState !== null || (mg = tr())), I & 4 && $h(d);
        break;
      case 22:
        if (gt = _ !== null && _.memoizedState !== null, d.mode & 1 ? ($i = (Xe = $i) || gt, Si(p, d), $i = Xe) : Si(p, d), qu(d), I & 8192) {
          if (Xe = d.memoizedState !== null, (d.stateNode.isHidden = Xe) && !gt && d.mode & 1) for (Zt = d, gt = d.child; gt !== null; ) {
            for (_t = Zt = gt; Zt !== null; ) {
              switch (ht = Zt, Ut = ht.child, ht.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Mh(4, ht, ht.return);
                  break;
                case 1:
                  Rh(ht, ht.return);
                  var Jt = ht.stateNode;
                  if (typeof Jt.componentWillUnmount == "function") {
                    I = ht, _ = ht.return;
                    try {
                      p = I, Jt.props = p.memoizedProps, Jt.state = p.memoizedState, Jt.componentWillUnmount();
                    } catch (nn) {
                      po(I, _, nn);
                    }
                  }
                  break;
                case 5:
                  Rh(ht, ht.return);
                  break;
                case 22:
                  if (ht.memoizedState !== null) {
                    C5(_t);
                    continue;
                  }
              }
              Ut !== null ? (Ut.return = ht, Zt = Ut) : C5(_t);
            }
            gt = gt.sibling;
          }
          e: for (gt = null, _t = d; ; ) {
            if (_t.tag === 5) {
              if (gt === null) {
                gt = _t;
                try {
                  M = _t.stateNode, Xe ? (j = M.style, typeof j.setProperty == "function" ? j.setProperty("display", "none", "important") : j.display = "none") : (ve = _t.stateNode, ke = _t.memoizedProps.style, z = ke != null && ke.hasOwnProperty("display") ? ke.display : null, ve.style.display = rn("display", z));
                } catch (nn) {
                  po(d, d.return, nn);
                }
              }
            } else if (_t.tag === 6) {
              if (gt === null) try {
                _t.stateNode.nodeValue = Xe ? "" : _t.memoizedProps;
              } catch (nn) {
                po(d, d.return, nn);
              }
            } else if ((_t.tag !== 22 && _t.tag !== 23 || _t.memoizedState === null || _t === d) && _t.child !== null) {
              _t.child.return = _t, _t = _t.child;
              continue;
            }
            if (_t === d) break e;
            for (; _t.sibling === null; ) {
              if (_t.return === null || _t.return === d) break e;
              gt === _t && (gt = null), _t = _t.return;
            }
            gt === _t && (gt = null), _t.sibling.return = _t.return, _t = _t.sibling;
          }
        }
        break;
      case 19:
        Si(p, d), qu(d), I & 4 && $h(d);
        break;
      case 21:
        break;
      default:
        Si(
          p,
          d
        ), qu(d);
    }
  }
  function qu(d) {
    var p = d.flags;
    if (p & 2) {
      try {
        e: {
          for (var _ = d.return; _ !== null; ) {
            if (Lb(_)) {
              var I = _;
              break e;
            }
            _ = _.return;
          }
          throw Error(n(160));
        }
        switch (I.tag) {
          case 5:
            var M = I.stateNode;
            I.flags & 32 && (ei(M, ""), I.flags &= -33);
            var j = b5(d);
            Dh(d, j, M);
            break;
          case 3:
          case 4:
            var z = I.stateNode.containerInfo, ve = b5(d);
            Dv(d, ve, z);
            break;
          default:
            throw Error(n(161));
        }
      } catch (ke) {
        po(d, d.return, ke);
      }
      d.flags &= -3;
    }
    p & 4096 && (d.flags &= -4097);
  }
  function S9(d, p, _) {
    Zt = d, $b(d);
  }
  function $b(d, p, _) {
    for (var I = (d.mode & 1) !== 0; Zt !== null; ) {
      var M = Zt, j = M.child;
      if (M.tag === 22 && I) {
        var z = M.memoizedState !== null || Oh;
        if (!z) {
          var ve = M.alternate, ke = ve !== null && ve.memoizedState !== null || $i;
          ve = Oh;
          var Xe = $i;
          if (Oh = z, ($i = ke) && !Xe) for (Zt = M; Zt !== null; ) z = Zt, ke = z.child, z.tag === 22 && z.memoizedState !== null ? jb(M) : ke !== null ? (ke.return = z, Zt = ke) : jb(M);
          for (; j !== null; ) Zt = j, $b(j), j = j.sibling;
          Zt = M, Oh = ve, $i = Xe;
        }
        jh(d);
      } else M.subtreeFlags & 8772 && j !== null ? (j.return = M, Zt = j) : jh(d);
    }
  }
  function jh(d) {
    for (; Zt !== null; ) {
      var p = Zt;
      if (p.flags & 8772) {
        var _ = p.alternate;
        try {
          if (p.flags & 8772) switch (p.tag) {
            case 0:
            case 11:
            case 15:
              $i || fg(5, p);
              break;
            case 1:
              var I = p.stateNode;
              if (p.flags & 4 && !$i) if (_ === null) I.componentDidMount();
              else {
                var M = p.elementType === p.type ? _.memoizedProps : qs(p.type, _.memoizedProps);
                I.componentDidUpdate(M, _.memoizedState, I.__reactInternalSnapshotBeforeUpdate);
              }
              var j = p.updateQueue;
              j !== null && a5(p, j, I);
              break;
            case 3:
              var z = p.updateQueue;
              if (z !== null) {
                if (_ = null, p.child !== null) switch (p.child.tag) {
                  case 5:
                    _ = p.child.stateNode;
                    break;
                  case 1:
                    _ = p.child.stateNode;
                }
                a5(p, z, _);
              }
              break;
            case 5:
              var ve = p.stateNode;
              if (_ === null && p.flags & 4) {
                _ = ve;
                var ke = p.memoizedProps;
                switch (p.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    ke.autoFocus && _.focus();
                    break;
                  case "img":
                    ke.src && (_.src = ke.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (p.memoizedState === null) {
                var Xe = p.alternate;
                if (Xe !== null) {
                  var gt = Xe.memoizedState;
                  if (gt !== null) {
                    var _t = gt.dehydrated;
                    _t !== null && $d(_t);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(n(163));
          }
          $i || p.flags & 512 && pg(p);
        } catch (ht) {
          po(p, p.return, ht);
        }
      }
      if (p === d) {
        Zt = null;
        break;
      }
      if (_ = p.sibling, _ !== null) {
        _.return = p.return, Zt = _;
        break;
      }
      Zt = p.return;
    }
  }
  function C5(d) {
    for (; Zt !== null; ) {
      var p = Zt;
      if (p === d) {
        Zt = null;
        break;
      }
      var _ = p.sibling;
      if (_ !== null) {
        _.return = p.return, Zt = _;
        break;
      }
      Zt = p.return;
    }
  }
  function jb(d) {
    for (; Zt !== null; ) {
      var p = Zt;
      try {
        switch (p.tag) {
          case 0:
          case 11:
          case 15:
            var _ = p.return;
            try {
              fg(4, p);
            } catch (ke) {
              po(p, _, ke);
            }
            break;
          case 1:
            var I = p.stateNode;
            if (typeof I.componentDidMount == "function") {
              var M = p.return;
              try {
                I.componentDidMount();
              } catch (ke) {
                po(p, M, ke);
              }
            }
            var j = p.return;
            try {
              pg(p);
            } catch (ke) {
              po(p, j, ke);
            }
            break;
          case 5:
            var z = p.return;
            try {
              pg(p);
            } catch (ke) {
              po(p, z, ke);
            }
        }
      } catch (ke) {
        po(p, p.return, ke);
      }
      if (p === d) {
        Zt = null;
        break;
      }
      var ve = p.sibling;
      if (ve !== null) {
        ve.return = p.return, Zt = ve;
        break;
      }
      Zt = p.return;
    }
  }
  var x9 = Math.ceil, sp = D.ReactCurrentDispatcher, hg = D.ReactCurrentOwner, Yl = D.ReactCurrentBatchConfig, gr = 0, fo = null, La = null, si = 0, el = 0, Fh = Yn(0), li = 0, Lv = null, lp = 0, Bh = 0, Fb = 0, Jd = null, us = null, mg = 0, Vh = 1 / 0, Zc = null, vg = !1, Bb = null, Xl = null, Uh = !1, Kl = null, gg = 0, $v = 0, yg = null, jv = -1, up = 0;
  function xi() {
    return gr & 6 ? tr() : jv !== -1 ? jv : jv = tr();
  }
  function Yc(d) {
    return d.mode & 1 ? gr & 2 && si !== 0 ? si & -si : L1.transition !== null ? (up === 0 && (up = yi()), up) : (d = Ar, d !== 0 || (d = window.event, d = d === void 0 ? 16 : ha(d.type)), d) : 1;
  }
  function to(d, p, _, I) {
    if (50 < $v) throw $v = 0, yg = null, Error(n(185));
    Ss(d, _, I), (!(gr & 2) || d !== fo) && (d === fo && (!(gr & 2) && (Bh |= _), li === 4 && Ju(d, si)), ui(d, I), _ === 1 && gr === 0 && !(p.mode & 1) && (Vh = tr() + 500, Ci && Ws()));
  }
  function ui(d, p) {
    var _ = d.callbackNode;
    io(d, p);
    var I = Ln(d, d === fo ? si : 0);
    if (I === 0) _ !== null && sa(_), d.callbackNode = null, d.callbackPriority = 0;
    else if (p = I & -I, d.callbackPriority !== p) {
      if (_ != null && sa(_), p === 1) d.tag === 0 ? yb(Gh.bind(null, d)) : gb(Gh.bind(null, d)), hb(function() {
        !(gr & 6) && Ws();
      }), _ = null;
      else {
        switch (Mc(I)) {
          case 1:
            _ = Eo;
            break;
          case 4:
            _ = Vn;
            break;
          case 16:
            _ = Gs;
            break;
          case 536870912:
            _ = Ff;
            break;
          default:
            _ = Gs;
        }
        _ = P5(_, bg.bind(null, d));
      }
      d.callbackPriority = p, d.callbackNode = _;
    }
  }
  function bg(d, p) {
    if (jv = -1, up = 0, gr & 6) throw Error(n(327));
    var _ = d.callbackNode;
    if (zh() && d.callbackNode !== _) return null;
    var I = Ln(d, d === fo ? si : 0);
    if (I === 0) return null;
    if (I & 30 || I & d.expiredLanes || p) p = Cg(d, I);
    else {
      p = I;
      var M = gr;
      gr |= 2;
      var j = S5();
      (fo !== d || si !== p) && (Zc = null, Vh = tr() + 500, dp(d, p));
      do
        try {
          I9();
          break;
        } catch (ve) {
          w5(d, ve);
        }
      while (!0);
      _l(), sp.current = j, gr = M, La !== null ? p = 0 : (fo = null, si = 0, p = li);
    }
    if (p !== 0) {
      if (p === 2 && (M = ai(d), M !== 0 && (I = M, p = cp(d, M))), p === 1) throw _ = Lv, dp(d, 0), Ju(d, I), ui(d, tr()), _;
      if (p === 6) Ju(d, I);
      else {
        if (M = d.current.alternate, !(I & 30) && !Ub(M) && (p = Cg(d, I), p === 2 && (j = ai(d), j !== 0 && (I = j, p = cp(d, j))), p === 1)) throw _ = Lv, dp(d, 0), Ju(d, I), ui(d, tr()), _;
        switch (d.finishedWork = M, d.finishedLanes = I, p) {
          case 0:
          case 1:
            throw Error(n(345));
          case 2:
            Qd(d, us, Zc);
            break;
          case 3:
            if (Ju(d, I), (I & 130023424) === I && (p = mg + 500 - tr(), 10 < p)) {
              if (Ln(d, 0) !== 0) break;
              if (M = d.suspendedLanes, (M & I) !== I) {
                xi(), d.pingedLanes |= d.suspendedLanes & M;
                break;
              }
              d.timeoutHandle = Yf(Qd.bind(null, d, us, Zc), p);
              break;
            }
            Qd(d, us, Zc);
            break;
          case 4:
            if (Ju(d, I), (I & 4194240) === I) break;
            for (p = d.eventTimes, M = -1; 0 < I; ) {
              var z = 31 - Oi(I);
              j = 1 << z, z = p[z], z > M && (M = z), I &= ~j;
            }
            if (I = M, I = tr() - I, I = (120 > I ? 120 : 480 > I ? 480 : 1080 > I ? 1080 : 1920 > I ? 1920 : 3e3 > I ? 3e3 : 4320 > I ? 4320 : 1960 * x9(I / 1960)) - I, 10 < I) {
              d.timeoutHandle = Yf(Qd.bind(null, d, us, Zc), I);
              break;
            }
            Qd(d, us, Zc);
            break;
          case 5:
            Qd(d, us, Zc);
            break;
          default:
            throw Error(n(329));
        }
      }
    }
    return ui(d, tr()), d.callbackNode === _ ? bg.bind(null, d) : null;
  }
  function cp(d, p) {
    var _ = Jd;
    return d.current.memoizedState.isDehydrated && (dp(d, p).flags |= 256), d = Cg(d, p), d !== 2 && (p = us, us = _, p !== null && Vb(p)), d;
  }
  function Vb(d) {
    us === null ? us = d : us.push.apply(us, d);
  }
  function Ub(d) {
    for (var p = d; ; ) {
      if (p.flags & 16384) {
        var _ = p.updateQueue;
        if (_ !== null && (_ = _.stores, _ !== null)) for (var I = 0; I < _.length; I++) {
          var M = _[I], j = M.getSnapshot;
          M = M.value;
          try {
            if (!jl(j(), M)) return !1;
          } catch (z) {
            return !1;
          }
        }
      }
      if (_ = p.child, p.subtreeFlags & 16384 && _ !== null) _.return = p, p = _;
      else {
        if (p === d) break;
        for (; p.sibling === null; ) {
          if (p.return === null || p.return === d) return !0;
          p = p.return;
        }
        p.sibling.return = p.return, p = p.sibling;
      }
    }
    return !0;
  }
  function Ju(d, p) {
    for (p &= ~Fb, p &= ~Bh, d.suspendedLanes |= p, d.pingedLanes &= ~p, d = d.expirationTimes; 0 < p; ) {
      var _ = 31 - Oi(p), I = 1 << _;
      d[_] = -1, p &= ~I;
    }
  }
  function Gh(d) {
    if (gr & 6) throw Error(n(327));
    zh();
    var p = Ln(d, 0);
    if (!(p & 1)) return ui(d, tr()), null;
    var _ = Cg(d, p);
    if (d.tag !== 0 && _ === 2) {
      var I = ai(d);
      I !== 0 && (p = I, _ = cp(d, I));
    }
    if (_ === 1) throw _ = Lv, dp(d, 0), Ju(d, p), ui(d, tr()), _;
    if (_ === 6) throw Error(n(345));
    return d.finishedWork = d.current.alternate, d.finishedLanes = p, Qd(d, us, Zc), ui(d, tr()), null;
  }
  function Gb(d, p) {
    var _ = gr;
    gr |= 1;
    try {
      return d(p);
    } finally {
      gr = _, gr === 0 && (Vh = tr() + 500, Ci && Ws());
    }
  }
  function Qu(d) {
    Kl !== null && Kl.tag === 0 && !(gr & 6) && zh();
    var p = gr;
    gr |= 1;
    var _ = Yl.transition, I = Ar;
    try {
      if (Yl.transition = null, Ar = 1, d) return d();
    } finally {
      Ar = I, Yl.transition = _, gr = p, !(gr & 6) && Ws();
    }
  }
  function _g() {
    el = Fh.current, Kr(Fh);
  }
  function dp(d, p) {
    d.finishedWork = null, d.finishedLanes = 0;
    var _ = d.timeoutHandle;
    if (_ !== -1 && (d.timeoutHandle = -1, XC(_)), La !== null) for (_ = La.return; _ !== null; ) {
      var I = _;
      switch (_b(I), I.tag) {
        case 1:
          I = I.type.childContextTypes, I != null && Vl();
          break;
        case 3:
          Ch(), Kr(uo), Kr($n), kb();
          break;
        case 5:
          Ib(I);
          break;
        case 4:
          Ch();
          break;
        case 13:
          Kr(za);
          break;
        case 19:
          Kr(za);
          break;
        case 10:
          Sb(I.type._context);
          break;
        case 22:
        case 23:
          _g();
      }
      _ = _.return;
    }
    if (fo = d, La = d = ef(d.current, null), si = el = p, li = 0, Lv = null, Fb = Bh = lp = 0, us = Jd = null, Jf !== null) {
      for (p = 0; p < Jf.length; p++) if (_ = Jf[p], I = _.interleaved, I !== null) {
        _.interleaved = null;
        var M = I.next, j = _.pending;
        if (j !== null) {
          var z = j.next;
          j.next = M, I.next = z;
        }
        _.pending = I;
      }
      Jf = null;
    }
    return d;
  }
  function w5(d, p) {
    do {
      var _ = La;
      try {
        if (_l(), G1.current = ss, Cl) {
          for (var I = ln.memoizedState; I !== null; ) {
            var M = I.queue;
            M !== null && (M.pending = null), I = I.next;
          }
          Cl = !1;
        }
        if (an = 0, dr = jn = ln = null, wh = !1, Iv = 0, hg.current = null, _ === null || _.return === null) {
          li = 1, Lv = p, La = null;
          break;
        }
        e: {
          var j = d, z = _.return, ve = _, ke = p;
          if (p = si, ve.flags |= 32768, ke !== null && typeof ke == "object" && typeof ke.then == "function") {
            var Xe = ke, gt = ve, _t = gt.tag;
            if (!(gt.mode & 1) && (_t === 0 || _t === 11 || _t === 15)) {
              var ht = gt.alternate;
              ht ? (gt.updateQueue = ht.updateQueue, gt.memoizedState = ht.memoizedState, gt.lanes = ht.lanes) : (gt.updateQueue = null, gt.memoizedState = null);
            }
            var Ut = p5(z);
            if (Ut !== null) {
              Ut.flags &= -257, Ob(Ut, z, ve, j, p), Ut.mode & 1 && Tv(j, Xe, p), p = Ut, ke = Xe;
              var Jt = p.updateQueue;
              if (Jt === null) {
                var nn = /* @__PURE__ */ new Set();
                nn.add(ke), p.updateQueue = nn;
              } else Jt.add(ke);
              break e;
            } else {
              if (!(p & 1)) {
                Tv(j, Xe, p), Fv();
                break e;
              }
              ke = Error(n(426));
            }
          } else if (Da && ve.mode & 1) {
            var Po = p5(z);
            if (Po !== null) {
              !(Po.flags & 65536) && (Po.flags |= 256), Ob(Po, z, ve, j, p), wb(Kd(ke, ve));
              break e;
            }
          }
          j = ke = Kd(ke, ve), li !== 4 && (li = 2), Jd === null ? Jd = [j] : Jd.push(j), j = z;
          do {
            switch (j.tag) {
              case 3:
                j.flags |= 65536, p &= -p, j.lanes |= p;
                var Be = d5(j, ke, p);
                r5(j, Be);
                break e;
              case 1:
                ve = ke;
                var Re = j.type, Ge = j.stateNode;
                if (!(j.flags & 128) && (typeof Re.getDerivedStateFromError == "function" || Ge !== null && typeof Ge.componentDidCatch == "function" && (Xl === null || !Xl.has(Ge)))) {
                  j.flags |= 65536, p &= -p, j.lanes |= p;
                  var xt = f5(j, ve, p);
                  r5(j, xt);
                  break e;
                }
            }
            j = j.return;
          } while (j !== null);
        }
        E5(_);
      } catch (on) {
        p = on, La === _ && _ !== null && (La = _ = _.return);
        continue;
      }
      break;
    } while (!0);
  }
  function S5() {
    var d = sp.current;
    return sp.current = ss, d === null ? ss : d;
  }
  function Fv() {
    (li === 0 || li === 3 || li === 2) && (li = 4), fo === null || !(lp & 268435455) && !(Bh & 268435455) || Ju(fo, si);
  }
  function Cg(d, p) {
    var _ = gr;
    gr |= 2;
    var I = S5();
    (fo !== d || si !== p) && (Zc = null, dp(d, p));
    do
      try {
        E9();
        break;
      } catch (M) {
        w5(d, M);
      }
    while (!0);
    if (_l(), gr = _, sp.current = I, La !== null) throw Error(n(261));
    return fo = null, si = 0, li;
  }
  function E9() {
    for (; La !== null; ) x5(La);
  }
  function I9() {
    for (; La !== null && !gi(); ) x5(La);
  }
  function x5(d) {
    var p = A5(d.alternate, d, el);
    d.memoizedProps = d.pendingProps, p === null ? E5(d) : La = p, hg.current = null;
  }
  function E5(d) {
    var p = d;
    do {
      var _ = p.alternate;
      if (d = p.return, p.flags & 32768) {
        if (_ = C9(_, p), _ !== null) {
          _.flags &= 32767, La = _;
          return;
        }
        if (d !== null) d.flags |= 32768, d.subtreeFlags = 0, d.deletions = null;
        else {
          li = 6, La = null;
          return;
        }
      } else if (_ = _9(_, p, el), _ !== null) {
        La = _;
        return;
      }
      if (p = p.sibling, p !== null) {
        La = p;
        return;
      }
      La = p = d;
    } while (p !== null);
    li === 0 && (li = 5);
  }
  function Qd(d, p, _) {
    var I = Ar, M = Yl.transition;
    try {
      Yl.transition = null, Ar = 1, k9(d, p, _, I);
    } finally {
      Yl.transition = M, Ar = I;
    }
    return null;
  }
  function k9(d, p, _, I) {
    do
      zh();
    while (Kl !== null);
    if (gr & 6) throw Error(n(327));
    _ = d.finishedWork;
    var M = d.finishedLanes;
    if (_ === null) return null;
    if (d.finishedWork = null, d.finishedLanes = 0, _ === d.current) throw Error(n(177));
    d.callbackNode = null, d.callbackPriority = 0;
    var j = _.lanes | _.childLanes;
    if (xs(d, j), d === fo && (La = fo = null, si = 0), !(_.subtreeFlags & 2064) && !(_.flags & 2064) || Uh || (Uh = !0, P5(Gs, function() {
      return zh(), null;
    })), j = (_.flags & 15990) !== 0, _.subtreeFlags & 15990 || j) {
      j = Yl.transition, Yl.transition = null;
      var z = Ar;
      Ar = 1;
      var ve = gr;
      gr |= 4, hg.current = null, w9(d, _), _5(_, d), E1(Zf), ue = !!fb, Zf = fb = null, d.current = _, S9(_), Cs(), gr = ve, Ar = z, Yl.transition = j;
    } else d.current = _;
    if (Uh && (Uh = !1, Kl = d, gg = M), j = d.pendingLanes, j === 0 && (Xl = null), Bf(_.stateNode), ui(d, tr()), p !== null) for (I = d.onRecoverableError, _ = 0; _ < p.length; _++) M = p[_], I(M.value, { componentStack: M.stack, digest: M.digest });
    if (vg) throw vg = !1, d = Bb, Bb = null, d;
    return gg & 1 && d.tag !== 0 && zh(), j = d.pendingLanes, j & 1 ? d === yg ? $v++ : ($v = 0, yg = d) : $v = 0, Ws(), null;
  }
  function zh() {
    if (Kl !== null) {
      var d = Mc(gg), p = Yl.transition, _ = Ar;
      try {
        if (Yl.transition = null, Ar = 16 > d ? 16 : d, Kl === null) var I = !1;
        else {
          if (d = Kl, Kl = null, gg = 0, gr & 6) throw Error(n(331));
          var M = gr;
          for (gr |= 4, Zt = d.current; Zt !== null; ) {
            var j = Zt, z = j.child;
            if (Zt.flags & 16) {
              var ve = j.deletions;
              if (ve !== null) {
                for (var ke = 0; ke < ve.length; ke++) {
                  var Xe = ve[ke];
                  for (Zt = Xe; Zt !== null; ) {
                    var gt = Zt;
                    switch (gt.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Mh(8, gt, j);
                    }
                    var _t = gt.child;
                    if (_t !== null) _t.return = gt, Zt = _t;
                    else for (; Zt !== null; ) {
                      gt = Zt;
                      var ht = gt.sibling, Ut = gt.return;
                      if (y5(gt), gt === Xe) {
                        Zt = null;
                        break;
                      }
                      if (ht !== null) {
                        ht.return = Ut, Zt = ht;
                        break;
                      }
                      Zt = Ut;
                    }
                  }
                }
                var Jt = j.alternate;
                if (Jt !== null) {
                  var nn = Jt.child;
                  if (nn !== null) {
                    Jt.child = null;
                    do {
                      var Po = nn.sibling;
                      nn.sibling = null, nn = Po;
                    } while (nn !== null);
                  }
                }
                Zt = j;
              }
            }
            if (j.subtreeFlags & 2064 && z !== null) z.return = j, Zt = z;
            else e: for (; Zt !== null; ) {
              if (j = Zt, j.flags & 2048) switch (j.tag) {
                case 0:
                case 11:
                case 15:
                  Mh(9, j, j.return);
              }
              var Be = j.sibling;
              if (Be !== null) {
                Be.return = j.return, Zt = Be;
                break e;
              }
              Zt = j.return;
            }
          }
          var Re = d.current;
          for (Zt = Re; Zt !== null; ) {
            z = Zt;
            var Ge = z.child;
            if (z.subtreeFlags & 2064 && Ge !== null) Ge.return = z, Zt = Ge;
            else e: for (z = Re; Zt !== null; ) {
              if (ve = Zt, ve.flags & 2048) try {
                switch (ve.tag) {
                  case 0:
                  case 11:
                  case 15:
                    fg(9, ve);
                }
              } catch (on) {
                po(ve, ve.return, on);
              }
              if (ve === z) {
                Zt = null;
                break e;
              }
              var xt = ve.sibling;
              if (xt !== null) {
                xt.return = ve.return, Zt = xt;
                break e;
              }
              Zt = ve.return;
            }
          }
          if (gr = M, Ws(), ws && typeof ws.onPostCommitFiberRoot == "function") try {
            ws.onPostCommitFiberRoot(zu, d);
          } catch (on) {
          }
          I = !0;
        }
        return I;
      } finally {
        Ar = _, Yl.transition = p;
      }
    }
    return !1;
  }
  function I5(d, p, _) {
    p = Kd(_, p), p = d5(d, p, 1), d = Yd(d, p, 1), p = xi(), d !== null && (Ss(d, 1, p), ui(d, p));
  }
  function po(d, p, _) {
    if (d.tag === 3) I5(d, d, _);
    else for (; p !== null; ) {
      if (p.tag === 3) {
        I5(p, d, _);
        break;
      } else if (p.tag === 1) {
        var I = p.stateNode;
        if (typeof p.type.getDerivedStateFromError == "function" || typeof I.componentDidCatch == "function" && (Xl === null || !Xl.has(I))) {
          d = Kd(_, d), d = f5(p, d, 1), p = Yd(p, d, 1), d = xi(), p !== null && (Ss(p, 1, d), ui(p, d));
          break;
        }
      }
      p = p.return;
    }
  }
  function A9(d, p, _) {
    var I = d.pingCache;
    I !== null && I.delete(p), p = xi(), d.pingedLanes |= d.suspendedLanes & _, fo === d && (si & _) === _ && (li === 4 || li === 3 && (si & 130023424) === si && 500 > tr() - mg ? dp(d, 0) : Fb |= _), ui(d, p);
  }
  function k5(d, p) {
    p === 0 && (d.mode & 1 ? (p = $r, $r <<= 1, !($r & 130023424) && ($r = 4194304)) : p = 1);
    var _ = xi();
    d = zc(d, p), d !== null && (Ss(d, p, _), ui(d, _));
  }
  function zb(d) {
    var p = d.memoizedState, _ = 0;
    p !== null && (_ = p.retryLane), k5(d, _);
  }
  function P9(d, p) {
    var _ = 0;
    switch (d.tag) {
      case 13:
        var I = d.stateNode, M = d.memoizedState;
        M !== null && (_ = M.retryLane);
        break;
      case 19:
        I = d.stateNode;
        break;
      default:
        throw Error(n(314));
    }
    I !== null && I.delete(p), k5(d, _);
  }
  var A5;
  A5 = function(d, p, _) {
    if (d !== null) if (d.memoizedProps !== p.pendingProps || uo.current) Js = !0;
    else {
      if (!(d.lanes & _) && !(p.flags & 128)) return Js = !1, Wc(d, p, _);
      Js = !!(d.flags & 131072);
    }
    else Js = !1, Da && p.flags & 1048576 && bb(p, vh, p.index);
    switch (p.lanes = 0, p.tag) {
      case 2:
        var I = p.type;
        Mv(d, p), d = p.pendingProps;
        var M = Bl(p, $n.current);
        yh(p, _), M = dt(null, p, I, d, M, _);
        var j = Uo();
        return p.flags |= 1, typeof M == "object" && M !== null && typeof M.render == "function" && M.$$typeof === void 0 ? (p.tag = 1, p.memoizedState = null, p.updateQueue = null, Ga(I) ? (j = !0, T1(p)) : j = !1, p.memoizedState = M.state !== null && M.state !== void 0 ? M.state : null, j1(p), M.updater = ap, p.stateNode = M, M._reactInternals = p, Nb(p, I, d, _), p = ig(null, p, I, !0, j, _)) : (p.tag = 0, Da && j && O1(p), ko(null, p, M, _), p = p.child), p;
      case 16:
        I = p.elementType;
        e: {
          switch (Mv(d, p), d = p.pendingProps, M = I._init, I = M(I._payload), p.type = I, M = p.tag = N9(I), d = qs(I, d), M) {
            case 0:
              p = Wn(null, p, I, d, _);
              break e;
            case 1:
              p = Ov(null, p, I, d, _);
              break e;
            case 11:
              p = Ph(null, p, I, d, _);
              break e;
            case 14:
              p = qd(null, p, I, qs(I.type, d), _);
              break e;
          }
          throw Error(n(
            306,
            I,
            ""
          ));
        }
        return p;
      case 0:
        return I = p.type, M = p.pendingProps, M = p.elementType === I ? M : qs(I, M), Wn(d, p, I, M, _);
      case 1:
        return I = p.type, M = p.pendingProps, M = p.elementType === I ? M : qs(I, M), Ov(d, p, I, M, _);
      case 3:
        e: {
          if (b9(p), d === null) throw Error(n(387));
          I = p.pendingProps, j = p.memoizedState, M = j.element, bh(d, p), B1(p, I, null, _);
          var z = p.memoizedState;
          if (I = z.element, j.isDehydrated) if (j = { element: I, isDehydrated: !1, cache: z.cache, pendingSuspenseBoundaries: z.pendingSuspenseBoundaries, transitions: z.transitions }, p.updateQueue.baseState = j, p.memoizedState = j, p.flags & 256) {
            M = Kd(Error(n(423)), p), p = m5(d, p, I, _, M);
            break e;
          } else if (I !== M) {
            M = Kd(Error(n(424)), p), p = m5(d, p, I, _, M);
            break e;
          } else for (Xs = xu(p.stateNode.containerInfo.firstChild), bl = p, Da = !0, Gl = null, _ = t5(p, null, I, _), p.child = _; _; ) _.flags = _.flags & -3 | 4096, _ = _.sibling;
          else {
            if (eo(), I === M) {
              p = Ao(d, p, _);
              break e;
            }
            ko(d, p, I, _);
          }
          p = p.child;
        }
        return p;
      case 5:
        return o5(p), d === null && M1(p), I = p.type, M = p.pendingProps, j = d !== null ? d.memoizedProps : null, z = M.children, yv(I, M) ? z = null : j !== null && yv(I, j) && (p.flags |= 32), op(d, p), ko(d, p, z, _), p.child;
      case 6:
        return d === null && M1(p), null;
      case 13:
        return v5(d, p, _);
      case 4:
        return Eb(p, p.stateNode.containerInfo), I = p.pendingProps, d === null ? p.child = gh(p, null, I, _) : ko(d, p, I, _), p.child;
      case 11:
        return I = p.type, M = p.pendingProps, M = p.elementType === I ? M : qs(I, M), Ph(d, p, I, M, _);
      case 7:
        return ko(d, p, p.pendingProps, _), p.child;
      case 8:
        return ko(d, p, p.pendingProps.children, _), p.child;
      case 12:
        return ko(d, p, p.pendingProps.children, _), p.child;
      case 10:
        e: {
          if (I = p.type._context, M = p.pendingProps, j = p.memoizedProps, z = M.value, ta(Gc, I._currentValue), I._currentValue = z, j !== null) if (jl(j.value, z)) {
            if (j.children === M.children && !uo.current) {
              p = Ao(d, p, _);
              break e;
            }
          } else for (j = p.child, j !== null && (j.return = p); j !== null; ) {
            var ve = j.dependencies;
            if (ve !== null) {
              z = j.child;
              for (var ke = ve.firstContext; ke !== null; ) {
                if (ke.context === I) {
                  if (j.tag === 1) {
                    ke = Ks(-1, _ & -_), ke.tag = 2;
                    var Xe = j.updateQueue;
                    if (Xe !== null) {
                      Xe = Xe.shared;
                      var gt = Xe.pending;
                      gt === null ? ke.next = ke : (ke.next = gt.next, gt.next = ke), Xe.pending = ke;
                    }
                  }
                  j.lanes |= _, ke = j.alternate, ke !== null && (ke.lanes |= _), xb(
                    j.return,
                    _,
                    p
                  ), ve.lanes |= _;
                  break;
                }
                ke = ke.next;
              }
            } else if (j.tag === 10) z = j.type === p.type ? null : j.child;
            else if (j.tag === 18) {
              if (z = j.return, z === null) throw Error(n(341));
              z.lanes |= _, ve = z.alternate, ve !== null && (ve.lanes |= _), xb(z, _, p), z = j.sibling;
            } else z = j.child;
            if (z !== null) z.return = j;
            else for (z = j; z !== null; ) {
              if (z === p) {
                z = null;
                break;
              }
              if (j = z.sibling, j !== null) {
                j.return = z.return, z = j;
                break;
              }
              z = z.return;
            }
            j = z;
          }
          ko(d, p, M.children, _), p = p.child;
        }
        return p;
      case 9:
        return M = p.type, I = p.pendingProps.children, yh(p, _), M = Hl(M), I = I(M), p.flags |= 1, ko(d, p, I, _), p.child;
      case 14:
        return I = p.type, M = qs(I, p.pendingProps), M = qs(I.type, M), qd(d, p, I, M, _);
      case 15:
        return og(d, p, p.type, p.pendingProps, _);
      case 17:
        return I = p.type, M = p.pendingProps, M = p.elementType === I ? M : qs(I, M), Mv(d, p), p.tag = 1, Ga(I) ? (d = !0, T1(p)) : d = !1, yh(p, _), l5(p, I, M), Nb(p, I, M, _), ig(null, p, I, !0, d, _);
      case 19:
        return Mb(d, p, _);
      case 22:
        return Qs(d, p, _);
    }
    throw Error(n(156, p.tag));
  };
  function P5(d, p) {
    return Qr(d, p);
  }
  function N5(d, p, _, I) {
    this.tag = d, this.key = _, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = p, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = I, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ql(d, p, _, I) {
    return new N5(d, p, _, I);
  }
  function Hb(d) {
    return d = d.prototype, !(!d || !d.isReactComponent);
  }
  function N9(d) {
    if (typeof d == "function") return Hb(d) ? 1 : 0;
    if (d != null) {
      if (d = d.$$typeof, d === he) return 11;
      if (d === Y) return 14;
    }
    return 2;
  }
  function ef(d, p) {
    var _ = d.alternate;
    return _ === null ? (_ = ql(d.tag, p, d.key, d.mode), _.elementType = d.elementType, _.type = d.type, _.stateNode = d.stateNode, _.alternate = d, d.alternate = _) : (_.pendingProps = p, _.type = d.type, _.flags = 0, _.subtreeFlags = 0, _.deletions = null), _.flags = d.flags & 14680064, _.childLanes = d.childLanes, _.lanes = d.lanes, _.child = d.child, _.memoizedProps = d.memoizedProps, _.memoizedState = d.memoizedState, _.updateQueue = d.updateQueue, p = d.dependencies, _.dependencies = p === null ? null : { lanes: p.lanes, firstContext: p.firstContext }, _.sibling = d.sibling, _.index = d.index, _.ref = d.ref, _;
  }
  function wg(d, p, _, I, M, j) {
    var z = 2;
    if (I = d, typeof d == "function") Hb(d) && (z = 1);
    else if (typeof d == "string") z = 5;
    else e: switch (d) {
      case G:
        return fp(_.children, M, j, p);
      case Z:
        z = 8, M |= 8;
        break;
      case K:
        return d = ql(12, _, p, M | 2), d.elementType = K, d.lanes = j, d;
      case _e:
        return d = ql(13, _, p, M), d.elementType = _e, d.lanes = j, d;
      case ge:
        return d = ql(19, _, p, M), d.elementType = ge, d.lanes = j, d;
      case oe:
        return Sg(_, M, j, p);
      default:
        if (typeof d == "object" && d !== null) switch (d.$$typeof) {
          case q:
            z = 10;
            break e;
          case pe:
            z = 9;
            break e;
          case he:
            z = 11;
            break e;
          case Y:
            z = 14;
            break e;
          case ee:
            z = 16, I = null;
            break e;
        }
        throw Error(n(130, d == null ? d : typeof d, ""));
    }
    return p = ql(z, _, p, M), p.elementType = d, p.type = I, p.lanes = j, p;
  }
  function fp(d, p, _, I) {
    return d = ql(7, d, I, p), d.lanes = _, d;
  }
  function Sg(d, p, _, I) {
    return d = ql(22, d, I, p), d.elementType = oe, d.lanes = _, d.stateNode = { isHidden: !1 }, d;
  }
  function xg(d, p, _) {
    return d = ql(6, d, null, p), d.lanes = _, d;
  }
  function Bv(d, p, _) {
    return p = ql(4, d.children !== null ? d.children : [], d.key, p), p.lanes = _, p.stateNode = { containerInfo: d.containerInfo, pendingChildren: null, implementation: d.implementation }, p;
  }
  function Vv(d, p, _, I, M) {
    this.tag = p, this.containerInfo = d, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = _u(0), this.expirationTimes = _u(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = _u(0), this.identifierPrefix = I, this.onRecoverableError = M, this.mutableSourceEagerHydrationData = null;
  }
  function Wb(d, p, _, I, M, j, z, ve, ke) {
    return d = new Vv(d, p, _, ve, ke), p === 1 ? (p = 1, j === !0 && (p |= 8)) : p = 0, j = ql(3, null, null, p), d.current = j, j.stateNode = d, j.memoizedState = { element: I, isDehydrated: _, cache: null, transitions: null, pendingSuspenseBoundaries: null }, j1(j), d;
  }
  function T5(d, p, _) {
    var I = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: B, key: I == null ? null : "" + I, children: d, containerInfo: p, implementation: _ };
  }
  function Zb(d) {
    if (!d) return Yu;
    d = d._reactInternals;
    e: {
      if (Vt(d) !== d || d.tag !== 1) throw Error(n(170));
      var p = d;
      do {
        switch (p.tag) {
          case 3:
            p = p.stateNode.context;
            break e;
          case 1:
            if (Ga(p.type)) {
              p = p.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        p = p.return;
      } while (p !== null);
      throw Error(n(171));
    }
    if (d.tag === 1) {
      var _ = d.type;
      if (Ga(_)) return Cv(d, _, p);
    }
    return p;
  }
  function Yb(d, p, _, I, M, j, z, ve, ke) {
    return d = Wb(_, I, !0, d, M, j, z, ve, ke), d.context = Zb(null), _ = d.current, I = xi(), M = Yc(_), j = Ks(I, M), j.callback = p != null ? p : null, Yd(_, j, M), d.current.lanes = M, Ss(d, M, I), ui(d, I), d;
  }
  function Eg(d, p, _, I) {
    var M = p.current, j = xi(), z = Yc(M);
    return _ = Zb(_), p.context === null ? p.context = _ : p.pendingContext = _, p = Ks(j, z), p.payload = { element: d }, I = I === void 0 ? null : I, I !== null && (p.callback = I), d = Yd(M, p, z), d !== null && (to(d, M, z, j), F1(d, M, z)), z;
  }
  function Uv(d) {
    if (d = d.current, !d.child) return null;
    switch (d.child.tag) {
      case 5:
        return d.child.stateNode;
      default:
        return d.child.stateNode;
    }
  }
  function O5(d, p) {
    if (d = d.memoizedState, d !== null && d.dehydrated !== null) {
      var _ = d.retryLane;
      d.retryLane = _ !== 0 && _ < p ? _ : p;
    }
  }
  function Xb(d, p) {
    O5(d, p), (d = d.alternate) && O5(d, p);
  }
  function T9() {
    return null;
  }
  var Kb = typeof reportError == "function" ? reportError : function(d) {
    console.error(d);
  };
  function Ig(d) {
    this._internalRoot = d;
  }
  Gv.prototype.render = Ig.prototype.render = function(d) {
    var p = this._internalRoot;
    if (p === null) throw Error(n(409));
    Eg(d, p, null, null);
  }, Gv.prototype.unmount = Ig.prototype.unmount = function() {
    var d = this._internalRoot;
    if (d !== null) {
      this._internalRoot = null;
      var p = d.containerInfo;
      Qu(function() {
        Eg(null, d, null, null);
      }), p[Vc] = null;
    }
  };
  function Gv(d) {
    this._internalRoot = d;
  }
  Gv.prototype.unstable_scheduleHydration = function(d) {
    if (d) {
      var p = Cu();
      d = { blockedOn: null, target: d, priority: p };
      for (var _ = 0; _ < Vr.length && p !== 0 && p < Vr[_].priority; _++) ;
      Vr.splice(_, 0, d), _ === 0 && lv(d);
    }
  };
  function tf(d) {
    return !(!d || d.nodeType !== 1 && d.nodeType !== 9 && d.nodeType !== 11);
  }
  function kg(d) {
    return !(!d || d.nodeType !== 1 && d.nodeType !== 9 && d.nodeType !== 11 && (d.nodeType !== 8 || d.nodeValue !== " react-mount-point-unstable "));
  }
  function R5() {
  }
  function O9(d, p, _, I, M) {
    if (M) {
      if (typeof I == "function") {
        var j = I;
        I = function() {
          var Xe = Uv(z);
          j.call(Xe);
        };
      }
      var z = Yb(p, I, d, 0, null, !1, !1, "", R5);
      return d._reactRootContainer = z, d[Vc] = z.current, hh(d.nodeType === 8 ? d.parentNode : d), Qu(), z;
    }
    for (; M = d.lastChild; ) d.removeChild(M);
    if (typeof I == "function") {
      var ve = I;
      I = function() {
        var Xe = Uv(ke);
        ve.call(Xe);
      };
    }
    var ke = Wb(d, 0, !1, null, null, !1, !1, "", R5);
    return d._reactRootContainer = ke, d[Vc] = ke.current, hh(d.nodeType === 8 ? d.parentNode : d), Qu(function() {
      Eg(p, ke, _, I);
    }), ke;
  }
  function Ag(d, p, _, I, M) {
    var j = _._reactRootContainer;
    if (j) {
      var z = j;
      if (typeof M == "function") {
        var ve = M;
        M = function() {
          var ke = Uv(z);
          ve.call(ke);
        };
      }
      Eg(p, z, d, M);
    } else z = O9(_, p, d, M, I);
    return Uv(z);
  }
  oh = function(d) {
    switch (d.tag) {
      case 3:
        var p = d.stateNode;
        if (p.current.memoizedState.isDehydrated) {
          var _ = Qa(p.pendingLanes);
          _ !== 0 && (ts(p, _ | 1), ui(p, tr()), !(gr & 6) && (Vh = tr() + 500, Ws()));
        }
        break;
      case 13:
        Qu(function() {
          var I = zc(d, 1);
          if (I !== null) {
            var M = xi();
            to(I, d, 1, M);
          }
        }), Xb(d, 1);
    }
  }, Dd = function(d) {
    if (d.tag === 13) {
      var p = zc(d, 134217728);
      if (p !== null) {
        var _ = xi();
        to(p, d, 134217728, _);
      }
      Xb(d, 134217728);
    }
  }, vr = function(d) {
    if (d.tag === 13) {
      var p = Yc(d), _ = zc(d, p);
      if (_ !== null) {
        var I = xi();
        to(_, d, p, I);
      }
      Xb(d, p);
    }
  }, Cu = function() {
    return Ar;
  }, vl = function(d, p) {
    var _ = Ar;
    try {
      return Ar = d, p();
    } finally {
      Ar = _;
    }
  }, ia = function(d, p, _) {
    switch (p) {
      case "input":
        if (St(d, _), p = _.name, _.type === "radio" && p != null) {
          for (_ = d; _.parentNode; ) _ = _.parentNode;
          for (_ = _.querySelectorAll("input[name=" + JSON.stringify("" + p) + '][type="radio"]'), p = 0; p < _.length; p++) {
            var I = _[p];
            if (I !== d && I.form === d.form) {
              var M = hn(I);
              if (!M) throw Error(n(90));
              be(I), St(I, M);
            }
          }
        }
        break;
      case "textarea":
        At(d, _);
        break;
      case "select":
        p = _.value, p != null && $t(d, !!_.multiple, p, !1);
    }
  }, bs = Gb, _s = Qu;
  var R9 = { usingClientEntryPoint: !1, Events: [_v, mh, hn, es, ti, Gb] }, zv = { findFiberByHostInstance: Fl, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, M5 = { bundleType: zv.bundleType, version: zv.version, rendererPackageName: zv.rendererPackageName, rendererConfig: zv.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: D.ReactCurrentDispatcher, findHostInstanceByFiber: function(d) {
    return d = Hn(d), d === null ? null : d.stateNode;
  }, findFiberByHostInstance: zv.findFiberByHostInstance || T9, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined") {
    var Pg = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Pg.isDisabled && Pg.supportsFiber) try {
      zu = Pg.inject(M5), ws = Pg;
    } catch (d) {
    }
  }
  return ru.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = R9, ru.createPortal = function(d, p) {
    var _ = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!tf(p)) throw Error(n(200));
    return T5(d, p, null, _);
  }, ru.createRoot = function(d, p) {
    if (!tf(d)) throw Error(n(299));
    var _ = !1, I = "", M = Kb;
    return p != null && (p.unstable_strictMode === !0 && (_ = !0), p.identifierPrefix !== void 0 && (I = p.identifierPrefix), p.onRecoverableError !== void 0 && (M = p.onRecoverableError)), p = Wb(d, 1, !1, null, null, _, !1, I, M), d[Vc] = p.current, hh(d.nodeType === 8 ? d.parentNode : d), new Ig(p);
  }, ru.findDOMNode = function(d) {
    if (d == null) return null;
    if (d.nodeType === 1) return d;
    var p = d._reactInternals;
    if (p === void 0)
      throw typeof d.render == "function" ? Error(n(188)) : (d = Object.keys(d).join(","), Error(n(268, d)));
    return d = Hn(p), d = d === null ? null : d.stateNode, d;
  }, ru.flushSync = function(d) {
    return Qu(d);
  }, ru.hydrate = function(d, p, _) {
    if (!kg(p)) throw Error(n(200));
    return Ag(null, d, p, !0, _);
  }, ru.hydrateRoot = function(d, p, _) {
    if (!tf(d)) throw Error(n(405));
    var I = _ != null && _.hydratedSources || null, M = !1, j = "", z = Kb;
    if (_ != null && (_.unstable_strictMode === !0 && (M = !0), _.identifierPrefix !== void 0 && (j = _.identifierPrefix), _.onRecoverableError !== void 0 && (z = _.onRecoverableError)), p = Yb(p, null, d, 1, _ != null ? _ : null, M, !1, j, z), d[Vc] = p.current, hh(d), I) for (d = 0; d < I.length; d++) _ = I[d], M = _._getVersion, M = M(_._source), p.mutableSourceEagerHydrationData == null ? p.mutableSourceEagerHydrationData = [_, M] : p.mutableSourceEagerHydrationData.push(
      _,
      M
    );
    return new Gv(p);
  }, ru.render = function(d, p, _) {
    if (!kg(p)) throw Error(n(200));
    return Ag(null, d, p, !1, _);
  }, ru.unmountComponentAtNode = function(d) {
    if (!kg(d)) throw Error(n(40));
    return d._reactRootContainer ? (Qu(function() {
      Ag(null, null, d, !1, function() {
        d._reactRootContainer = null, d[Vc] = null;
      });
    }), !0) : !1;
  }, ru.unstable_batchedUpdates = Gb, ru.unstable_renderSubtreeIntoContainer = function(d, p, _, I) {
    if (!kg(_)) throw Error(n(200));
    if (d == null || d._reactInternals === void 0) throw Error(n(38));
    return Ag(d, p, _, !1, I);
  }, ru.version = "18.3.1-next-f1338f8080-20240426", ru;
}
var au = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zV;
function M3e() {
  return zV || (zV = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = vo, t = jee(), n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, r = !1;
    function a(i) {
      r = i;
    }
    function o(i) {
      if (!r) {
        for (var l = arguments.length, h = new Array(l > 1 ? l - 1 : 0), g = 1; g < l; g++)
          h[g - 1] = arguments[g];
        c("warn", i, h);
      }
    }
    function s(i) {
      if (!r) {
        for (var l = arguments.length, h = new Array(l > 1 ? l - 1 : 0), g = 1; g < l; g++)
          h[g - 1] = arguments[g];
        c("error", i, h);
      }
    }
    function c(i, l, h) {
      {
        var g = n.ReactDebugCurrentFrame, w = g.getStackAddendum();
        w !== "" && (l += "%s", h = h.concat([w]));
        var A = h.map(function(L) {
          return String(L);
        });
        A.unshift("Warning: " + l), Function.prototype.apply.call(console[i], console, A);
      }
    }
    var u = 0, f = 1, m = 2, v = 3, y = 4, b = 5, S = 6, x = 7, E = 8, N = 9, R = 10, O = 11, D = 12, $ = 13, B = 14, G = 15, Z = 16, K = 17, q = 18, pe = 19, he = 21, _e = 22, ge = 23, Y = 24, ee = 25, oe = !0, me = !1, xe = !1, X = !1, ye = !1, ce = !0, se = !1, Ie = !0, Le = !0, ie = !0, $e = !0, we = /* @__PURE__ */ new Set(), Ne = {}, Ee = {};
    function le(i, l) {
      be(i, l), be(i + "Capture", l);
    }
    function be(i, l) {
      Ne[i] && s("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", i), Ne[i] = l;
      {
        var h = i.toLowerCase();
        Ee[h] = i, i === "onDoubleClick" && (Ee.ondblclick = i);
      }
      for (var g = 0; g < l.length; g++)
        we.add(l[g]);
    }
    var He = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", Ae = Object.prototype.hasOwnProperty;
    function it(i) {
      {
        var l = typeof Symbol == "function" && Symbol.toStringTag, h = l && i[Symbol.toStringTag] || i.constructor.name || "Object";
        return h;
      }
    }
    function ut(i) {
      try {
        return St(i), !1;
      } catch (l) {
        return !0;
      }
    }
    function St(i) {
      return "" + i;
    }
    function sn(i, l) {
      if (ut(i))
        return s("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", l, it(i)), St(i);
    }
    function zn(i) {
      if (ut(i))
        return s("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", it(i)), St(i);
    }
    function dn(i, l) {
      if (ut(i))
        return s("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", l, it(i)), St(i);
    }
    function $t(i, l) {
      if (ut(i))
        return s("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", l, it(i)), St(i);
    }
    function qt(i) {
      if (ut(i))
        return s("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", it(i)), St(i);
    }
    function fn(i) {
      if (ut(i))
        return s("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", it(i)), St(i);
    }
    var At = 0, Wt = 1, Xr = 2, Kn = 3, Sr = 4, jo = 5, ei = 6, tt = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", bt = tt + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", rn = new RegExp("^[" + tt + "][" + bt + "]*$"), Rn = {}, Cn = {};
    function Qn(i) {
      return Ae.call(Cn, i) ? !0 : Ae.call(Rn, i) ? !1 : rn.test(i) ? (Cn[i] = !0, !0) : (Rn[i] = !0, s("Invalid attribute name: `%s`", i), !1);
    }
    function er(i, l, h) {
      return l !== null ? l.type === At : h ? !1 : i.length > 2 && (i[0] === "o" || i[0] === "O") && (i[1] === "n" || i[1] === "N");
    }
    function oo(i, l, h, g) {
      if (h !== null && h.type === At)
        return !1;
      switch (typeof l) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (g)
            return !1;
          if (h !== null)
            return !h.acceptsBooleans;
          var w = i.toLowerCase().slice(0, 5);
          return w !== "data-" && w !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Lr(i, l, h, g) {
      if (l === null || typeof l == "undefined" || oo(i, l, h, g))
        return !0;
      if (g)
        return !1;
      if (h !== null)
        switch (h.type) {
          case Kn:
            return !l;
          case Sr:
            return l === !1;
          case jo:
            return isNaN(l);
          case ei:
            return isNaN(l) || l < 1;
        }
      return !1;
    }
    function ia(i) {
      return xr.hasOwnProperty(i) ? xr[i] : null;
    }
    function ir(i, l, h, g, w, A, L) {
      this.acceptsBooleans = l === Xr || l === Kn || l === Sr, this.attributeName = g, this.attributeNamespace = w, this.mustUseProperty = h, this.propertyName = i, this.type = l, this.sanitizeURL = A, this.removeEmptyString = L;
    }
    var xr = {}, wo = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    wo.forEach(function(i) {
      xr[i] = new ir(
        i,
        At,
        !1,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(i) {
      var l = i[0], h = i[1];
      xr[l] = new ir(
        l,
        Wt,
        !1,
        // mustUseProperty
        h,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(i) {
      xr[i] = new ir(
        i,
        Xr,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(i) {
      xr[i] = new ir(
        i,
        Xr,
        !1,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(i) {
      xr[i] = new ir(
        i,
        Kn,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      xr[i] = new ir(
        i,
        Kn,
        !0,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      xr[i] = new ir(
        i,
        Sr,
        !1,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      xr[i] = new ir(
        i,
        ei,
        !1,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(i) {
      xr[i] = new ir(
        i,
        jo,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var es = /[\-\:]([a-z])/g, ti = function(i) {
      return i[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      var l = i.replace(es, ti);
      xr[l] = new ir(
        l,
        Wt,
        !1,
        // mustUseProperty
        i,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      var l = i.replace(es, ti);
      xr[l] = new ir(
        l,
        Wt,
        !1,
        // mustUseProperty
        i,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      var l = i.replace(es, ti);
      xr[l] = new ir(
        l,
        Wt,
        !1,
        // mustUseProperty
        i,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(i) {
      xr[i] = new ir(
        i,
        Wt,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var bs = "xlinkHref";
    xr[bs] = new ir(
      "xlinkHref",
      Wt,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(i) {
      xr[i] = new ir(
        i,
        Wt,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var _s = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, ni = !1;
    function Ka(i) {
      !ni && _s.test(i) && (ni = !0, s("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(i)));
    }
    function So(i, l, h, g) {
      if (g.mustUseProperty) {
        var w = g.propertyName;
        return i[w];
      } else {
        sn(h, l), g.sanitizeURL && Ka("" + h);
        var A = g.attributeName, L = null;
        if (g.type === Sr) {
          if (i.hasAttribute(A)) {
            var F = i.getAttribute(A);
            return F === "" ? !0 : Lr(l, h, g, !1) ? F : F === "" + h ? h : F;
          }
        } else if (i.hasAttribute(A)) {
          if (Lr(l, h, g, !1))
            return i.getAttribute(A);
          if (g.type === Kn)
            return h;
          L = i.getAttribute(A);
        }
        return Lr(l, h, g, !1) ? L === null ? h : L : L === "" + h ? h : L;
      }
    }
    function Fo(i, l, h, g) {
      {
        if (!Qn(l))
          return;
        if (!i.hasAttribute(l))
          return h === void 0 ? void 0 : null;
        var w = i.getAttribute(l);
        return sn(h, l), w === "" + h ? h : w;
      }
    }
    function Pa(i, l, h, g) {
      var w = ia(l);
      if (!er(l, w, g)) {
        if (Lr(l, h, w, g) && (h = null), g || w === null) {
          if (Qn(l)) {
            var A = l;
            h === null ? i.removeAttribute(A) : (sn(h, l), i.setAttribute(A, "" + h));
          }
          return;
        }
        var L = w.mustUseProperty;
        if (L) {
          var F = w.propertyName;
          if (h === null) {
            var V = w.type;
            i[F] = V === Kn ? !1 : "";
          } else
            i[F] = h;
          return;
        }
        var J = w.attributeName, ae = w.attributeNamespace;
        if (h === null)
          i.removeAttribute(J);
        else {
          var Me = w.type, Te;
          Me === Kn || Me === Sr && h === !0 ? Te = "" : (sn(h, J), Te = "" + h, w.sanitizeURL && Ka(Te.toString())), ae ? i.setAttributeNS(ae, J, Te) : i.setAttribute(J, Te);
        }
      }
    }
    var ri = Symbol.for("react.element"), xo = Symbol.for("react.portal"), qa = Symbol.for("react.fragment"), ml = Symbol.for("react.strict_mode"), bu = Symbol.for("react.profiler"), Ce = Symbol.for("react.provider"), pt = Symbol.for("react.context"), Nt = Symbol.for("react.forward_ref"), Vt = Symbol.for("react.suspense"), Mn = Symbol.for("react.suspense_list"), Dn = Symbol.for("react.memo"), vn = Symbol.for("react.lazy"), Hn = Symbol.for("react.scope"), Ja = Symbol.for("react.debug_trace_mode"), Qr = Symbol.for("react.offscreen"), sa = Symbol.for("react.legacy_hidden"), gi = Symbol.for("react.cache"), Cs = Symbol.for("react.tracing_marker"), tr = Symbol.iterator, Ra = "@@iterator";
    function Eo(i) {
      if (i === null || typeof i != "object")
        return null;
      var l = tr && i[tr] || i[Ra];
      return typeof l == "function" ? l : null;
    }
    var Vn = Object.assign, Gs = 0, jf, Ff, zu, ws, Bf, Oi, ah;
    function Pt() {
    }
    Pt.__reactDisabledLog = !0;
    function qn() {
      {
        if (Gs === 0) {
          jf = console.log, Ff = console.info, zu = console.warn, ws = console.error, Bf = console.group, Oi = console.groupCollapsed, ah = console.groupEnd;
          var i = {
            configurable: !0,
            enumerable: !0,
            value: Pt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: i,
            log: i,
            warn: i,
            error: i,
            group: i,
            groupCollapsed: i,
            groupEnd: i
          });
        }
        Gs++;
      }
    }
    function xa() {
      {
        if (Gs--, Gs === 0) {
          var i = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Vn({}, i, {
              value: jf
            }),
            info: Vn({}, i, {
              value: Ff
            }),
            warn: Vn({}, i, {
              value: zu
            }),
            error: Vn({}, i, {
              value: ws
            }),
            group: Vn({}, i, {
              value: Bf
            }),
            groupCollapsed: Vn({}, i, {
              value: Oi
            }),
            groupEnd: Vn({}, i, {
              value: ah
            })
          });
        }
        Gs < 0 && s("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var $r = n.ReactCurrentDispatcher, Qa;
    function Ln(i, l, h) {
      {
        if (Qa === void 0)
          try {
            throw Error();
          } catch (w) {
            var g = w.stack.trim().match(/\n( *(at )?)/);
            Qa = g && g[1] || "";
          }
        return `
` + Qa + i;
      }
    }
    var Io = !1, io;
    {
      var ai = typeof WeakMap == "function" ? WeakMap : Map;
      io = new ai();
    }
    function yi(i, l) {
      if (!i || Io)
        return "";
      {
        var h = io.get(i);
        if (h !== void 0)
          return h;
      }
      var g;
      Io = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = $r.current, $r.current = null, qn();
      try {
        if (l) {
          var L = function() {
            throw Error();
          };
          if (Object.defineProperty(L.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(L, []);
            } catch (Ke) {
              g = Ke;
            }
            Reflect.construct(i, [], L);
          } else {
            try {
              L.call();
            } catch (Ke) {
              g = Ke;
            }
            i.call(L.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ke) {
            g = Ke;
          }
          i();
        }
      } catch (Ke) {
        if (Ke && g && typeof Ke.stack == "string") {
          for (var F = Ke.stack.split(`
`), V = g.stack.split(`
`), J = F.length - 1, ae = V.length - 1; J >= 1 && ae >= 0 && F[J] !== V[ae]; )
            ae--;
          for (; J >= 1 && ae >= 0; J--, ae--)
            if (F[J] !== V[ae]) {
              if (J !== 1 || ae !== 1)
                do
                  if (J--, ae--, ae < 0 || F[J] !== V[ae]) {
                    var Me = `
` + F[J].replace(" at new ", " at ");
                    return i.displayName && Me.includes("<anonymous>") && (Me = Me.replace("<anonymous>", i.displayName)), typeof i == "function" && io.set(i, Me), Me;
                  }
                while (J >= 1 && ae >= 0);
              break;
            }
        }
      } finally {
        Io = !1, $r.current = A, xa(), Error.prepareStackTrace = w;
      }
      var Te = i ? i.displayName || i.name : "", Ye = Te ? Ln(Te) : "";
      return typeof i == "function" && io.set(i, Ye), Ye;
    }
    function _u(i, l, h) {
      return yi(i, !0);
    }
    function Ss(i, l, h) {
      return yi(i, !1);
    }
    function xs(i) {
      var l = i.prototype;
      return !!(l && l.isReactComponent);
    }
    function ts(i, l, h) {
      if (i == null)
        return "";
      if (typeof i == "function")
        return yi(i, xs(i));
      if (typeof i == "string")
        return Ln(i);
      switch (i) {
        case Vt:
          return Ln("Suspense");
        case Mn:
          return Ln("SuspenseList");
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case Nt:
            return Ss(i.render);
          case Dn:
            return ts(i.type, l, h);
          case vn: {
            var g = i, w = g._payload, A = g._init;
            try {
              return ts(A(w), l, h);
            } catch (L) {
            }
          }
        }
      return "";
    }
    function Ar(i) {
      switch (i._debugOwner && i._debugOwner.type, i._debugSource, i.tag) {
        case b:
          return Ln(i.type);
        case Z:
          return Ln("Lazy");
        case $:
          return Ln("Suspense");
        case pe:
          return Ln("SuspenseList");
        case u:
        case m:
        case G:
          return Ss(i.type);
        case O:
          return Ss(i.type.render);
        case f:
          return _u(i.type);
        default:
          return "";
      }
    }
    function Mc(i) {
      try {
        var l = "", h = i;
        do
          l += Ar(h), h = h.return;
        while (h);
        return l;
      } catch (g) {
        return `
Error generating stack: ` + g.message + `
` + g.stack;
      }
    }
    function oh(i, l, h) {
      var g = i.displayName;
      if (g)
        return g;
      var w = l.displayName || l.name || "";
      return w !== "" ? h + "(" + w + ")" : h;
    }
    function Dd(i) {
      return i.displayName || "Context";
    }
    function vr(i) {
      if (i == null)
        return null;
      if (typeof i.tag == "number" && s("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof i == "function")
        return i.displayName || i.name || null;
      if (typeof i == "string")
        return i;
      switch (i) {
        case qa:
          return "Fragment";
        case xo:
          return "Portal";
        case bu:
          return "Profiler";
        case ml:
          return "StrictMode";
        case Vt:
          return "Suspense";
        case Mn:
          return "SuspenseList";
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case pt:
            var l = i;
            return Dd(l) + ".Consumer";
          case Ce:
            var h = i;
            return Dd(h._context) + ".Provider";
          case Nt:
            return oh(i, i.render, "ForwardRef");
          case Dn:
            var g = i.displayName || null;
            return g !== null ? g : vr(i.type) || "Memo";
          case vn: {
            var w = i, A = w._payload, L = w._init;
            try {
              return vr(L(A));
            } catch (F) {
              return null;
            }
          }
        }
      return null;
    }
    function Cu(i, l, h) {
      var g = l.displayName || l.name || "";
      return i.displayName || (g !== "" ? h + "(" + g + ")" : h);
    }
    function vl(i) {
      return i.displayName || "Context";
    }
    function In(i) {
      var l = i.tag, h = i.type;
      switch (l) {
        case Y:
          return "Cache";
        case N:
          var g = h;
          return vl(g) + ".Consumer";
        case R:
          var w = h;
          return vl(w._context) + ".Provider";
        case q:
          return "DehydratedFragment";
        case O:
          return Cu(h, h.render, "ForwardRef");
        case x:
          return "Fragment";
        case b:
          return h;
        case y:
          return "Portal";
        case v:
          return "Root";
        case S:
          return "Text";
        case Z:
          return vr(h);
        case E:
          return h === ml ? "StrictMode" : "Mode";
        case _e:
          return "Offscreen";
        case D:
          return "Profiler";
        case he:
          return "Scope";
        case $:
          return "Suspense";
        case pe:
          return "SuspenseList";
        case ee:
          return "TracingMarker";
        case f:
        case u:
        case K:
        case m:
        case B:
        case G:
          if (typeof h == "function")
            return h.displayName || h.name || null;
          if (typeof h == "string")
            return h;
          break;
      }
      return null;
    }
    var Hu = n.ReactDebugCurrentFrame, Ua = null, ns = !1;
    function rs() {
      {
        if (Ua === null)
          return null;
        var i = Ua._debugOwner;
        if (i !== null && typeof i != "undefined")
          return In(i);
      }
      return null;
    }
    function Vf() {
      return Ua === null ? "" : Mc(Ua);
    }
    function so() {
      Hu.getCurrentStack = null, Ua = null, ns = !1;
    }
    function Vr(i) {
      Hu.getCurrentStack = i === null ? null : Vf, Ua = i, ns = !1;
    }
    function m1() {
      return Ua;
    }
    function oi(i) {
      ns = i;
    }
    function lo(i) {
      return "" + i;
    }
    function Wu(i) {
      switch (typeof i) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return i;
        case "object":
          return fn(i), i;
        default:
          return "";
      }
    }
    var lv = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Ld(i, l) {
      lv[l.type] || l.onChange || l.onInput || l.readOnly || l.disabled || l.value == null || s("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), l.onChange || l.readOnly || l.disabled || l.checked == null || s("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function ih(i) {
      var l = i.type, h = i.nodeName;
      return h && h.toLowerCase() === "input" && (l === "checkbox" || l === "radio");
    }
    function v1(i) {
      return i._valueTracker;
    }
    function Uf(i) {
      i._valueTracker = null;
    }
    function $d(i) {
      var l = "";
      return i && (ih(i) ? l = i.checked ? "true" : "false" : l = i.value), l;
    }
    function jd(i) {
      var l = ih(i) ? "checked" : "value", h = Object.getOwnPropertyDescriptor(i.constructor.prototype, l);
      fn(i[l]);
      var g = "" + i[l];
      if (!(i.hasOwnProperty(l) || typeof h == "undefined" || typeof h.get != "function" || typeof h.set != "function")) {
        var w = h.get, A = h.set;
        Object.defineProperty(i, l, {
          configurable: !0,
          get: function() {
            return w.call(this);
          },
          set: function(F) {
            fn(F), g = "" + F, A.call(this, F);
          }
        }), Object.defineProperty(i, l, {
          enumerable: h.enumerable
        });
        var L = {
          getValue: function() {
            return g;
          },
          setValue: function(F) {
            fn(F), g = "" + F;
          },
          stopTracking: function() {
            Uf(i), delete i[l];
          }
        };
        return L;
      }
    }
    function ue(i) {
      v1(i) || (i._valueTracker = jd(i));
    }
    function De(i) {
      if (!i)
        return !1;
      var l = v1(i);
      if (!l)
        return !0;
      var h = l.getValue(), g = $d(i);
      return g !== h ? (l.setValue(g), !0) : !1;
    }
    function qe(i) {
      if (i = i || (typeof document != "undefined" ? document : void 0), typeof i == "undefined")
        return null;
      try {
        return i.activeElement || i.body;
      } catch (l) {
        return i.body;
      }
    }
    var Xt = !1, sr = !1, Ur = !1, ha = !1;
    function nr(i) {
      var l = i.type === "checkbox" || i.type === "radio";
      return l ? i.checked != null : i.value != null;
    }
    function ea(i, l) {
      var h = i, g = l.checked, w = Vn({}, l, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: g != null ? g : h._wrapperState.initialChecked
      });
      return w;
    }
    function Ri(i, l) {
      Ld("input", l), l.checked !== void 0 && l.defaultChecked !== void 0 && !sr && (s("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", rs() || "A component", l.type), sr = !0), l.value !== void 0 && l.defaultValue !== void 0 && !Xt && (s("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", rs() || "A component", l.type), Xt = !0);
      var h = i, g = l.defaultValue == null ? "" : l.defaultValue;
      h._wrapperState = {
        initialChecked: l.checked != null ? l.checked : l.defaultChecked,
        initialValue: Wu(l.value != null ? l.value : g),
        controlled: nr(l)
      };
    }
    function Mi(i, l) {
      var h = i, g = l.checked;
      g != null && Pa(h, "checked", g, !1);
    }
    function $l(i, l) {
      var h = i;
      {
        var g = nr(l);
        !h._wrapperState.controlled && g && !ha && (s("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), ha = !0), h._wrapperState.controlled && !g && !Ur && (s("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Ur = !0);
      }
      Mi(i, l);
      var w = Wu(l.value), A = l.type;
      if (w != null)
        A === "number" ? (w === 0 && h.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        h.value != w) && (h.value = lo(w)) : h.value !== lo(w) && (h.value = lo(w));
      else if (A === "submit" || A === "reset") {
        h.removeAttribute("value");
        return;
      }
      l.hasOwnProperty("value") ? Fd(h, l.type, w) : l.hasOwnProperty("defaultValue") && Fd(h, l.type, Wu(l.defaultValue)), l.checked == null && l.defaultChecked != null && (h.defaultChecked = !!l.defaultChecked);
    }
    function Dc(i, l, h) {
      var g = i;
      if (l.hasOwnProperty("value") || l.hasOwnProperty("defaultValue")) {
        var w = l.type, A = w === "submit" || w === "reset";
        if (A && (l.value === void 0 || l.value === null))
          return;
        var L = lo(g._wrapperState.initialValue);
        h || L !== g.value && (g.value = L), g.defaultValue = L;
      }
      var F = g.name;
      F !== "" && (g.name = ""), g.defaultChecked = !g.defaultChecked, g.defaultChecked = !!g._wrapperState.initialChecked, F !== "" && (g.name = F);
    }
    function sh(i, l) {
      var h = i;
      $l(h, l), as(h, l);
    }
    function as(i, l) {
      var h = l.name;
      if (l.type === "radio" && h != null) {
        for (var g = i; g.parentNode; )
          g = g.parentNode;
        sn(h, "name");
        for (var w = g.querySelectorAll("input[name=" + JSON.stringify("" + h) + '][type="radio"]'), A = 0; A < w.length; A++) {
          var L = w[A];
          if (!(L === i || L.form !== i.form)) {
            var F = q5(L);
            if (!F)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            De(L), $l(L, F);
          }
        }
      }
    }
    function Fd(i, l, h) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (l !== "number" || qe(i.ownerDocument) !== i) && (h == null ? i.defaultValue = lo(i._wrapperState.initialValue) : i.defaultValue !== lo(h) && (i.defaultValue = lo(h)));
    }
    var g1 = !1, lh = !1, yC = !1;
    function y1(i, l) {
      l.value == null && (typeof l.children == "object" && l.children !== null ? e.Children.forEach(l.children, function(h) {
        h != null && (typeof h == "string" || typeof h == "number" || lh || (lh = !0, s("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : l.dangerouslySetInnerHTML != null && (yC || (yC = !0, s("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), l.selected != null && !g1 && (s("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), g1 = !0);
    }
    function Y2(i, l) {
      l.value != null && i.setAttribute("value", lo(Wu(l.value)));
    }
    var uv = Array.isArray;
    function bi(i) {
      return uv(i);
    }
    var b1;
    b1 = !1;
    function bC() {
      var i = rs();
      return i ? `

Check the render method of \`` + i + "`." : "";
    }
    var _C = ["value", "defaultValue"];
    function e9(i) {
      {
        Ld("select", i);
        for (var l = 0; l < _C.length; l++) {
          var h = _C[l];
          if (i[h] != null) {
            var g = bi(i[h]);
            i.multiple && !g ? s("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", h, bC()) : !i.multiple && g && s("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", h, bC());
          }
        }
      }
    }
    function Bd(i, l, h, g) {
      var w = i.options;
      if (l) {
        for (var A = h, L = {}, F = 0; F < A.length; F++)
          L["$" + A[F]] = !0;
        for (var V = 0; V < w.length; V++) {
          var J = L.hasOwnProperty("$" + w[V].value);
          w[V].selected !== J && (w[V].selected = J), J && g && (w[V].defaultSelected = !0);
        }
      } else {
        for (var ae = lo(Wu(h)), Me = null, Te = 0; Te < w.length; Te++) {
          if (w[Te].value === ae) {
            w[Te].selected = !0, g && (w[Te].defaultSelected = !0);
            return;
          }
          Me === null && !w[Te].disabled && (Me = w[Te]);
        }
        Me !== null && (Me.selected = !0);
      }
    }
    function X2(i, l) {
      return Vn({}, l, {
        value: void 0
      });
    }
    function CC(i, l) {
      var h = i;
      e9(l), h._wrapperState = {
        wasMultiple: !!l.multiple
      }, l.value !== void 0 && l.defaultValue !== void 0 && !b1 && (s("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), b1 = !0);
    }
    function t9(i, l) {
      var h = i;
      h.multiple = !!l.multiple;
      var g = l.value;
      g != null ? Bd(h, !!l.multiple, g, !1) : l.defaultValue != null && Bd(h, !!l.multiple, l.defaultValue, !0);
    }
    function n9(i, l) {
      var h = i, g = h._wrapperState.wasMultiple;
      h._wrapperState.wasMultiple = !!l.multiple;
      var w = l.value;
      w != null ? Bd(h, !!l.multiple, w, !1) : g !== !!l.multiple && (l.defaultValue != null ? Bd(h, !!l.multiple, l.defaultValue, !0) : Bd(h, !!l.multiple, l.multiple ? [] : "", !1));
    }
    function r9(i, l) {
      var h = i, g = l.value;
      g != null && Bd(h, !!l.multiple, g, !1);
    }
    var K2 = !1;
    function q2(i, l) {
      var h = i;
      if (l.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var g = Vn({}, l, {
        value: void 0,
        defaultValue: void 0,
        children: lo(h._wrapperState.initialValue)
      });
      return g;
    }
    function wC(i, l) {
      var h = i;
      Ld("textarea", l), l.value !== void 0 && l.defaultValue !== void 0 && !K2 && (s("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", rs() || "A component"), K2 = !0);
      var g = l.value;
      if (g == null) {
        var w = l.children, A = l.defaultValue;
        if (w != null) {
          s("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (A != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (bi(w)) {
              if (w.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              w = w[0];
            }
            A = w;
          }
        }
        A == null && (A = ""), g = A;
      }
      h._wrapperState = {
        initialValue: Wu(g)
      };
    }
    function SC(i, l) {
      var h = i, g = Wu(l.value), w = Wu(l.defaultValue);
      if (g != null) {
        var A = lo(g);
        A !== h.value && (h.value = A), l.defaultValue == null && h.defaultValue !== A && (h.defaultValue = A);
      }
      w != null && (h.defaultValue = lo(w));
    }
    function xC(i, l) {
      var h = i, g = h.textContent;
      g === h._wrapperState.initialValue && g !== "" && g !== null && (h.value = g);
    }
    function J2(i, l) {
      SC(i, l);
    }
    var Lc = "http://www.w3.org/1999/xhtml", a9 = "http://www.w3.org/1998/Math/MathML", Q2 = "http://www.w3.org/2000/svg";
    function _1(i) {
      switch (i) {
        case "svg":
          return Q2;
        case "math":
          return a9;
        default:
          return Lc;
      }
    }
    function eb(i, l) {
      return i == null || i === Lc ? _1(l) : i === Q2 && l === "foreignObject" ? Lc : i;
    }
    var o9 = function(i) {
      return typeof MSApp != "undefined" && MSApp.execUnsafeLocalFunction ? function(l, h, g, w) {
        MSApp.execUnsafeLocalFunction(function() {
          return i(l, h, g, w);
        });
      } : i;
    }, C1, EC = o9(function(i, l) {
      if (i.namespaceURI === Q2 && !("innerHTML" in i)) {
        C1 = C1 || document.createElement("div"), C1.innerHTML = "<svg>" + l.valueOf().toString() + "</svg>";
        for (var h = C1.firstChild; i.firstChild; )
          i.removeChild(i.firstChild);
        for (; h.firstChild; )
          i.appendChild(h.firstChild);
        return;
      }
      i.innerHTML = l;
    }), zs = 1, $c = 3, Bo = 8, wu = 9, Gf = 11, w1 = function(i, l) {
      if (l) {
        var h = i.firstChild;
        if (h && h === i.lastChild && h.nodeType === $c) {
          h.nodeValue = l;
          return;
        }
      }
      i.textContent = l;
    }, IC = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, uh = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function kC(i, l) {
      return i + l.charAt(0).toUpperCase() + l.substring(1);
    }
    var AC = ["Webkit", "ms", "Moz", "O"];
    Object.keys(uh).forEach(function(i) {
      AC.forEach(function(l) {
        uh[kC(l, i)] = uh[i];
      });
    });
    function S1(i, l, h) {
      var g = l == null || typeof l == "boolean" || l === "";
      return g ? "" : !h && typeof l == "number" && l !== 0 && !(uh.hasOwnProperty(i) && uh[i]) ? l + "px" : ($t(l, i), ("" + l).trim());
    }
    var ch = /([A-Z])/g, i9 = /^ms-/;
    function s9(i) {
      return i.replace(ch, "-$1").toLowerCase().replace(i9, "-ms-");
    }
    var PC = function() {
    };
    {
      var NC = /^(?:webkit|moz|o)[A-Z]/, TC = /^-ms-/, cv = /-(.)/g, dh = /;\s*$/, fh = {}, ph = {}, OC = !1, tb = !1, nb = function(i) {
        return i.replace(cv, function(l, h) {
          return h.toUpperCase();
        });
      }, rb = function(i) {
        fh.hasOwnProperty(i) && fh[i] || (fh[i] = !0, s(
          "Unsupported style property %s. Did you mean %s?",
          i,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          nb(i.replace(TC, "ms-"))
        ));
      }, RC = function(i) {
        fh.hasOwnProperty(i) && fh[i] || (fh[i] = !0, s("Unsupported vendor-prefixed style property %s. Did you mean %s?", i, i.charAt(0).toUpperCase() + i.slice(1)));
      }, MC = function(i, l) {
        ph.hasOwnProperty(l) && ph[l] || (ph[l] = !0, s(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, i, l.replace(dh, "")));
      }, DC = function(i, l) {
        OC || (OC = !0, s("`NaN` is an invalid value for the `%s` css style property.", i));
      }, l9 = function(i, l) {
        tb || (tb = !0, s("`Infinity` is an invalid value for the `%s` css style property.", i));
      };
      PC = function(i, l) {
        i.indexOf("-") > -1 ? rb(i) : NC.test(i) ? RC(i) : dh.test(l) && MC(i, l), typeof l == "number" && (isNaN(l) ? DC(i, l) : isFinite(l) || l9(i, l));
      };
    }
    var u9 = PC;
    function c9(i) {
      {
        var l = "", h = "";
        for (var g in i)
          if (i.hasOwnProperty(g)) {
            var w = i[g];
            if (w != null) {
              var A = g.indexOf("--") === 0;
              l += h + (A ? g : s9(g)) + ":", l += S1(g, w, A), h = ";";
            }
          }
        return l || null;
      }
    }
    function LC(i, l) {
      var h = i.style;
      for (var g in l)
        if (l.hasOwnProperty(g)) {
          var w = g.indexOf("--") === 0;
          w || u9(g, l[g]);
          var A = S1(g, l[g], w);
          g === "float" && (g = "cssFloat"), w ? h.setProperty(g, A) : h[g] = A;
        }
    }
    function d9(i) {
      return i == null || typeof i == "boolean" || i === "";
    }
    function jl(i) {
      var l = {};
      for (var h in i)
        for (var g = IC[h] || [h], w = 0; w < g.length; w++)
          l[g[w]] = h;
      return l;
    }
    function dv(i, l) {
      {
        if (!l)
          return;
        var h = jl(i), g = jl(l), w = {};
        for (var A in h) {
          var L = h[A], F = g[A];
          if (F && L !== F) {
            var V = L + "," + F;
            if (w[V])
              continue;
            w[V] = !0, s("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", d9(i[L]) ? "Removing" : "Updating", L, F);
          }
        }
      }
    }
    var $C = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, jC = Vn({
      menuitem: !0
    }, $C), FC = "__html";
    function x1(i, l) {
      if (l) {
        if (jC[i] && (l.children != null || l.dangerouslySetInnerHTML != null))
          throw new Error(i + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (l.dangerouslySetInnerHTML != null) {
          if (l.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof l.dangerouslySetInnerHTML != "object" || !(FC in l.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!l.suppressContentEditableWarning && l.contentEditable && l.children != null && s("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), l.style != null && typeof l.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function jc(i, l) {
      if (i.indexOf("-") === -1)
        return typeof l.is == "string";
      switch (i) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var E1 = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, BC = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Su = {}, ab = new RegExp("^(aria)-[" + bt + "]*$"), fv = new RegExp("^(aria)[A-Z][" + bt + "]*$");
    function ob(i, l) {
      {
        if (Ae.call(Su, l) && Su[l])
          return !0;
        if (fv.test(l)) {
          var h = "aria-" + l.slice(4).toLowerCase(), g = BC.hasOwnProperty(h) ? h : null;
          if (g == null)
            return s("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", l), Su[l] = !0, !0;
          if (l !== g)
            return s("Invalid ARIA attribute `%s`. Did you mean `%s`?", l, g), Su[l] = !0, !0;
        }
        if (ab.test(l)) {
          var w = l.toLowerCase(), A = BC.hasOwnProperty(w) ? w : null;
          if (A == null)
            return Su[l] = !0, !1;
          if (l !== A)
            return s("Unknown ARIA attribute `%s`. Did you mean `%s`?", l, A), Su[l] = !0, !0;
        }
      }
      return !0;
    }
    function VC(i, l) {
      {
        var h = [];
        for (var g in l) {
          var w = ob(i, g);
          w || h.push(g);
        }
        var A = h.map(function(L) {
          return "`" + L + "`";
        }).join(", ");
        h.length === 1 ? s("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", A, i) : h.length > 1 && s("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", A, i);
      }
    }
    function I1(i, l) {
      jc(i, l) || VC(i, l);
    }
    var zf = !1;
    function ib(i, l) {
      {
        if (i !== "input" && i !== "textarea" && i !== "select")
          return;
        l != null && l.value === null && !zf && (zf = !0, i === "select" && l.multiple ? s("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", i) : s("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", i));
      }
    }
    var sb = function() {
    };
    {
      var _i = {}, lb = /^on./, UC = /^on[^A-Z]/, GC = new RegExp("^(aria)-[" + bt + "]*$"), zC = new RegExp("^(aria)[A-Z][" + bt + "]*$");
      sb = function(i, l, h, g) {
        if (Ae.call(_i, l) && _i[l])
          return !0;
        var w = l.toLowerCase();
        if (w === "onfocusin" || w === "onfocusout")
          return s("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), _i[l] = !0, !0;
        if (g != null) {
          var A = g.registrationNameDependencies, L = g.possibleRegistrationNames;
          if (A.hasOwnProperty(l))
            return !0;
          var F = L.hasOwnProperty(w) ? L[w] : null;
          if (F != null)
            return s("Invalid event handler property `%s`. Did you mean `%s`?", l, F), _i[l] = !0, !0;
          if (lb.test(l))
            return s("Unknown event handler property `%s`. It will be ignored.", l), _i[l] = !0, !0;
        } else if (lb.test(l))
          return UC.test(l) && s("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", l), _i[l] = !0, !0;
        if (GC.test(l) || zC.test(l))
          return !0;
        if (w === "innerhtml")
          return s("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), _i[l] = !0, !0;
        if (w === "aria")
          return s("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), _i[l] = !0, !0;
        if (w === "is" && h !== null && h !== void 0 && typeof h != "string")
          return s("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof h), _i[l] = !0, !0;
        if (typeof h == "number" && isNaN(h))
          return s("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", l), _i[l] = !0, !0;
        var V = ia(l), J = V !== null && V.type === At;
        if (E1.hasOwnProperty(w)) {
          var ae = E1[w];
          if (ae !== l)
            return s("Invalid DOM property `%s`. Did you mean `%s`?", l, ae), _i[l] = !0, !0;
        } else if (!J && l !== w)
          return s("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", l, w), _i[l] = !0, !0;
        return typeof h == "boolean" && oo(l, h, V, !1) ? (h ? s('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', h, l, l, h, l) : s('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', h, l, l, h, l, l, l), _i[l] = !0, !0) : J ? !0 : oo(l, h, V, !1) ? (_i[l] = !0, !1) : ((h === "false" || h === "true") && V !== null && V.type === Kn && (s("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", h, l, h === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', l, h), _i[l] = !0), !0);
      };
    }
    var HC = function(i, l, h) {
      {
        var g = [];
        for (var w in l) {
          var A = sb(i, w, l[w], h);
          A || g.push(w);
        }
        var L = g.map(function(F) {
          return "`" + F + "`";
        }).join(", ");
        g.length === 1 ? s("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", L, i) : g.length > 1 && s("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", L, i);
      }
    };
    function WC(i, l, h) {
      jc(i, l) || HC(i, l, h);
    }
    var Fc = 1, pv = 2, Hf = 4, f9 = Fc | pv | Hf, hv = null;
    function mv(i) {
      hv !== null && s("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), hv = i;
    }
    function p9() {
      hv === null && s("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), hv = null;
    }
    function ZC(i) {
      return i === hv;
    }
    function k1(i) {
      var l = i.target || i.srcElement || window;
      return l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === $c ? l.parentNode : l;
    }
    var Ea = null, Vd = null, Bc = null;
    function hh(i) {
      var l = Zh(i);
      if (l) {
        if (typeof Ea != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var h = l.stateNode;
        if (h) {
          var g = q5(h);
          Ea(l.stateNode, l.type, g);
        }
      }
    }
    function YC(i) {
      Ea = i;
    }
    function A1(i) {
      Vd ? Bc ? Bc.push(i) : Bc = [i] : Vd = i;
    }
    function vv() {
      return Vd !== null || Bc !== null;
    }
    function gv() {
      if (Vd) {
        var i = Vd, l = Bc;
        if (Vd = null, Bc = null, hh(i), l)
          for (var h = 0; h < l.length; h++)
            hh(l[h]);
      }
    }
    var Wf = function(i, l) {
      return i(l);
    }, ub = function() {
    }, cb = !1;
    function h9() {
      var i = vv();
      i && (ub(), gv());
    }
    function db(i, l, h) {
      if (cb)
        return i(l, h);
      cb = !0;
      try {
        return Wf(i, l, h);
      } finally {
        cb = !1, h9();
      }
    }
    function P1(i, l, h) {
      Wf = i, ub = h;
    }
    function N1(i) {
      return i === "button" || i === "input" || i === "select" || i === "textarea";
    }
    function fb(i, l, h) {
      switch (i) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(h.disabled && N1(l));
        default:
          return !1;
      }
    }
    function Zf(i, l) {
      var h = i.stateNode;
      if (h === null)
        return null;
      var g = q5(h);
      if (g === null)
        return null;
      var w = g[l];
      if (fb(l, i.type, g))
        return null;
      if (w && typeof w != "function")
        throw new Error("Expected `" + l + "` listener to be a function, instead got a value of `" + typeof w + "` type.");
      return w;
    }
    var yv = !1;
    if (He)
      try {
        var Yf = {};
        Object.defineProperty(Yf, "passive", {
          get: function() {
            yv = !0;
          }
        }), window.addEventListener("test", Yf, Yf), window.removeEventListener("test", Yf, Yf);
      } catch (i) {
        yv = !1;
      }
    function XC(i, l, h, g, w, A, L, F, V) {
      var J = Array.prototype.slice.call(arguments, 3);
      try {
        l.apply(h, J);
      } catch (ae) {
        this.onError(ae);
      }
    }
    var pb = XC;
    if (typeof window != "undefined" && typeof window.dispatchEvent == "function" && typeof document != "undefined" && typeof document.createEvent == "function") {
      var hb = document.createElement("react");
      pb = function(l, h, g, w, A, L, F, V, J) {
        if (typeof document == "undefined" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var ae = document.createEvent("Event"), Me = !1, Te = !0, Ye = window.event, Ke = Object.getOwnPropertyDescriptor(window, "event");
        function rt() {
          hb.removeEventListener(at, gn, !1), typeof window.event != "undefined" && window.hasOwnProperty("event") && (window.event = Ye);
        }
        var Ft = Array.prototype.slice.call(arguments, 3);
        function gn() {
          Me = !0, rt(), h.apply(g, Ft), Te = !1;
        }
        var un, Nr = !1, yr = !1;
        function Ve(Ue) {
          if (un = Ue.error, Nr = !0, un === null && Ue.colno === 0 && Ue.lineno === 0 && (yr = !0), Ue.defaultPrevented && un != null && typeof un == "object")
            try {
              un._suppressLogging = !0;
            } catch (Ct) {
            }
        }
        var at = "react-" + (l || "invokeguardedcallback");
        if (window.addEventListener("error", Ve), hb.addEventListener(at, gn, !1), ae.initEvent(at, !1, !1), hb.dispatchEvent(ae), Ke && Object.defineProperty(window, "event", Ke), Me && Te && (Nr ? yr && (un = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : un = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(un)), window.removeEventListener("error", Ve), !Me)
          return rt(), XC.apply(this, arguments);
      };
    }
    var m9 = pb, Ud = !1, xu = null, bv = !1, Gd = null, Zu = {
      onError: function(i) {
        Ud = !0, xu = i;
      }
    };
    function Xf(i, l, h, g, w, A, L, F, V) {
      Ud = !1, xu = null, m9.apply(Zu, arguments);
    }
    function Vc(i, l, h, g, w, A, L, F, V) {
      if (Xf.apply(this, arguments), Ud) {
        var J = vb();
        bv || (bv = !0, Gd = J);
      }
    }
    function mb() {
      if (bv) {
        var i = Gd;
        throw bv = !1, Gd = null, i;
      }
    }
    function v9() {
      return Ud;
    }
    function vb() {
      if (Ud) {
        var i = xu;
        return Ud = !1, xu = null, i;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Fl(i) {
      return i._reactInternals;
    }
    function _v(i) {
      return i._reactInternals !== void 0;
    }
    function mh(i, l) {
      i._reactInternals = l;
    }
    var hn = (
      /*                      */
      0
    ), zd = (
      /*                */
      1
    ), Ma = (
      /*                    */
      2
    ), Yn = (
      /*                       */
      4
    ), Kr = (
      /*                */
      16
    ), ta = (
      /*                 */
      32
    ), Yu = (
      /*                     */
      64
    ), $n = (
      /*                   */
      128
    ), uo = (
      /*            */
      256
    ), Hs = (
      /*                          */
      512
    ), Bl = (
      /*                     */
      1024
    ), Ga = (
      /*                      */
      2048
    ), Vl = (
      /*                    */
      4096
    ), Hd = (
      /*                   */
      8192
    ), Cv = (
      /*             */
      16384
    ), T1 = Ga | Yn | Yu | Hs | Bl | Cv, KC = (
      /*               */
      32767
    ), gl = (
      /*                   */
      32768
    ), Ci = (
      /*                */
      65536
    ), wv = (
      /* */
      131072
    ), gb = (
      /*                       */
      1048576
    ), yb = (
      /*                    */
      2097152
    ), Ws = (
      /*                 */
      4194304
    ), Wd = (
      /*                */
      8388608
    ), Zs = (
      /*               */
      16777216
    ), Kf = (
      /*              */
      33554432
    ), vh = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      Yn | Bl | 0
    ), Ys = Ma | Yn | Kr | ta | Hs | Vl | Hd, os = Yn | Yu | Hs | Hd, Ul = Ga | Kr, Di = Ws | Wd | yb, Uc = n.ReactCurrentOwner;
    function yl(i) {
      var l = i, h = i;
      if (i.alternate)
        for (; l.return; )
          l = l.return;
      else {
        var g = l;
        do
          l = g, (l.flags & (Ma | Vl)) !== hn && (h = l.return), g = l.return;
        while (g);
      }
      return l.tag === v ? h : null;
    }
    function bb(i) {
      if (i.tag === $) {
        var l = i.memoizedState;
        if (l === null) {
          var h = i.alternate;
          h !== null && (l = h.memoizedState);
        }
        if (l !== null)
          return l.dehydrated;
      }
      return null;
    }
    function O1(i) {
      return i.tag === v ? i.stateNode.containerInfo : null;
    }
    function _b(i) {
      return yl(i) === i;
    }
    function bl(i) {
      {
        var l = Uc.current;
        if (l !== null && l.tag === f) {
          var h = l, g = h.stateNode;
          g._warnedAboutRefsInRender || s("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", In(h) || "A component"), g._warnedAboutRefsInRender = !0;
        }
      }
      var w = Fl(i);
      return w ? yl(w) === w : !1;
    }
    function Xs(i) {
      if (yl(i) !== i)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Da(i) {
      var l = i.alternate;
      if (!l) {
        var h = yl(i);
        if (h === null)
          throw new Error("Unable to find node on an unmounted component.");
        return h !== i ? null : i;
      }
      for (var g = i, w = l; ; ) {
        var A = g.return;
        if (A === null)
          break;
        var L = A.alternate;
        if (L === null) {
          var F = A.return;
          if (F !== null) {
            g = w = F;
            continue;
          }
          break;
        }
        if (A.child === L.child) {
          for (var V = A.child; V; ) {
            if (V === g)
              return Xs(A), i;
            if (V === w)
              return Xs(A), l;
            V = V.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (g.return !== w.return)
          g = A, w = L;
        else {
          for (var J = !1, ae = A.child; ae; ) {
            if (ae === g) {
              J = !0, g = A, w = L;
              break;
            }
            if (ae === w) {
              J = !0, w = A, g = L;
              break;
            }
            ae = ae.sibling;
          }
          if (!J) {
            for (ae = L.child; ae; ) {
              if (ae === g) {
                J = !0, g = L, w = A;
                break;
              }
              if (ae === w) {
                J = !0, w = L, g = A;
                break;
              }
              ae = ae.sibling;
            }
            if (!J)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (g.alternate !== w)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (g.tag !== v)
        throw new Error("Unable to find node on an unmounted component.");
      return g.stateNode.current === g ? i : l;
    }
    function Gl(i) {
      var l = Da(i);
      return l !== null ? Cb(l) : null;
    }
    function Cb(i) {
      if (i.tag === b || i.tag === S)
        return i;
      for (var l = i.child; l !== null; ) {
        var h = Cb(l);
        if (h !== null)
          return h;
        l = l.sibling;
      }
      return null;
    }
    function qC(i) {
      var l = Da(i);
      return l !== null ? R1(l) : null;
    }
    function R1(i) {
      if (i.tag === b || i.tag === S)
        return i;
      for (var l = i.child; l !== null; ) {
        if (l.tag !== y) {
          var h = R1(l);
          if (h !== null)
            return h;
        }
        l = l.sibling;
      }
      return null;
    }
    var M1 = t.unstable_scheduleCallback, JC = t.unstable_cancelCallback, D1 = t.unstable_shouldYield, QC = t.unstable_requestPaint, eo = t.unstable_now, wb = t.unstable_getCurrentPriorityLevel, L1 = t.unstable_ImmediatePriority, qf = t.unstable_UserBlockingPriority, Xu = t.unstable_NormalPriority, e5 = t.unstable_LowPriority, $1 = t.unstable_IdlePriority, gh = t.unstable_yieldValue, t5 = t.unstable_setDisableYieldValue, Gc = null, ii = null, Dt = null, zl = !1, _l = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined";
    function Sb(i) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ == "undefined")
        return !1;
      var l = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (l.isDisabled)
        return !0;
      if (!l.supportsFiber)
        return s("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        Le && (i = Vn({}, i, {
          getLaneLabelMap: zc,
          injectProfilingHooks: n5
        })), Gc = l.inject(i), ii = l;
      } catch (h) {
        s("React instrumentation encountered an error: %s.", h);
      }
      return !!l.checkDCE;
    }
    function xb(i, l) {
      if (ii && typeof ii.onScheduleFiberRoot == "function")
        try {
          ii.onScheduleFiberRoot(Gc, i, l);
        } catch (h) {
          zl || (zl = !0, s("React instrumentation encountered an error: %s", h));
        }
    }
    function yh(i, l) {
      if (ii && typeof ii.onCommitFiberRoot == "function")
        try {
          var h = (i.current.flags & $n) === $n;
          if (ie) {
            var g;
            switch (l) {
              case Ao:
                g = L1;
                break;
              case Wc:
                g = qf;
                break;
              case Ku:
                g = Xu;
                break;
              case Nh:
                g = $1;
                break;
              default:
                g = Xu;
                break;
            }
            ii.onCommitFiberRoot(Gc, i, g, h);
          }
        } catch (w) {
          zl || (zl = !0, s("React instrumentation encountered an error: %s", w));
        }
    }
    function Hl(i) {
      if (ii && typeof ii.onPostCommitFiberRoot == "function")
        try {
          ii.onPostCommitFiberRoot(Gc, i);
        } catch (l) {
          zl || (zl = !0, s("React instrumentation encountered an error: %s", l));
        }
    }
    function Jf(i) {
      if (ii && typeof ii.onCommitFiberUnmount == "function")
        try {
          ii.onCommitFiberUnmount(Gc, i);
        } catch (l) {
          zl || (zl = !0, s("React instrumentation encountered an error: %s", l));
        }
    }
    function Vo(i) {
      if (typeof gh == "function" && (t5(i), a(i)), ii && typeof ii.setStrictMode == "function")
        try {
          ii.setStrictMode(Gc, i);
        } catch (l) {
          zl || (zl = !0, s("React instrumentation encountered an error: %s", l));
        }
    }
    function n5(i) {
      Dt = i;
    }
    function zc() {
      {
        for (var i = /* @__PURE__ */ new Map(), l = 1, h = 0; h < kv; h++) {
          var g = y9(l);
          i.set(l, g), l *= 2;
        }
        return i;
      }
    }
    function Zd(i) {
      Dt !== null && typeof Dt.markCommitStarted == "function" && Dt.markCommitStarted(i);
    }
    function j1() {
      Dt !== null && typeof Dt.markCommitStopped == "function" && Dt.markCommitStopped();
    }
    function bh(i) {
      Dt !== null && typeof Dt.markComponentRenderStarted == "function" && Dt.markComponentRenderStarted(i);
    }
    function Ks() {
      Dt !== null && typeof Dt.markComponentRenderStopped == "function" && Dt.markComponentRenderStopped();
    }
    function Yd(i) {
      Dt !== null && typeof Dt.markComponentPassiveEffectMountStarted == "function" && Dt.markComponentPassiveEffectMountStarted(i);
    }
    function F1() {
      Dt !== null && typeof Dt.markComponentPassiveEffectMountStopped == "function" && Dt.markComponentPassiveEffectMountStopped();
    }
    function r5(i) {
      Dt !== null && typeof Dt.markComponentPassiveEffectUnmountStarted == "function" && Dt.markComponentPassiveEffectUnmountStarted(i);
    }
    function B1() {
      Dt !== null && typeof Dt.markComponentPassiveEffectUnmountStopped == "function" && Dt.markComponentPassiveEffectUnmountStopped();
    }
    function a5(i) {
      Dt !== null && typeof Dt.markComponentLayoutEffectMountStarted == "function" && Dt.markComponentLayoutEffectMountStarted(i);
    }
    function Sv() {
      Dt !== null && typeof Dt.markComponentLayoutEffectMountStopped == "function" && Dt.markComponentLayoutEffectMountStopped();
    }
    function Eu(i) {
      Dt !== null && typeof Dt.markComponentLayoutEffectUnmountStarted == "function" && Dt.markComponentLayoutEffectUnmountStarted(i);
    }
    function _h() {
      Dt !== null && typeof Dt.markComponentLayoutEffectUnmountStopped == "function" && Dt.markComponentLayoutEffectUnmountStopped();
    }
    function xv(i, l, h) {
      Dt !== null && typeof Dt.markComponentErrored == "function" && Dt.markComponentErrored(i, l, h);
    }
    function Qf(i, l, h) {
      Dt !== null && typeof Dt.markComponentSuspended == "function" && Dt.markComponentSuspended(i, l, h);
    }
    function Eb(i) {
      Dt !== null && typeof Dt.markLayoutEffectsStarted == "function" && Dt.markLayoutEffectsStarted(i);
    }
    function Ch() {
      Dt !== null && typeof Dt.markLayoutEffectsStopped == "function" && Dt.markLayoutEffectsStopped();
    }
    function o5(i) {
      Dt !== null && typeof Dt.markPassiveEffectsStarted == "function" && Dt.markPassiveEffectsStarted(i);
    }
    function Ib() {
      Dt !== null && typeof Dt.markPassiveEffectsStopped == "function" && Dt.markPassiveEffectsStopped();
    }
    function za(i) {
      Dt !== null && typeof Dt.markRenderStarted == "function" && Dt.markRenderStarted(i);
    }
    function V1() {
      Dt !== null && typeof Dt.markRenderYielded == "function" && Dt.markRenderYielded();
    }
    function U1() {
      Dt !== null && typeof Dt.markRenderStopped == "function" && Dt.markRenderStopped();
    }
    function kb(i) {
      Dt !== null && typeof Dt.markRenderScheduled == "function" && Dt.markRenderScheduled(i);
    }
    function G1(i, l) {
      Dt !== null && typeof Dt.markForceUpdateScheduled == "function" && Dt.markForceUpdateScheduled(i, l);
    }
    function Ev(i, l) {
      Dt !== null && typeof Dt.markStateUpdateScheduled == "function" && Dt.markStateUpdateScheduled(i, l);
    }
    var an = (
      /*                         */
      0
    ), ln = (
      /*                 */
      1
    ), jn = (
      /*                    */
      2
    ), dr = (
      /*               */
      8
    ), Cl = (
      /*              */
      16
    ), wh = Math.clz32 ? Math.clz32 : is, Iv = Math.log, g9 = Math.LN2;
    function is(i) {
      var l = i >>> 0;
      return l === 0 ? 32 : 31 - (Iv(l) / g9 | 0) | 0;
    }
    var kv = 31, dt = (
      /*                        */
      0
    ), Uo = (
      /*                          */
      0
    ), cn = (
      /*                        */
      1
    ), Li = (
      /*    */
      2
    ), wl = (
      /*             */
      4
    ), Hc = (
      /*            */
      8
    ), Wl = (
      /*                     */
      16
    ), Sh = (
      /*                */
      32
    ), ep = (
      /*                       */
      4194240
    ), xh = (
      /*                        */
      64
    ), z1 = (
      /*                        */
      128
    ), H1 = (
      /*                        */
      256
    ), W1 = (
      /*                        */
      512
    ), Z1 = (
      /*                        */
      1024
    ), Y1 = (
      /*                        */
      2048
    ), tp = (
      /*                        */
      4096
    ), X1 = (
      /*                        */
      8192
    ), Eh = (
      /*                        */
      16384
    ), Ih = (
      /*                       */
      32768
    ), K1 = (
      /*                       */
      65536
    ), Av = (
      /*                       */
      131072
    ), q1 = (
      /*                       */
      262144
    ), J1 = (
      /*                       */
      524288
    ), Q1 = (
      /*                       */
      1048576
    ), eg = (
      /*                       */
      2097152
    ), kh = (
      /*                            */
      130023424
    ), np = (
      /*                             */
      4194304
    ), tg = (
      /*                             */
      8388608
    ), ng = (
      /*                             */
      16777216
    ), Ab = (
      /*                             */
      33554432
    ), rg = (
      /*                             */
      67108864
    ), i5 = np, Pv = (
      /*          */
      134217728
    ), Pb = (
      /*                          */
      268435455
    ), Ah = (
      /*               */
      268435456
    ), Xd = (
      /*                        */
      536870912
    ), ss = (
      /*                   */
      1073741824
    );
    function y9(i) {
      {
        if (i & cn)
          return "Sync";
        if (i & Li)
          return "InputContinuousHydration";
        if (i & wl)
          return "InputContinuous";
        if (i & Hc)
          return "DefaultHydration";
        if (i & Wl)
          return "Default";
        if (i & Sh)
          return "TransitionHydration";
        if (i & ep)
          return "Transition";
        if (i & kh)
          return "Retry";
        if (i & Pv)
          return "SelectiveHydration";
        if (i & Ah)
          return "IdleHydration";
        if (i & Xd)
          return "Idle";
        if (i & ss)
          return "Offscreen";
      }
    }
    var Na = -1, ag = xh, qs = np;
    function rp(i) {
      switch (ko(i)) {
        case cn:
          return cn;
        case Li:
          return Li;
        case wl:
          return wl;
        case Hc:
          return Hc;
        case Wl:
          return Wl;
        case Sh:
          return Sh;
        case xh:
        case z1:
        case H1:
        case W1:
        case Z1:
        case Y1:
        case tp:
        case X1:
        case Eh:
        case Ih:
        case K1:
        case Av:
        case q1:
        case J1:
        case Q1:
        case eg:
          return i & ep;
        case np:
        case tg:
        case ng:
        case Ab:
        case rg:
          return i & kh;
        case Pv:
          return Pv;
        case Ah:
          return Ah;
        case Xd:
          return Xd;
        case ss:
          return ss;
        default:
          return s("Should have found matching lanes. This is a bug in React."), i;
      }
    }
    function ap(i, l) {
      var h = i.pendingLanes;
      if (h === dt)
        return dt;
      var g = dt, w = i.suspendedLanes, A = i.pingedLanes, L = h & Pb;
      if (L !== dt) {
        var F = L & ~w;
        if (F !== dt)
          g = rp(F);
        else {
          var V = L & A;
          V !== dt && (g = rp(V));
        }
      } else {
        var J = h & ~w;
        J !== dt ? g = rp(J) : A !== dt && (g = rp(A));
      }
      if (g === dt)
        return dt;
      if (l !== dt && l !== g && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (l & w) === dt) {
        var ae = ko(g), Me = ko(l);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          ae >= Me || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          ae === Wl && (Me & ep) !== dt
        )
          return l;
      }
      (g & wl) !== dt && (g |= h & Wl);
      var Te = i.entangledLanes;
      if (Te !== dt)
        for (var Ye = i.entanglements, Ke = g & Te; Ke > 0; ) {
          var rt = qd(Ke), Ft = 1 << rt;
          g |= Ye[rt], Ke &= ~Ft;
        }
      return g;
    }
    function s5(i, l) {
      for (var h = i.eventTimes, g = Na; l > 0; ) {
        var w = qd(l), A = 1 << w, L = h[w];
        L > g && (g = L), l &= ~A;
      }
      return g;
    }
    function l5(i, l) {
      switch (i) {
        case cn:
        case Li:
        case wl:
          return l + 250;
        case Hc:
        case Wl:
        case Sh:
        case xh:
        case z1:
        case H1:
        case W1:
        case Z1:
        case Y1:
        case tp:
        case X1:
        case Eh:
        case Ih:
        case K1:
        case Av:
        case q1:
        case J1:
        case Q1:
        case eg:
          return l + 5e3;
        case np:
        case tg:
        case ng:
        case Ab:
        case rg:
          return Na;
        case Pv:
        case Ah:
        case Xd:
        case ss:
          return Na;
        default:
          return s("Should have found matching lanes. This is a bug in React."), Na;
      }
    }
    function u5(i, l) {
      for (var h = i.pendingLanes, g = i.suspendedLanes, w = i.pingedLanes, A = i.expirationTimes, L = h; L > 0; ) {
        var F = qd(L), V = 1 << F, J = A[F];
        J === Na ? ((V & g) === dt || (V & w) !== dt) && (A[F] = l5(V, l)) : J <= l && (i.expiredLanes |= V), L &= ~V;
      }
    }
    function Nb(i) {
      return rp(i.pendingLanes);
    }
    function Kd(i) {
      var l = i.pendingLanes & ~ss;
      return l !== dt ? l : l & ss ? ss : dt;
    }
    function Tb(i) {
      return (i & cn) !== dt;
    }
    function Nv(i) {
      return (i & Pb) !== dt;
    }
    function c5(i) {
      return (i & kh) === i;
    }
    function d5(i) {
      var l = cn | wl | Wl;
      return (i & l) === dt;
    }
    function f5(i) {
      return (i & ep) === i;
    }
    function Tv(i, l) {
      var h = Li | wl | Hc | Wl;
      return (l & h) !== dt;
    }
    function p5(i, l) {
      return (l & i.expiredLanes) !== dt;
    }
    function Ob(i) {
      return (i & ep) !== dt;
    }
    function h5() {
      var i = ag;
      return ag <<= 1, (ag & ep) === dt && (ag = xh), i;
    }
    function Js() {
      var i = qs;
      return qs <<= 1, (qs & kh) === dt && (qs = np), i;
    }
    function ko(i) {
      return i & -i;
    }
    function Ph(i) {
      return ko(i);
    }
    function qd(i) {
      return 31 - wh(i);
    }
    function og(i) {
      return qd(i);
    }
    function Qs(i, l) {
      return (i & l) !== dt;
    }
    function op(i, l) {
      return (i & l) === l;
    }
    function Wn(i, l) {
      return i | l;
    }
    function Ov(i, l) {
      return i & ~l;
    }
    function ig(i, l) {
      return i & l;
    }
    function b9(i) {
      return i;
    }
    function m5(i, l) {
      return i !== Uo && i < l ? i : l;
    }
    function Rv(i) {
      for (var l = [], h = 0; h < kv; h++)
        l.push(i);
      return l;
    }
    function ip(i, l, h) {
      i.pendingLanes |= l, l !== Xd && (i.suspendedLanes = dt, i.pingedLanes = dt);
      var g = i.eventTimes, w = og(l);
      g[w] = h;
    }
    function v5(i, l) {
      i.suspendedLanes |= l, i.pingedLanes &= ~l;
      for (var h = i.expirationTimes, g = l; g > 0; ) {
        var w = qd(g), A = 1 << w;
        h[w] = Na, g &= ~A;
      }
    }
    function sg(i, l, h) {
      i.pingedLanes |= i.suspendedLanes & l;
    }
    function lg(i, l) {
      var h = i.pendingLanes & ~l;
      i.pendingLanes = l, i.suspendedLanes = dt, i.pingedLanes = dt, i.expiredLanes &= l, i.mutableReadLanes &= l, i.entangledLanes &= l;
      for (var g = i.entanglements, w = i.eventTimes, A = i.expirationTimes, L = h; L > 0; ) {
        var F = qd(L), V = 1 << F;
        g[F] = dt, w[F] = Na, A[F] = Na, L &= ~V;
      }
    }
    function Rb(i, l) {
      for (var h = i.entangledLanes |= l, g = i.entanglements, w = h; w; ) {
        var A = qd(w), L = 1 << A;
        // Is this one of the newly entangled lanes?
        L & l | // Is this lane transitively entangled with the newly entangled lanes?
        g[A] & l && (g[A] |= l), w &= ~L;
      }
    }
    function g5(i, l) {
      var h = ko(l), g;
      switch (h) {
        case wl:
          g = Li;
          break;
        case Wl:
          g = Hc;
          break;
        case xh:
        case z1:
        case H1:
        case W1:
        case Z1:
        case Y1:
        case tp:
        case X1:
        case Eh:
        case Ih:
        case K1:
        case Av:
        case q1:
        case J1:
        case Q1:
        case eg:
        case np:
        case tg:
        case ng:
        case Ab:
        case rg:
          g = Sh;
          break;
        case Xd:
          g = Ah;
          break;
        default:
          g = Uo;
          break;
      }
      return (g & (i.suspendedLanes | l)) !== Uo ? Uo : g;
    }
    function ug(i, l, h) {
      if (_l)
        for (var g = i.pendingUpdatersLaneMap; h > 0; ) {
          var w = og(h), A = 1 << w, L = g[w];
          L.add(l), h &= ~A;
        }
    }
    function Mb(i, l) {
      if (_l)
        for (var h = i.pendingUpdatersLaneMap, g = i.memoizedUpdaters; l > 0; ) {
          var w = og(l), A = 1 << w, L = h[w];
          L.size > 0 && (L.forEach(function(F) {
            var V = F.alternate;
            (V === null || !g.has(V)) && g.add(F);
          }), L.clear()), l &= ~A;
        }
    }
    function Mv(i, l) {
      return null;
    }
    var Ao = cn, Wc = wl, Ku = Wl, Nh = Xd, Th = Uo;
    function Zl() {
      return Th;
    }
    function co(i) {
      Th = i;
    }
    function ls(i, l) {
      var h = Th;
      try {
        return Th = i, l();
      } finally {
        Th = h;
      }
    }
    function _9(i, l) {
      return i !== 0 && i < l ? i : l;
    }
    function C9(i, l) {
      return i > l ? i : l;
    }
    function Oh(i, l) {
      return i !== 0 && i < l;
    }
    function $i(i) {
      var l = ko(i);
      return Oh(Ao, l) ? Oh(Wc, l) ? Nv(l) ? Ku : Nh : Wc : Ao;
    }
    function cg(i) {
      var l = i.current.memoizedState;
      return l.isDehydrated;
    }
    var Zt;
    function Rh(i) {
      Zt = i;
    }
    function Db(i) {
      Zt(i);
    }
    var dg;
    function w9(i) {
      dg = i;
    }
    var Mh;
    function fg(i) {
      Mh = i;
    }
    var pg;
    function y5(i) {
      pg = i;
    }
    var Lb;
    function b5(i) {
      Lb = i;
    }
    var Dv = !1, Dh = [], Ha = null, wi = null, Es = null, Lh = /* @__PURE__ */ new Map(), $h = /* @__PURE__ */ new Map(), Si = [], _5 = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function qu(i) {
      return _5.indexOf(i) > -1;
    }
    function S9(i, l, h, g, w) {
      return {
        blockedOn: i,
        domEventName: l,
        eventSystemFlags: h,
        nativeEvent: w,
        targetContainers: [g]
      };
    }
    function $b(i, l) {
      switch (i) {
        case "focusin":
        case "focusout":
          Ha = null;
          break;
        case "dragenter":
        case "dragleave":
          wi = null;
          break;
        case "mouseover":
        case "mouseout":
          Es = null;
          break;
        case "pointerover":
        case "pointerout": {
          var h = l.pointerId;
          Lh.delete(h);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var g = l.pointerId;
          $h.delete(g);
          break;
        }
      }
    }
    function jh(i, l, h, g, w, A) {
      if (i === null || i.nativeEvent !== A) {
        var L = S9(l, h, g, w, A);
        if (l !== null) {
          var F = Zh(l);
          F !== null && dg(F);
        }
        return L;
      }
      i.eventSystemFlags |= g;
      var V = i.targetContainers;
      return w !== null && V.indexOf(w) === -1 && V.push(w), i;
    }
    function C5(i, l, h, g, w) {
      switch (l) {
        case "focusin": {
          var A = w;
          return Ha = jh(Ha, i, l, h, g, A), !0;
        }
        case "dragenter": {
          var L = w;
          return wi = jh(wi, i, l, h, g, L), !0;
        }
        case "mouseover": {
          var F = w;
          return Es = jh(Es, i, l, h, g, F), !0;
        }
        case "pointerover": {
          var V = w, J = V.pointerId;
          return Lh.set(J, jh(Lh.get(J) || null, i, l, h, g, V)), !0;
        }
        case "gotpointercapture": {
          var ae = w, Me = ae.pointerId;
          return $h.set(Me, jh($h.get(Me) || null, i, l, h, g, ae)), !0;
        }
      }
      return !1;
    }
    function jb(i) {
      var l = Zv(i.target);
      if (l !== null) {
        var h = yl(l);
        if (h !== null) {
          var g = h.tag;
          if (g === $) {
            var w = bb(h);
            if (w !== null) {
              i.blockedOn = w, Lb(i.priority, function() {
                Mh(h);
              });
              return;
            }
          } else if (g === v) {
            var A = h.stateNode;
            if (cg(A)) {
              i.blockedOn = O1(h);
              return;
            }
          }
        }
      }
      i.blockedOn = null;
    }
    function x9(i) {
      for (var l = pg(), h = {
        blockedOn: null,
        target: i,
        priority: l
      }, g = 0; g < Si.length && Oh(l, Si[g].priority); g++)
        ;
      Si.splice(g, 0, h), g === 0 && jb(h);
    }
    function sp(i) {
      if (i.blockedOn !== null)
        return !1;
      for (var l = i.targetContainers; l.length > 0; ) {
        var h = l[0], g = us(i.domEventName, i.eventSystemFlags, h, i.nativeEvent);
        if (g === null) {
          var w = i.nativeEvent, A = new w.constructor(w.type, w);
          mv(A), w.target.dispatchEvent(A), p9();
        } else {
          var L = Zh(g);
          return L !== null && dg(L), i.blockedOn = g, !1;
        }
        l.shift();
      }
      return !0;
    }
    function hg(i, l, h) {
      sp(i) && h.delete(l);
    }
    function Yl() {
      Dv = !1, Ha !== null && sp(Ha) && (Ha = null), wi !== null && sp(wi) && (wi = null), Es !== null && sp(Es) && (Es = null), Lh.forEach(hg), $h.forEach(hg);
    }
    function gr(i, l) {
      i.blockedOn === l && (i.blockedOn = null, Dv || (Dv = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, Yl)));
    }
    function fo(i) {
      if (Dh.length > 0) {
        gr(Dh[0], i);
        for (var l = 1; l < Dh.length; l++) {
          var h = Dh[l];
          h.blockedOn === i && (h.blockedOn = null);
        }
      }
      Ha !== null && gr(Ha, i), wi !== null && gr(wi, i), Es !== null && gr(Es, i);
      var g = function(F) {
        return gr(F, i);
      };
      Lh.forEach(g), $h.forEach(g);
      for (var w = 0; w < Si.length; w++) {
        var A = Si[w];
        A.blockedOn === i && (A.blockedOn = null);
      }
      for (; Si.length > 0; ) {
        var L = Si[0];
        if (L.blockedOn !== null)
          break;
        jb(L), L.blockedOn === null && Si.shift();
      }
    }
    var La = n.ReactCurrentBatchConfig, si = !0;
    function el(i) {
      si = !!i;
    }
    function Fh() {
      return si;
    }
    function li(i, l, h) {
      var g = mg(l), w;
      switch (g) {
        case Ao:
          w = Lv;
          break;
        case Wc:
          w = lp;
          break;
        case Ku:
        default:
          w = Bh;
          break;
      }
      return w.bind(null, l, h, i);
    }
    function Lv(i, l, h, g) {
      var w = Zl(), A = La.transition;
      La.transition = null;
      try {
        co(Ao), Bh(i, l, h, g);
      } finally {
        co(w), La.transition = A;
      }
    }
    function lp(i, l, h, g) {
      var w = Zl(), A = La.transition;
      La.transition = null;
      try {
        co(Wc), Bh(i, l, h, g);
      } finally {
        co(w), La.transition = A;
      }
    }
    function Bh(i, l, h, g) {
      si && Fb(i, l, h, g);
    }
    function Fb(i, l, h, g) {
      var w = us(i, l, h, g);
      if (w === null) {
        V9(i, l, g, Jd, h), $b(i, g);
        return;
      }
      if (C5(w, i, l, h, g)) {
        g.stopPropagation();
        return;
      }
      if ($b(i, g), l & Hf && qu(i)) {
        for (; w !== null; ) {
          var A = Zh(w);
          A !== null && Db(A);
          var L = us(i, l, h, g);
          if (L === null && V9(i, l, g, Jd, h), L === w)
            break;
          w = L;
        }
        w !== null && g.stopPropagation();
        return;
      }
      V9(i, l, g, null, h);
    }
    var Jd = null;
    function us(i, l, h, g) {
      Jd = null;
      var w = k1(g), A = Zv(w);
      if (A !== null) {
        var L = yl(A);
        if (L === null)
          A = null;
        else {
          var F = L.tag;
          if (F === $) {
            var V = bb(L);
            if (V !== null)
              return V;
            A = null;
          } else if (F === v) {
            var J = L.stateNode;
            if (cg(J))
              return O1(L);
            A = null;
          } else L !== A && (A = null);
        }
      }
      return Jd = A, null;
    }
    function mg(i) {
      switch (i) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Ao;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Wc;
        case "message": {
          var l = wb();
          switch (l) {
            case L1:
              return Ao;
            case qf:
              return Wc;
            case Xu:
            case e5:
              return Ku;
            case $1:
              return Nh;
            default:
              return Ku;
          }
        }
        default:
          return Ku;
      }
    }
    function Vh(i, l, h) {
      return i.addEventListener(l, h, !1), h;
    }
    function Zc(i, l, h) {
      return i.addEventListener(l, h, !0), h;
    }
    function vg(i, l, h, g) {
      return i.addEventListener(l, h, {
        capture: !0,
        passive: g
      }), h;
    }
    function Bb(i, l, h, g) {
      return i.addEventListener(l, h, {
        passive: g
      }), h;
    }
    var Xl = null, Uh = null, Kl = null;
    function gg(i) {
      return Xl = i, Uh = jv(), !0;
    }
    function $v() {
      Xl = null, Uh = null, Kl = null;
    }
    function yg() {
      if (Kl)
        return Kl;
      var i, l = Uh, h = l.length, g, w = jv(), A = w.length;
      for (i = 0; i < h && l[i] === w[i]; i++)
        ;
      var L = h - i;
      for (g = 1; g <= L && l[h - g] === w[A - g]; g++)
        ;
      var F = g > 1 ? 1 - g : void 0;
      return Kl = w.slice(i, F), Kl;
    }
    function jv() {
      return "value" in Xl ? Xl.value : Xl.textContent;
    }
    function up(i) {
      var l, h = i.keyCode;
      return "charCode" in i ? (l = i.charCode, l === 0 && h === 13 && (l = 13)) : l = h, l === 10 && (l = 13), l >= 32 || l === 13 ? l : 0;
    }
    function xi() {
      return !0;
    }
    function Yc() {
      return !1;
    }
    function to(i) {
      function l(h, g, w, A, L) {
        this._reactName = h, this._targetInst = w, this.type = g, this.nativeEvent = A, this.target = L, this.currentTarget = null;
        for (var F in i)
          if (i.hasOwnProperty(F)) {
            var V = i[F];
            V ? this[F] = V(A) : this[F] = A[F];
          }
        var J = A.defaultPrevented != null ? A.defaultPrevented : A.returnValue === !1;
        return J ? this.isDefaultPrevented = xi : this.isDefaultPrevented = Yc, this.isPropagationStopped = Yc, this;
      }
      return Vn(l.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var h = this.nativeEvent;
          h && (h.preventDefault ? h.preventDefault() : typeof h.returnValue != "unknown" && (h.returnValue = !1), this.isDefaultPrevented = xi);
        },
        stopPropagation: function() {
          var h = this.nativeEvent;
          h && (h.stopPropagation ? h.stopPropagation() : typeof h.cancelBubble != "unknown" && (h.cancelBubble = !0), this.isPropagationStopped = xi);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: xi
      }), l;
    }
    var ui = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(i) {
        return i.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, bg = to(ui), cp = Vn({}, ui, {
      view: 0,
      detail: 0
    }), Vb = to(cp), Ub, Ju, Gh;
    function Gb(i) {
      i !== Gh && (Gh && i.type === "mousemove" ? (Ub = i.screenX - Gh.screenX, Ju = i.screenY - Gh.screenY) : (Ub = 0, Ju = 0), Gh = i);
    }
    var Qu = Vn({}, cp, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: zb,
      button: 0,
      buttons: 0,
      relatedTarget: function(i) {
        return i.relatedTarget === void 0 ? i.fromElement === i.srcElement ? i.toElement : i.fromElement : i.relatedTarget;
      },
      movementX: function(i) {
        return "movementX" in i ? i.movementX : (Gb(i), Ub);
      },
      movementY: function(i) {
        return "movementY" in i ? i.movementY : Ju;
      }
    }), _g = to(Qu), dp = Vn({}, Qu, {
      dataTransfer: 0
    }), w5 = to(dp), S5 = Vn({}, cp, {
      relatedTarget: 0
    }), Fv = to(S5), Cg = Vn({}, ui, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), E9 = to(Cg), I9 = Vn({}, ui, {
      clipboardData: function(i) {
        return "clipboardData" in i ? i.clipboardData : window.clipboardData;
      }
    }), x5 = to(I9), E5 = Vn({}, ui, {
      data: 0
    }), Qd = to(E5), k9 = Qd, zh = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, I5 = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function po(i) {
      if (i.key) {
        var l = zh[i.key] || i.key;
        if (l !== "Unidentified")
          return l;
      }
      if (i.type === "keypress") {
        var h = up(i);
        return h === 13 ? "Enter" : String.fromCharCode(h);
      }
      return i.type === "keydown" || i.type === "keyup" ? I5[i.keyCode] || "Unidentified" : "";
    }
    var A9 = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function k5(i) {
      var l = this, h = l.nativeEvent;
      if (h.getModifierState)
        return h.getModifierState(i);
      var g = A9[i];
      return g ? !!h[g] : !1;
    }
    function zb(i) {
      return k5;
    }
    var P9 = Vn({}, cp, {
      key: po,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: zb,
      // Legacy Interface
      charCode: function(i) {
        return i.type === "keypress" ? up(i) : 0;
      },
      keyCode: function(i) {
        return i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
      },
      which: function(i) {
        return i.type === "keypress" ? up(i) : i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
      }
    }), A5 = to(P9), P5 = Vn({}, Qu, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), N5 = to(P5), ql = Vn({}, cp, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: zb
    }), Hb = to(ql), N9 = Vn({}, ui, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), ef = to(N9), wg = Vn({}, Qu, {
      deltaX: function(i) {
        return "deltaX" in i ? i.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in i ? -i.wheelDeltaX : 0
        );
      },
      deltaY: function(i) {
        return "deltaY" in i ? i.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in i ? -i.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in i ? -i.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), fp = to(wg), Sg = [9, 13, 27, 32], xg = 229, Bv = He && "CompositionEvent" in window, Vv = null;
    He && "documentMode" in document && (Vv = document.documentMode);
    var Wb = He && "TextEvent" in window && !Vv, T5 = He && (!Bv || Vv && Vv > 8 && Vv <= 11), Zb = 32, Yb = String.fromCharCode(Zb);
    function Eg() {
      le("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), le("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), le("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), le("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Uv = !1;
    function O5(i) {
      return (i.ctrlKey || i.altKey || i.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(i.ctrlKey && i.altKey);
    }
    function Xb(i) {
      switch (i) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function T9(i, l) {
      return i === "keydown" && l.keyCode === xg;
    }
    function Kb(i, l) {
      switch (i) {
        case "keyup":
          return Sg.indexOf(l.keyCode) !== -1;
        case "keydown":
          return l.keyCode !== xg;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Ig(i) {
      var l = i.detail;
      return typeof l == "object" && "data" in l ? l.data : null;
    }
    function Gv(i) {
      return i.locale === "ko";
    }
    var tf = !1;
    function kg(i, l, h, g, w) {
      var A, L;
      if (Bv ? A = Xb(l) : tf ? Kb(l, g) && (A = "onCompositionEnd") : T9(l, g) && (A = "onCompositionStart"), !A)
        return null;
      T5 && !Gv(g) && (!tf && A === "onCompositionStart" ? tf = gg(w) : A === "onCompositionEnd" && tf && (L = yg()));
      var F = j5(h, A);
      if (F.length > 0) {
        var V = new Qd(A, l, null, g, w);
        if (i.push({
          event: V,
          listeners: F
        }), L)
          V.data = L;
        else {
          var J = Ig(g);
          J !== null && (V.data = J);
        }
      }
    }
    function R5(i, l) {
      switch (i) {
        case "compositionend":
          return Ig(l);
        case "keypress":
          var h = l.which;
          return h !== Zb ? null : (Uv = !0, Yb);
        case "textInput":
          var g = l.data;
          return g === Yb && Uv ? null : g;
        default:
          return null;
      }
    }
    function O9(i, l) {
      if (tf) {
        if (i === "compositionend" || !Bv && Kb(i, l)) {
          var h = yg();
          return $v(), tf = !1, h;
        }
        return null;
      }
      switch (i) {
        case "paste":
          return null;
        case "keypress":
          if (!O5(l)) {
            if (l.char && l.char.length > 1)
              return l.char;
            if (l.which)
              return String.fromCharCode(l.which);
          }
          return null;
        case "compositionend":
          return T5 && !Gv(l) ? null : l.data;
        default:
          return null;
      }
    }
    function Ag(i, l, h, g, w) {
      var A;
      if (Wb ? A = R5(l, g) : A = O9(l, g), !A)
        return null;
      var L = j5(h, "onBeforeInput");
      if (L.length > 0) {
        var F = new k9("onBeforeInput", "beforeinput", null, g, w);
        i.push({
          event: F,
          listeners: L
        }), F.data = A;
      }
    }
    function R9(i, l, h, g, w, A, L) {
      kg(i, l, h, g, w), Ag(i, l, h, g, w);
    }
    var zv = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function M5(i) {
      var l = i && i.nodeName && i.nodeName.toLowerCase();
      return l === "input" ? !!zv[i.type] : l === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Pg(i) {
      if (!He)
        return !1;
      var l = "on" + i, h = l in document;
      if (!h) {
        var g = document.createElement("div");
        g.setAttribute(l, "return;"), h = typeof g[l] == "function";
      }
      return h;
    }
    function d() {
      le("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function p(i, l, h, g) {
      A1(g);
      var w = j5(l, "onChange");
      if (w.length > 0) {
        var A = new bg("onChange", "change", null, h, g);
        i.push({
          event: A,
          listeners: w
        });
      }
    }
    var _ = null, I = null;
    function M(i) {
      var l = i.nodeName && i.nodeName.toLowerCase();
      return l === "select" || l === "input" && i.type === "file";
    }
    function j(i) {
      var l = [];
      p(l, I, i, k1(i)), db(z, l);
    }
    function z(i) {
      LL(i, 0);
    }
    function ve(i) {
      var l = Dg(i);
      if (De(l))
        return i;
    }
    function ke(i, l) {
      if (i === "change")
        return l;
    }
    var Xe = !1;
    He && (Xe = Pg("input") && (!document.documentMode || document.documentMode > 9));
    function gt(i, l) {
      _ = i, I = l, _.attachEvent("onpropertychange", ht);
    }
    function _t() {
      _ && (_.detachEvent("onpropertychange", ht), _ = null, I = null);
    }
    function ht(i) {
      i.propertyName === "value" && ve(I) && j(i);
    }
    function Ut(i, l, h) {
      i === "focusin" ? (_t(), gt(l, h)) : i === "focusout" && _t();
    }
    function Jt(i, l) {
      if (i === "selectionchange" || i === "keyup" || i === "keydown")
        return ve(I);
    }
    function nn(i) {
      var l = i.nodeName;
      return l && l.toLowerCase() === "input" && (i.type === "checkbox" || i.type === "radio");
    }
    function Po(i, l) {
      if (i === "click")
        return ve(l);
    }
    function Be(i, l) {
      if (i === "input" || i === "change")
        return ve(l);
    }
    function Re(i) {
      var l = i._wrapperState;
      !l || !l.controlled || i.type !== "number" || Fd(i, "number", i.value);
    }
    function Ge(i, l, h, g, w, A, L) {
      var F = h ? Dg(h) : window, V, J;
      if (M(F) ? V = ke : M5(F) ? Xe ? V = Be : (V = Jt, J = Ut) : nn(F) && (V = Po), V) {
        var ae = V(l, h);
        if (ae) {
          p(i, ae, g, w);
          return;
        }
      }
      J && J(l, F, h), l === "focusout" && Re(F);
    }
    function xt() {
      be("onMouseEnter", ["mouseout", "mouseover"]), be("onMouseLeave", ["mouseout", "mouseover"]), be("onPointerEnter", ["pointerout", "pointerover"]), be("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function on(i, l, h, g, w, A, L) {
      var F = l === "mouseover" || l === "pointerover", V = l === "mouseout" || l === "pointerout";
      if (F && !ZC(g)) {
        var J = g.relatedTarget || g.fromElement;
        if (J && (Zv(J) || c3(J)))
          return;
      }
      if (!(!V && !F)) {
        var ae;
        if (w.window === w)
          ae = w;
        else {
          var Me = w.ownerDocument;
          Me ? ae = Me.defaultView || Me.parentWindow : ae = window;
        }
        var Te, Ye;
        if (V) {
          var Ke = g.relatedTarget || g.toElement;
          if (Te = h, Ye = Ke ? Zv(Ke) : null, Ye !== null) {
            var rt = yl(Ye);
            (Ye !== rt || Ye.tag !== b && Ye.tag !== S) && (Ye = null);
          }
        } else
          Te = null, Ye = h;
        if (Te !== Ye) {
          var Ft = _g, gn = "onMouseLeave", un = "onMouseEnter", Nr = "mouse";
          (l === "pointerout" || l === "pointerover") && (Ft = N5, gn = "onPointerLeave", un = "onPointerEnter", Nr = "pointer");
          var yr = Te == null ? ae : Dg(Te), Ve = Ye == null ? ae : Dg(Ye), at = new Ft(gn, Nr + "leave", Te, g, w);
          at.target = yr, at.relatedTarget = Ve;
          var Ue = null, Ct = Zv(w);
          if (Ct === h) {
            var Ht = new Ft(un, Nr + "enter", Ye, g, w);
            Ht.target = Ve, Ht.relatedTarget = yr, Ue = Ht;
          }
          sde(i, at, Ue, Te, Ye);
        }
      }
    }
    function bn(i, l) {
      return i === l && (i !== 0 || 1 / i === 1 / l) || i !== i && l !== l;
    }
    var Qt = typeof Object.is == "function" ? Object.is : bn;
    function wn(i, l) {
      if (Qt(i, l))
        return !0;
      if (typeof i != "object" || i === null || typeof l != "object" || l === null)
        return !1;
      var h = Object.keys(i), g = Object.keys(l);
      if (h.length !== g.length)
        return !1;
      for (var w = 0; w < h.length; w++) {
        var A = h[w];
        if (!Ae.call(l, A) || !Qt(i[A], l[A]))
          return !1;
      }
      return !0;
    }
    function ci(i) {
      for (; i && i.firstChild; )
        i = i.firstChild;
      return i;
    }
    function Gr(i) {
      for (; i; ) {
        if (i.nextSibling)
          return i.nextSibling;
        i = i.parentNode;
      }
    }
    function Xc(i, l) {
      for (var h = ci(i), g = 0, w = 0; h; ) {
        if (h.nodeType === $c) {
          if (w = g + h.textContent.length, g <= l && w >= l)
            return {
              node: h,
              offset: l - g
            };
          g = w;
        }
        h = ci(Gr(h));
      }
    }
    function M9(i) {
      var l = i.ownerDocument, h = l && l.defaultView || window, g = h.getSelection && h.getSelection();
      if (!g || g.rangeCount === 0)
        return null;
      var w = g.anchorNode, A = g.anchorOffset, L = g.focusNode, F = g.focusOffset;
      try {
        w.nodeType, L.nodeType;
      } catch (V) {
        return null;
      }
      return Vce(i, w, A, L, F);
    }
    function Vce(i, l, h, g, w) {
      var A = 0, L = -1, F = -1, V = 0, J = 0, ae = i, Me = null;
      e: for (; ; ) {
        for (var Te = null; ae === l && (h === 0 || ae.nodeType === $c) && (L = A + h), ae === g && (w === 0 || ae.nodeType === $c) && (F = A + w), ae.nodeType === $c && (A += ae.nodeValue.length), (Te = ae.firstChild) !== null; )
          Me = ae, ae = Te;
        for (; ; ) {
          if (ae === i)
            break e;
          if (Me === l && ++V === h && (L = A), Me === g && ++J === w && (F = A), (Te = ae.nextSibling) !== null)
            break;
          ae = Me, Me = ae.parentNode;
        }
        ae = Te;
      }
      return L === -1 || F === -1 ? null : {
        start: L,
        end: F
      };
    }
    function Uce(i, l) {
      var h = i.ownerDocument || document, g = h && h.defaultView || window;
      if (g.getSelection) {
        var w = g.getSelection(), A = i.textContent.length, L = Math.min(l.start, A), F = l.end === void 0 ? L : Math.min(l.end, A);
        if (!w.extend && L > F) {
          var V = F;
          F = L, L = V;
        }
        var J = Xc(i, L), ae = Xc(i, F);
        if (J && ae) {
          if (w.rangeCount === 1 && w.anchorNode === J.node && w.anchorOffset === J.offset && w.focusNode === ae.node && w.focusOffset === ae.offset)
            return;
          var Me = h.createRange();
          Me.setStart(J.node, J.offset), w.removeAllRanges(), L > F ? (w.addRange(Me), w.extend(ae.node, ae.offset)) : (Me.setEnd(ae.node, ae.offset), w.addRange(Me));
        }
      }
    }
    function xL(i) {
      return i && i.nodeType === $c;
    }
    function EL(i, l) {
      return !i || !l ? !1 : i === l ? !0 : xL(i) ? !1 : xL(l) ? EL(i, l.parentNode) : "contains" in i ? i.contains(l) : i.compareDocumentPosition ? !!(i.compareDocumentPosition(l) & 16) : !1;
    }
    function Gce(i) {
      return i && i.ownerDocument && EL(i.ownerDocument.documentElement, i);
    }
    function zce(i) {
      try {
        return typeof i.contentWindow.location.href == "string";
      } catch (l) {
        return !1;
      }
    }
    function IL() {
      for (var i = window, l = qe(); l instanceof i.HTMLIFrameElement; ) {
        if (zce(l))
          i = l.contentWindow;
        else
          return l;
        l = qe(i.document);
      }
      return l;
    }
    function D9(i) {
      var l = i && i.nodeName && i.nodeName.toLowerCase();
      return l && (l === "input" && (i.type === "text" || i.type === "search" || i.type === "tel" || i.type === "url" || i.type === "password") || l === "textarea" || i.contentEditable === "true");
    }
    function Hce() {
      var i = IL();
      return {
        focusedElem: i,
        selectionRange: D9(i) ? Zce(i) : null
      };
    }
    function Wce(i) {
      var l = IL(), h = i.focusedElem, g = i.selectionRange;
      if (l !== h && Gce(h)) {
        g !== null && D9(h) && Yce(h, g);
        for (var w = [], A = h; A = A.parentNode; )
          A.nodeType === zs && w.push({
            element: A,
            left: A.scrollLeft,
            top: A.scrollTop
          });
        typeof h.focus == "function" && h.focus();
        for (var L = 0; L < w.length; L++) {
          var F = w[L];
          F.element.scrollLeft = F.left, F.element.scrollTop = F.top;
        }
      }
    }
    function Zce(i) {
      var l;
      return "selectionStart" in i ? l = {
        start: i.selectionStart,
        end: i.selectionEnd
      } : l = M9(i), l || {
        start: 0,
        end: 0
      };
    }
    function Yce(i, l) {
      var h = l.start, g = l.end;
      g === void 0 && (g = h), "selectionStart" in i ? (i.selectionStart = h, i.selectionEnd = Math.min(g, i.value.length)) : Uce(i, l);
    }
    var Xce = He && "documentMode" in document && document.documentMode <= 11;
    function Kce() {
      le("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var Ng = null, L9 = null, qb = null, $9 = !1;
    function qce(i) {
      if ("selectionStart" in i && D9(i))
        return {
          start: i.selectionStart,
          end: i.selectionEnd
        };
      var l = i.ownerDocument && i.ownerDocument.defaultView || window, h = l.getSelection();
      return {
        anchorNode: h.anchorNode,
        anchorOffset: h.anchorOffset,
        focusNode: h.focusNode,
        focusOffset: h.focusOffset
      };
    }
    function Jce(i) {
      return i.window === i ? i.document : i.nodeType === wu ? i : i.ownerDocument;
    }
    function kL(i, l, h) {
      var g = Jce(h);
      if (!($9 || Ng == null || Ng !== qe(g))) {
        var w = qce(Ng);
        if (!qb || !wn(qb, w)) {
          qb = w;
          var A = j5(L9, "onSelect");
          if (A.length > 0) {
            var L = new bg("onSelect", "select", null, l, h);
            i.push({
              event: L,
              listeners: A
            }), L.target = Ng;
          }
        }
      }
    }
    function Qce(i, l, h, g, w, A, L) {
      var F = h ? Dg(h) : window;
      switch (l) {
        case "focusin":
          (M5(F) || F.contentEditable === "true") && (Ng = F, L9 = h, qb = null);
          break;
        case "focusout":
          Ng = null, L9 = null, qb = null;
          break;
        case "mousedown":
          $9 = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          $9 = !1, kL(i, g, w);
          break;
        case "selectionchange":
          if (Xce)
            break;
        case "keydown":
        case "keyup":
          kL(i, g, w);
      }
    }
    function D5(i, l) {
      var h = {};
      return h[i.toLowerCase()] = l.toLowerCase(), h["Webkit" + i] = "webkit" + l, h["Moz" + i] = "moz" + l, h;
    }
    var Tg = {
      animationend: D5("Animation", "AnimationEnd"),
      animationiteration: D5("Animation", "AnimationIteration"),
      animationstart: D5("Animation", "AnimationStart"),
      transitionend: D5("Transition", "TransitionEnd")
    }, j9 = {}, AL = {};
    He && (AL = document.createElement("div").style, "AnimationEvent" in window || (delete Tg.animationend.animation, delete Tg.animationiteration.animation, delete Tg.animationstart.animation), "TransitionEvent" in window || delete Tg.transitionend.transition);
    function L5(i) {
      if (j9[i])
        return j9[i];
      if (!Tg[i])
        return i;
      var l = Tg[i];
      for (var h in l)
        if (l.hasOwnProperty(h) && h in AL)
          return j9[i] = l[h];
      return i;
    }
    var PL = L5("animationend"), NL = L5("animationiteration"), TL = L5("animationstart"), OL = L5("transitionend"), RL = /* @__PURE__ */ new Map(), ML = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Hh(i, l) {
      RL.set(i, l), le(l, [i]);
    }
    function ede() {
      for (var i = 0; i < ML.length; i++) {
        var l = ML[i], h = l.toLowerCase(), g = l[0].toUpperCase() + l.slice(1);
        Hh(h, "on" + g);
      }
      Hh(PL, "onAnimationEnd"), Hh(NL, "onAnimationIteration"), Hh(TL, "onAnimationStart"), Hh("dblclick", "onDoubleClick"), Hh("focusin", "onFocus"), Hh("focusout", "onBlur"), Hh(OL, "onTransitionEnd");
    }
    function tde(i, l, h, g, w, A, L) {
      var F = RL.get(l);
      if (F !== void 0) {
        var V = bg, J = l;
        switch (l) {
          case "keypress":
            if (up(g) === 0)
              return;
          case "keydown":
          case "keyup":
            V = A5;
            break;
          case "focusin":
            J = "focus", V = Fv;
            break;
          case "focusout":
            J = "blur", V = Fv;
            break;
          case "beforeblur":
          case "afterblur":
            V = Fv;
            break;
          case "click":
            if (g.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            V = _g;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            V = w5;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            V = Hb;
            break;
          case PL:
          case NL:
          case TL:
            V = E9;
            break;
          case OL:
            V = ef;
            break;
          case "scroll":
            V = Vb;
            break;
          case "wheel":
            V = fp;
            break;
          case "copy":
          case "cut":
          case "paste":
            V = x5;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            V = N5;
            break;
        }
        var ae = (A & Hf) !== 0;
        {
          var Me = !ae && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          l === "scroll", Te = ode(h, F, g.type, ae, Me);
          if (Te.length > 0) {
            var Ye = new V(F, J, null, g, w);
            i.push({
              event: Ye,
              listeners: Te
            });
          }
        }
      }
    }
    ede(), xt(), d(), Kce(), Eg();
    function nde(i, l, h, g, w, A, L) {
      tde(i, l, h, g, w, A);
      var F = (A & f9) === 0;
      F && (on(i, l, h, g, w), Ge(i, l, h, g, w), Qce(i, l, h, g, w), R9(i, l, h, g, w));
    }
    var Jb = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], F9 = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Jb));
    function DL(i, l, h) {
      var g = i.type || "unknown-event";
      i.currentTarget = h, Vc(g, l, void 0, i), i.currentTarget = null;
    }
    function rde(i, l, h) {
      var g;
      if (h)
        for (var w = l.length - 1; w >= 0; w--) {
          var A = l[w], L = A.instance, F = A.currentTarget, V = A.listener;
          if (L !== g && i.isPropagationStopped())
            return;
          DL(i, V, F), g = L;
        }
      else
        for (var J = 0; J < l.length; J++) {
          var ae = l[J], Me = ae.instance, Te = ae.currentTarget, Ye = ae.listener;
          if (Me !== g && i.isPropagationStopped())
            return;
          DL(i, Ye, Te), g = Me;
        }
    }
    function LL(i, l) {
      for (var h = (l & Hf) !== 0, g = 0; g < i.length; g++) {
        var w = i[g], A = w.event, L = w.listeners;
        rde(A, L, h);
      }
      mb();
    }
    function ade(i, l, h, g, w) {
      var A = k1(h), L = [];
      nde(L, i, g, h, A, l), LL(L, l);
    }
    function no(i, l) {
      F9.has(i) || s('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', i);
      var h = !1, g = Mfe(l), w = lde(i);
      g.has(w) || ($L(l, i, pv, h), g.add(w));
    }
    function B9(i, l, h) {
      F9.has(i) && !l && s('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', i);
      var g = 0;
      l && (g |= Hf), $L(h, i, g, l);
    }
    var $5 = "_reactListening" + Math.random().toString(36).slice(2);
    function Qb(i) {
      if (!i[$5]) {
        i[$5] = !0, we.forEach(function(h) {
          h !== "selectionchange" && (F9.has(h) || B9(h, !1, i), B9(h, !0, i));
        });
        var l = i.nodeType === wu ? i : i.ownerDocument;
        l !== null && (l[$5] || (l[$5] = !0, B9("selectionchange", !1, l)));
      }
    }
    function $L(i, l, h, g, w) {
      var A = li(i, l, h), L = void 0;
      yv && (l === "touchstart" || l === "touchmove" || l === "wheel") && (L = !0), i = i, g ? L !== void 0 ? vg(i, l, A, L) : Zc(i, l, A) : L !== void 0 ? Bb(i, l, A, L) : Vh(i, l, A);
    }
    function jL(i, l) {
      return i === l || i.nodeType === Bo && i.parentNode === l;
    }
    function V9(i, l, h, g, w) {
      var A = g;
      if (!(l & Fc) && !(l & pv)) {
        var L = w;
        if (g !== null) {
          var F = g;
          e: for (; ; ) {
            if (F === null)
              return;
            var V = F.tag;
            if (V === v || V === y) {
              var J = F.stateNode.containerInfo;
              if (jL(J, L))
                break;
              if (V === y)
                for (var ae = F.return; ae !== null; ) {
                  var Me = ae.tag;
                  if (Me === v || Me === y) {
                    var Te = ae.stateNode.containerInfo;
                    if (jL(Te, L))
                      return;
                  }
                  ae = ae.return;
                }
              for (; J !== null; ) {
                var Ye = Zv(J);
                if (Ye === null)
                  return;
                var Ke = Ye.tag;
                if (Ke === b || Ke === S) {
                  F = A = Ye;
                  continue e;
                }
                J = J.parentNode;
              }
            }
            F = F.return;
          }
        }
      }
      db(function() {
        return ade(i, l, h, A);
      });
    }
    function e3(i, l, h) {
      return {
        instance: i,
        listener: l,
        currentTarget: h
      };
    }
    function ode(i, l, h, g, w, A) {
      for (var L = l !== null ? l + "Capture" : null, F = g ? L : l, V = [], J = i, ae = null; J !== null; ) {
        var Me = J, Te = Me.stateNode, Ye = Me.tag;
        if (Ye === b && Te !== null && (ae = Te, F !== null)) {
          var Ke = Zf(J, F);
          Ke != null && V.push(e3(J, Ke, ae));
        }
        if (w)
          break;
        J = J.return;
      }
      return V;
    }
    function j5(i, l) {
      for (var h = l + "Capture", g = [], w = i; w !== null; ) {
        var A = w, L = A.stateNode, F = A.tag;
        if (F === b && L !== null) {
          var V = L, J = Zf(w, h);
          J != null && g.unshift(e3(w, J, V));
          var ae = Zf(w, l);
          ae != null && g.push(e3(w, ae, V));
        }
        w = w.return;
      }
      return g;
    }
    function Og(i) {
      if (i === null)
        return null;
      do
        i = i.return;
      while (i && i.tag !== b);
      return i || null;
    }
    function ide(i, l) {
      for (var h = i, g = l, w = 0, A = h; A; A = Og(A))
        w++;
      for (var L = 0, F = g; F; F = Og(F))
        L++;
      for (; w - L > 0; )
        h = Og(h), w--;
      for (; L - w > 0; )
        g = Og(g), L--;
      for (var V = w; V--; ) {
        if (h === g || g !== null && h === g.alternate)
          return h;
        h = Og(h), g = Og(g);
      }
      return null;
    }
    function FL(i, l, h, g, w) {
      for (var A = l._reactName, L = [], F = h; F !== null && F !== g; ) {
        var V = F, J = V.alternate, ae = V.stateNode, Me = V.tag;
        if (J !== null && J === g)
          break;
        if (Me === b && ae !== null) {
          var Te = ae;
          if (w) {
            var Ye = Zf(F, A);
            Ye != null && L.unshift(e3(F, Ye, Te));
          } else if (!w) {
            var Ke = Zf(F, A);
            Ke != null && L.push(e3(F, Ke, Te));
          }
        }
        F = F.return;
      }
      L.length !== 0 && i.push({
        event: l,
        listeners: L
      });
    }
    function sde(i, l, h, g, w) {
      var A = g && w ? ide(g, w) : null;
      g !== null && FL(i, l, g, A, !1), w !== null && h !== null && FL(i, h, w, A, !0);
    }
    function lde(i, l) {
      return i + "__bubble";
    }
    var Jl = !1, t3 = "dangerouslySetInnerHTML", F5 = "suppressContentEditableWarning", Wh = "suppressHydrationWarning", BL = "autoFocus", Hv = "children", Wv = "style", B5 = "__html", U9, V5, n3, VL, U5, UL, GL;
    U9 = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, V5 = function(i, l) {
      I1(i, l), ib(i, l), WC(i, l, {
        registrationNameDependencies: Ne,
        possibleRegistrationNames: Ee
      });
    }, UL = He && !document.documentMode, n3 = function(i, l, h) {
      if (!Jl) {
        var g = G5(h), w = G5(l);
        w !== g && (Jl = !0, s("Prop `%s` did not match. Server: %s Client: %s", i, JSON.stringify(w), JSON.stringify(g)));
      }
    }, VL = function(i) {
      if (!Jl) {
        Jl = !0;
        var l = [];
        i.forEach(function(h) {
          l.push(h);
        }), s("Extra attributes from the server: %s", l);
      }
    }, U5 = function(i, l) {
      l === !1 ? s("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", i, i, i) : s("Expected `%s` listener to be a function, instead got a value of `%s` type.", i, typeof l);
    }, GL = function(i, l) {
      var h = i.namespaceURI === Lc ? i.ownerDocument.createElement(i.tagName) : i.ownerDocument.createElementNS(i.namespaceURI, i.tagName);
      return h.innerHTML = l, h.innerHTML;
    };
    var ude = /\r\n?/g, cde = /\u0000|\uFFFD/g;
    function G5(i) {
      qt(i);
      var l = typeof i == "string" ? i : "" + i;
      return l.replace(ude, `
`).replace(cde, "");
    }
    function z5(i, l, h, g) {
      var w = G5(l), A = G5(i);
      if (A !== w && (g && (Jl || (Jl = !0, s('Text content did not match. Server: "%s" Client: "%s"', A, w))), h && oe))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function zL(i) {
      return i.nodeType === wu ? i : i.ownerDocument;
    }
    function dde() {
    }
    function H5(i) {
      i.onclick = dde;
    }
    function fde(i, l, h, g, w) {
      for (var A in g)
        if (g.hasOwnProperty(A)) {
          var L = g[A];
          if (A === Wv)
            L && Object.freeze(L), LC(l, L);
          else if (A === t3) {
            var F = L ? L[B5] : void 0;
            F != null && EC(l, F);
          } else if (A === Hv)
            if (typeof L == "string") {
              var V = i !== "textarea" || L !== "";
              V && w1(l, L);
            } else typeof L == "number" && w1(l, "" + L);
          else A === F5 || A === Wh || A === BL || (Ne.hasOwnProperty(A) ? L != null && (typeof L != "function" && U5(A, L), A === "onScroll" && no("scroll", l)) : L != null && Pa(l, A, L, w));
        }
    }
    function pde(i, l, h, g) {
      for (var w = 0; w < l.length; w += 2) {
        var A = l[w], L = l[w + 1];
        A === Wv ? LC(i, L) : A === t3 ? EC(i, L) : A === Hv ? w1(i, L) : Pa(i, A, L, g);
      }
    }
    function hde(i, l, h, g) {
      var w, A = zL(h), L, F = g;
      if (F === Lc && (F = _1(i)), F === Lc) {
        if (w = jc(i, l), !w && i !== i.toLowerCase() && s("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", i), i === "script") {
          var V = A.createElement("div");
          V.innerHTML = "<script><\/script>";
          var J = V.firstChild;
          L = V.removeChild(J);
        } else if (typeof l.is == "string")
          L = A.createElement(i, {
            is: l.is
          });
        else if (L = A.createElement(i), i === "select") {
          var ae = L;
          l.multiple ? ae.multiple = !0 : l.size && (ae.size = l.size);
        }
      } else
        L = A.createElementNS(F, i);
      return F === Lc && !w && Object.prototype.toString.call(L) === "[object HTMLUnknownElement]" && !Ae.call(U9, i) && (U9[i] = !0, s("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", i)), L;
    }
    function mde(i, l) {
      return zL(l).createTextNode(i);
    }
    function vde(i, l, h, g) {
      var w = jc(l, h);
      V5(l, h);
      var A;
      switch (l) {
        case "dialog":
          no("cancel", i), no("close", i), A = h;
          break;
        case "iframe":
        case "object":
        case "embed":
          no("load", i), A = h;
          break;
        case "video":
        case "audio":
          for (var L = 0; L < Jb.length; L++)
            no(Jb[L], i);
          A = h;
          break;
        case "source":
          no("error", i), A = h;
          break;
        case "img":
        case "image":
        case "link":
          no("error", i), no("load", i), A = h;
          break;
        case "details":
          no("toggle", i), A = h;
          break;
        case "input":
          Ri(i, h), A = ea(i, h), no("invalid", i);
          break;
        case "option":
          y1(i, h), A = h;
          break;
        case "select":
          CC(i, h), A = X2(i, h), no("invalid", i);
          break;
        case "textarea":
          wC(i, h), A = q2(i, h), no("invalid", i);
          break;
        default:
          A = h;
      }
      switch (x1(l, A), fde(l, i, g, A, w), l) {
        case "input":
          ue(i), Dc(i, h, !1);
          break;
        case "textarea":
          ue(i), xC(i);
          break;
        case "option":
          Y2(i, h);
          break;
        case "select":
          t9(i, h);
          break;
        default:
          typeof A.onClick == "function" && H5(i);
          break;
      }
    }
    function gde(i, l, h, g, w) {
      V5(l, g);
      var A = null, L, F;
      switch (l) {
        case "input":
          L = ea(i, h), F = ea(i, g), A = [];
          break;
        case "select":
          L = X2(i, h), F = X2(i, g), A = [];
          break;
        case "textarea":
          L = q2(i, h), F = q2(i, g), A = [];
          break;
        default:
          L = h, F = g, typeof L.onClick != "function" && typeof F.onClick == "function" && H5(i);
          break;
      }
      x1(l, F);
      var V, J, ae = null;
      for (V in L)
        if (!(F.hasOwnProperty(V) || !L.hasOwnProperty(V) || L[V] == null))
          if (V === Wv) {
            var Me = L[V];
            for (J in Me)
              Me.hasOwnProperty(J) && (ae || (ae = {}), ae[J] = "");
          } else V === t3 || V === Hv || V === F5 || V === Wh || V === BL || (Ne.hasOwnProperty(V) ? A || (A = []) : (A = A || []).push(V, null));
      for (V in F) {
        var Te = F[V], Ye = L != null ? L[V] : void 0;
        if (!(!F.hasOwnProperty(V) || Te === Ye || Te == null && Ye == null))
          if (V === Wv)
            if (Te && Object.freeze(Te), Ye) {
              for (J in Ye)
                Ye.hasOwnProperty(J) && (!Te || !Te.hasOwnProperty(J)) && (ae || (ae = {}), ae[J] = "");
              for (J in Te)
                Te.hasOwnProperty(J) && Ye[J] !== Te[J] && (ae || (ae = {}), ae[J] = Te[J]);
            } else
              ae || (A || (A = []), A.push(V, ae)), ae = Te;
          else if (V === t3) {
            var Ke = Te ? Te[B5] : void 0, rt = Ye ? Ye[B5] : void 0;
            Ke != null && rt !== Ke && (A = A || []).push(V, Ke);
          } else V === Hv ? (typeof Te == "string" || typeof Te == "number") && (A = A || []).push(V, "" + Te) : V === F5 || V === Wh || (Ne.hasOwnProperty(V) ? (Te != null && (typeof Te != "function" && U5(V, Te), V === "onScroll" && no("scroll", i)), !A && Ye !== Te && (A = [])) : (A = A || []).push(V, Te));
      }
      return ae && (dv(ae, F[Wv]), (A = A || []).push(Wv, ae)), A;
    }
    function yde(i, l, h, g, w) {
      h === "input" && w.type === "radio" && w.name != null && Mi(i, w);
      var A = jc(h, g), L = jc(h, w);
      switch (pde(i, l, A, L), h) {
        case "input":
          $l(i, w);
          break;
        case "textarea":
          SC(i, w);
          break;
        case "select":
          n9(i, w);
          break;
      }
    }
    function bde(i) {
      {
        var l = i.toLowerCase();
        return E1.hasOwnProperty(l) && E1[l] || null;
      }
    }
    function _de(i, l, h, g, w, A, L) {
      var F, V;
      switch (F = jc(l, h), V5(l, h), l) {
        case "dialog":
          no("cancel", i), no("close", i);
          break;
        case "iframe":
        case "object":
        case "embed":
          no("load", i);
          break;
        case "video":
        case "audio":
          for (var J = 0; J < Jb.length; J++)
            no(Jb[J], i);
          break;
        case "source":
          no("error", i);
          break;
        case "img":
        case "image":
        case "link":
          no("error", i), no("load", i);
          break;
        case "details":
          no("toggle", i);
          break;
        case "input":
          Ri(i, h), no("invalid", i);
          break;
        case "option":
          y1(i, h);
          break;
        case "select":
          CC(i, h), no("invalid", i);
          break;
        case "textarea":
          wC(i, h), no("invalid", i);
          break;
      }
      x1(l, h);
      {
        V = /* @__PURE__ */ new Set();
        for (var ae = i.attributes, Me = 0; Me < ae.length; Me++) {
          var Te = ae[Me].name.toLowerCase();
          switch (Te) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              V.add(ae[Me].name);
          }
        }
      }
      var Ye = null;
      for (var Ke in h)
        if (h.hasOwnProperty(Ke)) {
          var rt = h[Ke];
          if (Ke === Hv)
            typeof rt == "string" ? i.textContent !== rt && (h[Wh] !== !0 && z5(i.textContent, rt, A, L), Ye = [Hv, rt]) : typeof rt == "number" && i.textContent !== "" + rt && (h[Wh] !== !0 && z5(i.textContent, rt, A, L), Ye = [Hv, "" + rt]);
          else if (Ne.hasOwnProperty(Ke))
            rt != null && (typeof rt != "function" && U5(Ke, rt), Ke === "onScroll" && no("scroll", i));
          else if (L && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof F == "boolean") {
            var Ft = void 0, gn = F && se ? null : ia(Ke);
            if (h[Wh] !== !0) {
              if (!(Ke === F5 || Ke === Wh || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              Ke === "value" || Ke === "checked" || Ke === "selected")) {
                if (Ke === t3) {
                  var un = i.innerHTML, Nr = rt ? rt[B5] : void 0;
                  if (Nr != null) {
                    var yr = GL(i, Nr);
                    yr !== un && n3(Ke, un, yr);
                  }
                } else if (Ke === Wv) {
                  if (V.delete(Ke), UL) {
                    var Ve = c9(rt);
                    Ft = i.getAttribute("style"), Ve !== Ft && n3(Ke, Ft, Ve);
                  }
                } else if (F && !se)
                  V.delete(Ke.toLowerCase()), Ft = Fo(i, Ke, rt), rt !== Ft && n3(Ke, Ft, rt);
                else if (!er(Ke, gn, F) && !Lr(Ke, rt, gn, F)) {
                  var at = !1;
                  if (gn !== null)
                    V.delete(gn.attributeName), Ft = So(i, Ke, rt, gn);
                  else {
                    var Ue = g;
                    if (Ue === Lc && (Ue = _1(l)), Ue === Lc)
                      V.delete(Ke.toLowerCase());
                    else {
                      var Ct = bde(Ke);
                      Ct !== null && Ct !== Ke && (at = !0, V.delete(Ct)), V.delete(Ke);
                    }
                    Ft = Fo(i, Ke, rt);
                  }
                  var Ht = se;
                  !Ht && rt !== Ft && !at && n3(Ke, Ft, rt);
                }
              }
            }
          }
        }
      switch (L && // $FlowFixMe - Should be inferred as not undefined.
      V.size > 0 && h[Wh] !== !0 && VL(V), l) {
        case "input":
          ue(i), Dc(i, h, !0);
          break;
        case "textarea":
          ue(i), xC(i);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof h.onClick == "function" && H5(i);
          break;
      }
      return Ye;
    }
    function Cde(i, l, h) {
      var g = i.nodeValue !== l;
      return g;
    }
    function G9(i, l) {
      {
        if (Jl)
          return;
        Jl = !0, s("Did not expect server HTML to contain a <%s> in <%s>.", l.nodeName.toLowerCase(), i.nodeName.toLowerCase());
      }
    }
    function z9(i, l) {
      {
        if (Jl)
          return;
        Jl = !0, s('Did not expect server HTML to contain the text node "%s" in <%s>.', l.nodeValue, i.nodeName.toLowerCase());
      }
    }
    function H9(i, l, h) {
      {
        if (Jl)
          return;
        Jl = !0, s("Expected server HTML to contain a matching <%s> in <%s>.", l, i.nodeName.toLowerCase());
      }
    }
    function W9(i, l) {
      {
        if (l === "" || Jl)
          return;
        Jl = !0, s('Expected server HTML to contain a matching text node for "%s" in <%s>.', l, i.nodeName.toLowerCase());
      }
    }
    function wde(i, l, h) {
      switch (l) {
        case "input":
          sh(i, h);
          return;
        case "textarea":
          J2(i, h);
          return;
        case "select":
          r9(i, h);
          return;
      }
    }
    var r3 = function() {
    }, a3 = function() {
    };
    {
      var Sde = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], HL = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], xde = HL.concat(["button"]), Ede = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], WL = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      a3 = function(i, l) {
        var h = Vn({}, i || WL), g = {
          tag: l
        };
        return HL.indexOf(l) !== -1 && (h.aTagInScope = null, h.buttonTagInScope = null, h.nobrTagInScope = null), xde.indexOf(l) !== -1 && (h.pTagInButtonScope = null), Sde.indexOf(l) !== -1 && l !== "address" && l !== "div" && l !== "p" && (h.listItemTagAutoclosing = null, h.dlItemTagAutoclosing = null), h.current = g, l === "form" && (h.formTag = g), l === "a" && (h.aTagInScope = g), l === "button" && (h.buttonTagInScope = g), l === "nobr" && (h.nobrTagInScope = g), l === "p" && (h.pTagInButtonScope = g), l === "li" && (h.listItemTagAutoclosing = g), (l === "dd" || l === "dt") && (h.dlItemTagAutoclosing = g), h;
      };
      var Ide = function(i, l) {
        switch (l) {
          case "select":
            return i === "option" || i === "optgroup" || i === "#text";
          case "optgroup":
            return i === "option" || i === "#text";
          case "option":
            return i === "#text";
          case "tr":
            return i === "th" || i === "td" || i === "style" || i === "script" || i === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return i === "tr" || i === "style" || i === "script" || i === "template";
          case "colgroup":
            return i === "col" || i === "template";
          case "table":
            return i === "caption" || i === "colgroup" || i === "tbody" || i === "tfoot" || i === "thead" || i === "style" || i === "script" || i === "template";
          case "head":
            return i === "base" || i === "basefont" || i === "bgsound" || i === "link" || i === "meta" || i === "title" || i === "noscript" || i === "noframes" || i === "style" || i === "script" || i === "template";
          case "html":
            return i === "head" || i === "body" || i === "frameset";
          case "frameset":
            return i === "frame";
          case "#document":
            return i === "html";
        }
        switch (i) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return l !== "h1" && l !== "h2" && l !== "h3" && l !== "h4" && l !== "h5" && l !== "h6";
          case "rp":
          case "rt":
            return Ede.indexOf(l) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return l == null;
        }
        return !0;
      }, kde = function(i, l) {
        switch (i) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return l.pTagInButtonScope;
          case "form":
            return l.formTag || l.pTagInButtonScope;
          case "li":
            return l.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return l.dlItemTagAutoclosing;
          case "button":
            return l.buttonTagInScope;
          case "a":
            return l.aTagInScope;
          case "nobr":
            return l.nobrTagInScope;
        }
        return null;
      }, ZL = {};
      r3 = function(i, l, h) {
        h = h || WL;
        var g = h.current, w = g && g.tag;
        l != null && (i != null && s("validateDOMNesting: when childText is passed, childTag should be null"), i = "#text");
        var A = Ide(i, w) ? null : g, L = A ? null : kde(i, h), F = A || L;
        if (F) {
          var V = F.tag, J = !!A + "|" + i + "|" + V;
          if (!ZL[J]) {
            ZL[J] = !0;
            var ae = i, Me = "";
            if (i === "#text" ? /\S/.test(l) ? ae = "Text nodes" : (ae = "Whitespace text nodes", Me = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : ae = "<" + i + ">", A) {
              var Te = "";
              V === "table" && i === "tr" && (Te += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), s("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", ae, V, Me, Te);
            } else
              s("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", ae, V);
          }
        }
      };
    }
    var W5 = "suppressHydrationWarning", Z5 = "$", Y5 = "/$", o3 = "$?", i3 = "$!", Ade = "style", Z9 = null, Y9 = null;
    function Pde(i) {
      var l, h, g = i.nodeType;
      switch (g) {
        case wu:
        case Gf: {
          l = g === wu ? "#document" : "#fragment";
          var w = i.documentElement;
          h = w ? w.namespaceURI : eb(null, "");
          break;
        }
        default: {
          var A = g === Bo ? i.parentNode : i, L = A.namespaceURI || null;
          l = A.tagName, h = eb(L, l);
          break;
        }
      }
      {
        var F = l.toLowerCase(), V = a3(null, F);
        return {
          namespace: h,
          ancestorInfo: V
        };
      }
    }
    function Nde(i, l, h) {
      {
        var g = i, w = eb(g.namespace, l), A = a3(g.ancestorInfo, l);
        return {
          namespace: w,
          ancestorInfo: A
        };
      }
    }
    function vht(i) {
      return i;
    }
    function Tde(i) {
      Z9 = Fh(), Y9 = Hce();
      var l = null;
      return el(!1), l;
    }
    function Ode(i) {
      Wce(Y9), el(Z9), Z9 = null, Y9 = null;
    }
    function Rde(i, l, h, g, w) {
      var A;
      {
        var L = g;
        if (r3(i, null, L.ancestorInfo), typeof l.children == "string" || typeof l.children == "number") {
          var F = "" + l.children, V = a3(L.ancestorInfo, i);
          r3(null, F, V);
        }
        A = L.namespace;
      }
      var J = hde(i, l, h, A);
      return u3(w, J), nE(J, l), J;
    }
    function Mde(i, l) {
      i.appendChild(l);
    }
    function Dde(i, l, h, g, w) {
      switch (vde(i, l, h, g), l) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!h.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function Lde(i, l, h, g, w, A) {
      {
        var L = A;
        if (typeof g.children != typeof h.children && (typeof g.children == "string" || typeof g.children == "number")) {
          var F = "" + g.children, V = a3(L.ancestorInfo, l);
          r3(null, F, V);
        }
      }
      return gde(i, l, h, g);
    }
    function X9(i, l) {
      return i === "textarea" || i === "noscript" || typeof l.children == "string" || typeof l.children == "number" || typeof l.dangerouslySetInnerHTML == "object" && l.dangerouslySetInnerHTML !== null && l.dangerouslySetInnerHTML.__html != null;
    }
    function $de(i, l, h, g) {
      {
        var w = h;
        r3(null, i, w.ancestorInfo);
      }
      var A = mde(i, l);
      return u3(g, A), A;
    }
    function jde() {
      var i = window.event;
      return i === void 0 ? Ku : mg(i.type);
    }
    var K9 = typeof setTimeout == "function" ? setTimeout : void 0, Fde = typeof clearTimeout == "function" ? clearTimeout : void 0, q9 = -1, YL = typeof Promise == "function" ? Promise : void 0, Bde = typeof queueMicrotask == "function" ? queueMicrotask : typeof YL != "undefined" ? function(i) {
      return YL.resolve(null).then(i).catch(Vde);
    } : K9;
    function Vde(i) {
      setTimeout(function() {
        throw i;
      });
    }
    function Ude(i, l, h, g) {
      switch (l) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          h.autoFocus && i.focus();
          return;
        case "img": {
          h.src && (i.src = h.src);
          return;
        }
      }
    }
    function Gde(i, l, h, g, w, A) {
      yde(i, l, h, g, w), nE(i, w);
    }
    function XL(i) {
      w1(i, "");
    }
    function zde(i, l, h) {
      i.nodeValue = h;
    }
    function Hde(i, l) {
      i.appendChild(l);
    }
    function Wde(i, l) {
      var h;
      i.nodeType === Bo ? (h = i.parentNode, h.insertBefore(l, i)) : (h = i, h.appendChild(l));
      var g = i._reactRootContainer;
      g == null && h.onclick === null && H5(h);
    }
    function Zde(i, l, h) {
      i.insertBefore(l, h);
    }
    function Yde(i, l, h) {
      i.nodeType === Bo ? i.parentNode.insertBefore(l, h) : i.insertBefore(l, h);
    }
    function Xde(i, l) {
      i.removeChild(l);
    }
    function Kde(i, l) {
      i.nodeType === Bo ? i.parentNode.removeChild(l) : i.removeChild(l);
    }
    function J9(i, l) {
      var h = l, g = 0;
      do {
        var w = h.nextSibling;
        if (i.removeChild(h), w && w.nodeType === Bo) {
          var A = w.data;
          if (A === Y5)
            if (g === 0) {
              i.removeChild(w), fo(l);
              return;
            } else
              g--;
          else (A === Z5 || A === o3 || A === i3) && g++;
        }
        h = w;
      } while (h);
      fo(l);
    }
    function qde(i, l) {
      i.nodeType === Bo ? J9(i.parentNode, l) : i.nodeType === zs && J9(i, l), fo(i);
    }
    function Jde(i) {
      i = i;
      var l = i.style;
      typeof l.setProperty == "function" ? l.setProperty("display", "none", "important") : l.display = "none";
    }
    function Qde(i) {
      i.nodeValue = "";
    }
    function efe(i, l) {
      i = i;
      var h = l[Ade], g = h != null && h.hasOwnProperty("display") ? h.display : null;
      i.style.display = S1("display", g);
    }
    function tfe(i, l) {
      i.nodeValue = l;
    }
    function nfe(i) {
      i.nodeType === zs ? i.textContent = "" : i.nodeType === wu && i.documentElement && i.removeChild(i.documentElement);
    }
    function rfe(i, l, h) {
      return i.nodeType !== zs || l.toLowerCase() !== i.nodeName.toLowerCase() ? null : i;
    }
    function afe(i, l) {
      return l === "" || i.nodeType !== $c ? null : i;
    }
    function ofe(i) {
      return i.nodeType !== Bo ? null : i;
    }
    function KL(i) {
      return i.data === o3;
    }
    function Q9(i) {
      return i.data === i3;
    }
    function ife(i) {
      var l = i.nextSibling && i.nextSibling.dataset, h, g, w;
      return l && (h = l.dgst, g = l.msg, w = l.stck), {
        message: g,
        digest: h,
        stack: w
      };
    }
    function sfe(i, l) {
      i._reactRetry = l;
    }
    function X5(i) {
      for (; i != null; i = i.nextSibling) {
        var l = i.nodeType;
        if (l === zs || l === $c)
          break;
        if (l === Bo) {
          var h = i.data;
          if (h === Z5 || h === i3 || h === o3)
            break;
          if (h === Y5)
            return null;
        }
      }
      return i;
    }
    function s3(i) {
      return X5(i.nextSibling);
    }
    function lfe(i) {
      return X5(i.firstChild);
    }
    function ufe(i) {
      return X5(i.firstChild);
    }
    function cfe(i) {
      return X5(i.nextSibling);
    }
    function dfe(i, l, h, g, w, A, L) {
      u3(A, i), nE(i, h);
      var F;
      {
        var V = w;
        F = V.namespace;
      }
      var J = (A.mode & ln) !== an;
      return _de(i, l, h, F, g, J, L);
    }
    function ffe(i, l, h, g) {
      return u3(h, i), h.mode & ln, Cde(i, l);
    }
    function pfe(i, l) {
      u3(l, i);
    }
    function hfe(i) {
      for (var l = i.nextSibling, h = 0; l; ) {
        if (l.nodeType === Bo) {
          var g = l.data;
          if (g === Y5) {
            if (h === 0)
              return s3(l);
            h--;
          } else (g === Z5 || g === i3 || g === o3) && h++;
        }
        l = l.nextSibling;
      }
      return null;
    }
    function qL(i) {
      for (var l = i.previousSibling, h = 0; l; ) {
        if (l.nodeType === Bo) {
          var g = l.data;
          if (g === Z5 || g === i3 || g === o3) {
            if (h === 0)
              return l;
            h--;
          } else g === Y5 && h++;
        }
        l = l.previousSibling;
      }
      return null;
    }
    function mfe(i) {
      fo(i);
    }
    function vfe(i) {
      fo(i);
    }
    function gfe(i) {
      return i !== "head" && i !== "body";
    }
    function yfe(i, l, h, g) {
      var w = !0;
      z5(l.nodeValue, h, g, w);
    }
    function bfe(i, l, h, g, w, A) {
      if (l[W5] !== !0) {
        var L = !0;
        z5(g.nodeValue, w, A, L);
      }
    }
    function _fe(i, l) {
      l.nodeType === zs ? G9(i, l) : l.nodeType === Bo || z9(i, l);
    }
    function Cfe(i, l) {
      {
        var h = i.parentNode;
        h !== null && (l.nodeType === zs ? G9(h, l) : l.nodeType === Bo || z9(h, l));
      }
    }
    function wfe(i, l, h, g, w) {
      (w || l[W5] !== !0) && (g.nodeType === zs ? G9(h, g) : g.nodeType === Bo || z9(h, g));
    }
    function Sfe(i, l, h) {
      H9(i, l);
    }
    function xfe(i, l) {
      W9(i, l);
    }
    function Efe(i, l, h) {
      {
        var g = i.parentNode;
        g !== null && H9(g, l);
      }
    }
    function Ife(i, l) {
      {
        var h = i.parentNode;
        h !== null && W9(h, l);
      }
    }
    function kfe(i, l, h, g, w, A) {
      (A || l[W5] !== !0) && H9(h, g);
    }
    function Afe(i, l, h, g, w) {
      (w || l[W5] !== !0) && W9(h, g);
    }
    function Pfe(i) {
      s("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", i.nodeName.toLowerCase());
    }
    function Nfe(i) {
      Qb(i);
    }
    var Rg = Math.random().toString(36).slice(2), Mg = "__reactFiber$" + Rg, eE = "__reactProps$" + Rg, l3 = "__reactContainer$" + Rg, tE = "__reactEvents$" + Rg, Tfe = "__reactListeners$" + Rg, Ofe = "__reactHandles$" + Rg;
    function Rfe(i) {
      delete i[Mg], delete i[eE], delete i[tE], delete i[Tfe], delete i[Ofe];
    }
    function u3(i, l) {
      l[Mg] = i;
    }
    function K5(i, l) {
      l[l3] = i;
    }
    function JL(i) {
      i[l3] = null;
    }
    function c3(i) {
      return !!i[l3];
    }
    function Zv(i) {
      var l = i[Mg];
      if (l)
        return l;
      for (var h = i.parentNode; h; ) {
        if (l = h[l3] || h[Mg], l) {
          var g = l.alternate;
          if (l.child !== null || g !== null && g.child !== null)
            for (var w = qL(i); w !== null; ) {
              var A = w[Mg];
              if (A)
                return A;
              w = qL(w);
            }
          return l;
        }
        i = h, h = i.parentNode;
      }
      return null;
    }
    function Zh(i) {
      var l = i[Mg] || i[l3];
      return l && (l.tag === b || l.tag === S || l.tag === $ || l.tag === v) ? l : null;
    }
    function Dg(i) {
      if (i.tag === b || i.tag === S)
        return i.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function q5(i) {
      return i[eE] || null;
    }
    function nE(i, l) {
      i[eE] = l;
    }
    function Mfe(i) {
      var l = i[tE];
      return l === void 0 && (l = i[tE] = /* @__PURE__ */ new Set()), l;
    }
    var QL = {}, e$ = n.ReactDebugCurrentFrame;
    function J5(i) {
      if (i) {
        var l = i._owner, h = ts(i.type, i._source, l ? l.type : null);
        e$.setExtraStackFrame(h);
      } else
        e$.setExtraStackFrame(null);
    }
    function Kc(i, l, h, g, w) {
      {
        var A = Function.call.bind(Ae);
        for (var L in i)
          if (A(i, L)) {
            var F = void 0;
            try {
              if (typeof i[L] != "function") {
                var V = Error((g || "React class") + ": " + h + " type `" + L + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[L] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw V.name = "Invariant Violation", V;
              }
              F = i[L](l, L, g, h, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (J) {
              F = J;
            }
            F && !(F instanceof Error) && (J5(w), s("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", h, L, typeof F), J5(null)), F instanceof Error && !(F.message in QL) && (QL[F.message] = !0, J5(w), s("Failed %s type: %s", h, F.message), J5(null));
          }
      }
    }
    var rE = [], Q5;
    Q5 = [];
    var pp = -1;
    function Yh(i) {
      return {
        current: i
      };
    }
    function tl(i, l) {
      if (pp < 0) {
        s("Unexpected pop.");
        return;
      }
      l !== Q5[pp] && s("Unexpected Fiber popped."), i.current = rE[pp], rE[pp] = null, Q5[pp] = null, pp--;
    }
    function nl(i, l, h) {
      pp++, rE[pp] = i.current, Q5[pp] = h, i.current = l;
    }
    var aE;
    aE = {};
    var Iu = {};
    Object.freeze(Iu);
    var hp = Yh(Iu), nf = Yh(!1), oE = Iu;
    function Lg(i, l, h) {
      return h && rf(l) ? oE : hp.current;
    }
    function t$(i, l, h) {
      {
        var g = i.stateNode;
        g.__reactInternalMemoizedUnmaskedChildContext = l, g.__reactInternalMemoizedMaskedChildContext = h;
      }
    }
    function $g(i, l) {
      {
        var h = i.type, g = h.contextTypes;
        if (!g)
          return Iu;
        var w = i.stateNode;
        if (w && w.__reactInternalMemoizedUnmaskedChildContext === l)
          return w.__reactInternalMemoizedMaskedChildContext;
        var A = {};
        for (var L in g)
          A[L] = l[L];
        {
          var F = In(i) || "Unknown";
          Kc(g, A, "context", F);
        }
        return w && t$(i, l, A), A;
      }
    }
    function ew() {
      return nf.current;
    }
    function rf(i) {
      {
        var l = i.childContextTypes;
        return l != null;
      }
    }
    function tw(i) {
      tl(nf, i), tl(hp, i);
    }
    function iE(i) {
      tl(nf, i), tl(hp, i);
    }
    function n$(i, l, h) {
      {
        if (hp.current !== Iu)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        nl(hp, l, i), nl(nf, h, i);
      }
    }
    function r$(i, l, h) {
      {
        var g = i.stateNode, w = l.childContextTypes;
        if (typeof g.getChildContext != "function") {
          {
            var A = In(i) || "Unknown";
            aE[A] || (aE[A] = !0, s("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", A, A));
          }
          return h;
        }
        var L = g.getChildContext();
        for (var F in L)
          if (!(F in w))
            throw new Error((In(i) || "Unknown") + '.getChildContext(): key "' + F + '" is not defined in childContextTypes.');
        {
          var V = In(i) || "Unknown";
          Kc(w, L, "child context", V);
        }
        return Vn({}, h, L);
      }
    }
    function nw(i) {
      {
        var l = i.stateNode, h = l && l.__reactInternalMemoizedMergedChildContext || Iu;
        return oE = hp.current, nl(hp, h, i), nl(nf, nf.current, i), !0;
      }
    }
    function a$(i, l, h) {
      {
        var g = i.stateNode;
        if (!g)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (h) {
          var w = r$(i, l, oE);
          g.__reactInternalMemoizedMergedChildContext = w, tl(nf, i), tl(hp, i), nl(hp, w, i), nl(nf, h, i);
        } else
          tl(nf, i), nl(nf, h, i);
      }
    }
    function Dfe(i) {
      {
        if (!_b(i) || i.tag !== f)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var l = i;
        do {
          switch (l.tag) {
            case v:
              return l.stateNode.context;
            case f: {
              var h = l.type;
              if (rf(h))
                return l.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          l = l.return;
        } while (l !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Xh = 0, rw = 1, mp = null, sE = !1, lE = !1;
    function o$(i) {
      mp === null ? mp = [i] : mp.push(i);
    }
    function Lfe(i) {
      sE = !0, o$(i);
    }
    function i$() {
      sE && Kh();
    }
    function Kh() {
      if (!lE && mp !== null) {
        lE = !0;
        var i = 0, l = Zl();
        try {
          var h = !0, g = mp;
          for (co(Ao); i < g.length; i++) {
            var w = g[i];
            do
              w = w(h);
            while (w !== null);
          }
          mp = null, sE = !1;
        } catch (A) {
          throw mp !== null && (mp = mp.slice(i + 1)), M1(L1, Kh), A;
        } finally {
          co(l), lE = !1;
        }
      }
      return null;
    }
    var jg = [], Fg = 0, aw = null, ow = 0, ec = [], tc = 0, Yv = null, vp = 1, gp = "";
    function $fe(i) {
      return Kv(), (i.flags & gb) !== hn;
    }
    function jfe(i) {
      return Kv(), ow;
    }
    function Ffe() {
      var i = gp, l = vp, h = l & ~Bfe(l);
      return h.toString(32) + i;
    }
    function Xv(i, l) {
      Kv(), jg[Fg++] = ow, jg[Fg++] = aw, aw = i, ow = l;
    }
    function s$(i, l, h) {
      Kv(), ec[tc++] = vp, ec[tc++] = gp, ec[tc++] = Yv, Yv = i;
      var g = vp, w = gp, A = iw(g) - 1, L = g & ~(1 << A), F = h + 1, V = iw(l) + A;
      if (V > 30) {
        var J = A - A % 5, ae = (1 << J) - 1, Me = (L & ae).toString(32), Te = L >> J, Ye = A - J, Ke = iw(l) + Ye, rt = F << Ye, Ft = rt | Te, gn = Me + w;
        vp = 1 << Ke | Ft, gp = gn;
      } else {
        var un = F << A, Nr = un | L, yr = w;
        vp = 1 << V | Nr, gp = yr;
      }
    }
    function uE(i) {
      Kv();
      var l = i.return;
      if (l !== null) {
        var h = 1, g = 0;
        Xv(i, h), s$(i, h, g);
      }
    }
    function iw(i) {
      return 32 - wh(i);
    }
    function Bfe(i) {
      return 1 << iw(i) - 1;
    }
    function cE(i) {
      for (; i === aw; )
        aw = jg[--Fg], jg[Fg] = null, ow = jg[--Fg], jg[Fg] = null;
      for (; i === Yv; )
        Yv = ec[--tc], ec[tc] = null, gp = ec[--tc], ec[tc] = null, vp = ec[--tc], ec[tc] = null;
    }
    function Vfe() {
      return Kv(), Yv !== null ? {
        id: vp,
        overflow: gp
      } : null;
    }
    function Ufe(i, l) {
      Kv(), ec[tc++] = vp, ec[tc++] = gp, ec[tc++] = Yv, vp = l.id, gp = l.overflow, Yv = i;
    }
    function Kv() {
      ks() || s("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var Is = null, nc = null, qc = !1, qv = !1, qh = null;
    function Gfe() {
      qc && s("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function l$() {
      qv = !0;
    }
    function zfe() {
      return qv;
    }
    function Hfe(i) {
      var l = i.stateNode.containerInfo;
      return nc = ufe(l), Is = i, qc = !0, qh = null, qv = !1, !0;
    }
    function Wfe(i, l, h) {
      return nc = cfe(l), Is = i, qc = !0, qh = null, qv = !1, h !== null && Ufe(i, h), !0;
    }
    function u$(i, l) {
      switch (i.tag) {
        case v: {
          _fe(i.stateNode.containerInfo, l);
          break;
        }
        case b: {
          var h = (i.mode & ln) !== an;
          wfe(
            i.type,
            i.memoizedProps,
            i.stateNode,
            l,
            // TODO: Delete this argument when we remove the legacy root API.
            h
          );
          break;
        }
        case $: {
          var g = i.memoizedState;
          g.dehydrated !== null && Cfe(g.dehydrated, l);
          break;
        }
      }
    }
    function c$(i, l) {
      u$(i, l);
      var h = Kme();
      h.stateNode = l, h.return = i;
      var g = i.deletions;
      g === null ? (i.deletions = [h], i.flags |= Kr) : g.push(h);
    }
    function dE(i, l) {
      {
        if (qv)
          return;
        switch (i.tag) {
          case v: {
            var h = i.stateNode.containerInfo;
            switch (l.tag) {
              case b:
                var g = l.type;
                l.pendingProps, Sfe(h, g);
                break;
              case S:
                var w = l.pendingProps;
                xfe(h, w);
                break;
            }
            break;
          }
          case b: {
            var A = i.type, L = i.memoizedProps, F = i.stateNode;
            switch (l.tag) {
              case b: {
                var V = l.type, J = l.pendingProps, ae = (i.mode & ln) !== an;
                kfe(
                  A,
                  L,
                  F,
                  V,
                  J,
                  // TODO: Delete this argument when we remove the legacy root API.
                  ae
                );
                break;
              }
              case S: {
                var Me = l.pendingProps, Te = (i.mode & ln) !== an;
                Afe(
                  A,
                  L,
                  F,
                  Me,
                  // TODO: Delete this argument when we remove the legacy root API.
                  Te
                );
                break;
              }
            }
            break;
          }
          case $: {
            var Ye = i.memoizedState, Ke = Ye.dehydrated;
            if (Ke !== null) switch (l.tag) {
              case b:
                var rt = l.type;
                l.pendingProps, Efe(Ke, rt);
                break;
              case S:
                var Ft = l.pendingProps;
                Ife(Ke, Ft);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function d$(i, l) {
      l.flags = l.flags & ~Vl | Ma, dE(i, l);
    }
    function f$(i, l) {
      switch (i.tag) {
        case b: {
          var h = i.type;
          i.pendingProps;
          var g = rfe(l, h);
          return g !== null ? (i.stateNode = g, Is = i, nc = lfe(g), !0) : !1;
        }
        case S: {
          var w = i.pendingProps, A = afe(l, w);
          return A !== null ? (i.stateNode = A, Is = i, nc = null, !0) : !1;
        }
        case $: {
          var L = ofe(l);
          if (L !== null) {
            var F = {
              dehydrated: L,
              treeContext: Vfe(),
              retryLane: ss
            };
            i.memoizedState = F;
            var V = qme(L);
            return V.return = i, i.child = V, Is = i, nc = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function fE(i) {
      return (i.mode & ln) !== an && (i.flags & $n) === hn;
    }
    function pE(i) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function hE(i) {
      if (qc) {
        var l = nc;
        if (!l) {
          fE(i) && (dE(Is, i), pE()), d$(Is, i), qc = !1, Is = i;
          return;
        }
        var h = l;
        if (!f$(i, l)) {
          fE(i) && (dE(Is, i), pE()), l = s3(h);
          var g = Is;
          if (!l || !f$(i, l)) {
            d$(Is, i), qc = !1, Is = i;
            return;
          }
          c$(g, h);
        }
      }
    }
    function Zfe(i, l, h) {
      var g = i.stateNode, w = !qv, A = dfe(g, i.type, i.memoizedProps, l, h, i, w);
      return i.updateQueue = A, A !== null;
    }
    function Yfe(i) {
      var l = i.stateNode, h = i.memoizedProps, g = ffe(l, h, i);
      if (g) {
        var w = Is;
        if (w !== null)
          switch (w.tag) {
            case v: {
              var A = w.stateNode.containerInfo, L = (w.mode & ln) !== an;
              yfe(
                A,
                l,
                h,
                // TODO: Delete this argument when we remove the legacy root API.
                L
              );
              break;
            }
            case b: {
              var F = w.type, V = w.memoizedProps, J = w.stateNode, ae = (w.mode & ln) !== an;
              bfe(
                F,
                V,
                J,
                l,
                h,
                // TODO: Delete this argument when we remove the legacy root API.
                ae
              );
              break;
            }
          }
      }
      return g;
    }
    function Xfe(i) {
      var l = i.memoizedState, h = l !== null ? l.dehydrated : null;
      if (!h)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      pfe(h, i);
    }
    function Kfe(i) {
      var l = i.memoizedState, h = l !== null ? l.dehydrated : null;
      if (!h)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return hfe(h);
    }
    function p$(i) {
      for (var l = i.return; l !== null && l.tag !== b && l.tag !== v && l.tag !== $; )
        l = l.return;
      Is = l;
    }
    function sw(i) {
      if (i !== Is)
        return !1;
      if (!qc)
        return p$(i), qc = !0, !1;
      if (i.tag !== v && (i.tag !== b || gfe(i.type) && !X9(i.type, i.memoizedProps))) {
        var l = nc;
        if (l)
          if (fE(i))
            h$(i), pE();
          else
            for (; l; )
              c$(i, l), l = s3(l);
      }
      return p$(i), i.tag === $ ? nc = Kfe(i) : nc = Is ? s3(i.stateNode) : null, !0;
    }
    function qfe() {
      return qc && nc !== null;
    }
    function h$(i) {
      for (var l = nc; l; )
        u$(i, l), l = s3(l);
    }
    function Bg() {
      Is = null, nc = null, qc = !1, qv = !1;
    }
    function m$() {
      qh !== null && (lF(qh), qh = null);
    }
    function ks() {
      return qc;
    }
    function mE(i) {
      qh === null ? qh = [i] : qh.push(i);
    }
    var Jfe = n.ReactCurrentBatchConfig, Qfe = null;
    function epe() {
      return Jfe.transition;
    }
    var Jc = {
      recordUnsafeLifecycleWarnings: function(i, l) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(i, l) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var tpe = function(i) {
        for (var l = null, h = i; h !== null; )
          h.mode & dr && (l = h), h = h.return;
        return l;
      }, Jv = function(i) {
        var l = [];
        return i.forEach(function(h) {
          l.push(h);
        }), l.sort().join(", ");
      }, d3 = [], f3 = [], p3 = [], h3 = [], m3 = [], v3 = [], Qv = /* @__PURE__ */ new Set();
      Jc.recordUnsafeLifecycleWarnings = function(i, l) {
        Qv.has(i.type) || (typeof l.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        l.componentWillMount.__suppressDeprecationWarning !== !0 && d3.push(i), i.mode & dr && typeof l.UNSAFE_componentWillMount == "function" && f3.push(i), typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && p3.push(i), i.mode & dr && typeof l.UNSAFE_componentWillReceiveProps == "function" && h3.push(i), typeof l.componentWillUpdate == "function" && l.componentWillUpdate.__suppressDeprecationWarning !== !0 && m3.push(i), i.mode & dr && typeof l.UNSAFE_componentWillUpdate == "function" && v3.push(i));
      }, Jc.flushPendingUnsafeLifecycleWarnings = function() {
        var i = /* @__PURE__ */ new Set();
        d3.length > 0 && (d3.forEach(function(Te) {
          i.add(In(Te) || "Component"), Qv.add(Te.type);
        }), d3 = []);
        var l = /* @__PURE__ */ new Set();
        f3.length > 0 && (f3.forEach(function(Te) {
          l.add(In(Te) || "Component"), Qv.add(Te.type);
        }), f3 = []);
        var h = /* @__PURE__ */ new Set();
        p3.length > 0 && (p3.forEach(function(Te) {
          h.add(In(Te) || "Component"), Qv.add(Te.type);
        }), p3 = []);
        var g = /* @__PURE__ */ new Set();
        h3.length > 0 && (h3.forEach(function(Te) {
          g.add(In(Te) || "Component"), Qv.add(Te.type);
        }), h3 = []);
        var w = /* @__PURE__ */ new Set();
        m3.length > 0 && (m3.forEach(function(Te) {
          w.add(In(Te) || "Component"), Qv.add(Te.type);
        }), m3 = []);
        var A = /* @__PURE__ */ new Set();
        if (v3.length > 0 && (v3.forEach(function(Te) {
          A.add(In(Te) || "Component"), Qv.add(Te.type);
        }), v3 = []), l.size > 0) {
          var L = Jv(l);
          s(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, L);
        }
        if (g.size > 0) {
          var F = Jv(g);
          s(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, F);
        }
        if (A.size > 0) {
          var V = Jv(A);
          s(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, V);
        }
        if (i.size > 0) {
          var J = Jv(i);
          o(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, J);
        }
        if (h.size > 0) {
          var ae = Jv(h);
          o(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, ae);
        }
        if (w.size > 0) {
          var Me = Jv(w);
          o(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Me);
        }
      };
      var lw = /* @__PURE__ */ new Map(), v$ = /* @__PURE__ */ new Set();
      Jc.recordLegacyContextWarning = function(i, l) {
        var h = tpe(i);
        if (h === null) {
          s("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!v$.has(i.type)) {
          var g = lw.get(h);
          (i.type.contextTypes != null || i.type.childContextTypes != null || l !== null && typeof l.getChildContext == "function") && (g === void 0 && (g = [], lw.set(h, g)), g.push(i));
        }
      }, Jc.flushLegacyContextWarning = function() {
        lw.forEach(function(i, l) {
          if (i.length !== 0) {
            var h = i[0], g = /* @__PURE__ */ new Set();
            i.forEach(function(A) {
              g.add(In(A) || "Component"), v$.add(A.type);
            });
            var w = Jv(g);
            try {
              Vr(h), s(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, w);
            } finally {
              so();
            }
          }
        });
      }, Jc.discardPendingWarnings = function() {
        d3 = [], f3 = [], p3 = [], h3 = [], m3 = [], v3 = [], lw = /* @__PURE__ */ new Map();
      };
    }
    var vE, gE, yE, bE, _E, g$ = function(i, l) {
    };
    vE = !1, gE = !1, yE = {}, bE = {}, _E = {}, g$ = function(i, l) {
      if (!(i === null || typeof i != "object") && !(!i._store || i._store.validated || i.key != null)) {
        if (typeof i._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        i._store.validated = !0;
        var h = In(l) || "Component";
        bE[h] || (bE[h] = !0, s('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function npe(i) {
      return i.prototype && i.prototype.isReactComponent;
    }
    function g3(i, l, h) {
      var g = h.ref;
      if (g !== null && typeof g != "function" && typeof g != "object") {
        if ((i.mode & dr || Ie) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(h._owner && h._self && h._owner.stateNode !== h._self) && // Will already throw with "Function components cannot have string refs"
        !(h._owner && h._owner.tag !== f) && // Will already warn with "Function components cannot be given refs"
        !(typeof h.type == "function" && !npe(h.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        h._owner) {
          var w = In(i) || "Component";
          yE[w] || (s('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', w, g), yE[w] = !0);
        }
        if (h._owner) {
          var A = h._owner, L;
          if (A) {
            var F = A;
            if (F.tag !== f)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            L = F.stateNode;
          }
          if (!L)
            throw new Error("Missing owner for string ref " + g + ". This error is likely caused by a bug in React. Please file an issue.");
          var V = L;
          dn(g, "ref");
          var J = "" + g;
          if (l !== null && l.ref !== null && typeof l.ref == "function" && l.ref._stringRef === J)
            return l.ref;
          var ae = function(Me) {
            var Te = V.refs;
            Me === null ? delete Te[J] : Te[J] = Me;
          };
          return ae._stringRef = J, ae;
        } else {
          if (typeof g != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!h._owner)
            throw new Error("Element ref was specified as a string (" + g + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return g;
    }
    function uw(i, l) {
      var h = Object.prototype.toString.call(l);
      throw new Error("Objects are not valid as a React child (found: " + (h === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : h) + "). If you meant to render a collection of children, use an array instead.");
    }
    function cw(i) {
      {
        var l = In(i) || "Component";
        if (_E[l])
          return;
        _E[l] = !0, s("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function y$(i) {
      var l = i._payload, h = i._init;
      return h(l);
    }
    function b$(i) {
      function l(Ve, at) {
        if (i) {
          var Ue = Ve.deletions;
          Ue === null ? (Ve.deletions = [at], Ve.flags |= Kr) : Ue.push(at);
        }
      }
      function h(Ve, at) {
        if (!i)
          return null;
        for (var Ue = at; Ue !== null; )
          l(Ve, Ue), Ue = Ue.sibling;
        return null;
      }
      function g(Ve, at) {
        for (var Ue = /* @__PURE__ */ new Map(), Ct = at; Ct !== null; )
          Ct.key !== null ? Ue.set(Ct.key, Ct) : Ue.set(Ct.index, Ct), Ct = Ct.sibling;
        return Ue;
      }
      function w(Ve, at) {
        var Ue = l0(Ve, at);
        return Ue.index = 0, Ue.sibling = null, Ue;
      }
      function A(Ve, at, Ue) {
        if (Ve.index = Ue, !i)
          return Ve.flags |= gb, at;
        var Ct = Ve.alternate;
        if (Ct !== null) {
          var Ht = Ct.index;
          return Ht < at ? (Ve.flags |= Ma, at) : Ht;
        } else
          return Ve.flags |= Ma, at;
      }
      function L(Ve) {
        return i && Ve.alternate === null && (Ve.flags |= Ma), Ve;
      }
      function F(Ve, at, Ue, Ct) {
        if (at === null || at.tag !== S) {
          var Ht = mk(Ue, Ve.mode, Ct);
          return Ht.return = Ve, Ht;
        } else {
          var Bt = w(at, Ue);
          return Bt.return = Ve, Bt;
        }
      }
      function V(Ve, at, Ue, Ct) {
        var Ht = Ue.type;
        if (Ht === qa)
          return ae(Ve, at, Ue.props.children, Ct, Ue.key);
        if (at !== null && (at.elementType === Ht || // Keep this check inline so it only runs on the false path:
        xF(at, Ue) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Ht == "object" && Ht !== null && Ht.$$typeof === vn && y$(Ht) === at.type)) {
          var Bt = w(at, Ue.props);
          return Bt.ref = g3(Ve, at, Ue), Bt.return = Ve, Bt._debugSource = Ue._source, Bt._debugOwner = Ue._owner, Bt;
        }
        var Tn = hk(Ue, Ve.mode, Ct);
        return Tn.ref = g3(Ve, at, Ue), Tn.return = Ve, Tn;
      }
      function J(Ve, at, Ue, Ct) {
        if (at === null || at.tag !== y || at.stateNode.containerInfo !== Ue.containerInfo || at.stateNode.implementation !== Ue.implementation) {
          var Ht = vk(Ue, Ve.mode, Ct);
          return Ht.return = Ve, Ht;
        } else {
          var Bt = w(at, Ue.children || []);
          return Bt.return = Ve, Bt;
        }
      }
      function ae(Ve, at, Ue, Ct, Ht) {
        if (at === null || at.tag !== x) {
          var Bt = lm(Ue, Ve.mode, Ct, Ht);
          return Bt.return = Ve, Bt;
        } else {
          var Tn = w(at, Ue);
          return Tn.return = Ve, Tn;
        }
      }
      function Me(Ve, at, Ue) {
        if (typeof at == "string" && at !== "" || typeof at == "number") {
          var Ct = mk("" + at, Ve.mode, Ue);
          return Ct.return = Ve, Ct;
        }
        if (typeof at == "object" && at !== null) {
          switch (at.$$typeof) {
            case ri: {
              var Ht = hk(at, Ve.mode, Ue);
              return Ht.ref = g3(Ve, null, at), Ht.return = Ve, Ht;
            }
            case xo: {
              var Bt = vk(at, Ve.mode, Ue);
              return Bt.return = Ve, Bt;
            }
            case vn: {
              var Tn = at._payload, Un = at._init;
              return Me(Ve, Un(Tn), Ue);
            }
          }
          if (bi(at) || Eo(at)) {
            var va = lm(at, Ve.mode, Ue, null);
            return va.return = Ve, va;
          }
          uw(Ve, at);
        }
        return typeof at == "function" && cw(Ve), null;
      }
      function Te(Ve, at, Ue, Ct) {
        var Ht = at !== null ? at.key : null;
        if (typeof Ue == "string" && Ue !== "" || typeof Ue == "number")
          return Ht !== null ? null : F(Ve, at, "" + Ue, Ct);
        if (typeof Ue == "object" && Ue !== null) {
          switch (Ue.$$typeof) {
            case ri:
              return Ue.key === Ht ? V(Ve, at, Ue, Ct) : null;
            case xo:
              return Ue.key === Ht ? J(Ve, at, Ue, Ct) : null;
            case vn: {
              var Bt = Ue._payload, Tn = Ue._init;
              return Te(Ve, at, Tn(Bt), Ct);
            }
          }
          if (bi(Ue) || Eo(Ue))
            return Ht !== null ? null : ae(Ve, at, Ue, Ct, null);
          uw(Ve, Ue);
        }
        return typeof Ue == "function" && cw(Ve), null;
      }
      function Ye(Ve, at, Ue, Ct, Ht) {
        if (typeof Ct == "string" && Ct !== "" || typeof Ct == "number") {
          var Bt = Ve.get(Ue) || null;
          return F(at, Bt, "" + Ct, Ht);
        }
        if (typeof Ct == "object" && Ct !== null) {
          switch (Ct.$$typeof) {
            case ri: {
              var Tn = Ve.get(Ct.key === null ? Ue : Ct.key) || null;
              return V(at, Tn, Ct, Ht);
            }
            case xo: {
              var Un = Ve.get(Ct.key === null ? Ue : Ct.key) || null;
              return J(at, Un, Ct, Ht);
            }
            case vn:
              var va = Ct._payload, zr = Ct._init;
              return Ye(Ve, at, Ue, zr(va), Ht);
          }
          if (bi(Ct) || Eo(Ct)) {
            var di = Ve.get(Ue) || null;
            return ae(at, di, Ct, Ht, null);
          }
          uw(at, Ct);
        }
        return typeof Ct == "function" && cw(at), null;
      }
      function Ke(Ve, at, Ue) {
        {
          if (typeof Ve != "object" || Ve === null)
            return at;
          switch (Ve.$$typeof) {
            case ri:
            case xo:
              g$(Ve, Ue);
              var Ct = Ve.key;
              if (typeof Ct != "string")
                break;
              if (at === null) {
                at = /* @__PURE__ */ new Set(), at.add(Ct);
                break;
              }
              if (!at.has(Ct)) {
                at.add(Ct);
                break;
              }
              s("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", Ct);
              break;
            case vn:
              var Ht = Ve._payload, Bt = Ve._init;
              Ke(Bt(Ht), at, Ue);
              break;
          }
        }
        return at;
      }
      function rt(Ve, at, Ue, Ct) {
        for (var Ht = null, Bt = 0; Bt < Ue.length; Bt++) {
          var Tn = Ue[Bt];
          Ht = Ke(Tn, Ht, Ve);
        }
        for (var Un = null, va = null, zr = at, di = 0, Hr = 0, Go = null; zr !== null && Hr < Ue.length; Hr++) {
          zr.index > Hr ? (Go = zr, zr = null) : Go = zr.sibling;
          var al = Te(Ve, zr, Ue[Hr], Ct);
          if (al === null) {
            zr === null && (zr = Go);
            break;
          }
          i && zr && al.alternate === null && l(Ve, zr), di = A(al, di, Hr), va === null ? Un = al : va.sibling = al, va = al, zr = Go;
        }
        if (Hr === Ue.length) {
          if (h(Ve, zr), ks()) {
            var Ms = Hr;
            Xv(Ve, Ms);
          }
          return Un;
        }
        if (zr === null) {
          for (; Hr < Ue.length; Hr++) {
            var Au = Me(Ve, Ue[Hr], Ct);
            Au !== null && (di = A(Au, di, Hr), va === null ? Un = Au : va.sibling = Au, va = Au);
          }
          if (ks()) {
            var Il = Hr;
            Xv(Ve, Il);
          }
          return Un;
        }
        for (var kl = g(Ve, zr); Hr < Ue.length; Hr++) {
          var ol = Ye(kl, Ve, Hr, Ue[Hr], Ct);
          ol !== null && (i && ol.alternate !== null && kl.delete(ol.key === null ? Hr : ol.key), di = A(ol, di, Hr), va === null ? Un = ol : va.sibling = ol, va = ol);
        }
        if (i && kl.forEach(function(oy) {
          return l(Ve, oy);
        }), ks()) {
          var xp = Hr;
          Xv(Ve, xp);
        }
        return Un;
      }
      function Ft(Ve, at, Ue, Ct) {
        var Ht = Eo(Ue);
        if (typeof Ht != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          Ue[Symbol.toStringTag] === "Generator" && (gE || s("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), gE = !0), Ue.entries === Ht && (vE || s("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), vE = !0);
          var Bt = Ht.call(Ue);
          if (Bt)
            for (var Tn = null, Un = Bt.next(); !Un.done; Un = Bt.next()) {
              var va = Un.value;
              Tn = Ke(va, Tn, Ve);
            }
        }
        var zr = Ht.call(Ue);
        if (zr == null)
          throw new Error("An iterable object provided no iterator.");
        for (var di = null, Hr = null, Go = at, al = 0, Ms = 0, Au = null, Il = zr.next(); Go !== null && !Il.done; Ms++, Il = zr.next()) {
          Go.index > Ms ? (Au = Go, Go = null) : Au = Go.sibling;
          var kl = Te(Ve, Go, Il.value, Ct);
          if (kl === null) {
            Go === null && (Go = Au);
            break;
          }
          i && Go && kl.alternate === null && l(Ve, Go), al = A(kl, al, Ms), Hr === null ? di = kl : Hr.sibling = kl, Hr = kl, Go = Au;
        }
        if (Il.done) {
          if (h(Ve, Go), ks()) {
            var ol = Ms;
            Xv(Ve, ol);
          }
          return di;
        }
        if (Go === null) {
          for (; !Il.done; Ms++, Il = zr.next()) {
            var xp = Me(Ve, Il.value, Ct);
            xp !== null && (al = A(xp, al, Ms), Hr === null ? di = xp : Hr.sibling = xp, Hr = xp);
          }
          if (ks()) {
            var oy = Ms;
            Xv(Ve, oy);
          }
          return di;
        }
        for (var X3 = g(Ve, Go); !Il.done; Ms++, Il = zr.next()) {
          var ff = Ye(X3, Ve, Ms, Il.value, Ct);
          ff !== null && (i && ff.alternate !== null && X3.delete(ff.key === null ? Ms : ff.key), al = A(ff, al, Ms), Hr === null ? di = ff : Hr.sibling = ff, Hr = ff);
        }
        if (i && X3.forEach(function(Ave) {
          return l(Ve, Ave);
        }), ks()) {
          var kve = Ms;
          Xv(Ve, kve);
        }
        return di;
      }
      function gn(Ve, at, Ue, Ct) {
        if (at !== null && at.tag === S) {
          h(Ve, at.sibling);
          var Ht = w(at, Ue);
          return Ht.return = Ve, Ht;
        }
        h(Ve, at);
        var Bt = mk(Ue, Ve.mode, Ct);
        return Bt.return = Ve, Bt;
      }
      function un(Ve, at, Ue, Ct) {
        for (var Ht = Ue.key, Bt = at; Bt !== null; ) {
          if (Bt.key === Ht) {
            var Tn = Ue.type;
            if (Tn === qa) {
              if (Bt.tag === x) {
                h(Ve, Bt.sibling);
                var Un = w(Bt, Ue.props.children);
                return Un.return = Ve, Un._debugSource = Ue._source, Un._debugOwner = Ue._owner, Un;
              }
            } else if (Bt.elementType === Tn || // Keep this check inline so it only runs on the false path:
            xF(Bt, Ue) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Tn == "object" && Tn !== null && Tn.$$typeof === vn && y$(Tn) === Bt.type) {
              h(Ve, Bt.sibling);
              var va = w(Bt, Ue.props);
              return va.ref = g3(Ve, Bt, Ue), va.return = Ve, va._debugSource = Ue._source, va._debugOwner = Ue._owner, va;
            }
            h(Ve, Bt);
            break;
          } else
            l(Ve, Bt);
          Bt = Bt.sibling;
        }
        if (Ue.type === qa) {
          var zr = lm(Ue.props.children, Ve.mode, Ct, Ue.key);
          return zr.return = Ve, zr;
        } else {
          var di = hk(Ue, Ve.mode, Ct);
          return di.ref = g3(Ve, at, Ue), di.return = Ve, di;
        }
      }
      function Nr(Ve, at, Ue, Ct) {
        for (var Ht = Ue.key, Bt = at; Bt !== null; ) {
          if (Bt.key === Ht)
            if (Bt.tag === y && Bt.stateNode.containerInfo === Ue.containerInfo && Bt.stateNode.implementation === Ue.implementation) {
              h(Ve, Bt.sibling);
              var Tn = w(Bt, Ue.children || []);
              return Tn.return = Ve, Tn;
            } else {
              h(Ve, Bt);
              break;
            }
          else
            l(Ve, Bt);
          Bt = Bt.sibling;
        }
        var Un = vk(Ue, Ve.mode, Ct);
        return Un.return = Ve, Un;
      }
      function yr(Ve, at, Ue, Ct) {
        var Ht = typeof Ue == "object" && Ue !== null && Ue.type === qa && Ue.key === null;
        if (Ht && (Ue = Ue.props.children), typeof Ue == "object" && Ue !== null) {
          switch (Ue.$$typeof) {
            case ri:
              return L(un(Ve, at, Ue, Ct));
            case xo:
              return L(Nr(Ve, at, Ue, Ct));
            case vn:
              var Bt = Ue._payload, Tn = Ue._init;
              return yr(Ve, at, Tn(Bt), Ct);
          }
          if (bi(Ue))
            return rt(Ve, at, Ue, Ct);
          if (Eo(Ue))
            return Ft(Ve, at, Ue, Ct);
          uw(Ve, Ue);
        }
        return typeof Ue == "string" && Ue !== "" || typeof Ue == "number" ? L(gn(Ve, at, "" + Ue, Ct)) : (typeof Ue == "function" && cw(Ve), h(Ve, at));
      }
      return yr;
    }
    var Vg = b$(!0), _$ = b$(!1);
    function rpe(i, l) {
      if (i !== null && l.child !== i.child)
        throw new Error("Resuming work not yet implemented.");
      if (l.child !== null) {
        var h = l.child, g = l0(h, h.pendingProps);
        for (l.child = g, g.return = l; h.sibling !== null; )
          h = h.sibling, g = g.sibling = l0(h, h.pendingProps), g.return = l;
        g.sibling = null;
      }
    }
    function ape(i, l) {
      for (var h = i.child; h !== null; )
        Hme(h, l), h = h.sibling;
    }
    var CE = Yh(null), wE;
    wE = {};
    var dw = null, Ug = null, SE = null, fw = !1;
    function pw() {
      dw = null, Ug = null, SE = null, fw = !1;
    }
    function C$() {
      fw = !0;
    }
    function w$() {
      fw = !1;
    }
    function S$(i, l, h) {
      nl(CE, l._currentValue, i), l._currentValue = h, l._currentRenderer !== void 0 && l._currentRenderer !== null && l._currentRenderer !== wE && s("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), l._currentRenderer = wE;
    }
    function xE(i, l) {
      var h = CE.current;
      tl(CE, l), i._currentValue = h;
    }
    function EE(i, l, h) {
      for (var g = i; g !== null; ) {
        var w = g.alternate;
        if (op(g.childLanes, l) ? w !== null && !op(w.childLanes, l) && (w.childLanes = Wn(w.childLanes, l)) : (g.childLanes = Wn(g.childLanes, l), w !== null && (w.childLanes = Wn(w.childLanes, l))), g === h)
          break;
        g = g.return;
      }
      g !== h && s("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function ope(i, l, h) {
      ipe(i, l, h);
    }
    function ipe(i, l, h) {
      var g = i.child;
      for (g !== null && (g.return = i); g !== null; ) {
        var w = void 0, A = g.dependencies;
        if (A !== null) {
          w = g.child;
          for (var L = A.firstContext; L !== null; ) {
            if (L.context === l) {
              if (g.tag === f) {
                var F = Ph(h), V = yp(Na, F);
                V.tag = mw;
                var J = g.updateQueue;
                if (J !== null) {
                  var ae = J.shared, Me = ae.pending;
                  Me === null ? V.next = V : (V.next = Me.next, Me.next = V), ae.pending = V;
                }
              }
              g.lanes = Wn(g.lanes, h);
              var Te = g.alternate;
              Te !== null && (Te.lanes = Wn(Te.lanes, h)), EE(g.return, h, i), A.lanes = Wn(A.lanes, h);
              break;
            }
            L = L.next;
          }
        } else if (g.tag === R)
          w = g.type === i.type ? null : g.child;
        else if (g.tag === q) {
          var Ye = g.return;
          if (Ye === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          Ye.lanes = Wn(Ye.lanes, h);
          var Ke = Ye.alternate;
          Ke !== null && (Ke.lanes = Wn(Ke.lanes, h)), EE(Ye, h, i), w = g.sibling;
        } else
          w = g.child;
        if (w !== null)
          w.return = g;
        else
          for (w = g; w !== null; ) {
            if (w === i) {
              w = null;
              break;
            }
            var rt = w.sibling;
            if (rt !== null) {
              rt.return = w.return, w = rt;
              break;
            }
            w = w.return;
          }
        g = w;
      }
    }
    function Gg(i, l) {
      dw = i, Ug = null, SE = null;
      var h = i.dependencies;
      if (h !== null) {
        var g = h.firstContext;
        g !== null && (Qs(h.lanes, l) && O3(), h.firstContext = null);
      }
    }
    function Ei(i) {
      fw && s("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var l = i._currentValue;
      if (SE !== i) {
        var h = {
          context: i,
          memoizedValue: l,
          next: null
        };
        if (Ug === null) {
          if (dw === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Ug = h, dw.dependencies = {
            lanes: dt,
            firstContext: h
          };
        } else
          Ug = Ug.next = h;
      }
      return l;
    }
    var e0 = null;
    function IE(i) {
      e0 === null ? e0 = [i] : e0.push(i);
    }
    function spe() {
      if (e0 !== null) {
        for (var i = 0; i < e0.length; i++) {
          var l = e0[i], h = l.interleaved;
          if (h !== null) {
            l.interleaved = null;
            var g = h.next, w = l.pending;
            if (w !== null) {
              var A = w.next;
              w.next = g, h.next = A;
            }
            l.pending = h;
          }
        }
        e0 = null;
      }
    }
    function x$(i, l, h, g) {
      var w = l.interleaved;
      return w === null ? (h.next = h, IE(l)) : (h.next = w.next, w.next = h), l.interleaved = h, hw(i, g);
    }
    function lpe(i, l, h, g) {
      var w = l.interleaved;
      w === null ? (h.next = h, IE(l)) : (h.next = w.next, w.next = h), l.interleaved = h;
    }
    function upe(i, l, h, g) {
      var w = l.interleaved;
      return w === null ? (h.next = h, IE(l)) : (h.next = w.next, w.next = h), l.interleaved = h, hw(i, g);
    }
    function Ql(i, l) {
      return hw(i, l);
    }
    var cpe = hw;
    function hw(i, l) {
      i.lanes = Wn(i.lanes, l);
      var h = i.alternate;
      h !== null && (h.lanes = Wn(h.lanes, l)), h === null && (i.flags & (Ma | Vl)) !== hn && _F(i);
      for (var g = i, w = i.return; w !== null; )
        w.childLanes = Wn(w.childLanes, l), h = w.alternate, h !== null ? h.childLanes = Wn(h.childLanes, l) : (w.flags & (Ma | Vl)) !== hn && _F(i), g = w, w = w.return;
      if (g.tag === v) {
        var A = g.stateNode;
        return A;
      } else
        return null;
    }
    var E$ = 0, I$ = 1, mw = 2, kE = 3, vw = !1, AE, gw;
    AE = !1, gw = null;
    function PE(i) {
      var l = {
        baseState: i.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: dt
        },
        effects: null
      };
      i.updateQueue = l;
    }
    function k$(i, l) {
      var h = l.updateQueue, g = i.updateQueue;
      if (h === g) {
        var w = {
          baseState: g.baseState,
          firstBaseUpdate: g.firstBaseUpdate,
          lastBaseUpdate: g.lastBaseUpdate,
          shared: g.shared,
          effects: g.effects
        };
        l.updateQueue = w;
      }
    }
    function yp(i, l) {
      var h = {
        eventTime: i,
        lane: l,
        tag: E$,
        payload: null,
        callback: null,
        next: null
      };
      return h;
    }
    function Jh(i, l, h) {
      var g = i.updateQueue;
      if (g === null)
        return null;
      var w = g.shared;
      if (gw === w && !AE && (s("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), AE = !0), lme()) {
        var A = w.pending;
        return A === null ? l.next = l : (l.next = A.next, A.next = l), w.pending = l, cpe(i, h);
      } else
        return upe(i, w, l, h);
    }
    function yw(i, l, h) {
      var g = l.updateQueue;
      if (g !== null) {
        var w = g.shared;
        if (Ob(h)) {
          var A = w.lanes;
          A = ig(A, i.pendingLanes);
          var L = Wn(A, h);
          w.lanes = L, Rb(i, L);
        }
      }
    }
    function NE(i, l) {
      var h = i.updateQueue, g = i.alternate;
      if (g !== null) {
        var w = g.updateQueue;
        if (h === w) {
          var A = null, L = null, F = h.firstBaseUpdate;
          if (F !== null) {
            var V = F;
            do {
              var J = {
                eventTime: V.eventTime,
                lane: V.lane,
                tag: V.tag,
                payload: V.payload,
                callback: V.callback,
                next: null
              };
              L === null ? A = L = J : (L.next = J, L = J), V = V.next;
            } while (V !== null);
            L === null ? A = L = l : (L.next = l, L = l);
          } else
            A = L = l;
          h = {
            baseState: w.baseState,
            firstBaseUpdate: A,
            lastBaseUpdate: L,
            shared: w.shared,
            effects: w.effects
          }, i.updateQueue = h;
          return;
        }
      }
      var ae = h.lastBaseUpdate;
      ae === null ? h.firstBaseUpdate = l : ae.next = l, h.lastBaseUpdate = l;
    }
    function dpe(i, l, h, g, w, A) {
      switch (h.tag) {
        case I$: {
          var L = h.payload;
          if (typeof L == "function") {
            C$();
            var F = L.call(A, g, w);
            {
              if (i.mode & dr) {
                Vo(!0);
                try {
                  L.call(A, g, w);
                } finally {
                  Vo(!1);
                }
              }
              w$();
            }
            return F;
          }
          return L;
        }
        case kE:
          i.flags = i.flags & ~Ci | $n;
        case E$: {
          var V = h.payload, J;
          if (typeof V == "function") {
            C$(), J = V.call(A, g, w);
            {
              if (i.mode & dr) {
                Vo(!0);
                try {
                  V.call(A, g, w);
                } finally {
                  Vo(!1);
                }
              }
              w$();
            }
          } else
            J = V;
          return J == null ? g : Vn({}, g, J);
        }
        case mw:
          return vw = !0, g;
      }
      return g;
    }
    function bw(i, l, h, g) {
      var w = i.updateQueue;
      vw = !1, gw = w.shared;
      var A = w.firstBaseUpdate, L = w.lastBaseUpdate, F = w.shared.pending;
      if (F !== null) {
        w.shared.pending = null;
        var V = F, J = V.next;
        V.next = null, L === null ? A = J : L.next = J, L = V;
        var ae = i.alternate;
        if (ae !== null) {
          var Me = ae.updateQueue, Te = Me.lastBaseUpdate;
          Te !== L && (Te === null ? Me.firstBaseUpdate = J : Te.next = J, Me.lastBaseUpdate = V);
        }
      }
      if (A !== null) {
        var Ye = w.baseState, Ke = dt, rt = null, Ft = null, gn = null, un = A;
        do {
          var Nr = un.lane, yr = un.eventTime;
          if (op(g, Nr)) {
            if (gn !== null) {
              var at = {
                eventTime: yr,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Uo,
                tag: un.tag,
                payload: un.payload,
                callback: un.callback,
                next: null
              };
              gn = gn.next = at;
            }
            Ye = dpe(i, w, un, Ye, l, h);
            var Ue = un.callback;
            if (Ue !== null && // If the update was already committed, we should not queue its
            // callback again.
            un.lane !== Uo) {
              i.flags |= Yu;
              var Ct = w.effects;
              Ct === null ? w.effects = [un] : Ct.push(un);
            }
          } else {
            var Ve = {
              eventTime: yr,
              lane: Nr,
              tag: un.tag,
              payload: un.payload,
              callback: un.callback,
              next: null
            };
            gn === null ? (Ft = gn = Ve, rt = Ye) : gn = gn.next = Ve, Ke = Wn(Ke, Nr);
          }
          if (un = un.next, un === null) {
            if (F = w.shared.pending, F === null)
              break;
            var Ht = F, Bt = Ht.next;
            Ht.next = null, un = Bt, w.lastBaseUpdate = Ht, w.shared.pending = null;
          }
        } while (!0);
        gn === null && (rt = Ye), w.baseState = rt, w.firstBaseUpdate = Ft, w.lastBaseUpdate = gn;
        var Tn = w.shared.interleaved;
        if (Tn !== null) {
          var Un = Tn;
          do
            Ke = Wn(Ke, Un.lane), Un = Un.next;
          while (Un !== Tn);
        } else A === null && (w.shared.lanes = dt);
        z3(Ke), i.lanes = Ke, i.memoizedState = Ye;
      }
      gw = null;
    }
    function fpe(i, l) {
      if (typeof i != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + i));
      i.call(l);
    }
    function A$() {
      vw = !1;
    }
    function _w() {
      return vw;
    }
    function P$(i, l, h) {
      var g = l.effects;
      if (l.effects = null, g !== null)
        for (var w = 0; w < g.length; w++) {
          var A = g[w], L = A.callback;
          L !== null && (A.callback = null, fpe(L, h));
        }
    }
    var y3 = {}, Qh = Yh(y3), b3 = Yh(y3), Cw = Yh(y3);
    function ww(i) {
      if (i === y3)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return i;
    }
    function N$() {
      var i = ww(Cw.current);
      return i;
    }
    function TE(i, l) {
      nl(Cw, l, i), nl(b3, i, i), nl(Qh, y3, i);
      var h = Pde(l);
      tl(Qh, i), nl(Qh, h, i);
    }
    function zg(i) {
      tl(Qh, i), tl(b3, i), tl(Cw, i);
    }
    function OE() {
      var i = ww(Qh.current);
      return i;
    }
    function T$(i) {
      ww(Cw.current);
      var l = ww(Qh.current), h = Nde(l, i.type);
      l !== h && (nl(b3, i, i), nl(Qh, h, i));
    }
    function RE(i) {
      b3.current === i && (tl(Qh, i), tl(b3, i));
    }
    var ppe = 0, O$ = 1, R$ = 1, _3 = 2, Qc = Yh(ppe);
    function ME(i, l) {
      return (i & l) !== 0;
    }
    function Hg(i) {
      return i & O$;
    }
    function DE(i, l) {
      return i & O$ | l;
    }
    function hpe(i, l) {
      return i | l;
    }
    function em(i, l) {
      nl(Qc, l, i);
    }
    function Wg(i) {
      tl(Qc, i);
    }
    function mpe(i, l) {
      var h = i.memoizedState;
      return h !== null ? h.dehydrated !== null : (i.memoizedProps, !0);
    }
    function Sw(i) {
      for (var l = i; l !== null; ) {
        if (l.tag === $) {
          var h = l.memoizedState;
          if (h !== null) {
            var g = h.dehydrated;
            if (g === null || KL(g) || Q9(g))
              return l;
          }
        } else if (l.tag === pe && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        l.memoizedProps.revealOrder !== void 0) {
          var w = (l.flags & $n) !== hn;
          if (w)
            return l;
        } else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === i)
          return null;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === i)
            return null;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
      return null;
    }
    var eu = (
      /*   */
      0
    ), ji = (
      /* */
      1
    ), af = (
      /*  */
      2
    ), Fi = (
      /*    */
      4
    ), As = (
      /*   */
      8
    ), LE = [];
    function $E() {
      for (var i = 0; i < LE.length; i++) {
        var l = LE[i];
        l._workInProgressVersionPrimary = null;
      }
      LE.length = 0;
    }
    function vpe(i, l) {
      var h = l._getVersion, g = h(l._source);
      i.mutableSourceEagerHydrationData == null ? i.mutableSourceEagerHydrationData = [l, g] : i.mutableSourceEagerHydrationData.push(l, g);
    }
    var Gt = n.ReactCurrentDispatcher, C3 = n.ReactCurrentBatchConfig, jE, Zg;
    jE = /* @__PURE__ */ new Set();
    var t0 = dt, ma = null, Bi = null, Vi = null, xw = !1, w3 = !1, S3 = 0, gpe = 0, ype = 25, lt = null, rc = null, tm = -1, FE = !1;
    function na() {
      {
        var i = lt;
        rc === null ? rc = [i] : rc.push(i);
      }
    }
    function Lt() {
      {
        var i = lt;
        rc !== null && (tm++, rc[tm] !== i && bpe(i));
      }
    }
    function Yg(i) {
      i != null && !bi(i) && s("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", lt, typeof i);
    }
    function bpe(i) {
      {
        var l = In(ma);
        if (!jE.has(l) && (jE.add(l), rc !== null)) {
          for (var h = "", g = 30, w = 0; w <= tm; w++) {
            for (var A = rc[w], L = w === tm ? i : A, F = w + 1 + ". " + A; F.length < g; )
              F += " ";
            F += L + `
`, h += F;
          }
          s(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, l, h);
        }
      }
    }
    function rl() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function BE(i, l) {
      if (FE)
        return !1;
      if (l === null)
        return s("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", lt), !1;
      i.length !== l.length && s(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, lt, "[" + l.join(", ") + "]", "[" + i.join(", ") + "]");
      for (var h = 0; h < l.length && h < i.length; h++)
        if (!Qt(i[h], l[h]))
          return !1;
      return !0;
    }
    function Xg(i, l, h, g, w, A) {
      t0 = A, ma = l, rc = i !== null ? i._debugHookTypes : null, tm = -1, FE = i !== null && i.type !== l.type, l.memoizedState = null, l.updateQueue = null, l.lanes = dt, i !== null && i.memoizedState !== null ? Gt.current = tj : rc !== null ? Gt.current = ej : Gt.current = Q$;
      var L = h(g, w);
      if (w3) {
        var F = 0;
        do {
          if (w3 = !1, S3 = 0, F >= ype)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          F += 1, FE = !1, Bi = null, Vi = null, l.updateQueue = null, tm = -1, Gt.current = nj, L = h(g, w);
        } while (w3);
      }
      Gt.current = $w, l._debugHookTypes = rc;
      var V = Bi !== null && Bi.next !== null;
      if (t0 = dt, ma = null, Bi = null, Vi = null, lt = null, rc = null, tm = -1, i !== null && (i.flags & Di) !== (l.flags & Di) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (i.mode & ln) !== an && s("Internal React error: Expected static flag was missing. Please notify the React team."), xw = !1, V)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return L;
    }
    function Kg() {
      var i = S3 !== 0;
      return S3 = 0, i;
    }
    function M$(i, l, h) {
      l.updateQueue = i.updateQueue, (l.mode & Cl) !== an ? l.flags &= ~(Kf | Zs | Ga | Yn) : l.flags &= ~(Ga | Yn), i.lanes = Ov(i.lanes, h);
    }
    function D$() {
      if (Gt.current = $w, xw) {
        for (var i = ma.memoizedState; i !== null; ) {
          var l = i.queue;
          l !== null && (l.pending = null), i = i.next;
        }
        xw = !1;
      }
      t0 = dt, ma = null, Bi = null, Vi = null, rc = null, tm = -1, lt = null, Y$ = !1, w3 = !1, S3 = 0;
    }
    function of() {
      var i = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Vi === null ? ma.memoizedState = Vi = i : Vi = Vi.next = i, Vi;
    }
    function ac() {
      var i;
      if (Bi === null) {
        var l = ma.alternate;
        l !== null ? i = l.memoizedState : i = null;
      } else
        i = Bi.next;
      var h;
      if (Vi === null ? h = ma.memoizedState : h = Vi.next, h !== null)
        Vi = h, h = Vi.next, Bi = i;
      else {
        if (i === null)
          throw new Error("Rendered more hooks than during the previous render.");
        Bi = i;
        var g = {
          memoizedState: Bi.memoizedState,
          baseState: Bi.baseState,
          baseQueue: Bi.baseQueue,
          queue: Bi.queue,
          next: null
        };
        Vi === null ? ma.memoizedState = Vi = g : Vi = Vi.next = g;
      }
      return Vi;
    }
    function L$() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function VE(i, l) {
      return typeof l == "function" ? l(i) : l;
    }
    function UE(i, l, h) {
      var g = of(), w;
      h !== void 0 ? w = h(l) : w = l, g.memoizedState = g.baseState = w;
      var A = {
        pending: null,
        interleaved: null,
        lanes: dt,
        dispatch: null,
        lastRenderedReducer: i,
        lastRenderedState: w
      };
      g.queue = A;
      var L = A.dispatch = Spe.bind(null, ma, A);
      return [g.memoizedState, L];
    }
    function GE(i, l, h) {
      var g = ac(), w = g.queue;
      if (w === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      w.lastRenderedReducer = i;
      var A = Bi, L = A.baseQueue, F = w.pending;
      if (F !== null) {
        if (L !== null) {
          var V = L.next, J = F.next;
          L.next = J, F.next = V;
        }
        A.baseQueue !== L && s("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), A.baseQueue = L = F, w.pending = null;
      }
      if (L !== null) {
        var ae = L.next, Me = A.baseState, Te = null, Ye = null, Ke = null, rt = ae;
        do {
          var Ft = rt.lane;
          if (op(t0, Ft)) {
            if (Ke !== null) {
              var un = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Uo,
                action: rt.action,
                hasEagerState: rt.hasEagerState,
                eagerState: rt.eagerState,
                next: null
              };
              Ke = Ke.next = un;
            }
            if (rt.hasEagerState)
              Me = rt.eagerState;
            else {
              var Nr = rt.action;
              Me = i(Me, Nr);
            }
          } else {
            var gn = {
              lane: Ft,
              action: rt.action,
              hasEagerState: rt.hasEagerState,
              eagerState: rt.eagerState,
              next: null
            };
            Ke === null ? (Ye = Ke = gn, Te = Me) : Ke = Ke.next = gn, ma.lanes = Wn(ma.lanes, Ft), z3(Ft);
          }
          rt = rt.next;
        } while (rt !== null && rt !== ae);
        Ke === null ? Te = Me : Ke.next = Ye, Qt(Me, g.memoizedState) || O3(), g.memoizedState = Me, g.baseState = Te, g.baseQueue = Ke, w.lastRenderedState = Me;
      }
      var yr = w.interleaved;
      if (yr !== null) {
        var Ve = yr;
        do {
          var at = Ve.lane;
          ma.lanes = Wn(ma.lanes, at), z3(at), Ve = Ve.next;
        } while (Ve !== yr);
      } else L === null && (w.lanes = dt);
      var Ue = w.dispatch;
      return [g.memoizedState, Ue];
    }
    function zE(i, l, h) {
      var g = ac(), w = g.queue;
      if (w === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      w.lastRenderedReducer = i;
      var A = w.dispatch, L = w.pending, F = g.memoizedState;
      if (L !== null) {
        w.pending = null;
        var V = L.next, J = V;
        do {
          var ae = J.action;
          F = i(F, ae), J = J.next;
        } while (J !== V);
        Qt(F, g.memoizedState) || O3(), g.memoizedState = F, g.baseQueue === null && (g.baseState = F), w.lastRenderedState = F;
      }
      return [F, A];
    }
    function ght(i, l, h) {
    }
    function yht(i, l, h) {
    }
    function HE(i, l, h) {
      var g = ma, w = of(), A, L = ks();
      if (L) {
        if (h === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        A = h(), Zg || A !== h() && (s("The result of getServerSnapshot should be cached to avoid an infinite loop"), Zg = !0);
      } else {
        if (A = l(), !Zg) {
          var F = l();
          Qt(A, F) || (s("The result of getSnapshot should be cached to avoid an infinite loop"), Zg = !0);
        }
        var V = nS();
        if (V === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Tv(V, t0) || $$(g, l, A);
      }
      w.memoizedState = A;
      var J = {
        value: A,
        getSnapshot: l
      };
      return w.queue = J, Pw(F$.bind(null, g, J, i), [i]), g.flags |= Ga, x3(ji | As, j$.bind(null, g, J, A, l), void 0, null), A;
    }
    function Ew(i, l, h) {
      var g = ma, w = ac(), A = l();
      if (!Zg) {
        var L = l();
        Qt(A, L) || (s("The result of getSnapshot should be cached to avoid an infinite loop"), Zg = !0);
      }
      var F = w.memoizedState, V = !Qt(F, A);
      V && (w.memoizedState = A, O3());
      var J = w.queue;
      if (I3(F$.bind(null, g, J, i), [i]), J.getSnapshot !== l || V || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Vi !== null && Vi.memoizedState.tag & ji) {
        g.flags |= Ga, x3(ji | As, j$.bind(null, g, J, A, l), void 0, null);
        var ae = nS();
        if (ae === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Tv(ae, t0) || $$(g, l, A);
      }
      return A;
    }
    function $$(i, l, h) {
      i.flags |= Cv;
      var g = {
        getSnapshot: l,
        value: h
      }, w = ma.updateQueue;
      if (w === null)
        w = L$(), ma.updateQueue = w, w.stores = [g];
      else {
        var A = w.stores;
        A === null ? w.stores = [g] : A.push(g);
      }
    }
    function j$(i, l, h, g) {
      l.value = h, l.getSnapshot = g, B$(l) && V$(i);
    }
    function F$(i, l, h) {
      var g = function() {
        B$(l) && V$(i);
      };
      return h(g);
    }
    function B$(i) {
      var l = i.getSnapshot, h = i.value;
      try {
        var g = l();
        return !Qt(h, g);
      } catch (w) {
        return !0;
      }
    }
    function V$(i) {
      var l = Ql(i, cn);
      l !== null && Hi(l, i, cn, Na);
    }
    function Iw(i) {
      var l = of();
      typeof i == "function" && (i = i()), l.memoizedState = l.baseState = i;
      var h = {
        pending: null,
        interleaved: null,
        lanes: dt,
        dispatch: null,
        lastRenderedReducer: VE,
        lastRenderedState: i
      };
      l.queue = h;
      var g = h.dispatch = xpe.bind(null, ma, h);
      return [l.memoizedState, g];
    }
    function WE(i) {
      return GE(VE);
    }
    function ZE(i) {
      return zE(VE);
    }
    function x3(i, l, h, g) {
      var w = {
        tag: i,
        create: l,
        destroy: h,
        deps: g,
        // Circular
        next: null
      }, A = ma.updateQueue;
      if (A === null)
        A = L$(), ma.updateQueue = A, A.lastEffect = w.next = w;
      else {
        var L = A.lastEffect;
        if (L === null)
          A.lastEffect = w.next = w;
        else {
          var F = L.next;
          L.next = w, w.next = F, A.lastEffect = w;
        }
      }
      return w;
    }
    function YE(i) {
      var l = of();
      {
        var h = {
          current: i
        };
        return l.memoizedState = h, h;
      }
    }
    function kw(i) {
      var l = ac();
      return l.memoizedState;
    }
    function E3(i, l, h, g) {
      var w = of(), A = g === void 0 ? null : g;
      ma.flags |= i, w.memoizedState = x3(ji | l, h, void 0, A);
    }
    function Aw(i, l, h, g) {
      var w = ac(), A = g === void 0 ? null : g, L = void 0;
      if (Bi !== null) {
        var F = Bi.memoizedState;
        if (L = F.destroy, A !== null) {
          var V = F.deps;
          if (BE(A, V)) {
            w.memoizedState = x3(l, h, L, A);
            return;
          }
        }
      }
      ma.flags |= i, w.memoizedState = x3(ji | l, h, L, A);
    }
    function Pw(i, l) {
      return (ma.mode & Cl) !== an ? E3(Kf | Ga | Wd, As, i, l) : E3(Ga | Wd, As, i, l);
    }
    function I3(i, l) {
      return Aw(Ga, As, i, l);
    }
    function XE(i, l) {
      return E3(Yn, af, i, l);
    }
    function Nw(i, l) {
      return Aw(Yn, af, i, l);
    }
    function KE(i, l) {
      var h = Yn;
      return h |= Ws, (ma.mode & Cl) !== an && (h |= Zs), E3(h, Fi, i, l);
    }
    function Tw(i, l) {
      return Aw(Yn, Fi, i, l);
    }
    function U$(i, l) {
      if (typeof l == "function") {
        var h = l, g = i();
        return h(g), function() {
          h(null);
        };
      } else if (l != null) {
        var w = l;
        w.hasOwnProperty("current") || s("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(w).join(", ") + "}");
        var A = i();
        return w.current = A, function() {
          w.current = null;
        };
      }
    }
    function qE(i, l, h) {
      typeof l != "function" && s("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", l !== null ? typeof l : "null");
      var g = h != null ? h.concat([i]) : null, w = Yn;
      return w |= Ws, (ma.mode & Cl) !== an && (w |= Zs), E3(w, Fi, U$.bind(null, l, i), g);
    }
    function Ow(i, l, h) {
      typeof l != "function" && s("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", l !== null ? typeof l : "null");
      var g = h != null ? h.concat([i]) : null;
      return Aw(Yn, Fi, U$.bind(null, l, i), g);
    }
    function _pe(i, l) {
    }
    var Rw = _pe;
    function JE(i, l) {
      var h = of(), g = l === void 0 ? null : l;
      return h.memoizedState = [i, g], i;
    }
    function Mw(i, l) {
      var h = ac(), g = l === void 0 ? null : l, w = h.memoizedState;
      if (w !== null && g !== null) {
        var A = w[1];
        if (BE(g, A))
          return w[0];
      }
      return h.memoizedState = [i, g], i;
    }
    function QE(i, l) {
      var h = of(), g = l === void 0 ? null : l, w = i();
      return h.memoizedState = [w, g], w;
    }
    function Dw(i, l) {
      var h = ac(), g = l === void 0 ? null : l, w = h.memoizedState;
      if (w !== null && g !== null) {
        var A = w[1];
        if (BE(g, A))
          return w[0];
      }
      var L = i();
      return h.memoizedState = [L, g], L;
    }
    function eI(i) {
      var l = of();
      return l.memoizedState = i, i;
    }
    function G$(i) {
      var l = ac(), h = Bi, g = h.memoizedState;
      return H$(l, g, i);
    }
    function z$(i) {
      var l = ac();
      if (Bi === null)
        return l.memoizedState = i, i;
      var h = Bi.memoizedState;
      return H$(l, h, i);
    }
    function H$(i, l, h) {
      var g = !d5(t0);
      if (g) {
        if (!Qt(h, l)) {
          var w = h5();
          ma.lanes = Wn(ma.lanes, w), z3(w), i.baseState = !0;
        }
        return l;
      } else
        return i.baseState && (i.baseState = !1, O3()), i.memoizedState = h, h;
    }
    function Cpe(i, l, h) {
      var g = Zl();
      co(_9(g, Wc)), i(!0);
      var w = C3.transition;
      C3.transition = {};
      var A = C3.transition;
      C3.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        i(!1), l();
      } finally {
        if (co(g), C3.transition = w, w === null && A._updatedFibers) {
          var L = A._updatedFibers.size;
          L > 10 && o("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), A._updatedFibers.clear();
        }
      }
    }
    function tI() {
      var i = Iw(!1), l = i[0], h = i[1], g = Cpe.bind(null, h), w = of();
      return w.memoizedState = g, [l, g];
    }
    function W$() {
      var i = WE(), l = i[0], h = ac(), g = h.memoizedState;
      return [l, g];
    }
    function Z$() {
      var i = ZE(), l = i[0], h = ac(), g = h.memoizedState;
      return [l, g];
    }
    var Y$ = !1;
    function wpe() {
      return Y$;
    }
    function nI() {
      var i = of(), l = nS(), h = l.identifierPrefix, g;
      if (ks()) {
        var w = Ffe();
        g = ":" + h + "R" + w;
        var A = S3++;
        A > 0 && (g += "H" + A.toString(32)), g += ":";
      } else {
        var L = gpe++;
        g = ":" + h + "r" + L.toString(32) + ":";
      }
      return i.memoizedState = g, g;
    }
    function Lw() {
      var i = ac(), l = i.memoizedState;
      return l;
    }
    function Spe(i, l, h) {
      typeof arguments[3] == "function" && s("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var g = im(i), w = {
        lane: g,
        action: h,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (X$(i))
        K$(l, w);
      else {
        var A = x$(i, l, w, g);
        if (A !== null) {
          var L = El();
          Hi(A, i, g, L), q$(A, l, g);
        }
      }
      J$(i, g);
    }
    function xpe(i, l, h) {
      typeof arguments[3] == "function" && s("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var g = im(i), w = {
        lane: g,
        action: h,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (X$(i))
        K$(l, w);
      else {
        var A = i.alternate;
        if (i.lanes === dt && (A === null || A.lanes === dt)) {
          var L = l.lastRenderedReducer;
          if (L !== null) {
            var F;
            F = Gt.current, Gt.current = ed;
            try {
              var V = l.lastRenderedState, J = L(V, h);
              if (w.hasEagerState = !0, w.eagerState = J, Qt(J, V)) {
                lpe(i, l, w, g);
                return;
              }
            } catch (Te) {
            } finally {
              Gt.current = F;
            }
          }
        }
        var ae = x$(i, l, w, g);
        if (ae !== null) {
          var Me = El();
          Hi(ae, i, g, Me), q$(ae, l, g);
        }
      }
      J$(i, g);
    }
    function X$(i) {
      var l = i.alternate;
      return i === ma || l !== null && l === ma;
    }
    function K$(i, l) {
      w3 = xw = !0;
      var h = i.pending;
      h === null ? l.next = l : (l.next = h.next, h.next = l), i.pending = l;
    }
    function q$(i, l, h) {
      if (Ob(h)) {
        var g = l.lanes;
        g = ig(g, i.pendingLanes);
        var w = Wn(g, h);
        l.lanes = w, Rb(i, w);
      }
    }
    function J$(i, l, h) {
      Ev(i, l);
    }
    var $w = {
      readContext: Ei,
      useCallback: rl,
      useContext: rl,
      useEffect: rl,
      useImperativeHandle: rl,
      useInsertionEffect: rl,
      useLayoutEffect: rl,
      useMemo: rl,
      useReducer: rl,
      useRef: rl,
      useState: rl,
      useDebugValue: rl,
      useDeferredValue: rl,
      useTransition: rl,
      useMutableSource: rl,
      useSyncExternalStore: rl,
      useId: rl,
      unstable_isNewReconciler: me
    }, Q$ = null, ej = null, tj = null, nj = null, sf = null, ed = null, jw = null;
    {
      var rI = function() {
        s("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Bn = function() {
        s("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      Q$ = {
        readContext: function(i) {
          return Ei(i);
        },
        useCallback: function(i, l) {
          return lt = "useCallback", na(), Yg(l), JE(i, l);
        },
        useContext: function(i) {
          return lt = "useContext", na(), Ei(i);
        },
        useEffect: function(i, l) {
          return lt = "useEffect", na(), Yg(l), Pw(i, l);
        },
        useImperativeHandle: function(i, l, h) {
          return lt = "useImperativeHandle", na(), Yg(h), qE(i, l, h);
        },
        useInsertionEffect: function(i, l) {
          return lt = "useInsertionEffect", na(), Yg(l), XE(i, l);
        },
        useLayoutEffect: function(i, l) {
          return lt = "useLayoutEffect", na(), Yg(l), KE(i, l);
        },
        useMemo: function(i, l) {
          lt = "useMemo", na(), Yg(l);
          var h = Gt.current;
          Gt.current = sf;
          try {
            return QE(i, l);
          } finally {
            Gt.current = h;
          }
        },
        useReducer: function(i, l, h) {
          lt = "useReducer", na();
          var g = Gt.current;
          Gt.current = sf;
          try {
            return UE(i, l, h);
          } finally {
            Gt.current = g;
          }
        },
        useRef: function(i) {
          return lt = "useRef", na(), YE(i);
        },
        useState: function(i) {
          lt = "useState", na();
          var l = Gt.current;
          Gt.current = sf;
          try {
            return Iw(i);
          } finally {
            Gt.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return lt = "useDebugValue", na(), void 0;
        },
        useDeferredValue: function(i) {
          return lt = "useDeferredValue", na(), eI(i);
        },
        useTransition: function() {
          return lt = "useTransition", na(), tI();
        },
        useMutableSource: function(i, l, h) {
          return lt = "useMutableSource", na(), void 0;
        },
        useSyncExternalStore: function(i, l, h) {
          return lt = "useSyncExternalStore", na(), HE(i, l, h);
        },
        useId: function() {
          return lt = "useId", na(), nI();
        },
        unstable_isNewReconciler: me
      }, ej = {
        readContext: function(i) {
          return Ei(i);
        },
        useCallback: function(i, l) {
          return lt = "useCallback", Lt(), JE(i, l);
        },
        useContext: function(i) {
          return lt = "useContext", Lt(), Ei(i);
        },
        useEffect: function(i, l) {
          return lt = "useEffect", Lt(), Pw(i, l);
        },
        useImperativeHandle: function(i, l, h) {
          return lt = "useImperativeHandle", Lt(), qE(i, l, h);
        },
        useInsertionEffect: function(i, l) {
          return lt = "useInsertionEffect", Lt(), XE(i, l);
        },
        useLayoutEffect: function(i, l) {
          return lt = "useLayoutEffect", Lt(), KE(i, l);
        },
        useMemo: function(i, l) {
          lt = "useMemo", Lt();
          var h = Gt.current;
          Gt.current = sf;
          try {
            return QE(i, l);
          } finally {
            Gt.current = h;
          }
        },
        useReducer: function(i, l, h) {
          lt = "useReducer", Lt();
          var g = Gt.current;
          Gt.current = sf;
          try {
            return UE(i, l, h);
          } finally {
            Gt.current = g;
          }
        },
        useRef: function(i) {
          return lt = "useRef", Lt(), YE(i);
        },
        useState: function(i) {
          lt = "useState", Lt();
          var l = Gt.current;
          Gt.current = sf;
          try {
            return Iw(i);
          } finally {
            Gt.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return lt = "useDebugValue", Lt(), void 0;
        },
        useDeferredValue: function(i) {
          return lt = "useDeferredValue", Lt(), eI(i);
        },
        useTransition: function() {
          return lt = "useTransition", Lt(), tI();
        },
        useMutableSource: function(i, l, h) {
          return lt = "useMutableSource", Lt(), void 0;
        },
        useSyncExternalStore: function(i, l, h) {
          return lt = "useSyncExternalStore", Lt(), HE(i, l, h);
        },
        useId: function() {
          return lt = "useId", Lt(), nI();
        },
        unstable_isNewReconciler: me
      }, tj = {
        readContext: function(i) {
          return Ei(i);
        },
        useCallback: function(i, l) {
          return lt = "useCallback", Lt(), Mw(i, l);
        },
        useContext: function(i) {
          return lt = "useContext", Lt(), Ei(i);
        },
        useEffect: function(i, l) {
          return lt = "useEffect", Lt(), I3(i, l);
        },
        useImperativeHandle: function(i, l, h) {
          return lt = "useImperativeHandle", Lt(), Ow(i, l, h);
        },
        useInsertionEffect: function(i, l) {
          return lt = "useInsertionEffect", Lt(), Nw(i, l);
        },
        useLayoutEffect: function(i, l) {
          return lt = "useLayoutEffect", Lt(), Tw(i, l);
        },
        useMemo: function(i, l) {
          lt = "useMemo", Lt();
          var h = Gt.current;
          Gt.current = ed;
          try {
            return Dw(i, l);
          } finally {
            Gt.current = h;
          }
        },
        useReducer: function(i, l, h) {
          lt = "useReducer", Lt();
          var g = Gt.current;
          Gt.current = ed;
          try {
            return GE(i, l, h);
          } finally {
            Gt.current = g;
          }
        },
        useRef: function(i) {
          return lt = "useRef", Lt(), kw();
        },
        useState: function(i) {
          lt = "useState", Lt();
          var l = Gt.current;
          Gt.current = ed;
          try {
            return WE(i);
          } finally {
            Gt.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return lt = "useDebugValue", Lt(), Rw();
        },
        useDeferredValue: function(i) {
          return lt = "useDeferredValue", Lt(), G$(i);
        },
        useTransition: function() {
          return lt = "useTransition", Lt(), W$();
        },
        useMutableSource: function(i, l, h) {
          return lt = "useMutableSource", Lt(), void 0;
        },
        useSyncExternalStore: function(i, l, h) {
          return lt = "useSyncExternalStore", Lt(), Ew(i, l);
        },
        useId: function() {
          return lt = "useId", Lt(), Lw();
        },
        unstable_isNewReconciler: me
      }, nj = {
        readContext: function(i) {
          return Ei(i);
        },
        useCallback: function(i, l) {
          return lt = "useCallback", Lt(), Mw(i, l);
        },
        useContext: function(i) {
          return lt = "useContext", Lt(), Ei(i);
        },
        useEffect: function(i, l) {
          return lt = "useEffect", Lt(), I3(i, l);
        },
        useImperativeHandle: function(i, l, h) {
          return lt = "useImperativeHandle", Lt(), Ow(i, l, h);
        },
        useInsertionEffect: function(i, l) {
          return lt = "useInsertionEffect", Lt(), Nw(i, l);
        },
        useLayoutEffect: function(i, l) {
          return lt = "useLayoutEffect", Lt(), Tw(i, l);
        },
        useMemo: function(i, l) {
          lt = "useMemo", Lt();
          var h = Gt.current;
          Gt.current = jw;
          try {
            return Dw(i, l);
          } finally {
            Gt.current = h;
          }
        },
        useReducer: function(i, l, h) {
          lt = "useReducer", Lt();
          var g = Gt.current;
          Gt.current = jw;
          try {
            return zE(i, l, h);
          } finally {
            Gt.current = g;
          }
        },
        useRef: function(i) {
          return lt = "useRef", Lt(), kw();
        },
        useState: function(i) {
          lt = "useState", Lt();
          var l = Gt.current;
          Gt.current = jw;
          try {
            return ZE(i);
          } finally {
            Gt.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return lt = "useDebugValue", Lt(), Rw();
        },
        useDeferredValue: function(i) {
          return lt = "useDeferredValue", Lt(), z$(i);
        },
        useTransition: function() {
          return lt = "useTransition", Lt(), Z$();
        },
        useMutableSource: function(i, l, h) {
          return lt = "useMutableSource", Lt(), void 0;
        },
        useSyncExternalStore: function(i, l, h) {
          return lt = "useSyncExternalStore", Lt(), Ew(i, l);
        },
        useId: function() {
          return lt = "useId", Lt(), Lw();
        },
        unstable_isNewReconciler: me
      }, sf = {
        readContext: function(i) {
          return rI(), Ei(i);
        },
        useCallback: function(i, l) {
          return lt = "useCallback", Bn(), na(), JE(i, l);
        },
        useContext: function(i) {
          return lt = "useContext", Bn(), na(), Ei(i);
        },
        useEffect: function(i, l) {
          return lt = "useEffect", Bn(), na(), Pw(i, l);
        },
        useImperativeHandle: function(i, l, h) {
          return lt = "useImperativeHandle", Bn(), na(), qE(i, l, h);
        },
        useInsertionEffect: function(i, l) {
          return lt = "useInsertionEffect", Bn(), na(), XE(i, l);
        },
        useLayoutEffect: function(i, l) {
          return lt = "useLayoutEffect", Bn(), na(), KE(i, l);
        },
        useMemo: function(i, l) {
          lt = "useMemo", Bn(), na();
          var h = Gt.current;
          Gt.current = sf;
          try {
            return QE(i, l);
          } finally {
            Gt.current = h;
          }
        },
        useReducer: function(i, l, h) {
          lt = "useReducer", Bn(), na();
          var g = Gt.current;
          Gt.current = sf;
          try {
            return UE(i, l, h);
          } finally {
            Gt.current = g;
          }
        },
        useRef: function(i) {
          return lt = "useRef", Bn(), na(), YE(i);
        },
        useState: function(i) {
          lt = "useState", Bn(), na();
          var l = Gt.current;
          Gt.current = sf;
          try {
            return Iw(i);
          } finally {
            Gt.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return lt = "useDebugValue", Bn(), na(), void 0;
        },
        useDeferredValue: function(i) {
          return lt = "useDeferredValue", Bn(), na(), eI(i);
        },
        useTransition: function() {
          return lt = "useTransition", Bn(), na(), tI();
        },
        useMutableSource: function(i, l, h) {
          return lt = "useMutableSource", Bn(), na(), void 0;
        },
        useSyncExternalStore: function(i, l, h) {
          return lt = "useSyncExternalStore", Bn(), na(), HE(i, l, h);
        },
        useId: function() {
          return lt = "useId", Bn(), na(), nI();
        },
        unstable_isNewReconciler: me
      }, ed = {
        readContext: function(i) {
          return rI(), Ei(i);
        },
        useCallback: function(i, l) {
          return lt = "useCallback", Bn(), Lt(), Mw(i, l);
        },
        useContext: function(i) {
          return lt = "useContext", Bn(), Lt(), Ei(i);
        },
        useEffect: function(i, l) {
          return lt = "useEffect", Bn(), Lt(), I3(i, l);
        },
        useImperativeHandle: function(i, l, h) {
          return lt = "useImperativeHandle", Bn(), Lt(), Ow(i, l, h);
        },
        useInsertionEffect: function(i, l) {
          return lt = "useInsertionEffect", Bn(), Lt(), Nw(i, l);
        },
        useLayoutEffect: function(i, l) {
          return lt = "useLayoutEffect", Bn(), Lt(), Tw(i, l);
        },
        useMemo: function(i, l) {
          lt = "useMemo", Bn(), Lt();
          var h = Gt.current;
          Gt.current = ed;
          try {
            return Dw(i, l);
          } finally {
            Gt.current = h;
          }
        },
        useReducer: function(i, l, h) {
          lt = "useReducer", Bn(), Lt();
          var g = Gt.current;
          Gt.current = ed;
          try {
            return GE(i, l, h);
          } finally {
            Gt.current = g;
          }
        },
        useRef: function(i) {
          return lt = "useRef", Bn(), Lt(), kw();
        },
        useState: function(i) {
          lt = "useState", Bn(), Lt();
          var l = Gt.current;
          Gt.current = ed;
          try {
            return WE(i);
          } finally {
            Gt.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return lt = "useDebugValue", Bn(), Lt(), Rw();
        },
        useDeferredValue: function(i) {
          return lt = "useDeferredValue", Bn(), Lt(), G$(i);
        },
        useTransition: function() {
          return lt = "useTransition", Bn(), Lt(), W$();
        },
        useMutableSource: function(i, l, h) {
          return lt = "useMutableSource", Bn(), Lt(), void 0;
        },
        useSyncExternalStore: function(i, l, h) {
          return lt = "useSyncExternalStore", Bn(), Lt(), Ew(i, l);
        },
        useId: function() {
          return lt = "useId", Bn(), Lt(), Lw();
        },
        unstable_isNewReconciler: me
      }, jw = {
        readContext: function(i) {
          return rI(), Ei(i);
        },
        useCallback: function(i, l) {
          return lt = "useCallback", Bn(), Lt(), Mw(i, l);
        },
        useContext: function(i) {
          return lt = "useContext", Bn(), Lt(), Ei(i);
        },
        useEffect: function(i, l) {
          return lt = "useEffect", Bn(), Lt(), I3(i, l);
        },
        useImperativeHandle: function(i, l, h) {
          return lt = "useImperativeHandle", Bn(), Lt(), Ow(i, l, h);
        },
        useInsertionEffect: function(i, l) {
          return lt = "useInsertionEffect", Bn(), Lt(), Nw(i, l);
        },
        useLayoutEffect: function(i, l) {
          return lt = "useLayoutEffect", Bn(), Lt(), Tw(i, l);
        },
        useMemo: function(i, l) {
          lt = "useMemo", Bn(), Lt();
          var h = Gt.current;
          Gt.current = ed;
          try {
            return Dw(i, l);
          } finally {
            Gt.current = h;
          }
        },
        useReducer: function(i, l, h) {
          lt = "useReducer", Bn(), Lt();
          var g = Gt.current;
          Gt.current = ed;
          try {
            return zE(i, l, h);
          } finally {
            Gt.current = g;
          }
        },
        useRef: function(i) {
          return lt = "useRef", Bn(), Lt(), kw();
        },
        useState: function(i) {
          lt = "useState", Bn(), Lt();
          var l = Gt.current;
          Gt.current = ed;
          try {
            return ZE(i);
          } finally {
            Gt.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return lt = "useDebugValue", Bn(), Lt(), Rw();
        },
        useDeferredValue: function(i) {
          return lt = "useDeferredValue", Bn(), Lt(), z$(i);
        },
        useTransition: function() {
          return lt = "useTransition", Bn(), Lt(), Z$();
        },
        useMutableSource: function(i, l, h) {
          return lt = "useMutableSource", Bn(), Lt(), void 0;
        },
        useSyncExternalStore: function(i, l, h) {
          return lt = "useSyncExternalStore", Bn(), Lt(), Ew(i, l);
        },
        useId: function() {
          return lt = "useId", Bn(), Lt(), Lw();
        },
        unstable_isNewReconciler: me
      };
    }
    var nm = t.unstable_now, rj = 0, Fw = -1, k3 = -1, Bw = -1, aI = !1, Vw = !1;
    function aj() {
      return aI;
    }
    function Epe() {
      Vw = !0;
    }
    function Ipe() {
      aI = !1, Vw = !1;
    }
    function kpe() {
      aI = Vw, Vw = !1;
    }
    function oj() {
      return rj;
    }
    function ij() {
      rj = nm();
    }
    function oI(i) {
      k3 = nm(), i.actualStartTime < 0 && (i.actualStartTime = nm());
    }
    function sj(i) {
      k3 = -1;
    }
    function Uw(i, l) {
      if (k3 >= 0) {
        var h = nm() - k3;
        i.actualDuration += h, l && (i.selfBaseDuration = h), k3 = -1;
      }
    }
    function lf(i) {
      if (Fw >= 0) {
        var l = nm() - Fw;
        Fw = -1;
        for (var h = i.return; h !== null; ) {
          switch (h.tag) {
            case v:
              var g = h.stateNode;
              g.effectDuration += l;
              return;
            case D:
              var w = h.stateNode;
              w.effectDuration += l;
              return;
          }
          h = h.return;
        }
      }
    }
    function iI(i) {
      if (Bw >= 0) {
        var l = nm() - Bw;
        Bw = -1;
        for (var h = i.return; h !== null; ) {
          switch (h.tag) {
            case v:
              var g = h.stateNode;
              g !== null && (g.passiveEffectDuration += l);
              return;
            case D:
              var w = h.stateNode;
              w !== null && (w.passiveEffectDuration += l);
              return;
          }
          h = h.return;
        }
      }
    }
    function uf() {
      Fw = nm();
    }
    function sI() {
      Bw = nm();
    }
    function lI(i) {
      for (var l = i.child; l; )
        i.actualDuration += l.actualDuration, l = l.sibling;
    }
    function td(i, l) {
      if (i && i.defaultProps) {
        var h = Vn({}, l), g = i.defaultProps;
        for (var w in g)
          h[w] === void 0 && (h[w] = g[w]);
        return h;
      }
      return l;
    }
    var uI = {}, cI, dI, fI, pI, hI, lj, Gw, mI, vI, gI, A3;
    {
      cI = /* @__PURE__ */ new Set(), dI = /* @__PURE__ */ new Set(), fI = /* @__PURE__ */ new Set(), pI = /* @__PURE__ */ new Set(), mI = /* @__PURE__ */ new Set(), hI = /* @__PURE__ */ new Set(), vI = /* @__PURE__ */ new Set(), gI = /* @__PURE__ */ new Set(), A3 = /* @__PURE__ */ new Set();
      var uj = /* @__PURE__ */ new Set();
      Gw = function(i, l) {
        if (!(i === null || typeof i == "function")) {
          var h = l + "_" + i;
          uj.has(h) || (uj.add(h), s("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", l, i));
        }
      }, lj = function(i, l) {
        if (l === void 0) {
          var h = vr(i) || "Component";
          hI.has(h) || (hI.add(h), s("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", h));
        }
      }, Object.defineProperty(uI, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(uI);
    }
    function yI(i, l, h, g) {
      var w = i.memoizedState, A = h(g, w);
      {
        if (i.mode & dr) {
          Vo(!0);
          try {
            A = h(g, w);
          } finally {
            Vo(!1);
          }
        }
        lj(l, A);
      }
      var L = A == null ? w : Vn({}, w, A);
      if (i.memoizedState = L, i.lanes === dt) {
        var F = i.updateQueue;
        F.baseState = L;
      }
    }
    var bI = {
      isMounted: bl,
      enqueueSetState: function(i, l, h) {
        var g = Fl(i), w = El(), A = im(g), L = yp(w, A);
        L.payload = l, h != null && (Gw(h, "setState"), L.callback = h);
        var F = Jh(g, L, A);
        F !== null && (Hi(F, g, A, w), yw(F, g, A)), Ev(g, A);
      },
      enqueueReplaceState: function(i, l, h) {
        var g = Fl(i), w = El(), A = im(g), L = yp(w, A);
        L.tag = I$, L.payload = l, h != null && (Gw(h, "replaceState"), L.callback = h);
        var F = Jh(g, L, A);
        F !== null && (Hi(F, g, A, w), yw(F, g, A)), Ev(g, A);
      },
      enqueueForceUpdate: function(i, l) {
        var h = Fl(i), g = El(), w = im(h), A = yp(g, w);
        A.tag = mw, l != null && (Gw(l, "forceUpdate"), A.callback = l);
        var L = Jh(h, A, w);
        L !== null && (Hi(L, h, w, g), yw(L, h, w)), G1(h, w);
      }
    };
    function cj(i, l, h, g, w, A, L) {
      var F = i.stateNode;
      if (typeof F.shouldComponentUpdate == "function") {
        var V = F.shouldComponentUpdate(g, A, L);
        {
          if (i.mode & dr) {
            Vo(!0);
            try {
              V = F.shouldComponentUpdate(g, A, L);
            } finally {
              Vo(!1);
            }
          }
          V === void 0 && s("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", vr(l) || "Component");
        }
        return V;
      }
      return l.prototype && l.prototype.isPureReactComponent ? !wn(h, g) || !wn(w, A) : !0;
    }
    function Ape(i, l, h) {
      var g = i.stateNode;
      {
        var w = vr(l) || "Component", A = g.render;
        A || (l.prototype && typeof l.prototype.render == "function" ? s("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", w) : s("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", w)), g.getInitialState && !g.getInitialState.isReactClassApproved && !g.state && s("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", w), g.getDefaultProps && !g.getDefaultProps.isReactClassApproved && s("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", w), g.propTypes && s("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", w), g.contextType && s("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", w), l.childContextTypes && !A3.has(l) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (i.mode & dr) === an && (A3.add(l), s(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, w)), l.contextTypes && !A3.has(l) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (i.mode & dr) === an && (A3.add(l), s(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, w)), g.contextTypes && s("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", w), l.contextType && l.contextTypes && !vI.has(l) && (vI.add(l), s("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", w)), typeof g.componentShouldUpdate == "function" && s("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", w), l.prototype && l.prototype.isPureReactComponent && typeof g.shouldComponentUpdate != "undefined" && s("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", vr(l) || "A pure component"), typeof g.componentDidUnmount == "function" && s("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", w), typeof g.componentDidReceiveProps == "function" && s("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", w), typeof g.componentWillRecieveProps == "function" && s("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", w), typeof g.UNSAFE_componentWillRecieveProps == "function" && s("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", w);
        var L = g.props !== h;
        g.props !== void 0 && L && s("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", w, w), g.defaultProps && s("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", w, w), typeof g.getSnapshotBeforeUpdate == "function" && typeof g.componentDidUpdate != "function" && !fI.has(l) && (fI.add(l), s("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", vr(l))), typeof g.getDerivedStateFromProps == "function" && s("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", w), typeof g.getDerivedStateFromError == "function" && s("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", w), typeof l.getSnapshotBeforeUpdate == "function" && s("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", w);
        var F = g.state;
        F && (typeof F != "object" || bi(F)) && s("%s.state: must be set to an object or null", w), typeof g.getChildContext == "function" && typeof l.childContextTypes != "object" && s("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", w);
      }
    }
    function dj(i, l) {
      l.updater = bI, i.stateNode = l, mh(l, i), l._reactInternalInstance = uI;
    }
    function fj(i, l, h) {
      var g = !1, w = Iu, A = Iu, L = l.contextType;
      if ("contextType" in l) {
        var F = (
          // Allow null for conditional declaration
          L === null || L !== void 0 && L.$$typeof === pt && L._context === void 0
        );
        if (!F && !gI.has(l)) {
          gI.add(l);
          var V = "";
          L === void 0 ? V = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof L != "object" ? V = " However, it is set to a " + typeof L + "." : L.$$typeof === Ce ? V = " Did you accidentally pass the Context.Provider instead?" : L._context !== void 0 ? V = " Did you accidentally pass the Context.Consumer instead?" : V = " However, it is set to an object with keys {" + Object.keys(L).join(", ") + "}.", s("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", vr(l) || "Component", V);
        }
      }
      if (typeof L == "object" && L !== null)
        A = Ei(L);
      else {
        w = Lg(i, l, !0);
        var J = l.contextTypes;
        g = J != null, A = g ? $g(i, w) : Iu;
      }
      var ae = new l(h, A);
      if (i.mode & dr) {
        Vo(!0);
        try {
          ae = new l(h, A);
        } finally {
          Vo(!1);
        }
      }
      var Me = i.memoizedState = ae.state !== null && ae.state !== void 0 ? ae.state : null;
      dj(i, ae);
      {
        if (typeof l.getDerivedStateFromProps == "function" && Me === null) {
          var Te = vr(l) || "Component";
          dI.has(Te) || (dI.add(Te), s("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Te, ae.state === null ? "null" : "undefined", Te));
        }
        if (typeof l.getDerivedStateFromProps == "function" || typeof ae.getSnapshotBeforeUpdate == "function") {
          var Ye = null, Ke = null, rt = null;
          if (typeof ae.componentWillMount == "function" && ae.componentWillMount.__suppressDeprecationWarning !== !0 ? Ye = "componentWillMount" : typeof ae.UNSAFE_componentWillMount == "function" && (Ye = "UNSAFE_componentWillMount"), typeof ae.componentWillReceiveProps == "function" && ae.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Ke = "componentWillReceiveProps" : typeof ae.UNSAFE_componentWillReceiveProps == "function" && (Ke = "UNSAFE_componentWillReceiveProps"), typeof ae.componentWillUpdate == "function" && ae.componentWillUpdate.__suppressDeprecationWarning !== !0 ? rt = "componentWillUpdate" : typeof ae.UNSAFE_componentWillUpdate == "function" && (rt = "UNSAFE_componentWillUpdate"), Ye !== null || Ke !== null || rt !== null) {
            var Ft = vr(l) || "Component", gn = typeof l.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            pI.has(Ft) || (pI.add(Ft), s(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Ft, gn, Ye !== null ? `
  ` + Ye : "", Ke !== null ? `
  ` + Ke : "", rt !== null ? `
  ` + rt : ""));
          }
        }
      }
      return g && t$(i, w, A), ae;
    }
    function Ppe(i, l) {
      var h = l.state;
      typeof l.componentWillMount == "function" && l.componentWillMount(), typeof l.UNSAFE_componentWillMount == "function" && l.UNSAFE_componentWillMount(), h !== l.state && (s("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", In(i) || "Component"), bI.enqueueReplaceState(l, l.state, null));
    }
    function pj(i, l, h, g) {
      var w = l.state;
      if (typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(h, g), typeof l.UNSAFE_componentWillReceiveProps == "function" && l.UNSAFE_componentWillReceiveProps(h, g), l.state !== w) {
        {
          var A = In(i) || "Component";
          cI.has(A) || (cI.add(A), s("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", A));
        }
        bI.enqueueReplaceState(l, l.state, null);
      }
    }
    function _I(i, l, h, g) {
      Ape(i, l, h);
      var w = i.stateNode;
      w.props = h, w.state = i.memoizedState, w.refs = {}, PE(i);
      var A = l.contextType;
      if (typeof A == "object" && A !== null)
        w.context = Ei(A);
      else {
        var L = Lg(i, l, !0);
        w.context = $g(i, L);
      }
      {
        if (w.state === h) {
          var F = vr(l) || "Component";
          mI.has(F) || (mI.add(F), s("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", F));
        }
        i.mode & dr && Jc.recordLegacyContextWarning(i, w), Jc.recordUnsafeLifecycleWarnings(i, w);
      }
      w.state = i.memoizedState;
      var V = l.getDerivedStateFromProps;
      if (typeof V == "function" && (yI(i, l, V, h), w.state = i.memoizedState), typeof l.getDerivedStateFromProps != "function" && typeof w.getSnapshotBeforeUpdate != "function" && (typeof w.UNSAFE_componentWillMount == "function" || typeof w.componentWillMount == "function") && (Ppe(i, w), bw(i, h, w, g), w.state = i.memoizedState), typeof w.componentDidMount == "function") {
        var J = Yn;
        J |= Ws, (i.mode & Cl) !== an && (J |= Zs), i.flags |= J;
      }
    }
    function Npe(i, l, h, g) {
      var w = i.stateNode, A = i.memoizedProps;
      w.props = A;
      var L = w.context, F = l.contextType, V = Iu;
      if (typeof F == "object" && F !== null)
        V = Ei(F);
      else {
        var J = Lg(i, l, !0);
        V = $g(i, J);
      }
      var ae = l.getDerivedStateFromProps, Me = typeof ae == "function" || typeof w.getSnapshotBeforeUpdate == "function";
      !Me && (typeof w.UNSAFE_componentWillReceiveProps == "function" || typeof w.componentWillReceiveProps == "function") && (A !== h || L !== V) && pj(i, w, h, V), A$();
      var Te = i.memoizedState, Ye = w.state = Te;
      if (bw(i, h, w, g), Ye = i.memoizedState, A === h && Te === Ye && !ew() && !_w()) {
        if (typeof w.componentDidMount == "function") {
          var Ke = Yn;
          Ke |= Ws, (i.mode & Cl) !== an && (Ke |= Zs), i.flags |= Ke;
        }
        return !1;
      }
      typeof ae == "function" && (yI(i, l, ae, h), Ye = i.memoizedState);
      var rt = _w() || cj(i, l, A, h, Te, Ye, V);
      if (rt) {
        if (!Me && (typeof w.UNSAFE_componentWillMount == "function" || typeof w.componentWillMount == "function") && (typeof w.componentWillMount == "function" && w.componentWillMount(), typeof w.UNSAFE_componentWillMount == "function" && w.UNSAFE_componentWillMount()), typeof w.componentDidMount == "function") {
          var Ft = Yn;
          Ft |= Ws, (i.mode & Cl) !== an && (Ft |= Zs), i.flags |= Ft;
        }
      } else {
        if (typeof w.componentDidMount == "function") {
          var gn = Yn;
          gn |= Ws, (i.mode & Cl) !== an && (gn |= Zs), i.flags |= gn;
        }
        i.memoizedProps = h, i.memoizedState = Ye;
      }
      return w.props = h, w.state = Ye, w.context = V, rt;
    }
    function Tpe(i, l, h, g, w) {
      var A = l.stateNode;
      k$(i, l);
      var L = l.memoizedProps, F = l.type === l.elementType ? L : td(l.type, L);
      A.props = F;
      var V = l.pendingProps, J = A.context, ae = h.contextType, Me = Iu;
      if (typeof ae == "object" && ae !== null)
        Me = Ei(ae);
      else {
        var Te = Lg(l, h, !0);
        Me = $g(l, Te);
      }
      var Ye = h.getDerivedStateFromProps, Ke = typeof Ye == "function" || typeof A.getSnapshotBeforeUpdate == "function";
      !Ke && (typeof A.UNSAFE_componentWillReceiveProps == "function" || typeof A.componentWillReceiveProps == "function") && (L !== V || J !== Me) && pj(l, A, g, Me), A$();
      var rt = l.memoizedState, Ft = A.state = rt;
      if (bw(l, g, A, w), Ft = l.memoizedState, L === V && rt === Ft && !ew() && !_w() && !xe)
        return typeof A.componentDidUpdate == "function" && (L !== i.memoizedProps || rt !== i.memoizedState) && (l.flags |= Yn), typeof A.getSnapshotBeforeUpdate == "function" && (L !== i.memoizedProps || rt !== i.memoizedState) && (l.flags |= Bl), !1;
      typeof Ye == "function" && (yI(l, h, Ye, g), Ft = l.memoizedState);
      var gn = _w() || cj(l, h, F, g, rt, Ft, Me) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      xe;
      return gn ? (!Ke && (typeof A.UNSAFE_componentWillUpdate == "function" || typeof A.componentWillUpdate == "function") && (typeof A.componentWillUpdate == "function" && A.componentWillUpdate(g, Ft, Me), typeof A.UNSAFE_componentWillUpdate == "function" && A.UNSAFE_componentWillUpdate(g, Ft, Me)), typeof A.componentDidUpdate == "function" && (l.flags |= Yn), typeof A.getSnapshotBeforeUpdate == "function" && (l.flags |= Bl)) : (typeof A.componentDidUpdate == "function" && (L !== i.memoizedProps || rt !== i.memoizedState) && (l.flags |= Yn), typeof A.getSnapshotBeforeUpdate == "function" && (L !== i.memoizedProps || rt !== i.memoizedState) && (l.flags |= Bl), l.memoizedProps = g, l.memoizedState = Ft), A.props = g, A.state = Ft, A.context = Me, gn;
    }
    function n0(i, l) {
      return {
        value: i,
        source: l,
        stack: Mc(l),
        digest: null
      };
    }
    function CI(i, l, h) {
      return {
        value: i,
        source: null,
        stack: h != null ? h : null,
        digest: l != null ? l : null
      };
    }
    function Ope(i, l) {
      return !0;
    }
    function wI(i, l) {
      try {
        var h = Ope(i, l);
        if (h === !1)
          return;
        var g = l.value, w = l.source, A = l.stack, L = A !== null ? A : "";
        if (g != null && g._suppressLogging) {
          if (i.tag === f)
            return;
          console.error(g);
        }
        var F = w ? In(w) : null, V = F ? "The above error occurred in the <" + F + "> component:" : "The above error occurred in one of your React components:", J;
        if (i.tag === v)
          J = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var ae = In(i) || "Anonymous";
          J = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + ae + ".");
        }
        var Me = V + `
` + L + `

` + ("" + J);
        console.error(Me);
      } catch (Te) {
        setTimeout(function() {
          throw Te;
        });
      }
    }
    var Rpe = typeof WeakMap == "function" ? WeakMap : Map;
    function hj(i, l, h) {
      var g = yp(Na, h);
      g.tag = kE, g.payload = {
        element: null
      };
      var w = l.value;
      return g.callback = function() {
        Eme(w), wI(i, l);
      }, g;
    }
    function SI(i, l, h) {
      var g = yp(Na, h);
      g.tag = kE;
      var w = i.type.getDerivedStateFromError;
      if (typeof w == "function") {
        var A = l.value;
        g.payload = function() {
          return w(A);
        }, g.callback = function() {
          EF(i), wI(i, l);
        };
      }
      var L = i.stateNode;
      return L !== null && typeof L.componentDidCatch == "function" && (g.callback = function() {
        EF(i), wI(i, l), typeof w != "function" && Sme(this);
        var V = l.value, J = l.stack;
        this.componentDidCatch(V, {
          componentStack: J !== null ? J : ""
        }), typeof w != "function" && (Qs(i.lanes, cn) || s("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", In(i) || "Unknown"));
      }), g;
    }
    function mj(i, l, h) {
      var g = i.pingCache, w;
      if (g === null ? (g = i.pingCache = new Rpe(), w = /* @__PURE__ */ new Set(), g.set(l, w)) : (w = g.get(l), w === void 0 && (w = /* @__PURE__ */ new Set(), g.set(l, w))), !w.has(h)) {
        w.add(h);
        var A = Ime.bind(null, i, l, h);
        _l && H3(i, h), l.then(A, A);
      }
    }
    function Mpe(i, l, h, g) {
      var w = i.updateQueue;
      if (w === null) {
        var A = /* @__PURE__ */ new Set();
        A.add(h), i.updateQueue = A;
      } else
        w.add(h);
    }
    function Dpe(i, l) {
      var h = i.tag;
      if ((i.mode & ln) === an && (h === u || h === O || h === G)) {
        var g = i.alternate;
        g ? (i.updateQueue = g.updateQueue, i.memoizedState = g.memoizedState, i.lanes = g.lanes) : (i.updateQueue = null, i.memoizedState = null);
      }
    }
    function vj(i) {
      var l = i;
      do {
        if (l.tag === $ && mpe(l))
          return l;
        l = l.return;
      } while (l !== null);
      return null;
    }
    function gj(i, l, h, g, w) {
      if ((i.mode & ln) === an) {
        if (i === l)
          i.flags |= Ci;
        else {
          if (i.flags |= $n, h.flags |= wv, h.flags &= ~(T1 | gl), h.tag === f) {
            var A = h.alternate;
            if (A === null)
              h.tag = K;
            else {
              var L = yp(Na, cn);
              L.tag = mw, Jh(h, L, cn);
            }
          }
          h.lanes = Wn(h.lanes, cn);
        }
        return i;
      }
      return i.flags |= Ci, i.lanes = w, i;
    }
    function Lpe(i, l, h, g, w) {
      if (h.flags |= gl, _l && H3(i, w), g !== null && typeof g == "object" && typeof g.then == "function") {
        var A = g;
        Dpe(h), ks() && h.mode & ln && l$();
        var L = vj(l);
        if (L !== null) {
          L.flags &= ~uo, gj(L, l, h, i, w), L.mode & ln && mj(i, A, w), Mpe(L, i, A);
          return;
        } else {
          if (!Tb(w)) {
            mj(i, A, w), nk();
            return;
          }
          var F = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          g = F;
        }
      } else if (ks() && h.mode & ln) {
        l$();
        var V = vj(l);
        if (V !== null) {
          (V.flags & Ci) === hn && (V.flags |= uo), gj(V, l, h, i, w), mE(n0(g, h));
          return;
        }
      }
      g = n0(g, h), mme(g);
      var J = l;
      do {
        switch (J.tag) {
          case v: {
            var ae = g;
            J.flags |= Ci;
            var Me = Ph(w);
            J.lanes = Wn(J.lanes, Me);
            var Te = hj(J, ae, Me);
            NE(J, Te);
            return;
          }
          case f:
            var Ye = g, Ke = J.type, rt = J.stateNode;
            if ((J.flags & $n) === hn && (typeof Ke.getDerivedStateFromError == "function" || rt !== null && typeof rt.componentDidCatch == "function" && !vF(rt))) {
              J.flags |= Ci;
              var Ft = Ph(w);
              J.lanes = Wn(J.lanes, Ft);
              var gn = SI(J, Ye, Ft);
              NE(J, gn);
              return;
            }
            break;
        }
        J = J.return;
      } while (J !== null);
    }
    function $pe() {
      return null;
    }
    var P3 = n.ReactCurrentOwner, nd = !1, xI, N3, EI, II, kI, r0, AI, zw, T3;
    xI = {}, N3 = {}, EI = {}, II = {}, kI = {}, r0 = !1, AI = {}, zw = {}, T3 = {};
    function Sl(i, l, h, g) {
      i === null ? l.child = _$(l, null, h, g) : l.child = Vg(l, i.child, h, g);
    }
    function jpe(i, l, h, g) {
      l.child = Vg(l, i.child, null, g), l.child = Vg(l, null, h, g);
    }
    function yj(i, l, h, g, w) {
      if (l.type !== l.elementType) {
        var A = h.propTypes;
        A && Kc(
          A,
          g,
          // Resolved props
          "prop",
          vr(h)
        );
      }
      var L = h.render, F = l.ref, V, J;
      Gg(l, w), bh(l);
      {
        if (P3.current = l, oi(!0), V = Xg(i, l, L, g, F, w), J = Kg(), l.mode & dr) {
          Vo(!0);
          try {
            V = Xg(i, l, L, g, F, w), J = Kg();
          } finally {
            Vo(!1);
          }
        }
        oi(!1);
      }
      return Ks(), i !== null && !nd ? (M$(i, l, w), bp(i, l, w)) : (ks() && J && uE(l), l.flags |= zd, Sl(i, l, V, w), l.child);
    }
    function bj(i, l, h, g, w) {
      if (i === null) {
        var A = h.type;
        if (Gme(A) && h.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        h.defaultProps === void 0) {
          var L = A;
          return L = ay(A), l.tag = G, l.type = L, TI(l, A), _j(i, l, L, g, w);
        }
        {
          var F = A.propTypes;
          if (F && Kc(
            F,
            g,
            // Resolved props
            "prop",
            vr(A)
          ), h.defaultProps !== void 0) {
            var V = vr(A) || "Unknown";
            T3[V] || (s("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", V), T3[V] = !0);
          }
        }
        var J = pk(h.type, null, g, l, l.mode, w);
        return J.ref = l.ref, J.return = l, l.child = J, J;
      }
      {
        var ae = h.type, Me = ae.propTypes;
        Me && Kc(
          Me,
          g,
          // Resolved props
          "prop",
          vr(ae)
        );
      }
      var Te = i.child, Ye = $I(i, w);
      if (!Ye) {
        var Ke = Te.memoizedProps, rt = h.compare;
        if (rt = rt !== null ? rt : wn, rt(Ke, g) && i.ref === l.ref)
          return bp(i, l, w);
      }
      l.flags |= zd;
      var Ft = l0(Te, g);
      return Ft.ref = l.ref, Ft.return = l, l.child = Ft, Ft;
    }
    function _j(i, l, h, g, w) {
      if (l.type !== l.elementType) {
        var A = l.elementType;
        if (A.$$typeof === vn) {
          var L = A, F = L._payload, V = L._init;
          try {
            A = V(F);
          } catch (Me) {
            A = null;
          }
          var J = A && A.propTypes;
          J && Kc(
            J,
            g,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            vr(A)
          );
        }
      }
      if (i !== null) {
        var ae = i.memoizedProps;
        if (wn(ae, g) && i.ref === l.ref && // Prevent bailout if the implementation changed due to hot reload.
        l.type === i.type)
          if (nd = !1, l.pendingProps = g = ae, $I(i, w))
            (i.flags & wv) !== hn && (nd = !0);
          else return l.lanes = i.lanes, bp(i, l, w);
      }
      return PI(i, l, h, g, w);
    }
    function Cj(i, l, h) {
      var g = l.pendingProps, w = g.children, A = i !== null ? i.memoizedState : null;
      if (g.mode === "hidden" || X)
        if ((l.mode & ln) === an) {
          var L = {
            baseLanes: dt,
            cachePool: null,
            transitions: null
          };
          l.memoizedState = L, rS(l, h);
        } else if (Qs(h, ss)) {
          var Me = {
            baseLanes: dt,
            cachePool: null,
            transitions: null
          };
          l.memoizedState = Me;
          var Te = A !== null ? A.baseLanes : h;
          rS(l, Te);
        } else {
          var F = null, V;
          if (A !== null) {
            var J = A.baseLanes;
            V = Wn(J, h);
          } else
            V = h;
          l.lanes = l.childLanes = ss;
          var ae = {
            baseLanes: V,
            cachePool: F,
            transitions: null
          };
          return l.memoizedState = ae, l.updateQueue = null, rS(l, V), null;
        }
      else {
        var Ye;
        A !== null ? (Ye = Wn(A.baseLanes, h), l.memoizedState = null) : Ye = h, rS(l, Ye);
      }
      return Sl(i, l, w, h), l.child;
    }
    function Fpe(i, l, h) {
      var g = l.pendingProps;
      return Sl(i, l, g, h), l.child;
    }
    function Bpe(i, l, h) {
      var g = l.pendingProps.children;
      return Sl(i, l, g, h), l.child;
    }
    function Vpe(i, l, h) {
      {
        l.flags |= Yn;
        {
          var g = l.stateNode;
          g.effectDuration = 0, g.passiveEffectDuration = 0;
        }
      }
      var w = l.pendingProps, A = w.children;
      return Sl(i, l, A, h), l.child;
    }
    function wj(i, l) {
      var h = l.ref;
      (i === null && h !== null || i !== null && i.ref !== h) && (l.flags |= Hs, l.flags |= yb);
    }
    function PI(i, l, h, g, w) {
      if (l.type !== l.elementType) {
        var A = h.propTypes;
        A && Kc(
          A,
          g,
          // Resolved props
          "prop",
          vr(h)
        );
      }
      var L;
      {
        var F = Lg(l, h, !0);
        L = $g(l, F);
      }
      var V, J;
      Gg(l, w), bh(l);
      {
        if (P3.current = l, oi(!0), V = Xg(i, l, h, g, L, w), J = Kg(), l.mode & dr) {
          Vo(!0);
          try {
            V = Xg(i, l, h, g, L, w), J = Kg();
          } finally {
            Vo(!1);
          }
        }
        oi(!1);
      }
      return Ks(), i !== null && !nd ? (M$(i, l, w), bp(i, l, w)) : (ks() && J && uE(l), l.flags |= zd, Sl(i, l, V, w), l.child);
    }
    function Sj(i, l, h, g, w) {
      {
        switch (ave(l)) {
          case !1: {
            var A = l.stateNode, L = l.type, F = new L(l.memoizedProps, A.context), V = F.state;
            A.updater.enqueueSetState(A, V, null);
            break;
          }
          case !0: {
            l.flags |= $n, l.flags |= Ci;
            var J = new Error("Simulated error coming from DevTools"), ae = Ph(w);
            l.lanes = Wn(l.lanes, ae);
            var Me = SI(l, n0(J, l), ae);
            NE(l, Me);
            break;
          }
        }
        if (l.type !== l.elementType) {
          var Te = h.propTypes;
          Te && Kc(
            Te,
            g,
            // Resolved props
            "prop",
            vr(h)
          );
        }
      }
      var Ye;
      rf(h) ? (Ye = !0, nw(l)) : Ye = !1, Gg(l, w);
      var Ke = l.stateNode, rt;
      Ke === null ? (Ww(i, l), fj(l, h, g), _I(l, h, g, w), rt = !0) : i === null ? rt = Npe(l, h, g, w) : rt = Tpe(i, l, h, g, w);
      var Ft = NI(i, l, h, rt, Ye, w);
      {
        var gn = l.stateNode;
        rt && gn.props !== g && (r0 || s("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", In(l) || "a component"), r0 = !0);
      }
      return Ft;
    }
    function NI(i, l, h, g, w, A) {
      wj(i, l);
      var L = (l.flags & $n) !== hn;
      if (!g && !L)
        return w && a$(l, h, !1), bp(i, l, A);
      var F = l.stateNode;
      P3.current = l;
      var V;
      if (L && typeof h.getDerivedStateFromError != "function")
        V = null, sj();
      else {
        bh(l);
        {
          if (oi(!0), V = F.render(), l.mode & dr) {
            Vo(!0);
            try {
              F.render();
            } finally {
              Vo(!1);
            }
          }
          oi(!1);
        }
        Ks();
      }
      return l.flags |= zd, i !== null && L ? jpe(i, l, V, A) : Sl(i, l, V, A), l.memoizedState = F.state, w && a$(l, h, !0), l.child;
    }
    function xj(i) {
      var l = i.stateNode;
      l.pendingContext ? n$(i, l.pendingContext, l.pendingContext !== l.context) : l.context && n$(i, l.context, !1), TE(i, l.containerInfo);
    }
    function Upe(i, l, h) {
      if (xj(l), i === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var g = l.pendingProps, w = l.memoizedState, A = w.element;
      k$(i, l), bw(l, g, null, h);
      var L = l.memoizedState;
      l.stateNode;
      var F = L.element;
      if (w.isDehydrated) {
        var V = {
          element: F,
          isDehydrated: !1,
          cache: L.cache,
          pendingSuspenseBoundaries: L.pendingSuspenseBoundaries,
          transitions: L.transitions
        }, J = l.updateQueue;
        if (J.baseState = V, l.memoizedState = V, l.flags & uo) {
          var ae = n0(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), l);
          return Ej(i, l, F, h, ae);
        } else if (F !== A) {
          var Me = n0(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), l);
          return Ej(i, l, F, h, Me);
        } else {
          Hfe(l);
          var Te = _$(l, null, F, h);
          l.child = Te;
          for (var Ye = Te; Ye; )
            Ye.flags = Ye.flags & ~Ma | Vl, Ye = Ye.sibling;
        }
      } else {
        if (Bg(), F === A)
          return bp(i, l, h);
        Sl(i, l, F, h);
      }
      return l.child;
    }
    function Ej(i, l, h, g, w) {
      return Bg(), mE(w), l.flags |= uo, Sl(i, l, h, g), l.child;
    }
    function Gpe(i, l, h) {
      T$(l), i === null && hE(l);
      var g = l.type, w = l.pendingProps, A = i !== null ? i.memoizedProps : null, L = w.children, F = X9(g, w);
      return F ? L = null : A !== null && X9(g, A) && (l.flags |= ta), wj(i, l), Sl(i, l, L, h), l.child;
    }
    function zpe(i, l) {
      return i === null && hE(l), null;
    }
    function Hpe(i, l, h, g) {
      Ww(i, l);
      var w = l.pendingProps, A = h, L = A._payload, F = A._init, V = F(L);
      l.type = V;
      var J = l.tag = zme(V), ae = td(V, w), Me;
      switch (J) {
        case u:
          return TI(l, V), l.type = V = ay(V), Me = PI(null, l, V, ae, g), Me;
        case f:
          return l.type = V = sk(V), Me = Sj(null, l, V, ae, g), Me;
        case O:
          return l.type = V = lk(V), Me = yj(null, l, V, ae, g), Me;
        case B: {
          if (l.type !== l.elementType) {
            var Te = V.propTypes;
            Te && Kc(
              Te,
              ae,
              // Resolved for outer only
              "prop",
              vr(V)
            );
          }
          return Me = bj(
            null,
            l,
            V,
            td(V.type, ae),
            // The inner type can have defaults too
            g
          ), Me;
        }
      }
      var Ye = "";
      throw V !== null && typeof V == "object" && V.$$typeof === vn && (Ye = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + V + ". " + ("Lazy element type must resolve to a class or function." + Ye));
    }
    function Wpe(i, l, h, g, w) {
      Ww(i, l), l.tag = f;
      var A;
      return rf(h) ? (A = !0, nw(l)) : A = !1, Gg(l, w), fj(l, h, g), _I(l, h, g, w), NI(null, l, h, !0, A, w);
    }
    function Zpe(i, l, h, g) {
      Ww(i, l);
      var w = l.pendingProps, A;
      {
        var L = Lg(l, h, !1);
        A = $g(l, L);
      }
      Gg(l, g);
      var F, V;
      bh(l);
      {
        if (h.prototype && typeof h.prototype.render == "function") {
          var J = vr(h) || "Unknown";
          xI[J] || (s("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", J, J), xI[J] = !0);
        }
        l.mode & dr && Jc.recordLegacyContextWarning(l, null), oi(!0), P3.current = l, F = Xg(null, l, h, w, A, g), V = Kg(), oi(!1);
      }
      if (Ks(), l.flags |= zd, typeof F == "object" && F !== null && typeof F.render == "function" && F.$$typeof === void 0) {
        var ae = vr(h) || "Unknown";
        N3[ae] || (s("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ae, ae, ae), N3[ae] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof F == "object" && F !== null && typeof F.render == "function" && F.$$typeof === void 0
      ) {
        {
          var Me = vr(h) || "Unknown";
          N3[Me] || (s("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Me, Me, Me), N3[Me] = !0);
        }
        l.tag = f, l.memoizedState = null, l.updateQueue = null;
        var Te = !1;
        return rf(h) ? (Te = !0, nw(l)) : Te = !1, l.memoizedState = F.state !== null && F.state !== void 0 ? F.state : null, PE(l), dj(l, F), _I(l, h, w, g), NI(null, l, h, !0, Te, g);
      } else {
        if (l.tag = u, l.mode & dr) {
          Vo(!0);
          try {
            F = Xg(null, l, h, w, A, g), V = Kg();
          } finally {
            Vo(!1);
          }
        }
        return ks() && V && uE(l), Sl(null, l, F, g), TI(l, h), l.child;
      }
    }
    function TI(i, l) {
      {
        if (l && l.childContextTypes && s("%s(...): childContextTypes cannot be defined on a function component.", l.displayName || l.name || "Component"), i.ref !== null) {
          var h = "", g = rs();
          g && (h += `

Check the render method of \`` + g + "`.");
          var w = g || "", A = i._debugSource;
          A && (w = A.fileName + ":" + A.lineNumber), kI[w] || (kI[w] = !0, s("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", h));
        }
        if (l.defaultProps !== void 0) {
          var L = vr(l) || "Unknown";
          T3[L] || (s("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", L), T3[L] = !0);
        }
        if (typeof l.getDerivedStateFromProps == "function") {
          var F = vr(l) || "Unknown";
          II[F] || (s("%s: Function components do not support getDerivedStateFromProps.", F), II[F] = !0);
        }
        if (typeof l.contextType == "object" && l.contextType !== null) {
          var V = vr(l) || "Unknown";
          EI[V] || (s("%s: Function components do not support contextType.", V), EI[V] = !0);
        }
      }
    }
    var OI = {
      dehydrated: null,
      treeContext: null,
      retryLane: Uo
    };
    function RI(i) {
      return {
        baseLanes: i,
        cachePool: $pe(),
        transitions: null
      };
    }
    function Ype(i, l) {
      var h = null;
      return {
        baseLanes: Wn(i.baseLanes, l),
        cachePool: h,
        transitions: i.transitions
      };
    }
    function Xpe(i, l, h, g) {
      if (l !== null) {
        var w = l.memoizedState;
        if (w === null)
          return !1;
      }
      return ME(i, _3);
    }
    function Kpe(i, l) {
      return Ov(i.childLanes, l);
    }
    function Ij(i, l, h) {
      var g = l.pendingProps;
      ove(l) && (l.flags |= $n);
      var w = Qc.current, A = !1, L = (l.flags & $n) !== hn;
      if (L || Xpe(w, i) ? (A = !0, l.flags &= ~$n) : (i === null || i.memoizedState !== null) && (w = hpe(w, R$)), w = Hg(w), em(l, w), i === null) {
        hE(l);
        var F = l.memoizedState;
        if (F !== null) {
          var V = F.dehydrated;
          if (V !== null)
            return the(l, V);
        }
        var J = g.children, ae = g.fallback;
        if (A) {
          var Me = qpe(l, J, ae, h), Te = l.child;
          return Te.memoizedState = RI(h), l.memoizedState = OI, Me;
        } else
          return MI(l, J);
      } else {
        var Ye = i.memoizedState;
        if (Ye !== null) {
          var Ke = Ye.dehydrated;
          if (Ke !== null)
            return nhe(i, l, L, g, Ke, Ye, h);
        }
        if (A) {
          var rt = g.fallback, Ft = g.children, gn = Qpe(i, l, Ft, rt, h), un = l.child, Nr = i.child.memoizedState;
          return un.memoizedState = Nr === null ? RI(h) : Ype(Nr, h), un.childLanes = Kpe(i, h), l.memoizedState = OI, gn;
        } else {
          var yr = g.children, Ve = Jpe(i, l, yr, h);
          return l.memoizedState = null, Ve;
        }
      }
    }
    function MI(i, l, h) {
      var g = i.mode, w = {
        mode: "visible",
        children: l
      }, A = DI(w, g);
      return A.return = i, i.child = A, A;
    }
    function qpe(i, l, h, g) {
      var w = i.mode, A = i.child, L = {
        mode: "hidden",
        children: l
      }, F, V;
      return (w & ln) === an && A !== null ? (F = A, F.childLanes = dt, F.pendingProps = L, i.mode & jn && (F.actualDuration = 0, F.actualStartTime = -1, F.selfBaseDuration = 0, F.treeBaseDuration = 0), V = lm(h, w, g, null)) : (F = DI(L, w), V = lm(h, w, g, null)), F.return = i, V.return = i, F.sibling = V, i.child = F, V;
    }
    function DI(i, l, h) {
      return kF(i, l, dt, null);
    }
    function kj(i, l) {
      return l0(i, l);
    }
    function Jpe(i, l, h, g) {
      var w = i.child, A = w.sibling, L = kj(w, {
        mode: "visible",
        children: h
      });
      if ((l.mode & ln) === an && (L.lanes = g), L.return = l, L.sibling = null, A !== null) {
        var F = l.deletions;
        F === null ? (l.deletions = [A], l.flags |= Kr) : F.push(A);
      }
      return l.child = L, L;
    }
    function Qpe(i, l, h, g, w) {
      var A = l.mode, L = i.child, F = L.sibling, V = {
        mode: "hidden",
        children: h
      }, J;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (A & ln) === an && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        l.child !== L
      ) {
        var ae = l.child;
        J = ae, J.childLanes = dt, J.pendingProps = V, l.mode & jn && (J.actualDuration = 0, J.actualStartTime = -1, J.selfBaseDuration = L.selfBaseDuration, J.treeBaseDuration = L.treeBaseDuration), l.deletions = null;
      } else
        J = kj(L, V), J.subtreeFlags = L.subtreeFlags & Di;
      var Me;
      return F !== null ? Me = l0(F, g) : (Me = lm(g, A, w, null), Me.flags |= Ma), Me.return = l, J.return = l, J.sibling = Me, l.child = J, Me;
    }
    function Hw(i, l, h, g) {
      g !== null && mE(g), Vg(l, i.child, null, h);
      var w = l.pendingProps, A = w.children, L = MI(l, A);
      return L.flags |= Ma, l.memoizedState = null, L;
    }
    function ehe(i, l, h, g, w) {
      var A = l.mode, L = {
        mode: "visible",
        children: h
      }, F = DI(L, A), V = lm(g, A, w, null);
      return V.flags |= Ma, F.return = l, V.return = l, F.sibling = V, l.child = F, (l.mode & ln) !== an && Vg(l, i.child, null, w), V;
    }
    function the(i, l, h) {
      return (i.mode & ln) === an ? (s("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), i.lanes = cn) : Q9(l) ? i.lanes = Hc : i.lanes = ss, null;
    }
    function nhe(i, l, h, g, w, A, L) {
      if (h)
        if (l.flags & uo) {
          l.flags &= ~uo;
          var Ve = CI(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return Hw(i, l, L, Ve);
        } else {
          if (l.memoizedState !== null)
            return l.child = i.child, l.flags |= $n, null;
          var at = g.children, Ue = g.fallback, Ct = ehe(i, l, at, Ue, L), Ht = l.child;
          return Ht.memoizedState = RI(L), l.memoizedState = OI, Ct;
        }
      else {
        if (Gfe(), (l.mode & ln) === an)
          return Hw(
            i,
            l,
            L,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (Q9(w)) {
          var F, V, J;
          {
            var ae = ife(w);
            F = ae.digest, V = ae.message, J = ae.stack;
          }
          var Me;
          V ? Me = new Error(V) : Me = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var Te = CI(Me, F, J);
          return Hw(i, l, L, Te);
        }
        var Ye = Qs(L, i.childLanes);
        if (nd || Ye) {
          var Ke = nS();
          if (Ke !== null) {
            var rt = g5(Ke, L);
            if (rt !== Uo && rt !== A.retryLane) {
              A.retryLane = rt;
              var Ft = Na;
              Ql(i, rt), Hi(Ke, i, rt, Ft);
            }
          }
          nk();
          var gn = CI(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return Hw(i, l, L, gn);
        } else if (KL(w)) {
          l.flags |= $n, l.child = i.child;
          var un = kme.bind(null, i);
          return sfe(w, un), null;
        } else {
          Wfe(l, w, A.treeContext);
          var Nr = g.children, yr = MI(l, Nr);
          return yr.flags |= Vl, yr;
        }
      }
    }
    function Aj(i, l, h) {
      i.lanes = Wn(i.lanes, l);
      var g = i.alternate;
      g !== null && (g.lanes = Wn(g.lanes, l)), EE(i.return, l, h);
    }
    function rhe(i, l, h) {
      for (var g = l; g !== null; ) {
        if (g.tag === $) {
          var w = g.memoizedState;
          w !== null && Aj(g, h, i);
        } else if (g.tag === pe)
          Aj(g, h, i);
        else if (g.child !== null) {
          g.child.return = g, g = g.child;
          continue;
        }
        if (g === i)
          return;
        for (; g.sibling === null; ) {
          if (g.return === null || g.return === i)
            return;
          g = g.return;
        }
        g.sibling.return = g.return, g = g.sibling;
      }
    }
    function ahe(i) {
      for (var l = i, h = null; l !== null; ) {
        var g = l.alternate;
        g !== null && Sw(g) === null && (h = l), l = l.sibling;
      }
      return h;
    }
    function ohe(i) {
      if (i !== void 0 && i !== "forwards" && i !== "backwards" && i !== "together" && !AI[i])
        if (AI[i] = !0, typeof i == "string")
          switch (i.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              s('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', i, i.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              s('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', i, i.toLowerCase());
              break;
            }
            default:
              s('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', i);
              break;
          }
        else
          s('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', i);
    }
    function ihe(i, l) {
      i !== void 0 && !zw[i] && (i !== "collapsed" && i !== "hidden" ? (zw[i] = !0, s('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', i)) : l !== "forwards" && l !== "backwards" && (zw[i] = !0, s('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', i)));
    }
    function Pj(i, l) {
      {
        var h = bi(i), g = !h && typeof Eo(i) == "function";
        if (h || g) {
          var w = h ? "array" : "iterable";
          return s("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", w, l, w), !1;
        }
      }
      return !0;
    }
    function she(i, l) {
      if ((l === "forwards" || l === "backwards") && i !== void 0 && i !== null && i !== !1)
        if (bi(i)) {
          for (var h = 0; h < i.length; h++)
            if (!Pj(i[h], h))
              return;
        } else {
          var g = Eo(i);
          if (typeof g == "function") {
            var w = g.call(i);
            if (w)
              for (var A = w.next(), L = 0; !A.done; A = w.next()) {
                if (!Pj(A.value, L))
                  return;
                L++;
              }
          } else
            s('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', l);
        }
    }
    function LI(i, l, h, g, w) {
      var A = i.memoizedState;
      A === null ? i.memoizedState = {
        isBackwards: l,
        rendering: null,
        renderingStartTime: 0,
        last: g,
        tail: h,
        tailMode: w
      } : (A.isBackwards = l, A.rendering = null, A.renderingStartTime = 0, A.last = g, A.tail = h, A.tailMode = w);
    }
    function Nj(i, l, h) {
      var g = l.pendingProps, w = g.revealOrder, A = g.tail, L = g.children;
      ohe(w), ihe(A, w), she(L, w), Sl(i, l, L, h);
      var F = Qc.current, V = ME(F, _3);
      if (V)
        F = DE(F, _3), l.flags |= $n;
      else {
        var J = i !== null && (i.flags & $n) !== hn;
        J && rhe(l, l.child, h), F = Hg(F);
      }
      if (em(l, F), (l.mode & ln) === an)
        l.memoizedState = null;
      else
        switch (w) {
          case "forwards": {
            var ae = ahe(l.child), Me;
            ae === null ? (Me = l.child, l.child = null) : (Me = ae.sibling, ae.sibling = null), LI(
              l,
              !1,
              // isBackwards
              Me,
              ae,
              A
            );
            break;
          }
          case "backwards": {
            var Te = null, Ye = l.child;
            for (l.child = null; Ye !== null; ) {
              var Ke = Ye.alternate;
              if (Ke !== null && Sw(Ke) === null) {
                l.child = Ye;
                break;
              }
              var rt = Ye.sibling;
              Ye.sibling = Te, Te = Ye, Ye = rt;
            }
            LI(
              l,
              !0,
              // isBackwards
              Te,
              null,
              // last
              A
            );
            break;
          }
          case "together": {
            LI(
              l,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            l.memoizedState = null;
        }
      return l.child;
    }
    function lhe(i, l, h) {
      TE(l, l.stateNode.containerInfo);
      var g = l.pendingProps;
      return i === null ? l.child = Vg(l, null, g, h) : Sl(i, l, g, h), l.child;
    }
    var Tj = !1;
    function uhe(i, l, h) {
      var g = l.type, w = g._context, A = l.pendingProps, L = l.memoizedProps, F = A.value;
      {
        "value" in A || Tj || (Tj = !0, s("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var V = l.type.propTypes;
        V && Kc(V, A, "prop", "Context.Provider");
      }
      if (S$(l, w, F), L !== null) {
        var J = L.value;
        if (Qt(J, F)) {
          if (L.children === A.children && !ew())
            return bp(i, l, h);
        } else
          ope(l, w, h);
      }
      var ae = A.children;
      return Sl(i, l, ae, h), l.child;
    }
    var Oj = !1;
    function che(i, l, h) {
      var g = l.type;
      g._context === void 0 ? g !== g.Consumer && (Oj || (Oj = !0, s("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : g = g._context;
      var w = l.pendingProps, A = w.children;
      typeof A != "function" && s("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Gg(l, h);
      var L = Ei(g);
      bh(l);
      var F;
      return P3.current = l, oi(!0), F = A(L), oi(!1), Ks(), l.flags |= zd, Sl(i, l, F, h), l.child;
    }
    function O3() {
      nd = !0;
    }
    function Ww(i, l) {
      (l.mode & ln) === an && i !== null && (i.alternate = null, l.alternate = null, l.flags |= Ma);
    }
    function bp(i, l, h) {
      return i !== null && (l.dependencies = i.dependencies), sj(), z3(l.lanes), Qs(h, l.childLanes) ? (rpe(i, l), l.child) : null;
    }
    function dhe(i, l, h) {
      {
        var g = l.return;
        if (g === null)
          throw new Error("Cannot swap the root fiber.");
        if (i.alternate = null, l.alternate = null, h.index = l.index, h.sibling = l.sibling, h.return = l.return, h.ref = l.ref, l === g.child)
          g.child = h;
        else {
          var w = g.child;
          if (w === null)
            throw new Error("Expected parent to have a child.");
          for (; w.sibling !== l; )
            if (w = w.sibling, w === null)
              throw new Error("Expected to find the previous sibling.");
          w.sibling = h;
        }
        var A = g.deletions;
        return A === null ? (g.deletions = [i], g.flags |= Kr) : A.push(i), h.flags |= Ma, h;
      }
    }
    function $I(i, l) {
      var h = i.lanes;
      return !!Qs(h, l);
    }
    function fhe(i, l, h) {
      switch (l.tag) {
        case v:
          xj(l), l.stateNode, Bg();
          break;
        case b:
          T$(l);
          break;
        case f: {
          var g = l.type;
          rf(g) && nw(l);
          break;
        }
        case y:
          TE(l, l.stateNode.containerInfo);
          break;
        case R: {
          var w = l.memoizedProps.value, A = l.type._context;
          S$(l, A, w);
          break;
        }
        case D:
          {
            var L = Qs(h, l.childLanes);
            L && (l.flags |= Yn);
            {
              var F = l.stateNode;
              F.effectDuration = 0, F.passiveEffectDuration = 0;
            }
          }
          break;
        case $: {
          var V = l.memoizedState;
          if (V !== null) {
            if (V.dehydrated !== null)
              return em(l, Hg(Qc.current)), l.flags |= $n, null;
            var J = l.child, ae = J.childLanes;
            if (Qs(h, ae))
              return Ij(i, l, h);
            em(l, Hg(Qc.current));
            var Me = bp(i, l, h);
            return Me !== null ? Me.sibling : null;
          } else
            em(l, Hg(Qc.current));
          break;
        }
        case pe: {
          var Te = (i.flags & $n) !== hn, Ye = Qs(h, l.childLanes);
          if (Te) {
            if (Ye)
              return Nj(i, l, h);
            l.flags |= $n;
          }
          var Ke = l.memoizedState;
          if (Ke !== null && (Ke.rendering = null, Ke.tail = null, Ke.lastEffect = null), em(l, Qc.current), Ye)
            break;
          return null;
        }
        case _e:
        case ge:
          return l.lanes = dt, Cj(i, l, h);
      }
      return bp(i, l, h);
    }
    function Rj(i, l, h) {
      if (l._debugNeedsRemount && i !== null)
        return dhe(i, l, pk(l.type, l.key, l.pendingProps, l._debugOwner || null, l.mode, l.lanes));
      if (i !== null) {
        var g = i.memoizedProps, w = l.pendingProps;
        if (g !== w || ew() || // Force a re-render if the implementation changed due to hot reload:
        l.type !== i.type)
          nd = !0;
        else {
          var A = $I(i, h);
          if (!A && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (l.flags & $n) === hn)
            return nd = !1, fhe(i, l, h);
          (i.flags & wv) !== hn ? nd = !0 : nd = !1;
        }
      } else if (nd = !1, ks() && $fe(l)) {
        var L = l.index, F = jfe();
        s$(l, F, L);
      }
      switch (l.lanes = dt, l.tag) {
        case m:
          return Zpe(i, l, l.type, h);
        case Z: {
          var V = l.elementType;
          return Hpe(i, l, V, h);
        }
        case u: {
          var J = l.type, ae = l.pendingProps, Me = l.elementType === J ? ae : td(J, ae);
          return PI(i, l, J, Me, h);
        }
        case f: {
          var Te = l.type, Ye = l.pendingProps, Ke = l.elementType === Te ? Ye : td(Te, Ye);
          return Sj(i, l, Te, Ke, h);
        }
        case v:
          return Upe(i, l, h);
        case b:
          return Gpe(i, l, h);
        case S:
          return zpe(i, l);
        case $:
          return Ij(i, l, h);
        case y:
          return lhe(i, l, h);
        case O: {
          var rt = l.type, Ft = l.pendingProps, gn = l.elementType === rt ? Ft : td(rt, Ft);
          return yj(i, l, rt, gn, h);
        }
        case x:
          return Fpe(i, l, h);
        case E:
          return Bpe(i, l, h);
        case D:
          return Vpe(i, l, h);
        case R:
          return uhe(i, l, h);
        case N:
          return che(i, l, h);
        case B: {
          var un = l.type, Nr = l.pendingProps, yr = td(un, Nr);
          if (l.type !== l.elementType) {
            var Ve = un.propTypes;
            Ve && Kc(
              Ve,
              yr,
              // Resolved for outer only
              "prop",
              vr(un)
            );
          }
          return yr = td(un.type, yr), bj(i, l, un, yr, h);
        }
        case G:
          return _j(i, l, l.type, l.pendingProps, h);
        case K: {
          var at = l.type, Ue = l.pendingProps, Ct = l.elementType === at ? Ue : td(at, Ue);
          return Wpe(i, l, at, Ct, h);
        }
        case pe:
          return Nj(i, l, h);
        case he:
          break;
        case _e:
          return Cj(i, l, h);
      }
      throw new Error("Unknown unit of work tag (" + l.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function qg(i) {
      i.flags |= Yn;
    }
    function Mj(i) {
      i.flags |= Hs, i.flags |= yb;
    }
    var Dj, jI, Lj, $j;
    Dj = function(i, l, h, g) {
      for (var w = l.child; w !== null; ) {
        if (w.tag === b || w.tag === S)
          Mde(i, w.stateNode);
        else if (w.tag !== y) {
          if (w.child !== null) {
            w.child.return = w, w = w.child;
            continue;
          }
        }
        if (w === l)
          return;
        for (; w.sibling === null; ) {
          if (w.return === null || w.return === l)
            return;
          w = w.return;
        }
        w.sibling.return = w.return, w = w.sibling;
      }
    }, jI = function(i, l) {
    }, Lj = function(i, l, h, g, w) {
      var A = i.memoizedProps;
      if (A !== g) {
        var L = l.stateNode, F = OE(), V = Lde(L, h, A, g, w, F);
        l.updateQueue = V, V && qg(l);
      }
    }, $j = function(i, l, h, g) {
      h !== g && qg(l);
    };
    function R3(i, l) {
      if (!ks())
        switch (i.tailMode) {
          case "hidden": {
            for (var h = i.tail, g = null; h !== null; )
              h.alternate !== null && (g = h), h = h.sibling;
            g === null ? i.tail = null : g.sibling = null;
            break;
          }
          case "collapsed": {
            for (var w = i.tail, A = null; w !== null; )
              w.alternate !== null && (A = w), w = w.sibling;
            A === null ? !l && i.tail !== null ? i.tail.sibling = null : i.tail = null : A.sibling = null;
            break;
          }
        }
    }
    function Ps(i) {
      var l = i.alternate !== null && i.alternate.child === i.child, h = dt, g = hn;
      if (l) {
        if ((i.mode & jn) !== an) {
          for (var V = i.selfBaseDuration, J = i.child; J !== null; )
            h = Wn(h, Wn(J.lanes, J.childLanes)), g |= J.subtreeFlags & Di, g |= J.flags & Di, V += J.treeBaseDuration, J = J.sibling;
          i.treeBaseDuration = V;
        } else
          for (var ae = i.child; ae !== null; )
            h = Wn(h, Wn(ae.lanes, ae.childLanes)), g |= ae.subtreeFlags & Di, g |= ae.flags & Di, ae.return = i, ae = ae.sibling;
        i.subtreeFlags |= g;
      } else {
        if ((i.mode & jn) !== an) {
          for (var w = i.actualDuration, A = i.selfBaseDuration, L = i.child; L !== null; )
            h = Wn(h, Wn(L.lanes, L.childLanes)), g |= L.subtreeFlags, g |= L.flags, w += L.actualDuration, A += L.treeBaseDuration, L = L.sibling;
          i.actualDuration = w, i.treeBaseDuration = A;
        } else
          for (var F = i.child; F !== null; )
            h = Wn(h, Wn(F.lanes, F.childLanes)), g |= F.subtreeFlags, g |= F.flags, F.return = i, F = F.sibling;
        i.subtreeFlags |= g;
      }
      return i.childLanes = h, l;
    }
    function phe(i, l, h) {
      if (qfe() && (l.mode & ln) !== an && (l.flags & $n) === hn)
        return h$(l), Bg(), l.flags |= uo | gl | Ci, !1;
      var g = sw(l);
      if (h !== null && h.dehydrated !== null)
        if (i === null) {
          if (!g)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (Xfe(l), Ps(l), (l.mode & jn) !== an) {
            var w = h !== null;
            if (w) {
              var A = l.child;
              A !== null && (l.treeBaseDuration -= A.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Bg(), (l.flags & $n) === hn && (l.memoizedState = null), l.flags |= Yn, Ps(l), (l.mode & jn) !== an) {
            var L = h !== null;
            if (L) {
              var F = l.child;
              F !== null && (l.treeBaseDuration -= F.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return m$(), !0;
    }
    function jj(i, l, h) {
      var g = l.pendingProps;
      switch (cE(l), l.tag) {
        case m:
        case Z:
        case G:
        case u:
        case O:
        case x:
        case E:
        case D:
        case N:
        case B:
          return Ps(l), null;
        case f: {
          var w = l.type;
          return rf(w) && tw(l), Ps(l), null;
        }
        case v: {
          var A = l.stateNode;
          if (zg(l), iE(l), $E(), A.pendingContext && (A.context = A.pendingContext, A.pendingContext = null), i === null || i.child === null) {
            var L = sw(l);
            if (L)
              qg(l);
            else if (i !== null) {
              var F = i.memoizedState;
              // Check if this is a client root
              (!F.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (l.flags & uo) !== hn) && (l.flags |= Bl, m$());
            }
          }
          return jI(i, l), Ps(l), null;
        }
        case b: {
          RE(l);
          var V = N$(), J = l.type;
          if (i !== null && l.stateNode != null)
            Lj(i, l, J, g, V), i.ref !== l.ref && Mj(l);
          else {
            if (!g) {
              if (l.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return Ps(l), null;
            }
            var ae = OE(), Me = sw(l);
            if (Me)
              Zfe(l, V, ae) && qg(l);
            else {
              var Te = Rde(J, g, V, ae, l);
              Dj(Te, l, !1, !1), l.stateNode = Te, Dde(Te, J, g, V) && qg(l);
            }
            l.ref !== null && Mj(l);
          }
          return Ps(l), null;
        }
        case S: {
          var Ye = g;
          if (i && l.stateNode != null) {
            var Ke = i.memoizedProps;
            $j(i, l, Ke, Ye);
          } else {
            if (typeof Ye != "string" && l.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var rt = N$(), Ft = OE(), gn = sw(l);
            gn ? Yfe(l) && qg(l) : l.stateNode = $de(Ye, rt, Ft, l);
          }
          return Ps(l), null;
        }
        case $: {
          Wg(l);
          var un = l.memoizedState;
          if (i === null || i.memoizedState !== null && i.memoizedState.dehydrated !== null) {
            var Nr = phe(i, l, un);
            if (!Nr)
              return l.flags & Ci ? l : null;
          }
          if ((l.flags & $n) !== hn)
            return l.lanes = h, (l.mode & jn) !== an && lI(l), l;
          var yr = un !== null, Ve = i !== null && i.memoizedState !== null;
          if (yr !== Ve && yr) {
            var at = l.child;
            if (at.flags |= Hd, (l.mode & ln) !== an) {
              var Ue = i === null && (l.memoizedProps.unstable_avoidThisFallback !== !0 || !ye);
              Ue || ME(Qc.current, R$) ? hme() : nk();
            }
          }
          var Ct = l.updateQueue;
          if (Ct !== null && (l.flags |= Yn), Ps(l), (l.mode & jn) !== an && yr) {
            var Ht = l.child;
            Ht !== null && (l.treeBaseDuration -= Ht.treeBaseDuration);
          }
          return null;
        }
        case y:
          return zg(l), jI(i, l), i === null && Nfe(l.stateNode.containerInfo), Ps(l), null;
        case R:
          var Bt = l.type._context;
          return xE(Bt, l), Ps(l), null;
        case K: {
          var Tn = l.type;
          return rf(Tn) && tw(l), Ps(l), null;
        }
        case pe: {
          Wg(l);
          var Un = l.memoizedState;
          if (Un === null)
            return Ps(l), null;
          var va = (l.flags & $n) !== hn, zr = Un.rendering;
          if (zr === null)
            if (va)
              R3(Un, !1);
            else {
              var di = vme() && (i === null || (i.flags & $n) === hn);
              if (!di)
                for (var Hr = l.child; Hr !== null; ) {
                  var Go = Sw(Hr);
                  if (Go !== null) {
                    va = !0, l.flags |= $n, R3(Un, !1);
                    var al = Go.updateQueue;
                    return al !== null && (l.updateQueue = al, l.flags |= Yn), l.subtreeFlags = hn, ape(l, h), em(l, DE(Qc.current, _3)), l.child;
                  }
                  Hr = Hr.sibling;
                }
              Un.tail !== null && eo() > oF() && (l.flags |= $n, va = !0, R3(Un, !1), l.lanes = i5);
            }
          else {
            if (!va) {
              var Ms = Sw(zr);
              if (Ms !== null) {
                l.flags |= $n, va = !0;
                var Au = Ms.updateQueue;
                if (Au !== null && (l.updateQueue = Au, l.flags |= Yn), R3(Un, !0), Un.tail === null && Un.tailMode === "hidden" && !zr.alternate && !ks())
                  return Ps(l), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              eo() * 2 - Un.renderingStartTime > oF() && h !== ss && (l.flags |= $n, va = !0, R3(Un, !1), l.lanes = i5);
            }
            if (Un.isBackwards)
              zr.sibling = l.child, l.child = zr;
            else {
              var Il = Un.last;
              Il !== null ? Il.sibling = zr : l.child = zr, Un.last = zr;
            }
          }
          if (Un.tail !== null) {
            var kl = Un.tail;
            Un.rendering = kl, Un.tail = kl.sibling, Un.renderingStartTime = eo(), kl.sibling = null;
            var ol = Qc.current;
            return va ? ol = DE(ol, _3) : ol = Hg(ol), em(l, ol), kl;
          }
          return Ps(l), null;
        }
        case he:
          break;
        case _e:
        case ge: {
          tk(l);
          var xp = l.memoizedState, oy = xp !== null;
          if (i !== null) {
            var X3 = i.memoizedState, ff = X3 !== null;
            ff !== oy && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !X && (l.flags |= Hd);
          }
          return !oy || (l.mode & ln) === an ? Ps(l) : Qs(df, ss) && (Ps(l), l.subtreeFlags & (Ma | Yn) && (l.flags |= Hd)), null;
        }
        case Y:
          return null;
        case ee:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + l.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function hhe(i, l, h) {
      switch (cE(l), l.tag) {
        case f: {
          var g = l.type;
          rf(g) && tw(l);
          var w = l.flags;
          return w & Ci ? (l.flags = w & ~Ci | $n, (l.mode & jn) !== an && lI(l), l) : null;
        }
        case v: {
          l.stateNode, zg(l), iE(l), $E();
          var A = l.flags;
          return (A & Ci) !== hn && (A & $n) === hn ? (l.flags = A & ~Ci | $n, l) : null;
        }
        case b:
          return RE(l), null;
        case $: {
          Wg(l);
          var L = l.memoizedState;
          if (L !== null && L.dehydrated !== null) {
            if (l.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Bg();
          }
          var F = l.flags;
          return F & Ci ? (l.flags = F & ~Ci | $n, (l.mode & jn) !== an && lI(l), l) : null;
        }
        case pe:
          return Wg(l), null;
        case y:
          return zg(l), null;
        case R:
          var V = l.type._context;
          return xE(V, l), null;
        case _e:
        case ge:
          return tk(l), null;
        case Y:
          return null;
        default:
          return null;
      }
    }
    function Fj(i, l, h) {
      switch (cE(l), l.tag) {
        case f: {
          var g = l.type.childContextTypes;
          g != null && tw(l);
          break;
        }
        case v: {
          l.stateNode, zg(l), iE(l), $E();
          break;
        }
        case b: {
          RE(l);
          break;
        }
        case y:
          zg(l);
          break;
        case $:
          Wg(l);
          break;
        case pe:
          Wg(l);
          break;
        case R:
          var w = l.type._context;
          xE(w, l);
          break;
        case _e:
        case ge:
          tk(l);
          break;
      }
    }
    var Bj = null;
    Bj = /* @__PURE__ */ new Set();
    var Zw = !1, Ns = !1, mhe = typeof WeakSet == "function" ? WeakSet : Set, en = null, Jg = null, Qg = null;
    function vhe(i) {
      Xf(null, function() {
        throw i;
      }), vb();
    }
    var ghe = function(i, l) {
      if (l.props = i.memoizedProps, l.state = i.memoizedState, i.mode & jn)
        try {
          uf(), l.componentWillUnmount();
        } finally {
          lf(i);
        }
      else
        l.componentWillUnmount();
    };
    function Vj(i, l) {
      try {
        rm(Fi, i);
      } catch (h) {
        $a(i, l, h);
      }
    }
    function FI(i, l, h) {
      try {
        ghe(i, h);
      } catch (g) {
        $a(i, l, g);
      }
    }
    function yhe(i, l, h) {
      try {
        h.componentDidMount();
      } catch (g) {
        $a(i, l, g);
      }
    }
    function Uj(i, l) {
      try {
        zj(i);
      } catch (h) {
        $a(i, l, h);
      }
    }
    function ey(i, l) {
      var h = i.ref;
      if (h !== null)
        if (typeof h == "function") {
          var g;
          try {
            if (ie && $e && i.mode & jn)
              try {
                uf(), g = h(null);
              } finally {
                lf(i);
              }
            else
              g = h(null);
          } catch (w) {
            $a(i, l, w);
          }
          typeof g == "function" && s("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", In(i));
        } else
          h.current = null;
    }
    function Yw(i, l, h) {
      try {
        h();
      } catch (g) {
        $a(i, l, g);
      }
    }
    var Gj = !1;
    function bhe(i, l) {
      Tde(i.containerInfo), en = l, _he();
      var h = Gj;
      return Gj = !1, h;
    }
    function _he() {
      for (; en !== null; ) {
        var i = en, l = i.child;
        (i.subtreeFlags & vh) !== hn && l !== null ? (l.return = i, en = l) : Che();
      }
    }
    function Che() {
      for (; en !== null; ) {
        var i = en;
        Vr(i);
        try {
          whe(i);
        } catch (h) {
          $a(i, i.return, h);
        }
        so();
        var l = i.sibling;
        if (l !== null) {
          l.return = i.return, en = l;
          return;
        }
        en = i.return;
      }
    }
    function whe(i) {
      var l = i.alternate, h = i.flags;
      if ((h & Bl) !== hn) {
        switch (Vr(i), i.tag) {
          case u:
          case O:
          case G:
            break;
          case f: {
            if (l !== null) {
              var g = l.memoizedProps, w = l.memoizedState, A = i.stateNode;
              i.type === i.elementType && !r0 && (A.props !== i.memoizedProps && s("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", In(i) || "instance"), A.state !== i.memoizedState && s("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", In(i) || "instance"));
              var L = A.getSnapshotBeforeUpdate(i.elementType === i.type ? g : td(i.type, g), w);
              {
                var F = Bj;
                L === void 0 && !F.has(i.type) && (F.add(i.type), s("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", In(i)));
              }
              A.__reactInternalSnapshotBeforeUpdate = L;
            }
            break;
          }
          case v: {
            {
              var V = i.stateNode;
              nfe(V.containerInfo);
            }
            break;
          }
          case b:
          case S:
          case y:
          case K:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        so();
      }
    }
    function rd(i, l, h) {
      var g = l.updateQueue, w = g !== null ? g.lastEffect : null;
      if (w !== null) {
        var A = w.next, L = A;
        do {
          if ((L.tag & i) === i) {
            var F = L.destroy;
            L.destroy = void 0, F !== void 0 && ((i & As) !== eu ? r5(l) : (i & Fi) !== eu && Eu(l), (i & af) !== eu && W3(!0), Yw(l, h, F), (i & af) !== eu && W3(!1), (i & As) !== eu ? B1() : (i & Fi) !== eu && _h());
          }
          L = L.next;
        } while (L !== A);
      }
    }
    function rm(i, l) {
      var h = l.updateQueue, g = h !== null ? h.lastEffect : null;
      if (g !== null) {
        var w = g.next, A = w;
        do {
          if ((A.tag & i) === i) {
            (i & As) !== eu ? Yd(l) : (i & Fi) !== eu && a5(l);
            var L = A.create;
            (i & af) !== eu && W3(!0), A.destroy = L(), (i & af) !== eu && W3(!1), (i & As) !== eu ? F1() : (i & Fi) !== eu && Sv();
            {
              var F = A.destroy;
              if (F !== void 0 && typeof F != "function") {
                var V = void 0;
                (A.tag & Fi) !== hn ? V = "useLayoutEffect" : (A.tag & af) !== hn ? V = "useInsertionEffect" : V = "useEffect";
                var J = void 0;
                F === null ? J = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof F.then == "function" ? J = `

It looks like you wrote ` + V + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + V + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : J = " You returned: " + F, s("%s must not return anything besides a function, which is used for clean-up.%s", V, J);
              }
            }
          }
          A = A.next;
        } while (A !== w);
      }
    }
    function She(i, l) {
      if ((l.flags & Yn) !== hn)
        switch (l.tag) {
          case D: {
            var h = l.stateNode.passiveEffectDuration, g = l.memoizedProps, w = g.id, A = g.onPostCommit, L = oj(), F = l.alternate === null ? "mount" : "update";
            aj() && (F = "nested-update"), typeof A == "function" && A(w, F, h, L);
            var V = l.return;
            e: for (; V !== null; ) {
              switch (V.tag) {
                case v:
                  var J = V.stateNode;
                  J.passiveEffectDuration += h;
                  break e;
                case D:
                  var ae = V.stateNode;
                  ae.passiveEffectDuration += h;
                  break e;
              }
              V = V.return;
            }
            break;
          }
        }
    }
    function xhe(i, l, h, g) {
      if ((h.flags & os) !== hn)
        switch (h.tag) {
          case u:
          case O:
          case G: {
            if (!Ns)
              if (h.mode & jn)
                try {
                  uf(), rm(Fi | ji, h);
                } finally {
                  lf(h);
                }
              else
                rm(Fi | ji, h);
            break;
          }
          case f: {
            var w = h.stateNode;
            if (h.flags & Yn && !Ns)
              if (l === null)
                if (h.type === h.elementType && !r0 && (w.props !== h.memoizedProps && s("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", In(h) || "instance"), w.state !== h.memoizedState && s("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", In(h) || "instance")), h.mode & jn)
                  try {
                    uf(), w.componentDidMount();
                  } finally {
                    lf(h);
                  }
                else
                  w.componentDidMount();
              else {
                var A = h.elementType === h.type ? l.memoizedProps : td(h.type, l.memoizedProps), L = l.memoizedState;
                if (h.type === h.elementType && !r0 && (w.props !== h.memoizedProps && s("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", In(h) || "instance"), w.state !== h.memoizedState && s("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", In(h) || "instance")), h.mode & jn)
                  try {
                    uf(), w.componentDidUpdate(A, L, w.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    lf(h);
                  }
                else
                  w.componentDidUpdate(A, L, w.__reactInternalSnapshotBeforeUpdate);
              }
            var F = h.updateQueue;
            F !== null && (h.type === h.elementType && !r0 && (w.props !== h.memoizedProps && s("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", In(h) || "instance"), w.state !== h.memoizedState && s("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", In(h) || "instance")), P$(h, F, w));
            break;
          }
          case v: {
            var V = h.updateQueue;
            if (V !== null) {
              var J = null;
              if (h.child !== null)
                switch (h.child.tag) {
                  case b:
                    J = h.child.stateNode;
                    break;
                  case f:
                    J = h.child.stateNode;
                    break;
                }
              P$(h, V, J);
            }
            break;
          }
          case b: {
            var ae = h.stateNode;
            if (l === null && h.flags & Yn) {
              var Me = h.type, Te = h.memoizedProps;
              Ude(ae, Me, Te);
            }
            break;
          }
          case S:
            break;
          case y:
            break;
          case D: {
            {
              var Ye = h.memoizedProps, Ke = Ye.onCommit, rt = Ye.onRender, Ft = h.stateNode.effectDuration, gn = oj(), un = l === null ? "mount" : "update";
              aj() && (un = "nested-update"), typeof rt == "function" && rt(h.memoizedProps.id, un, h.actualDuration, h.treeBaseDuration, h.actualStartTime, gn);
              {
                typeof Ke == "function" && Ke(h.memoizedProps.id, un, Ft, gn), Cme(h);
                var Nr = h.return;
                e: for (; Nr !== null; ) {
                  switch (Nr.tag) {
                    case v:
                      var yr = Nr.stateNode;
                      yr.effectDuration += Ft;
                      break e;
                    case D:
                      var Ve = Nr.stateNode;
                      Ve.effectDuration += Ft;
                      break e;
                  }
                  Nr = Nr.return;
                }
              }
            }
            break;
          }
          case $: {
            Ohe(i, h);
            break;
          }
          case pe:
          case K:
          case he:
          case _e:
          case ge:
          case ee:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      Ns || h.flags & Hs && zj(h);
    }
    function Ehe(i) {
      switch (i.tag) {
        case u:
        case O:
        case G: {
          if (i.mode & jn)
            try {
              uf(), Vj(i, i.return);
            } finally {
              lf(i);
            }
          else
            Vj(i, i.return);
          break;
        }
        case f: {
          var l = i.stateNode;
          typeof l.componentDidMount == "function" && yhe(i, i.return, l), Uj(i, i.return);
          break;
        }
        case b: {
          Uj(i, i.return);
          break;
        }
      }
    }
    function Ihe(i, l) {
      for (var h = null, g = i; ; ) {
        if (g.tag === b) {
          if (h === null) {
            h = g;
            try {
              var w = g.stateNode;
              l ? Jde(w) : efe(g.stateNode, g.memoizedProps);
            } catch (L) {
              $a(i, i.return, L);
            }
          }
        } else if (g.tag === S) {
          if (h === null)
            try {
              var A = g.stateNode;
              l ? Qde(A) : tfe(A, g.memoizedProps);
            } catch (L) {
              $a(i, i.return, L);
            }
        } else if (!((g.tag === _e || g.tag === ge) && g.memoizedState !== null && g !== i)) {
          if (g.child !== null) {
            g.child.return = g, g = g.child;
            continue;
          }
        }
        if (g === i)
          return;
        for (; g.sibling === null; ) {
          if (g.return === null || g.return === i)
            return;
          h === g && (h = null), g = g.return;
        }
        h === g && (h = null), g.sibling.return = g.return, g = g.sibling;
      }
    }
    function zj(i) {
      var l = i.ref;
      if (l !== null) {
        var h = i.stateNode, g;
        switch (i.tag) {
          case b:
            g = h;
            break;
          default:
            g = h;
        }
        if (typeof l == "function") {
          var w;
          if (i.mode & jn)
            try {
              uf(), w = l(g);
            } finally {
              lf(i);
            }
          else
            w = l(g);
          typeof w == "function" && s("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", In(i));
        } else
          l.hasOwnProperty("current") || s("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", In(i)), l.current = g;
      }
    }
    function khe(i) {
      var l = i.alternate;
      l !== null && (l.return = null), i.return = null;
    }
    function Hj(i) {
      var l = i.alternate;
      l !== null && (i.alternate = null, Hj(l));
      {
        if (i.child = null, i.deletions = null, i.sibling = null, i.tag === b) {
          var h = i.stateNode;
          h !== null && Rfe(h);
        }
        i.stateNode = null, i._debugOwner = null, i.return = null, i.dependencies = null, i.memoizedProps = null, i.memoizedState = null, i.pendingProps = null, i.stateNode = null, i.updateQueue = null;
      }
    }
    function Ahe(i) {
      for (var l = i.return; l !== null; ) {
        if (Wj(l))
          return l;
        l = l.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Wj(i) {
      return i.tag === b || i.tag === v || i.tag === y;
    }
    function Zj(i) {
      var l = i;
      e: for (; ; ) {
        for (; l.sibling === null; ) {
          if (l.return === null || Wj(l.return))
            return null;
          l = l.return;
        }
        for (l.sibling.return = l.return, l = l.sibling; l.tag !== b && l.tag !== S && l.tag !== q; ) {
          if (l.flags & Ma || l.child === null || l.tag === y)
            continue e;
          l.child.return = l, l = l.child;
        }
        if (!(l.flags & Ma))
          return l.stateNode;
      }
    }
    function Phe(i) {
      var l = Ahe(i);
      switch (l.tag) {
        case b: {
          var h = l.stateNode;
          l.flags & ta && (XL(h), l.flags &= ~ta);
          var g = Zj(i);
          VI(i, g, h);
          break;
        }
        case v:
        case y: {
          var w = l.stateNode.containerInfo, A = Zj(i);
          BI(i, A, w);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function BI(i, l, h) {
      var g = i.tag, w = g === b || g === S;
      if (w) {
        var A = i.stateNode;
        l ? Yde(h, A, l) : Wde(h, A);
      } else if (g !== y) {
        var L = i.child;
        if (L !== null) {
          BI(L, l, h);
          for (var F = L.sibling; F !== null; )
            BI(F, l, h), F = F.sibling;
        }
      }
    }
    function VI(i, l, h) {
      var g = i.tag, w = g === b || g === S;
      if (w) {
        var A = i.stateNode;
        l ? Zde(h, A, l) : Hde(h, A);
      } else if (g !== y) {
        var L = i.child;
        if (L !== null) {
          VI(L, l, h);
          for (var F = L.sibling; F !== null; )
            VI(F, l, h), F = F.sibling;
        }
      }
    }
    var Ts = null, ad = !1;
    function Nhe(i, l, h) {
      {
        var g = l;
        e: for (; g !== null; ) {
          switch (g.tag) {
            case b: {
              Ts = g.stateNode, ad = !1;
              break e;
            }
            case v: {
              Ts = g.stateNode.containerInfo, ad = !0;
              break e;
            }
            case y: {
              Ts = g.stateNode.containerInfo, ad = !0;
              break e;
            }
          }
          g = g.return;
        }
        if (Ts === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        Yj(i, l, h), Ts = null, ad = !1;
      }
      khe(h);
    }
    function am(i, l, h) {
      for (var g = h.child; g !== null; )
        Yj(i, l, g), g = g.sibling;
    }
    function Yj(i, l, h) {
      switch (Jf(h), h.tag) {
        case b:
          Ns || ey(h, l);
        case S: {
          {
            var g = Ts, w = ad;
            Ts = null, am(i, l, h), Ts = g, ad = w, Ts !== null && (ad ? Kde(Ts, h.stateNode) : Xde(Ts, h.stateNode));
          }
          return;
        }
        case q: {
          Ts !== null && (ad ? qde(Ts, h.stateNode) : J9(Ts, h.stateNode));
          return;
        }
        case y: {
          {
            var A = Ts, L = ad;
            Ts = h.stateNode.containerInfo, ad = !0, am(i, l, h), Ts = A, ad = L;
          }
          return;
        }
        case u:
        case O:
        case B:
        case G: {
          if (!Ns) {
            var F = h.updateQueue;
            if (F !== null) {
              var V = F.lastEffect;
              if (V !== null) {
                var J = V.next, ae = J;
                do {
                  var Me = ae, Te = Me.destroy, Ye = Me.tag;
                  Te !== void 0 && ((Ye & af) !== eu ? Yw(h, l, Te) : (Ye & Fi) !== eu && (Eu(h), h.mode & jn ? (uf(), Yw(h, l, Te), lf(h)) : Yw(h, l, Te), _h())), ae = ae.next;
                } while (ae !== J);
              }
            }
          }
          am(i, l, h);
          return;
        }
        case f: {
          if (!Ns) {
            ey(h, l);
            var Ke = h.stateNode;
            typeof Ke.componentWillUnmount == "function" && FI(h, l, Ke);
          }
          am(i, l, h);
          return;
        }
        case he: {
          am(i, l, h);
          return;
        }
        case _e: {
          if (
            // TODO: Remove this dead flag
            h.mode & ln
          ) {
            var rt = Ns;
            Ns = rt || h.memoizedState !== null, am(i, l, h), Ns = rt;
          } else
            am(i, l, h);
          break;
        }
        default: {
          am(i, l, h);
          return;
        }
      }
    }
    function The(i) {
      i.memoizedState;
    }
    function Ohe(i, l) {
      var h = l.memoizedState;
      if (h === null) {
        var g = l.alternate;
        if (g !== null) {
          var w = g.memoizedState;
          if (w !== null) {
            var A = w.dehydrated;
            A !== null && vfe(A);
          }
        }
      }
    }
    function Xj(i) {
      var l = i.updateQueue;
      if (l !== null) {
        i.updateQueue = null;
        var h = i.stateNode;
        h === null && (h = i.stateNode = new mhe()), l.forEach(function(g) {
          var w = Ame.bind(null, i, g);
          if (!h.has(g)) {
            if (h.add(g), _l)
              if (Jg !== null && Qg !== null)
                H3(Qg, Jg);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            g.then(w, w);
          }
        });
      }
    }
    function Rhe(i, l, h) {
      Jg = h, Qg = i, Vr(l), Kj(l, i), Vr(l), Jg = null, Qg = null;
    }
    function od(i, l, h) {
      var g = l.deletions;
      if (g !== null)
        for (var w = 0; w < g.length; w++) {
          var A = g[w];
          try {
            Nhe(i, l, A);
          } catch (V) {
            $a(A, l, V);
          }
        }
      var L = m1();
      if (l.subtreeFlags & Ys)
        for (var F = l.child; F !== null; )
          Vr(F), Kj(F, i), F = F.sibling;
      Vr(L);
    }
    function Kj(i, l, h) {
      var g = i.alternate, w = i.flags;
      switch (i.tag) {
        case u:
        case O:
        case B:
        case G: {
          if (od(l, i), cf(i), w & Yn) {
            try {
              rd(af | ji, i, i.return), rm(af | ji, i);
            } catch (Tn) {
              $a(i, i.return, Tn);
            }
            if (i.mode & jn) {
              try {
                uf(), rd(Fi | ji, i, i.return);
              } catch (Tn) {
                $a(i, i.return, Tn);
              }
              lf(i);
            } else
              try {
                rd(Fi | ji, i, i.return);
              } catch (Tn) {
                $a(i, i.return, Tn);
              }
          }
          return;
        }
        case f: {
          od(l, i), cf(i), w & Hs && g !== null && ey(g, g.return);
          return;
        }
        case b: {
          od(l, i), cf(i), w & Hs && g !== null && ey(g, g.return);
          {
            if (i.flags & ta) {
              var A = i.stateNode;
              try {
                XL(A);
              } catch (Tn) {
                $a(i, i.return, Tn);
              }
            }
            if (w & Yn) {
              var L = i.stateNode;
              if (L != null) {
                var F = i.memoizedProps, V = g !== null ? g.memoizedProps : F, J = i.type, ae = i.updateQueue;
                if (i.updateQueue = null, ae !== null)
                  try {
                    Gde(L, ae, J, V, F, i);
                  } catch (Tn) {
                    $a(i, i.return, Tn);
                  }
              }
            }
          }
          return;
        }
        case S: {
          if (od(l, i), cf(i), w & Yn) {
            if (i.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var Me = i.stateNode, Te = i.memoizedProps, Ye = g !== null ? g.memoizedProps : Te;
            try {
              zde(Me, Ye, Te);
            } catch (Tn) {
              $a(i, i.return, Tn);
            }
          }
          return;
        }
        case v: {
          if (od(l, i), cf(i), w & Yn && g !== null) {
            var Ke = g.memoizedState;
            if (Ke.isDehydrated)
              try {
                mfe(l.containerInfo);
              } catch (Tn) {
                $a(i, i.return, Tn);
              }
          }
          return;
        }
        case y: {
          od(l, i), cf(i);
          return;
        }
        case $: {
          od(l, i), cf(i);
          var rt = i.child;
          if (rt.flags & Hd) {
            var Ft = rt.stateNode, gn = rt.memoizedState, un = gn !== null;
            if (Ft.isHidden = un, un) {
              var Nr = rt.alternate !== null && rt.alternate.memoizedState !== null;
              Nr || pme();
            }
          }
          if (w & Yn) {
            try {
              The(i);
            } catch (Tn) {
              $a(i, i.return, Tn);
            }
            Xj(i);
          }
          return;
        }
        case _e: {
          var yr = g !== null && g.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            i.mode & ln
          ) {
            var Ve = Ns;
            Ns = Ve || yr, od(l, i), Ns = Ve;
          } else
            od(l, i);
          if (cf(i), w & Hd) {
            var at = i.stateNode, Ue = i.memoizedState, Ct = Ue !== null, Ht = i;
            if (at.isHidden = Ct, Ct && !yr && (Ht.mode & ln) !== an) {
              en = Ht;
              for (var Bt = Ht.child; Bt !== null; )
                en = Bt, Dhe(Bt), Bt = Bt.sibling;
            }
            Ihe(Ht, Ct);
          }
          return;
        }
        case pe: {
          od(l, i), cf(i), w & Yn && Xj(i);
          return;
        }
        case he:
          return;
        default: {
          od(l, i), cf(i);
          return;
        }
      }
    }
    function cf(i) {
      var l = i.flags;
      if (l & Ma) {
        try {
          Phe(i);
        } catch (h) {
          $a(i, i.return, h);
        }
        i.flags &= ~Ma;
      }
      l & Vl && (i.flags &= ~Vl);
    }
    function Mhe(i, l, h) {
      Jg = h, Qg = l, en = i, qj(i, l, h), Jg = null, Qg = null;
    }
    function qj(i, l, h) {
      for (var g = (i.mode & ln) !== an; en !== null; ) {
        var w = en, A = w.child;
        if (w.tag === _e && g) {
          var L = w.memoizedState !== null, F = L || Zw;
          if (F) {
            UI(i, l, h);
            continue;
          } else {
            var V = w.alternate, J = V !== null && V.memoizedState !== null, ae = J || Ns, Me = Zw, Te = Ns;
            Zw = F, Ns = ae, Ns && !Te && (en = w, Lhe(w));
            for (var Ye = A; Ye !== null; )
              en = Ye, qj(
                Ye,
                // New root; bubble back up to here and stop.
                l,
                h
              ), Ye = Ye.sibling;
            en = w, Zw = Me, Ns = Te, UI(i, l, h);
            continue;
          }
        }
        (w.subtreeFlags & os) !== hn && A !== null ? (A.return = w, en = A) : UI(i, l, h);
      }
    }
    function UI(i, l, h) {
      for (; en !== null; ) {
        var g = en;
        if ((g.flags & os) !== hn) {
          var w = g.alternate;
          Vr(g);
          try {
            xhe(l, w, g, h);
          } catch (L) {
            $a(g, g.return, L);
          }
          so();
        }
        if (g === i) {
          en = null;
          return;
        }
        var A = g.sibling;
        if (A !== null) {
          A.return = g.return, en = A;
          return;
        }
        en = g.return;
      }
    }
    function Dhe(i) {
      for (; en !== null; ) {
        var l = en, h = l.child;
        switch (l.tag) {
          case u:
          case O:
          case B:
          case G: {
            if (l.mode & jn)
              try {
                uf(), rd(Fi, l, l.return);
              } finally {
                lf(l);
              }
            else
              rd(Fi, l, l.return);
            break;
          }
          case f: {
            ey(l, l.return);
            var g = l.stateNode;
            typeof g.componentWillUnmount == "function" && FI(l, l.return, g);
            break;
          }
          case b: {
            ey(l, l.return);
            break;
          }
          case _e: {
            var w = l.memoizedState !== null;
            if (w) {
              Jj(i);
              continue;
            }
            break;
          }
        }
        h !== null ? (h.return = l, en = h) : Jj(i);
      }
    }
    function Jj(i) {
      for (; en !== null; ) {
        var l = en;
        if (l === i) {
          en = null;
          return;
        }
        var h = l.sibling;
        if (h !== null) {
          h.return = l.return, en = h;
          return;
        }
        en = l.return;
      }
    }
    function Lhe(i) {
      for (; en !== null; ) {
        var l = en, h = l.child;
        if (l.tag === _e) {
          var g = l.memoizedState !== null;
          if (g) {
            Qj(i);
            continue;
          }
        }
        h !== null ? (h.return = l, en = h) : Qj(i);
      }
    }
    function Qj(i) {
      for (; en !== null; ) {
        var l = en;
        Vr(l);
        try {
          Ehe(l);
        } catch (g) {
          $a(l, l.return, g);
        }
        if (so(), l === i) {
          en = null;
          return;
        }
        var h = l.sibling;
        if (h !== null) {
          h.return = l.return, en = h;
          return;
        }
        en = l.return;
      }
    }
    function $he(i, l, h, g) {
      en = l, jhe(l, i, h, g);
    }
    function jhe(i, l, h, g) {
      for (; en !== null; ) {
        var w = en, A = w.child;
        (w.subtreeFlags & Ul) !== hn && A !== null ? (A.return = w, en = A) : Fhe(i, l, h, g);
      }
    }
    function Fhe(i, l, h, g) {
      for (; en !== null; ) {
        var w = en;
        if ((w.flags & Ga) !== hn) {
          Vr(w);
          try {
            Bhe(l, w, h, g);
          } catch (L) {
            $a(w, w.return, L);
          }
          so();
        }
        if (w === i) {
          en = null;
          return;
        }
        var A = w.sibling;
        if (A !== null) {
          A.return = w.return, en = A;
          return;
        }
        en = w.return;
      }
    }
    function Bhe(i, l, h, g) {
      switch (l.tag) {
        case u:
        case O:
        case G: {
          if (l.mode & jn) {
            sI();
            try {
              rm(As | ji, l);
            } finally {
              iI(l);
            }
          } else
            rm(As | ji, l);
          break;
        }
      }
    }
    function Vhe(i) {
      en = i, Uhe();
    }
    function Uhe() {
      for (; en !== null; ) {
        var i = en, l = i.child;
        if ((en.flags & Kr) !== hn) {
          var h = i.deletions;
          if (h !== null) {
            for (var g = 0; g < h.length; g++) {
              var w = h[g];
              en = w, Hhe(w, i);
            }
            {
              var A = i.alternate;
              if (A !== null) {
                var L = A.child;
                if (L !== null) {
                  A.child = null;
                  do {
                    var F = L.sibling;
                    L.sibling = null, L = F;
                  } while (L !== null);
                }
              }
            }
            en = i;
          }
        }
        (i.subtreeFlags & Ul) !== hn && l !== null ? (l.return = i, en = l) : Ghe();
      }
    }
    function Ghe() {
      for (; en !== null; ) {
        var i = en;
        (i.flags & Ga) !== hn && (Vr(i), zhe(i), so());
        var l = i.sibling;
        if (l !== null) {
          l.return = i.return, en = l;
          return;
        }
        en = i.return;
      }
    }
    function zhe(i) {
      switch (i.tag) {
        case u:
        case O:
        case G: {
          i.mode & jn ? (sI(), rd(As | ji, i, i.return), iI(i)) : rd(As | ji, i, i.return);
          break;
        }
      }
    }
    function Hhe(i, l) {
      for (; en !== null; ) {
        var h = en;
        Vr(h), Zhe(h, l), so();
        var g = h.child;
        g !== null ? (g.return = h, en = g) : Whe(i);
      }
    }
    function Whe(i) {
      for (; en !== null; ) {
        var l = en, h = l.sibling, g = l.return;
        if (Hj(l), l === i) {
          en = null;
          return;
        }
        if (h !== null) {
          h.return = g, en = h;
          return;
        }
        en = g;
      }
    }
    function Zhe(i, l) {
      switch (i.tag) {
        case u:
        case O:
        case G: {
          i.mode & jn ? (sI(), rd(As, i, l), iI(i)) : rd(As, i, l);
          break;
        }
      }
    }
    function Yhe(i) {
      switch (i.tag) {
        case u:
        case O:
        case G: {
          try {
            rm(Fi | ji, i);
          } catch (h) {
            $a(i, i.return, h);
          }
          break;
        }
        case f: {
          var l = i.stateNode;
          try {
            l.componentDidMount();
          } catch (h) {
            $a(i, i.return, h);
          }
          break;
        }
      }
    }
    function Xhe(i) {
      switch (i.tag) {
        case u:
        case O:
        case G: {
          try {
            rm(As | ji, i);
          } catch (l) {
            $a(i, i.return, l);
          }
          break;
        }
      }
    }
    function Khe(i) {
      switch (i.tag) {
        case u:
        case O:
        case G: {
          try {
            rd(Fi | ji, i, i.return);
          } catch (h) {
            $a(i, i.return, h);
          }
          break;
        }
        case f: {
          var l = i.stateNode;
          typeof l.componentWillUnmount == "function" && FI(i, i.return, l);
          break;
        }
      }
    }
    function qhe(i) {
      switch (i.tag) {
        case u:
        case O:
        case G:
          try {
            rd(As | ji, i, i.return);
          } catch (l) {
            $a(i, i.return, l);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var M3 = Symbol.for;
      M3("selector.component"), M3("selector.has_pseudo_class"), M3("selector.role"), M3("selector.test_id"), M3("selector.text");
    }
    var Jhe = [];
    function Qhe() {
      Jhe.forEach(function(i) {
        return i();
      });
    }
    var eme = n.ReactCurrentActQueue;
    function tme(i) {
      {
        var l = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT != "undefined" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), h = typeof jest != "undefined";
        return h && l !== !1;
      }
    }
    function eF() {
      {
        var i = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT != "undefined" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !i && eme.current !== null && s("The current testing environment is not configured to support act(...)"), i;
      }
    }
    var nme = Math.ceil, GI = n.ReactCurrentDispatcher, zI = n.ReactCurrentOwner, Os = n.ReactCurrentBatchConfig, id = n.ReactCurrentActQueue, Ui = (
      /*             */
      0
    ), tF = (
      /*               */
      1
    ), Rs = (
      /*                */
      2
    ), oc = (
      /*                */
      4
    ), _p = 0, D3 = 1, a0 = 2, Xw = 3, L3 = 4, nF = 5, HI = 6, Pr = Ui, xl = null, No = null, Gi = dt, df = dt, WI = Yh(dt), zi = _p, $3 = null, Kw = dt, j3 = dt, qw = dt, F3 = null, tu = null, ZI = 0, rF = 500, aF = 1 / 0, rme = 500, Cp = null;
    function B3() {
      aF = eo() + rme;
    }
    function oF() {
      return aF;
    }
    var Jw = !1, YI = null, ty = null, o0 = !1, om = null, V3 = dt, XI = [], KI = null, ame = 50, U3 = 0, qI = null, JI = !1, Qw = !1, ome = 50, ny = 0, eS = null, G3 = Na, tS = dt, iF = !1;
    function nS() {
      return xl;
    }
    function El() {
      return (Pr & (Rs | oc)) !== Ui ? eo() : (G3 !== Na || (G3 = eo()), G3);
    }
    function im(i) {
      var l = i.mode;
      if ((l & ln) === an)
        return cn;
      if ((Pr & Rs) !== Ui && Gi !== dt)
        return Ph(Gi);
      var h = epe() !== Qfe;
      if (h) {
        if (Os.transition !== null) {
          var g = Os.transition;
          g._updatedFibers || (g._updatedFibers = /* @__PURE__ */ new Set()), g._updatedFibers.add(i);
        }
        return tS === Uo && (tS = h5()), tS;
      }
      var w = Zl();
      if (w !== Uo)
        return w;
      var A = jde();
      return A;
    }
    function ime(i) {
      var l = i.mode;
      return (l & ln) === an ? cn : Js();
    }
    function Hi(i, l, h, g) {
      Nme(), iF && s("useInsertionEffect must not schedule updates."), JI && (Qw = !0), ip(i, h, g), (Pr & Rs) !== dt && i === xl ? Rme(l) : (_l && ug(i, l, h), Mme(l), i === xl && ((Pr & Rs) === Ui && (j3 = Wn(j3, h)), zi === L3 && sm(i, Gi)), nu(i, g), h === cn && Pr === Ui && (l.mode & ln) === an && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !id.isBatchingLegacy && (B3(), i$()));
    }
    function sme(i, l, h) {
      var g = i.current;
      g.lanes = l, ip(i, l, h), nu(i, h);
    }
    function lme(i) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Pr & Rs) !== Ui
      );
    }
    function nu(i, l) {
      var h = i.callbackNode;
      u5(i, l);
      var g = ap(i, i === xl ? Gi : dt);
      if (g === dt) {
        h !== null && wF(h), i.callbackNode = null, i.callbackPriority = Uo;
        return;
      }
      var w = ko(g), A = i.callbackPriority;
      if (A === w && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(id.current !== null && h !== ok)) {
        h == null && A !== cn && s("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      h != null && wF(h);
      var L;
      if (w === cn)
        i.tag === Xh ? (id.isBatchingLegacy !== null && (id.didScheduleLegacyUpdate = !0), Lfe(uF.bind(null, i))) : o$(uF.bind(null, i)), id.current !== null ? id.current.push(Kh) : Bde(function() {
          (Pr & (Rs | oc)) === Ui && Kh();
        }), L = null;
      else {
        var F;
        switch ($i(g)) {
          case Ao:
            F = L1;
            break;
          case Wc:
            F = qf;
            break;
          case Ku:
            F = Xu;
            break;
          case Nh:
            F = $1;
            break;
          default:
            F = Xu;
            break;
        }
        L = ik(F, sF.bind(null, i));
      }
      i.callbackPriority = w, i.callbackNode = L;
    }
    function sF(i, l) {
      if (Ipe(), G3 = Na, tS = dt, (Pr & (Rs | oc)) !== Ui)
        throw new Error("Should not already be working.");
      var h = i.callbackNode, g = Sp();
      if (g && i.callbackNode !== h)
        return null;
      var w = ap(i, i === xl ? Gi : dt);
      if (w === dt)
        return null;
      var A = !Tv(i, w) && !p5(i, w) && !l, L = A ? yme(i, w) : aS(i, w);
      if (L !== _p) {
        if (L === a0) {
          var F = Kd(i);
          F !== dt && (w = F, L = QI(i, F));
        }
        if (L === D3) {
          var V = $3;
          throw i0(i, dt), sm(i, w), nu(i, eo()), V;
        }
        if (L === HI)
          sm(i, w);
        else {
          var J = !Tv(i, w), ae = i.current.alternate;
          if (J && !cme(ae)) {
            if (L = aS(i, w), L === a0) {
              var Me = Kd(i);
              Me !== dt && (w = Me, L = QI(i, Me));
            }
            if (L === D3) {
              var Te = $3;
              throw i0(i, dt), sm(i, w), nu(i, eo()), Te;
            }
          }
          i.finishedWork = ae, i.finishedLanes = w, ume(i, L, w);
        }
      }
      return nu(i, eo()), i.callbackNode === h ? sF.bind(null, i) : null;
    }
    function QI(i, l) {
      var h = F3;
      if (cg(i)) {
        var g = i0(i, l);
        g.flags |= uo, Pfe(i.containerInfo);
      }
      var w = aS(i, l);
      if (w !== a0) {
        var A = tu;
        tu = h, A !== null && lF(A);
      }
      return w;
    }
    function lF(i) {
      tu === null ? tu = i : tu.push.apply(tu, i);
    }
    function ume(i, l, h) {
      switch (l) {
        case _p:
        case D3:
          throw new Error("Root did not complete. This is a bug in React.");
        case a0: {
          s0(i, tu, Cp);
          break;
        }
        case Xw: {
          if (sm(i, h), c5(h) && // do not delay if we're inside an act() scope
          !SF()) {
            var g = ZI + rF - eo();
            if (g > 10) {
              var w = ap(i, dt);
              if (w !== dt)
                break;
              var A = i.suspendedLanes;
              if (!op(A, h)) {
                El(), sg(i, A);
                break;
              }
              i.timeoutHandle = K9(s0.bind(null, i, tu, Cp), g);
              break;
            }
          }
          s0(i, tu, Cp);
          break;
        }
        case L3: {
          if (sm(i, h), f5(h))
            break;
          if (!SF()) {
            var L = s5(i, h), F = L, V = eo() - F, J = Pme(V) - V;
            if (J > 10) {
              i.timeoutHandle = K9(s0.bind(null, i, tu, Cp), J);
              break;
            }
          }
          s0(i, tu, Cp);
          break;
        }
        case nF: {
          s0(i, tu, Cp);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function cme(i) {
      for (var l = i; ; ) {
        if (l.flags & Cv) {
          var h = l.updateQueue;
          if (h !== null) {
            var g = h.stores;
            if (g !== null)
              for (var w = 0; w < g.length; w++) {
                var A = g[w], L = A.getSnapshot, F = A.value;
                try {
                  if (!Qt(L(), F))
                    return !1;
                } catch (J) {
                  return !1;
                }
              }
          }
        }
        var V = l.child;
        if (l.subtreeFlags & Cv && V !== null) {
          V.return = l, l = V;
          continue;
        }
        if (l === i)
          return !0;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === i)
            return !0;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
      return !0;
    }
    function sm(i, l) {
      l = Ov(l, qw), l = Ov(l, j3), v5(i, l);
    }
    function uF(i) {
      if (kpe(), (Pr & (Rs | oc)) !== Ui)
        throw new Error("Should not already be working.");
      Sp();
      var l = ap(i, dt);
      if (!Qs(l, cn))
        return nu(i, eo()), null;
      var h = aS(i, l);
      if (i.tag !== Xh && h === a0) {
        var g = Kd(i);
        g !== dt && (l = g, h = QI(i, g));
      }
      if (h === D3) {
        var w = $3;
        throw i0(i, dt), sm(i, l), nu(i, eo()), w;
      }
      if (h === HI)
        throw new Error("Root did not complete. This is a bug in React.");
      var A = i.current.alternate;
      return i.finishedWork = A, i.finishedLanes = l, s0(i, tu, Cp), nu(i, eo()), null;
    }
    function dme(i, l) {
      l !== dt && (Rb(i, Wn(l, cn)), nu(i, eo()), (Pr & (Rs | oc)) === Ui && (B3(), Kh()));
    }
    function ek(i, l) {
      var h = Pr;
      Pr |= tF;
      try {
        return i(l);
      } finally {
        Pr = h, Pr === Ui && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !id.isBatchingLegacy && (B3(), i$());
      }
    }
    function fme(i, l, h, g, w) {
      var A = Zl(), L = Os.transition;
      try {
        return Os.transition = null, co(Ao), i(l, h, g, w);
      } finally {
        co(A), Os.transition = L, Pr === Ui && B3();
      }
    }
    function wp(i) {
      om !== null && om.tag === Xh && (Pr & (Rs | oc)) === Ui && Sp();
      var l = Pr;
      Pr |= tF;
      var h = Os.transition, g = Zl();
      try {
        return Os.transition = null, co(Ao), i ? i() : void 0;
      } finally {
        co(g), Os.transition = h, Pr = l, (Pr & (Rs | oc)) === Ui && Kh();
      }
    }
    function cF() {
      return (Pr & (Rs | oc)) !== Ui;
    }
    function rS(i, l) {
      nl(WI, df, i), df = Wn(df, l);
    }
    function tk(i) {
      df = WI.current, tl(WI, i);
    }
    function i0(i, l) {
      i.finishedWork = null, i.finishedLanes = dt;
      var h = i.timeoutHandle;
      if (h !== q9 && (i.timeoutHandle = q9, Fde(h)), No !== null)
        for (var g = No.return; g !== null; ) {
          var w = g.alternate;
          Fj(w, g), g = g.return;
        }
      xl = i;
      var A = l0(i.current, null);
      return No = A, Gi = df = l, zi = _p, $3 = null, Kw = dt, j3 = dt, qw = dt, F3 = null, tu = null, spe(), Jc.discardPendingWarnings(), A;
    }
    function dF(i, l) {
      do {
        var h = No;
        try {
          if (pw(), D$(), so(), zI.current = null, h === null || h.return === null) {
            zi = D3, $3 = l, No = null;
            return;
          }
          if (ie && h.mode & jn && Uw(h, !0), Le)
            if (Ks(), l !== null && typeof l == "object" && typeof l.then == "function") {
              var g = l;
              Qf(h, g, Gi);
            } else
              xv(h, l, Gi);
          Lpe(i, h.return, h, l, Gi), mF(h);
        } catch (w) {
          l = w, No === h && h !== null ? (h = h.return, No = h) : h = No;
          continue;
        }
        return;
      } while (!0);
    }
    function fF() {
      var i = GI.current;
      return GI.current = $w, i === null ? $w : i;
    }
    function pF(i) {
      GI.current = i;
    }
    function pme() {
      ZI = eo();
    }
    function z3(i) {
      Kw = Wn(i, Kw);
    }
    function hme() {
      zi === _p && (zi = Xw);
    }
    function nk() {
      (zi === _p || zi === Xw || zi === a0) && (zi = L3), xl !== null && (Nv(Kw) || Nv(j3)) && sm(xl, Gi);
    }
    function mme(i) {
      zi !== L3 && (zi = a0), F3 === null ? F3 = [i] : F3.push(i);
    }
    function vme() {
      return zi === _p;
    }
    function aS(i, l) {
      var h = Pr;
      Pr |= Rs;
      var g = fF();
      if (xl !== i || Gi !== l) {
        if (_l) {
          var w = i.memoizedUpdaters;
          w.size > 0 && (H3(i, Gi), w.clear()), Mb(i, l);
        }
        Cp = Mv(), i0(i, l);
      }
      za(l);
      do
        try {
          gme();
          break;
        } catch (A) {
          dF(i, A);
        }
      while (!0);
      if (pw(), Pr = h, pF(g), No !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return U1(), xl = null, Gi = dt, zi;
    }
    function gme() {
      for (; No !== null; )
        hF(No);
    }
    function yme(i, l) {
      var h = Pr;
      Pr |= Rs;
      var g = fF();
      if (xl !== i || Gi !== l) {
        if (_l) {
          var w = i.memoizedUpdaters;
          w.size > 0 && (H3(i, Gi), w.clear()), Mb(i, l);
        }
        Cp = Mv(), B3(), i0(i, l);
      }
      za(l);
      do
        try {
          bme();
          break;
        } catch (A) {
          dF(i, A);
        }
      while (!0);
      return pw(), pF(g), Pr = h, No !== null ? (V1(), _p) : (U1(), xl = null, Gi = dt, zi);
    }
    function bme() {
      for (; No !== null && !D1(); )
        hF(No);
    }
    function hF(i) {
      var l = i.alternate;
      Vr(i);
      var h;
      (i.mode & jn) !== an ? (oI(i), h = rk(l, i, df), Uw(i, !0)) : h = rk(l, i, df), so(), i.memoizedProps = i.pendingProps, h === null ? mF(i) : No = h, zI.current = null;
    }
    function mF(i) {
      var l = i;
      do {
        var h = l.alternate, g = l.return;
        if ((l.flags & gl) === hn) {
          Vr(l);
          var w = void 0;
          if ((l.mode & jn) === an ? w = jj(h, l, df) : (oI(l), w = jj(h, l, df), Uw(l, !1)), so(), w !== null) {
            No = w;
            return;
          }
        } else {
          var A = hhe(h, l);
          if (A !== null) {
            A.flags &= KC, No = A;
            return;
          }
          if ((l.mode & jn) !== an) {
            Uw(l, !1);
            for (var L = l.actualDuration, F = l.child; F !== null; )
              L += F.actualDuration, F = F.sibling;
            l.actualDuration = L;
          }
          if (g !== null)
            g.flags |= gl, g.subtreeFlags = hn, g.deletions = null;
          else {
            zi = HI, No = null;
            return;
          }
        }
        var V = l.sibling;
        if (V !== null) {
          No = V;
          return;
        }
        l = g, No = l;
      } while (l !== null);
      zi === _p && (zi = nF);
    }
    function s0(i, l, h) {
      var g = Zl(), w = Os.transition;
      try {
        Os.transition = null, co(Ao), _me(i, l, h, g);
      } finally {
        Os.transition = w, co(g);
      }
      return null;
    }
    function _me(i, l, h, g) {
      do
        Sp();
      while (om !== null);
      if (Tme(), (Pr & (Rs | oc)) !== Ui)
        throw new Error("Should not already be working.");
      var w = i.finishedWork, A = i.finishedLanes;
      if (Zd(A), w === null)
        return j1(), null;
      if (A === dt && s("root.finishedLanes should not be empty during a commit. This is a bug in React."), i.finishedWork = null, i.finishedLanes = dt, w === i.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      i.callbackNode = null, i.callbackPriority = Uo;
      var L = Wn(w.lanes, w.childLanes);
      lg(i, L), i === xl && (xl = null, No = null, Gi = dt), ((w.subtreeFlags & Ul) !== hn || (w.flags & Ul) !== hn) && (o0 || (o0 = !0, KI = h, ik(Xu, function() {
        return Sp(), null;
      })));
      var F = (w.subtreeFlags & (vh | Ys | os | Ul)) !== hn, V = (w.flags & (vh | Ys | os | Ul)) !== hn;
      if (F || V) {
        var J = Os.transition;
        Os.transition = null;
        var ae = Zl();
        co(Ao);
        var Me = Pr;
        Pr |= oc, zI.current = null, bhe(i, w), ij(), Rhe(i, w, A), Ode(i.containerInfo), i.current = w, Eb(A), Mhe(w, i, A), Ch(), QC(), Pr = Me, co(ae), Os.transition = J;
      } else
        i.current = w, ij();
      var Te = o0;
      if (o0 ? (o0 = !1, om = i, V3 = A) : (ny = 0, eS = null), L = i.pendingLanes, L === dt && (ty = null), Te || bF(i.current, !1), yh(w.stateNode, g), _l && i.memoizedUpdaters.clear(), Qhe(), nu(i, eo()), l !== null)
        for (var Ye = i.onRecoverableError, Ke = 0; Ke < l.length; Ke++) {
          var rt = l[Ke], Ft = rt.stack, gn = rt.digest;
          Ye(rt.value, {
            componentStack: Ft,
            digest: gn
          });
        }
      if (Jw) {
        Jw = !1;
        var un = YI;
        throw YI = null, un;
      }
      return Qs(V3, cn) && i.tag !== Xh && Sp(), L = i.pendingLanes, Qs(L, cn) ? (Epe(), i === qI ? U3++ : (U3 = 0, qI = i)) : U3 = 0, Kh(), j1(), null;
    }
    function Sp() {
      if (om !== null) {
        var i = $i(V3), l = C9(Ku, i), h = Os.transition, g = Zl();
        try {
          return Os.transition = null, co(l), wme();
        } finally {
          co(g), Os.transition = h;
        }
      }
      return !1;
    }
    function Cme(i) {
      XI.push(i), o0 || (o0 = !0, ik(Xu, function() {
        return Sp(), null;
      }));
    }
    function wme() {
      if (om === null)
        return !1;
      var i = KI;
      KI = null;
      var l = om, h = V3;
      if (om = null, V3 = dt, (Pr & (Rs | oc)) !== Ui)
        throw new Error("Cannot flush passive effects while already rendering.");
      JI = !0, Qw = !1, o5(h);
      var g = Pr;
      Pr |= oc, Vhe(l.current), $he(l, l.current, h, i);
      {
        var w = XI;
        XI = [];
        for (var A = 0; A < w.length; A++) {
          var L = w[A];
          She(l, L);
        }
      }
      Ib(), bF(l.current, !0), Pr = g, Kh(), Qw ? l === eS ? ny++ : (ny = 0, eS = l) : ny = 0, JI = !1, Qw = !1, Hl(l);
      {
        var F = l.current.stateNode;
        F.effectDuration = 0, F.passiveEffectDuration = 0;
      }
      return !0;
    }
    function vF(i) {
      return ty !== null && ty.has(i);
    }
    function Sme(i) {
      ty === null ? ty = /* @__PURE__ */ new Set([i]) : ty.add(i);
    }
    function xme(i) {
      Jw || (Jw = !0, YI = i);
    }
    var Eme = xme;
    function gF(i, l, h) {
      var g = n0(h, l), w = hj(i, g, cn), A = Jh(i, w, cn), L = El();
      A !== null && (ip(A, cn, L), nu(A, L));
    }
    function $a(i, l, h) {
      if (vhe(h), W3(!1), i.tag === v) {
        gF(i, i, h);
        return;
      }
      var g = null;
      for (g = l; g !== null; ) {
        if (g.tag === v) {
          gF(g, i, h);
          return;
        } else if (g.tag === f) {
          var w = g.type, A = g.stateNode;
          if (typeof w.getDerivedStateFromError == "function" || typeof A.componentDidCatch == "function" && !vF(A)) {
            var L = n0(h, i), F = SI(g, L, cn), V = Jh(g, F, cn), J = El();
            V !== null && (ip(V, cn, J), nu(V, J));
            return;
          }
        }
        g = g.return;
      }
      s(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, h);
    }
    function Ime(i, l, h) {
      var g = i.pingCache;
      g !== null && g.delete(l);
      var w = El();
      sg(i, h), Dme(i), xl === i && op(Gi, h) && (zi === L3 || zi === Xw && c5(Gi) && eo() - ZI < rF ? i0(i, dt) : qw = Wn(qw, h)), nu(i, w);
    }
    function yF(i, l) {
      l === Uo && (l = ime(i));
      var h = El(), g = Ql(i, l);
      g !== null && (ip(g, l, h), nu(g, h));
    }
    function kme(i) {
      var l = i.memoizedState, h = Uo;
      l !== null && (h = l.retryLane), yF(i, h);
    }
    function Ame(i, l) {
      var h = Uo, g;
      switch (i.tag) {
        case $:
          g = i.stateNode;
          var w = i.memoizedState;
          w !== null && (h = w.retryLane);
          break;
        case pe:
          g = i.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      g !== null && g.delete(l), yF(i, h);
    }
    function Pme(i) {
      return i < 120 ? 120 : i < 480 ? 480 : i < 1080 ? 1080 : i < 1920 ? 1920 : i < 3e3 ? 3e3 : i < 4320 ? 4320 : nme(i / 1960) * 1960;
    }
    function Nme() {
      if (U3 > ame)
        throw U3 = 0, qI = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      ny > ome && (ny = 0, eS = null, s("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function Tme() {
      Jc.flushLegacyContextWarning(), Jc.flushPendingUnsafeLifecycleWarnings();
    }
    function bF(i, l) {
      Vr(i), oS(i, Zs, Khe), l && oS(i, Kf, qhe), oS(i, Zs, Yhe), l && oS(i, Kf, Xhe), so();
    }
    function oS(i, l, h) {
      for (var g = i, w = null; g !== null; ) {
        var A = g.subtreeFlags & l;
        g !== w && g.child !== null && A !== hn ? g = g.child : ((g.flags & l) !== hn && h(g), g.sibling !== null ? g = g.sibling : g = w = g.return);
      }
    }
    var iS = null;
    function _F(i) {
      {
        if ((Pr & Rs) !== Ui || !(i.mode & ln))
          return;
        var l = i.tag;
        if (l !== m && l !== v && l !== f && l !== u && l !== O && l !== B && l !== G)
          return;
        var h = In(i) || "ReactComponent";
        if (iS !== null) {
          if (iS.has(h))
            return;
          iS.add(h);
        } else
          iS = /* @__PURE__ */ new Set([h]);
        var g = Ua;
        try {
          Vr(i), s("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          g ? Vr(i) : so();
        }
      }
    }
    var rk;
    {
      var Ome = null;
      rk = function(i, l, h) {
        var g = AF(Ome, l);
        try {
          return Rj(i, l, h);
        } catch (A) {
          if (zfe() || A !== null && typeof A == "object" && typeof A.then == "function")
            throw A;
          if (pw(), D$(), Fj(i, l), AF(l, g), l.mode & jn && oI(l), Xf(null, Rj, null, i, l, h), v9()) {
            var w = vb();
            typeof w == "object" && w !== null && w._suppressLogging && typeof A == "object" && A !== null && !A._suppressLogging && (A._suppressLogging = !0);
          }
          throw A;
        }
      };
    }
    var CF = !1, ak;
    ak = /* @__PURE__ */ new Set();
    function Rme(i) {
      if (ns && !wpe())
        switch (i.tag) {
          case u:
          case O:
          case G: {
            var l = No && In(No) || "Unknown", h = l;
            if (!ak.has(h)) {
              ak.add(h);
              var g = In(i) || "Unknown";
              s("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", g, l, l);
            }
            break;
          }
          case f: {
            CF || (s("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), CF = !0);
            break;
          }
        }
    }
    function H3(i, l) {
      if (_l) {
        var h = i.memoizedUpdaters;
        h.forEach(function(g) {
          ug(i, g, l);
        });
      }
    }
    var ok = {};
    function ik(i, l) {
      {
        var h = id.current;
        return h !== null ? (h.push(l), ok) : M1(i, l);
      }
    }
    function wF(i) {
      if (i !== ok)
        return JC(i);
    }
    function SF() {
      return id.current !== null;
    }
    function Mme(i) {
      {
        if (i.mode & ln) {
          if (!eF())
            return;
        } else if (!tme() || Pr !== Ui || i.tag !== u && i.tag !== O && i.tag !== G)
          return;
        if (id.current === null) {
          var l = Ua;
          try {
            Vr(i), s(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, In(i));
          } finally {
            l ? Vr(i) : so();
          }
        }
      }
    }
    function Dme(i) {
      i.tag !== Xh && eF() && id.current === null && s(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function W3(i) {
      iF = i;
    }
    var ic = null, ry = null, Lme = function(i) {
      ic = i;
    };
    function ay(i) {
      {
        if (ic === null)
          return i;
        var l = ic(i);
        return l === void 0 ? i : l.current;
      }
    }
    function sk(i) {
      return ay(i);
    }
    function lk(i) {
      {
        if (ic === null)
          return i;
        var l = ic(i);
        if (l === void 0) {
          if (i != null && typeof i.render == "function") {
            var h = ay(i.render);
            if (i.render !== h) {
              var g = {
                $$typeof: Nt,
                render: h
              };
              return i.displayName !== void 0 && (g.displayName = i.displayName), g;
            }
          }
          return i;
        }
        return l.current;
      }
    }
    function xF(i, l) {
      {
        if (ic === null)
          return !1;
        var h = i.elementType, g = l.type, w = !1, A = typeof g == "object" && g !== null ? g.$$typeof : null;
        switch (i.tag) {
          case f: {
            typeof g == "function" && (w = !0);
            break;
          }
          case u: {
            (typeof g == "function" || A === vn) && (w = !0);
            break;
          }
          case O: {
            (A === Nt || A === vn) && (w = !0);
            break;
          }
          case B:
          case G: {
            (A === Dn || A === vn) && (w = !0);
            break;
          }
          default:
            return !1;
        }
        if (w) {
          var L = ic(h);
          if (L !== void 0 && L === ic(g))
            return !0;
        }
        return !1;
      }
    }
    function EF(i) {
      {
        if (ic === null || typeof WeakSet != "function")
          return;
        ry === null && (ry = /* @__PURE__ */ new WeakSet()), ry.add(i);
      }
    }
    var $me = function(i, l) {
      {
        if (ic === null)
          return;
        var h = l.staleFamilies, g = l.updatedFamilies;
        Sp(), wp(function() {
          uk(i.current, g, h);
        });
      }
    }, jme = function(i, l) {
      {
        if (i.context !== Iu)
          return;
        Sp(), wp(function() {
          Z3(l, i, null, null);
        });
      }
    };
    function uk(i, l, h) {
      {
        var g = i.alternate, w = i.child, A = i.sibling, L = i.tag, F = i.type, V = null;
        switch (L) {
          case u:
          case G:
          case f:
            V = F;
            break;
          case O:
            V = F.render;
            break;
        }
        if (ic === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var J = !1, ae = !1;
        if (V !== null) {
          var Me = ic(V);
          Me !== void 0 && (h.has(Me) ? ae = !0 : l.has(Me) && (L === f ? ae = !0 : J = !0));
        }
        if (ry !== null && (ry.has(i) || g !== null && ry.has(g)) && (ae = !0), ae && (i._debugNeedsRemount = !0), ae || J) {
          var Te = Ql(i, cn);
          Te !== null && Hi(Te, i, cn, Na);
        }
        w !== null && !ae && uk(w, l, h), A !== null && uk(A, l, h);
      }
    }
    var Fme = function(i, l) {
      {
        var h = /* @__PURE__ */ new Set(), g = new Set(l.map(function(w) {
          return w.current;
        }));
        return ck(i.current, g, h), h;
      }
    };
    function ck(i, l, h) {
      {
        var g = i.child, w = i.sibling, A = i.tag, L = i.type, F = null;
        switch (A) {
          case u:
          case G:
          case f:
            F = L;
            break;
          case O:
            F = L.render;
            break;
        }
        var V = !1;
        F !== null && l.has(F) && (V = !0), V ? Bme(i, h) : g !== null && ck(g, l, h), w !== null && ck(w, l, h);
      }
    }
    function Bme(i, l) {
      {
        var h = Vme(i, l);
        if (h)
          return;
        for (var g = i; ; ) {
          switch (g.tag) {
            case b:
              l.add(g.stateNode);
              return;
            case y:
              l.add(g.stateNode.containerInfo);
              return;
            case v:
              l.add(g.stateNode.containerInfo);
              return;
          }
          if (g.return === null)
            throw new Error("Expected to reach root first.");
          g = g.return;
        }
      }
    }
    function Vme(i, l) {
      for (var h = i, g = !1; ; ) {
        if (h.tag === b)
          g = !0, l.add(h.stateNode);
        else if (h.child !== null) {
          h.child.return = h, h = h.child;
          continue;
        }
        if (h === i)
          return g;
        for (; h.sibling === null; ) {
          if (h.return === null || h.return === i)
            return g;
          h = h.return;
        }
        h.sibling.return = h.return, h = h.sibling;
      }
      return !1;
    }
    var dk;
    {
      dk = !1;
      try {
        var IF = Object.preventExtensions({});
      } catch (i) {
        dk = !0;
      }
    }
    function Ume(i, l, h, g) {
      this.tag = i, this.key = h, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = l, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = g, this.flags = hn, this.subtreeFlags = hn, this.deletions = null, this.lanes = dt, this.childLanes = dt, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !dk && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var ku = function(i, l, h, g) {
      return new Ume(i, l, h, g);
    };
    function fk(i) {
      var l = i.prototype;
      return !!(l && l.isReactComponent);
    }
    function Gme(i) {
      return typeof i == "function" && !fk(i) && i.defaultProps === void 0;
    }
    function zme(i) {
      if (typeof i == "function")
        return fk(i) ? f : u;
      if (i != null) {
        var l = i.$$typeof;
        if (l === Nt)
          return O;
        if (l === Dn)
          return B;
      }
      return m;
    }
    function l0(i, l) {
      var h = i.alternate;
      h === null ? (h = ku(i.tag, l, i.key, i.mode), h.elementType = i.elementType, h.type = i.type, h.stateNode = i.stateNode, h._debugSource = i._debugSource, h._debugOwner = i._debugOwner, h._debugHookTypes = i._debugHookTypes, h.alternate = i, i.alternate = h) : (h.pendingProps = l, h.type = i.type, h.flags = hn, h.subtreeFlags = hn, h.deletions = null, h.actualDuration = 0, h.actualStartTime = -1), h.flags = i.flags & Di, h.childLanes = i.childLanes, h.lanes = i.lanes, h.child = i.child, h.memoizedProps = i.memoizedProps, h.memoizedState = i.memoizedState, h.updateQueue = i.updateQueue;
      var g = i.dependencies;
      switch (h.dependencies = g === null ? null : {
        lanes: g.lanes,
        firstContext: g.firstContext
      }, h.sibling = i.sibling, h.index = i.index, h.ref = i.ref, h.selfBaseDuration = i.selfBaseDuration, h.treeBaseDuration = i.treeBaseDuration, h._debugNeedsRemount = i._debugNeedsRemount, h.tag) {
        case m:
        case u:
        case G:
          h.type = ay(i.type);
          break;
        case f:
          h.type = sk(i.type);
          break;
        case O:
          h.type = lk(i.type);
          break;
      }
      return h;
    }
    function Hme(i, l) {
      i.flags &= Di | Ma;
      var h = i.alternate;
      if (h === null)
        i.childLanes = dt, i.lanes = l, i.child = null, i.subtreeFlags = hn, i.memoizedProps = null, i.memoizedState = null, i.updateQueue = null, i.dependencies = null, i.stateNode = null, i.selfBaseDuration = 0, i.treeBaseDuration = 0;
      else {
        i.childLanes = h.childLanes, i.lanes = h.lanes, i.child = h.child, i.subtreeFlags = hn, i.deletions = null, i.memoizedProps = h.memoizedProps, i.memoizedState = h.memoizedState, i.updateQueue = h.updateQueue, i.type = h.type;
        var g = h.dependencies;
        i.dependencies = g === null ? null : {
          lanes: g.lanes,
          firstContext: g.firstContext
        }, i.selfBaseDuration = h.selfBaseDuration, i.treeBaseDuration = h.treeBaseDuration;
      }
      return i;
    }
    function Wme(i, l, h) {
      var g;
      return i === rw ? (g = ln, l === !0 && (g |= dr, g |= Cl)) : g = an, _l && (g |= jn), ku(v, null, null, g);
    }
    function pk(i, l, h, g, w, A) {
      var L = m, F = i;
      if (typeof i == "function")
        fk(i) ? (L = f, F = sk(F)) : F = ay(F);
      else if (typeof i == "string")
        L = b;
      else
        e: switch (i) {
          case qa:
            return lm(h.children, w, A, l);
          case ml:
            L = E, w |= dr, (w & ln) !== an && (w |= Cl);
            break;
          case bu:
            return Zme(h, w, A, l);
          case Vt:
            return Yme(h, w, A, l);
          case Mn:
            return Xme(h, w, A, l);
          case Qr:
            return kF(h, w, A, l);
          case sa:
          case Hn:
          case gi:
          case Cs:
          case Ja:
          default: {
            if (typeof i == "object" && i !== null)
              switch (i.$$typeof) {
                case Ce:
                  L = R;
                  break e;
                case pt:
                  L = N;
                  break e;
                case Nt:
                  L = O, F = lk(F);
                  break e;
                case Dn:
                  L = B;
                  break e;
                case vn:
                  L = Z, F = null;
                  break e;
              }
            var V = "";
            {
              (i === void 0 || typeof i == "object" && i !== null && Object.keys(i).length === 0) && (V += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var J = g ? In(g) : null;
              J && (V += `

Check the render method of \`` + J + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (i == null ? i : typeof i) + "." + V));
          }
        }
      var ae = ku(L, h, l, w);
      return ae.elementType = i, ae.type = F, ae.lanes = A, ae._debugOwner = g, ae;
    }
    function hk(i, l, h) {
      var g = null;
      g = i._owner;
      var w = i.type, A = i.key, L = i.props, F = pk(w, A, L, g, l, h);
      return F._debugSource = i._source, F._debugOwner = i._owner, F;
    }
    function lm(i, l, h, g) {
      var w = ku(x, i, g, l);
      return w.lanes = h, w;
    }
    function Zme(i, l, h, g) {
      typeof i.id != "string" && s('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof i.id);
      var w = ku(D, i, g, l | jn);
      return w.elementType = bu, w.lanes = h, w.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, w;
    }
    function Yme(i, l, h, g) {
      var w = ku($, i, g, l);
      return w.elementType = Vt, w.lanes = h, w;
    }
    function Xme(i, l, h, g) {
      var w = ku(pe, i, g, l);
      return w.elementType = Mn, w.lanes = h, w;
    }
    function kF(i, l, h, g) {
      var w = ku(_e, i, g, l);
      w.elementType = Qr, w.lanes = h;
      var A = {
        isHidden: !1
      };
      return w.stateNode = A, w;
    }
    function mk(i, l, h) {
      var g = ku(S, i, null, l);
      return g.lanes = h, g;
    }
    function Kme() {
      var i = ku(b, null, null, an);
      return i.elementType = "DELETED", i;
    }
    function qme(i) {
      var l = ku(q, null, null, an);
      return l.stateNode = i, l;
    }
    function vk(i, l, h) {
      var g = i.children !== null ? i.children : [], w = ku(y, g, i.key, l);
      return w.lanes = h, w.stateNode = {
        containerInfo: i.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: i.implementation
      }, w;
    }
    function AF(i, l) {
      return i === null && (i = ku(m, null, null, an)), i.tag = l.tag, i.key = l.key, i.elementType = l.elementType, i.type = l.type, i.stateNode = l.stateNode, i.return = l.return, i.child = l.child, i.sibling = l.sibling, i.index = l.index, i.ref = l.ref, i.pendingProps = l.pendingProps, i.memoizedProps = l.memoizedProps, i.updateQueue = l.updateQueue, i.memoizedState = l.memoizedState, i.dependencies = l.dependencies, i.mode = l.mode, i.flags = l.flags, i.subtreeFlags = l.subtreeFlags, i.deletions = l.deletions, i.lanes = l.lanes, i.childLanes = l.childLanes, i.alternate = l.alternate, i.actualDuration = l.actualDuration, i.actualStartTime = l.actualStartTime, i.selfBaseDuration = l.selfBaseDuration, i.treeBaseDuration = l.treeBaseDuration, i._debugSource = l._debugSource, i._debugOwner = l._debugOwner, i._debugNeedsRemount = l._debugNeedsRemount, i._debugHookTypes = l._debugHookTypes, i;
    }
    function Jme(i, l, h, g, w) {
      this.tag = l, this.containerInfo = i, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = q9, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Uo, this.eventTimes = Rv(dt), this.expirationTimes = Rv(Na), this.pendingLanes = dt, this.suspendedLanes = dt, this.pingedLanes = dt, this.expiredLanes = dt, this.mutableReadLanes = dt, this.finishedLanes = dt, this.entangledLanes = dt, this.entanglements = Rv(dt), this.identifierPrefix = g, this.onRecoverableError = w, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var A = this.pendingUpdatersLaneMap = [], L = 0; L < kv; L++)
          A.push(/* @__PURE__ */ new Set());
      }
      switch (l) {
        case rw:
          this._debugRootType = h ? "hydrateRoot()" : "createRoot()";
          break;
        case Xh:
          this._debugRootType = h ? "hydrate()" : "render()";
          break;
      }
    }
    function PF(i, l, h, g, w, A, L, F, V, J) {
      var ae = new Jme(i, l, h, F, V), Me = Wme(l, A);
      ae.current = Me, Me.stateNode = ae;
      {
        var Te = {
          element: g,
          isDehydrated: h,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        Me.memoizedState = Te;
      }
      return PE(Me), ae;
    }
    var gk = "18.3.1";
    function Qme(i, l, h) {
      var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return zn(g), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: xo,
        key: g == null ? null : "" + g,
        children: i,
        containerInfo: l,
        implementation: h
      };
    }
    var yk, bk;
    yk = !1, bk = {};
    function NF(i) {
      if (!i)
        return Iu;
      var l = Fl(i), h = Dfe(l);
      if (l.tag === f) {
        var g = l.type;
        if (rf(g))
          return r$(l, g, h);
      }
      return h;
    }
    function eve(i, l) {
      {
        var h = Fl(i);
        if (h === void 0) {
          if (typeof i.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var g = Object.keys(i).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + g);
        }
        var w = Gl(h);
        if (w === null)
          return null;
        if (w.mode & dr) {
          var A = In(h) || "Component";
          if (!bk[A]) {
            bk[A] = !0;
            var L = Ua;
            try {
              Vr(w), h.mode & dr ? s("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", l, l, A) : s("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", l, l, A);
            } finally {
              L ? Vr(L) : so();
            }
          }
        }
        return w.stateNode;
      }
    }
    function TF(i, l, h, g, w, A, L, F) {
      var V = !1, J = null;
      return PF(i, l, V, J, h, g, w, A, L);
    }
    function OF(i, l, h, g, w, A, L, F, V, J) {
      var ae = !0, Me = PF(h, g, ae, i, w, A, L, F, V);
      Me.context = NF(null);
      var Te = Me.current, Ye = El(), Ke = im(Te), rt = yp(Ye, Ke);
      return rt.callback = l != null ? l : null, Jh(Te, rt, Ke), sme(Me, Ke, Ye), Me;
    }
    function Z3(i, l, h, g) {
      xb(l, i);
      var w = l.current, A = El(), L = im(w);
      kb(L);
      var F = NF(h);
      l.context === null ? l.context = F : l.pendingContext = F, ns && Ua !== null && !yk && (yk = !0, s(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, In(Ua) || "Unknown"));
      var V = yp(A, L);
      V.payload = {
        element: i
      }, g = g === void 0 ? null : g, g !== null && (typeof g != "function" && s("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", g), V.callback = g);
      var J = Jh(w, V, L);
      return J !== null && (Hi(J, w, L, A), yw(J, w, L)), L;
    }
    function sS(i) {
      var l = i.current;
      if (!l.child)
        return null;
      switch (l.child.tag) {
        case b:
          return l.child.stateNode;
        default:
          return l.child.stateNode;
      }
    }
    function tve(i) {
      switch (i.tag) {
        case v: {
          var l = i.stateNode;
          if (cg(l)) {
            var h = Nb(l);
            dme(l, h);
          }
          break;
        }
        case $: {
          wp(function() {
            var w = Ql(i, cn);
            if (w !== null) {
              var A = El();
              Hi(w, i, cn, A);
            }
          });
          var g = cn;
          _k(i, g);
          break;
        }
      }
    }
    function RF(i, l) {
      var h = i.memoizedState;
      h !== null && h.dehydrated !== null && (h.retryLane = m5(h.retryLane, l));
    }
    function _k(i, l) {
      RF(i, l);
      var h = i.alternate;
      h && RF(h, l);
    }
    function nve(i) {
      if (i.tag === $) {
        var l = Pv, h = Ql(i, l);
        if (h !== null) {
          var g = El();
          Hi(h, i, l, g);
        }
        _k(i, l);
      }
    }
    function rve(i) {
      if (i.tag === $) {
        var l = im(i), h = Ql(i, l);
        if (h !== null) {
          var g = El();
          Hi(h, i, l, g);
        }
        _k(i, l);
      }
    }
    function MF(i) {
      var l = qC(i);
      return l === null ? null : l.stateNode;
    }
    var DF = function(i) {
      return null;
    };
    function ave(i) {
      return DF(i);
    }
    var LF = function(i) {
      return !1;
    };
    function ove(i) {
      return LF(i);
    }
    var $F = null, jF = null, FF = null, BF = null, VF = null, UF = null, GF = null, zF = null, HF = null;
    {
      var WF = function(i, l, h) {
        var g = l[h], w = bi(i) ? i.slice() : Vn({}, i);
        return h + 1 === l.length ? (bi(w) ? w.splice(g, 1) : delete w[g], w) : (w[g] = WF(i[g], l, h + 1), w);
      }, ZF = function(i, l) {
        return WF(i, l, 0);
      }, YF = function(i, l, h, g) {
        var w = l[g], A = bi(i) ? i.slice() : Vn({}, i);
        if (g + 1 === l.length) {
          var L = h[g];
          A[L] = A[w], bi(A) ? A.splice(w, 1) : delete A[w];
        } else
          A[w] = YF(
            // $FlowFixMe number or string is fine here
            i[w],
            l,
            h,
            g + 1
          );
        return A;
      }, XF = function(i, l, h) {
        if (l.length !== h.length) {
          o("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var g = 0; g < h.length - 1; g++)
            if (l[g] !== h[g]) {
              o("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return YF(i, l, h, 0);
      }, KF = function(i, l, h, g) {
        if (h >= l.length)
          return g;
        var w = l[h], A = bi(i) ? i.slice() : Vn({}, i);
        return A[w] = KF(i[w], l, h + 1, g), A;
      }, qF = function(i, l, h) {
        return KF(i, l, 0, h);
      }, Ck = function(i, l) {
        for (var h = i.memoizedState; h !== null && l > 0; )
          h = h.next, l--;
        return h;
      };
      $F = function(i, l, h, g) {
        var w = Ck(i, l);
        if (w !== null) {
          var A = qF(w.memoizedState, h, g);
          w.memoizedState = A, w.baseState = A, i.memoizedProps = Vn({}, i.memoizedProps);
          var L = Ql(i, cn);
          L !== null && Hi(L, i, cn, Na);
        }
      }, jF = function(i, l, h) {
        var g = Ck(i, l);
        if (g !== null) {
          var w = ZF(g.memoizedState, h);
          g.memoizedState = w, g.baseState = w, i.memoizedProps = Vn({}, i.memoizedProps);
          var A = Ql(i, cn);
          A !== null && Hi(A, i, cn, Na);
        }
      }, FF = function(i, l, h, g) {
        var w = Ck(i, l);
        if (w !== null) {
          var A = XF(w.memoizedState, h, g);
          w.memoizedState = A, w.baseState = A, i.memoizedProps = Vn({}, i.memoizedProps);
          var L = Ql(i, cn);
          L !== null && Hi(L, i, cn, Na);
        }
      }, BF = function(i, l, h) {
        i.pendingProps = qF(i.memoizedProps, l, h), i.alternate && (i.alternate.pendingProps = i.pendingProps);
        var g = Ql(i, cn);
        g !== null && Hi(g, i, cn, Na);
      }, VF = function(i, l) {
        i.pendingProps = ZF(i.memoizedProps, l), i.alternate && (i.alternate.pendingProps = i.pendingProps);
        var h = Ql(i, cn);
        h !== null && Hi(h, i, cn, Na);
      }, UF = function(i, l, h) {
        i.pendingProps = XF(i.memoizedProps, l, h), i.alternate && (i.alternate.pendingProps = i.pendingProps);
        var g = Ql(i, cn);
        g !== null && Hi(g, i, cn, Na);
      }, GF = function(i) {
        var l = Ql(i, cn);
        l !== null && Hi(l, i, cn, Na);
      }, zF = function(i) {
        DF = i;
      }, HF = function(i) {
        LF = i;
      };
    }
    function ive(i) {
      var l = Gl(i);
      return l === null ? null : l.stateNode;
    }
    function sve(i) {
      return null;
    }
    function lve() {
      return Ua;
    }
    function uve(i) {
      var l = i.findFiberByHostInstance, h = n.ReactCurrentDispatcher;
      return Sb({
        bundleType: i.bundleType,
        version: i.version,
        rendererPackageName: i.rendererPackageName,
        rendererConfig: i.rendererConfig,
        overrideHookState: $F,
        overrideHookStateDeletePath: jF,
        overrideHookStateRenamePath: FF,
        overrideProps: BF,
        overridePropsDeletePath: VF,
        overridePropsRenamePath: UF,
        setErrorHandler: zF,
        setSuspenseHandler: HF,
        scheduleUpdate: GF,
        currentDispatcherRef: h,
        findHostInstanceByFiber: ive,
        findFiberByHostInstance: l || sve,
        // React Refresh
        findHostInstancesForRefresh: Fme,
        scheduleRefresh: $me,
        scheduleRoot: jme,
        setRefreshHandler: Lme,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: lve,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: gk
      });
    }
    var JF = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(i) {
      console.error(i);
    };
    function wk(i) {
      this._internalRoot = i;
    }
    lS.prototype.render = wk.prototype.render = function(i) {
      var l = this._internalRoot;
      if (l === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? s("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : uS(arguments[1]) ? s("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] != "undefined" && s("You passed a second argument to root.render(...) but it only accepts one argument.");
        var h = l.containerInfo;
        if (h.nodeType !== Bo) {
          var g = MF(l.current);
          g && g.parentNode !== h && s("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      Z3(i, l, null, null);
    }, lS.prototype.unmount = wk.prototype.unmount = function() {
      typeof arguments[0] == "function" && s("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var i = this._internalRoot;
      if (i !== null) {
        this._internalRoot = null;
        var l = i.containerInfo;
        cF() && s("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), wp(function() {
          Z3(null, i, null, null);
        }), JL(l);
      }
    };
    function cve(i, l) {
      if (!uS(i))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      QF(i);
      var h = !1, g = !1, w = "", A = JF;
      l != null && (l.hydrate ? o("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof l == "object" && l !== null && l.$$typeof === ri && s(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), l.unstable_strictMode === !0 && (h = !0), l.identifierPrefix !== void 0 && (w = l.identifierPrefix), l.onRecoverableError !== void 0 && (A = l.onRecoverableError), l.transitionCallbacks !== void 0 && l.transitionCallbacks);
      var L = TF(i, rw, null, h, g, w, A);
      K5(L.current, i);
      var F = i.nodeType === Bo ? i.parentNode : i;
      return Qb(F), new wk(L);
    }
    function lS(i) {
      this._internalRoot = i;
    }
    function dve(i) {
      i && x9(i);
    }
    lS.prototype.unstable_scheduleHydration = dve;
    function fve(i, l, h) {
      if (!uS(i))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      QF(i), l === void 0 && s("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var g = h != null ? h : null, w = h != null && h.hydratedSources || null, A = !1, L = !1, F = "", V = JF;
      h != null && (h.unstable_strictMode === !0 && (A = !0), h.identifierPrefix !== void 0 && (F = h.identifierPrefix), h.onRecoverableError !== void 0 && (V = h.onRecoverableError));
      var J = OF(l, null, i, rw, g, A, L, F, V);
      if (K5(J.current, i), Qb(i), w)
        for (var ae = 0; ae < w.length; ae++) {
          var Me = w[ae];
          vpe(J, Me);
        }
      return new lS(J);
    }
    function uS(i) {
      return !!(i && (i.nodeType === zs || i.nodeType === wu || i.nodeType === Gf || !ce));
    }
    function Y3(i) {
      return !!(i && (i.nodeType === zs || i.nodeType === wu || i.nodeType === Gf || i.nodeType === Bo && i.nodeValue === " react-mount-point-unstable "));
    }
    function QF(i) {
      i.nodeType === zs && i.tagName && i.tagName.toUpperCase() === "BODY" && s("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), c3(i) && (i._reactRootContainer ? s("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : s("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var pve = n.ReactCurrentOwner, eB;
    eB = function(i) {
      if (i._reactRootContainer && i.nodeType !== Bo) {
        var l = MF(i._reactRootContainer.current);
        l && l.parentNode !== i && s("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var h = !!i._reactRootContainer, g = Sk(i), w = !!(g && Zh(g));
      w && !h && s("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), i.nodeType === zs && i.tagName && i.tagName.toUpperCase() === "BODY" && s("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function Sk(i) {
      return i ? i.nodeType === wu ? i.documentElement : i.firstChild : null;
    }
    function tB() {
    }
    function hve(i, l, h, g, w) {
      if (w) {
        if (typeof g == "function") {
          var A = g;
          g = function() {
            var Te = sS(L);
            A.call(Te);
          };
        }
        var L = OF(
          l,
          g,
          i,
          Xh,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          tB
        );
        i._reactRootContainer = L, K5(L.current, i);
        var F = i.nodeType === Bo ? i.parentNode : i;
        return Qb(F), wp(), L;
      } else {
        for (var V; V = i.lastChild; )
          i.removeChild(V);
        if (typeof g == "function") {
          var J = g;
          g = function() {
            var Te = sS(ae);
            J.call(Te);
          };
        }
        var ae = TF(
          i,
          Xh,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          tB
        );
        i._reactRootContainer = ae, K5(ae.current, i);
        var Me = i.nodeType === Bo ? i.parentNode : i;
        return Qb(Me), wp(function() {
          Z3(l, ae, h, g);
        }), ae;
      }
    }
    function mve(i, l) {
      i !== null && typeof i != "function" && s("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", l, i);
    }
    function cS(i, l, h, g, w) {
      eB(h), mve(w === void 0 ? null : w, "render");
      var A = h._reactRootContainer, L;
      if (!A)
        L = hve(h, l, i, w, g);
      else {
        if (L = A, typeof w == "function") {
          var F = w;
          w = function() {
            var V = sS(L);
            F.call(V);
          };
        }
        Z3(l, L, i, w);
      }
      return sS(L);
    }
    var nB = !1;
    function vve(i) {
      {
        nB || (nB = !0, s("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var l = pve.current;
        if (l !== null && l.stateNode !== null) {
          var h = l.stateNode._warnedAboutRefsInRender;
          h || s("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", vr(l.type) || "A component"), l.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return i == null ? null : i.nodeType === zs ? i : eve(i, "findDOMNode");
    }
    function gve(i, l, h) {
      if (s("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Y3(l))
        throw new Error("Target container is not a DOM element.");
      {
        var g = c3(l) && l._reactRootContainer === void 0;
        g && s("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return cS(null, i, l, !0, h);
    }
    function yve(i, l, h) {
      if (s("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Y3(l))
        throw new Error("Target container is not a DOM element.");
      {
        var g = c3(l) && l._reactRootContainer === void 0;
        g && s("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return cS(null, i, l, !1, h);
    }
    function bve(i, l, h, g) {
      if (s("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Y3(h))
        throw new Error("Target container is not a DOM element.");
      if (i == null || !_v(i))
        throw new Error("parentComponent must be a valid React Component");
      return cS(i, l, h, !1, g);
    }
    var rB = !1;
    function _ve(i) {
      if (rB || (rB = !0, s("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !Y3(i))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var l = c3(i) && i._reactRootContainer === void 0;
        l && s("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (i._reactRootContainer) {
        {
          var h = Sk(i), g = h && !Zh(h);
          g && s("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return wp(function() {
          cS(null, null, i, !1, function() {
            i._reactRootContainer = null, JL(i);
          });
        }), !0;
      } else {
        {
          var w = Sk(i), A = !!(w && Zh(w)), L = i.nodeType === zs && Y3(i.parentNode) && !!i.parentNode._reactRootContainer;
          A && s("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", L ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Rh(tve), w9(nve), fg(rve), y5(Zl), b5(ls), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && s("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), YC(wde), P1(ek, fme, wp);
    function Cve(i, l) {
      var h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!uS(l))
        throw new Error("Target container is not a DOM element.");
      return Qme(i, l, null, h);
    }
    function wve(i, l, h, g) {
      return bve(i, l, h, g);
    }
    var xk = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Zh, Dg, q5, A1, gv, ek]
    };
    function Sve(i, l) {
      return xk.usingClientEntryPoint || s('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), cve(i, l);
    }
    function xve(i, l, h) {
      return xk.usingClientEntryPoint || s('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), fve(i, l, h);
    }
    function Eve(i) {
      return cF() && s("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), wp(i);
    }
    var Ive = uve({
      findFiberByHostInstance: Zv,
      bundleType: 1,
      version: gk,
      rendererPackageName: "react-dom"
    });
    if (!Ive && He && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var aB = window.location.protocol;
      /^(https?|file):$/.test(aB) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (aB === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    au.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = xk, au.createPortal = Cve, au.createRoot = Sve, au.findDOMNode = vve, au.flushSync = Eve, au.hydrate = gve, au.hydrateRoot = xve, au.render = yve, au.unmountComponentAtNode = _ve, au.unstable_batchedUpdates = ek, au.unstable_renderSubtreeIntoContainer = wve, au.version = gk, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), au;
}
function Fee() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ == "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(Fee);
    } catch (e) {
      console.error(e);
    }
  }
}
process.env.NODE_ENV === "production" ? (Fee(), vT.exports = R3e()) : vT.exports = M3e();
var Bee = vT.exports, n4 = function(e) {
  return e && e.Math === Math && e;
}, aa = (
  // eslint-disable-next-line es/no-global-this -- safe
  n4(typeof globalThis == "object" && globalThis) || n4(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  n4(typeof self == "object" && self) || n4(typeof Nu == "object" && Nu) || n4(typeof Nu == "object" && Nu) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")()
), mr = function(e) {
  try {
    return !!e();
  } catch (t) {
    return !0;
  }
}, D3e = mr, T_ = !D3e(function() {
  var e = function() {
  }.bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), L3e = T_, Vee = Function.prototype, HV = Vee.apply, WV = Vee.call, Um = typeof Reflect == "object" && Reflect.apply || (L3e ? WV.bind(HV) : function() {
  return WV.apply(HV, arguments);
}), Uee = T_, Gee = Function.prototype, gT = Gee.call, $3e = Uee && Gee.bind.bind(gT, gT), Rr = Uee ? $3e : function(e) {
  return function() {
    return gT.apply(e, arguments);
  };
}, zee = Rr, j3e = zee({}.toString), F3e = zee("".slice), Tf = function(e) {
  return F3e(j3e(e), 8, -1);
}, B3e = Tf, V3e = Rr, r8 = function(e) {
  if (B3e(e) === "Function") return V3e(e);
}, Wk = typeof document == "object" && document.all, bo = typeof Wk == "undefined" && Wk !== void 0 ? function(e) {
  return typeof e == "function" || e === Wk;
} : function(e) {
  return typeof e == "function";
}, Gm = {}, U3e = mr, _o = !U3e(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), G3e = T_, ES = Function.prototype.call, Co = G3e ? ES.bind(ES) : function() {
  return ES.apply(ES, arguments);
}, O_ = {}, Hee = {}.propertyIsEnumerable, Wee = Object.getOwnPropertyDescriptor, z3e = Wee && !Hee.call({ 1: 2 }, 1);
O_.f = z3e ? function(t) {
  var n = Wee(this, t);
  return !!n && n.enumerable;
} : Hee;
var zm = function(e, t) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: t
  };
}, H3e = Rr, W3e = mr, Z3e = Tf, Zk = Object, Y3e = H3e("".split), a8 = W3e(function() {
  return !Zk("z").propertyIsEnumerable(0);
}) ? function(e) {
  return Z3e(e) === "String" ? Y3e(e, "") : Zk(e);
} : Zk, P2 = function(e) {
  return e == null;
}, X3e = P2, K3e = TypeError, Of = function(e) {
  if (X3e(e)) throw new K3e("Can't call method on " + e);
  return e;
}, q3e = a8, J3e = Of, Tc = function(e) {
  return q3e(J3e(e));
}, Q3e = bo, Lo = function(e) {
  return typeof e == "object" ? e !== null : Q3e(e);
}, Yr = {}, Yk = Yr, Xk = aa, e4e = bo, ZV = function(e) {
  return e4e(e) ? e : void 0;
}, Ni = function(e, t) {
  return arguments.length < 2 ? ZV(Yk[e]) || ZV(Xk[e]) : Yk[e] && Yk[e][t] || Xk[e] && Xk[e][t];
}, t4e = Rr, Sa = t4e({}.isPrototypeOf), n4e = aa, YV = n4e.navigator, XV = YV && YV.userAgent, Xp = XV ? String(XV) : "", Zee = aa, Kk = Xp, KV = Zee.process, qV = Zee.Deno, JV = KV && KV.versions || qV && qV.version, QV = JV && JV.v8, vd, V7;
QV && (vd = QV.split("."), V7 = vd[0] > 0 && vd[0] < 4 ? 1 : +(vd[0] + vd[1]));
!V7 && Kk && (vd = Kk.match(/Edge\/(\d+)/), (!vd || vd[1] >= 74) && (vd = Kk.match(/Chrome\/(\d+)/), vd && (V7 = +vd[1])));
var N2 = V7, eU = N2, r4e = mr, a4e = aa, o4e = a4e.String, T2 = !!Object.getOwnPropertySymbols && !r4e(function() {
  var e = Symbol("symbol detection");
  return !o4e(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && eU && eU < 41;
}), i4e = T2, Yee = i4e && !Symbol.sham && typeof Symbol.iterator == "symbol", s4e = Ni, l4e = bo, u4e = Sa, c4e = Yee, d4e = Object, R_ = c4e ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var t = s4e("Symbol");
  return l4e(t) && u4e(t.prototype, d4e(e));
}, f4e = String, Hm = function(e) {
  try {
    return f4e(e);
  } catch (t) {
    return "Object";
  }
}, p4e = bo, h4e = Hm, m4e = TypeError, Ti = function(e) {
  if (p4e(e)) return e;
  throw new m4e(h4e(e) + " is not a function");
}, v4e = Ti, g4e = P2, GR = function(e, t) {
  var n = e[t];
  return g4e(n) ? void 0 : v4e(n);
}, qk = Co, Jk = bo, Qk = Lo, y4e = TypeError, b4e = function(e, t) {
  var n, r;
  if (t === "string" && Jk(n = e.toString) && !Qk(r = qk(n, e)) || Jk(n = e.valueOf) && !Qk(r = qk(n, e)) || t !== "string" && Jk(n = e.toString) && !Qk(r = qk(n, e))) return r;
  throw new y4e("Can't convert object to primitive value");
}, Xee = { exports: {} }, zR = !0, tU = aa, _4e = Object.defineProperty, C4e = function(e, t) {
  try {
    _4e(tU, e, { value: t, configurable: !0, writable: !0 });
  } catch (n) {
    tU[e] = t;
  }
  return t;
}, w4e = aa, S4e = C4e, nU = "__core-js_shared__", rU = Xee.exports = w4e[nU] || S4e(nU, {});
(rU.versions || (rU.versions = [])).push({
  version: "3.38.1",
  mode: "pure",
  copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var HR = Xee.exports, aU = HR, O2 = function(e, t) {
  return aU[e] || (aU[e] = t || {});
}, x4e = Of, E4e = Object, hl = function(e) {
  return E4e(x4e(e));
}, I4e = Rr, k4e = hl, A4e = I4e({}.hasOwnProperty), Qo = Object.hasOwn || function(t, n) {
  return A4e(k4e(t), n);
}, P4e = Rr, N4e = 0, T4e = Math.random(), O4e = P4e(1 .toString), o8 = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + O4e(++N4e + T4e, 36);
}, R4e = aa, M4e = O2, oU = Qo, D4e = o8, L4e = T2, $4e = Yee, Oy = R4e.Symbol, eA = M4e("wks"), j4e = $4e ? Oy.for || Oy : Oy && Oy.withoutSetter || D4e, Ya = function(e) {
  return oU(eA, e) || (eA[e] = L4e && oU(Oy, e) ? Oy[e] : j4e("Symbol." + e)), eA[e];
}, F4e = Co, iU = Lo, sU = R_, B4e = GR, V4e = b4e, U4e = Ya, G4e = TypeError, z4e = U4e("toPrimitive"), Kee = function(e, t) {
  if (!iU(e) || sU(e)) return e;
  var n = B4e(e, z4e), r;
  if (n) {
    if (t === void 0 && (t = "default"), r = F4e(n, e, t), !iU(r) || sU(r)) return r;
    throw new G4e("Can't convert object to primitive value");
  }
  return t === void 0 && (t = "number"), V4e(e, t);
}, H4e = Kee, W4e = R_, WR = function(e) {
  var t = H4e(e, "string");
  return W4e(t) ? t : t + "";
}, Z4e = aa, lU = Lo, yT = Z4e.document, Y4e = lU(yT) && lU(yT.createElement), ZR = function(e) {
  return Y4e ? yT.createElement(e) : {};
}, X4e = _o, K4e = mr, q4e = ZR, qee = !X4e && !K4e(function() {
  return Object.defineProperty(q4e("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), J4e = _o, Q4e = Co, e_e = O_, t_e = zm, n_e = Tc, r_e = WR, a_e = Qo, o_e = qee, uU = Object.getOwnPropertyDescriptor;
Gm.f = J4e ? uU : function(t, n) {
  if (t = n_e(t), n = r_e(n), o_e) try {
    return uU(t, n);
  } catch (r) {
  }
  if (a_e(t, n)) return t_e(!Q4e(e_e.f, t, n), t[n]);
};
var i_e = mr, s_e = bo, l_e = /#|\.prototype\./, M_ = function(e, t) {
  var n = c_e[u_e(e)];
  return n === f_e ? !0 : n === d_e ? !1 : s_e(t) ? i_e(t) : !!t;
}, u_e = M_.normalize = function(e) {
  return String(e).replace(l_e, ".").toLowerCase();
}, c_e = M_.data = {}, d_e = M_.NATIVE = "N", f_e = M_.POLYFILL = "P", Jee = M_, cU = r8, p_e = Ti, h_e = T_, m_e = cU(cU.bind), ms = function(e, t) {
  return p_e(e), t === void 0 ? e : h_e ? m_e(e, t) : function() {
    return e.apply(t, arguments);
  };
}, mu = {}, v_e = _o, g_e = mr, Qee = v_e && g_e(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), y_e = Lo, b_e = String, __e = TypeError, vs = function(e) {
  if (y_e(e)) return e;
  throw new __e(b_e(e) + " is not an object");
}, C_e = _o, w_e = qee, S_e = Qee, IS = vs, dU = WR, x_e = TypeError, tA = Object.defineProperty, E_e = Object.getOwnPropertyDescriptor, nA = "enumerable", rA = "configurable", aA = "writable";
mu.f = C_e ? S_e ? function(t, n, r) {
  if (IS(t), n = dU(n), IS(r), typeof t == "function" && n === "prototype" && "value" in r && aA in r && !r[aA]) {
    var a = E_e(t, n);
    a && a[aA] && (t[n] = r.value, r = {
      configurable: rA in r ? r[rA] : a[rA],
      enumerable: nA in r ? r[nA] : a[nA],
      writable: !1
    });
  }
  return tA(t, n, r);
} : tA : function(t, n, r) {
  if (IS(t), n = dU(n), IS(r), w_e) try {
    return tA(t, n, r);
  } catch (a) {
  }
  if ("get" in r || "set" in r) throw new x_e("Accessors not supported");
  return "value" in r && (t[n] = r.value), t;
};
var I_e = _o, k_e = mu, A_e = zm, Wm = I_e ? function(e, t, n) {
  return k_e.f(e, t, A_e(1, n));
} : function(e, t, n) {
  return e[t] = n, e;
}, r4 = aa, P_e = Um, N_e = r8, T_e = bo, O_e = Gm.f, R_e = Jee, uy = Yr, M_e = ms, cy = Wm, fU = Qo, D_e = function(e) {
  var t = function(n, r, a) {
    if (this instanceof t) {
      switch (arguments.length) {
        case 0:
          return new e();
        case 1:
          return new e(n);
        case 2:
          return new e(n, r);
      }
      return new e(n, r, a);
    }
    return P_e(e, this, arguments);
  };
  return t.prototype = e.prototype, t;
}, vt = function(e, t) {
  var n = e.target, r = e.global, a = e.stat, o = e.proto, s = r ? r4 : a ? r4[n] : r4[n] && r4[n].prototype, c = r ? uy : uy[n] || cy(uy, n, {})[n], u = c.prototype, f, m, v, y, b, S, x, E, N;
  for (y in t)
    f = R_e(r ? y : n + (a ? "." : "#") + y, e.forced), m = !f && s && fU(s, y), S = c[y], m && (e.dontCallGetSet ? (N = O_e(s, y), x = N && N.value) : x = s[y]), b = m && x ? x : t[y], !(!f && !o && typeof S == typeof b) && (e.bind && m ? E = M_e(b, r4) : e.wrap && m ? E = D_e(b) : o && T_e(b) ? E = N_e(b) : E = b, (e.sham || b && b.sham || S && S.sham) && cy(E, "sham", !0), cy(c, y, E), o && (v = n + "Prototype", fU(uy, v) || cy(uy, v, {}), cy(uy[v], y, b), e.real && u && (f || !u[y]) && cy(u, y, b)));
}, L_e = O2, $_e = o8, pU = L_e("keys"), i8 = function(e) {
  return pU[e] || (pU[e] = $_e(e));
}, j_e = mr, ete = !j_e(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), F_e = Qo, B_e = bo, V_e = hl, U_e = i8, G_e = ete, hU = U_e("IE_PROTO"), bT = Object, z_e = bT.prototype, R2 = G_e ? bT.getPrototypeOf : function(e) {
  var t = V_e(e);
  if (F_e(t, hU)) return t[hU];
  var n = t.constructor;
  return B_e(n) && t instanceof n ? n.prototype : t instanceof bT ? z_e : null;
}, H_e = Rr, W_e = Ti, Z_e = function(e, t, n) {
  try {
    return H_e(W_e(Object.getOwnPropertyDescriptor(e, t)[n]));
  } catch (r) {
  }
}, Y_e = Lo, X_e = function(e) {
  return Y_e(e) || e === null;
}, K_e = X_e, q_e = String, J_e = TypeError, Q_e = function(e) {
  if (K_e(e)) return e;
  throw new J_e("Can't set " + q_e(e) + " as a prototype");
}, eCe = Z_e, tCe = Lo, nCe = Of, rCe = Q_e, tte = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, t = {}, n;
  try {
    n = eCe(Object.prototype, "__proto__", "set"), n(t, []), e = t instanceof Array;
  } catch (r) {
  }
  return function(a, o) {
    return nCe(a), rCe(o), tCe(a) && (e ? n(a, o) : a.__proto__ = o), a;
  };
}() : void 0), D_ = {}, aCe = Math.ceil, oCe = Math.floor, iCe = Math.trunc || function(t) {
  var n = +t;
  return (n > 0 ? oCe : aCe)(n);
}, sCe = iCe, s1 = function(e) {
  var t = +e;
  return t !== t || t === 0 ? 0 : sCe(t);
}, lCe = s1, uCe = Math.max, cCe = Math.min, s8 = function(e, t) {
  var n = lCe(e);
  return n < 0 ? uCe(n + t, 0) : cCe(n, t);
}, dCe = s1, fCe = Math.min, YR = function(e) {
  var t = dCe(e);
  return t > 0 ? fCe(t, 9007199254740991) : 0;
}, pCe = YR, Gu = function(e) {
  return pCe(e.length);
}, hCe = Tc, mCe = s8, vCe = Gu, mU = function(e) {
  return function(t, n, r) {
    var a = hCe(t), o = vCe(a);
    if (o === 0) return !e && -1;
    var s = mCe(r, o), c;
    if (e && n !== n) {
      for (; o > s; )
        if (c = a[s++], c !== c) return !0;
    } else for (; o > s; s++)
      if ((e || s in a) && a[s] === n) return e || s || 0;
    return !e && -1;
  };
}, XR = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: mU(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: mU(!1)
}, L_ = {}, gCe = Rr, oA = Qo, yCe = Tc, bCe = XR.indexOf, _Ce = L_, vU = gCe([].push), nte = function(e, t) {
  var n = yCe(e), r = 0, a = [], o;
  for (o in n) !oA(_Ce, o) && oA(n, o) && vU(a, o);
  for (; t.length > r; ) oA(n, o = t[r++]) && (~bCe(a, o) || vU(a, o));
  return a;
}, KR = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], CCe = nte, wCe = KR, SCe = wCe.concat("length", "prototype");
D_.f = Object.getOwnPropertyNames || function(t) {
  return CCe(t, SCe);
};
var $_ = {};
$_.f = Object.getOwnPropertySymbols;
var xCe = Ni, ECe = Rr, ICe = D_, kCe = $_, ACe = vs, PCe = ECe([].concat), rte = xCe("Reflect", "ownKeys") || function(t) {
  var n = ICe.f(ACe(t)), r = kCe.f;
  return r ? PCe(n, r(t)) : n;
}, gU = Qo, NCe = rte, TCe = Gm, OCe = mu, RCe = function(e, t, n) {
  for (var r = NCe(t), a = OCe.f, o = TCe.f, s = 0; s < r.length; s++) {
    var c = r[s];
    !gU(e, c) && !(n && gU(n, c)) && a(e, c, o(t, c));
  }
}, l8 = {}, MCe = nte, DCe = KR, j_ = Object.keys || function(t) {
  return MCe(t, DCe);
}, LCe = _o, $Ce = Qee, jCe = mu, FCe = vs, BCe = Tc, VCe = j_;
l8.f = LCe && !$Ce ? Object.defineProperties : function(t, n) {
  FCe(t);
  for (var r = BCe(n), a = VCe(n), o = a.length, s = 0, c; o > s; ) jCe.f(t, c = a[s++], r[c]);
  return t;
};
var UCe = Ni, ate = UCe("document", "documentElement"), GCe = vs, zCe = l8, yU = KR, HCe = L_, WCe = ate, ZCe = ZR, YCe = i8, bU = ">", _U = "<", _T = "prototype", CT = "script", ote = YCe("IE_PROTO"), iA = function() {
}, ite = function(e) {
  return _U + CT + bU + e + _U + "/" + CT + bU;
}, CU = function(e) {
  e.write(ite("")), e.close();
  var t = e.parentWindow.Object;
  return e = null, t;
}, XCe = function() {
  var e = ZCe("iframe"), t = "java" + CT + ":", n;
  return e.style.display = "none", WCe.appendChild(e), e.src = String(t), n = e.contentWindow.document, n.open(), n.write(ite("document.F=Object")), n.close(), n.F;
}, kS, Hx = function() {
  try {
    kS = new ActiveXObject("htmlfile");
  } catch (t) {
  }
  Hx = typeof document != "undefined" ? document.domain && kS ? CU(kS) : XCe() : CU(kS);
  for (var e = yU.length; e--; ) delete Hx[_T][yU[e]];
  return Hx();
};
HCe[ote] = !0;
var Zm = Object.create || function(t, n) {
  var r;
  return t !== null ? (iA[_T] = GCe(t), r = new iA(), iA[_T] = null, r[ote] = t) : r = Hx(), n === void 0 ? r : zCe.f(r, n);
}, KCe = Lo, qCe = Wm, JCe = function(e, t) {
  KCe(t) && "cause" in t && qCe(e, "cause", t.cause);
}, QCe = Rr, ste = Error, e5e = QCe("".replace), t5e = function(e) {
  return String(new ste(e).stack);
}("zxcasd"), lte = /\n\s*at [^:]*:[^\n]*/, n5e = lte.test(t5e), r5e = function(e, t) {
  if (n5e && typeof e == "string" && !ste.prepareStackTrace)
    for (; t--; ) e = e5e(e, lte, "");
  return e;
}, a5e = mr, o5e = zm, i5e = !a5e(function() {
  var e = new Error("a");
  return "stack" in e ? (Object.defineProperty(e, "stack", o5e(1, 7)), e.stack !== 7) : !0;
}), s5e = Wm, l5e = r5e, u5e = i5e, wU = Error.captureStackTrace, c5e = function(e, t, n, r) {
  u5e && (wU ? wU(e, t) : s5e(e, "stack", l5e(n, r)));
}, M2 = {}, d5e = Ya, f5e = M2, p5e = d5e("iterator"), h5e = Array.prototype, ute = function(e) {
  return e !== void 0 && (f5e.Array === e || h5e[p5e] === e);
}, m5e = Ya, v5e = m5e("toStringTag"), cte = {};
cte[v5e] = "z";
var qR = String(cte) === "[object z]", g5e = qR, y5e = bo, Wx = Tf, b5e = Ya, _5e = b5e("toStringTag"), C5e = Object, w5e = Wx(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", S5e = function(e, t) {
  try {
    return e[t];
  } catch (n) {
  }
}, Ym = g5e ? Wx : function(e) {
  var t, n, r;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (n = S5e(t = C5e(e), _5e)) == "string" ? n : w5e ? Wx(t) : (r = Wx(t)) === "Object" && y5e(t.callee) ? "Arguments" : r;
}, x5e = Ym, SU = GR, E5e = P2, I5e = M2, k5e = Ya, A5e = k5e("iterator"), F_ = function(e) {
  if (!E5e(e)) return SU(e, A5e) || SU(e, "@@iterator") || I5e[x5e(e)];
}, P5e = Co, N5e = Ti, T5e = vs, O5e = Hm, R5e = F_, M5e = TypeError, JR = function(e, t) {
  var n = arguments.length < 2 ? R5e(e) : t;
  if (N5e(n)) return T5e(P5e(n, e));
  throw new M5e(O5e(e) + " is not iterable");
}, D5e = Co, xU = vs, L5e = GR, u8 = function(e, t, n) {
  var r, a;
  xU(e);
  try {
    if (r = L5e(e, "return"), !r) {
      if (t === "throw") throw n;
      return n;
    }
    r = D5e(r, e);
  } catch (o) {
    a = !0, r = o;
  }
  if (t === "throw") throw n;
  if (a) throw r;
  return xU(r), n;
}, $5e = ms, j5e = Co, F5e = vs, B5e = Hm, V5e = ute, U5e = Gu, EU = Sa, G5e = JR, z5e = F_, IU = u8, H5e = TypeError, Zx = function(e, t) {
  this.stopped = e, this.result = t;
}, kU = Zx.prototype, Td = function(e, t, n) {
  var r = n && n.that, a = !!(n && n.AS_ENTRIES), o = !!(n && n.IS_RECORD), s = !!(n && n.IS_ITERATOR), c = !!(n && n.INTERRUPTED), u = $5e(t, r), f, m, v, y, b, S, x, E = function(R) {
    return f && IU(f, "normal", R), new Zx(!0, R);
  }, N = function(R) {
    return a ? (F5e(R), c ? u(R[0], R[1], E) : u(R[0], R[1])) : c ? u(R, E) : u(R);
  };
  if (o)
    f = e.iterator;
  else if (s)
    f = e;
  else {
    if (m = z5e(e), !m) throw new H5e(B5e(e) + " is not iterable");
    if (V5e(m)) {
      for (v = 0, y = U5e(e); y > v; v++)
        if (b = N(e[v]), b && EU(kU, b)) return b;
      return new Zx(!1);
    }
    f = G5e(e, m);
  }
  for (S = o ? e.next : f.next; !(x = j5e(S, f)).done; ) {
    try {
      b = N(x.value);
    } catch (R) {
      IU(f, "throw", R);
    }
    if (typeof b == "object" && b && EU(kU, b)) return b;
  }
  return new Zx(!1);
}, W5e = Ym, Z5e = String, Us = function(e) {
  if (W5e(e) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
  return Z5e(e);
}, Y5e = Us, X5e = function(e, t) {
  return e === void 0 ? arguments.length < 2 ? "" : t : Y5e(e);
}, K5e = vt, q5e = Sa, J5e = R2, U7 = tte, Q5e = RCe, dte = Zm, sA = Wm, lA = zm, ewe = JCe, twe = c5e, nwe = Td, rwe = X5e, awe = Ya, owe = awe("toStringTag"), G7 = Error, iwe = [].push, c2 = function(t, n) {
  var r = q5e(uA, this), a;
  U7 ? a = U7(new G7(), r ? J5e(this) : uA) : (a = r ? this : dte(uA), sA(a, owe, "Error")), n !== void 0 && sA(a, "message", rwe(n)), twe(a, c2, a.stack, 1), arguments.length > 2 && ewe(a, arguments[2]);
  var o = [];
  return nwe(t, iwe, { that: o }), sA(a, "errors", o), a;
};
U7 ? U7(c2, G7) : Q5e(c2, G7, { name: !0 });
var uA = c2.prototype = dte(G7.prototype, {
  constructor: lA(1, c2),
  message: lA(1, ""),
  name: lA(1, "AggregateError")
});
K5e({ global: !0, constructor: !0, arity: 2 }, {
  AggregateError: c2
});
var swe = aa, lwe = bo, AU = swe.WeakMap, uwe = lwe(AU) && /native code/.test(String(AU)), cwe = uwe, fte = aa, dwe = Lo, fwe = Wm, cA = Qo, dA = HR, pwe = i8, hwe = L_, PU = "Object already initialized", wT = fte.TypeError, mwe = fte.WeakMap, z7, s_, H7, vwe = function(e) {
  return H7(e) ? s_(e) : z7(e, {});
}, gwe = function(e) {
  return function(t) {
    var n;
    if (!dwe(t) || (n = s_(t)).type !== e)
      throw new wT("Incompatible receiver, " + e + " required");
    return n;
  };
};
if (cwe || dA.state) {
  var hf = dA.state || (dA.state = new mwe());
  hf.get = hf.get, hf.has = hf.has, hf.set = hf.set, z7 = function(e, t) {
    if (hf.has(e)) throw new wT(PU);
    return t.facade = e, hf.set(e, t), t;
  }, s_ = function(e) {
    return hf.get(e) || {};
  }, H7 = function(e) {
    return hf.has(e);
  };
} else {
  var dy = pwe("state");
  hwe[dy] = !0, z7 = function(e, t) {
    if (cA(e, dy)) throw new wT(PU);
    return t.facade = e, fwe(e, dy, t), t;
  }, s_ = function(e) {
    return cA(e, dy) ? e[dy] : {};
  }, H7 = function(e) {
    return cA(e, dy);
  };
}
var Xm = {
  set: z7,
  get: s_,
  has: H7,
  enforce: vwe,
  getterFor: gwe
}, ST = _o, ywe = Qo, pte = Function.prototype, bwe = ST && Object.getOwnPropertyDescriptor, QR = ywe(pte, "name"), _we = QR && function() {
}.name === "something", Cwe = QR && (!ST || ST && bwe(pte, "name").configurable), hte = {
  EXISTS: QR,
  PROPER: _we,
  CONFIGURABLE: Cwe
}, wwe = Wm, Km = function(e, t, n, r) {
  return r && r.enumerable ? e[t] = n : wwe(e, t, n), e;
}, Swe = mr, xwe = bo, Ewe = Lo, Iwe = Zm, NU = R2, kwe = Km, Awe = Ya, xT = Awe("iterator"), mte = !1, $p, fA, pA;
[].keys && (pA = [].keys(), "next" in pA ? (fA = NU(NU(pA)), fA !== Object.prototype && ($p = fA)) : mte = !0);
var Pwe = !Ewe($p) || Swe(function() {
  var e = {};
  return $p[xT].call(e) !== e;
});
Pwe ? $p = {} : $p = Iwe($p);
xwe($p[xT]) || kwe($p, xT, function() {
  return this;
});
var vte = {
  IteratorPrototype: $p,
  BUGGY_SAFARI_ITERATORS: mte
}, Nwe = qR, Twe = Ym, Owe = Nwe ? {}.toString : function() {
  return "[object " + Twe(this) + "]";
}, Rwe = qR, Mwe = mu.f, Dwe = Wm, Lwe = Qo, $we = Owe, jwe = Ya, TU = jwe("toStringTag"), Rf = function(e, t, n, r) {
  var a = n ? e : e && e.prototype;
  a && (Lwe(a, TU) || Mwe(a, TU, { configurable: !0, value: t }), r && !Rwe && Dwe(a, "toString", $we));
}, Fwe = vte.IteratorPrototype, Bwe = Zm, Vwe = zm, Uwe = Rf, Gwe = M2, zwe = function() {
  return this;
}, gte = function(e, t, n, r) {
  var a = t + " Iterator";
  return e.prototype = Bwe(Fwe, { next: Vwe(+!r, n) }), Uwe(e, a, !1, !0), Gwe[a] = zwe, e;
}, Hwe = vt, Wwe = Co, yte = hte, Zwe = gte, Ywe = R2, Xwe = Rf, OU = Km, Kwe = Ya, RU = M2, bte = vte, qwe = yte.PROPER;
yte.CONFIGURABLE;
bte.IteratorPrototype;
var AS = bte.BUGGY_SAFARI_ITERATORS, hA = Kwe("iterator"), MU = "keys", PS = "values", DU = "entries", Jwe = function() {
  return this;
}, eM = function(e, t, n, r, a, o, s) {
  Zwe(n, t, r);
  var c = function(N) {
    if (N === a && y) return y;
    if (!AS && N && N in m) return m[N];
    switch (N) {
      case MU:
        return function() {
          return new n(this, N);
        };
      case PS:
        return function() {
          return new n(this, N);
        };
      case DU:
        return function() {
          return new n(this, N);
        };
    }
    return function() {
      return new n(this);
    };
  }, u = t + " Iterator", f = !1, m = e.prototype, v = m[hA] || m["@@iterator"] || a && m[a], y = !AS && v || c(a), b = t === "Array" && m.entries || v, S, x, E;
  if (b && (S = Ywe(b.call(new e())), S !== Object.prototype && S.next && (Xwe(S, u, !0, !0), RU[u] = Jwe)), qwe && a === PS && v && v.name !== PS && (f = !0, y = function() {
    return Wwe(v, this);
  }), a)
    if (x = {
      values: c(PS),
      keys: o ? y : c(MU),
      entries: c(DU)
    }, s) for (E in x)
      (AS || f || !(E in m)) && OU(m, E, x[E]);
    else Hwe({ target: t, proto: !0, forced: AS || f }, x);
  return s && m[hA] !== y && OU(m, hA, y, { name: a }), RU[t] = y, x;
}, c8 = function(e, t) {
  return { value: e, done: t };
}, Qwe = Tc, LU = M2, _te = Xm;
mu.f;
var eSe = eM, NS = c8, Cte = "Array Iterator", tSe = _te.set, nSe = _te.getterFor(Cte);
eSe(Array, "Array", function(e, t) {
  tSe(this, {
    type: Cte,
    target: Qwe(e),
    // target
    index: 0,
    // next index
    kind: t
    // kind
  });
}, function() {
  var e = nSe(this), t = e.target, n = e.index++;
  if (!t || n >= t.length)
    return e.target = null, NS(void 0, !0);
  switch (e.kind) {
    case "keys":
      return NS(n, !1);
    case "values":
      return NS(t[n], !1);
  }
  return NS([n, t[n]], !1);
}, "values");
LU.Arguments = LU.Array;
var a4 = aa, rSe = Xp, aSe = Tf, TS = function(e) {
  return rSe.slice(0, e.length) === e;
}, tM = function() {
  return TS("Bun/") ? "BUN" : TS("Cloudflare-Workers") ? "CLOUDFLARE" : TS("Deno/") ? "DENO" : TS("Node.js/") ? "NODE" : a4.Bun && typeof Bun.version == "string" ? "BUN" : a4.Deno && typeof Deno.version == "object" ? "DENO" : aSe(a4.process) === "process" ? "NODE" : a4.window && a4.document ? "BROWSER" : "REST";
}(), oSe = tM, d8 = oSe === "NODE", iSe = mu, B_ = function(e, t, n) {
  return iSe.f(e, t, n);
}, sSe = Ni, lSe = B_, uSe = Ya, cSe = _o, $U = uSe("species"), wte = function(e) {
  var t = sSe(e);
  cSe && t && !t[$U] && lSe(t, $U, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, dSe = Sa, fSe = TypeError, V_ = function(e, t) {
  if (dSe(t, e)) return e;
  throw new fSe("Incorrect invocation");
}, pSe = Rr, hSe = bo, ET = HR, mSe = pSe(Function.toString);
hSe(ET.inspectSource) || (ET.inspectSource = function(e) {
  return mSe(e);
});
var Ste = ET.inspectSource, vSe = Rr, gSe = mr, xte = bo, ySe = Ym, bSe = Ni, _Se = Ste, Ete = function() {
}, Ite = bSe("Reflect", "construct"), nM = /^\s*(?:class|function)\b/, CSe = vSe(nM.exec), wSe = !nM.test(Ete), o4 = function(t) {
  if (!xte(t)) return !1;
  try {
    return Ite(Ete, [], t), !0;
  } catch (n) {
    return !1;
  }
}, kte = function(t) {
  if (!xte(t)) return !1;
  switch (ySe(t)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return wSe || !!CSe(nM, _Se(t));
  } catch (n) {
    return !0;
  }
};
kte.sham = !0;
var f8 = !Ite || gSe(function() {
  var e;
  return o4(o4.call) || !o4(Object) || !o4(function() {
    e = !0;
  }) || e;
}) ? kte : o4, SSe = f8, xSe = Hm, ESe = TypeError, Ate = function(e) {
  if (SSe(e)) return e;
  throw new ESe(xSe(e) + " is not a constructor");
}, jU = vs, ISe = Ate, kSe = P2, ASe = Ya, PSe = ASe("species"), Pte = function(e, t) {
  var n = jU(e).constructor, r;
  return n === void 0 || kSe(r = jU(n)[PSe]) ? t : ISe(r);
}, NSe = Rr, Kp = NSe([].slice), TSe = TypeError, D2 = function(e, t) {
  if (e < t) throw new TSe("Not enough arguments");
  return e;
}, OSe = Xp, Nte = /(?:ipad|iphone|ipod).*applewebkit/i.test(OSe), Tu = aa, RSe = Um, MSe = ms, FU = bo, DSe = Qo, Tte = mr, BU = ate, LSe = Kp, VU = ZR, $Se = D2, jSe = Nte, FSe = d8, IT = Tu.setImmediate, kT = Tu.clearImmediate, BSe = Tu.process, mA = Tu.Dispatch, VSe = Tu.Function, UU = Tu.MessageChannel, USe = Tu.String, vA = 0, F4 = {}, GU = "onreadystatechange", l_, c0, gA, yA;
Tte(function() {
  l_ = Tu.location;
});
var rM = function(e) {
  if (DSe(F4, e)) {
    var t = F4[e];
    delete F4[e], t();
  }
}, bA = function(e) {
  return function() {
    rM(e);
  };
}, zU = function(e) {
  rM(e.data);
}, HU = function(e) {
  Tu.postMessage(USe(e), l_.protocol + "//" + l_.host);
};
(!IT || !kT) && (IT = function(t) {
  $Se(arguments.length, 1);
  var n = FU(t) ? t : VSe(t), r = LSe(arguments, 1);
  return F4[++vA] = function() {
    RSe(n, void 0, r);
  }, c0(vA), vA;
}, kT = function(t) {
  delete F4[t];
}, FSe ? c0 = function(e) {
  BSe.nextTick(bA(e));
} : mA && mA.now ? c0 = function(e) {
  mA.now(bA(e));
} : UU && !jSe ? (gA = new UU(), yA = gA.port2, gA.port1.onmessage = zU, c0 = MSe(yA.postMessage, yA)) : Tu.addEventListener && FU(Tu.postMessage) && !Tu.importScripts && l_ && l_.protocol !== "file:" && !Tte(HU) ? (c0 = HU, Tu.addEventListener("message", zU, !1)) : GU in VU("script") ? c0 = function(e) {
  BU.appendChild(VU("script"))[GU] = function() {
    BU.removeChild(this), rM(e);
  };
} : c0 = function(e) {
  setTimeout(bA(e), 0);
});
var Ote = {
  set: IT,
  clear: kT
}, WU = aa, GSe = _o, zSe = Object.getOwnPropertyDescriptor, Rte = function(e) {
  if (!GSe) return WU[e];
  var t = zSe(WU, e);
  return t && t.value;
}, Mte = function() {
  this.head = null, this.tail = null;
};
Mte.prototype = {
  add: function(e) {
    var t = { item: e, next: null }, n = this.tail;
    n ? n.next = t : this.head = t, this.tail = t;
  },
  get: function() {
    var e = this.head;
    if (e) {
      var t = this.head = e.next;
      return t === null && (this.tail = null), e.item;
    }
  }
};
var Dte = Mte, HSe = Xp, WSe = /ipad|iphone|ipod/i.test(HSe) && typeof Pebble != "undefined", ZSe = Xp, YSe = /web0s(?!.*chrome)/i.test(ZSe), d2 = aa, XSe = Rte, ZU = ms, _A = Ote.set, KSe = Dte, qSe = Nte, JSe = WSe, QSe = YSe, CA = d8, YU = d2.MutationObserver || d2.WebKitMutationObserver, XU = d2.document, KU = d2.process, OS = d2.Promise, AT = XSe("queueMicrotask"), fy, wA, SA, RS, qU;
if (!AT) {
  var MS = new KSe(), DS = function() {
    var e, t;
    for (CA && (e = KU.domain) && e.exit(); t = MS.get(); ) try {
      t();
    } catch (n) {
      throw MS.head && fy(), n;
    }
    e && e.enter();
  };
  !qSe && !CA && !QSe && YU && XU ? (wA = !0, SA = XU.createTextNode(""), new YU(DS).observe(SA, { characterData: !0 }), fy = function() {
    SA.data = wA = !wA;
  }) : !JSe && OS && OS.resolve ? (RS = OS.resolve(void 0), RS.constructor = OS, qU = ZU(RS.then, RS), fy = function() {
    qU(DS);
  }) : CA ? fy = function() {
    KU.nextTick(DS);
  } : (_A = ZU(_A, d2), fy = function() {
    _A(DS);
  }), AT = function(e) {
    MS.head || fy(), MS.add(e);
  };
}
var exe = AT, txe = function(e, t) {
  try {
    arguments.length === 1 ? console.error(e) : console.error(e, t);
  } catch (n) {
  }
}, L2 = function(e) {
  try {
    return { error: !1, value: e() };
  } catch (t) {
    return { error: !0, value: t };
  }
}, nxe = aa, $2 = nxe.Promise, rxe = aa, B4 = $2, axe = bo, oxe = Jee, ixe = Ste, sxe = Ya, JU = tM, xA = N2, QU = B4 && B4.prototype, lxe = sxe("species"), PT = !1, Lte = axe(rxe.PromiseRejectionEvent), uxe = oxe("Promise", function() {
  var e = ixe(B4), t = e !== String(B4);
  if (!t && xA === 66 || !(QU.catch && QU.finally)) return !0;
  if (!xA || xA < 51 || !/native code/.test(e)) {
    var n = new B4(function(o) {
      o(1);
    }), r = function(o) {
      o(function() {
      }, function() {
      });
    }, a = n.constructor = {};
    if (a[lxe] = r, PT = n.then(function() {
    }) instanceof r, !PT) return !0;
  }
  return !t && (JU === "BROWSER" || JU === "DENO") && !Lte;
}), U_ = {
  CONSTRUCTOR: uxe,
  REJECTION_EVENT: Lte,
  SUBCLASSING: PT
}, Mf = {}, eG = Ti, cxe = TypeError, dxe = function(e) {
  var t, n;
  this.promise = new e(function(r, a) {
    if (t !== void 0 || n !== void 0) throw new cxe("Bad Promise constructor");
    t = r, n = a;
  }), this.resolve = eG(t), this.reject = eG(n);
};
Mf.f = function(e) {
  return new dxe(e);
};
var fxe = vt, W7 = d8, Lm = aa, G_ = Co, pxe = Km, hxe = Rf, mxe = wte, vxe = Ti, NT = bo, gxe = Lo, yxe = V_, bxe = Pte, $te = Ote.set, aM = exe, _xe = txe, Cxe = L2, wxe = Dte, jte = Xm, TT = $2, oM = U_, Fte = Mf, p8 = "Promise", Bte = oM.CONSTRUCTOR, Sxe = oM.REJECTION_EVENT;
oM.SUBCLASSING;
var EA = jte.getterFor(p8), xxe = jte.set, Exe = TT && TT.prototype, Ry = TT, IA = Exe, Vte = Lm.TypeError, OT = Lm.document, iM = Lm.process, RT = Fte.f, Ixe = RT, kxe = !!(OT && OT.createEvent && Lm.dispatchEvent), Ute = "unhandledrejection", Axe = "rejectionhandled", tG = 0, Gte = 1, Pxe = 2, sM = 1, zte = 2, LS, nG, Nxe, Hte = function(e) {
  var t;
  return gxe(e) && NT(t = e.then) ? t : !1;
}, Wte = function(e, t) {
  var n = t.value, r = t.state === Gte, a = r ? e.ok : e.fail, o = e.resolve, s = e.reject, c = e.domain, u, f, m;
  try {
    a ? (r || (t.rejection === zte && Oxe(t), t.rejection = sM), a === !0 ? u = n : (c && c.enter(), u = a(n), c && (c.exit(), m = !0)), u === e.promise ? s(new Vte("Promise-chain cycle")) : (f = Hte(u)) ? G_(f, u, o, s) : o(u)) : s(n);
  } catch (v) {
    c && !m && c.exit(), s(v);
  }
}, Zte = function(e, t) {
  e.notified || (e.notified = !0, aM(function() {
    for (var n = e.reactions, r; r = n.get(); )
      Wte(r, e);
    e.notified = !1, t && !e.rejection && Txe(e);
  }));
}, Yte = function(e, t, n) {
  var r, a;
  kxe ? (r = OT.createEvent("Event"), r.promise = t, r.reason = n, r.initEvent(e, !1, !0), Lm.dispatchEvent(r)) : r = { promise: t, reason: n }, !Sxe && (a = Lm["on" + e]) ? a(r) : e === Ute && _xe("Unhandled promise rejection", n);
}, Txe = function(e) {
  G_($te, Lm, function() {
    var t = e.facade, n = e.value, r = rG(e), a;
    if (r && (a = Cxe(function() {
      W7 ? iM.emit("unhandledRejection", n, t) : Yte(Ute, t, n);
    }), e.rejection = W7 || rG(e) ? zte : sM, a.error))
      throw a.value;
  });
}, rG = function(e) {
  return e.rejection !== sM && !e.parent;
}, Oxe = function(e) {
  G_($te, Lm, function() {
    var t = e.facade;
    W7 ? iM.emit("rejectionHandled", t) : Yte(Axe, t, e.value);
  });
}, My = function(e, t, n) {
  return function(r) {
    e(t, r, n);
  };
}, Ky = function(e, t, n) {
  e.done || (e.done = !0, n && (e = n), e.value = t, e.state = Pxe, Zte(e, !0));
}, MT = function(e, t, n) {
  if (!e.done) {
    e.done = !0, n && (e = n);
    try {
      if (e.facade === t) throw new Vte("Promise can't be resolved itself");
      var r = Hte(t);
      r ? aM(function() {
        var a = { done: !1 };
        try {
          G_(
            r,
            t,
            My(MT, a, e),
            My(Ky, a, e)
          );
        } catch (o) {
          Ky(a, o, e);
        }
      }) : (e.value = t, e.state = Gte, Zte(e, !1));
    } catch (a) {
      Ky({ done: !1 }, a, e);
    }
  }
};
Bte && (Ry = function(t) {
  yxe(this, IA), vxe(t), G_(LS, this);
  var n = EA(this);
  try {
    t(My(MT, n), My(Ky, n));
  } catch (r) {
    Ky(n, r);
  }
}, IA = Ry.prototype, LS = function(t) {
  xxe(this, {
    type: p8,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new wxe(),
    rejection: !1,
    state: tG,
    value: null
  });
}, LS.prototype = pxe(IA, "then", function(t, n) {
  var r = EA(this), a = RT(bxe(this, Ry));
  return r.parent = !0, a.ok = NT(t) ? t : !0, a.fail = NT(n) && n, a.domain = W7 ? iM.domain : void 0, r.state === tG ? r.reactions.add(a) : aM(function() {
    Wte(a, r);
  }), a.promise;
}), nG = function() {
  var e = new LS(), t = EA(e);
  this.promise = e, this.resolve = My(MT, t), this.reject = My(Ky, t);
}, Fte.f = RT = function(e) {
  return e === Ry || e === Nxe ? new nG(e) : Ixe(e);
});
fxe({ global: !0, constructor: !0, wrap: !0, forced: Bte }, {
  Promise: Ry
});
hxe(Ry, p8, !1, !0);
mxe(p8);
var Rxe = Ya, Xte = Rxe("iterator"), Kte = !1;
try {
  var Mxe = 0, aG = {
    next: function() {
      return { done: !!Mxe++ };
    },
    return: function() {
      Kte = !0;
    }
  };
  aG[Xte] = function() {
    return this;
  }, Array.from(aG, function() {
    throw 2;
  });
} catch (e) {
}
var qte = function(e, t) {
  try {
    if (!t && !Kte) return !1;
  } catch (a) {
    return !1;
  }
  var n = !1;
  try {
    var r = {};
    r[Xte] = function() {
      return {
        next: function() {
          return { done: n = !0 };
        }
      };
    }, e(r);
  } catch (a) {
  }
  return n;
}, Dxe = $2, Lxe = qte, $xe = U_.CONSTRUCTOR, h8 = $xe || !Lxe(function(e) {
  Dxe.all(e).then(void 0, function() {
  });
}), jxe = vt, Fxe = Co, Bxe = Ti, Vxe = Mf, Uxe = L2, Gxe = Td, zxe = h8;
jxe({ target: "Promise", stat: !0, forced: zxe }, {
  all: function(t) {
    var n = this, r = Vxe.f(n), a = r.resolve, o = r.reject, s = Uxe(function() {
      var c = Bxe(n.resolve), u = [], f = 0, m = 1;
      Gxe(t, function(v) {
        var y = f++, b = !1;
        m++, Fxe(c, n, v).then(function(S) {
          b || (b = !0, u[y] = S, --m || a(u));
        }, o);
      }), --m || a(u);
    });
    return s.error && o(s.value), r.promise;
  }
});
var Hxe = vt, Wxe = U_.CONSTRUCTOR, oG = $2;
oG && oG.prototype;
Hxe({ target: "Promise", proto: !0, forced: Wxe, real: !0 }, {
  catch: function(e) {
    return this.then(void 0, e);
  }
});
var Zxe = vt, Yxe = Co, Xxe = Ti, Kxe = Mf, qxe = L2, Jxe = Td, Qxe = h8;
Zxe({ target: "Promise", stat: !0, forced: Qxe }, {
  race: function(t) {
    var n = this, r = Kxe.f(n), a = r.reject, o = qxe(function() {
      var s = Xxe(n.resolve);
      Jxe(t, function(c) {
        Yxe(s, n, c).then(r.resolve, a);
      });
    });
    return o.error && a(o.value), r.promise;
  }
});
var e7e = vt, t7e = Mf, n7e = U_.CONSTRUCTOR;
e7e({ target: "Promise", stat: !0, forced: n7e }, {
  reject: function(t) {
    var n = t7e.f(this), r = n.reject;
    return r(t), n.promise;
  }
});
var r7e = vs, a7e = Lo, o7e = Mf, Jte = function(e, t) {
  if (r7e(e), a7e(t) && t.constructor === e) return t;
  var n = o7e.f(e), r = n.resolve;
  return r(t), n.promise;
}, i7e = vt, s7e = Ni, l7e = zR, u7e = $2, c7e = U_.CONSTRUCTOR, d7e = Jte, f7e = s7e("Promise"), p7e = !c7e;
i7e({ target: "Promise", stat: !0, forced: l7e }, {
  resolve: function(t) {
    return d7e(p7e && this === f7e ? u7e : this, t);
  }
});
var h7e = vt, m7e = Co, v7e = Ti, g7e = Mf, y7e = L2, b7e = Td, _7e = h8;
h7e({ target: "Promise", stat: !0, forced: _7e }, {
  allSettled: function(t) {
    var n = this, r = g7e.f(n), a = r.resolve, o = r.reject, s = y7e(function() {
      var c = v7e(n.resolve), u = [], f = 0, m = 1;
      b7e(t, function(v) {
        var y = f++, b = !1;
        m++, m7e(c, n, v).then(function(S) {
          b || (b = !0, u[y] = { status: "fulfilled", value: S }, --m || a(u));
        }, function(S) {
          b || (b = !0, u[y] = { status: "rejected", reason: S }, --m || a(u));
        });
      }), --m || a(u);
    });
    return s.error && o(s.value), r.promise;
  }
});
var C7e = vt, w7e = Co, S7e = Ti, x7e = Ni, E7e = Mf, I7e = L2, k7e = Td, A7e = h8, iG = "No one promise resolved";
C7e({ target: "Promise", stat: !0, forced: A7e }, {
  any: function(t) {
    var n = this, r = x7e("AggregateError"), a = E7e.f(n), o = a.resolve, s = a.reject, c = I7e(function() {
      var u = S7e(n.resolve), f = [], m = 0, v = 1, y = !1;
      k7e(t, function(b) {
        var S = m++, x = !1;
        v++, w7e(u, n, b).then(function(E) {
          x || y || (y = !0, o(E));
        }, function(E) {
          x || y || (x = !0, f[S] = E, --v || s(new r(f, iG)));
        });
      }), --v || s(new r(f, iG));
    });
    return c.error && s(c.value), a.promise;
  }
});
var P7e = vt, N7e = Mf;
P7e({ target: "Promise", stat: !0 }, {
  withResolvers: function() {
    var t = N7e.f(this);
    return {
      promise: t.promise,
      resolve: t.resolve,
      reject: t.reject
    };
  }
});
var T7e = vt, DT = $2, O7e = mr, R7e = Ni, M7e = bo, D7e = Pte, sG = Jte, L7e = DT && DT.prototype, $7e = !!DT && O7e(function() {
  L7e.finally.call({ then: function() {
  } }, function() {
  });
});
T7e({ target: "Promise", proto: !0, real: !0, forced: $7e }, {
  finally: function(e) {
    var t = D7e(this, R7e("Promise")), n = M7e(e);
    return this.then(
      n ? function(r) {
        return sG(t, e()).then(function() {
          return r;
        });
      } : e,
      n ? function(r) {
        return sG(t, e()).then(function() {
          throw r;
        });
      } : e
    );
  }
});
var lM = Rr, j7e = s1, F7e = Us, B7e = Of, V7e = lM("".charAt), lG = lM("".charCodeAt), U7e = lM("".slice), uG = function(e) {
  return function(t, n) {
    var r = F7e(B7e(t)), a = j7e(n), o = r.length, s, c;
    return a < 0 || a >= o ? e ? "" : void 0 : (s = lG(r, a), s < 55296 || s > 56319 || a + 1 === o || (c = lG(r, a + 1)) < 56320 || c > 57343 ? e ? V7e(r, a) : s : e ? U7e(r, a, a + 2) : (s - 55296 << 10) + (c - 56320) + 65536);
  };
}, Qte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: uG(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: uG(!0)
}, G7e = Qte.charAt, z7e = Us, ene = Xm, H7e = eM, cG = c8, tne = "String Iterator", W7e = ene.set, Z7e = ene.getterFor(tne);
H7e(String, "String", function(e) {
  W7e(this, {
    type: tne,
    string: z7e(e),
    index: 0
  });
}, function() {
  var t = Z7e(this), n = t.string, r = t.index, a;
  return r >= n.length ? cG(void 0, !0) : (a = G7e(n, r), t.index += a.length, cG(a, !1));
});
var Y7e = Yr, X7e = Y7e.Promise, K7e = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, q7e = K7e, J7e = aa, Q7e = Rf, dG = M2;
for (var kA in q7e)
  Q7e(J7e[kA], kA), dG[kA] = dG.Array;
var e6e = X7e, nne = e6e, t6e = vt, n6e = aa, r6e = Um, a6e = Kp, o6e = Mf, i6e = Ti, rne = L2, AA = n6e.Promise, fG = !1, s6e = !AA || !AA.try || rne(function() {
  AA.try(function(e) {
    fG = e === 8;
  }, 8);
}).error || !fG;
t6e({ target: "Promise", stat: !0, forced: s6e }, {
  try: function(e) {
    var t = arguments.length > 1 ? a6e(arguments, 1) : [], n = o6e.f(this), r = rne(function() {
      return r6e(i6e(e), void 0, t);
    });
    return (r.error ? n.reject : n.resolve)(r.value), n.promise;
  }
});
var l6e = nne, u6e = l6e, c6e = u6e, d6e = c6e, ane = d6e;
const one = /* @__PURE__ */ Mt(ane);
function pG(e, t, n, r, a, o, s) {
  try {
    var c = e[o](s), u = c.value;
  } catch (f) {
    return void n(f);
  }
  c.done ? t(u) : one.resolve(u).then(r, a);
}
function On(e) {
  return function() {
    var t = this, n = arguments;
    return new one(function(r, a) {
      var o = e.apply(t, n);
      function s(u) {
        pG(o, r, a, s, c, "next", u);
      }
      function c(u) {
        pG(o, r, a, s, c, "throw", u);
      }
      s(void 0);
    });
  };
}
var ine = { exports: {} }, sne = { exports: {} }, f6e = Tf, qm = Array.isArray || function(t) {
  return f6e(t) === "Array";
}, p6e = TypeError, h6e = 9007199254740991, uM = function(e) {
  if (e > h6e) throw p6e("Maximum allowed index exceeded");
  return e;
}, m6e = _o, v6e = mu, g6e = zm, m8 = function(e, t, n) {
  m6e ? v6e.f(e, t, g6e(0, n)) : e[t] = n;
}, hG = qm, y6e = f8, b6e = Lo, _6e = Ya, C6e = _6e("species"), mG = Array, w6e = function(e) {
  var t;
  return hG(e) && (t = e.constructor, y6e(t) && (t === mG || hG(t.prototype)) ? t = void 0 : b6e(t) && (t = t[C6e], t === null && (t = void 0))), t === void 0 ? mG : t;
}, S6e = w6e, cM = function(e, t) {
  return new (S6e(e))(t === 0 ? 0 : t);
}, x6e = mr, E6e = Ya, I6e = N2, k6e = E6e("species"), v8 = function(e) {
  return I6e >= 51 || !x6e(function() {
    var t = [], n = t.constructor = {};
    return n[k6e] = function() {
      return { foo: 1 };
    }, t[e](Boolean).foo !== 1;
  });
}, A6e = vt, P6e = mr, N6e = qm, T6e = Lo, O6e = hl, R6e = Gu, vG = uM, gG = m8, M6e = cM, D6e = v8, L6e = Ya, $6e = N2, lne = L6e("isConcatSpreadable"), j6e = $6e >= 51 || !P6e(function() {
  var e = [];
  return e[lne] = !1, e.concat()[0] !== e;
}), F6e = function(e) {
  if (!T6e(e)) return !1;
  var t = e[lne];
  return t !== void 0 ? !!t : N6e(e);
}, B6e = !j6e || !D6e("concat");
A6e({ target: "Array", proto: !0, arity: 1, forced: B6e }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(t) {
    var n = O6e(this), r = M6e(n, 0), a = 0, o, s, c, u, f;
    for (o = -1, c = arguments.length; o < c; o++)
      if (f = o === -1 ? n : arguments[o], F6e(f))
        for (u = R6e(f), vG(a + u), s = 0; s < u; s++, a++) s in f && gG(r, a, f[s]);
      else
        vG(a + 1), gG(r, a++, f);
    return r.length = a, r;
  }
});
var g8 = {}, V6e = Tf, U6e = Tc, une = D_.f, G6e = Kp, cne = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], z6e = function(e) {
  try {
    return une(e);
  } catch (t) {
    return G6e(cne);
  }
};
g8.f = function(t) {
  return cne && V6e(t) === "Window" ? z6e(t) : une(U6e(t));
};
var z_ = {}, H6e = Ya;
z_.f = H6e;
var yG = Yr, W6e = Qo, Z6e = z_, Y6e = mu.f, $o = function(e) {
  var t = yG.Symbol || (yG.Symbol = {});
  W6e(t, e) || Y6e(t, e, {
    value: Z6e.f(e)
  });
}, X6e = Co, K6e = Ni, q6e = Ya, J6e = Km, dne = function() {
  var e = K6e("Symbol"), t = e && e.prototype, n = t && t.valueOf, r = q6e("toPrimitive");
  t && !t[r] && J6e(t, r, function(a) {
    return X6e(n, this);
  }, { arity: 1 });
}, Q6e = ms, e8e = Rr, t8e = a8, n8e = hl, r8e = Gu, a8e = cM, bG = e8e([].push), um = function(e) {
  var t = e === 1, n = e === 2, r = e === 3, a = e === 4, o = e === 6, s = e === 7, c = e === 5 || o;
  return function(u, f, m, v) {
    for (var y = n8e(u), b = t8e(y), S = r8e(b), x = Q6e(f, m), E = 0, N = v || a8e, R = t ? N(u, S) : n || s ? N(u, 0) : void 0, O, D; S > E; E++) if ((c || E in b) && (O = b[E], D = x(O, E, y), e))
      if (t) R[E] = D;
      else if (D) switch (e) {
        case 3:
          return !0;
        case 5:
          return O;
        case 6:
          return E;
        case 2:
          bG(R, O);
      }
      else switch (e) {
        case 4:
          return !1;
        case 7:
          bG(R, O);
      }
    return o ? -1 : r || a ? a : R;
  };
}, qp = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: um(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: um(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: um(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: um(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: um(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: um(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: um(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: um(7)
}, y8 = vt, H_ = aa, dM = Co, o8e = Rr, f2 = _o, p2 = T2, i8e = mr, ds = Qo, s8e = Sa, LT = vs, b8 = Tc, fM = WR, l8e = Us, $T = zm, h2 = Zm, fne = j_, u8e = D_, pne = g8, c8e = $_, hne = Gm, mne = mu, d8e = l8, vne = O_, _G = Km, f8e = B_, pM = O2, p8e = i8, gne = L_, CG = o8, h8e = Ya, m8e = z_, v8e = $o, g8e = dne, y8e = Rf, yne = Xm, _8 = qp.forEach, lu = p8e("hidden"), C8 = "Symbol", u_ = "prototype", b8e = yne.set, wG = yne.getterFor(C8), wd = Object[u_], $0 = H_.Symbol, C4 = $0 && $0[u_], _8e = H_.RangeError, C8e = H_.TypeError, PA = H_.QObject, bne = hne.f, j0 = mne.f, _ne = pne.f, w8e = vne.f, Cne = o8e([].push), Up = pM("symbols"), W_ = pM("op-symbols"), S8e = pM("wks"), jT = !PA || !PA[u_] || !PA[u_].findChild, wne = function(e, t, n) {
  var r = bne(wd, t);
  r && delete wd[t], j0(e, t, n), r && e !== wd && j0(wd, t, r);
}, FT = f2 && i8e(function() {
  return h2(j0({}, "a", {
    get: function() {
      return j0(this, "a", { value: 7 }).a;
    }
  })).a !== 7;
}) ? wne : j0, NA = function(e, t) {
  var n = Up[e] = h2(C4);
  return b8e(n, {
    type: C8,
    tag: e,
    description: t
  }), f2 || (n.description = t), n;
}, w8 = function(t, n, r) {
  t === wd && w8(W_, n, r), LT(t);
  var a = fM(n);
  return LT(r), ds(Up, a) ? (r.enumerable ? (ds(t, lu) && t[lu][a] && (t[lu][a] = !1), r = h2(r, { enumerable: $T(0, !1) })) : (ds(t, lu) || j0(t, lu, $T(1, h2(null))), t[lu][a] = !0), FT(t, a, r)) : j0(t, a, r);
}, hM = function(t, n) {
  LT(t);
  var r = b8(n), a = fne(r).concat(Ine(r));
  return _8(a, function(o) {
    (!f2 || dM(Sne, r, o)) && w8(t, o, r[o]);
  }), t;
}, x8e = function(t, n) {
  return n === void 0 ? h2(t) : hM(h2(t), n);
}, Sne = function(t) {
  var n = fM(t), r = dM(w8e, this, n);
  return this === wd && ds(Up, n) && !ds(W_, n) ? !1 : r || !ds(this, n) || !ds(Up, n) || ds(this, lu) && this[lu][n] ? r : !0;
}, xne = function(t, n) {
  var r = b8(t), a = fM(n);
  if (!(r === wd && ds(Up, a) && !ds(W_, a))) {
    var o = bne(r, a);
    return o && ds(Up, a) && !(ds(r, lu) && r[lu][a]) && (o.enumerable = !0), o;
  }
}, Ene = function(t) {
  var n = _ne(b8(t)), r = [];
  return _8(n, function(a) {
    !ds(Up, a) && !ds(gne, a) && Cne(r, a);
  }), r;
}, Ine = function(e) {
  var t = e === wd, n = _ne(t ? W_ : b8(e)), r = [];
  return _8(n, function(a) {
    ds(Up, a) && (!t || ds(wd, a)) && Cne(r, Up[a]);
  }), r;
};
p2 || ($0 = function() {
  if (s8e(C4, this)) throw new C8e("Symbol is not a constructor");
  var t = !arguments.length || arguments[0] === void 0 ? void 0 : l8e(arguments[0]), n = CG(t), r = function(a) {
    var o = this === void 0 ? H_ : this;
    o === wd && dM(r, W_, a), ds(o, lu) && ds(o[lu], n) && (o[lu][n] = !1);
    var s = $T(1, a);
    try {
      FT(o, n, s);
    } catch (c) {
      if (!(c instanceof _8e)) throw c;
      wne(o, n, s);
    }
  };
  return f2 && jT && FT(wd, n, { configurable: !0, set: r }), NA(n, t);
}, C4 = $0[u_], _G(C4, "toString", function() {
  return wG(this).tag;
}), _G($0, "withoutSetter", function(e) {
  return NA(CG(e), e);
}), vne.f = Sne, mne.f = w8, d8e.f = hM, hne.f = xne, u8e.f = pne.f = Ene, c8e.f = Ine, m8e.f = function(e) {
  return NA(h8e(e), e);
}, f2 && f8e(C4, "description", {
  configurable: !0,
  get: function() {
    return wG(this).description;
  }
}));
y8({ global: !0, constructor: !0, wrap: !0, forced: !p2, sham: !p2 }, {
  Symbol: $0
});
_8(fne(S8e), function(e) {
  v8e(e);
});
y8({ target: C8, stat: !0, forced: !p2 }, {
  useSetter: function() {
    jT = !0;
  },
  useSimple: function() {
    jT = !1;
  }
});
y8({ target: "Object", stat: !0, forced: !p2, sham: !f2 }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: x8e,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: w8,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: hM,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: xne
});
y8({ target: "Object", stat: !0, forced: !p2 }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: Ene
});
g8e();
y8e($0, C8);
gne[lu] = !0;
var E8e = T2, kne = E8e && !!Symbol.for && !!Symbol.keyFor, I8e = vt, k8e = Ni, A8e = Qo, P8e = Us, Ane = O2, N8e = kne, TA = Ane("string-to-symbol-registry"), T8e = Ane("symbol-to-string-registry");
I8e({ target: "Symbol", stat: !0, forced: !N8e }, {
  for: function(e) {
    var t = P8e(e);
    if (A8e(TA, t)) return TA[t];
    var n = k8e("Symbol")(t);
    return TA[t] = n, T8e[n] = t, n;
  }
});
var O8e = vt, R8e = Qo, M8e = R_, D8e = Hm, L8e = O2, $8e = kne, SG = L8e("symbol-to-string-registry");
O8e({ target: "Symbol", stat: !0, forced: !$8e }, {
  keyFor: function(t) {
    if (!M8e(t)) throw new TypeError(D8e(t) + " is not a symbol");
    if (R8e(SG, t)) return SG[t];
  }
});
var j8e = Rr, xG = qm, F8e = bo, EG = Tf, B8e = Us, IG = j8e([].push), V8e = function(e) {
  if (F8e(e)) return e;
  if (xG(e)) {
    for (var t = e.length, n = [], r = 0; r < t; r++) {
      var a = e[r];
      typeof a == "string" ? IG(n, a) : (typeof a == "number" || EG(a) === "Number" || EG(a) === "String") && IG(n, B8e(a));
    }
    var o = n.length, s = !0;
    return function(c, u) {
      if (s)
        return s = !1, u;
      if (xG(this)) return u;
      for (var f = 0; f < o; f++) if (n[f] === c) return u;
    };
  }
}, U8e = vt, Pne = Ni, Nne = Um, G8e = Co, Z_ = Rr, Tne = mr, kG = bo, AG = R_, One = Kp, z8e = V8e, H8e = T2, W8e = String, Om = Pne("JSON", "stringify"), $S = Z_(/./.exec), PG = Z_("".charAt), Z8e = Z_("".charCodeAt), Y8e = Z_("".replace), X8e = Z_(1 .toString), K8e = /[\uD800-\uDFFF]/g, NG = /^[\uD800-\uDBFF]$/, TG = /^[\uDC00-\uDFFF]$/, OG = !H8e || Tne(function() {
  var e = Pne("Symbol")("stringify detection");
  return Om([e]) !== "[null]" || Om({ a: e }) !== "{}" || Om(Object(e)) !== "{}";
}), RG = Tne(function() {
  return Om("\uDF06\uD834") !== '"\\udf06\\ud834"' || Om("\uDEAD") !== '"\\udead"';
}), q8e = function(e, t) {
  var n = One(arguments), r = z8e(t);
  if (!(!kG(r) && (e === void 0 || AG(e))))
    return n[1] = function(a, o) {
      if (kG(r) && (o = G8e(r, this, W8e(a), o)), !AG(o)) return o;
    }, Nne(Om, null, n);
}, J8e = function(e, t, n) {
  var r = PG(n, t - 1), a = PG(n, t + 1);
  return $S(NG, e) && !$S(TG, a) || $S(TG, e) && !$S(NG, r) ? "\\u" + X8e(Z8e(e, 0), 16) : e;
};
Om && U8e({ target: "JSON", stat: !0, arity: 3, forced: OG || RG }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(t, n, r) {
    var a = One(arguments), o = Nne(OG ? q8e : Om, null, a);
    return RG && typeof o == "string" ? Y8e(o, K8e, J8e) : o;
  }
});
var Q8e = vt, e9e = T2, t9e = mr, Rne = $_, n9e = hl, r9e = !e9e || t9e(function() {
  Rne.f(1);
});
Q8e({ target: "Object", stat: !0, forced: r9e }, {
  getOwnPropertySymbols: function(t) {
    var n = Rne.f;
    return n ? n(n9e(t)) : [];
  }
});
var a9e = $o;
a9e("asyncIterator");
var o9e = $o;
o9e("hasInstance");
var i9e = $o;
i9e("isConcatSpreadable");
var s9e = $o;
s9e("iterator");
var l9e = $o;
l9e("match");
var u9e = $o;
u9e("matchAll");
var c9e = $o;
c9e("replace");
var d9e = $o;
d9e("search");
var f9e = $o;
f9e("species");
var p9e = $o;
p9e("split");
var h9e = $o, m9e = dne;
h9e("toPrimitive");
m9e();
var v9e = Ni, g9e = $o, y9e = Rf;
g9e("toStringTag");
y9e(v9e("Symbol"), "Symbol");
var b9e = $o;
b9e("unscopables");
var _9e = aa, C9e = Rf;
C9e(_9e.JSON, "JSON", !0);
var w9e = Yr, S9e = w9e.Symbol, x9e = S9e, Mne = x9e, E9e = Ya, I9e = mu.f, MG = E9e("metadata"), DG = Function.prototype;
DG[MG] === void 0 && I9e(DG, MG, {
  value: null
});
var k9e = $o;
k9e("asyncDispose");
var A9e = $o;
A9e("dispose");
var P9e = $o;
P9e("metadata");
var N9e = Mne, T9e = N9e, O9e = Ni, R9e = Rr, mM = O9e("Symbol"), M9e = mM.keyFor, D9e = R9e(mM.prototype.valueOf), Dne = mM.isRegisteredSymbol || function(t) {
  try {
    return M9e(D9e(t)) !== void 0;
  } catch (n) {
    return !1;
  }
}, L9e = vt, $9e = Dne;
L9e({ target: "Symbol", stat: !0 }, {
  isRegisteredSymbol: $9e
});
var j9e = O2, Lne = Ni, F9e = Rr, B9e = R_, V9e = Ya, Z7 = Lne("Symbol"), LG = Z7.isWellKnownSymbol, $ne = Lne("Object", "getOwnPropertyNames"), U9e = F9e(Z7.prototype.valueOf), $G = j9e("wks");
for (var OA = 0, jG = $ne(Z7), G9e = jG.length; OA < G9e; OA++)
  try {
    var FG = jG[OA];
    B9e(Z7[FG]) && V9e(FG);
  } catch (e) {
  }
var jne = function(t) {
  if (LG && LG(t)) return !0;
  try {
    for (var n = U9e(t), r = 0, a = $ne($G), o = a.length; r < o; r++)
      if ($G[a[r]] == n) return !0;
  } catch (s) {
  }
  return !1;
}, z9e = vt, H9e = jne;
z9e({ target: "Symbol", stat: !0, forced: !0 }, {
  isWellKnownSymbol: H9e
});
var W9e = $o;
W9e("customMatcher");
var Z9e = $o;
Z9e("observable");
var Y9e = vt, X9e = Dne;
Y9e({ target: "Symbol", stat: !0, name: "isRegisteredSymbol" }, {
  isRegistered: X9e
});
var K9e = vt, q9e = jne;
K9e({ target: "Symbol", stat: !0, name: "isWellKnownSymbol", forced: !0 }, {
  isWellKnown: q9e
});
var J9e = $o;
J9e("matcher");
var Q9e = $o;
Q9e("metadataKey");
var eEe = $o;
eEe("patternMatch");
var tEe = $o;
tEe("replaceAll");
var nEe = T9e, rEe = nEe, vM = rEe;
const Dy = /* @__PURE__ */ Mt(vM);
var aEe = z_, oEe = aEe.f("iterator"), iEe = oEe, Fne = iEe, sEe = Fne, lEe = sEe, uEe = lEe, cEe = uEe, Bne = cEe;
const dEe = /* @__PURE__ */ Mt(Bne);
(function(e) {
  var t = vM, n = Bne;
  function r(a) {
    "@babel/helpers - typeof";
    return e.exports = r = typeof t == "function" && typeof n == "symbol" ? function(o) {
      return typeof o;
    } : function(o) {
      return o && typeof t == "function" && o.constructor === t && o !== t.prototype ? "symbol" : typeof o;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, r(a);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(sne);
var fEe = sne.exports, Vne = { exports: {} }, pEe = vt, hEe = _o, BG = mu.f;
pEe({ target: "Object", stat: !0, forced: Object.defineProperty !== BG, sham: !hEe }, {
  defineProperty: BG
});
var mEe = Yr, Une = mEe.Object, vEe = Vne.exports = function(t, n, r) {
  return Une.defineProperty(t, n, r);
};
Une.defineProperty.sham && (vEe.sham = !0);
var gEe = Vne.exports, yEe = gEe, Gne = yEe, bEe = Gne, _Ee = bEe, CEe = _Ee, wEe = CEe, zne = wEe;
const S8 = /* @__PURE__ */ Mt(zne);
var SEe = vt, xEe = _o, EEe = Zm;
SEe({ target: "Object", stat: !0, sham: !xEe }, {
  create: EEe
});
var IEe = Yr, kEe = IEe.Object, AEe = function(t, n) {
  return kEe.create(t, n);
}, PEe = AEe, Hne = PEe, NEe = Hne, TEe = NEe, OEe = TEe, REe = OEe, Wne = REe;
const Zne = /* @__PURE__ */ Mt(Wne);
var MEe = vt, DEe = mr, LEe = hl, Yne = R2, $Ee = ete, jEe = DEe(function() {
  Yne(1);
});
MEe({ target: "Object", stat: !0, forced: jEe, sham: !$Ee }, {
  getPrototypeOf: function(t) {
    return Yne(LEe(t));
  }
});
var FEe = Yr, BEe = FEe.Object.getPrototypeOf, VEe = BEe, UEe = VEe, GEe = UEe, zEe = GEe, HEe = zEe, WEe = HEe, Xne = WEe;
const VG = /* @__PURE__ */ Mt(Xne);
var ZEe = mr, l1 = function(e, t) {
  var n = [][e];
  return !!n && ZEe(function() {
    n.call(null, t || function() {
      return 1;
    }, 1);
  });
}, YEe = qp.forEach, XEe = l1, KEe = XEe("forEach"), qEe = KEe ? [].forEach : function(t) {
  return YEe(this, t, arguments.length > 1 ? arguments[1] : void 0);
}, JEe = vt, UG = qEe;
JEe({ target: "Array", proto: !0, forced: [].forEach !== UG }, {
  forEach: UG
});
var QEe = aa, eIe = Yr, Xa = function(e, t) {
  var n = eIe[e + "Prototype"], r = n && n[t];
  if (r) return r;
  var a = QEe[e], o = a && a.prototype;
  return o && o[t];
}, tIe = Xa, nIe = tIe("Array", "forEach"), rIe = nIe, aIe = rIe, oIe = Ym, iIe = Qo, sIe = Sa, lIe = aIe, RA = Array.prototype, uIe = {
  DOMTokenList: !0,
  NodeList: !0
}, Kne = function(e) {
  var t = e.forEach;
  return e === RA || sIe(RA, e) && t === RA.forEach || iIe(uIe, oIe(e)) ? lIe : t;
}, cIe = Kne, dIe = cIe, fIe = dIe, pIe = fIe, hIe = pIe, mIe = _o, vIe = qm, gIe = TypeError, yIe = Object.getOwnPropertyDescriptor, bIe = mIe && !function() {
  if (this !== void 0) return !0;
  try {
    Object.defineProperty([], "length", { writable: !1 }).length = 1;
  } catch (e) {
    return e instanceof TypeError;
  }
}(), _Ie = bIe ? function(e, t) {
  if (vIe(e) && !yIe(e, "length").writable)
    throw new gIe("Cannot set read only .length");
  return e.length = t;
} : function(e, t) {
  return e.length = t;
}, CIe = vt, wIe = hl, SIe = Gu, xIe = _Ie, EIe = uM, IIe = mr, kIe = IIe(function() {
  return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
}), AIe = function() {
  try {
    Object.defineProperty([], "length", { writable: !1 }).push();
  } catch (e) {
    return e instanceof TypeError;
  }
}, PIe = kIe || !AIe();
CIe({ target: "Array", proto: !0, arity: 1, forced: PIe }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function(t) {
    var n = wIe(this), r = SIe(n), a = arguments.length;
    EIe(r + a);
    for (var o = 0; o < a; o++)
      n[r] = arguments[o], r++;
    return xIe(n, r), r;
  }
});
var NIe = Xa, TIe = NIe("Array", "push"), OIe = Sa, RIe = TIe, MA = Array.prototype, MIe = function(e) {
  var t = e.push;
  return e === MA || OIe(MA, e) && t === MA.push ? RIe : t;
}, DIe = MIe, LIe = DIe, $Ie = LIe, jIe = $Ie, FIe = jIe, BIe = FIe, qne = BIe;
const Jne = /* @__PURE__ */ Mt(qne);
var VIe = vt, UIe = tte;
VIe({ target: "Object", stat: !0 }, {
  setPrototypeOf: UIe
});
var GIe = Yr, zIe = GIe.Object.setPrototypeOf, HIe = zIe, WIe = HIe, ZIe = WIe, YIe = ZIe, XIe = YIe, KIe = XIe, Qne = KIe;
const BT = /* @__PURE__ */ Mt(Qne);
var qIe = vt, JIe = Rr, QIe = qm, eke = JIe([].reverse), GG = [1, 2];
qIe({ target: "Array", proto: !0, forced: String(GG) === String(GG.reverse()) }, {
  reverse: function() {
    return QIe(this) && (this.length = this.length), eke(this);
  }
});
var tke = Xa, nke = tke("Array", "reverse"), rke = Sa, ake = nke, DA = Array.prototype, oke = function(e) {
  var t = e.reverse;
  return e === DA || rke(DA, e) && t === DA.reverse ? ake : t;
}, ike = oke, ere = ike, ske = ere, lke = ske, uke = lke, cke = uke, dke = cke, fke = vt, zG = qm, pke = f8, hke = Lo, HG = s8, mke = Gu, vke = Tc, gke = m8, yke = Ya, bke = v8, _ke = Kp, Cke = bke("slice"), wke = yke("species"), LA = Array, Ske = Math.max;
fke({ target: "Array", proto: !0, forced: !Cke }, {
  slice: function(t, n) {
    var r = vke(this), a = mke(r), o = HG(t, a), s = HG(n === void 0 ? a : n, a), c, u, f;
    if (zG(r) && (c = r.constructor, pke(c) && (c === LA || zG(c.prototype)) ? c = void 0 : hke(c) && (c = c[wke], c === null && (c = void 0)), c === LA || c === void 0))
      return _ke(r, o, s);
    for (u = new (c === void 0 ? LA : c)(Ske(s - o, 0)), f = 0; o < s; o++, f++) o in r && gke(u, f, r[o]);
    return u.length = f, u;
  }
});
var xke = Xa, Eke = xke("Array", "slice"), Ike = Sa, kke = Eke, $A = Array.prototype, Ake = function(e) {
  var t = e.slice;
  return e === $A || Ike($A, e) && t === $A.slice ? kke : t;
}, Pke = Ake, tre = Pke, Nke = tre, Tke = Nke, Oke = Tke, Rke = Oke, nre = Rke;
const Mke = /* @__PURE__ */ Mt(nre);
(function(e) {
  var t = fEe.default, n = zne, r = vM, a = Wne, o = Xne, s = hIe, c = qne, u = Qne, f = ane, m = dke, v = nre;
  function y() {
    e.exports = y = function() {
      return S;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
    var b, S = {}, x = Object.prototype, E = x.hasOwnProperty, N = n || function(Ne, Ee, le) {
      Ne[Ee] = le.value;
    }, R = typeof r == "function" ? r : {}, O = R.iterator || "@@iterator", D = R.asyncIterator || "@@asyncIterator", $ = R.toStringTag || "@@toStringTag";
    function B(Ne, Ee, le) {
      return n(Ne, Ee, {
        value: le,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), Ne[Ee];
    }
    try {
      B({}, "");
    } catch (Ne) {
      B = function(le, be, He) {
        return le[be] = He;
      };
    }
    function G(Ne, Ee, le, be) {
      var He = Ee && Ee.prototype instanceof ge ? Ee : ge, Ae = a(He.prototype), it = new $e(be || []);
      return N(Ae, "_invoke", {
        value: se(Ne, le, it)
      }), Ae;
    }
    function Z(Ne, Ee, le) {
      try {
        return {
          type: "normal",
          arg: Ne.call(Ee, le)
        };
      } catch (be) {
        return {
          type: "throw",
          arg: be
        };
      }
    }
    S.wrap = G;
    var K = "suspendedStart", q = "suspendedYield", pe = "executing", he = "completed", _e = {};
    function ge() {
    }
    function Y() {
    }
    function ee() {
    }
    var oe = {};
    B(oe, O, function() {
      return this;
    });
    var me = o, xe = me && me(me(we([])));
    xe && xe !== x && E.call(xe, O) && (oe = xe);
    var X = ee.prototype = ge.prototype = a(oe);
    function ye(Ne) {
      var Ee;
      s(Ee = ["next", "throw", "return"]).call(Ee, function(le) {
        B(Ne, le, function(be) {
          return this._invoke(le, be);
        });
      });
    }
    function ce(Ne, Ee) {
      function le(He, Ae, it, ut) {
        var St = Z(Ne[He], Ne, Ae);
        if (St.type !== "throw") {
          var sn = St.arg, zn = sn.value;
          return zn && t(zn) == "object" && E.call(zn, "__await") ? Ee.resolve(zn.__await).then(function(dn) {
            le("next", dn, it, ut);
          }, function(dn) {
            le("throw", dn, it, ut);
          }) : Ee.resolve(zn).then(function(dn) {
            sn.value = dn, it(sn);
          }, function(dn) {
            return le("throw", dn, it, ut);
          });
        }
        ut(St.arg);
      }
      var be;
      N(this, "_invoke", {
        value: function(Ae, it) {
          function ut() {
            return new Ee(function(St, sn) {
              le(Ae, it, St, sn);
            });
          }
          return be = be ? be.then(ut, ut) : ut();
        }
      });
    }
    function se(Ne, Ee, le) {
      var be = K;
      return function(He, Ae) {
        if (be === pe) throw Error("Generator is already running");
        if (be === he) {
          if (He === "throw") throw Ae;
          return {
            value: b,
            done: !0
          };
        }
        for (le.method = He, le.arg = Ae; ; ) {
          var it = le.delegate;
          if (it) {
            var ut = Ie(it, le);
            if (ut) {
              if (ut === _e) continue;
              return ut;
            }
          }
          if (le.method === "next") le.sent = le._sent = le.arg;
          else if (le.method === "throw") {
            if (be === K) throw be = he, le.arg;
            le.dispatchException(le.arg);
          } else le.method === "return" && le.abrupt("return", le.arg);
          be = pe;
          var St = Z(Ne, Ee, le);
          if (St.type === "normal") {
            if (be = le.done ? he : q, St.arg === _e) continue;
            return {
              value: St.arg,
              done: le.done
            };
          }
          St.type === "throw" && (be = he, le.method = "throw", le.arg = St.arg);
        }
      };
    }
    function Ie(Ne, Ee) {
      var le = Ee.method, be = Ne.iterator[le];
      if (be === b) return Ee.delegate = null, le === "throw" && Ne.iterator.return && (Ee.method = "return", Ee.arg = b, Ie(Ne, Ee), Ee.method === "throw") || le !== "return" && (Ee.method = "throw", Ee.arg = new TypeError("The iterator does not provide a '" + le + "' method")), _e;
      var He = Z(be, Ne.iterator, Ee.arg);
      if (He.type === "throw") return Ee.method = "throw", Ee.arg = He.arg, Ee.delegate = null, _e;
      var Ae = He.arg;
      return Ae ? Ae.done ? (Ee[Ne.resultName] = Ae.value, Ee.next = Ne.nextLoc, Ee.method !== "return" && (Ee.method = "next", Ee.arg = b), Ee.delegate = null, _e) : Ae : (Ee.method = "throw", Ee.arg = new TypeError("iterator result is not an object"), Ee.delegate = null, _e);
    }
    function Le(Ne) {
      var Ee, le = {
        tryLoc: Ne[0]
      };
      1 in Ne && (le.catchLoc = Ne[1]), 2 in Ne && (le.finallyLoc = Ne[2], le.afterLoc = Ne[3]), c(Ee = this.tryEntries).call(Ee, le);
    }
    function ie(Ne) {
      var Ee = Ne.completion || {};
      Ee.type = "normal", delete Ee.arg, Ne.completion = Ee;
    }
    function $e(Ne) {
      this.tryEntries = [{
        tryLoc: "root"
      }], s(Ne).call(Ne, Le, this), this.reset(!0);
    }
    function we(Ne) {
      if (Ne || Ne === "") {
        var Ee = Ne[O];
        if (Ee) return Ee.call(Ne);
        if (typeof Ne.next == "function") return Ne;
        if (!isNaN(Ne.length)) {
          var le = -1, be = function He() {
            for (; ++le < Ne.length; ) if (E.call(Ne, le)) return He.value = Ne[le], He.done = !1, He;
            return He.value = b, He.done = !0, He;
          };
          return be.next = be;
        }
      }
      throw new TypeError(t(Ne) + " is not iterable");
    }
    return Y.prototype = ee, N(X, "constructor", {
      value: ee,
      configurable: !0
    }), N(ee, "constructor", {
      value: Y,
      configurable: !0
    }), Y.displayName = B(ee, $, "GeneratorFunction"), S.isGeneratorFunction = function(Ne) {
      var Ee = typeof Ne == "function" && Ne.constructor;
      return !!Ee && (Ee === Y || (Ee.displayName || Ee.name) === "GeneratorFunction");
    }, S.mark = function(Ne) {
      return u ? u(Ne, ee) : (Ne.__proto__ = ee, B(Ne, $, "GeneratorFunction")), Ne.prototype = a(X), Ne;
    }, S.awrap = function(Ne) {
      return {
        __await: Ne
      };
    }, ye(ce.prototype), B(ce.prototype, D, function() {
      return this;
    }), S.AsyncIterator = ce, S.async = function(Ne, Ee, le, be, He) {
      He === void 0 && (He = f);
      var Ae = new ce(G(Ne, Ee, le, be), He);
      return S.isGeneratorFunction(Ee) ? Ae : Ae.next().then(function(it) {
        return it.done ? it.value : Ae.next();
      });
    }, ye(X), B(X, $, "Generator"), B(X, O, function() {
      return this;
    }), B(X, "toString", function() {
      return "[object Generator]";
    }), S.keys = function(Ne) {
      var Ee = Object(Ne), le = [];
      for (var be in Ee) c(le).call(le, be);
      return m(le).call(le), function He() {
        for (; le.length; ) {
          var Ae = le.pop();
          if (Ae in Ee) return He.value = Ae, He.done = !1, He;
        }
        return He.done = !0, He;
      };
    }, S.values = we, $e.prototype = {
      constructor: $e,
      reset: function(Ee) {
        var le;
        if (this.prev = 0, this.next = 0, this.sent = this._sent = b, this.done = !1, this.delegate = null, this.method = "next", this.arg = b, s(le = this.tryEntries).call(le, ie), !Ee) for (var be in this) be.charAt(0) === "t" && E.call(this, be) && !isNaN(+v(be).call(be, 1)) && (this[be] = b);
      },
      stop: function() {
        this.done = !0;
        var Ee = this.tryEntries[0].completion;
        if (Ee.type === "throw") throw Ee.arg;
        return this.rval;
      },
      dispatchException: function(Ee) {
        if (this.done) throw Ee;
        var le = this;
        function be(sn, zn) {
          return it.type = "throw", it.arg = Ee, le.next = sn, zn && (le.method = "next", le.arg = b), !!zn;
        }
        for (var He = this.tryEntries.length - 1; He >= 0; --He) {
          var Ae = this.tryEntries[He], it = Ae.completion;
          if (Ae.tryLoc === "root") return be("end");
          if (Ae.tryLoc <= this.prev) {
            var ut = E.call(Ae, "catchLoc"), St = E.call(Ae, "finallyLoc");
            if (ut && St) {
              if (this.prev < Ae.catchLoc) return be(Ae.catchLoc, !0);
              if (this.prev < Ae.finallyLoc) return be(Ae.finallyLoc);
            } else if (ut) {
              if (this.prev < Ae.catchLoc) return be(Ae.catchLoc, !0);
            } else {
              if (!St) throw Error("try statement without catch or finally");
              if (this.prev < Ae.finallyLoc) return be(Ae.finallyLoc);
            }
          }
        }
      },
      abrupt: function(Ee, le) {
        for (var be = this.tryEntries.length - 1; be >= 0; --be) {
          var He = this.tryEntries[be];
          if (He.tryLoc <= this.prev && E.call(He, "finallyLoc") && this.prev < He.finallyLoc) {
            var Ae = He;
            break;
          }
        }
        Ae && (Ee === "break" || Ee === "continue") && Ae.tryLoc <= le && le <= Ae.finallyLoc && (Ae = null);
        var it = Ae ? Ae.completion : {};
        return it.type = Ee, it.arg = le, Ae ? (this.method = "next", this.next = Ae.finallyLoc, _e) : this.complete(it);
      },
      complete: function(Ee, le) {
        if (Ee.type === "throw") throw Ee.arg;
        return Ee.type === "break" || Ee.type === "continue" ? this.next = Ee.arg : Ee.type === "return" ? (this.rval = this.arg = Ee.arg, this.method = "return", this.next = "end") : Ee.type === "normal" && le && (this.next = le), _e;
      },
      finish: function(Ee) {
        for (var le = this.tryEntries.length - 1; le >= 0; --le) {
          var be = this.tryEntries[le];
          if (be.finallyLoc === Ee) return this.complete(be.completion, be.afterLoc), ie(be), _e;
        }
      },
      catch: function(Ee) {
        for (var le = this.tryEntries.length - 1; le >= 0; --le) {
          var be = this.tryEntries[le];
          if (be.tryLoc === Ee) {
            var He = be.completion;
            if (He.type === "throw") {
              var Ae = He.arg;
              ie(be);
            }
            return Ae;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function(Ee, le, be) {
        return this.delegate = {
          iterator: we(Ee),
          resultName: le,
          nextLoc: be
        }, this.method === "next" && (this.arg = b), _e;
      }
    }, S;
  }
  e.exports = y, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ine);
var Dke = ine.exports, Yx = Dke(), Lke = Yx;
try {
  regeneratorRuntime = Yx;
} catch (e) {
  typeof globalThis == "object" ? globalThis.regeneratorRuntime = Yx : Function("r", "regeneratorRuntime = r")(Yx);
}
const yt = /* @__PURE__ */ Mt(Lke);
var $ke = vt, jke = hl, rre = j_, Fke = mr, Bke = Fke(function() {
  rre(1);
});
$ke({ target: "Object", stat: !0, forced: Bke }, {
  keys: function(t) {
    return rre(jke(t));
  }
});
var Vke = Yr, Uke = Vke.Object.keys, Gke = Uke, zke = Gke, Hke = zke;
const Pe = /* @__PURE__ */ Mt(Hke);
var Wke = Yr, Zke = Wke.Object.getOwnPropertySymbols, Yke = Zke, are = Yke, Xke = are;
const te = /* @__PURE__ */ Mt(Xke);
var ore = { exports: {} }, Kke = vt, qke = mr, Jke = Tc, ire = Gm.f, sre = _o, Qke = !sre || qke(function() {
  ire(1);
});
Kke({ target: "Object", stat: !0, forced: Qke, sham: !sre }, {
  getOwnPropertyDescriptor: function(t, n) {
    return ire(Jke(t), n);
  }
});
var eAe = Yr, lre = eAe.Object, tAe = ore.exports = function(t, n) {
  return lre.getOwnPropertyDescriptor(t, n);
};
lre.getOwnPropertyDescriptor.sham && (tAe.sham = !0);
var nAe = ore.exports, rAe = nAe, ure = rAe, aAe = ure;
const re = /* @__PURE__ */ Mt(aAe);
var oAe = vt, iAe = _o, sAe = rte, lAe = Tc, uAe = Gm, cAe = m8;
oAe({ target: "Object", stat: !0, sham: !iAe }, {
  getOwnPropertyDescriptors: function(t) {
    for (var n = lAe(t), r = uAe.f, a = sAe(n), o = {}, s = 0, c, u; a.length > s; )
      u = r(n, c = a[s++]), u !== void 0 && cAe(o, c, u);
    return o;
  }
});
var dAe = Yr, fAe = dAe.Object.getOwnPropertyDescriptors, pAe = fAe, hAe = pAe, mAe = hAe;
const ne = /* @__PURE__ */ Mt(mAe);
var cre = { exports: {} }, vAe = vt, gAe = _o, WG = l8.f;
vAe({ target: "Object", stat: !0, forced: Object.defineProperties !== WG, sham: !gAe }, {
  defineProperties: WG
});
var yAe = Yr, dre = yAe.Object, bAe = cre.exports = function(t, n) {
  return dre.defineProperties(t, n);
};
dre.defineProperties.sham && (bAe.sham = !0);
var _Ae = cre.exports, CAe = _Ae, wAe = CAe, SAe = wAe;
const Ze = /* @__PURE__ */ Mt(SAe);
var xAe = Gne;
const We = /* @__PURE__ */ Mt(xAe);
function mi(e) {
  "@babel/helpers - typeof";
  return mi = typeof Dy == "function" && typeof dEe == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Dy == "function" && t.constructor === Dy && t !== Dy.prototype ? "symbol" : typeof t;
  }, mi(e);
}
var EAe = are, IAe = EAe, kAe = IAe, AAe = kAe, PAe = AAe;
const ZG = /* @__PURE__ */ Mt(PAe);
var NAe = vt, TAe = XR.includes, OAe = mr, RAe = OAe(function() {
  return !Array(1).includes();
});
NAe({ target: "Array", proto: !0, forced: RAe }, {
  includes: function(t) {
    return TAe(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var MAe = Xa, DAe = MAe("Array", "includes"), LAe = Lo, $Ae = Tf, jAe = Ya, FAe = jAe("match"), BAe = function(e) {
  var t;
  return LAe(e) && ((t = e[FAe]) !== void 0 ? !!t : $Ae(e) === "RegExp");
}, VAe = BAe, UAe = TypeError, fre = function(e) {
  if (VAe(e))
    throw new UAe("The method doesn't accept regular expressions");
  return e;
}, GAe = Ya, zAe = GAe("match"), pre = function(e) {
  var t = /./;
  try {
    "/./"[e](t);
  } catch (n) {
    try {
      return t[zAe] = !1, "/./"[e](t);
    } catch (r) {
    }
  }
  return !1;
}, HAe = vt, WAe = Rr, ZAe = fre, YAe = Of, YG = Us, XAe = pre, KAe = WAe("".indexOf);
HAe({ target: "String", proto: !0, forced: !XAe("includes") }, {
  includes: function(t) {
    return !!~KAe(
      YG(YAe(this)),
      YG(ZAe(t)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var qAe = Xa, JAe = qAe("String", "includes"), XG = Sa, QAe = DAe, ePe = JAe, jA = Array.prototype, FA = String.prototype, tPe = function(e) {
  var t = e.includes;
  return e === jA || XG(jA, e) && t === jA.includes ? QAe : typeof e == "string" || e === FA || XG(FA, e) && t === FA.includes ? ePe : t;
}, nPe = tPe, hre = nPe, rPe = hre, aPe = rPe, oPe = aPe, iPe = oPe, sPe = iPe;
const mre = /* @__PURE__ */ Mt(sPe);
function lPe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (mre(t).call(t, r)) continue;
    n[r] = e[r];
  }
  return n;
}
function pa(e, t) {
  if (e == null) return {};
  var n, r, a = lPe(e, t);
  if (ZG) {
    var o = ZG(e);
    for (r = 0; r < o.length; r++) n = o[r], mre(t).call(t, n) || {}.propertyIsEnumerable.call(e, n) && (a[n] = e[n]);
  }
  return a;
}
function Qe(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
var uPe = z_, cPe = uPe.f("toPrimitive"), dPe = cPe, fPe = dPe, pPe = fPe, hPe = pPe, mPe = hPe, vPe = mPe, gPe = vPe;
const yPe = /* @__PURE__ */ Mt(gPe);
function bPe(e, t) {
  if (mi(e) != "object" || !e) return e;
  var n = e[yPe];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (mi(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vre(e) {
  var t = bPe(e, "string");
  return mi(t) == "symbol" ? t : t + "";
}
function _Pe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), S8(e, vre(r.key), r);
  }
}
function et(e, t, n) {
  return t && _Pe(e.prototype, t), S8(e, "prototype", {
    writable: !1
  }), e;
}
function T(e, t, n) {
  return (t = vre(t)) in e ? S8(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var CPe = Kne;
const Q = /* @__PURE__ */ Mt(CPe);
var wPe = vt, SPe = qp.filter, xPe = v8, EPe = xPe("filter");
wPe({ target: "Array", proto: !0, forced: !EPe }, {
  filter: function(t) {
    return SPe(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var IPe = Xa, kPe = IPe("Array", "filter"), APe = Sa, PPe = kPe, BA = Array.prototype, NPe = function(e) {
  var t = e.filter;
  return e === BA || APe(BA, e) && t === BA.filter ? PPe : t;
}, TPe = NPe, OPe = TPe, RPe = OPe;
const Oe = /* @__PURE__ */ Mt(RPe);
var gre = Rr, MPe = Ti, DPe = Lo, LPe = Qo, KG = Kp, $Pe = T_, yre = Function, jPe = gre([].concat), FPe = gre([].join), VA = {}, BPe = function(e, t, n) {
  if (!LPe(VA, t)) {
    for (var r = [], a = 0; a < t; a++) r[a] = "a[" + a + "]";
    VA[t] = yre("C,a", "return new C(" + FPe(r, ",") + ")");
  }
  return VA[t](e, n);
}, bre = $Pe ? yre.bind : function(t) {
  var n = MPe(this), r = n.prototype, a = KG(arguments, 1), o = function() {
    var c = jPe(a, KG(arguments));
    return this instanceof o ? BPe(n, c.length, c) : n.apply(t, c);
  };
  return DPe(r) && (o.prototype = r), o;
}, VPe = vt, qG = bre;
VPe({ target: "Function", proto: !0, forced: Function.bind !== qG }, {
  bind: qG
});
var UPe = Xa, GPe = UPe("Function", "bind"), zPe = Sa, HPe = GPe, UA = Function.prototype, WPe = function(e) {
  var t = e.bind;
  return e === UA || zPe(UA, e) && t === UA.bind ? HPe : t;
}, ZPe = WPe, _re = ZPe, YPe = _re;
const pn = /* @__PURE__ */ Mt(YPe);
var XPe = hre;
const jt = /* @__PURE__ */ Mt(XPe);
var KPe = Xa, qPe = KPe("Array", "concat"), JPe = Sa, QPe = qPe, GA = Array.prototype, eNe = function(e) {
  var t = e.concat;
  return e === GA || JPe(GA, e) && t === GA.concat ? QPe : t;
}, tNe = eNe, nNe = tNe, rNe = nNe;
const je = /* @__PURE__ */ Mt(rNe);
var aNe = nne;
const Yt = /* @__PURE__ */ Mt(aNe);
var oNe = vt, iNe = qp.find, JG = "find", Cre = !0;
JG in [] && Array(1)[JG](function() {
  Cre = !1;
});
oNe({ target: "Array", proto: !0, forced: Cre }, {
  find: function(t) {
    return iNe(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var sNe = Xa, lNe = sNe("Array", "find"), uNe = Sa, cNe = lNe, zA = Array.prototype, dNe = function(e) {
  var t = e.find;
  return e === zA || uNe(zA, e) && t === zA.find ? cNe : t;
}, fNe = dNe, pNe = fNe, hNe = pNe;
const Ji = /* @__PURE__ */ Mt(hNe);
var mNe = s1, vNe = Us, gNe = Of, yNe = RangeError, wre = function(t) {
  var n = vNe(gNe(this)), r = "", a = mNe(t);
  if (a < 0 || a === 1 / 0) throw new yNe("Wrong number of repetitions");
  for (; a > 0; (a >>>= 1) && (n += n)) a & 1 && (r += n);
  return r;
}, Sre = Rr, bNe = YR, QG = Us, _Ne = wre, CNe = Of, wNe = Sre(_Ne), SNe = Sre("".slice), xNe = Math.ceil, ez = function(e) {
  return function(t, n, r) {
    var a = QG(CNe(t)), o = bNe(n), s = a.length, c = r === void 0 ? " " : QG(r), u, f;
    return o <= s || c === "" ? a : (u = o - s, f = wNe(c, xNe(u / c.length)), f.length > u && (f = SNe(f, 0, u)), e ? a + f : f + a);
  };
}, ENe = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: ez(!1),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: ez(!0)
}, Jm = Rr, tz = mr, d0 = ENe.start, INe = RangeError, kNe = isFinite, ANe = Math.abs, Jp = Date.prototype, HA = Jp.toISOString, PNe = Jm(Jp.getTime), NNe = Jm(Jp.getUTCDate), TNe = Jm(Jp.getUTCFullYear), ONe = Jm(Jp.getUTCHours), RNe = Jm(Jp.getUTCMilliseconds), MNe = Jm(Jp.getUTCMinutes), DNe = Jm(Jp.getUTCMonth), LNe = Jm(Jp.getUTCSeconds), $Ne = tz(function() {
  return HA.call(new Date(-5e13 - 1)) !== "0385-07-25T07:06:39.999Z";
}) || !tz(function() {
  HA.call(/* @__PURE__ */ new Date(NaN));
}) ? function() {
  if (!kNe(PNe(this))) throw new INe("Invalid time value");
  var t = this, n = TNe(t), r = RNe(t), a = n < 0 ? "-" : n > 9999 ? "+" : "";
  return a + d0(ANe(n), a ? 6 : 4, 0) + "-" + d0(DNe(t) + 1, 2, 0) + "-" + d0(NNe(t), 2, 0) + "T" + d0(ONe(t), 2, 0) + ":" + d0(MNe(t), 2, 0) + ":" + d0(LNe(t), 2, 0) + "." + d0(r, 3, 0) + "Z";
} : HA, jNe = vt, xre = Co, FNe = hl, BNe = Kee, VNe = $Ne, UNe = Tf, GNe = mr, zNe = GNe(function() {
  return (/* @__PURE__ */ new Date(NaN)).toJSON() !== null || xre(Date.prototype.toJSON, { toISOString: function() {
    return 1;
  } }) !== 1;
});
jNe({ target: "Date", proto: !0, forced: zNe }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  toJSON: function(t) {
    var n = FNe(this), r = BNe(n, "number");
    return typeof r == "number" && !isFinite(r) ? null : !("toISOString" in n) && UNe(n) === "Date" ? xre(VNe, n) : n.toISOString();
  }
});
var VT = Yr, HNe = Um;
VT.JSON || (VT.JSON = { stringify: JSON.stringify });
var WNe = function(t, n, r) {
  return HNe(VT.JSON.stringify, null, arguments);
}, ZNe = WNe, YNe = ZNe, XNe = YNe;
const Pc = /* @__PURE__ */ Mt(XNe);
var KNe = mr, Ere = !KNe(function() {
  return Object.isExtensible(Object.preventExtensions({}));
}), Ire = { exports: {} }, qNe = mr, JNe = qNe(function() {
  if (typeof ArrayBuffer == "function") {
    var e = new ArrayBuffer(8);
    Object.isExtensible(e) && Object.defineProperty(e, "a", { value: 8 });
  }
}), QNe = mr, eTe = Lo, tTe = Tf, nz = JNe, Xx = Object.isExtensible, nTe = QNe(function() {
  Xx(1);
}), rTe = nTe || nz ? function(t) {
  return !eTe(t) || nz && tTe(t) === "ArrayBuffer" ? !1 : Xx ? Xx(t) : !0;
} : Xx, aTe = vt, oTe = Rr, iTe = L_, sTe = Lo, gM = Qo, lTe = mu.f, rz = D_, uTe = g8, yM = rTe, cTe = o8, dTe = Ere, kre = !1, Gp = cTe("meta"), fTe = 0, bM = function(e) {
  lTe(e, Gp, { value: {
    objectID: "O" + fTe++,
    // object ID
    weakData: {}
    // weak collections IDs
  } });
}, pTe = function(e, t) {
  if (!sTe(e)) return typeof e == "symbol" ? e : (typeof e == "string" ? "S" : "P") + e;
  if (!gM(e, Gp)) {
    if (!yM(e)) return "F";
    if (!t) return "E";
    bM(e);
  }
  return e[Gp].objectID;
}, hTe = function(e, t) {
  if (!gM(e, Gp)) {
    if (!yM(e)) return !0;
    if (!t) return !1;
    bM(e);
  }
  return e[Gp].weakData;
}, mTe = function(e) {
  return dTe && kre && yM(e) && !gM(e, Gp) && bM(e), e;
}, vTe = function() {
  gTe.enable = function() {
  }, kre = !0;
  var e = rz.f, t = oTe([].splice), n = {};
  n[Gp] = 1, e(n).length && (rz.f = function(r) {
    for (var a = e(r), o = 0, s = a.length; o < s; o++)
      if (a[o] === Gp) {
        t(a, o, 1);
        break;
      }
    return a;
  }, aTe({ target: "Object", stat: !0, forced: !0 }, {
    getOwnPropertyNames: uTe.f
  }));
}, gTe = Ire.exports = {
  enable: vTe,
  fastKey: pTe,
  getWeakData: hTe,
  onFreeze: mTe
};
iTe[Gp] = !0;
var _M = Ire.exports, yTe = vt, bTe = Ere, _Te = mr, CTe = Lo, wTe = _M.onFreeze, UT = Object.freeze, STe = _Te(function() {
  UT(1);
});
yTe({ target: "Object", stat: !0, forced: STe, sham: !bTe }, {
  freeze: function(t) {
    return UT && CTe(t) ? UT(wTe(t)) : t;
  }
});
var xTe = Yr, ETe = xTe.Object.freeze, ITe = ETe, kTe = ITe, ATe = kTe;
const PTe = /* @__PURE__ */ Mt(ATe);
var NTe = vt, TTe = qm;
NTe({ target: "Array", stat: !0 }, {
  isArray: TTe
});
var OTe = Yr, RTe = OTe.Array.isArray, MTe = RTe, Are = MTe, DTe = Are, LTe = DTe, $Te = LTe, jTe = $Te, FTe = jTe;
const Pre = /* @__PURE__ */ Mt(FTe);
function BTe(e) {
  if (Pre(e)) return e;
}
var VTe = F_, UTe = VTe, GTe = UTe, zTe = GTe, HTe = zTe, WTe = HTe, ZTe = WTe, YTe = ZTe, Nre = YTe;
const Tre = /* @__PURE__ */ Mt(Nre);
function XTe(e, t) {
  var n = e == null ? null : typeof Dy != "undefined" && Tre(e) || e["@@iterator"];
  if (n != null) {
    var r, a, o, s, c = [], u = !0, f = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        u = !1;
      } else for (; !(u = (r = o.call(n)).done) && (Jne(c).call(c, r.value), c.length !== t); u = !0) ;
    } catch (m) {
      f = !0, a = m;
    } finally {
      try {
        if (!u && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (f) throw a;
      }
    }
    return c;
  }
}
var KTe = vs, qTe = u8, JTe = function(e, t, n, r) {
  try {
    return r ? t(KTe(n)[0], n[1]) : t(n);
  } catch (a) {
    qTe(e, "throw", a);
  }
}, QTe = ms, eOe = Co, tOe = hl, nOe = JTe, rOe = ute, aOe = f8, oOe = Gu, az = m8, iOe = JR, sOe = F_, oz = Array, Ore = function(t) {
  var n = tOe(t), r = aOe(this), a = arguments.length, o = a > 1 ? arguments[1] : void 0, s = o !== void 0;
  s && (o = QTe(o, a > 2 ? arguments[2] : void 0));
  var c = sOe(n), u = 0, f, m, v, y, b, S;
  if (c && !(this === oz && rOe(c)))
    for (m = r ? new this() : [], y = iOe(n, c), b = y.next; !(v = eOe(b, y)).done; u++)
      S = s ? nOe(y, o, [v.value, u], !0) : v.value, az(m, u, S);
  else
    for (f = oOe(n), m = r ? new this(f) : oz(f); f > u; u++)
      S = s ? o(n[u], u) : n[u], az(m, u, S);
  return m.length = u, m;
}, lOe = vt, uOe = Ore, cOe = qte, dOe = !cOe(function(e) {
  Array.from(e);
});
lOe({ target: "Array", stat: !0, forced: dOe }, {
  from: uOe
});
var fOe = Yr, pOe = fOe.Array.from, hOe = pOe, Rre = hOe, mOe = Rre, vOe = mOe, gOe = vOe, yOe = gOe, bOe = yOe;
const Mre = /* @__PURE__ */ Mt(bOe);
function GT(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Dre(e, t) {
  if (e) {
    var n;
    if (typeof e == "string") return GT(e, t);
    var r = Mke(n = {}.toString.call(e)).call(n, 8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Mre(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? GT(e, t) : void 0;
  }
}
function _Oe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ze(e, t) {
  return BTe(e) || XTe(e, t) || Dre(e, t) || _Oe();
}
function COe(e) {
  if (Pre(e)) return GT(e);
}
function wOe(e) {
  if (typeof Dy != "undefined" && Tre(e) != null || e["@@iterator"] != null) return Mre(e);
}
function SOe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Pn(e) {
  return COe(e) || wOe(e) || Dre(e) || SOe();
}
var xOe = vt, EOe = r8, IOe = XR.indexOf, kOe = l1, zT = EOe([].indexOf), Lre = !!zT && 1 / zT([1], 1, -0) < 0, AOe = Lre || !kOe("indexOf");
xOe({ target: "Array", proto: !0, forced: AOe }, {
  indexOf: function(t) {
    var n = arguments.length > 1 ? arguments[1] : void 0;
    return Lre ? zT(this, t, n) || 0 : IOe(this, t, n);
  }
});
var POe = Xa, NOe = POe("Array", "indexOf"), TOe = Sa, OOe = NOe, WA = Array.prototype, ROe = function(e) {
  var t = e.indexOf;
  return e === WA || TOe(WA, e) && t === WA.indexOf ? OOe : t;
}, MOe = ROe, $re = MOe, DOe = $re;
const ka = /* @__PURE__ */ Mt(DOe);
var LOe = Ti, $Oe = hl, jOe = a8, FOe = Gu, iz = TypeError, sz = "Reduce of empty array with no initial value", lz = function(e) {
  return function(t, n, r, a) {
    var o = $Oe(t), s = jOe(o), c = FOe(o);
    if (LOe(n), c === 0 && r < 2) throw new iz(sz);
    var u = e ? c - 1 : 0, f = e ? -1 : 1;
    if (r < 2) for (; ; ) {
      if (u in s) {
        a = s[u], u += f;
        break;
      }
      if (u += f, e ? u < 0 : c <= u)
        throw new iz(sz);
    }
    for (; e ? u >= 0 : c > u; u += f) u in s && (a = n(a, s[u], u, o));
    return a;
  };
}, BOe = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: lz(!1),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: lz(!0)
}, VOe = vt, UOe = BOe.left, GOe = l1, uz = N2, zOe = d8, HOe = !zOe && uz > 79 && uz < 83, WOe = HOe || !GOe("reduce");
VOe({ target: "Array", proto: !0, forced: WOe }, {
  reduce: function(t) {
    var n = arguments.length;
    return UOe(this, t, n, n > 1 ? arguments[1] : void 0);
  }
});
var ZOe = Xa, YOe = ZOe("Array", "reduce"), XOe = Sa, KOe = YOe, ZA = Array.prototype, qOe = function(e) {
  var t = e.reduce;
  return e === ZA || XOe(ZA, e) && t === ZA.reduce ? KOe : t;
}, JOe = qOe, QOe = JOe, eRe = QOe;
const rr = /* @__PURE__ */ Mt(eRe);
var tRe = Xa, nRe = tRe("Array", "values"), rRe = nRe, aRe = rRe, oRe = Ym, iRe = Qo, sRe = Sa, lRe = aRe, YA = Array.prototype, uRe = {
  DOMTokenList: !0,
  NodeList: !0
}, cRe = function(e) {
  var t = e.values;
  return e === YA || sRe(YA, e) && t === YA.values || iRe(uRe, oRe(e)) ? lRe : t;
}, dRe = cRe;
const gd = /* @__PURE__ */ Mt(dRe);
var fRe = vt, pRe = qp.map, hRe = v8, mRe = hRe("map");
fRe({ target: "Array", proto: !0, forced: !mRe }, {
  map: function(t) {
    return pRe(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var vRe = Xa, gRe = vRe("Array", "map"), yRe = Sa, bRe = gRe, XA = Array.prototype, _Re = function(e) {
  var t = e.map;
  return e === XA || yRe(XA, e) && t === XA.map ? bRe : t;
}, CRe = _Re, wRe = CRe, SRe = wRe;
const It = /* @__PURE__ */ Mt(SRe);
var CM = `	
\v\f\r                　\u2028\u2029\uFEFF`, xRe = Rr, ERe = Of, IRe = Us, HT = CM, cz = xRe("".replace), kRe = RegExp("^[" + HT + "]+"), ARe = RegExp("(^|[^" + HT + "])[" + HT + "]+$"), KA = function(e) {
  return function(t) {
    var n = IRe(ERe(t));
    return e & 1 && (n = cz(n, kRe, "")), e & 2 && (n = cz(n, ARe, "$1")), n;
  };
}, wM = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: KA(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: KA(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: KA(3)
}, jre = aa, PRe = mr, NRe = Rr, TRe = Us, ORe = wM.trim, dz = CM, V4 = jre.parseInt, fz = jre.Symbol, pz = fz && fz.iterator, Fre = /^[+-]?0x/i, RRe = NRe(Fre.exec), MRe = V4(dz + "08") !== 8 || V4(dz + "0x16") !== 22 || pz && !PRe(function() {
  V4(Object(pz));
}), DRe = MRe ? function(t, n) {
  var r = ORe(TRe(t));
  return V4(r, n >>> 0 || (RRe(Fre, r) ? 16 : 10));
} : V4, LRe = vt, hz = DRe;
LRe({ global: !0, forced: parseInt !== hz }, {
  parseInt: hz
});
var $Re = Yr, jRe = $Re.parseInt, FRe = jRe, BRe = FRe, VRe = BRe;
const Ou = /* @__PURE__ */ Mt(VRe);
var URe = vt, GRe = Ni, qA = Um, zRe = bre, mz = Ate, HRe = vs, vz = Lo, WRe = Zm, Bre = mr, SM = GRe("Reflect", "construct"), ZRe = Object.prototype, YRe = [].push, Vre = Bre(function() {
  function e() {
  }
  return !(SM(function() {
  }, [], e) instanceof e);
}), Ure = !Bre(function() {
  SM(function() {
  });
}), gz = Vre || Ure;
URe({ target: "Reflect", stat: !0, forced: gz, sham: gz }, {
  construct: function(t, n) {
    mz(t), HRe(n);
    var r = arguments.length < 3 ? t : mz(arguments[2]);
    if (Ure && !Vre) return SM(t, n, r);
    if (t === r) {
      switch (n.length) {
        case 0:
          return new t();
        case 1:
          return new t(n[0]);
        case 2:
          return new t(n[0], n[1]);
        case 3:
          return new t(n[0], n[1], n[2]);
        case 4:
          return new t(n[0], n[1], n[2], n[3]);
      }
      var a = [null];
      return qA(YRe, a, n), new (qA(zRe, t, a))();
    }
    var o = r.prototype, s = WRe(vz(o) ? o : ZRe), c = qA(t, s, n);
    return vz(c) ? c : s;
  }
});
var XRe = Yr, KRe = XRe.Reflect.construct, qRe = KRe, Gre = qRe, JRe = Gre;
const U = /* @__PURE__ */ Mt(JRe);
var yz = _o, QRe = Rr, eMe = Co, tMe = mr, JA = j_, nMe = $_, rMe = O_, aMe = hl, oMe = a8, py = Object.assign, bz = Object.defineProperty, iMe = QRe([].concat), zre = !py || tMe(function() {
  if (yz && py({ b: 1 }, py(bz({}, "a", {
    enumerable: !0,
    get: function() {
      bz(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1) return !0;
  var e = {}, t = {}, n = Symbol("assign detection"), r = "abcdefghijklmnopqrst";
  return e[n] = 7, r.split("").forEach(function(a) {
    t[a] = a;
  }), py({}, e)[n] !== 7 || JA(py({}, t)).join("") !== r;
}) ? function(t, n) {
  for (var r = aMe(t), a = arguments.length, o = 1, s = nMe.f, c = rMe.f; a > o; )
    for (var u = oMe(arguments[o++]), f = s ? iMe(JA(u), s(u)) : JA(u), m = f.length, v = 0, y; m > v; )
      y = f[v++], (!yz || eMe(c, u, y)) && (r[y] = u[y]);
  return r;
} : py, sMe = vt, _z = zre;
sMe({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== _z }, {
  assign: _z
});
var lMe = Yr, uMe = lMe.Object.assign, cMe = uMe, Hre = cMe, dMe = Hre, fMe = dMe, pMe = fMe, hMe = pMe, mMe = hMe;
const Cz = /* @__PURE__ */ Mt(mMe);
var vMe = _re, gMe = vMe, yMe = gMe, bMe = yMe, _Me = bMe;
const Y_ = /* @__PURE__ */ Mt(_Me);
function kt() {
  var e;
  return kt = Cz ? Y_(e = Cz).call(e) : function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var a in r) ({}).hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, kt.apply(null, arguments);
}
function Se(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function c_(e, t) {
  var n;
  return c_ = BT ? Y_(n = BT).call(n) : function(r, a) {
    return r.__proto__ = a, r;
  }, c_(e, t);
}
function ft(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Zne(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), S8(e, "prototype", {
    writable: !1
  }), t && c_(e, t);
}
function ct(e, t) {
  if (t && (mi(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Se(e);
}
function fe(e) {
  var t;
  return fe = BT ? Y_(t = VG).call(t) : function(n) {
    return n.__proto__ || VG(n);
  }, fe(e);
}
var X_, fr, Wre, P0, wz, Zre, WT, Yre, Y7 = {}, Xre = [], CMe = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function Rp(e, t) {
  for (var n in t) e[n] = t[n];
  return e;
}
function Kre(e) {
  var t = e.parentNode;
  t && t.removeChild(e);
}
function P(e, t, n) {
  var r, a, o, s = {};
  for (o in t) o == "key" ? r = t[o] : o == "ref" ? a = t[o] : s[o] = t[o];
  if (arguments.length > 2 && (s.children = arguments.length > 3 ? X_.call(arguments, 2) : n), typeof e == "function" && e.defaultProps != null) for (o in e.defaultProps) s[o] === void 0 && (s[o] = e.defaultProps[o]);
  return U4(e, s, r, a, null);
}
function U4(e, t, n, r, a) {
  var o = { type: e, props: t, key: n, ref: r, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: a == null ? ++Wre : a };
  return a == null && fr.vnode != null && fr.vnode(o), o;
}
function ra(e) {
  return e.children;
}
function yo(e, t) {
  this.props = e, this.context = t;
}
function d_(e, t) {
  if (t == null) return e.__ ? d_(e.__, e.__.__k.indexOf(e) + 1) : null;
  for (var n; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) return n.__e;
  return typeof e.type == "function" ? d_(e) : null;
}
function qre(e) {
  var t, n;
  if ((e = e.__) != null && e.__c != null) {
    for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) {
      e.__e = e.__c.base = n.__e;
      break;
    }
    return qre(e);
  }
}
function ZT(e) {
  (!e.__d && (e.__d = !0) && P0.push(e) && !X7.__r++ || wz !== fr.debounceRendering) && ((wz = fr.debounceRendering) || Zre)(X7);
}
function X7() {
  var e, t, n, r, a, o, s, c;
  for (P0.sort(WT); e = P0.shift(); ) e.__d && (t = P0.length, r = void 0, a = void 0, s = (o = (n = e).__v).__e, (c = n.__P) && (r = [], (a = Rp({}, o)).__v = o.__v + 1, EM(c, o, a, n.__n, c.ownerSVGElement !== void 0, o.__h != null ? [s] : null, r, s == null ? d_(o) : s, o.__h), nae(r, o), o.__e != s && qre(o)), P0.length > t && P0.sort(WT));
  X7.__r = 0;
}
function Jre(e, t, n, r, a, o, s, c, u, f) {
  var m, v, y, b, S, x, E, N = r && r.__k || Xre, R = N.length;
  for (n.__k = [], m = 0; m < t.length; m++) if ((b = n.__k[m] = (b = t[m]) == null || typeof b == "boolean" || typeof b == "function" ? null : typeof b == "string" || typeof b == "number" || typeof b == "bigint" ? U4(null, b, null, null, b) : Array.isArray(b) ? U4(ra, { children: b }, null, null, null) : b.__b > 0 ? U4(b.type, b.props, b.key, b.ref ? b.ref : null, b.__v) : b) != null) {
    if (b.__ = n, b.__b = n.__b + 1, (y = N[m]) === null || y && b.key == y.key && b.type === y.type) N[m] = void 0;
    else for (v = 0; v < R; v++) {
      if ((y = N[v]) && b.key == y.key && b.type === y.type) {
        N[v] = void 0;
        break;
      }
      y = null;
    }
    EM(e, b, y = y || Y7, a, o, s, c, u, f), S = b.__e, (v = b.ref) && y.ref != v && (E || (E = []), y.ref && E.push(y.ref, null, b), E.push(v, b.__c || S, b)), S != null ? (x == null && (x = S), typeof b.type == "function" && b.__k === y.__k ? b.__d = u = Qre(b, u, e) : u = eae(e, b, y, N, S, u), typeof n.type == "function" && (n.__d = u)) : u && y.__e == u && u.parentNode != e && (u = d_(y));
  }
  for (n.__e = x, m = R; m--; ) N[m] != null && (typeof n.type == "function" && N[m].__e != null && N[m].__e == n.__d && (n.__d = tae(r).nextSibling), aae(N[m], N[m]));
  if (E) for (m = 0; m < E.length; m++) rae(E[m], E[++m], E[++m]);
}
function Qre(e, t, n) {
  for (var r, a = e.__k, o = 0; a && o < a.length; o++) (r = a[o]) && (r.__ = e, t = typeof r.type == "function" ? Qre(r, t, n) : eae(n, r, r, a, r.__e, t));
  return t;
}
function xM(e, t) {
  return t = t || [], e == null || typeof e == "boolean" || (Array.isArray(e) ? e.some(function(n) {
    xM(n, t);
  }) : t.push(e)), t;
}
function eae(e, t, n, r, a, o) {
  var s, c, u;
  if (t.__d !== void 0) s = t.__d, t.__d = void 0;
  else if (n == null || a != o || a.parentNode == null) e: if (o == null || o.parentNode !== e) e.appendChild(a), s = null;
  else {
    for (c = o, u = 0; (c = c.nextSibling) && u < r.length; u += 1) if (c == a) break e;
    e.insertBefore(a, o), s = o;
  }
  return s !== void 0 ? s : a.nextSibling;
}
function tae(e) {
  var t, n, r;
  if (e.type == null || typeof e.type == "string") return e.__e;
  if (e.__k) {
    for (t = e.__k.length - 1; t >= 0; t--) if ((n = e.__k[t]) && (r = tae(n))) return r;
  }
  return null;
}
function wMe(e, t, n, r, a) {
  var o;
  for (o in n) o === "children" || o === "key" || o in t || K7(e, o, null, n[o], r);
  for (o in t) a && typeof t[o] != "function" || o === "children" || o === "key" || o === "value" || o === "checked" || n[o] === t[o] || K7(e, o, t[o], n[o], r);
}
function Sz(e, t, n) {
  t[0] === "-" ? e.setProperty(t, n == null ? "" : n) : e[t] = n == null ? "" : typeof n != "number" || CMe.test(t) ? n : n + "px";
}
function K7(e, t, n, r, a) {
  var o;
  e: if (t === "style") if (typeof n == "string") e.style.cssText = n;
  else {
    if (typeof r == "string" && (e.style.cssText = r = ""), r) for (t in r) n && t in n || Sz(e.style, t, "");
    if (n) for (t in n) r && n[t] === r[t] || Sz(e.style, t, n[t]);
  }
  else if (t[0] === "o" && t[1] === "n") o = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + o] = n, n ? r || e.addEventListener(t, o ? Ez : xz, o) : e.removeEventListener(t, o ? Ez : xz, o);
  else if (t !== "dangerouslySetInnerHTML") {
    if (a) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (t !== "width" && t !== "height" && t !== "href" && t !== "list" && t !== "form" && t !== "tabIndex" && t !== "download" && t in e) try {
      e[t] = n == null ? "" : n;
      break e;
    } catch (s) {
    }
    typeof n == "function" || (n == null || n === !1 && t[4] !== "-" ? e.removeAttribute(t) : e.setAttribute(t, n));
  }
}
function xz(e) {
  return this.l[e.type + !1](fr.event ? fr.event(e) : e);
}
function Ez(e) {
  return this.l[e.type + !0](fr.event ? fr.event(e) : e);
}
function EM(e, t, n, r, a, o, s, c, u) {
  var f, m, v, y, b, S, x, E, N, R, O, D, $, B, G, Z = t.type;
  if (t.constructor !== void 0) return null;
  n.__h != null && (u = n.__h, c = t.__e = n.__e, t.__h = null, o = [c]), (f = fr.__b) && f(t);
  try {
    e: if (typeof Z == "function") {
      if (E = t.props, N = (f = Z.contextType) && r[f.__c], R = f ? N ? N.props.value : f.__ : r, n.__c ? x = (m = t.__c = n.__c).__ = m.__E : ("prototype" in Z && Z.prototype.render ? t.__c = m = new Z(E, R) : (t.__c = m = new yo(E, R), m.constructor = Z, m.render = xMe), N && N.sub(m), m.props = E, m.state || (m.state = {}), m.context = R, m.__n = r, v = m.__d = !0, m.__h = [], m._sb = []), m.__s == null && (m.__s = m.state), Z.getDerivedStateFromProps != null && (m.__s == m.state && (m.__s = Rp({}, m.__s)), Rp(m.__s, Z.getDerivedStateFromProps(E, m.__s))), y = m.props, b = m.state, m.__v = t, v) Z.getDerivedStateFromProps == null && m.componentWillMount != null && m.componentWillMount(), m.componentDidMount != null && m.__h.push(m.componentDidMount);
      else {
        if (Z.getDerivedStateFromProps == null && E !== y && m.componentWillReceiveProps != null && m.componentWillReceiveProps(E, R), !m.__e && m.shouldComponentUpdate != null && m.shouldComponentUpdate(E, m.__s, R) === !1 || t.__v === n.__v) {
          for (t.__v !== n.__v && (m.props = E, m.state = m.__s, m.__d = !1), m.__e = !1, t.__e = n.__e, t.__k = n.__k, t.__k.forEach(function(K) {
            K && (K.__ = t);
          }), O = 0; O < m._sb.length; O++) m.__h.push(m._sb[O]);
          m._sb = [], m.__h.length && s.push(m);
          break e;
        }
        m.componentWillUpdate != null && m.componentWillUpdate(E, m.__s, R), m.componentDidUpdate != null && m.__h.push(function() {
          m.componentDidUpdate(y, b, S);
        });
      }
      if (m.context = R, m.props = E, m.__P = e, D = fr.__r, $ = 0, "prototype" in Z && Z.prototype.render) {
        for (m.state = m.__s, m.__d = !1, D && D(t), f = m.render(m.props, m.state, m.context), B = 0; B < m._sb.length; B++) m.__h.push(m._sb[B]);
        m._sb = [];
      } else do
        m.__d = !1, D && D(t), f = m.render(m.props, m.state, m.context), m.state = m.__s;
      while (m.__d && ++$ < 25);
      m.state = m.__s, m.getChildContext != null && (r = Rp(Rp({}, r), m.getChildContext())), v || m.getSnapshotBeforeUpdate == null || (S = m.getSnapshotBeforeUpdate(y, b)), G = f != null && f.type === ra && f.key == null ? f.props.children : f, Jre(e, Array.isArray(G) ? G : [G], t, n, r, a, o, s, c, u), m.base = t.__e, t.__h = null, m.__h.length && s.push(m), x && (m.__E = m.__ = null), m.__e = !1;
    } else o == null && t.__v === n.__v ? (t.__k = n.__k, t.__e = n.__e) : t.__e = SMe(n.__e, t, n, r, a, o, s, u);
    (f = fr.diffed) && f(t);
  } catch (K) {
    t.__v = null, (u || o != null) && (t.__e = c, t.__h = !!u, o[o.indexOf(c)] = null), fr.__e(K, t, n);
  }
}
function nae(e, t) {
  fr.__c && fr.__c(t, e), e.some(function(n) {
    try {
      e = n.__h, n.__h = [], e.some(function(r) {
        r.call(n);
      });
    } catch (r) {
      fr.__e(r, n.__v);
    }
  });
}
function SMe(e, t, n, r, a, o, s, c) {
  var u, f, m, v = n.props, y = t.props, b = t.type, S = 0;
  if (b === "svg" && (a = !0), o != null) {
    for (; S < o.length; S++) if ((u = o[S]) && "setAttribute" in u == !!b && (b ? u.localName === b : u.nodeType === 3)) {
      e = u, o[S] = null;
      break;
    }
  }
  if (e == null) {
    if (b === null) return document.createTextNode(y);
    e = a ? document.createElementNS("http://www.w3.org/2000/svg", b) : document.createElement(b, y.is && y), o = null, c = !1;
  }
  if (b === null) v === y || c && e.data === y || (e.data = y);
  else {
    if (o = o && X_.call(e.childNodes), f = (v = n.props || Y7).dangerouslySetInnerHTML, m = y.dangerouslySetInnerHTML, !c) {
      if (o != null) for (v = {}, S = 0; S < e.attributes.length; S++) v[e.attributes[S].name] = e.attributes[S].value;
      (m || f) && (m && (f && m.__html == f.__html || m.__html === e.innerHTML) || (e.innerHTML = m && m.__html || ""));
    }
    if (wMe(e, y, v, a, c), m) t.__k = [];
    else if (S = t.props.children, Jre(e, Array.isArray(S) ? S : [S], t, n, r, a && b !== "foreignObject", o, s, o ? o[0] : n.__k && d_(n, 0), c), o != null) for (S = o.length; S--; ) o[S] != null && Kre(o[S]);
    c || ("value" in y && (S = y.value) !== void 0 && (S !== e.value || b === "progress" && !S || b === "option" && S !== v.value) && K7(e, "value", S, v.value, !1), "checked" in y && (S = y.checked) !== void 0 && S !== e.checked && K7(e, "checked", S, v.checked, !1));
  }
  return e;
}
function rae(e, t, n) {
  try {
    typeof e == "function" ? e(t) : e.current = t;
  } catch (r) {
    fr.__e(r, n);
  }
}
function aae(e, t, n) {
  var r, a;
  if (fr.unmount && fr.unmount(e), (r = e.ref) && (r.current && r.current !== e.__e || rae(r, null, t)), (r = e.__c) != null) {
    if (r.componentWillUnmount) try {
      r.componentWillUnmount();
    } catch (o) {
      fr.__e(o, t);
    }
    r.base = r.__P = null, e.__c = void 0;
  }
  if (r = e.__k) for (a = 0; a < r.length; a++) r[a] && aae(r[a], t, n || typeof e.type != "function");
  n || e.__e == null || Kre(e.__e), e.__ = e.__e = e.__d = void 0;
}
function xMe(e, t, n) {
  return this.constructor(e, n);
}
function QA(e, t, n) {
  var r, a, o;
  fr.__ && fr.__(e, t), a = (r = typeof n == "function") ? null : n && n.__k || t.__k, o = [], EM(t, e = (!r && n || t).__k = P(ra, null, [e]), a || Y7, Y7, t.ownerSVGElement !== void 0, !r && n ? [n] : a ? null : t.firstChild ? X_.call(t.childNodes) : null, o, !r && n ? n : a ? a.__e : t.firstChild, r), nae(o, e);
}
function EMe(e, t, n) {
  var r, a, o, s = Rp({}, e.props);
  for (o in t) o == "key" ? r = t[o] : o == "ref" ? a = t[o] : s[o] = t[o];
  return arguments.length > 2 && (s.children = arguments.length > 3 ? X_.call(arguments, 2) : n), U4(e.type, s, r || e.key, a || e.ref, null);
}
function IM(e, t) {
  var n = { __c: t = "__cC" + Yre++, __: e, Consumer: function(r, a) {
    return r.children(a);
  }, Provider: function(r) {
    var a, o;
    return this.getChildContext || (a = [], (o = {})[t] = this, this.getChildContext = function() {
      return o;
    }, this.shouldComponentUpdate = function(s) {
      this.props.value !== s.value && a.some(function(c) {
        c.__e = !0, ZT(c);
      });
    }, this.sub = function(s) {
      a.push(s);
      var c = s.componentWillUnmount;
      s.componentWillUnmount = function() {
        a.splice(a.indexOf(s), 1), c && c.call(s);
      };
    }), r.children;
  } };
  return n.Provider.__ = n.Consumer.contextType = n;
}
X_ = Xre.slice, fr = { __e: function(e, t, n, r) {
  for (var a, o, s; t = t.__; ) if ((a = t.__c) && !a.__) try {
    if ((o = a.constructor) && o.getDerivedStateFromError != null && (a.setState(o.getDerivedStateFromError(e)), s = a.__d), a.componentDidCatch != null && (a.componentDidCatch(e, r || {}), s = a.__d), s) return a.__E = a;
  } catch (c) {
    e = c;
  }
  throw e;
} }, Wre = 0, yo.prototype.setState = function(e, t) {
  var n;
  n = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Rp({}, this.state), typeof e == "function" && (e = e(Rp({}, n), this.props)), e && Rp(n, e), e != null && this.__v && (t && this._sb.push(t), ZT(this));
}, yo.prototype.forceUpdate = function(e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), ZT(this));
}, yo.prototype.render = ra, P0 = [], Zre = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, WT = function(e, t) {
  return e.__v.__b - t.__v.__b;
}, X7.__r = 0, Yre = 0;
var oae = aa, IMe = Um, kMe = bo, AMe = tM, PMe = Xp, NMe = Kp, TMe = D2, OMe = oae.Function, RMe = /MSIE .\./.test(PMe) || AMe === "BUN" && function() {
  var e = oae.Bun.version.split(".");
  return e.length < 3 || e[0] === "0" && (e[1] < 3 || e[1] === "3" && e[2] === "0");
}(), iae = function(e, t) {
  var n = t ? 2 : 1;
  return RMe ? function(r, a) {
    var o = TMe(arguments.length, 1) > n, s = kMe(r) ? r : OMe(r), c = o ? NMe(arguments, n) : [], u = o ? function() {
      IMe(s, this, c);
    } : s;
    return t ? e(u, a) : e(u);
  } : e;
}, MMe = vt, sae = aa, DMe = iae, Iz = DMe(sae.setInterval, !0);
MMe({ global: !0, bind: !0, forced: sae.setInterval !== Iz }, {
  setInterval: Iz
});
var LMe = vt, lae = aa, $Me = iae, kz = $Me(lae.setTimeout, !0);
LMe({ global: !0, bind: !0, forced: lae.setTimeout !== kz }, {
  setTimeout: kz
});
var jMe = Yr, FMe = jMe.setTimeout, BMe = FMe;
const Ro = /* @__PURE__ */ Mt(BMe);
var uae = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = "", s = 0; s < arguments.length; s++) {
        var c = arguments[s];
        c && (o = a(o, r(c)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var s = "";
      for (var c in o)
        t.call(o, c) && o[c] && (s = a(s, c));
      return s;
    }
    function a(o, s) {
      return s ? o ? o + " " + s : o + s : o;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(uae);
var VMe = uae.exports;
const Tt = /* @__PURE__ */ Mt(VMe);
var UMe = vt, GMe = aa, zMe = _M, HMe = mr, WMe = Wm, ZMe = Td, YMe = V_, XMe = bo, KMe = Lo, qMe = P2, JMe = Rf, QMe = mu.f, eDe = qp.forEach, tDe = _o, cae = Xm, nDe = cae.set, rDe = cae.getterFor, dae = function(e, t, n) {
  var r = e.indexOf("Map") !== -1, a = e.indexOf("Weak") !== -1, o = r ? "set" : "add", s = GMe[e], c = s && s.prototype, u = {}, f;
  if (!tDe || !XMe(s) || !(a || c.forEach && !HMe(function() {
    new s().entries().next();
  })))
    f = n.getConstructor(t, e, r, o), zMe.enable();
  else {
    f = t(function(y, b) {
      nDe(YMe(y, m), {
        type: e,
        collection: new s()
      }), qMe(b) || ZMe(b, y[o], { that: y, AS_ENTRIES: r });
    });
    var m = f.prototype, v = rDe(e);
    eDe(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function(y) {
      var b = y === "add" || y === "set";
      y in c && !(a && y === "clear") && WMe(m, y, function(S, x) {
        var E = v(this).collection;
        if (!b && a && !KMe(S)) return y === "get" ? void 0 : !1;
        var N = E[y](S === 0 ? 0 : S, x);
        return b ? this : N;
      });
    }), a || QMe(m, "size", {
      configurable: !0,
      get: function() {
        return v(this).collection.size;
      }
    });
  }
  return JMe(f, e, !1, !0), u[e] = f, UMe({ global: !0, forced: !0 }, u), a || n.setStrong(f, e, r), f;
}, aDe = Km, fae = function(e, t, n) {
  for (var r in t)
    n && n.unsafe && e[r] ? e[r] = t[r] : aDe(e, r, t[r], n);
  return e;
}, Az = Zm, oDe = B_, Pz = fae, iDe = ms, sDe = V_, lDe = P2, uDe = Td, cDe = eM, jS = c8, dDe = wte, i4 = _o, Nz = _M.fastKey, pae = Xm, Tz = pae.set, eP = pae.getterFor, hae = {
  getConstructor: function(e, t, n, r) {
    var a = e(function(f, m) {
      sDe(f, o), Tz(f, {
        type: t,
        index: Az(null),
        first: null,
        last: null,
        size: 0
      }), i4 || (f.size = 0), lDe(m) || uDe(m, f[r], { that: f, AS_ENTRIES: n });
    }), o = a.prototype, s = eP(t), c = function(f, m, v) {
      var y = s(f), b = u(f, m), S, x;
      return b ? b.value = v : (y.last = b = {
        index: x = Nz(m, !0),
        key: m,
        value: v,
        previous: S = y.last,
        next: null,
        removed: !1
      }, y.first || (y.first = b), S && (S.next = b), i4 ? y.size++ : f.size++, x !== "F" && (y.index[x] = b)), f;
    }, u = function(f, m) {
      var v = s(f), y = Nz(m), b;
      if (y !== "F") return v.index[y];
      for (b = v.first; b; b = b.next)
        if (b.key === m) return b;
    };
    return Pz(o, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function() {
        for (var m = this, v = s(m), y = v.first; y; )
          y.removed = !0, y.previous && (y.previous = y.previous.next = null), y = y.next;
        v.first = v.last = null, v.index = Az(null), i4 ? v.size = 0 : m.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      delete: function(f) {
        var m = this, v = s(m), y = u(m, f);
        if (y) {
          var b = y.next, S = y.previous;
          delete v.index[y.index], y.removed = !0, S && (S.next = b), b && (b.previous = S), v.first === y && (v.first = b), v.last === y && (v.last = S), i4 ? v.size-- : m.size--;
        }
        return !!y;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function(m) {
        for (var v = s(this), y = iDe(m, arguments.length > 1 ? arguments[1] : void 0), b; b = b ? b.next : v.first; )
          for (y(b.value, b.key, this); b && b.removed; ) b = b.previous;
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function(m) {
        return !!u(this, m);
      }
    }), Pz(o, n ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function(m) {
        var v = u(this, m);
        return v && v.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function(m, v) {
        return c(this, m === 0 ? 0 : m, v);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function(m) {
        return c(this, m = m === 0 ? 0 : m, m);
      }
    }), i4 && oDe(o, "size", {
      configurable: !0,
      get: function() {
        return s(this).size;
      }
    }), a;
  },
  setStrong: function(e, t, n) {
    var r = t + " Iterator", a = eP(t), o = eP(r);
    cDe(e, t, function(s, c) {
      Tz(this, {
        type: r,
        target: s,
        state: a(s),
        kind: c,
        last: null
      });
    }, function() {
      for (var s = o(this), c = s.kind, u = s.last; u && u.removed; ) u = u.previous;
      return !s.target || !(s.last = u = u ? u.next : s.state.first) ? (s.target = null, jS(void 0, !0)) : jS(c === "keys" ? u.key : c === "values" ? u.value : [u.key, u.value], !1);
    }, n ? "entries" : "values", !n, !0), dDe(t);
  }
}, fDe = dae, pDe = hae;
fDe("Map", function(e) {
  return function() {
    return e(this, arguments.length ? arguments[0] : void 0);
  };
}, pDe);
var mae = function(e, t) {
  return t === 1 ? function(n, r) {
    return n[e](r);
  } : function(n, r, a) {
    return n[e](r, a);
  };
}, hDe = Ni, FS = mae, Oz = hDe("Map"), Od = {
  Map: Oz,
  set: FS("set", 2),
  get: FS("get", 1),
  has: FS("has", 1),
  remove: FS("delete", 1),
  proto: Oz.prototype
}, mDe = vt, vDe = Rr, gDe = Ti, yDe = Of, bDe = Td, x8 = Od, _De = zR, CDe = x8.Map, wDe = x8.has, SDe = x8.get, xDe = x8.set, EDe = vDe([].push);
mDe({ target: "Map", stat: !0, forced: _De }, {
  groupBy: function(t, n) {
    yDe(t), gDe(n);
    var r = new CDe(), a = 0;
    return bDe(t, function(o) {
      var s = n(o, a++);
      wDe(r, s) ? EDe(SDe(r, s), o) : xDe(r, s, [o]);
    }), r;
  }
});
var IDe = Yr, kDe = IDe.Map, ADe = kDe, PDe = ADe, NDe = PDe, TDe = NDe, ODe = ms, RDe = vs, MDe = hl, DDe = Td, LDe = function(e, t, n) {
  return function(a) {
    var o = MDe(a), s = arguments.length, c = s > 1 ? arguments[1] : void 0, u = c !== void 0, f = u ? ODe(c, s > 2 ? arguments[2] : void 0) : void 0, m = new e(), v = 0;
    return DDe(o, function(y) {
      var b = u ? f(y, v++) : y;
      n ? t(m, RDe(b)[0], b[1]) : t(m, b);
    }), m;
  };
}, $De = vt, Rz = Od, jDe = LDe;
$De({ target: "Map", stat: !0, forced: !0 }, {
  from: jDe(Rz.Map, Rz.set, !0)
});
var FDe = vs, BDe = function(e, t, n) {
  return function() {
    for (var a = new e(), o = arguments.length, s = 0; s < o; s++) {
      var c = arguments[s];
      n ? t(a, FDe(c)[0], c[1]) : t(a, c);
    }
    return a;
  };
}, VDe = vt, Mz = Od, UDe = BDe;
VDe({ target: "Map", stat: !0, forced: !0 }, {
  of: UDe(Mz.Map, Mz.set, !0)
});
var GDe = Hm, zDe = TypeError, vu = function(e) {
  if (typeof e == "object" && "size" in e && "has" in e && "get" in e && "set" in e && "delete" in e && "entries" in e) return e;
  throw new zDe(GDe(e) + " is not a map");
}, HDe = vt, WDe = vu, ZDe = Od.remove;
HDe({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  deleteAll: function() {
    for (var t = WDe(this), n = !0, r, a = 0, o = arguments.length; a < o; a++)
      r = ZDe(t, arguments[a]), n = n && r;
    return !!n;
  }
});
var YDe = vt, XDe = vu, kM = Od, KDe = kM.get, qDe = kM.has, Dz = kM.set;
YDe({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  emplace: function(t, n) {
    var r = XDe(this), a, o;
    return qDe(r, t) ? (a = KDe(r, t), "update" in n && (a = n.update(a, t, r), Dz(r, t, a)), a) : (o = n.insert(t, r), Dz(r, t, o), o);
  }
});
var JDe = Co, Qm = function(e, t, n) {
  for (var r = n ? e : e.iterator, a = e.next, o, s; !(o = JDe(a, r)).done; )
    if (s = t(o.value), s !== void 0) return s;
}, QDe = Qm, Df = function(e, t, n) {
  return n ? QDe(e.entries(), function(r) {
    return t(r[1], r[0]);
  }, !0) : e.forEach(t);
}, eLe = vt, tLe = ms, nLe = vu, rLe = Df;
eLe({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  every: function(t) {
    var n = nLe(this), r = tLe(t, arguments.length > 1 ? arguments[1] : void 0);
    return rLe(n, function(a, o) {
      if (!r(a, o, n)) return !1;
    }, !0) !== !1;
  }
});
var aLe = vt, oLe = ms, iLe = vu, vae = Od, sLe = Df, lLe = vae.Map, uLe = vae.set;
aLe({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  filter: function(t) {
    var n = iLe(this), r = oLe(t, arguments.length > 1 ? arguments[1] : void 0), a = new lLe();
    return sLe(n, function(o, s) {
      r(o, s, n) && uLe(a, s, o);
    }), a;
  }
});
var cLe = vt, dLe = ms, fLe = vu, pLe = Df;
cLe({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  find: function(t) {
    var n = fLe(this), r = dLe(t, arguments.length > 1 ? arguments[1] : void 0), a = pLe(n, function(o, s) {
      if (r(o, s, n)) return { value: o };
    }, !0);
    return a && a.value;
  }
});
var hLe = vt, mLe = ms, vLe = vu, gLe = Df;
hLe({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  findKey: function(t) {
    var n = vLe(this), r = mLe(t, arguments.length > 1 ? arguments[1] : void 0), a = gLe(n, function(o, s) {
      if (r(o, s, n)) return { key: s };
    }, !0);
    return a && a.key;
  }
});
var yLe = function(e, t) {
  return e === t || e !== e && t !== t;
}, bLe = vt, _Le = yLe, CLe = vu, wLe = Df;
bLe({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  includes: function(t) {
    return wLe(CLe(this), function(n) {
      if (_Le(n, t)) return !0;
    }, !0) === !0;
  }
});
var SLe = vt, xLe = Co, ELe = Td, ILe = bo, Lz = Ti, kLe = Od.Map;
SLe({ target: "Map", stat: !0, forced: !0 }, {
  keyBy: function(t, n) {
    var r = ILe(this) ? this : kLe, a = new r();
    Lz(n);
    var o = Lz(a.set);
    return ELe(t, function(s) {
      xLe(o, a, n(s), s);
    }), a;
  }
});
var ALe = vt, PLe = vu, NLe = Df;
ALe({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  keyOf: function(t) {
    var n = NLe(PLe(this), function(r, a) {
      if (r === t) return { key: a };
    }, !0);
    return n && n.key;
  }
});
var TLe = vt, OLe = ms, RLe = vu, gae = Od, MLe = Df, DLe = gae.Map, LLe = gae.set;
TLe({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  mapKeys: function(t) {
    var n = RLe(this), r = OLe(t, arguments.length > 1 ? arguments[1] : void 0), a = new DLe();
    return MLe(n, function(o, s) {
      LLe(a, r(o, s, n), o);
    }), a;
  }
});
var $Le = vt, jLe = ms, FLe = vu, yae = Od, BLe = Df, VLe = yae.Map, ULe = yae.set;
$Le({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  mapValues: function(t) {
    var n = FLe(this), r = jLe(t, arguments.length > 1 ? arguments[1] : void 0), a = new VLe();
    return BLe(n, function(o, s) {
      ULe(a, s, r(o, s, n));
    }), a;
  }
});
var GLe = vt, zLe = vu, HLe = Td, WLe = Od.set;
GLe({ target: "Map", proto: !0, real: !0, arity: 1, forced: !0 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  merge: function(t) {
    for (var n = zLe(this), r = arguments.length, a = 0; a < r; )
      HLe(arguments[a++], function(o, s) {
        WLe(n, o, s);
      }, { AS_ENTRIES: !0 });
    return n;
  }
});
var ZLe = vt, YLe = Ti, XLe = vu, KLe = Df, qLe = TypeError;
ZLe({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  reduce: function(t) {
    var n = XLe(this), r = arguments.length < 2, a = r ? void 0 : arguments[1];
    if (YLe(t), KLe(n, function(o, s) {
      r ? (r = !1, a = o) : a = t(a, o, s, n);
    }), r) throw new qLe("Reduce of empty map with no initial value");
    return a;
  }
});
var JLe = vt, QLe = ms, e$e = vu, t$e = Df;
JLe({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  some: function(t) {
    var n = e$e(this), r = QLe(t, arguments.length > 1 ? arguments[1] : void 0);
    return t$e(n, function(a, o) {
      if (r(a, o, n)) return !0;
    }, !0) === !0;
  }
});
var n$e = vt, $z = Ti, r$e = vu, AM = Od, a$e = TypeError, o$e = AM.get, i$e = AM.has, s$e = AM.set;
n$e({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  update: function(t, n) {
    var r = r$e(this), a = arguments.length;
    $z(n);
    var o = i$e(r, t);
    if (!o && a < 3)
      throw new a$e("Updating absent value");
    var s = o ? o$e(r, t) : $z(a > 2 ? arguments[2] : void 0)(t, r);
    return s$e(r, t, n(s, t, r)), r;
  }
});
var BS = Co, tP = Ti, VS = bo, l$e = vs, u$e = TypeError, bae = function(t, n) {
  var r = l$e(this), a = tP(r.get), o = tP(r.has), s = tP(r.set), c = arguments.length > 2 ? arguments[2] : void 0, u;
  if (!VS(n) && !VS(c))
    throw new u$e("At least one callback required");
  return BS(o, r, t) ? (u = BS(a, r, t), VS(n) && (u = n(u), BS(s, r, t, u))) : VS(c) && (u = c(), BS(s, r, t, u)), u;
}, c$e = vt, d$e = bae;
c$e({ target: "Map", proto: !0, real: !0, forced: !0 }, {
  upsert: d$e
});
var f$e = vt, p$e = bae;
f$e({ target: "Map", proto: !0, real: !0, name: "upsert", forced: !0 }, {
  updateOrInsert: p$e
});
var h$e = TDe, m$e = h$e, v$e = m$e;
const jz = /* @__PURE__ */ Mt(v$e);
var g$e = $re, y$e = g$e, b$e = y$e, _$e = b$e, C$e = _$e;
const w$e = /* @__PURE__ */ Mt(C$e);
function S$e(e) {
  try {
    var t;
    return w$e(t = Function.toString.call(e)).call(t, "[native code]") !== -1;
  } catch (n) {
    return typeof e == "function";
  }
}
var x$e = Gre, E$e = x$e, I$e = E$e, k$e = I$e, A$e = k$e;
const _ae = /* @__PURE__ */ Mt(A$e);
function Cae() {
  try {
    var e = !Boolean.prototype.valueOf.call(_ae(Boolean, [], function() {
    }));
  } catch (t) {
  }
  return (Cae = function() {
    return !!e;
  })();
}
function P$e(e, t, n) {
  if (Cae()) return _ae.apply(null, arguments);
  var r = [null];
  Jne(r).apply(r, t);
  var a = new (Y_(e).apply(e, r))();
  return n && c_(a, n.prototype), a;
}
function f_(e) {
  var t = typeof jz == "function" ? new jz() : void 0;
  return f_ = function(r) {
    if (r === null || !S$e(r)) return r;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(r)) return t.get(r);
      t.set(r, a);
    }
    function a() {
      return P$e(r, arguments, fe(this).constructor);
    }
    return a.prototype = Zne(r.prototype, {
      constructor: {
        value: a,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), c_(a, r);
  }, f_(e);
}
var N$e = tre;
const Xo = /* @__PURE__ */ Mt(N$e);
var Fz = Qo, T$e = function(e) {
  return e !== void 0 && (Fz(e, "value") || Fz(e, "writable"));
}, O$e = vt, R$e = Co, M$e = Lo, D$e = vs, L$e = T$e, $$e = Gm, j$e = R2;
function wae(e, t) {
  var n = arguments.length < 3 ? e : arguments[2], r, a;
  if (D$e(e) === n) return e[t];
  if (r = $$e.f(e, t), r) return L$e(r) ? r.value : r.get === void 0 ? void 0 : R$e(r.get, n);
  if (M$e(a = j$e(e))) return wae(a, t, n);
}
O$e({ target: "Reflect", stat: !0 }, {
  get: wae
});
var F$e = Yr, B$e = F$e.Reflect.get, V$e = B$e, U$e = V$e, G$e = U$e, z$e = G$e, H$e = z$e, W$e = H$e, Z$e = W$e;
const Bz = /* @__PURE__ */ Mt(Z$e);
var Y$e = ure, X$e = Y$e, K$e = X$e, q$e = K$e, J$e = q$e;
const Q$e = /* @__PURE__ */ Mt(J$e);
function eje(e, t) {
  for (; !{}.hasOwnProperty.call(e, t) && (e = fe(e)) !== null; ) ;
  return e;
}
function Nn() {
  var e;
  return Nn = typeof Reflect != "undefined" && Bz ? Y_(e = Bz).call(e) : function(t, n, r) {
    var a = eje(t, n);
    if (a) {
      var o = Q$e(a, n);
      return o.get ? o.get.call(arguments.length < 3 ? t : r) : o.value;
    }
  }, Nn.apply(null, arguments);
}
var tje = vt, nje = qp.every, rje = l1, aje = rje("every");
tje({ target: "Array", proto: !0, forced: !aje }, {
  every: function(t) {
    return nje(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var oje = Xa, ije = oje("Array", "every"), sje = Sa, lje = ije, nP = Array.prototype, uje = function(e) {
  var t = e.every;
  return e === nP || sje(nP, e) && t === nP.every ? lje : t;
}, cje = uje, dje = cje, fje = dje;
const $m = /* @__PURE__ */ Mt(fje);
var pje = vt, hje = Rr, Sae = Date, mje = hje(Sae.prototype.getTime);
pje({ target: "Date", stat: !0 }, {
  now: function() {
    return mje(new Sae());
  }
});
var vje = Yr, gje = vje.Date.now, yje = gje, bje = yje, _je = bje;
const m2 = /* @__PURE__ */ Mt(_je);
var Cje = hte.PROPER, wje = mr, Vz = CM, Uz = "​᠎", xae = function(e) {
  return wje(function() {
    return !!Vz[e]() || Uz[e]() !== Uz || Cje && Vz[e].name !== e;
  });
}, Sje = wM.start, xje = xae, Eae = xje("trimStart") ? function() {
  return Sje(this);
} : "".trimStart, Eje = vt, Gz = Eae;
Eje({ target: "String", proto: !0, name: "trimStart", forced: "".trimLeft !== Gz }, {
  trimLeft: Gz
});
var Ije = vt, zz = Eae;
Ije({ target: "String", proto: !0, name: "trimStart", forced: "".trimStart !== zz }, {
  trimStart: zz
});
var kje = Xa, Aje = kje("String", "trimLeft"), Pje = Sa, Nje = Aje, rP = String.prototype, Tje = function(e) {
  var t = e.trimStart;
  return typeof e == "string" || e === rP || Pje(rP, e) && t === rP.trimStart ? Nje : t;
}, Oje = Tje, Rje = Oje, Mje = Rje;
const Dje = /* @__PURE__ */ Mt(Mje);
var Lje = Are;
const E8 = /* @__PURE__ */ Mt(Lje);
var Iae = _o, $je = mr, kae = Rr, jje = R2, Fje = j_, Bje = Tc, Vje = O_.f, Aae = kae(Vje), Uje = kae([].push), Gje = Iae && $je(function() {
  var e = /* @__PURE__ */ Object.create(null);
  return e[2] = 2, !Aae(e, 2);
}), Hz = function(e) {
  return function(t) {
    for (var n = Bje(t), r = Fje(n), a = Gje && jje(n) === null, o = r.length, s = 0, c = [], u; o > s; )
      u = r[s++], (!Iae || (a ? u in n : Aae(n, u))) && Uje(c, e ? [u, n[u]] : n[u]);
    return c;
  };
}, Pae = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: Hz(!0),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: Hz(!1)
}, zje = vt, Hje = Pae.values;
zje({ target: "Object", stat: !0 }, {
  values: function(t) {
    return Hje(t);
  }
});
var Wje = Yr, Zje = Wje.Object.values, Yje = Zje, Xje = Yje, Kje = Xje;
const qje = /* @__PURE__ */ Mt(Kje);
var Jje = vt, Qje = wM.trim, eFe = xae;
Jje({ target: "String", proto: !0, forced: eFe("trim") }, {
  trim: function() {
    return Qje(this);
  }
});
var tFe = Xa, nFe = tFe("String", "trim"), rFe = Sa, aFe = nFe, aP = String.prototype, oFe = function(e) {
  var t = e.trim;
  return typeof e == "string" || e === aP || rFe(aP, e) && t === aP.trim ? aFe : t;
}, iFe = oFe, sFe = iFe, lFe = sFe;
const zp = /* @__PURE__ */ Mt(lFe);
var uFe = Um, cFe = Tc, dFe = s1, fFe = Gu, pFe = l1, hFe = Math.min, YT = [].lastIndexOf, Nae = !!YT && 1 / [1].lastIndexOf(1, -0) < 0, mFe = pFe("lastIndexOf"), vFe = Nae || !mFe, gFe = vFe ? function(t) {
  if (Nae) return uFe(YT, this, arguments) || 0;
  var n = cFe(this), r = fFe(n);
  if (r === 0) return -1;
  var a = r - 1;
  for (arguments.length > 1 && (a = hFe(a, dFe(arguments[1]))), a < 0 && (a = r + a); a >= 0; a--) if (a in n && n[a] === t) return a || 0;
  return -1;
} : YT, yFe = vt, Wz = gFe;
yFe({ target: "Array", proto: !0, forced: Wz !== [].lastIndexOf }, {
  lastIndexOf: Wz
});
var bFe = Xa, _Fe = bFe("Array", "lastIndexOf"), CFe = Sa, wFe = _Fe, oP = Array.prototype, SFe = function(e) {
  var t = e.lastIndexOf;
  return e === oP || CFe(oP, e) && t === oP.lastIndexOf ? wFe : t;
}, xFe = SFe, EFe = xFe, IFe = EFe;
const kFe = /* @__PURE__ */ Mt(IFe);
var AFe = hl, Zz = s8, PFe = Gu, NFe = function(t) {
  for (var n = AFe(this), r = PFe(n), a = arguments.length, o = Zz(a > 1 ? arguments[1] : void 0, r), s = a > 2 ? arguments[2] : void 0, c = s === void 0 ? r : Zz(s, r); c > o; ) n[o++] = t;
  return n;
}, TFe = vt, OFe = NFe;
TFe({ target: "Array", proto: !0 }, {
  fill: OFe
});
var RFe = Xa, MFe = RFe("Array", "fill"), DFe = Sa, LFe = MFe, iP = Array.prototype, $Fe = function(e) {
  var t = e.fill;
  return e === iP || DFe(iP, e) && t === iP.fill ? LFe : t;
}, jFe = $Fe, FFe = jFe, BFe = FFe;
const Tae = /* @__PURE__ */ Mt(BFe);
var VFe = vt, sP = aa;
VFe({ global: !0, forced: sP.globalThis !== sP }, {
  globalThis: sP
});
var UFe = aa, GFe = UFe, zFe = GFe, HFe = zFe, WFe = HFe, ZFe = WFe, YFe = ZFe, XFe = YFe, KFe = XFe;
const Yz = /* @__PURE__ */ Mt(KFe);
var qFe = Mne;
const Oae = /* @__PURE__ */ Mt(qFe);
var JFe = Fne;
const Rae = /* @__PURE__ */ Mt(JFe);
var QFe = vt, eBe = mr, tBe = g8.f, nBe = eBe(function() {
  return !Object.getOwnPropertyNames(1);
});
QFe({ target: "Object", stat: !0, forced: nBe }, {
  getOwnPropertyNames: tBe
});
var rBe = Yr, aBe = rBe.Object, oBe = function(t) {
  return aBe.getOwnPropertyNames(t);
}, iBe = oBe, sBe = iBe, lBe = sBe;
const Mae = /* @__PURE__ */ Mt(lBe);
var uBe = Xa, cBe = uBe("Array", "entries"), dBe = cBe, fBe = dBe, pBe = Ym, hBe = Qo, mBe = Sa, vBe = fBe, lP = Array.prototype, gBe = {
  DOMTokenList: !0,
  NodeList: !0
}, yBe = function(e) {
  var t = e.entries;
  return e === lP || mBe(lP, e) && t === lP.entries || hBe(gBe, pBe(e)) ? vBe : t;
}, bBe = yBe;
const _Be = /* @__PURE__ */ Mt(bBe);
var CBe = vt, wBe = Rr, SBe = s8, xBe = RangeError, Xz = String.fromCharCode, Kz = String.fromCodePoint, EBe = wBe([].join), IBe = !!Kz && Kz.length !== 1;
CBe({ target: "String", stat: !0, arity: 1, forced: IBe }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function(t) {
    for (var n = [], r = arguments.length, a = 0, o; r > a; ) {
      if (o = +arguments[a++], SBe(o, 1114111) !== o) throw new xBe(o + " is not a valid code point");
      n[a] = o < 65536 ? Xz(o) : Xz(((o -= 65536) >> 10) + 55296, o % 1024 + 56320);
    }
    return EBe(n, "");
  }
});
var kBe = mr, ABe = Ya, PBe = _o, qz = zR, NBe = ABe("iterator"), I8 = !kBe(function() {
  var e = new URL("b?a=1&b=2&c=3", "https://a"), t = e.searchParams, n = new URLSearchParams("a=1&a=2&b=3"), r = "";
  return e.pathname = "c%20d", t.forEach(function(a, o) {
    t.delete("b"), r += o + a;
  }), n.delete("a", 2), n.delete("b", void 0), qz && (!e.toJSON || !n.has("a", 1) || n.has("a", 2) || !n.has("a", void 0) || n.has("b")) || !t.size && (qz || !PBe) || !t.sort || e.href !== "https://a/c%20d?a=1&c=3" || t.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !t[NBe] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("https://тест").host !== "xn--e1aybc" || new URL("https://a#б").hash !== "#%D0%B1" || r !== "a1c3" || new URL("https://x", void 0).host !== "x";
}), Jz = Kp, TBe = Math.floor, XT = function(e, t) {
  var n = e.length;
  if (n < 8)
    for (var r = 1, a, o; r < n; ) {
      for (o = r, a = e[r]; o && t(e[o - 1], a) > 0; )
        e[o] = e[--o];
      o !== r++ && (e[o] = a);
    }
  else
    for (var s = TBe(n / 2), c = XT(Jz(e, 0, s), t), u = XT(Jz(e, s), t), f = c.length, m = u.length, v = 0, y = 0; v < f || y < m; )
      e[v + y] = v < f && y < m ? t(c[v], u[y]) <= 0 ? c[v++] : u[y++] : v < f ? c[v++] : u[y++];
  return e;
}, Dae = XT, KT = vt, Lae = aa, PM = Rte, OBe = Ni, US = Co, kd = Rr, G4 = _o, $ae = I8, jae = Km, RBe = B_, MBe = fae, DBe = Rf, LBe = gte, NM = Xm, Fae = V_, uP = bo, $Be = Qo, jBe = ms, FBe = Ym, BBe = vs, Bae = Lo, Rl = Us, VBe = Zm, Qz = zm, eH = JR, UBe = F_, GS = c8, hy = D2, GBe = Ya, zBe = Dae, HBe = GBe("iterator"), j2 = "URLSearchParams", Vae = j2 + "Iterator", Uae = NM.set, gc = NM.getterFor(j2), WBe = NM.getterFor(Vae), tH = PM("fetch"), q7 = PM("Request"), z4 = PM("Headers"), cP = q7 && q7.prototype, nH = z4 && z4.prototype, ZBe = Lae.TypeError, YBe = Lae.encodeURIComponent, XBe = String.fromCharCode, KBe = OBe("String", "fromCodePoint"), qBe = parseInt, Kx = kd("".charAt), rH = kd([].join), Cm = kd([].push), Gae = kd("".replace), JBe = kd([].shift), aH = kd([].splice), oH = kd("".split), zae = kd("".slice), QBe = kd(/./.exec), eVe = /\+/g, dP = "�", tVe = /^[0-9a-f]+$/i, iH = function(e, t) {
  var n = zae(e, t, t + 2);
  return QBe(tVe, n) ? qBe(n, 16) : NaN;
}, nVe = function(e) {
  for (var t = 0, n = 128; n > 0 && e & n; n >>= 1)
    t++;
  return t;
}, rVe = function(e) {
  var t = null;
  switch (e.length) {
    case 1:
      t = e[0];
      break;
    case 2:
      t = (e[0] & 31) << 6 | e[1] & 63;
      break;
    case 3:
      t = (e[0] & 15) << 12 | (e[1] & 63) << 6 | e[2] & 63;
      break;
    case 4:
      t = (e[0] & 7) << 18 | (e[1] & 63) << 12 | (e[2] & 63) << 6 | e[3] & 63;
      break;
  }
  return t > 1114111 ? null : t;
}, sH = function(e) {
  e = Gae(e, eVe, " ");
  for (var t = e.length, n = "", r = 0; r < t; ) {
    var a = Kx(e, r);
    if (a === "%") {
      if (Kx(e, r + 1) === "%" || r + 3 > t) {
        n += "%", r++;
        continue;
      }
      var o = iH(e, r + 1);
      if (o !== o) {
        n += a, r++;
        continue;
      }
      r += 2;
      var s = nVe(o);
      if (s === 0)
        a = XBe(o);
      else {
        if (s === 1 || s > 4) {
          n += dP, r++;
          continue;
        }
        for (var c = [o], u = 1; u < s && (r++, !(r + 3 > t || Kx(e, r) !== "%")); ) {
          var f = iH(e, r + 1);
          if (f !== f) {
            r += 3;
            break;
          }
          if (f > 191 || f < 128) break;
          Cm(c, f), r += 2, u++;
        }
        if (c.length !== s) {
          n += dP;
          continue;
        }
        var m = rVe(c);
        m === null ? n += dP : a = KBe(m);
      }
    }
    n += a, r++;
  }
  return n;
}, aVe = /[!'()~]|%20/g, oVe = {
  "!": "%21",
  "'": "%27",
  "(": "%28",
  ")": "%29",
  "~": "%7E",
  "%20": "+"
}, iVe = function(e) {
  return oVe[e];
}, lH = function(e) {
  return Gae(YBe(e), aVe, iVe);
}, fP = LBe(function(t, n) {
  Uae(this, {
    type: Vae,
    target: gc(t).entries,
    index: 0,
    kind: n
  });
}, j2, function() {
  var t = WBe(this), n = t.target, r = t.index++;
  if (!n || r >= n.length)
    return t.target = null, GS(void 0, !0);
  var a = n[r];
  switch (t.kind) {
    case "keys":
      return GS(a.key, !1);
    case "values":
      return GS(a.value, !1);
  }
  return GS([a.key, a.value], !1);
}, !0), Hae = function(e) {
  this.entries = [], this.url = null, e !== void 0 && (Bae(e) ? this.parseObject(e) : this.parseQuery(typeof e == "string" ? Kx(e, 0) === "?" ? zae(e, 1) : e : Rl(e)));
};
Hae.prototype = {
  type: j2,
  bindURL: function(e) {
    this.url = e, this.update();
  },
  parseObject: function(e) {
    var t = this.entries, n = UBe(e), r, a, o, s, c, u, f;
    if (n)
      for (r = eH(e, n), a = r.next; !(o = US(a, r)).done; ) {
        if (s = eH(BBe(o.value)), c = s.next, (u = US(c, s)).done || (f = US(c, s)).done || !US(c, s).done) throw new ZBe("Expected sequence with length 2");
        Cm(t, { key: Rl(u.value), value: Rl(f.value) });
      }
    else for (var m in e) $Be(e, m) && Cm(t, { key: m, value: Rl(e[m]) });
  },
  parseQuery: function(e) {
    if (e)
      for (var t = this.entries, n = oH(e, "&"), r = 0, a, o; r < n.length; )
        a = n[r++], a.length && (o = oH(a, "="), Cm(t, {
          key: sH(JBe(o)),
          value: sH(rH(o, "="))
        }));
  },
  serialize: function() {
    for (var e = this.entries, t = [], n = 0, r; n < e.length; )
      r = e[n++], Cm(t, lH(r.key) + "=" + lH(r.value));
    return rH(t, "&");
  },
  update: function() {
    this.entries.length = 0, this.parseQuery(this.url.query);
  },
  updateURL: function() {
    this.url && this.url.update();
  }
};
var k8 = function() {
  Fae(this, v2);
  var t = arguments.length > 0 ? arguments[0] : void 0, n = Uae(this, new Hae(t));
  G4 || (this.size = n.entries.length);
}, v2 = k8.prototype;
MBe(v2, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function(t, n) {
    var r = gc(this);
    hy(arguments.length, 2), Cm(r.entries, { key: Rl(t), value: Rl(n) }), G4 || this.length++, r.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  delete: function(e) {
    for (var t = gc(this), n = hy(arguments.length, 1), r = t.entries, a = Rl(e), o = n < 2 ? void 0 : arguments[1], s = o === void 0 ? o : Rl(o), c = 0; c < r.length; ) {
      var u = r[c];
      if (u.key === a && (s === void 0 || u.value === s)) {
        if (aH(r, c, 1), s !== void 0) break;
      } else c++;
    }
    G4 || (this.size = r.length), t.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function(t) {
    var n = gc(this).entries;
    hy(arguments.length, 1);
    for (var r = Rl(t), a = 0; a < n.length; a++)
      if (n[a].key === r) return n[a].value;
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function(t) {
    var n = gc(this).entries;
    hy(arguments.length, 1);
    for (var r = Rl(t), a = [], o = 0; o < n.length; o++)
      n[o].key === r && Cm(a, n[o].value);
    return a;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function(t) {
    for (var n = gc(this).entries, r = hy(arguments.length, 1), a = Rl(t), o = r < 2 ? void 0 : arguments[1], s = o === void 0 ? o : Rl(o), c = 0; c < n.length; ) {
      var u = n[c++];
      if (u.key === a && (s === void 0 || u.value === s)) return !0;
    }
    return !1;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function(t, n) {
    var r = gc(this);
    hy(arguments.length, 1);
    for (var a = r.entries, o = !1, s = Rl(t), c = Rl(n), u = 0, f; u < a.length; u++)
      f = a[u], f.key === s && (o ? aH(a, u--, 1) : (o = !0, f.value = c));
    o || Cm(a, { key: s, value: c }), G4 || (this.size = a.length), r.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function() {
    var t = gc(this);
    zBe(t.entries, function(n, r) {
      return n.key > r.key ? 1 : -1;
    }), t.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function(t) {
    for (var n = gc(this).entries, r = jBe(t, arguments.length > 1 ? arguments[1] : void 0), a = 0, o; a < n.length; )
      o = n[a++], r(o.value, o.key, this);
  },
  // `URLSearchParams.prototype.keys` method
  keys: function() {
    return new fP(this, "keys");
  },
  // `URLSearchParams.prototype.values` method
  values: function() {
    return new fP(this, "values");
  },
  // `URLSearchParams.prototype.entries` method
  entries: function() {
    return new fP(this, "entries");
  }
}, { enumerable: !0 });
jae(v2, HBe, v2.entries, { name: "entries" });
jae(v2, "toString", function() {
  return gc(this).serialize();
}, { enumerable: !0 });
G4 && RBe(v2, "size", {
  get: function() {
    return gc(this).entries.length;
  },
  configurable: !0,
  enumerable: !0
});
DBe(k8, j2);
KT({ global: !0, constructor: !0, forced: !$ae }, {
  URLSearchParams: k8
});
if (!$ae && uP(z4)) {
  var sVe = kd(nH.has), lVe = kd(nH.set), uH = function(e) {
    if (Bae(e)) {
      var t = e.body, n;
      if (FBe(t) === j2)
        return n = e.headers ? new z4(e.headers) : new z4(), sVe(n, "content-type") || lVe(n, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), VBe(e, {
          body: Qz(0, Rl(t)),
          headers: Qz(0, n)
        });
    }
    return e;
  };
  if (uP(tH) && KT({ global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 }, {
    fetch: function(t) {
      return tH(t, arguments.length > 1 ? uH(arguments[1]) : {});
    }
  }), uP(q7)) {
    var pP = function(t) {
      return Fae(this, cP), new q7(t, arguments.length > 1 ? uH(arguments[1]) : {});
    };
    cP.constructor = pP, pP.prototype = cP, KT({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, {
      Request: pP
    });
  }
}
var uVe = {
  URLSearchParams: k8,
  getState: gc
}, cVe = Yr, dVe = cVe.URLSearchParams, fVe = dVe, pVe = fVe, hVe = pVe;
const cH = /* @__PURE__ */ Mt(hVe);
var mVe = Hne;
const vVe = /* @__PURE__ */ Mt(mVe);
var gVe = vt, yVe = r8;
Gm.f;
var bVe = YR, dH = Us, _Ve = fre, CVe = Of, wVe = pre, SVe = yVe("".slice), xVe = Math.min, EVe = wVe("startsWith");
gVe({ target: "String", proto: !0, forced: !EVe }, {
  startsWith: function(t) {
    var n = dH(CVe(this));
    _Ve(t);
    var r = bVe(xVe(arguments.length > 1 ? arguments[1] : void 0, n.length)), a = dH(t);
    return SVe(n, r, r + a.length) === a;
  }
});
var IVe = Xa, kVe = IVe("String", "startsWith"), AVe = Sa, PVe = kVe, hP = String.prototype, NVe = function(e) {
  var t = e.startsWith;
  return typeof e == "string" || e === hP || AVe(hP, e) && t === hP.startsWith ? PVe : t;
}, TVe = NVe, OVe = TVe, RVe = OVe;
const MVe = /* @__PURE__ */ Mt(RVe);
var DVe = vt, LVe = qp.findIndex, fH = "findIndex", Wae = !0;
fH in [] && Array(1)[fH](function() {
  Wae = !1;
});
DVe({ target: "Array", proto: !0, forced: Wae }, {
  findIndex: function(t) {
    return LVe(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var $Ve = Xa, jVe = $Ve("Array", "findIndex"), FVe = Sa, BVe = jVe, mP = Array.prototype, VVe = function(e) {
  var t = e.findIndex;
  return e === mP || FVe(mP, e) && t === mP.findIndex ? BVe : t;
}, UVe = VVe, GVe = UVe, zVe = GVe;
const qT = /* @__PURE__ */ Mt(zVe);
var HVe = vt, WVe = qp.some, ZVe = l1, YVe = ZVe("some");
HVe({ target: "Array", proto: !0, forced: !YVe }, {
  some: function(t) {
    return WVe(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var XVe = Xa, KVe = XVe("Array", "some"), qVe = Sa, JVe = KVe, vP = Array.prototype, QVe = function(e) {
  var t = e.some;
  return e === vP || qVe(vP, e) && t === vP.some ? JVe : t;
}, eUe = QVe, tUe = eUe, nUe = tUe;
const A8 = /* @__PURE__ */ Mt(nUe);
var rUe = qm, aUe = Gu, oUe = uM, iUe = ms, Zae = function(e, t, n, r, a, o, s, c) {
  for (var u = a, f = 0, m = s ? iUe(s, c) : !1, v, y; f < r; )
    f in n && (v = m ? m(n[f], f, t) : n[f], o > 0 && rUe(v) ? (y = aUe(v), u = Zae(e, t, v, y, u, o - 1) - 1) : (oUe(u + 1), e[u] = v), u++), f++;
  return u;
}, sUe = Zae, lUe = vt, uUe = sUe, cUe = hl, dUe = Gu, fUe = s1, pUe = cM;
lUe({ target: "Array", proto: !0 }, {
  flat: function() {
    var t = arguments.length ? arguments[0] : void 0, n = cUe(this), r = dUe(n), a = pUe(n, 0);
    return a.length = uUe(a, n, n, r, 0, t === void 0 ? 1 : fUe(t)), a;
  }
});
var hUe = Xa, mUe = hUe("Array", "flat"), vUe = Sa, gUe = mUe, gP = Array.prototype, yUe = function(e) {
  var t = e.flat;
  return e === gP || vUe(gP, e) && t === gP.flat ? gUe : t;
}, bUe = yUe, _Ue = bUe, CUe = _Ue;
const Yae = /* @__PURE__ */ Mt(CUe);
var wUe = vt, SUe = Pae.entries;
wUe({ target: "Object", stat: !0 }, {
  entries: function(t) {
    return SUe(t);
  }
});
var xUe = Yr, EUe = xUe.Object.entries, IUe = EUe, kUe = IUe, AUe = kUe;
const K_ = /* @__PURE__ */ Mt(AUe);
var pH = Hm, PUe = TypeError, NUe = function(e, t) {
  if (!delete e[t]) throw new PUe("Cannot delete property " + pH(t) + " of " + pH(e));
}, TUe = Xp, hH = TUe.match(/firefox\/(\d+)/i), OUe = !!hH && +hH[1], RUe = Xp, MUe = /MSIE|Trident/.test(RUe), DUe = Xp, mH = DUe.match(/AppleWebKit\/(\d+)\./), LUe = !!mH && +mH[1], $Ue = vt, Xae = Rr, jUe = Ti, FUe = hl, vH = Gu, BUe = NUe, gH = Us, TM = mr, VUe = Dae, UUe = l1, yH = OUe, GUe = MUe, bH = N2, _H = LUe, wm = [], CH = Xae(wm.sort), zUe = Xae(wm.push), HUe = TM(function() {
  wm.sort(void 0);
}), WUe = TM(function() {
  wm.sort(null);
}), ZUe = UUe("sort"), Kae = !TM(function() {
  if (bH) return bH < 70;
  if (!(yH && yH > 3)) {
    if (GUe) return !0;
    if (_H) return _H < 603;
    var e = "", t, n, r, a;
    for (t = 65; t < 76; t++) {
      switch (n = String.fromCharCode(t), t) {
        case 66:
        case 69:
        case 70:
        case 72:
          r = 3;
          break;
        case 68:
        case 71:
          r = 4;
          break;
        default:
          r = 2;
      }
      for (a = 0; a < 47; a++)
        wm.push({ k: n + a, v: r });
    }
    for (wm.sort(function(o, s) {
      return s.v - o.v;
    }), a = 0; a < wm.length; a++)
      n = wm[a].k.charAt(0), e.charAt(e.length - 1) !== n && (e += n);
    return e !== "DGBEFHACIJK";
  }
}), YUe = HUe || !WUe || !ZUe || !Kae, XUe = function(e) {
  return function(t, n) {
    return n === void 0 ? -1 : t === void 0 ? 1 : e !== void 0 ? +e(t, n) || 0 : gH(t) > gH(n) ? 1 : -1;
  };
};
$Ue({ target: "Array", proto: !0, forced: YUe }, {
  sort: function(t) {
    t !== void 0 && jUe(t);
    var n = FUe(this);
    if (Kae) return t === void 0 ? CH(n) : CH(n, t);
    var r = [], a = vH(n), o, s;
    for (s = 0; s < a; s++)
      s in n && zUe(r, n[s]);
    for (VUe(r, XUe(t)), o = vH(r), s = 0; s < o; ) n[s] = r[s++];
    for (; s < a; ) BUe(n, s++);
    return n;
  }
});
var KUe = Xa, qUe = KUe("Array", "sort"), JUe = Sa, QUe = qUe, yP = Array.prototype, eGe = function(e) {
  var t = e.sort;
  return e === yP || JUe(yP, e) && t === yP.sort ? QUe : t;
}, tGe = eGe, nGe = tGe, rGe = nGe;
const qx = /* @__PURE__ */ Mt(rGe);
var aGe = vt;
aGe({ target: "Number", stat: !0 }, {
  isNaN: function(t) {
    return t !== t;
  }
});
var oGe = Yr, iGe = oGe.Number.isNaN, sGe = iGe, lGe = sGe, uGe = lGe;
const cGe = /* @__PURE__ */ Mt(uGe);
var dGe = Hre;
const wH = /* @__PURE__ */ Mt(dGe);
var u1 = Rr, bP = 2147483647, H4 = 36, qae = 1, JT = 26, fGe = 38, pGe = 700, hGe = 72, mGe = 128, vGe = "-", gGe = /[^\0-\u007E]/, Jae = /[.\u3002\uFF0E\uFF61]/g, SH = "Overflow: input needs wider integers to process", _P = H4 - qae, xH = RangeError, yGe = u1(Jae.exec), Ly = Math.floor, CP = String.fromCharCode, EH = u1("".charCodeAt), Qae = u1([].join), Sm = u1([].push), bGe = u1("".replace), _Ge = u1("".split), CGe = u1("".toLowerCase), wGe = function(e) {
  for (var t = [], n = 0, r = e.length; n < r; ) {
    var a = EH(e, n++);
    if (a >= 55296 && a <= 56319 && n < r) {
      var o = EH(e, n++);
      (o & 64512) === 56320 ? Sm(t, ((a & 1023) << 10) + (o & 1023) + 65536) : (Sm(t, a), n--);
    } else
      Sm(t, a);
  }
  return t;
}, IH = function(e) {
  return e + 22 + 75 * (e < 26);
}, SGe = function(e, t, n) {
  var r = 0;
  for (e = n ? Ly(e / pGe) : e >> 1, e += Ly(e / t); e > _P * JT >> 1; )
    e = Ly(e / _P), r += H4;
  return Ly(r + (_P + 1) * e / (e + fGe));
}, xGe = function(e) {
  var t = [];
  e = wGe(e);
  var n = e.length, r = mGe, a = 0, o = hGe, s, c;
  for (s = 0; s < e.length; s++)
    c = e[s], c < 128 && Sm(t, CP(c));
  var u = t.length, f = u;
  for (u && Sm(t, vGe); f < n; ) {
    var m = bP;
    for (s = 0; s < e.length; s++)
      c = e[s], c >= r && c < m && (m = c);
    var v = f + 1;
    if (m - r > Ly((bP - a) / v))
      throw new xH(SH);
    for (a += (m - r) * v, r = m, s = 0; s < e.length; s++) {
      if (c = e[s], c < r && ++a > bP)
        throw new xH(SH);
      if (c === r) {
        for (var y = a, b = H4; ; ) {
          var S = b <= o ? qae : b >= o + JT ? JT : b - o;
          if (y < S) break;
          var x = y - S, E = H4 - S;
          Sm(t, CP(IH(S + x % E))), y = Ly(x / E), b += H4;
        }
        Sm(t, CP(IH(y))), o = SGe(a, v, f === u), a = 0, f++;
      }
    }
    a++, r++;
  }
  return Qae(t, "");
}, EGe = function(e) {
  var t = [], n = _Ge(bGe(CGe(e), Jae, "."), "."), r, a;
  for (r = 0; r < n.length; r++)
    a = n[r], Sm(t, yGe(gGe, a) ? "xn--" + xGe(a) : a);
  return Qae(t, ".");
}, IGe = vt, OM = _o, kGe = I8, RM = aa, kH = ms, Oc = Rr, J7 = Km, sc = B_, AGe = V_, QT = Qo, MM = zre, my = Ore, ld = Kp, PGe = Qte.codeAt, NGe = EGe, Np = Us, TGe = Rf, OGe = D2, eoe = uVe, toe = Xm, RGe = toe.set, Q7 = toe.getterFor("URL"), MGe = eoe.URLSearchParams, DGe = eoe.getState, s4 = RM.URL, eO = RM.TypeError, e6 = RM.parseInt, LGe = Math.floor, AH = Math.pow, Cc = Oc("".charAt), _d = Oc(/./.exec), w4 = Oc([].join), $Ge = Oc(1 .toString), jGe = Oc([].pop), Iy = Oc([].push), wP = Oc("".replace), FGe = Oc([].shift), BGe = Oc("".split), W4 = Oc("".slice), t6 = Oc("".toLowerCase), VGe = Oc([].unshift), UGe = "Invalid authority", SP = "Invalid scheme", f0 = "Invalid host", PH = "Invalid port", noe = /[a-z]/i, GGe = /[\d+-.a-z]/i, tO = /\d/, zGe = /^0x/i, HGe = /^[0-7]+$/, WGe = /^\d+$/, roe = /^[\da-f]+$/i, ZGe = /[\0\t\n\r #%/:<>?@[\\\]^|]/, YGe = /[\0\t\n\r #/:<>?@[\\\]^|]/, XGe = /^[\u0000-\u0020]+/, KGe = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, qGe = /[\t\n\r]/g, lc, JGe = function(e) {
  var t = BGe(e, "."), n, r, a, o, s, c, u;
  if (t.length && t[t.length - 1] === "" && t.length--, n = t.length, n > 4) return e;
  for (r = [], a = 0; a < n; a++) {
    if (o = t[a], o === "") return e;
    if (s = 10, o.length > 1 && Cc(o, 0) === "0" && (s = _d(zGe, o) ? 16 : 8, o = W4(o, s === 8 ? 1 : 2)), o === "")
      c = 0;
    else {
      if (!_d(s === 10 ? WGe : s === 8 ? HGe : roe, o)) return e;
      c = e6(o, s);
    }
    Iy(r, c);
  }
  for (a = 0; a < n; a++)
    if (c = r[a], a === n - 1) {
      if (c >= AH(256, 5 - n)) return null;
    } else if (c > 255) return null;
  for (u = jGe(r), a = 0; a < r.length; a++)
    u += r[a] * AH(256, 3 - a);
  return u;
}, QGe = function(e) {
  var t = [0, 0, 0, 0, 0, 0, 0, 0], n = 0, r = null, a = 0, o, s, c, u, f, m, v, y = function() {
    return Cc(e, a);
  };
  if (y() === ":") {
    if (Cc(e, 1) !== ":") return;
    a += 2, n++, r = n;
  }
  for (; y(); ) {
    if (n === 8) return;
    if (y() === ":") {
      if (r !== null) return;
      a++, n++, r = n;
      continue;
    }
    for (o = s = 0; s < 4 && _d(roe, y()); )
      o = o * 16 + e6(y(), 16), a++, s++;
    if (y() === ".") {
      if (s === 0 || (a -= s, n > 6)) return;
      for (c = 0; y(); ) {
        if (u = null, c > 0)
          if (y() === "." && c < 4) a++;
          else return;
        if (!_d(tO, y())) return;
        for (; _d(tO, y()); ) {
          if (f = e6(y(), 10), u === null) u = f;
          else {
            if (u === 0) return;
            u = u * 10 + f;
          }
          if (u > 255) return;
          a++;
        }
        t[n] = t[n] * 256 + u, c++, (c === 2 || c === 4) && n++;
      }
      if (c !== 4) return;
      break;
    } else if (y() === ":") {
      if (a++, !y()) return;
    } else if (y()) return;
    t[n++] = o;
  }
  if (r !== null)
    for (m = n - r, n = 7; n !== 0 && m > 0; )
      v = t[n], t[n--] = t[r + m - 1], t[r + --m] = v;
  else if (n !== 8) return;
  return t;
}, eze = function(e) {
  for (var t = null, n = 1, r = null, a = 0, o = 0; o < 8; o++)
    e[o] !== 0 ? (a > n && (t = r, n = a), r = null, a = 0) : (r === null && (r = o), ++a);
  return a > n ? r : t;
}, l4 = function(e) {
  var t, n, r, a;
  if (typeof e == "number") {
    for (t = [], n = 0; n < 4; n++)
      VGe(t, e % 256), e = LGe(e / 256);
    return w4(t, ".");
  }
  if (typeof e == "object") {
    for (t = "", r = eze(e), n = 0; n < 8; n++)
      a && e[n] === 0 || (a && (a = !1), r === n ? (t += n ? ":" : "::", a = !0) : (t += $Ge(e[n], 16), n < 7 && (t += ":")));
    return "[" + t + "]";
  }
  return e;
}, Jx = {}, aoe = MM({}, Jx, {
  " ": 1,
  '"': 1,
  "<": 1,
  ">": 1,
  "`": 1
}), ooe = MM({}, aoe, {
  "#": 1,
  "?": 1,
  "{": 1,
  "}": 1
}), xP = MM({}, ooe, {
  "/": 1,
  ":": 1,
  ";": 1,
  "=": 1,
  "@": 1,
  "[": 1,
  "\\": 1,
  "]": 1,
  "^": 1,
  "|": 1
}), cm = function(e, t) {
  var n = PGe(e, 0);
  return n > 32 && n < 127 && !QT(t, e) ? e : encodeURIComponent(e);
}, zS = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
}, S4 = function(e, t) {
  var n;
  return e.length === 2 && _d(noe, Cc(e, 0)) && ((n = Cc(e, 1)) === ":" || !t && n === "|");
}, NH = function(e) {
  var t;
  return e.length > 1 && S4(W4(e, 0, 2)) && (e.length === 2 || (t = Cc(e, 2)) === "/" || t === "\\" || t === "?" || t === "#");
}, tze = function(e) {
  return e === "." || t6(e) === "%2e";
}, nze = function(e) {
  return e = t6(e), e === ".." || e === "%2e." || e === ".%2e" || e === "%2e%2e";
}, EP = {}, TH = {}, IP = {}, OH = {}, RH = {}, kP = {}, MH = {}, DH = {}, HS = {}, WS = {}, AP = {}, PP = {}, NP = {}, TP = {}, LH = {}, OP = {}, vy = {}, mf = {}, $H = {}, p0 = {}, kp = {}, DM = function(e, t, n) {
  var r = Np(e), a, o, s;
  if (t) {
    if (o = this.parse(r), o) throw new eO(o);
    this.searchParams = null;
  } else {
    if (n !== void 0 && (a = new DM(n, !0)), o = this.parse(r, null, a), o) throw new eO(o);
    s = DGe(new MGe()), s.bindURL(this), this.searchParams = s;
  }
};
DM.prototype = {
  type: "URL",
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function(e, t, n) {
    var r = this, a = t || EP, o = 0, s = "", c = !1, u = !1, f = !1, m, v, y, b;
    for (e = Np(e), t || (r.scheme = "", r.username = "", r.password = "", r.host = null, r.port = null, r.path = [], r.query = null, r.fragment = null, r.cannotBeABaseURL = !1, e = wP(e, XGe, ""), e = wP(e, KGe, "$1")), e = wP(e, qGe, ""), m = my(e); o <= m.length; ) {
      switch (v = m[o], a) {
        case EP:
          if (v && _d(noe, v))
            s += t6(v), a = TH;
          else {
            if (t)
              return SP;
            a = IP;
            continue;
          }
          break;
        case TH:
          if (v && (_d(GGe, v) || v === "+" || v === "-" || v === "."))
            s += t6(v);
          else if (v === ":") {
            if (t && (r.isSpecial() !== QT(zS, s) || s === "file" && (r.includesCredentials() || r.port !== null) || r.scheme === "file" && !r.host)) return;
            if (r.scheme = s, t) {
              r.isSpecial() && zS[r.scheme] === r.port && (r.port = null);
              return;
            }
            s = "", r.scheme === "file" ? a = TP : r.isSpecial() && n && n.scheme === r.scheme ? a = OH : r.isSpecial() ? a = DH : m[o + 1] === "/" ? (a = RH, o++) : (r.cannotBeABaseURL = !0, Iy(r.path, ""), a = $H);
          } else {
            if (t)
              return SP;
            s = "", a = IP, o = 0;
            continue;
          }
          break;
        case IP:
          if (!n || n.cannotBeABaseURL && v !== "#") return SP;
          if (n.cannotBeABaseURL && v === "#") {
            r.scheme = n.scheme, r.path = ld(n.path), r.query = n.query, r.fragment = "", r.cannotBeABaseURL = !0, a = kp;
            break;
          }
          a = n.scheme === "file" ? TP : kP;
          continue;
        case OH:
          if (v === "/" && m[o + 1] === "/")
            a = HS, o++;
          else {
            a = kP;
            continue;
          }
          break;
        case RH:
          if (v === "/") {
            a = WS;
            break;
          } else {
            a = mf;
            continue;
          }
        case kP:
          if (r.scheme = n.scheme, v === lc)
            r.username = n.username, r.password = n.password, r.host = n.host, r.port = n.port, r.path = ld(n.path), r.query = n.query;
          else if (v === "/" || v === "\\" && r.isSpecial())
            a = MH;
          else if (v === "?")
            r.username = n.username, r.password = n.password, r.host = n.host, r.port = n.port, r.path = ld(n.path), r.query = "", a = p0;
          else if (v === "#")
            r.username = n.username, r.password = n.password, r.host = n.host, r.port = n.port, r.path = ld(n.path), r.query = n.query, r.fragment = "", a = kp;
          else {
            r.username = n.username, r.password = n.password, r.host = n.host, r.port = n.port, r.path = ld(n.path), r.path.length--, a = mf;
            continue;
          }
          break;
        case MH:
          if (r.isSpecial() && (v === "/" || v === "\\"))
            a = HS;
          else if (v === "/")
            a = WS;
          else {
            r.username = n.username, r.password = n.password, r.host = n.host, r.port = n.port, a = mf;
            continue;
          }
          break;
        case DH:
          if (a = HS, v !== "/" || Cc(s, o + 1) !== "/") continue;
          o++;
          break;
        case HS:
          if (v !== "/" && v !== "\\") {
            a = WS;
            continue;
          }
          break;
        case WS:
          if (v === "@") {
            c && (s = "%40" + s), c = !0, y = my(s);
            for (var S = 0; S < y.length; S++) {
              var x = y[S];
              if (x === ":" && !f) {
                f = !0;
                continue;
              }
              var E = cm(x, xP);
              f ? r.password += E : r.username += E;
            }
            s = "";
          } else if (v === lc || v === "/" || v === "?" || v === "#" || v === "\\" && r.isSpecial()) {
            if (c && s === "") return UGe;
            o -= my(s).length + 1, s = "", a = AP;
          } else s += v;
          break;
        case AP:
        case PP:
          if (t && r.scheme === "file") {
            a = OP;
            continue;
          } else if (v === ":" && !u) {
            if (s === "") return f0;
            if (b = r.parseHost(s), b) return b;
            if (s = "", a = NP, t === PP) return;
          } else if (v === lc || v === "/" || v === "?" || v === "#" || v === "\\" && r.isSpecial()) {
            if (r.isSpecial() && s === "") return f0;
            if (t && s === "" && (r.includesCredentials() || r.port !== null)) return;
            if (b = r.parseHost(s), b) return b;
            if (s = "", a = vy, t) return;
            continue;
          } else
            v === "[" ? u = !0 : v === "]" && (u = !1), s += v;
          break;
        case NP:
          if (_d(tO, v))
            s += v;
          else if (v === lc || v === "/" || v === "?" || v === "#" || v === "\\" && r.isSpecial() || t) {
            if (s !== "") {
              var N = e6(s, 10);
              if (N > 65535) return PH;
              r.port = r.isSpecial() && N === zS[r.scheme] ? null : N, s = "";
            }
            if (t) return;
            a = vy;
            continue;
          } else return PH;
          break;
        case TP:
          if (r.scheme = "file", v === "/" || v === "\\") a = LH;
          else if (n && n.scheme === "file")
            switch (v) {
              case lc:
                r.host = n.host, r.path = ld(n.path), r.query = n.query;
                break;
              case "?":
                r.host = n.host, r.path = ld(n.path), r.query = "", a = p0;
                break;
              case "#":
                r.host = n.host, r.path = ld(n.path), r.query = n.query, r.fragment = "", a = kp;
                break;
              default:
                NH(w4(ld(m, o), "")) || (r.host = n.host, r.path = ld(n.path), r.shortenPath()), a = mf;
                continue;
            }
          else {
            a = mf;
            continue;
          }
          break;
        case LH:
          if (v === "/" || v === "\\") {
            a = OP;
            break;
          }
          n && n.scheme === "file" && !NH(w4(ld(m, o), "")) && (S4(n.path[0], !0) ? Iy(r.path, n.path[0]) : r.host = n.host), a = mf;
          continue;
        case OP:
          if (v === lc || v === "/" || v === "\\" || v === "?" || v === "#") {
            if (!t && S4(s))
              a = mf;
            else if (s === "") {
              if (r.host = "", t) return;
              a = vy;
            } else {
              if (b = r.parseHost(s), b) return b;
              if (r.host === "localhost" && (r.host = ""), t) return;
              s = "", a = vy;
            }
            continue;
          } else s += v;
          break;
        case vy:
          if (r.isSpecial()) {
            if (a = mf, v !== "/" && v !== "\\") continue;
          } else if (!t && v === "?")
            r.query = "", a = p0;
          else if (!t && v === "#")
            r.fragment = "", a = kp;
          else if (v !== lc && (a = mf, v !== "/"))
            continue;
          break;
        case mf:
          if (v === lc || v === "/" || v === "\\" && r.isSpecial() || !t && (v === "?" || v === "#")) {
            if (nze(s) ? (r.shortenPath(), v !== "/" && !(v === "\\" && r.isSpecial()) && Iy(r.path, "")) : tze(s) ? v !== "/" && !(v === "\\" && r.isSpecial()) && Iy(r.path, "") : (r.scheme === "file" && !r.path.length && S4(s) && (r.host && (r.host = ""), s = Cc(s, 0) + ":"), Iy(r.path, s)), s = "", r.scheme === "file" && (v === lc || v === "?" || v === "#"))
              for (; r.path.length > 1 && r.path[0] === ""; )
                FGe(r.path);
            v === "?" ? (r.query = "", a = p0) : v === "#" && (r.fragment = "", a = kp);
          } else
            s += cm(v, ooe);
          break;
        case $H:
          v === "?" ? (r.query = "", a = p0) : v === "#" ? (r.fragment = "", a = kp) : v !== lc && (r.path[0] += cm(v, Jx));
          break;
        case p0:
          !t && v === "#" ? (r.fragment = "", a = kp) : v !== lc && (v === "'" && r.isSpecial() ? r.query += "%27" : v === "#" ? r.query += "%23" : r.query += cm(v, Jx));
          break;
        case kp:
          v !== lc && (r.fragment += cm(v, aoe));
          break;
      }
      o++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function(e) {
    var t, n, r;
    if (Cc(e, 0) === "[") {
      if (Cc(e, e.length - 1) !== "]" || (t = QGe(W4(e, 1, -1)), !t)) return f0;
      this.host = t;
    } else if (this.isSpecial()) {
      if (e = NGe(e), _d(ZGe, e) || (t = JGe(e), t === null)) return f0;
      this.host = t;
    } else {
      if (_d(YGe, e)) return f0;
      for (t = "", n = my(e), r = 0; r < n.length; r++)
        t += cm(n[r], Jx);
      this.host = t;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function() {
    return !this.host || this.cannotBeABaseURL || this.scheme === "file";
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function() {
    return this.username !== "" || this.password !== "";
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function() {
    return QT(zS, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function() {
    var e = this.path, t = e.length;
    t && (this.scheme !== "file" || t !== 1 || !S4(e[0], !0)) && e.length--;
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function() {
    var e = this, t = e.scheme, n = e.username, r = e.password, a = e.host, o = e.port, s = e.path, c = e.query, u = e.fragment, f = t + ":";
    return a !== null ? (f += "//", e.includesCredentials() && (f += n + (r ? ":" + r : "") + "@"), f += l4(a), o !== null && (f += ":" + o)) : t === "file" && (f += "//"), f += e.cannotBeABaseURL ? s[0] : s.length ? "/" + w4(s, "/") : "", c !== null && (f += "?" + c), u !== null && (f += "#" + u), f;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function(e) {
    var t = this.parse(e);
    if (t) throw new eO(t);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function() {
    var e = this.scheme, t = this.port;
    if (e === "blob") try {
      return new g2(e.path[0]).origin;
    } catch (n) {
      return "null";
    }
    return e === "file" || !this.isSpecial() ? "null" : e + "://" + l4(this.host) + (t !== null ? ":" + t : "");
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function() {
    return this.scheme + ":";
  },
  setProtocol: function(e) {
    this.parse(Np(e) + ":", EP);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function() {
    return this.username;
  },
  setUsername: function(e) {
    var t = my(Np(e));
    if (!this.cannotHaveUsernamePasswordPort()) {
      this.username = "";
      for (var n = 0; n < t.length; n++)
        this.username += cm(t[n], xP);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function() {
    return this.password;
  },
  setPassword: function(e) {
    var t = my(Np(e));
    if (!this.cannotHaveUsernamePasswordPort()) {
      this.password = "";
      for (var n = 0; n < t.length; n++)
        this.password += cm(t[n], xP);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function() {
    var e = this.host, t = this.port;
    return e === null ? "" : t === null ? l4(e) : l4(e) + ":" + t;
  },
  setHost: function(e) {
    this.cannotBeABaseURL || this.parse(e, AP);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function() {
    var e = this.host;
    return e === null ? "" : l4(e);
  },
  setHostname: function(e) {
    this.cannotBeABaseURL || this.parse(e, PP);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function() {
    var e = this.port;
    return e === null ? "" : Np(e);
  },
  setPort: function(e) {
    this.cannotHaveUsernamePasswordPort() || (e = Np(e), e === "" ? this.port = null : this.parse(e, NP));
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function() {
    var e = this.path;
    return this.cannotBeABaseURL ? e[0] : e.length ? "/" + w4(e, "/") : "";
  },
  setPathname: function(e) {
    this.cannotBeABaseURL || (this.path = [], this.parse(e, vy));
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function() {
    var e = this.query;
    return e ? "?" + e : "";
  },
  setSearch: function(e) {
    e = Np(e), e === "" ? this.query = null : (Cc(e, 0) === "?" && (e = W4(e, 1)), this.query = "", this.parse(e, p0)), this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function() {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function() {
    var e = this.fragment;
    return e ? "#" + e : "";
  },
  setHash: function(e) {
    if (e = Np(e), e === "") {
      this.fragment = null;
      return;
    }
    Cc(e, 0) === "#" && (e = W4(e, 1)), this.fragment = "", this.parse(e, kp);
  },
  update: function() {
    this.query = this.searchParams.serialize() || null;
  }
};
var g2 = function(t) {
  var n = AGe(this, Tl), r = OGe(arguments.length, 1) > 1 ? arguments[1] : void 0, a = RGe(n, new DM(t, !1, r));
  OM || (n.href = a.serialize(), n.origin = a.getOrigin(), n.protocol = a.getProtocol(), n.username = a.getUsername(), n.password = a.getPassword(), n.host = a.getHost(), n.hostname = a.getHostname(), n.port = a.getPort(), n.pathname = a.getPathname(), n.search = a.getSearch(), n.searchParams = a.getSearchParams(), n.hash = a.getHash());
}, Tl = g2.prototype, uc = function(e, t) {
  return {
    get: function() {
      return Q7(this)[e]();
    },
    set: t && function(n) {
      return Q7(this)[t](n);
    },
    configurable: !0,
    enumerable: !0
  };
};
OM && (sc(Tl, "href", uc("serialize", "setHref")), sc(Tl, "origin", uc("getOrigin")), sc(Tl, "protocol", uc("getProtocol", "setProtocol")), sc(Tl, "username", uc("getUsername", "setUsername")), sc(Tl, "password", uc("getPassword", "setPassword")), sc(Tl, "host", uc("getHost", "setHost")), sc(Tl, "hostname", uc("getHostname", "setHostname")), sc(Tl, "port", uc("getPort", "setPort")), sc(Tl, "pathname", uc("getPathname", "setPathname")), sc(Tl, "search", uc("getSearch", "setSearch")), sc(Tl, "searchParams", uc("getSearchParams")), sc(Tl, "hash", uc("getHash", "setHash")));
J7(Tl, "toJSON", function() {
  return Q7(this).serialize();
}, { enumerable: !0 });
J7(Tl, "toString", function() {
  return Q7(this).serialize();
}, { enumerable: !0 });
if (s4) {
  var jH = s4.createObjectURL, FH = s4.revokeObjectURL;
  jH && J7(g2, "createObjectURL", kH(jH, s4)), FH && J7(g2, "revokeObjectURL", kH(FH, s4));
}
TGe(g2, "URL");
IGe({ global: !0, constructor: !0, forced: !kGe, sham: !OM }, {
  URL: g2
});
var rze = vt, aze = Ni, ioe = mr, oze = D2, BH = Us, ize = I8, LM = aze("URL"), sze = ize && ioe(function() {
  LM.canParse();
}), lze = ioe(function() {
  return LM.canParse.length !== 1;
});
rze({ target: "URL", stat: !0, forced: !sze || lze }, {
  canParse: function(t) {
    var n = oze(arguments.length, 1), r = BH(t), a = n < 2 || arguments[1] === void 0 ? void 0 : BH(arguments[1]);
    try {
      return !!new LM(r, a);
    } catch (o) {
      return !1;
    }
  }
});
var uze = vt, cze = Ni, dze = D2, VH = Us, fze = I8, pze = cze("URL");
uze({ target: "URL", stat: !0, forced: !fze }, {
  parse: function(t) {
    var n = dze(arguments.length, 1), r = VH(t), a = n < 2 || arguments[1] === void 0 ? void 0 : VH(arguments[1]);
    try {
      return new pze(r, a);
    } catch (o) {
      return null;
    }
  }
});
var hze = Yr, mze = hze.URL, vze = mze, gze = vze, yze = gze;
const bze = /* @__PURE__ */ Mt(yze);
var _ze = ere;
const Cze = /* @__PURE__ */ Mt(_ze);
var wze = Rre;
const soe = /* @__PURE__ */ Mt(wze);
var Sze = Nre;
const xze = /* @__PURE__ */ Mt(Sze);
var Eze = Yr, Ize = Eze.setInterval, kze = Ize;
const loe = /* @__PURE__ */ Mt(kze);
var Aze = vt, Pze = wre;
Aze({ target: "String", proto: !0 }, {
  repeat: Pze
});
var Nze = Xa, Tze = Nze("String", "repeat"), Oze = Sa, Rze = Tze, RP = String.prototype, Mze = function(e) {
  var t = e.repeat;
  return typeof e == "string" || e === RP || Oze(RP, e) && t === RP.repeat ? Rze : t;
}, Dze = Mze, Lze = Dze, $ze = Lze;
const jze = /* @__PURE__ */ Mt($ze);
var Fze = dae, Bze = hae;
Fze("Set", function(e) {
  return function() {
    return e(this, arguments.length ? arguments[0] : void 0);
  };
}, Bze);
var Vze = Hm, Uze = TypeError, c1 = function(e) {
  if (typeof e == "object" && "size" in e && "has" in e && "add" in e && "delete" in e && "keys" in e) return e;
  throw new Uze(Vze(e) + " is not a set");
}, Gze = Ni, MP = mae, uoe = Gze("Set"), zze = uoe.prototype, d1 = {
  Set: uoe,
  add: MP("add", 1),
  has: MP("has", 1),
  remove: MP("delete", 1),
  proto: zze
}, Hze = Qm, q_ = function(e, t, n) {
  return n ? Hze(e.keys(), t, !0) : e.forEach(t);
}, coe = d1, Wze = q_, Zze = coe.Set, Yze = coe.add, $M = function(e) {
  var t = new Zze();
  return Wze(e, function(n) {
    Yze(t, n);
  }), t;
}, J_ = function(e) {
  return e.size;
}, Xze = function(e) {
  return {
    iterator: e,
    next: e.next,
    done: !1
  };
}, UH = Ti, doe = vs, GH = Co, Kze = s1, qze = Xze, zH = "Invalid size", Jze = RangeError, Qze = TypeError, eHe = Math.max, foe = function(e, t) {
  this.set = e, this.size = eHe(t, 0), this.has = UH(e.has), this.keys = UH(e.keys);
};
foe.prototype = {
  getIterator: function() {
    return qze(doe(GH(this.keys, this.set)));
  },
  includes: function(e) {
    return GH(this.has, this.set, e);
  }
};
var f1 = function(e) {
  doe(e);
  var t = +e.size;
  if (t !== t) throw new Qze(zH);
  var n = Kze(t);
  if (n < 0) throw new Jze(zH);
  return new foe(e, n);
}, tHe = c1, poe = d1, nHe = $M, rHe = J_, aHe = f1, oHe = q_, iHe = Qm, sHe = poe.has, HH = poe.remove, lHe = function(t) {
  var n = tHe(this), r = aHe(t), a = nHe(n);
  return rHe(n) <= r.size ? oHe(n, function(o) {
    r.includes(o) && HH(a, o);
  }) : iHe(r.getIterator(), function(o) {
    sHe(n, o) && HH(a, o);
  }), a;
}, p1 = function() {
  return !1;
}, uHe = vt, cHe = lHe, dHe = p1;
uHe({ target: "Set", proto: !0, real: !0, forced: !dHe() }, {
  difference: cHe
});
var fHe = c1, jM = d1, pHe = J_, hHe = f1, mHe = q_, vHe = Qm, gHe = jM.Set, WH = jM.add, yHe = jM.has, bHe = function(t) {
  var n = fHe(this), r = hHe(t), a = new gHe();
  return pHe(n) > r.size ? vHe(r.getIterator(), function(o) {
    yHe(n, o) && WH(a, o);
  }) : mHe(n, function(o) {
    r.includes(o) && WH(a, o);
  }), a;
}, _He = vt, CHe = bHe, wHe = p1, SHe = !wHe();
_He({ target: "Set", proto: !0, real: !0, forced: SHe }, {
  intersection: CHe
});
var xHe = c1, EHe = d1.has, IHe = J_, kHe = f1, AHe = q_, PHe = Qm, NHe = u8, THe = function(t) {
  var n = xHe(this), r = kHe(t);
  if (IHe(n) <= r.size) return AHe(n, function(o) {
    if (r.includes(o)) return !1;
  }, !0) !== !1;
  var a = r.getIterator();
  return PHe(a, function(o) {
    if (EHe(n, o)) return NHe(a, "normal", !1);
  }) !== !1;
}, OHe = vt, RHe = THe, MHe = p1;
OHe({ target: "Set", proto: !0, real: !0, forced: !MHe() }, {
  isDisjointFrom: RHe
});
var DHe = c1, LHe = J_, $He = q_, jHe = f1, FHe = function(t) {
  var n = DHe(this), r = jHe(t);
  return LHe(n) > r.size ? !1 : $He(n, function(a) {
    if (!r.includes(a)) return !1;
  }, !0) !== !1;
}, BHe = vt, VHe = FHe, UHe = p1;
BHe({ target: "Set", proto: !0, real: !0, forced: !UHe() }, {
  isSubsetOf: VHe
});
var GHe = c1, zHe = d1.has, HHe = J_, WHe = f1, ZHe = Qm, YHe = u8, XHe = function(t) {
  var n = GHe(this), r = WHe(t);
  if (HHe(n) < r.size) return !1;
  var a = r.getIterator();
  return ZHe(a, function(o) {
    if (!zHe(n, o)) return YHe(a, "normal", !1);
  }) !== !1;
}, KHe = vt, qHe = XHe, JHe = p1;
KHe({ target: "Set", proto: !0, real: !0, forced: !JHe() }, {
  isSupersetOf: qHe
});
var QHe = c1, FM = d1, eWe = $M, tWe = f1, nWe = Qm, rWe = FM.add, aWe = FM.has, oWe = FM.remove, iWe = function(t) {
  var n = QHe(this), r = tWe(t).getIterator(), a = eWe(n);
  return nWe(r, function(o) {
    aWe(n, o) ? oWe(a, o) : rWe(a, o);
  }), a;
}, sWe = vt, lWe = iWe, uWe = p1;
sWe({ target: "Set", proto: !0, real: !0, forced: !uWe() }, {
  symmetricDifference: lWe
});
var cWe = c1, dWe = d1.add, fWe = $M, pWe = f1, hWe = Qm, mWe = function(t) {
  var n = cWe(this), r = pWe(t).getIterator(), a = fWe(n);
  return hWe(r, function(o) {
    dWe(a, o);
  }), a;
}, vWe = vt, gWe = mWe, yWe = p1;
vWe({ target: "Set", proto: !0, real: !0, forced: !yWe() }, {
  union: gWe
});
var bWe = Yr, _We = bWe.Set, CWe = _We, wWe = CWe, SWe = wWe;
const xWe = /* @__PURE__ */ Mt(SWe);
var hoe = { payButton: "Pay", "payButton.redirecting": "Redirecting...", "payButton.with": "Pay %{value} with %{maskedData}", "payButton.saveDetails": "Save details", close: "Close", storeDetails: "Save for my next payment", readMore: "Read more", "creditCard.holderName": "Name on card", "creditCard.holderName.placeholder": "J. Smith", "creditCard.holderName.invalid": "Enter name as shown on card", "creditCard.numberField.title": "Card number", "creditCard.numberField.placeholder": "1234 5678 9012 3456", "creditCard.expiryDateField.title": "Expiry date", "creditCard.expiryDateField.placeholder": "MM/YY", "creditCard.expiryDateField.month": "Month", "creditCard.expiryDateField.month.placeholder": "MM", "creditCard.expiryDateField.year.placeholder": "YY", "creditCard.expiryDateField.year": "Year", "creditCard.cvcField.title": "Security code", "creditCard.cvcField.placeholder": "123", "creditCard.storeDetailsButton": "Remember for next time", "creditCard.cvcField.placeholder.4digits": "4 digits", "creditCard.cvcField.placeholder.3digits": "3 digits", "creditCard.taxNumber.placeholder": "YYMMDD / 0123456789", installments: "Number of installments", installmentOption: "%{times}x %{partialValue}", installmentOptionMonths: "%{times} months", "installments.oneTime": "One time payment", "installments.installments": "Installments payment", "installments.revolving": "Revolving payment", "sepaDirectDebit.ibanField.invalid": "Invalid account number", "sepaDirectDebit.nameField.placeholder": "J. Smith", "sepa.ownerName": "Holder Name", "sepa.ibanNumber": "Account Number (IBAN)", "error.title": "Error", "error.subtitle.redirect": "Redirect failed", "error.subtitle.payment": "Payment failed", "error.subtitle.refused": "Payment refused", "error.message.unknown": "An unknown error occurred", "errorPanel.title": "Existing errors", "idealIssuer.selectField.title": "Bank", "idealIssuer.selectField.placeholder": "Select your bank", "creditCard.success": "Payment Successful", loading: "Loading…", continue: "Continue", continueTo: "Continue to", "wechatpay.timetopay": "You have %@ to pay", "sr.wechatpay.timetopay": "You have %#minutes%# %#seconds%# to pay", "wechatpay.scanqrcode": "Scan QR code", personalDetails: "Personal details", companyDetails: "Company details", "companyDetails.name": "Company name", "companyDetails.registrationNumber": "Registration number", socialSecurityNumber: "Social security number", firstName: "First name", "firstName.invalid": "Enter your first name", infix: "Prefix", lastName: "Last name", "lastName.invalid": "Enter your last name", mobileNumber: "Mobile number", "mobileNumber.invalid": "Invalid mobile number", city: "City", postalCode: "Postal code", "postalCode.optional": "Postal code (optional)", countryCode: "Country Code", telephoneNumber: "Telephone number", dateOfBirth: "Date of birth", shopperEmail: "Email address", gender: "Gender", "gender.notselected": "Select your gender", male: "Male", female: "Female", billingAddress: "Billing address", street: "Street", stateOrProvince: "State or province", country: "Country/Region", houseNumberOrName: "House number", separateDeliveryAddress: "Specify a separate delivery address", deliveryAddress: "Delivery Address", "deliveryAddress.firstName": "Recipient first name", "deliveryAddress.lastName": "Recipient last name", zipCode: "Zip code", apartmentSuite: "Apartment / Suite", provinceOrTerritory: "Province or Territory", cityTown: "City / Town", address: "Address", "address.placeholder": "Find your address", "address.errors.incomplete": "Enter an address to continue", "address.enterManually": "Enter address manually", state: "State", "field.title.optional": "(optional)", "creditCard.cvcField.title.optional": "Security code (optional)", "issuerList.wallet.placeholder": "Select your wallet", privacyPolicy: "Privacy policy", "afterPay.agreement": "I agree with the %@ of Riverty", paymentConditions: "payment conditions", openApp: "Open the app", "voucher.readInstructions": "Read instructions", "voucher.introduction": "Thank you for your purchase, please use the following coupon to complete your payment.", "voucher.expirationDate": "Expiration Date", "voucher.alternativeReference": "Alternative Reference", "dragonpay.voucher.non.bank.selectField.placeholder": "Select your provider", "dragonpay.voucher.bank.selectField.placeholder": "Select your bank", "voucher.paymentReferenceLabel": "Payment Reference", "voucher.surcharge": "Incl. %@ surcharge", "voucher.introduction.doku": "Thank you for your purchase, please use the following information to complete your payment.", "voucher.shopperName": "Shopper Name", "voucher.merchantName": "Merchant", "voucher.introduction.econtext": "Thank you for your purchase, please use the following information to complete your payment.", "voucher.telephoneNumber": "Phone Number", "voucher.shopperReference": "Shopper Reference", "voucher.collectionInstitutionNumber": "Collection Institution Number", "voucher.econtext.telephoneNumber.invalid": "Telephone number must be 10 or 11 digits long", "boletobancario.btnLabel": "Generate Boleto", "boleto.sendCopyToEmail": "Send a copy to my email", "button.copy": "Copy", "button.download": "Download", "boleto.socialSecurityNumber": "CPF/CNPJ", "boleto.socialSecurityNumber.invalid": "Enter a valid CPF/CNPJ number", "creditCard.storedCard.description.ariaLabel": "Stored card ends in %@", "voucher.entity": "Entity", donateButton: "Donate", notNowButton: "Not now", thanksForYourSupport: "Thanks for your support!", "resultMessages.preauthorized": "Details saved", preauthorizeWith: "Preauthorize with", confirmPreauthorization: "Confirm preauthorization", confirmPurchase: "Confirm purchase", applyGiftcard: "Redeem", giftcardBalance: "Gift card balance", deductedBalance: "Deducted balance", "creditCard.pin.title": "Pin", "creditCard.encryptedPassword.label": "First 2 digits of card password", "creditCard.encryptedPassword.placeholder": "12", "creditCard.encryptedPassword.invalid": "Invalid password", "creditCard.taxNumber": "Cardholder birthdate or Corporate registration number", "creditCard.taxNumber.label": "Cardholder birthdate (YYMMDD) or Corporate registration number (10 digits)", "creditCard.taxNumber.labelAlt": "Corporate registration number (10 digits)", "creditCard.taxNumber.invalid": "Invalid Cardholder birthdate or Corporate registration number", "storedPaymentMethod.disable.button": "Remove", "storedPaymentMethod.disable.confirmation": "Remove stored payment method", "storedPaymentMethod.disable.confirmButton": "Yes, remove", "storedPaymentMethod.disable.cancelButton": "Cancel", "ach.bankAccount": "Bank account", "ach.accountHolderNameField.title": "Account holder name", "ach.accountHolderNameField.placeholder": "J. Smith", "ach.accountHolderNameField.invalid": "Invalid account holder name", "ach.accountNumberField.title": "Account number", "ach.accountNumberField.invalid": "Invalid account number", "ach.accountLocationField.title": "ABA routing number", "ach.accountLocationField.invalid": "Invalid ABA routing number", "ach.savedBankAccount": "Saved bank account", "select.state": "Select state", "select.stateOrProvince": "Select state or province", "select.provinceOrTerritory": "Select province or territory", "select.country": "Select country/region", "select.noOptionsFound": "No options found", "select.filter.placeholder": "Search...", "telephoneNumber.invalid": "Invalid telephone number", qrCodeOrApp: "or", "paypal.processingPayment": "Processing payment...", generateQRCode: "Generate QR code", "await.waitForConfirmation": "Waiting for confirmation", "mbway.confirmPayment": "Confirm your payment on the MB WAY app", "shopperEmail.invalid": "Invalid email address", "dateOfBirth.format": "DD/MM/YYYY", "dateOfBirth.invalid": "Enter a valid date of birth that indicates you are at least 18 years old", "blik.confirmPayment": "Open your banking app to confirm the payment.", "blik.invalid": "Enter 6 numbers", "blik.code": "6-digit code", "blik.help": "Get the code from your banking app.", "swish.pendingMessage": "After you scan, the status can be pending for up to 10 minutes. Attempting to pay again within this time may result in multiple charges.", "field.valid": "Field valid", "field.invalid": "Field not valid", "error.va.gen.01": "Incomplete field", "error.va.gen.02": "Field not valid", "error.va.sf-cc-num.01": "Enter a valid card number", "error.va.sf-cc-num.02": "Enter the card number", "error.va.sf-cc-num.03": "Enter a supported card brand", "error.va.sf-cc-num.04": "Enter the complete card number", "error.va.sf-cc-dat.01": "Enter a valid expiry date", "error.va.sf-cc-dat.02": "Enter a valid expiry date", "error.va.sf-cc-dat.03": "Credit card about to expire", "error.va.sf-cc-dat.04": "Enter the expiry date", "error.va.sf-cc-dat.05": "Enter the complete expiry date", "error.va.sf-cc-mth.01": "Enter the expiry month", "error.va.sf-cc-yr.01": "Enter the expiry year", "error.va.sf-cc-yr.02": "Enter the complete expiry year", "error.va.sf-cc-cvc.01": "Enter the security code", "error.va.sf-cc-cvc.02": "Enter the complete security code", "error.va.sf-ach-num.01": "Bank account number field is empty", "error.va.sf-ach-num.02": "Bank account number is the wrong length", "error.va.sf-ach-loc.01": "Bank routing number field is empty", "error.va.sf-ach-loc.02": "Bank routing number is the wrong length", "error.va.sf-kcp-pwd.01": "Password field is empty", "error.va.sf-kcp-pwd.02": "Password is the wrong length", "error.giftcard.no-balance": "This gift card has zero balance", "error.giftcard.card-error": "In our records we have no gift card with this number", "error.giftcard.currency-error": "Gift cards are only valid in the currency they were issued in", "amazonpay.signout": "Sign out from Amazon", "amazonpay.changePaymentDetails": "Change payment details", "partialPayment.warning": "Select another payment method to pay the remaining", "partialPayment.remainingBalance": "Remaining balance will be %{amount}", "bankTransfer.beneficiary": "Beneficiary", "bankTransfer.iban": "IBAN", "bankTransfer.bic": "BIC", "bankTransfer.reference": "Reference", "bankTransfer.introduction": "Continue to create a new bank transfer payment. You can use the details in the following screen to finalize this payment.", "bankTransfer.instructions": "Thank you for your purchase, please use the following information to complete your payment.", "bacs.accountHolderName": "Bank account holder name", "bacs.accountHolderName.invalid": "Invalid bank account holder name", "bacs.accountNumber": "Bank account number", "bacs.accountNumber.invalid": "Invalid bank account number", "bacs.bankLocationId": "Sort code", "bacs.bankLocationId.invalid": "Invalid sort code", "bacs.consent.amount": "I agree that the above amount will be deducted from my bank account.", "bacs.consent.account": "I confirm the account is in my name and I am the only signatory required to authorise the Direct Debit on this account.", edit: "Edit", "bacs.confirm": "Confirm and pay", "bacs.result.introduction": "Download your Direct Debit Instruction (DDI / Mandate)", "download.pdf": "Download PDF", "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe for card number", "creditCard.encryptedCardNumber.aria.label": "Card number", "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe for expiry date", "creditCard.encryptedExpiryDate.aria.label": "Expiry date", "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe for expiry month", "creditCard.encryptedExpiryMonth.aria.label": "Expiry month", "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe for expiry year", "creditCard.encryptedExpiryYear.aria.label": "Expiry year", "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe for security code", "creditCard.encryptedSecurityCode.aria.label": "Security code", "creditCard.encryptedPassword.aria.iframeTitle": "Iframe for password", "creditCard.encryptedPassword.aria.label": "First 2 digits of card password", "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe for card number", "giftcard.encryptedCardNumber.aria.label": "Card number", "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe for pin", "giftcard.encryptedSecurityCode.aria.label": "Pin", giftcardTransactionLimit: "Max. %{amount} allowed per transaction on this gift card", "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe for bank account number", "ach.encryptedBankAccountNumber.aria.label": "Account number", "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe for bank routing number", "ach.encryptedBankLocationId.aria.label": "ABA routing number", "pix.instructions": "Open the app with the PIX registered key, choose Pay with PIX and scan the QR Code or copy and paste the code", "twint.saved": "saved", orPayWith: "or pay with", invalidFormatExpects: "Invalid format. Expected format: %{format}", "upi.qrCodeWaitingMessage": "Scan the QR code using your preferred UPI app to complete the payment", "upi.vpaWaitingMessage": "Open your UPI app to confirm the payment", "upi.modeSelection": "How would you like to use UPI?", "upi.completePayment": "Complete your payment", "upi.mode.enterUpiId": "Enter UPI ID", "upi.mode.qrCode": "QR code", "upi.mode.payByAnyUpi": "Pay by any UPI app", "upi.collect.dropdown.label": "Enter UPI ID", "upi.collect.field.label": "Enter UPI ID / VPA", "onlineBanking.termsAndConditions": "By continuing you agree with the %#terms and conditions%#", "onlineBankingPL.termsAndConditions": "By continuing you agree with the %#regulations%# and %#information obligation%# of Przelewy24", "ctp.loading.poweredByCtp": "Powered by Click to Pay", "ctp.loading.intro": "We are checking to see if you have any saved cards with Click to Pay...", "ctp.login.title": "Continue to Click to Pay", "ctp.login.subtitle": "Enter the email address that is connected to Click to Pay to continue.", "ctp.login.inputLabel": "Email", "ctp.logout.notYou": "Not you?", "ctp.logout.notYourCards": "Not your cards?", "ctp.logout.notYourCard": "Not your card?", "ctp.logout.notYourProfile": "Not your profile?", "ctp.otp.fieldLabel": "One time code", "ctp.otp.resendCode": "Resend code", "ctp.otp.codeResent": "Code resent", "ctp.otp.title": "Access your Click to Pay cards", "ctp.otp.subtitle": "Enter the code %@ sent to %@ to verify it‘s you.", "ctp.otp.saveCookiesCheckbox.label": "Skip verification next time", "ctp.otp.saveCookiesCheckbox.information": "Select to be remembered on your device and browser at participating stores for faster checkout. Not recommended for shared devices.", "ctp.otp.saveCookiesCheckbox.shorterInfo": "Select to be remembered on your device and browser", "ctp.emptyProfile.message": "No cards registered in this Click to Pay profile", "ctp.separatorText": "or use", "ctp.cards.title": "Complete payment with Click to Pay", "ctp.cards.subtitle": "Select a card to use.", "ctp.cards.expiredCard": "Expired", "ctp.manualCardEntry": "Manual card entry", "ctp.aria.infoModalButton": "What is Click to Pay", "ctp.infoPopup.title": "Click to Pay brings the ease of contactless, online", "ctp.infoPopup.subtitle": "A fast, secure payment method supported by Mastercard, Visa and other payment cards.", "ctp.infoPopup.benefit1": "Click to Pay uses encryption to keep your information safe and secure", "ctp.infoPopup.benefit2": "Use it with merchants worldwide", "ctp.infoPopup.benefit3": "Set up once for hassle-free payments in the future", "ctp.errors.AUTH_INVALID": "Authentication Invalid", "ctp.errors.NOT_FOUND": "No account found, enter a valid email or continue using manual card entry", "ctp.errors.ID_FORMAT_UNSUPPORTED": "Format not supported", "ctp.errors.FRAUD": "The user account was locked or disabled", "ctp.errors.CONSUMER_ID_MISSING": "Consumer identity is missing in the request", "ctp.errors.ACCT_INACCESSIBLE": "This account is currently not available, e.g it is locked", "ctp.errors.CODE_INVALID": "Incorrect verification code", "ctp.errors.CODE_EXPIRED": "This code has expired", "ctp.errors.RETRIES_EXCEEDED": "The limit for the number of retries for OTP generation was exceeded", "ctp.errors.OTP_SEND_FAILED": "The OTP could not be sent to the recipient", "ctp.errors.REQUEST_TIMEOUT": "Something went wrong, try again or use the manual card entry", "ctp.errors.UNKNOWN_ERROR": "Something went wrong, try again or use the manual card entry", "ctp.errors.SERVICE_ERROR": "Something went wrong, try again or use the manual card entry", "ctp.errors.SERVER_ERROR": "Something went wrong, try again or use the manual card entry", "ctp.errors.INVALID_PARAMETER": "Something went wrong, try again or use the manual card entry", "ctp.errors.AUTH_ERROR": "Something went wrong, try again or use the manual card entry", "paymentMethodsList.aria.label": "Choose a payment method", "companyDetails.name.invalid": "Enter the company name", "companyDetails.registrationNumber.invalid": "Enter the registration number", "consent.checkbox.invalid": "You must agree with the terms & conditions", "form.instruction": "All fields are required unless marked otherwise.", "trustly.descriptor": "Instant Bank Payment", "trustly.description1": "Pay directly from any of your bank accounts, backed by bank-level security", "trustly.description2": "No cards, no app download, no registration", "ancv.input.label": "Your ANCV identification", "ancv.confirmPayment": "Use your ANCV application to confirm the payment.", "ancv.form.instruction": "The Cheque-Vacances application is necessary to validate this payment.", "ancv.beneficiaryId.invalid": "Enter a valid email address or ANCV ID", "payme.openPayMeApp": "Complete your payment in the PayMe app by authorizing the payment in the app and wait for the confirmation.", "payme.redirectButtonLabel": "Open PayMe app", "payme.scanQrCode": "Complete your payment by QR code", "payme.timeToPay": "This QR code is valid for %@", "payme.instructions.steps": "Open the PayMe app.%@Scan the QR code to authorize the payment.%@Complete the payment in the app and wait for confirmation.", "payme.instructions.footnote": "Please do not close this page before the payment is completed" }, EWe = Object.freeze({ __proto__: null, default: hoe }), n6 = "en-US", moe = hoe, nO = { ar: function() {
  return import("./ar-DDjAYRg-.js");
}, "cs-CZ": function() {
  return import("./cs-CZ-DCQ1EqfT.js");
}, "da-DK": function() {
  return import("./da-DK-DQklWzZs.js");
}, "de-DE": function() {
  return import("./de-DE-BKmWsp41.js");
}, "el-GR": function() {
  return import("./el-GR-BxeOHKSa.js");
}, "en-US": function() {
  return Promise.resolve().then(function() {
    return EWe;
  });
}, "es-ES": function() {
  return import("./es-ES-D56gIEfR.js");
}, "fi-FI": function() {
  return import("./fi-FI-BVazBkT0.js");
}, "fr-FR": function() {
  return import("./fr-FR-BTOXP4NG.js");
}, "hr-HR": function() {
  return import("./hr-HR-C34TS9Z3.js");
}, "hu-HU": function() {
  return import("./hu-HU-DbXTkJh7.js");
}, "it-IT": function() {
  return import("./it-IT-BLAk4ZQQ.js");
}, "ja-JP": function() {
  return import("./ja-JP-Dg_9FdXr.js");
}, "ko-KR": function() {
  return import("./ko-KR-FtP71RhA.js");
}, "nl-NL": function() {
  return import("./nl-NL-6Pdg4pAO.js");
}, "no-NO": function() {
  return import("./no-NO-6QYZoL6o.js");
}, "pl-PL": function() {
  return import("./pl-PL-Du78jlBr.js");
}, "pt-BR": function() {
  return import("./pt-BR-CdUFc6lv.js");
}, "pt-PT": function() {
  return import("./pt-PT-_uvDIHob.js");
}, "ro-RO": function() {
  return import("./ro-RO-bzYGcBVk.js");
}, "ru-RU": function() {
  return import("./ru-RU-CnAeaOrj.js");
}, "sk-SK": function() {
  return import("./sk-SK-CDUHZL3W.js");
}, "sl-SI": function() {
  return import("./sl-SI-BmvYVTxr.js");
}, "sv-SE": function() {
  return import("./sv-SE-BZvSszl5.js");
}, "zh-CN": function() {
  return import("./zh-CN-BHCZN1k1.js");
}, "zh-TW": function() {
  return import("./zh-TW-D6AsUpDg.js");
} };
function ZH(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function DP(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = ZH(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = ZH(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var YH = function(e) {
  return e.toLowerCase().substring(0, 2);
};
function rO(e) {
  var t = e.replace("_", "-");
  if (new RegExp("([a-z]{2})([-])([A-Z]{2})").test(t)) return t;
  var n = t.split("-"), r = ze(n, 2), a = r[0], o = r[1];
  if (!a || !o) return null;
  var s = [a.toLowerCase(), o.toUpperCase()].join("-");
  return s.length === 5 ? s : null;
}
function aO(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  if (!e || e.length < 1 || e.length > 5) return n6;
  var n = rO(e);
  return ka(t).call(t, n) > -1 ? n : function(r, a) {
    return r && typeof r == "string" && Ji(a).call(a, function(o) {
      return YH(o) === YH(r);
    }) || null;
  }(n || e, t);
}
var LP = function(e, t) {
  return e.replace(/%{(\w+)}/g, function(n, r) {
    return t[r] || "";
  });
}, IWe = function() {
  var e = On(yt.mark(function t(n) {
    var r, a, o, s = arguments;
    return yt.wrap(function(c) {
      for (; ; ) switch (c.prev = c.next) {
        case 0:
          return r = s.length > 1 && s[1] !== void 0 ? s[1] : {}, a = aO(n, Pe(nO)) || n6, c.next = 4, nO[a]();
        case 4:
          return o = c.sent, c.abrupt("return", DP(DP(DP({}, moe), o.default), !!r[n] && r[n]));
        case 6:
        case "end":
          return c.stop();
      }
    }, t);
  }));
  return function(t) {
    return e.apply(this, arguments);
  };
}(), voe = function(e, t) {
  var n = e.split(/%#(.*?)%#/gm);
  if (t.length !== Math.floor(n.length / 2)) throw Error("The number of functions provided does not match the number of elements in the translation string.");
  return It(n).call(n, function(r, a) {
    var o = Math.floor(a / 2);
    return a % 2 == 0 ? r : t[o](r);
  });
}, kWe = { IDR: 1, JPY: 1, KRW: 1, VND: 1, BYR: 1, CVE: 1, DJF: 1, GHC: 1, GNF: 1, KMF: 1, PYG: 1, RWF: 1, UGX: 1, VUV: 1, XAF: 1, XOF: 1, XPF: 1, MRO: 10, BHD: 1e3, IQD: 1e3, JOD: 1e3, KWD: 1e3, OMR: 1e3, LYD: 1e3, TND: 1e3 }, XH = { RSD: { minimumFractionDigits: 2 }, AFN: { minimumFractionDigits: 2 }, ALL: { minimumFractionDigits: 2 }, IRR: { minimumFractionDigits: 2 }, LAK: { minimumFractionDigits: 2 }, LBP: { minimumFractionDigits: 2 }, MMK: { minimumFractionDigits: 2 }, SOS: { minimumFractionDigits: 2 }, SYP: { minimumFractionDigits: 2 }, YER: { minimumFractionDigits: 2 }, IQD: { minimumFractionDigits: 3 } };
function KH(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $P(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = KH(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = KH(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var P8 = function(e, t) {
  var n = function(r) {
    return kWe[r] || 100;
  }(t);
  return Ou(String(e), 10) / n;
};
function qH(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function JH(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = qH(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = qH(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var jP, AWe = Intl.DateTimeFormat, goe = function() {
  function e() {
    var t, n, r = this, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : n6, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Qe(this, e), T(this, "supportedLocales", void 0), T(this, "locale", void 0), T(this, "languageCode", void 0), T(this, "translations", moe), T(this, "customTranslations", void 0), T(this, "loaded", void 0), T(this, "timeFormatOptions", { hour: "numeric", minute: "numeric" }), T(this, "timeAndDateFormatOptions", JH({ year: "numeric", month: "2-digit", day: "2-digit" }, this.timeFormatOptions)), T(this, "timeAndDateFormatter", void 0);
    var s = Pe(nO);
    this.customTranslations = function() {
      var m, v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, y = arguments.length > 1 ? arguments[1] : void 0;
      return rr(m = Pe(v)).call(m, function(b, S) {
        var x = rO(S) || aO(S, y);
        return x && (b[x] = v[S]), b;
      }, {});
    }(o, s);
    var c = Pe(this.customTranslations);
    this.supportedLocales = Oe(t = je(n = []).call(n, Pn(s), Pn(c))).call(t, function(m, v, y) {
      return ka(y).call(y, m) === v;
    }), this.locale = rO(a) || aO(a, this.supportedLocales) || n6;
    var u = this.locale.split("-"), f = ze(u, 1)[0];
    this.languageCode = f, this.timeAndDateFormatter = AWe(this.locale, this.timeAndDateFormatOptions), this.loaded = IWe(this.locale, this.customTranslations).then(function(m) {
      r.translations = m;
    });
  }
  return et(e, [{ key: "get", value: function(t, n) {
    var r = function(a, o) {
      var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : { values: {}, count: 0 }, c = "".concat(o, "__plural"), u = function(f) {
        var m;
        return je(m = "".concat(o, "__")).call(m, f);
      };
      return Object.prototype.hasOwnProperty.call(a, u(s.count)) ? LP(a[u(s.count)], gd(s)) : Object.prototype.hasOwnProperty.call(a, c) && s.count > 1 ? LP(a[c], gd(s)) : Object.prototype.hasOwnProperty.call(a, o) ? LP(a[o], gd(s)) : null;
    }(this.translations, t, n);
    return r !== null ? r : t;
  } }, { key: "amount", value: function(t, n, r) {
    return function(a, o, s) {
      var c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, u = a.toString(), f = P8(u, s), m = o.replace("_", "-"), v = XH[s] ? $P($P({}, c), XH[s]) : c, y = $P({ style: "currency", currency: s, currencyDisplay: "symbol" }, v);
      try {
        return f.toLocaleString(m, y);
      } catch (b) {
        return u;
      }
    }(t, this.locale, n, r);
  } }, { key: "date", value: function(t) {
    if (t === void 0) return "";
    var n = JH({ year: "numeric", month: "2-digit", day: "2-digit" }, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {});
    return new Date(t).toLocaleDateString(this.locale, n);
  } }, { key: "dateTime", value: function(t) {
    return t === void 0 ? "" : this.timeAndDateFormatter.format(new Date(t));
  } }]), e;
}(), yc = function(e, t) {
  var n = t.split(".");
  return rr(n).call(n, function(r, a) {
    return r && r[a] ? r[a] : void 0;
  }, e);
}, PWe = et(function e() {
  var t = this;
  Qe(this, e), T(this, "events", {}), T(this, "on", function(n, r) {
    t.events[n] = t.events[n] || [], t.events[n].push(r);
  }), T(this, "off", function(n, r) {
    var a;
    t.events[n] && (t.events[n] = rr(a = t.events[n]).call(a, function(o, s) {
      return s !== r && o.push(s), o;
    }, []));
  }), T(this, "emit", function(n, r) {
    var a;
    t.events[n] && Q(a = t.events[n]).call(a, function(o) {
      o(r);
    });
  });
});
function F2() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    var t = 16 * Math.random() | 0;
    return (e == "x" ? t : 3 & t | 8).toString(16);
  });
}
var QH = "v3/analytics", ZS = "log", eW = "error", h0 = "info", oO = "action", iO = "submit", N8 = "selected", e1 = "rendered", yoe = "displayed", boe = "input", _oe = "download", sO = "validationError", BM = "focus", VM = "unfocus", lO = "configured", Coe = "instant_payment_button", tW = "list", woe = "ApiError", Soe = "web_700", nW = (T(T(T(T(T(T(T(T(T(T(jP = {}, "error.va.sf-cc-num.02", "900"), "error.va.sf-cc-num.04", "901"), "error.va.sf-cc-num.01", "902"), "error.va.sf-cc-num.03", "903"), "error.va.sf-cc-dat.04", "910"), "error.va.sf-cc-dat.05", "911"), "error.va.sf-cc-dat.01", "912"), "error.va.sf-cc-dat.02", "913"), "error.va.sf-cc-dat.03", "914"), "error.va.sf-cc-mth.01", "915"), T(T(T(T(T(T(T(T(T(T(jP, "error.va.sf-cc-yr.01", "917"), "error.va.sf-cc-yr.02", "918"), "error.va.sf-cc-cvc.01", "920"), "error.va.sf-cc-cvc.02", "921"), "creditCard.holderName.invalid", "925"), "boleto.socialSecurityNumber.invalid", "926"), "error.va.gen.01.country", "930"), "error.va.gen.01.street", "931"), "error.va.gen.01.house_number_or_name", "932"), "error.va.gen.01.postal_code", "933"), T(T(T(T(T(T(T(T(T(T(jP, "invalidFormatExpects.postal_code", "934"), "error.va.gen.01.city", "935"), "error.va.gen.01.state_or_province", "936"), "error.va.sf-kcp-pwd.01", "940"), "error.va.sf-kcp-pwd.02", "941"), "creditCard.taxNumber.invalid", "942"), "error.va.sf-ach-num.01", "945"), "error.va.sf-ach-num.02", "946"), "error.va.sf-ach-loc.01", "947"), "error.va.sf-ach-loc.02", "948")), rW = ["cart", "minicart", "pdp", "checkout"], aW = ["applicationInfo", "checkoutAttemptId"], qy = function(e) {
  return e.FINGERPRINT_DATA_SENT = "fingerprintDataSentWeb", e.FINGERPRINT_IFRAME_LOADED = "fingerprintIframeLoaded", e.FINGERPRINT_COMPLETED = "fingerprintCompleted", e.CHALLENGE_DATA_SENT = "challengeDataSentWeb", e.CHALLENGE_IFRAME_LOADED = "challengeIframeLoaded", e.CHALLENGE_COMPLETED = "challengeCompleted", e;
}({}), NWe = ["firstName", "lastName"];
function oW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ud(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = oW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = oW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var T8 = function() {
  function e(t) {
    var n;
    Qe(this, e), T(this, "_id", je(n = "".concat(this.constructor.type, "-")).call(n, F2())), T(this, "props", void 0), T(this, "state", void 0), T(this, "_node", void 0), T(this, "_component", void 0), T(this, "eventEmitter", new PWe()), T(this, "_parentInstance", void 0), T(this, "resources", void 0), this.props = this.formatProps(ud(ud({}, this.constructor.defaultProps), {}, { setStatusAutomatically: !0 }, t)), this._parentInstance = this.props._parentInstance, this._node = null, this.state = {}, this.resources = this.props.modules ? this.props.modules.resources : void 0;
  }
  return et(e, [{ key: "formatProps", value: function(t) {
    return t;
  } }, { key: "formatData", value: function() {
    return {};
  } }, { key: "setUpAnalytics", value: function(t) {
    return null;
  } }, { key: "submitAnalytics", value: function(t) {
    return null;
  } }, { key: "setState", value: function(t) {
    this.state = ud(ud({}, this.state), t);
  } }, { key: "data", get: function() {
    var t, n, r = yc(this.props, "modules.risk.data"), a = (t = yc(this.props, "modules.analytics.getEnabled")) === null || t === void 0 || !t() ? "do-not-track" : (n = yc(this.props, "modules.analytics.getCheckoutAttemptId")) === null || n === void 0 ? void 0 : n(), o = this.state.order || this.props.order, s = this.formatData();
    if (s.paymentMethod && a && (s.paymentMethod.checkoutAttemptId = a), this.props.type !== "riverty" && s.billingAddress) {
      var c = s.billingAddress;
      c.firstName, c.lastName;
      var u = pa(c, NWe);
      s.billingAddress = ud({}, u);
    }
    return ud(ud(ud(ud({}, r && { riskData: { clientData: r } }), o && { order: { orderData: o.orderData, pspReference: o.pspReference } }), s), {}, { clientStateDataIndicator: !0 });
  } }, { key: "render", value: function() {
    throw new Error("Payment method cannot be rendered.");
  } }, { key: "mount", value: function(t) {
    var n = this, r = typeof t == "string" ? document.querySelector(t) : t;
    if (!r) throw new Error("Component could not mount. Root node was not found.");
    var a, o = !this._node;
    return this._node && this.unmount(), this._node = r, this._component = this.render(), QA(this._component, r), o && this.props.modules && this.props.modules.analytics && this.setUpAnalytics({ containerWidth: r && r.offsetWidth, component: this.props.isDropin ? "dropin" : (a = this.constructor.analyticsType) !== null && a !== void 0 ? a : this.constructor.type, flavor: this.props.isDropin ? "dropin" : "components" }).then(function() {
      n.props.isDropin || n.submitAnalytics({ type: e1 });
    }), this;
  } }, { key: "update", value: function(t) {
    return this.props = this.formatProps(ud(ud({}, this.props), t)), this.state = {}, this.unmount().mount(this._node);
  } }, { key: "remount", value: function(t) {
    if (!this._node) throw new Error("Component is not mounted.");
    var n = t || this.render();
    return QA(n, this._node, null), this;
  } }, { key: "unmount", value: function() {
    return this._node && QA(null, this._node), this;
  } }, { key: "remove", value: function() {
    this.unmount(), this._parentInstance && this._parentInstance.remove(this);
  } }]), e;
}();
T(T8, "defaultProps", {});
var B2, go, FP, iW, ju = function(e) {
  var t = e.inline, n = t !== void 0 && t, r = e.size, a = r === void 0 ? "large" : r;
  return P("div", { "data-testid": "spinner", className: "adyen-checkout__spinner__wrapper ".concat(n ? "adyen-checkout__spinner__wrapper--inline" : "") }, P("div", { className: "adyen-checkout__spinner adyen-checkout__spinner--".concat(a) }));
}, p_ = 0, xoe = [], Qx = [], sW = fr.__b, lW = fr.__r, uW = fr.diffed, cW = fr.__c, dW = fr.unmount;
function Q_(e, t) {
  fr.__h && fr.__h(go, e, p_ || t), p_ = 0;
  var n = go.__H || (go.__H = { __: [], __h: [] });
  return e >= n.__.length && n.__.push({ __V: Qx }), n.__[e];
}
function Je(e) {
  return p_ = 1, Eoe(Ioe, e);
}
function Eoe(e, t, n) {
  var r = Q_(B2++, 2);
  if (r.t = e, !r.__c && (r.__ = [n ? n(t) : Ioe(void 0, t), function(c) {
    var u = r.__N ? r.__N[0] : r.__[0], f = r.t(u, c);
    u !== f && (r.__N = [f, r.__[1]], r.__c.setState({}));
  }], r.__c = go, !go.u)) {
    var a = function(c, u, f) {
      if (!r.__c.__H) return !0;
      var m = r.__c.__H.__.filter(function(y) {
        return y.__c;
      });
      if (m.every(function(y) {
        return !y.__N;
      })) return !o || o.call(this, c, u, f);
      var v = !1;
      return m.forEach(function(y) {
        if (y.__N) {
          var b = y.__[0];
          y.__ = y.__N, y.__N = void 0, b !== y.__[0] && (v = !0);
        }
      }), !(!v && r.__c.props === c) && (!o || o.call(this, c, u, f));
    };
    go.u = !0;
    var o = go.shouldComponentUpdate, s = go.componentWillUpdate;
    go.componentWillUpdate = function(c, u, f) {
      if (this.__e) {
        var m = o;
        o = void 0, a(c, u, f), o = m;
      }
      s && s.call(this, c, u, f);
    }, go.shouldComponentUpdate = a;
  }
  return r.__N || r.__;
}
function Rt(e, t) {
  var n = Q_(B2++, 3);
  !fr.__s && zM(n.__H, t) && (n.__ = e, n.i = t, go.__H.__h.push(n));
}
function UM(e, t) {
  var n = Q_(B2++, 4);
  !fr.__s && zM(n.__H, t) && (n.__ = e, n.i = t, go.__h.push(n));
}
function _n(e) {
  return p_ = 5, Qi(function() {
    return { current: e };
  }, []);
}
function Qi(e, t) {
  var n = Q_(B2++, 7);
  return zM(n.__H, t) ? (n.__V = e(), n.i = t, n.__h = e, n.__V) : n.__;
}
function Kt(e, t) {
  return p_ = 8, Qi(function() {
    return e;
  }, t);
}
function GM(e) {
  var t = go.context[e.__c], n = Q_(B2++, 9);
  return n.c = e, t ? (n.__ == null && (n.__ = !0, t.sub(go)), t.props.value) : e.__;
}
function TWe() {
  for (var e; e = xoe.shift(); ) if (e.__P && e.__H) try {
    e.__H.__h.forEach(e7), e.__H.__h.forEach(uO), e.__H.__h = [];
  } catch (t) {
    e.__H.__h = [], fr.__e(t, e.__v);
  }
}
fr.__b = function(e) {
  go = null, sW && sW(e);
}, fr.__r = function(e) {
  lW && lW(e), B2 = 0;
  var t = (go = e.__c).__H;
  t && (FP === go ? (t.__h = [], go.__h = [], t.__.forEach(function(n) {
    n.__N && (n.__ = n.__N), n.__V = Qx, n.__N = n.i = void 0;
  })) : (t.__h.forEach(e7), t.__h.forEach(uO), t.__h = [])), FP = go;
}, fr.diffed = function(e) {
  uW && uW(e);
  var t = e.__c;
  t && t.__H && (t.__H.__h.length && (xoe.push(t) !== 1 && iW === fr.requestAnimationFrame || ((iW = fr.requestAnimationFrame) || OWe)(TWe)), t.__H.__.forEach(function(n) {
    n.i && (n.__H = n.i), n.__V !== Qx && (n.__ = n.__V), n.i = void 0, n.__V = Qx;
  })), FP = go = null;
}, fr.__c = function(e, t) {
  t.some(function(n) {
    try {
      n.__h.forEach(e7), n.__h = n.__h.filter(function(r) {
        return !r.__ || uO(r);
      });
    } catch (r) {
      t.some(function(a) {
        a.__h && (a.__h = []);
      }), t = [], fr.__e(r, n.__v);
    }
  }), cW && cW(e, t);
}, fr.unmount = function(e) {
  dW && dW(e);
  var t, n = e.__c;
  n && n.__H && (n.__H.__.forEach(function(r) {
    try {
      e7(r);
    } catch (a) {
      t = a;
    }
  }), n.__H = void 0, t && fr.__e(t, n.__v));
};
var fW = typeof requestAnimationFrame == "function";
function OWe(e) {
  var t, n = function() {
    clearTimeout(r), fW && cancelAnimationFrame(t), setTimeout(e);
  }, r = setTimeout(n, 100);
  fW && (t = requestAnimationFrame(n));
}
function e7(e) {
  var t = go, n = e.__c;
  typeof n == "function" && (e.__c = void 0, n()), go = t;
}
function uO(e) {
  var t = go;
  e.__c = e.__(), go = t;
}
function zM(e, t) {
  return !e || e.length !== t.length || t.some(function(n, r) {
    return n !== e[r];
  });
}
function Ioe(e, t) {
  return typeof t == "function" ? t(e) : t;
}
var cO = "https://checkoutshopper-live.adyen.com/checkoutshopper/", RWe = ["resourceContext", "extension"];
function pW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function BP(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = pW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = pW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var koe = function() {
  function e() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : cO;
    Qe(this, e), T(this, "resourceContext", void 0), T(this, "returnImage", function(r) {
      var a, o, s, c, u, f, m = r.name, v = r.resourceContext, y = r.imageFolder, b = y === void 0 ? "" : y, S = r.parentFolder, x = S === void 0 ? "" : S, E = r.extension, N = r.size, R = N === void 0 ? "" : N, O = r.subFolder, D = O === void 0 ? "" : O;
      return je(a = je(o = je(s = je(c = je(u = je(f = "".concat(v, "images/")).call(f, b)).call(u, D)).call(c, x)).call(s, m)).call(o, R, ".")).call(a, E);
    }), T(this, "getImageUrl", function(r) {
      var a = r.resourceContext, o = a === void 0 ? cO : a, s = r.extension, c = s === void 0 ? "svg" : s, u = pa(r, RWe);
      return function(f) {
        var m = BP({ extension: c, resourceContext: o, imageFolder: "logos/", parentFolder: "", name: f }, u);
        return t.returnImage(m);
      };
    }), this.resourceContext = n;
  }
  return et(e, [{ key: "getImage", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.getImageUrl(BP(BP({}, t), {}, { resourceContext: this.resourceContext }));
  } }]), e;
}(), Aoe = IM({ i18n: new goe(), loadingContext: "", commonProps: {}, resources: new koe() });
function wt() {
  return GM(Aoe);
}
function MWe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var pu = function(e) {
  ft(n, yo);
  var t = MWe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "onClick", function(u) {
      u.preventDefault(), a.props.disabled || a.props.onClick(u, { complete: a.complete });
    }), T(Se(a), "complete", function() {
      var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1e3;
      a.setState({ completed: !0 }), Ro(function() {
        a.setState({ completed: !1 });
      }, u);
    }), a;
  }
  return et(n, [{ key: "render", value: function(r, a) {
    var o, s, c = r.classNameModifiers, u = c === void 0 ? [] : c, f = r.disabled, m = r.href, v = r.icon, y = r.inline, b = r.label, S = r.status, x = r.variant, E = a.completed, N = wt().i18n, R = v ? P("img", { className: "adyen-checkout__button__icon", src: v, alt: "", "aria-hidden": "true" }) : "", O = je(o = []).call(o, Pn(u), Pn(x !== "primary" ? [x] : []), Pn(y ? ["inline"] : []), Pn(E ? ["completed"] : []), Pn(S === "loading" || S === "redirect" ? ["loading"] : [])), D = Tt(je(s = ["adyen-checkout__button"]).call(s, Pn(It(O).call(O, function(G) {
      return "adyen-checkout__button--".concat(G);
    })))), $ = { loading: P(ju, { size: "medium" }), redirect: P("span", { className: "adyen-checkout__button__content" }, P(ju, { size: "medium", inline: !0 }), N.get("payButton.redirecting")), default: P("span", { className: "adyen-checkout__button__content" }, R, P("span", { className: "adyen-checkout__button__text" }, b)) }, B = $[S] || $.default;
    return m ? P("a", { className: D, href: m, disabled: f, target: this.props.target, rel: this.props.rel }, B) : P("button", { className: D, type: "button", disabled: f, onClick: this.onClick }, B, S !== "loading" && S !== "redirect" && this.props.children);
  } }]), n;
}();
T(pu, "defaultProps", { status: "default", variant: "primary", disabled: !1, label: "", inline: !1, target: "_self", onClick: function() {
} });
var Poe = function(e, t) {
  return t != null && t.value && t != null && t.currency ? e.amount(t.value, t.currency, { currencyDisplay: t.currencyDisplay || "symbol" }) : "";
}, HM = function(e, t) {
  var n;
  return je(n = "".concat(e.get("payButton"), " ")).call(n, Poe(e, t));
}, DWe = function(e) {
  var t = e.label;
  return P("span", { className: "checkout-secondary-button__text" }, t);
}, LWe = ["amount", "secondaryAmount", "classNameModifiers", "label"], ev = function(e) {
  var t, n = e.amount, r = e.secondaryAmount, a = e.classNameModifiers, o = a === void 0 ? [] : a, s = e.label, c = pa(e, LWe), u = wt().i18n, f = n && {}.hasOwnProperty.call(n, "value") && n.value === 0, m = f ? u.get("confirmPreauthorization") : HM(u, n), v = !f && !s && n && r && Pe(r).length ? function(y, b) {
    var S, x = b && b != null && b.value && b != null && b.currency ? y.amount(b.value, b.currency, { currencyDisplay: b.currencyDisplay || "symbol" }) : "", E = x.length ? "/ " : "";
    return je(S = "".concat(E)).call(S, x);
  }(u, r) : null;
  return P(pu, kt({}, c, { disabled: c.disabled || c.status === "loading", classNameModifiers: je(t = []).call(t, Pn(o), ["pay"]), label: s || m }), v && P(DWe, { label: v }));
}, hW = ["action", "resultCode", "sessionData", "order", "sessionResult"];
function $We(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var _r = function(e) {
  ft(n, e);
  var t = $We(n);
  function n(r, a, o) {
    var s;
    return Qe(this, n), s = t.call(this, a), T(Se(s), "cause", void 0), s.name = n.errorTypes[r], s.cause = o == null ? void 0 : o.cause, s;
  }
  return et(n);
}(f_(Error));
function Ir() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
  return Object.prototype.hasOwnProperty.call(e, t);
}
function mW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function m0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = mW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = mW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function jWe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(_r, "errorTypes", { NETWORK_ERROR: "NETWORK_ERROR", CANCEL: "CANCEL", IMPLEMENTATION_ERROR: "IMPLEMENTATION_ERROR", ERROR: "ERROR" });
var Dr = function(e) {
  ft(n, T8);
  var t = jWe(n);
  function n(r) {
    var a, o, s, c, u, f, m, v, y, b, S;
    return Qe(this, n), S = t.call(this, r), T(Se(S), "componentRef", void 0), T(Se(S), "elementRef", void 0), T(Se(S), "handleError", function(x) {
      S.setElementStatus("ready"), S.props.onError && S.props.onError(x, S.elementRef);
    }), T(Se(S), "handleAdditionalDetails", function(x) {
      return S.props.onAdditionalDetails ? S.props.onAdditionalDetails(x, S.elementRef) : S.props.session && S.submitAdditionalDetails(x.data), x;
    }), T(Se(S), "handleOrder", function(x) {
      S.updateParent({ order: x.order }), S.props.onPaymentCompleted && S.props.onPaymentCompleted(x, S.elementRef);
    }), T(Se(S), "handleFinalResult", function(x) {
      if (S.props.setStatusAutomatically) {
        var E = function(D) {
          switch (D.resultCode) {
            case "Authorised":
            case "Received":
            case "Pending":
              return ["success"];
            case "Cancelled":
            case "Error":
            case "Refused":
              return ["error"];
          }
        }(x), N = ze(E, 2), R = N[0], O = N[1];
        R && S.setElementStatus(R, O);
      }
      return S.props.onPaymentCompleted && S.props.onPaymentCompleted(x, S.elementRef), x;
    }), T(Se(S), "setComponentRef", function(x) {
      S.componentRef = x;
    }), T(Se(S), "payButton", function(x) {
      return P(ev, kt({}, x, { amount: S.props.amount, secondaryAmount: S.props.secondaryAmount, onClick: S.submit }));
    }), S.submit = pn(a = S.submit).call(a, Se(S)), S.setState = pn(o = S.setState).call(o, Se(S)), S.onValid = pn(s = S.onValid).call(s, Se(S)), S.onComplete = pn(c = S.onComplete).call(c, Se(S)), S.onSubmit = pn(u = S.onSubmit).call(u, Se(S)), S.handleAction = pn(f = S.handleAction).call(f, Se(S)), S.handleOrder = pn(m = S.handleOrder).call(m, Se(S)), S.handleResponse = pn(v = S.handleResponse).call(v, Se(S)), S.setElementStatus = pn(y = S.setElementStatus).call(y, Se(S)), S.submitAnalytics = pn(b = S.submitAnalytics).call(b, Se(S)), S.elementRef = r && r.elementRef || Se(S), S;
  }
  return et(n, [{ key: "setState", value: function(r) {
    this.state = m0(m0({}, this.state), r), this.onChange();
  } }, { key: "onChange", value: function() {
    var r = this.isValid, a = { data: this.data, errors: this.state.errors, valid: this.state.valid, isValid: r };
    return this.props.onChange && this.props.onChange(a, this.elementRef), r && this.onValid(), a;
  } }, { key: "setUpAnalytics", value: function(r) {
    var a, o = (a = this.props.session) === null || a === void 0 ? void 0 : a.id;
    return this.props.modules.analytics.setUp(m0(m0({}, r), o && { sessionId: o }));
  } }, { key: "submitAnalytics", value: function(r, a) {
    var o, s = this.constructor.analyticsType;
    s || (s = this.constructor.type === "scheme" || this.constructor.type === "bcmc" ? this.constructor.type : this.props.type), (o = this.props.modules) === null || o === void 0 || o.analytics.sendAnalytics(s, r, a);
  } }, { key: "onSubmit", value: function() {
    var r = this;
    if (this.props.isInstantPayment && this.elementRef.closeActivePaymentMethod(), this.props.setStatusAutomatically && this.setElementStatus("loading"), this.props.onSubmit) this.submitAnalytics({ type: iO }), this.props.onSubmit({ data: this.data, isValid: this.isValid }, this.elementRef);
    else if (this._parentInstance.session) {
      var a = this.props.beforeSubmit ? new Yt(function(o, s) {
        return r.props.beforeSubmit(r.data, r.elementRef, { resolve: o, reject: s });
      }) : Yt.resolve(this.data);
      a.then(function(o) {
        return r.submitAnalytics({ type: iO }), r.submitPayment(o);
      }).catch(function() {
        r.elementRef.setStatus("ready");
      });
    } else this.handleError(new _r("IMPLEMENTATION_ERROR", "Could not submit the payment"));
  } }, { key: "onValid", value: function() {
    var r = { data: this.data };
    return this.props.onValid && this.props.onValid(r, this.elementRef), r;
  } }, { key: "onComplete", value: function(r) {
    this.props.onComplete && this.props.onComplete(r, this.elementRef);
  } }, { key: "submit", value: function() {
    this.isValid ? this.onSubmit() : this.showValidation();
  } }, { key: "showValidation", value: function() {
    return this.componentRef && this.componentRef.showValidation && this.componentRef.showValidation(), this;
  } }, { key: "setElementStatus", value: function(r, a) {
    var o;
    return (o = this.elementRef) === null || o === void 0 || o.setStatus(r, a), this;
  } }, { key: "setStatus", value: function(r, a) {
    var o;
    return (o = this.componentRef) !== null && o !== void 0 && o.setStatus && this.componentRef.setStatus(r, a), this;
  } }, { key: "submitPayment", value: function(r) {
    var a = this;
    return this._parentInstance.session.submitPayment(r).then(this.handleResponse).catch(function(o) {
      return a.handleError(o);
    });
  } }, { key: "submitAdditionalDetails", value: function(r) {
    return this._parentInstance.session.submitDetails(r).then(this.handleResponse).catch(this.handleError);
  } }, { key: "handleAction", value: function(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!r || !r.type)
      throw Ir(r, "action") && Ir(r, "resultCode") ? new Error('handleAction::Invalid Action - the passed action object itself has an "action" property and a "resultCode": have you passed in the whole response object by mistake?') : new Error('handleAction::Invalid Action - the passed action object does not have a "type" property');
    var o = this._parentInstance.createFromAction(r, m0(m0(m0({}, this.elementRef.props), a), {}, { onAdditionalDetails: this.handleAdditionalDetails }));
    return o ? (this.unmount(), o.mount(this._node)) : null;
  } }, { key: "handleResponse", value: function(r) {
    var a, o = function(s) {
      var c, u = [], f = rr(c = Pe(s)).call(c, function(m, v) {
        return jt(hW).call(hW, v) ? m[v] = s[v] : u.push(v), m;
      }, {});
      return u.length && console.warn("The following properties should not be passed to the client: ".concat(u.join(", "))), f;
    }(r);
    o.action ? this.elementRef.handleAction(o.action) : ((a = o.order) === null || a === void 0 || (a = a.remainingAmount) === null || a === void 0 ? void 0 : a.value) > 0 ? this.handleOrder(o) : this.elementRef.handleFinalResult(o);
  } }, { key: "updateParent", value: function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.elementRef._parentInstance.update(r);
  } }, { key: "isValid", get: function() {
    return !1;
  } }, { key: "icon", get: function() {
    var r, a = this.props.paymentMethodType || this.type;
    return (r = this.props.icon) !== null && r !== void 0 ? r : this.resources.getImage()(a);
  } }, { key: "displayName", get: function() {
    return this.props.name || this.constructor.type;
  } }, { key: "additionalInfo", get: function() {
    return null;
  } }, { key: "accessibleName", get: function() {
    return this.displayName;
  } }, { key: "type", get: function() {
    return this.props.type || this.constructor.type;
  } }]), n;
}();
function FWe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var eC = function(e) {
  ft(n, yo);
  var t = FWe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "iframeEl", void 0), a;
  }
  return et(n, [{ key: "iframeOnLoad", value: function() {
    this.props.callback && typeof this.props.callback == "function" && this.props.callback(this.iframeEl.contentWindow);
  } }, { key: "componentDidMount", value: function() {
    var r;
    if (this.iframeEl.addEventListener) this.iframeEl.addEventListener("load", pn(r = this.iframeOnLoad).call(r, this), !1);
    else if (this.iframeEl.attachEvent) {
      var a;
      this.iframeEl.attachEvent("onload", pn(a = this.iframeOnLoad).call(a, this));
    } else {
      var o;
      this.iframeEl.onload = pn(o = this.iframeOnLoad).call(o, this);
    }
  } }, { key: "componentWillUnmount", value: function() {
    var r;
    if (this.iframeEl.removeEventListener) this.iframeEl.removeEventListener("load", pn(r = this.iframeOnLoad).call(r, this), !1);
    else if (this.iframeEl.detachEvent) {
      var a;
      this.iframeEl.detachEvent("onload", pn(a = this.iframeOnLoad).call(a, this));
    } else this.iframeEl.onload = null;
  } }, { key: "render", value: function(r) {
    var a = this, o = r.name, s = r.src, c = r.width, u = r.height, f = r.minWidth, m = r.minHeight, v = r.allow, y = r.title, b = r.classNameModifiers, S = Oe(b).call(b, function(x) {
      return !!x;
    });
    return P("iframe", { ref: function(x) {
      a.iframeEl = x;
    }, allow: v, className: Tt("adyen-checkout__iframe", "adyen-checkout__iframe--".concat(o), S.length && It(b).call(b, function(x) {
      var E;
      return je(E = "adyen-checkout__iframe--".concat(o, "-")).call(E, x);
    })), name: o, src: s, width: c, height: u, frameBorder: "0", title: y, referrerpolicy: "origin", "min-width": f, "min-height": m });
  } }]), n;
}();
T(eC, "defaultProps", { width: "0", height: "0", minWidth: "0", minHeight: "0", src: null, allow: null, title: "components iframe", classNameModifiers: [] });
var WM = function(e, t, n) {
  var r, a = new Yt(function(o, s) {
    r = Ro(function() {
      s(n);
    }, e), t.then(function(c) {
      clearTimeout(r), o(c);
    }).catch(function(c) {
      clearTimeout(r), s(c);
    });
  });
  return { promise: a, cancel: function() {
    clearTimeout(r);
  } };
}, O8 = "deviceFingerprint", BWe = { result: { type: O8, value: "df-timedOut" }, errorCode: "timeout" }, VWe = "unknownError", vW = { timeout: "iframe loading timed out", wrongOrigin: "Result did not come from the expected origin", wrongDataType: "Result data was not of the expected type", missingProperty: "Result data did not contain the expected properties", unknownError: "An unknown error occurred" }, ZM = function(e, t, n, r) {
  return function(a) {
    var o = {};
    if ((a.origin || a.originalEvent.origin) !== e) return "Message was not sent from the expected domain";
    if (typeof a.data != "string") return "Event data was not of type string";
    if (!a.data.length) return "Invalid event data string";
    try {
      var s = JSON.parse(a.data);
      if (!Ir(s, "type") || s.type !== r) return "Event data was not of expected type";
      t(s);
    } catch (c) {
      return o.type = "".concat(r, "-JSON-parse-error"), o.comment = "failed to JSON parse event.data", o.extraInfo = "event.data = ".concat(a.data), o.eventDataRaw = a.data, console.debug("get-process-message-handler::CATCH::Un-parseable JSON:: parseErrorObj=", o), !1;
    }
    return !0;
  };
}, YM = function(e) {
  var t, n, r, a = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/.exec(e);
  if (!a) return null;
  var o = ze(a, 5), s = o[1], c = o[2], u = o[3], f = o[4];
  return s && c && u ? je(t = je(n = je(r = "".concat(s, ":")).call(r, c)).call(n, u)).call(t, f ? ":".concat(f) : "") : null;
};
function UWe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var GWe = function(e) {
  ft(n, yo);
  var t = UWe(n);
  function n(r) {
    var a;
    return Qe(this, n), a = t.call(this, r), T(Se(a), "postMessageDomain", void 0), T(Se(a), "processMessageHandler", void 0), T(Se(a), "deviceFingerPrintPromise", void 0), a.postMessageDomain = YM(a.props.loadingContext) || a.props.loadingContext, a;
  }
  return et(n, [{ key: "getDfpPromise", value: function() {
    var r = this;
    return new Yt(function(a, o) {
      r.processMessageHandler = ZM(r.postMessageDomain, a, 0, O8), window.addEventListener("message", r.processMessageHandler);
    });
  } }, { key: "componentDidMount", value: function() {
    var r = this;
    this.deviceFingerPrintPromise = WM(2e4, this.getDfpPromise(), BWe), this.deviceFingerPrintPromise.promise.then(function(a) {
      r.props.onCompleteFingerprint(a), window.removeEventListener("message", r.processMessageHandler);
    }).catch(function(a) {
      r.props.onErrorFingerprint(a), window.removeEventListener("message", r.processMessageHandler);
    });
  } }, { key: "render", value: function(r) {
    var a = r.dfpURL;
    return P("div", { className: "adyen-checkout-risk__device-fingerprint" }, P(eC, { name: "dfIframe", src: a, allow: "geolocation; microphone; camera;", title: "devicefingerprinting iframe" }));
  } }]), n;
}();
function zWe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Noe = function(e) {
  ft(n, yo);
  var t = zWe(n);
  function n(r) {
    var a, o, s;
    return Qe(this, n), a = t.call(this, r), r.clientKey && (a.state = { status: "retrievingFingerPrint", dfpURL: je(o = je(s = "".concat(a.props.loadingContext, "assets/html/")).call(s, r.clientKey, "/dfp.")).call(o, "1.0.0", ".html") }), a;
  }
  return et(n, [{ key: "setStatusComplete", value: function(r) {
    var a = this;
    this.setState({ status: "complete" }, function() {
      a.props.onComplete(r);
    });
  } }, { key: "render", value: function(r, a) {
    var o = this, s = r.loadingContext, c = a.dfpURL;
    return this.state.status === "retrievingFingerPrint" ? P("div", { className: "adyen-checkout-risk__device-fingerprint--wrapper", style: { position: "absolute", width: 0, height: 0 } }, P(GWe, { loadingContext: s, dfpURL: c, onCompleteFingerprint: function(u) {
      o.setStatusComplete(u);
    }, onErrorFingerprint: function(u) {
      var f;
      o.props.onError({ errorCode: f = u.errorCode, message: vW[f] || vW[VWe], type: O8 }), o.setStatusComplete(u.result);
    } })) : null;
  } }]), n;
}();
T(Noe, "defaultProps", { onComplete: function() {
}, onError: function() {
} });
var tC = { decode: function(e) {
  if (!tC.isBase64(e)) return { success: !1, error: "not base64" };
  try {
    var t = (n = e, decodeURIComponent(It(Array.prototype).call(window.atob(n), function(r) {
      var a;
      return "%".concat(Xo(a = "00".concat(r.charCodeAt(0).toString(16))).call(a, -2));
    }).join("")));
    return { success: !0, data: t };
  } catch (r) {
    return { success: !1, error: "malformed URI sequence" };
  }
  var n;
}, encode: function(e) {
  return window.btoa(e);
}, isBase64: function(e) {
  if (!e || e.length % 4) return !1;
  try {
    return window.btoa(window.atob(e)) === e;
  } catch (t) {
    return !1;
  }
} };
function gW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function v0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = gW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = gW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function HWe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var dO = function(e) {
  ft(n, T8);
  var t = HWe(n);
  function n(r) {
    var a;
    Qe(this, n), a = t.call(this, r), T(Se(a), "nodeRiskContainer", null), T(Se(a), "onComplete", function(s) {
      var c = v0(v0({}, a.state.data), {}, T(T(T({}, s.type, s.value), "persistentCookie", s.persistentCookie), "components", s.components));
      a.setState({ data: c, isValid: !0 }), a.props.risk.onComplete(a.data), a.cleanUp();
    }), T(Se(a), "onError", function(s) {
      a.props.risk.onError(s), a.cleanUp();
    }), T(Se(a), "cleanUp", function() {
      a.nodeRiskContainer && a.nodeRiskContainer.parentNode && a.nodeRiskContainer.parentNode.removeChild(a.nodeRiskContainer);
    });
    var o = T({}, O8, null);
    return a.setState({ data: o }), a.props.risk.enabled === !0 && (document.querySelector(a.props.risk.node) ? (a.nodeRiskContainer = document.createElement("div"), document.querySelector(a.props.risk.node).appendChild(a.nodeRiskContainer), a.mount(a.nodeRiskContainer)) : a.onError({ message: "RiskModule node was not found" })), a;
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return v0(v0({}, r), {}, { risk: v0(v0({}, n.defaultProps.risk), r.risk) });
  } }, { key: "isValid", get: function() {
    return this.state.isValid;
  } }, { key: "data", get: function() {
    if (this.isValid) {
      var r = v0({ version: "1.0.0" }, this.state.data);
      return tC.encode(Pc(r));
    }
    return !1;
  } }, { key: "componentWillUnmount", value: function() {
    this.cleanUp();
  } }, { key: "render", value: function() {
    return P(Noe, kt({}, this.props, { loadingContext: this.props.loadingContext, onComplete: this.onComplete, onError: this.onError }));
  } }]), n;
}();
function tv(e) {
  var t, n = e.children, r = e.classNameModifiers, a = r === void 0 ? [] : r, o = e.label, s = e.readonly, c = s !== void 0 && s, u = wt().i18n;
  return P("fieldset", { className: Tt(je(t = ["adyen-checkout__fieldset"]).call(t, Pn(It(a).call(a, function(f) {
    return "adyen-checkout__fieldset--".concat(f);
  })), [{ "adyen-checkout__fieldset--readonly": c }])) }, o && P("legend", { className: "adyen-checkout__fieldset__title" }, u.get(o)), P("div", { className: "adyen-checkout__fieldset__fields" }, n));
}
function oa() {
  var e = wt().resources;
  return Kt(function(t) {
    return e == null ? void 0 : e.getImage(t);
  }, []);
}
T(dO, "type", "risk"), T(dO, "defaultProps", { risk: { enabled: !0, onComplete: function() {
}, onError: function() {
}, node: "body" } });
var VP, h_ = function(e) {
  var t, n = e.type, r = e.className, a = r === void 0 ? "" : r, o = e.alt, s = o === void 0 ? "" : o, c = e.height, u = e.width, f = (t = oa()({ imageFolder: "components/" })) === null || t === void 0 ? void 0 : t(n);
  return P("img", { className: Tt("adyen-checkout__icon", a), alt: s, src: f, height: c, width: u });
}, Or = "encryptedCardNumber", Jr = "encryptedExpiryDate", ro = "encryptedExpiryMonth", Ca = "encryptedExpiryYear", Fr = "encryptedSecurityCode", yd = "encryptedPassword", Jy = "encryptedBankAccountNumber", Qy = "encryptedBankLocationId", UP = "encryptedSecurityCode3digits", GP = "encryptedSecurityCode4digits", r6 = "giftcard", x4 = ["amex", "mc", "visa"], yW = ["ach", r6], $y = [Or, Jr, ro, Ca, Fr, yd], WWe = [Jy, Qy], xm = je($y).call($y, WWe), bW = ["bcmc"], Toe = "required", XM = "optional", KM = "hidden", jm = Toe, m_ = XM, v_ = KM, jp = Toe, g_ = XM, y2 = KM, Ooe = "data-cse", Roe = "data-info", Moe = "data-uid", Z4 = ["accel", "pulse", "star", "nyce"], ZWe = { visa: "VISA", mc: "MasterCard", amex: "American Express", discover: "Discover", cup: "China Union Pay", jcb: "JCB", diners: "Diners Club", maestro: "Maestro", bcmc: "Bancontact card", bijcard: "de Bijenkorf Card" }, F0 = "-ariaError", B0 = "incomplete field", qM = "Unsupported card entered", Doe = "Card number field empty", Loe = "Expiry date field empty", $oe = "Expiry year field empty", joe = "Expiry month field empty", Foe = "Security code field empty", Boe = "KCP password field empty", Voe = "ACH bank account field empty", Uoe = "ACH bank location field empty", hi = (T(T(T(T(T(T(T(T(T(T(VP = {}, B0, "error.va.gen.01"), "field not valid", "error.va.gen.02"), "luhn check failed", "error.va.sf-cc-num.01"), Doe, "error.va.sf-cc-num.02"), qM, "error.va.sf-cc-num.03"), "Card number not filled correctly", "error.va.sf-cc-num.04"), "Card too old", "error.va.sf-cc-dat.01"), "Date too far in future", "error.va.sf-cc-dat.02"), "Your card expires before check out date", "error.va.sf-cc-dat.03"), Loe, "error.va.sf-cc-dat.04"), T(T(T(T(T(T(T(T(T(T(VP, "Expiry date not filled correctly", "error.va.sf-cc-dat.05"), $oe, "error.va.sf-cc-yr.01"), "Expiry year not filled correctly", "error.va.sf-cc-yr.02"), joe, "error.va.sf-cc-mth.01"), Foe, "error.va.sf-cc-cvc.01"), "Security code not filled correctly", "error.va.sf-cc-cvc.02"), Boe, "error.va.sf-kcp-pwd.01"), "KCP password not filled correctly", "error.va.sf-kcp-pwd.02"), Voe, "error.va.sf-ach-num.01"), "ACH bank account not filled correctly", "error.va.sf-ach-num.02"), T(T(VP, Uoe, "error.va.sf-ach-loc.01"), "ACH bank location id not filled correctly", "error.va.sf-ach-loc.02")), YWe = hi[B0], XWe = T(T(T(T(T(T(T(T({}, Or, hi[Doe]), Jr, hi[Loe]), ro, hi[joe]), Ca, hi[$oe]), Fr, hi[Foe]), yd, hi[Boe]), Jy, hi[Voe]), Qy, hi[Uoe]), R8 = "focusField", JM = "notValidating:blurScenario", _W = m2(), QM = function() {
  var e;
  return _W += 1, je(e = "".concat(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "field", "-")).call(e, _W);
};
function CW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function wW(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = CW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = CW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var xn = function(e) {
  var t = e.children, n = e.className, r = e.classNameModifiers, a = e.dir, o = e.disabled, s = e.errorMessage, c = e.helper, u = e.inputWrapperModifiers, f = e.isLoading, m = e.isValid, v = e.label, y = e.labelEndAdornment, b = e.name, S = e.onBlur, x = e.onFieldBlur, E = e.onFocus, N = e.onFocusField, R = e.showValidIcon, O = e.useLabelElement, D = e.addContextualElement, $ = e.filled, B = e.focused, G = e.i18n, Z = e.errorVisibleToScreenReader, K = e.renderAlternativeToLabel, q = Z == null || Z, pe = _n(QM("adyen-checkout-".concat(b))), he = Je(!1), _e = ze(he, 2), ge = _e[0], Y = _e[1], ee = Je(!1), oe = ze(ee, 2), me = oe[0], xe = oe[1];
  B != null && Y(!!B), $ != null && xe(!!$);
  var X = Kt(function(Le) {
    Y(!0), E == null || E(Le);
  }, [E]), ye = Kt(function(Le) {
    Y(!1), S == null || S(Le), x == null || x(Le);
  }, [S, x]), ce = Kt(function() {
    return P(ra, null, typeof v == "string" && P("span", { className: Tt({ "adyen-checkout__label__text": !0, "adyen-checkout__label__text--error": s }), "data-id": b }, v), typeof v == "function" && v(), y && P("span", { className: "adyen-checkout__label-adornment--end" }, y), c && P("span", { className: "adyen-checkout__helper-text" }, c));
  }, [v, s, y, c]), se = Kt(function() {
    var Le, ie, $e;
    return P(ra, null, P("div", { className: Tt(je(Le = ["adyen-checkout__input-wrapper"]).call(Le, Pn(It(u).call(u, function(we) {
      return "adyen-checkout__input-wrapper--".concat(we);
    })))), dir: a }, It(ie = xM(t)).call(ie, function(we) {
      var Ne = wW(wW({ isValid: m, onFocusHandler: X, onBlurHandler: ye, isInvalid: !!s }, b && { uniqueId: pe.current }), {}, { addContextualElement: D });
      return EMe(we, Ne);
    }), f && P("span", { className: "adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--loading" }, P(ju, { size: "small" })), m && R !== !1 && P("span", { className: "adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--valid" }, P(h_, { type: "checkmark", alt: G == null ? void 0 : G.get("field.valid") })), s && P("span", { className: "adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--invalid" }, P(h_, { type: "field_error", alt: G == null ? void 0 : G.get("error.title") }))), D && P("span", kt({ className: "adyen-checkout__error-text" }, q && { id: je($e = "".concat(pe.current)).call($e, F0) }, { "aria-hidden": q ? null : "true" }), s && typeof s == "string" && s.length ? s : null));
  }, [t, s, f, m, X, ye]), Ie = Kt(function(Le) {
    var ie = Le.onFocusField, $e = Le.focused, we = Le.filled, Ne = Le.disabled, Ee = Le.name, le = Le.uniqueId, be = Le.useLabelElement, He = Le.isSecuredField, Ae = Le.children, it = Le.renderAlternativeToLabel, ut = { onClick: ie, className: Tt({ "adyen-checkout__label": !0, "adyen-checkout__label--focused": $e, "adyen-checkout__label--filled": we, "adyen-checkout__label--disabled": Ne }) };
    return be ? P("label", kt({}, ut, !He && { htmlFor: Ee && le }), Ae) : it(ut, Ae, le);
  }, []);
  return P("div", { className: Tt("adyen-checkout__field", n, It(r).call(r, function(Le) {
    return "adyen-checkout__field--".concat(Le);
  }), { "adyen-checkout__field--error": s, "adyen-checkout__field--valid": m }) }, P(Ie, { onFocusField: N, name: b, disabled: o, filled: me, focused: ge, useLabelElement: O, uniqueId: pe.current, isSecuredField: !q, renderAlternativeToLabel: K }, ce()), se());
};
xn.defaultProps = { className: "", classNameModifiers: [], inputWrapperModifiers: [], useLabelElement: !0, addContextualElement: !0, renderAlternativeToLabel: function() {
  return null;
} };
var KWe = function(e) {
  var t = e.data, n = t.name, r = t.registrationNumber;
  return P(tv, { classNameModifiers: ["companyDetails"], label: "companyDetails", readonly: !0 }, n && "".concat(n, " "), r && "".concat(r, " "));
}, qWe = function(e, t, n, r) {
  var a, o;
  if ((a = e[n]) !== null && a !== void 0 && (a = a[t]) !== null && a !== void 0 && a.formatterFn) return null;
  var s = (o = e[n]) === null || o === void 0 || (o = o[t]) === null || o === void 0 ? void 0 : o.maxlength;
  return s || 30;
}, ul = function(e) {
  return !(e != null && !/^[\s]*$/.test(e));
}, eD = "?\\+_=!@#$%^&*(){}~<>\\[\\]\\\\", _m = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "g";
  return new RegExp("[".concat(e, "]"), t);
};
(function(e, t) {
  var n;
  new RegExp(je(n = "^[".concat("^")).call(n, e, "]+$"));
})(eD);
var Goe = { default: { validate: function(e) {
  return e && e.length > 0;
}, modes: ["blur"], errorMessage: "error.va.gen.01" }, name: { validate: function(e) {
  return !ul(e) || null;
}, errorMessage: "companyDetails.name.invalid", modes: ["blur"] }, registrationNumber: { validate: function(e) {
  return !ul(e) || null;
}, errorMessage: "companyDetails.registrationNumber.invalid", modes: ["blur"] } };
function SW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zP(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = SW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = SW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var JWe = function(e) {
  var t = e.name, n = e.registrationNumber;
  return zP({}, (t || n) && { company: zP(zP({}, t && { name: t }), n && { registrationNumber: n }) });
}, fO = function() {
  function e(t, n, r, a) {
    var o;
    Qe(this, e), T(this, "shouldValidate", void 0), T(this, "isValid", void 0), T(this, "errorMessage", void 0), this.shouldValidate = jt(o = t.modes).call(o, r), this.isValid = t.validate(n, a), this.errorMessage = t.errorMessage;
  }
  return et(e, [{ key: "hasError", value: function() {
    return arguments.length > 0 && arguments[0] !== void 0 && arguments[0] ? !this.isValid && this.shouldValidate : this.isValid != null && !this.isValid && this.shouldValidate;
  } }]), e;
}();
function xW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function EW(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = xW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = xW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var QWe = function() {
  function e(t) {
    Qe(this, e), T(this, "validationResults", void 0), this.validationResults = t;
  }
  return et(e, [{ key: "isValid", get: function() {
    var t;
    return rr(t = this.validationResults).call(t, function(n, r) {
      return n && r.isValid;
    }, !0);
  } }, { key: "hasError", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
    return !!this.getError(t);
  } }, { key: "getError", value: function() {
    var t, n = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
    return Ji(t = this.validationResults).call(t, function(r) {
      return r.hasError(n);
    });
  } }, { key: "getAllErrors", value: function() {
    var t;
    return Oe(t = this.validationResults).call(t, function(n) {
      return n.hasError();
    });
  } }]), e;
}(), eZe = function() {
  function e(t) {
    Qe(this, e), T(this, "rules", { default: { validate: function() {
      return !0;
    }, modes: ["blur", "input"] } }), this.setRules(t);
  }
  return et(e, [{ key: "setRules", value: function(t) {
    this.rules = EW(EW({}, this.rules), t);
  } }, { key: "getRulesFor", value: function(t) {
    var n, r = (n = this.rules[t]) !== null && n !== void 0 ? n : this.rules.default;
    return E8(r) || (r = [r]), r;
  } }, { key: "validate", value: function(t, n) {
    var r = t.key, a = t.value, o = t.mode, s = o === void 0 ? "blur" : o, c = this.getRulesFor(r), u = It(c).call(c, function(f) {
      return new fO(f, a, s, n);
    });
    return new QWe(u);
  } }]), e;
}();
function IW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function yn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = IW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = IW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var gy = function(e, t) {
  var n, r;
  return rr(n = Oe(r = Pe(e)).call(r, function(a) {
    return !jt(t).call(t, a);
  })).call(n, function(a, o) {
    return a[o] = e[o], a;
  }, {});
}, HP = function(e, t, n, r, a) {
  return rr(t).call(t, function(o, s) {
    var c, u, f;
    return yn(yn({}, o), {}, T({}, s, (c = (u = (f = o[s]) !== null && f !== void 0 ? f : a == null ? void 0 : a[s]) !== null && u !== void 0 ? u : r == null ? void 0 : r[s]) !== null && c !== void 0 ? c : n));
  }, e);
};
function kW(e) {
  var t = e.schema, n = e.defaultData, r = e.processField, a = e.fieldProblems, o = function(c) {
    var u, f;
    if (n[c] === void 0) return { valid: !1, errors: null, data: null, fieldProblems: (u = a == null ? void 0 : a[c]) !== null && u !== void 0 ? u : null };
    var m = r({ key: c, value: n[c], mode: "blur" }, { state: { data: n } }), v = ze(m, 2), y = v[0], b = v[1];
    return { valid: b.isValid && !(a != null && a[c]) || !1, errors: b.hasError() ? b.getError() : null, data: y, fieldProblems: (f = a == null ? void 0 : a[c]) !== null && f !== void 0 ? f : null };
  }, s = rr(t).call(t, function(c, u) {
    var f = o(u), m = f.valid, v = f.errors, y = f.data, b = f.fieldProblems;
    return { valid: yn(yn({}, c.valid), {}, T({}, u, m)), errors: yn(yn({}, c.errors), {}, T({}, u, v)), data: yn(yn({}, c.data), {}, T({}, u, y)), fieldProblems: yn(yn({}, c.fieldProblems), {}, T({}, u, b)) };
  }, { data: {}, valid: {}, errors: {}, fieldProblems: {} });
  return { schema: t, data: s.data, valid: s.valid, errors: s.errors, fieldProblems: s.fieldProblems };
}
function gs(e) {
  var t = e.rules, n = t === void 0 ? {} : t, r = e.formatters, a = r === void 0 ? {} : r, o = e.defaultData, s = o === void 0 ? {} : o, c = e.fieldProblems, u = c === void 0 ? {} : c, f = e.schema, m = f === void 0 ? [] : f, v = Qi(function() {
    return new eZe(n);
  }, [n]), y = function(K, q) {
    var pe = K.key, he = K.value, _e = K.mode, ge = a == null ? void 0 : a[pe], Y = function(oe) {
      return oe && "formatterFn" in oe;
    }(ge) ? ge.formatterFn : ge, ee = Y && typeof Y == "function" ? Y(he != null ? he : "", q) : he;
    return [ee, v.validate({ key: pe, value: ee, mode: _e }, q)];
  }, b = Eoe(/* @__PURE__ */ function(K) {
    return function(q, pe) {
      var he = pe.type, _e = pe.key, ge = pe.value, Y = pe.mode, ee = pe.schema, oe = pe.defaultData, me = pe.formValue, xe = pe.selectedSchema, X = pe.fieldProblems, ye = xe || q.schema;
      switch (he) {
        case "setData":
          return yn(yn({}, q), {}, { data: yn(yn({}, q.data), {}, T({}, _e, ge)) });
        case "setValid":
          return yn(yn({}, q), {}, { valid: yn(yn({}, q.valid), {}, T({}, _e, ge)) });
        case "setErrors":
          return yn(yn({}, q), {}, { errors: yn(yn({}, q.errors), {}, T({}, _e, ge)) });
        case "setFieldProblems":
          var ce, se;
          return (ce = q == null || (se = q.schema) === null || se === void 0 ? void 0 : rr(se).call(se, function(At, Wt) {
            var Xr, Kn;
            return yn(yn({}, At), {}, { fieldProblems: yn(yn({}, q.fieldProblems), {}, T({}, Wt, (Xr = X == null ? void 0 : X[Wt]) !== null && Xr !== void 0 ? Xr : null)), valid: yn(yn({}, q.valid), {}, T({}, Wt, ((Kn = q.valid) === null || Kn === void 0 ? void 0 : Kn[Wt]) && !X[Wt])) });
          }, q)) !== null && ce !== void 0 ? ce : q;
        case "updateField":
          var Ie = K({ key: _e, value: ge, mode: Y }, { state: q }), Le = ze(Ie, 2), ie = Le[0], $e = Le[1], we = q.data[_e], Ne = yn({}, q.fieldProblems);
          return we !== ie && (Ne[_e] = null), yn(yn({}, q), {}, { data: yn(yn({}, q.data), {}, T({}, _e, ie)), errors: yn(yn({}, q.errors), {}, T({}, _e, $e.hasError() ? $e.getError() : null)), valid: yn(yn({}, q.valid), {}, T({}, _e, $e.isValid && !Ne[_e] || !1)), fieldProblems: Ne });
        case "mergeForm":
          var Ee, le = yn(yn({}, q), {}, { data: yn(yn({}, q.data), me.data), errors: yn(yn({}, q.errors), me.errors), valid: yn(yn({}, q.valid), me.valid), fieldProblems: yn(yn({}, q.fieldProblems), me.fieldProblems) });
          return le.valid && (le.isValid = $m(Ee = qje(le.valid)).call(Ee, function(At) {
            return At;
          })), le;
        case "setSchema":
          var be, He, Ae, it, ut = kW({ schema: ee, defaultData: oe, processField: K, fieldProblems: X }), St = Oe(be = q.schema).call(be, function(At) {
            return !jt(ee).call(ee, At);
          }), sn = Oe(ee).call(ee, function(At) {
            var Wt;
            return !jt(Wt = q.schema).call(Wt, At);
          }), zn = { data: gy(q.data, sn), errors: gy(q.errors, sn), valid: gy(q.valid, sn) }, dn = HP(gy(q.data, St), sn, null, ut.data, (He = q.local) === null || He === void 0 ? void 0 : He.data), $t = HP(gy(q.valid, St), sn, !1, ut.valid, (Ae = q.local) === null || Ae === void 0 ? void 0 : Ae.valid), qt = HP(gy(q.errors, St), sn, null, ut.errors, (it = q.local) === null || it === void 0 ? void 0 : it.errors);
          return yn(yn({}, q), {}, { schema: ee, data: dn, valid: $t, errors: qt, local: zn });
        case "validateForm":
          var fn = rr(ye).call(ye, function(At, Wt) {
            var Xr = K({ key: Wt, value: q.data[Wt], mode: "blur" }, { state: q }), Kn = ze(Xr, 2)[1];
            return { valid: yn(yn({}, At.valid), {}, T({}, Wt, Kn.isValid && !q.fieldProblems[Wt] || !1)), errors: yn(yn({}, At.errors), {}, T({}, Wt, Kn.hasError(!0) ? Kn.getError(!0) : null)) };
          }, { valid: q.valid, errors: q.errors });
          return yn(yn({}, q), {}, { valid: fn.valid, errors: fn.errors });
        default:
          throw new Error("Undefined useForm action");
      }
    };
  }(y), { defaultData: s, schema: m != null ? m : [], processField: y, fieldProblems: u }, kW), S = ze(b, 2), x = S[0], E = S[1], N = Qi(function() {
    var K;
    return rr(K = x.schema).call(K, function(q, pe) {
      return q && x.valid[pe];
    }, !0);
  }, [x.schema, x.valid]), R = Kt(function() {
    E({ type: "validateForm", selectedSchema: arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null });
  }, []), O = Kt(function(K, q) {
    return E({ type: "setErrors", key: K, value: q });
  }, []), D = Kt(function(K, q) {
    return E({ type: "setValid", key: K, value: q });
  }, []), $ = Kt(function(K, q) {
    return E({ type: "setData", key: K, value: q });
  }, []), B = Kt(function(K) {
    return E({ type: "setSchema", schema: K, defaultData: s });
  }, [x.schema]), G = Kt(function(K) {
    return E({ type: "mergeForm", formValue: K });
  }, []), Z = Kt(function(K) {
    return E({ type: "setFieldProblems", fieldProblems: K });
  }, [x.schema]);
  return Rt(function() {
    Z(u != null ? u : {});
  }, [Pc(u)]), { handleChangeFor: function(K, q) {
    return function(pe) {
      var he = function(_e, ge) {
        return ge.target ? ge.target.type === "checkbox" ? !x.data[_e] : ge.target.value : ge;
      }(K, pe);
      E({ type: "updateField", key: K, value: he, mode: q });
    };
  }, triggerValidation: R, setSchema: B, setData: $, setValid: D, setErrors: O, isValid: N, mergeForm: G, setFieldProblems: Z, schema: x.schema, valid: x.valid, errors: x.errors, data: x.data, fieldProblems: x.fieldProblems };
}
var tZe = ["setRef"], nZe = ["classNameModifiers", "uniqueId", "isInvalid", "isValid", "addContextualElement"];
function nC(e) {
  var t, n = e.setRef, r = pa(e, tZe), a = r.autoCorrect, o = r.classNameModifiers, s = r.isInvalid, c = r.isValid, u = r.readonly, f = u === void 0 ? null : u, m = r.spellCheck, v = r.type, y = r.uniqueId, b = r.disabled, S = r.className;
  Object.prototype.hasOwnProperty.call(r, "onChange") && console.error("Error: Form fields that rely on InputBase may not have an onChange property");
  var x = Kt(function(B) {
    r.onInput(B);
  }, [r.onInput]), E = Kt(function(B) {
    r != null && r.onKeyPress && r.onKeyPress(B);
  }, [r == null ? void 0 : r.onKeyPress]), N = Kt(function(B) {
    r != null && r.onKeyUp && r.onKeyUp(B);
  }, [r == null ? void 0 : r.onKeyUp]), R = Kt(function(B) {
    var G, Z, K;
    r == null || (G = r.onBlurHandler) === null || G === void 0 || G.call(r, B), r.trimOnBlur && (B.target.value = zp(K = B.target.value).call(K)), r == null || (Z = r.onBlur) === null || Z === void 0 || Z.call(r, B);
  }, [r.onBlur, r.onBlurHandler]), O = Kt(function(B) {
    var G;
    r == null || (G = r.onFocusHandler) === null || G === void 0 || G.call(r, B);
  }, [r.onFocusHandler]), D = Tt("adyen-checkout__input", ["adyen-checkout__input--".concat(v)], S, { "adyen-checkout__input--invalid": s, "adyen-checkout__input--valid": c }, It(o).call(o, function(B) {
    return "adyen-checkout__input--".concat(B);
  }));
  r.classNameModifiers, r.uniqueId, r.isInvalid, r.isValid, r.addContextualElement;
  var $ = pa(r, nZe);
  return P("input", kt({ id: y }, $, { "aria-required": $.required, type: v, className: D, readOnly: f, spellCheck: m, autoCorrect: a, "aria-describedby": je(t = "".concat(y)).call(t, F0), "aria-invalid": s, onInput: x, onBlur: R, onFocus: O, onKeyUp: N, onKeyPress: E, disabled: b, ref: n }));
}
function vi(e) {
  return P(nC, kt({ classNameModifiers: ["large"] }, e, { "aria-required": e.required, type: "text" }));
}
function AW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function PW(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = AW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = AW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
nC.defaultProps = { type: "text", classNameModifiers: [] };
var zoe = ["name", "registrationNumber"];
function Hoe(e) {
  var t, n = e.label, r = n === void 0 ? "" : n, a = e.namePrefix, o = e.requiredFields, s = e.visibility, c = wt().i18n, u = gs({ schema: o, rules: PW(PW({}, Goe), e.validationRules), defaultData: e.data }), f = u.handleChangeFor, m = u.triggerValidation, v = u.data, y = u.valid, b = u.errors, S = u.isValid, x = _n({});
  Pe(x.current).length || (t = e.setComponentRef) === null || t === void 0 || t.call(e, x.current), x.current.showValidation = function() {
    m();
  };
  var E = function(R) {
    var O;
    return je(O = "".concat(a ? "".concat(a, ".") : "")).call(O, R);
  }, N = function(R) {
    return function(O) {
      var D = O.target.name.split("".concat(a, ".")).pop();
      f(D, R)(O);
    };
  };
  return Rt(function() {
    var R = JWe(v);
    e.onChange({ data: R, valid: y, errors: b, isValid: S });
  }, [v, y, b, S]), s === "hidden" ? null : s === "readOnly" ? P(KWe, kt({}, e, { data: v })) : P(tv, { classNameModifiers: [r], label: r }, jt(o).call(o, "name") && P(xn, { label: c.get("companyDetails.name"), classNameModifiers: ["name"], errorMessage: !!b.name, i18n: c, name: E("companyName") }, P(vi, { name: E("name"), value: v.name, classNameModifiers: ["name"], onInput: N("input"), onBlur: N("blur"), spellCheck: !1 })), jt(o).call(o, "registrationNumber") && P(xn, { label: c.get("companyDetails.registrationNumber"), classNameModifiers: ["registrationNumber"], errorMessage: !!b.registrationNumber, i18n: c, name: E("registrationNumber") }, P(vi, { name: E("registrationNumber"), value: v.registrationNumber, classNameModifiers: ["registrationNumber"], onInput: N("input"), onBlur: N("blur"), spellCheck: !1 })));
}
Hoe.defaultProps = { data: {}, onChange: function() {
}, visibility: "editable", requiredFields: zoe, validationRules: Goe };
var rZe = function(e) {
  var t = e.data, n = t.firstName, r = t.lastName, a = t.shopperEmail, o = t.telephoneNumber;
  return P(tv, { classNameModifiers: ["personalDetails"], label: "personalDetails", readonly: !0 }, n && "".concat(n, " "), r && "".concat(r, " "), a && P(ra, null, P("br", null), a), o && P(ra, null, P("br", null), o));
}, aZe = /^(([a-z0-9!#$%&'*+\-/=?^_`{|}~]+(\.[a-z0-9!#$%&'*+\-/=?^_`{|}~]+)*)|(".+"))@((\[((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}])|([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*\.([a-z]{2,})))$/i, Woe = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/, Zoe = function() {
  var e = document.createElement("input");
  return e.setAttribute("type", "date"), e.type === "date";
}, oZe = function(e) {
  var t = e.replace(/\D|\s/g, "").replace(/^(00)(.*)?/, "01$2").replace(/^(3[2-9])(.*)?/, "0$1$2").replace(/^([4-9])(.*)?/, "0$1").replace(/^([0-9]{2})(00)(.*)?/, "$101").replace(/^(3[01])(02)(.*)?/, "29$2").replace(/^([0-9]{2})([2-9]|1[3-9])(.*)?/, "$10$2").replace(/^([0-9]{2})([0-9]{2})([0-9])/, "$1/$2/$3").replace(/^([0-9]{2})([0-9])/, "$1/$2"), n = t.split("/"), r = ze(n, 3), a = r[0], o = a === void 0 ? "" : a, s = r[1], c = s === void 0 ? "" : s, u = r[2], f = u === void 0 ? "" : u;
  return f.length === 4 && o === "29" && c === "02" && (Number(f) % 4 != 0 || f.substr(2, 2) === "00" && Number(f) % 400 != 0) ? t.replace(/^29/, "28") : t;
}, Yoe = function() {
  var e, t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (ka(n).call(n, "/") === -1) return n;
  var r = n.split("/"), a = ze(r, 3), o = a[0], s = o === void 0 ? "" : o, c = a[1], u = c === void 0 ? "" : c, f = a[2], m = f === void 0 ? "" : f;
  return s && u && m ? je(e = je(t = "".concat(m, "-")).call(t, u, "-")).call(e, s) : null;
}, Xoe = function(e) {
  return ul(e) ? null : e.length >= 6 && e.length <= 320 && aZe.test(e);
}, V2 = { default: { validate: function(e) {
  return e && e.length > 0;
}, errorMessage: "error.va.gen.02", modes: ["blur"] }, gender: { validate: function(e) {
  return e && e.length > 0;
}, errorMessage: "gender.notselected", modes: ["blur"] }, firstName: { validate: function(e) {
  return !ul(e) || null;
}, errorMessage: "firstName.invalid", modes: ["blur"] }, lastName: { validate: function(e) {
  return !ul(e) || null;
}, errorMessage: "lastName.invalid", modes: ["blur"] }, dateOfBirth: { validate: function(e) {
  return ul(e) ? null : function(t) {
    if (!t) return !1;
    var n = Yoe(t), r = m2() - Date.parse(n);
    return new Date(r).getFullYear() - 1970 >= 18;
  }(e);
}, errorMessage: "dateOfBirth.invalid", modes: ["blur"] }, telephoneNumber: { validate: function(e) {
  return ul(e) ? null : Woe.test(e);
}, errorMessage: "telephoneNumber.invalid", modes: ["blur"] }, shopperEmail: { validate: function(e) {
  return Xoe(e);
}, errorMessage: "shopperEmail.invalid", modes: ["blur"] } };
function NW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function g0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = NW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = NW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var iZe = function(e) {
  var t = e.firstName, n = e.lastName, r = e.gender, a = e.dateOfBirth, o = e.shopperEmail, s = e.telephoneNumber;
  return g0(g0(g0(g0({}, (t || n) && { shopperName: g0(g0(g0({}, t && { firstName: t }), n && { lastName: n }), r && { gender: r }) }), a && { dateOfBirth: Yoe(a) }), o && { shopperEmail: o }), s && { telephoneNumber: s });
};
function tD(e) {
  var t = e.items, n = e.name, r = e.onChange, a = e.value, o = e.isInvalid, s = e.uniqueId, c = wt().i18n, u = s == null ? void 0 : s.replace(/[0-9]/g, "").substring(0, kFe(s).call(s, "-"));
  return P("div", { className: "adyen-checkout__radio_group" }, It(t).call(t, function(f) {
    var m = QM(u);
    return P("div", { key: f.id, className: "adyen-checkout__radio_group__input-wrapper" }, P("input", { id: m, type: "radio", checked: a === f.id, className: "adyen-checkout__radio_group__input", name: n, onChange: r, onClick: r, value: f.id }), P("label", { className: Tt(["adyen-checkout__label__text", "adyen-checkout__radio_group__label", e.className, { "adyen-checkout__radio_group__label--invalid": o }]), htmlFor: m }, c.get(f.name)));
  }));
}
function sZe(e) {
  var t = Qi(Zoe, []);
  return P(nC, kt({}, e, t ? { type: "date" } : { onInput: function(n) {
    var r = n.target.value;
    n.target.value = oZe(r), e.onInput(n);
  }, maxLength: 10 }));
}
function rC(e) {
  return P(nC, kt({}, e, { type: "email", autoCapitalize: "off" }));
}
function Koe(e) {
  return P(nC, kt({}, e, { type: "tel" }));
}
function TW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function OW(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = TW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = TW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
tD.defaultProps = { onChange: function() {
}, items: [] };
var t7 = ["firstName", "lastName", "gender", "dateOfBirth", "shopperEmail", "telephoneNumber"];
function aC(e) {
  var t, n = e.label, r = n === void 0 ? "" : n, a = e.namePrefix, o = e.placeholders, s = e.requiredFields, c = e.visibility, u = wt().i18n, f = _n({});
  Pe(f.current).length || (t = e.setComponentRef) === null || t === void 0 || t.call(e, f.current);
  var m = Qi(Zoe, []), v = gs({ schema: s, rules: OW(OW({}, V2), e.validationRules), defaultData: e.data }), y = v.handleChangeFor, b = v.triggerValidation, S = v.data, x = v.valid, E = v.errors, N = v.isValid;
  f.current.showValidation = function() {
    b();
  };
  var R = function($) {
    return function(B) {
      var G = B.target.name.split("".concat(a, ".")).pop();
      y(G, $)(B);
    };
  }, O = function($) {
    var B;
    return je(B = "".concat(a ? "".concat(a, ".") : "")).call(B, $);
  }, D = function($) {
    return $ && $.errorMessage ? u.get($.errorMessage) : !!$;
  };
  return Rt(function() {
    var $ = iZe(S);
    e.onChange({ data: $, valid: x, errors: E, isValid: N });
  }, [S, x, E, N]), c === "hidden" ? null : c === "readOnly" ? P(rZe, kt({}, e, { data: S })) : P(ra, null, P(tv, { classNameModifiers: ["personalDetails"], label: r }, jt(s).call(s, "firstName") && P(xn, { label: u.get("firstName"), classNameModifiers: ["col-50", "firstName"], errorMessage: D(E.firstName), name: "firstName", i18n: u }, P(vi, { name: O("firstName"), value: S.firstName, classNameModifiers: ["firstName"], onInput: R("input"), onBlur: R("blur"), placeholder: o.firstName, spellCheck: !1, required: !0 })), jt(s).call(s, "lastName") && P(xn, { label: u.get("lastName"), classNameModifiers: ["col-50", "lastName"], errorMessage: D(E.lastName), name: "lastName", i18n: u }, P(vi, { name: O("lastName"), value: S.lastName, classNameModifiers: ["lastName"], onInput: R("input"), onBlur: R("blur"), placeholder: o.lastName, spellCheck: !1, required: !0 })), jt(s).call(s, "gender") && P(xn, { errorMessage: D(E.gender), classNameModifiers: ["gender"], name: "gender", useLabelElement: !1 }, P(tD, { name: O("gender"), value: S.gender, items: [{ id: "MALE", name: "male" }, { id: "FEMALE", name: "female" }], classNameModifiers: ["gender"], onInput: R("input"), onChange: R("blur"), required: !0 })), jt(s).call(s, "dateOfBirth") && P(xn, { label: u.get("dateOfBirth"), classNameModifiers: ["col-50", "dateOfBirth"], errorMessage: D(E.dateOfBirth), helper: m ? null : u.get("dateOfBirth.format"), name: "dateOfBirth", i18n: u }, P(sZe, { name: O("dateOfBirth"), value: S.dateOfBirth, classNameModifiers: ["dateOfBirth"], onInput: R("input"), onBlur: R("blur"), placeholder: o.dateOfBirth, required: !0 })), jt(s).call(s, "shopperEmail") && P(xn, { label: u.get("shopperEmail"), classNameModifiers: ["shopperEmail"], errorMessage: D(E.shopperEmail), dir: "ltr", name: "emailAddress", i18n: u }, P(rC, { name: O("shopperEmail"), value: S.shopperEmail, classNameModifiers: ["shopperEmail"], onInput: R("input"), onBlur: R("blur"), placeholder: o.shopperEmail, required: !0 })), jt(s).call(s, "telephoneNumber") && P(xn, { label: u.get("telephoneNumber"), classNameModifiers: ["telephoneNumber"], errorMessage: D(E.telephoneNumber), dir: "ltr", name: "telephoneNumber", i18n: u }, P(Koe, { name: O("telephoneNumber"), value: S.telephoneNumber, classNameModifiers: ["telephoneNumber"], onInput: R("input"), onBlur: R("blur"), placeholder: o.telephoneNumber, required: !0 }))), !1);
}
aC.defaultProps = { data: {}, onChange: function() {
}, placeholders: {}, requiredFields: t7, validationRules: V2, visibility: "editable" };
var n7 = "N/A", fu = ["street", "houseNumberOrName", "postalCode", "city", "stateOrProvince", "country", "firstName", "lastName"], pd = fu[0], hc = fu[1], _f = fu[2], x0 = fu[3], Pu = fu[4], N0 = fu[5], RW = fu[6], MW = fu[7], qoe = { AU: { hasDataset: !0, labels: T(T(T({}, hc, "apartmentSuite"), Pu, "state"), pd, "address"), optionalFields: [hc], placeholders: T({}, Pu, "select.state"), schema: [N0, pd, hc, x0, [[Pu, 50], [_f, 50]]] }, BR: { hasDataset: !0, labels: T({}, Pu, "state"), placeholders: T({}, Pu, "select.state") }, CA: { hasDataset: !0, labels: T(T(T({}, hc, "apartmentSuite"), Pu, "provinceOrTerritory"), pd, "address"), optionalFields: [hc], schema: [N0, pd, hc, [[x0, 70], [_f, 30]], Pu] }, GB: { labels: T({}, x0, "cityTown"), schema: [N0, [[hc, 30], [pd, 70]], [[x0, 70], [_f, 30]], Pu] }, US: { hasDataset: !0, labels: T(T(T(T({}, _f, "zipCode"), hc, "apartmentSuite"), Pu, "state"), pd, "address"), optionalFields: [hc], placeholders: T({}, Pu, "select.state"), schema: [N0, pd, hc, x0, [[Pu, 50], [_f, 50]]] }, default: { optionalFields: [], placeholders: T({}, Pu, "select.provinceOrTerritory"), schema: [N0, [[pd, 70], [hc, 30]], [[_f, 30], [x0, 70]], Pu] } }, lZe = { default: { labels: T({}, _f, "zipCode"), schema: [_f] } }, DW = Pe(qoe), uZe = function(e) {
  var t = e.firstName, n = e.lastName;
  return P(ra, null, t && "".concat(t, " "), n && "".concat(n), P("br", null));
}, cZe = function(e) {
  var t = e.data, n = e.label, r = t.street, a = t.houseNumberOrName, o = t.city, s = t.postalCode, c = t.stateOrProvince, u = t.country, f = t.firstName, m = t.lastName;
  return P(tv, { classNameModifiers: [n], label: n, readonly: !0 }, (f || m) && P(uZe, { firstName: f, lastName: m }), !!r && r, a && ", ".concat(a, ","), P("br", null), s && "".concat(s), o && ", ".concat(o), c && c !== n7 && ", ".concat(c), u && ", ".concat(u, " "));
}, zo = function(e) {
  var t;
  return { formatterFn: function(n) {
    return n.replace(_m("^\\d", "g"), "").substring(0, e);
  }, format: Tae(t = new Array(e)).call(t, "9").join(""), maxlength: e };
}, dZe = _m(eD), WP = function(e) {
  return function(t) {
    return Dje(t).call(t).replace(/\s+/g, " ");
  }(e).replace(dZe, "");
}, fZe = { postalCode: { formatterFn: function(e, t) {
  var n, r = t.state.data.country, a = (n = nD[r]) === null || n === void 0 ? void 0 : n.postalCode.formatterFn;
  return a ? a(e) : e;
} }, street: { formatterFn: WP }, houseNumberOrName: { formatterFn: WP }, city: { formatterFn: WP } }, nD = { AT: { postalCode: zo(4) }, AU: { postalCode: zo(4) }, BE: { postalCode: zo(4) }, BG: { postalCode: zo(4) }, BR: { postalCode: { formatterFn: function(e) {
  var t = e.replace(_m("^\\d-", "g"), ""), n = ka(t).call(t, "-") > -1 ? 9 : 8;
  return t.substring(0, n);
}, format: "12345678 or 12345-678", maxlength: 9 } }, CA: { postalCode: { format: "A9A 9A9 or A9A9A9", maxlength: 7 } }, CH: { postalCode: zo(4) }, CY: { postalCode: zo(4) }, CZ: { postalCode: { format: "999 99", maxlength: 6 } }, DE: { postalCode: zo(5) }, DK: { postalCode: { format: "9999", maxlength: 7 } }, EE: { postalCode: zo(5) }, ES: { postalCode: zo(5) }, FI: { postalCode: zo(5) }, FR: { postalCode: zo(5) }, GB: { postalCode: { formatterFn: function(e) {
  return e.replace(_m(eD), "").substring(0, 8);
}, format: "AA99 9AA or A99 9AA or A9 9AA", maxlength: 8 } }, GR: { postalCode: { format: "999 99", maxlength: 6 } }, HR: { postalCode: { format: "[1-5]9999", maxlength: 5 } }, HU: { postalCode: zo(4) }, IE: { postalCode: { format: "A99 A999", maxlength: 8 } }, IS: { postalCode: zo(3) }, IT: { postalCode: zo(5) }, LI: { postalCode: zo(4) }, LT: { postalCode: { format: "9999 or 99999 or LT-99999", maxlength: 8 } }, LU: { postalCode: zo(4) }, LV: { postalCode: { format: "9999 or LV-9999", maxlength: 7 } }, MC: { postalCode: { format: "980NN", maxlength: 5 } }, MT: { postalCode: { format: "AA99 or AAA99 or AA9999 or AAA9999", maxlength: 8 } }, MY: { postalCode: zo(5) }, NL: { postalCode: { format: "9999AA", maxlength: 7 } }, NZ: { postalCode: zo(4) }, NO: { postalCode: zo(4) }, PL: { postalCode: { formatterFn: function(e) {
  var t = e.replace(_m("^\\d-", "g"), ""), n = ka(t).call(t, "-") > -1 ? 6 : 5;
  return t.substring(0, n);
}, format: "99999 or 99-999", maxlength: 6 } }, PT: { postalCode: { formatterFn: function(e) {
  return e.replace(_m("^\\d-", "g"), "").substring(0, 8);
}, format: "9999-999", maxlength: 8 } }, RO: { postalCode: zo(6) }, SI: { postalCode: { format: "9999 or SI-9999", maxlength: 7 } }, SE: { postalCode: zo(5) }, SG: { postalCode: zo(6) }, SK: { postalCode: { format: "99999 or SK-99999", maxlength: 8 } }, JP: { postalCode: { format: "999-9999", maxlength: 8 } }, US: { postalCode: { formatterFn: function(e) {
  var t = e.replace(_m("^\\d-", "g"), ""), n = ka(t).call(t, "-") > -1 ? 10 : 5;
  return t.substring(0, n);
}, format: "99999 or 99999-9999" } } }, To = function(e) {
  return { pattern: new RegExp("\\d{".concat(e, "}")) };
}, Joe = function(e, t, n) {
  if (t) {
    var r, a;
    if (n.postalCode.errorMessage = { translationKey: "invalidFormatExpects", translationObject: { values: { format: ((r = nD[t]) === null || r === void 0 ? void 0 : r.postalCode.format) || null } } }, ul(e)) return null;
    var o = (a = pZe[t]) === null || a === void 0 ? void 0 : a.pattern;
    return o ? o.test(e) : !!e;
  }
  return !ul(e) || null;
}, pZe = { AT: To(4), AU: To(4), BE: { pattern: /(?:(?:[1-9])(?:\d{3}))/ }, BG: To(4), BR: { pattern: /^\d{5}-?\d{3}$/ }, CA: { pattern: /(?:[ABCEGHJ-NPRSTVXY]\d[A-Z][ -]?\d[A-Z]\d)/ }, CH: { pattern: /[1-9]\d{3}/ }, CY: To(4), CZ: { pattern: /\d{3}\s?\d{2}/ }, DE: To(5), DK: To(4), EE: To(5), ES: { pattern: /(?:0[1-9]|[1-4]\d|5[0-2])\d{3}/ }, FI: To(5), FR: To(5), GB: { pattern: /^([A-Za-z][A-Ha-hK-Yk-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/ }, GE: To(4), GR: { pattern: /^\d{3}\s{0,1}\d{2}$/ }, HR: { pattern: /^([1-5])[0-9]{4}$/ }, HU: To(4), IE: { pattern: /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}/ }, IS: To(3), IT: To(5), LI: To(4), LT: { pattern: /^(LT-\d{5})$/ }, LU: To(4), LV: { pattern: /^(LV-)[0-9]{4}$/ }, MC: { pattern: /^980\d{2}$/ }, MT: { pattern: /^[A-Za-z]{3}\d{4}$/ }, MY: To(5), NL: { pattern: /(?:NL-)?(?:[1-9]\d{3} ?(?:[A-EGHJ-NPRTVWXZ][A-EGHJ-NPRSTVWXZ]|S[BCEGHJ-NPRTVWXZ]))/ }, NO: To(4), PL: { pattern: /^\d{2}[-]{0,1}\d{3}$/ }, PT: { pattern: /^([1-9]\d{3})([- ]?(\d{3})? *)$/ }, RO: To(6), SI: To(4), SE: To(5), SG: To(6), SK: To(5), US: To(5) }, hZe = function(e) {
  var t = { postalCode: { modes: ["blur"], validate: function(n) {
    return Joe(n, e, t);
  }, errorMessage: hi[B0] } };
  return t;
}, mZe = function(e) {
  var t = { postalCode: { modes: ["blur"], validate: function(n, r) {
    var a = r.state.data.country;
    return Joe(n, a, t);
  }, errorMessage: hi[B0] }, houseNumberOrName: { validate: function(n, r) {
    var a, o = (a = r.state) === null || a === void 0 || (a = a.data) === null || a === void 0 ? void 0 : a.country;
    return o && e.countryHasOptionalField(o, "houseNumberOrName") || !ul(n) || null;
  }, modes: ["blur"], errorMessage: hi[B0] }, default: { validate: function(n) {
    return !ul(n) || null;
  }, modes: ["blur"], errorMessage: hi[B0] } };
  return t;
}, Bs = Yz !== void 0 && Yz || typeof self != "undefined" && self || typeof global != "undefined" && global || {}, LW = "URLSearchParams" in Bs, Qoe = "Symbol" in Bs && "iterator" in Oae, E4 = "FileReader" in Bs && "Blob" in Bs && function() {
  try {
    return new Blob(), !0;
  } catch (e) {
    return !1;
  }
}(), $W = "FormData" in Bs, a6 = "ArrayBuffer" in Bs;
if (a6) var jW = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"], vZe = ArrayBuffer.isView || function(e) {
  return e && ka(jW).call(jW, Object.prototype.toString.call(e)) > -1;
};
function ky(e) {
  if (typeof e != "string" && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || e === "") throw new TypeError('Invalid character in header field name: "' + e + '"');
  return e.toLowerCase();
}
function pO(e) {
  return typeof e != "string" && (e = String(e)), e;
}
function ZP(e) {
  var t = { next: function() {
    var n = e.shift();
    return { done: n === void 0, value: n };
  } };
  return Qoe && (t[Rae] = function() {
    return t;
  }), t;
}
function Wi(e) {
  if (this.map = {}, e instanceof Wi) Q(e).call(e, function(n, r) {
    this.append(r, n);
  }, this);
  else if (E8(e)) Q(e).call(e, function(n) {
    if (n.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + n.length);
    this.append(n[0], n[1]);
  }, this);
  else if (e) {
    var t;
    Q(t = Mae(e)).call(t, function(n) {
      this.append(n, e[n]);
    }, this);
  }
}
function YP(e) {
  if (!e._noBody) return e.bodyUsed ? Yt.reject(new TypeError("Already read")) : void (e.bodyUsed = !0);
}
function eie(e) {
  return new Yt(function(t, n) {
    e.onload = function() {
      t(e.result);
    }, e.onerror = function() {
      n(e.error);
    };
  });
}
function gZe(e) {
  var t = new FileReader(), n = eie(t);
  return t.readAsArrayBuffer(e), n;
}
function FW(e) {
  if (Xo(e)) return Xo(e).call(e, 0);
  var t = new Uint8Array(e.byteLength);
  return t.set(new Uint8Array(e)), t.buffer;
}
function BW() {
  return this.bodyUsed = !1, this._initBody = function(e) {
    var t;
    this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? typeof e == "string" ? this._bodyText = e : E4 && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : $W && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : LW && cH.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : a6 && E4 && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = FW(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : a6 && (ArrayBuffer.prototype.isPrototypeOf(e) || vZe(e)) ? this._bodyArrayBuffer = FW(e) : this._bodyText = e = Object.prototype.toString.call(e) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof e == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : LW && cH.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
  }, E4 && (this.blob = function() {
    var e = YP(this);
    if (e) return e;
    if (this._bodyBlob) return Yt.resolve(this._bodyBlob);
    if (this._bodyArrayBuffer) return Yt.resolve(new Blob([this._bodyArrayBuffer]));
    if (this._bodyFormData) throw new Error("could not read FormData body as blob");
    return Yt.resolve(new Blob([this._bodyText]));
  }), this.arrayBuffer = function() {
    if (this._bodyArrayBuffer) {
      var e, t = YP(this);
      return t || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Yt.resolve(Xo(e = this._bodyArrayBuffer.buffer).call(e, this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Yt.resolve(this._bodyArrayBuffer));
    }
    if (E4) return this.blob().then(gZe);
    throw new Error("could not read as ArrayBuffer");
  }, this.text = function() {
    var e, t, n, r, a, o = YP(this);
    if (o) return o;
    if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader(), n = eie(t), r = /charset=([A-Za-z0-9_-]+)/.exec(e.type), a = r ? r[1] : "utf-8", t.readAsText(e, a), n;
    if (this._bodyArrayBuffer) return Yt.resolve(function(s) {
      for (var c = new Uint8Array(s), u = new Array(c.length), f = 0; f < c.length; f++) u[f] = String.fromCharCode(c[f]);
      return u.join("");
    }(this._bodyArrayBuffer));
    if (this._bodyFormData) throw new Error("could not read FormData body as text");
    return Yt.resolve(this._bodyText);
  }, $W && (this.formData = function() {
    return this.text().then(yZe);
  }), this.json = function() {
    return this.text().then(JSON.parse);
  }, this;
}
Wi.prototype.append = function(e, t) {
  e = ky(e), t = pO(t);
  var n = It(this)[e];
  It(this)[e] = n ? n + ", " + t : t;
}, Wi.prototype.delete = function(e) {
  delete It(this)[ky(e)];
}, Wi.prototype.get = function(e) {
  return e = ky(e), this.has(e) ? It(this)[e] : null;
}, Wi.prototype.has = function(e) {
  return It(this).hasOwnProperty(ky(e));
}, Wi.prototype.set = function(e, t) {
  It(this)[ky(e)] = pO(t);
}, Wi.prototype.forEach = function(e, t) {
  for (var n in It(this)) It(this).hasOwnProperty(n) && e.call(t, It(this)[n], n, this);
}, Wi.prototype.keys = function() {
  var e = [];
  return Q(this).call(this, function(t, n) {
    e.push(n);
  }), ZP(e);
}, Wi.prototype.values = function() {
  var e = [];
  return Q(this).call(this, function(t) {
    e.push(t);
  }), ZP(e);
}, Wi.prototype.entries = function() {
  var e = [];
  return Q(this).call(this, function(t, n) {
    e.push([n, t]);
  }), ZP(e);
}, Qoe && (Wi.prototype[Rae] = _Be(Wi.prototype));
var VW = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
function V0(e, t) {
  if (!(this instanceof V0)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  var n, r, a = (t = t || {}).body;
  if (e instanceof V0) {
    if (e.bodyUsed) throw new TypeError("Already read");
    this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new Wi(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, a || e._bodyInit == null || (a = e._bodyInit, e.bodyUsed = !0);
  } else this.url = String(e);
  if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new Wi(t.headers)), this.method = (n = t.method || this.method || "GET", r = n.toUpperCase(), ka(VW).call(VW, r) > -1 ? r : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal || function() {
    if ("AbortController" in Bs) return new AbortController().signal;
  }(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && a) throw new TypeError("Body not allowed for GET or HEAD requests");
  if (this._initBody(a), !(this.method !== "GET" && this.method !== "HEAD" || t.cache !== "no-store" && t.cache !== "no-cache")) {
    var o = /([?&])_=[^&]*/;
    o.test(this.url) ? this.url = this.url.replace(o, "$1_=" + (/* @__PURE__ */ new Date()).getTime()) : this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
  }
}
function yZe(e) {
  var t, n = new FormData();
  return Q(t = zp(e).call(e).split("&")).call(t, function(r) {
    if (r) {
      var a = r.split("="), o = a.shift().replace(/\+/g, " "), s = a.join("=").replace(/\+/g, " ");
      n.append(decodeURIComponent(o), decodeURIComponent(s));
    }
  }), n;
}
function xf(e, t) {
  if (!(this instanceof xf)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  if (t || (t = {}), this.type = "default", this.status = t.status === void 0 ? 200 : t.status, this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
  this.ok = this.status >= 200 && this.status < 300, this.statusText = t.statusText === void 0 ? "" : "" + t.statusText, this.headers = new Wi(t.headers), this.url = t.url || "", this._initBody(e);
}
V0.prototype.clone = function() {
  return new V0(this, { body: this._bodyInit });
}, BW.call(V0.prototype), BW.call(xf.prototype), xf.prototype.clone = function() {
  return new xf(this._bodyInit, { status: this.status, statusText: this.statusText, headers: new Wi(this.headers), url: this.url });
}, xf.error = function() {
  var e = new xf(null, { status: 200, statusText: "" });
  return e.status = 0, e.type = "error", e;
};
var UW = [301, 302, 303, 307, 308];
xf.redirect = function(e, t) {
  if (ka(UW).call(UW, t) === -1) throw new RangeError("Invalid status code");
  return new xf(null, { status: t, headers: { location: e } });
};
var T0 = Bs.DOMException;
try {
  new T0();
} catch (e) {
  T0 = function(t, n) {
    this.message = t, this.name = n;
    var r = Error(t);
    this.stack = r.stack;
  }, T0.prototype = vVe(Error.prototype), T0.prototype.constructor = T0;
}
function hO(e, t) {
  return new Yt(function(n, r) {
    var a = new V0(e, t);
    if (a.signal && a.signal.aborted) return r(new T0("Aborted", "AbortError"));
    var o = new XMLHttpRequest();
    function s() {
      o.abort();
    }
    if (o.onload = function() {
      var v, y, b, S, x, E, N = { statusText: o.statusText, headers: (y = o.getAllResponseHeaders() || "", x = new Wi(), E = y.replace(/\r?\n[\t ]+/g, " "), Q(b = It(S = E.split("\r")).call(S, function(O) {
        return ka(O).call(O, `
`) === 0 ? O.substr(1, O.length) : O;
      })).call(b, function(O) {
        var D, $ = O.split(":"), B = zp(D = $.shift()).call(D);
        if (B) {
          var G, Z = zp(G = $.join(":")).call(G);
          try {
            x.append(B, Z);
          } catch (K) {
            console.warn("Response " + K.message);
          }
        }
      }), x) };
      MVe(v = a.url).call(v, "file://") && (o.status < 200 || o.status > 599) ? N.status = 200 : N.status = o.status, N.url = "responseURL" in o ? o.responseURL : N.headers.get("X-Request-URL");
      var R = "response" in o ? o.response : o.responseText;
      Ro(function() {
        n(new xf(R, N));
      }, 0);
    }, o.onerror = function() {
      Ro(function() {
        r(new TypeError("Network request failed"));
      }, 0);
    }, o.ontimeout = function() {
      Ro(function() {
        r(new TypeError("Network request timed out"));
      }, 0);
    }, o.onabort = function() {
      Ro(function() {
        r(new T0("Aborted", "AbortError"));
      }, 0);
    }, o.open(a.method, function(v) {
      try {
        return v === "" && Bs.location.href ? Bs.location.href : v;
      } catch (y) {
        return v;
      }
    }(a.url), !0), a.credentials === "include" ? o.withCredentials = !0 : a.credentials === "omit" && (o.withCredentials = !1), "responseType" in o && (E4 ? o.responseType = "blob" : a6 && (o.responseType = "arraybuffer")), t && mi(t.headers) === "object" && !(t.headers instanceof Wi || Bs.Headers && t.headers instanceof Bs.Headers)) {
      var c, u, f = [];
      Q(c = Mae(t.headers)).call(c, function(v) {
        f.push(ky(v)), o.setRequestHeader(v, pO(t.headers[v]));
      }), Q(u = a.headers).call(u, function(v, y) {
        ka(f).call(f, y) === -1 && o.setRequestHeader(y, v);
      });
    } else {
      var m;
      Q(m = a.headers).call(m, function(v, y) {
        o.setRequestHeader(y, v);
      });
    }
    a.signal && (a.signal.addEventListener("abort", s), o.onreadystatechange = function() {
      o.readyState === 4 && a.signal.removeEventListener("abort", s);
    }), o.send(a._bodyInit === void 0 ? null : a._bodyInit);
  });
}
hO.polyfill = !0, Bs.fetch || (Bs.fetch = hO, Bs.Headers = Wi, Bs.Request = V0, Bs.Response = xf);
var bZe = typeof window != "undefined" && "fetch" in window ? window.fetch : hO, tie = "https://checkoutshopper-live.adyen.com/checkoutshopper/", GW = ["amount", "secondaryAmount", "countryCode", "environment", "loadingContext", "i18n", "modules", "order", "session", "clientKey", "showPayButton", "redirectFromTopWhenInIframe", "installmentOptions", "onPaymentCompleted", "beforeRedirect", "beforeSubmit", "onSubmit", "onActionHandled", "onAdditionalDetails", "onCancel", "onChange", "onError", "onBalanceCheck", "onOrderRequest", "onOrderCreated", "setStatusAutomatically"], _Ze = 6e4;
function zW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function U0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = zW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = zW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function CZe(e) {
  return e && e.errorCode && e.errorType && e.message && e.status;
}
function nie(e, t) {
  var n, r, a, o = e.headers, s = o === void 0 ? [] : o, c = e.errorLevel, u = c === void 0 ? "warn" : c, f = e.loadingContext, m = f === void 0 ? tie : f, v = e.method, y = v === void 0 ? "GET" : v, b = e.path, S = e.timeout, x = S === void 0 ? _Ze : S, E = U0(U0({ method: y, mode: "cors", cache: "default", credentials: "same-origin", headers: U0({ Accept: "application/json, text/plain, */*", "Content-Type": y === "POST" ? "application/json" : "text/plain" }, s), redirect: "follow", referrerPolicy: "no-referrer-when-downgrade" }, ((n = AbortSignal) === null || n === void 0 ? void 0 : n.timeout) && { signal: (r = AbortSignal) === null || r === void 0 ? void 0 : r.timeout(x) }), t && { body: Pc(t) }), N = je(a = "".concat(m)).call(a, b);
  return bZe(N, E).then(function() {
    var R = On(yt.mark(function O(D) {
      var $;
      return yt.wrap(function(B) {
        for (; ; ) switch (B.prev = B.next) {
          case 0:
            return B.next = 2, D.json();
          case 2:
            if ($ = B.sent, !D.ok) {
              B.next = 5;
              break;
            }
            return B.abrupt("return", $);
          case 5:
            if (!CZe($)) {
              B.next = 8;
              break;
            }
            return XP($.message, u, $), B.abrupt("return");
          case 8:
            return XP(e.errorMessage || "Service at ".concat(N, " is not available"), u, $), B.abrupt("return");
          case 11:
          case "end":
            return B.stop();
        }
      }, O);
    }));
    return function(O) {
      return R.apply(this, arguments);
    };
  }()).catch(function(R) {
    var O;
    if (R instanceof _r) throw R;
    XP(e.errorMessage || je(O = "Call to ".concat(N, " failed. Error= ")).call(O, R), u, R);
  });
}
function XP(e, t, n) {
  switch (t) {
    case "silent":
      break;
    case "info":
    case "warn":
    case "error":
      console[t](e);
      break;
    default:
      throw new _r("NETWORK_ERROR", e, { cause: n });
  }
}
function fl(e, t) {
  return nie(U0(U0({}, e), {}, { method: "POST" }), t);
}
function rD(e, t, n) {
  var r;
  return function(a, o) {
    return nie(U0(U0({}, a), {}, { method: "GET" }), o);
  }({ loadingContext: t, errorLevel: "warn", errorMessage: "Dataset ".concat(e, " is not available"), path: n ? je(r = "datasets/".concat(e, "/")).call(r, n, ".json") : "datasets/".concat(e, ".json") });
}
var G0 = { "adyen-checkout__dropdown": "Select-module_adyen-checkout__dropdown__0Mj-n", "adyen-checkout__dropdown__button": "Select-module_adyen-checkout__dropdown__button__yTyqq", "adyen-checkout__dropdown__button--active": "Select-module_adyen-checkout__dropdown__button--active__Ej-JR", "adyen-checkout__filter-input": "Select-module_adyen-checkout__filter-input__CwPBS", "adyen-checkout__dropdown__list": "Select-module_adyen-checkout__dropdown__list__YtEzj", "adyen-checkout__dropdown__list--active": "Select-module_adyen-checkout__dropdown__list--active__Gegw2", "adyen-checkout__dropdown__element": "Select-module_adyen-checkout__dropdown__element__ORU4-" };
function ps(e) {
  var t, n = e.backgroundUrl, r = n === void 0 ? "" : n, a = e.className, o = a === void 0 ? "" : a, s = e.classNameModifiers, c = s === void 0 ? [] : s, u = e.src, f = u === void 0 ? "" : u, m = e.alt, v = m === void 0 ? "" : m, y = e.showOnError, b = y !== void 0 && y, S = Je(!1), x = ze(S, 2), E = x[0], N = x[1], R = _n(null), O = function() {
    N(!0);
  }, D = Tt.apply(void 0, je(t = [[o], "adyen-checkout__image", { "adyen-checkout__image--loaded": E }]).call(t, Pn(It(c).call(c, function($) {
    return "adyen-checkout__image--".concat($);
  }))));
  return Rt(function() {
    var $ = r ? new Image() : R.current;
    $.src = r || f, $.onload = O, N(!!$.complete);
  }, []), r ? P("div", kt({ "data-testid": "background", style: { backgroundUrl: r } }, e, { className: D })) : P("img", kt({}, e, { alt: v, ref: R, className: D, onError: function() {
    N(b);
  } }));
}
var wZe = ["filterable", "toggleButtonRef"];
function SZe(e) {
  var t = e.filterable, n = e.toggleButtonRef, r = pa(e, wZe);
  return t ? P("div", kt({}, r, { ref: n })) : P("button", kt({ id: r.id, "aria-describedby": r.ariaDescribedBy, type: "button" }, r, { ref: n }));
}
function xZe(e) {
  var t = wt().i18n, n = e.active, r = e.selected, a = e.inputText, o = e.readonly, s = e.showList, c = r.selectedOptionName || r.name || e.placeholder || "", u = s ? a : c, f = o ? null : e.filterable ? function(y) {
    y.preventDefault(), document.activeElement === e.filterInputRef.current ? e.showList || e.toggleList(y) : e.filterInputRef.current && e.filterInputRef.current.focus();
  } : e.toggleList, m = o ? null : e.onFocus, v = n.id ? "listItem-".concat(n.id) : "";
  return P(SZe, { className: Tt(T(T(T(T(T(T(T({ "adyen-checkout__dropdown__button": !0 }, G0["adyen-checkout__dropdown__button"], !0), "adyen-checkout__dropdown__button--readonly", o), "adyen-checkout__dropdown__button--active", s), G0["adyen-checkout__dropdown__button--active"], s), "adyen-checkout__dropdown__button--invalid", e.isInvalid), "adyen-checkout__dropdown__button--valid", e.isValid), "adyen-checkout__dropdown__button--disabled", r.disabled)), disabled: e.disabled, filterable: e.filterable, onClick: f, onKeyDown: o ? null : e.onButtonKeyDown, toggleButtonRef: e.toggleButtonRef }, e.filterable ? P(ra, null, !s && r.icon && P(ps, { className: "adyen-checkout__dropdown__button__icon", src: r.icon, alt: r.name }), P("input", { value: u, "aria-autocomplete": "list", "aria-controls": e.selectListId, "aria-expanded": s, "aria-owns": e.selectListId, autoComplete: "off", className: Tt("adyen-checkout__filter-input", [G0["adyen-checkout__filter-input"]]), onInput: e.onInput, onFocus: m, placeholder: t.get("select.filter.placeholder"), ref: e.filterInputRef, role: "combobox", "aria-activedescendant": v, type: "text", readOnly: e.readonly, id: e.id, "aria-describedby": e.ariaDescribedBy }), !s && r.secondaryText && P("span", { className: "adyen-checkout__dropdown__button__secondary-text" }, r.secondaryText)) : P(ra, null, r.icon && P(ps, { className: "adyen-checkout__dropdown__button__icon", src: r.icon, alt: r.name }), P("span", { className: "adyen-checkout__dropdown__button__text" }, c), r.secondaryText && P("span", { className: "adyen-checkout__dropdown__button__secondary-text" }, r.secondaryText)));
}
var EZe = ["item", "active", "selected"], IZe = function(e) {
  var t = e.item, n = e.active, r = e.selected, a = pa(e, EZe);
  return P("li", { "aria-disabled": !!t.disabled, "aria-selected": r, className: Tt(["adyen-checkout__dropdown__element", G0["adyen-checkout__dropdown__element"], { "adyen-checkout__dropdown__element--active": n, "adyen-checkout__dropdown__element--disabled": !!t.disabled }]), "data-disabled": t.disabled === !0 || null, "data-value": t.id, onClick: a.onSelect, onMouseEnter: a.onHover, role: "option", id: "listItem-".concat(t.id) }, t.icon && P(ps, { className: "adyen-checkout__dropdown__element__icon", alt: t.name, src: t.icon }), P("span", { className: "adyen-checkout__dropdown__element__text" }, t.name), t.secondaryText && P("span", { className: "adyen-checkout__dropdown__element__secondary-text" }, t.secondaryText), r && P(h_, { type: "checkmark", height: 14, width: 14 }));
}, kZe = ["selected", "active", "filteredItems", "showList"];
function AZe(e) {
  var t = e.selected, n = e.active, r = e.filteredItems, a = e.showList, o = pa(e, kZe), s = wt().i18n;
  return P("ul", { className: Tt(T(T(T({ "adyen-checkout__dropdown__list": !0 }, G0["adyen-checkout__dropdown__list"], !0), "adyen-checkout__dropdown__list--active", a), G0["adyen-checkout__dropdown__list--active"], a)), id: o.selectListId, ref: o.selectListRef, role: "listbox" }, r.length ? It(r).call(r, function(c) {
    return P(IZe, { active: c.id === n.id, item: c, key: c.id, onSelect: o.onSelect, onHover: o.onHover, selected: c.id === t.id });
  }) : P("div", { className: "adyen-checkout__dropdown__element adyen-checkout__dropdown__element--no-options" }, s.get("select.noOptionsFound")));
}
var cc = { arrowDown: "ArrowDown", arrowUp: "ArrowUp", enter: "Enter", escape: "Escape", space: " ", tab: "Tab" }, PZe = function(e) {
  var t = e.parentNode, n = window.getComputedStyle(t, null), r = Ou(n.getPropertyValue("border-top-width")), a = e.offsetTop - t.offsetTop < t.scrollTop, o = e.offsetTop - t.offsetTop + e.clientHeight - r > t.scrollTop + t.clientHeight;
  (a || o) && (t.scrollTop = e.offsetTop - t.offsetTop - t.clientHeight / 2 - r + e.clientHeight / 2);
};
function Ad(e) {
  var t, n, r = e.items, a = r === void 0 ? [] : r, o = e.className, s = o === void 0 ? "" : o, c = e.classNameModifiers, u = c === void 0 ? [] : c, f = e.filterable, m = f === void 0 || f, v = e.readonly, y = v !== void 0 && v, b = e.onChange, S = b === void 0 ? function() {
  } : b, x = e.onInput, E = e.selectedValue, N = e.name, R = e.isInvalid, O = e.isValid, D = e.placeholder, $ = e.uniqueId, B = e.disabled, G = e.disableTextFilter, Z = e.clearOnSelect, K = e.blurOnClose, q = e.onListToggle, pe = _n(null), he = _n(null), _e = _n(null), ge = _n(null), Y = Je(null), ee = ze(Y, 2), oe = ee[0], me = ee[1], xe = Je(!1), X = ze(xe, 2), ye = X[0], ce = X[1], se = Qi(function() {
    return "select-".concat(F2());
  }, []), Ie = Ji(a).call(a, function($t) {
    return $t.id === E;
  }) || {}, Le = Je(), ie = ze(Le, 2), $e = ie[0], we = ie[1], Ne = Je(Ie), Ee = ze(Ne, 2), le = Ee[0], be = Ee[1], He = Ie, Ae = G ? a : Oe(a).call(a, function($t) {
    var qt;
    return !oe || jt(qt = $t.name.toLowerCase()).call(qt, oe.toLowerCase());
  }), it = function($t) {
    if ($t) {
      var qt = document.getElementById("listItem-".concat($t.id));
      PZe(qt);
    }
  }, ut = function() {
    K && pe.current.blur(), ce(!1);
  }, St = function() {
    ce(!0);
  }, sn = function($t) {
    var qt = $t.currentTarget.getAttribute("data-value");
    return Ji(Ae).call(Ae, function(fn) {
      return fn.id == qt;
    });
  }, zn = function($t) {
    var qt;
    $t.preventDefault(), (qt = $t.currentTarget instanceof HTMLElement && $t.currentTarget.getAttribute("role") === "option" ? sn($t) : le.id && A8(Ae).call(Ae, function(fn) {
      return fn.id === le.id;
    }) ? le : oe ? Ae[0] : { id: E }) && !qt.disabled && (S({ target: { value: qt.id, name: N } }), Z && we(null), ut());
  }, dn = function($t) {
    switch ($t.key) {
      case cc.space:
      case cc.enter:
        zn($t);
        break;
      case cc.arrowDown:
        $t.preventDefault(), function() {
          if (Ae && !(Ae.length < 1)) {
            var qt = qT(Ae).call(Ae, function(Wt) {
              return Wt === le;
            }) + 1, fn = qt < Ae.length ? qt : 0, At = Ae[fn];
            it(At), be(At);
          }
        }();
        break;
      case cc.arrowUp:
        $t.preventDefault(), function() {
          if (Ae && !(Ae.length < 1)) {
            var qt = qT(Ae).call(Ae, function(Wt) {
              return Wt === le;
            }) - 1, fn = qt < 0 ? Ae.length - 1 : qt, At = Ae[fn];
            it(At), be(At);
          }
        }();
    }
  };
  return Rt(function() {
    ye ? we(null) : me(null);
  }, [ye]), Rt(function() {
    ye && m && pe.current && pe.current.focus(), q == null || q(ye);
  }, [ye]), Rt(function() {
    function $t(qt) {
      var fn;
      (qt.composedPath ? !jt(fn = qt.composedPath()).call(fn, he.current) : !he.current.contains(qt.target)) && ut();
    }
    return document.addEventListener("click", $t, !1), function() {
      document.removeEventListener("click", $t, !1);
    };
  }, [he]), P("div", { className: Tt(je(t = ["adyen-checkout__dropdown", G0["adyen-checkout__dropdown"], s]).call(t, Pn(It(u).call(u, function($t) {
    return "adyen-checkout__dropdown--".concat($t);
  })))), ref: he }, P(xZe, { inputText: $e, id: $ != null ? $ : null, active: le, selected: He, filterInputRef: pe, filterable: m, isInvalid: R, isValid: O, onButtonKeyDown: function($t) {
    var qt;
    $t.key === cc.enter && m && ye && oe ? zn($t) : $t.key === cc.escape ? ut() : !jt(qt = [cc.arrowUp, cc.arrowDown, cc.enter]).call(qt, $t.key) && ($t.key !== cc.space || m && ye) ? ($t.shiftKey && $t.key === cc.tab || $t.key === cc.tab) && ut() : ($t.preventDefault(), ye ? dn($t) : St());
  }, onFocus: St, onInput: function($t) {
    var qt = $t.target.value;
    we(qt), me(qt), x && x(qt);
  }, placeholder: D, readonly: y, selectListId: se, showList: ye, toggleButtonRef: _e, toggleList: function($t) {
    $t.preventDefault(), ye ? (we(He.name), ut()) : (we(null), St());
  }, disabled: B, ariaDescribedBy: $ ? je(n = "".concat($)).call(n, F0) : null }), P(AZe, { active: le, filteredItems: Ae, onHover: function($t) {
    $t.preventDefault();
    var qt = sn($t);
    be(qt);
  }, onSelect: zn, selected: He, selectListId: se, selectListRef: ge, showList: ye }));
}
function NZe(e) {
  var t = e.classNameModifiers, n = e.label, r = e.onDropdownChange, a = e.readOnly, o = e.selectedCountry, s = e.specifications, c = e.value, u = wt(), f = u.i18n, m = u.loadingContext, v = Je([]), y = ze(v, 2), b = y[0], S = y[1], x = Je(!1), E = ze(x, 2), N = E[0], R = E[1], O = s.getPlaceholderKeyForField("stateOrProvince", o);
  return UM(function() {
    if (!o || !s.countryHasDataset(o)) return S([]), void R(!0);
    rD("states/".concat(o), m, f.locale).then(function(D) {
      var $ = D && D.length ? D : [];
      S($), R(!0);
    }).catch(function() {
      S([]), R(!0);
    });
  }, [o]), N && b.length ? P(xn, { label: n, classNameModifiers: t, errorMessage: e.errorMessage, isValid: !!c, showValidIcon: !1, name: "stateOrProvince", i18n: f }, P(Ad, { name: "stateOrProvince", onChange: r, selectedValue: c, placeholder: f.get(O), items: b, readonly: a && !!c })) : null;
}
function TZe(e) {
  var t = e.allowedCountries, n = t === void 0 ? [] : t, r = e.classNameModifiers, a = r === void 0 ? [] : r, o = e.errorMessage, s = e.onDropdownChange, c = e.value, u = wt(), f = u.i18n, m = u.loadingContext, v = Je([]), y = ze(v, 2), b = y[0], S = y[1], x = Je(!1), E = ze(x, 2), N = E[0], R = E[1], O = Je(e.readOnly), D = ze(O, 2), $ = D[0], B = D[1];
  return UM(function() {
    rD("countries", m, f.locale).then(function(G) {
      var Z = n.length ? Oe(G).call(G, function(K) {
        return jt(n).call(n, K.id);
      }) : G;
      S(Z || []), B(Z.length === 1 || $), R(!0);
    }).catch(function(G) {
      console.error(G), S([]), R(!0);
    });
  }, []), N ? P(xn, { name: "country", label: f.get("country"), errorMessage: o, classNameModifiers: a, isValid: !!c, showValidIcon: !1, i18n: f }, P(Ad, { onChange: s, name: "country", placeholder: f.get("select.country"), selectedValue: c, items: b, readonly: $ && !!c })) : null;
}
function OZe(e) {
  var t, n = wt().i18n, r = e.classNameModifiers, a = r === void 0 ? [] : r, o = e.data, s = e.errors, c = e.valid, u = e.fieldName, f = e.onInput, m = e.onBlur, v = e.trimOnBlur, y = e.maxLength, b = e.disabled, S = o[u], x = o.country, E = e.specifications.countryHasOptionalField(x, u), N = e.specifications.getKeyForField(u, x), R = E ? " ".concat(n.get("field.title.optional")) : "", O = je(t = "".concat(n.get(N))).call(t, R), D = function($, B, G) {
    var Z, K;
    if (mi((Z = $[B]) === null || Z === void 0 ? void 0 : Z.errorMessage) === "object") {
      var q = $[B].errorMessage, pe = q.translationKey, he = q.translationObject;
      return G.get(pe, he);
    }
    return G.get((K = $[B]) === null || K === void 0 ? void 0 : K.errorMessage) || !!$[B];
  }(s, u, n);
  switch (u) {
    case "country":
      return P(TZe, { allowedCountries: e.allowedCountries, classNameModifiers: a, label: O, errorMessage: D, onDropdownChange: e.onDropdownChange, value: S });
    case "stateOrProvince":
      return P(NZe, { classNameModifiers: a, label: O, errorMessage: D, onDropdownChange: e.onDropdownChange, selectedCountry: x, specifications: e.specifications, value: S });
    default:
      return P(xn, { label: O, classNameModifiers: a, errorMessage: D, isValid: c[u], name: u, i18n: n, onFocus: function($) {
        return e.onFieldFocusAnalytics(u, $);
      }, onBlur: function($) {
        return e.onFieldBlurAnalytics(u, $);
      } }, P(vi, { name: u, classNameModifiers: a, value: S, onInput: f, onBlur: m, maxlength: y, trimOnBlur: v, disabled: b, required: !E }));
  }
}
function HW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function WW(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = HW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = HW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
Ad.defaultProps = { className: "", classNameModifiers: [], filterable: !0, items: [], readonly: !1, onChange: function() {
} };
var o6 = function() {
  function e(t) {
    Qe(this, e), T(this, "specifications", void 0), this.specifications = WW(WW({}, qoe), t);
  }
  return et(e, [{ key: "countryHasDataset", value: function(t) {
    var n;
    return !((n = this.specifications) === null || n === void 0 || (n = n[t]) === null || n === void 0 || !n.hasDataset);
  } }, { key: "countryHasOptionalField", value: function(t, n) {
    var r;
    return !((r = this.specifications) === null || r === void 0 || (r = r[t]) === null || r === void 0 || (r = r.optionalFields) === null || r === void 0 || !jt(r).call(r, n));
  } }, { key: "getAddressSchemaForCountry", value: function(t) {
    var n;
    return ((n = this.specifications) === null || n === void 0 || (n = n[t]) === null || n === void 0 ? void 0 : n.schema) || this.specifications.default.schema;
  } }, { key: "getAddressLabelsForCountry", value: function(t) {
    var n;
    return ((n = this.specifications) === null || n === void 0 || (n = n[t]) === null || n === void 0 ? void 0 : n.labels) || this.specifications.default.labels;
  } }, { key: "getOptionalFieldsForCountry", value: function(t) {
    var n, r;
    return ((n = this.specifications) === null || n === void 0 || (n = n[t]) === null || n === void 0 ? void 0 : n.optionalFields) || ((r = this.specifications.default) === null || r === void 0 ? void 0 : r.optionalFields) || [];
  } }, { key: "getKeyForField", value: function(t, n) {
    var r, a;
    return ((r = this.specifications) === null || r === void 0 || (r = r[n]) === null || r === void 0 || (r = r.labels) === null || r === void 0 ? void 0 : r[t]) || ((a = this.specifications) === null || a === void 0 || (a = a.default) === null || a === void 0 || (a = a.labels) === null || a === void 0 ? void 0 : a[t]) || t;
  } }, { key: "getPlaceholderKeyForField", value: function(t, n) {
    var r, a;
    return ((r = this.specifications) === null || r === void 0 || (r = r[n]) === null || r === void 0 || (r = r.placeholders) === null || r === void 0 ? void 0 : r[t]) || ((a = this.specifications) === null || a === void 0 || (a = a.default) === null || a === void 0 || (a = a.placeholders) === null || a === void 0 ? void 0 : a[t]);
  } }, { key: "getAddressSchemaForCountryFlat", value: function(t) {
    var n, r;
    return Oe(n = Yae(r = this.getAddressSchemaForCountry(t)).call(r, 2)).call(n, function(a) {
      return typeof a == "string";
    });
  } }]), e;
}(), aD = function(e) {
  var t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
  return function() {
    for (var r = this, a = arguments.length, o = new Array(a), s = 0; s < a; s++) o[s] = arguments[s];
    clearTimeout(t), t = Ro(function() {
      return e.apply(r, o);
    }, n);
  };
};
function RZe(e) {
  var t = e.onAddressLookup, n = e.onAddressSelected, r = e.onSelect, a = e.onManualAddress, o = e.externalErrorMessage, s = e.hideManualButton, c = e.addressSearchDebounceMs, u = Je([]), f = ze(u, 2), m = f[0], v = f[1], y = Je([]), b = ze(y, 2), S = b[0], x = b[1], E = Je(""), N = ze(E, 2), R = N[0], O = N[1], D = wt().i18n, $ = Kt(function(K) {
    K != null && K.errorMessage && O(K.errorMessage);
  }, []), B = Kt(function() {
    var K = On(yt.mark(function q(pe) {
      return yt.wrap(function(he) {
        for (; ; ) switch (he.prev = he.next) {
          case 0:
            new Yt(function(_e, ge) {
              t(pe, { resolve: _e, reject: ge });
            }).then(function(_e) {
              var ge;
              x(_e), v(It(ge = _e).call(ge, function(Y) {
                return { id: Y.id, name: Y.name };
              })), O("");
            }).catch(function(_e) {
              return $(_e);
            });
          case 1:
          case "end":
            return he.stop();
        }
      }, q);
    }));
    return function(q) {
      return K.apply(this, arguments);
    };
  }(), [t]);
  Rt(function() {
    O(o);
  }, [o]);
  var G = function() {
    var K = On(yt.mark(function q(pe) {
      var he;
      return yt.wrap(function(_e) {
        for (; ; ) switch (_e.prev = _e.next) {
          case 0:
            if (pe.target.value) {
              _e.next = 3;
              break;
            }
            return O(D.get("address.errors.incomplete")), _e.abrupt("return");
          case 3:
            if (he = Ji(S).call(S, function(ge) {
              return ge.id === pe.target.value;
            }), typeof n == "function") {
              _e.next = 8;
              break;
            }
            return r(he), v([]), _e.abrupt("return");
          case 8:
            new Yt(function(ge, Y) {
              n(he, { resolve: ge, reject: Y });
            }).then(function(ge) {
              r(ge), v([]);
            }).catch(function(ge) {
              return $(ge);
            });
          case 9:
          case "end":
            return _e.stop();
        }
      }, q);
    }));
    return function(q) {
      return K.apply(this, arguments);
    };
  }(), Z = Qi(function() {
    return aD(B, c);
  }, []);
  return P("div", { className: "adyen-checkout__address-search adyen-checkout__field-group" }, P(xn, { label: D.get("address"), classNameModifiers: ["address-search"], errorMessage: R, name: "address-search" }, P(Ad, { name: "address-search", className: "adyen-checkout__address-search__dropdown", onInput: Z, items: m, onChange: G, disableTextFilter: !0, blurOnClose: !0 })), !s && P("span", { className: "adyen-checkout__address-search__manual-add" }, P("button", { type: "button", className: "adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link adyen-checkout__address-search__manual-add__button", onClick: a }, "+ " + D.get("address.enterManually"))));
}
function ZW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function YS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = ZW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = ZW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function t1(e) {
  var t, n, r = wt().i18n, a = e.label, o = a === void 0 ? "" : a, s = e.requiredFields, c = e.visibility, u = e.iOSFocusedField, f = u === void 0 ? null : u, m = _n({});
  Pe(m.current).length || (n = e.setComponentRef) === null || n === void 0 || n.call(e, m.current);
  var v = Qi(function() {
    return new o6(e.specifications);
  }, [e.specifications]), y = Oe(t = v.getAddressSchemaForCountryFlat(e.countryCode)).call(t, function(Ie) {
    return jt(s).call(s, Ie);
  }), b = Je(!1), S = ze(b, 2), x = S[0], E = S[1], N = Je(!1), R = ze(N, 2), O = R[0], D = R[1], $ = Je(""), B = ze($, 2), G = B[0], Z = B[1], K = !!e.onAddressLookup, q = !e.onAddressLookup || x || O, pe = gs({ schema: y, defaultData: e.data, rules: YS(YS({}, mZe(v)), e.validationRules), formatters: fZe }), he = pe.data, _e = pe.errors, ge = pe.valid, Y = pe.isValid, ee = pe.handleChangeFor, oe = pe.triggerValidation, me = pe.setData, xe = Kt(function(Ie) {
    var Le = fu;
    Q(Le).call(Le, function(ie) {
      var $e = Ie[ie];
      $e != null && me(ie, String($e));
    }), oe(), E(!0);
  }, [E, oe, me]), X = Kt(function() {
    D(!0);
  }, []);
  m.current.showValidation = function() {
    oe(), Z(!K || q || Y ? "" : r.get("address.errors.incomplete"));
  };
  var ye = Oe(y).call(y, function(Ie) {
    return !f || Ie === f;
  });
  if (Rt(function() {
    var Ie = v.countryHasDataset(he.country) ? "" : n7, Le = YS(YS({}, he), {}, { stateOrProvince: Ie });
    Q(s).call(s, function(ie) {
      var $e;
      ee(ie, "input")(($e = Le[ie]) !== null && $e !== void 0 ? $e : "");
    }), Le.postalCode && ee("postalCode", "blur")(he.postalCode);
  }, [he.country]), Rt(function() {
    var Ie = jt(s).call(s, "stateOrProvince"), Le = he.country && v.countryHasDataset(he.country), ie = Ie && Le, $e = he.stateOrProvince || (ie ? "" : n7);
    ee("stateOrProvince", "input")($e);
  }, []), Rt(function() {
    var Ie = v.getOptionalFieldsForCountry(he.country), Le = rr(fu).call(fu, function(ie, $e) {
      var we = jt(Ie).call(Ie, $e), Ne = jt(s).call(s, $e), Ee = he[$e], le = e.data[$e], be = we && !Ee || !Ne ? Ne || Ee || !le ? n7 : le : Ee;
      return be != null && be.length && (ie[$e] = be), ie;
    }, {});
    e.onChange({ data: Le, valid: ge, errors: _e, isValid: Y });
  }, [he, ge, _e, Y]), c === "hidden") return null;
  if (c === "readOnly") return P(cZe, { data: he, label: o });
  var ce = function(Ie, Le) {
    var ie, $e = Le.classNameModifiers, we = $e === void 0 ? [] : $e;
    return jt(s).call(s, Ie) ? P(OZe, { key: Ie, allowedCountries: e.allowedCountries, classNameModifiers: je(ie = []).call(ie, Pn(we), [Ie]), data: he, errors: _e, valid: ge, fieldName: Ie, onInput: ee(Ie, "input"), onBlur: ee(Ie, "blur"), onDropdownChange: ee(Ie, "blur"), specifications: v, maxLength: qWe(nD, Ie, he.country), trimOnBlur: !0, disabled: !jt(ye).call(ye, Ie), onFieldFocusAnalytics: e.onFieldFocusAnalytics, onFieldBlurAnalytics: e.onFieldBlurAnalytics }) : null;
  }, se = v.getAddressSchemaForCountry(he.country);
  return P(ra, null, P(tv, { classNameModifiers: [o || "address"], label: o }, K && P(RZe, { onAddressLookup: e.onAddressLookup, onAddressSelected: e.onAddressSelected, onSelect: xe, onManualAddress: X, externalErrorMessage: G, hideManualButton: q, addressSearchDebounceMs: e.addressSearchDebounceMs }), q && P(ra, null, It(se).call(se, function(Ie) {
    return Ie instanceof Array ? P("div", { className: "adyen-checkout__field-group" }, It(Le = Ie).call(Le, function(ie) {
      var $e = ze(ie, 2), we = $e[0], Ne = $e[1];
      return ce(we, { classNameModifiers: ["col-".concat(Ne)] });
    })) : ce(Ie, {});
    var Le;
  }))), !1);
}
t1.defaultProps = { countryCode: null, validationRules: null, data: {}, onChange: function() {
}, visibility: "editable", requiredFields: fu, specifications: {}, onFieldFocusAnalytics: function() {
}, onFieldBlurAnalytics: function() {
} };
var MZe = ["classNameModifiers", "label", "isInvalid", "onChange"], DZe = ["uniqueId", "addContextualElement"];
function U2(e) {
  var t, n = e.classNameModifiers, r = n === void 0 ? [] : n, a = e.label, o = e.isInvalid, s = e.onChange, c = pa(e, MZe), u = c.uniqueId, f = c.addContextualElement, m = pa(c, DZe);
  return P("label", { className: "adyen-checkout__checkbox", htmlFor: u }, P("input", kt({ id: u }, m, f && { "aria-describedby": je(t = "".concat(u)).call(t, F0) }, { className: Tt(["adyen-checkout__checkbox__input", [c.className], { "adyen-checkout__checkbox__input--invalid": o }, It(r).call(r, function(v) {
    return "adyen-checkout__input--".concat(v);
  })]), type: "checkbox", onChange: s })), P("span", { className: "adyen-checkout__checkbox__label" }, a));
}
U2.defaultProps = { onChange: function() {
} };
var LZe = ["errorMessage", "label", "onChange", "i18n"];
function mO(e) {
  var t, n, r, a = e.errorMessage, o = e.label, s = e.onChange, c = e.i18n, u = pa(e, LZe);
  return P(xn, { classNameModifiers: ["consentCheckbox"], errorMessage: a, i18n: c, name: "consentCheckbox", useLabelElement: !1, label: c.get("creditCard.holderName") }, P(U2, { name: "consentCheckbox", classNameModifiers: je(t = []).call(t, Pn((n = u.classNameModifiers) !== null && n !== void 0 ? n : u.classNameModifiers = []), ["consentCheckbox"]), onInput: s, value: u == null || (r = u.data) === null || r === void 0 ? void 0 : r.consentCheckbox, label: o, checked: u.checked }));
}
var jy = ["companyDetails", "personalDetails", "billingAddress", "deliveryAddress", "bankAccount"], $Ze = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return rr(jy).call(jy, function(n, r) {
    var a = e[r] !== "hidden", o = r === "deliveryAddress", s = (e == null ? void 0 : e.billingAddress) === "hidden";
    return n[r] = a && (!o || s || function() {
      return Pe(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).length > 1;
    }(t[r])), n;
  }, {});
}, jZe = function(e, t, n) {
  var r, a, o = e, s = o.split(":"), c = s.length > 1;
  c && (a = s[0], o = s[1]);
  var u = function(f, m, v) {
    return jt(fu).call(fu, f) ? v != null && v[f] ? m.get(v == null ? void 0 : v[f]) : m.get(f) : null;
  }(o, t, n);
  return u && a ? c ? je(r = "".concat(t.get(a), " ")).call(r, u) : u : null;
}, Rm = { AD: { length: 24, structure: "F04F04A12", example: "AD9912345678901234567890" }, AE: { length: 23, structure: "F03F16", example: "AE993331234567890123456" }, AL: { length: 28, structure: "F08A16", example: "AL47212110090000000235698741" }, AT: { length: 20, structure: "F05F11", example: "AT611904300234573201" }, AZ: { length: 28, structure: "U04A20", example: "AZ21NABZ00000000137010001944" }, BA: { length: 20, structure: "F03F03F08F02", example: "BA391290079401028494" }, BE: { length: 16, structure: "F03F07F02", example: "BE68 5390 0754 7034" }, BG: { length: 22, structure: "U04F04F02A08", example: "BG80BNBG96611020345678" }, BH: { length: 22, structure: "U04A14", example: "BH67BMAG00001299123456" }, BR: { length: 29, structure: "F08F05F10U01A01", example: "BR9700360305000010009795493P1" }, CH: { length: 21, structure: "F05A12", example: "CH9300762011623852957" }, CR: { length: 22, structure: "F04F14", example: "CR72012300000171549015" }, CY: { length: 28, structure: "F03F05A16", example: "CY17002001280000001200527600" }, CZ: { length: 24, structure: "F04F06F10", example: "CZ6508000000192000145399" }, DE: { length: 22, structure: "F08F10", example: "DE00123456789012345678" }, DK: { length: 18, structure: "F04F09F01", example: "DK5000400440116243" }, DO: { length: 28, structure: "U04F20", example: "DO28BAGR00000001212453611324" }, EE: { length: 20, structure: "F02F02F11F01", example: "EE382200221020145685" }, ES: { length: 24, structure: "F04F04F01F01F10", example: "ES9121000418450200051332" }, FI: { length: 18, structure: "F06F07F01", example: "FI2112345600000785" }, FO: { length: 18, structure: "F04F09F01", example: "FO6264600001631634" }, FR: { length: 27, structure: "F05F05A11F02", example: "FR1420041010050500013M02606" }, GB: { length: 22, structure: "U04F06F08", example: "GB29NWBK60161331926819" }, GE: { length: 22, structure: "U02F16", example: "GE29NB0000000101904917" }, GI: { length: 23, structure: "U04A15", example: "GI75NWBK000000007099453" }, GL: { length: 18, structure: "F04F09F01", example: "GL8964710001000206" }, GR: { length: 27, structure: "F03F04A16", example: "GR1601101250000000012300695" }, GT: { length: 28, structure: "A04A20", example: "GT82TRAJ01020000001210029690" }, HR: { length: 21, structure: "F07F10", example: "HR1210010051863000160" }, HU: { length: 28, structure: "F03F04F01F15F01", example: "HU42117730161111101800000000" }, IE: { length: 22, structure: "U04F06F08", example: "IE29AIBK93115212345678" }, IL: { length: 23, structure: "F03F03F13", example: "IL620108000000099999999" }, IS: { length: 26, structure: "F04F02F06F10", example: "IS140159260076545510730339" }, IT: { length: 27, structure: "U01F05F05A12", example: "IT60X0542811101000000123456" }, KW: { length: 30, structure: "U04A22", example: "KW81CBKU0000000000001234560101" }, KZ: { length: 20, structure: "F03A13", example: "KZ86125KZT5004100100" }, LB: { length: 28, structure: "F04A20", example: "LB62099900000001001901229114" }, LC: { length: 32, structure: "U04F24", example: "LC07HEMM000100010012001200013015" }, LI: { length: 21, structure: "F05A12", example: "LI21088100002324013AA" }, LT: { length: 20, structure: "F05F11", example: "LT121000011101001000" }, LU: { length: 20, structure: "F03A13", example: "LU280019400644750000" }, LV: { length: 21, structure: "U04A13", example: "LV80BANK0000435195001" }, MC: { length: 27, structure: "F05F05A11F02", example: "MC5811222000010123456789030" }, MD: { length: 24, structure: "U02A18", example: "MD24AG000225100013104168" }, ME: { length: 22, structure: "F03F13F02", example: "ME25505000012345678951" }, MK: { length: 19, structure: "F03A10F02", example: "MK07250120000058984" }, MR: { length: 27, structure: "F05F05F11F02", example: "MR1300020001010000123456753" }, MT: { length: 31, structure: "U04F05A18", example: "MT84MALT011000012345MTLCAST001S" }, MU: { length: 30, structure: "U04F02F02F12F03U03", example: "MU17BOMM0101101030300200000MUR" }, NL: { length: 18, structure: "U04F10", example: "NL99BANK0123456789" }, NO: { length: 15, structure: "F04F06F01", example: "NO9386011117947" }, PK: { length: 24, structure: "U04A16", example: "PK36SCBL0000001123456702" }, PL: { length: 28, structure: "F08F16", example: "PL00123456780912345678901234" }, PS: { length: 29, structure: "U04A21", example: "PS92PALS000000000400123456702" }, PT: { length: 25, structure: "F04F04F11F02", example: "PT50000201231234567890154" }, RO: { length: 24, structure: "U04A16", example: "RO49AAAA1B31007593840000" }, RS: { length: 22, structure: "F03F13F02", example: "RS35260005601001611379" }, SA: { length: 24, structure: "F02A18", example: "SA0380000000608010167519" }, SE: { length: 24, structure: "F03F16F01", example: "SE4550000000058398257466" }, SI: { length: 19, structure: "F05F08F02", example: "SI56263300012039086" }, SK: { length: 24, structure: "F04F06F10", example: "SK3112000000198742637541" }, SM: { length: 27, structure: "U01F05F05A12", example: "SM86U0322509800000000270100" }, ST: { length: 25, structure: "F08F11F02", example: "ST68000100010051845310112" }, TL: { length: 23, structure: "F03F14F02", example: "TL380080012345678910157" }, TN: { length: 24, structure: "F02F03F13F02", example: "TN5910006035183598478831" }, TR: { length: 26, structure: "F05F01A16", example: "TR330006100519786457841326" }, VG: { length: 24, structure: "U04F16", example: "VG96VPVG0000012345678901" }, XK: { length: 20, structure: "F04F10F02", example: "XK051212012345678906" }, AO: { length: 25, structure: "F21", example: "AO69123456789012345678901" }, BF: { length: 27, structure: "F23", example: "BF2312345678901234567890123" }, BI: { length: 16, structure: "F12", example: "BI41123456789012" }, BJ: { length: 28, structure: "F24", example: "BJ39123456789012345678901234" }, CI: { length: 28, structure: "U01F23", example: "CI17A12345678901234567890123" }, CM: { length: 27, structure: "F23", example: "CM9012345678901234567890123" }, CV: { length: 25, structure: "F21", example: "CV30123456789012345678901" }, DZ: { length: 24, structure: "F20", example: "DZ8612345678901234567890" }, IR: { length: 26, structure: "F22", example: "IR861234568790123456789012" }, JO: { length: 30, structure: "A04F22", example: "JO15AAAA1234567890123456789012" }, MG: { length: 27, structure: "F23", example: "MG1812345678901234567890123" }, ML: { length: 28, structure: "U01F23", example: "ML15A12345678901234567890123" }, MZ: { length: 25, structure: "F21", example: "MZ25123456789012345678901" }, QA: { length: 29, structure: "U04A21", example: "QA30AAAA123456789012345678901" }, SN: { length: 28, structure: "U01F23", example: "SN52A12345678901234567890123" }, UA: { length: 29, structure: "F25", example: "UA511234567890123456789012345" } }, vO = function(e) {
  var t;
  return zp(t = e.replace(/\W/gi, "").replace(/(.{4})(?!$)/g, "$1 ")).call(t);
}, i6 = function(e) {
  return e.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
}, FZe = function(e, t) {
  return function(n, r) {
    var a;
    if (r === null || !Rm[r] || !Rm[r].structure) return !1;
    var o = Rm[r].structure, s = It(a = o.match(/(.{3})/g)).call(a, function(c) {
      var u, f, m = Xo(c).call(c, 0, 1), v = Ou(Xo(c).call(c, 1), 10);
      switch (m) {
        case "A":
          f = "0-9A-Za-z";
          break;
        case "B":
          f = "0-9A-Z";
          break;
        case "C":
          f = "A-Za-z";
          break;
        case "F":
          f = "0-9";
          break;
        case "L":
          f = "a-z";
          break;
        case "U":
          f = "A-Z";
          break;
        case "W":
          f = "0-9a-z";
      }
      return je(u = "([".concat(f, "]{")).call(u, v, "})");
    });
    return new RegExp("^".concat(s.join(""), "$"));
  }(0, t);
}, BZe = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
  return e && Rm[e] && Rm[e].example ? vO(Rm[e].example) : "AB00 1234 5678 9012 3456 7890";
}, rie = function(e) {
  return Xo(e).call(e, 0, 2);
};
function yy(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  this.status = e, this.code = t;
}
var VZe = function(e) {
  var t = i6(e), n = function(a) {
    var o, s = a, c = 65, u = 90;
    return s = (s = s.toUpperCase()).substr(4) + s.substr(0, 4), It(o = s.split("")).call(o, function(f) {
      var m = f.charCodeAt(0);
      return m >= c && m <= u ? m - c + 10 : f;
    }).join("");
  }(t), r = function(a) {
    for (var o, s = a; s.length > 2; ) o = Xo(s).call(s, 0, 9), s = Ou(o, 10) % 97 + Xo(s).call(s, o.length);
    return Ou(s, 10) % 97;
  }(n) === 1;
  return r && function(a) {
    var o = Xo(a).call(a, 0, 2), s = FZe(0, o);
    return s.test && s.test(Xo(a).call(a, 4)) || !1;
  }(t);
}, u4 = function(e) {
  var t = i6(e);
  if (e.length < 2) return new yy("no-validate", "TOO_SHORT");
  var n = function(r) {
    return !(!r || !Rm[r]) && Rm[r];
  }(rie(t));
  return n ? t.length > n.length ? new yy("invalid", "TOO_LONG") : t.length === n.length ? VZe(e) ? new yy("valid", "VALID") : new yy("invalid", "INVALID_IBAN") : new yy("no-validate", "UNKNOWN") : new yy("invalid", "INVALID_COUNTRY");
}, XS = function(e) {
  return !ul(e) || null;
};
function YW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ou(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = YW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = YW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function UZe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var XW = { isValid: !1, errorMessage: "ach.accountHolderNameField.invalid", error: "ach.accountHolderNameField.invalid" }, KP = { isValid: !1, errorMessage: "sepaDirectDebit.ibanField.invalid", error: "sepaDirectDebit.ibanField.invalid" }, oD = function(e) {
  ft(n, yo);
  var t = UZe(n);
  function n(r) {
    var a, o, s, c;
    if (Qe(this, n), c = t.call(this, r), T(Se(c), "ibanNumber", void 0), T(Se(c), "setData", function(y, b, S) {
      c.setState(function(x) {
        return { data: ou(ou({}, x.data), {}, T({}, y, b)) };
      }, S);
    }), T(Se(c), "setError", function(y, b, S) {
      c.setState(function(x) {
        return { errors: ou(ou({}, x.errors), {}, T({}, y, b)) };
      }, S);
    }), T(Se(c), "setValid", function(y, b, S) {
      c.setState(function(x) {
        return { valid: ou(ou({}, x.valid), {}, T({}, y, b)) };
      }, S);
    }), T(Se(c), "handleHolderInput", function(y) {
      c.setState(function(b) {
        return { data: ou(ou({}, b.data), {}, { ownerName: y }) };
      }, function() {
        var b = XS(c.state.data.ownerName), S = b == null || b ? null : XW;
        c.setError("holder", S, c.onChange);
      });
    }), T(Se(c), "handleIbanInput", function(y) {
      var b = y.target.value, S = i6(b), x = vO(S), E = u4(x).status, N = rie(S), R = y.target.selectionStart, O = c.state.data.ibanNumber, D = function($, B, G) {
        if ($ === 0 || !B.length) return 0;
        var Z = B.length - G.length, K = Z > 0, q = function(he, _e) {
          return /\s/.test(he.charAt(_e));
        }, pe = $ - Z;
        return K && (q(B, pe + 1) || q(B, pe)) ? $ + 1 : !K && q(B, $ - 1) ? $ - 1 : $;
      }(R, x, O);
      c.setState(function($) {
        return { data: ou(ou({}, $.data), {}, { ibanNumber: x, countryCode: N }), errors: ou(ou({}, $.errors), {}, { iban: E === "invalid" ? KP : null }), valid: ou(ou({}, $.valid), {}, { iban: E === "valid" }) };
      }, function() {
        y.target.setSelectionRange(D, D), c.onChange();
      });
    }), T(Se(c), "handleIbanBlur", function(y) {
      var b = y.target.value;
      if (b.length > 0) {
        var S = u4(b).status;
        c.setError("iban", S !== "valid" ? KP : null, c.onChange);
      } else c.setError("iban", null, c.onChange);
    }), c.state = { status: "ready", data: { ownerName: (r == null || (a = r.data) === null || a === void 0 ? void 0 : a.ownerName) || "", ibanNumber: (r == null || (o = r.data) === null || o === void 0 ? void 0 : o.ibanNumber) || "", countryCode: (r == null || (s = r.data) === null || s === void 0 ? void 0 : s.countryCode) || "" }, isValid: !1, cursor: 0, errors: {}, valid: {} }, c.state.data.ibanNumber) {
      var u = i6(c.state.data.ibanNumber);
      c.state.data.ibanNumber = vO(u);
    }
    if (c.state.data.ibanNumber || c.state.data.ownerName) {
      var f = c.props.holderName ? XS(c.state.data.ownerName) : "", m = (c.state.data.ibanNumber ? u4(c.state.data.ibanNumber).status === "valid" : "") && f, v = { data: c.state.data, isValid: m };
      c.props.onChange(v);
    }
    return c;
  }
  return et(n, [{ key: "setStatus", value: function(r) {
    this.setState({ status: r });
  } }, { key: "onChange", value: function() {
    var r = !this.props.holderName || XS(this.state.data.ownerName), a = u4(this.state.data.ibanNumber).status === "valid" && r, o = { data: this.state.data, isValid: a, errors: this.state.errors };
    this.props.onChange(o);
  } }, { key: "showValidation", value: function() {
    var r = u4(this.state.data.ibanNumber).status, a = XS(this.state.data.ownerName);
    this.setError("iban", r !== "valid" ? KP : null);
    var o = a ? null : XW;
    this.setError("holder", o, this.onChange);
  } }, { key: "render", value: function(r, a) {
    var o = this, s = r.placeholders, c = r.countryCode, u = a.data, f = a.errors, m = a.valid, v = wt().i18n;
    return P(tv, { classNameModifiers: ["iban-input"], label: this.props.label }, this.props.holderName && P(xn, { className: "adyen-checkout__field--owner-name", label: v.get("sepa.ownerName"), filled: u.ownerName && u.ownerName.length, errorMessage: !!f.holder && v.get(f.holder.error), dir: "ltr", i18n: v, name: "ownerName" }, P(vi, { name: "ownerName", className: "adyen-checkout__iban-input__owner-name", placeholder: "ownerName" in s ? s.ownerName : v.get("sepaDirectDebit.nameField.placeholder"), value: u.ownerName, "aria-invalid": !!this.state.errors.holder, "aria-label": v.get("sepa.ownerName"), onInput: function(y) {
      return o.handleHolderInput(y.target.value);
    }, onBlur: function(y) {
      return o.handleHolderInput(y.target.value);
    } })), P(xn, { className: "adyen-checkout__field--iban-number", label: v.get("sepa.ibanNumber"), errorMessage: !!f.iban && v.get(f.iban.error), filled: u.ibanNumber && u.ibanNumber.length, isValid: m.iban, onBlur: this.handleIbanBlur, dir: "ltr", i18n: v, name: "ibanNumber" }, P(vi, { setRef: function(y) {
      o.ibanNumber = y;
    }, name: "ibanNumber", className: "adyen-checkout__iban-input__iban-number", classNameModifiers: ["large"], placeholder: "ibanNumber" in s ? s.ibanNumber : BZe(c), value: u.ibanNumber, onInput: this.handleIbanInput, "aria-invalid": !!this.state.errors.iban, "aria-label": v.get("sepa.ibanNumber"), autocorrect: "off", spellcheck: !1 })), this.props.showPayButton && this.props.payButton({ status: this.state.status }));
  } }]), n;
}();
T(oD, "defaultProps", { onChange: function() {
}, countryCode: null, holderName: !0, placeholders: {}, label: null });
var Qp = function() {
  var e = wt().i18n;
  return P("p", { className: "adyen-checkout-form-instruction" }, e.get("form.instruction"));
};
function KW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
var aie = function(e) {
  var t, n = hi[e];
  return n || (n = Ji(t = Pe(hi)).call(t, function(r) {
    return hi[r] === e;
  })) || e;
}, GZe = function(e, t) {
  var n = function(r) {
    for (var a = 1; a < arguments.length; a++) {
      var o, s, c = arguments[a] != null ? arguments[a] : {};
      a % 2 ? Q(o = KW(Object(c), !0)).call(o, function(u) {
        T(r, u, c[u]);
      }) : ne ? Ze(r, ne(c)) : Q(s = KW(Object(c))).call(s, function(u) {
        We(r, u, re(c, u));
      });
    }
    return r;
  }({}, e);
  return n.error = n.error ? n.error : function(r) {
    var a = Pe(hi);
    return rr(a).call(a, function(o, s) {
      var c = hi[s];
      return (ka(c).call(c, "sf-") > -1 || ka(c).call(c, "gen.01") > -1) && (o[c] = r.get(c)), o;
    }, {});
  }(t), n;
}, zZe = function(e, t) {
  for (var n, r = e, a = 0, o = K_(t); a < o.length; a++) {
    var s = ze(o[a], 2), c = s[0];
    if (s[1] === e) {
      r = c;
      break;
    }
  }
  return (n = r) === null || n === void 0 ? void 0 : n.toLowerCase().replace(/[_.\s]/g, "-");
}, HZe = function(e, t) {
  var n = e.i18n, r = e.fieldTypeMappingFn, a = e.SRPanelRef, o = t.errors, s = t.isValidating, c = t.layout, u = function(v) {
    var y, b = v.errors, S = v.i18n, x = v.layout, E = v.countrySpecificLabels, N = v.fieldTypeMappingFn, R = rr(y = K_(b)).call(y, function(O, D) {
      var $ = ze(D, 2), B = $[0];
      if ($[1]) {
        var G, Z, K, q, pe = b[B];
        G = pe instanceof fO ? mi(pe.errorMessage) === "object" ? pe.errorMessage.translationKey : pe.errorMessage : pe.error;
        var he = Z = pe instanceof fO || !("errorI18n" in pe) ? mi(pe.errorMessage) === "object" ? je(K = je(q = "".concat(S.get(pe.errorMessage.translationKey), " ")).call(q, gd(pe.errorMessage.translationObject).format)).call(K, "") : S.get(pe.errorMessage) + "" : pe.errorI18n + "";
        if (N) {
          var _e, ge = N(B, S, E);
          ge && (he = je(_e = "".concat(ge, ": ")).call(_e, Z));
        }
        O.push({ field: B, errorMessage: he, errorCode: G }), x && qx(O).call(O, function(Y, ee) {
          return ka(x).call(x, Y.field) - ka(x).call(x, ee.field);
        });
      }
      return O;
    }, []);
    return R;
  }({ errors: o, i18n: n, fieldTypeMappingFn: r, countrySpecificLabels: t.countrySpecificLabels, layout: c });
  if (u.length) {
    if (s) {
      var f = It(u).call(u, function(v) {
        return v.errorMessage;
      });
      a.setMessages(f);
      var m = It(u).call(u, function(v) {
        return v.field;
      });
      return { currentErrorsSortedByLayout: u, action: R8, fieldToFocus: m[0] };
    }
    return a == null || a.setMessages(null), { currentErrorsSortedByLayout: u, action: JM };
  }
  return a == null || a.setMessages(null), { currentErrorsSortedByLayout: u, action: "none" };
}, qW = function(e, t) {
  var n;
  return e ? rr(n = K_(e)).call(n, function(r, a) {
    var o, s = ze(a, 2), c = s[0], u = s[1];
    return u && (r[je(o = "".concat(t)).call(o, c)] = u), r;
  }, {}) : null;
}, oie = IM({ srPanel: null, setSRMessagesFromObjects: null, setSRMessagesFromStrings: null, clearSRPanel: null, shouldMoveFocusSR: null });
function oC() {
  return GM(oie);
}
var iie = function(e, t) {
  var n = [];
  return e && typeof e.querySelectorAll == "function" && (n = Xo([]).call(e.querySelectorAll(t))), n;
}, Ru = function(e, t) {
  if (e) return e.querySelector(t);
}, r7 = function(e, t) {
  if (e) return e.getAttribute(t);
}, s6 = function(e, t, n, r) {
  if (typeof e.addEventListener != "function") {
    if (!e.attachEvent) throw new Error(": Unable to bind ".concat(t, "-event"));
    e.attachEvent("on".concat(t), n);
  } else e.addEventListener(t, n, r);
}, l6 = function(e, t, n, r) {
  if (typeof e.addEventListener == "function") e.removeEventListener(t, n, r);
  else {
    if (!e.attachEvent) throw new Error(": Unable to unbind ".concat(t, "-event"));
    e.detachEvent("on".concat(t), n);
  }
}, sie = function(e, t) {
  var n = Ru(document, e), r = t === "issuer" ? "issuer-list" : t;
  if (r === "country" || r === "stateOrProvince" || r === "issuer-list") {
    var a = Ru(n, ".adyen-checkout__field--".concat(r, " .adyen-checkout__filter-input"));
    a == null || a.focus();
  } else {
    var o = Ru(n, '[name="'.concat(r, '"]'));
    o == null || o.focus();
  }
};
function lie(e) {
  var t = _n();
  return Rt(function() {
    t.current = e;
  }, [e]), t.current;
}
function gO(e, t, n) {
  var r, a = n;
  return e.length !== 1 || t || (r = e), e.length > (t == null ? void 0 : t.length) && (r = Oe(e).call(e, function(o) {
    var s = o[a];
    return !A8(t).call(t, function(c) {
      return c[a] === s;
    });
  })), r;
}
var WZe = ["companyDetails", "personalDetails", "bankAccount", "billingAddress", "deliveryAddress"];
function JW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function dm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = JW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = JW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function QW(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ds(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = QW(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = QW(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var eZ = { isValid: !1, errorMessage: "consent.checkbox.invalid", error: "consent.checkbox.invalid" };
function ZZe(e) {
  var t, n, r, a, o, s, c = e.countryCode, u = e.visibility, f = wt().i18n, m = _n({});
  Pe(m.current).length || (s = e.setComponentRef) === null || s === void 0 || s.call(e, m.current);
  var v = _n(!1), y = Je($Ze(u, e.data)), b = ze(y, 2), S = b[0], x = b[1], E = _n(rr(jy).call(jy, function(ye, ce) {
    return ye[ce] = function(se) {
      E[ce].current = se;
    }, ye;
  }, {})).current, N = !!e.consentCheckboxLabel, R = !N && $m(t = Pe(S)).call(t, function(ye) {
    return !S[ye];
  }), O = u.deliveryAddress === "editable" && u.billingAddress !== "hidden", D = Je(Ds(Ds({}, e.data), N && { consentCheckbox: !1 })), $ = ze(D, 2), B = $[0], G = $[1], Z = Je({}), K = ze(Z, 2), q = K[0], pe = K[1], he = Je({}), _e = ze(he, 2), ge = _e[0], Y = _e[1], ee = Je("ready"), oe = ze(ee, 2), me = oe[0], xe = oe[1];
  m.current.showValidation = function() {
    v.current = !0, Q(jy).call(jy, function(ye) {
      E[ye].current && E[ye].current.showValidation();
    }), pe(Ds({}, N && { consentCheckbox: B.consentCheckbox ? null : eZ }));
  }, m.current.setStatus = xe, function(ye) {
    var ce = ye.errors, se = ye.data, Ie = ye.props, Le = ye.isValidating, ie = Je(null), $e = ze(ie, 2), we = $e[0], Ne = $e[1], Ee = lie(we), le = oC(), be = le.setSRMessagesFromObjects, He = le.setSRMessagesFromStrings, Ae = le.clearSRPanel, it = le.shouldMoveFocusSR, ut = be == null ? void 0 : be({ fieldTypeMappingFn: jZe }), St = Qi(function() {
      return new o6();
    }, []), sn = Qi(function() {
      return new o6(Ie.deliveryAddressSpecification);
    }, []);
    Rt(function() {
      try {
        var zn, dn, $t, qt, fn, At = "deliveryAddress:", Wt = "billingAddress:", Xr = ce.companyDetails, Kn = ce.personalDetails, Sr = ce.bankAccount, jo = ce.billingAddress, ei = ce.deliveryAddress, tt = pa(ce, WZe), bt = qW(jo, Wt), rn = qW(ei, At), Rn = dm(dm(dm(dm(dm(dm({}, mi(Xr) === "object" && Xr), mi(Kn) === "object" && Kn), mi(Sr) === "object" && Sr), mi(bt) === "object" && bt), mi(rn) === "object" && rn), tt), Cn = zoe, Qn = (zn = Ie.personalDetailsRequiredFields) !== null && zn !== void 0 ? zn : t7, er = Oe(t7).call(t7, function(So) {
          return Qn == null ? void 0 : jt(Qn).call(Qn, So);
        }), oo = St.getAddressSchemaForCountryFlat((dn = se.billingAddress) === null || dn === void 0 ? void 0 : dn.country), Lr = It(oo).call(oo, function(So) {
          var Fo;
          return je(Fo = "".concat(Wt)).call(Fo, So);
        }), ia = sn.getAddressSchemaForCountryFlat(($t = se.deliveryAddress) === null || $t === void 0 ? void 0 : $t.country), ir = It(ia).call(ia, function(So) {
          var Fo;
          return je(Fo = "".concat(At)).call(Fo, So);
        }), xr = je(Cn).call(Cn, er, ["holder", "iban"], Lr, ir, ["consentCheckbox"]), wo = St.getAddressLabelsForCountry((qt = se.billingAddress) === null || qt === void 0 ? void 0 : qt.country), es = sn.getAddressLabelsForCountry((fn = se.deliveryAddress) === null || fn === void 0 ? void 0 : fn.country), ti = ut == null ? void 0 : ut({ errors: Rn, isValidating: Le.current, layout: xr, countrySpecificLabels: dm(dm({}, wo), es) }), bs = ti == null ? void 0 : ti.currentErrorsSortedByLayout;
        switch (Ne(bs), ti == null ? void 0 : ti.action) {
          case R8:
            it && sie(".adyen-checkout__open-invoice", ti.fieldToFocus), Ro(function() {
              Le.current = !1;
            }, 300);
            break;
          case JM:
            var _s = gO(bs, Ee, "field"), ni = _s == null ? void 0 : _s[0];
            if (ni) {
              var Ka = ni.errorCode === "shopperEmail.invalid" ? ni.errorMessage : null;
              He(Ka);
            } else Ae();
        }
      } catch (So) {
      }
    }, [ce, se]);
  }({ errors: q, data: B, props: e, isValidating: v }), Rt(function() {
    var ye = function() {
      var Le;
      return $m(Le = Pe(S)).call(Le, function(ie) {
        return !S[ie] || !!ge[ie];
      });
    }(), ce = !N || !!ge.consentCheckbox, se = ye && ce, Ie = function(Le, ie) {
      var $e, we;
      return rr($e = Oe(we = Pe(ie)).call(we, function(Ne) {
        return Le[Ne];
      })).call($e, function(Ne, Ee) {
        return Ne[Ee] = ie[Ee], Ne;
      }, {});
    }(S, B);
    e.onChange({ data: Ie, errors: q, valid: ge, isValid: se });
  }, [B, S]);
  var X = function(ye) {
    return function(ce) {
      G(function(se) {
        return Ds(Ds({}, se), {}, T({}, ye, ce.data));
      }), Y(function(se) {
        return Ds(Ds({}, se), {}, T({}, ye, ce.isValid));
      }), pe(function(se) {
        return Ds(Ds({}, se), {}, T({}, ye, ce.errors));
      });
    };
  };
  return P("div", { className: "adyen-checkout__open-invoice" }, e.showFormInstruction && P(Qp, null), S.companyDetails && P(Hoe, { data: e.data.companyDetails, label: "companyDetails", onChange: X("companyDetails"), setComponentRef: E.companyDetails, visibility: u.companyDetails }), S.personalDetails && P(aC, { data: e.data.personalDetails, requiredFields: e.personalDetailsRequiredFields, label: "personalDetails", onChange: X("personalDetails"), setComponentRef: E.personalDetails, visibility: u.personalDetails }), S.bankAccount && P(oD, { holderName: !0, label: "bankAccount", data: B.bankAccount, onChange: X("bankAccount"), ref: E.bankAccount }), S.billingAddress && P(t1, { allowedCountries: (n = e == null || (r = e.billingAddressSpecification) === null || r === void 0 ? void 0 : r.allowedCountries) !== null && n !== void 0 ? n : e.allowedCountries, countryCode: c, requiredFields: e.billingAddressRequiredFields, specifications: e.billingAddressSpecification, data: B.billingAddress, label: "billingAddress", onChange: X("billingAddress"), setComponentRef: E.billingAddress, visibility: u.billingAddress }), O && P(xn, { name: "separateDeliveryAddress", useLabelElement: !1, addContextualElement: !1 }, P(U2, { label: f.get("separateDeliveryAddress"), checked: S.deliveryAddress, classNameModifiers: ["separateDeliveryAddress"], name: "separateDeliveryAddress", onChange: function() {
    x(function(ye) {
      return Ds(Ds({}, ye), {}, { deliveryAddress: !S.deliveryAddress });
    });
  } })), S.deliveryAddress && P(t1, { allowedCountries: (a = e == null || (o = e.deliveryAddressSpecification) === null || o === void 0 ? void 0 : o.allowedCountries) !== null && a !== void 0 ? a : e.allowedCountries, countryCode: c, requiredFields: e.deliveryAddressRequiredFields, specifications: e.deliveryAddressSpecification, data: B.deliveryAddress, label: "deliveryAddress", onChange: X("deliveryAddress"), setComponentRef: E.deliveryAddress, visibility: u.deliveryAddress }), N && P(mO, { data: B, errorMessage: !!q.consentCheckbox, label: e.consentCheckboxLabel, onChange: function(ye) {
    var ce = ye.target.checked;
    G(function(se) {
      return Ds(Ds({}, se), {}, { consentCheckbox: ce });
    }), Y(function(se) {
      return Ds(Ds({}, se), {}, { consentCheckbox: ce });
    }), pe(function(se) {
      return Ds(Ds({}, se), { consentCheckbox: ce ? null : eZ });
    });
  }, i18n: f }), e.showPayButton && e.payButton({ status: me, classNameModifiers: Pn(R ? ["standalone"] : []), label: f.get("confirmPurchase") }));
}
function YZe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var hr = function(e) {
  ft(n, yo);
  var t = YZe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "state", { loaded: !1 }), a;
  }
  return et(n, [{ key: "componentDidMount", value: function() {
    var r = this;
    this.props.i18n ? this.props.i18n.loaded.then(function() {
      r.setState({ loaded: !0 });
    }) : this.setState({ loaded: !0 }), this.props.i18n && this.props.loadingContext && this.props.resources || console.error("CoreProvider - WARNING core provider is missing one of the following: i18n, loadingContext or resources");
  } }, { key: "render", value: function(r) {
    var a = r.children;
    return this.state.loaded ? P(Aoe.Provider, { value: { i18n: this.props.i18n, loadingContext: this.props.loadingContext, commonProps: this.props.commonProps || {}, resources: this.props.resources } }, xM(a)) : null;
  } }]), n;
}(), tZ = Object.prototype.toString;
function M8(e) {
  return mi(e) === "object" && e !== null && Object.prototype.toString.call(e) === "[object Array]";
}
function Mp(e) {
  return e != null;
}
function a7(e) {
  return e !== !1 && Mp(e);
}
function qP(e) {
  return !!e && mi(e) === "object";
}
function uie(e, t) {
  var n, r = mi(e), a = mi(t);
  return e && t && r === "object" && r === a ? Pe(e).length === Pe(t).length && $m(n = Pe(e)).call(n, function(o) {
    return uie(e[o], t[o]);
  }) : e === t;
}
function XZe(e) {
  return !a7(e) || !(!(typeof (t = e) == "number" || qP(t) && tZ.call(t) === "[object Number]") || e !== 0 && !cGe(e)) || !(!M8(e) && !function(n) {
    return typeof n == "string" || qP(n) && tZ.call(n) === "[object String]";
  }(e) || e.length !== 0) || !(!qP(e) || Pe(e).length !== 0);
  var t;
}
function yf() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  var r = t, a = r.shift();
  return function() {
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a.apply(this, je(r).call(r, s));
  };
}
var eh = function(e) {
  var t = e.srPanel, n = e.children, r = wt().i18n, a = t.moveFocus;
  return P(oie.Provider, { value: { srPanel: t, setSRMessagesFromObjects: function(o) {
    var s = o.fieldTypeMappingFn;
    return yf(HZe, { SRPanelRef: t, i18n: r, fieldTypeMappingFn: s });
  }, setSRMessagesFromStrings: function(o) {
    t.setMessages(o);
  }, clearSRPanel: function() {
    t.setMessages(null);
  }, shouldMoveFocusSR: a } }, n);
};
function nZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Al(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = nZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = nZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function KZe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var gu = function(e) {
  ft(n, Dr);
  var t = KZe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "formatProps", value: function(r) {
    var a, o = r.countryCode || ((a = r.data) === null || a === void 0 || (a = a.billingAddress) === null || a === void 0 ? void 0 : a.countryCode);
    return Al(Al({}, r), {}, { allowedCountries: [o], visibility: Al(Al({}, n.defaultProps.visibility), r.visibility), data: Al(Al({}, r.data), {}, { billingAddress: Al(Al({}, r.data.billingAddress), {}, { country: o }), deliveryAddress: Al(Al({}, r.data.deliveryAddress), {}, { country: o }) }) });
  } }, { key: "formatData", value: function() {
    var r = this.state.data, a = r === void 0 ? {} : r, o = a.companyDetails, s = o === void 0 ? {} : o, c = a.personalDetails, u = c === void 0 ? {} : c, f = a.billingAddress, m = a.deliveryAddress, v = a.bankAccount;
    return Al(Al(Al(Al(Al({ paymentMethod: { type: this.constructor.type } }, u), s), v && { bankAccount: { iban: v.ibanNumber, ownerName: v.ownerName, countryCode: v.countryCode } }), f && { billingAddress: f }), (m || f) && { deliveryAddress: m || f });
  } }, { key: "render", value: function() {
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(eh, { srPanel: this.props.modules.srPanel }, P(ZZe, kt({ setComponentRef: this.setComponentRef }, this.props, this.state, { onChange: this.setState, onSubmit: this.submit, payButton: this.payButton }))));
  } }]), n;
}();
function cie(e) {
  var t = wt().i18n, n = t.get("paymentConditions"), r = t.get("afterPay.agreement").split("%@"), a = ze(r, 2), o = a[0], s = a[1];
  return o && s ? P(ra, null, o, P("a", { className: "adyen-checkout__link", target: "_blank", rel: "noopener noreferrer", href: e.url }, n), s) : P("span", { className: "adyen-checkout__checkbox__label" }, t.get("privacyPolicy"));
}
T(gu, "defaultProps", { onChange: function() {
}, data: { companyDetails: {}, personalDetails: {}, billingAddress: {}, deliveryAddress: {}, bankAccount: {} }, visibility: { companyDetails: "hidden", personalDetails: "editable", billingAddress: "editable", deliveryAddress: "editable", bankAccount: "hidden" }, showFormInstruction: !0 });
var die = ["BE", "NL"], qZe = { be: { en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/be_en", fr: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/be_fr", nl: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/be_nl" }, nl: { en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/nl_en", nl: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/nl_nl" } };
function fie(e, t, n) {
  var r, a, o, s = t == null ? void 0 : Xo(r = t.toLowerCase()).call(r, 0, 2), c = (a = n[e == null ? void 0 : e.toLowerCase()]) === null || a === void 0 ? void 0 : a[s];
  if (c) return c;
  console.warn(je(o = "Cannot find a consent url for the provided countryCode: ".concat(e, " and locale: ")).call(o, t));
}
function rZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function aZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = rZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = rZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function JZe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var yO = function(e) {
  ft(n, gu);
  var t = JZe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    var a;
    return aZ(aZ({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { allowedCountries: r.countryCode ? [r.countryCode] : die, consentCheckboxLabel: P(cie, { url: fie(r.countryCode, (a = r.i18n) === null || a === void 0 ? void 0 : a.locale, qZe) }) });
  } }]), n;
}();
function oZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function iZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = oZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = oZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function QZe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(yO, "type", "afterpay_default");
var bO = function(e) {
  ft(n, gu);
  var t = QZe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return iZ(iZ({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { allowedCountries: r.countryCode ? [r.countryCode] : die });
  } }]), n;
}();
function nv() {
  var e = yc(window, "screen.colorDepth") || "", t = !!yc(window, "navigator.javaEnabled") && window.navigator.javaEnabled(), n = yc(window, "screen.height") || "", r = yc(window, "screen.width") || "", a = yc(window, "navigator.userAgent") || "";
  return { acceptHeader: "*/*", colorDepth: e, language: yc(window, "navigator.language") || yc(window, "navigator.browserLanguage") || "en", javaEnabled: t, screenHeight: n, screenWidth: r, userAgent: a, timeZoneOffset: (/* @__PURE__ */ new Date()).getTimezoneOffset() };
}
T(bO, "type", "afterpay_b2b"), T(bO, "defaultProps", { onChange: function() {
}, data: { companyDetails: {}, personalDetails: {}, billingAddress: {}, deliveryAddress: {} }, visibility: { companyDetails: "editable", personalDetails: "editable", billingAddress: "editable", deliveryAddress: "editable" }, showFormInstruction: !0 });
var eYe = "v1/AmazonPayUtility/signString", tYe = "v1/AmazonPayUtility/updateCheckoutSession", nYe = "https://static-eu.payments-amazon.com/checkout.js", rYe = "https://static-na.payments-amazon.com/checkout.js", aYe = "en_GB", oYe = "en_US", iYe = { EU: "EUR", UK: "GBP", US: "USD" }, sYe = ["en_GB", "de_DE", "fr_FR", "it_IT", "es_ES"], lYe = ["en_US"];
function sZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = sZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = sZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function uYe(e, t) {
  var n = /* @__PURE__ */ function(a) {
    return a === "US" ? lYe : sYe;
  }(t), r = jt(n).call(n, e) ? e : /* @__PURE__ */ function(a) {
    return a === "US" ? oYe : aYe;
  }(t);
  return r;
}
function cYe(e) {
  return e === "noTagline" ? "C0001" : null;
}
function dYe(e) {
  var t = e.addressDetails, n = e.cancelUrl, r = e.checkoutMode, a = e.deliverySpecifications, o = e.returnUrl, s = e.merchantMetadata, c = e.chargePermissionType, u = e.recurringMetadata, f = e.configuration.storeId, m = r === "ProcessOrder", v = m ? function(y) {
    return { amount: String(P8(y.value, y.currency)), currencyCode: y.currency };
  }(e.amount) : null;
  return hd(hd(hd(hd(hd({ storeId: f, chargePermissionType: c, webCheckoutDetails: hd(hd(hd({}, m ? { checkoutResultReturnUrl: o } : { checkoutReviewReturnUrl: o }), n && { checkoutCancelUrl: n }), m && { checkoutMode: r }) }, m && { paymentDetails: { chargeAmount: v, paymentIntent: "Confirm", presentmentCurrency: v.currencyCode, totalOrderAmount: v } }), u && { recurringMetadata: u }), s && { merchantMetadata: s }), a && { deliverySpecifications: a }), t && { addressDetails: t });
}
function lZ(e, t, n) {
  var r;
  return fl({ loadingContext: e, path: je(r = "".concat("v1/AmazonPayUtility/getCheckoutDetails", "?clientKey=")).call(r, t) }, n);
}
function uZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function cZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = uZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = uZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function fYe(e) {
  var t = this, n = wt().loadingContext, r = e.amazonRef, a = e.configuration, o = a === void 0 ? {} : a, s = Je(null), c = ze(s, 2), u = c[0], f = c[1], m = dYe(e), v = function(b) {
    var S;
    return hd(hd(hd({}, b.buttonColor && { buttonColor: b.buttonColor }), b.design && { design: cYe(b.design) }), {}, { checkoutLanguage: uYe(b.locale, b.configuration.region), ledgerCurrency: iYe[b.configuration.region] || b.currency || ((S = b.amount) === null || S === void 0 ? void 0 : S.currency), merchantId: b.configuration.merchantId, productType: b.productType, placement: b.placement, sandbox: b.environment === "TEST" });
  }(e), y = function() {
    new Yt(e.onClick).then(t.initCheckout).catch(function(b) {
      e.onError && e.onError(b, t.componentRef);
    });
  };
  return this.initCheckout = function() {
    var b = { payloadJSON: Pc(m), publicKeyId: o.publicKeyId, signature: u };
    r.Pay.initCheckout(cZ(cZ({}, v), {}, { createCheckoutSessionConfig: b }));
  }, Rt(function() {
    var b = e.clientKey;
    (function(S, x, E) {
      var N;
      return fl({ loadingContext: S, path: je(N = "".concat(eYe, "?clientKey=")).call(N, x) }, { stringToSign: Pc(E) });
    })(n, b, m).then(function(S) {
      if (S == null || !S.signature) return console.error("Could not get AmazonPay signature");
      f(S.signature), e.showPayButton && r.Pay.renderButton("#amazonPayButton", v).onClick(y);
    }).catch(function(S) {
      console.error(S), e.onError && e.onError(S, t.componentRef);
    });
  }, []), e.showPayButton ? P("div", { className: "adyen-checkout__amazonpay__button", id: "amazonPayButton" }) : null;
}
function pYe(e) {
  var t = wt().i18n, n = e.amazonRef, r = e.amazonCheckoutSessionId;
  return Rt(function() {
    var a = { amazonCheckoutSessionId: r, changeAction: "changeAddress" };
    n.Pay.bindChangeAction(".adyen-checkout__amazonpay__button--changeAddress", a);
  }, []), P("button", { type: "button", className: "adyen-checkout__button adyen-checkout__button--ghost adyen-checkout__amazonpay__button--changeAddress" }, t.get("amazonpay.changePaymentDetails"));
}
function hYe(e) {
  var t = this, n = wt(), r = n.i18n, a = n.loadingContext;
  return this.createOrder = function() {
    var o = e.amazonCheckoutSessionId, s = e.amount, c = e.clientKey, u = e.chargePermissionType, f = e.publicKeyId, m = e.region, v = e.recurringMetadata, y = e.returnUrl;
    (function(b, S, x) {
      var E;
      return fl({ loadingContext: b, path: je(E = "".concat(tYe, "?clientKey=")).call(E, S) }, x);
    })(a, c, { amount: s, chargePermissionType: u, checkoutResultReturnUrl: y, checkoutSessionId: o, publicKeyId: f, recurringMetadata: v, region: m }).then(function(b) {
      var S;
      if (b == null || (S = b.action) === null || S === void 0 || !S.type) return console.error(b.errorMessage || "Could not get the AmazonPay URL");
      b.action.type === "redirect" && window.location.assign(b.action.url);
    }).catch(function(b) {
      e.onError && e.onError(b, t.componentRef);
    });
  }, P(pu, { classNameModifiers: ["standalone", "pay"], label: r.get("confirmPurchase"), onClick: this.createOrder });
}
function mYe(e) {
  var t = wt().i18n;
  return P("button", { type: "button", className: "adyen-checkout__button  adyen-checkout__button--ghost adyen-checkout__amazonpay__button--signOut", onClick: function() {
    new Yt(e.onSignOut).then(function() {
      e.amazonRef.Pay.signout();
    }).catch(console.error);
  } }, t.get("amazonpay.signout"));
}
var G2 = et(function e(t) {
  var n = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "body", a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  Qe(this, e), T(this, "src", void 0), T(this, "node", void 0), T(this, "attributes", void 0), T(this, "dataAttributes", void 0), T(this, "isScriptLoadCalled", !1), T(this, "script", void 0), T(this, "load", function() {
    if (!n.isScriptLoadCalled) return new Yt(function(s, c) {
      var u = function() {
        n.script.setAttribute("data-script-loaded", "true"), s();
      }, f = function() {
        n.remove(), c(new Error("Unable to load script ".concat(n.src)));
      };
      n.isScriptLoadCalled = !0;
      var m = document.querySelector(n.node);
      if (n.script = m.querySelector('script[src="'.concat(n.src, '"]')), n.script && n.script.getAttribute("data-script-loaded")) s();
      else {
        if (n.script) return n.script.addEventListener("load", u), void n.script.addEventListener("error", f);
        n.script = document.createElement("script"), wH(n.script, n.attributes), wH(n.script.dataset, n.dataAttributes), n.script.src = n.src, n.script.async = !0, n.script.addEventListener("load", u), n.script.addEventListener("error", f), m.appendChild(n.script);
      }
    });
  }), T(this, "remove", function() {
    return n.script.parentNode && n.script.parentNode.removeChild(n.script);
  }), this.src = t, this.node = r, this.attributes = a, this.dataAttributes = o;
});
function vYe(e) {
  var t, n, r = Je("pending"), a = ze(r, 2), o = a[0], s = a[1], c = _n(null), u = _n(null), f = function() {
    s("ready");
  };
  return this.submit = function() {
    return c.current && c.current.initCheckout ? c.current.initCheckout() : u.current && u.current.createOrder ? u.current.createOrder() : void 0;
  }, Rt(function() {
    var m = e.configuration.region === "US" ? rYe : nYe, v = new G2(m);
    return window.amazon ? f() : v.load().then(f), function() {
      v.remove();
    };
  }, []), o === "pending" ? P("div", { className: "adyen-checkout__amazonpay" }, P("div", { className: "adyen-checkout__amazonpay__status adyen-checkout__amazonpay__status--pending" }, P(ju, null))) : e.showSignOutButton ? P("div", { className: "adyen-checkout__amazonpay" }, P(mYe, { amazonRef: window.amazon, onSignOut: e.onSignOut })) : e.amazonCheckoutSessionId ? P("div", { className: "adyen-checkout__amazonpay" }, e.showOrderButton && P(hYe, { amazonCheckoutSessionId: e.amazonCheckoutSessionId, amount: e.amount, chargePermissionType: e.chargePermissionType, recurringMetadata: e.recurringMetadata, clientKey: e.clientKey, onError: e.onError, publicKeyId: (t = e.configuration) === null || t === void 0 ? void 0 : t.publicKeyId, region: (n = e.configuration) === null || n === void 0 ? void 0 : n.region, returnUrl: e.returnUrl, ref: u }), e.showChangePaymentDetailsButton && P(pYe, { amazonCheckoutSessionId: e.amazonCheckoutSessionId, amazonRef: window.amazon })) : P("div", { className: "adyen-checkout__amazonpay" }, P(fYe, kt({}, e, { amazonRef: window.amazon, ref: c })));
}
var gYe = { cancelUrl: typeof window != "undefined" ? window.location.href : "", configuration: {}, environment: "TEST", locale: "en_GB", placement: "Cart", productType: "PayAndShip", returnUrl: typeof window != "undefined" ? window.location.href : "", showOrderButton: !0, showChangePaymentDetailsButton: !1, showSignOutButton: !1, showPayButton: !0, onClick: function(e) {
  return e();
}, onSignOut: function(e) {
  return e();
}, isExpress: !1 };
function dZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function KS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = dZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = dZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function yYe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var _O = function(e) {
  ft(n, Dr);
  var t = yYe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "submitAnalytics", value: function(r) {
    Nn(fe(n.prototype), "submitAnalytics", this).call(this, KS({}, r), this.props);
  } }, { key: "formatProps", value: function(r) {
    return KS(KS({}, r), {}, { checkoutMode: r.isDropin ? "ProcessOrder" : r.checkoutMode, environment: r.environment.toUpperCase(), locale: r.locale.replace("-", "_"), productType: r.isDropin && !r.addressDetails ? "PayOnly" : r.productType });
  } }, { key: "formatData", value: function() {
    var r = this.props.amazonCheckoutSessionId;
    return { paymentMethod: KS({ type: n.type }, r && { checkoutSessionId: r }), browserInfo: this.browserInfo };
  } }, { key: "getShopperDetails", value: function() {
    var r = this.props, a = r.amazonCheckoutSessionId, o = r.configuration, s = o === void 0 ? {} : o, c = r.loadingContext, u = r.clientKey;
    return a ? lZ(c, u, { checkoutSessionId: a, getDeliveryAddress: !0, publicKeyId: s.publicKeyId, region: s.region }) : console.error("Could not shopper details. Missing checkoutSessionId.");
  } }, { key: "handleDeclineFlow", value: function() {
    var r = this, a = this.props, o = a.amazonCheckoutSessionId, s = a.configuration, c = s === void 0 ? {} : s, u = a.loadingContext, f = a.clientKey;
    if (!o) return console.error("Could handle the decline flow. Missing checkoutSessionId.");
    lZ(u, f, { checkoutSessionId: o, getDeclineFlowUrl: !0, publicKeyId: c.publicKeyId, region: c.region }).then(function() {
      var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (m == null || !m.declineFlowUrl) throw m;
      window.location.assign(m.declineFlowUrl);
    }).catch(function(m) {
      r.props.onError && r.props.onError(m, r.componentRef);
    });
  } }, { key: "isValid", get: function() {
    return !0;
  } }, { key: "browserInfo", get: function() {
    return nv();
  } }, { key: "submit", value: function() {
    var r = this.data, a = this.isValid, o = this.props.onSubmit, s = o === void 0 ? function() {
    } : o;
    return this.componentRef && this.componentRef.submit ? this.componentRef.submit() : s({ data: r, isValid: a }, this);
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(vYe, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props)));
  } }]), n;
}();
T(_O, "type", "amazonpay"), T(_O, "defaultProps", gYe);
var qS = { "apple-pay": "ApplePayButton-module_apple-pay__gYjuP", "apple-pay-button": "ApplePayButton-module_apple-pay-button__l5g-d", "apple-pay-button-black": "ApplePayButton-module_apple-pay-button-black__istwW", "apple-pay-button-white": "ApplePayButton-module_apple-pay-button-white__-wLaE", "apple-pay-button-white-with-line": "ApplePayButton-module_apple-pay-button-white-with-line__MlRq7", "apple-pay-button--type-plain": "ApplePayButton-module_apple-pay-button--type-plain__ycfNl", "apple-pay-button--type-buy": "ApplePayButton-module_apple-pay-button--type-buy__9m8AB", "apple-pay-button--type-donate": "ApplePayButton-module_apple-pay-button--type-donate__HmRdK", "apple-pay-button--type-check-out": "ApplePayButton-module_apple-pay-button--type-check-out__XdGWd", "apple-pay-button--type-book": "ApplePayButton-module_apple-pay-button--type-book__-v-VY", "apple-pay-button--type-subscribe": "ApplePayButton-module_apple-pay-button--type-subscribe__WxWIF", "apple-pay-button--type-add-money": "ApplePayButton-module_apple-pay-button--type-add-money__zeBA8", "apple-pay-button--type-contribute": "ApplePayButton-module_apple-pay-button--type-contribute__G3E8e", "apple-pay-button--type-order": "ApplePayButton-module_apple-pay-button--type-order__ggI6j", "apple-pay-button--type-reload": "ApplePayButton-module_apple-pay-button--type-reload__QbgLd", "apple-pay-button--type-rent": "ApplePayButton-module_apple-pay-button--type-rent__VzC-E", "apple-pay-button--type-support": "ApplePayButton-module_apple-pay-button--type-support__6EjmY", "apple-pay-button--type-tip": "ApplePayButton-module_apple-pay-button--type-tip__bdzGK", "apple-pay-button--type-top-up": "ApplePayButton-module_apple-pay-button--type-top-up__Eb3qR" };
function bYe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var pie = function(e) {
  ft(n, yo);
  var t = bYe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "render", value: function(r) {
    var a = r.buttonColor, o = r.buttonType;
    return P("button", { type: "button", "aria-label": this.props.i18n.get("payButton"), lang: this.props.i18n.languageCode, className: Tt("adyen-checkout__applepay__button", "adyen-checkout__applepay__button--".concat(a), "adyen-checkout__applepay__button--".concat(o), [qS["apple-pay"]], [qS["apple-pay-button"]], [qS["apple-pay-button-".concat(a)]], [qS["apple-pay-button--type-".concat(o)]]), onClick: this.props.onClick });
  } }]), n;
}();
function fZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function JS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = fZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = fZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
T(pie, "defaultProps", { onClick: function() {
}, buttonColor: "black", buttonType: "plain" });
var _Ye = function() {
  function e(t, n) {
    var r = this;
    Qe(this, e), T(this, "session", void 0), T(this, "options", void 0), this.options = n, this.session = new ApplePaySession(n.version, t), this.session.onvalidatemerchant = function(a) {
      return r.onvalidatemerchant(a, n.onValidateMerchant);
    }, this.session.onpaymentauthorized = function(a) {
      return r.onpaymentauthorized(a, n.onPaymentAuthorized);
    }, this.session.oncancel = function(a) {
      return r.oncancel(a, n.onCancel);
    }, typeof n.onPaymentMethodSelected == "function" && (this.session.onpaymentmethodselected = function(a) {
      return r.onpaymentmethodselected(a, n.onPaymentMethodSelected);
    }), typeof n.onShippingContactSelected == "function" && (this.session.onshippingcontactselected = function(a) {
      return r.onshippingcontactselected(a, n.onShippingContactSelected);
    }), typeof n.onShippingMethodSelected == "function" && (this.session.onshippingmethodselected = function(a) {
      return r.onshippingmethodselected(a, n.onShippingMethodSelected);
    });
  }
  return et(e, [{ key: "begin", value: function() {
    return this.session.begin();
  } }, { key: "onvalidatemerchant", value: function(t, n) {
    var r = this;
    return new Yt(function(a, o) {
      return n(a, o, t.validationURL);
    }).then(function(a) {
      r.session.completeMerchantValidation(a);
    }).catch(function(a) {
      console.error(a), r.session.abort(), r.options.onError(a);
    });
  } }, { key: "onpaymentauthorized", value: function(t, n) {
    var r = this;
    return new Yt(function(a, o) {
      return n(a, o, t);
    }).then(function(a) {
      var o;
      r.session.completePayment(JS(JS({}, a), {}, { status: (o = a == null ? void 0 : a.status) !== null && o !== void 0 ? o : ApplePaySession.STATUS_SUCCESS }));
    }).catch(function(a) {
      var o;
      r.session.completePayment(JS(JS({}, a), {}, { status: (o = a == null ? void 0 : a.status) !== null && o !== void 0 ? o : ApplePaySession.STATUS_FAILURE }));
    });
  } }, { key: "onpaymentmethodselected", value: function(t, n) {
    var r = this;
    return new Yt(function(a, o) {
      return n(a, o, t);
    }).then(function(a) {
      console.log("onpaymentmethodselected", a), r.session.completePaymentMethodSelection(a);
    }).catch(function(a) {
      r.session.completePaymentMethodSelection(a);
    });
  } }, { key: "onshippingcontactselected", value: function(t, n) {
    var r = this;
    return new Yt(function(a, o) {
      return n(a, o, t);
    }).then(function(a) {
      r.session.completeShippingContactSelection(a);
    }).catch(function(a) {
      r.session.completeShippingContactSelection(a);
    });
  } }, { key: "onshippingmethodselected", value: function(t, n) {
    var r = this;
    return new Yt(function(a, o) {
      return n(a, o, t);
    }).then(function(a) {
      r.session.completeShippingMethodSelection(a);
    }).catch(function(a) {
      r.session.completeShippingMethodSelection(a);
    });
  } }, { key: "oncancel", value: function(t, n) {
    n(t);
  } }]), e;
}(), CYe = { amount: { currency: "USD", value: 0 }, countryCode: "US", totalPriceStatus: "final", totalPriceLabel: void 0, configuration: { merchantName: "", merchantId: "" }, initiative: "web", isExpress: !1, lineItems: void 0, merchantCapabilities: ["supports3DS"], shippingMethods: void 0, shippingType: void 0, supportedCountries: void 0, supportedNetworks: ["amex", "discover", "masterCard", "visa"], requiredBillingContactFields: void 0, requiredShippingContactFields: void 0, billingContact: void 0, shippingContact: void 0, applicationData: void 0, onClick: function(e) {
  return e();
}, onAuthorized: function(e) {
  return e();
}, onPaymentMethodSelected: null, onShippingContactSelected: null, onShippingMethodSelected: null, buttonType: "plain", buttonColor: "black", showPayButton: !0 }, wYe = ["countryCode", "companyName", "amount"], SYe = function(e) {
  var t = e.countryCode;
  e.companyName;
  var n = e.amount, r = pa(e, wYe), a = function(o) {
    return String(P8(o.value, o.currency));
  }(n);
  return { countryCode: t, currencyCode: n.currency, total: { label: r.totalPriceLabel, amount: a, type: r.totalPriceStatus }, lineItems: r.lineItems, shippingMethods: r.shippingMethods, shippingType: r.shippingType, recurringPaymentRequest: r.recurringPaymentRequest, merchantCapabilities: r.merchantCapabilities, supportedCountries: r.supportedCountries, supportedNetworks: r.supportedNetworks, requiredShippingContactFields: r.requiredShippingContactFields, requiredBillingContactFields: r.requiredBillingContactFields, billingContact: r.billingContact, shippingContact: r.shippingContact, applicationData: r.applicationData };
};
function pZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function c4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = pZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = pZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function xYe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var CO = function(e) {
  ft(r, Dr);
  var t, n = xYe(r);
  function r(a) {
    var o, s, c, u;
    return Qe(this, r), (u = n.call(this, a)).startSession = pn(o = u.startSession).call(o, Se(u)), u.submit = pn(s = u.submit).call(s, Se(u)), u.validateMerchant = pn(c = u.validateMerchant).call(c, Se(u)), u;
  }
  return et(r, [{ key: "submitAnalytics", value: function(a) {
    Nn(fe(r.prototype), "submitAnalytics", this).call(this, c4({}, a), this.props);
  } }, { key: "formatProps", value: function(a) {
    var o, s, c, u, f = a.version || function(v) {
      for (var y = [], b = v; b > 0; b--) y.push(b);
      try {
        return Ji(y).call(y, function(S) {
          return S && window.ApplePaySession && ApplePaySession.supportsVersion(S);
        });
      } catch (S) {
        return console.warn(S), null;
      }
    }(14), m = (o = a.brands) !== null && o !== void 0 && o.length ? (c = a.brands, u = { mc: "masterCard", amex: "amex", visa: "visa", elodebit: "elo", elo: "elo", interac: "interac", discover: "discover", jcb: "jcb", electron: "electron", maestro: "maestro", girocard: "girocard", cartebancaire: "cartesBancaires", eftpos_australia: "eftpos" }, rr(c).call(c, function(v, y) {
      return u[y] && !jt(v).call(v, u[y]) && v.push(u[y]), v;
    }, [])) : a.supportedNetworks;
    return c4(c4({}, a), {}, { configuration: a.configuration, supportedNetworks: m, version: f, totalPriceLabel: a.totalPriceLabel || ((s = a.configuration) === null || s === void 0 ? void 0 : s.merchantName) });
  } }, { key: "formatData", value: function() {
    return { paymentMethod: c4({ type: r.type }, this.state) };
  } }, { key: "submit", value: function() {
    return this.props.isInstantPayment && this.submitAnalytics({ type: N8, target: Coe }), this.startSession(this.props.onAuthorized);
  } }, { key: "startSession", value: function(a) {
    var o = this, s = this.props, c = s.version, u = s.onValidateMerchant, f = s.onPaymentMethodSelected, m = s.onShippingMethodSelected, v = s.onShippingContactSelected, y = SYe(c4({ companyName: this.props.configuration.merchantName }, this.props)), b = new _Ye(y, { version: c, onError: function(S) {
      o.handleError(new _r("ERROR", "ApplePay - Something went wrong on ApplePayService", { cause: S }));
    }, onCancel: function(S) {
      o.handleError(new _r("CANCEL", "ApplePay UI dismissed", { cause: S }));
    }, onPaymentMethodSelected: f, onShippingMethodSelected: m, onShippingContactSelected: v, onValidateMerchant: u || this.validateMerchant, onPaymentAuthorized: function(S, x, E) {
      var N;
      E != null && (N = E.payment) !== null && N !== void 0 && (N = N.token) !== null && N !== void 0 && N.paymentData && o.setState({ applePayToken: btoa(Pc(E.payment.token.paymentData)) }), Nn(fe(r.prototype), "submit", o).call(o), a(S, x, E);
    } });
    return new Yt(function(S, x) {
      return o.props.onClick(S, x);
    }).then(function() {
      b.begin();
    }).catch(function() {
      return {};
    });
  } }, { key: "validateMerchant", value: (t = On(yt.mark(function a(o, s) {
    var c, u, f, m, v, y, b, S, x, E, N, R, O, D, $;
    return yt.wrap(function(B) {
      for (; ; ) switch (B.prev = B.next) {
        case 0:
          return u = window.location.hostname, f = this.props, m = f.clientKey, v = f.configuration, y = f.loadingContext, b = f.initiative, S = v.merchantName, x = v.merchantId, E = je(c = "".concat("v1/applePay/sessions", "?clientKey=")).call(c, m), N = { loadingContext: y, path: E }, R = { displayName: S, domainName: u, initiative: b, merchantIdentifier: x }, B.prev = 6, B.next = 9, fl(N, R);
        case 9:
          O = B.sent, (D = tC.decode(O.data)).success ? ($ = JSON.parse(D.data), o($)) : s("Could not decode Apple Pay session"), B.next = 17;
          break;
        case 14:
          B.prev = 14, B.t0 = B.catch(6), s("Could not get Apple Pay session");
        case 17:
        case "end":
          return B.stop();
      }
    }, a, this, [[6, 14]]);
  })), function(a, o) {
    return t.apply(this, arguments);
  }) }, { key: "isValid", get: function() {
    return !0;
  } }, { key: "isAvailable", value: function() {
    if (document.location.protocol !== "https:") return Yt.reject(new _r("IMPLEMENTATION_ERROR", "Trying to start an Apple Pay session from an insecure document"));
    if (!this.props.onValidateMerchant && !this.props.clientKey) return Yt.reject(new _r("IMPLEMENTATION_ERROR", "clientKey was not provided"));
    try {
      if (window.ApplePaySession && ApplePaySession.canMakePayments() && ApplePaySession.supportsVersion(this.props.version)) return Yt.resolve(!0);
    } catch (a) {
      console.warn(a);
    }
    return Yt.reject(new _r("ERROR", "Apple Pay is not available on this device"));
  } }, { key: "render", value: function() {
    var a = this;
    return this.props.showPayButton ? P(pie, { i18n: this.props.i18n, buttonColor: this.props.buttonColor, buttonType: this.props.buttonType, onClick: function(o) {
      o.preventDefault(), a.submit();
    } }) : null;
  } }]), r;
}();
function hZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function mZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = hZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = hZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
T(CO, "type", "applepay"), T(CO, "defaultProps", CYe);
var vZ = { labels: T({}, pd, "address"), schema: [pd, [[N0, 70], [_f, 30]]] }, EYe = ["ID", "PH", "TH", "VN", "JP", "TW", "KR", "SG", "MY", "HK"], IYe = rr(DW).call(DW, function(e, t) {
  return mZ(mZ({}, e), {}, T({}, t, vZ));
}, { default: vZ });
function gZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function QS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = gZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = gZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function kYe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var hie = function(e) {
  ft(n, gu);
  var t = kYe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return QS(QS({}, Nn(fe(n.prototype), "formatProps", this).call(this, QS(QS({}, r), { visibility: { deliveryAddress: "hidden", companyDetails: "hidden" } }))), {}, { allowedCountries: EYe, personalDetailsRequiredFields: ["firstName", "lastName", "telephoneNumber"], billingAddressRequiredFields: ["country", "street", "postalCode"], billingAddressSpecification: IYe });
  } }]), n;
}();
function AYe(e) {
  var t = e.name, n = e.id, r = e.icon, a = e.onClick, o = e.selected, s = o !== void 0 && o;
  return P("button", { type: "button", className: Tt("adyen-checkout__issuer-button", { "adyen-checkout__issuer-button--selected": s }), "aria-label": t, "aria-pressed": s, onClick: a, value: n }, !!r && P(ps, { className: "adyen-checkout__issuer-button-img", alt: t, src: r }), P("span", { className: "adyen-checkout__issuer-button-text" }, t));
}
T(hie, "type", "atome");
var PYe = function(e) {
  var t = e.items, n = t === void 0 ? [] : t, r = e.selectedIssuerId, a = e.onChange, o = wt().i18n, s = Kt(function(c) {
    var u = c.currentTarget.value;
    We(c.target, "value", { value: u }), a(c);
  }, [a]);
  return P("div", { className: "adyen-checkout__issuer-button-group", role: "group", "aria-label": o.get("idealIssuer.selectField.placeholder") }, It(n).call(n, function(c) {
    return P(AYe, kt({ key: c.id }, c, { selected: r === c.id, onClick: s }));
  }));
};
function z2(e) {
  var t, n = e.label, r = n === void 0 ? "qrCodeOrApp" : n, a = e.classNames, o = a === void 0 ? [] : a, s = wt().i18n;
  return P("div", { className: Tt.apply(void 0, je(t = ["adyen-checkout__content-separator"]).call(t, Pn(o))) }, s.get(r));
}
var NYe = function(e) {
  var t, n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
  try {
    t = new bze(e);
  } catch (r) {
    return !1;
  }
  return n && t.protocol === "http:" || t.protocol === "https:";
};
function D8(e) {
  var t = e.message, n = e.urls, r = typeof t == "string", a = $m(n).call(n, function(o) {
    return typeof o == "string" && NYe(o);
  });
  return r && a ? function(o, s) {
    return P("span", { className: "adyen-checkout-disclaimer__label" }, voe(o, It(s).call(s, function(c) {
      return function(u) {
        return P("a", { className: "adyen-checkout__link", href: c, target: "_blank", rel: "noopener noreferrer" }, u);
      };
    })));
  }(t, n) : null;
}
var TYe = ["items", "placeholder", "issuer", "highlightedIds"];
function yZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
var OYe = function(e, t) {
  var n, r, a = e.issuer, o = e.items, s = (n = Ji(o).call(o, function(c) {
    return c.id === a;
  })) === null || n === void 0 ? void 0 : n.name;
  return a && s ? je(r = "".concat(t.get("continueTo"), " ")).call(r, s) : t.get("continue");
}, RYe = ["issuer"], MYe = { issuer: { validate: function(e) {
  return !!e && e.length > 0;
}, errorMessage: "idealIssuer.selectField.placeholder", modes: ["blur"] } }, E0 = function(e) {
  return e[e.ButtonGroup = 0] = "ButtonGroup", e[e.Dropdown = 1] = "Dropdown", e;
}(E0 || {});
function mie(e) {
  var t, n = e.items, r = e.placeholder, a = r === void 0 ? "idealIssuer.selectField.placeholder" : r, o = e.issuer, s = e.highlightedIds, c = s === void 0 ? [] : s, u = pa(e, TYe), f = wt().i18n, m = gs({ schema: RYe, defaultData: { issuer: o }, rules: MYe }), v = m.handleChangeFor, y = m.triggerValidation, b = m.data, S = m.valid, x = m.errors, E = m.isValid, N = Je("ready"), R = ze(N, 2), O = R[0], D = R[1], $ = Je(E0.Dropdown), B = ze($, 2), G = B[0], Z = B[1], K = oC(), q = K.setSRMessagesFromObjects, pe = K.shouldMoveFocusSR, he = q == null ? void 0 : q({});
  this.setStatus = function(xe) {
    D(xe);
  };
  var _e = Kt(function(xe) {
    return function(X) {
      var ye = xe === E0.Dropdown ? tW : "featured_issuer", ce = Ji(n).call(n, function(se) {
        return se.id === X.target.value;
      });
      u.onSubmitAnalytics({ type: N8, target: ye, issuer: ce.name }), Z(xe), v("issuer")(X);
    };
  }, [v]), ge = Kt(function(xe) {
    xe && u.onSubmitAnalytics({ type: yoe, target: tW });
  }, []), Y = _n(aD(u.onSubmitAnalytics, 3e3)), ee = Kt(function() {
    Y.current({ type: boe, target: "list_search" });
  }, []);
  Rt(function() {
    u.onChange({ data: b, valid: S, errors: x, isValid: E });
    var xe = he == null ? void 0 : he({ errors: x, isValidating: !0 });
    (xe == null ? void 0 : xe.action) === R8 && pe && sie(".adyen-checkout__issuer-list", xe.fieldToFocus);
  }, [b, S, x, E]), this.showValidation = function() {
    y();
  };
  var oe = rr(n).call(n, function(xe, X) {
    return jt(c).call(c, X.id) && xe.highlightedItems.push(function(ye) {
      for (var ce = 1; ce < arguments.length; ce++) {
        var se, Ie, Le = arguments[ce] != null ? arguments[ce] : {};
        ce % 2 ? Q(se = yZ(Object(Le), !0)).call(se, function(ie) {
          T(ye, ie, Le[ie]);
        }) : ne ? Ze(ye, ne(Le)) : Q(Ie = yZ(Object(Le))).call(Ie, function(ie) {
          We(ye, ie, re(Le, ie));
        });
      }
      return ye;
    }({}, X)), xe;
  }, { highlightedItems: [] }), me = oe.highlightedItems;
  return P("div", { className: "adyen-checkout__issuer-list" }, !!me.length && P(ra, null, P(PYe, { selectedIssuerId: G === E0.ButtonGroup ? b.issuer : null, items: me, onChange: _e(E0.ButtonGroup) }), P(z2, null)), P(xn, { errorMessage: function(xe) {
    return xe && xe.errorMessage ? f.get(xe.errorMessage) : !!xe;
  }(x.issuer), classNameModifiers: ["issuer-list"], name: "issuer" }, P(Ad, { items: n, selectedValue: G === E0.Dropdown ? b.issuer : null, placeholder: f.get(a), name: "issuer", className: "adyen-checkout__issuer-list__dropdown", onChange: _e(E0.Dropdown), onListToggle: ge, onInput: ee })), u.termsAndConditions && P("div", { className: "adyen-checkout__issuer-list__termsAndConditions" }, P(D8, { message: f.get(u.termsAndConditions.translationKey), urls: u.termsAndConditions.urls })), u.showPayButton && u.payButton({ status: O, label: OYe({ issuer: b.issuer, items: je(t = []).call(t, Pn(n), Pn(me)) }, f) }));
}
function bZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
mie.defaultProps = { onChange: function() {
} };
var iD = function(e, t, n) {
  return function(r) {
    if (!r) return null;
    var a = function(o) {
      for (var s = 1; s < arguments.length; s++) {
        var c, u, f = arguments[s] != null ? arguments[s] : {};
        s % 2 ? Q(c = bZ(Object(f), !0)).call(c, function(m) {
          T(o, m, f[m]);
        }) : ne ? Ze(o, ne(f)) : Q(u = bZ(Object(f))).call(u, function(m) {
          We(o, m, re(f, m));
        });
      }
      return o;
    }({ parentFolder: r ? "".concat(t, "/") : "", type: r || t }, e);
    return n(a)(r);
  };
}, DYe = ["label", "icon", "payButton", "onSubmit", "amount", "name", "showPayButton"];
function _Z(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function CZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = _Z(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = _Z(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Lf(e) {
  var t = e.label, n = t === void 0 ? null : t, r = e.icon, a = r === void 0 ? null : r, o = e.payButton, s = e.onSubmit, c = e.amount, u = c === void 0 ? null : c, f = e.name, m = e.showPayButton, v = pa(e, DYe), y = wt().i18n, b = Je("ready"), S = ze(b, 2), x = S[0], E = S[1];
  if (this.setStatus = function(N) {
    E(N);
  }, m) return P(ra, null, o(CZ(CZ({}, v), {}, { status: x, icon: a, classNameModifiers: ["standalone"], label: n || function() {
    var N, R;
    return u && {}.hasOwnProperty.call(u, "value") && u.value === 0 ? je(N = "".concat(y.get("preauthorizeWith"), " ")).call(N, f) : je(R = "".concat(y.get("continueTo"), " ")).call(R, f);
  }(), onClick: s })));
}
function wZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ex(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = wZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = wZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function LYe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var ys = function(e) {
  ft(n, Dr);
  var t = LYe(n);
  function n(r) {
    var a;
    if (Qe(this, n), (a = t.call(this, r)).props.showImage) {
      var o, s = iD({ loadingContext: a.props.loadingContext }, a.constructor.type, function(c) {
        return a.resources.getImage(c);
      });
      a.props.issuers = It(o = a.props.issuers).call(o, function(c) {
        return ex(ex({}, c), {}, { icon: s(c.id) });
      });
    }
    return a;
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    var a, o = r.details && r.details.length && (Ji(a = r.details).call(a, function(s) {
      return s.key === "issuer";
    }) || {}).items || r.issuers || [];
    return ex(ex({}, r), {}, { issuers: o });
  } }, { key: "formatData", value: function() {
    var r;
    return { paymentMethod: { type: this.constructor.type, issuer: (r = this.state) === null || r === void 0 || (r = r.data) === null || r === void 0 ? void 0 : r.issuer } };
  } }, { key: "isValid", get: function() {
    var r;
    return this.props.issuers.length === 0 || !((r = this.state) === null || r === void 0 || !r.isValid);
  } }, { key: "brands", get: function() {
    var r;
    return this.props.showPaymentMethodItemImages ? It(r = this.props.issuers).call(r, function(a) {
      return { icon: a.icon, name: a.id };
    }) : [];
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, this.props.issuers.length > 0 ? P(eh, { srPanel: this.props.modules.srPanel }, P(mie, kt({ ref: function(a) {
      r.componentRef = a;
    }, items: this.props.issuers, highlightedIds: this.props.highlightedIssuers }, this.props, this.state, { showImage: this.props.showImage, type: this.constructor.type, onChange: this.setState, onSubmit: this.submit, payButton: this.payButton, onSubmitAnalytics: this.submitAnalytics }))) : P(Lf, kt({ showPayButton: this.props.showPayButton, name: this.props.name }, this.props, { onSubmit: this.submit, payButton: this.payButton, ref: function(a) {
      r.componentRef = a;
    } })));
  } }]), n;
}();
function SZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = SZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = SZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function $Ye(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(ys, "defaultProps", { showImage: !0, onValid: function() {
}, issuers: [], highlightedIssuers: [], loadingContext: tie, showPaymentMethodItemImages: !1, showPayButton: !0 });
var vie = function(e) {
  ft(n, ys);
  var t = $Ye(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return xZ(xZ({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { showImage: !1 });
  } }]), n;
}();
function EZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function IZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = EZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = EZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function jYe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(vie, "type", "billdesk_online");
var gie = function(e) {
  ft(n, ys);
  var t = jYe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return IZ(IZ({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { showImage: !1, placeholder: "issuerList.wallet.placeholder" });
  } }]), n;
}();
T(gie, "type", "billdesk_wallet");
var kZ, AZ, PZ, NZ, FYe = function(e, t) {
  return t === Jr ? (e[ro] = !1, e[Ca] = !1) : e[t] = !1, e;
}, BYe = function(e, t) {
  return function(n, r) {
    var a = t.valid[r] !== !0 ? /* @__PURE__ */ function(o, s) {
      return s !== 1 || o !== ro && o !== Ca ? o : Jr;
    }(r, e) : null;
    return a = function(o, s, c) {
      var u = rr(c).call(c, function(S, x) {
        return S.isFieldOfType || (S.isFieldOfType = o === x, S.fieldIsValid = !s.errors[x]), S;
      }, { isFieldOfType: !1, fieldIsValid: !1 }), f = u.isFieldOfType, m = u.fieldIsValid, v = o === Fr ? "cvcPolicy" : "expiryDatePolicy", y = v === "cvcPolicy" ? m_ : g_, b = v === "cvcPolicy" ? v_ : y2;
      return (s[v] === y || s[v] === b) && m && f ? null : o;
    }(a, t, [Fr, Jr, ro, Ca]), a && !jt(n).call(n, a) && n.push(a), n;
  };
}, VYe = et(function e(t) {
  Qe(this, e), T(this, "callbacks", void 0), T(this, "config", void 0), T(this, "props", void 0), T(this, "state", void 0), T(this, "validateForm", void 0), T(this, "handleBrandFromBinLookup", void 0), T(this, "callbacksHandler", void 0), T(this, "configHandler", void 0), T(this, "createCardSecuredFields", void 0), T(this, "createNonCardSecuredFields", void 0), T(this, "createSecuredFields", void 0), T(this, "destroySecuredFields", void 0), T(this, "handleIOSTouchEvents", void 0), T(this, "destroyTouchendListener", void 0), T(this, "destroyTouchstartListener", void 0), T(this, "handleBinValue", void 0), T(this, "handleEncryption", void 0), T(this, "handleFocus", void 0), T(this, "handleIframeConfigFeedback", void 0), T(this, "handleValidation", void 0), T(this, "handleSFShiftTab", void 0), T(this, "handleShiftTab", void 0), T(this, "isConfigured", void 0), T(this, "postMessageToAllIframes", void 0), T(this, "processAutoComplete", void 0), T(this, "processBrand", void 0), T(this, "sendBrandToCardSF", void 0), T(this, "sendExpiryDatePolicyToSF", void 0), T(this, "setFocusOnFrame", void 0), T(this, "setupSecuredField", void 0), T(this, "touchendListener", void 0), T(this, "touchstartListener", void 0), T(this, "hasGenuineTouchEvents", void 0), T(this, "encryptedAttrName", void 0), T(this, "hasRedundantCVCField", void 0), T(this, "isSingleBrandedCard", void 0), T(this, "securityCode", void 0), this.props = t, this.state = {}, this.config = {}, this.callbacks = {};
}), wO = typeof window != "undefined" && window.console && window.console.error && pn(kZ = window.console.error).call(kZ, window.console);
typeof window != "undefined" && window.console && window.console.info && pn(AZ = window.console.info).call(AZ, window.console);
var JP = typeof window != "undefined" && window.console && window.console.log && pn(PZ = window.console.log).call(PZ, window.console), Em = typeof window != "undefined" && window.console && window.console.warn && pn(NZ = window.console.warn).call(NZ, window.console);
function UYe(e) {
  var t, n, r, a, o, s;
  this.config.cardGroupTypes = M8(s = e.cardGroupTypes) && s.length ? s : x4;
  var c = e.loadingContext;
  if (c) {
    var u;
    this.config.loadingContext = (u = c).charAt(u.length - 1) === "/" ? c : "".concat(c, "/"), this.config.isCreditCardType = jt(yW).call(yW, e.type) === !1, this.config.iframeUIConfig = e.iframeUIConfig, this.config.allowedDOMAccess = !(e.allowedDOMAccess === !1 || e.allowedDOMAccess === "false"), this.config.autoFocus = !(e.autoFocus === !1 || e.autoFocus === "false"), this.config.showWarnings = e.showWarnings === !0 || e.showWarnings === "true", this.config.trimTrailingSeparator = !(e.trimTrailingSeparator === !1 || e.trimTrailingSeparator === "false"), this.config.keypadFix = !(e.keypadFix === !1 || e.keypadFix === "false"), this.config.legacyInputMode = e.legacyInputMode || null, this.config.minimumExpiryDate = e.minimumExpiryDate || null, this.config.implementationType = e.implementationType, this.config.sfLogAtStart = window._b$dl === !0;
    var f = this.config.isCreditCardType ? "card" : e.type;
    ka(f).call(f, "sepa") > -1 && (f = "iban");
    var m = btoa(window.location.origin), v = !!e.forceCompat || typeof window.TextEncoder != "function", y = je(t = "".concat(f)).call(t, v ? "Compat" : "");
    this.config.iframeSrc = je(n = je(r = je(a = je(o = "".concat(this.config.loadingContext, "securedfields/")).call(o, e.clientKey, "/")).call(a, "4.9.0", "/securedFields.html?type=")).call(r, y, "&d=")).call(n, m), this.config.maskSecurityCode = e.maskSecurityCode, this.config.shouldDisableIOSArrowKeys = e.shouldDisableIOSArrowKeys;
  } else Em("WARNING Config :: no loadingContext has been specified!");
}
var dc = function() {
};
function GYe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  this.callbacks.onLoad = e.onLoad ? e.onLoad : dc, this.callbacks.onConfigSuccess = e.onConfigSuccess ? e.onConfigSuccess : dc, this.callbacks.onFieldValid = e.onFieldValid ? e.onFieldValid : dc, this.callbacks.onAllValid = e.onAllValid ? e.onAllValid : dc, this.callbacks.onBrand = e.onBrand ? e.onBrand : dc, this.callbacks.onError = e.onError ? e.onError : dc, this.callbacks.onFocus = e.onFocus ? e.onFocus : dc, this.callbacks.onBinValue = e.onBinValue ? e.onBinValue : dc, this.callbacks.onAutoComplete = e.onAutoComplete ? e.onAutoComplete : dc, this.callbacks.onAdditionalSFConfig = e.onAdditionalSFConfig ? e.onAdditionalSFConfig : dc, this.callbacks.onAdditionalSFRemoved = e.onAdditionalSFRemoved ? e.onAdditionalSFRemoved : dc, this.callbacks.onTouchstartIOS = e.onTouchstartIOS ? e.onTouchstartIOS : dc;
}
var yie = function(e) {
  return { fieldType: e.fieldType, encryptedFieldName: e.encryptedFieldName, uid: e.uuid, valid: e.isValid, type: e.txVariant, rootNode: e.rootNode };
}, bie = function(e, t, n, r, a) {
  if (!Ir(e, "error")) return null;
  var o = t, s = { rootNode: r, fieldType: e.fieldType, error: null, type: null }, c = e.error !== "";
  return c || o.hasError ? o.errorType === hi[qM] ? null : (s.error = c ? e.error : "", s.type = n, o.hasError = c, o.errorType = s.error, a(s), s) : null;
};
function zYe(e) {
  var t, n, r, a, o = e.fieldType;
  if (this.state.type === "card" && Ir(e, "cvcPolicy") && Mp(e.cvcPolicy) && Ir(this.state.securedFields, Fr) && (this.state.securedFields[Fr].cvcPolicy = e.cvcPolicy), bie(e, this.state.securedFields[o], this.state.type, this.props.rootNode, this.callbacks.onError), this.state.securedFields[o].isEncrypted) {
    t = function(u) {
      var f, m, v, y = u.fieldType, b = u.txVariant, S = u.rootNode, x = y === Jr, E = [], N = ["encryptedExpiryMonth", "encryptedExpiryYear"], R = x ? 2 : 1;
      for (f = 0; f < R; f += 1) {
        var O;
        v = x ? N[f] : y, m = je(O = "".concat(b, "-encrypted-")).call(O, v);
        var D = yie({ fieldType: y, encryptedFieldName: x ? v : y, uuid: m, isValid: !1, txVariant: b, rootNode: S });
        E.push(D);
      }
      return E;
    }({ fieldType: o, txVariant: this.state.type, rootNode: this.props.rootNode }), o === Or && (t[0].endDigits = "");
    for (var s = 0, c = t.length; s < c; s += 1) this.config.allowedDOMAccess && (n = this.props.rootNode, r = t[s].uid, a = void 0, (a = Ru(n, "#".concat(r))) && n.removeChild(a)), this.callbacks.onFieldValid(t[s]);
    this.state.securedFields[o].isEncrypted = !1;
  }
  this.validateForm(), Ir(e, "brand") && this.processBrand(e);
}
var QP, Ic = function(e, t, n) {
  if (t) {
    var r = Pc(e);
    t.postMessage(r, n);
  }
};
function Id(e, t) {
  var n;
  return ((n = e.securedFields[t]) === null || n === void 0 ? void 0 : n.iframeContentWindow) || null;
}
function HYe(e) {
  var t, n, r = e.fieldType;
  this.config.autoFocus && (e.type !== "year" && r !== Ca || this.setFocusOnFrame(Fr), r === ro && this.setFocusOnFrame(Ca));
  var a = e[r];
  this.state.securedFields[r].isEncrypted = !0, this.config.allowedDOMAccess && function(c, u, f) {
    var m, v, y, b, S, x, E, N;
    for (m = 0; m < c.length; m += 1) {
      var R, O = c[m];
      y = O.encryptedFieldName, v = je(R = "".concat(u, "-encrypted-")).call(R, y), S = y, x = O.blob, N = void 0, (N = Ru(b = f, "#".concat(E = v))) || ((N = document.createElement("input")).type = "hidden", N.name = S, N.id = E, b.appendChild(N)), N.setAttribute("value", x);
    }
  }(a, this.state.type, this.props.rootNode), bie({ error: "", fieldType: r }, this.state.securedFields[r], this.state.type, this.props.rootNode, this.callbacks.onError);
  var o = function(c) {
    var u, f, m, v, y, b = c.fieldType, S = c.txVariant, x = c.rootNode, E = c.encryptedObjArr, N = [];
    for (u = 0; u < E.length; u += 1) {
      var R;
      v = (m = E[u]).encryptedFieldName, f = je(R = "".concat(S, "-encrypted-")).call(R, v), y = m.blob;
      var O = yie({ fieldType: b, encryptedFieldName: v, uuid: f, isValid: !0, txVariant: S, rootNode: x });
      O.blob = y, N.push(O);
    }
    return N;
  }({ fieldType: r, txVariant: this.state.type, rootNode: this.props.rootNode, encryptedObjArr: a });
  if (r === ro && Ir(this.state.securedFields, Ca)) {
    var s = { txVariant: this.state.type, code: e.code, blob: a[0].blob, fieldType: Ca, numKey: this.state.securedFields[Ca].numKey };
    Ic(s, Id(this.state, Ca), this.config.loadingContext);
  }
  for (r === Or && a7(e.endDigits) && (o[0].endDigits = e.endDigits), r === Or && a7(e.issuerBin) && (o[0].issuerBin = +e.issuerBin), r === Jr && a7(e.expiryDate) && (o[1].expiryDate = e.expiryDate), t = 0, n = o.length; t < n; t += 1) this.callbacks.onFieldValid(o[t]);
  this.validateForm();
}
var Jn = { __NO_BRAND: "noBrand", cards: [] };
Jn.cards.push({ cardType: "mc", startingRules: [51, 52, 53, 54, 55, 22, 23, 24, 25, 26, 27], permittedLengths: [16], pattern: /^(5[1-5][0-9]{0,14}|2[2-7][0-9]{0,14})$/, securityCode: "CVC" }), Jn.cards.push({ cardType: "visadankort", startingRules: [4571], permittedLengths: [16], pattern: /^(4571)[0-9]{0,12}$/ }), Jn.cards.push({ cardType: "visa", startingRules: [4], permittedLengths: [13, 16, 19], pattern: /^4[0-9]{0,18}$/, securityCode: "CVV" }), Jn.cards.push({ cardType: "amex", startingRules: [34, 37], permittedLengths: [15], pattern: /^3[47][0-9]{0,13}$/, securityCode: "CID" }), Jn.cards.push({ cardType: "diners", startingRules: [36], permittedLengths: [14, 16], pattern: /^(36)[0-9]{0,12}$/ }), Jn.cards.push({ cardType: "maestrouk", startingRules: [6759], permittedLengths: [16, 18, 19], pattern: /^(6759)[0-9]{0,15}$/ }), Jn.cards.push({ cardType: "solo", startingRules: [6767], permittedLengths: [16, 18, 19], pattern: /^(6767)[0-9]{0,15}$/ }), Jn.cards.push({ cardType: "laser", startingRules: [6304, 6706, 677117, 677120], permittedLengths: [16, 17, 18, 19], pattern: /^(6304|6706|6709|6771)[0-9]{0,15}$/, cvcPolicy: "optional" }), Jn.cards.push({ cardType: "discover", startingRules: [6011, 644, 645, 646, 647, 648, 649, 65], permittedLengths: [16, 17, 18, 19], pattern: /^(6011[0-9]{0,12}|(644|645|646|647|648|649)[0-9]{0,13}|65[0-9]{0,14})$/ }), Jn.cards.push({ cardType: "jcb", startingRules: [3528, 3529, 353, 354, 355, 356, 357, 358], permittedLengths: [16, 19], pattern: /^(352[8,9]{1}[0-9]{0,15}|35[4-8]{1}[0-9]{0,16})$/, securityCode: "CAV" }), Jn.cards.push({ cardType: "bcmc", startingRules: [6703, 479658, 606005], permittedLengths: [16, 17, 18, 19], pattern: /^((6703)[0-9]{0,15}|(479658|606005)[0-9]{0,13})$/, cvcPolicy: "hidden" }), Jn.cards.push({ cardType: "bijcard", startingRules: [5100081], permittedLengths: [16], pattern: /^(5100081)[0-9]{0,9}$/ }), Jn.cards.push({ cardType: "dankort", startingRules: [5019], permittedLengths: [16], pattern: /^(5019)[0-9]{0,12}$/ }), Jn.cards.push({ cardType: "hipercard", startingRules: [606282], permittedLengths: [16], pattern: /^(606282)[0-9]{0,10}$/ }), Jn.cards.push({ cardType: "cup", startingRules: [62, 81], permittedLengths: [14, 15, 16, 17, 18, 19], pattern: /^(62|81)[0-9]{0,17}$/ }), Jn.cards.push({ cardType: "maestro", startingRules: [50, 56, 57, 58, 6], permittedLengths: [16, 17, 18, 19], pattern: /^(5[0|6-8][0-9]{0,17}|6[0-9]{0,18})$/, cvcPolicy: "optional" }), Jn.cards.push({ cardType: "elo", startingRules: [506699, 50670, 50671, 50672, 50673, 50674, 50675, 50676, 506770, 506771, 506772, 506773, 506774, 506775, 506776, 506777, 506778, 401178, 438935, 451416, 457631, 457632, 504175, 627780, 636297, 636368], permittedLengths: [16], pattern: /^((((506699)|(506770)|(506771)|(506772)|(506773)|(506774)|(506775)|(506776)|(506777)|(506778)|(401178)|(438935)|(451416)|(457631)|(457632)|(504175)|(627780)|(636368)|(636297))[0-9]{0,10})|((50676)|(50675)|(50674)|(50673)|(50672)|(50671)|(50670))[0-9]{0,11})$/ }), Jn.cards.push({ cardType: "uatp", startingRules: [1], permittedLengths: [15], pattern: /^1[0-9]{0,14}$/, cvcPolicy: "optional" }), Jn.cards.push({ cardType: "cartebancaire", startingRules: [4, 5, 6], permittedLengths: [16], pattern: /^[4-6][0-9]{0,15}$/ }), Jn.cards.push({ cardType: "visaalphabankbonus", startingRules: [450903], permittedLengths: [16], pattern: /^(450903)[0-9]{0,10}$/ }), Jn.cards.push({ cardType: "mcalphabankbonus", startingRules: [510099], permittedLengths: [16], pattern: /^(510099)[0-9]{0,10}$/ }), Jn.cards.push({ cardType: "hiper", startingRules: [637095, 637568, 637599, 637609, 637612], permittedLengths: [16], pattern: /^(637095|637568|637599|637609|637612)[0-9]{0,10}$/ }), Jn.cards.push({ cardType: "oasis", startingRules: [982616], permittedLengths: [16], pattern: /^(982616)[0-9]{0,10}$/, cvcPolicy: "optional" }), Jn.cards.push({ cardType: "karenmillen", startingRules: [98261465], permittedLengths: [16], pattern: /^(98261465)[0-9]{0,8}$/, cvcPolicy: "optional" }), Jn.cards.push({ cardType: "warehouse", startingRules: [982633], permittedLengths: [16], pattern: /^(982633)[0-9]{0,10}$/, cvcPolicy: "optional" }), Jn.cards.push({ cardType: "mir", startingRules: [220], permittedLengths: [16, 17, 18, 19], pattern: /^(220)[0-9]{0,16}$/ }), Jn.cards.push({ cardType: "codensa", startingRules: [590712], permittedLengths: [16], pattern: /^(590712)[0-9]{0,10}$/ }), Jn.cards.push({ cardType: "naranja", startingRules: [377798, 377799, 402917, 402918, 527571, 527572, 589562], permittedLengths: [16, 17, 18, 19], pattern: /^(37|40|5[28])([279])\d*$/ }), Jn.cards.push({ cardType: "cabal", startingRules: [589657, 600691, 603522, 6042, 6043, 636908], permittedLengths: [16, 17, 18, 19], pattern: /^(58|6[03])([03469])\d*$/ }), Jn.cards.push({ cardType: "shopping", startingRules: [2799, 589407, 603488], permittedLengths: [16, 17, 18, 19], pattern: /^(27|58|60)([39])\d*$/ }), Jn.cards.push({ cardType: "argencard", startingRules: [501], permittedLengths: [16, 17, 18, 19], pattern: /^(50)(1)\d*$/ }), Jn.cards.push({ cardType: "troy", startingRules: [9792], permittedLengths: [16], pattern: /^(97)(9)\d*$/ }), Jn.cards.push({ cardType: "forbrugsforeningen", startingRules: [600722], permittedLengths: [16], pattern: /^(60)(0)\d*$/ }), Jn.cards.push({ cardType: "vpay", startingRules: [401, 408, 413, 434, 435, 437, 439, 441, 442, 443, 444, 446, 447, 455, 458, 460, 461, 463, 466, 471, 479, 482, 483, 487], permittedLengths: [13, 14, 15, 16, 17, 18, 19], pattern: /^(40[1,8]|413|43[4,5]|44[1,2,3,4,6,7]|45[5,8]|46[0,1,3,6]|47[1,9]|48[2,3,7])[0-9]{0,16}$/ }), Jn.cards.push({ cardType: "rupay", startingRules: [508528], permittedLengths: [16], pattern: /^(100003|508(2|[5-9])|60(69|[7-8])|652(1[5-9]|[2-5][0-9]|8[5-9])|65300[3-4]|8172([0-1]|[3-5]|7|9)|817(3[3-8]|40[6-9]|410)|35380([0-2]|[5-6]|9))[0-9]{0,12}$/ }), Jn.cards.push({ cardType: "ticket", expiryDatePolicy: "hidden" });
var sD = { detectCard: function(e, t) {
  var n, r, a;
  if (t) {
    var o, s;
    if ((n = Oe(o = Oe(s = Jn.cards).call(s, function(f) {
      return jt(t).call(t, f.cardType);
    })).call(o, function(f) {
      return Ir(f, "pattern") && e.match(f.pattern);
    })).length) {
      if (n.length === 1) return n[0];
      for (r = 0, a = n.length; r < a; r += 1) if (!n[r].longestRule) {
        var c, u = rr(c = n[r].startingRules).call(c, function(f, m) {
          return f > m ? f : m;
        });
        n[r].longestRule = String(u).length;
      }
      return rr(n).call(n, function(f, m) {
        return f.longestRule >= m.longestRule ? f : m;
      });
    }
    return { cardType: Jn.__NO_BRAND };
  }
  return { cardType: Jn.__NO_BRAND };
}, detectCardLength: function(e, t) {
  var n, r, a, o = 0, s = !1, c = t, u = e.cardType !== Jn.__NO_BRAND ? e.permittedLengths[e.permittedLengths.length - 1] : 0;
  if (u && c > u && (o = c.length - u) > 0 && (a = c = c.substring(0, c.length - o)), Q(n = e.permittedLengths).call(n, function(m) {
    c.length === m && (s = !0);
  }), c.length === u) {
    var f = Math.floor(c.length / 4);
    r = u + (c.length % 4 > 0 ? f : f - 1), e.cardType.toLowerCase() === "amex" && (r = u + 2);
  }
  return { shortenedNewValue: a, maxLength: r, reachedValidLength: s };
}, getShortestPermittedCardLength: function() {
  if (!QP) {
    var e, t = [];
    Q(e = Jn.cards).call(e, function(n) {
      var r;
      t = je(t).call(t, (r = n.permittedLengths) !== null && r !== void 0 ? r : []);
    }), QP = Math.min.apply(null, t);
  }
  return QP;
}, getCardByBrand: function(e) {
  var t;
  return Oe(t = Jn.cards).call(t, function(n) {
    return n.cardType === e;
  })[0];
}, isGenericCardType: function(e) {
  if (!e) throw new Error("Error: isGenericCardType: type param has not been specified");
  return e === "card" || e === "scheme";
}, __NO_BRAND: Jn.__NO_BRAND, allCards: Jn.cards }, WYe = et(function e() {
  Qe(this, e), T(this, "sfConfig", void 0), T(this, "fieldType", void 0), T(this, "iframeSrc", void 0), T(this, "loadingContext", void 0), T(this, "holderEl", void 0), T(this, "iframeRef", void 0), T(this, "loadToConfigTimeout", void 0), T(this, "_errorType", void 0), T(this, "_hasError", void 0), T(this, "_isValid", void 0), T(this, "_cvcPolicy", void 0), T(this, "_expiryDatePolicy", void 0), T(this, "_iframeContentWindow", void 0), T(this, "_isEncrypted", void 0), T(this, "_numKey", void 0), T(this, "_iframeOnLoadListener", void 0), T(this, "_postMessageListener", void 0), T(this, "onIframeLoadedCallback", void 0), T(this, "onConfigCallback", void 0), T(this, "onEncryptionCallback", void 0), T(this, "onValidationCallback", void 0), T(this, "onFocusCallback", void 0), T(this, "onBinValueCallback", void 0), T(this, "onTouchstartCallback", void 0), T(this, "onShiftTabCallback", void 0), T(this, "onAutoCompleteCallback", void 0), this.sfConfig = {};
});
function TZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function OZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = TZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = TZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var _ie = function(e, t) {
  var n = e === "card" ? "nocard" : e || "nocard", r = { type: n, extension: "svg" };
  return t.getImage(r)(n);
}, o7 = function(e) {
  var t = e.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
  return jt(xm).call(xm, e) && (t = t.substring(10)), t;
};
function iC() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  var r = M8(t[0]) ? t[0] : t;
  return { from: function(a) {
    var o;
    return rr(o = It(r).call(r, function(s) {
      return s in a ? T({}, s, a[s]) : {};
    })).call(o, function(s, c) {
      return OZ(OZ({}, s), c);
    }, {});
  } };
}
function Cie() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  var r = M8(t[0]) ? t[0] : t;
  return { from: function(a) {
    var o, s = Oe(o = Pe(a)).call(o, function(c) {
      return !jt(r).call(r, c);
    });
    return iC.apply(void 0, Pn(s)).from(a);
  } };
}
function RZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function MZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = RZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = RZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function DZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function eN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = DZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = DZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function ZYe(e, t, n) {
  var r = e.txVariant, a = function(o) {
    var s = T(T(T(T(T(T(T(T(T(T({}, Or, o.get && o.get("creditCard.numberField.placeholder")), Jr, o.get && o.get("creditCard.expiryDateField.placeholder")), ro, o.get && o.get("creditCard.expiryDateField.month.placeholder")), Ca, o.get && o.get("creditCard.expiryDateField.year.placeholder")), Fr, o.get && o.get("creditCard.cvcField.placeholder")), UP, o.get && o.get("creditCard.cvcField.placeholder.3digits")), GP, o.get && o.get("creditCard.cvcField.placeholder.4digits")), yd, o.get && o.get("creditCard.encryptedPassword.placeholder")), Jy, o.get && o.get("ach.accountNumberField.placeholder")), Qy, o.get && o.get("ach.accountLocationId.placeholder"));
    return s[Jy] === "ach.accountNumberField.placeholder" && (s[Jy] = ""), s[Qy] === "ach.accountLocationId.placeholder" && (s[Qy] = ""), s;
  }(n);
  return eN(eN(eN({}, t !== Fr && T({}, t, a[t])), t === Fr && r === r6 && T({}, t, a[t])), t === Fr && r !== r6 && T(T({}, UP, a[UP]), GP, a[GP]));
}
function LZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = LZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = LZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function YYe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var XYe = function(e) {
  ft(n, WYe);
  var t = YYe(n);
  function n(r, a) {
    var o;
    Qe(this, n), o = t.call(this);
    var s = ["fieldType", "iframeSrc", "cvcPolicy", "expiryDatePolicy", "loadingContext", "holderEl"], c = Cie(s).from(r);
    o.sfConfig = tx(tx(tx({}, o.sfConfig), c), {}, { iframeUIConfig: tx({}, c.iframeUIConfig) });
    var u = iC(s).from(r);
    return o.fieldType = u.fieldType, o.cvcPolicy = u.cvcPolicy, o.expiryDatePolicy = u.expiryDatePolicy, o.iframeSrc = u.iframeSrc, o.loadingContext = u.loadingContext, o.holderEl = u.holderEl, o.isValid = !1, o.iframeContentWindow = null, o.numKey = function() {
      if (!window.crypto) return 4294967296 * Math.random() | 0;
      var f = new Uint32Array(1);
      return window.crypto.getRandomValues(f), f[0];
    }(), o.isEncrypted = !1, o.hasError = !1, o.errorType = "", ct(o, o.init(a));
  }
  return et(n, [{ key: "init", value: function(r) {
    var a = function(u, f, m) {
      var v, y, b, S = jt(v = ["ach", "giftcard"]).call(v, u.txVariant) ? u.txVariant : "creditCard", x = m.get(je(y = "".concat(S, ".")).call(y, f, ".aria.iframeTitle")), E = m.get(je(b = "".concat(S, ".")).call(b, f, ".aria.label")), N = m.locale, R = GZe({ iframeTitle: x, label: E }, m);
      return MZ(MZ({}, N && { lang: N }), {}, T({}, f, R));
    }(this.sfConfig, this.fieldType, r);
    this.sfConfig.iframeUIConfig.ariaConfig = a;
    var o = ZYe(this.sfConfig, this.fieldType, r);
    this.sfConfig.iframeUIConfig.placeholders = o;
    var s = function(u) {
      var f = u.src, m = u.title, v = m === void 0 ? "iframe element" : m, y = u.policy, b = y === void 0 ? "origin" : y, S = document.createElement("iframe");
      S.setAttribute("src", f), S.classList.add("js-iframe"), v === "" || zp(v).call(v).length === 0 || v === "none" ? S.setAttribute("role", "presentation") : S.setAttribute("title", v), S.setAttribute("allowtransparency", "true"), S.setAttribute("referrerpolicy", b);
      var x = document.createTextNode("<p>Your browser does not support iframes.</p>");
      return S.appendChild(x), S;
    }({ src: this.iframeSrc, title: a[this.fieldType].iframeTitle, policy: "origin" });
    this.holderEl.appendChild(s);
    var c = Ru(this.holderEl, ".js-iframe");
    return c && (this.iframeContentWindow = c.contentWindow, this.iframeOnLoadListener = this.iframeOnLoadListenerFn, s6(c, "load", this.iframeOnLoadListener, !1)), this.iframeRef = c, this;
  } }, { key: "iframeOnLoadListenerFn", value: function() {
    this.postMessageListener = this.postMessageListenerFn, s6(window, "message", this.postMessageListener, !1);
    var r = { fieldType: this.fieldType, extraFieldData: this.sfConfig.extraFieldData, uid: this.sfConfig.uid, cvcPolicy: this.cvcPolicy, expiryDatePolicy: this.expiryDatePolicy, numKey: this.numKey, txVariant: this.sfConfig.txVariant, cardGroupTypes: this.sfConfig.cardGroupTypes, iframeUIConfig: this.sfConfig.iframeUIConfig, sfLogAtStart: this.sfConfig.sfLogAtStart, trimTrailingSeparator: this.sfConfig.trimTrailingSeparator, isCreditCardType: this.sfConfig.isCreditCardType, showWarnings: this.sfConfig.showWarnings, legacyInputMode: this.sfConfig.legacyInputMode, minimumExpiryDate: this.sfConfig.minimumExpiryDate, implementationType: this.sfConfig.implementationType, maskSecurityCode: this.sfConfig.maskSecurityCode, exposeExpiryDate: this.sfConfig.exposeExpiryDate, disableIOSArrowKeys: this.sfConfig.disableIOSArrowKeys };
    window._b$dl && console.log("### SecuredField:::: onIframeLoaded:: created configObj=", r), Ic(r, this.iframeContentWindow, this.loadingContext), this.onIframeLoadedCallback();
  } }, { key: "postMessageListenerFn", value: function(r) {
    if (function(o, s, c) {
      var u = o.origin, f = ka(s).call(s, "/checkoutshopper/"), m = f > -1 ? s.substring(0, f) : s, v = m.length - 1;
      return m.charAt(v) === "/" && (m = m.substring(0, v)), u === m || (c && (Em(`WARNING postMessageValidation: postMessage listener for iframe::origin mismatch!
 Received message with origin:`, u, "but the only allowed origin for messages to CSF is", m), Em("### event.data=", o.data)), !1);
    }(r, this.loadingContext, this.sfConfig.showWarnings)) {
      var a;
      try {
        a = JSON.parse(r.data);
      } catch (o) {
        return function(s) {
          var c;
          return s.data && s.data.type && typeof s.data.type == "string" && ka(c = s.data.type).call(c, "webpack") > -1;
        }(r) ? void (this.sfConfig.showWarnings && JP("### SecuredField::postMessageListenerFn:: PARSE FAIL - WEBPACK")) : function(s) {
          var c;
          return s.data && typeof s.data == "string" && ka(c = s.data).call(c, "cvox") > -1;
        }(r) ? void (this.sfConfig.showWarnings && JP("### SecuredField::postMessageListenerFn:: PARSE FAIL - CHROMEVOX")) : void (this.sfConfig.showWarnings && JP("### SecuredField::postMessageListenerFn:: PARSE FAIL - UNKNOWN REASON: event.data=", r.data));
      }
      if (Ir(a, "action") && Ir(a, "numKey")) if (this.numKey === a.numKey) switch (a.action) {
        case "encryption":
          this.isValid = !0, this.onEncryptionCallback(a);
          break;
        case "config":
          window._b$dl && console.log("### SecuredField::postMessageListenerFn:: configured - calling onConfigCallback", a.fieldType), this.onConfigCallback(a);
          break;
        case "focus":
          this.onFocusCallback(a);
          break;
        case "binValue":
          this.onBinValueCallback(a);
          break;
        case "touch":
          this.onTouchstartCallback(a);
          break;
        case "shifttab":
          this.onShiftTabCallback(a);
          break;
        case "autoComplete":
          this.onAutoCompleteCallback(a);
          break;
        default:
          this.isValid = !1, this.onValidationCallback(a);
      }
      else this.sfConfig.showWarnings && Em("WARNING SecuredField :: postMessage listener for iframe :: data mismatch! (Probably a message from an unrelated securedField)");
      else this.sfConfig.showWarnings && Em("WARNING SecuredField :: postMessage listener for iframe :: data mismatch!");
    }
  } }, { key: "destroy", value: function() {
    l6(window, "message", this.postMessageListener, !1), l6(this.iframeRef, "load", this.iframeOnLoadListener, !1), this.iframeContentWindow = null, function(r) {
      for (; r.firstChild; ) r.removeChild(r.firstChild);
    }(this.holderEl);
  } }, { key: "isOptionalOrHidden", value: function() {
    if (this.fieldType === Jr || this.fieldType === ro || this.fieldType === Ca) switch (this.expiryDatePolicy) {
      case y2:
        return !0;
      case g_:
        return !this.hasError;
      default:
        return !1;
    }
    if (this.fieldType === Fr) switch (this.cvcPolicy) {
      case v_:
        return !0;
      case m_:
        return !this.hasError;
      default:
        return !1;
    }
    return !1;
  } }, { key: "onIframeLoaded", value: function(r) {
    return this.onIframeLoadedCallback = r, this;
  } }, { key: "onEncryption", value: function(r) {
    return this.onEncryptionCallback = r, this;
  } }, { key: "onValidation", value: function(r) {
    return this.onValidationCallback = r, this;
  } }, { key: "onConfig", value: function(r) {
    return this.onConfigCallback = r, this;
  } }, { key: "onFocus", value: function(r) {
    return this.onFocusCallback = r, this;
  } }, { key: "onBinValue", value: function(r) {
    return this.onBinValueCallback = r, this;
  } }, { key: "onTouchstart", value: function(r) {
    return this.onTouchstartCallback = r, this;
  } }, { key: "onShiftTab", value: function(r) {
    return this.onShiftTabCallback = r, this;
  } }, { key: "onAutoComplete", value: function(r) {
    return this.onAutoCompleteCallback = r, this;
  } }, { key: "errorType", get: function() {
    return this._errorType;
  }, set: function(r) {
    this._errorType = r;
  } }, { key: "hasError", get: function() {
    return this._hasError;
  }, set: function(r) {
    this._hasError = r;
  } }, { key: "isValid", get: function() {
    if (this.fieldType === Fr) switch (this.cvcPolicy) {
      case v_:
        return !0;
      case m_:
        return !this.hasError;
      default:
        return this._isValid;
    }
    if (this.fieldType === Jr || this.fieldType === ro || this.fieldType === Ca) switch (this.expiryDatePolicy) {
      case y2:
        return !0;
      case g_:
        return !this.hasError;
      default:
        return this._isValid;
    }
    return this._isValid;
  }, set: function(r) {
    this._isValid = r;
  } }, { key: "cvcPolicy", get: function() {
    return this._cvcPolicy;
  }, set: function(r) {
    this.fieldType === Fr && r !== this.cvcPolicy && (this._cvcPolicy = r, this.hasError && this.errorType === "isValidated" && (this.hasError = !1));
  } }, { key: "expiryDatePolicy", get: function() {
    return this._expiryDatePolicy;
  }, set: function(r) {
    this.fieldType !== Jr && this.fieldType !== ro && this.fieldType !== Ca || r !== this.expiryDatePolicy && (this._expiryDatePolicy = r, this.hasError && this.errorType === "isValidated" && (this.hasError = !1));
  } }, { key: "iframeContentWindow", get: function() {
    return this._iframeContentWindow;
  }, set: function(r) {
    this._iframeContentWindow = r;
  } }, { key: "isEncrypted", get: function() {
    return this._isEncrypted;
  }, set: function(r) {
    this._isEncrypted = r;
  } }, { key: "numKey", get: function() {
    return this._numKey;
  }, set: function(r) {
    this._numKey = r;
  } }, { key: "iframeOnLoadListener", get: function() {
    return this._iframeOnLoadListener;
  }, set: function(r) {
    this._iframeOnLoadListener = pn(r).call(r, this);
  } }, { key: "postMessageListener", get: function() {
    return this._postMessageListener;
  }, set: function(r) {
    this._postMessageListener = pn(r).call(r, this);
  } }]), n;
}();
function KYe() {
  var e, t = this;
  this.encryptedAttrName = Ooe;
  var n = Oe(e = iie(this.props.rootNode, "[".concat(this.encryptedAttrName, "]"))).call(e, function(o) {
    var s, c = r7(o, t.encryptedAttrName), u = jt(xm).call(xm, c);
    return u || console.warn(je(s = "WARNING: '".concat(c, "' is not a valid type for the '")).call(s, t.encryptedAttrName, "' attribute. A SecuredField will not be created for this element.")), u;
  }), r = jm, a = jp;
  return this.config.isCreditCardType ? (this.isSingleBrandedCard = !1, this.securityCode = "", this.createCardSecuredFields(n, r, a), n.length) : (this.createNonCardSecuredFields(n), n.length);
}
function qYe(e) {
  return SO.apply(this, arguments);
}
function SO() {
  return SO = On(yt.mark(function e(t) {
    var n, r;
    return yt.wrap(function(a) {
      for (; ; ) switch (a.prev = a.next) {
        case 0:
          n = 0;
        case 1:
          if (!(n < t.length)) {
            a.next = 8;
            break;
          }
          return r = t[n], a.next = 5, this.setupSecuredField(r).catch(function(o) {
            window._b$dl && console.log("Secured fields setup failure. e=", o);
          });
        case 5:
          n++, a.next = 1;
          break;
        case 8:
        case "end":
          return a.stop();
      }
    }, e, this);
  })), SO.apply(this, arguments);
}
function JYe(e, t, n) {
  return xO.apply(this, arguments);
}
function xO() {
  return xO = On(yt.mark(function e(t, n, r) {
    var a, o, s, c, u, f = this;
    return yt.wrap(function(m) {
      for (; ; ) switch (m.prev = m.next) {
        case 0:
          (a = this.state.type) === "card" && this.config.cardGroupTypes.length === 1 && (a = this.config.cardGroupTypes[0], this.state.type = a), this.isSingleBrandedCard = a !== "card", this.isSingleBrandedCard && (Mp(o = sD.getCardByBrand(a)) ? (n = o.cvcPolicy || jm, r = o.expiryDatePolicy || jp, this.securityCode = o.securityCode) : this.state.type = "unrecognised-single-brand"), s = 0;
        case 5:
          if (!(s < t.length)) {
            m.next = 14;
            break;
          }
          return c = t[s], window._b$dl && console.log(`
About to set up securedField:`, c), m.next = 10, this.setupSecuredField(c, n, r).catch(function(v) {
            window._b$dl && console.log("Secured fields setup failure. e=", v);
          });
        case 10:
          window._b$dl && console.log("Finished setting up securedField:", c);
        case 11:
          s++, m.next = 5;
          break;
        case 14:
          window._b$dl && console.log("Finished setting up all securedFields"), this.isSingleBrandedCard && (u = { type: this.state.type, rootNode: this.props.rootNode, brand: a, cvcPolicy: n, expiryDatePolicy: r, cvcText: this.securityCode }, Ro(function() {
            f.callbacks.onBrand(u);
          }, 0));
        case 16:
        case "end":
          return m.stop();
      }
    }, e, this);
  })), xO.apply(this, arguments);
}
function QYe(e, t, n) {
  var r = this;
  return new Yt(function(a, o) {
    var s = r7(e, r.encryptedAttrName);
    s === Ca && (r.state.hasSeparateDateFields = !0);
    var c = { fieldType: s, extraFieldData: r7(e, Roe), uid: r7(e, Moe), cvcPolicy: t, holderEl: e, expiryDatePolicy: n, txVariant: r.state.type, cardGroupTypes: r.config.cardGroupTypes, iframeUIConfig: r.config.iframeUIConfig ? r.config.iframeUIConfig : {}, sfLogAtStart: r.config.sfLogAtStart, trimTrailingSeparator: r.config.trimTrailingSeparator, isCreditCardType: r.config.isCreditCardType, iframeSrc: r.config.iframeSrc, loadingContext: r.config.loadingContext, showWarnings: r.config.showWarnings, legacyInputMode: r.config.legacyInputMode, minimumExpiryDate: r.config.minimumExpiryDate, implementationType: r.config.implementationType, maskSecurityCode: r.config.maskSecurityCode, exposeExpiryDate: r.props.exposeExpiryDate, disableIOSArrowKeys: r.config.shouldDisableIOSArrowKeys }, u = new XYe(c, r.props.i18n).onIframeLoaded(function() {
      var f;
      if (r.state.iframeCount += 1, window._b$dl && console.log("### createSecuredFields::onIframeLoaded:: this.state.iframeCount=", r.state.iframeCount), r.state.iframeCount > r.state.numIframes) throw r.destroySecuredFields(), new _r("ERROR", je(f = `One or more securedFields has just loaded new content. This should never happen. securedFields have been removed.
                        iframe load count=`.concat(r.state.iframeCount, ". Expected count:")).call(f, r.state.numIframes));
      u.loadToConfigTimeout = Ro(function() {
        o({ type: u.fieldType, failReason: "sf took too long to config" });
      }, 6e3), r.state.iframeCount === r.state.originalNumIframes && r.callbacks.onLoad({ iframesLoaded: !0 });
    }).onConfig(function(f) {
      r.handleIframeConfigFeedback(f), clearTimeout(u.loadToConfigTimeout), u.loadToConfigTimeout = null, a(f);
    }).onFocus(function(f) {
      r.handleFocus(f);
    }).onBinValue(function(f) {
      r.handleBinValue(f);
    }).onTouchstart(function(f) {
      r.config.shouldDisableIOSArrowKeys && (r.hasGenuineTouchEvents || f.hasGenuineTouchEvents) && r.callbacks.onTouchstartIOS({ fieldType: f.fieldType }), (f.hasGenuineTouchEvents || r.hasGenuineTouchEvents) && r.postMessageToAllIframes({ fieldType: f.fieldType, fieldClick: !0 });
    }).onShiftTab(function(f) {
      r.handleSFShiftTab(f.fieldType);
    }).onEncryption(function(f) {
      r.handleEncryption(f);
    }).onValidation(function(f) {
      r.handleValidation(f);
    }).onAutoComplete(function(f) {
      r.processAutoComplete(f);
    });
    r.state.securedFields[s] = u;
  });
}
var eXe = typeof navigator != "undefined" && /(android)/i.test(navigator.userAgent), tXe = typeof navigator != "undefined" && function() {
  var e = navigator.userAgent, t = ka(e).call(e, "MSIE ");
  if (t > 0) return Ou(e.substring(t + 5, ka(e).call(e, ".", t)), 10);
  if (ka(e).call(e, "Trident/") > 0) {
    var n = ka(e).call(e, "rv:");
    return Ou(e.substring(n + 3, ka(e).call(e, ".", n)), 10);
  }
  var r = ka(e).call(e, "Edge/");
  return r > 0 && Ou(e.substring(r + 5, ka(e).call(e, ".", r)), 10);
}(), z0 = { __IS_ANDROID: eXe, __IS_IE: tXe, __IS_IOS: typeof navigator != "undefined" && /iphone|ipod|ipad/i.test(navigator.userAgent), __IS_FIREFOX: typeof navigator != "undefined" && /(firefox)/i.test(navigator.userAgent), __IS_SAFARI: typeof navigator != "undefined" && /(safari)/i.test(navigator.userAgent) && !/(chrome)/i.test(navigator.userAgent) }, nXe = function(e) {
  var t, n = e.target;
  if (n instanceof HTMLInputElement || HTMLTextAreaElement && n instanceof HTMLTextAreaElement) {
    var r = n.value, a = "selectionStart" in (t = n) ? t.selectionStart : 0, o = !1;
    a === r.length && (a -= 1, o = !0), n.value = r;
    try {
      n.setSelectionRange && (n.focus(), n.setSelectionRange(a, a), o && (a += 1, Ro(function() {
        n.setSelectionRange(a, a);
      }, 0)));
    } catch (u) {
    }
  } else if (this.config.keypadFix) {
    var s = this.props.rootNode, c = document.createElement("input");
    c.style.width = "1px", c.style.height = "1px", c.style.opacity = "0", c.style.fontSize = "18px", s.appendChild(c), c.focus(), s.removeChild(c);
  }
  this.destroyTouchendListener(), this.state.registerFieldForIos = !1, this.postMessageToAllIframes({ fieldType: "webInternalElement", fieldClick: !0 });
}, rXe = function(e) {
  this.hasGenuineTouchEvents = !0;
  var t = e.target;
  if (t instanceof HTMLInputElement || t instanceof HTMLSpanElement) {
    var n, r, a;
    this.postMessageToAllIframes({ fieldType: "webInternalElement", checkoutTouchEvent: !0 });
    var o = (n = t.getAttribute("name")) !== null && n !== void 0 ? n : t.getAttribute("data-id");
    (r = (a = this.callbacks).onTouchstartIOS) === null || r === void 0 || r.call(a, { fieldType: "webInternalElement", name: o });
  }
}, aXe = function() {
  var e = Ru(document, "body");
  e.style.cursor = "pointer", s6(e, "touchend", this.touchendListener), this.state.registerFieldForIos = !0;
}, oXe = function() {
  if (!z0.__IS_IOS) return !1;
  var e = Ru(document, "body");
  return e.style.cursor = "auto", l6(e, "touchend", this.touchendListener), !0;
}, iXe = function() {
  return !!z0.__IS_IOS && (l6(document, "touchstart", this.touchstartListener), !0);
}, d4 = function(e, t, n) {
  return function(r) {
    var a = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], o = Xo(Array.prototype).call(iie(document, "*[data-cse], a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable]")), s = [];
    Q(o).call(o, function(u) {
      var f = u.getAttribute("tabindex"), m = !f || Ou(f, 10) >= 0, v = u.getBoundingClientRect(), y = v.width > 0 && v.height > 0;
      m && y && s.push(u);
    });
    var c = function(u, f) {
      for (var m = 0; m < u.length; m += 1) if (f(u[m])) return m;
      return -1;
    }(s, function(u) {
      return u === r || r.contains(u);
    });
    return s[c + (a ? -1 : 1)];
  }(Ru(t, "[data-cse=".concat(e, "]")), n);
}, sXe = function(e) {
  var t;
  switch (this.state.type) {
    case "ach":
      t = function(o) {
        var s;
        return o === Qy && (s = Jy), { fieldToFocus: s, additionalField: void 0 };
      }(e);
      break;
    case "giftcard":
      t = function(o, s) {
        var c, u;
        switch (o) {
          case Or:
            c = d4(Or, s);
            break;
          case Fr:
            u = Or;
        }
        return { fieldToFocus: u, additionalField: c };
      }(e, this.props.rootNode);
      break;
    default:
      t = this.state.isKCP ? function(o, s, c) {
        var u, f;
        switch (o) {
          case Or:
            u = d4(Or, s);
            break;
          case Jr:
          case ro:
            f = Or;
            break;
          case Ca:
            f = ro;
            break;
          case Fr:
            f = c ? Ca : Jr;
            break;
          case yd:
            u = d4(o, s);
        }
        return { fieldToFocus: f, additionalField: u };
      }(e, this.props.rootNode, this.state.hasSeparateDateFields) : function(o, s, c, u) {
        var f, m;
        switch (o) {
          case Or:
            f = d4(Or, s);
            break;
          case Jr:
          case ro:
            m = Or;
            break;
          case Ca:
            m = ro;
            break;
          case Fr:
            u === 1 ? f = d4(Fr, s) : m = c ? Ca : Jr;
        }
        return { fieldToFocus: m, additionalField: f };
      }(e, this.props.rootNode, this.state.hasSeparateDateFields, this.state.numIframes);
  }
  var n, r = t.fieldToFocus, a = t.additionalField;
  r ? this.setFocusOnFrame(r, !1) : a && (n = a) && (n.focus(), n.blur(), n.focus());
}, lXe = function(e) {
  (z0.__IS_FIREFOX || z0.__IS_IE && z0.__IS_IE <= 11) && this.handleShiftTab(e);
};
function $Z(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function H0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = $Z(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = $Z(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function uXe(e) {
  if (Ir(this.state.securedFields, Or)) {
    var t = H0(H0({ txVariant: this.state.type }, e), {}, { fieldType: Or, numKey: this.state.securedFields[Or].numKey });
    Ic(t, Id(this.state, Or), this.config.loadingContext);
  }
}
function cXe(e) {
  var t = this, n = Ir(this.state.securedFields, ro) && Ir(this.state.securedFields, Ca) ? [ro, Ca] : [Jr];
  Q(n).call(n, function(r) {
    var a = H0(H0({ txVariant: t.state.type }, e), {}, { fieldType: r, numKey: t.state.securedFields[r].numKey });
    Ic(a, Id(t.state, r), t.config.loadingContext);
  });
}
function dXe(e, t) {
  var n, r, a = this.state.type === "card";
  if (!e || !Pe(e).length) return a ? (this.sendBrandToCardSF({ brand: "reset" }), this.sendExpiryDatePolicyToSF({ expiryDatePolicy: jp })) : t && this.processBrand(H0(H0({}, t), {}, { fieldType: Or })), void (this.state.type === "card" && Ir(this.state.securedFields, Jr) && (this.state.securedFields[Jr].expiryDatePolicy = jp));
  var o = e.supportedBrands[0], s = o.brand, c = (n = o.expiryDatePolicy) !== null && n !== void 0 ? n : o.showExpiryDate === !0 ? jp : y2, u = { brand: s, cvcPolicy: o.cvcPolicy, expiryDatePolicy: c, cvcText: "Security code", showSocialSecurityNumber: (r = o.showSocialSecurityNumber) !== null && r !== void 0 && r, fieldType: Or };
  if (this.processBrand(u), a) {
    var f = H0({ brand: s, enableLuhnCheck: e.supportedBrands[0].enableLuhnCheck !== !1 }, (o == null ? void 0 : o.panLength) && { panLength: o == null ? void 0 : o.panLength });
    this.sendBrandToCardSF(f), this.sendExpiryDatePolicyToSF({ expiryDatePolicy: c });
  }
  Ir(this.state.securedFields, Fr) && (this.state.securedFields[Fr].cvcPolicy = o.cvcPolicy), Ir(this.state.securedFields, Jr) ? this.state.securedFields[Jr].expiryDatePolicy = c : Ir(this.state.securedFields, ro) && Ir(this.state.securedFields, Ca) && (this.state.securedFields[ro].expiryDatePolicy = c, this.state.securedFields[Ca].expiryDatePolicy = c), this.validateForm();
}
function fXe(e, t, n) {
  var r = e.csfState, a = e.csfConfig;
  if (Ir(r.securedFields, t)) {
    var o = { txVariant: r.type, fieldType: t, focus: !0, numKey: r.securedFields[t].numKey };
    Ic(o, Id(r, t), a.loadingContext);
  }
}
function pXe(e, t) {
  var n = e.csfState, r = e.csfConfig, a = Pe(t || {});
  if (!a.length) return !1;
  var o = Pe(n.securedFields);
  return Q(o).call(o, function(s) {
    var c = { txVariant: n.type, fieldType: s, numKey: n.securedFields[s].numKey };
    Q(a).call(a, function(u) {
      c[u] = t[u];
    }), Ic(c, Id(n, s), r.loadingContext);
  }), !0;
}
var hXe = function(e, t) {
  return !uie(e, t);
};
function mXe(e, t) {
  var n = e.csfState, r = e.csfConfig, a = e.csfProps, o = e.csfCallbacks;
  if (t.fieldType === Or) {
    var s = { brand: t.brand, cvcPolicy: t.cvcPolicy, expiryDatePolicy: t.expiryDatePolicy, showSocialSecurityNumber: t.showSocialSecurityNumber }, c = hXe(s, n.brand);
    if (!c) return null;
    var u = n.type === "card" || n.type === "bcmc";
    if (u && c && (n.brand = s, Ir(n.securedFields, Fr))) {
      var f = { txVariant: n.type, brand: s.brand, fieldType: Fr, cvcPolicy: t.cvcPolicy, numKey: n.securedFields[Fr].numKey };
      Ic(f, Id(n, Fr), r.loadingContext);
    }
    var m = u ? iC(["brand", "cvcPolicy", "cvcText", "expiryDatePolicy", "showSocialSecurityNumber"]).from(t) : null;
    if (m && m.brand) {
      var v = m;
      v.type = n.type, v.rootNode = a.rootNode, o.onBrand(v);
    }
    return !0;
  }
  return !1;
}
function jZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vXe(e, t) {
  var n = e.csfState, r = e.csfConfig, a = e.csfCallbacks;
  if (t.name === "cc-name") {
    var o = function(x) {
      for (var E = 1; E < arguments.length; E++) {
        var N, R, O = arguments[E] != null ? arguments[E] : {};
        E % 2 ? Q(N = jZ(Object(O), !0)).call(N, function(D) {
          T(x, D, O[D]);
        }) : ne ? Ze(x, ne(O)) : Q(R = jZ(Object(O))).call(R, function(D) {
          We(x, D, re(O, D));
        });
      }
      return x;
    }({}, t);
    delete o.numKey;
    var s = o;
    return a.onAutoComplete(s), !0;
  }
  if (t.name === "cc-exp") {
    var c, u = t.value.replace(/[^0-9]/gi, "/").split("/");
    if (u.length !== 2) return !1;
    u[0].length === 1 && (u[0] = "0".concat(u[0]));
    var f = u[0], m = u[1];
    if (!(((m == null ? void 0 : m.length) === 4 || (m == null ? void 0 : m.length) === 2) && !isNaN(Ou(m)))) return !1;
    var v = Xo(m).call(m, -2), y = je(c = "".concat(f, "/")).call(c, v);
    if (Ir(n.securedFields, Jr)) {
      var b = { txVariant: n.type, fieldType: Jr, autoComplete: y, numKey: n.securedFields[Jr].numKey };
      return Ic(b, Id(n, Jr), r.loadingContext), !0;
    }
    if (Ir(n.securedFields, ro)) {
      var S = { txVariant: n.type, fieldType: ro, autoComplete: f, numKey: n.securedFields[ro].numKey };
      Ic(S, Id(n, ro), r.loadingContext);
    }
    return Ir(n.securedFields, Ca) && Ro(function() {
      var x = { txVariant: n.type, fieldType: Ca, autoComplete: v, numKey: n.securedFields[Ca].numKey };
      Ic(x, Id(n, Ca), r.loadingContext);
    }, 0), !0;
  }
  return !1;
}
function FZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gXe(e, t, n) {
  var r = e.csfState, a = e.csfProps, o = e.csfCallbacks, s = function(f) {
    for (var m = 1; m < arguments.length; m++) {
      var v, y, b = arguments[m] != null ? arguments[m] : {};
      m % 2 ? Q(v = FZ(Object(b), !0)).call(v, function(S) {
        T(f, S, b[S]);
      }) : ne ? Ze(f, ne(b)) : Q(y = FZ(Object(b))).call(y, function(S) {
        We(f, S, re(b, S));
      });
    }
    return f;
  }({}, n);
  delete s.numKey, s.rootNode = a.rootNode, s.type = r.type;
  var c = s.fieldType;
  s.focus ? r.currentFocusObject !== c && (r.currentFocusObject = c, z0.__IS_IOS && !r.registerFieldForIos && t()) : r.currentFocusObject === c && (r.currentFocusObject = null);
  var u = s;
  u.currentFocusObject = r.currentFocusObject, o.onFocus(u);
}
function yXe(e, t, n) {
  var r = e.csfState, a = e.csfCallbacks;
  if (r.iframeConfigCount += 1, window._b$dl && console.log("### handleIframeConfigFeedback::csfState.iframeConfigCount:: ", r.iframeConfigCount, "who=", n.fieldType), r.isConfigured) {
    var o = { additionalIframeConfigured: !0, fieldType: n.fieldType, type: r.type };
    a.onAdditionalSFConfig(o);
  } else if (r.iframeConfigCount === r.originalNumIframes) return t(), !0;
  return !1;
}
function bXe(e, t) {
  var n = e.csfState, r = e.csfConfig, a = e.csfProps, o = e.csfCallbacks;
  n.isConfigured = !0;
  var s = { iframesConfigured: !0, type: n.type, rootNode: a.rootNode };
  if (o.onConfigSuccess(s), n.numIframes === 1 && r.isCreditCardType) {
    if (n.type === "card") return wO("ERROR: Payment method with a single secured field - but 'type' has not been set to a specific card brand"), !1;
    var c, u = sD.getCardByBrand(n.type);
    u && ((c = u.cvcPolicy) !== null && c !== void 0 ? c : jm) !== jm && t();
  }
  return !0;
}
function _Xe(e) {
  var t = e.csfState, n = e.csfProps, r = e.csfCallbacks, a = function(c) {
    for (var u = Pe(c), f = 0, m = u.length; f < m; f += 1) if (!c[u[f]].isValid) return !1;
    return !0;
  }(t.securedFields), o = a !== t.allValid;
  if (t.allValid = a, a || o) {
    var s = { allValid: a, type: t.type, rootNode: n.rootNode };
    r.onAllValid(s);
  }
}
function CXe(e, t) {
  var n = e.csfState, r = e.csfCallbacks, a = t.binValue, o = t.encryptedBin, s = t.uuid, c = { binValue: a, type: n.type };
  o && (c.encryptedBin = o, c.uuid = s), r.onBinValue(c);
}
function wXe() {
  var e = this;
  this.postMessageToAllIframes({ destroy: !0 });
  var t = Pe(this.state.securedFields);
  Q(t).call(t, function(n) {
    var r = e.state.securedFields[n];
    r && r.destroy(), e.state.securedFields[n] = null;
  }), this.destroyTouchendListener(), this.destroyTouchstartListener(), this.state.securedFields = {};
}
function SXe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var f4 = function() {
  Em("".concat(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "You cannot use secured fields", " - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened."));
}, xXe = function(e) {
  ft(n, VYe);
  var t = SXe(n);
  function n(r) {
    var a, o, s, c, u, f;
    Qe(this, n), (f = t.call(this, r)).state = { type: f.props.type, brand: f.props.type !== "card" ? { brand: f.props.type, cvcPolicy: "required" } : { brand: null, cvcPolicy: "required" }, allValid: void 0, numIframes: 0, originalNumIframes: 0, iframeCount: 0, iframeConfigCount: 0, isConfigured: !1, hasSeparateDateFields: !1, currentFocusObject: null, registerFieldForIos: !1, securedFields: {}, isKCP: !1 };
    var m = { csfState: f.state, csfConfig: f.config, csfProps: f.props, csfCallbacks: f.callbacks };
    return f.configHandler = UYe, f.callbacksHandler = GYe, f.validateForm = yf(_Xe, m), f.isConfigured = yf(bXe, m, f.validateForm), f.handleIframeConfigFeedback = yf(yXe, m, f.isConfigured), f.processBrand = yf(mXe, m), f.handleValidation = zYe, f.handleEncryption = HYe, f.createSecuredFields = KYe, f.createNonCardSecuredFields = qYe, f.createCardSecuredFields = JYe, f.setupSecuredField = QYe, f.postMessageToAllIframes = yf(pXe, m), f.handleIOSTouchEvents = pn(a = aXe).call(a, Se(f)), f.touchendListener = pn(o = nXe).call(o, Se(f)), f.destroyTouchendListener = pn(s = oXe).call(s, Se(f)), f.touchstartListener = pn(c = rXe).call(c, Se(f)), f.destroyTouchstartListener = pn(u = iXe).call(u, Se(f)), f.setFocusOnFrame = yf(fXe, m), f.handleFocus = yf(gXe, m, f.handleIOSTouchEvents), f.handleSFShiftTab = lXe, f.handleShiftTab = sXe, f.destroySecuredFields = wXe, f.processAutoComplete = yf(vXe, m), f.handleBinValue = yf(CXe, m), f.handleBrandFromBinLookup = dXe, f.sendBrandToCardSF = uXe, f.sendExpiryDatePolicyToSF = cXe, f.init(), f;
  }
  return et(n, [{ key: "init", value: function() {
    this.configHandler(this.props), this.callbacksHandler(this.props.callbacks);
    var r = this.createSecuredFields();
    this.state.numIframes = this.state.originalNumIframes = r, this.state.isKCP = !!this.props.isKCP, z0.__IS_IOS && this.config.shouldDisableIOSArrowKeys && (this.hasGenuineTouchEvents = !1, s6(document, "touchstart", this.touchstartListener));
  } }, { key: "createReturnObject", value: function() {
    var r = this;
    return { updateStyles: function(a) {
      r.state.isConfigured ? r.postMessageToAllIframes({ styleObject: a }) : Em("You cannot update the secured fields styling - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened.");
    }, setFocusOnFrame: function(a) {
      r.state.isConfigured ? r.setFocusOnFrame(a) : f4("You cannot set focus on any secured field");
    }, isValidated: function(a, o) {
      if (r.state.isConfigured) {
        if (Ir(r.state.securedFields, a)) {
          r.state.securedFields[a].hasError = !0, r.state.securedFields[a].errorType === "" && (r.state.securedFields[a].errorType = "isValidated");
          var s = { txVariant: r.state.type, fieldType: a, externalValidation: !0, code: o, numKey: r.state.securedFields[a].numKey };
          Ic(s, Id(r.state, a), r.config.loadingContext);
        }
      } else f4("You cannot set validated on any secured field");
    }, hasUnsupportedCard: function(a, o) {
      if (r.state.isConfigured) {
        if (Ir(r.state.securedFields, a)) {
          r.state.securedFields[a].hasError = !!o, r.state.securedFields[a].errorType = o;
          var s = { txVariant: r.state.type, fieldType: a, unsupportedCard: !!o, code: o, numKey: r.state.securedFields[a].numKey };
          Ic(s, Id(r.state, a), r.config.loadingContext);
        }
      } else f4("You cannot set hasUnsupportedCard on any secured field");
    }, destroy: function() {
      r.state.isConfigured ? r.destroySecuredFields() : f4("You cannot destroy secured fields");
    }, brandsFromBinLookup: function(a, o) {
      if (!r.config.isCreditCardType) return null;
      r.state.isConfigured ? r.handleBrandFromBinLookup(a, o) : f4("You cannot set pass brands to secured fields");
    }, addSecuredField: function(a) {
      var o = Ru(r.props.rootNode, '[data-cse="'.concat(a, '"]'));
      o && (r.state.numIframes += 1, r.setupSecuredField(o));
    }, removeSecuredField: function(a) {
      if (r.state.securedFields[a]) {
        r.state.securedFields[a].destroy(), delete r.state.securedFields[a], r.state.numIframes -= 1, r.state.iframeCount -= 1;
        var o = { additionalIframeRemoved: !0, fieldType: a, type: r.state.type };
        r.callbacks.onAdditionalSFRemoved(o);
      }
    }, setKCPStatus: function(a) {
      r.state.isKCP = a;
    }, sfIsOptionalOrHidden: function(a) {
      return r.state.securedFields[a].isOptionalOrHidden();
    } };
  } }]), n;
}();
function BZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
var EXe = function(e) {
  if (!e) throw new Error("No securedFields configuration object defined");
  var t = function(a) {
    for (var o = 1; o < arguments.length; o++) {
      var s, c, u = arguments[o] != null ? arguments[o] : {};
      o % 2 ? Q(s = BZ(Object(u), !0)).call(s, function(f) {
        T(a, f, u[f]);
      }) : ne ? Ze(a, ne(u)) : Q(c = BZ(Object(u))).call(c, function(f) {
        We(a, f, re(u, f));
      });
    }
    return a;
  }({}, e);
  try {
    var n = sD.isGenericCardType(t.type);
    t.type = n ? "card" : t.type;
  } catch (a) {
    t.type = "card";
  }
  if (!Ir(t, "rootNode")) return wO('ERROR: SecuredFields configuration object is missing a "rootNode" property');
  if (XZe(t.clientKey)) return Em('WARNING: AdyenCheckout configuration object is missing a "clientKey" property.');
  var r = IXe(t.rootNode);
  return r ? (t.rootNode = r, new xXe(t).createReturnObject()) : wO("ERROR: SecuredFields cannot find a valid rootNode element for ".concat(t.type));
}, IXe = function(e) {
  var t;
  return mi(e) === "object" && (t = e), typeof e != "string" || (t = Ru(document, e)) ? t : null;
};
function VZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Zo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = VZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = VZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function nx(e, t, n, r) {
  return (t !== XM && t !== KM || n[e] !== 0) && r[e];
}
var kXe = function(e) {
  this.numCharsInField[e.fieldType] = e.numChars, this.props.onFocus(e);
}, AXe = function(e) {
  var t = this;
  return !this.state.detectedUnsupportedBrands && (this.setState({ isSfpValid: e.allValid }, function() {
    t.props.onChange(t.state, { event: "handleOnAllValid" }), t.props.onAllValid(e);
  }), !0);
}, PXe = function(e) {
  var t = this;
  this.setState({ autoCompleteName: e.value }, function() {
    t.props.onChange(t.state, { event: "handleOnAutoComplete", fieldType: e.fieldType }), t.setState({ autoCompleteName: null });
  }), this.props.onAutoComplete(e);
}, NXe = function(e) {
  var t = this;
  return (!this.state.detectedUnsupportedBrands || e.fieldType !== Or) && (this.setState(function(n) {
    var r;
    return { data: Zo(Zo({}, n.data), {}, T({}, e.encryptedFieldName, e.blob)), valid: Zo(Zo({}, n.valid), {}, T({}, e.encryptedFieldName, e.valid)), errors: Zo(Zo({}, n.errors), {}, T({}, e.fieldType, (r = n.errors[e.fieldType]) !== null && r !== void 0 && r)) };
  }, function() {
    t.props.onChange(t.state, { event: "handleOnFieldValid", fieldType: e.fieldType }), t.props.onFieldValid(e);
  }), !0);
}, TXe = function(e) {
  var t = this;
  clearTimeout(this.csfLoadFailTimeout), this.csfLoadFailTimeout = null, this.props.onLoad(e), this.csfConfigFailTimeout = Ro(function() {
    t.state.status !== "ready" && (t.setState({ status: "csfConfigFailure" }), t.props.onError(new _r("ERROR", "secured fields have failed to configure")));
  }, this.csfConfigFailTimeoutMS);
}, OXe = function(e) {
  var t = this;
  clearTimeout(this.csfConfigFailTimeout), this.csfConfigFailTimeout = null, this.setState({ status: "ready" }, function() {
    t.props.onConfigSuccess(e);
  });
}, RXe = function(e) {
  var t = this;
  this.setState(function(n) {
    var r, a, o = nx(Fr, e.cvcPolicy, t.numCharsInField, n.errors), s = t.numDateFields === 1 ? nx(Jr, e.expiryDatePolicy, t.numCharsInField, n.errors) : null, c = t.numDateFields === 2 ? nx(ro, e.expiryDatePolicy, t.numCharsInField, n.errors) : null, u = t.numDateFields === 2 ? nx(Ca, e.expiryDatePolicy, t.numCharsInField, n.errors) : null;
    return { brand: e.brand, cvcPolicy: (r = e.cvcPolicy) !== null && r !== void 0 ? r : jm, showSocialSecurityNumber: e.showSocialSecurityNumber, errors: Zo(Zo(Zo(Zo(Zo({}, n.errors), Mp(o) && T({}, Fr, o)), Mp(s) && T({}, Jr, s)), Mp(c) && T({}, ro, c)), Mp(u) && T({}, Ca, u)), expiryDatePolicy: (a = e.expiryDatePolicy) !== null && a !== void 0 ? a : jp };
  }, function() {
    var n, r;
    t.props.onChange(t.state, { event: "handleOnBrand" });
    var a = (n = (r = t.props.brandsConfiguration[e.brand]) === null || r === void 0 ? void 0 : r.icon) !== null && n !== void 0 ? n : _ie(e.brand, t.props.resources);
    t.props.onBrand(Zo(Zo({}, e), {}, { brandImageUrl: a }));
  });
}, MXe = function(e) {
  var t = this, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = e.error;
  return this.setState(function(a) {
    return Zo(Zo(Zo({ errors: Zo(Zo({}, a.errors), {}, T({}, e.fieldType, r || !1)) }, n && { data: Zo(Zo({}, a.data), {}, T({}, Or, void 0)) }), n && { valid: Zo(Zo({}, a.valid), {}, T({}, Or, !1)) }), n && { isSfpValid: !1 });
  }, function() {
    t.props.onChange(t.state, { event: "handleOnError", fieldType: e.fieldType });
  }), !0;
}, DXe = function() {
  var e = this;
  this.setState({ status: "ready" }, function() {
    return e.props.onChange({ isSfpValid: !0 });
  });
}, LXe = function(e) {
  var t, n;
  (t = (n = this.props).disableIOSArrowKeys) === null || t === void 0 || t.call(n, e);
};
function UZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function cd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = UZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = UZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function $Xe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var sC = function(e) {
  ft(n, yo);
  var t = $Xe(n);
  function n(r) {
    var a, o, s, c, u, f, m, v, y, b, S, x, E, N, R, O, D;
    Qe(this, n), D = t.call(this, r), T(Se(D), "csfLoadFailTimeout", void 0), T(Se(D), "csfLoadFailTimeoutMS", void 0), T(Se(D), "csfConfigFailTimeout", void 0), T(Se(D), "csfConfigFailTimeoutMS", void 0), T(Se(D), "numCharsInField", void 0), T(Se(D), "rootNode", void 0), T(Se(D), "numDateFields", void 0), T(Se(D), "csf", void 0), T(Se(D), "handleOnLoad", void 0), T(Se(D), "handleOnConfigSuccess", void 0), T(Se(D), "handleOnFieldValid", void 0), T(Se(D), "handleOnAllValid", void 0), T(Se(D), "handleOnBrand", void 0), T(Se(D), "handleFocus", void 0), T(Se(D), "handleOnError", void 0), T(Se(D), "handleOnAutoComplete", void 0), T(Se(D), "handleOnNoDataRequired", void 0), T(Se(D), "handleOnTouchstartIOS", void 0), T(Se(D), "state", void 0), T(Se(D), "props", void 0), T(Se(D), "issuingCountryCode", void 0), T(Se(D), "setRootNode", function(B) {
      D.rootNode = B;
    });
    var $ = { status: "loading", brand: r.type, errors: {}, valid: {}, data: {}, cvcPolicy: jm, expiryDatePolicy: jp, isSfpValid: !1, hasKoreanFields: r.hasKoreanFields };
    return D.state = $, D.csfLoadFailTimeout = null, D.csfLoadFailTimeoutMS = 3e4, D.csfConfigFailTimeout = null, D.csfConfigFailTimeoutMS = 15e3, D.numCharsInField = {}, D.handleOnLoad = pn(a = TXe).call(a, Se(D)), D.handleOnConfigSuccess = pn(o = OXe).call(o, Se(D)), D.handleOnFieldValid = pn(s = NXe).call(s, Se(D)), D.handleOnAllValid = pn(c = AXe).call(c, Se(D)), D.handleOnBrand = pn(u = RXe).call(u, Se(D)), D.handleFocus = pn(f = kXe).call(f, Se(D)), D.handleOnError = pn(m = MXe).call(m, Se(D)), D.handleOnNoDataRequired = pn(v = DXe).call(v, Se(D)), D.handleOnAutoComplete = pn(y = PXe).call(y, Se(D)), D.handleOnTouchstartIOS = pn(b = LXe).call(b, Se(D)), D.processBinLookupResponse = pn(S = D.processBinLookupResponse).call(S, Se(D)), D.setFocusOn = pn(x = D.setFocusOn).call(x, Se(D)), D.updateStyles = pn(E = D.updateStyles).call(E, Se(D)), D.handleUnsupportedCard = pn(N = D.handleUnsupportedCard).call(N, Se(D)), D.showValidation = pn(R = D.showValidation).call(R, Se(D)), D.destroy = pn(O = D.destroy).call(O, Se(D)), D;
  }
  return et(n, [{ key: "componentDidMount", value: function() {
    var r = this;
    this.props.rootNode && this.setRootNode(this.props.rootNode);
    var a = function(s) {
      var c;
      return s ? It(c = Xo(Array.prototype).call(s.querySelectorAll('[data-cse*="encrypted"]'))).call(c, function(u) {
        return u.getAttribute("data-cse");
      }) : [];
    }(this.rootNode), o = rr(a).call(a, FYe, {});
    this.setState({ valid: o }), Q(a).call(a, function(s) {
      r.numCharsInField[s] = 0;
    }), this.numDateFields = Oe(a).call(a, function(s) {
      return s.match(/Expiry/);
    }).length, a.length ? (this.destroy(), this.initializeCSF(this.rootNode)) : this.handleOnNoDataRequired();
  } }, { key: "componentDidUpdate", value: function() {
    this.checkForKCPFields();
  } }, { key: "componentWillUnmount", value: function() {
    this.csf = null, clearTimeout(this.csfLoadFailTimeout), clearTimeout(this.csfConfigFailTimeout);
  } }, { key: "initializeCSF", value: function(r) {
    var a = this, o = this.props.loadingContext, s = { rootNode: r, type: this.props.type, clientKey: this.props.clientKey, cardGroupTypes: this.props.brands, allowedDOMAccess: this.props.allowedDOMAccess, autoFocus: this.props.autoFocus, trimTrailingSeparator: this.props.trimTrailingSeparator, loadingContext: o, keypadFix: this.props.keypadFix, showWarnings: this.props.showWarnings, iframeUIConfig: { sfStyles: this.props.styles }, i18n: this.props.i18n, callbacks: { onLoad: this.handleOnLoad, onConfigSuccess: this.handleOnConfigSuccess, onFieldValid: this.handleOnFieldValid, onAllValid: this.handleOnAllValid, onBrand: this.handleOnBrand, onError: this.handleOnError, onFocus: this.handleFocus, onBinValue: this.props.onBinValue, onAutoComplete: this.handleOnAutoComplete, onAdditionalSFConfig: this.props.onAdditionalSFConfig, onAdditionalSFRemoved: this.props.onAdditionalSFRemoved, onTouchstartIOS: this.handleOnTouchstartIOS }, isKCP: this.state.hasKoreanFields, legacyInputMode: this.props.legacyInputMode, minimumExpiryDate: this.props.minimumExpiryDate, implementationType: this.props.implementationType || "components", forceCompat: this.props.forceCompat, maskSecurityCode: this.props.maskSecurityCode, exposeExpiryDate: this.props.exposeExpiryDate, shouldDisableIOSArrowKeys: !!this.props.disableIOSArrowKeys };
    this.csf = EXe(s), this.csfLoadFailTimeout = Ro(function() {
      a.state.status !== "ready" && (a.setState({ status: "csfLoadFailure" }), a.props.onError(new _r("ERROR", "secured field iframes have failed to load")));
    }, this.csfLoadFailTimeoutMS);
  } }, { key: "checkForKCPFields", value: function() {
    var r = this, a = !1;
    this.props.koreanAuthenticationRequired && (a = this.issuingCountryCode ? this.issuingCountryCode === "kr" : this.props.countryCode === "kr"), this.state.hasKoreanFields && !a && (this.setState(function(o) {
      return { data: cd(cd({}, o.data), {}, T({}, yd, void 0)), valid: cd(cd({}, o.valid), {}, T({}, yd, !1)), errors: cd(cd({}, o.errors), {}, T({}, yd, !1)), hasKoreanFields: !1 };
    }, function() {
      r.props.onChange(r.state);
    }), this.csf.removeSecuredField(yd), this.csf.setKCPStatus(!1)), !this.state.hasKoreanFields && a && (this.setState(function(o) {
      return { valid: cd(cd({}, o.valid), {}, T({}, yd, !1)), hasKoreanFields: !0, isSfpValid: !1 };
    }, function() {
      r.props.onChange(r.state);
    }), this.csf.addSecuredField(yd), this.csf.setKCPStatus(!0));
  } }, { key: "getChildContext", value: function() {
    return { i18n: this.props.i18n };
  } }, { key: "handleUnsupportedCard", value: function(r) {
    var a = !!r.error;
    return a && this.setState({ detectedUnsupportedBrands: r.detectedBrands }), r.rootNode = this.rootNode, this.handleOnError(r, a), this.csf && this.csf.hasUnsupportedCard(Or, r.error), a;
  } }, { key: "setFocusOn", value: function(r) {
    this.csf && this.csf.setFocusOnFrame(r);
  } }, { key: "updateStyles", value: function(r) {
    this.csf && this.csf.updateStyles(r);
  } }, { key: "sfIsOptionalOrHidden", value: function(r) {
    return this.csf.sfIsOptionalOrHidden(r);
  } }, { key: "destroy", value: function() {
    this.csf && this.csf.destroy();
  } }, { key: "showValidation", value: function() {
    var r, a, o = this, s = this.numDateFields, c = this.state;
    Q(r = rr(a = Pe(c.valid)).call(a, BYe(s, c), [])).call(r, function(u) {
      var f = function(m, v, y) {
        return { rootNode: v, fieldType: m, error: yc(y, "errors.".concat(m)) || XWe[m] || YWe, type: "card" };
      }(u, o.rootNode, c);
      o.handleOnError(f, !!c.detectedUnsupportedBrands), o.csf && o.csf.isValidated && o.csf.isValidated(u, f.error);
    });
  } }, { key: "mapErrorsToValidationRuleResult", value: function() {
    var r = this, a = Pe(this.state.errors);
    return rr(a).call(a, function(o, s) {
      return r.state.errors[s] ? o[s] = cd({ isValid: !1, errorMessage: aie(r.state.errors[s]), errorI18n: r.props.i18n.get(r.state.errors[s]), error: r.state.errors[s], rootNode: r.rootNode }, r.state.detectedUnsupportedBrands && { detectedBrands: r.state.detectedUnsupportedBrands }) : o[s] = null, o;
    }, {});
  } }, { key: "processBinLookupResponse", value: function(r, a) {
    var o, s = this;
    this.state.detectedUnsupportedBrands && (this.setState(function(u) {
      return { errors: cd(cd({}, u.errors), {}, T({}, Or, !1)), detectedUnsupportedBrands: null };
    }), this.csf && r) && this.handleUnsupportedCard({ type: "card", fieldType: "encryptedCardNumber", error: "" }), this.issuingCountryCode = r == null || (o = r.issuingCountryCode) === null || o === void 0 ? void 0 : o.toLowerCase();
    var c = (a == null ? void 0 : a.brand) && jt(bW).call(bW, a.brand);
    c && this.setState(a, function() {
      s.props.onChange(s.state);
    }), this.csf && this.csf.brandsFromBinLookup(r, c ? a : null);
  } }, { key: "render", value: function(r, a) {
    return r.render({ setRootNode: this.setRootNode, setFocusOn: this.setFocusOn }, a);
  } }]), n;
}();
T(sC, "defaultProps", { type: "card", keypadFix: !0, rootNode: null, loadingContext: null, brands: [], allowedDOMAccess: !1, showWarnings: !1, autoFocus: !0, trimTrailingSeparator: !0, onChange: function() {
}, onLoad: function() {
}, onConfigSuccess: function() {
}, onAllValid: function() {
}, onFieldValid: function() {
}, onBrand: function() {
}, onError: function() {
}, onBinValue: function() {
}, onFocus: function() {
}, onAutoComplete: function() {
}, styles: {} });
var EO = function(e) {
  return e.full = "full", e.partial = "partial", e.none = "none", e;
}({}), jXe = { type: "card", setComponentRef: function() {
}, hasHolderName: !1, holderNameRequired: !1, enableStoreDetails: !1, hasCVC: !0, showBrandIcon: !0, showBrandsUnderCardNumber: !0, positionHolderNameOnTop: !1, billingAddressRequired: !1, billingAddressMode: EO.full, billingAddressRequiredFields: ["street", "houseNumberOrName", "postalCode", "city", "stateOrProvince", "country"], installmentOptions: {}, configuration: { koreanAuthenticationRequired: !1, socialSecurityNumberMode: "auto" }, autoFocus: !0, isPayButtonPrimaryVariant: !0, disableIOSArrowKeys: !0, exposeExpiryDate: !1, onLoad: function() {
}, onConfigSuccess: function() {
}, onAllValid: function() {
}, onFieldValid: function() {
}, onBrand: function() {
}, onError: function() {
}, onBinValue: function() {
}, onBlur: function() {
}, onFocus: function() {
}, onChange: function() {
}, data: { billingAddress: {} }, styles: {}, placeholders: {} }, FXe = { base: { caretColor: "#0075FF" } };
function lD(e) {
  var t;
  return zp(t = e.replace(/[^0-9]/g, "")).call(t);
}
function uD() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (typeof e != "string") return "";
  var t = lD(e), n = t.length > 11 ? function(r) {
    return r.replace(/^(\d{2})(\d{3})(\d{3})?(\d{4})?(\d{1,2})?$/g, function(a, o, s, c) {
      var u, f, m, v, y = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", b = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
      return je(u = je(f = je(m = je(v = "".concat(o, ".")).call(v, s, ".")).call(m, c, "/")).call(f, y)).call(u, b.length ? "-".concat(b) : "");
    });
  }(t) : function(r) {
    return r.replace(/\W/gi, "").replace(/(\d{3})(?!$)/g, "$1.").replace(/(.{11}).(\d{1,2})$/g, "$1-$2");
  }(t);
  return n;
}
function cD(e) {
  return /(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$)/.test(e);
}
var BXe = { socialSecurityNumber: uD }, GZ = { socialSecurityNumber: [{ modes: ["blur"], validate: function(e) {
  return ul(e) ? null : cD(e);
}, errorMessage: "boleto.socialSecurityNumber.invalid" }], taxNumber: [{ modes: ["blur"], validate: function(e) {
  return ul(e) ? null : (e == null ? void 0 : e.length) === 6 || (e == null ? void 0 : e.length) === 10;
}, errorMessage: "creditCard.taxNumber.invalid" }], holderName: [{ modes: ["blur"], validate: function(e) {
  return !ul(e) || null;
}, errorMessage: "creditCard.holderName.invalid" }], default: [{ modes: ["blur"], validate: function(e) {
  return !!e && typeof e == "string" && zp(e).call(e).length > 0;
} }] };
function zZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
var VXe = function(e, t) {
  return rr(e).call(e, function(n, r) {
    return n || jt(t).call(t, r.brand);
  }, !1);
}, wie = function(e) {
  return It(e).call(e, function(t) {
    return function(n) {
      for (var r = 1; r < arguments.length; r++) {
        var a, o, s = arguments[r] != null ? arguments[r] : {};
        r % 2 ? Q(a = zZ(Object(s), !0)).call(a, function(c) {
          T(n, c, s[c]);
        }) : ne ? Ze(n, ne(s)) : Q(o = zZ(Object(s))).call(o, function(c) {
          We(n, c, re(s, c));
        });
      }
      return n;
    }({}, t);
  });
}, UXe = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "mc", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "visa", r = wie(e);
  return r[0].brand !== t && r[0].brand !== n && Cze(r).call(r), r.length = 1, r;
};
function Sie(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = e.type, o = e.cvcPolicy, s = t.sfp, c = n.dualBrandSelectElements, u = n.setDualBrandSelectElements, f = n.setSelectedBrandValue, m = n.issuingCountryCode, v = n.setIssuingCountryCode;
  return { processBinLookup: function(y, b) {
    var S, x, E, N, R = y != null && y.issuingCountryCode ? y.issuingCountryCode.toLowerCase() : null;
    if (v(R), !y || !Pe(y).length) {
      u([]), f("");
      var O = b && a !== "card" ? a : null;
      return s.current.processBinLookupResponse(y, { brand: O, cvcPolicy: o }), void (r.current = 0);
    }
    if ((S = y.supportedBrands) !== null && S !== void 0 && S.length) {
      var D = VXe(y.supportedBrands, Z4), $ = D ? UXe(y.supportedBrands) : wie(y.supportedBrands);
      if ($.length > 1) {
        var B = (x = ze($, 2), E = x[0], N = x[1], { dualBrandSelectElements: [{ id: E.brand, brandObject: E }, { id: N.brand, brandObject: N }], selectedBrandValue: "", leadBrand: E });
        u(B.dualBrandSelectElements), f(B.selectedBrandValue), s.current.processBinLookupResponse({ issuingCountryCode: y.issuingCountryCode, supportedBrands: [B.leadBrand] }), B.leadBrand.panLength > 0 && (r.current = B.leadBrand.panLength);
      } else u([]), f(""), D || f($[0].brand), s.current.processBinLookupResponse({ issuingCountryCode: y.issuingCountryCode, supportedBrands: $ }), $[0].panLength > 0 && (r.current = $[0].panLength);
    }
  }, handleDualBrandSelection: function(y) {
    var b = y;
    if (y instanceof Event) {
      var S = y.target;
      b = S.getAttribute("data-value") || S.getAttribute("alt");
    }
    var x = [];
    b && (x = rr(c).call(c, function(E, N) {
      return N.brandObject.brand === b && E.push(N.brandObject), E;
    }, [])).length && (f(b), s.current.processBinLookupResponse({ issuingCountryCode: m, supportedBrands: x }));
  } };
}
var xie = "holderName", dD = "socialSecurityNumber", W0 = [Or, Jr, Fr], Z0 = [xie, Or, Jr, Fr], Y0 = [Or, Jr, Fr, xie], fD = ["taxNumber", yd], GXe = je(W0).call(W0, fD), zXe = je(Z0).call(Z0, fD), HXe = je(Y0).call(Y0, fD), WXe = je(W0).call(W0, [dD]), ZXe = je(Z0).call(Z0, [dD]), YXe = je(Y0).call(Y0, [dD]), Eie = function(e, t) {
  return t({ type: e === "card" ? "nocard" : e || "nocard", extension: "svg" })(e);
}, XXe = function(e, t, n) {
  switch (e) {
    case "socialSecurityNumber":
      return t.get("boleto.".concat(e));
    case "street":
    case "houseNumberOrName":
    case "postalCode":
    case "stateOrProvince":
    case "city":
    case "country":
      return n != null && n[e] ? t.get(n == null ? void 0 : n[e]) : t.get(e);
    default:
      return null;
  }
};
function lC(e) {
  var t;
  return (t = ZWe[e]) !== null && t !== void 0 ? t : e;
}
var KXe = "LoadingWrapper-module_loading-input__form__ffCKa", qXe = "LoadingWrapper-module_loading-input__form--loading__7GmVo", JXe = "LoadingWrapper-module_loading-input__spinner__GxA51", QXe = "LoadingWrapper-module_loading-input__spinner--active__ENNBS", uC = function(e) {
  var t = e.children, n = e.status, r = Tt("adyen-checkout__loading-input__form", KXe, T({}, qXe, n === "loading")), a = Tt(T(T({}, JXe, !0), QXe, n === "loading"));
  return P("div", { style: { position: "relative" } }, P("div", { className: a }, P(ju, null)), P("div", { className: r }, t));
};
function eKe(e) {
  var t = e.frontCVC, n = t !== void 0 && t, r = e.fieldLabel, a = Tt({ "adyen-checkout__card__cvc__hint__wrapper": !0, "adyen-checkout__field__cvc--front-hint": !!n, "adyen-checkout__field__cvc--back-hint": !n });
  return P("span", { className: a }, P("svg", { className: "adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--front", width: "27", height: "18", viewBox: "0 0 27 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": !n, "aria-describedby": "adyen-checkout__cvc__front-hint-img", role: "img" }, P("title", { id: "adyen-checkout__cvc__front-hint-img" }, r), P("path", { d: "M0 3C0 1.34315 1.34315 0 3 0H24C25.6569 0 27 1.34315 27 3V15C27 16.6569 25.6569 18 24 18H3C1.34315 18 0 16.6569 0 15V3Z", fill: "#E6E9EB" }), P("rect", { x: "4", y: "12", width: "19", height: "2", fill: "#B9C4C9" }), P("rect", { x: "4", y: "4", width: "4", height: "4", rx: "1", fill: "white" }), P("rect", { className: "adyen-checkout__card__cvc__hint__location", x: "16.5", y: "4.5", width: "7", height: "5", rx: "2.5", stroke: "#C12424" })), P("svg", { className: "adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--back", width: "27", height: "18", viewBox: "0 0 27 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": !!n, "aria-describedby": "adyen-checkout__cvc__back-hint-img", role: "img" }, P("title", { id: "adyen-checkout__cvc__back-hint-img" }, r), P("path", { d: "M27 4.00001V3.37501C27 2.4799 26.6444 1.62146 26.0115 0.988518C25.3786 0.355581 24.5201 0 23.625 0H3.375C2.47989 0 1.62145 0.355581 0.988514 0.988518C0.355579 1.62146 0 2.4799 0 3.37501V4.00001H27Z", fill: "#E6E9EB" }), P("path", { d: "M0 6.99994V14.6666C0 15.5507 0.355579 16.3985 0.988514 17.0237C1.62145 17.6488 2.47989 18 3.375 18H23.625C24.5201 18 25.3786 17.6488 26.0115 17.0237C26.6444 16.3985 27 15.5507 27 14.6666V6.99994H0Z", fill: "#E6E9EB" }), P("rect", { y: "4.00012", width: "27", height: "3.00001", fill: "#687282" }), P("path", { d: "M4 11C4 10.4477 4.44772 10 5 10H21C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14H5C4.44771 14 4 13.5523 4 13V11Z", fill: "white" }), P("rect", { className: "adyen-checkout__card__cvc__hint__location", x: "16.5", y: "9.5", width: "7", height: "5", rx: "2.5", stroke: "#C12424" })));
}
var dl = { "card-input__wrapper": "CardInput-module_card-input__wrapper__wXSCw", "card-input__icon": "CardInput-module_card-input__icon__3Cz5M", "card-input__form": "CardInput-module_card-input__form__fRo1r", "card-input__spinner": "CardInput-module_card-input__spinner__-j2Qi", "card-input__spinner--active": "CardInput-module_card-input__spinner--active__slD7w", "card-input__form--loading": "CardInput-module_card-input__form--loading__rrmdj", "adyen-checkout__input": "CardInput-module_adyen-checkout__input__11tlB", "adyen-checkout__card__cvc__input--hidden": "CardInput-module_adyen-checkout__card__cvc__input--hidden__VIlHV", "adyen-checkout__card__exp-date__input--hidden": "CardInput-module_adyen-checkout__card__exp-date__input--hidden__evi6-", "adyen-checkout__card__exp-cvc__exp-date__input--hidden": "CardInput-module_adyen-checkout__card__exp-cvc__exp-date__input--hidden__YC3VT", "revolving-plan-installments__disabled": "CardInput-module_revolving-plan-installments__disabled__VhNj2" };
function rv(e) {
  var t = T(T(T(T({}, Ooe, e.encryptedFieldType), Roe, e["data-info"]), Moe, e.uniqueId), "className", e.className);
  return P("span", t, e.children);
}
var pD = function(e, t) {
  return P("div", kt({}, e, { "aria-hidden": "true" }), t);
};
function Iie(e) {
  var t, n = e.label, r = e.onFocusField, a = r === void 0 ? function() {
  } : r, o = e.error, s = o === void 0 ? "" : o, c = e.className, u = c === void 0 ? "" : c, f = e.classNameModifiers, m = f === void 0 ? [] : f, v = e.focused, y = e.filled, b = e.isValid, S = e.frontCVC, x = S !== void 0 && S, E = e.cvcPolicy, N = E === void 0 ? jm : E, R = wt().i18n, O = Tt(u, T(T({ "adyen-checkout__field__cvc": !0 }, dl["adyen-checkout__card__cvc__input--hidden"], N === v_), "adyen-checkout__field__cvc--optional", N === m_)), D = Tt(T({ "adyen-checkout__input": !0, "adyen-checkout__input--small": !0, "adyen-checkout__card__cvc__input": !0, "adyen-checkout__input--error": s, "adyen-checkout__input--focus": v, "adyen-checkout__input--valid": b }, dl["adyen-checkout__input"], !0)), $ = N !== m_ ? n : R.get("creditCard.cvcField.title.optional");
  return P(xn, { label: $, focused: v, filled: y, classNameModifiers: je(t = []).call(t, Pn(m), ["securityCode"]), onFocusField: function() {
    return a(Fr);
  }, className: O, errorMessage: s, isValid: b, dir: "ltr", name: Fr, i18n: R, errorVisibleToScreenReader: !1, useLabelElement: !1, renderAlternativeToLabel: pD }, P(rv, { encryptedFieldType: Fr, className: D }), P(eKe, { frontCVC: x, fieldLabel: $ }));
}
function tKe(e) {
  var t, n, r, a, o = e.brand, s = e.hasCVC, c = e.onFocusField, u = e.errors, f = e.valid, m = e.cvcPolicy, v = e.focusedElement, y = e.lastFour, b = e.expiryMonth, S = e.expiryYear, x = wt().i18n, E = x.get("creditCard.storedCard.description.ariaLabel").replace("%@", y), N = b && S ? je(t = je(n = " ".concat(x.get("creditCard.expiryDateField.title"), " ")).call(n, b, "/")).call(t, S) : "", R = je(r = "".concat(E)).call(r, N);
  return P("div", { className: "adyen-checkout__card__form adyen-checkout__card__form--oneClick", "aria-label": R }, P("div", { className: "adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper" }, b && S && P(xn, { label: x.get("creditCard.expiryDateField.title"), className: "adyen-checkout__field--50", classNameModifiers: ["storedCard"], name: "expiryDateField", disabled: !0 }, P(vi, { name: "expiryDateField", className: "adyen-checkout__input adyen-checkout__input--disabled adyen-checkout__card__exp-date__input--oneclick", value: je(a = "".concat(b, " / ")).call(a, S), readonly: !0, disabled: !0, dir: "ltr" })), s && P(Iie, kt({ cvcPolicy: m, error: function(O, D) {
    return O[D] ? x.get(O[D]) : null;
  }(u, Fr), focused: v === "encryptedSecurityCode", filled: !!f.encryptedSecurityCode || !!u.encryptedSecurityCode, isValid: !!f.encryptedSecurityCode, label: x.get("creditCard.cvcField.title"), onFocusField: c }, b && S && { className: "adyen-checkout__field--50" }, { classNameModifiers: ["storedCard"], frontCVC: o === "amex" }))));
}
function HZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function WZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = HZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = HZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function hD(e) {
  var t, n, r, a, o = wt().i18n, s = e.amount, c = e.brand, u = e.onChange, f = e.type, m = e.installmentOptions[c] || e.installmentOptions.card, v = Je((m == null ? void 0 : m.preselectedValue) || (m == null ? void 0 : gd(m)[0])), y = ze(v, 2), b = y[0], S = y[1], x = Je("onetime"), E = ze(x, 2), N = E[0], R = E[1], O = m == null || (t = m.plans) === null || t === void 0 ? void 0 : jt(t).call(t, "revolving"), D = function(B) {
    var G = B.target.value;
    S(Number(G));
  }, $ = function(B) {
    var G, Z, K;
    return f === "amount" ? (G = "installmentOption", Z = { count: B, values: { times: B, partialValue: (K = B, o.amount(s.value / K, s.currency)) } }) : (G = "installmentOptionMonths", Z = { count: B, values: { times: B } }), { id: B, name: s.value ? o.get(G, Z) : "".concat(B) };
  };
  return Rt(function() {
    var B, G;
    m != null && (B = gd(m)) !== null && B !== void 0 && jt(B).call(B, b) || S((G = m == null ? void 0 : m.preselectedValue) !== null && G !== void 0 ? G : m == null ? void 0 : gd(m)[0]);
  }, [c]), Rt(function() {
    var B = WZ(WZ({ value: b }, O && N === "revolving" && { plan: N, value: 1 }), O && N === "onetime" && { value: 1 });
    u(m ? B : { value: null });
  }, [b, m, N]), m ? s.value === 0 ? null : P("div", { className: "adyen-checkout__installments" }, O ? P(tv, { classNameModifiers: ["revolving-plan"], label: "" }, P(tD, { items: [{ id: "onetime", name: "installments.oneTime" }, { id: "installments", name: "installments.installments" }, { id: "revolving", name: "installments.revolving" }], onChange: function(B) {
    var G = B.currentTarget.getAttribute("value");
    R(G);
  }, value: N }), P(xn, { className: "".concat(N !== "installments" ? dl["revolving-plan-installments__disabled"] : dl["revolving-plan-installments"]), classNameModifiers: ["revolving-plan-installments"], name: "", useLabelElement: !1, addContextualElement: !1 }, P(Ad, { filterable: !1, items: It(a = gd(m)).call(a, $), selectedValue: b, onChange: D, name: "installments", disabled: N !== "installments" }))) : P(xn, { label: o.get("installments"), classNameModifiers: ["installments"], name: "", useLabelElement: !1, addContextualElement: !1 }, P(Ad, { filterable: !1, items: It(n = gd(m)).call(n, $), selectedValue: b, onChange: D, name: "installments", readonly: (m == null || (r = gd(m)) === null || r === void 0 ? void 0 : r.length) === 1 }))) : null;
}
hD.defaultProps = { brand: "", amount: {}, onChange: function() {
} };
var nKe = function(e) {
  var t = e.sfpState, n = e.setFocusOn, r = e.cvcPolicy, a = e.focusedElement, o = e.hasInstallments, s = e.handleInstallments, c = e.showAmountsInInstallments, u = e.amount, f = e.hasCVC, m = e.installmentOptions, v = e.lastFour, y = e.expiryMonth, b = e.expiryYear, S = e.disclaimerMessage;
  return P(uC, { status: t.status }, P(tKe, { errors: t.errors, brand: t.brand, hasCVC: f, cvcPolicy: r, onFocusField: n, focusedElement: a, valid: t.valid, lastFour: v, expiryMonth: y, expiryYear: b }), o && P(hD, { amount: u, brand: t.brand, installmentOptions: m, onChange: s, type: c ? "amount" : "months" }), S && P(D8, { message: S.message.replace("%{linkText}", "%#".concat(S.linkText, "%#")), urls: [S.link] }));
};
function rKe(e) {
  var t, n, r = e.brand, a = e.brandsConfiguration, o = a === void 0 ? {} : a, s = oa(), c = r === "card" ? "nocard" : r, u = (t = (n = o[r]) === null || n === void 0 ? void 0 : n.icon) !== null && t !== void 0 ? t : Eie(c, s);
  return P("img", { className: "".concat(dl["card-input__icon"], " adyen-checkout__card__cardNumber__brandIcon"), onError: function(f) {
    f.target.style.cssText = "display: none";
  }, alt: lC(r), src: u });
}
var aKe = function(e) {
  var t, n, r, a = e.brand, o = e.onClick, s = e.dataValue, c = e.notSelected, u = e.brandsConfiguration, f = u === void 0 ? {} : u, m = oa(), v = a === "card" ? "nocard" : a, y = (t = (n = f[a]) === null || n === void 0 ? void 0 : n.icon) !== null && t !== void 0 ? t : Eie(v, m);
  return P("img", { className: je(r = "".concat(dl["card-input__icon"], " ")).call(r, c ? "adyen-checkout__card__cardNumber__brandIcon--not-selected" : "", " adyen-checkout__card__cardNumber__brandIcon"), onError: function(b) {
    b.target.style.cssText = "display: none";
  }, alt: lC(a), src: y, onClick: o, "data-value": s });
};
function oKe(e) {
  var t = wt().i18n, n = e.error, r = n === void 0 ? "" : n, a = e.isValid, o = a !== void 0 && a, s = e.onFocusField, c = s === void 0 ? function() {
  } : s, u = e.dualBrandingElements, f = e.dualBrandingChangeHandler, m = e.dualBrandingSelected;
  return P(xn, { label: e.label, focused: e.focused, filled: e.filled, classNameModifiers: ["cardNumber"], onFocusField: function() {
    return c(Or);
  }, errorMessage: r, isValid: o, dir: "ltr", name: Or, showValidIcon: !1, i18n: t, errorVisibleToScreenReader: !1, useLabelElement: !1, renderAlternativeToLabel: pD }, P(rv, { encryptedFieldType: Or, className: Tt(T(T(T(T(T({ "adyen-checkout__input": !0, "adyen-checkout__input--large": !0, "adyen-checkout__card__cardNumber__input": !0 }, dl["adyen-checkout__input"], !0), "adyen-checkout__input--error", r), "adyen-checkout__input--focus", e.focused), "adyen-checkout__input--valid", o), "adyen-checkout__card__cardNumber__input--noBrand", !e.showBrandIcon)) }, e.showBrandIcon && !u && P(rKe, { brandsConfiguration: e.brandsConfiguration, brand: e.brand })), u && !r && P("div", { className: Tt(["adyen-checkout__card__dual-branding__buttons", { "adyen-checkout__card__dual-branding__buttons--active": o }]) }, It(u).call(u, function(v) {
    return P(aKe, { key: v.id, brand: v.id, brandsConfiguration: e.brandsConfiguration, onClick: f, dataValue: v.id, notSelected: m !== "" && m !== v.id });
  })));
}
function iKe(e) {
  var t, n = e.label, r = e.focused, a = e.filled, o = e.onFocusField, s = e.className, c = s === void 0 ? "" : s, u = e.error, f = u === void 0 ? "" : u, m = e.isValid, v = m !== void 0 && m, y = e.expiryDatePolicy, b = y === void 0 ? jp : y, S = wt().i18n, x = oa(), E = Tt(c, T(T({ "adyen-checkout__field__exp-date": !0 }, dl["adyen-checkout__card__exp-date__input--hidden"], b === y2), "adyen-checkout__field__exp-date--optional", b === g_)), N = b !== g_ ? n : je(t = "".concat(n, " ")).call(t, S.get("field.title.optional"));
  return P(xn, { label: N, classNameModifiers: ["expiryDate"], className: E, focused: r, filled: a, onFocusField: function() {
    return o(Jr);
  }, errorMessage: f, isValid: v, dir: "ltr", name: "encryptedExpiryDate", i18n: S, errorVisibleToScreenReader: !1, useLabelElement: !1, renderAlternativeToLabel: pD }, P(rv, { encryptedFieldType: Jr, className: Tt("adyen-checkout__input", "adyen-checkout__input--small", "adyen-checkout__card__exp-date__input", [dl["adyen-checkout__input"]], { "adyen-checkout__input--error": f, "adyen-checkout__input--focus": r, "adyen-checkout__input--valid": v }) }), P("span", { className: Tt("adyen-checkout__field__exp-date_hint_wrapper", [dl["checkout__field__exp-date_hint_wrapper"]], { "adyen-checkout__field__exp-date_hint_wrapper--hidden": f || v }) }, P("img", { src: x({ imageFolder: "components/" })("expiry_date_hint"), className: "adyen-checkout__field__exp-date_hint", alt: N })));
}
var sKe = function(e) {
  var t = e.brands, n = e.activeBrand;
  return t != null && t.length ? P("span", { className: Tt("adyen-checkout__card__brands", { "adyen-checkout__card__brands--hidden": n !== "card" }) }, It(t).call(t, function(r) {
    var a = r.name, o = r.icon;
    return P("span", { key: a, className: "adyen-checkout__card__brands__brand-wrapper" }, P(ps, { src: o, alt: lC(a) }));
  })) : null;
};
function lKe(e) {
  var t = e.brand, n = e.brandsIcons, r = e.brandsConfiguration, a = e.dualBrandingElements, o = e.dualBrandingChangeHandler, s = e.dualBrandingSelected, c = e.errors, u = e.focusedElement, f = e.hasCVC, m = e.cvcPolicy, v = e.expiryDatePolicy, y = e.onFocusField, b = e.showBrandIcon, S = e.showBrandsUnderCardNumber, x = e.valid, E = wt().i18n, N = function(O, D) {
    return O[D] ? E.get(O[D]) : null;
  }, R = n == null ? void 0 : Oe(n).call(n, function(O) {
    return !(Z4 != null && jt(Z4).call(Z4, O.name));
  });
  return P("div", { className: "adyen-checkout__card__form" }, P(oKe, { brand: t, brandsConfiguration: r, error: N(c, Or), focused: u === Or, isValid: !!x.encryptedCardNumber, label: E.get("creditCard.numberField.title"), onFocusField: y, filled: !!c.encryptedCardNumber || !!x.encryptedCardNumber, showBrandIcon: b, dualBrandingElements: a, dualBrandingChangeHandler: o, dualBrandingSelected: s }), S && P(sKe, { activeBrand: t, brands: R }), P("div", { className: Tt("adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper", T({}, dl["adyen-checkout__card__exp-cvc__exp-date__input--hidden"], v === y2)) }, P(iKe, { error: N(c, Jr), focused: u === Jr, isValid: !!x.encryptedExpiryMonth && !!x.encryptedExpiryYear, filled: !!c.encryptedExpiryDate || !!x.encryptedExpiryYear, label: E.get("creditCard.expiryDateField.title"), onFocusField: y, className: "adyen-checkout__field--50", expiryDatePolicy: v }), f && P(Iie, { error: N(c, Fr), focused: u === Fr, cvcPolicy: m, isValid: !!x.encryptedSecurityCode, filled: !!c.encryptedSecurityCode || !!x.encryptedSecurityCode, label: E.get("creditCard.cvcField.title"), onFocusField: y, className: "adyen-checkout__field--50", frontCVC: t === "amex" })));
}
function uKe(e) {
  var t = wt().i18n, n = Qi(function() {
    var r;
    return ((r = e.value) === null || r === void 0 ? void 0 : r.length) > 6 ? t.get("creditCard.taxNumber.labelAlt") : t.get("creditCard.taxNumber.label");
  }, [e.value]);
  return P("div", { className: "adyen-checkout__card__kcp-authentication" }, P(xn, { label: n, filled: e.filled, classNameModifiers: ["kcp-taxNumber"], errorMessage: e.error && t.get("creditCard.taxNumber.invalid"), isValid: e.isValid, dir: "ltr", name: "kcpTaxNumberOrDOB", onFocus: function(r) {
    return e.onFieldFocusAnalytics("taxNumber", r);
  }, onBlur: function(r) {
    return e.onFieldBlurAnalytics("taxNumber", r);
  } }, P(Koe, { name: "kcpTaxNumberOrDOB", className: "adyen-checkout__card__kcp-taxNumber__input ".concat(dl["adyen-checkout__input"]), placeholder: t.get("creditCard.taxNumber.placeholder"), maxLength: 10, minLength: 6, autoComplete: "false", value: e.value, required: !0, onBlur: e.onBlur, onInput: e.onInput, disabled: e.disabled })), P(xn, { label: t.get("creditCard.encryptedPassword.label"), focused: e.focusedElement === "encryptedPassword", filled: e.filled, classNameModifiers: ["50", "koreanAuthentication-encryptedPassword"], onFocusField: function() {
    return e.onFocusField("encryptedPassword");
  }, errorMessage: e.encryptedPasswordState.errors && t.get(String(e.encryptedPasswordState.errors)), isValid: e.encryptedPasswordState.valid, dir: "ltr", name: "encryptedPassword" }, P(rv, { encryptedFieldType: "encryptedPassword", className: Tt(T(T(T(T({ "adyen-checkout__input": !0, "adyen-checkout__input--large": !0 }, dl["adyen-checkout__input"], !0), "adyen-checkout__input--error", e.encryptedPasswordState.errors), "adyen-checkout__input--valid", e.encryptedPasswordState.valid), "adyen-checkout__input--focus", e.focusedElement === "encryptedPassword")) })));
}
function kie(e) {
  var t = e.onBlur, n = e.onInput, r = e.valid, a = r !== void 0 && r, o = e.error, s = o === void 0 ? null : o, c = e.data, u = c === void 0 ? "" : c, f = e.required, m = f !== void 0 && f, v = e.disabled, y = v !== void 0 && v, b = e.onFieldFocusAnalytics, S = b === void 0 ? null : b, x = e.onFieldBlurAnalytics, E = x === void 0 ? null : x, N = wt().i18n;
  return P(xn, { label: "".concat(N.get("boleto.socialSecurityNumber")), classNameModifiers: ["socialSecurityNumber"], errorMessage: s && s.errorMessage ? N.get(s.errorMessage) : !!s, isValid: !!a, name: "socialSecurityNumber", onFocus: function(R) {
    return S == null ? void 0 : S("socialSecurityNumber", R);
  }, onBlur: function(R) {
    return E == null ? void 0 : E("socialSecurityNumber", R);
  } }, P(vi, { name: "socialSecurityNumber", autocorrect: "off", spellcheck: !1, value: u, maxLength: 18, onInput: n, onBlur: t, required: m, disabled: y }));
}
var cKe = ["storeDetails"];
function mD(e) {
  var t = e.storeDetails, n = t !== void 0 && t, r = pa(e, cKe), a = wt().i18n, o = Je(n), s = ze(o, 2), c = s[0], u = s[1];
  return Rt(function() {
    r.onChange(c);
  }, [c]), P("div", { className: "adyen-checkout__store-details" }, P(U2, { onChange: function(f) {
    u(f.target.checked);
  }, label: a.get("storeDetails"), name: "storeDetails" }));
}
function dKe(e) {
  var t = e.onBlur, n = e.onInput, r = e.placeholder, a = e.value, o = e.required, s = e.error, c = s !== void 0 && s, u = e.isValid, f = e.disabled, m = e.onFieldFocusAnalytics, v = e.onFieldBlurAnalytics, y = wt().i18n;
  return P(xn, { label: y.get("creditCard.holderName"), className: "adyen-checkout__card__holderName", errorMessage: c && y.get("creditCard.holderName.invalid"), isValid: !!u, name: "holderName", i18n: y, onFocus: function(b) {
    return m("holderName", b);
  }, onBlur: function(b) {
    return v("holderName", b);
  } }, P(vi, { name: "holderName", className: "adyen-checkout__card__holderName__input ".concat(dl["adyen-checkout__input"]), placeholder: r || y.get("creditCard.holderName.placeholder"), autocomplete: "cc-name", value: a, required: o, onBlur: t, onInput: n, disabled: f }));
}
var fKe = function(e) {
  var t = e.data, n = e.valid, r = e.errors, a = e.handleChangeFor, o = e.sfpState, s = e.setFocusOn, c = e.cvcPolicy, u = e.focusedElement, f = e.hasInstallments, m = e.handleInstallments, v = e.showAmountsInInstallments, y = e.brandsIcons, b = e.formData, S = e.formErrors, x = e.formValid, E = e.expiryDatePolicy, N = e.dualBrandSelectElements, R = e.extensions, O = e.selectedBrandValue, D = e.showKCP, $ = e.showBrazilianSSN, B = e.socialSecurityNumber, G = e.handleOnStoreDetails, Z = e.billingAddress, K = e.handleAddress, q = e.setAddressRef, pe = e.partialAddressSchema, he = e.onAddressLookup, _e = e.onAddressSelected, ge = e.addressSearchDebounceMs, Y = e.amount, ee = e.billingAddressRequired, oe = e.billingAddressRequiredFields, me = e.billingAddressAllowedCountries, xe = e.billingAddressValidationRules, X = xe === void 0 ? null : xe, ye = e.brandsConfiguration, ce = e.showStoreDetailsCheckbox, se = e.hasCVC, Ie = e.hasHolderName, Le = e.holderNameRequired, ie = e.installmentOptions, $e = e.placeholders, we = e.positionHolderNameOnTop, Ne = e.showBrandIcon, Ee = e.showBrandsUnderCardNumber, le = e.iOSFocusedField, be = e.disclaimerMessage, He = e.onFieldFocusAnalytics, Ae = e.onFieldBlurAnalytics, it = P(dKe, { required: Le, placeholder: $e.holderName, value: b.holderName, error: !!S.holderName && Le, isValid: !!x.holderName, onBlur: a("holderName", "blur"), onInput: a("holderName", "input"), disabled: le && le !== "holderName", onFieldFocusAnalytics: He, onFieldBlurAnalytics: Ae });
  return P(uC, { status: o.status }, Ie && we && it, P(lKe, { showBrandIcon: Ne, showBrandsUnderCardNumber: Ee, brand: o.brand, brandsIcons: y, brandsConfiguration: ye, focusedElement: u, onFocusField: s, hasCVC: se, cvcPolicy: c, expiryDatePolicy: E, errors: o.errors, valid: o.valid, dualBrandingElements: N.length > 0 && N, dualBrandingChangeHandler: R.handleDualBrandSelection, dualBrandingSelected: O }), Ie && !we && it, D && P(uKe, { onFocusField: s, focusedElement: u, encryptedPasswordState: { data: o.encryptedPassword, valid: !!o.valid && o.valid.encryptedPassword, errors: !!o.errors && o.errors.encryptedPassword }, value: t.taxNumber, error: !!r.taxNumber, isValid: !!n.taxNumber, onBlur: a("taxNumber", "blur"), onInput: a("taxNumber", "input"), disabled: le && le !== "kcpTaxNumberOrDOB", onFieldFocusAnalytics: He, onFieldBlurAnalytics: Ae }), $ && P("div", { className: "adyen-checkout__card__socialSecurityNumber" }, P(kie, { onBlur: a("socialSecurityNumber", "blur"), onInput: a("socialSecurityNumber", "input"), error: r == null ? void 0 : r.socialSecurityNumber, valid: n == null ? void 0 : n.socialSecurityNumber, data: B, required: !0, disabled: le && le !== "socialSecurityNumber", onFieldFocusAnalytics: He, onFieldBlurAnalytics: Ae })), ce && P(mD, { onChange: G }), f && P(hD, { amount: Y, brand: o.brand, installmentOptions: ie, onChange: m, type: v ? "amount" : "months" }), ee && P(t1, { label: "billingAddress", data: Z, onChange: K, allowedCountries: me, requiredFields: oe, setComponentRef: q, validationRules: X, specifications: pe, iOSFocusedField: le, onAddressLookup: he, onAddressSelected: _e, addressSearchDebounceMs: ge, onFieldFocusAnalytics: He, onFieldBlurAnalytics: Ae }), be && P(D8, { message: be.message.replace("%{linkText}", "%#".concat(be.linkText, "%#")), urls: [be.link] }));
};
function pKe(e, t) {
  var n = Oae !== void 0 && xze(e) || e["@@iterator"];
  if (!n) {
    if (E8(e) || (n = function(u, f) {
      var m;
      if (u) {
        if (typeof u == "string") return ZZ(u, f);
        var v = Xo(m = Object.prototype.toString.call(u)).call(m, 8, -1);
        if (v === "Object" && u.constructor && (v = u.constructor.name), v === "Map" || v === "Set") return soe(u);
        if (v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v)) return ZZ(u, f);
      }
    }(e)) || t) {
      n && (e = n);
      var r = 0, a = function() {
      };
      return { s: a, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(u) {
        throw u;
      }, f: a };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, s = !0, c = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var u = n.next();
    return s = u.done, u;
  }, e: function(u) {
    c = !0, o = u;
  }, f: function() {
    try {
      s || n.return == null || n.return();
    } finally {
      if (c) throw o;
    }
  } };
}
function ZZ(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var YZ = function(e, t) {
  var n = e;
  if (n === "taxNumber" && (n = "kcpTaxNumberOrDOB"), n === "country" || n === "stateOrProvince") {
    var r = Ru(t.current.rootNode, ".adyen-checkout__field--".concat(n, " .adyen-checkout__filter-input"));
    r == null || r.focus();
  } else {
    var a = Ru(t.current.rootNode, '[name="'.concat(n, '"]'));
    a == null || a.focus();
  }
}, hKe = ["billingAddress"];
function XZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ho(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = XZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = XZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var Aie = function(e) {
  var t, n, r, a = _n(null), o = _n(!1), s = oa(), c = oC(), u = c.setSRMessagesFromObjects, f = c.setSRMessagesFromStrings, m = c.clearSRPanel, v = c.shouldMoveFocusSR, y = u == null ? void 0 : u({ fieldTypeMappingFn: XXe }), b = _n(null), S = function(Pt) {
    b.current = Pt;
  }, x = _n({});
  Pe(x.current).length || e.setComponentRef(x.current);
  var E = _n(0), N = _n(!1), R = Qi(function() {
    return new o6(e.specifications);
  }, [e.specifications]);
  x.current.sfp = a;
  var O = Je("ready"), D = ze(O, 2), $ = D[0], B = D[1], G = Je({}), Z = ze(G, 2), K = Z[0], q = Z[1], pe = Je(Ho({}, e.holderNameRequired && { holderName: !1 })), he = ze(pe, 2), _e = he[0], ge = he[1], Y = Je(Ho({}, e.hasHolderName && { holderName: (t = e.data.holderName) !== null && t !== void 0 ? t : "" })), ee = ze(Y, 2), oe = ee[0], me = ee[1], xe = Je(null), X = ze(xe, 2), ye = X[0], ce = X[1], se = Je(""), Ie = ze(se, 2), Le = Ie[0], ie = Ie[1], $e = Je(!1), we = ze($e, 2), Ne = we[0], Ee = we[1], le = Je(jp), be = ze(le, 2), He = be[0], Ae = be[1], it = Je(jm), ut = ze(it, 2), St = ut[0], sn = ut[1], zn = Je(null), dn = ze(zn, 2), $t = dn[0], qt = dn[1], fn = Je([]), At = ze(fn, 2), Wt = At[0], Xr = At[1], Kn = Je(""), Sr = ze(Kn, 2), jo = Sr[0], ei = Sr[1], tt = e.billingAddressMode !== EO.none && e.billingAddressRequired, bt = e.billingAddressMode == EO.partial ? lZe : null, rn = _n(bt && ((n = e.data) === null || n === void 0 || (n = n.billingAddress) === null || n === void 0 ? void 0 : n.country)), Rn = Je(!1), Cn = ze(Rn, 2), Qn = Cn[0], er = Cn[1], oo = Je(tt ? e.data.billingAddress : null), Lr = ze(oo, 2), ia = Lr[0], ir = Lr[1], xr = Je(!1), wo = ze(xr, 2), es = wo[0], ti = wo[1], bs = Je(""), _s = ze(bs, 2), ni = _s[0], Ka = _s[1], So = Je({ value: null }), Fo = ze(So, 2), Pa = Fo[0], ri = Fo[1], xo = Je(null), qa = ze(xo, 2), ml = qa[0], bu = qa[1], Ce = gs({ schema: [], defaultData: e.data, formatters: BXe, rules: GZ }), pt = Ce.handleChangeFor, Nt = Ce.triggerValidation, Vt = Ce.data, Mn = Ce.valid, Dn = Ce.errors, vn = Ce.setSchema, Hn = Ce.setData, Ja = Ce.setValid, Qr = Ce.setErrors, sa = !!Pe(e.installmentOptions).length && e.fundingSource !== "debit", gi = (r = e.showInstallmentAmounts) === null || r === void 0 || r, Cs = ($t != null ? $t : e.countryCode) === "kr", tr = e.configuration.koreanAuthenticationRequired && Cs, Ra = es && e.configuration.socialSecurityNumberMode === "auto" || e.configuration.socialSecurityNumberMode === "show", Eo = function(Pt, qn) {
    e.onFocus({ fieldType: Pt, event: qn });
  }, Vn = function(Pt, qn) {
    e.onBlur({ fieldType: Pt, event: qn });
  }, Gs = /* @__PURE__ */ function(Pt, qn, xa) {
    return function($r) {
      Pt($r.currentFocusObject), $r.focus === !0 ? qn($r.fieldType, $r) : xa($r.fieldType, $r);
    };
  }(ie, Eo, Vn), jf = function() {
    return function(Pt) {
      var qn = Pt.props, xa = Pt.showKCP, $r = Pt.showBrazilianSSN, Qa = Pt.countrySpecificSchemas, Ln = Qa === void 0 ? null : Qa, Io = Pt.billingAddressRequiredFields, io = Io === void 0 ? null : Io, ai = W0, yi = qn.hasHolderName && qn.holderNameRequired;
      if (yi && (ai = qn.positionHolderNameOnTop ? Z0 : Y0), xa && (ai = GXe, yi && (ai = qn.positionHolderNameOnTop ? zXe : HXe)), $r && (ai = WXe, yi && (ai = qn.positionHolderNameOnTop ? ZXe : YXe)), Ln) {
        var _u, Ss = Oe(_u = Yae(Ln).call(Ln, 2)).call(_u, function(ts) {
          return typeof ts != "number";
        }), xs = Ss;
        io && (xs = Oe(Ss).call(Ss, function(ts) {
          return jt(io).call(io, ts);
        })), ai = je(W0).call(W0, xs), yi && (ai = qn.positionHolderNameOnTop ? je(Z0).call(Z0, xs) : je(Y0).call(Y0, xs));
      }
      return ai;
    }(Ho({ props: e, showKCP: tr, showBrazilianSSN: Ra }, e.billingAddressRequired && { countrySpecificSchemas: R.getAddressSchemaForCountry(ia == null ? void 0 : ia.country), billingAddressRequiredFields: e.billingAddressRequiredFields }));
  }, Ff = Kt(function(Pt) {
    var qn = Pt.fieldType !== "webInternalElement" ? Pt.fieldType : Pt.name;
    bu(qn);
  }, []), zu = /* @__PURE__ */ function(Pt, qn, xa) {
    return function($r) {
      Pt("billingAddress", $r.data), qn("billingAddress", $r.isValid), xa("billingAddress", $r.errors);
    };
  }(Hn, Ja, Qr), ws = /* @__PURE__ */ function(Pt, qn, xa) {
    return function() {
      Pt.current || (Pt.current = !0, Yt.resolve().then(function() {
        var $r, Qa = qT(xa).call(xa, function(io) {
          return io === Or;
        }), Ln = pKe(Xo(xa).call(xa, Qa + 1));
        try {
          for (Ln.s(); !($r = Ln.n()).done; ) {
            var Io = $r.value;
            if (!jt($y).call($y, Io)) {
              YZ(Io, qn);
              break;
            }
            if (!qn.current.sfIsOptionalOrHidden(Io)) {
              qn.current.setFocusOn(Io);
              break;
            }
          }
        } catch (io) {
          Ln.e(io);
        } finally {
          Ln.f();
        }
        Pt.current = !1;
      }));
    };
  }(N, a, jf()), Bf = Qi(function() {
    return Sie(e, { sfp: a }, { dualBrandSelectElements: Wt, setDualBrandSelectElements: Xr, setSelectedBrandValue: ei, issuingCountryCode: $t, setIssuingCountryCode: qt }, E);
  }, [Wt, $t]);
  x.current.showValidation = function() {
    o.current = !0, m == null || m(), a.current.showValidation(), Nt(["holderName", "socialSecurityNumber", "taxNumber"]), b != null && b.current && b.current.showValidation();
  }, x.current.processBinLookupResponse = function(Pt, qn) {
    Bf.processBinLookup(Pt, qn);
  }, x.current.setStatus = B, Rt(function() {
    return x.current.setFocusOn = a.current.setFocusOn, x.current.updateStyles = a.current.updateStyles, x.current.handleUnsupportedCard = a.current.handleUnsupportedCard, function() {
      a.current.destroy();
    };
  }, []), Rt(function() {
    var Pt, qn = je(Pt = []).call(Pt, Pn(e.hasHolderName ? ["holderName"] : []), Pn(Ra ? ["socialSecurityNumber"] : []), Pn(tr ? ["taxNumber"] : []), Pn(tt ? ["billingAddress"] : []));
    vn(qn);
  }, [e.hasHolderName, Ra, tr]), Rt(function() {
    var Pt, qn;
    me(Ho(Ho({}, oe), {}, { holderName: (Pt = Vt.holderName) !== null && Pt !== void 0 ? Pt : "", taxNumber: Vt.taxNumber })), Ka(Vt.socialSecurityNumber), tt && ir(Ho({}, Vt.billingAddress)), ge(Ho(Ho({}, _e), {}, { holderName: !e.holderNameRequired || Mn.holderName, socialSecurityNumber: !!Mn.socialSecurityNumber && Mn.socialSecurityNumber, taxNumber: !!Mn.taxNumber && Mn.taxNumber, billingAddress: !!Mn.billingAddress && Mn.billingAddress }));
    var xa = !!Dn.billingAddress && rr(qn = K_(Dn.billingAddress)).call(qn, function($r, Qa) {
      var Ln = ze(Qa, 2)[1];
      return $r || Ln != null;
    }, !1);
    q(Ho(Ho({}, K), {}, { holderName: e.holderNameRequired && Dn.holderName ? Dn.holderName : null, socialSecurityNumber: Ra && Dn.socialSecurityNumber ? Dn.socialSecurityNumber : null, taxNumber: tr && Dn.taxNumber ? Dn.taxNumber : null, billingAddress: tt && xa ? Dn.billingAddress : null }));
  }, [Vt, Mn, Dn]);
  var Oi = lie(ye);
  Rt(function() {
    var Pt, qn, xa = _e.holderName, $r = Ne, Qa = !tt || _e.billingAddress, Ln = !tr || !!_e.taxNumber && !!_e.encryptedPassword, Io = !Ra || !!_e.socialSecurityNumber, io = $r && xa && Qa && Ln && Io, ai = a.current.mapErrorsToValidationRuleResult(), yi = Ho(Ho({}, K), ai), _u = yi.billingAddress, Ss = Ho(Ho({}, pa(yi, hKe)), _u), xs = y == null ? void 0 : y({ errors: Ss, isValidating: o.current, layout: jf(), countrySpecificLabels: (Pt = R.getAddressLabelsForCountry(ia == null ? void 0 : ia.country)) !== null && Pt !== void 0 ? Pt : bt == null || (qn = bt.default) === null || qn === void 0 ? void 0 : qn.labels }), ts = xs == null ? void 0 : xs.currentErrorsSortedByLayout;
    switch (ce(ts), xs == null ? void 0 : xs.action) {
      case R8:
        v && function(Cu, vl, In) {
          Cu && (jt($y).call($y, In) ? vl.current.setFocusOn(In) : YZ(In, vl));
        }(o.current, a, xs == null ? void 0 : xs.fieldToFocus), Ro(function() {
          o.current = !1;
        }, 300);
        break;
      case JM:
        var Ar = gO(ts, Oi, "field"), Mc = Ar == null ? void 0 : Ar[0];
        if (Mc) {
          var oh = function(Cu) {
            var vl;
            return !jt(vl = ["error.va.sf-cc-num.03", "error.va.sf-cc-dat.01", "error.va.sf-cc-dat.02", "error.va.sf-cc-dat.03"]).call(vl, Cu);
          }(Mc.errorCode), Dd = oh ? Mc.errorMessage : null;
          f(Dd);
        } else m();
    }
    if (ts) {
      var vr = gO(ts, Oi, "field");
      vr == null || Q(vr).call(vr, function(Cu) {
        var vl = { fieldType: Cu.field, errorCode: Cu.errorCode };
        e.onErrorAnalytics(vl);
      });
    }
    e.onChange({ data: oe, valid: _e, errors: yi, isValid: io, billingAddress: ia, selectedBrandValue: jo, storePaymentMethod: Qn, socialSecurityNumber: ni, installments: Pa });
  }, [oe, _e, K, jo, Qn, Pa]);
  var ah = e.storedPaymentMethodId ? nKe : fKe;
  return P(ra, null, P(sC, kt({ ref: a }, function(Pt) {
    return { allowedDOMAccess: Pt.allowedDOMAccess, autoFocus: Pt.autoFocus, brands: Pt.brands, brandsConfiguration: Pt.brandsConfiguration, clientKey: Pt.clientKey, countryCode: Pt.countryCode, forceCompat: Pt.forceCompat, i18n: Pt.i18n, implementationType: Pt.implementationType, keypadFix: Pt.keypadFix, legacyInputMode: Pt.legacyInputMode, loadingContext: Pt.loadingContext, minimumExpiryDate: Pt.minimumExpiryDate, onAdditionalSFConfig: Pt.onAdditionalSFConfig, onAdditionalSFRemoved: Pt.onAdditionalSFRemoved, onAllValid: Pt.onAllValid, onAutoComplete: Pt.onAutoComplete, onBinValue: Pt.onBinValue, onConfigSuccess: Pt.onConfigSuccess, onError: Pt.onError, onFieldValid: Pt.onFieldValid, onLoad: Pt.onLoad, showWarnings: Pt.showWarnings, trimTrailingSeparator: Pt.trimTrailingSeparator, maskSecurityCode: Pt.maskSecurityCode, exposeExpiryDate: Pt.exposeExpiryDate, resources: Pt.resources };
  }(e), { styles: Ho(Ho({}, FXe), e.styles), koreanAuthenticationRequired: e.configuration.koreanAuthenticationRequired, hasKoreanFields: !(!e.configuration.koreanAuthenticationRequired || e.countryCode !== "kr"), onChange: function(Pt, qn) {
    if (Pt.autoCompleteName) {
      if (!e.hasHolderName) return;
      var xa = (Qa = "blur", Io = rr(Ln = GZ.holderName).call(Ln, function(io, ai) {
        var yi;
        return io.length || jt(yi = ai.modes).call(yi, Qa) && io.push(ai.validate), io;
      }, []), Io[0]), $r = xa(Pt.autoCompleteName) ? Pt.autoCompleteName : null;
      $r && (Hn("holderName", $r), Ja("holderName", !0), Qr("holderName", null));
    } else {
      var Qa, Ln, Io;
      e.autoFocus && E.current > 0 && (qn == null ? void 0 : qn.event) === "handleOnFieldValid" && (qn == null ? void 0 : qn.fieldType) === Or && Pt.valid.encryptedCardNumber && ws(), me(Ho(Ho({}, oe), Pt.data)), q(Ho(Ho({}, K), Pt.errors)), ge(Ho(Ho({}, _e), Pt.valid)), Ee(Pt.isSfpValid), sn(Pt.cvcPolicy), ti(Pt.showSocialSecurityNumber), Ae(Pt.expiryDatePolicy);
    }
  }, onBrand: e.onBrand, onFocus: Gs, type: e.brand, disableIOSArrowKeys: e.disableIOSArrowKeys ? Ff : null, render: function(Pt, qn) {
    var xa, $r = Pt.setRootNode, Qa = Pt.setFocusOn;
    return P("div", { ref: $r, className: Tt(T(T(T({ "adyen-checkout__card-input": !0 }, dl["card-input__wrapper"], !0), "adyen-checkout__card-input--".concat((xa = e.fundingSource) !== null && xa !== void 0 ? xa : "credit"), !0), "adyen-checkout__card-input--loading", $ === "loading")), role: "form" }, e.showFormInstruction && P(Qp, null), P(ah, kt({}, function(Ln) {
      return { amount: Ln.amount, billingAddressRequired: Ln.billingAddressRequired, billingAddressRequiredFields: Ln.billingAddressRequiredFields, billingAddressAllowedCountries: Ln.billingAddressAllowedCountries, brandsConfiguration: Ln.brandsConfiguration, showStoreDetailsCheckbox: Ln.showStoreDetailsCheckbox, hasCVC: Ln.hasCVC, hasHolderName: Ln.hasHolderName, holderNameRequired: Ln.holderNameRequired, installmentOptions: Ln.installmentOptions, placeholders: Ln.placeholders, positionHolderNameOnTop: Ln.positionHolderNameOnTop, showBrandIcon: Ln.showBrandIcon, showBrandsUnderCardNumber: Ln.showBrandsUnderCardNumber, lastFour: Ln.lastFour, expiryMonth: Ln.expiryMonth, expiryYear: Ln.expiryYear, disclaimerMessage: Ln.disclaimerMessage };
    }(e), { data: oe, valid: _e, errors: K, handleChangeFor: pt, focusedElement: Le, setFocusOn: Qa, sfpState: qn, cvcPolicy: St, hasInstallments: sa, showAmountsInInstallments: gi, handleInstallments: ri, brandsIcons: e.brandsIcons, formData: Vt, formErrors: Dn, formValid: Mn, expiryDatePolicy: He, dualBrandSelectElements: Wt, extensions: Bf, selectedBrandValue: jo, showKCP: tr, showBrazilianSSN: Ra, socialSecurityNumber: ni, handleOnStoreDetails: er, setAddressRef: S, billingAddress: ia, billingAddressValidationRules: bt && hZe(rn.current), partialAddressSchema: bt, handleAddress: zu, onAddressLookup: e.onAddressLookup, onAddressSelected: e.onAddressSelected, addressSearchDebounceMs: e.addressSearchDebounceMs, iOSFocusedField: ml, onFieldFocusAnalytics: Eo, onFieldBlurAnalytics: Vn })));
  } })), e.showPayButton && e.payButton({ status: $, variant: e.isPayButtonPrimaryVariant ? "primary" : "secondary", icon: s({ imageFolder: "components/" })("lock") }));
};
function KZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
Aie.defaultProps = jXe;
var Pie = function(e) {
  var t = null;
  return function(n) {
    e.props.doBinLookup !== !1 && (n.encryptedBin && e.props.clientKey ? (t = n.uuid, fl({ loadingContext: e.props.loadingContext, path: "v3/bin/binLookup?token=".concat(e.props.clientKey) }, { type: e.props.type, supportedBrands: e.props.brands || x4, encryptedBin: n.encryptedBin, requestId: n.uuid }).then(function(r) {
      var a;
      if ((r == null ? void 0 : r.requestId) === t) if ((a = r.brands) !== null && a !== void 0 && a.length) {
        var o, s, c = rr(o = r.brands).call(o, function(f, m) {
          return f.detectedBrands.push(m.brand), f.paymentMethodVariants.push(m.paymentMethodVariant), m.supported === !0 && f.supportedBrands.push(m), f;
        }, { supportedBrands: [], detectedBrands: [], paymentMethodVariants: [] });
        if (c.supportedBrands.length) return e.processBinLookupResponse(function(f) {
          for (var m = 1; m < arguments.length; m++) {
            var v, y, b = arguments[m] != null ? arguments[m] : {};
            m % 2 ? Q(v = KZ(Object(b), !0)).call(v, function(S) {
              T(f, S, b[S]);
            }) : ne ? Ze(f, ne(b)) : Q(y = KZ(Object(b))).call(y, function(S) {
              We(f, S, re(b, S));
            });
          }
          return f;
        }({ issuingCountryCode: r.issuingCountryCode, supportedBrands: c.supportedBrands }, r.showSocialSecurityNumber ? { showSocialSecurityNumber: r.showSocialSecurityNumber } : {})), void e.onBinLookup({ type: n.type, detectedBrands: c.detectedBrands, supportedBrands: It(s = c.supportedBrands).call(s, function(f) {
          return f.brand;
        }), paymentMethodVariants: c.paymentMethodVariants, supportedBrandsRaw: c.supportedBrands, brands: e.props.brands || x4, issuingCountryCode: r.issuingCountryCode });
        if (c.detectedBrands.length) {
          var u = { type: "card", fieldType: "encryptedCardNumber", error: aie(qM), detectedBrands: c.detectedBrands };
          return e.handleUnsupportedCard(u), void e.onBinLookup({ type: n.type, detectedBrands: c.detectedBrands, supportedBrands: null, paymentMethodVariants: c.paymentMethodVariants, brands: e.props.brands || x4 });
        }
      } else e.onBinLookup({ type: n.type, detectedBrands: null, supportedBrands: null, paymentMethodVariants: null, brands: e.props.brands || x4 }), e.processBinLookupResponse({}, !0);
      else r != null && r.requestId || e.props.onError(r || { errorType: "binLookup", message: "unknownError" });
    })) : t && (e.processBinLookupResponse(null, !0), t = null, e.handleUnsupportedCard({ type: "card", fieldType: "encryptedCardNumber", error: "" }), e.onBinLookup({ isReset: !0 }))), e.props.onBinValue && e.props.onBinValue(n);
  };
};
function mKe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Vs = function(e) {
  ft(n, e);
  var t = mKe(n);
  function n(r, a, o) {
    var s, c, u;
    Qe(this, n), u = t.call(this), T(Se(u), "reason", void 0), T(Se(u), "message", void 0), T(Se(u), "source", void 0), T(Se(u), "scheme", void 0), T(Se(u), "errorFromCardSchemeSdk", void 0);
    var f = "error" in r ? r == null || (s = r.error) === null || s === void 0 ? void 0 : s.message : r == null ? void 0 : r.message, m = "error" in r ? r == null || (c = r.error) === null || c === void 0 ? void 0 : c.reason : r == null ? void 0 : r.reason;
    return u.message = f, u.reason = m, u.source = a, u.scheme = o, u.errorFromCardSchemeSdk = r, u;
  }
  return et(n, [{ key: "toString", value: function() {
    var r, a, o;
    return je(r = je(a = je(o = "Reason: ".concat(this.reason, " / Source: ")).call(o, this.source, " / Scheme: ")).call(a, this.scheme, " / Message: ")).call(r, this.message);
  } }]), n;
}(f_(Error)), Nie = function() {
  function e(c, u) {
    if (Qe(this, e), T(this, "schemeSdk", void 0), T(this, "schemeName", void 0), T(this, "customSdkConfiguration", void 0), T(this, "sdkUrl", void 0), T(this, "scriptElement", null), !c) throw Error("AbstractSrcInitiator: Invalid SDK URL");
    this.sdkUrl = c, this.customSdkConfiguration = u;
  }
  var t, n, r, a, o, s;
  return et(e, [{ key: "loadSdkScript", value: (s = On(yt.mark(function c() {
    return yt.wrap(function(u) {
      for (; ; ) switch (u.prev = u.next) {
        case 0:
          if (this.isSdkIsAvailableOnWindow()) {
            u.next = 4;
            break;
          }
          return this.scriptElement = new G2(this.sdkUrl), u.next = 4, this.scriptElement.load();
        case 4:
          this.assignSdkReference();
        case 5:
        case "end":
          return u.stop();
      }
    }, c, this);
  })), function() {
    return s.apply(this, arguments);
  }) }, { key: "removeSdkScript", value: function() {
    this.scriptElement.remove();
  } }, { key: "checkout", value: (o = On(yt.mark(function c(u) {
    var f;
    return yt.wrap(function(m) {
      for (; ; ) switch (m.prev = m.next) {
        case 0:
          return m.prev = 0, m.next = 3, this.schemeSdk.checkout(u);
        case 3:
          return f = m.sent, m.abrupt("return", f);
        case 7:
          throw m.prev = 7, m.t0 = m.catch(0), new Vs(m.t0, "checkout", this.schemeName);
        case 11:
        case "end":
          return m.stop();
      }
    }, c, this, [[0, 7]]);
  })), function(c) {
    return o.apply(this, arguments);
  }) }, { key: "unbindAppInstance", value: (a = On(yt.mark(function c() {
    return yt.wrap(function(u) {
      for (; ; ) switch (u.prev = u.next) {
        case 0:
          return u.prev = 0, u.next = 3, this.schemeSdk.unbindAppInstance();
        case 3:
          u.next = 9;
          break;
        case 5:
          throw u.prev = 5, u.t0 = u.catch(0), new Vs(u.t0, "unbindAppInstance", this.schemeName);
        case 9:
        case "end":
          return u.stop();
      }
    }, c, this, [[0, 5]]);
  })), function() {
    return a.apply(this, arguments);
  }) }, { key: "isRecognized", value: (r = On(yt.mark(function c() {
    var u;
    return yt.wrap(function(f) {
      for (; ; ) switch (f.prev = f.next) {
        case 0:
          return f.prev = 0, f.next = 3, this.schemeSdk.isRecognized();
        case 3:
          return u = f.sent, f.abrupt("return", u);
        case 7:
          throw f.prev = 7, f.t0 = f.catch(0), new Vs(f.t0, "isRecognized", this.schemeName);
        case 11:
        case "end":
          return f.stop();
      }
    }, c, this, [[0, 7]]);
  })), function() {
    return r.apply(this, arguments);
  }) }, { key: "initiateIdentityValidation", value: (n = On(yt.mark(function c() {
    var u;
    return yt.wrap(function(f) {
      for (; ; ) switch (f.prev = f.next) {
        case 0:
          return f.prev = 0, f.next = 3, this.schemeSdk.initiateIdentityValidation();
        case 3:
          return u = f.sent, f.abrupt("return", u);
        case 7:
          throw f.prev = 7, f.t0 = f.catch(0), new Vs(f.t0, "initiateIdentityValidation", this.schemeName);
        case 11:
        case "end":
          return f.stop();
      }
    }, c, this, [[0, 7]]);
  })), function() {
    return n.apply(this, arguments);
  }) }, { key: "getSrcProfile", value: (t = On(yt.mark(function c(u) {
    var f;
    return yt.wrap(function(m) {
      for (; ; ) switch (m.prev = m.next) {
        case 0:
          return m.prev = 0, m.next = 3, this.schemeSdk.getSrcProfile({ idTokens: u });
        case 3:
          return f = m.sent, m.abrupt("return", f);
        case 7:
          throw m.prev = 7, m.t0 = m.catch(0), new Vs(m.t0, "getSrcProfile", this.schemeName);
        case 11:
        case "end":
          return m.stop();
      }
    }, c, this, [[0, 7]]);
  })), function(c) {
    return t.apply(this, arguments);
  }) }]), e;
}();
function qZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = qZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = qZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function vKe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var gKe = { email: "EMAIL", telephoneNumber: "MOBILE_NUMBER" }, yKe = function(e) {
  ft(o, Nie);
  var t, n, r, a = vKe(o);
  function o(s, c) {
    var u, f;
    return Qe(this, o), f = a.call(this, jt(u = s.toLowerCase()).call(u, "live") ? "https://assets.secure.checkout.visa.com/checkout-widget/resources/js/src-i-adapter/visa-sdk.js?v2" : "https://sandbox-assets.secure.checkout.visa.com/checkout-widget/resources/js/src-i-adapter/visa-sdk.js?v2", c), T(Se(f), "schemeName", "visa"), f;
  }
  return et(o, [{ key: "isSdkIsAvailableOnWindow", value: function() {
    var s;
    return !((s = window.vAdapters) === null || s === void 0 || !s.VisaSRCI);
  } }, { key: "assignSdkReference", value: function() {
    this.schemeSdk = new window.vAdapters.VisaSRCI();
  } }, { key: "init", value: (r = On(yt.mark(function s(c, u) {
    var f;
    return yt.wrap(function(m) {
      for (; ; ) switch (m.prev = m.next) {
        case 0:
          return m.prev = 0, f = tN(tN(tN({}, c), (v = this.customSdkConfiguration, y = void 0, b = void 0, S = void 0, y = v.dpaLocale, b = y === void 0 ? "en_US" : y, S = v.dpaPresentationName, { dpaTransactionOptions: { dpaLocale: b, payloadTypeIndicator: "NON_PAYMENT", customInputData: { checkoutOrchestrator: "merchant" } }, dpaData: { dpaPresentationName: S === void 0 ? "" : S } })), {}, { srciTransactionId: u }), m.next = 4, this.schemeSdk.init(f);
        case 4:
          m.next = 10;
          break;
        case 6:
          throw m.prev = 6, m.t0 = m.catch(0), new Vs(m.t0, "init", this.schemeName);
        case 10:
        case "end":
          return m.stop();
      }
      var v, y, b, S;
    }, s, this, [[0, 6]]);
  })), function(s, c) {
    return r.apply(this, arguments);
  }) }, { key: "identityLookup", value: (n = On(yt.mark(function s(c) {
    var u, f, m, v;
    return yt.wrap(function(y) {
      for (; ; ) switch (y.prev = y.next) {
        case 0:
          return u = c.identityValue, f = c.type, y.prev = 1, m = { identityValue: u, type: gKe[f] }, y.next = 5, this.schemeSdk.identityLookup(m);
        case 5:
          return v = y.sent, y.abrupt("return", v);
        case 9:
          throw y.prev = 9, y.t0 = y.catch(1), new Vs(y.t0, "identityLookup", this.schemeName);
        case 13:
        case "end":
          return y.stop();
      }
    }, s, this, [[1, 9]]);
  })), function(s) {
    return n.apply(this, arguments);
  }) }, { key: "completeIdentityValidation", value: (t = On(yt.mark(function s(c) {
    var u;
    return yt.wrap(function(f) {
      for (; ; ) switch (f.prev = f.next) {
        case 0:
          return f.prev = 0, f.next = 3, this.schemeSdk.completeIdentityValidation(c);
        case 3:
          return u = f.sent, f.abrupt("return", u);
        case 7:
          throw f.prev = 7, f.t0 = f.catch(0), new Vs(f.t0, "completeIdentityValidation", this.schemeName);
        case 11:
        case "end":
          return f.stop();
      }
    }, s, this, [[0, 7]]);
  })), function(s) {
    return t.apply(this, arguments);
  }) }]), o;
}();
function JZ(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function nN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = JZ(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = JZ(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function bKe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var _Ke = { email: "EMAIL_ADDRESS", telephoneNumber: "MOBILE_PHONE_NUMBER" }, CKe = function(e) {
  ft(o, Nie);
  var t, n, r, a = bKe(o);
  function o(s, c) {
    var u, f;
    return Qe(this, o), f = a.call(this, jt(u = s.toLowerCase()).call(u, "live") ? "https://src.mastercard.com/sdk/srcsdk.mastercard.js" : "https://sandbox.src.mastercard.com/sdk/srcsdk.mastercard.js", c), T(Se(f), "schemeName", "mc"), f;
  }
  return et(o, [{ key: "isSdkIsAvailableOnWindow", value: function() {
    return !!window.SRCSDK_MASTERCARD;
  } }, { key: "assignSdkReference", value: function() {
    this.schemeSdk = window.SRCSDK_MASTERCARD;
  } }, { key: "init", value: (r = On(yt.mark(function s(c, u) {
    var f;
    return yt.wrap(function(m) {
      for (; ; ) switch (m.prev = m.next) {
        case 0:
          return m.prev = 0, f = nN(nN(nN({}, c), (v = this.customSdkConfiguration, y = void 0, b = void 0, S = void 0, y = v.dpaLocale, b = y === void 0 ? "en_US" : y, S = v.dpaPresentationName, { dpaTransactionOptions: { dpaLocale: b, paymentOptions: { dynamicDataType: "CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM" }, consumerNameRequested: !0, customInputData: { "com.mastercard.dcfExperience": "PAYMENT_SETTINGS" }, confirmPayment: !1 }, dpaData: { dpaPresentationName: S === void 0 ? "" : S } })), {}, { srciTransactionId: u }), m.next = 4, this.schemeSdk.init(f);
        case 4:
          m.next = 10;
          break;
        case 6:
          throw m.prev = 6, m.t0 = m.catch(0), new Vs(m.t0, "init", this.schemeName);
        case 10:
        case "end":
          return m.stop();
      }
      var v, y, b, S;
    }, s, this, [[0, 6]]);
  })), function(s, c) {
    return r.apply(this, arguments);
  }) }, { key: "identityLookup", value: (n = On(yt.mark(function s(c) {
    var u, f, m, v;
    return yt.wrap(function(y) {
      for (; ; ) switch (y.prev = y.next) {
        case 0:
          return u = c.identityValue, f = c.type, y.prev = 1, m = { identityValue: u, identityType: _Ke[f] }, y.next = 5, this.schemeSdk.identityLookup({ consumerIdentity: m });
        case 5:
          return v = y.sent, y.abrupt("return", v);
        case 9:
          throw y.prev = 9, y.t0 = y.catch(1), new Vs(y.t0, "identityLookup", this.schemeName);
        case 13:
        case "end":
          return y.stop();
      }
    }, s, this, [[1, 9]]);
  })), function(s) {
    return n.apply(this, arguments);
  }) }, { key: "completeIdentityValidation", value: (t = On(yt.mark(function s(c) {
    var u;
    return yt.wrap(function(f) {
      for (; ; ) switch (f.prev = f.next) {
        case 0:
          return f.prev = 0, f.next = 3, this.schemeSdk.completeIdentityValidation({ validationData: c });
        case 3:
          return u = f.sent, f.abrupt("return", u);
        case 7:
          throw f.prev = 7, f.t0 = f.catch(0), new Vs(f.t0, "completeIdentityValidation", this.schemeName);
        case 11:
        case "end":
          return f.stop();
      }
    }, s, this, [[0, 7]]);
  })), function(s) {
    return t.apply(this, arguments);
  }) }]), o;
}(), Tie = function(e) {
  return e.status === "fulfilled";
}, Oie = function(e) {
  return e.status === "rejected";
}, QZ = { visa: yKe, mc: CKe, default: null }, wKe = function(e, t, n) {
  var r = QZ[e] || QZ.default;
  return r ? new r(t, n) : null;
}, SKe = function() {
  function e(n, r) {
    var a = r.dpaLocale, o = a === void 0 ? "en_US" : a, s = r.dpaPresentationName, c = s === void 0 ? "" : s;
    Qe(this, e), T(this, "schemes", void 0), T(this, "customSdkConfiguration", void 0), this.schemes = n, this.customSdkConfiguration = { dpaLocale: o, dpaPresentationName: c };
  }
  var t;
  return et(e, [{ key: "load", value: (t = On(yt.mark(function n(r) {
    var a = this;
    return yt.wrap(function(o) {
      for (; ; ) switch (o.prev = o.next) {
        case 0:
          if (this.schemes && this.schemes.length !== 0) {
            o.next = 2;
            break;
          }
          throw new _r("ERROR", "ClickToPay -> SrcSdkLoader: There are no schemes set to be loaded");
        case 2:
          return o.abrupt("return", new Yt(function(s, c) {
            var u, f = It(u = a.schemes).call(u, function(v) {
              return wKe(v, r, a.customSdkConfiguration);
            }), m = It(f).call(f, function(v) {
              return v.loadSdkScript();
            });
            Yt.allSettled(m).then(function(v) {
              $m(v).call(v, Oie) && c(new _r("ERROR", "ClickToPay -> SrcSdkLoader # Unable to load network schemes: ".concat(a.schemes.toString())));
              var y = Oe(f).call(f, function(b, S) {
                return Tie(v[S]);
              });
              s(y);
            });
          }));
        case 3:
        case "end":
          return o.stop();
      }
    }, n, this);
  })), function(n) {
    return t.apply(this, arguments);
  }) }]), e;
}(), u6 = { mc: "Mastercard", visa: "Visa" }, xKe = function() {
  function e(t, n, r) {
    Qe(this, e), T(this, "dateOfCardLastUsed", void 0), T(this, "dateOfCardCreated", void 0), T(this, "panLastFour", void 0), T(this, "srcDigitalCardId", void 0), T(this, "scheme", void 0), T(this, "artUri", void 0), T(this, "srcCorrelationId", void 0), T(this, "tokenId", void 0), T(this, "isExpired", void 0), T(this, "panExpirationMonth", void 0), T(this, "panExpirationYear", void 0), T(this, "descriptorName", void 0), T(this, "status", null), this.dateOfCardLastUsed = t.dateOfCardLastUsed, this.dateOfCardCreated = t.dateOfCardCreated, this.panLastFour = t.panLastFour, this.srcDigitalCardId = t.srcDigitalCardId, this.descriptorName = t.digitalCardData.descriptorName, this.tokenId = t.tokenId, this.scheme = n, this.artUri = t.digitalCardData.artUri, this.srcCorrelationId = r, this.panExpirationMonth = t.panExpirationMonth, this.panExpirationYear = t.panExpirationYear, this.status = t.digitalCardData.status, this.isExpired = this.confirmCardIsExpired();
  }
  return et(e, [{ key: "title", get: function() {
    return this.scheme === "visa" ? u6[this.scheme] : this.descriptorName || u6[this.scheme];
  } }, { key: "isDcfPopupEmbedded", get: function() {
    return this.scheme === "mc";
  } }, { key: "confirmCardIsExpired", value: function() {
    if (this.status !== "ACTIVE") return !0;
    if (!this.panExpirationYear && !this.panExpirationMonth) return !1;
    var t = [(/* @__PURE__ */ new Date()).getMonth() + 1, (/* @__PURE__ */ new Date()).getFullYear()], n = t[0], r = t[1];
    return !(Number(this.panExpirationYear) > r) && !(Number(this.panExpirationYear) === r && Number(this.panExpirationMonth) >= n);
  } }]), e;
}(), Rie = "ctpIframe";
function EKe(e, t, n) {
  var r, a = e.scheme, o = e.tokenId, s = e.srcDigitalCardId, c = e.srcCorrelationId;
  return a === "visa" ? o ? { srcScheme: a, srcCorrelationId: c, srcTokenReference: jt(r = n.toLowerCase()).call(r, "live") ? o : "987654321" } : { srcScheme: a, srcCheckoutPayload: t.checkoutResponse, srcCorrelationId: c } : { srcScheme: a, srcDigitalCardId: s, srcCorrelationId: c };
}
function IKe(e, t) {
  var n, r = t.profiles, a = t.srcCorrelationId, o = rr(r).call(r, function(s, c) {
    var u, f, m = It(u = c.maskedCards).call(u, function(v) {
      return new xKe(v, t.scheme, a);
    });
    return je(f = []).call(f, Pn(s), Pn(m));
  }, []);
  return je(n = []).call(n, Pn(e), Pn(o));
}
function eY(e, t) {
  return new Date(t.dateOfCardLastUsed).getTime() - new Date(e.dateOfCardLastUsed).getTime();
}
function kKe(e, t) {
  return new Date(t.dateOfCardCreated).getTime() - new Date(e.dateOfCardCreated).getTime();
}
function AKe(e, t) {
  return t.isExpired ? e.expiredCards.push(t) : e.availableCards.push(t), e;
}
function PKe(e, t) {
  return t.dateOfCardLastUsed ? e.usedCards.push(t) : e.unusedCards.push(t), e;
}
function NKe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Ay = function(e) {
  ft(n, e);
  var t = NKe(n);
  function n(r) {
    var a;
    return Qe(this, n), (a = t.call(this, r)).name = "TimeoutError", a;
  }
  return et(n);
}(f_(Error));
function tY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function rx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = tY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = tY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var Tr = function(e) {
  return e.Idle = "Idle", e.Loading = "Loading", e.ShopperIdentified = "ShopperIdentified", e.OneTimePassword = "OneTimePassword", e.Ready = "Ready", e.Login = "Login", e.NotAvailable = "NotAvailable", e;
}({});
function rN(e, t, n) {
  var r = new Yt(function(a, o) {
    return Ro(function() {
      return o(n);
    }, t);
  });
  return Yt.race([e(), r]);
}
var TKe = function() {
  function e(m, v, y, b, S) {
    Qe(this, e), T(this, "sdkLoader", void 0), T(this, "schemesConfig", void 0), T(this, "shopperIdentity", void 0), T(this, "environment", void 0), T(this, "onTimeout", void 0), T(this, "srciTransactionId", F2()), T(this, "sdks", void 0), T(this, "validationSchemeSdk", null), T(this, "stateSubscriber", void 0), T(this, "state", Tr.Idle), T(this, "shopperCards", null), T(this, "identityValidationData", null), T(this, "storeCookies", !1), this.sdkLoader = v, this.schemesConfig = m, this.shopperIdentity = b, this.environment = y, this.onTimeout = S;
  }
  var t, n, r, a, o, s, c, u, f;
  return et(e, [{ key: "shopperAccountFound", get: function() {
    var m;
    return jt(m = [Tr.Ready, Tr.ShopperIdentified]).call(m, this.state);
  } }, { key: "schemes", get: function() {
    return this.sdkLoader.schemes;
  } }, { key: "updateStoreCookiesConsent", value: function(m) {
    this.storeCookies = m;
  } }, { key: "initialize", value: (f = On(yt.mark(function m() {
    var v, y, b, S, x, E, N, R, O;
    return yt.wrap(function(D) {
      for (; ; ) switch (D.prev = D.next) {
        case 0:
          return this.setState(Tr.Loading), D.prev = 1, D.next = 4, this.sdkLoader.load(this.environment);
        case 4:
          return this.sdks = D.sent, D.next = 7, this.initiateSdks();
        case 7:
          return D.next = 9, this.verifyIfShopperIsRecognized();
        case 9:
          if (v = D.sent, y = v.recognized, b = y !== void 0 && y, S = v.idTokens, x = S === void 0 ? null : S, !b) {
            D.next = 19;
            break;
          }
          return D.next = 17, this.getShopperProfile(x);
        case 17:
          return this.setState(Tr.Ready), D.abrupt("return");
        case 19:
          if (this.shopperIdentity) {
            D.next = 22;
            break;
          }
          return this.setState(Tr.NotAvailable), D.abrupt("return");
        case 22:
          return D.next = 24, this.verifyIfShopperIsEnrolled(this.shopperIdentity);
        case 24:
          if (!D.sent.isEnrolled) {
            D.next = 29;
            break;
          }
          return this.setState(Tr.ShopperIdentified), D.abrupt("return");
        case 29:
          this.setState(Tr.NotAvailable), D.next = 36;
          break;
        case 32:
          D.prev = 32, D.t0 = D.catch(1), D.t0 instanceof Vs && (D.t0 === null || D.t0 === void 0 ? void 0 : D.t0.reason) === "REQUEST_TIMEOUT" ? (R = new Ay(je(E = "ClickToPayService - Timeout during ".concat(D.t0.source, "() of the scheme '")).call(E, D.t0.scheme, "'")), (N = this.onTimeout) === null || N === void 0 || N.call(this, R)) : D.t0 instanceof Ay ? (console.warn(D.t0.toString()), (O = this.onTimeout) === null || O === void 0 || O.call(this, D.t0)) : D.t0 instanceof Vs ? console.warn("Error at ClickToPayService # init: ".concat(D.t0.toString())) : console.warn(D.t0), this.setState(Tr.NotAvailable);
        case 36:
        case "end":
          return D.stop();
      }
    }, m, this, [[1, 32]]);
  })), function() {
    return f.apply(this, arguments);
  }) }, { key: "subscribeOnStateChange", value: function(m) {
    this.stateSubscriber = m;
  } }, { key: "startIdentityValidation", value: (u = On(yt.mark(function m() {
    var v, y;
    return yt.wrap(function(b) {
      for (; ; ) switch (b.prev = b.next) {
        case 0:
          if (this.validationSchemeSdk) {
            b.next = 2;
            break;
          }
          throw Error("startIdentityValidation: No ValidationSDK set for the validation process");
        case 2:
          return b.next = 4, this.validationSchemeSdk.initiateIdentityValidation();
        case 4:
          v = b.sent, y = v.maskedValidationChannel, this.identityValidationData = { maskedShopperContact: y.replace(/\*/g, "•"), selectedNetwork: u6[this.validationSchemeSdk.schemeName] }, this.setState(Tr.OneTimePassword);
        case 8:
        case "end":
          return b.stop();
      }
    }, m, this);
  })), function() {
    return u.apply(this, arguments);
  }) }, { key: "finishIdentityValidation", value: (c = On(yt.mark(function m(v) {
    var y;
    return yt.wrap(function(b) {
      for (; ; ) switch (b.prev = b.next) {
        case 0:
          if (this.validationSchemeSdk) {
            b.next = 2;
            break;
          }
          throw Error("finishIdentityValidation: No ValidationSDK set for the validation process");
        case 2:
          return b.next = 4, this.validationSchemeSdk.completeIdentityValidation(v);
        case 4:
          return y = b.sent, b.next = 7, this.getShopperProfile([y.idToken]);
        case 7:
          this.setState(Tr.Ready), this.validationSchemeSdk = null;
        case 9:
        case "end":
          return b.stop();
      }
    }, m, this);
  })), function(m) {
    return c.apply(this, arguments);
  }) }, { key: "checkout", value: (s = On(yt.mark(function m(v) {
    var y, b, S;
    return yt.wrap(function(x) {
      for (; ; ) switch (x.prev = x.next) {
        case 0:
          if (v) {
            x.next = 2;
            break;
          }
          throw Error("ClickToPayService # checkout: Missing card data");
        case 2:
          return b = Ji(y = this.sdks).call(y, function(E) {
            return E.schemeName === v.scheme;
          }), x.next = 5, b.checkout(rx(rx({ srcDigitalCardId: v.srcDigitalCardId, srcCorrelationId: v.srcCorrelationId }, v.isDcfPopupEmbedded && { windowRef: window.frames[Rie] }), this.storeCookies && { complianceSettings: { complianceResources: [{ complianceType: "REMEMBER_ME", uri: "" }] } }));
        case 5:
          if ((S = x.sent).dcfActionCode === "COMPLETE") {
            x.next = 8;
            break;
          }
          throw new _r("ERROR", "Checkout through Scheme DCF did not complete. DCF Action code received: ".concat(S.dcfActionCode));
        case 8:
          return x.abrupt("return", EKe(v, S, this.environment));
        case 9:
        case "end":
          return x.stop();
      }
    }, m, this);
  })), function(m) {
    return s.apply(this, arguments);
  }) }, { key: "logout", value: (o = On(yt.mark(function m() {
    var v, y;
    return yt.wrap(function(b) {
      for (; ; ) switch (b.prev = b.next) {
        case 0:
          if (this.sdks) {
            b.next = 2;
            break;
          }
          throw new _r("ERROR", "ClickToPayService is not initialized");
        case 2:
          return b.prev = 2, y = It(v = this.sdks).call(v, function(S) {
            return S.unbindAppInstance();
          }), b.next = 6, Yt.all(y);
        case 6:
          b.next = 11;
          break;
        case 8:
          b.prev = 8, b.t0 = b.catch(2), b.t0 instanceof Vs ? console.warn("Error at ClickToPayService # logout: ".concat(b.t0.toString())) : console.warn(b.t0);
        case 11:
          this.shopperCards = null, this.identityValidationData = null, this.validationSchemeSdk = null, this.setState(Tr.Login);
        case 15:
        case "end":
          return b.stop();
      }
    }, m, this, [[2, 8]]);
  })), function() {
    return o.apply(this, arguments);
  }) }, { key: "verifyIfShopperIsEnrolled", value: (a = On(yt.mark(function m(v) {
    var y, b = this;
    return yt.wrap(function(S) {
      for (; ; ) switch (S.prev = S.next) {
        case 0:
          return y = v.shopperEmail, S.abrupt("return", new Yt(function(x, E) {
            var N, R = It(N = b.sdks).call(N, function(O) {
              var D = rN(function() {
                return O.identityLookup({ identityValue: y, type: "email" });
              }, 5e3, new Ay("ClickToPayService - Timeout during identityLookup() of the scheme '".concat(O.schemeName, "'")));
              return D.then(function($) {
                $.consumerPresent && !b.validationSchemeSdk && (b.setSdkForPerformingShopperIdentityValidation(O), x({ isEnrolled: !0 }));
              }).catch(function($) {
                E($);
              }), D;
            });
            Yt.allSettled(R).then(function() {
              x({ isEnrolled: !1 });
            });
          }));
        case 2:
        case "end":
          return S.stop();
      }
    }, m);
  })), function(m) {
    return a.apply(this, arguments);
  }) }, { key: "setState", value: function(m) {
    var v;
    this.state = m, (v = this.stateSubscriber) === null || v === void 0 || v.call(this, this.state);
  } }, { key: "setSdkForPerformingShopperIdentityValidation", value: function(m) {
    this.validationSchemeSdk = m;
  } }, { key: "getShopperProfile", value: (r = On(yt.mark(function m(v) {
    var y = this;
    return yt.wrap(function(b) {
      for (; ; ) switch (b.prev = b.next) {
        case 0:
          return b.abrupt("return", new Yt(function(S, x) {
            var E, N = It(E = y.sdks).call(E, function(R) {
              return R.getSrcProfile(v);
            });
            Yt.allSettled(N).then(function(R) {
              var O;
              $m(R).call(R, Oie) && x(R[0].reason);
              var D, $, B, G, Z, K, q, pe, he, _e = Oe(O = It(R).call(R, function(ge, Y) {
                return Tie(ge) && rx(rx({}, ge.value), {}, { scheme: y.sdks[Y].schemeName });
              })).call(O, function(ge) {
                return !!ge;
              });
              y.shopperCards = (B = rr(D = _e).call(D, IKe, []), G = rr(B).call(B, AKe, { availableCards: [], expiredCards: [] }), Z = G.availableCards, K = G.expiredCards, q = rr(Z).call(Z, PKe, { unusedCards: [], usedCards: [] }), pe = q.unusedCards, he = q.usedCards, je($ = []).call($, Pn(qx(he).call(he, eY)), Pn(qx(pe).call(pe, kKe)), Pn(qx(K).call(K, eY)))), S();
            });
          }));
        case 1:
        case "end":
          return b.stop();
      }
    }, m);
  })), function(m) {
    return r.apply(this, arguments);
  }) }, { key: "verifyIfShopperIsRecognized", value: (n = On(yt.mark(function m() {
    var v = this;
    return yt.wrap(function(y) {
      for (; ; ) switch (y.prev = y.next) {
        case 0:
          return y.abrupt("return", new Yt(function(b, S) {
            var x, E = It(x = v.sdks).call(x, function(N) {
              var R = rN(function() {
                return N.isRecognized();
              }, 5e3, new Ay("ClickToPayService - Timeout during isRecognized() of the scheme '".concat(N.schemeName, "'")));
              return R.then(function(O) {
                return O.recognized && b(O);
              }).catch(function(O) {
                return S(O);
              }), R;
            });
            Yt.allSettled(E).then(function() {
              return b({ recognized: !1 });
            });
          }));
        case 1:
        case "end":
          return y.stop();
      }
    }, m);
  })), function() {
    return n.apply(this, arguments);
  }) }, { key: "initiateSdks", value: (t = On(yt.mark(function m() {
    var v, y, b = this;
    return yt.wrap(function(S) {
      for (; ; ) switch (S.prev = S.next) {
        case 0:
          return y = It(v = this.sdks).call(v, function(x) {
            var E = b.schemesConfig[x.schemeName];
            return rN(function() {
              return x.init(E, b.srciTransactionId);
            }, 5e3, new Ay("ClickToPayService - Timeout during init() of the scheme '".concat(x.schemeName, "'")));
          }), S.next = 3, Yt.all(y);
        case 3:
        case "end":
          return S.stop();
      }
    }, m, this);
  })), function() {
    return t.apply(this, arguments);
  }) }]), e;
}();
function nY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function IO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = nY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = nY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Mie(e, t, n) {
  var r = RKe(e);
  if (!r) return null;
  var a = OKe(t == null ? void 0 : t.shopperEmail, t == null ? void 0 : t.telephoneNumber), o = Pe(r), s = new SKe(o, { dpaLocale: t == null ? void 0 : t.locale, dpaPresentationName: t == null ? void 0 : t.merchantDisplayName });
  return new TKe(r, s, n, a, t == null ? void 0 : t.onTimeout);
}
var OKe = function(e, t) {
  var n = IO({}, e && { shopperEmail: e });
  return Pe(n).length > 0 ? n : null;
}, RKe = function(e) {
  if (!e) return null;
  var t = e.visaSrciDpaId, n = e.visaSrcInitiatorId, r = e.mcDpaId, a = e.mcSrcClientId, o = IO(IO({}, r && a && { mc: { srciDpaId: r, srcInitiatorId: a } }), t && n && { visa: { srciDpaId: t, srcInitiatorId: n } });
  return Pe(o).length === 0 ? null : o;
}, Die = IM({ status: null, onSubmit: null, onSetStatus: null, onError: null, onReady: null, amount: null, configuration: null, isStandaloneComponent: null, isCtpPrimaryPaymentMethod: null, isStoringCookies: !1, setIsCtpPrimaryPaymentMethod: null, logoutShopper: null, updateStoreCookiesConsent: null, ctpState: null, cards: [], schemes: [], otpMaskedContact: null, otpNetwork: null, checkout: null, verifyIfShopperIsEnrolled: null, startIdentityValidation: null, finishIdentityValidation: null }), Lie = function(e) {
  var t, n, r = e.isStandaloneComponent, a = r !== void 0 && r, o = e.clickToPayService, s = e.amount, c = e.configuration, u = e.children, f = e.setClickToPayRef, m = e.onSubmit, v = e.onSetStatus, y = e.onError, b = Je(o), S = ze(b, 1)[0], x = Je((o == null ? void 0 : o.state) || Tr.NotAvailable), E = ze(x, 2), N = E[0], R = E[1], O = Je(!0), D = ze(O, 2), $ = D[0], B = D[1], G = Je("ready"), Z = ze(G, 2), K = Z[0], q = Z[1], pe = _n({}), he = _n(!1);
  Rt(function() {
    f(pe.current), pe.current.setStatus = q;
  }, []), Rt(function() {
    S == null || S.subscribeOnStateChange(function(X) {
      return R(X);
    });
  }, [S]);
  var _e = Kt(function() {
    var X;
    he.current || ((X = c.onReady) === null || X === void 0 || X.call(c), he.current = !0);
  }, [c.onReady]), ge = Kt(function() {
    var X = On(yt.mark(function ye(ce) {
      return yt.wrap(function(se) {
        for (; ; ) switch (se.prev = se.next) {
          case 0:
            return se.next = 2, S == null ? void 0 : S.finishIdentityValidation(ce);
          case 2:
          case "end":
            return se.stop();
        }
      }, ye);
    }));
    return function(ye) {
      return X.apply(this, arguments);
    };
  }(), [S]), Y = Kt(On(yt.mark(function X() {
    var ye;
    return yt.wrap(function(ce) {
      for (; ; ) switch (ce.prev = ce.next) {
        case 0:
          return ce.next = 2, S == null ? void 0 : S.startIdentityValidation();
        case 2:
          return ye = ce.sent, ce.abrupt("return", ye);
        case 4:
        case "end":
          return ce.stop();
      }
    }, X);
  })), [S]), ee = Kt(function() {
    var X = On(yt.mark(function ye(ce) {
      return yt.wrap(function(se) {
        for (; ; ) switch (se.prev = se.next) {
          case 0:
            return se.next = 2, S == null ? void 0 : S.checkout(ce);
          case 2:
            return se.abrupt("return", se.sent);
          case 3:
          case "end":
            return se.stop();
        }
      }, ye);
    }));
    return function(ye) {
      return X.apply(this, arguments);
    };
  }(), [S]), oe = Kt(function() {
    var X = On(yt.mark(function ye(ce) {
      return yt.wrap(function(se) {
        for (; ; ) switch (se.prev = se.next) {
          case 0:
            return se.next = 2, S == null ? void 0 : S.verifyIfShopperIsEnrolled(ce);
          case 2:
            return se.abrupt("return", se.sent);
          case 3:
          case "end":
            return se.stop();
        }
      }, ye);
    }));
    return function(ye) {
      return X.apply(this, arguments);
    };
  }(), [S]), me = Kt(On(yt.mark(function X() {
    return yt.wrap(function(ye) {
      for (; ; ) switch (ye.prev = ye.next) {
        case 0:
          return ye.next = 2, S == null ? void 0 : S.logout();
        case 2:
        case "end":
          return ye.stop();
      }
    }, X);
  })), [S]), xe = Kt(function(X) {
    S.updateStoreCookiesConsent(X);
  }, [S]);
  return P(Die.Provider, { value: { status: K, onSubmit: m, onError: y, onSetStatus: v, amount: s, configuration: c, isStoringCookies: S == null ? void 0 : S.storeCookies, isStandaloneComponent: a, isCtpPrimaryPaymentMethod: $, setIsCtpPrimaryPaymentMethod: B, ctpState: N, verifyIfShopperIsEnrolled: oe, cards: S == null ? void 0 : S.shopperCards, schemes: S == null ? void 0 : S.schemes, otpMaskedContact: S == null || (t = S.identityValidationData) === null || t === void 0 ? void 0 : t.maskedShopperContact, otpNetwork: S == null || (n = S.identityValidationData) === null || n === void 0 ? void 0 : n.selectedNetwork, checkout: ee, logoutShopper: me, startIdentityValidation: Y, finishIdentityValidation: ge, updateStoreCookiesConsent: xe, onReady: _e } }, u);
};
function Rc() {
  return GM(Die);
}
var MKe = { otp: { validate: function(e) {
  return !!e && e.length > 0;
}, errorMessage: "", modes: ["blur"] }, default: { validate: function(e) {
  return !!e && e.length > 0;
}, errorMessage: "", modes: ["blur"] } }, DKe = function(e) {
  var t = e.onError, n = e.onResendCode, r = e.disabled, a = Je(null), o = ze(a, 2), s = o[0], c = o[1], u = Je(!1), f = ze(u, 2), m = f[0], v = f[1], y = wt().i18n, b = Rc().startIdentityValidation;
  Rt(function() {
    var x = null;
    return s > 0 && (x = Ro(function() {
      return c(s - 1);
    }, 1e3)), function() {
      return clearTimeout(x);
    };
  }, [s]), Rt(function() {
    var x = null;
    return m && (x = Ro(function() {
      v(!1), c(60);
    }, 2e3)), function() {
      return clearTimeout(x);
    };
  }, [m]);
  var S = Kt(function() {
    var x = On(yt.mark(function E(N) {
      return yt.wrap(function(R) {
        for (; ; ) switch (R.prev = R.next) {
          case 0:
            return N.preventDefault(), R.prev = 1, n(), v(!0), R.next = 6, b();
          case 6:
            R.next = 13;
            break;
          case 8:
            R.prev = 8, R.t0 = R.catch(1), t(R.t0.reason), c(0), v(!1);
          case 13:
          case "end":
            return R.stop();
        }
      }, E, null, [[1, 8]]);
    }));
    return function(E) {
      return x.apply(this, arguments);
    };
  }(), [b, t, n]);
  return m ? P("div", { className: "adyen-checkout-ctp__otp-resend-code--confirmation" }, y.get("ctp.otp.codeResent"), P(h_, { type: "checkmark", height: 14, width: 14 })) : s > 0 ? P("div", { className: "adyen-checkout-ctp__otp-resend-code--disabled" }, y.get("ctp.otp.resendCode"), " -", " ", P("span", { className: "adyen-checkout-ctp__otp-resend-code-counter" }, " ", s > 0 && "".concat(s, "s"), " ")) : P("div", { role: "link", tabIndex: 0, className: Tt("adyen-checkout-ctp__otp-resend-code", { "adyen-checkout-ctp__otp-resend-code--disabled": r }), onClick: S }, y.get("ctp.otp.resendCode"));
}, LKe = function(e) {
  var t = wt().i18n, n = Rc().configuration.disableOtpAutoFocus, r = Je(null), a = ze(r, 2), o = a[0], s = a[1], c = gs({ schema: ["otp"], rules: MKe }), u = c.handleChangeFor, f = c.data, m = c.triggerValidation, v = c.valid, y = c.errors, b = c.isValid, S = c.setData, x = _n({ validateInput: null }), E = _n(null), N = Je(!1), R = ze(N, 2), O = R[0], D = R[1], $ = Kt(function() {
    D(!0), m();
  }, [m]);
  Rt(function() {
    f.otp && D(!0);
  }, [f.otp]), Rt(function() {
    !n && E.current && E.current.focus();
  }, [E.current, n]), Rt(function() {
    x.current.validateInput = $, e.onSetInputHandlers(x.current);
  }, [$, e.onSetInputHandlers]);
  var B = Kt(function() {
    S("otp", ""), s(null), n || E.current.focus(), e.onResendCode();
  }, [e.onResendCode, E.current, n]), G = Kt(function(q) {
    var pe = t.get("ctp.errors.".concat(q));
    pe && s(pe);
  }, [t]), Z = Kt(function(q) {
    q.key === "Enter" && e.onPressEnter();
  }, [e.onPressEnter]), K = Kt(function(q) {
    q.key === "Enter" && q.preventDefault();
  }, []);
  return Rt(function() {
    e.onChange({ data: f, valid: v, errors: y, isValid: b });
  }, [f, v, y]), P(xn, { name: "oneTimePassword", label: t.get("ctp.otp.fieldLabel"), labelEndAdornment: !e.hideResendOtpButton && P(DKe, { disabled: e.isValidatingOtp, onError: G, onResendCode: B }), errorMessage: O ? o || e.errorMessage || !!y.otp : null, classNameModifiers: ["otp"] }, P(vi, { name: "otp", autocorrect: "off", spellcheck: !1, value: f.otp, disabled: e.disabled, onInput: u("otp", "input"), onBlur: u("otp", "blur"), onKeyUp: Z, onKeyPress: K, setRef: function(q) {
    E.current = q;
  } }));
}, $ie = function(e) {
  var t = e.classNameModifiers, n = t === void 0 ? [] : t, r = oa(), a = Rc().schemes, o = r()("ctp"), s = r({ imageFolder: "components/" })("pipe");
  return P("div", { className: Tt("adyen_checkout-ctp__brand-wrapper", It(n).call(n, function(c) {
    return "adyen_checkout-ctp__brand-wrapper--".concat(c);
  })) }, P(ps, { className: "adyen_checkout-ctp__brand-logo", src: o, alt: "Logo of Click to Pay" }), P(ps, { className: "adyen_checkout-ctp__brand-pipe", src: s, alt: "" }), It(a).call(a, function(c) {
    return P(ps, { key: c, className: Tt("adyen_checkout-ctp__brand-scheme", "adyen_checkout-ctp__brand-scheme-".concat(c)), src: r()(c), alt: "Logo of ".concat(u6[c]) });
  }));
}, $Ke = function(e) {
  var t = e.modalElement, n = e.isOpen, r = e.isDismissible, a = e.focusFirst, o = e.focusAfterClose, s = e.onClose;
  (function(f) {
    var m = f.rootElement, v = f.focusFirst, y = f.shouldTrap, b = y === void 0 || y, S = Je(v), x = ze(S, 2), E = x[0], N = x[1];
    Rt(function() {
      b && (E == null || E.focus());
    }, [E, b]), Rt(function() {
      if (b) {
        var R = m.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'), O = R[0], D = R[R.length - 1];
        N(v || O);
        var $ = function(B) {
          if (B.key === "Tab" || B.keyCode === 9) return B.shiftKey && document.activeElement === O ? (D.focus(), void B.preventDefault()) : document.activeElement === D ? (O.focus(), void B.preventDefault()) : void 0;
        };
        return m.addEventListener("keydown", $), function() {
          N(null), m.removeEventListener("keydown", $);
        };
      }
    }, [m, v, b]);
  })({ rootElement: t, shouldTrap: n, focusFirst: a });
  var c = Kt(function() {
    o.focus(), s();
  }, [s, o]), u = Kt(function(f) {
    r && f.target instanceof HTMLElement && !t.contains(f.target) && c();
  }, [c, r, t]);
  return Rt(function() {
    if (n && t) {
      var f = function(m) {
        (m.key === "Escape" || m.key === "Esc" || m.keyCode === 27) && c();
      };
      return t.addEventListener("keydown", f), function() {
        return t.removeEventListener("keydown", f);
      };
    }
  }, [n, t, c]), { closeModal: c, handleClickOutside: u };
}, jKe = ["children", "classNameModifiers", "isOpen", "onClose", "isDismissible", "labelledBy", "describedBy", "focusFirst", "focusAfterClose"], FKe = function(e) {
  var t = e.children, n = e.classNameModifiers, r = n === void 0 ? [] : n, a = e.isOpen, o = e.onClose, s = e.isDismissible, c = s === void 0 || s, u = e.labelledBy, f = e.describedBy, m = e.focusFirst, v = e.focusAfterClose, y = pa(e, jKe), b = _n(), S = $Ke({ modalElement: b.current, isOpen: a, isDismissible: c, focusFirst: m, focusAfterClose: v, onClose: o }), x = S.closeModal, E = S.handleClickOutside;
  return P("div", kt({ className: Tt("adyen-checkout__modal-wrapper", It(r).call(r, function(N) {
    return "adyen-checkout__modal-wrapper--".concat(N);
  }), { "adyen-checkout__modal-wrapper--open": a }), role: "dialog", "aria-labelledby": u, "aria-describedby": f, "aria-modal": "true", "aria-hidden": !a, onClick: E }, y), P("div", { className: "adyen-checkout__modal", ref: b }, t({ onCloseModal: x })));
}, BKe = m2();
function rY() {
  return "adyen-".concat(BKe += 1);
}
var VKe = function(e) {
  var t = e.isOpen, n = e.onClose, r = e.focusAfterClose, a = _n(), o = wt().i18n, s = oa(), c = rY(), u = rY();
  return P(FKe, { onClose: n, isOpen: t, classNameModifiers: ["ctp"], labelledBy: c, describedBy: u, focusFirst: a.current, focusAfterClose: r }, function(f) {
    var m = f.onCloseModal;
    return P(ra, null, P(ps, { className: "adyen-checkout__ctp-modal-header-image", src: s({ imageFolder: "components/" })("ctp_landscape"), alt: "" }), P("h1", { id: c, className: "adyen-checkout__ctp-modal-title" }, o.get("ctp.infoPopup.title")), P("div", { id: u }, P("p", { tabIndex: -1, ref: a, className: "adyen-checkout__ctp-modal-text" }, o.get("ctp.infoPopup.subtitle")), P("ul", { className: "adyen-checkout__ctp-modal-text adyen-checkout__ctp-modal-benefits", type: "disc" }, P("li", null, o.get("ctp.infoPopup.benefit1")), P("li", null, o.get("ctp.infoPopup.benefit2")), P("li", null, o.get("ctp.infoPopup.benefit3"))), P($ie, { classNameModifiers: ["popup"] })), P(pu, { onClick: m, label: o.get("close") }));
  });
}, jie = function() {
  var e = Je(!1), t = ze(e, 2), n = t[0], r = t[1], a = _n(), o = wt().i18n, s = oa()({ imageFolder: "components/" })("info"), c = Kt(function() {
    r(!1);
  }, []), u = Kt(function() {
    r(!0);
  }, []);
  return P(ra, null, P("button", { ref: a, onClick: u, className: "adyen-web__ctp-info-button", "aria-label": o.get("ctp.aria.infoModalButton"), type: "button" }, P(ps, { height: "15", src: s, ariaHidden: !0 })), P(VKe, { isOpen: n, onClose: c, focusAfterClose: a.current }));
}, UKe = function() {
  var e, t = Rc(), n = t.ctpState, r = t.logoutShopper, a = t.status, o = t.cards, s = wt().i18n;
  if (jt(e = [Tr.Ready, Tr.OneTimePassword]).call(e, n) === !1) return null;
  var c = Qi(function() {
    return n === Tr.Ready && o.length > 1 ? s.get("ctp.logout.notYourCards") : n === Tr.Ready && o.length === 1 ? s.get("ctp.logout.notYourCard") : n === Tr.Ready && o.length === 0 ? s.get("ctp.logout.notYourProfile") : s.get("ctp.logout.notYou");
  }, [s, n]);
  return P("span", { role: "button", tabIndex: 0, className: Tt("adyen-checkout-ctp__section-logout-button", { "adyen-checkout-ctp__section-logout-button--disabled": a === "loading" }), onClick: r }, c);
}, Hp = function(e) {
  var t = e.children, n = Rc().isStandaloneComponent;
  return P("div", { className: Tt("adyen-checkout-ctp__section", { "adyen-checkout-ctp__section--standalone": n }) }, P("div", { className: "adyen-checkout-ctp__section-brand" }, P($ie, null), P(UKe, null)), t);
};
Hp.Title = function(e) {
  var t = e.endAdornment, n = e.children;
  return P("div", { className: "adyen-checkout-ctp__section-header" }, P("h1", { className: "adyen-checkout-ctp__section-header-title" }, n), t && P("span", { className: "adyen-checkout-ctp__section-header-adornment" }, t));
}, Hp.Text = function(e) {
  var t = e.children;
  return P("p", { className: "adyen-checkout-ctp__section-text" }, t);
};
function GKe() {
  var e = wt().i18n, t = Rc(), n = t.updateStoreCookiesConsent, r = Je(t.isStoringCookies), a = ze(r, 2), o = a[0], s = a[1], c = Je(window.matchMedia("(max-width: 480px)").matches), u = ze(c, 2), f = u[0], m = u[1], v = Kt(function() {
    var y = !o;
    s(y), n(y);
  }, [n, s, o]);
  return P("div", { className: Tt("adyen-checkout-ctp__otp-checkbox-container", { "adyen-checkout-ctp__otp-checkbox-container--checked": o }) }, P(xn, { name: "clickToPayCookiesCheckbox", addContextualElement: !1, useLabelElement: !1, i18n: e }, P(U2, { name: "clickToPayCookiesCheckbox", onInput: v, label: e.get("ctp.otp.saveCookiesCheckbox.label"), checked: o, "aria-describedby": "adyen-ctp-cookies-info" })), P("p", { className: "adyen-checkout-ctp__otp-checkbox-info" }, f ? P(ra, null, P("span", { id: "adyen-ctp-cookies-info" }, e.get("ctp.otp.saveCookiesCheckbox.shorterInfo"), " "), P("button", { className: "adyen-checkout-ctp__otp-readmore-button", onClick: function() {
    return m(!1);
  } }, e.get("readMore"), "..")) : P("span", { id: "adyen-ctp-cookies-info" }, e.get("ctp.otp.saveCookiesCheckbox.information"))));
}
var zKe = function(e) {
  var t = e.onDisplayCardComponent, n = wt().i18n, r = Rc(), a = r.finishIdentityValidation, o = r.otpMaskedContact, s = r.otpNetwork, c = r.isCtpPrimaryPaymentMethod, u = Je(null), f = ze(u, 2), m = f[0], v = f[1], y = Je(!1), b = ze(y, 2), S = b[0], x = b[1], E = Je(!1), N = ze(E, 2), R = N[0], O = N[1], D = Je(null), $ = ze(D, 2), B = $[0], G = $[1], Z = Je(null), K = ze(Z, 2), q = K[0], pe = K[1], he = Je(!1), _e = ze(he, 2), ge = _e[0], Y = _e[1], ee = Kt(function(ye) {
    pe(ye);
  }, []), oe = Kt(function(ye) {
    var ce = ye.data, se = ye.isValid;
    v(ce.otp), x(se);
  }, []), me = Kt(function() {
    G(null);
  }, []), xe = Kt(On(yt.mark(function ye() {
    return yt.wrap(function(ce) {
      for (; ; ) switch (ce.prev = ce.next) {
        case 0:
          if (G(null), S) {
            ce.next = 4;
            break;
          }
          return q.validateInput(), ce.abrupt("return");
        case 4:
          return O(!0), ce.prev = 5, ce.next = 8, a(m);
        case 8:
          ce.next = 15;
          break;
        case 10:
          ce.prev = 10, ce.t0 = ce.catch(5), G(ce.t0 === null || ce.t0 === void 0 ? void 0 : ce.t0.reason), O(!1), (ce.t0 === null || ce.t0 === void 0 ? void 0 : ce.t0.reason) === "ACCT_INACCESSIBLE" && (Y(!0), t == null || t());
        case 15:
        case "end":
          return ce.stop();
      }
    }, ye, null, [[5, 10]]);
  })), [m, S, q, t]), X = n.get("ctp.otp.subtitle").split("%@");
  return P(ra, null, P(Hp.Title, { endAdornment: P(jie, null) }, n.get("ctp.otp.title")), P(Hp.Text, null, X[0], " ", s, " ", X[1], P("span", { className: "adyen-checkout-ctp__otp-subtitle--highlighted" }, o), X[2]), P(LKe, { hideResendOtpButton: ge, onChange: oe, onSetInputHandlers: ee, disabled: R, errorMessage: B && n.get("ctp.errors.".concat(B)), onPressEnter: xe, onResendCode: me, isValidatingOtp: R }), P(GKe, null), P(pu, { disabled: ge, label: n.get("continue"), variant: c ? "primary" : "secondary", onClick: xe, status: R && "loading" }));
}, HKe = function(e) {
  var t = e.card, n = e.errorMessage, r = wt().i18n, a = oa(), o = t.artUri || a()(t.scheme);
  return P(ra, null, P("div", { className: "adyen-checkout-ctp__card-list-single-card" }, P(ps, { src: o, height: 24, className: "adyen-checkout-ctp__card-image" }), P("span", { className: Tt({ "adyen-checkout-ctp__card-list-single-card-expired": t.isExpired }) }, t.title, " ", "•••• ".concat(t.panLastFour)), t.isExpired && P("span", { className: "adyen-checkout-ctp__expired-label" }, r.get("ctp.cards.expiredCard"))), n && P("div", { className: "adyen-checkout__error-text" }, n));
}, L8 = function() {
  return window.matchMedia("(max-width: 768px)").matches && /Android|iPhone|iPod/.test(navigator.userAgent);
}, WKe = ["srcDigitalCardId"], ZKe = function(e) {
  var t = e.cardSelected, n = e.cards, r = e.errorMessage, a = e.onChangeCard, o = wt().i18n, s = oa(), c = Rc().status, u = gs({ schema: WKe, defaultData: { srcDigitalCardId: t.srcDigitalCardId } }), f = u.handleChangeFor, m = u.data, v = Qi(function() {
    return It(n).call(n, function(y) {
      var b;
      return { icon: y.artUri || s()(y.scheme), name: je(b = "".concat(L8() ? "" : y.title, " •••• ")).call(b, y.panLastFour, " "), secondaryText: y.isExpired && o.get("ctp.cards.expiredCard"), id: y.srcDigitalCardId, disabled: y.isExpired };
    });
  }, [n]);
  return Rt(function() {
    var y = m.srcDigitalCardId, b = Ji(n).call(n, function(S) {
      return S.srcDigitalCardId === y;
    });
    a(b);
  }, [m, a]), P(xn, { name: "clickToPayCards", errorMessage: r }, P(Ad, { items: v, selectedValue: m.srcDigitalCardId, name: "cards", filterable: !1, className: "adyen-checkout-ctp__cards-list-dropdown", readonly: c === "loading", onChange: f("srcDigitalCardId") }));
};
function aY(e, t) {
  if (!e) return null;
  var n = t.get("ctp.errors.".concat(e));
  return jt(n).call(n, "ctp.errors") ? t.get("ctp.errors.UNKNOWN_ERROR") : n;
}
function YKe(e, t, n) {
  return n ? L8() ? null : e.get("payButton.with", { values: { value: Poe(e, t), maskedData: "•••• ".concat(n == null ? void 0 : n.panLastFour) } }) : e.get("payButton");
}
var XKe = function(e) {
  var t = e.onDisplayCardComponent, n = wt().i18n, r = oa(), a = Rc(), o = a.amount, s = a.cards, c = a.checkout, u = a.isCtpPrimaryPaymentMethod, f = a.status, m = a.onSubmit, v = a.onSetStatus, y = a.onError, b = Je(Ji(s).call(s, function(ge) {
    return !ge.isExpired;
  }) || s[0]), S = ze(b, 2), x = S[0], E = S[1], N = Je(null), R = ze(N, 2), O = R[0], D = R[1], $ = $m(s).call(s, function(ge) {
    return ge.isExpired;
  }), B = Je(!1), G = ze(B, 2), Z = G[0], K = G[1];
  Rt(function() {
    (s.length === 0 || $) && (t == null || t());
  }, [t, $, s]);
  var q = Kt(On(yt.mark(function ge() {
    var Y, ee, oe;
    return yt.wrap(function(me) {
      for (; ; ) switch (me.prev = me.next) {
        case 0:
          if (x) {
            me.next = 2;
            break;
          }
          return me.abrupt("return");
        case 2:
          return me.prev = 2, K(!0), D(null), v("loading"), me.next = 8, c(x);
        case 8:
          Y = me.sent, m(Y), me.next = 17;
          break;
        case 12:
          me.prev = 12, me.t0 = me.catch(2), me.t0 instanceof Vs && (D(me.t0 === null || me.t0 === void 0 ? void 0 : me.t0.reason), console.warn(je(ee = je(oe = "CtP - Checkout: Reason: ".concat(me.t0 === null || me.t0 === void 0 ? void 0 : me.t0.reason, " / Source: ")).call(oe, me.t0 === null || me.t0 === void 0 ? void 0 : me.t0.source, " / Scheme: ")).call(ee, me.t0 === null || me.t0 === void 0 ? void 0 : me.t0.scheme))), K(!1), y(me.t0);
        case 17:
        case "end":
          return me.stop();
      }
    }, ge, null, [[2, 12]]);
  })), [c, x]), pe = Kt(function(ge) {
    E(ge);
  }, []), he = Z && f === "loading" && (x == null ? void 0 : x.isDcfPopupEmbedded), _e = f !== "loading" || !he;
  return P(ra, null, P(eC, { name: Rie, height: "380", width: "100%", classNameModifiers: [he ? "" : "hidden"] }), _e && P(ra, null, P(Hp.Title, null, n.get("ctp.cards.title")), P(Hp.Text, null, n.get("ctp.cards.subtitle")), s.length === 0 && P("div", { className: "adyen-checkout-ctp__empty-cards" }, n.get("ctp.emptyProfile.message")), s.length === 1 && P(HKe, { card: s[0], errorMessage: aY(O, n) }), s.length > 1 && P(ZKe, { cardSelected: x, cards: s, onChangeCard: pe, errorMessage: aY(O, n) }), P(ev, { disabled: $, amount: o, label: YKe(n, o, x), status: f, variant: u ? "primary" : "secondary", icon: s.length !== 0 && r({ imageFolder: "components/" })(u ? "lock" : "lock_black"), onClick: q })));
}, KKe = function() {
  var e = wt().i18n;
  return P(ra, null, P("div", { className: "adyen-checkout-ctp__card-animation" }, P("div", { className: "adyen-checkout-ctp__card-animation-layer" }), P("div", { className: "adyen-checkout-ctp__card-animation-layer" }), P("div", { className: "adyen-checkout-ctp__card-animation-layer" })), P("div", { className: "adyen-checkout-ctp__loading-subtitle" }, e.get("ctp.loading.intro")));
}, qKe = { shopperLogin: { validate: function(e) {
  return !!e && e.length > 0;
}, errorMessage: "", modes: ["blur"] }, default: { validate: function(e) {
  return !!e && e.length > 0;
}, errorMessage: "", modes: ["blur"] } }, JKe = function(e) {
  var t = wt().i18n, n = gs({ schema: ["shopperLogin"], rules: qKe }), r = n.handleChangeFor, a = n.data, o = n.triggerValidation, s = n.valid, c = n.errors, u = n.isValid, f = _n({ validateInput: null }), m = Je(!1), v = ze(m, 2), y = v[0], b = v[1], S = Kt(function() {
    b(!0), o();
  }, [o]);
  Rt(function() {
    a.shopperLogin && b(!0);
  }, [a.shopperLogin]), Rt(function() {
    f.current.validateInput = S, e.onSetInputHandlers(f.current);
  }, [S, e.onSetInputHandlers]);
  var x = Kt(function(N) {
    N.key === "Enter" && e.onPressEnter();
  }, [e.onPressEnter]), E = Kt(function(N) {
    N.key === "Enter" && N.preventDefault();
  }, []);
  return Rt(function() {
    e.onChange({ data: a, valid: s, errors: c, isValid: u });
  }, [a, s, c]), P(xn, { name: "shopperLogin", label: t.get("ctp.login.inputLabel"), errorMessage: y ? e.errorMessage || !!c.shopperLogin : null, classNameModifiers: ["shopperLogin"] }, P(rC, { name: "shopperLogin", autocorrect: "off", spellcheck: !1, value: a.shopperLogin, disabled: e.disabled, onInput: r("shopperLogin", "input"), onBlur: r("shopperLogin", "blur"), onKeyPress: E, onKeyUp: x }));
}, QKe = function() {
  var e = wt().i18n, t = Rc(), n = t.isCtpPrimaryPaymentMethod, r = t.setIsCtpPrimaryPaymentMethod, a = t.verifyIfShopperIsEnrolled, o = t.startIdentityValidation, s = Je(null), c = ze(s, 2), u = c[0], f = c[1], m = Je(!1), v = ze(m, 2), y = v[0], b = v[1], S = Je(null), x = ze(S, 2), E = x[0], N = x[1], R = Je(!1), O = ze(R, 2), D = O[0], $ = O[1], B = Je(null), G = ze(B, 2), Z = G[0], K = G[1], q = Kt(function(_e) {
    K(_e);
  }, []), pe = Kt(function(_e) {
    var ge, Y = _e.data, ee = _e.isValid;
    f(Y.shopperLogin), b(ee), (Y == null || (ge = Y.shopperLogin) === null || ge === void 0 ? void 0 : ge.length) > 0 && r(!0);
  }, []), he = Kt(On(yt.mark(function _e() {
    var ge;
    return yt.wrap(function(Y) {
      for (; ; ) switch (Y.prev = Y.next) {
        case 0:
          if (N(null), y) {
            Y.next = 4;
            break;
          }
          return Z.validateInput(), Y.abrupt("return");
        case 4:
          return $(!0), Y.prev = 5, Y.next = 8, a({ shopperEmail: u });
        case 8:
          if (ge = Y.sent, !ge.isEnrolled) {
            Y.next = 15;
            break;
          }
          return Y.next = 13, o();
        case 13:
          Y.next = 17;
          break;
        case 15:
          N("NOT_FOUND"), $(!1);
        case 17:
          Y.next = 25;
          break;
        case 19:
          Y.prev = 19, Y.t0 = Y.catch(5), Y.t0 instanceof Vs && console.warn("CtP - Login error: ".concat(Y.t0.toString())), Y.t0 instanceof Ay && console.warn(Y.t0.toString()), N(Y.t0 === null || Y.t0 === void 0 ? void 0 : Y.t0.reason), $(!1);
        case 25:
        case "end":
          return Y.stop();
      }
    }, _e, null, [[5, 19]]);
  })), [a, o, u, y, Z]);
  return P(ra, null, P(Hp.Title, { endAdornment: P(jie, null) }, e.get("ctp.login.title")), P(Hp.Text, null, e.get("ctp.login.subtitle")), P(JKe, { onChange: pe, onSetInputHandlers: q, disabled: D, errorMessage: E && e.get("ctp.errors.".concat(E)), onPressEnter: he }), P(pu, { label: e.get("continue"), variant: n ? "primary" : "secondary", status: D && "loading", onClick: function() {
    he();
  } }));
}, kO = function(e) {
  var t, n = e.onDisplayCardComponent, r = Rc(), a = r.ctpState, o = r.onReady, s = r.startIdentityValidation, c = r.logoutShopper;
  return Rt(function() {
    var u;
    jt(u = [Tr.OneTimePassword, Tr.Login, Tr.Ready]).call(u, a) && o();
  }, [a, o]), Rt(function() {
    function u() {
      return u = On(yt.mark(function f() {
        return yt.wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              return m.prev = 0, m.next = 3, s();
            case 3:
              m.next = 10;
              break;
            case 5:
              return m.prev = 5, m.t0 = m.catch(0), m.t0 instanceof Vs && console.warn("CtP - Identity Validation error: ".concat(m.t0.toString())), m.next = 10, c();
            case 10:
            case "end":
              return m.stop();
          }
        }, f, null, [[0, 5]]);
      })), u.apply(this, arguments);
    }
    a === Tr.ShopperIdentified && function() {
      u.apply(this, arguments);
    }();
  }, [a]), a === Tr.NotAvailable ? null : P(Hp, null, jt(t = [Tr.Loading, Tr.ShopperIdentified]).call(t, a) && P(KKe, null), a === Tr.OneTimePassword && P(zKe, { onDisplayCardComponent: n }), a === Tr.Ready && P(XKe, { onDisplayCardComponent: n }), a === Tr.Login && P(QKe, null));
}, eqe = function(e) {
  var t = e.children, n = wt().i18n, r = Je(null), a = ze(r, 2), o = a[0], s = a[1], c = Rc(), u = c.ctpState, f = c.isCtpPrimaryPaymentMethod, m = c.setIsCtpPrimaryPaymentMethod, v = c.status, y = o === null && f === null;
  Rt(function() {
    if (y) {
      if (u === Tr.ShopperIdentified || u === Tr.Ready) return s(!1), void m(!0);
      u === Tr.NotAvailable && (s(!0), m(!1));
    }
  }, [u, y]);
  var b = Kt(function() {
    s(!0), m(!1);
  }, []);
  return u === Tr.NotAvailable ? t() : u === Tr.Loading || u === Tr.ShopperIdentified ? P(kO, null) : P(ra, null, P(kO, { onDisplayCardComponent: b }), P(z2, { classNames: ["adyen-checkout-ctp__separator"], label: n.get("ctp.separatorText") }), o ? t(!f) : P(pu, { variant: "secondary", disabled: v === "loading", label: n.get("ctp.manualCardEntry"), onClick: b }));
}, tqe = ["amount", "configuration", "clickToPayService", "setClickToPayRef", "onSetStatus", "onSubmit", "onError", "isStandaloneComponent"], nqe = function(e) {
  var t = e.amount, n = e.configuration, r = e.clickToPayService, a = e.setClickToPayRef, o = e.onSetStatus, s = e.onSubmit, c = e.onError, u = e.isStandaloneComponent, f = pa(e, tqe);
  return P(Lie, { isStandaloneComponent: u, configuration: n, amount: t, clickToPayService: r, setClickToPayRef: a, onSetStatus: o, onSubmit: s, onError: c }, P(eqe, null, f.children));
};
function oY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function cs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = oY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = oY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function rqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Ol = function(e) {
  ft(n, Dr);
  var t = rqe(n);
  function n(r) {
    var a, o;
    return Qe(this, n), a = t.call(this, r), T(Se(a), "clickToPayService", void 0), T(Se(a), "clickToPayRef", null), T(Se(a), "setClickToPayRef", function(s) {
      a.clickToPayRef = s;
    }), T(Se(a), "onBrand", function(s) {
      a.eventEmitter.emit("brand", cs(cs({}, s), {}, { brand: s.brand === "card" ? null : s.brand })), a.props.onBrand && a.props.onBrand(s);
    }), T(Se(a), "handleClickToPaySubmit", function(s) {
      a.setState({ data: cs({}, s), valid: {}, errors: {}, isValid: !0 }), a.submit();
    }), T(Se(a), "onConfigSuccess", function(s) {
      var c, u;
      a.submitAnalytics({ type: lO }), (c = (u = a.props).onConfigSuccess) === null || c === void 0 || c.call(u, s);
    }), T(Se(a), "onFocus", function(s) {
      var c, u, f, m;
      a.submitAnalytics({ type: BM, target: o7(s.fieldType) }), jt(xm).call(xm, s.fieldType) ? (c = (u = a.props).onFocus) === null || c === void 0 || c.call(u, s.event) : (f = (m = a.props).onFocus) === null || f === void 0 || f.call(m, s);
    }), T(Se(a), "onBlur", function(s) {
      var c, u, f, m;
      a.submitAnalytics({ type: VM, target: o7(s.fieldType) }), jt(xm).call(xm, s.fieldType) ? (c = (u = a.props).onBlur) === null || c === void 0 || c.call(u, s.event) : (f = (m = a.props).onBlur) === null || f === void 0 || f.call(m, s);
    }), T(Se(a), "onErrorAnalytics", function(s) {
      a.submitAnalytics({ type: sO, target: o7(s.fieldType), validationErrorCode: s.errorCode, validationErrorMessage: zZe(s.errorCode, hi) });
    }), T(Se(a), "onBinValue", Pie(Se(a))), T(Se(a), "payButton", function(s) {
      var c, u, f = ((c = a.props.amount) === null || c === void 0 ? void 0 : c.value) === 0, m = ((u = a.props.storedPaymentMethodId) === null || u === void 0 ? void 0 : u.length) > 0;
      return P(ev, kt({}, s, { amount: a.props.amount, secondaryAmount: a.props.secondaryAmount, label: f && !m ? a.props.i18n.get("payButton.saveDetails") : "", onClick: a.submit }));
    }), r._disableClickToPay || (a.clickToPayService = Mie(a.props.configuration, a.props.clickToPayConfiguration, a.props.environment), (o = a.clickToPayService) === null || o === void 0 || o.initialize()), a;
  }
  return et(n, [{ key: "setStatus", value: function(r, a) {
    var o, s;
    return (o = this.componentRef) !== null && o !== void 0 && o.setStatus && this.componentRef.setStatus(r, a), (s = this.clickToPayRef) !== null && s !== void 0 && s.setStatus && this.clickToPayRef.setStatus(r, a), this;
  } }, { key: "formatProps", value: function(r) {
    var a, o, s, c, u, f, m, v, y, b, S, x, E, N, R, O = (a = (o = r.session) === null || o === void 0 || (o = o.configuration) === null || o === void 0 ? void 0 : o.enableStoreDetails) !== null && a !== void 0 ? a : r.enableStoreDetails, D = ((s = r.amount) === null || s === void 0 ? void 0 : s.value) !== 0 && O;
    return cs(cs({}, r), {}, { holderNameRequired: !!r.hasHolderName && r.holderNameRequired, hasCVC: !(r.brand && r.brand === "bcmc" || r.hideCVC), billingAddressRequired: !r.storedPaymentMethodId && r.billingAddressRequired, type: r.type === "scheme" ? "card" : r.type, countryCode: r.countryCode ? r.countryCode.toLowerCase() : null, configuration: cs(cs({}, r.configuration), {}, { socialSecurityNumberMode: (c = (u = r.configuration) === null || u === void 0 ? void 0 : u.socialSecurityNumberMode) !== null && c !== void 0 ? c : "auto" }), brandsConfiguration: r.brandsConfiguration || ((f = r.configuration) === null || f === void 0 ? void 0 : f.brandsConfiguration) || {}, icon: r.icon || ((m = r.configuration) === null || m === void 0 ? void 0 : m.icon), installmentOptions: ((v = r.session) === null || v === void 0 || (v = v.configuration) === null || v === void 0 ? void 0 : v.installmentOptions) || r.installmentOptions, enableStoreDetails: O, showStoreDetailsCheckbox: D, clickToPayConfiguration: cs(cs({}, r.clickToPayConfiguration), {}, { disableOtpAutoFocus: ((y = r.clickToPayConfiguration) === null || y === void 0 ? void 0 : y.disableOtpAutoFocus) || !1, shopperEmail: ((b = r.clickToPayConfiguration) === null || b === void 0 ? void 0 : b.shopperEmail) || (r == null || (S = r._parentInstance) === null || S === void 0 || (S = S.options) === null || S === void 0 || (S = S.session) === null || S === void 0 ? void 0 : S.shopperEmail), telephoneNumber: ((x = r.clickToPayConfiguration) === null || x === void 0 ? void 0 : x.telephoneNumber) || (r == null || (E = r._parentInstance) === null || E === void 0 || (E = E.options) === null || E === void 0 || (E = E.session) === null || E === void 0 ? void 0 : E.telephoneNumber), locale: ((N = r.clickToPayConfiguration) === null || N === void 0 ? void 0 : N.locale) || ((R = r.i18n) === null || R === void 0 || (R = R.locale) === null || R === void 0 ? void 0 : R.replace("-", "_")) }) });
  } }, { key: "formatData", value: function() {
    var r, a = this.state.selectedBrandValue || this.props.brand;
    return cs(cs(cs(cs(cs({ paymentMethod: cs(cs(cs(cs({ type: n.type }, this.state.data), this.props.storedPaymentMethodId && { storedPaymentMethodId: this.props.storedPaymentMethodId }), a && { brand: a }), this.props.fundingSource && { fundingSource: this.props.fundingSource }) }, this.state.billingAddress && { billingAddress: this.state.billingAddress }), this.state.socialSecurityNumber && { socialSecurityNumber: this.state.socialSecurityNumber }), this.storePaymentMethodPayload), (((r = this.state.installments) == null ? void 0 : r.plan) === "revolving" || (r == null ? void 0 : r.value) > 1) && { installments: this.state.installments }), {}, { browserInfo: this.browserInfo, origin: !!window && window.location.origin });
  } }, { key: "updateStyles", value: function(r) {
    var a;
    return (a = this.componentRef) !== null && a !== void 0 && a.updateStyles && this.componentRef.updateStyles(r), this;
  } }, { key: "setFocusOn", value: function(r) {
    var a;
    return (a = this.componentRef) !== null && a !== void 0 && a.setFocusOn && this.componentRef.setFocusOn(r), this;
  } }, { key: "processBinLookupResponse", value: function(r) {
    var a, o = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    return (a = this.componentRef) !== null && a !== void 0 && a.processBinLookupResponse && this.componentRef.processBinLookupResponse(r, o), this;
  } }, { key: "handleUnsupportedCard", value: function(r) {
    var a;
    return (a = this.componentRef) !== null && a !== void 0 && a.handleUnsupportedCard && this.componentRef.handleUnsupportedCard(r), this;
  } }, { key: "onBinLookup", value: function(r) {
    if (!r.isReset) {
      var a = Cie("supportedBrandsRaw").from(r);
      this.props.onBinLookup(a);
    }
  } }, { key: "submitAnalytics", value: function(r) {
    var a = r.type;
    a !== e1 && a !== lO || this.constructor.type === "scheme" && Ir(this.props, "supportedShopperInteractions") && (r.isStoredPaymentMethod = !0, r.brand = this.props.brand), Nn(fe(n.prototype), "submitAnalytics", this).call(this, r);
  } }, { key: "storePaymentMethodPayload", get: function() {
    var r, a;
    return ((r = this.props.storedPaymentMethodId) === null || r === void 0 ? void 0 : r.length) > 0 ? {} : ((a = this.props.amount) === null || a === void 0 ? void 0 : a.value) === 0 ? this.props.enableStoreDetails ? { storePaymentMethod: !0 } : {} : this.props.showStoreDetailsCheckbox && this.state.storePaymentMethod !== void 0 ? { storePaymentMethod: !!this.state.storePaymentMethod } : {};
  } }, { key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "icon", get: function() {
    var r;
    return (r = this.props.icon) !== null && r !== void 0 ? r : this.resources.getImage()(this.brand);
  } }, { key: "brands", get: function() {
    var r = this, a = this.props, o = a.brands, s = a.brandsConfiguration;
    return o ? It(o).call(o, function(c) {
      var u, f;
      return { icon: (u = (f = s[c]) === null || f === void 0 ? void 0 : f.icon) !== null && u !== void 0 ? u : r.props.modules.resources.getImage()(c), name: c };
    }) : [];
  } }, { key: "brand", get: function() {
    return this.props.brand || this.props.type;
  } }, { key: "displayName", get: function() {
    return this.props.storedPaymentMethodId ? "•••• ".concat(this.props.lastFour) : this.props.name || n.type;
  } }, { key: "accessibleName", get: function() {
    return (this.props.name || n.type) + (this.props.storedPaymentMethodId ? " " + this.props.i18n.get("creditCard.storedCard.description.ariaLabel").replace("%@", this.props.lastFour) : "");
  } }, { key: "browserInfo", get: function() {
    return nv();
  } }, { key: "renderCardInput", value: function() {
    var r = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return P(Aie, kt({ setComponentRef: this.setComponentRef }, this.props, this.state, { onChange: this.setState, onSubmit: this.submit, payButton: this.payButton, onBrand: this.onBrand, onBinValue: this.onBinValue, brand: this.brand, brandsIcons: this.brands, isPayButtonPrimaryVariant: r, resources: this.resources, onFocus: this.onFocus, onBlur: this.onBlur, onErrorAnalytics: this.onErrorAnalytics, onConfigSuccess: this.onConfigSuccess }));
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(eh, { srPanel: this.props.modules.srPanel }, P(nqe, { amount: this.props.amount, configuration: this.props.clickToPayConfiguration, clickToPayService: this.clickToPayService, isStandaloneComponent: !1, setClickToPayRef: this.setClickToPayRef, onSetStatus: this.setElementStatus, onSubmit: this.handleClickToPaySubmit, onError: this.handleError }, function(a) {
      return r.renderCardInput(a);
    })));
  } }]), n;
}();
T(Ol, "type", "scheme"), T(Ol, "defaultProps", { onBinLookup: function() {
}, showBrandsUnderCardNumber: !0, showFormInstruction: !0, _disableClickToPay: !1 });
var ax = function(e) {
  return e.CustomerDismissed = "CUSTOMER_DISMISSED", e.CustomerRequestApproved = "CUSTOMER_REQUEST_APPROVED", e.CustomerRequestDeclined = "CUSTOMER_REQUEST_DECLINED", e.CustomerRequestFailed = "CUSTOMER_REQUEST_FAILED", e;
}({});
function iY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ox(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = iY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = iY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function aqe(e) {
  var t = e.enableStoreDetails, n = e.cashAppService, r = e.onClick, a = e.onChangeStoreDetails, o = e.onAuthorize, s = e.onError, c = _n(null), u = Je("loading"), f = ze(u, 2), m = f[0], v = f[1], y = _n([]), b = Je(!1), S = ze(b, 2), x = S[0], E = S[1];
  this.setStatus = v;
  var N = Kt(On(yt.mark(function R() {
    return yt.wrap(function(O) {
      for (; ; ) switch (O.prev = O.next) {
        case 0:
          return O.prev = 0, O.next = 3, n.initialize();
        case 3:
          return y.current = [n.subscribeToEvent(ax.CustomerDismissed, function() {
            s(new _r("CANCEL", "Customer dismissed the modal"));
          }), n.subscribeToEvent(ax.CustomerRequestDeclined, On(yt.mark(function D() {
            return yt.wrap(function($) {
              for (; ; ) switch ($.prev = $.next) {
                case 0:
                  return s(new _r("ERROR", "Payment declined by CashAppPay")), $.next = 3, n.restart();
                case 3:
                  return $.next = 5, n.renderButton(c.current);
                case 5:
                case "end":
                  return $.stop();
              }
            }, D);
          }))), n.subscribeToEvent(ax.CustomerRequestApproved, function(D) {
            var $, B, G = D.customerProfile, Z = D.grants, K = ox(ox(ox(ox({}, (G == null ? void 0 : G.id) && { customerId: G.id }), (G == null ? void 0 : G.cashtag) && { cashTag: G.cashtag }), (Z == null || ($ = Z.payment) === null || $ === void 0 ? void 0 : $.grantId) && { grantId: Z.payment.grantId }), (Z == null || (B = Z.onFile) === null || B === void 0 ? void 0 : B.grantId) && { onFileGrantId: Z.onFile.grantId });
            o(K);
          }), n.subscribeToEvent(ax.CustomerRequestFailed, function() {
            s(new _r("ERROR", "Customer request failed"));
          })], O.next = 6, n.renderButton(c.current);
        case 6:
          v("ready"), O.next = 12;
          break;
        case 9:
          O.prev = 9, O.t0 = O.catch(0), s(O.t0);
        case 12:
        case "end":
          return O.stop();
      }
    }, R, null, [[0, 9]]);
  })), [n, s, o]);
  return Rt(function() {
    t && (n.setStorePaymentMethod(x), a(x));
  }, [t, x]), Rt(function() {
    return N(), function() {
      var R;
      n.restart(), Q(R = y.current).call(R, function(O) {
        return O();
      });
    };
  }, [n, N]), P("div", { className: "adyen-checkout__cashapp" }, m === "loading" && P(ju, null), m !== "loading" && t && P(mD, { storeDetails: x, onChange: E }), P("div", { onClick: r, className: "adyen-checkout__cashapp-button", ref: c }));
}
function sY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function aN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = sY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = sY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var oqe = function() {
  function e(o, s) {
    Qe(this, e), T(this, "sdkLoader", void 0), T(this, "configuration", void 0), T(this, "pay", void 0), T(this, "startAuthorization", void 0), this.configuration = s, this.sdkLoader = o, s.clientId || console.warn("CashAppService: clientId is missing");
  }
  var t, n, r, a;
  return et(e, [{ key: "hasOneTimePayment", get: function() {
    var o = this.configuration.amount;
    return (o == null ? void 0 : o.value) > 0;
  } }, { key: "hasOnFilePayment", get: function() {
    return this.configuration.storePaymentMethod;
  } }, { key: "setStorePaymentMethod", value: function(o) {
    this.configuration.storePaymentMethod = o;
  } }, { key: "initialize", value: (a = On(yt.mark(function o() {
    var s, c, u, f;
    return yt.wrap(function(m) {
      for (; ; ) switch (m.prev = m.next) {
        case 0:
          return m.prev = 0, s = this.configuration, c = s.environment, u = s.clientId, m.next = 4, this.sdkLoader.load(c);
        case 4:
          return f = m.sent, m.next = 7, f.pay({ clientId: u });
        case 7:
          this.pay = m.sent, m.next = 13;
          break;
        case 10:
          throw m.prev = 10, m.t0 = m.catch(0), new _r("ERROR", "Error during initialization", { cause: m.t0 });
        case 13:
        case "end":
          return m.stop();
      }
    }, o, this, [[0, 10]]);
  })), function() {
    return a.apply(this, arguments);
  }) }, { key: "renderButton", value: (r = On(yt.mark(function o(s) {
    var c, u, f, m, v;
    return yt.wrap(function(y) {
      for (; ; ) switch (y.prev = y.next) {
        case 0:
          return y.prev = 0, c = this.configuration, u = c.button, f = c.useCashAppButtonUi, y.next = 4, this.pay.render(s, { manage: !1, button: !!f && aN({ width: "full", shape: "semiround" }, u) });
        case 4:
          m = y.sent, v = m.begin, this.startAuthorization = v, y.next = 12;
          break;
        case 9:
          throw y.prev = 9, y.t0 = y.catch(0), new _r("ERROR", "Error rendering CashAppPay button", { cause: y.t0 });
        case 12:
        case "end":
          return y.stop();
      }
    }, o, this, [[0, 9]]);
  })), function(o) {
    return r.apply(this, arguments);
  }) }, { key: "begin", value: function() {
    this.startAuthorization ? this.startAuthorization() : console.warn("CashAppService - begin() not available");
  } }, { key: "subscribeToEvent", value: function(o, s) {
    var c = this;
    return this.pay.addEventListener(o, s), function() {
      c.pay.removeEventListener(o, s);
    };
  } }, { key: "createCustomerRequest", value: (n = On(yt.mark(function o() {
    var s, c, u, f, m, v, y;
    return yt.wrap(function(b) {
      for (; ; ) switch (b.prev = b.next) {
        case 0:
          return b.prev = 0, s = this.configuration, c = s.referenceId, u = s.amount, f = s.scopeId, m = s.redirectURL, v = m === void 0 ? window.location.href : m, y = { referenceId: c, redirectURL: v, actions: aN(aN({}, this.hasOneTimePayment && { payment: { amount: u, scopeId: f } }), this.hasOnFilePayment && { onFile: { scopeId: f } }) }, b.next = 5, this.pay.customerRequest(y);
        case 5:
          b.next = 10;
          break;
        case 7:
          throw b.prev = 7, b.t0 = b.catch(0), new _r("ERROR", "Something went wrong during customerRequest creation", { cause: b.t0 });
        case 10:
        case "end":
          return b.stop();
      }
    }, o, this, [[0, 7]]);
  })), function() {
    return n.apply(this, arguments);
  }) }, { key: "restart", value: (t = On(yt.mark(function o() {
    return yt.wrap(function(s) {
      for (; ; ) switch (s.prev = s.next) {
        case 0:
          return s.next = 2, this.pay.restart();
        case 2:
        case "end":
          return s.stop();
      }
    }, o, this);
  })), function() {
    return t.apply(this, arguments);
  }) }]), e;
}(), iqe = function() {
  function e() {
    Qe(this, e);
  }
  var t;
  return et(e, [{ key: "isSdkIsAvailableOnWindow", value: function() {
    return !!window.CashApp;
  } }, { key: "load", value: (t = On(yt.mark(function n(r) {
    var a, o, s;
    return yt.wrap(function(c) {
      for (; ; ) switch (c.prev = c.next) {
        case 0:
          if (o = jt(a = r.toLowerCase()).call(a, "live") ? "https://kit.cash.app/v1/pay.js" : "https://sandbox.kit.cash.app/v1/pay.js", this.isSdkIsAvailableOnWindow()) {
            c.next = 5;
            break;
          }
          return s = new G2(o), c.next = 5, s.load();
        case 5:
          return c.abrupt("return", window.CashApp);
        case 6:
        case "end":
          return c.stop();
      }
    }, n, this);
  })), function(n) {
    return t.apply(this, arguments);
  }) }]), e;
}();
function lY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = lY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = lY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function sqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var AO = function(e) {
  ft(n, Dr);
  var t = sqe(n);
  function n(r) {
    var a, o, s, c, u;
    return Qe(this, n), u = t.call(this, r), T(Se(u), "cashAppService", void 0), T(Se(u), "submit", function() {
      var f = u.props, m = f.onClick;
      if (f.storedPaymentMethodId) Nn((s = Se(u), fe(n.prototype)), "submit", s).call(s);
      else {
        var v = !1;
        new Yt(function(y, b) {
          return m({ resolve: y, reject: b });
        }).catch(function() {
          throw v = !0, Error("onClick rejected");
        }).then(function() {
          return u.cashAppService.createCustomerRequest();
        }).then(function() {
          u.cashAppService.begin();
        }).catch(function(y) {
          v || u.handleError(y);
        });
      }
    }), T(Se(u), "handleOnChangeStoreDetails", function(f) {
      var m = vf(vf({}, u.state.data), {}, { shopperWantsToStore: f });
      u.setState({ data: m });
    }), T(Se(u), "handleAuthorize", function(f) {
      var m = vf(vf({}, u.state.data), f);
      u.setState({ data: m, valid: {}, errors: {}, isValid: !0 }), Nn((c = Se(u), fe(n.prototype)), "submit", c).call(c);
    }), u.props.enableStoreDetails && u.props.storePaymentMethod && console.warn("CashAppPay: enableStoreDetails AND storePaymentMethod configuration properties should not be used together. That can lead to undesired behavior."), u.props.storedPaymentMethodId ? ct(u) : (u.cashAppService = new oqe(new iqe(), { storePaymentMethod: u.props.storePaymentMethod, useCashAppButtonUi: u.props.showPayButton, environment: u.props.environment, amount: u.props.amount, redirectURL: u.props.redirectURL, clientId: (a = u.props.configuration) === null || a === void 0 ? void 0 : a.clientId, scopeId: (o = u.props.configuration) === null || o === void 0 ? void 0 : o.scopeId, button: u.props.button, referenceId: u.props.referenceId }), u);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    var a;
    return vf(vf({}, r), {}, { enableStoreDetails: ((a = r.session) === null || a === void 0 || (a = a.configuration) === null || a === void 0 ? void 0 : a.enableStoreDetails) || r.enableStoreDetails });
  } }, { key: "formatData", value: function() {
    var r = this.state.data || {}, a = r.shopperWantsToStore, o = r.grantId, s = r.onFileGrantId, c = r.cashTag, u = r.customerId, f = this.props, m = f.storePaymentMethod, v = f.storedPaymentMethodId, y = this.props.enableStoreDetails || !this.props.session && m;
    if (v) return { paymentMethod: { type: n.type, storedPaymentMethodId: v } };
    var b = s && c;
    return vf({ paymentMethod: vf(vf(vf({ type: n.type }, o && { grantId: o }), u && { customerId: u }), b && { onFileGrantId: s, cashtag: c }) }, y && { storePaymentMethod: m || a });
  } }, { key: "displayName", get: function() {
    return this.props.storedPaymentMethodId && this.props.cashtag ? this.props.cashtag : this.props.name;
  } }, { key: "additionalInfo", get: function() {
    return this.props.storedPaymentMethodId ? "Cash App Pay" : "";
  } }, { key: "isValid", get: function() {
    return !0;
  } }, { key: "render", value: function() {
    var r, a = this;
    return P(hr, { i18n: this.props.i18n, resources: this.resources, loadingContext: this.props.loadingContext }, this.props.storedPaymentMethodId ? P(Lf, { showPayButton: this.props.showPayButton, label: HM(this.props.i18n, this.props.amount), icon: (r = this.resources) === null || r === void 0 ? void 0 : r.getImage({ imageFolder: "components/" })("lock"), name: this.displayName, amount: this.props.amount, payButton: this.payButton, onSubmit: this.submit, ref: function(o) {
      a.componentRef = o;
    } }) : P(aqe, { ref: function(o) {
      a.componentRef = o;
    }, enableStoreDetails: this.props.enableStoreDetails, cashAppService: this.cashAppService, onChangeStoreDetails: this.handleOnChangeStoreDetails, onError: this.handleError, onClick: this.submit, onAuthorize: this.handleAuthorize }));
  } }]), n;
}();
function uY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = uY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = uY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function lqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(AO, "type", "cashapp"), T(AO, "defaultProps", { onClick: function(e) {
  e.resolve();
}, showPayButton: !0, enableStoreDetails: !1, storePaymentMethod: !1 });
var Fie = function(e) {
  ft(r, Dr);
  var t, n = lqe(r);
  function r(a) {
    var o, s;
    return Qe(this, r), s = n.call(this, a), T(Se(s), "clickToPayService", void 0), T(Se(s), "ctpConfiguration", void 0), T(Se(s), "handleClickToPaySubmit", function(c) {
      s.setState({ data: fm({}, c), valid: {}, errors: {}, isValid: !0 }), s.submit();
    }), s.ctpConfiguration = { shopperEmail: s.props.shopperEmail, telephoneNumber: s.props.telephoneNumber, merchantDisplayName: s.props.merchantDisplayName, locale: s.props.locale, onReady: s.props.onReady, onTimeout: s.props.onTimeout }, s.clickToPayService = Mie(s.props.configuration, s.ctpConfiguration, s.props.environment), (o = s.clickToPayService) === null || o === void 0 || o.initialize().catch(function(c) {
      s.handleError(new _r("ERROR", c.toString(), { cause: c }));
    }), s.clickToPayService || console.warn("ClickToPay not initialized - Likely the payment method is not configured or its configuration is missing"), s;
  }
  return et(r, [{ key: "isValid", get: function() {
    return !0;
  } }, { key: "browserInfo", get: function() {
    return nv();
  } }, { key: "formatData", value: function() {
    var a, o = this.state.data, s = o.srcScheme, c = o.srcCorrelationId, u = o.srcTokenReference, f = o.srcCheckoutPayload, m = o.srcDigitalCardId;
    return { paymentMethod: fm(fm(fm(fm(fm({ type: r.type }, s && { srcScheme: s }), c && { srcCorrelationId: c }), u && { srcTokenReference: u }), f && { srcCheckoutPayload: f }), m && { srcDigitalCardId: m }), browserInfo: this.browserInfo, origin: (a = window) === null || a === void 0 || (a = a.location) === null || a === void 0 ? void 0 : a.origin };
  } }, { key: "formatProps", value: function(a) {
    var o, s, c;
    return fm(fm({}, a), {}, { disableOtpAutoFocus: a.disableOtpAutoFocus || !1, shopperEmail: a.shopperEmail || (a == null || (o = a._parentInstance) === null || o === void 0 || (o = o.options) === null || o === void 0 || (o = o.session) === null || o === void 0 ? void 0 : o.shopperEmail), telephoneNumber: a.telephoneNumber || (a == null || (s = a._parentInstance) === null || s === void 0 || (s = s.options) === null || s === void 0 || (s = s.session) === null || s === void 0 ? void 0 : s.telephoneNumber), locale: a.locale || ((c = a.i18n) === null || c === void 0 || (c = c.locale) === null || c === void 0 ? void 0 : c.replace("-", "_")) });
  } }, { key: "isAvailable", value: (t = On(yt.mark(function a() {
    var o = this;
    return yt.wrap(function(s) {
      for (; ; ) switch (s.prev = s.next) {
        case 0:
          if (this.clickToPayService) {
            s.next = 2;
            break;
          }
          return s.abrupt("return", Yt.reject());
        case 2:
          if (!this.clickToPayService.shopperAccountFound) {
            s.next = 4;
            break;
          }
          return s.abrupt("return", Yt.resolve());
        case 4:
          return s.abrupt("return", new Yt(function(c, u) {
            o.clickToPayService.subscribeOnStateChange(function(f) {
              o.clickToPayService.shopperAccountFound && c(), f !== Tr.NotAvailable && f !== Tr.Login && f !== Tr.Idle || u();
            });
          }));
        case 5:
        case "end":
          return s.stop();
      }
    }, a, this);
  })), function() {
    return t.apply(this, arguments);
  }) }, { key: "render", value: function() {
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(Lie, { isStandaloneComponent: !0, configuration: this.ctpConfiguration, amount: this.props.amount, clickToPayService: this.clickToPayService, setClickToPayRef: this.setComponentRef, onSetStatus: this.setElementStatus, onSubmit: this.handleClickToPaySubmit, onError: this.handleError }, P(kO, null)));
  } }]), r;
}();
function cY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function c6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = cY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = cY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function uqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(Fie, "type", "clicktopay");
var PO = function(e) {
  ft(n, Ol);
  var t = uqe(n);
  function n(r) {
    var a;
    return Qe(this, n), a = t.call(this, r), T(Se(a), "onBrand", function(o) {
      a.props.onBrand && a.props.onBrand(o);
    }), a;
  }
  return et(n, [{ key: "formatData", value: function() {
    var r = Nn(fe(n.prototype), "formatData", this).call(this);
    return r.paymentMethod.type = this.constructor.type, r;
  } }, { key: "formatProps", value: function(r) {
    return c6(c6({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { type: "bcmc", cvcPolicy: v_ });
  } }]), n;
}();
function dY(e) {
  var t = e.description, n = t === void 0 ? "" : t, r = e.name, a = r === void 0 ? "" : r, o = e.logoUrl, s = o === void 0 ? "" : o, c = e.url, u = c === void 0 ? "" : c, f = e.backgroundUrl, m = f === void 0 ? "" : f, v = "linear-gradient(0, #000, #0003), url(".concat(m, ")");
  return P("div", { className: "adyen-checkout__campaign-container" }, P(ps, { className: "adyen-checkout__campaign-background-image", style: { backgroundImage: v }, backgroundUrl: m }), P("div", { className: "adyen-checkout__campaign-content" }, s && P("img", { src: s, className: "adyen-checkout__campaign-logo", alt: a }), a && P("div", { className: "adyen-checkout__campaign-title" }, a), n && P("div", { className: "adyen-checkout__campaign-description" }, n, u && " ›")));
}
function cqe(e) {
  var t = e.url;
  return P("div", { className: "adyen-checkout__campaign" }, !t && P(dY, e), t && P("a", { href: t, className: "adyen-checkout__campaign-link", target: "_blank", rel: "noopener noreferrer" }, P(dY, e)));
}
T(PO, "type", "bcmc"), T(PO, "defaultProps", c6(c6({}, Ol.defaultProps), {}, { brands: ["bcmc", "maestro", "visa"] }));
var dqe = function(e) {
  var t = e.options, n = t === void 0 ? [] : t, r = e.name, a = e.onChange;
  return P("div", { className: "adyen-checkout__button-group" }, It(n).call(n, function(o, s) {
    var c, u = o.label, f = o.selected, m = o.value, v = o.disabled;
    return P("label", { key: je(c = "".concat(r)).call(c, s), className: Tt({ "adyen-checkout__button": !0, "adyen-checkout__button--selected": f, "adyen-checkout__button--disabled": v }) }, P("input", { type: "radio", className: "adyen-checkout__button-group__input", value: m, checked: f, onChange: a, disabled: v }), P("span", { className: "adyen-checkout__button-text" }, u));
  }));
};
function fY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function pY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = fY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = fY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Bie(e) {
  var t, n = e.amounts, r = e.onCancel, a = e.onDonate, o = e.showCancelButton, s = o === void 0 || o, c = e.disclaimerMessage, u = wt().i18n, f = oa(), m = n.currency, v = Je("ready"), y = ze(v, 2), b = y[0], S = y[1], x = Je(!1), E = ze(x, 2), N = E[0], R = E[1], O = Je({ currency: m, value: null }), D = ze(O, 2), $ = D[0], B = D[1];
  this.setStatus = function(Z) {
    S(Z);
  };
  var G = Kt(function(Z, K) {
    return u.amount(Z, K);
  }, [u]);
  return Rt(function() {
    e.onChange({ data: { amount: $ }, isValid: N });
  }, [$, N]), b === "error" ? P("div", { className: "adyen-checkout__adyen-giving" }, P(ps, { className: "adyen-checkout__status__icon adyen-checkout__status__icon--error", src: f({ imageFolder: "components/" })("error"), alt: u.get("error.message.unknown") }), P("div", { className: "adyen-checkout__status__text" }, u.get("error.message.unknown"))) : b === "success" ? P("div", { className: "adyen-checkout__adyen-giving" }, P(ps, { className: "adyen-checkout__status__icon adyen-checkout__status__icon--success", src: f({ imageFolder: "components/" })("heart"), alt: u.get("thanksForYourSupport") }), P("div", { className: "adyen-checkout__status__text" }, u.get("thanksForYourSupport"))) : P("div", { className: "adyen-checkout__adyen-giving" }, P(cqe, e), P("div", { className: "adyen-checkout__adyen-giving-actions" }, P("div", { className: "adyen-checkout__amounts" }, P(dqe, { options: It(t = gd(n)).call(t, function(Z) {
    return { value: Z, label: G(Z, m), disabled: b === "loading", selected: Z === $.value };
  }), name: "amount", onChange: function(Z) {
    var K = Z.target, q = Ou(K.value, 10);
    R(!0), B(function(pe) {
      return pY(pY({}, pe), {}, { value: q });
    });
  } })), c && P(D8, { message: c.message.replace("%{linkText}", "%#".concat(c.linkText, "%#")), urls: [c.link] }), P(pu, { classNameModifiers: ["donate"], onClick: function() {
    S("loading"), a({ data: { amount: $ } });
  }, label: u.get("donateButton"), disabled: !$.value, status: b }), s && P(pu, { classNameModifiers: ["decline"], variant: "ghost", onClick: function() {
    S("loading"), r({ data: { amount: $ }, isValid: N });
  }, disabled: b === "loading", label: "".concat(u.get("notNowButton"), " ›") })));
}
Bie.defaultProps = { onCancel: function() {
}, onChange: function() {
}, onDonate: function() {
}, amounts: {}, showCancelButton: !0 };
var fqe = ["bannerUrl", "nonprofitDescription", "nonprofitName", "nonprofitUrl", "termsAndConditionsUrl"];
function hY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ix(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = hY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = hY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function pqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var NO = function(e) {
  ft(n, Dr);
  var t = pqe(n);
  function n(r) {
    var a, o;
    return Qe(this, n), o = t.call(this, r), T(Se(o), "handleRef", function(s) {
      o.componentRef = s;
    }), o.donate = pn(a = o.donate).call(a, Se(o)), o;
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    if (this.isNewDonation(r)) {
      var a = r, o = a.bannerUrl, s = a.nonprofitDescription, c = a.nonprofitName, u = a.nonprofitUrl, f = a.termsAndConditionsUrl;
      return ix(ix({}, pa(a, fqe)), {}, { backgroundUrl: o, description: s, name: c, url: u, disclaimerMessage: { message: "By donating you agree to the %{linkText} ", linkText: "terms and conditions", link: f } });
    }
    return r;
  } }, { key: "isNewDonation", value: function(r) {
    var a;
    return A8(a = Pe(r)).call(a, function(o) {
      return jt(o).call(o, "nonprofit") && r[o];
    });
  } }, { key: "data", get: function() {
    return this.state.data;
  } }, { key: "isValid", get: function() {
    return this.state.isValid;
  } }, { key: "setState", value: function(r) {
    this.state = ix(ix({}, this.state), r);
  } }, { key: "donate", value: function() {
    var r = this.data, a = this.isValid;
    this.props.onDonate({ data: r, isValid: a }, this);
  } }, { key: "render", value: function() {
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(Bie, kt({}, this.props, { ref: this.handleRef, onChange: this.setState, onDonate: this.donate })));
  } }]), n;
}();
T(NO, "type", "donation"), T(NO, "defaultProps", { onCancel: function() {
}, onDonate: function() {
} });
var mY = function() {
  try {
    if (window.parent.location.href) return window.location !== window.parent.location;
  } catch (e) {
    return !1;
  }
};
function vY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var gY, Vie = function(e) {
  ft(n, yo);
  var t = hqe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "postForm", void 0), a;
  }
  return et(n, [{ key: "componentDidMount", value: function() {
    var r = this, a = new Yt(function(o, s) {
      return r.props.beforeRedirect(o, s, function(c) {
        for (var u = 1; u < arguments.length; u++) {
          var f, m, v = arguments[u] != null ? arguments[u] : {};
          u % 2 ? Q(f = vY(Object(v), !0)).call(f, function(y) {
            T(c, y, v[y]);
          }) : ne ? Ze(c, ne(v)) : Q(m = vY(Object(v))).call(m, function(y) {
            We(c, y, re(v, y));
          });
        }
        return c;
      }({ url: r.props.url, method: r.props.method }, r.props.data ? { data: r.props.data } : {}));
    });
    a.then(function() {
      var o, s;
      r.postForm ? r.postForm.submit() : r.props.redirectFromTopWhenInIframe && mY() ? (o = (s = window.top.location).assign) === null || o === void 0 || o.call(s, r.props.url) : window.location.assign(r.props.url);
    }).catch(function() {
    });
  } }, { key: "render", value: function(r) {
    var a, o = this, s = r.url, c = r.method, u = r.data, f = u === void 0 ? {} : u;
    return c === "POST" ? P("form", kt({ method: "post", action: s, style: { display: "none" }, ref: function(m) {
      o.postForm = m;
    } }, this.props.redirectFromTopWhenInIframe && mY() && { target: "_top" }), It(a = Pe(f)).call(a, function(m) {
      return P("input", { type: "hidden", name: m, key: m, value: f[m] });
    })) : null;
  } }]), n;
}();
function yY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = yY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = yY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function mqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(Vie, "defaultProps", { beforeRedirect: function(e) {
  return e();
}, method: "GET" });
var Mm = function(e) {
  ft(n, Dr);
  var t = mqe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return bY(bY({}, r), {}, { showButton: !!r.showPayButton });
  } }, { key: "formatData", value: function() {
    return { paymentMethod: { type: this.props.type }, browserInfo: this.browserInfo };
  } }, { key: "isValid", get: function() {
    return !0;
  } }, { key: "browserInfo", get: function() {
    return nv();
  } }, { key: "render", value: function() {
    var r = this;
    return this.props.url && this.props.method ? P(Vie, this.props) : this.props.showButton ? P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(Lf, kt({}, this.props, { onSubmit: this.submit, payButton: this.payButton, ref: function(a) {
      r.componentRef = a;
    } }))) : null;
  } }]), n;
}();
function _Y(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function CY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = _Y(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = _Y(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function vqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
gY = Mm, T(Mm, "type", "redirect"), T(Mm, "defaultProps", { type: gY.type, showPayButton: !0 });
var Uie = function(e) {
  ft(n, Mm);
  var t = vqe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    var a;
    return CY(CY({}, r), {}, { showPayButton: (a = r.showButton) !== null && a !== void 0 ? a : r.showPayButton });
  } }, { key: "displayName", get: function() {
    return this.props.name || this.constructor.type;
  } }, { key: "render", value: function() {
    var r = this;
    return this.props.showPayButton ? P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(Lf, kt({}, this.props, { name: this.displayName, onSubmit: this.submit, payButton: this.payButton, ref: function(a) {
      r.componentRef = a;
    } }))) : null;
  } }]), n;
}();
T(Uie, "type", "giropay");
var Gie = 2, zie = 0, gqe = "adyen", yqe = "https://pay.google.com/gp/p/js/pay.js", bqe = ["amount", "countryCode", "totalPriceStatus"], _qe = ["configuration"];
function wY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function TO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = wY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = wY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Cqe(e) {
  var t = e.amount, n = e.countryCode, r = n === void 0 ? "US" : n, a = e.totalPriceStatus, o = a === void 0 ? "FINAL" : a, s = pa(e, bqe), c = String(P8(t.value, t.currency));
  return TO({ countryCode: r, currencyCode: t.currency, totalPrice: c, totalPriceStatus: o }, s.transactionInfo);
}
function SY(e) {
  var t = e.configuration, n = pa(e, _qe);
  return { apiVersion: Gie, apiVersionMinor: zie, transactionInfo: Cqe(n), merchantInfo: TO(TO({ merchantId: t.merchantId, merchantName: t.merchantName }, t.merchantOrigin ? { merchantOrigin: t.merchantOrigin } : {}), t.authJwt ? { authJwt: t.authJwt } : {}), allowedPaymentMethods: [{ type: "CARD", tokenizationSpecification: { type: "PAYMENT_GATEWAY", parameters: { gateway: gqe, gatewayMerchantId: t.gatewayMerchantId } }, parameters: { allowedAuthMethods: n.allowedAuthMethods, allowedCardNetworks: n.allowedCardNetworks, assuranceDetailsRequired: n.assuranceDetailsRequired, allowPrepaidCards: n.allowPrepaidCards, allowCreditCards: n.allowCreditCards, billingAddressRequired: n.billingAddressRequired, billingAddressParameters: n.billingAddressParameters } }], emailRequired: n.emailRequired, shippingAddressRequired: n.shippingAddressRequired, shippingAddressParameters: n.shippingAddressParameters, shippingOptionRequired: n.shippingOptionRequired, shippingOptionParameters: n.shippingOptionParameters, callbackIntents: n.callbackIntents };
}
var xY = ["en", "ar", "bg", "ca", "cs", "da", "de", "el", "es", "et", "fi", "fr", "hr", "id", "it", "ja", "ko", "ms", "nl", "no", "pl", "pt", "ru", "sk", "sl", "sr", "sv", "th", "tr", "uk", "zh"], wqe = function() {
  function e(n) {
    Qe(this, e), T(this, "paymentsClient", void 0);
    var r = function() {
      switch ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "TEST").toLowerCase()) {
        case "production":
        case "live":
        case "live-au":
        case "live-apse":
        case "live-us":
        case "live-in":
          return "PRODUCTION";
        default:
          return "TEST";
      }
    }(n.environment);
    this.paymentsClient = this.getGooglePaymentsClient({ environment: r, paymentDataCallbacks: n.paymentDataCallbacks });
  }
  var t;
  return et(e, [{ key: "getGooglePaymentsClient", value: (t = On(yt.mark(function n(r) {
    var a, o;
    return yt.wrap(function(s) {
      for (; ; ) switch (s.prev = s.next) {
        case 0:
          if ((a = window.google) !== null && a !== void 0 && a.payments) {
            s.next = 4;
            break;
          }
          return o = new G2(yqe), s.next = 4, o.load();
        case 4:
          return s.abrupt("return", new google.payments.api.PaymentsClient(r));
        case 5:
        case "end":
          return s.stop();
      }
    }, n);
  })), function(n) {
    return t.apply(this, arguments);
  }) }, { key: "isReadyToPay", value: function(n) {
    return this.paymentsClient ? this.paymentsClient.then(function(r) {
      return r.isReadyToPay((o = (a = n).allowedAuthMethods, s = a.allowedCardNetworks, c = a.existingPaymentMethodRequired, { apiVersion: Gie, apiVersionMinor: zie, allowedPaymentMethods: [{ type: "CARD", parameters: { allowedAuthMethods: o, allowedCardNetworks: s }, tokenizationSpecification: { type: "PAYMENT_GATEWAY", parameters: {} } }], existingPaymentMethodRequired: c !== void 0 && c }));
      var a, o, s, c;
    }) : Yt.reject(new Error("Google Pay is not available"));
  } }, { key: "prefetchPaymentData", value: function(n) {
    if (!this.paymentsClient) throw new Error("Google Pay is not available");
    var r = SY(n);
    this.paymentsClient.then(function(a) {
      return a.prefetchPaymentData(r);
    });
  } }, { key: "initiatePayment", value: function(n) {
    if (!this.paymentsClient) throw new Error("Google Pay is not available");
    var r = SY(n);
    return this.paymentsClient.then(function(a) {
      return a.loadPaymentData(r);
    });
  } }]), e;
}();
function Sqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Hie = function(e) {
  ft(n, yo);
  var t = Sqe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "paywithgoogleWrapper", void 0), T(Se(a), "clicked", !1), T(Se(a), "handleClick", function(u) {
      u.preventDefault(), u.stopPropagation(), a.clicked || (a.props.onClick(u), a.clicked = !0, Ro(function() {
        a.clicked = !1;
      }, 300));
    }), a;
  }
  return et(n, [{ key: "componentDidMount", value: function() {
    var r = this, a = this.props, o = a.buttonColor, s = a.buttonType, c = a.buttonLocale, u = a.buttonSizeMode, f = a.buttonRootNode;
    a.paymentsClient.then(function(m) {
      return m.createButton({ onClick: r.handleClick, buttonType: s, buttonColor: o, buttonLocale: c, buttonSizeMode: u, buttonRootNode: f });
    }).then(function(m) {
      r.paywithgoogleWrapper.appendChild(m);
    });
  } }, { key: "render", value: function() {
    var r = this;
    return P("span", { className: "adyen-checkout__paywithgoogle", ref: function(a) {
      r.paywithgoogleWrapper = a;
    } });
  } }]), n;
}();
T(Hie, "defaultProps", { buttonColor: "default", buttonType: "long", buttonSizeMode: "static" });
var xqe = { environment: "TEST", isExpress: !1, existingPaymentMethodRequired: !1, buttonColor: "default", buttonType: "long", buttonSizeMode: void 0, showPayButton: !0, configuration: { gatewayMerchantId: "", merchantId: "", merchantName: "" }, amount: { value: 0, currency: "USD" }, countryCode: "US", totalPriceStatus: "FINAL", onAuthorized: function(e) {
  return e;
}, onClick: function(e) {
  return e();
}, allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"], allowedCardNetworks: ["AMEX", "DISCOVER", "JCB", "MASTERCARD", "VISA"], allowCreditCards: !0, allowPrepaidCards: !0, billingAddressRequired: !1, billingAddressParameters: void 0, assuranceDetailsRequired: !1, emailRequired: !1, shippingAddressRequired: !1, shippingAddressParameters: void 0, shippingOptionRequired: !1, shippingOptionParameters: void 0, paymentMethods: [] };
function EY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = EY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = EY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Eqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var d6 = function(e) {
  ft(n, Dr);
  var t = Eqe(n);
  function n() {
    var r, a, o;
    Qe(this, n);
    for (var s = arguments.length, c = new Array(s), u = 0; u < s; u++) c[u] = arguments[u];
    return o = t.call.apply(t, je(r = [this]).call(r, c)), T(Se(o), "googlePay", new wqe(o.props)), T(Se(o), "submit", function() {
      o.props.isInstantPayment && o.submitAnalytics({ type: N8, target: Coe });
      var f = o.props.onAuthorized, m = f === void 0 ? function() {
      } : f;
      return new Yt(function(v, y) {
        return o.props.onClick(v, y);
      }).then(function() {
        return o.googlePay.initiatePayment(o.props);
      }).then(function(v) {
        return o.setState({ googlePayToken: v.paymentMethodData.tokenizationData.token, googlePayCardNetwork: v.paymentMethodData.info.cardNetwork }), Nn((a = Se(o), fe(n.prototype)), "submit", a).call(a), m(v);
      }).catch(function(v) {
        v.statusCode === "CANCELED" ? o.handleError(new _r("CANCEL", v.toString(), { cause: v })) : o.handleError(new _r("ERROR", v.toString(), { cause: v }));
      });
    }), T(Se(o), "isAvailable", function() {
      return o.isReadyToPay().then(function(f) {
        if (!f.result) throw new Error("Google Pay is not available");
        if (f.paymentMethodPresent === !1) throw new Error("Google Pay - No paymentMethodPresent");
        return !0;
      }).catch(function() {
        return !1;
      });
    }), T(Se(o), "isReadyToPay", function() {
      return o.googlePay.isReadyToPay(o.props);
    }), T(Se(o), "prefetch", function() {
      return o.googlePay.prefetchPaymentData(o.props);
    }), o;
  }
  return et(n, [{ key: "submitAnalytics", value: function(r) {
    Nn(fe(n.prototype), "submitAnalytics", this).call(this, sx({}, r), this.props);
  } }, { key: "formatProps", value: function(r) {
    var a, o, s, c, u, f, m = (a = r.brands) !== null && a !== void 0 && a.length ? (u = r.brands, f = { mc: "MASTERCARD", amex: "AMEX", visa: "VISA", interac: "INTERAC", discover: "DISCOVER" }, rr(u).call(u, function(b, S) {
      return f[S] && !jt(b).call(b, f[S]) && b.push(f[S]), b;
    }, [])) : r.allowedCardNetworks, v = (o = r.buttonSizeMode) !== null && o !== void 0 ? o : r.isDropin ? "fill" : "static", y = function() {
      var b = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "").toLowerCase().substring(0, 2);
      return jt(xY).call(xY, b) ? b : null;
    }((s = r.buttonLocale) !== null && s !== void 0 ? s : (c = r.i18n) === null || c === void 0 ? void 0 : c.locale);
    return sx(sx({}, r), {}, { showButton: r.showPayButton === !0, configuration: r.configuration, allowedCardNetworks: m, buttonSizeMode: v, buttonLocale: y });
  } }, { key: "formatData", value: function() {
    var r;
    return { paymentMethod: sx({ type: (r = this.props.type) !== null && r !== void 0 ? r : n.type }, this.state), browserInfo: this.browserInfo, origin: !!window && window.location.origin };
  } }, { key: "isValid", get: function() {
    return !!this.state.googlePayToken;
  } }, { key: "browserInfo", get: function() {
    return nv();
  } }, { key: "icon", get: function() {
    var r;
    return (r = this.props.icon) !== null && r !== void 0 ? r : this.resources.getImage()("googlepay");
  } }, { key: "render", value: function() {
    return this.props.showPayButton ? P(Hie, { buttonColor: this.props.buttonColor, buttonType: this.props.buttonType, buttonSizeMode: this.props.buttonSizeMode, buttonLocale: this.props.buttonLocale, buttonRootNode: this.props.buttonRootNode, paymentsClient: this.googlePay.paymentsClient, onClick: this.submit }) : null;
  } }]), n;
}();
function Iqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(d6, "type", "paywithgoogle"), T(d6, "defaultProps", xqe);
var Wie = function(e) {
  ft(n, ys);
  var t = Iqe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n);
}();
T(Wie, "type", "entercash");
var kqe = { telephoneNumber: [{ validate: function(e) {
  return !!e && e.length <= 11;
}, errorMessage: "voucher.econtext.telephoneNumber.invalid", modes: ["input", "blur"] }, { validate: function(e) {
  return !!e && Woe.test(e) && (e.length === 10 || e.length === 11);
}, errorMessage: "voucher.econtext.telephoneNumber.invalid", modes: ["blur"] }] }, Aqe = ["personalDetailsRequired", "data", "onChange", "showPayButton", "payButton"];
function Pqe(e) {
  var t, n = e.personalDetailsRequired, r = n === void 0 || n, a = e.data, o = e.onChange, s = e.showPayButton, c = e.payButton, u = pa(e, Aqe), f = _n(null), m = wt().i18n, v = Je("ready"), y = ze(v, 2), b = y[0], S = y[1], x = _n({});
  Pe(x.current).length || (t = u.setComponentRef) === null || t === void 0 || t.call(u, x.current), x.current.showValidation = function() {
    var N;
    (N = f.current) === null || N === void 0 || N.showValidation();
  }, x.current.setStatus = S;
  var E = r && u.showFormInstruction;
  return P("div", { className: "adyen-checkout__econtext-input__field" }, E && P(Qp, null), r && P(aC, { data: a, requiredFields: ["firstName", "lastName", "telephoneNumber", "shopperEmail"], onChange: o, namePrefix: "econtext", setComponentRef: function(N) {
    f.current = N;
  }, validationRules: kqe }), s && c({ status: b, label: m.get("confirmPurchase") }));
}
function Zie(e) {
  var t, n, r = (t = e, (n = document.createElement("textArea")).readOnly = !0, n.value = t, document.body.appendChild(n), n);
  if (window.navigator.userAgent.match(/ipad|iphone/i)) {
    var a = document.createRange();
    a.selectNodeContents(r);
    var o = window.getSelection();
    o.removeAllRanges(), o.addRange(a), r.setSelectionRange(0, 999999);
  } else r.select();
  document.execCommand("copy"), document.body.removeChild(r);
}
var Nqe = ["voucherDetails", "className"];
function av(e) {
  var t, n = e.voucherDetails, r = n === void 0 ? [] : n, a = e.className, o = a === void 0 ? "" : a, s = pa(e, Nqe), c = wt().i18n, u = oa();
  return P("div", { className: Tt("adyen-checkout__voucher-result", "adyen-checkout__voucher-result--".concat(s.paymentMethodType), o) }, P("div", { className: "adyen-checkout__voucher-result__top" }, P("div", { className: "adyen-checkout__voucher-result__image" }, !!s.imageUrl && P("span", { className: "adyen-checkout__voucher-result__image__wrapper" }, P("img", { alt: s.paymentMethodType, className: "adyen-checkout__voucher-result__image__brand", src: s.imageUrl })), !!s.issuerImageUrl && P("span", { className: "adyen-checkout__voucher-result__image__wrapper" }, P("img", { alt: s.paymentMethodType, className: "adyen-checkout__voucher-result__image__issuer", src: s.issuerImageUrl }))), P("div", { className: "adyen-checkout__voucher-result__introduction" }, s.introduction, " ", s.instructionsUrl && P("a", { className: "adyen-checkout__link adyen-checkout__link--voucher-result-instructions", href: s.instructionsUrl, target: "_blank", rel: "noopener noreferrer" }, c.get("voucher.readInstructions"), " ›")), s.amount && P("div", { className: "adyen-checkout__voucher-result__amount" }, s.amount, s.surcharge && P("span", { className: "adyen-checkout__voucher-result__surcharge" }, "(", c.get("voucher.surcharge").replace("%@", s.surcharge), ")"))), s.reference && P("div", { className: "adyen-checkout__voucher-result__separator" }, P("div", { className: "adyen-checkout__voucher-result__separator__inner" }), P("div", { className: "adyen-checkout__voucher-result__code__label" }, P("span", { className: "adyen-checkout__voucher-result__code__label__text" }, c.get("voucher.paymentReferenceLabel")))), P("div", { className: "adyen-checkout__voucher-result__bottom" }, s.reference && P("div", { className: "adyen-checkout__voucher-result__code" }, s.barcode && P("img", { alt: c.get("voucher.paymentReferenceLabel"), className: "adyen-checkout__voucher-result__code__barcode", src: s.barcode }), P("span", null, s.reference)), (!!s.downloadUrl || !!s.copyBtn) && P("ul", { className: "adyen-checkout__voucher-result__actions" }, !!s.copyBtn && P("li", { className: "adyen-checkout__voucher-result__actions__item" }, P(pu, { inline: !0, variant: "action", onClick: function(f, m) {
    var v = m.complete;
    Zie(s.reference), v();
  }, icon: u({ imageFolder: "components/" })("copy"), label: c.get("button.copy") })), !!s.downloadUrl && P("li", { className: "adyen-checkout__voucher-result__actions__item" }, P(pu, { inline: !0, variant: "action", href: s.downloadUrl, icon: u({ imageFolder: "components/" })("download"), label: s.downloadButtonText || c.get("button.download"), target: "_blank", rel: "noopener noreferrer" }))), P("ul", { className: "adyen-checkout__voucher-result__details" }, It(t = Oe(r).call(r, function(f) {
    var m = f.label, v = f.value;
    return !!m && !!v;
  })).call(t, function(f, m) {
    var v = f.label, y = f.value;
    return P("li", { key: m, className: "adyen-checkout__voucher-result__details__item" }, P("span", { className: "adyen-checkout__voucher-result__details__label" }, v), P("span", { className: "adyen-checkout__voucher-result__details__value" }, y));
  }))));
}
var Tqe = function(e) {
  var t = e.reference, n = e.totalAmount, r = e.expiresAt, a = e.paymentMethodType, o = e.maskedTelephoneNumber, s = e.instructionsUrl, c = e.collectionInstitutionNumber, u = wt().i18n, f = oa();
  return P(av, { paymentMethodType: a, reference: t, introduction: u.get("voucher.introduction.econtext"), imageUrl: f()(a), instructionsUrl: s, amount: n && u.amount(n.value, n.currency), voucherDetails: [{ label: u.get("voucher.collectionInstitutionNumber"), value: c }, { label: u.get("voucher.expirationDate"), value: u.dateTime(r) }, { label: u.get("voucher.telephoneNumber"), value: o }], copyBtn: !0 });
};
function IY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = IY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = IY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Oqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Fy = function(e) {
  ft(n, Dr);
  var t = Oqe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "isValid", get: function() {
    return !this.props.personalDetailsRequired || !!this.state.isValid;
  } }, { key: "formatData", value: function() {
    return kY(kY({}, this.state.data), {}, { paymentMethod: { type: this.props.type || n.type } });
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, this.props.reference ? P(Tqe, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props)) : P(Pqe, kt({ setComponentRef: this.setComponentRef }, this.props, { onChange: this.setState, onSubmit: this.submit, payButton: this.payButton })));
  } }]), n;
}();
T(Fy, "type", "econtext"), T(Fy, "defaultProps", { personalDetailsRequired: !0, showFormInstruction: !0 });
var cC = ["ES", "FR"];
function AY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function PY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = AY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = AY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Rqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Yie = function(e) {
  ft(n, gu);
  var t = Rqe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return PY(PY({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { allowedCountries: r.countryCode ? [r.countryCode] : cC });
  } }]), n;
}();
function NY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function TY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = NY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = NY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Mqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(Yie, "type", "facilypay_3x");
var Xie = function(e) {
  ft(n, gu);
  var t = Mqe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return TY(TY({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { allowedCountries: r.countryCode ? [r.countryCode] : cC });
  } }]), n;
}();
function OY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function RY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = OY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = OY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Dqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(Xie, "type", "facilypay_4x");
var Kie = function(e) {
  ft(n, gu);
  var t = Dqe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return RY(RY({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { allowedCountries: r.countryCode ? [r.countryCode] : cC });
  } }]), n;
}();
function MY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function DY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = MY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = MY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Lqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(Kie, "type", "facilypay_6x");
var qie = function(e) {
  ft(n, gu);
  var t = Lqe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return DY(DY({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { allowedCountries: r.countryCode ? [r.countryCode] : cC });
  } }]), n;
}();
function LY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $Y(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = LY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = LY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function $qe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(qie, "type", "facilypay_10x");
var Jie = function(e) {
  ft(n, gu);
  var t = $qe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return $Y($Y({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { allowedCountries: r.countryCode ? [r.countryCode] : cC });
  } }]), n;
}();
T(Jie, "type", "facilypay_12x");
var jY = ["black", "white"], FY = ["en_US", "en_AU", "en_GB", "fr_CA", "es_ES", "it_IT", "fr_FR", "de_DE", "pt_BR", "zh_CN", "da_DK", "zh_HK", "id_ID", "he_IL", "ja_JP", "ko_KR", "nl_NL", "no_NO", "pl_PL", "pt_PT", "ru_RU", "sv_SE", "th_TH", "zh_TW"];
function BY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = BY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = BY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var jqe = function(e) {
  var t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return e === "paypal" ? gm({}, n) : rr(t = Pe(n)).call(t, function(r, a) {
    var o = n[a];
    return (a !== "color" || jt(jY).call(jY, o)) && (r[a] = o), r;
  }, {});
}, Fqe = function(e) {
  var t = e.amount, n = e.countryCode, r = e.debug, a = e.environment, o = a === void 0 ? "" : a, s = e.locale, c = e.configuration, u = e.commit, f = e.vault, m = e.enableMessages, v = function(R) {
    var O = R ? R.replace("-", "_") : null;
    return jt(FY).call(FY, O) ? O : null;
  }(s), y = t ? t.currency : null, b = o.toLowerCase() === "test", S = b ? "AXy9hIzWB6h_LjZUHjHmsbsiicSIbL4GKOrcgomEedVjduUinIU4C2llxkW5p0OG0zTNgviYFceaXEnj" : "AU0Z-TP9t5_9196agaBN6ZD3UAwypdP1IX8ZYH3PcNNAQMXUTDQlChruXqQEhyI6-NKBKowN6ydkj477", x = c.merchantId, E = c.intent, N = "buttons,funding-eligibility".concat(m ? ",messages" : "");
  return gm(gm(gm(gm(gm(gm(gm({}, x && { "merchant-id": x }), v && { locale: v }), n && b && { "buyer-country": n }), r && b && { debug: r }), y && { currency: y }), E && { intent: E }), {}, { commit: u, vault: f, "client-id": S, "integration-date": "2020-02-01", "enable-funding": "paylater,venmo", components: N });
}, Bqe = ["onInit", "onApprove", "onClick", "onCancel", "onError", "onShippingChange", "onShippingAddressChange", "onShippingOptionsChange", "onSubmit", "isProcessingPayment", "paypalRef", "style"];
function VY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function by(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = VY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = VY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Vqe(e) {
  var t, n = e.onInit, r = e.onApprove, a = e.onClick, o = e.onCancel, s = e.onError, c = e.onShippingChange, u = e.onShippingAddressChange, f = e.onShippingOptionsChange, m = e.onSubmit, v = e.isProcessingPayment, y = e.paypalRef, b = e.style, S = pa(e, Bqe), x = wt().i18n, E = ((t = S.configuration) === null || t === void 0 ? void 0 : t.intent) === "tokenize", N = _n(null), R = _n(null), O = _n(null), D = _n(null), $ = function(G, Z) {
    var K = by(by(by(by(by(by({}, E && { createBillingAgreement: m }), !E && { createOrder: m }), !E && G !== "venmo" && c && { onShippingChange: c }), !E && G !== "venmo" && u && { onShippingAddressChange: u }), !E && G !== "venmo" && f && { onShippingOptionsChange: f }), {}, { fundingSource: G, style: jqe(G, b), onInit: n, onClick: a, onCancel: o, onError: s, onApprove: r }), q = y.Buttons(K);
    q.isEligible() && q.render(Z.current);
  };
  Rt(function() {
    c && u && console.warn('PayPal - "onShippingChange" and "onShippingAddressChange" are defined. It is recommended to only use "onShippingAddressChange", as "onShippingChange" is getting deprecated');
  }, [c, u]), Rt(function() {
    var G = y.FUNDING, Z = G.PAYPAL, K = G.CREDIT, q = G.PAYLATER, pe = G.VENMO;
    $(Z, N), S.blockPayPalCreditButton || $(K, R), S.blockPayPalPayLaterButton || $(q, O), S.blockPayPalVenmoButton || $(pe, D);
  }, []);
  var B = S.commit === !0;
  return P("div", { className: Tt("adyen-checkout__paypal__buttons", { "adyen-checkout__paypal-processing": v }) }, P("div", { className: "adyen-checkout__paypal__button adyen-checkout__paypal__button--paypal", ref: N }), P("div", { className: "adyen-checkout__paypal__button adyen-checkout__paypal__button--credit", ref: R }), P("div", { className: "adyen-checkout__paypal__button adyen-checkout__paypal__button--pay-later", ref: O }), P("div", { className: "adyen-checkout__paypal__button adyen-checkout__paypal__button--venmo", ref: D }), v && P("div", { className: "adyen-checkout__paypal" }, P("div", { className: "adyen-checkout__paypal__status adyen-checkout__paypal__status--processing" }, P(ju, { size: "medium", inline: !0 }), B && x.get("paypal.processingPayment"))));
}
var Uqe = ["onApprove", "onCancel", "onChange", "onError", "onSubmit"];
function UY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function GY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = UY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = UY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Gqe(e) {
  var t = e.onApprove, n = e.onCancel, r = e.onChange, a = e.onError, o = e.onSubmit, s = pa(e, Uqe), c = Je("pending"), u = ze(c, 2), f = u[0], m = u[1];
  this.setStatus = m;
  var v = Kt(function(b, S) {
    m("processing"), t(b, S);
  }, [t]), y = function() {
    m("ready");
  };
  return Rt(function() {
    var b = function(N) {
      var R, O, D = Fqe(N), $ = decodeURIComponent(It(R = Pe(D)).call(R, function(B) {
        var G;
        return je(G = "".concat(B, "=")).call(G, D[B]);
      }).join("&"));
      return je(O = "".concat("https://www.paypal.com/sdk/js", "?")).call(O, $);
    }(s), S = GY({}, s.cspNonce && { nonce: s.cspNonce }), x = GY({}, s.cspNonce && { cspNonce: s.cspNonce }), E = new G2(b, "body", S, x);
    return E.load().then(y), function() {
      E.remove();
    };
  }, []), P("div", { className: "adyen-checkout__paypal" }, f === "pending" ? P("div", { className: "adyen-checkout__paypal__status adyen-checkout__paypal__status--pending" }, P(ju, null)) : P(Vqe, kt({}, s, { onCancel: n, onChange: r, onError: a, onSubmit: o, onApprove: v, isProcessingPayment: f === "processing", paypalRef: window.paypal })));
}
var zqe = "No token was provided", Hqe = "Calling submit() is not supported for this payment method", zY = "The instance of the PayPal component being used is not the same which started the payment";
function HY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = HY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = HY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var WY = function(e) {
  var t = e.paypalAddressObject;
  if (!t) return null;
  var n = function() {
    var a, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return o && s ? je(a = "".concat(o, ", ")).call(a, s) : o || s || null;
  }(t.address_line_1, t.address_line_2), r = bc(bc(bc(bc(bc({}, n && { street: n }), t.admin_area_1 && { stateOrProvince: t.admin_area_1 }), t.admin_area_2 && { city: t.admin_area_2 }), t.postal_code && { postalCode: t.postal_code }), t.country_code && { country: t.country_code });
  return Pe(r).length > 0 ? r : null;
}, Wqe = ["onShippingAddressChange", "onShippingOptionsChange"];
function ZY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function oN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = ZY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = ZY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Zqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var i7 = function(e) {
  ft(n, Dr);
  var t = Zqe(n);
  function n(r) {
    var a, o, s, c;
    return Qe(this, n), c = t.call(this, r), T(Se(c), "paymentData", null), T(Se(c), "resolve", null), T(Se(c), "reject", null), T(Se(c), "submit", function() {
      c.handleError(new _r("IMPLEMENTATION_ERROR", Hqe));
    }), T(Se(c), "handleAction", function(u) {
      return c.updateWithAction(u);
    }), T(Se(c), "updateWithAction", function(u) {
      if (u.paymentMethodType !== c.type) throw new Error("Invalid Action");
      return u.paymentData && (c.paymentData = u.paymentData), u.sdkData && u.sdkData.token ? c.handleResolve(u.sdkData.token) : c.handleReject(zqe), null;
    }), T(Se(c), "handleCancel", function() {
      c.handleError(new _r("CANCEL"));
    }), T(Se(c), "handleOnApprove", function(u, f) {
      var m = c.props.onShopperDetails, v = { data: { details: u, paymentData: c.paymentData } };
      if (m) return f.order.get().then(function(y) {
        var b = function(S) {
          var x, E, N, R, O, D, $, B;
          if (!S) return null;
          var G = { firstName: S == null || (x = S.payer) === null || x === void 0 || (x = x.name) === null || x === void 0 ? void 0 : x.given_name, lastName: S == null || (E = S.payer) === null || E === void 0 || (E = E.name) === null || E === void 0 ? void 0 : E.surname }, Z = S == null || (N = S.payer) === null || N === void 0 ? void 0 : N.email_address, K = S == null || (R = S.payer) === null || R === void 0 || (R = R.address) === null || R === void 0 ? void 0 : R.country_code, q = S == null || (O = S.payer) === null || O === void 0 || (O = O.phone) === null || O === void 0 || (O = O.phone_number) === null || O === void 0 ? void 0 : O.national_number, pe = S == null || (D = S.payer) === null || D === void 0 ? void 0 : D.birth_date, he = WY({ paypalAddressObject: S == null || ($ = S.payer) === null || $ === void 0 ? void 0 : $.address }), _e = WY({ paypalAddressObject: S == null || (B = S.purchase_units) === null || B === void 0 || (B = B[0].shipping) === null || B === void 0 ? void 0 : B.address }), ge = bc(bc(bc(bc(bc(bc(bc({}, G.firstName && { shopperName: G }), Z && { shopperEmail: Z }), pe && { dateOfBirth: pe }), q && { telephoneNumber: q }), K && { countryCode: K }), he && { billingAddress: he }), _e && { shippingAddress: _e });
          return Pe(ge).length > 0 ? ge : null;
        }(y);
        return new Yt(function(S, x) {
          return m(b, y, { resolve: S, reject: x });
        });
      }).then(function() {
        return c.handleAdditionalDetails(v);
      }).catch(function(y) {
        return c.handleError(new _r("ERROR", "Something went wrong while parsing PayPal Order", { cause: y }));
      });
      c.handleAdditionalDetails(v);
    }), c.handleSubmit = pn(a = c.handleSubmit).call(a, Se(c)), c.handleOnShippingAddressChange = pn(o = c.handleOnShippingAddressChange).call(o, Se(c)), c.handleOnShippingOptionsChange = pn(s = c.handleOnShippingOptionsChange).call(s, Se(c)), c;
  }
  return et(n, [{ key: "submitAnalytics", value: function(r) {
    Nn(fe(n.prototype), "submitAnalytics", this).call(this, oN({}, r), this.props);
  } }, { key: "formatProps", value: function(r) {
    var a, o = r.configuration, s = o.merchantId, c = o.intent, u = ((a = r.amount) === null || a === void 0 ? void 0 : a.value) === 0 ? "tokenize" : r.intent || c, f = u === "tokenize" || r.vault, m = r.userAction === "continue";
    return oN(oN({}, r), {}, { commit: !m && r.commit, vault: f, configuration: { intent: u, merchantId: s } });
  } }, { key: "updatePaymentData", value: function(r) {
    r || console.warn("PayPal - Updating payment data with an invalid value"), this.paymentData = r;
  } }, { key: "formatData", value: function() {
    var r = this.props, a = r.isExpress, o = r.userAction;
    return { paymentMethod: { type: n.type, userAction: o, subtype: a ? "express" : n.subtype } };
  } }, { key: "isValid", get: function() {
    return !0;
  } }, { key: "handleResolve", value: function(r) {
    if (!this.resolve) return this.handleError(new _r("ERROR", zY));
    this.resolve(r);
  } }, { key: "handleReject", value: function(r) {
    if (!this.reject) return this.handleError(new _r("ERROR", zY));
    this.reject(new Error(r));
  } }, { key: "handleSubmit", value: function() {
    var r = this;
    return Nn(fe(n.prototype), "submit", this).call(this), new Yt(function(a, o) {
      r.resolve = a, r.reject = o;
    });
  } }, { key: "handleOnShippingAddressChange", value: function(r, a) {
    return this.props.onShippingAddressChange(r, a, this);
  } }, { key: "handleOnShippingOptionsChange", value: function(r, a) {
    return this.props.onShippingOptionsChange(r, a, this);
  } }, { key: "render", value: function() {
    var r = this;
    if (!this.props.showPayButton) return null;
    var a = this.props, o = a.onShippingAddressChange, s = a.onShippingOptionsChange, c = pa(a, Wqe);
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(Gqe, kt({ ref: function(u) {
      r.componentRef = u;
    } }, c, o && { onShippingAddressChange: this.handleOnShippingAddressChange }, s && { onShippingOptionsChange: this.handleOnShippingOptionsChange }, { onCancel: this.handleCancel, onChange: this.setState, onApprove: this.handleOnApprove, onError: function(u) {
      r.handleError(new _r("ERROR", u.toString(), { cause: u }));
    }, onSubmit: this.handleSubmit })));
  } }]), n;
}();
function YY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Yqe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = YY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = YY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Qie(e) {
  var t, n, r = wt().i18n, a = Je("ready"), o = ze(a, 2), s = o[0], c = o[1], u = !(e == null || (t = e.items) === null || t === void 0 || !t.length), f = gs({ schema: je(n = []).call(n, Pn(u ? ["phonePrefix"] : []), ["phoneNumber"]), defaultData: Yqe({}, u ? { phonePrefix: e.selected } : {}), rules: { phoneNumber: { modes: ["blur"], errorMessage: "error.va.gen.01", validate: function(E) {
    return (E == null ? void 0 : E.length) > 6;
  } } } }), m = f.handleChangeFor, v = f.triggerValidation, y = f.data, b = f.valid, S = f.errors, x = f.isValid;
  return Rt(function() {
    e.onChange({ data: y, valid: b, errors: S, isValid: x });
  }, [y, b, S, x]), this.showValidation = v, this.setStatus = c, P("div", { className: "adyen-checkout__phone-input" }, P(xn, { errorMessage: !!S.phoneNumber, label: r.get(e.phoneLabel), className: Tt({ "adyen-checkout__input--phone-number": !0 }), inputWrapperModifiers: ["phoneInput"], name: "" }, P("div", { className: "adyen-checkout__input-wrapper" }, P("div", { className: Tt({ "adyen-checkout__input": !0, "adyen-checkout__input--invalid": !!S.phoneNumber }) }, !!u && P(xn, { inputWrapperModifiers: ["phoneInput"], name: e.prefixName }, P(Ad, { className: "adyen-checkout__dropdown--small adyen-checkout__countryFlag", filterable: !1, items: e.items, name: e.prefixName, onChange: m("phonePrefix"), placeholder: r.get("infix"), selectedValue: y.phonePrefix }), P("div", { className: "adyen-checkout__phoneNumber" }, P("input", { type: "tel", name: e.phoneName, value: y.phoneNumber, onInput: m("phoneNumber", "input"), onBlur: m("phoneNumber", "blur"), placeholder: "123 456 789", className: "adyen-checkout__input adyen-checkout__input--phoneNumber", autoCorrect: "off" })))))), this.props.showPayButton && this.props.payButton({ status: s }));
}
function XY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function KY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = XY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = XY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
T(i7, "type", "paypal"), T(i7, "subtype", "sdk"), T(i7, "defaultProps", { environment: "TEST", status: "loading", showPayButton: !0, userAction: "pay", merchantId: "", cspNonce: null, intent: null, commit: !0, vault: !1, style: { height: 48 }, blockPayPalCreditButton: !1, blockPayPalPayLaterButton: !1, enableMessages: !1, blockPayPalVenmoButton: !1, isExpress: !1, configuration: { merchantId: "", intent: null }, onInit: function() {
}, onClick: function() {
}, onCancel: function() {
}, onError: function() {
} }), Qie.defaultProps = { phoneLabel: "telephoneNumber" };
var qY, Xqe = function(e, t) {
  if (e && t) {
    var n = Ji(e).call(e, function(r) {
      return r.code === t;
    });
    return !!n && n.id;
  }
  return !1;
}, iN = [{ id: "+7", name: "Russian Federation", code: "RU" }, { id: "+9955", name: "Georgia", code: "GE" }, { id: "+507", name: "Panama", code: "PA" }, { id: "+44", name: "United Kingdom", code: "GB" }, { id: "+992", name: "Tajikistan", code: "TJ" }, { id: "+370", name: "Lithuania", code: "LT" }, { id: "+972", name: "Israel", code: "IL" }, { id: "+996", name: "Kyrgyzstan", code: "KG" }, { id: "+380", name: "Ukraine", code: "UA" }, { id: "+84", name: "Viet Nam", code: "VN" }, { id: "+90", name: "Turkey", code: "TR" }, { id: "+994", name: "Azerbaijan", code: "AZ" }, { id: "+374", name: "Armenia", code: "AM" }, { id: "+371", name: "Latvia", code: "LV" }, { id: "+91", name: "India", code: "IN" }, { id: "+66", name: "Thailand", code: "TH" }, { id: "+373", name: "Moldova", code: "MD" }, { id: "+1", name: "United States", code: "US" }, { id: "+81", name: "Japan", code: "JP" }, { id: "+998", name: "Uzbekistan", code: "UZ" }, { id: "+77", name: "Kazakhstan", code: "KZ" }, { id: "+375", name: "Belarus", code: "BY" }, { id: "+372", name: "Estonia", code: "EE" }, { id: "+40", name: "Romania", code: "RO" }, { id: "+82", name: "Korea", code: "KR" }];
function JY(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function QY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = JY(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = JY(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Kqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var OO = function(e) {
  ft(n, Dr);
  var t = Kqe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "formatProps", value: function(r) {
    return QY(QY({ onValid: function() {
    } }, r), {}, { selected: Xqe(r.items, r.countryCode) });
  } }, { key: "formatData", value: function() {
    return { paymentMethod: { type: n.type, "qiwiwallet.telephoneNumberPrefix": this.state.data ? this.state.data.phonePrefix : "", "qiwiwallet.telephoneNumber": this.state.data ? this.state.data.phoneNumber : "" } };
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(Qie, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props, this.state, { phoneLabel: "mobileNumber", onChange: this.setState, onSubmit: this.submit, payButton: this.payButton })));
  } }]), n;
}();
function eX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function pm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = eX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = eX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
T(OO, "type", "qiwiwallet"), T(OO, "defaultProps", { items: Oe(qY = It(iN).call(iN, function(e) {
  var t;
  if (!e) throw new Error("No item passed");
  return !(!e.code || !e.id) && KY(KY({}, e), {}, { name: je(t = "".concat(e.name, " (")).call(t, e.id, ")"), selectedOptionName: e.id });
})).call(qY, function(e) {
  return e !== !1;
}), countryCode: iN[0].code, prefixName: "qiwiwallet.telephoneNumberPrefix", phoneName: "qiwiwallet.telephoneNumber" });
function ese(e) {
  var t = this, n = _n(null), r = Je({}), a = ze(r, 2), o = a[0], s = a[1], c = Je({}), u = ze(c, 2), f = u[0], m = u[1], v = Je({}), y = ze(v, 2), b = y[0], S = y[1], x = Je(!1), E = ze(x, 2), N = E[0], R = E[1], O = Je(null), D = ze(O, 2), $ = D[0], B = D[1], G = Je([]), Z = ze(G, 2), K = Z[0], q = Z[1], pe = Je(""), he = ze(pe, 2), _e = he[0], ge = he[1], Y = Qi(function() {
    return Sie(e, { sfp: n }, { dualBrandSelectElements: K, setDualBrandSelectElements: q, setSelectedBrandValue: ge, issuingCountryCode: $, setIssuingCountryCode: B });
  }, [K, $]);
  return this.processBinLookupResponse = function(ee, oe) {
    Y.processBinLookup(ee, oe);
  }, this.dualBrandingChangeHandler = Y.handleDualBrandSelection, Rt(function() {
    return t.setFocusOn = n.current.setFocusOn, t.updateStyles = n.current.updateStyles, t.showValidation = n.current.showValidation, t.handleUnsupportedCard = n.current.handleUnsupportedCard, function() {
      n.current.destroy();
    };
  }, []), Rt(function() {
    var ee = n.current.mapErrorsToValidationRuleResult();
    e.onChange({ data: b, valid: f, errors: pm(pm({}, o), ee), isValid: N, selectedBrandValue: _e });
  }, [b, f, o, _e]), P(sC, kt({ ref: n }, qqe(e), { onChange: function(ee) {
    S(pm(pm({}, b), ee.data)), s(pm(pm({}, o), ee.errors)), m(pm(pm({}, f), ee.valid)), R(ee.isSfpValid);
  }, render: function() {
    return null;
  } }));
}
ese.defaultProps = { onChange: function() {
}, onError: function() {
} };
var qqe = function(e) {
  return { allowedDOMAccess: e.allowedDOMAccess, autoFocus: e.autoFocus, brands: e.brands, brandsConfiguration: e.brandsConfiguration, clientKey: e.clientKey, i18n: e.i18n, implementationType: e.implementationType, keypadFix: e.keypadFix, legacyInputMode: e.legacyInputMode, loadingContext: e.loadingContext, minimumExpiryDate: e.minimumExpiryDate, onAdditionalSFConfig: e.onAdditionalSFConfig, onAdditionalSFRemoved: e.onAdditionalSFRemoved, onAllValid: e.onAllValid, onAutoComplete: e.onAutoComplete, onBinValue: e.onBinValue, onBrand: e.onBrand, onConfigSuccess: e.onConfigSuccess, onError: e.onError, onFieldValid: e.onFieldValid, onFocus: e.onFocus, onLoad: e.onLoad, rootNode: e.rootNode, showWarnings: e.showWarnings, styles: e.styles, trimTrailingSeparator: e.trimTrailingSeparator, type: e.type, resources: e.resources };
};
function tX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function p4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = tX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = tX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Jqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var s7 = function(e) {
  ft(n, Dr);
  var t = Jqe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "onBinValue", Pie(Se(a))), T(Se(a), "onFocus", function(u) {
      var f, m;
      a.submitAnalytics({ type: u.focus === !0 ? BM : VM, target: o7(u.fieldType) }), (f = (m = a.props).onFocus) === null || f === void 0 || f.call(m, u);
    }), a;
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return p4(p4({}, r), {}, { type: r.type === "scheme" || r.type === "securedfields" ? "card" : r.type });
  } }, { key: "formatData", value: function() {
    var r = this.state.selectedBrandValue || this.props.brand;
    return { paymentMethod: p4(p4({ type: n.type }, this.state.data), r && { brand: r }), browserInfo: this.browserInfo };
  } }, { key: "updateStyles", value: function(r) {
    var a;
    return (a = this.componentRef) !== null && a !== void 0 && a.updateStyles && this.componentRef.updateStyles(r), this;
  } }, { key: "setFocusOn", value: function(r) {
    var a;
    return (a = this.componentRef) !== null && a !== void 0 && a.setFocusOn && this.componentRef.setFocusOn(r), this;
  } }, { key: "processBinLookupResponse", value: function(r) {
    var a;
    return (a = this.componentRef) !== null && a !== void 0 && a.processBinLookupResponse && this.componentRef.processBinLookupResponse(r), this;
  } }, { key: "dualBrandingChangeHandler", value: function(r) {
    var a;
    return (a = this.componentRef) !== null && a !== void 0 && a.dualBrandingChangeHandler && this.componentRef.dualBrandingChangeHandler(r), this;
  } }, { key: "handleUnsupportedCard", value: function(r) {
    var a;
    return (a = this.componentRef) !== null && a !== void 0 && a.handleUnsupportedCard && this.componentRef.handleUnsupportedCard(r), this;
  } }, { key: "onBinLookup", value: function(r) {
    var a, o = this, s = p4({}, r);
    s.rootNode = this._node, s.isReset || (s.supportedBrandsRaw = (a = r.supportedBrandsRaw) === null || a === void 0 ? void 0 : It(a).call(a, function(c) {
      var u, f;
      return c.brandImageUrl = (u = (f = o.props.brandsConfiguration[c.brand]) === null || f === void 0 ? void 0 : f.icon) !== null && u !== void 0 ? u : _ie(c.brand, o.resources), c;
    })), this.props.onBinLookup(s);
  } }, { key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "browserInfo", get: function() {
    return nv();
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(ese, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props, this.state, { rootNode: this._node, onChange: this.setState, onBinValue: this.onBinValue, implementationType: "custom", resources: this.resources, onFocus: this.onFocus })));
  } }]), n;
}();
function nX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = nX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = nX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Qqe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(s7, "type", "scheme"), T(s7, "analyticsType", "custom-scheme"), T(s7, "defaultProps", { onBinLookup: function() {
}, brandsConfiguration: {} });
var RO = function(e) {
  ft(n, Dr);
  var t = Qqe(n);
  function n(r) {
    var a;
    return Qe(this, n), (a = t.call(this, r)).state = sN(sN({}, a.state), { data: { ibanNumber: "", ownerName: "" } }), a;
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return sN({ holderName: !0 }, r);
  } }, { key: "formatData", value: function() {
    return { paymentMethod: { type: n.type, iban: this.state.data.ibanNumber, ownerName: this.state.data.ownerName } };
  } }, { key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, this.props.showFormInstruction && P(Qp, null), P(oD, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props, { onChange: this.setState, onSubmit: this.submit, payButton: this.payButton })));
  } }]), n;
}();
function eJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(RO, "type", "sepadirectdebit"), T(RO, "defaultProps", { showFormInstruction: !0 });
var tse = function(e) {
  ft(n, yo);
  var t = eJe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "formEl", void 0), a;
  }
  return et(n, [{ key: "componentDidMount", value: function() {
    this.formEl.submit(), this.props.onFormSubmit("".concat(this.props.inputName, " sent"));
  } }, { key: "render", value: function(r) {
    var a = this, o = r.name, s = r.action, c = r.target, u = r.inputName, f = r.inputValue;
    return P("form", { ref: function(m) {
      a.formEl = m;
    }, method: "POST", className: Tt(["adyen-checkout__threeds2__form", "adyen-checkout__threeds2__form--".concat(o)]), name: o, action: s, target: c, style: { display: "none" } }, P("input", { name: u, value: f }));
  } }]), n;
}(), vD = "threeDS2Error", If = "threeDS2", $8 = "3DS2", tJe = { result: { transStatus: "U" }, type: "challengeResult", errorCode: "timeout" }, nJe = { result: { threeDSCompInd: "N" }, type: "fingerPrintResult", errorCode: "timeout" }, rJe = "unknownError", rX = { timeout: "ThreeDS2 timed out", wrongOrigin: "Result came in the right format but not from the expected origin", HTMLElementError: "No proper HTML element was passed", wrongDataType: "Result data was not of the expected type", missingProperty: "Result data did not contain the expected properties", unknownError: "An unknown error occurred" }, nse = { "01": ["250px", "400px"], "02": ["390px", "400px"], "03": ["500px", "600px"], "04": ["600px", "400px"], "05": ["100%", "100%"] }, rse = function(e) {
  return "success" in e && !e.success;
}, ase = function(e) {
  var t = tC.decode(e);
  if (t.success) try {
    return JSON.parse(t.data);
  } catch (n) {
    return { success: !1, error: "Could not JSON parse token" };
  }
  return t;
}, j8 = function(e) {
  if (!e || !Pe(e).length) throw new Error("No (populated) data object to encode");
  return tC.encode(Pc(e));
}, aX = function(e) {
  var t = e.length === 1 ? "0".concat(e) : e;
  return Object.prototype.hasOwnProperty.call(nse, t) ? t : "02";
}, aJe = function(e, t, n) {
  return { data: T(T({}, e, j8({ threeDSCompInd: t.threeDSCompInd })), "paymentData", n) };
}, oJe = function(e, t, n) {
  return { data: { details: { "threeds2.fingerprint": j8(t) }, paymentData: n } };
}, iJe = function(e, t, n) {
  return { data: { details: T({}, e, j8({ transStatus: t, authorisationToken: n })) } };
}, sJe = function(e, t, n) {
  return { data: { details: { "threeds2.challengeResult": j8({ transStatus: t }) }, paymentData: n } };
}, MO = function(e, t) {
  return { errorCode: e, message: rX[e] || t || rX[rJe] };
}, ose = function(e) {
  var t = window.btoa(e).split("=")[0];
  return t = (t = t.replace(/\+/g, "-")).replace(/\//g, "_");
}, lJe = ["elementRef"], uJe = ["createFromAction", "onAdditionalDetails"];
function cJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var oX = "threeDSIframe", dJe = function(e) {
  ft(n, yo);
  var t = cJe(n);
  function n(r) {
    var a;
    Qe(this, n), a = t.call(this, r), T(Se(a), "processMessageHandler", void 0), T(Se(a), "challengePromise", void 0), T(Se(a), "iframeCallback", function() {
      a.setState({ status: "iframeLoaded" }), a.state.status === "init" && a.props.onActionHandled({ componentType: "3DS2Challenge", actionDescription: "".concat($8, " challenge iframe loaded") });
    });
    var o = Pc(a.props.cReqData), s = ose(o);
    return a.state = { base64URLencodedData: s, status: "init" }, a;
  }
  return et(n, [{ key: "get3DS2ChallengePromise", value: function() {
    var r = this;
    return new Yt(function(a, o) {
      r.processMessageHandler = ZM(r.props.postMessageDomain, a, 0, "challengeResult"), window.addEventListener("message", r.processMessageHandler);
    });
  } }, { key: "componentDidMount", value: function() {
    var r = this;
    this.challengePromise = WM(6e5, this.get3DS2ChallengePromise(), tJe), this.challengePromise.promise.then(function(a) {
      window.removeEventListener("message", r.processMessageHandler), r.props.onCompleteChallenge(a);
    }).catch(function(a) {
      window.removeEventListener("message", r.processMessageHandler), r.props.onErrorChallenge(a);
    });
  } }, { key: "componentWillUnmount", value: function() {
    this.challengePromise && this.challengePromise.cancel(), window.removeEventListener("message", this.processMessageHandler);
  } }, { key: "render", value: function(r, a) {
    var o = r.acsURL, s = r.cReqData, c = r.iframeSizeArr, u = r.onFormSubmit, f = a.base64URLencodedData, m = a.status, v = ze(c, 2), y = v[0], b = v[1];
    return P("div", { className: Tt(["adyen-checkout__threeds2__challenge", "adyen-checkout__threeds2__challenge--".concat(s.challengeWindowSize)]) }, m !== "iframeLoaded" && P(ju, null), P(eC, { name: oX, width: y, height: b, callback: this.iframeCallback }), P(tse, { name: "cReqForm", action: o, target: oX, inputName: "creq", inputValue: f, onFormSubmit: u }));
  } }]), n;
}();
function fJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var ise = function(e) {
  ft(n, yo);
  var t = fJe(n);
  function n(r) {
    var a;
    if (Qe(this, n), a = t.call(this, r), T(Se(a), "onActionHandled", function(m) {
      a.props.onSubmitAnalytics({ type: If, message: m.actionDescription, subtype: qy.CHALLENGE_IFRAME_LOADED }), a.props.onActionHandled(m);
    }), T(Se(a), "onFormSubmit", function(m) {
      a.props.onSubmitAnalytics({ type: If, message: m, subtype: qy.CHALLENGE_DATA_SENT });
    }), a.props.token) {
      var o = function(m) {
        var v = m.token, y = m.size, b = ase(v);
        if (rse(b)) return b;
        var S, x = b, E = x.acsTransID, N = x.acsURL, R = x.messageVersion, O = x.threeDSNotificationURL, D = x.threeDSServerTransID, $ = YM(O);
        return { acsURL: N, cReqData: { acsTransID: E, messageVersion: R, threeDSServerTransID: D, messageType: "CReq", challengeWindowSize: aX(y) }, iframeSizeArr: (S = y, nse[aX(S)]), postMessageDomain: $ };
      }({ token: a.props.token, size: a.props.challengeWindowSize || a.props.size }), s = o.cReqData, c = s.acsTransID, u = s.messageVersion, f = s.threeDSServerTransID;
      if (!(o.acsURL && c && u && f)) return a.setStatusError({ errorInfo: "Challenge Data missing one or more of the following properties (acsURL | acsTransID | messageVersion | threeDSServerTransID)" }), ct(a);
      a.state = { status: "retrievingChallengeToken", challengeData: o, errorInfo: null };
    } else a.setStatusError({ errorInfo: "Missing challengeToken parameter" });
    return a;
  }
  return et(n, [{ key: "setStatusComplete", value: function(r) {
    var a = this, o = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    this.setState({ status: "complete" }, function() {
      var s, c = (a.props.useOriginalFlow ? sJe : iJe)(a.props.dataKey, r.transStatus, a.props.paymentData);
      switch (r == null ? void 0 : r.transStatus) {
        case "Y":
          s = "success";
          break;
        case "N":
          s = "failed";
          break;
        case "U":
          s = o ? "timeout" : "cancelled";
      }
      r != null && r.errorCode && (s = "noTransStatus");
      var u = { type: If, message: "".concat($8, " challenge has completed"), subtype: qy.CHALLENGE_COMPLETED, result: s };
      a.props.onSubmitAnalytics(u), a.props.onComplete(c);
    });
  } }, { key: "setStatusError", value: function(r) {
    this.setState({ status: "error", errorInfo: r.errorInfo }), this.props.onError(r);
  } }, { key: "render", value: function(r, a) {
    var o = this, s = a.challengeData, c = oa();
    return this.state.status === "retrievingChallengeToken" ? P(dJe, kt({ onCompleteChallenge: function(u) {
      if (Ir(u.result, "errorCode") && u.result.errorCode.length) {
        var f = MO(u.result.errorCode, u.result.errorDescription);
        o.props.onError(f);
      }
      o.setStatusComplete(u.result);
    }, onErrorChallenge: function(u) {
      if (Ir(u, "errorCode")) {
        var f = MO(u.errorCode);
        return o.props.onError(f), void o.setStatusComplete(u.result);
      }
    } }, s, { onActionHandled: this.onActionHandled, onFormSubmit: this.onFormSubmit })) : this.state.status === "error" ? P("div", { className: "adyen-checkout__threeds2-challenge-error" }, P(ps, { className: "adyen-checkout__status__icon adyen-checkout__status__icon--error", src: c({ imageFolder: "components/" })("error"), alt: "" }), P("div", { className: "adyen-checkout__status__text" }, this.state.errorInfo ? this.state.errorInfo : this.props.i18n.get("error.message.unknown"))) : null;
  } }]), n;
}();
function pJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(ise, "defaultProps", { onComplete: function() {
}, onError: function() {
}, onActionHandled: function() {
} });
var DO = function(e) {
  ft(n, Dr);
  var t = pJe(n);
  function n() {
    var r, a, o;
    Qe(this, n);
    for (var s = arguments.length, c = new Array(s), u = 0; u < s; u++) c[u] = arguments[u];
    return o = t.call.apply(t, je(r = [this]).call(r, c)), T(Se(o), "submitAnalytics", function(f) {
      f.type !== e1 && Nn((a = Se(o), fe(n.prototype)), "submitAnalytics", a).call(a, f);
    }), o;
  }
  return et(n, [{ key: "onComplete", value: function(r) {
    r && Nn(fe(n.prototype), "onComplete", this).call(this, r), this.unmount();
  } }, { key: "render", value: function() {
    if (!Mp(this.props.paymentData)) {
      var r = Ir(this.props, "useOriginalFlow") ? "paymentData" : "authorisationToken";
      return this.props.onError({ errorCode: "threeds2.challenge", message: "No ".concat(r, " received. Challenge cannot proceed") }), this.submitAnalytics({ type: vD, code: Soe, errorType: woe, message: "".concat("3DS2Challenge_Error", ": Missing 'paymentData' property from threeDS2 action") }), null;
    }
    return P(ise, kt({}, this.props, { onComplete: this.onComplete, onSubmitAnalytics: this.submitAnalytics }));
  } }]), n;
}();
function hJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(DO, "type", "threeDS2Challenge"), T(DO, "defaultProps", { dataKey: "threeDSResult", size: "02", type: "threeDS2Challenge" });
var iX = "threeDSMethodIframe", sse = function(e) {
  ft(n, yo);
  var t = hJe(n);
  function n(r) {
    var a;
    Qe(this, n), a = t.call(this, r), T(Se(a), "processMessageHandler", void 0), T(Se(a), "fingerPrintPromise", void 0);
    var o = a.props, s = o.threeDSServerTransID, c = o.threeDSMethodNotificationURL, u = Pc({ threeDSServerTransID: s, threeDSMethodNotificationURL: c }), f = ose(u);
    return a.state = { base64URLencodedData: f }, a;
  }
  return et(n, [{ key: "get3DS2MethodPromise", value: function() {
    var r = this;
    return new Yt(function(a, o) {
      r.processMessageHandler = ZM(r.props.postMessageDomain, a, 0, "fingerPrintResult"), window.addEventListener("message", r.processMessageHandler);
    });
  } }, { key: "componentDidMount", value: function() {
    var r = this;
    this.fingerPrintPromise = WM(1e4, this.get3DS2MethodPromise(), nJe), this.fingerPrintPromise.promise.then(function(a) {
      window.removeEventListener("message", r.processMessageHandler), r.props.onCompleteFingerprint(a);
    }).catch(function(a) {
      window.removeEventListener("message", r.processMessageHandler), r.props.onErrorFingerprint(a);
    });
  } }, { key: "componentWillUnmount", value: function() {
    this.fingerPrintPromise && this.fingerPrintPromise.cancel(), window.removeEventListener("message", this.processMessageHandler);
  } }, { key: "render", value: function(r, a) {
    var o = r.threeDSMethodURL, s = r.onActionHandled, c = r.onFormSubmit, u = a.base64URLencodedData;
    return P("div", { className: "adyen-checkout__3ds2-device-fingerprint" }, this.props.showSpinner && P(ju, null), P("div", { style: { display: "none" } }, P(eC, { name: iX, callback: function() {
      s({ componentType: "3DS2Fingerprint", actionDescription: "".concat($8, " fingerprint iframe loaded") });
    } }), P(tse, { name: "threeDSMethodForm", action: o, target: iX, inputName: "threeDSMethodData", inputValue: u, onFormSubmit: c })));
  } }]), n;
}();
function mJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(sse, "defaultProps", { showSpinner: !0 });
var LO = function(e) {
  ft(n, yo);
  var t = mJe(n);
  function n(r) {
    var a;
    Qe(this, n), a = t.call(this, r), T(Se(a), "onActionHandled", function(f) {
      a.props.onSubmitAnalytics({ type: If, message: f.actionDescription, subtype: qy.FINGERPRINT_IFRAME_LOADED }), a.props.onActionHandled(f);
    }), T(Se(a), "onFormSubmit", function(f) {
      a.props.onSubmitAnalytics({ type: If, message: f, subtype: qy.FINGERPRINT_DATA_SENT });
    });
    var o = a.props, s = o.token, c = o.notificationURL;
    if (s) {
      var u = function(f) {
        var m = f.token, v = f.notificationURL, y = ase(m);
        if (rse(y)) return y;
        var b = y, S = b.threeDSMethodNotificationURL, x = b.threeDSMethodUrl, E = v || S;
        return { threeDSServerTransID: b.threeDSServerTransID, threeDSMethodURL: x, threeDSMethodNotificationURL: E, postMessageDomain: YM(E) };
      }({ token: s, notificationURL: c });
      a.state = { status: "init", fingerPrintData: u };
    } else a.state = { status: "error" }, a.props.onError({ errorCode: a.props.dataKey, message: "Missing fingerprintToken parameter" });
    return a;
  }
  return et(n, [{ key: "componentDidMount", value: function() {
    if (!this.state.fingerPrintData || !this.state.fingerPrintData.threeDSMethodURL) return this.setStatusComplete({ threeDSCompInd: "U" }), void console.debug("### PrepareFingerprint3DS2::exiting:: no fingerPrintData or no threeDSMethodURL");
    this.setState({ status: "retrievingFingerPrint" });
  } }, { key: "setStatusComplete", value: function(r) {
    var a = this, o = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    this.setState({ status: "complete" }, function() {
      var s, c = (a.props.useOriginalFlow ? oJe : aJe)(a.props.dataKey, r, a.props.paymentData);
      switch (r == null ? void 0 : r.threeDSCompInd) {
        case "Y":
          s = "success";
          break;
        case "N":
          s = o ? "timeout" : "failed";
          break;
        case "U":
          s = "noThreeDSMethodURL";
      }
      var u = { type: If, message: "".concat($8, " fingerprinting has completed"), subtype: qy.FINGERPRINT_COMPLETED, result: s };
      a.props.onSubmitAnalytics(u), a.props.onComplete(c);
    });
  } }, { key: "render", value: function(r, a) {
    var o = this, s = r.showSpinner, c = a.status, u = a.fingerPrintData;
    return c === "retrievingFingerPrint" ? P(sse, kt({ onCompleteFingerprint: function(f) {
      o.setStatusComplete(f.result);
    }, onErrorFingerprint: function(f) {
      var m = MO(f.errorCode);
      console.debug("### PrepareFingerprint3DS2::fingerprint timed-out:: errorCodeObject=", m), o.setStatusComplete(f.result, !0);
    }, showSpinner: s }, u, { onActionHandled: this.onActionHandled, onFormSubmit: this.onFormSubmit })) : null;
  } }]), n;
}();
function sX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function lX(e) {
  var t = this, n = e.data;
  fl({ path: "v1/submitThreeDS2Fingerprint?token=".concat(this.props.clientKey), loadingContext: this.props.loadingContext, errorLevel: "fatal" }, function(r) {
    for (var a = 1; a < arguments.length; a++) {
      var o, s, c = arguments[a] != null ? arguments[a] : {};
      a % 2 ? Q(o = sX(Object(c), !0)).call(o, function(u) {
        T(r, u, c[u]);
      }) : ne ? Ze(r, ne(c)) : Q(s = sX(Object(c))).call(s, function(u) {
        We(r, u, re(c, u));
      });
    }
    return r;
  }({}, n)).then(function(r) {
    var a, o, s, c = (a = t.props.elementRef) !== null && a !== void 0 ? a : t;
    if (c) {
      if (r.action || r.details) {
        if (r.type === "completed") {
          var u = r.details;
          return t.onComplete({ data: { details: u } });
        }
        return ((o = r.action) === null || o === void 0 ? void 0 : o.type) === "threeDS2" ? c.handleAction(r.action, iC("challengeWindowSize").from(t.props)) : ((s = r.action) === null || s === void 0 ? void 0 : s.type) === "redirect" ? c.handleAction(r.action) : void 0;
      }
      console.error("Handled Error::callSubmit3DS2Fingerprint::FAILED:: resData=", r);
    } else console.error("Handled Error::callSubmit3DS2Fingerprint::FAILED:: actionHandler=", c);
  }).catch(function(r) {
    t.handleError(r);
  });
}
function vJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(LO, "type", "scheme"), T(LO, "defaultProps", { onComplete: function() {
}, onError: function() {
}, paymentData: "", showSpinner: !0, onActionHandled: function() {
} });
var $O = function(e) {
  ft(n, Dr);
  var t = vJe(n);
  function n() {
    var r, a, o;
    Qe(this, n);
    for (var s = arguments.length, c = new Array(s), u = 0; u < s; u++) c[u] = arguments[u];
    return o = t.call.apply(t, je(r = [this]).call(r, c)), T(Se(o), "callSubmit3DS2Fingerprint", pn(lX).call(lX, Se(o))), T(Se(o), "submitAnalytics", function(f) {
      f.type !== e1 && Nn((a = Se(o), fe(n.prototype)), "submitAnalytics", a).call(a, f);
    }), o;
  }
  return et(n, [{ key: "onComplete", value: function(r) {
    Nn(fe(n.prototype), "onComplete", this).call(this, r), this.unmount();
  } }, { key: "render", value: function() {
    return Mp(this.props.paymentData) ? P(LO, kt({}, this.props, { onComplete: this.props.useOriginalFlow ? this.onComplete : this.callSubmit3DS2Fingerprint, onSubmitAnalytics: this.submitAnalytics, isMDFlow: this.props.paymentData.length < 15 })) : (this.props.onError({ errorCode: n.defaultProps.dataKey, message: "No paymentData received. Fingerprinting cannot proceed" }), this.submitAnalytics({ type: vD, code: Soe, errorType: woe, message: "".concat("3DS2Fingerprint_Error", ": Missing 'paymentData' property from threeDS2 action") }), null);
  } }]), n;
}();
T($O, "type", "threeDS2Fingerprint"), T($O, "defaultProps", { dataKey: "fingerprintResult", type: "threeDS2Fingerprint" });
var uX = function(e) {
  var t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
  if (n === 0) return e;
  var r = String(e);
  return r.length >= n ? r : Xo(t = jze("0").call("0", n) + r).call(t, -1 * n);
}, gJe = function(e, t) {
  var n = /* @__PURE__ */ new Date(), r = t.getTime() - n.getTime(), a = r / 1e3, o = function(s, c, u) {
    var f = u.getTime() - s.getTime();
    return 100 - Math.round(100 * (c.getTime() - s.getTime()) / f);
  }(e, n, t);
  return { total: r, minutes: uX(Math.floor(a / 60 % 60)), seconds: uX(Math.floor(a % 60)), completed: r <= 0, percentage: o };
}, yJe = function() {
  function e(t) {
    Qe(this, e), T(this, "TRANSLATION_KEY", "sr.wechatpay.timetopay"), T(this, "LONG_TIMEOUT", 18e4), T(this, "MID_TIMEOUT", 6e4), T(this, "SHORT_TIMEOUT", 3e4), T(this, "srPanel", void 0), T(this, "i18n", void 0), T(this, "srInterval", void 0), T(this, "timeout", void 0), T(this, "timeLeft", void 0);
    var n = t.srPanel, r = t.i18n;
    this.srPanel = n, this.i18n = r, this.srPanel.setAriaProps({ "aria-relevant": "additions text" });
  }
  return et(e, [{ key: "update", value: function(t) {
    var n = t.minutes, r = t.seconds;
    if (n !== "-" && r !== "-") {
      var a = typeof n == "string" ? Ou(n, 10) : n, o = typeof r == "string" ? Ou(r, 10) : r;
      this.timeLeft = { minutes: a, seconds: o }, a > 5 && this.timeout !== this.LONG_TIMEOUT && (this.timeout = this.LONG_TIMEOUT, this.setInterval(this.timeout)), a >= 1 && a <= 5 && this.timeout !== this.MID_TIMEOUT && (this.timeout = this.MID_TIMEOUT, this.setInterval(this.timeout)), a < 1 && o > 0 && this.timeout !== this.SHORT_TIMEOUT && (this.timeout = this.SHORT_TIMEOUT, this.setInterval(this.timeout));
    }
  } }, { key: "tearDown", value: function() {
    this.clearInterval(), this.srPanel.setAriaProps({ "aria-relevant": this.srPanel.constructor.defaultProps.ariaAttributes["aria-relevant"] }), this.srPanel.setMessages(null);
  } }, { key: "setInterval", value: function(t) {
    function n(r) {
      return t.apply(this, arguments);
    }
    return n.toString = function() {
      return t.toString();
    }, n;
  }(function(t) {
    var n = this;
    this.clearInterval();
    var r = function() {
      n.srPanel.setMessages(null), n.srPanel.setMessages(n.getSrMessages(n.timeLeft));
    };
    r(), this.srInterval = loe(r, t);
  }) }, { key: "getSrMessages", value: function(t) {
    var n, r = t.minutes, a = t.seconds, o = this.i18n.get(this.TRANSLATION_KEY), s = It(n = [r, a]).call(n, function(c) {
      return c !== 0 ? function(u) {
        var f;
        return je(f = "".concat(c, " ")).call(f, u);
      } : function() {
        return "";
      };
    });
    return [voe(o, s).join("")];
  } }, { key: "clearInterval", value: function(t) {
    function n() {
      return t.apply(this, arguments);
    }
    return n.toString = function() {
      return t.toString();
    }, n;
  }(function() {
    this.srInterval && clearInterval(this.srInterval);
  }) }]), e;
}(), bJe = function(e) {
  var t = wt().i18n, n = oC().srPanel, r = _n(null);
  Rt(function() {
    return r.current = new yJe({ i18n: t, srPanel: n }), function() {
      r.current.tearDown();
    };
  }, []), Rt(function() {
    try {
      if (!r.current) return;
      r.current.update(e);
    } catch (a) {
      throw r.current.tearDown(), r.current = null, a;
    }
  }, [e]);
}, _Je = function(e) {
  var t = 6e4 * e, n = (/* @__PURE__ */ new Date()).getTime();
  return { startTime: new Date(n), endTime: new Date(n + t) };
};
function lse(e) {
  var t = e.minutesFromNow, n = e.onTick, r = n === void 0 ? function() {
  } : n, a = e.onCompleted, o = a === void 0 ? function() {
  } : a, s = _n(_Je(t)).current, c = s.startTime, u = s.endTime, f = Je({ minutes: "-", seconds: "-" }), m = ze(f, 2), v = m[0], y = m[1];
  return bJe(v), Rt(function() {
    var b = loe(function() {
      var S = gJe(c, u), x = S.minutes, E = S.seconds, N = S.percentage;
      if (S.completed) o();
      else {
        var R = { minutes: x, seconds: E, percentage: N };
        y(R), r(R);
      }
    }, 1e3);
    return function() {
      clearInterval(b);
    };
  }, []), P("span", { className: "adyen-checkout__countdown", role: "timer" }, P("span", { className: "countdown__minutes" }, v.minutes), P("span", { className: "countdown__separator" }, ":"), P("span", { className: "countdown__seconds" }, v.seconds));
}
function use(e, t, n, r) {
  if (!e || !t) throw new Error("Could not check the payment status");
  return fl({ loadingContext: n, path: "services/PaymentInitiation/v1/status?clientKey=".concat(t), timeout: r }, { paymentData: e });
}
function cX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function lx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = cX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = cX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var dX = function(e) {
  switch (e.resultCode.toLowerCase()) {
    case "refused":
    case "error":
    case "cancelled":
      return { type: "error", props: lx(lx({}, e), {}, { message: "error.subtitle.refused" }) };
    case "unknown":
      return { type: "error", props: lx(lx({}, e), {}, { message: "error.message.unknown" }) };
    case "pending":
    case "received":
      return { type: e.resultCode.toLowerCase(), props: e };
    default:
      return { type: "success", props: e };
  }
}, cse = function(e) {
  if (!e.type && e.resultCode) return dX(e);
  if (!e.type) return { type: "error", props: e };
  switch (e.type.toLowerCase()) {
    case "pending":
      return { type: "pending", props: e };
    case "complete":
      return dX(e);
    default:
      return { type: "error", props: e };
  }
}, gD = function(e) {
  var t = oC().srPanel;
  Rt(function() {
    return t.setAriaProps({ "aria-relevant": "additions text" }), function() {
      t.setMessages(null), t.setAriaProps({ "aria-relevant": t.constructor.defaultProps.ariaAttributes["aria-relevant"] });
    };
  }, []), Rt(function() {
    t.setMessages(e);
  }, [e]);
};
function CJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var yD = function(e) {
  ft(n, yo);
  var t = CJe(n);
  function n(r) {
    var a;
    return Qe(this, n), a = t.call(this, r), T(Se(a), "timeoutId", void 0), T(Se(a), "redirectToApp", function(o) {
      window.location.assign(o);
    }), T(Se(a), "statusInterval", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      if (!a.state.expired && !a.state.completed) {
        a.setState(function(c) {
          return { timePassed: c.timePassed + a.props.delay + o };
        });
        var s = a.state.timePassed >= a.props.throttleTime ? a.props.throttledInterval : a.state.delay;
        a.pollStatus(s);
      }
    }), T(Se(a), "onTick", function(o) {
      a.setState({ percentage: o.percentage });
    }), T(Se(a), "onTimeUp", function() {
      a.setState({ expired: !0 }), clearTimeout(a.timeoutId), a.props.onError(new _r("ERROR", "Payment Expired"));
    }), T(Se(a), "onComplete", function(o) {
      clearTimeout(a.timeoutId), a.setState({ completed: !0, loading: !1 });
      var s = { data: { details: { payload: o.props.payload }, paymentData: a.props.paymentData } };
      a.props.onComplete(s, Se(a));
    }), T(Se(a), "onError", function(o) {
      if (clearTimeout(a.timeoutId), a.setState({ expired: !0, loading: !1 }), o.props.payload) {
        var s = { data: { details: { payload: o.props.payload }, paymentData: a.props.paymentData } };
        a.props.onComplete(s, Se(a));
      }
      var c = new _r("ERROR", "error result with no payload in response");
      return a.props.onError(c);
    }), T(Se(a), "checkStatus", function() {
      var o = a.props;
      return use(o.paymentData, o.clientKey, o.loadingContext, o.throttledInterval).then(cse).catch(function(s) {
        return { type: "network-error", props: s };
      }).then(function(s) {
        switch (s.type) {
          case "success":
            a.onComplete(s);
            break;
          case "error":
            a.onError(s);
            break;
          default:
            a.setState({ loading: !1 });
        }
        return s;
      });
    }), a.state = { buttonStatus: "default", completed: !1, delay: r.delay, expired: !1, loading: !0, percentage: 100, timePassed: 0 }, a;
  }
  return et(n, [{ key: "componentDidMount", value: function() {
    this.statusInterval();
  } }, { key: "componentWillUnmount", value: function() {
    clearTimeout(this.timeoutId);
  } }, { key: "pollStatus", value: function(r) {
    var a = this;
    clearTimeout(this.timeoutId), this.timeoutId = Ro(On(yt.mark(function o() {
      var s, c;
      return yt.wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            return s = performance.now(), u.next = 3, a.checkStatus();
          case 3:
            c = performance.now(), a.statusInterval(Math.round(c - s));
          case 5:
          case "end":
            return u.stop();
        }
      }, o);
    })), r);
  } }, { key: "render", value: function(r, a) {
    var o, s, c, u, f, m, v = this, y = r.amount, b = r.url, S = r.brandLogo, x = r.brandName, E = r.countdownTime, N = r.type, R = r.onActionHandled, O = a.expired, D = a.completed, $ = a.loading, B = wt(), G = B.i18n, Z = B.loadingContext, K = oa(), q = this.props.qrCodeData ? je(o = je(s = "".concat(Z)).call(s, "barcode.shtml?barcodeType=qrCode&fileType=png&data=")).call(o, this.props.qrCodeData) : this.props.qrCodeImage, pe = function(Y, ee) {
      var oe = G.get(ee);
      return gD(oe), P("div", { className: "adyen-checkout__qr-loader adyen-checkout__qr-loader--result" }, P("img", { className: "adyen-checkout__qr-loader__icon adyen-checkout__qr-loader__icon--result", src: K({ imageFolder: "components/" })(Y), alt: oe }), P("div", { className: "adyen-checkout__qr-loader__subtitle adyen-checkout__qr-loader__subtitle--result" }, oe));
    };
    if (O) return pe("error", "error.subtitle.payment");
    if (D) return pe("success", "creditCard.success");
    if ($) return P("div", { className: "adyen-checkout__qr-loader" }, S && P("img", { alt: x, src: S, className: "adyen-checkout__qr-loader__brand-logo" }), P(ju, null));
    var he, _e = G.get(this.props.timeToPay).split("%@"), ge = (he = _n(null), Rt(function() {
      var Y;
      (Y = he.current) === null || Y === void 0 || Y.focus();
    }, []), he);
    return P("div", { className: je(c = `
                    adyen-checkout__qr-loader
                    adyen-checkout__qr-loader--`.concat(N, `
                    `)).call(c, It(u = this.props.classNameModifiers).call(u, function(Y) {
      return "adyen-checkout__qr-loader--".concat(Y);
    }), `
                `) }, S && P("img", { src: S, alt: x, className: "adyen-checkout__qr-loader__brand-logo" }), y && y.value && y.currency && P("div", { className: "adyen-checkout__qr-loader__payment_amount" }, G.amount(y.value, y.currency)), b && P("div", { className: "adyen-checkout__qr-loader__app-link" }, this.props.redirectIntroduction && P("div", { className: "adyen-checkout__qr-loader__subtitle" }, G.get(this.props.redirectIntroduction)), P(pu, { classNameModifiers: ["qr-loader"], onClick: function() {
      return v.redirectToApp(b);
    }, label: G.get(this.props.buttonLabel) }), P(z2, null)), P("div", { ref: ge, tabIndex: 0, className: "adyen-checkout__qr-loader__subtitle" }, G.get(this.props.introduction)), P("img", { src: q, alt: G.get("wechatpay.scanqrcode"), onLoad: function() {
      R == null || R({ componentType: v.props.type, actionDescription: "qr-code-loaded" });
    } }), P("div", { className: "adyen-checkout__qr-loader__progress" }, P("span", { className: "adyen-checkout__qr-loader__percentage", style: { width: "".concat(this.state.percentage, "%") } })), P("div", { className: "adyen-checkout__qr-loader__countdown" }, _e[0], " ", P(lse, { minutesFromNow: E, onTick: this.onTick, onCompleted: this.onTimeUp }), " ", _e[1]), typeof this.props.instructions == "string" ? P("div", { className: "adyen-checkout__qr-loader__instructions" }, G.get(this.props.instructions)) : (f = (m = this.props).instructions) === null || f === void 0 ? void 0 : f.call(m), this.props.copyBtn && P("div", { className: "adyen-checkout__qr-loader__actions" }, P(pu, { inline: !0, variant: "action", onClick: function(Y, ee) {
      var oe = ee.complete;
      Zie(v.props.qrCodeData), v.props.onSubmitAnalytics({ type: _oe, target: "qr_download_button" }), oe();
    }, icon: K({ imageFolder: "components/" })("copy"), label: G.get("button.copy") })));
  } }]), n;
}();
function fX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function wJe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = fX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = fX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function SJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(yD, "defaultProps", { delay: 2e3, countdownTime: 15, onError: function() {
}, onComplete: function() {
}, throttleTime: 6e4, classNameModifiers: [], throttledInterval: 1e4, introduction: "wechatpay.scanqrcode", timeToPay: "wechatpay.timetopay", buttonLabel: "openApp" });
var $f = function(e) {
  ft(n, Dr);
  var t = SJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatData", value: function() {
    return { paymentMethod: wJe({ type: this.props.type || this.constructor.type }, this.state.data) };
  } }, { key: "isValid", get: function() {
    return !0;
  } }, { key: "renderQRCode", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(eh, { srPanel: this.props.modules.srPanel }, P(yD, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props, { type: this.constructor.type, brandLogo: this.props.brandLogo || this.icon, delay: this.props.delay, onComplete: this.onComplete, countdownTime: this.props.countdownTime, instructions: this.props.instructions, onActionHandled: this.props.onActionHandled, brandName: this.displayName, onSubmitAnalytics: this.submitAnalytics }))));
  } }, { key: "render", value: function() {
    var r = this;
    return this.props.paymentData ? this.renderQRCode() : this.props.showPayButton ? P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(Lf, { showPayButton: this.props.showPayButton, name: this.displayName, onSubmit: this.submit, payButton: this.payButton, ref: function(a) {
      r.componentRef = a;
    } })) : null;
  } }]), n;
}();
T($f, "defaultProps", { qrCodeImage: "", amount: null, paymentData: null, onError: function() {
}, onComplete: function() {
}, onActionHandled: function() {
} });
function pX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var f6 = function(e) {
  ft(n, $f);
  var t = xJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return function(a) {
      for (var o = 1; o < arguments.length; o++) {
        var s, c, u = arguments[o] != null ? arguments[o] : {};
        o % 2 ? Q(s = pX(Object(u), !0)).call(s, function(f) {
          T(a, f, u[f]);
        }) : ne ? Ze(a, ne(u)) : Q(c = pX(Object(u))).call(c, function(f) {
          We(a, f, re(u, f));
        });
      }
      return a;
    }({ delay: 2e3, countdownTime: 15 }, Nn(fe(n.prototype), "formatProps", this).call(this, r));
  } }]), n;
}();
T(f6, "type", "wechatpayQR"), T(f6, "analyticsType", "wechatpayQR");
function hX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function EJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var dse = function(e) {
  ft(n, $f);
  var t = EJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return function(a) {
      for (var o = 1; o < arguments.length; o++) {
        var s, c, u = arguments[o] != null ? arguments[o] : {};
        o % 2 ? Q(s = hX(Object(u), !0)).call(s, function(f) {
          T(a, f, u[f]);
        }) : ne ? Ze(a, ne(u)) : Q(c = hX(Object(u))).call(c, function(f) {
          We(a, f, re(u, f));
        });
      }
      return a;
    }({ delay: 2e3, countdownTime: 3 }, Nn(fe(n.prototype), "formatProps", this).call(this, r));
  } }]), n;
}();
T(dse, "type", "paynow");
function mX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function IJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var jO = function(e) {
  ft(n, $f);
  var t = IJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return function(a) {
      for (var o = 1; o < arguments.length; o++) {
        var s, c, u = arguments[o] != null ? arguments[o] : {};
        o % 2 ? Q(s = mX(Object(u), !0)).call(s, function(f) {
          T(a, f, u[f]);
        }) : ne ? Ze(a, ne(u)) : Q(c = mX(Object(u))).call(c, function(f) {
          We(a, f, re(u, f));
        });
      }
      return a;
    }({ delay: 2e3, countdownTime: 15, buttonLabel: window.matchMedia("(max-width: 768px)").matches && /Android|iPhone|iPod/.test(navigator.userAgent) ? "openApp" : "generateQRCode" }, Nn(fe(n.prototype), "formatProps", this).call(this, r));
  } }]), n;
}();
function kJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(jO, "type", "bcmc_mobile");
var fse = function(e) {
  ft(n, ys);
  var t = kJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n);
}();
function AJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(fse, "type", "molpay_ebanking_fpx_MY");
var pse = function(e) {
  ft(n, ys);
  var t = AJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n);
}();
function PJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(pse, "type", "molpay_ebanking_TH");
var hse = function(e) {
  ft(n, ys);
  var t = PJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n);
}();
function vX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = vX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = vX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function mse(e) {
  var t, n, r = wt().i18n, a = oa(), o = function() {
    var D = ["dragonpay_ebanking", "dragonpay_otc_banking", "dragonpay_otc_non_banking"];
    return ka(D).call(D, e.type) > -1;
  }, s = gs({ schema: je(t = []).call(t, Pn(o() ? ["issuer"] : []), ["shopperEmail"]), rules: { issuer: { validate: function(D) {
    return o() && !!D;
  }, modes: ["input", "blur"] }, shopperEmail: V2.shopperEmail } }), c = s.handleChangeFor, u = s.triggerValidation, f = s.data, m = s.valid, v = s.errors, y = s.isValid, b = iD({}, e.type, a), S = It(n = e.items).call(n, function(D) {
    return gX(gX({}, D), {}, { icon: b(D.id && D.id.toLowerCase()) });
  }), x = function(D) {
    return D === "dragonpay_otc_non_banking" ? "dragonpay.voucher.non.bank.selectField.placeholder" : "dragonpay.voucher.bank.selectField.placeholder";
  };
  Rt(function() {
    e.onChange({ isValid: y, data: f, valid: m, errors: v });
  }, [y, f, m, v]);
  var E = Je("ready"), N = ze(E, 2), R = N[0], O = N[1];
  return this.setStatus = O, this.showValidation = u, P("div", { className: "adyen-checkout__dragonpay-input__field" }, P(xn, { label: r.get("shopperEmail"), errorMessage: !!v.shopperEmail, name: "dragonpay-shopperEmail" }, P(rC, { name: "dragonpay-shopperEmail", autoCorrect: "off", value: f.shopperEmail, className: "adyen-checkout__input--large", spellCheck: !1, onInput: c("shopperEmail", "input"), onBlur: c("shopperEmail", "blur") })), o() && P(xn, { label: r.get(x(e.type)), errorMessage: !!v.issuer, name: "issuer" }, P(Ad, { items: S, selectedValue: f.issuer, placeholder: r.get(x(e.type)), name: "issuer", className: "adyen-checkout__dropdown--large adyen-checkout__issuer-list__dropdown", onChange: c("issuer") })), e.showPayButton && e.payButton({ status: R, label: r.get("confirmPurchase") }));
}
function NJe(e) {
  var t = e.reference, n = e.totalAmount, r = e.surcharge, a = e.expiresAt, o = e.alternativeReference, s = e.instructionsUrl, c = e.icon, u = e.issuer, f = e.paymentMethodType, m = wt().i18n, v = oa(), y = f !== "dragonpay_otc_philippines" ? iD({}, f, v)(u.toLowerCase()) : null;
  return P(av, { reference: t, paymentMethodType: f, introduction: m.get("voucher.introduction"), imageUrl: c, issuerImageUrl: y, instructionsUrl: s, amount: n && m.amount(n.value, n.currency), surcharge: r && m.amount(r.value, r.currency), voucherDetails: [{ label: m.get("voucher.expirationDate"), value: m.dateTime(a) }, { label: m.get("voucher.alternativeReference"), value: o }], copyBtn: !0 });
}
function yX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _y(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = yX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = yX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function TJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(hse, "type", "molpay_ebanking_VN"), mse.defaultProps = { data: {}, items: [], onChange: function() {
} };
var I4 = function(e) {
  ft(n, Dr);
  var t = TJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "formatData", value: function() {
    var r = this.state.data, a = r.issuer, o = r.shopperEmail;
    return _y(_y({}, o && { shopperEmail: o }), {}, { paymentMethod: _y(_y({}, a && { issuer: a }), {}, { type: this.props.type || n.type }) });
  } }, { key: "formatProps", value: function(r) {
    var a, o;
    return _y(_y({}, r), {}, { issuers: (a = (o = r.details) === null || o === void 0 || (o = Ji(o).call(o, function(s) {
      return s.key === "issuer";
    })) === null || o === void 0 ? void 0 : o.items) !== null && a !== void 0 ? a : r.issuers });
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, this.props.reference ? P(NJe, kt({ ref: function(a) {
      r.componentRef = a;
    }, icon: this.icon }, this.props)) : P(mse, kt({ ref: function(a) {
      r.componentRef = a;
    }, items: this.props.issuers }, this.props, { onChange: this.setState, onSubmit: this.submit, payButton: this.payButton })));
  } }]), n;
}();
function OJe(e) {
  var t, n = _n(null), r = wt().i18n, a = Je("ready"), o = ze(a, 2), s = o[0], c = o[1], u = _n({});
  return Pe(u.current).length || (t = e.setComponentRef) === null || t === void 0 || t.call(e, u.current), u.current.showValidation = function() {
    var f;
    (f = n.current) === null || f === void 0 || f.showValidation();
  }, u.current.setStatus = c, P("div", { className: "adyen-checkout__doku-input__field" }, e.showFormInstruction && P(Qp, null), P(aC, { data: e.data, requiredFields: ["firstName", "lastName", "shopperEmail"], onChange: e.onChange, namePrefix: "doku", setComponentRef: function(f) {
    n.current = f;
  } }), e.showPayButton && e.payButton({ status: s, label: r.get("confirmPurchase") }));
}
T(I4, "type", "dragonpay");
var RJe = function(e) {
  var t = e.reference, n = e.expiresAt, r = e.instructionsUrl, a = e.shopperName, o = e.merchantName, s = e.totalAmount, c = e.paymentMethodType, u = wt().i18n, f = oa();
  return P(av, { paymentMethodType: c, reference: t, introduction: u.get("voucher.introduction.doku"), imageUrl: f()(c), instructionsUrl: r, amount: s && u.amount(s.value, s.currency), voucherDetails: [{ label: u.get("voucher.expirationDate"), value: u.date(n) }, { label: u.get("voucher.shopperName"), value: a }, { label: u.get("voucher.merchantName"), value: o }], copyBtn: !0 });
};
function bX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _X(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = bX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = bX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function MJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Nl = function(e) {
  ft(n, Dr);
  var t = MJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "formatData", value: function() {
    return _X(_X({}, this.state.data), {}, { paymentMethod: { type: this.props.type || n.type } });
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, this.props.reference ? P(RJe, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props)) : P(OJe, kt({ setComponentRef: this.setComponentRef }, this.props, { onChange: this.setState, onSubmit: this.submit, payButton: this.payButton })));
  } }]), n;
}();
T(Nl, "type", "doku"), T(Nl, "defaultProps", { showFormInstruction: !0 });
var DJe = { socialSecurityNumber: { validate: cD, errorMessage: "error.va.gen.02", modes: ["blur"] }, shopperEmail: V2.shopperEmail, default: { validate: function(e) {
  return !!e && e.length > 0;
}, errorMessage: "error.va.gen.02", modes: ["blur"] }, firstName: { validate: function(e) {
  return !!e && e.length > 0;
}, errorMessage: "firstName.invalid", modes: ["blur"] }, lastName: { validate: function(e) {
  return !!e && e.length > 0;
}, errorMessage: "lastName.invalid", modes: ["blur"] } }, LJe = { socialSecurityNumber: function(e) {
  return uD(e);
} };
function vse(e) {
  var t = e.errors, n = e.value, r = e.onInput, a = e.onBlur, o = wt().i18n, s = Je(!1), c = ze(s, 2), u = c[0], f = c[1];
  return P("div", { className: Tt("adyen-checkout__fieldset", "adyen-checkout__fieldset--sendCopyToEmail", e.classNames) }, P(xn, { classNameModifiers: ["sendCopyToEmail"], name: "sendCopyToEmail", useLabelElement: !1, addContextualElement: !1 }, P(U2, { onChange: function(m) {
    f(m.target.checked), e.onToggle(u);
  }, label: o.get("boleto.sendCopyToEmail"), name: "sendCopyToEmail" })), u && P(xn, { label: o.get("shopperEmail"), classNameModifiers: ["shopperEmail"], errorMessage: t && t.errorMessage ? o.get(t.errorMessage) : !!t, name: "shopperEmail" }, P(rC, { name: "shopperEmail", autoCorrect: "off", spellCheck: !1, value: n, onInput: r, onBlur: a })));
}
function gse(e) {
  var t = e.i18n, n = e.data, r = e.handleChangeFor, a = e.errors, o = e.valid, s = function(c) {
    return c && c.errorMessage ? t.get(c.errorMessage) : !!c;
  };
  return P("div", { className: "adyen-checkout__fieldset adyen-checkout__fieldset--address adyen-checkout__fieldset--personalDetails" }, P("div", { className: "adyen-checkout__fieldset__title" }, t.get("personalDetails")), P("div", { className: "adyen-checkout__fieldset__fields" }, P(xn, { label: t.get("firstName"), classNameModifiers: ["firstName", "col-50"], errorMessage: s(a.firstName), name: "firstName" }, P(vi, { name: "firstName", autocorrect: "off", spellcheck: !1, value: n.firstName, onInput: r("firstName", "input"), onBlur: r("firstName", "blur") })), P(xn, { label: t.get("lastName"), classNameModifiers: ["lastName", "col-50"], errorMessage: s(a.lastName), name: "lastName" }, P(vi, { name: "lastName", autocorrect: "off", spellcheck: !1, value: n.lastName, onInput: r("lastName", "input"), onBlur: r("lastName", "blur") })), P(kie, { data: n.socialSecurityNumber, error: a.socialSecurityNumber, valid: o.socialSecurityNumber, onInput: r("socialSecurityNumber", "input"), onBlur: r("socialSecurityNumber", "blur") })));
}
function CX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function wX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = CX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = CX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function yse(e) {
  var t = wt().i18n, n = _n(null), r = gs({ schema: ["firstName", "lastName", "socialSecurityNumber", "billingAddress", "shopperEmail"], defaultData: e.data, rules: DJe, formatters: LJe }), a = r.handleChangeFor, o = r.triggerValidation, s = r.setSchema, c = r.setData, u = r.setValid, f = r.setErrors, m = r.data, v = r.valid, y = r.errors, b = r.isValid, S = Je(!1), x = ze(S, 2), E = x[0], N = x[1];
  Rt(function() {
    var q, pe = je(q = []).call(q, Pn(e.personalDetailsRequired ? ["firstName", "lastName", "socialSecurityNumber"] : []), Pn(e.billingAddressRequired ? ["billingAddress"] : []), Pn(E ? ["shopperEmail"] : []));
    s(pe);
  }, [E, e.personalDetailsRequired, e.billingAddressRequired]);
  var R, O = Je("ready"), D = ze(O, 2), $ = D[0], B = D[1], G = _n({});
  Pe(G.current).length || (R = e.setComponentRef) === null || R === void 0 || R.call(e, G.current), G.current.showValidation = function() {
    o(), e.billingAddressRequired && n.current.showValidation();
  }, G.current.setStatus = B, Rt(function() {
    var q = !e.billingAddressRequired || !!v.billingAddress;
    e.onChange({ data: m, valid: v, errors: y, isValid: b && q });
  }, [m, v, y]);
  var Z = Pn(e.personalDetailsRequired || e.billingAddressRequired || e.showEmailAddress ? [] : ["standalone"]), K = e.showFormInstruction && (e.personalDetailsRequired || e.billingAddressRequired);
  return P("div", { className: "adyen-checkout__boleto-input__field" }, K && P(Qp, null), e.personalDetailsRequired && P(gse, { i18n: t, data: m, handleChangeFor: a, errors: y, valid: v }), e.billingAddressRequired && P(t1, { allowedCountries: ["BR"], label: "billingAddress", data: wX(wX({}, e.data.billingAddress), {}, { country: "BR" }), onChange: function(q) {
    c("billingAddress", q.data), u("billingAddress", q.isValid), f("billingAddress", q.errors);
  }, requiredFields: ["country", "street", "houseNumberOrName", "postalCode", "city", "stateOrProvince"], setComponentRef: function(q) {
    n.current = q;
  } }), e.showEmailAddress && P(vse, { value: m.shopperEmail, errors: y.shopperEmail, onToggle: function() {
    return N(!E);
  }, onInput: a("shopperEmail", "input"), onBlur: a("shopperEmail", "blur") }), e.showPayButton && e.payButton({ status: $, label: t.get("boletobancario.btnLabel"), classNameModifiers: Z }));
}
yse.defaultProps = { data: {}, showEmailAddress: !0, personalDetailsRequired: !0, billingAddressRequired: !0, showFormInstruction: !0 };
var $Je = function(e) {
  var t, n = wt(), r = n.i18n, a = n.loadingContext, o = oa(), s = e.reference, c = e.expiresAt, u = e.totalAmount, f = e.paymentMethodType, m = e.downloadUrl, v = s.replace(/[^\d]/g, "").replace(/^(\d{4})(\d{5})\d{1}(\d{10})\d{1}(\d{10})\d{1}(\d{15})$/, "$1$5$2$3$4"), y = je(t = "".concat(a, "barcode.shtml?data=")).call(t, v, "&barcodeType=BT_Int2of5A&fileType=png");
  return P(av, { reference: s, paymentMethodType: "boletobancario", barcode: y, introduction: r.get("voucher.introduction"), imageUrl: o()(f), amount: u && r.amount(u.value, u.currency), voucherDetails: [{ label: r.get("voucher.expirationDate"), value: r.date(c) }], downloadUrl: m, copyBtn: !0 });
};
function SX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ux(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = SX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = SX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function jJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var ym = function(e) {
  ft(n, Dr);
  var t = jJe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "handleRef", function(u) {
      a.componentRef = u;
    }), a;
  }
  return et(n, [{ key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "formatData", value: function() {
    var r = this.state.data, a = r === void 0 ? {} : r, o = a.billingAddress, s = a.shopperEmail, c = a.firstName, u = a.lastName, f = a.socialSecurityNumber, m = f === void 0 ? "" : f;
    return ux(ux(ux(ux({ paymentMethod: { type: this.props.type || n.type } }, o && { billingAddress: o }), s && { shopperEmail: s }), c && u && { shopperName: { firstName: c, lastName: u } }), m && { socialSecurityNumber: lD(m) });
  } }, { key: "render", value: function() {
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, this.props.reference ? P($Je, kt({ ref: this.handleRef, icon: this.icon }, this.props)) : P(yse, kt({ setComponentRef: this.handleRef }, this.props, { onChange: this.setState, onSubmit: this.submit, payButton: this.payButton })));
  } }]), n;
}();
T(ym, "type", "boletobancario");
var FJe = function(e) {
  var t, n, r = wt(), a = r.i18n, o = r.loadingContext, s = oa(), c = e.alternativeReference, u = e.reference, f = e.expiresAt, m = e.merchantReference, v = e.totalAmount, y = e.paymentMethodType, b = e.downloadUrl, S = je(t = "".concat(o, "barcode.shtml?data=")).call(t, u, "&barcodeType=BT_Code128C&fileType=png"), x = je(n = []).call(n, Pn(f ? [{ label: a.get("voucher.expirationDate"), value: a.date(f) }] : []), Pn(m ? [{ label: a.get("voucher.shopperReference"), value: m }] : []), Pn(c ? [{ label: a.get("voucher.alternativeReference"), value: c }] : []));
  return P(av, { amount: v && a.amount(v.value, v.currency), barcode: S, copyBtn: !0, downloadUrl: b, imageUrl: s()(y), introduction: a.get("voucher.introduction"), paymentMethodType: "oxxo", reference: u, voucherDetails: x });
};
function xX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function EX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = xX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = xX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function BJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var FO = function(e) {
  ft(n, Dr);
  var t = BJe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "handleRef", function(u) {
      a.componentRef = u;
    }), a;
  }
  return et(n, [{ key: "isValid", get: function() {
    return !0;
  } }, { key: "formatData", value: function() {
    return { paymentMethod: { type: this.props.type || n.type } };
  } }, { key: "render", value: function() {
    var r;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, this.props.reference ? P(FJe, kt({ ref: this.handleRef }, this.props)) : this.props.showPayButton && this.payButton(EX(EX({}, this.props), {}, { classNameModifiers: ["standalone"], label: je(r = "".concat(this.props.i18n.get("continueTo"), " ")).call(r, this.props.name), onClick: this.submit })));
  } }]), n;
}();
T(FO, "type", "oxxo"), T(FO, "defaultProps", { showPayButton: !1, name: "Oxxo" });
var VJe = function(e) {
  var t, n = wt().i18n, r = oa(), a = e.entity, o = e.reference, s = e.expiresAt, c = e.merchantReference, u = e.totalAmount, f = e.paymentMethodType, m = e.downloadUrl, v = je(t = []).call(t, Pn(a ? [{ label: n.get("voucher.entity"), value: a }] : []), Pn(s ? [{ label: n.get("voucher.expirationDate"), value: n.date(s) }] : []), Pn(c ? [{ label: n.get("voucher.shopperReference"), value: c }] : []));
  return P(av, { amount: u && n.amount(u.value, u.currency), barcode: null, copyBtn: !0, downloadUrl: m, imageUrl: r()(f), introduction: n.get("voucher.introduction"), paymentMethodType: "multibanco", reference: o, voucherDetails: v });
};
function IX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = IX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = IX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function UJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var BO = function(e) {
  ft(n, Dr);
  var t = UJe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "handleRef", function(u) {
      a.componentRef = u;
    }), a;
  }
  return et(n, [{ key: "isValid", get: function() {
    return !0;
  } }, { key: "formatProps", value: function(r) {
    return kX(kX({}, r), {}, { name: r.name || "Multibanco" });
  } }, { key: "formatData", value: function() {
    return { paymentMethod: { type: this.props.type || n.type } };
  } }, { key: "render", value: function() {
    var r = this;
    return this.props.reference ? P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(VJe, kt({ ref: this.handleRef }, this.props))) : this.props.showPayButton ? P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(Lf, { showPayButton: this.props.showPayButton, name: this.displayName, amount: this.props.amount, payButton: this.payButton, onSubmit: this.submit, ref: function(a) {
      r.componentRef = a;
    } })) : null;
  } }]), n;
}();
function GJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(BO, "type", "multibanco"), T(BO, "defaultProps", { showPayButton: !0 });
var VO = function(e) {
  ft(n, ys);
  var t = GJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n);
}();
function AX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function PX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = AX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = AX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function zJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(VO, "type", "dotpay");
var bse = function(e) {
  ft(n, ys);
  var t = zJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return PX(PX({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { showImage: !1 });
  } }]), n;
}();
function HJe(e) {
  var t = e.children, n = e.classNames, r = n === void 0 ? [] : n, a = e.type, o = a === void 0 ? "error" : a, s = e.icon;
  return P("div", { className: Tt("adyen-checkout__alert-message", "adyen-checkout__alert-message--".concat(o), r) }, s && P(h_, { className: "adyen-checkout__alert-message__icon", type: s }), t);
}
T(bse, "type", "eps");
var WJe = ["brand", "amount", "balance", "transactionLimit"];
function ZJe(e) {
  e.brand;
  var t = e.amount, n = e.balance, r = e.transactionLimit, a = pa(e, WJe), o = wt().i18n, s = t.value > (r == null ? void 0 : r.value) ? r : t, c = (n == null ? void 0 : n.value) - (s == null ? void 0 : s.value);
  return P("div", { className: "adyen-checkout__giftcard-result" }, P("ul", { className: "adyen-checkout__giftcard-result__balance" }, P("li", { className: "adyen-checkout__giftcard-result__balance__item" }, P("span", { className: "adyen-checkout__giftcard-result__balance__title" }, o.get("giftcardBalance")), P("span", { className: "adyen-checkout__giftcard-result__balance__value adyen-checkout__giftcard-result__balance__value--amount" }, o.amount(n.value, n.currency))), r && r.value && P("li", { className: "adyen-checkout__giftcard-result__balance__item" }, P("span", { className: "adyen-checkout__giftcard-result__balance__title adyen-checkout__giftcard-result__balance__title--transactionLimit" }, o.get("giftcardTransactionLimit", { values: { amount: o.amount(r.value, r.currency) } })))), this.props.showPayButton && this.props.payButton({ amount: s, status: a.status, onClick: a.onSubmit }), P("p", { className: "adyen-checkout__giftcard-result__remaining-balance" }, o.get("partialPayment.remainingBalance", { values: { amount: o.amount(c, n.currency) } })));
}
var _se = function(e) {
  var t, n = e.i18n, r = e.classNameModifiers, a = e.sfpState, o = e.getCardErrorMessage, s = e.focusedElement, c = e.setFocusOn;
  return P(xn, { label: n.get("creditCard.numberField.title"), classNameModifiers: je(t = ["number"]).call(t, Pn(r)), errorMessage: o(a), focused: s === "encryptedCardNumber", onFocusField: function() {
    return c("encryptedCardNumber");
  }, dir: "ltr", name: "encryptedCardNumber", errorVisibleToScreenReader: !1 }, P(rv, { encryptedFieldType: "encryptedCardNumber", "data-info": '{"length":"15-32", "maskInterval":4}', className: Tt({ "adyen-checkout__input": !0, "adyen-checkout__input--large": !0, "adyen-checkout__card__cardNumber__input": !0, "adyen-checkout__input--error": o(a), "adyen-checkout__input--focus": s === "encryptedCardNumber" }) }));
}, Cse = function(e) {
  var t, n = e.i18n, r = e.classNameModifiers, a = e.sfpState, o = e.focusedElement, s = e.setFocusOn, c = e.label, u = c === void 0 ? n.get("creditCard.pin.title") : c;
  return P(xn, { label: u, classNameModifiers: je(t = ["pin"]).call(t, Pn(r)), errorMessage: a.errors.encryptedSecurityCode && n.get(a.errors.encryptedSecurityCode), focused: o === "encryptedSecurityCode", onFocusField: function() {
    return s("encryptedSecurityCode");
  }, dir: "ltr", name: "encryptedSecurityCode", errorVisibleToScreenReader: !1 }, P(rv, { encryptedFieldType: "encryptedSecurityCode", "data-info": '{"length":"3-10", "maskInterval": 0}', className: Tt({ "adyen-checkout__input": !0, "adyen-checkout__input--large": !0, "adyen-checkout__card__cvc__input": !0, "adyen-checkout__input--error": a.errors.encryptedSecurityCode, "adyen-checkout__input--focus": o === "encryptedSecurityCode" }) }));
};
function YJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var wse = function(e) {
  ft(n, yo);
  var t = YJe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "state", { status: "ready", data: {}, balance: null, transactionLimit: null, focusedElement: !1, isValid: !1 }), T(Se(a), "sfp", void 0), T(Se(a), "onChange", function(u) {
      a.props.onChange({ data: u.data, isValid: u.isSfpValid });
    }), T(Se(a), "showValidation", function() {
      a.sfp.showValidation();
    }), T(Se(a), "handleFocus", function(u) {
      a.setState({ focusedElement: u.currentFocusObject }), u.focus === !0 ? a.props.onFocus(u) : a.props.onBlur(u);
    }), T(Se(a), "setBalance", function(u) {
      var f = u.balance, m = u.transactionLimit;
      a.setState({ balance: f, transactionLimit: m });
    }), a;
  }
  return et(n, [{ key: "setStatus", value: function(r) {
    this.setState({ status: r });
  } }, { key: "render", value: function(r, a) {
    var o, s = this, c = a.focusedElement, u = a.balance, f = a.transactionLimit, m = wt().i18n, v = (f == null ? void 0 : f.value) < (u == null ? void 0 : u.value) ? f : u, y = (v == null ? void 0 : v.value) >= ((o = this.props.amount) === null || o === void 0 ? void 0 : o.value);
    if (v && y) return P(ZJe, kt({ balance: u, transactionLimit: f, onSubmit: r.onSubmit }, r));
    var b = function(S) {
      if (S.errors.encryptedCardNumber) return m.get(S.errors.encryptedCardNumber);
      switch (s.state.status) {
        case "no-balance":
          return m.get("error.giftcard.no-balance");
        case "card-error":
          return m.get("error.giftcard.card-error");
        case "currency-error":
          return m.get("error.giftcard.currency-error");
        default:
          return null;
      }
    };
    return P("div", { className: "adyen-checkout__giftcard" }, this.state.status === "error" && P(HJe, { icon: "cross" }, m.get("error.message.unknown")), P(sC, kt({}, this.props, { ref: function(S) {
      s.sfp = S;
    }, onChange: this.onChange, onFocus: this.handleFocus, type: r6, render: function(S, x) {
      var E = S.setRootNode, N = S.setFocusOn;
      return s.props.fieldsLayoutComponent({ i18n: m, pinRequired: s.props.pinRequired, focusedElement: c, getCardErrorMessage: b, setRootNode: E, setFocusOn: N, sfpState: x });
    } })), this.props.showPayButton && this.props.payButton({ status: this.state.status, onClick: this.props.onBalanceCheck, label: m.get("applyGiftcard") }));
  } }]), n;
}();
function NX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function TX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = NX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = NX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function XJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(wse, "defaultProps", { pinRequired: !0, expiryDateRequired: !1, onChange: function() {
}, onFocus: function() {
}, onBlur: function() {
}, fieldsLayoutComponent: function(e) {
  var t = e.setRootNode, n = e.pinRequired;
  return P("div", { ref: t, className: "adyen-checkout__field-wrapper" }, P(_se, kt({}, e, { classNameModifiers: n ? ["70"] : ["100"] })), n && P(Cse, kt({}, e, { classNameModifiers: ["30"] })));
} });
var OX, p6 = function(e) {
  ft(n, Dr);
  var t = XJe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "handleBalanceCheck", function(u) {
      return a.props.onBalanceCheck ? new Yt(function(f, m) {
        a.props.onBalanceCheck(f, m, u);
      }) : a.props.session ? a.props.session.checkBalance(u) : void 0;
    }), T(Se(a), "onOrderRequest", function(u) {
      return a.props.onOrderRequest ? new Yt(function(f, m) {
        a.props.onOrderRequest(f, m, u);
      }) : a.props.session ? a.props.session.createOrder() : void 0;
    }), T(Se(a), "handleOrder", function(u) {
      var f = u.order;
      if (a.updateParent({ order: f }), a.props.session && a.props.onOrderCreated) return a.props.onOrderCreated(f);
    }), T(Se(a), "onBalanceCheck", function() {
      return a.props.session || a.props.onBalanceCheck ? a.isValid ? (a.setStatus("loading"), void a.handleBalanceCheck(a.formatData()).then(function(u) {
        var f, m = u.balance, v = u.transactionLimit, y = v === void 0 ? {} : v;
        if (!m) throw new Error("card-error");
        if ((m == null ? void 0 : m.currency) !== ((f = a.props.amount) === null || f === void 0 ? void 0 : f.currency)) throw new Error("currency-error");
        if ((m == null ? void 0 : m.value) <= 0) throw new Error("no-balance");
        if (a.componentRef.setBalance({ balance: m, transactionLimit: y }), a.props.amount.value > m.value || a.props.amount.value > y.value) return a.props.order ? a.submit() : a.onOrderRequest(a.data).then(function(b) {
          a.setState({ order: { orderData: b.orderData, pspReference: b.pspReference } }), a.submit();
        });
        a.props.onRequiringConfirmation && a.props.onRequiringConfirmation();
      }).catch(function(u) {
        a.setStatus((u == null ? void 0 : u.message) || "error"), a.props.onError && a.handleError(new _r("ERROR", u));
      })) : (a.showValidation(), !1) : a.submit();
    }), T(Se(a), "payButton", function(u) {
      return P(ev, u);
    }), a;
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return TX(TX({}, r == null ? void 0 : r.configuration), r);
  } }, { key: "formatData", value: function() {
    var r, a;
    return { paymentMethod: { type: this.constructor.type, brand: this.props.brand, encryptedCardNumber: (r = this.state.data) === null || r === void 0 ? void 0 : r.encryptedCardNumber, encryptedSecurityCode: (a = this.state.data) === null || a === void 0 ? void 0 : a.encryptedSecurityCode } };
  } }, { key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "icon", get: function() {
    var r;
    return ((r = this.props.brandsConfiguration[this.props.brand]) === null || r === void 0 ? void 0 : r.icon) || this.props.icon || this.resources.getImage()(this.props.brand);
  } }, { key: "displayName", get: function() {
    var r;
    return ((r = this.props.brandsConfiguration[this.props.brand]) === null || r === void 0 ? void 0 : r.name) || this.props.name;
  } }, { key: "balanceCheck", value: function() {
    return this.onBalanceCheck();
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(wse, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props, { onChange: this.setState, onBalanceCheck: this.onBalanceCheck, onSubmit: this.submit, payButton: this.payButton })));
  } }]), n;
}();
function KJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(p6, "type", "giftcard"), T(p6, "defaultProps", { brandsConfiguration: {} });
var l7 = function(e) {
  ft(n, Mm);
  var t = KJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n);
}();
function RX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function MX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = RX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = RX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function qJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
OX = l7, T(l7, "type", "vipps"), T(l7, "defaultProps", { type: OX.type, showPayButton: !0, name: "Vipps" });
var Sse = function(e) {
  ft(n, ys);
  var t = qJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return MX(MX({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { showImage: !1 });
  } }]), n;
}();
function DX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function LX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = DX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = DX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function JJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(Sse, "type", "payu_IN_cashcard");
var xse = function(e) {
  ft(n, ys);
  var t = JJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return LX(LX({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { showImage: !1 });
  } }]), n;
}();
T(xse, "type", "payu_IN_nb");
var Ese = ["AT", "CH", "DE", "NL"];
function $X(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function jX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = $X(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = $X(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function QJe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Ise = function(e) {
  ft(n, gu);
  var t = QJe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return jX(jX({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { allowedCountries: r.countryCode ? [r.countryCode] : Ese });
  } }]), n;
}();
function FX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function eQe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(Ise, "type", "ratepay");
var kse = function(e) {
  ft(n, $f);
  var t = eQe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return function(a) {
      for (var o = 1; o < arguments.length; o++) {
        var s, c, u = arguments[o] != null ? arguments[o] : {};
        o % 2 ? Q(s = FX(Object(u), !0)).call(s, function(f) {
          T(a, f, u[f]);
        }) : ne ? Ze(a, ne(u)) : Q(c = FX(Object(u))).call(c, function(f) {
          We(a, f, re(u, f));
        });
      }
      return a;
    }({ delay: 2e3, countdownTime: 3, instructions: "swish.pendingMessage" }, Nn(fe(n.prototype), "formatProps", this).call(this, r));
  } }]), n;
}();
T(kse, "type", "swish");
var tQe = function(e) {
  var t = e.paymentMethodComponent, n = e.isLoaded;
  return t && n ? P("div", { className: "adyen-checkout__payment-method__details__content" }, t) : null;
}, O0 = { "adyen-checkout__payment-methods-list": "DropinComponent-module_adyen-checkout__payment-methods-list__mAjAm", "adyen-checkout__payment-method": "DropinComponent-module_adyen-checkout__payment-method__nWdwg", "adyen-checkout__payment-method__details": "DropinComponent-module_adyen-checkout__payment-method__details__-rsW7", "adyen-checkout__payment-method__image": "DropinComponent-module_adyen-checkout__payment-method__image__nB80V", "adyen-checkout__payment-method__image__wrapper": "DropinComponent-module_adyen-checkout__payment-method__image__wrapper__6NWzA", "adyen-checkout__payment-method--selected": "DropinComponent-module_adyen-checkout__payment-method--selected__6egZF" }, BX = ["googlepay", "paywithgoogle"], dC = function(e) {
  var t = e.src, n = e.altDescription, r = e.type, a = e.disabled, o = a !== void 0 && a;
  return P("span", { className: Tt("adyen-checkout__payment-method__image__wrapper", O0["adyen-checkout__payment-method__image__wrapper"], { "adyen-checkout__payment-method__image__wrapper--outline": !jt(BX).call(BX, r), "adyen-checkout__payment-method__image__wrapper--disabled": !!o }) }, P(ps, { className: "adyen-checkout__payment-method__image ".concat(O0["adyen-checkout__payment-method__image"]), src: t, alt: n }));
}, nQe = function(e) {
  var t = e.id, n = e.open, r = e.onDisable, a = e.onCancel, o = wt().i18n;
  return P("div", { id: t, "aria-hidden": !n, className: Tt({ "adyen-checkout__payment-method__disable-confirmation": !0, "adyen-checkout__payment-method__disable-confirmation--open": n }) }, P("div", { className: "adyen-checkout__payment-method__disable-confirmation__content" }, o.get("storedPaymentMethod.disable.confirmation"), P("div", { className: "adyen-checkout__payment-method__disable-confirmation__buttons" }, P("button", { type: "button", className: Tt("adyen-checkout__button", "adyen-checkout__payment-method__disable-confirmation__button", "adyen-checkout__payment-method__disable-confirmation__button--remove"), disabled: !n, onClick: r }, o.get("storedPaymentMethod.disable.confirmButton")), P("button", { type: "button", className: Tt("adyen-checkout__button", "adyen-checkout__payment-method__disable-confirmation__button", "adyen-checkout__payment-method__disable-confirmation__button--cancel"), disabled: !n, onClick: a }, o.get("storedPaymentMethod.disable.cancelButton")))));
}, rQe = function(e) {
  var t = e.allowedBrands;
  if (e.isPaymentMethodSelected) return null;
  var n = function(o) {
    var s = o.length <= 4 ? o : Xo(o).call(o, 0, 3);
    return { visibleBrands: s, leftBrandsAmount: o.length - s.length };
  }(t), r = n.visibleBrands, a = n.leftBrandsAmount;
  return P("span", { className: "adyen-checkout__payment-method__brands" }, It(r).call(r, function(o) {
    return P(dC, { key: o.name, altDescription: lC(o.name), type: o.name, src: o.icon });
  }), a !== 0 && P("span", { className: "adyen-checkout__payment-method__brand-number" }, "+", a));
}, aQe = function(e) {
  var t = e.activeBrand, n = e.brands, r = e.excludedUIBrands, a = e.isPaymentMethodSelected, o = e.isCompactView, s = o === void 0 || o, c = Oe(n).call(n, function(u) {
    return !(r != null && jt(r).call(r, u.name));
  });
  return s ? P(rQe, { allowedBrands: c, isPaymentMethodSelected: a }) : P("span", { className: "adyen-checkout__payment-method__brands" }, It(c).call(c, function(u) {
    return P(dC, { key: u.name, altDescription: lC(u.name), type: u.name, src: u.icon, disabled: t && t !== u.name });
  }));
}, oQe = function(e) {
  var t = e.displayName, n = e.additionalInfo, r = e.isSelected;
  return P("span", { className: "adyen-checkout__payment-method__name_wrapper" }, P("span", { className: Tt({ "adyen-checkout__payment-method__name": !0, "adyen-checkout__payment-method__name--selected": r }) }, t), n && P("span", { className: Tt({ "adyen-checkout__payment-method__additional-info": !0, "adyen-checkout__payment-method__additional-info--selected": r }) }, n));
};
function VX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function UX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = VX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = VX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function iQe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Ase = function(e) {
  ft(n, yo);
  var t = iQe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "state", { showDisableStoredPaymentMethodConfirmation: !1, activeBrand: null }), T(Se(a), "toggleDisableConfirmation", function() {
      a.setState({ showDisableStoredPaymentMethodConfirmation: !a.state.showDisableStoredPaymentMethodConfirmation });
    }), T(Se(a), "onDisableStoredPaymentMethod", function() {
      a.props.onDisableStoredPaymentMethod(a.props.paymentMethod), a.toggleDisableConfirmation();
    }), T(Se(a), "handleOnListItemClick", function() {
      var u = a.props;
      (0, u.onSelect)(u.paymentMethod);
    }), a;
  }
  return et(n, [{ key: "componentDidMount", value: function() {
    var r = this;
    this.props.paymentMethod.eventEmitter.on("brand", function(a) {
      r.setState({ activeBrand: a.brand });
    });
  } }, { key: "componentWillUnmount", value: function() {
    var r = this;
    this.props.paymentMethod.eventEmitter.off("brand", function(a) {
      r.setState({ activeBrand: a.brand });
    });
  } }, { key: "render", value: function(r, a) {
    var o, s = r.paymentMethod, c = r.isSelected, u = r.isDisablingPaymentMethod, f = r.isLoaded, m = r.isLoading, v = r.standalone, y = a.activeBrand, b = wt().i18n;
    if (!s) return null;
    var S = s.props.type === "card" || s.props.type === "scheme", x = Tt(UX(UX(T(T({ "adyen-checkout__payment-method": !0 }, O0["adyen-checkout__payment-method"], !0), "adyen-checkout__payment-method--".concat(s.props.type), !0), S && T({}, "adyen-checkout__payment-method--".concat((o = s.props.fundingSource) !== null && o !== void 0 ? o : "credit"), !0)), {}, T(T(T(T(T(T(T(T({ "adyen-checkout__payment-method--selected": c }, O0["adyen-checkout__payment-method--selected"], c), "adyen-checkout__payment-method--loading", m), "adyen-checkout__payment-method--disabling", u), "adyen-checkout__payment-method--confirming", this.state.showDisableStoredPaymentMethodConfirmation), "adyen-checkout__payment-method--standalone", v), O0["adyen-checkout__payment-method--loading"], m), s._id, !0), this.props.className, !0))), E = this.props.showRemovePaymentMethodButton && s.props.oneClick && c, N = "remove-".concat(s._id), R = "container-".concat(s._id), O = "button-".concat(s._id), D = !s.props.oneClick && s.brands && s.brands.length > 0;
    return P("li", { key: s._id, className: x, onClick: this.handleOnListItemClick }, P("div", { className: "adyen-checkout__payment-method__header" }, P("button", { className: "adyen-checkout__payment-method__header__title", id: O, role: "radio", "aria-checked": c, type: "button" }, P("span", { className: Tt({ "adyen-checkout__payment-method__radio": !0, "adyen-checkout__payment-method__radio--selected": c }), "aria-hidden": "true" }), P(dC, kt({}, s.props.oneClick && { altDescription: s.props.name }, { type: s.type, src: s.icon })), P(oQe, { displayName: s.displayName, isSelected: c, additionalInfo: s.additionalInfo })), E && P("button", { type: "button", className: "adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link", onClick: this.toggleDisableConfirmation, "aria-expanded": this.state.showDisableStoredPaymentMethodConfirmation, "aria-controls": N }, b.get("storedPaymentMethod.disable.button")), D && P(aQe, { activeBrand: y, brands: s.brands, excludedUIBrands: Z4, isPaymentMethodSelected: c, isCompactView: s.props.showBrandsUnderCardNumber })), P("div", { className: "adyen-checkout__payment-method__details ".concat(O0["adyen-checkout__payment-method__details"]), id: R, role: "region" }, E && P(nQe, { id: N, open: this.state.showDisableStoredPaymentMethodConfirmation, onDisable: this.onDisableStoredPaymentMethod, onCancel: this.toggleDisableConfirmation }), P(tQe, { paymentMethodComponent: s.render(), isLoaded: f })));
  } }]), n;
}();
T(Ase, "defaultProps", { paymentMethod: null, isSelected: !1, isLoaded: !1, isLoading: !1, showDisableStoredPaymentMethodConfirmation: !1 });
var sQe = function(e) {
  var t, n = e.order, r = e.orderStatus, a = e.onOrderCancel, o = e.brandLogoConfiguration, s = wt().i18n, c = oa();
  return P("div", null, P("ul", { className: "adyen-checkout__order-payment-methods-list" }, r == null || (t = r.paymentMethods) === null || t === void 0 ? void 0 : It(t).call(t, function(u, f) {
    var m;
    return P("li", { key: je(m = "".concat(u.type, "-")).call(m, f), className: "adyen-checkout__order-payment-method" }, P("div", { className: "adyen-checkout__order-payment-method__header" }, P("div", { className: "adyen-checkout__payment-method__header__title" }, P(dC, { altDescription: u.name, type: u.type, src: o[u.type] || c()(u.type) }), "•••• ", u.lastFour), a && P("button", { type: "button", className: "adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link", onClick: function() {
      a({ order: n });
    } }, s.get("storedPaymentMethod.disable.button"))), P("div", { className: "adyen-checkout__order-payment-method__details" }, P("div", { className: "adyen-checkout__order-payment-method__deducted-amount" }, P("div", { className: "adyen-checkout__order-payment-method__deducted-amount__label" }, s.get("deductedBalance")), P("div", { className: "adyen-checkout__order-payment-method__deducted-amount__value" }, s.amount(u.amount.value, u.amount.currency)))));
  })), r.remainingAmount && P("div", { className: "adyen-checkout__order-remaining-amount" }, s.get("partialPayment.warning"), " ", P("strong", null, s.amount(r.remainingAmount.value, r.remainingAmount.currency))));
};
function lQe(e) {
  var t = e.paymentMethods, n = e.showContentSeparator, r = wt().i18n;
  return P(ra, null, P("ul", { className: "adyen-checkout__instant-payment-methods-list" }, It(t).call(t, function(a) {
    return P("li", { key: a.type }, a.render());
  })), n && P(z2, { label: r.get("orPayWith") }));
}
function GX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = GX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = GX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function uQe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Pse = function(e) {
  ft(n, yo);
  var t = uQe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "componentDidMount", value: function() {
    if (this.props.paymentMethods[0]) {
      var r = this.props.paymentMethods[0];
      (this.props.openFirstStoredPaymentMethod && yc(r, "props.oneClick") === !0 || this.props.openFirstPaymentMethod) && this.props.onSelect(r);
    }
  } }, { key: "render", value: function(r) {
    var a = this, o = r.paymentMethods, s = r.instantPaymentMethods, c = r.activePaymentMethod, u = r.cachedPaymentMethods, f = r.isLoading, m = r.isDisablingPaymentMethod, v = wt().i18n, y = Tt(T(T(T({}, O0["adyen-checkout__payment-methods-list"], !0), "adyen-checkout__payment-methods-list", !0), "adyen-checkout__payment-methods-list--loading", f)), b = function(x) {
      var E = Je({}), N = ze(E, 2), R = N[0], O = N[1];
      return Rt(function() {
        O(rr(x).call(x, function(D, $) {
          return zX(zX({}, D), $.props.brand && $.icon && T({}, $.props.brand, $.icon));
        }, {}));
      }, [x]), R;
    }(o), S = (o == null ? void 0 : o.length) > 0;
    return P(ra, null, this.props.orderStatus && P(sQe, { order: this.props.order, orderStatus: this.props.orderStatus, onOrderCancel: this.props.onOrderCancel, brandLogoConfiguration: b }), !!s.length && P(lQe, { showContentSeparator: S, paymentMethods: s }), P("ul", { className: y, role: "radiogroup", "aria-label": v.get("paymentMethodsList.aria.label"), required: !0 }, It(o).call(o, function(x, E, N) {
      var R = c && c._id === x._id, O = x._id in u, D = c && N[E + 1] && c._id === N[E + 1]._id;
      return P(Ase, { className: Tt({ "adyen-checkout__payment-method--next-selected": D }), standalone: o.length === 1, paymentMethod: x, isSelected: R, isDisablingPaymentMethod: R && m, isLoaded: O, isLoading: f, onSelect: a.props.onSelect, key: x._id, showRemovePaymentMethodButton: a.props.showRemovePaymentMethodButton, onDisableStoredPaymentMethod: a.props.onDisableStoredPaymentMethod });
    })));
  } }]), n;
}();
T(Pse, "defaultProps", { instantPaymentMethods: [], paymentMethods: [], activePaymentMethod: null, cachedPaymentMethods: {}, orderStatus: null, onSelect: function() {
}, onDisableStoredPaymentMethod: function() {
}, isDisablingPaymentMethod: !1, isLoading: !1 });
var cQe = function(e) {
  var t = e.message, n = wt().i18n, r = oa(), a = n.get(t || "creditCard.success");
  return gD(a), P("div", { className: "adyen-checkout__status adyen-checkout__status--success" }, P(ps, { height: "88", className: "adyen-checkout__status__icon", src: r({ extension: "gif", imageFolder: "components/" })("success"), alt: n.get(t || "creditCard.success") }), P("span", { className: "adyen-checkout__status__text" }, a));
}, dQe = function(e) {
  var t = e.message, n = wt().i18n, r = oa(), a = n.get(t || "error.message.unknown");
  return gD(a), P("div", { className: "adyen-checkout__status adyen-checkout__status--error" }, P(ps, { className: "adyen-checkout__status__icon", src: r({ extension: "gif", imageFolder: "components/" })("error"), alt: n.get(t || "error.message.unknown"), height: "88" }), P("span", { className: "adyen-checkout__status__text" }, a));
};
function HX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function WX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = HX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = HX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function fQe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var pQe = function(e) {
  ft(n, yo);
  var t = fQe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "state", { elements: [], instantPaymentElements: [], orderStatus: null, isDisabling: !1, status: { type: "loading", props: void 0 }, activePaymentMethod: null, cachedPaymentMethods: {} }), T(Se(a), "prepareDropinData", function() {
      var u = a.props, f = u.order, m = u.clientKey, v = u.loadingContext, y = a.props.onCreateElements(), b = ze(y, 3), S = b[0], x = b[1], E = b[2], N = f ? function(R, O) {
        return fl({ path: "v1/order/status?clientKey=".concat(R.clientKey), loadingContext: R.loadingContext }, { orderData: O.orderData });
      }({ clientKey: m, loadingContext: v }, f) : null;
      Yt.all([S, x, E, N]).then(function(R) {
        var O, D, $ = ze(R, 4), B = $[0], G = $[1], Z = $[2], K = $[3];
        a.setState({ instantPaymentElements: Z, elements: je(O = []).call(O, Pn(B), Pn(G)), orderStatus: K }), a.setStatus("ready"), (D = a.props.modules) === null || D === void 0 || D.analytics.sendAnalytics("dropin", { type: e1 });
      }), a.onOrderCancel = a.getOnOrderCancel();
    }), T(Se(a), "setStatus", function(u) {
      var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      a.setState({ status: { type: u, props: f } });
    }), T(Se(a), "setActivePaymentMethod", function(u) {
      a.setState(function(f) {
        return { activePaymentMethod: u, cachedPaymentMethods: WX(WX({}, f.cachedPaymentMethods), {}, T({}, u._id, !0)) };
      });
    }), T(Se(a), "handleOnSelectPaymentMethod", function(u) {
      var f = a.state.activePaymentMethod;
      a.setActivePaymentMethod(u), (f && f._id !== u._id || !f) && (a.props.onSelect(u), u.submitAnalytics({ type: e1 }));
    }), T(Se(a), "handleDisableStoredPaymentMethod", function(u) {
      a.setState({ isDisabling: !0 }), new Yt(function(f, m) {
        return a.props.onDisableStoredPaymentMethod(u.props.storedPaymentMethodId, f, m);
      }).then(function() {
        a.setState(function(f) {
          var m;
          return { elements: Oe(m = f.elements).call(m, function(v) {
            return v._id !== u._id;
          }) };
        }), a.setState({ isDisabling: !1 });
      }).catch(function() {
        a.setState({ isDisabling: !1 });
      });
    }), T(Se(a), "getOnOrderCancel", function() {
      return a.props.onOrderCancel ? function(u) {
        a.props.onOrderCancel(u);
      } : a.props.session ? function(u) {
        return a.props.session.cancelOrder(u).then(function() {
          return a.props._parentInstance.update({ order: null });
        }).catch(function(f) {
          return a.setStatus((f == null ? void 0 : f.message) || "error");
        });
      } : null;
    }), T(Se(a), "onOrderCancel", void 0), a;
  }
  return et(n, [{ key: "componentDidMount", value: function() {
    this.prepareDropinData();
  } }, { key: "componentDidUpdate", value: function(r, a) {
    a.status.type !== this.state.status.type && this.state.activePaymentMethod && this.state.activePaymentMethod.setStatus(this.state.status.type), this.state.status.type === "ready" && a.status.type !== "ready" && this.props.onReady && this.props.onReady();
  } }, { key: "closeActivePaymentMethod", value: function() {
    this.setState({ activePaymentMethod: null });
  } }, { key: "render", value: function(r, a) {
    var o, s, c, u, f = a.elements, m = a.instantPaymentElements, v = a.status, y = a.activePaymentMethod, b = a.cachedPaymentMethods, S = v.type === "loading", x = v.type === "redirect", E = (f == null ? void 0 : f.length) > 0 || (m == null ? void 0 : m.length) > 0;
    switch (v.type) {
      case "success":
        return P(cQe, { message: (r == null || (o = r.amount) === null || o === void 0 ? void 0 : o.value) === 0 ? "resultMessages.preauthorized" : (s = v.props) === null || s === void 0 ? void 0 : s.message });
      case "error":
        return P(dQe, { message: (c = v.props) === null || c === void 0 ? void 0 : c.message });
      case "custom":
        return (u = v.props) === null || u === void 0 || (u = u.component) === null || u === void 0 ? void 0 : u.render();
      default:
        return P("div", { className: "adyen-checkout__dropin adyen-checkout__dropin--".concat(v.type) }, x && v.props.component && v.props.component.render(), S && v.props && v.props.component && v.props.component.render(), E && P(Pse, { isLoading: S || x, isDisablingPaymentMethod: this.state.isDisabling, paymentMethods: f, instantPaymentMethods: m, activePaymentMethod: y, cachedPaymentMethods: b, order: this.props.order, orderStatus: this.state.orderStatus, onOrderCancel: this.onOrderCancel, onSelect: this.handleOnSelectPaymentMethod, openFirstPaymentMethod: this.props.openFirstPaymentMethod, openFirstStoredPaymentMethod: this.props.openFirstStoredPaymentMethod, onDisableStoredPaymentMethod: this.handleDisableStoredPaymentMethod, showRemovePaymentMethodButton: this.props.showRemovePaymentMethodButton }));
    }
  } }]), n;
}(), ZX = ["androidpay", "samsungpay", "clicktopay"], hQe = function(e) {
  return !jt(ZX).call(ZX, e.constructor.type);
}, mQe = function(e) {
  return !!e;
}, vQe = function(e) {
  if (e.isAvailable) {
    var t = new Yt(function(n, r) {
      return Ro(r, 5e3);
    });
    return Yt.race([e.isAvailable(), t]);
  }
  return Yt.resolve(!!e);
}, lN = function() {
  var e, t, n, r, a = arguments.length > 1 ? arguments[1] : void 0, o = arguments.length > 2 ? arguments[2] : void 0, s = Oe(e = Oe(t = It(n = function(u) {
    if (!A8(u).call(u, function(m) {
      return (m == null ? void 0 : m.type) === "upi";
    })) return u;
    var f = ["upi_qr", "upi_collect", "upi_intent"];
    return Oe(u).call(u, function(m) {
      return !jt(f).call(f, m == null ? void 0 : m.type);
    });
  }(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [])).call(n, function(u) {
    return o(u, a);
  })).call(t, mQe)).call(e, hQe), c = It(r = It(s).call(s, vQe)).call(r, function(u) {
    return u.catch(function(f) {
      return f;
    });
  });
  return Yt.all(c).then(function(u) {
    return Oe(s).call(s, function(f, m) {
      return u[m] === !0;
    });
  });
};
function YX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function XX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = YX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = YX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function KX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function qX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = KX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = KX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function JX(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = JX(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = JX(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function gQe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var QX = ["paywithgoogle", "googlepay", "applepay"], UO = function(e) {
  ft(n, Dr);
  var t = gQe(n);
  function n(r) {
    var a, o, s;
    return Qe(this, n), s = t.call(this, r), T(Se(s), "dropinRef", null), T(Se(s), "componentFromAction", void 0), T(Se(s), "handleCreate", function() {
      var c = s.props, u = c.paymentMethods, f = c.storedPaymentMethods, m = c.showStoredPaymentMethods, v = c.showPaymentMethods, y = c.instantPaymentMethods, b = function(N) {
        return { beforeSubmit: N.beforeSubmit, onSubmit: N.onSubmit, elementRef: N.elementRef, showPayButton: N.showPayButton, isDropin: !0 };
      }(hm(hm({}, s.props), {}, { elementRef: s.elementRef })), S = m ? function() {
        var N = arguments.length > 2 ? arguments[2] : void 0;
        return lN(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], XX(XX({}, arguments.length > 1 ? arguments[1] : void 0), {}, { oneClick: !0 }), N);
      }(f, b, s._parentInstance.create) : [], x = v ? lN(u, b, s._parentInstance.create) : [], E = function() {
        var N = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], R = arguments.length > 1 ? arguments[1] : void 0, O = arguments.length > 2 ? arguments[2] : void 0;
        return N.length ? lN(N, qX(qX({}, R), {}, { isInstantPayment: !0, showPayButton: !0 }), O) : [];
      }(y, b, s._parentInstance.create);
      return [S, x, E];
    }), T(Se(s), "handleOrder", function(c) {
      var u = c.order;
      s.updateParent({ order: u });
    }), s.submit = pn(a = s.submit).call(a, Se(s)), s.handleAction = pn(o = s.handleAction).call(o, Se(s)), s;
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    var a, o, s = Oe(a = soe(new xWe(r.instantPaymentTypes))).call(a, function(f) {
      return jt(QX).call(QX, f);
    }), c = rr(s).call(s, function(f, m) {
      var v, y, b = Ji(v = r.paymentMethods).call(v, function(S) {
        return S.type === m;
      });
      return b ? je(y = []).call(y, Pn(f), [b]) : f;
    }, []), u = Oe(o = r.paymentMethods).call(o, function(f) {
      var m = f.type;
      return !jt(s).call(s, m);
    });
    return hm(hm({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { instantPaymentTypes: s, instantPaymentMethods: c, paymentMethods: u });
  } }, { key: "isValid", get: function() {
    return !!this.dropinRef && !!this.dropinRef.state.activePaymentMethod && !!this.dropinRef.state.activePaymentMethod.isValid;
  } }, { key: "showValidation", value: function() {
    return this.dropinRef.state.activePaymentMethod && this.dropinRef.state.activePaymentMethod.showValidation(), this;
  } }, { key: "setStatus", value: function(r) {
    var a, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (a = this.dropinRef) === null || a === void 0 || a.setStatus(r, o), this;
  } }, { key: "activePaymentMethod", get: function() {
    var r, a;
    return (r = this.dropinRef) !== null && r !== void 0 && r.state || (a = this.dropinRef) !== null && a !== void 0 && a.state.activePaymentMethod ? this.dropinRef.state.activePaymentMethod : null;
  } }, { key: "data", get: function() {
    return this.activePaymentMethod ? this.dropinRef.state.activePaymentMethod.data : null;
  } }, { key: "submit", value: function() {
    if (!this.activePaymentMethod) throw new Error("No active payment method.");
    this.activePaymentMethod.submit();
  } }, { key: "handleAction", value: function(r) {
    var a, o, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!r || !r.type)
      throw Ir(r, "action") && Ir(r, "resultCode") ? new Error('handleAction::Invalid Action - the passed action object itself has an "action" property and a "resultCode": have you passed in the whole response object by mistake?') : new Error('handleAction::Invalid Action - the passed action object does not have a "type" property');
    if (r.type !== "redirect" && (a = this.activePaymentMethod) !== null && a !== void 0 && a.updateWithAction) return this.activePaymentMethod.updateWithAction(r);
    this.elementRef instanceof n && (s = hm(hm({}, (o = this.elementRef.activePaymentMethod) === null || o === void 0 ? void 0 : o.props), s));
    var c = this._parentInstance.createFromAction(r, hm(hm({}, s), {}, { elementRef: this.elementRef, onAdditionalDetails: this.handleAdditionalDetails, isDropin: !0 }));
    return c ? (this.setStatus(c.props.statusType, { component: c }), this.componentFromAction = c, this) : null;
  } }, { key: "closeActivePaymentMethod", value: function() {
    this.dropinRef.closeActivePaymentMethod();
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(eh, { srPanel: this.props.modules.srPanel }, P(pQe, kt({}, this.props, { onChange: this.setState, elementRef: this.elementRef, onCreateElements: this.handleCreate, ref: function(a) {
      r.dropinRef = a;
    } }))));
  } }]), n;
}();
T(UO, "type", "dropin"), T(UO, "defaultProps", { isDropin: !0, onReady: function() {
}, onComplete: function() {
}, onError: function() {
}, onSelect: function() {
}, onDisableStoredPaymentMethod: null, onChange: function() {
}, instantPaymentMethods: [], amount: {}, installmentOptions: {}, paymentMethodsConfiguration: {}, openFirstPaymentMethod: !0, openFirstStoredPaymentMethod: !0, showStoredPaymentMethods: !0, showPaymentMethods: !0, showRemoveStoredPaymentMethodButton: !1, showPayButton: !0 });
var yQe = "AchInput-module_sf-input__wrapper__lfdiv", Nse = "AchInput-module_adyen-checkout__input__8WwCR", GO = function(e) {
  return e.replace(/[^0-9]/g, "");
}, eK = function(e) {
  var t, n = e.id, r = e.dataInfo, a = e.className, o = a === void 0 ? "" : a, s = e.label, c = e.focused, u = e.filled, f = e.errorMessage, m = f === void 0 ? "" : f, v = e.isValid, y = v !== void 0 && v, b = e.onFocusField, S = e.dir, x = (t = n).charAt(0).toUpperCase() + Xo(t).call(t, 1), E = "encrypted".concat(x);
  return P(xn, { label: s, focused: c, filled: u, classNameModifiers: [n], onFocusField: function() {
    return b(E);
  }, errorMessage: m, isValid: y, className: o, dir: S, name: n, errorVisibleToScreenReader: !1 }, P(rv, { encryptedFieldType: E, "data-info": r, className: Tt(T(T(T(T({ "adyen-checkout__input": !0, "adyen-checkout__input--large": !0 }, Nse, !0), "adyen-checkout__input--error", m.length), "adyen-checkout__input--focus", c), "adyen-checkout__input--valid", y)) }));
}, bQe = function(e) {
  var t = e.focusedElement, n = e.onFocusField, r = e.errors, a = e.valid, o = wt().i18n;
  return P("div", { className: "adyen-checkout__ach-sf__form adyen-checkout__field-wrapper" }, P(eK, { id: "bankAccountNumber", focused: t === "encryptedBankAccountNumber", isValid: !!a.encryptedBankAccountNumber, label: o.get("ach.accountNumberField.title"), onFocusField: n, filled: !!r.encryptedBankAccountNumber || !!a.encryptedBankAccountNumber, errorMessage: !!r.encryptedBankAccountNumber && o.get(r.encryptedBankAccountNumber), dataInfo: '{"length":"4-17"}', className: "adyen-checkout__field--50", dir: "ltr" }), P(eK, { id: "bankLocationId", focused: t === "encryptedBankLocationId", isValid: !!a.encryptedBankLocationId, label: o.get("ach.accountLocationField.title"), onFocusField: n, filled: !!r.encryptedBankLocationId || !!a.encryptedBankLocationId, errorMessage: !!r.encryptedBankLocationId && o.get(r.encryptedBankLocationId), dataInfo: '{"length":9}', className: "adyen-checkout__field--50", dir: "ltr" }));
}, _Qe = { base: { caretColor: "#0075FF" } };
function tK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ho(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = tK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = tK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function cx(e) {
  return !(arguments.length > 1 && arguments[1] !== void 0 && arguments[1]) || !!e && typeof e == "string" && zp(e).call(e).length > 0;
}
function Tse(e) {
  var t, n = this, r = wt().i18n, a = e.hasHolderName && (!!e.holderName || !!e.data.holderName), o = Je({}), s = ze(o, 2), c = s[0], u = s[1], f = Je(ho({}, e.holderNameRequired && { holderName: a })), m = ze(f, 2), v = m[0], y = m[1], b = Je(ho({}, e.hasHolderName && { holderName: e.holderName || e.data.holderName })), S = ze(b, 2), x = S[0], E = S[1], N = Je(e.billingAddressRequired ? e.data.billingAddress : null), R = ze(N, 2), O = R[0], D = R[1], $ = Je(!1), B = ze($, 2), G = B[0], Z = B[1], K = Je(""), q = ze(K, 2), pe = q[0], he = q[1], _e = Je(!1), ge = ze(_e, 2), Y = ge[0], ee = ge[1], oe = function($e) {
    D(ho(ho({}, O), $e.data)), y(ho(ho({}, v), {}, { billingAddress: $e.isValid }));
  }, me = function($e) {
    var we = $e.target.value;
    E(ho(ho({}, x), {}, { holderName: we })), u(ho(ho({}, c), {}, { holderName: !!e.holderNameRequired && !cx(we) })), y(ho(ho({}, v), {}, { holderName: !e.holderNameRequired || cx(we, e.holderNameRequired) }));
  }, xe = _n(null), X = _n(null), ye = function($e) {
    X.current = $e;
  }, ce = Je("ready"), se = ze(ce, 2), Ie = se[0], Le = se[1], ie = _n({});
  return Pe(ie.current).length || (t = e.setComponentRef) === null || t === void 0 || t.call(e, ie.current), ie.current.showValidation = function() {
    xe.current.showValidation(), e.holderNameRequired && !v.holderName && u(ho(ho({}, c), {}, { holderName: !0 })), X.current && X.current.showValidation();
  }, ie.current.setStatus = Le, Rt(function() {
    return n.setFocusOn = xe.current.setFocusOn, n.updateStyles = xe.current.updateStyles, function() {
      xe.current.destroy();
    };
  }, []), Rt(function() {
    var $e = cx(x.holderName, e.holderNameRequired), we = G, Ne = !e.billingAddressRequired || !!v.billingAddress, Ee = we && $e && Ne;
    e.onChange({ data: x, isValid: Ee, billingAddress: O, storePaymentMethod: Y });
  }, [x, v, c, Y]), P("div", { className: "adyen-checkout__ach" }, e.showFormInstruction && P(Qp, null), P(sC, kt({ ref: xe }, CQe(e), { styles: ho(ho({}, _Qe), e.styles), onChange: function($e) {
    var we = $e, Ne = we.autoCompleteName ? we.autoCompleteName : x.holderName;
    E(ho(ho(ho({}, x), we.data), {}, { holderName: Ne })), u(ho(ho({}, c), we.errors)), y(ho(ho(ho({}, v), we.valid), {}, { holderName: !e.holderNameRequired || cx(Ne, e.holderNameRequired) })), Z(we.isSfpValid);
  }, onFocus: function($e) {
    var we = $e.focus === !0;
    he($e.currentFocusObject), we ? e.onFocus($e) : e.onBlur($e);
  }, render: function($e, we) {
    var Ne = $e.setRootNode, Ee = $e.setFocusOn;
    return P("div", { ref: Ne, className: "adyen-checkout__ach-input ".concat(yQe) }, P(uC, { status: we.status }, P("div", { className: Tt(["adyen-checkout__fieldset", "adyen-checkout__fieldset--ach"]) }, P("div", { className: "adyen-checkout__fieldset__title" }, r.get("ach.bankAccount")), e.hasHolderName && P(xn, { label: r.get("ach.accountHolderNameField.title"), className: "adyen-checkout__pm__holderName", errorMessage: !!c.holderName && r.get("ach.accountHolderNameField.invalid"), isValid: !!v.holderName, name: "holderName" }, P(vi, { className: "adyen-checkout__pm__holderName__input ".concat(Nse), placeholder: e.placeholders.holderName || r.get("ach.accountHolderNameField.placeholder"), value: x.holderName, required: e.holderNameRequired, onInput: me })), P(bQe, { focusedElement: pe, onFocusField: Ee, errors: we.errors, valid: we.valid })), e.billingAddressRequired && P(t1, { label: "billingAddress", data: O, onChange: oe, allowedCountries: e.billingAddressAllowedCountries, requiredFields: e.billingAddressRequiredFields, setComponentRef: ye }), e.enableStoreDetails && P(mD, { onChange: ee })));
  } })), e.showPayButton && e.payButton({ status: Ie, label: r.get("confirmPurchase") }));
}
Tse.defaultProps = { type: "ach", hasHolderName: !0, holderNameRequired: !0, billingAddressRequired: !0, billingAddressAllowedCountries: ["US", "PR"], showFormInstruction: !0, onLoad: function() {
}, onConfigSuccess: function() {
}, onAllValid: function() {
}, onFieldValid: function() {
}, onError: function() {
}, onBlur: function() {
}, onFocus: function() {
}, onChange: function() {
}, holderName: "", data: { holderName: "", billingAddress: {} }, styles: {}, placeholders: {} };
var CQe = function(e) {
  return { allowedDOMAccess: e.allowedDOMAccess, autoFocus: e.autoFocus, clientKey: e.clientKey, i18n: e.i18n, keypadFix: e.keypadFix, legacyInputMode: e.legacyInputMode, loadingContext: e.loadingContext, onAllValid: e.onAllValid, onConfigSuccess: e.onConfigSuccess, onError: e.onError, onFieldValid: e.onFieldValid, onFocus: e.onFocus, onLoad: e.onLoad, showWarnings: e.showWarnings, styles: e.styles, type: e.type, forceCompat: e.forceCompat, resources: e.resources };
};
function nK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Cy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = nK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = nK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function wQe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Ose = function(e) {
  ft(n, Dr);
  var t = wQe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    var a;
    return Cy(Cy({}, r), {}, { holderNameRequired: (a = r.hasHolderName) !== null && a !== void 0 ? a : r.holderNameRequired });
  } }, { key: "formatData", value: function() {
    var r, a = !!this.props.storedPaymentMethodId, o = Cy(Cy({ type: n.type }, this.state.data), {}, { ownerName: (r = this.state.data) === null || r === void 0 ? void 0 : r.holderName }, a && { storedPaymentMethodId: this.props.storedPaymentMethodId });
    return delete o.holderName, Cy(Cy({ paymentMethod: o }, this.state.billingAddress && { billingAddress: this.state.billingAddress }), this.state.storePaymentMethod && { storePaymentMethod: this.state.storePaymentMethod });
  } }, { key: "updateStyles", value: function(r) {
    return this.componentRef && this.componentRef.updateStyles && this.componentRef.updateStyles(r), this;
  } }, { key: "setFocusOn", value: function(r) {
    return this.componentRef && this.componentRef.setFocusOn && this.componentRef.setFocusOn(r), this;
  } }, { key: "isValid", get: function() {
    return !!this.props.storedPaymentMethodId || !!this.state.isValid;
  } }, { key: "displayName", get: function() {
    var r;
    return this.props.storedPaymentMethodId && this.props.bankAccountNumber ? "•••• ".concat(Xo(r = this.props.bankAccountNumber).call(r, -4)) : this.props.name;
  } }, { key: "additionalInfo", get: function() {
    return this.props.storedPaymentMethodId ? this.props.i18n.get("ach.savedBankAccount") : "";
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, this.props.storedPaymentMethodId ? P(Lf, { showPayButton: this.props.showPayButton, name: this.displayName, amount: this.props.amount, payButton: this.payButton, onSubmit: this.submit, ref: function(a) {
      r.componentRef = a;
    } }) : P(Tse, kt({ setComponentRef: this.setComponentRef }, this.props, { onChange: this.setState, onSubmit: this.submit, payButton: this.payButton, resources: this.resources })));
  } }]), n;
}();
T(Ose, "type", "ach");
var SQe = /\b(2\d{1}|(9(3|6|2|1)))\d{7}\b/, xQe = /^(\d){4,}$/, EQe = { phoneNumber: { modes: ["blur"], validate: function(e, t) {
  var n = t.state.data.phonePrefix === "+351" ? SQe : xQe;
  return ul(e) ? null : n.test(e);
}, errorMessage: "invalidPhoneNumber" }, phonePrefix: { modes: ["blur"], validate: function(e) {
  return !!e;
}, errorMessage: "invalidCountryCode" } }, IQe = { phoneNumber: { formatterFn: function(e) {
  return e.replace(_m("^\\d", "g"), "");
} } };
function rK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function aK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = rK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = rK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Rse(e) {
  var t, n, r, a, o, s, c = wt().i18n, u = e.requiredFields || je(t = []).call(t, Pn(e != null && (n = e.items) !== null && n !== void 0 && n.length ? ["phonePrefix"] : []), ["phoneNumber"]), f = jt(u).call(u, "phonePrefix") && !(e == null || (r = e.items) === null || r === void 0 || !r.length), m = jt(u).call(u, "phoneNumber"), v = gs(aK(aK({ i18n: c }, e), {}, { schema: u, defaultData: e.data, rules: EQe, formatters: IQe })), y = v.handleChangeFor, b = v.data, S = v.valid, x = v.errors, E = v.isValid, N = v.triggerValidation, R = v.setSchema;
  Rt(function() {
    R(u);
  }, [u.toString()]), Rt(function() {
    b.phoneNumber && y("phoneNumber", "blur")(b.phoneNumber);
  }, [b.phonePrefix]), Rt(function() {
    e.onChange({ data: b, valid: S, errors: x, isValid: E });
  }, [b, S, x, E]), this.triggerValidation = N;
  var O = function() {
    var G = document.querySelector(".adyen-checkout-phone-input--new [uniqueid]");
    return G ? G.getAttribute("uniqueid") : null;
  }, D = Kt(function(G) {
    if (x[G]) {
      var Z = G === "phoneNumber" ? "phoneNumberErrorKey" : "phonePrefixErrorKey", K = e[Z] ? e[Z] : x[G].errorMessage, q = c.get(K);
      return q || null;
    }
    return null;
  }, [x]), $ = Qi(function() {
    return QM("adyen-checkout-phonePrefix");
  }, []), B = (x.phoneNumber || x.phonePrefix) && !0;
  return P("div", { className: "adyen-checkout-phone-input--new" }, P("label", { htmlFor: O() }, P("span", { className: Tt({ "adyen-checkout__label__text": !0, "adyen-checkout__label__text--error": B }) }, e.phoneNumberKey ? c.get(e.phoneNumberKey) : c.get("telephoneNumber"))), P(xn, { name: "phoneNumber", className: Tt({ "adyen-checkout-field": !0, "adyen-checkout-field--phone-input": !0 }), inputWrapperModifiers: ["phone-input"], isValid: S.phoneNumber, errorMessage: B, showValidIcon: !x.phonePrefix }, P("div", { className: Tt({ "adyen-checkout__input": !0, "adyen-checkout__input--invalid": !!x.phoneNumber || !!x.phonePrefix, "adyen-checkout__input--valid": (!f || S.phonePrefix) && S.phoneNumber, "adyen-checkout-input": !0, "adyen-checkout-input-holder--phone-input": !0 }) }, f && P(Ad, { className: "adyen-checkout-dropdown adyen-checkout-dropdown--countrycode-selector", items: e.items, onChange: y("phonePrefix"), placeholder: c.get("infix"), selectedValue: b.phonePrefix, uniqueId: $ }), m && P("div", { className: "adyen-checkout-phone-number" }, P("input", { id: O(), type: "tel", value: b.phoneNumber, onInput: y("phoneNumber", "input"), onBlur: y("phoneNumber", "blur"), placeholder: e.placeholders.phoneNumber || "123456789", className: "adyen-checkout__input adyen-checkout-input adyen-checkout-input--phone-number", autoCorrect: "off", "aria-required": !0, "aria-label": e.phoneNumberKey ? c.get(e.phoneNumberKey) : c.get("telephoneNumber"), "aria-invalid": !S.phoneNumber, "aria-describedby": je(a = "".concat(O())).call(a, F0) })))), P("div", { className: "adyen-checkout-phone-input__error-holder" }, f && D("phonePrefix") && P("span", { className: "adyen-checkout__error-text", "aria-live": "polite", id: je(o = "".concat($)).call(o, F0) }, D("phonePrefix")), m && D("phoneNumber") && P("span", { className: "adyen-checkout__error-text", "aria-live": "polite", id: je(s = "".concat(O())).call(s, F0) }, D("phoneNumber"))));
}
function Mse(e) {
  var t, n = wt(), r = n.i18n, a = n.loadingContext, o = _n(null), s = e.allowedCountries, c = s === void 0 ? [] : s, u = Je("ready"), f = ze(u, 2), m = f[0], v = f[1];
  this.setStatus = v, this.showValidation = o == null || (t = o.current) === null || t === void 0 ? void 0 : t.triggerValidation;
  var y = function(x) {
    var E = x.allowedCountries, N = x.loadingContext, R = x.handleError, O = Je("loading"), D = ze(O, 2), $ = D[0], B = D[1], G = Je([]), Z = ze(G, 2), K = Z[0], q = Z[1];
    return UM(function() {
      rD("phonenumbers", N).then(function(pe) {
        var he = E.length ? Oe(pe).call(pe, function(ge) {
          return jt(E).call(E, ge.id);
        }) : pe, _e = It(he).call(he, function(ge) {
          var Y, ee = ge.prefix, oe = ge.id;
          return { id: ee, name: je(Y = "".concat(ee, " (")).call(Y, oe, ")"), selectedOptionName: ee };
        });
        q(_e || []), B("ready");
      }).catch(function(pe) {
        q([]), B("ready"), R == null || R(new _r("ERROR", pe));
      });
    }, []), { phonePrefixes: K, loadingStatus: $ };
  }({ allowedCountries: c, loadingContext: a, handleError: e.onError }), b = y.loadingStatus, S = y.phonePrefixes;
  return P(uC, { status: b }, P("div", { className: "adyen-checkout__mb-way" }, P(Rse, kt({}, e, { items: S, ref: o, onChange: function(x) {
    var E = x.data, N = x.valid, R = x.errors, O = x.isValid;
    e.onChange({ data: E, valid: N, errors: R, isValid: O });
  }, data: e.data })), e.showPayButton && e.payButton({ status: m, label: r.get("confirmPurchase") })));
}
Rse.defaultProps = { phoneLabel: "telephoneNumber" }, Mse.defaultProps = { onChange: function() {
}, phoneNumberKey: "mobileNumber", phoneNumberErrorKey: "mobileNumber.invalid" };
var kQe = 2e3, AQe = 15, PQe = 6e4, NQe = 1e4, TQe = "mbway", OQe = "mbway.confirmPayment", RQe = "await.waitForConfirmation", MQe = !1, DQe = ["message"];
function oK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function iK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = oK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = oK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function fC(e) {
  var t, n = this, r = wt(), a = r.i18n, o = r.loadingContext, s = oa(), c = Je(!1), u = ze(c, 2), f = u[0], m = u[1], v = Je(!1), y = ze(v, 2), b = y[0], S = y[1], x = Je(!0), E = ze(x, 2), N = E[0], R = E[1], O = Je(!1), D = ze(O, 2), $ = D[0], B = D[1], G = Je(e.delay), Z = ze(G, 2), K = Z[0], q = Z[1], pe = Je(100), he = ze(pe, 2), _e = he[0], ge = he[1], Y = Je(0), ee = ze(Y, 2), oe = ee[0], me = ee[1], xe = Je(!1), X = ze(xe, 2), ye = X[0], ce = X[1], se = Je(null), Ie = ze(se, 2), Le = Ie[0], ie = Ie[1], $e = function() {
    var le = e.paymentData, be = e.clientKey, He = e.throttleInterval;
    $ || (e.onActionHandled({ componentType: e.type, actionDescription: "polling-started" }), B(!0)), use(le, be, o, He).then(cse).catch(function(Ae) {
      var it = Ae.message, ut = pa(Ae, DQe);
      return { type: "network-error", props: iK(iK({}, it && { message: a.get(it) }), ut) };
    }).then(function(Ae) {
      switch (Ae.type) {
        case "success":
          (function(it) {
            if (it.props.payload) {
              m(!0);
              var ut = { data: { details: { payload: it.props.payload }, paymentData: e.paymentData } };
              return e.onComplete(ut, n);
            }
            S(!0), e.onError(new _r("ERROR", "successful result, but no payload in response"));
          })(Ae);
          break;
        case "error":
          (function(it) {
            if (S(!0), it.props.payload) {
              var ut = { data: { details: { payload: it.props.payload }, paymentData: e.paymentData } };
              return e.onComplete(ut, n);
            }
            e.onError(new _r("ERROR", "error result with no payload in response"));
          })(Ae);
          break;
        default:
          R(!1);
      }
    });
  }, we = function(le) {
    window.location.assign(le);
  };
  Rt(function() {
    e.shouldRedirectAutomatically && e.url && we(e.url);
  }, [e.shouldRedirectAutomatically, e.url]), Rt(function() {
    return $e(), function() {
      clearTimeout(Le);
    };
  }, []), Rt(function() {
    if (b || f) return clearTimeout(Le);
    N || ie(Ro(function() {
      $e();
      var le = oe + K;
      me(le), le >= e.throttleTime && !ye && (q(e.throttleInterval), ce(!0));
    }, K));
  }, [N, b, f, oe]);
  var Ne = function(le, be) {
    return P("div", { className: "adyen-checkout__await adyen-checkout__await--result" }, P("img", { className: "adyen-checkout__await__icon adyen-checkout__await__icon--result", src: s({ imageFolder: "components/" })(le), alt: a.get(be) }), P("div", { className: "adyen-checkout__await__subtitle adyen-checkout__await__subtitle--result" }, a.get(be)));
  };
  if (b) return Ne("error", "error.subtitle.payment");
  if (f) return Ne("success", "creditCard.success");
  if (N) return P("div", { className: "adyen-checkout__await" }, e.brandLogo && P("img", { src: e.brandLogo, alt: e.type, className: "adyen-checkout__await__brand-logo" }), P(ju, { inline: !1, size: "large" }));
  var Ee = a.get("wechatpay.timetopay").split("%@");
  return P("div", { className: Tt("adyen-checkout__await", "adyen-checkout__await--".concat(e.type), It(t = e.classNameModifiers).call(t, function(le) {
    return "adyen-checkout__await--".concat(le);
  })) }, e.brandLogo && P("img", { src: e.brandLogo, alt: e.type, className: "adyen-checkout__await__brand-logo" }), P("div", { className: "adyen-checkout__await__subtitle" }, e.messageText), P("div", { className: "adyen-checkout__await__indicator-holder" }, P("div", { className: "adyen-checkout__await__indicator-spinner" }, P(ju, { inline: !1, size: "medium" })), P("div", { className: "adyen-checkout__await__indicator-text" }, e.awaitText)), e.showCountdownTimer && P("div", { className: "adyen-checkout__await__countdown-holder" }, P("div", { className: "adyen-checkout__await__progress" }, P("span", { className: "adyen-checkout__await__percentage", style: { width: "".concat(_e, "%") } })), P("div", { className: "adyen-checkout__await__countdown" }, Ee[0], " ", P(lse, { minutesFromNow: e.countdownTime, onTick: function(le) {
    ge(le.percentage);
  }, onCompleted: function() {
    S(!0), clearTimeout(Le), e.onError(new _r("ERROR", "Payment Expired"));
  } }), " ", Ee[1])), e.url && !e.shouldRedirectAutomatically && P("div", { className: "adyen-checkout__await__app-link" }, P(z2, null), P(pu, { classNameModifiers: ["await"], onClick: function() {
    return we(e.url);
  }, label: a.get("openApp") })));
}
function sK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function uN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = sK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = sK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function LQe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
fC.defaultProps = { countdownTime: 15, onError: function() {
}, onComplete: function() {
}, onActionHandled: function() {
}, delay: 2e3, throttleTime: 6e4, throttleInterval: 1e4, showCountdownTimer: !0, classNameModifiers: [], url: null };
var Dse = function(e) {
  ft(n, Dr);
  var t = LQe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    var a = r.data, o = a === void 0 ? {} : a, s = r.placeholders, c = s === void 0 ? {} : s;
    return uN(uN({}, r), {}, { data: { phoneNumber: o.telephoneNumber || o.phoneNumber, phonePrefix: o.phonePrefix || "+351" }, placeholders: { phoneNumber: c.telephoneNumber || c.phoneNumber || "932123456" } });
  } }, { key: "formatData", value: function() {
    var r;
    return { paymentMethod: uN({ type: n.type }, ((r = this.state.data) === null || r === void 0 ? void 0 : r.phoneNumber) && { telephoneNumber: this.state.data.phonePrefix + this.state.data.phoneNumber }) };
  } }, { key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "displayName", get: function() {
    return this.props.name;
  } }, { key: "render", value: function() {
    var r = this;
    return this.props.paymentData ? P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(eh, { srPanel: this.props.modules.srPanel }, P(fC, { ref: function(a) {
      r.componentRef = a;
    }, clientKey: this.props.clientKey, paymentData: this.props.paymentData, onError: this.props.onError, onComplete: this.onComplete, brandLogo: this.icon, type: TQe, messageText: this.props.i18n.get(OQe), awaitText: this.props.i18n.get(RQe), showCountdownTimer: MQe, delay: kQe, countdownTime: AQe, throttleTime: PQe, throttleInterval: NQe, onActionHandled: this.props.onActionHandled }))) : P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(Mse, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props, { onChange: this.setState, onSubmit: this.submit, payButton: this.payButton })));
  } }]), n;
}();
function Lse(e) {
  var t = this, n = wt().i18n, r = oa(), a = gs({ schema: ["blikCode"], rules: { blikCode: { validate: function(x) {
    return (x == null ? void 0 : x.length) === 6;
  }, errorMessage: "blik.invalid", modes: ["blur"] } }, formatters: { blikCode: GO } }), o = a.handleChangeFor, s = a.triggerValidation, c = a.data, u = a.valid, f = a.errors, m = a.isValid;
  Rt(function() {
    e.onChange({ data: c, errors: f, valid: u, isValid: m }, t);
  }, [c, u, f, m]);
  var v = Je("ready"), y = ze(v, 2), b = y[0], S = y[1];
  return this.setStatus = S, this.showValidation = s, P("div", { className: "adyen-checkout__blik" }, P("p", { className: "adyen-checkout__blik__helper" }, n.get("blik.help")), P(xn, { errorMessage: !!f.blikCode && n.get(f.blikCode.errorMessage), label: n.get("blik.code"), classNameModifiers: ["blikCode", "50"], isValid: u.blikCode, dir: "ltr", name: "blikCode" }, P(vi, { value: c.blikCode, name: "blikCode", spellcheck: !1, required: !0, autocorrect: "off", autocomplete: "off", onInput: o("blikCode", "input"), onBlur: o("blikCode", "blur"), placeholder: "123456", inputMode: "numeric", maxLength: 6 })), e.showPayButton && e.payButton({ status: b, icon: r({ imageFolder: "components/" })("lock") }));
}
T(Dse, "type", "mbway"), Lse.defaultProps = { data: { blikCode: "" } };
var $Qe = 2e3, jQe = 15, FQe = 6e4, BQe = 1e4, VQe = "blik", UQe = "blik.confirmPayment", GQe = "await.waitForConfirmation", zQe = !1;
function lK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function uK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = lK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = lK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function HQe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var $se = function(e) {
  ft(n, Dr);
  var t = HQe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatData", value: function() {
    var r, a = !!this.props.storedPaymentMethodId;
    return { paymentMethod: uK(uK({ type: n.type }, !a && { blikCode: (r = this.state) === null || r === void 0 || (r = r.data) === null || r === void 0 ? void 0 : r.blikCode }), a && { storedPaymentMethodId: this.props.storedPaymentMethodId }) };
  } }, { key: "isValid", get: function() {
    return !!this.props.storedPaymentMethodId || !!this.state.isValid;
  } }, { key: "displayName", get: function() {
    return this.props.storedPaymentMethodId && this.props.label ? this.props.label : this.props.name;
  } }, { key: "additionalInfo", get: function() {
    return this.props.storedPaymentMethodId && this.props.label ? this.props.name : null;
  } }, { key: "render", value: function() {
    var r = this;
    return this.props.paymentData ? P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(eh, { srPanel: this.props.modules.srPanel }, P(fC, { ref: function(a) {
      r.componentRef = a;
    }, clientKey: this.props.clientKey, paymentData: this.props.paymentData, onError: this.handleError, onComplete: this.onComplete, brandLogo: this.icon, type: VQe, messageText: this.props.i18n.get(UQe), awaitText: this.props.i18n.get(GQe), showCountdownTimer: zQe, delay: $Qe, countdownTime: jQe, throttleTime: FQe, throttleInterval: BQe, onActionHandled: this.props.onActionHandled }))) : P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, this.props.storedPaymentMethodId ? P(Lf, { showPayButton: this.props.showPayButton, name: this.displayName, amount: this.props.amount, payButton: this.payButton, onSubmit: this.submit, ref: function(a) {
      r.componentRef = a;
    } }) : P(Lse, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props, { onChange: this.setState, onSubmit: this.submit, payButton: this.payButton })));
  } }]), n;
}();
function WQe(e) {
  var t = e.reference, n = e.totalAmount, r = e.paymentMethodType, a = wt().i18n, o = oa();
  return P(av, { paymentMethodType: r, introduction: a.get("bankTransfer.instructions"), imageUrl: o()(r), amount: n && a.amount(n.value, n.currency), voucherDetails: [{ label: a.get("bankTransfer.beneficiary"), value: e.beneficiary }, { label: a.get("bankTransfer.iban"), value: e.iban }, { label: a.get("bankTransfer.bic"), value: e.bic }, { label: a.get("bankTransfer.reference"), value: t }] });
}
function ZQe(e) {
  var t = wt().i18n, n = Je(!1), r = ze(n, 2), a = r[0], o = r[1], s = gs({ schema: [], defaultData: e.data, rules: { shopperEmail: V2.shopperEmail } }), c = s.handleChangeFor, u = s.triggerValidation, f = s.data, m = s.valid, v = s.errors, y = s.isValid, b = s.setSchema;
  return Rt(function() {
    b(a ? ["shopperEmail"] : []);
  }, [a]), this.showValidation = u, Rt(function() {
    e.onChange({ data: f, errors: v, valid: m, isValid: y });
  }, [f, m, v, a, y]), P("div", { className: "adyen-checkout__bankTransfer" }, P("p", { className: "adyen-checkout__bankTransfer__introduction" }, t.get("bankTransfer.introduction")), P(vse, { classNames: "adyen-checkout__bankTransfer__emailField", value: f.shopperEmail, errors: v.shopperEmail, onToggle: function() {
    return o(!a);
  }, onInput: c("shopperEmail", "input"), onBlur: c("shopperEmail", "blur") }));
}
function cK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function YQe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T($se, "type", "blik");
var zO = function(e) {
  ft(n, Dr);
  var t = YQe(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "state", { isValid: !a.props.showEmailAddress, data: {} }), T(Se(a), "handleRef", function(u) {
      a.componentRef = u;
    }), a;
  }
  return et(n, [{ key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "formatData", value: function() {
    var r = this.state.data.shopperEmail;
    return function(a) {
      for (var o = 1; o < arguments.length; o++) {
        var s, c, u = arguments[o] != null ? arguments[o] : {};
        o % 2 ? Q(s = cK(Object(u), !0)).call(s, function(f) {
          T(a, f, u[f]);
        }) : ne ? Ze(a, ne(u)) : Q(c = cK(Object(u))).call(c, function(f) {
          We(a, f, re(u, f));
        });
      }
      return a;
    }({ paymentMethod: { type: n.type } }, r && { shopperEmail: r });
  } }, { key: "render", value: function() {
    return this.props.reference ? P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(WQe, kt({ ref: this.handleRef }, this.props))) : P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, this.props.showEmailAddress && P(ZQe, kt({ ref: this.handleRef }, this.props, { onChange: this.setState })), P(Lf, kt({}, this.props, { showPayButton: this.props.showPayButton, name: this.displayName, onSubmit: this.submit, payButton: this.payButton })));
  } }]), n;
}();
T(zO, "type", "bankTransfer_IBAN"), T(zO, "defaultProps", { showPayButton: !0, showEmailAddress: !0 });
var XQe = ["CA", "US"];
function dK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = dK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = dK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function KQe(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var jse = function(e) {
  ft(n, gu);
  var t = KQe(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return fK(fK({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { allowedCountries: XQe, personalDetailsRequiredFields: ["firstName", "lastName", "telephoneNumber", "shopperEmail"] });
  } }]), n;
}();
T(jse, "type", "affirm");
var qQe = { socialSecurityNumber: { validate: cD, errorMessage: "", modes: ["blur"] }, default: { validate: function(e) {
  return !!e && e.length > 0;
}, errorMessage: "", modes: ["blur"] } }, JQe = { socialSecurityNumber: function(e) {
  return uD(e);
} };
function QQe(e) {
  var t, n = e.name, r = e.data, a = e.personalDetailsRequired, o = e.showPayButton, s = o !== void 0 && o, c = e.onChange, u = e.payButton, f = wt().i18n, m = ["firstName", "lastName", "socialSecurityNumber"], v = gs({ schema: m, defaultData: r, rules: qQe, formatters: JQe }), y = v.handleChangeFor, b = v.triggerValidation, S = v.setSchema, x = v.data, E = v.valid, N = v.errors, R = v.isValid;
  Rt(function() {
    var Z, K = a ? je(Z = []).call(Z, m) : [];
    S(K);
  }, [a]);
  var O = Je("ready"), D = ze(O, 2), $ = D[0], B = D[1];
  this.setStatus = B, this.showValidation = function() {
    b();
  }, Rt(function() {
    c({ data: x, valid: E, errors: N, isValid: R });
  }, [c, x, E, N]);
  var G = a ? [] : ["standalone"];
  return P("div", { className: "adyen-checkout__pix-input__field", style: s || a ? null : { display: "none" } }, a && P(gse, { i18n: f, data: x, handleChangeFor: y, errors: N, valid: E }), s && u({ status: $, label: je(t = "".concat(f.get("continueTo"), " ")).call(t, n), classNameModifiers: G }));
}
function pK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function u7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = pK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = pK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function eet(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var HO = function(e) {
  ft(n, $f);
  var t = eet(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "formatProps", value: function(r) {
    return u7({ copyBtn: !0, introduction: "pix.instructions" }, Nn(fe(n.prototype), "formatProps", this).call(this, r));
  } }, { key: "formatData", value: function() {
    var r = this.state.data, a = r === void 0 ? {} : r, o = a.firstName, s = a.lastName, c = a.socialSecurityNumber, u = c === void 0 ? "" : c;
    return u7(u7({ paymentMethod: { type: this.props.type || this.constructor.type } }, o && s && { shopperName: { firstName: o, lastName: s } }), u && { socialSecurityNumber: lD(u) });
  } }, { key: "render", value: function() {
    var r = this;
    return this.props.paymentData ? this.renderQRCode() : P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(QQe, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props, { showPayButton: this.props.showPayButton, personalDetailsRequired: this.props.personalDetailsRequired, name: this.displayName, onChange: this.setState, payButton: this.payButton })));
  } }]), n;
}();
T(HO, "type", "pix"), T(HO, "defaultProps", u7({ showPayButton: !1, personalDetailsRequired: !1, countdownTime: 15, delay: 2e3 }, $f.defaultProps));
var tet = /^(\d){1,8}$/, net = /^(\d){6}$/, ret = { bankAccountNumber: { modes: ["blur", "input"], validate: function(e) {
  return !!e && tet.test(e);
} }, bankLocationId: [{ modes: ["input"], validate: function(e) {
  return !!e && /^(\d){1,6}$/.test(e);
} }, { modes: ["blur"], validate: function(e) {
  return !!e && net.test(e);
} }], amountConsentCheckbox: { modes: ["blur"], validate: function(e) {
  return !!e;
} }, accountConsentCheckbox: { modes: ["blur"], validate: function(e) {
  return !!e;
} }, shopperEmail: V2.shopperEmail, default: { modes: ["blur"], validate: function(e) {
  return !!e && e.length > 0;
} } }, aet = { bankAccountNumber: GO, bankLocationId: GO }, wy = "enter-data", fc = "confirm-data";
function Fse(e) {
  var t, n, r, a = this, o = wt().i18n, s = oa(), c = gs({ schema: ["holderName", "bankAccountNumber", "bankLocationId", "shopperEmail", "amountConsentCheckbox", "accountConsentCheckbox"], defaultData: e.data, formatters: aet, rules: ret }), u = c.handleChangeFor, f = c.triggerValidation, m = c.data, v = c.valid, y = c.errors, b = c.isValid, S = Je(wy), x = ze(S, 2), E = x[0], N = x[1];
  return this.setStatus = N, this.showValidation = f, Rt(function() {
    e.onChange({ data: m, valid: v, errors: y, isValid: b });
  }, [m, v, y, b]), P("div", { className: Tt({ "adyen-checkout__bacs": !0, "adyen-checkout__bacs--confirm": E === fc || E === "loading" }) }, e.showFormInstruction && P(Qp, null), E == fc && P("div", { className: Tt({ "adyen-checkout__bacs--edit": !0, "adyen-checkout__bacs--edit-dropin": e.isDropin }) }, P(vi, { name: "bacsEdit", className: "adyen-checkout__bacs--edit-button", value: o.get("edit"), "aria-label": o.get("edit"), readonly: !0, onClick: function() {
    return a.setStatus(wy);
  } })), P(xn, { className: Tt({ "adyen-checkout__bacs--holder-name": !0, "adyen-checkout__field--inactive": E === fc || E === "loading" }), label: o.get("bacs.accountHolderName"), errorMessage: !!y.holderName && o.get("bacs.accountHolderName.invalid"), isValid: v.holderName, name: "accountHolderName", i18n: o }, P(vi, { name: "bacs.accountHolderName", className: "adyen-checkout__bacs-input--holder-name", placeholder: e.placeholders.holderName, value: m.holderName, "aria-invalid": !v.holderName, "aria-label": o.get("bacs.accountHolderName"), "aria-required": "true", required: !0, readonly: E === fc || E === "loading", autocorrect: "off", onBlur: u("holderName", "blur"), onInput: u("holderName", "input") })), P("div", { className: "adyen-checkout__bacs__num-id adyen-checkout__field-wrapper" }, P(xn, { errorMessage: !!y.bankAccountNumber && o.get("bacs.accountNumber.invalid"), label: o.get("bacs.accountNumber"), className: Tt({ "adyen-checkout__bacs--bank-account-number": !0, "adyen-checkout__field--inactive": E === fc || E === "loading" }), classNameModifiers: ["col-70"], isValid: v.bankAccountNumber, name: "bankAccountNumber", i18n: o }, P(vi, { value: m.bankAccountNumber, className: "adyen-checkout__bacs-input--bank-account-number", placeholder: e.placeholders.bankAccountNumber, "aria-invalid": !v.bankAccountNumber, "aria-label": o.get("bacs.accountNumber"), "aria-required": "true", required: !0, readonly: E === fc || E === "loading", autocorrect: "off", onBlur: u("bankAccountNumber", "blur"), onInput: u("bankAccountNumber", "input") })), P(xn, { errorMessage: !!y.bankLocationId && o.get("bacs.bankLocationId.invalid"), label: o.get("bacs.bankLocationId"), className: Tt({ "adyen-checkout__bacs--bank-location-id": !0, "adyen-checkout__field--inactive": E === fc || E === "loading" }), classNameModifiers: ["col-30"], isValid: v.bankLocationId, name: "bankLocationId", i18n: o }, P(vi, { value: m.bankLocationId, className: "adyen-checkout__bacs-input--bank-location-id", placeholder: e.placeholders.bankLocationId, "aria-invalid": !v.bankLocationId, "aria-label": o.get("bacs.bankLocationId"), "aria-required": "true", required: !0, readonly: E === fc || E === "loading", autocorrect: "off", onBlur: u("bankLocationId", "blur"), onInput: u("bankLocationId", "input") }))), P(xn, { errorMessage: !!y.shopperEmail && o.get("shopperEmail.invalid"), label: o.get("shopperEmail"), className: Tt({ "adyen-checkout__bacs--shopper-email": !0, "adyen-checkout__field--inactive": E === fc || E === "loading" }), isValid: v.shopperEmail, name: "emailAddress", i18n: o }, P(rC, { value: m.shopperEmail, name: "shopperEmail", className: "adyen-checkout__bacs-input--shopper-email", classNameModifiers: ["large"], placeholder: e.placeholders.shopperEmail, spellcheck: !1, "aria-invalid": !v.shopperEmail, "aria-label": o.get("shopperEmail"), "aria-required": "true", required: !0, readonly: E === fc || E === "loading", autocorrect: "off", onInput: u("shopperEmail", "input"), onBlur: u("shopperEmail", "blur") })), E === wy && P(mO, { classNameModifiers: ["amountConsentCheckbox"], errorMessage: !!y.amountConsentCheckbox, label: o.get("bacs.consent.amount"), onChange: u("amountConsentCheckbox"), checked: !!m.amountConsentCheckbox, i18n: o }), E === wy && P(mO, { classNameModifiers: ["accountConsentCheckbox"], errorMessage: !!y.accountConsentCheckbox, label: o.get("bacs.consent.account"), onChange: u("accountConsentCheckbox"), checked: !!m.accountConsentCheckbox, i18n: o }), e.showPayButton && e.payButton({ status: E, label: E === wy ? o.get("continue") : je(t = "".concat(o.get("bacs.confirm"), " ")).call(t, (n = e.amount) !== null && n !== void 0 && n.value && (r = e.amount) !== null && r !== void 0 && r.currency ? o.amount(e.amount.value, e.amount.currency) : ""), icon: s({ imageFolder: "components/" })("lock"), onClick: function() {
    return b ? E === wy ? a.setStatus(fc) : E === fc ? e.onSubmit() : void 0 : a.showValidation();
  } }));
}
Fse.defaultProps = { data: {}, placeholders: {} };
var oet = function(e) {
  var t = wt().i18n, n = oa(), r = e.url, a = e.paymentMethodType;
  return P(av, { paymentMethodType: a, introduction: t.get("bacs.result.introduction"), imageUrl: n()(a), downloadUrl: r, downloadButtonText: t.get("download.pdf") });
};
function hK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function dx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = hK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = hK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function iet(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var WO = function(e) {
  ft(n, Dr);
  var t = iet(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "payButton", function(u) {
      return P(ev, kt({ amount: a.props.amount, onClick: a.submit }, u));
    }), a;
  }
  return et(n, [{ key: "formatData", value: function() {
    var r, a, o, s;
    return dx({ paymentMethod: dx(dx(dx({ type: n.type }, ((r = this.state.data) === null || r === void 0 ? void 0 : r.holderName) && { holderName: this.state.data.holderName }), ((a = this.state.data) === null || a === void 0 ? void 0 : a.bankAccountNumber) && { bankAccountNumber: this.state.data.bankAccountNumber }), ((o = this.state.data) === null || o === void 0 ? void 0 : o.bankLocationId) && { bankLocationId: this.state.data.bankLocationId }) }, ((s = this.state.data) === null || s === void 0 ? void 0 : s.shopperEmail) && { shopperEmail: this.state.data.shopperEmail });
  } }, { key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, this.props.url ? P(oet, { ref: function(a) {
      r.componentRef = a;
    }, icon: this.icon, url: this.props.url, paymentMethodType: this.props.paymentMethodType }) : P(Fse, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props, { onChange: this.setState, payButton: this.payButton, onSubmit: this.submit })));
  } }]), n;
}();
function set(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(WO, "type", "directdebit_GB"), T(WO, "defaultProps", { showFormInstruction: !0 });
var uet = function(e) {
  ft(n, Dr);
  var t = set(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "data", get: function() {
    return this.state.data;
  } }, { key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "render", value: function() {
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(t1, kt({ setComponentRef: this.setComponentRef }, this.props, { onChange: this.setState }, !1)));
  } }]), n;
}();
function cet(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Bse = function(e) {
  ft(n, Dr);
  var t = cet(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "data", get: function() {
    return this.state.data;
  } }, { key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "render", value: function() {
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, this.props.showFormInstruction && P(Qp, null), P(aC, kt({ setComponentRef: this.setComponentRef }, this.props, { onChange: this.setState }, !1)));
  } }]), n;
}();
T(Bse, "defaultProps", { showFormInstruction: !0 });
var det = "https://x.klarnacdn.net/kp/lib/v1/api.js", fet = ["sdkData", "paymentMethodType", "payButton"];
function pet(e) {
  var t = e.sdkData;
  e.paymentMethodType;
  var n = e.payButton, r = pa(e, fet), a = _n(null), o = Je("ready"), s = ze(o, 2), c = s[0], u = s[1], f = function() {
    u("error"), r.onComplete({ data: { paymentData: r.paymentData, details: {} } });
  };
  return Rt(function() {
    window.klarnaAsyncCallback = function() {
      window.Klarna.Payments.init({ client_token: t.client_token }), window.Klarna.Payments.load({ container: a.current, payment_method_category: t.payment_method_category }, function(v) {
        !v.show_form || v.error ? f() : r.onLoaded();
      });
    };
    var m = new G2(det);
    return m.load(), function() {
      m.remove();
    };
  }, []), c !== "error" && c !== "success" ? P("div", { className: "adyen-checkout__klarna-widget" }, P("div", { ref: a }), n({ status: c, disabled: c === "loading", onClick: function() {
    u("loading");
    try {
      window.Klarna.Payments.authorize({ payment_method_category: t.payment_method_category }, function(m) {
        m.approved === !0 && m.show_form === !0 ? (u("success"), r.onComplete({ data: { paymentData: r.paymentData, details: { token: m.authorization_token, authorization_token: m.authorization_token } } })) : m.approved || m.show_form !== !0 ? f() : (u("ready"), r.onError(m));
      });
    } catch (m) {
      f();
    }
  } })) : null;
}
function mK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = mK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = mK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function het(e) {
  var t, n = Je({ sdkData: e.sdkData, paymentMethodType: e.paymentMethodType, paymentData: e.paymentData }), r = ze(n, 2), a = r[0], o = r[1], s = Je("ready"), c = ze(s, 2), u = c[0], f = c[1];
  return this.setAction = o, this.setStatus = f, a.sdkData ? P(pet, { sdkData: a.sdkData, paymentMethodType: a.paymentMethodType, paymentData: a.paymentData, payButton: e.payButton, onComplete: e.onComplete, onError: e.onError, onLoaded: e.onLoaded }) : e.showPayButton ? e.payButton(vK(vK({}, e), {}, { status: u, disabled: u === "loading", classNameModifiers: ["standalone"], label: je(t = "".concat(this.props.i18n.get("continueTo"), " ")).call(t, e.displayName) })) : null;
}
function gK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function met(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = gK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = gK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function vet(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var yK, By = function(e) {
  ft(n, Dr);
  var t = vet(n);
  function n(r) {
    var a, o, s, c, u;
    return Qe(this, n), u = t.call(this, r), T(Se(u), "payButton", function(f) {
      return P(ev, kt({ amount: u.props.amount, onClick: u.submit }, f));
    }), u.onComplete = pn(a = u.onComplete).call(a, Se(u)), u.updateWithAction = pn(o = u.updateWithAction).call(o, Se(u)), u.submit = pn(s = u.submit).call(s, Se(u)), u.onLoaded = pn(c = u.onLoaded).call(c, Se(u)), u;
  }
  return et(n, [{ key: "isValid", get: function() {
    return !0;
  } }, { key: "formatData", value: function() {
    return { paymentMethod: met({ type: this.type }, this.props.useKlarnaWidget ? { subtype: "sdk" } : {}) };
  } }, { key: "updateWithAction", value: function(r) {
    if (r.paymentMethodType !== this.type) throw new Error("Invalid Action");
    this.componentRef.setAction(r);
  } }, { key: "onLoaded", value: function() {
    this.setElementStatus("ready");
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(het, kt({}, this.props, { ref: function(a) {
      r.componentRef = a;
    }, displayName: this.displayName, onComplete: function(a) {
      return r.handleAdditionalDetails(a);
    }, onError: this.props.onError, payButton: this.payButton, onLoaded: this.onLoaded })));
  } }]), n;
}();
function get(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(By, "type", "klarna"), T(By, "defaultProps", { useKlarnaWidget: !1 });
var c7 = function(e) {
  ft(n, Mm);
  var t = get(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "payButton", function(u) {
      return P(ev, kt({}, u, { label: a.payButtonLabel(), onClick: a.submit }));
    }), a;
  }
  return et(n, [{ key: "displayName", get: function() {
    var r, a = this.props, o = a.i18n, s = a.name;
    return a.storedPaymentMethodId ? je(r = "".concat(s, " ")).call(r, o.get("twint.saved")) : s || this.constructor.type;
  } }, { key: "payButtonLabel", value: function() {
    var r, a = this.props, o = a.i18n, s = a.amount, c = a.storedPaymentMethodId, u = a.name;
    return c ? HM(o, s) : je(r = "".concat(o.get("continueTo"), " ")).call(r, u);
  } }]), n;
}();
yK = c7, T(c7, "type", "twint"), T(c7, "defaultProps", { type: yK.type, showPayButton: !0 });
var yet = function(e) {
  var t = e.i18n, n = e.sfpState, r = e.focusedElement, a = e.setFocusOn;
  return P(xn, { label: t.get("creditCard.expiryDateField.title"), classNameModifiers: ["expireDate", "50"], errorMessage: n.errors.encryptedExpiryDate && t.get(n.errors.encryptedExpiryDate), focused: r === "encryptedExpiryDate", onFocusField: function() {
    return a("encryptedExpiryDate");
  }, dir: "ltr", name: "encryptedExpiryDate", errorVisibleToScreenReader: !1 }, P(rv, { encryptedFieldType: "encryptedExpiryDate", className: Tt("adyen-checkout__input", "adyen-checkout__input--small", "adyen-checkout__card__exp-date__input", [dl["adyen-checkout__input"]], { "adyen-checkout__input--error": n.errors.encryptedExpiryDate, "adyen-checkout__input--focus": r === "encryptedExpiryDate", "adyen-checkout__input--valid": !!n.valid.encryptedExpiryMonth && !!n.valid.encryptedExpiryYear }) }));
};
function bK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _K(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = bK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = bK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var bet = function(e) {
  var t = e.setRootNode, n = _K(_K({}, e), {}, { label: e.i18n.get("creditCard.cvcField.title") });
  return P("div", { ref: t }, P(_se, kt({}, e, { classNameModifiers: ["100"] })), P("div", { className: "adyen-checkout__field-wrapper" }, P(yet, e), P(Cse, kt({}, n, { classNameModifiers: ["50"] }))));
};
function CK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function cN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = CK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = CK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function _et(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var d7 = function(e) {
  ft(n, p6);
  var t = _et(n);
  function n(r) {
    return Qe(this, n), t.call(this, cN(cN({}, r), {}, { pinRequired: !0, expiryDateRequired: !0, fieldsLayoutComponent: bet }));
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return cN({ brand: r.type }, r);
  } }, { key: "formatData", value: function() {
    var r, a, o, s;
    return { paymentMethod: { type: this.constructor.type, brand: this.props.brand, encryptedCardNumber: (r = this.state.data) === null || r === void 0 ? void 0 : r.encryptedCardNumber, encryptedSecurityCode: (a = this.state.data) === null || a === void 0 ? void 0 : a.encryptedSecurityCode, encryptedExpiryMonth: (o = this.state.data) === null || o === void 0 ? void 0 : o.encryptedExpiryMonth, encryptedExpiryYear: (s = this.state.data) === null || s === void 0 ? void 0 : s.encryptedExpiryYear } };
  } }]), n;
}();
function wK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = wK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = wK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Cet(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(d7, "type", "mealVoucher_FR");
var dN, Vse = function(e) {
  ft(n, ys);
  var t = Cet(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return fx(fx({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { showImage: !1 });
  } }, { key: "formatData", value: function() {
    return fx(fx({}, Nn(fe(n.prototype), "formatData", this).call(this)), {}, { browserInfo: this.browserInfo });
  } }, { key: "browserInfo", get: function() {
    return nv();
  } }]), n;
}();
function SK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = SK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = SK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function wet(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(Vse, "type", "onlinebanking_IN");
var k4 = function(e) {
  ft(n, ys);
  var t = wet(n);
  function n(r) {
    return Qe(this, n), t.call(this, xK(xK({}, r), {}, { termsAndConditions: n.termsAndConditions }));
  }
  return et(n);
}();
function EK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function px(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = EK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = EK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function xet(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
dN = k4, T(k4, "type", "onlineBanking_PL"), T(k4, "disclaimerUrlsMap", { regulation: "https://www.przelewy24.pl/regulamin", obligation: "https://www.przelewy24.pl/obowiazek-informacyjny-rodo-platnicy" }), T(k4, "termsAndConditions", { translationKey: "onlineBankingPL.termsAndConditions", urls: [dN.disclaimerUrlsMap.regulation, dN.disclaimerUrlsMap.obligation] });
var Use = function(e) {
  ft(n, gu);
  var t = xet(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return px(px({}, Nn(fe(n.prototype), "formatProps", this).call(this, px(px({}, r), { visibility: { bankAccount: "editable" } }))), {}, { allowedCountries: r.countryCode ? [r.countryCode] : Ese });
  } }]), n;
}();
T(Use, "type", "ratepay_directdebit");
var Eet = { virtualPaymentAddress: { validate: function(e) {
  return !!e && e.length > 0;
}, errorMessage: "", modes: ["blur"] }, default: { validate: function(e) {
  return !!e && e.length > 0;
}, errorMessage: "", modes: ["blur"] } }, Gse = function(e) {
  var t = wt().i18n, n = gs({ schema: ["virtualPaymentAddress"], defaultData: e.data, rules: Eet }), r = n.handleChangeFor, a = n.triggerValidation, o = n.data, s = n.valid, c = n.errors, u = n.isValid, f = _n({ validateInput: null }), m = Kt(function() {
    a();
  }, [a]);
  return Rt(function() {
    f.current.validateInput = m, e.onSetInputHandlers(f.current);
  }, [m, e.onSetInputHandlers]), Rt(function() {
    e.onChange({ data: o, valid: s, errors: c, isValid: u });
  }, [o, s, c, u]), P(xn, { label: t.get("upi.collect.field.label"), errorMessage: !!c.virtualPaymentAddress, classNameModifiers: ["vpa"], name: "virtualPaymentAddress" }, P(vi, { name: "virtualPaymentAddress", autocorrect: "off", spellcheck: !1, disabled: e.disabled, value: o.virtualPaymentAddress, onInput: r("virtualPaymentAddress", "input"), onBlur: r("virtualPaymentAddress", "blur") }));
};
function Iet(e) {
  var t, n = e.classNameModifiers, r = e.selectedValue, a = e.disabled, o = a !== void 0 && a, s = e.options, c = e.onChange;
  return s && s.length !== 0 ? P("div", { className: Tt.apply(void 0, je(t = ["adyen-checkout__segmented-control", { "adyen-checkout__segmented-control--disabled": o }]).call(t, Pn(It(n).call(n, function(u) {
    return "adyen-checkout__segmented-control--".concat(u);
  })))), role: "group" }, It(s).call(s, function(u) {
    var f = u.label, m = u.value, v = u.htmlProps;
    return P("button", kt({ disabled: o, key: m, onClick: function(y) {
      return c(m, y);
    }, className: Tt("adyen-checkout__segmented-control-segment", { "adyen-checkout__segmented-control-segment--selected": r === m }), type: "button" }, v), f);
  })) : null;
}
var mo = function(e) {
  return e.Vpa = "vpa", e.QrCode = "qrCode", e.Intent = "intent", e;
}({}), y0 = function(e) {
  return e.UpiCollect = "upi_collect", e.UpiQr = "upi_qr", e.UpiIntent = "upi_intent", e;
}({});
function ket(e) {
  var t = e.buttonId, n = e.isSelected, r = e.children, a = e.classNames;
  return P("button", { className: Tt("adyen-checkout-radio-button", a === void 0 ? [] : a), id: t, role: "radio", "aria-checked": n, type: "button" }, P("span", { className: Tt({ "adyen-checkout-radio-button__radio": !0, "adyen-checkout-radio-button__radio--selected": n }), "aria-hidden": "true" }), r);
}
var Aet = function(e) {
  var t, n = e.app, r = e.imgSrc, a = e.isSelected, o = e.onSelect, s = o === void 0 ? function() {
  } : o, c = e.children, u = je(t = "adyen-checkout-upi-app-item-radio-button-".concat(n.id, "-")).call(t, F2());
  return P("li", { className: Tt({ "adyen-checkout-upi-app-item": !0, "adyen-checkout-upi-app-item--selected": a }), role: "button", "aria-expanded": a, onClick: function() {
    return function(f) {
      s(f);
    }(n);
  } }, P("div", { className: "adyen-checkout-upi-app-item-header" }, P(ket, { buttonId: u, isSelected: a }, P(dC, { src: r, altDescription: n.name, type: n.id }), P("label", { htmlFor: u }, n.name))), a && c && P("div", { className: "adyen-checkout-upi-app-item-details" }, c));
}, Pet = function(e) {
  var t = e.apps, n = e.selectedAppId, r = e.disabled, a = e.onAppSelect, o = a === void 0 ? function() {
  } : a, s = e.onVpaInputChange, c = s === void 0 ? function() {
  } : s, u = e.onSetInputHandlers, f = u === void 0 ? function() {
  } : u, m = wt().i18n, v = oa();
  return P("ul", { className: Tt({ "adyen-checkout-upi-app-list": !0, "adyen-checkout-upi-app-list--loading": r }), role: "radiogroup", "aria-label": m.get("paymentMethodsList.aria.label"), required: !0 }, It(t).call(t, function(y) {
    var b = "adyen-checkout-upi-app-item-".concat(y.id, "}"), S = n === y.id, x = y.id === mo.Vpa, E = x ? "upi" : "upi/".concat(y.id), N = v()(E.toLowerCase());
    return P(Aet, { key: b, app: y, imgSrc: N, isSelected: S, onSelect: o }, x && P(Gse, { disabled: r, onChange: c, onSetInputHandlers: f }));
  }));
}, pc = { ButtonId: { VPA: "upi-button-".concat(mo.Vpa), QR: "upi-button-".concat(mo.QrCode), INTENT: "upi-button-".concat(mo.Intent) }, AreaId: { VPA: "upi-area-".concat(mo.Vpa), QR: "upi-area-".concat(mo.QrCode), INTENT: "upi-area-".concat(mo.Intent) } };
function IK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = IK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = IK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Net(e) {
  var t = e.defaultMode, n = e.onChange, r = e.onUpdateMode, a = e.payButton, o = e.showPayButton, s = e.apps, c = s === void 0 ? [] : s, u = wt().i18n, f = oa(), m = Je("ready"), v = ze(m, 2), y = v[0], b = v[1], S = Je(!0), x = ze(S, 2), E = x[0], N = x[1], R = Je(t), O = ze(R, 2), D = O[0], $ = O[1], B = Je(""), G = ze(B, 2), Z = G[0], K = G[1], q = Je(null), pe = ze(q, 2), he = pe[0], _e = pe[1], ge = Je(null), Y = ze(ge, 2), ee = Y[0], oe = Y[1], me = Je(null), xe = ze(me, 2), X = xe[0], ye = xe[1], ce = Je(null), se = ze(ce, 2), Ie = se[0], Le = se[1], ie = function(le, be) {
    var He = wt().i18n;
    return Qi(function() {
      var Ae, it = { label: He.get("upi.mode.payByAnyUpi"), value: mo.Intent, htmlProps: { id: pc.ButtonId.INTENT, "aria-expanded": be === mo.Intent, "aria-controls": pc.AreaId.INTENT } }, ut = { label: He.get("upi.mode.enterUpiId"), value: mo.Vpa, htmlProps: { id: pc.ButtonId.VPA, "aria-expanded": be === mo.Vpa, "aria-controls": pc.AreaId.VPA } }, St = { label: He.get("upi.mode.qrCode"), value: mo.QrCode, htmlProps: { id: pc.ButtonId.QR, "aria-expanded": be === mo.QrCode, "aria-controls": pc.AreaId.QR } }, sn = le.length > 0, zn = L8() ? 1 : 0, dn = Tae(Ae = new Array(2)).call(Ae, sn ? it : ut);
      return dn[zn] = St, dn;
    }, [le, be]);
  }(c, D);
  this.setStatus = function(le) {
    b(le);
  }, this.showValidation = function() {
    he == null || he.validateInput();
  };
  var $e = Kt(function(le) {
    _e(le);
  }, []), we = Kt(function(le) {
    $(le), r(le);
  }, [r]), Ne = Kt(function(le) {
    (le == null ? void 0 : le.id) !== (ee == null ? void 0 : ee.id) && (oe(le), N(!0));
  }, [ee]), Ee = Kt(function(le) {
    var be = le.data.virtualPaymentAddress, He = le.errors, Ae = le.valid, it = le.isValid;
    K(be), Le(He), ye(Ae), N(it);
  }, []);
  return Rt(function() {
    D !== mo.QrCode ? n({ data: kK(kK({}, Z && { virtualPaymentAddress: Z }), ee && { app: ee }), errors: Ie, valid: X, isValid: E }) : n({ data: {}, valid: {}, errors: {}, isValid: !0 });
  }, [Z, ee, Ie, X, E, D]), P(ra, null, P("p", { className: "adyen-checkout_upi-mode-selection-text" }, u.get("upi.modeSelection")), P(Iet, { onChange: we, selectedValue: D, disabled: y === "loading", classNameModifiers: ["upi-margin-bottom"], options: ie }), P(z2, { label: u.get("upi.completePayment") }), D === mo.Intent && P("div", { id: pc.AreaId.INTENT, "aria-labelledby": pc.ButtonId.INTENT, className: "adyen-checkout-upi-area-intent", role: "region" }, P(Pet, { disabled: y === "loading", apps: c, selectedAppId: ee == null ? void 0 : ee.id, onAppSelect: Ne, onVpaInputChange: Ee, onSetInputHandlers: $e }), o && a({ label: u.get("continue"), status: y, disabled: ee == null })), D === mo.Vpa && P("div", { id: pc.AreaId.VPA, "aria-labelledby": pc.ButtonId.VPA, className: "adyen-checkout-upi-area-vpa", role: "region" }, P(Gse, { disabled: y === "loading", onChange: n, onSetInputHandlers: $e }), o && a({ label: u.get("continue"), status: y })), D === mo.QrCode && P("div", { id: pc.AreaId.QR, "aria-labelledby": pc.ButtonId.QR, className: "adyen-checkout-upi-area-qr-code", role: "region" }, o && a({ label: u.get("generateQRCode"), icon: f({ imageFolder: "components/" })("qr"), status: y })));
}
function AK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ap(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = AK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = AK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Tet(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var A4 = function(e) {
  ft(n, Dr);
  var t = Tet(n);
  function n(r) {
    var a;
    return Qe(this, n), a = t.call(this, r), T(Se(a), "selectedMode", void 0), T(Se(a), "onUpdateMode", function(o) {
      a.selectedMode = o;
    }), a.selectedMode = a.props.defaultMode, a;
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    var a, o, s, c;
    if (!L8()) return Ap(Ap({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { defaultMode: (c = r == null ? void 0 : r.defaultMode) !== null && c !== void 0 ? c : mo.QrCode, apps: [] });
    var u = ((a = r.apps) === null || a === void 0 ? void 0 : a.length) > 0, f = u ? mo.Intent : mo.Vpa, m = [f, mo.QrCode], v = { id: mo.Vpa, name: r.i18n.get("upi.collect.dropdown.label"), type: y0.UpiCollect }, y = u ? je(o = []).call(o, Pn(It(s = r.apps).call(s, function(b) {
      return Ap(Ap({}, b), {}, { type: y0.UpiIntent });
    })), [v]) : [];
    return Ap(Ap({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { defaultMode: jt(m).call(m, r == null ? void 0 : r.defaultMode) ? r.defaultMode : f, apps: y });
  } }, { key: "isValid", get: function() {
    return this.state.isValid;
  } }, { key: "formatData", value: function() {
    var r = this.state.data || {}, a = r.virtualPaymentAddress, o = r.app;
    return { paymentMethod: Ap(Ap(Ap({}, this.paymentType && { type: this.paymentType }), this.paymentType === y0.UpiCollect && a && { virtualPaymentAddress: a }), this.paymentType === y0.UpiIntent && (o == null ? void 0 : o.id) && { appId: o.id }) };
  } }, { key: "paymentType", get: function() {
    var r;
    return this.selectedMode === mo.QrCode ? y0.UpiQr : this.selectedMode === mo.Vpa ? y0.UpiCollect : (r = this.state.data) === null || r === void 0 || (r = r.app) === null || r === void 0 ? void 0 : r.type;
  } }, { key: "renderContent", value: function(r, a, o) {
    var s = this;
    switch (r) {
      case "qrCode":
        return P(yD, kt({ ref: function(c) {
          s.componentRef = c;
        } }, this.props, { qrCodeData: this.props.qrCodeData ? encodeURIComponent(this.props.qrCodeData) : null, type: y0.UpiQr, brandLogo: this.props.brandLogo || this.icon, onComplete: this.onComplete, introduction: this.props.i18n.get("upi.qrCodeWaitingMessage"), countdownTime: 5, onActionHandled: this.props.onActionHandled }));
      case "await":
        return P(fC, { ref: function(c) {
          s.componentRef = c;
        }, url: a, type: o, showCountdownTimer: !0, shouldRedirectAutomatically: !0, countdownTime: 5, clientKey: this.props.clientKey, paymentData: this.props.paymentData, onActionHandled: this.props.onActionHandled, onError: this.props.onError, messageText: this.props.i18n.get("upi.vpaWaitingMessage"), awaitText: this.props.i18n.get("await.waitForConfirmation"), onComplete: this.onComplete, brandLogo: this.icon });
      default:
        return P(Net, { ref: function(c) {
          s.componentRef = c;
        }, payButton: this.payButton, onChange: this.setState, onUpdateMode: this.onUpdateMode, apps: this.props.apps, defaultMode: this.props.defaultMode, showPayButton: this.props.showPayButton });
    }
  } }, { key: "render", value: function() {
    var r = this.props, a = r.type, o = r.url, s = r.paymentMethodType;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(eh, { srPanel: this.props.modules.srPanel }, this.renderContent(a, o, s)));
  } }]), n;
}();
function PK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = PK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = PK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Oet(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(A4, "type", "upi");
var zse = function(e) {
  ft(n, ys);
  var t = Oet(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return hx(hx({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { showImage: !1 });
  } }, { key: "formatData", value: function() {
    return hx(hx({}, Nn(fe(n.prototype), "formatData", this).call(this)), {}, { browserInfo: this.browserInfo });
  } }, { key: "browserInfo", get: function() {
    return nv();
  } }]), n;
}();
function NK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function TK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = NK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = NK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Ret(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(zse, "type", "wallet_IN");
var ZO = function(e) {
  ft(n, ys);
  var t = Ret(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return TK(TK({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { showImage: !1, termsAndConditions: n.termsAndConditions });
  } }, { key: "icon", get: function() {
    var r;
    return (r = this.props.icon) !== null && r !== void 0 ? r : this.resources.getImage()("bankTransfer_IBAN");
  } }]), n;
}();
function OK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function RK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = OK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = OK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Met(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(ZO, "type", "onlineBanking_CZ"), T(ZO, "termsAndConditions", { translationKey: "onlineBanking.termsAndConditions", urls: ["https://static.payu.com/sites/terms/files/payu_privacy_policy_cs.pdf"] });
var YO = function(e) {
  ft(n, ys);
  var t = Met(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return RK(RK({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { showImage: !1, termsAndConditions: n.termsAndConditions });
  } }, { key: "icon", get: function() {
    var r;
    return (r = this.props.icon) !== null && r !== void 0 ? r : this.resources.getImage()("bankTransfer_IBAN");
  } }]), n;
}();
function MK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function DK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = MK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = MK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function Det(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(YO, "type", "onlineBanking_SK"), T(YO, "termsAndConditions", { translationKey: "onlineBanking.termsAndConditions", urls: ["https://static.payu.com/sites/terms/files/payu_privacy_policy_sk.pdf"] });
var Hse = function(e) {
  ft(n, ys);
  var t = Det(n);
  function n(r) {
    return Qe(this, n), t.call(this, DK(DK({}, r), {}, { showPaymentMethodItemImages: !0 }));
  }
  return et(n);
}();
T(Hse, "type", "paybybank");
function LK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Let(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Wse = function(e) {
  ft(n, $f);
  var t = Let(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return function(a) {
      for (var o = 1; o < arguments.length; o++) {
        var s, c, u = arguments[o] != null ? arguments[o] : {};
        o % 2 ? Q(s = LK(Object(u), !0)).call(s, function(f) {
          T(a, f, u[f]);
        }) : ne ? Ze(a, ne(u)) : Q(c = LK(Object(u))).call(c, function(f) {
          We(a, f, re(u, f));
        });
      }
      return a;
    }({ delay: 2e3, countdownTime: 1.5 }, Nn(fe(n.prototype), "formatProps", this).call(this, r));
  } }]), n;
}();
T(Wse, "type", "promptpay");
function $K(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $et(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Zse = function(e) {
  ft(n, $f);
  var t = $et(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return function(a) {
      for (var o = 1; o < arguments.length; o++) {
        var s, c, u = arguments[o] != null ? arguments[o] : {};
        o % 2 ? Q(s = $K(Object(u), !0)).call(s, function(f) {
          T(a, f, u[f]);
        }) : ne ? Ze(a, ne(u)) : Q(c = $K(Object(u))).call(c, function(f) {
          We(a, f, re(u, f));
        });
      }
      return a;
    }({ delay: 2e3, countdownTime: 1.5 }, Nn(fe(n.prototype), "formatProps", this).call(this, r));
  } }]), n;
}();
T(Zse, "type", "duitnow");
var jet = { beneficiaryId: { validate: function(e) {
  return Xoe(e) || /^\d{11}$/.test(e);
}, errorMessage: "ancv.beneficiaryId.invalid", modes: ["blur"] } };
function Yse(e) {
  var t = this, n = e.showPayButton, r = e.payButton, a = e.onChange, o = e.onSubmit, s = wt().i18n, c = gs({ schema: ["beneficiaryId"], rules: jet }), u = c.handleChangeFor, f = c.triggerValidation, m = c.data, v = c.valid, y = c.errors, b = c.isValid;
  Rt(function() {
    a({ data: m, errors: y, valid: v, isValid: b }, t);
  }, [m, v, y, b]);
  var S = Je("ready"), x = ze(S, 2), E = x[0], N = x[1];
  return this.setStatus = N, this.showValidation = f, P(uC, null, P("div", { className: "adyen-checkout__ancv" }, P("p", { className: "adyen-checkout-form-instruction" }, s.get("ancv.form.instruction")), P(xn, { errorMessage: !!y.beneficiaryId && s.get(y.beneficiaryId.errorMessage), label: s.get("ancv.input.label"), isValid: v.beneficiaryId, name: "beneficiaryId" }, P(vi, { value: m.beneficiaryId, name: "beneficiaryId", spellcheck: !0, required: !0, onInput: u("beneficiaryId", "input"), onBlur: u("beneficiaryId", "blur") })), n && r({ status: E, label: s.get("confirmPurchase"), onClick: o })));
}
Yse.defaultProps = {};
var Fet = 6e4, Bet = 1e4, Vet = !1;
function Uet(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var Xse = function(e) {
  ft(n, Dr);
  var t = Uet(n);
  function n() {
    var r, a;
    Qe(this, n);
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++) s[c] = arguments[c];
    return a = t.call.apply(t, je(r = [this]).call(r, s)), T(Se(a), "onOrderRequest", function(u) {
      return a.props.onOrderRequest ? new Yt(function(f, m) {
        a.props.onOrderRequest(f, m, u);
      }) : a.props.session ? a.props.session.createOrder() : void 0;
    }), T(Se(a), "handleOrder", function(u) {
      var f = u.order;
      if (a.updateParent({ order: f }), a.props.session && a.props.onOrderCreated) return a.props.onOrderCreated(f);
    }), T(Se(a), "createOrder", function() {
      a.setStatus("loading"), a.props.order ? a.onSubmit() : a.onOrderRequest(a.data).then(function(u) {
        return a.setState({ order: { orderData: u.orderData, pspReference: u.pspReference } }), a.onSubmit();
      }).catch(function(u) {
        a.setStatus((u == null ? void 0 : u.message) || "error"), a.props.onError && a.handleError(new _r("ERROR", u));
      });
    }), T(Se(a), "payButton", function(u) {
      return P(ev, u);
    }), a;
  }
  return et(n, [{ key: "formatData", value: function() {
    var r;
    return { paymentMethod: { type: n.type, beneficiaryId: (r = this.state.data) === null || r === void 0 ? void 0 : r.beneficiaryId } };
  } }, { key: "submit", value: function() {
    if (!this.isValid) return this.showValidation(), !1;
    this.createOrder();
  } }, { key: "isValid", get: function() {
    return !!this.state.isValid;
  } }, { key: "displayName", get: function() {
    return this.props.name;
  } }, { key: "render", value: function() {
    var r = this;
    return this.props.paymentData ? P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(eh, { srPanel: this.props.modules.srPanel }, P(fC, { ref: function(a) {
      r.componentRef = a;
    }, clientKey: this.props.clientKey, paymentData: this.props.paymentData, onError: this.props.onError, onComplete: this.onComplete, brandLogo: this.icon, type: this.constructor.type, messageText: this.props.i18n.get("ancv.confirmPayment"), awaitText: this.props.i18n.get("await.waitForConfirmation"), showCountdownTimer: Vet, throttleTime: Fet, throttleInterval: Bet, onActionHandled: this.props.onActionHandled }))) : P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P(Yse, kt({ ref: function(a) {
      r.componentRef = a;
    } }, this.props, { onSubmit: this.submit, onChange: this.setState, payButton: this.payButton, showPayButton: this.props.showPayButton })));
  } }]), n;
}();
function Get(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(Xse, "type", "ancv");
var Kse = function(e) {
  ft(n, Mm);
  var t = Get(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "displayName", get: function() {
    return this.props.name || this.constructor.type;
  } }, { key: "render", value: function() {
    var r = this;
    return P(hr, { i18n: this.props.i18n, loadingContext: this.props.loadingContext, resources: this.resources }, P("div", { className: "adyen-checkout-trustly" }, P("p", { className: "adyen-checkout-trustly__descriptor" }, this.props.i18n.get("trustly.descriptor")), P("ul", { className: "adyen-checkout-trustly__description-list" }, P("li", null, this.props.i18n.get("trustly.description1")), P("li", null, this.props.i18n.get("trustly.description2")))), this.props.showPayButton && P(Lf, kt({}, this.props, { name: this.displayName, onSubmit: this.submit, payButton: this.payButton, ref: function(a) {
      r.componentRef = a;
    } })));
  } }]), n;
}();
function zet() {
  var e, t = wt().i18n, n = t.get("payme.instructions.steps"), r = t.get("payme.instructions.footnote");
  return P("div", { className: "adyen-checkout-payme-instructions" }, P("ol", { className: "adyen-checkout-payme-instructions__steps" }, It(e = n.split("%@")).call(e, function(a, o) {
    return P("li", { key: "instruction-".concat(o) }, a);
  })), P("span", null, r));
}
function jK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Het(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(Kse, "type", "trustly");
var f7 = function(e) {
  ft(n, $f);
  var t = Het(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    return function(a) {
      for (var o = 1; o < arguments.length; o++) {
        var s, c, u = arguments[o] != null ? arguments[o] : {};
        o % 2 ? Q(s = jK(Object(u), !0)).call(s, function(f) {
          T(a, f, u[f]);
        }) : ne ? Ze(a, ne(u)) : Q(c = jK(Object(u))).call(c, function(f) {
          We(a, f, re(u, f));
        });
      }
      return a;
    }({ delay: n.defaultDelay, countdownTime: n.defaultCountdown, redirectIntroduction: "payme.openPayMeApp", introduction: "payme.scanQrCode", timeToPay: "payme.timeToPay", buttonLabel: "payme.redirectButtonLabel", instructions: zet }, Nn(fe(n.prototype), "formatProps", this).call(this, r));
  } }]), n;
}();
function Wet(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
T(f7, "type", "payme"), T(f7, "defaultCountdown", 10), T(f7, "defaultDelay", 2e3);
var qse = function(e) {
  ft(n, ys);
  var t = Wet(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n);
}();
T(qse, "type", "ebanking_FI");
var Zet = ["AT", "CH", "DE"], Yet = ["NO", "SE", "FI", "DK", "DE", "AT", "CH", "NL", "BE"], Xet = { default: { labels: T(T({}, RW, "deliveryAddress.firstName"), MW, "deliveryAddress.lastName"), schema: [N0, [[RW, 50], [MW, 50]], [[pd, 70], [hc, 30]], [[_f, 30], [x0, 70]]] } }, Ket = { at: { en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/at_en", de: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/at_de" }, ch: { en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/ch_en", de: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/ch_de", fr: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/ch_fr" }, de: { en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/de_en", de: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/de_de" } };
function FK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function I0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = FK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = FK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function qet(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var XO = function(e) {
  ft(n, gu);
  var t = qet(n);
  function n() {
    return Qe(this, n), t.apply(this, arguments);
  }
  return et(n, [{ key: "formatProps", value: function(r) {
    var a;
    return I0(I0({}, Nn(fe(n.prototype), "formatProps", this).call(this, r)), {}, { billingAddressSpecification: I0(I0({}, r.billingAddressSpecification), {}, { allowedCountries: r.countryCode ? [r.countryCode] : Zet }), deliveryAddressSpecification: I0(I0({}, r.deliveryAddressSpecification), {}, { allowedCountries: Yet }), consentCheckboxLabel: P(cie, { url: fie(r.countryCode, (a = r.i18n) === null || a === void 0 ? void 0 : a.locale, Ket) }) });
  } }]), n;
}();
function BK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function VK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = BK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = BK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
T(XO, "type", "riverty"), T(XO, "defaultProps", I0({ personalDetailsRequiredFields: ["firstName", "lastName", "dateOfBirth", "shopperEmail", "telephoneNumber"], deliveryAddressSpecification: Xet }, gu.defaultProps));
var Y4 = { address: uet, bankTransfer_IBAN: zO, donation: NO, dropin: UO, personal_details: Bse, amex: Ol, bcmc: PO, card: Ol, diners: Ol, discover: Ol, jcb: Ol, kcp: Ol, maestro: Ol, mc: Ol, scheme: Ol, storedCard: Ol, securedfields: s7, threeDS2Challenge: DO, threeDS2DeviceFingerprint: $O, visa: Ol, ach: Ose, directdebit_GB: WO, sepadirectdebit: RO, affirm: jse, afterpay: yO, afterpay_default: yO, afterpay_b2b: bO, atome: hie, facilypay_3x: Yie, facilypay_4x: Xie, facilypay_6x: Kie, facilypay_10x: qie, facilypay_12x: Jie, ratepay: Ise, ratepay_directdebit: Use, riverty: XO, amazonpay: _O, applepay: CO, cashapp: AO, clicktopay: Fie, googlepay: d6, paypal: i7, paywithgoogle: d6, qiwiwallet: OO, boletobancario: ym, boletobancario_bancodobrasil: ym, boletobancario_bradesco: ym, boletobancario_hsbc: ym, boletobancario_itau: ym, boletobancario_santander: ym, doku: Nl, doku_alfamart: Nl, doku_permata_lite_atm: Nl, doku_indomaret: Nl, doku_atm_mandiri_va: Nl, doku_sinarmas_va: Nl, doku_mandiri_va: Nl, doku_cimb_va: Nl, doku_danamon_va: Nl, doku_bri_va: Nl, doku_bni_va: Nl, doku_bca_va: Nl, doku_wallet: Nl, oxxo: FO, primeiropay_boleto: ym, billdesk_online: vie, billdesk_wallet: gie, dotpay: VO, entercash: Wie, eps: bse, molpay_ebanking_fpx_MY: fse, molpay_ebanking_TH: pse, molpay_ebanking_VN: hse, onlineBanking: VO, onlineBanking_CZ: ZO, onlinebanking_IN: Vse, onlineBanking_PL: k4, onlineBanking_SK: YO, paybybank: Hse, payu_IN_cashcard: Sse, payu_IN_nb: xse, wallet_IN: zse, ebanking_FI: qse, dragonpay_ebanking: I4, dragonpay_otc_banking: I4, dragonpay_otc_non_banking: I4, dragonpay_otc_philippines: I4, econtext_atm: Fy, econtext_online: Fy, econtext_seven_eleven: Fy, econtext_stores: Fy, giropay: Uie, multibanco: BO, redirect: Mm, twint: c7, vipps: l7, trustly: Kse, klarna: By, klarna_b2b: By, klarna_account: By, klarna_paynow: By, bcmc_mobile: jO, bcmc_mobile_QR: jO, pix: HO, swish: kse, wechatpay: f6, wechatpayQR: f6, promptpay: Wse, paynow: dse, duitnow: Zse, payme: f7, blik: $se, mbway: Dse, upi: A4, upi_qr: A4, upi_collect: A4, upi_intent: A4, ancv: Xse, giftcard: p6, mealVoucher_FR_natixis: d7, mealVoucher_FR_sodexo: d7, mealVoucher_FR_groupeup: d7, default: null }, P4 = function(e, t) {
  var n, r = Y4[e] || Y4.default;
  return r ? new r(VK(VK({}, t), {}, { id: je(n = "".concat(e, "-")).call(n, F2()) })) : null;
}, fN = function(e) {
  var t = e;
  return e === "scheme" && (t = arguments.length > 2 && arguments[2] !== void 0 && arguments[2] ? "storedCard" : "card"), (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {})[t] || {};
};
function UK(e) {
  return !this.length || ka(this).call(this, e.type) > -1;
}
function GK(e) {
  return !this.length || ka(this).call(this, e.type) < 0;
}
function Jet(e) {
  var t;
  return !!e && !!e.supportedShopperInteractions && jt(t = e.supportedShopperInteractions).call(t, "Ecommerce");
}
var zK = ["scheme", "blik", "twint", "ach", "cashapp"];
function Qet(e) {
  return !!e && !!e.type && jt(zK).call(zK, e.type);
}
function HK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function WK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = HK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = HK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var ett = function(e) {
  return WK(WK({}, e), {}, { storedPaymentMethodId: e.id });
}, ttt = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Qe(this, e), T(this, "paymentMethods", []), T(this, "storedPaymentMethods", []), function(r) {
      var a, o;
      if (typeof r == "string") throw new Error('paymentMethodsResponse was provided but of an incorrect type (should be an object but a string was provided).Try JSON.parse("{...}") your paymentMethodsResponse.');
      if (r instanceof Array) throw new Error("paymentMethodsResponse was provided but of an incorrect type (should be an object but an array was provided).Please check you are passing the whole response.");
      !r || r != null && (a = r.paymentMethods) !== null && a !== void 0 && a.length || r != null && (o = r.storedPaymentMethods) !== null && o !== void 0 && o.length || console.warn("paymentMethodsResponse was provided but no payment methods were found.");
    }(t), this.paymentMethods = t ? function(r, a) {
      var o, s = a.allowPaymentMethods, c = s === void 0 ? [] : s, u = a.removePaymentMethods, f = u === void 0 ? [] : u;
      return r ? Oe(o = Oe(r).call(r, UK, c)).call(o, GK, f) : [];
    }(t.paymentMethods, n) : [], this.storedPaymentMethods = t ? function(r, a) {
      var o, s, c, u, f = a.allowPaymentMethods, m = f === void 0 ? [] : f, v = a.removePaymentMethods, y = v === void 0 ? [] : v;
      return r ? It(o = Oe(s = Oe(c = Oe(u = Oe(r).call(r, Qet)).call(u, UK, m)).call(c, GK, y)).call(s, Jet)).call(o, ett) : [];
    }(t.storedPaymentMethods, n) : [];
  }
  return et(e, [{ key: "mapCreatedComponentType", value: function(t) {
    return t === "card" ? "scheme" : t;
  } }, { key: "has", value: function(t) {
    var n, r = this;
    return !!Ji(n = this.paymentMethods).call(n, function(a) {
      return a.type === r.mapCreatedComponentType(t);
    });
  } }, { key: "find", value: function(t) {
    var n, r = this;
    return Ji(n = this.paymentMethods).call(n, function(a) {
      return a.type === r.mapCreatedComponentType(t);
    });
  } }]), e;
}();
function ZK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function md(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = ZK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = ZK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var h4 = function(e) {
  return function(t, n) {
    return P4(t.paymentMethodType, md(md(md({}, n), t), {}, { onComplete: n.onAdditionalDetails, onError: n.onError, statusType: e }));
  };
}, ntt = { redirect: function(e, t) {
  return P4("redirect", md(md(md({}, t), e), {}, { statusType: "redirect" }));
}, threeDS2Fingerprint: function(e, t) {
  return P4("threeDS2DeviceFingerprint", md(md({ createFromAction: t.createFromAction, token: e.token, paymentData: e.paymentData, onError: t.onError, showSpinner: !t.isDropin, isDropin: !!t.isDropin }, t), {}, { type: "IdentifyShopper", onComplete: t.onAdditionalDetails, statusType: "loading", useOriginalFlow: !0 }));
}, threeDS2Challenge: function(e, t) {
  var n;
  return P4("threeDS2Challenge", md(md({}, t), {}, { token: e.token, paymentData: e.paymentData, onComplete: t.onAdditionalDetails, onError: t.onError, size: (n = t.size) !== null && n !== void 0 ? n : "02", isDropin: !!t.isDropin, type: "ChallengeShopper", statusType: "custom", useOriginalFlow: !0 }));
}, threeDS2: function(e, t) {
  var n, r = e.subtype === "fingerprint" ? "threeDS2DeviceFingerprint" : "threeDS2Challenge", a = e.subtype === "fingerprint" ? e.paymentData : e.authorisationToken, o = md({ token: e.token, paymentData: a, onActionHandled: t.onActionHandled, onComplete: t.onAdditionalDetails, onError: t.onError, isDropin: !!t.isDropin, loadingContext: t.loadingContext, clientKey: t.clientKey, _parentInstance: t._parentInstance, paymentMethodType: t.paymentMethodType, challengeWindowSize: t.challengeWindowSize, modules: { analytics: (n = t.modules) === null || n === void 0 ? void 0 : n.analytics } }, function(s, c) {
    if (s === "fingerprint") {
      var u = iC(c.elementRef ? lJe : uJe).from(c);
      return u.showSpinner = !c.isDropin, u.statusType = "loading", u;
    }
    return { statusType: "custom", i18n: c.i18n };
  }(e.subtype, t));
  return P4(r, o);
}, voucher: h4("custom"), qrCode: h4("custom"), await: h4("custom"), bankTransfer: h4("custom"), sdk: h4("custom") };
function YK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
var rtt = function(e) {
  return function(t) {
    var n, r, a = function(s) {
      for (var c = 1; c < arguments.length; c++) {
        var u, f, m = arguments[c] != null ? arguments[c] : {};
        c % 2 ? Q(u = YK(Object(m), !0)).call(u, function(v) {
          T(s, v, m[v]);
        }) : ne ? Ze(s, ne(m)) : Q(f = YK(Object(m))).call(f, function(v) {
          We(s, v, re(m, v));
        });
      }
      return s;
    }({ version: "5.66.1", payload_version: 1, platform: "web", locale: e.locale }, t), o = It(n = Pe(a)).call(n, function(s) {
      var c;
      return je(c = "".concat(encodeURIComponent(s), "=")).call(c, encodeURIComponent(a[s]));
    }).join("&");
    new Image().src = je(r = "".concat(e.loadingContext, "images/analytics.png?")).call(r, o);
  };
}, att = function() {
  function e() {
    Qe(this, e), T(this, "storage", void 0), this.storage = {};
  }
  return et(e, [{ key: "length", get: function() {
    return Pe(this.storage).length;
  } }, { key: "key", value: function(t) {
    return Pe(this.storage)[t];
  } }, { key: "getItem", value: function(t) {
    return this.storage[t] || null;
  } }, { key: "setItem", value: function(t, n) {
    return this.storage[t] = n;
  } }, { key: "removeItem", value: function(t) {
    delete this.storage[t];
  } }, { key: "clear", value: function() {
    this.storage = {};
  } }]), e;
}(), Jse = function() {
  function e(t, n) {
    Qe(this, e), T(this, "prefix", "adyen-checkout__"), T(this, "key", void 0), T(this, "storage", void 0);
    try {
      if (this.storage = n ? window[n] : window.localStorage, !this.storage) throw new Error("storage does not exist");
    } catch (r) {
      this.storage = new att();
    }
    this.key = this.prefix + t;
  }
  return et(e, [{ key: "get", value: function() {
    try {
      return JSON.parse(this.storage.getItem(this.key));
    } catch (t) {
      return null;
    }
  } }, { key: "set", value: function(t) {
    this.storage.setItem(this.key, Pc(t));
  } }, { key: "remove", value: function() {
    this.storage.removeItem(this.key);
  } }, { key: "clear", value: function() {
    this.storage.clear();
  } }, { key: "keyByIndex", value: function(t) {
    return this.storage.key(t);
  } }, { key: "length", get: function() {
    return this.storage.length;
  } }]), e;
}();
function XK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
var ott = function(e) {
  var t, n, r = e.analyticsContext, a = e.clientKey, o = e.locale, s = e.analyticsPath, c = { errorLevel: "fatal", loadingContext: r, path: je(t = "".concat(s, "?clientKey=")).call(t, a) };
  return function(u) {
    var f = function(y) {
      for (var b = 1; b < arguments.length; b++) {
        var S, x, E = arguments[b] != null ? arguments[b] : {};
        b % 2 ? Q(S = XK(Object(E), !0)).call(S, function(N) {
          T(y, N, E[N]);
        }) : ne ? Ze(y, ne(E)) : Q(x = XK(Object(E))).call(x, function(N) {
          We(y, N, re(E, N));
        });
      }
      return y;
    }({ version: "5.66.1", channel: "Web", platform: "Web", buildType: window.AdyenCheckout ? "umd" : "compiled", locale: o, referrer: window.location.href, screenWidth: window.screen.width }, u);
    if (n) return n;
    if (!a) return Yt.reject("no-client-key");
    var m = new Jse("checkout-attempt-id", "sessionStorage"), v = m.get();
    return function(y) {
      if (y == null || !y.id) return !1;
      var b = m2() - 9e5;
      return y.timestamp > b;
    }(v) ? Yt.resolve(v.id) : n = fl(c, f).then(function(y) {
      if (y != null && y.checkoutAttemptId) return m.set({ id: y.checkoutAttemptId, timestamp: m2() }), y.checkoutAttemptId;
    }).catch(function() {
      return Yt.reject('WARNING: Failed to retrieve "checkoutAttemptId". Consequently, analytics will not be available for this payment. The payment process, however, will not be affected.');
    });
  };
}, itt = function(e) {
  var t = e.analyticsContext, n = e.clientKey, r = e.analyticsPath, a = { channel: "Web", platform: "Web", info: [], errors: [], logs: [] }, o = { add: function(s, c) {
    a[s].push(c);
  }, run: function(s) {
    var c = function(u) {
      var f, m;
      return a.info.length || a.logs.length || a.errors.length ? fl({ errorLevel: "silent", loadingContext: t, path: je(f = je(m = "".concat(r, "/")).call(m, u, "?clientKey=")).call(f, n) }, a).then(function() {
      }).catch(function() {
        console.debug("### EventsQueue:::: send has failed");
      }) : Yt.resolve(null);
    }(s);
    return a.info = [], a.errors = [], a.logs = [], c;
  }, getQueue: function() {
    return a;
  } };
  return o;
};
function KK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = KK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = KK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var stt = function(e, t) {
  var n, r, a;
  return e === hi[B0] || e === "invalidFormatExpects" ? (r = nW[je(a = "".concat(e, ".")).call(a, t)]) !== null && r !== void 0 ? r : e : (n = nW[e]) !== null && n !== void 0 ? n : e;
}, ltt = function(e) {
  var t;
  return rr(t = Pe(e)).call(t, function(n, r) {
    return jt(aW).call(aW, r) && (n[r] = e[r]), n;
  }, {});
};
function qK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function mx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = qK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = qK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function JK(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function mm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = JK(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = JK(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var m4 = null, QK = !1, pN = null, utt = function(e) {
  var t, n, r = e.loadingContext, a = e.locale, o = e.clientKey, s = e.analytics, c = e.amount, u = e.analyticsContext, f = mm(mm({}, { enabled: !0, telemetry: !0, checkoutAttemptId: null, analyticsData: {} }), s), m = rtt({ loadingContext: r, locale: a }), v = ott({ analyticsContext: u, clientKey: o, locale: a, amount: c, analyticsPath: QH }), y = itt({ analyticsContext: u, clientKey: o, analyticsPath: QH }), b = function() {
    return m4 ? y.run(m4) : Yt.resolve(null);
  }, S = { setUp: (t = On(yt.mark(function x(E) {
    var N, R, O, D, $;
    return yt.wrap(function(B) {
      for (; ; ) switch (B.prev = B.next) {
        case 0:
          if (N = f.enabled, R = f.payload, O = f.telemetry, D = ltt(f.analyticsData), N !== !0) {
            B.next = 15;
            break;
          }
          if (O !== !0 || m4) {
            B.next = 14;
            break;
          }
          return B.prev = 4, B.next = 7, v(mm(mm(mm({}, E), R && mm({}, R)), Pe(D).length && mm({}, D)));
        case 7:
          $ = B.sent, m4 = $, B.next = 14;
          break;
        case 11:
          B.prev = 11, B.t0 = B.catch(4), console.warn("Fetching checkoutAttemptId failed.".concat(B.t0 ? " Error=".concat(B.t0) : ""));
        case 14:
          QK || (m(E), QK = !0);
        case 15:
        case "end":
          return B.stop();
      }
    }, x, null, [[4, 11]]);
  })), function(x) {
    return t.apply(this, arguments);
  }), getCheckoutAttemptId: function() {
    return m4;
  }, getEventsQueue: function() {
    return y;
  }, createAnalyticsEvent: function(x) {
    var E, N, R, O = x.event, D = function($) {
      return gf(gf(gf(gf(gf(gf(gf(gf(gf(gf({ timestamp: String(m2()), component: $.component, id: F2() }, $.event === "error" && { code: $.code, errorType: $.errorType, message: $.message }), $.event === "log" && { type: $.type, message: $.message }), $.event === "log" && ($.type === oO || $.type === If) && { subType: $.subtype }), $.event === "log" && $.type === If && { result: $.result }), $.event === "info" && { type: $.type, target: $.target }), $.event === "info" && $.issuer && { issuer: $.issuer }), $.event === "info" && { isExpress: $.isExpress, expressPage: $.expressPage }), $.event === "info" && $.isStoredPaymentMethod && { isStoredPaymentMethod: $.isStoredPaymentMethod, brand: $.brand }), $.event === "info" && $.type === sO && { validationErrorCode: stt($.validationErrorCode, $.target), validationErrorMessage: $.validationErrorMessage }), $.metadata && { metadata: $.metadata });
    }(mm({ event: O }, x.data));
    return N = D, R = (E = O) === h0 ? E : "".concat(E, "s"), y.add("".concat(R), N), E === h0 && (clearTimeout(pN), pN = Ro(b, 1e4)), E !== ZS && E !== eW || (clearTimeout(pN), aD(b)()), D;
  }, getEnabled: function() {
    return f.enabled;
  }, sendAnalytics: null };
  return S.sendAnalytics = (n = S, function(x, E) {
    var N = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, R = E.type, O = E.target;
    switch (R) {
      case e1:
        var D = E.isStoredPaymentMethod, $ = E.brand, B = N.isExpress, G = N.expressPage, Z = G && jt(rW).call(rW, G), K = mx(mx(mx(mx({ component: x, type: R }, typeof D == "boolean" && { isStoredPaymentMethod: D }), $ && { brand: $ }), typeof B == "boolean" && { isExpress: B }), B === !0 && Z && { expressPage: G });
        n.createAnalyticsEvent({ event: h0, data: K });
        break;
      case lO:
        var q = { component: x, type: R, isStoredPaymentMethod: E.isStoredPaymentMethod, brand: E.brand };
        n.createAnalyticsEvent({ event: h0, data: q });
        break;
      case BM:
      case VM:
      case yoe:
      case boe:
      case _oe:
        n.createAnalyticsEvent({ event: h0, data: { component: x, type: R, target: O } });
        break;
      case N8:
        var pe = E.issuer;
        n.createAnalyticsEvent({ event: h0, data: { component: x, type: R, target: O, issuer: pe } });
        break;
      case sO:
        var he = E.validationErrorCode, _e = E.validationErrorMessage;
        n.createAnalyticsEvent({ event: h0, data: { component: x, type: R, target: O, validationErrorCode: he, validationErrorMessage: _e } });
        break;
      case iO:
        n.createAnalyticsEvent({ event: ZS, data: { component: x, type: R, message: "Shopper clicked pay" } });
        break;
      case oO:
        var ge = E.subtype, Y = E.message;
        n.createAnalyticsEvent({ event: ZS, data: { component: x, type: R, subtype: ge, message: Y } });
        break;
      case If:
        var ee = E.message, oe = E.metadata, me = E.subtype, xe = E.result;
        n.createAnalyticsEvent({ event: ZS, data: { component: x, type: R, message: ee, metadata: oe, subtype: me, result: xe } });
        break;
      case vD:
        var X = E.message, ye = E.code, ce = E.errorType;
        n.createAnalyticsEvent({ event: eW, data: { component: x, type: R, message: X, code: ye, errorType: ce } });
        break;
      default:
        n.createAnalyticsEvent(E);
    }
  }), S;
};
function eq(e) {
  var t;
  return rr(t = Pe(e)).call(t, function(n, r) {
    return jt(GW).call(GW, r) && (n[r] = e[r]), n;
  }, {});
}
var b2 = "v1";
function tq(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ctt(e, t) {
  var n, r, a = je(n = je(r = "".concat(b2, "/sessions/")).call(r, t.id, "/payments?clientKey=")).call(n, t.clientKey), o = function(s) {
    for (var c = 1; c < arguments.length; c++) {
      var u, f, m = arguments[c] != null ? arguments[c] : {};
      c % 2 ? Q(u = tq(Object(m), !0)).call(u, function(v) {
        T(s, v, m[v]);
      }) : ne ? Ze(s, ne(m)) : Q(f = tq(Object(m))).call(f, function(v) {
        We(s, v, re(m, v));
      });
    }
    return s;
  }({ sessionData: t.data }, e);
  return fl({ loadingContext: t.loadingContext, path: a, errorLevel: "fatal" }, o);
}
function nq(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function dtt(e, t) {
  var n, r, a = je(n = je(r = "".concat(b2, "/sessions/")).call(r, t.id, "/paymentDetails?clientKey=")).call(n, t.clientKey), o = function(s) {
    for (var c = 1; c < arguments.length; c++) {
      var u, f, m = arguments[c] != null ? arguments[c] : {};
      c % 2 ? Q(u = nq(Object(m), !0)).call(u, function(v) {
        T(s, v, m[v]);
      }) : ne ? Ze(s, ne(m)) : Q(f = nq(Object(m))).call(f, function(v) {
        We(s, v, re(m, v));
      });
    }
    return s;
  }({ sessionData: t.data }, e);
  return fl({ loadingContext: t.loadingContext, path: a, errorLevel: "fatal" }, o);
}
function rq(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ftt(e, t) {
  var n, r, a = je(n = je(r = "".concat(b2, "/sessions/")).call(r, e.id, "/setup?clientKey=")).call(n, e.clientKey), o = function(s) {
    for (var c = 1; c < arguments.length; c++) {
      var u, f, m = arguments[c] != null ? arguments[c] : {};
      c % 2 ? Q(u = rq(Object(m), !0)).call(u, function(v) {
        T(s, v, m[v]);
      }) : ne ? Ze(s, ne(m)) : Q(f = rq(Object(m))).call(f, function(v) {
        We(s, v, re(m, v));
      });
    }
    return s;
  }({ sessionData: e.data }, t.order ? { order: { orderData: t.order.orderData, pspReference: t.order.pspReference } } : {});
  return fl({ loadingContext: e.loadingContext, path: a, errorLevel: "fatal" }, o);
}
function aq(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ptt(e, t) {
  var n, r, a = je(n = je(r = "".concat(b2, "/sessions/")).call(r, t.id, "/paymentMethodBalance?clientKey=")).call(n, t.clientKey), o = function(s) {
    for (var c = 1; c < arguments.length; c++) {
      var u, f, m = arguments[c] != null ? arguments[c] : {};
      c % 2 ? Q(u = aq(Object(m), !0)).call(u, function(v) {
        T(s, v, m[v]);
      }) : ne ? Ze(s, ne(m)) : Q(f = aq(Object(m))).call(f, function(v) {
        We(s, v, re(m, v));
      });
    }
    return s;
  }({ sessionData: t.data }, e);
  return fl({ loadingContext: t.loadingContext, path: a, errorLevel: "fatal" }, o);
}
function oq(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function htt(e) {
  if (!e || !e.id) throw new Error("Invalid session");
  return function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var r, a, o = arguments[n] != null ? arguments[n] : {};
      n % 2 ? Q(r = oq(Object(o), !0)).call(r, function(s) {
        T(t, s, o[s]);
      }) : ne ? Ze(t, ne(o)) : Q(a = oq(Object(o))).call(a, function(s) {
        We(t, s, re(o, s));
      });
    }
    return t;
  }({ id: e.id }, e.sessionData ? { sessionData: e.sessionData } : {});
}
function iq(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
var mtt = function() {
  function e(t, n, r) {
    Qe(this, e), T(this, "session", void 0), T(this, "storage", void 0), T(this, "clientKey", void 0), T(this, "loadingContext", void 0), T(this, "configuration", void 0);
    var a = htt(t);
    if (!n) throw new Error("No clientKey available");
    if (!r) throw new Error("No loadingContext available");
    this.storage = new Jse("session", "localStorage"), this.clientKey = n, this.loadingContext = r, this.session = a, this.session.sessionData ? this.storeSession() : this.session = this.getStoredSession();
  }
  return et(e, [{ key: "id", get: function() {
    return this.session.id;
  } }, { key: "data", get: function() {
    return this.session.sessionData;
  } }, { key: "updateSessionData", value: function(t) {
    this.session.sessionData = t, this.storeSession();
  } }, { key: "setupSession", value: function(t) {
    var n = this;
    return ftt(this, t).then(function(r) {
      return r.configuration && (n.configuration = function(a) {
        for (var o = 1; o < arguments.length; o++) {
          var s, c, u = arguments[o] != null ? arguments[o] : {};
          o % 2 ? Q(s = iq(Object(u), !0)).call(s, function(f) {
            T(a, f, u[f]);
          }) : ne ? Ze(a, ne(u)) : Q(c = iq(Object(u))).call(c, function(f) {
            We(a, f, re(u, f));
          });
        }
        return a;
      }({}, r.configuration)), r.sessionData && n.updateSessionData(r.sessionData), r;
    });
  } }, { key: "submitPayment", value: function(t) {
    var n = this;
    return ctt(t, this).then(function(r) {
      return r.sessionData && n.updateSessionData(r.sessionData), r;
    });
  } }, { key: "submitDetails", value: function(t) {
    var n = this;
    return dtt(t, this).then(function(r) {
      return r.sessionData && n.updateSessionData(r.sessionData), r;
    });
  } }, { key: "checkBalance", value: function(t) {
    var n = this;
    return ptt(t, this).then(function(r) {
      return r.sessionData && n.updateSessionData(r.sessionData), r;
    });
  } }, { key: "createOrder", value: function() {
    var t = this;
    return function(n) {
      var r, a, o = je(r = je(a = "".concat(b2, "/sessions/")).call(a, n.id, "/orders?clientKey=")).call(r, n.clientKey), s = { sessionData: n.data };
      return fl({ loadingContext: n.loadingContext, path: o, errorLevel: "fatal" }, s);
    }(this).then(function(n) {
      return n.sessionData && t.updateSessionData(n.sessionData), n;
    });
  } }, { key: "cancelOrder", value: function(t) {
    var n = this;
    return function(r, a) {
      var o, s, c = je(o = je(s = "".concat(b2, "/sessions/")).call(s, a.id, "/orders/cancel?clientKey=")).call(o, a.clientKey), u = { sessionData: a.data, order: r };
      return fl({ loadingContext: a.loadingContext, path: c, errorLevel: "fatal" }, u);
    }(t.order, this).then(function(r) {
      return r.sessionData && n.updateSessionData(r.sessionData), r;
    });
  } }, { key: "getStoredSession", value: function() {
    var t = this.storage.get();
    return this.id === (t == null ? void 0 : t.id) ? t : this.session;
  } }, { key: "storeSession", value: function() {
    this.storage.set({ id: this.session.id, sessionData: this.session.sessionData });
  } }, { key: "removeStoredSession", value: function() {
    this.storage.remove();
  } }]), e;
}();
function vtt(e) {
  var t = e.setComponentRef, n = _n({});
  Pe(n.current).length || t == null || t(n.current);
  var r = Je(null), a = ze(r, 2), o = a[0], s = a[1];
  return n.current.setMessages = function(c) {
    s(c);
  }, o ? P(ra, null, It(o).call(o, function(c) {
    return P("div", kt({ key: c, className: "adyen-checkout-sr-panel__msg" }, !1), c);
  })) : null;
}
function sq(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = sq(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = sq(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
function gtt(e) {
  var t = function() {
    if (typeof Reflect == "undefined" || !U || U.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(U(Boolean, [], function() {
      })), !0;
    } catch (n) {
      return !1;
    }
  }();
  return function() {
    var n, r = fe(e);
    if (t) {
      var a = fe(this).constructor;
      n = U(r, arguments, a);
    } else n = r.apply(this, arguments);
    return ct(this, n);
  };
}
var KO = function(e) {
  ft(n, T8);
  var t = gtt(n);
  function n(r) {
    var a, o;
    if (Qe(this, n), o = t.call(this, r), T(Se(o), "srPanelContainer", null), T(Se(o), "id", void 0), T(Se(o), "showPanel", void 0), T(Se(o), "_enabled", void 0), T(Se(o), "_moveFocus", void 0), T(Se(o), "componentRef", void 0), T(Se(o), "setComponentRef", function(c) {
      o.componentRef = c;
    }), T(Se(o), "setMessages", function(c) {
      if (o.props.enabled) {
        var u = null;
        c && (u = E8(c) ? c : [c]), o.componentRef.setMessages(u);
      }
    }), o.id = o.props.id, o.showPanel = !1, o._enabled = !1, o._moveFocus = (a = o.props.moveFocus) === null || a === void 0 || a, o.props.enabled) {
      if (o._enabled = !0, !document.querySelector(o.props.node)) throw new Error("Component could not mount. Root node was not found.");
      var s = document.getElementById(o.id);
      s && document.querySelector(o.props.node).removeChild(s), o.srPanelContainer = document.createElement("div"), o.srPanelContainer.className = "sr-panel-holder", o.srPanelContainer.id = o.id, document.querySelector(o.props.node).appendChild(o.srPanelContainer), o.mount(o.srPanelContainer);
    }
    return o;
  }
  return et(n, [{ key: "enabled", get: function() {
    return this._enabled;
  } }, { key: "moveFocus", get: function() {
    return this._moveFocus;
  } }, { key: "setAriaProps", value: function(r) {
    for (var a = document.querySelector('[class^="adyen-checkout-sr-panel"]'), o = 0, s = K_(r); o < s.length; o++) {
      var c = ze(s[o], 2), u = c[0], f = c[1];
      a.setAttribute(u, f);
    }
    this.props = vx(vx({}, this.props), {}, { ariaAttributes: vx(vx({}, this.props.ariaAttributes), r) });
  } }, { key: "render", value: function() {
    return this.props.enabled ? P("div", kt({ className: this.showPanel ? "adyen-checkout-sr-panel" : "adyen-checkout-sr-panel--sr-only", role: "log" }, this.props.ariaAttributes, !1), P(vtt, { setComponentRef: this.setComponentRef })) : null;
  } }]), n;
}();
T(KO, "type", "srPanel"), T(KO, "defaultProps", { enabled: !0, node: "body", showPanel: !1, id: "ariaLiveSRPanel", ariaAttributes: { "aria-relevant": "all", "aria-live": "polite", "aria-atomic": "true" } });
var ytt = ["amount", "shopperLocale", "paymentMethods"];
function lq(e, t) {
  var n = Pe(e);
  if (te) {
    var r = te(e);
    t && (r = Oe(r).call(r, function(a) {
      return re(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n, r, a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q(n = lq(Object(a), !0)).call(n, function(o) {
      T(e, o, a[o]);
    }) : ne ? Ze(e, ne(a)) : Q(r = lq(Object(a))).call(r, function(o) {
      We(e, o, re(a, o));
    });
  }
  return e;
}
var Qse = function() {
  function e(t) {
    var n, r, a, o, s, c, u = this;
    Qe(this, e), T(this, "session", void 0), T(this, "paymentMethodsResponse", void 0), T(this, "modules", void 0), T(this, "options", void 0), T(this, "components", []), T(this, "loadingContext", void 0), T(this, "cdnContext", void 0), T(this, "analyticsContext", void 0), T(this, "update", function() {
      var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return u.setOptions(v), u.initialize().then(function() {
        var y;
        return Q(y = u.components).call(y, function(b) {
          return b.update(u.getPropsForComponent(u.options));
        }), u;
      });
    }), T(this, "remove", function(v) {
      var y;
      return u.components = Oe(y = u.components).call(y, function(b) {
        return b._id !== v._id;
      }), v.unmount(), u;
    }), T(this, "setOptions", function(v) {
      Ir(v == null ? void 0 : v.paymentMethodsConfiguration, "scheme") && console.warn('WARNING: You cannot define a property "scheme" on the paymentMethodsConfiguration object - it should be defined as "card" otherwise it will be ignored'), Ir(v, "installmentOptions") && console.warn("WARNING: you are setting installmentOptions directly in the top level configuration object. They should be set via the 'paymentMethodsConfiguration' object or directly on the 'card' component."), u.options = fi(fi({}, u.options), v);
    }), this.create = pn(n = this.create).call(n, this), this.createFromAction = pn(r = this.createFromAction).call(r, this), this.setOptions(t), this.loadingContext = function() {
      var v = arguments.length > 1 ? arguments[1] : void 0;
      return v || { test: "https://checkoutshopper-test.adyen.com/checkoutshopper/", live: "https://checkoutshopper-live.adyen.com/checkoutshopper/", "live-us": "https://checkoutshopper-live-us.adyen.com/checkoutshopper/", "live-au": "https://checkoutshopper-live-au.adyen.com/checkoutshopper/", "live-apse": "https://checkoutshopper-live-apse.adyen.com/checkoutshopper/", "live-in": "https://checkoutshopper-live-in.adyen.com/checkoutshopper/" }[(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "").toLowerCase()] || "https://checkoutshopper-live.adyen.com/checkoutshopper/";
    }(this.options.environment, (a = this.options.environmentUrls) === null || a === void 0 ? void 0 : a.api), this.cdnContext = function() {
      var v = arguments.length > 1 ? arguments[1] : void 0;
      return v || { beta: "https://cdf6519016.cdn.adyen.com/checkoutshopper/", test: "https://checkoutshopper-test.adyen.com/checkoutshopper/", live: "https://checkoutshopper-live.adyen.com/checkoutshopper/", "live-us": "https://checkoutshopper-live-us.adyen.com/checkoutshopper/", "live-au": "https://checkoutshopper-live-au.adyen.com/checkoutshopper/", "live-apse": "https://checkoutshopper-live-apse.adyen.com/checkoutshopper/", "live-in": "https://checkoutshopper-live-in.adyen.com/checkoutshopper/" }[(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "").toLowerCase()] || cO;
    }(this.options.resourceEnvironment || this.options.environment, (o = this.options.environmentUrls) === null || o === void 0 ? void 0 : o.api), this.analyticsContext = function() {
      var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "https://checkoutanalytics-live.adyen.com/checkoutanalytics/", y = { test: "https://checkoutanalytics-test.adyen.com/checkoutanalytics/", live: "https://checkoutanalytics-live.adyen.com/checkoutanalytics/", "live-us": "https://checkoutanalytics-live-us.adyen.com/checkoutanalytics/", "live-au": "https://checkoutanalytics-live-au.adyen.com/checkoutanalytics/", "live-apse": "https://checkoutanalytics-live-apse.adyen.com/checkoutanalytics/", "live-in": "https://checkoutanalytics-live-in.adyen.com/checkoutanalytics/" };
      return y[v] || y[v.toLowerCase()] || v;
    }(this.options.environment);
    var f, m = (s = this.options.clientKey) === null || s === void 0 ? void 0 : s.substr(0, 4);
    if ((m === "test" || m === "live") && !jt(c = this.loadingContext).call(c, m)) throw new Error(je(f = "Error: you are using a '".concat(m, "' clientKey against the '")).call(f, this.options.environment, "' environment"));
    window.adyenWebVersion = e.version.version;
  }
  return et(e, [{ key: "initialize", value: function() {
    var t = this;
    return this.options.session ? (this.session = new mtt(this.options.session, this.options.clientKey, this.loadingContext), this.session.setupSession(this.options).then(function(n) {
      var r = n.amount, a = n.shopperLocale, o = n.paymentMethods, s = pa(n, ytt);
      return t.setOptions(fi(fi({}, s), {}, { amount: t.options.order ? t.options.order.remainingAmount : r, locale: t.options.locale || a })), t.createPaymentMethodsList(o), t.createCoreModules(), t;
    }).catch(function(n) {
      return t.options.onError && t.options.onError(n), t;
    })) : (this.createCoreModules(), this.createPaymentMethodsList(), Yt.resolve(this));
  } }, { key: "submitDetails", value: function(t) {
    var n = this;
    if (this.options.onAdditionalDetails) return this.options.onAdditionalDetails(t);
    this.session && this.session.submitDetails(t).then(function(r) {
      var a, o;
      (a = (o = n.options).onPaymentCompleted) === null || a === void 0 || a.call(o, r);
    }).catch(function(r) {
      var a, o;
      (a = (o = n.options).onError) === null || a === void 0 || a.call(o, r);
    });
  } }, { key: "create", value: function(t, n) {
    var r = this.getPropsForComponent(n);
    return t ? this.handleCreate(t, r) : this.handleCreateError();
  } }, { key: "createFromAction", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!t || !t.type)
      throw Ir(t, "action") && Ir(t, "resultCode") ? new Error('createFromAction::Invalid Action - the passed action object itself has an "action" property and a "resultCode": have you passed in the whole response object by mistake?') : new Error('createFromAction::Invalid Action - the passed action object does not have a "type" property');
    if (t.type) {
      var r, a = t.type === If ? je(r = "".concat(t.type)).call(r, t.subtype) : t.paymentMethodType;
      this.modules.analytics.sendAnalytics(a, { type: oO, subtype: t.type, message: "".concat(a, " action was handled by the SDK") });
      var o = fN(t.type, this.options.paymentMethodsConfiguration);
      return function(s) {
        var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = ntt[s.type];
        if (u && typeof u == "function") return u(s, c);
        throw new Error("Invalid Action");
      }(t, fi(fi(fi({}, eq(this.options)), o), this.getPropsForComponent(n)));
    }
    return this.handleCreateError();
  } }, { key: "getPropsForComponent", value: function(t) {
    return fi(fi(fi({ paymentMethods: this.paymentMethodsResponse.paymentMethods, storedPaymentMethods: this.paymentMethodsResponse.storedPaymentMethods }, this.options.countryCode === "FI" ? { openFirstPaymentMethod: !1, openFirstStoredPaymentMethod: !1 } : {}), t), {}, { i18n: this.modules.i18n, modules: this.modules, session: this.session, loadingContext: this.loadingContext, cdnContext: this.cdnContext, createFromAction: this.createFromAction, _parentInstance: this });
  } }, { key: "handleCreate", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (t.prototype instanceof Dr) {
      var r, a = n.type !== "dropin" && !n.isDropin, o = a && !n.supportedShopperInteractions ? Ji(r = this.paymentMethodsResponse).call(r, n.type) : {}, s = a ? fN(n.type, this.options.paymentMethodsConfiguration, !!n.storedPaymentMethodId) : {}, c = new t(fi(fi(fi(fi({}, eq(this.options)), o), s), n));
      return n.isDropin || this.components.push(c), c;
    }
    if (typeof t == "string" && Y4[t]) return t === "dropin" && Ir(n, "paymentMethodsConfiguration") && console.warn("WARNING: You are setting a 'paymentMethodsConfiguration' object in the Dropin configuration options. This object will be ignored."), this.handleCreate(Y4[t], fi({ type: t }, n));
    if (typeof t == "string" && this.paymentMethodsResponse.has(t)) return this.handleCreate(Y4.redirect, fi({ type: t }, n));
    if (mi(t) === "object" && typeof t.type == "string") {
      var u = fN(t.type, this.options.paymentMethodsConfiguration, !!t.storedPaymentMethodId);
      return this.handleCreate(t.type, fi(fi(fi({}, t), n), u));
    }
    return this.handleCreateError(t);
  } }, { key: "handleCreateError", value: function(t) {
    var n, r = t && t.name ? t.name : "The passed payment method", a = t ? je(n = "".concat(r, " is not a valid Checkout Component. What was passed as a txVariant was: ")).call(n, Pc(t), ". Check if this payment method is configured in the Backoffice or if the txVariant is a valid one") : "No Payment Method component was passed";
    throw new Error(a);
  } }, { key: "createPaymentMethodsList", value: function(t) {
    this.paymentMethodsResponse = new ttt(this.options.paymentMethodsResponse || t, this.options);
  } }, { key: "createCoreModules", value: function() {
    this.modules || (this.modules = PTe({ risk: new dO(fi(fi({}, this.options), {}, { loadingContext: this.loadingContext })), analytics: utt({ loadingContext: this.loadingContext, analyticsContext: this.analyticsContext, clientKey: this.options.clientKey, locale: this.options.locale, analytics: this.options.analytics, amount: this.options.amount }), resources: new koe(this.cdnContext), i18n: new goe(this.options.locale, this.options.translations), srPanel: new KO(this.options.srConfig) }));
  } }]), e;
}();
function btt(e) {
  return qO.apply(this, arguments);
}
function qO() {
  return qO = On(yt.mark(function e(t) {
    var n;
    return yt.wrap(function(r) {
      for (; ; ) switch (r.prev = r.next) {
        case 0:
          return n = new Qse(t), r.next = 3, n.initialize();
        case 3:
          return r.abrupt("return", r.sent);
        case 4:
        case "end":
          return r.stop();
      }
    }, e);
  })), qO.apply(this, arguments);
}
T(Qse, "version", { version: "5.66.1", revision: "aa18474", branch: "HEAD", buildId: "@adyen/adyen-web-f79d52ec-a302-4f04-addc-dde86866ce63" });
const _tt = (e, t, n = !1) => st(void 0, null, function* () {
  const r = or(), a = parseInt(En("CLEENG_ORDER_ID") || "0", 10), o = `${r}/connectors/adyen/sessions`, s = yield Mr(o, {
    method: "POST",
    body: JSON.stringify(n ? {
      returnUrl: $7({ isMyAccount: !0 }),
      filterPaymentMethodsByType: e,
      filterPaymentMethods: t
    } : {
      orderId: a,
      filterPaymentMethodsByType: e,
      filterPaymentMethods: t,
      returnUrl: $7({
        queryParams: { orderId: a }
      })
    })
  }), { responseData: c, errors: u } = yield s.json();
  if (!s.ok)
    throw new Error(u[0]);
  return c;
}), Ctt = (e) => {
  mn(() => {
    const t = document.createElement("script");
    return t.src = e, t.async = !0, document.body.appendChild(t), () => {
      document.body.removeChild(t);
    };
  }, [e]);
}, wtt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28.646 22.28" }, e), /* @__PURE__ */ k.createElement("path", { id: "Icon_awesome-credit-card", "data-name": "Icon awesome-credit-card", d: "M0,22.143A2.388,2.388,0,0,0,2.387,24.53H26.259a2.388,2.388,0,0,0,2.387-2.387V13.39H0Zm9.549-3.382a.6.6,0,0,1,.6-.6h6.764a.6.6,0,0,1,.6.6V20.75a.6.6,0,0,1-.6.6H10.145a.6.6,0,0,1-.6-.6Zm-6.366,0a.6.6,0,0,1,.6-.6H7.36a.6.6,0,0,1,.6.6V20.75a.6.6,0,0,1-.6.6H3.78a.6.6,0,0,1-.6-.6ZM28.646,4.637V7.024H0V4.637A2.388,2.388,0,0,1,2.387,2.25H26.259A2.388,2.388,0,0,1,28.646,4.637Z", transform: "translate(0 -2.25)", fill: "#bcc3cd" })), bD = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ width: "100%", height: "100%", viewBox: "0 0 26 31", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/" }, e), /* @__PURE__ */ k.createElement("g", { id: "Artboard1", transform: "matrix(1,0,0,1,-1.11762e-05,0)" }, /* @__PURE__ */ k.createElement("rect", { x: 0, y: 0, width: 25.576, height: 30.177, style: {
  fill: "none"
} }), /* @__PURE__ */ k.createElement("clipPath", { id: "_clip1" }, /* @__PURE__ */ k.createElement("rect", { x: 0, y: 0, width: 25.576, height: 30.177 })), /* @__PURE__ */ k.createElement("g", { clipPath: "url(#_clip1)" }, /* @__PURE__ */ k.createElement("g", { transform: "matrix(1,0,0,1,1.11762e-05,0)" }, /* @__PURE__ */ k.createElement("path", { d: "M7.266,29.154L7.789,25.832L6.624,25.805L1.061,25.805L4.927,1.292C4.939,1.218 4.978,1.149 5.035,1.1C5.092,1.051 5.165,1.024 5.241,1.024L14.621,1.024C17.735,1.024 19.884,1.672 21.006,2.951C21.532,3.551 21.867,4.178 22.029,4.868C22.199,5.592 22.202,6.457 22.036,7.512L22.024,7.589L22.024,8.265L22.55,8.563C22.993,8.798 23.345,9.067 23.615,9.375C24.065,9.888 24.356,10.54 24.479,11.313C24.606,12.108 24.564,13.054 24.356,14.125C24.116,15.357 23.728,16.43 23.204,17.308C22.722,18.117 22.108,18.788 21.379,19.308C20.683,19.802 19.856,20.177 18.921,20.417C18.015,20.653 16.982,20.772 15.849,20.772L15.119,20.772C14.597,20.772 14.09,20.96 13.692,21.297C13.293,21.641 13.029,22.111 12.948,22.625L12.893,22.924L11.969,28.779L11.927,28.994C11.916,29.062 11.897,29.096 11.869,29.119C11.844,29.14 11.808,29.154 11.773,29.154L7.266,29.154Z", style: {
  fill: "rgb(37,59,128)",
  fillRule: "nonzero"
} }), /* @__PURE__ */ k.createElement("path", { d: "M23.048,7.667C23.02,7.846 22.988,8.029 22.952,8.217C21.715,14.568 17.483,16.762 12.078,16.762L9.326,16.762C8.665,16.762 8.108,17.242 8.005,17.894L6.596,26.83L6.197,29.363C6.13,29.791 6.46,30.177 6.892,30.177L11.773,30.177C12.351,30.177 12.842,29.757 12.933,29.187L12.981,28.939L13.9,23.107L13.959,22.787C14.049,22.215 14.541,21.795 15.119,21.795L15.849,21.795C20.578,21.795 24.28,19.875 25.362,14.319C25.814,11.998 25.58,10.06 24.384,8.697C24.022,8.286 23.573,7.945 23.048,7.667Z", style: {
  fill: "rgb(23,155,215)",
  fillRule: "nonzero"
} }), /* @__PURE__ */ k.createElement("path", { d: "M21.754,7.151C21.565,7.096 21.37,7.046 21.17,7.001C20.969,6.957 20.763,6.918 20.551,6.884C19.809,6.764 18.996,6.707 18.125,6.707L10.773,6.707C10.592,6.707 10.42,6.748 10.266,6.822C9.927,6.985 9.675,7.306 9.614,7.699L8.05,17.605L8.005,17.894C8.108,17.242 8.665,16.762 9.326,16.762L12.078,16.762C17.483,16.762 21.715,14.567 22.952,8.217C22.989,8.029 23.02,7.846 23.048,7.667C22.735,7.501 22.396,7.359 22.031,7.238C21.941,7.208 21.848,7.179 21.754,7.151Z", style: {
  fill: "rgb(34,45,101)",
  fillRule: "nonzero"
} }), /* @__PURE__ */ k.createElement("path", { d: "M9.614,7.699C9.675,7.306 9.927,6.985 10.266,6.823C10.421,6.749 10.592,6.708 10.773,6.708L18.125,6.708C18.996,6.708 19.809,6.765 20.551,6.885C20.763,6.919 20.969,6.958 21.17,7.002C21.37,7.047 21.565,7.097 21.754,7.152C21.848,7.18 21.941,7.209 22.032,7.238C22.397,7.359 22.736,7.502 23.049,7.667C23.417,5.32 23.046,3.722 21.777,2.275C20.378,0.682 17.853,0 14.622,0L5.242,0C4.582,0 4.019,0.48 3.917,1.133L0.01,25.898C-0.067,26.388 0.311,26.83 0.805,26.83L6.596,26.83L8.05,17.605L9.614,7.699Z", style: {
  fill: "rgb(37,59,128)",
  fillRule: "nonzero"
} }))))), JO = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 47.654 19.573" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_2834", "data-name": "Group 2834", transform: "translate(-657.466 -581)", style: {
  isolation: "isolate"
} }, /* @__PURE__ */ k.createElement("path", { id: "Path_1960", "data-name": "Path 1960", d: "M1467.467,704.565l-.286-.067v-1.7c.185,0,.367,0,.55,0a1.776,1.776,0,0,0,1.94-1.33,1.993,1.993,0,0,0,.016-1.529c-1.181-3.175-2.317-6.367-3.467-9.554-.033-.093-.061-.188-.1-.306.759,0,1.5,0,2.231.009.061,0,.149.116.174.193.429,1.368.851,2.739,1.274,4.11s.838,2.711,1.258,4.066c.018.059.04.117.085.248.048-.14.078-.219.1-.3q1.256-4.054,2.509-8.109c.047-.152.1-.225.282-.222.675.013,1.35.005,2.054.005a1.762,1.762,0,0,1-.043.183q-2,5.618-4.013,11.236a6.341,6.341,0,0,1-1,1.859,3.174,3.174,0,0,1-2.229,1.162c-.075.008-.149.029-.224.045Z", transform: "translate(-770.97 -103.991)", fill: "#bcc3cd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1961", "data-name": "Path 1961", d: "M797.059,581a3.426,3.426,0,0,1-2.41,3.554,6.35,6.35,0,0,1-.737.105,2.5,2.5,0,0,1,.142-1.272,3.529,3.529,0,0,1,2.668-2.344.658.658,0,0,0,.1-.043Z", transform: "translate(-130.062)", fill: "#bcc3cd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1962", "data-name": "Path 1962", d: "M669.862,664.428a3.518,3.518,0,0,0,.433,6.231c-.177.409-.338.827-.535,1.227a9.013,9.013,0,0,1-1.437,2.11,2.06,2.06,0,0,1-2.608.558,3.254,3.254,0,0,0-2.029-.339,7.95,7.95,0,0,0-1.057.345,2.538,2.538,0,0,1-1.266.233,2.054,2.054,0,0,1-1.2-.67,9.773,9.773,0,0,1-2.395-4.331,7.133,7.133,0,0,1-.086-3.795,4.007,4.007,0,0,1,2.43-2.816,3.2,3.2,0,0,1,2.364-.052c.291.107.583.211.869.332a1.559,1.559,0,0,0,1.22.008,9.333,9.333,0,0,1,1.5-.5,3.611,3.611,0,0,1,3.581,1.164c.052.057.1.121.144.183C669.812,664.346,669.831,664.379,669.862,664.428Z", transform: "translate(0 -78.064)", fill: "#bcc3cd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1963", "data-name": "Path 1963", d: "M1022.6,604.825c.079,0,.141-.009.2-.009,1.77,0,3.541-.009,5.311,0a4.561,4.561,0,0,1,3.579,1.551,4.722,4.722,0,0,1,1.116,3.342,4.588,4.588,0,0,1-1.508,3.461,4.8,4.8,0,0,1-3.225,1.19c-.97.019-1.941.006-2.911.007h-.312v4.941H1022.6Zm2.262,1.9v5.744c.839,0,1.661,0,2.483,0,.186,0,.374,0,.558-.018a3.061,3.061,0,0,0,1.6-.566,2.689,2.689,0,0,0,1-2.277,2.561,2.561,0,0,0-1.951-2.758,3.458,3.458,0,0,0-.8-.12c-.916-.018-1.833-.014-2.749-.018A1.42,1.42,0,0,0,1024.865,606.726Z", transform: "translate(-348.121 -22.703)", fill: "#bcc3cd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1964", "data-name": "Path 1964", d: "M1262.627,697.649h-2.076v-1.688l-.087-.057a.252.252,0,0,1-.013.1,4.076,4.076,0,0,1-5.783.966,2.914,2.914,0,0,1,.538-4.849,6.933,6.933,0,0,1,2.6-.572c.829-.05,1.659-.094,2.488-.15.06,0,.165-.084.164-.127a7.5,7.5,0,0,0-.053-1.16,1.494,1.494,0,0,0-1.126-1.211,3.037,3.037,0,0,0-1.543-.08,1.839,1.839,0,0,0-1.56,1.412h-2.02a2.759,2.759,0,0,1,.373-1.334,3.622,3.622,0,0,1,2.283-1.682,5.54,5.54,0,0,1,3.954.28,3.051,3.051,0,0,1,1.862,2.928c.01,2.346,0,4.691,0,7.037Zm-2.195-4.729a.535.535,0,0,0-.089-.009c-.751.047-1.5.092-2.253.142a3.907,3.907,0,0,0-1.448.3,1.339,1.339,0,0,0,.028,2.483,2.722,2.722,0,0,0,1.5.188A2.463,2.463,0,0,0,1260.432,692.92Z", transform: "translate(-568.363 -101.039)", fill: "#bcc3cd" }))), ele = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 80 38.1" }, e), /* @__PURE__ */ k.createElement("path", { className: "st0", d: "M37.8,19.7V29h-3V6h7.8c1.9,0,3.7,0.7,5.1,2c1.4,1.2,2.1,3,2.1,4.9c0,1.9-0.7,3.6-2.1,4.9c-1.4,1.3-3.1,2-5.1,2 L37.8,19.7L37.8,19.7z M37.8,8.8v8h5c1.1,0,2.2-0.4,2.9-1.2c1.6-1.5,1.6-4,0.1-5.5c0,0-0.1-0.1-0.1-0.1c-0.8-0.8-1.8-1.3-2.9-1.2 L37.8,8.8L37.8,8.8z", fill: "#5F6368" }), /* @__PURE__ */ k.createElement("path", { className: "st0", d: "M56.7,12.8c2.2,0,3.9,0.6,5.2,1.8s1.9,2.8,1.9,4.8V29H61v-2.2h-0.1c-1.2,1.8-2.9,2.7-4.9,2.7 c-1.7,0-3.2-0.5-4.4-1.5c-1.1-1-1.8-2.4-1.8-3.9c0-1.6,0.6-2.9,1.8-3.9c1.2-1,2.9-1.4,4.9-1.4c1.8,0,3.2,0.3,4.3,1v-0.7 c0-1-0.4-2-1.2-2.6c-0.8-0.7-1.8-1.1-2.9-1.1c-1.7,0-3,0.7-3.9,2.1l-2.6-1.6C51.8,13.8,53.9,12.8,56.7,12.8z M52.9,24.2 c0,0.8,0.4,1.5,1,1.9c0.7,0.5,1.5,0.8,2.3,0.8c1.2,0,2.4-0.5,3.3-1.4c1-0.9,1.5-2,1.5-3.2c-0.9-0.7-2.2-1.1-3.9-1.1 c-1.2,0-2.2,0.3-3,0.9C53.3,22.6,52.9,23.3,52.9,24.2z", fill: "#5F6368" }), /* @__PURE__ */ k.createElement("path", { className: "st0", d: "M80,13.3l-9.9,22.7h-3l3.7-7.9l-6.5-14.7h3.2l4.7,11.3h0.1l4.6-11.3H80z", fill: "#5F6368" }), /* @__PURE__ */ k.createElement("path", { className: "st1", d: "M25.9,17.7c0-0.9-0.1-1.8-0.2-2.7H13.2v5.1h7.1c-0.3,1.6-1.2,3.1-2.6,4v3.3H22C24.5,25.1,25.9,21.7,25.9,17.7z", fill: "#4285F4" }), /* @__PURE__ */ k.createElement("path", { className: "st2", d: "M13.2,30.6c3.6,0,6.6-1.2,8.8-3.2l-4.3-3.3c-1.2,0.8-2.7,1.3-4.5,1.3c-3.4,0-6.4-2.3-7.4-5.5H1.4v3.4 C3.7,27.8,8.2,30.6,13.2,30.6z", fill: "#34A853" }), /* @__PURE__ */ k.createElement("path", { className: "st3", d: "M5.8,19.9c-0.6-1.6-0.6-3.4,0-5.1v-3.4H1.4c-1.9,3.7-1.9,8.1,0,11.9L5.8,19.9z", fill: "#FBBC04" }), /* @__PURE__ */ k.createElement("path", { className: "st4", d: "M13.2,9.4c1.9,0,3.7,0.7,5.1,2l0,0l3.8-3.8c-2.4-2.2-5.6-3.5-8.8-3.4c-5,0-9.6,2.8-11.8,7.3l4.4,3.4 C6.8,11.7,9.8,9.4,13.2,9.4z", fill: "#EA4335" })), Stt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ width: 22, height: 19, viewBox: "0 0 22 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), /* @__PURE__ */ k.createElement("path", { d: "M0.390137 1.93534V17.298C0.390137 18.0333 1.01404 18.635 1.77659 18.635H11.2946C18.4903 18.635 21.6098 14.7509 21.6098 9.5966C21.6098 4.46904 18.4903 0.598297 11.2946 0.598297H1.77659C1.01404 0.598297 0.390137 1.19997 0.390137 1.93534Z", fill: "white" }), /* @__PURE__ */ k.createElement("path", { d: "M6.76089 4.36875V15.7203H11.8838C16.5354 15.7203 18.5527 13.1866 18.5527 9.60328C18.5527 6.17376 16.5354 3.51305 11.8838 3.51305H7.64822C7.15603 3.51305 6.76089 3.90079 6.76089 4.36875Z", fill: "#CC0066" }), /* @__PURE__ */ k.createElement("path", { d: "M11.2946 17.4116H3.01746C2.28264 17.4116 1.68646 16.8367 1.68646 16.1281V3.11195C1.68646 2.40331 2.28264 1.82838 3.01746 1.82838H11.2946C19.1488 1.82838 20.3204 6.70191 20.3204 9.60329C20.3204 14.6373 17.1108 17.4116 11.2946 17.4116ZM3.01746 2.25624C2.52527 2.25624 2.13013 2.6373 2.13013 3.11195V16.1281C2.13013 16.6027 2.52527 16.9838 3.01746 16.9838H11.2946C16.8265 16.9838 19.8767 14.3632 19.8767 9.60329C19.8767 3.21222 14.4973 2.25624 11.2946 2.25624H3.01746Z", fill: "black" }), /* @__PURE__ */ k.createElement("path", { d: "M8.56327 8.07237C8.7435 8.07237 8.90988 8.09912 9.06932 8.1526C9.22876 8.20608 9.36048 8.29299 9.47832 8.39995C9.58924 8.5136 9.67936 8.65399 9.74868 8.81443C9.81107 8.98156 9.84573 9.17544 9.84573 9.40273C9.84573 9.60329 9.818 9.78379 9.76948 9.95092C9.71402 10.1181 9.63777 10.2651 9.53378 10.3855C9.4298 10.5058 9.29808 10.5994 9.13864 10.6729C8.9792 10.7398 8.79203 10.7799 8.57713 10.7799H7.36398V8.06569H8.56327V8.07237ZM8.52167 10.2852C8.61179 10.2852 8.69498 10.2718 8.7851 10.2451C8.86828 10.2183 8.94454 10.1715 9.00693 10.1047C9.06932 10.0378 9.12478 9.95761 9.16637 9.85064C9.20797 9.74368 9.22876 9.62334 9.22876 9.46958C9.22876 9.33588 9.2149 9.20886 9.18717 9.1019C9.15944 8.99493 9.11091 8.89466 9.04852 8.82112C8.98613 8.74758 8.90295 8.68073 8.79896 8.64062C8.69498 8.60051 8.5702 8.58045 8.41769 8.58045H7.97402V10.2919H8.52167V10.2852Z", fill: "white" }), /* @__PURE__ */ k.createElement("path", { d: "M12.3483 8.07237V8.57377H10.8648V9.15538H12.2304V9.61666H10.8648V10.2785H12.3829V10.7799H10.2478V8.06569H12.3483V8.07237Z", fill: "white" }), /* @__PURE__ */ k.createElement("path", { d: "M14.4696 8.07237L15.5233 10.7866H14.8786L14.6637 10.1849H13.61L13.3881 10.7866H12.7642L13.8249 8.07237H14.4696ZM14.5042 9.73699L14.1507 8.74089H14.1437L13.7763 9.73699H14.5042Z", fill: "white" }), /* @__PURE__ */ k.createElement("path", { d: "M16.5284 8.07237V10.2852H17.901V10.7866H15.9115V8.07237H16.5284Z", fill: "white" }), /* @__PURE__ */ k.createElement("path", { d: "M4.4455 10.6796C5.16145 10.6796 5.74184 10.1199 5.74184 9.42947C5.74184 8.73904 5.16145 8.17934 4.4455 8.17934C3.72956 8.17934 3.14917 8.73904 3.14917 9.42947C3.14917 10.1199 3.72956 10.6796 4.4455 10.6796Z", fill: "black" }), /* @__PURE__ */ k.createElement("path", { d: "M5.42295 15.7203C4.33459 15.7203 3.46112 14.8712 3.46112 13.8283V12.3509C3.46112 11.8295 3.89785 11.4016 4.4455 11.4016C4.98622 11.4016 5.42988 11.8228 5.42988 12.3509V15.7203H5.42295Z", fill: "black" })), uq = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ width: 24, height: 15, viewBox: "0 0 24 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), /* @__PURE__ */ k.createElement("path", { d: "M0.820801 14.9343V11.5062H1.83709C2.57578 11.5062 3.05099 11.7952 3.05099 12.3926C3.05099 12.7305 2.90043 12.9656 2.6887 13.1027C2.99452 13.2496 3.17331 13.5337 3.17331 13.9205C3.17331 14.6111 2.6887 14.9343 1.93589 14.9343H0.820801ZM1.4748 12.9313H1.95942C2.25583 12.9313 2.38288 12.7795 2.38288 12.5004C2.38288 12.2016 2.15232 12.1037 1.84179 12.1037H1.4748L1.4748 12.9313ZM1.4748 14.3368H1.87943C2.27466 14.3368 2.5052 14.234 2.5052 13.9108C2.5052 13.5924 2.30759 13.4602 1.93589 13.4602H1.4748L1.4748 14.3368ZM4.44158 14.993C3.79699 14.993 3.47234 14.6649 3.47234 14.2242C3.47234 13.7393 3.85345 13.4553 4.41806 13.4504C4.55836 13.4531 4.69829 13.4662 4.8368 13.4896V13.3721C4.8368 13.0733 4.67212 12.9313 4.35689 12.9313C4.14453 12.9285 3.93365 12.9684 3.73582 13.0489L3.6182 12.52C3.82051 12.4318 4.14516 12.373 4.43217 12.373C5.12381 12.373 5.46727 12.755 5.46727 13.4161V14.7776C5.27437 14.8804 4.91208 14.993 4.44158 14.993ZM4.8368 14.4397V13.9157C4.72711 13.8903 4.61512 13.8771 4.50275 13.8765C4.28631 13.8765 4.11694 13.9646 4.11694 14.1948C4.11694 14.4005 4.25808 14.5082 4.50745 14.5082C4.62084 14.5121 4.73356 14.4886 4.8368 14.4397ZM5.9244 14.9343V12.5885C6.26251 12.4471 6.62337 12.374 6.98774 12.373C7.67466 12.373 8.06989 12.7256 8.06989 13.377V14.9343H7.42059V13.4259C7.42059 13.088 7.27003 12.9313 6.98302 12.9313C6.84051 12.9292 6.69926 12.9593 6.56898 13.0195V14.9343L5.9244 14.9343ZM10.3389 12.52L10.2166 13.0537C10.0485 12.9779 9.86805 12.9364 9.68494 12.9313C9.30384 12.9313 9.09682 13.2105 9.09682 13.6708C9.09682 14.1752 9.31324 14.4348 9.71788 14.4348C9.89846 14.4296 10.0761 14.3863 10.2401 14.3074L10.3436 14.851C10.1306 14.9497 9.89925 14.9982 9.66612 14.993C8.88509 14.993 8.43341 14.4886 8.43341 13.6904C8.43341 12.897 8.88039 12.373 9.62849 12.373C9.87239 12.3718 10.114 12.4218 10.3389 12.52ZM11.7416 14.993C11.017 14.993 10.5654 14.469 10.5654 13.6806C10.5654 12.897 11.017 12.373 11.7416 12.373C12.4709 12.373 12.9132 12.897 12.9132 13.6806C12.9132 14.469 12.4709 14.993 11.7416 14.993ZM11.7416 14.4348C12.0757 14.4348 12.2498 14.1458 12.2498 13.6806C12.2498 13.2202 12.0757 12.9313 11.7416 12.9313C11.4123 12.9313 11.2288 13.2202 11.2288 13.6806C11.2288 14.1458 11.4123 14.4348 11.7416 14.4348ZM13.2889 14.9343V12.5885C13.627 12.4471 13.9879 12.374 14.3522 12.373C15.0392 12.373 15.4344 12.7256 15.4344 13.377V14.9343H14.7851V13.4259C14.7851 13.088 14.6345 12.9313 14.3475 12.9313C14.205 12.9292 14.0638 12.9593 13.9335 13.0195V14.9343L13.2889 14.9343ZM16.8987 14.993C16.3388 14.993 16.0518 14.6747 16.0518 14.0283V12.9705H15.7319V12.4318H16.0518V11.8882L16.7011 11.8539V12.4318H17.2234V12.9705H16.7011V14.0185C16.7011 14.3025 16.814 14.4348 17.0257 14.4348C17.1096 14.4345 17.1933 14.4247 17.2751 14.4054L17.308 14.949C17.1737 14.98 17.0363 14.9947 16.8987 14.993ZM18.5376 14.993C17.893 14.993 17.5683 14.6649 17.5683 14.2242C17.5683 13.7393 17.9494 13.4553 18.514 13.4504C18.6543 13.4531 18.7943 13.4662 18.9328 13.4896V13.3721C18.9328 13.0733 18.7681 12.9313 18.4529 12.9313C18.2405 12.9285 18.0296 12.9684 17.8318 13.0489L17.7142 12.52C17.9165 12.4318 18.2412 12.373 18.5282 12.373C19.2198 12.373 19.5633 12.755 19.5633 13.4161V14.7776C19.3704 14.8804 19.0081 14.993 18.5376 14.993ZM18.9328 14.4397V13.9157C18.8231 13.8903 18.7111 13.8771 18.5987 13.8765C18.3823 13.8765 18.2129 13.9646 18.2129 14.1948C18.2129 14.4005 18.3541 14.5082 18.6034 14.5082C18.7168 14.5121 18.8295 14.4886 18.9328 14.4397ZM21.7847 12.52L21.6624 13.0537C21.4943 12.9779 21.3138 12.9364 21.1307 12.9313C20.7496 12.9313 20.5426 13.2105 20.5426 13.6708C20.5426 14.1752 20.759 14.4348 21.1637 14.4348C21.3442 14.4296 21.5219 14.3863 21.6859 14.3074L21.7894 14.851C21.5764 14.9497 21.345 14.9982 21.1119 14.993C20.3309 14.993 19.8792 14.4886 19.8792 13.6904C19.8792 12.897 20.3262 12.373 21.0743 12.373C21.3182 12.3718 21.5598 12.4218 21.7847 12.52ZM23.2123 14.993C22.6524 14.993 22.3654 14.6747 22.3654 14.0283V12.9705H22.0454V12.4318H22.3654V11.8882L23.0146 11.8539V12.4318H23.5369V12.9705H23.0146V14.0185C23.0146 14.3025 23.1276 14.4348 23.3393 14.4348C23.4232 14.4345 23.5068 14.4247 23.5887 14.4054L23.6216 14.949C23.4872 14.98 23.3499 14.9947 23.2123 14.993Z", fill: "#1E3764" }), /* @__PURE__ */ k.createElement("path", { d: "M5.29647 9.89674C8.69178 9.89674 10.3894 7.61666 12.0871 5.33658H0.820801V9.89674H5.29647Z", fill: "url(#paint0_linear_30_173)" }), /* @__PURE__ */ k.createElement("path", { d: "M19.0394 0.776443C15.5633 0.776443 13.8252 3.05652 12.0871 5.33661H23.6216V0.776443H19.0394Z", fill: "url(#paint1_linear_30_173)" }), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("linearGradient", { id: "paint0_linear_30_173", x1: 3.09961, y1: 7.82718, x2: 11.3558, y2: 4.78283, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ k.createElement("stop", { stopColor: "#005AB9" }), /* @__PURE__ */ k.createElement("stop", { offset: 1, stopColor: "#1E3764" })), /* @__PURE__ */ k.createElement("linearGradient", { id: "paint1_linear_30_173", x1: 12.7855, y1: 5.73212, x2: 21.7142, y2: 2.63597, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ k.createElement("stop", { stopColor: "#FBA900" }), /* @__PURE__ */ k.createElement("stop", { offset: 1, stopColor: "#FFD800" })))), tle = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ width: 31, height: 30, viewBox: "0 0 31 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), /* @__PURE__ */ k.createElement("path", { d: "M27.5 6.99993H24.23C24.6004 5.96545 24.5785 4.83106 24.1685 3.81165C23.7584 2.79223 22.9887 1.95861 22.0052 1.4687C21.0217 0.978791 19.8927 0.866618 18.832 1.15343C17.7713 1.44025 16.8526 2.10613 16.25 3.02493L15.5 4.02993L14.75 3.00993C14.1471 2.08838 13.2265 1.4205 12.1633 1.13325C11.1002 0.845998 9.96853 0.959407 8.98351 1.45192C7.99849 1.94442 7.22878 2.7817 6.82068 3.80458C6.41258 4.82746 6.39455 5.96463 6.77002 6.99993H3.50002C3.10646 6.99886 2.71659 7.07584 2.35297 7.22641C1.98935 7.37698 1.65919 7.59816 1.3816 7.87714C1.10401 8.15613 0.884491 8.48739 0.735744 8.85176C0.586997 9.21613 0.511975 9.60638 0.515017 9.99993L0.500017 26.4999C0.498696 26.8943 0.575391 27.285 0.725687 27.6495C0.875984 28.0141 1.09691 28.3454 1.37575 28.6242C1.65459 28.903 1.98583 29.124 2.35041 29.2743C2.71498 29.4246 3.10568 29.5013 3.50002 29.4999H27.5C27.8944 29.5013 28.2851 29.4246 28.6496 29.2743C29.0142 29.124 29.3454 28.903 29.6243 28.6242C29.9031 28.3454 30.1241 28.0141 30.2743 27.6495C30.4246 27.285 30.5013 26.8943 30.5 26.4999V9.99993C30.5013 9.60559 30.4246 9.21489 30.2743 8.85032C30.1241 8.48575 29.9031 8.1545 29.6243 7.87566C29.3454 7.59683 29.0142 7.3759 28.6496 7.2256C28.2851 7.0753 27.8944 6.99861 27.5 6.99993ZM20 3.99993C20.2967 3.99993 20.5867 4.0879 20.8334 4.25273C21.08 4.41755 21.2723 4.65182 21.3858 4.9259C21.4994 5.19999 21.5291 5.50159 21.4712 5.79257C21.4133 6.08354 21.2705 6.35081 21.0607 6.56059C20.8509 6.77037 20.5836 6.91323 20.2927 6.97111C20.0017 7.02899 19.7001 6.99928 19.426 6.88575C19.1519 6.77222 18.9176 6.57996 18.7528 6.33328C18.588 6.08661 18.5 5.7966 18.5 5.49993C18.5 5.10211 18.6581 4.72057 18.9394 4.43927C19.2207 4.15796 19.6022 3.99993 20 3.99993ZM11 3.99993C11.2967 3.99993 11.5867 4.0879 11.8334 4.25273C12.08 4.41755 12.2723 4.65182 12.3858 4.9259C12.4994 5.19999 12.5291 5.50159 12.4712 5.79257C12.4133 6.08354 12.2705 6.35081 12.0607 6.56059C11.8509 6.77037 11.5836 6.91323 11.2927 6.97111C11.0017 7.02899 10.7001 6.99928 10.426 6.88575C10.1519 6.77222 9.91763 6.57996 9.75281 6.33328C9.58799 6.08661 9.50002 5.7966 9.50002 5.49993C9.50002 5.10211 9.65805 4.72057 9.93936 4.43927C10.2207 4.15796 10.6022 3.99993 11 3.99993ZM27.5 26.4999H3.50002V23.4999H27.5V26.4999ZM27.5 18.9999H3.50002V9.99993H11.12L8.00002 14.2449L10.43 15.9999L14 11.1399L15.5 9.09993L17 11.1399L20.57 15.9999L23 14.2449L19.88 9.99993H27.5V18.9999Z", fill: "#BCC3CD" })), nle = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 67.614, height: 31.789, viewBox: "0 0 67.614 31.789" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#662d91;}.b{clip-path:url(#a);}"), /* @__PURE__ */ k.createElement("clipPath", { id: "a" }, /* @__PURE__ */ k.createElement("path", { className: "a", d: "M3252.226-5954.029h67.614v-31.789h-67.614Z", transform: "translate(-3252.226 5985.818)" }))), /* @__PURE__ */ k.createElement("g", { transform: "translate(-424.855 1329.887)" }, /* @__PURE__ */ k.createElement("g", { transform: "translate(424.854 -1329.887)" }, /* @__PURE__ */ k.createElement("g", { className: "b" }, /* @__PURE__ */ k.createElement("g", { transform: "translate(6.507 6.871)" }, /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-148.74-96.412a2.788,2.788,0,0,0-2.774-2.8h-1.375v5.575h1.375a2.783,2.783,0,0,0,2.774-2.775m6.257,11.115h-5.049l-4.009-5.563h-1.348v5.551h-4.45v-16.677h6.375c3.675,0,6.675,2.5,6.675,5.574a5.417,5.417,0,0,1-2.9,4.575l4.707,6.54", transform: "translate(157.339 101.986)" })), /* @__PURE__ */ k.createElement("g", { transform: "translate(19.557 10.219)" }, /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-118.061-55.808c-1.175,0-2.175,1.6-2.175,3.575s1,3.577,2.175,3.577c1.2,0,2.2-1.6,2.2-3.577s-1-3.575-2.2-3.575m6.849,3.575a6.816,6.816,0,0,1-6.849,6.8,6.8,6.8,0,0,1-6.825-6.8,6.8,6.8,0,0,1,6.825-6.8,6.817,6.817,0,0,1,6.849,6.8", transform: "translate(124.886 59.034)" })), /* @__PURE__ */ k.createElement("g", { transform: "translate(34.099 10.479)" }, /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-165.623-.293l-5.126,5.125V-.31H-175.2V12.759h4.449v-5.3l5.352,5.3h5.6l-6.8-6.8,5.633-5.631V8.082c0,2.575,1.549,4.951,5.448,4.951a6.183,6.183,0,0,0,4.376-2l2,1.725h.95V-.293h-4.449v8.45a2.492,2.492,0,0,1-2.278,1.424c-1.095,0-1.6-.649-1.6-2.725V-.293Z", transform: "translate(175.199 0.31)" })))))), rle = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 39.875, height: 36.23, viewBox: "0 0 39.875 36.23" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#f90;}")), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M.075,29.773c.12-.193.311-.206.578-.037A38.631,38.631,0,0,0,20.383,35a39.055,39.055,0,0,0,14.04-2.651l.524-.233c.229-.1.389-.166.487-.216a.669.669,0,0,1,.873.216c.2.289.15.558-.2.8-.426.316-1,.681-1.672,1.087a26.982,26.982,0,0,1-6.956,2.869,29.282,29.282,0,0,1-7.506,1.014,29.134,29.134,0,0,1-10.7-1.973A29.718,29.718,0,0,1,.251,30.342.5.5,0,0,1,0,29.976a.362.362,0,0,1,.083-.216ZM10.987,19.438a7.315,7.315,0,0,1,1.235-4.283,7.606,7.606,0,0,1,3.391-2.684,18.385,18.385,0,0,1,4.84-1.2c.648-.076,1.717-.171,3.191-.289v-.615a6.647,6.647,0,0,0-.5-3.117,2.722,2.722,0,0,0-2.394-1.08h-.3a3.992,3.992,0,0,0-2.071.765,3.005,3.005,0,0,0-1.122,1.822.932.932,0,0,1-.723.848l-4.189-.524c-.412-.1-.618-.3-.618-.648a.992.992,0,0,1,.037-.249A6.992,6.992,0,0,1,14.788,3.4a11.626,11.626,0,0,1,5.635-1.745h.9A9.226,9.226,0,0,1,27.783,3.8c.224.249.449.5.673.8a4.309,4.309,0,0,1,.47.748,3.186,3.186,0,0,1,.324.947c.1.422.175.7.224.848A4.789,4.789,0,0,1,29.6,8.16c.017.52.033.819.033.919v8.776a5.42,5.42,0,0,0,.274,1.722,3.963,3.963,0,0,0,.524,1.12l.848,1.12a1.133,1.133,0,0,1,.226.6.64.64,0,0,1-.3.522c-1.995,1.745-3.092,2.693-3.263,2.842a.97.97,0,0,1-1.047.075,10.077,10.077,0,0,1-.874-.824l-.515-.577c-.1-.123-.276-.349-.527-.7l-.5-.723A8.908,8.908,0,0,1,20.493,25.8a10.509,10.509,0,0,1-3.042.377,6.378,6.378,0,0,1-4.588-1.719,6.438,6.438,0,0,1-1.8-4.887l-.083-.126Zm6.238-.728a3.436,3.436,0,0,0,.706,2.267,2.389,2.389,0,0,0,1.92.851,2.449,2.449,0,0,0,.324-.033,1.835,1.835,0,0,1,.276-.038A3.729,3.729,0,0,0,22.818,19.8a5.229,5.229,0,0,0,.6-1.513,6.489,6.489,0,0,0,.224-1.33c.025-.324.025-.9.025-1.67v-.9a12.856,12.856,0,0,0-3.191.3,3.9,3.9,0,0,0-3.191,4.039l-.058-.033ZM32.453,30.39a1.206,1.206,0,0,1,.219-.283,5.923,5.923,0,0,1,1.745-.831,13.453,13.453,0,0,1,2.679-.4,2.21,2.21,0,0,1,.681.05c1.08.1,1.745.279,1.948.549a1.156,1.156,0,0,1,.15.648v.249a8.3,8.3,0,0,1-.69,2.992,7.236,7.236,0,0,1-1.921,2.792.548.548,0,0,1-.327.15.388.388,0,0,1-.15-.02c-.15-.073-.178-.2-.106-.4a13.642,13.642,0,0,0,1.34-4.388.953.953,0,0,0-.145-.572c-.241-.276-.914-.427-2.034-.427-.4,0-.886.027-1.446.076-.6.075-1.164.15-1.662.224a.44.44,0,0,1-.3-.073c-.05-.05-.06-.078-.033-.128a.274.274,0,0,1,.033-.1v-.1Z", transform: "translate(-0.002 -1.653)" })), _D = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40.983 35.773" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#62dba3;}")), /* @__PURE__ */ k.createElement("g", { transform: "translate(-66.976 -261.917)" }, /* @__PURE__ */ k.createElement("g", { transform: "translate(66.976 288.598)" }, /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-410.7,527.946a2.932,2.932,0,0,0-2.858,3.106,2.91,2.91,0,0,0,2.858,3.083,2.3,2.3,0,0,0,1.891-.878v.383a.4.4,0,0,0,.383.383h.945v-5.941h-1.328v.754A2.3,2.3,0,0,0-410.7,527.946Zm.237,1.215a1.818,1.818,0,0,1,1.769,1.89,1.833,1.833,0,0,1-1.766,1.89,1.8,1.8,0,0,1-1.746-1.9A1.771,1.771,0,0,1-410.459,529.161Z", transform: "translate(413.554 -525.044)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-364.5,534.013a.372.372,0,0,1-.383-.383v-5.559h1.328v.735a2.071,2.071,0,0,1,1.791-.872,2.219,2.219,0,0,1,2.26,2.275v3.8h-.923a.407.407,0,0,1-.405-.405V530.5a1.26,1.26,0,0,0-1.237-1.349,1.606,1.606,0,0,0-1.486,1.71v3.151Z", transform: "translate(372.419 -525.034)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-320.758,512.475a2.932,2.932,0,0,0-2.858,3.106,2.91,2.91,0,0,0,2.858,3.083,2.3,2.3,0,0,0,1.89-.878v.383a.4.4,0,0,0,.383.383h.945v-8.912h-1.328v3.725A2.3,2.3,0,0,0-320.758,512.475Zm.237,1.215a1.818,1.818,0,0,1,1.769,1.89,1.833,1.833,0,0,1-1.766,1.89,1.8,1.8,0,0,1-1.746-1.9A1.771,1.771,0,0,1-320.522,513.69Z", transform: "translate(337.547 -509.573)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-274.56,534.391a.372.372,0,0,1-.383-.383v-5.559h1.328v.99a1.636,1.636,0,0,1,1.6-1.058,2.77,2.77,0,0,1,.473.045V529.8a1.912,1.912,0,0,0-.63-.112,1.57,1.57,0,0,0-1.44,1.709v2.994Z", transform: "translate(296.413 -525.412)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-203.075,534.759a.372.372,0,0,1-.383-.383v-5.559h1.328v5.942Z", transform: "translate(236 -525.781)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-185.343,512.475a2.932,2.932,0,0,0-2.858,3.106,2.91,2.91,0,0,0,2.858,3.083,2.3,2.3,0,0,0,1.89-.878v.383a.4.4,0,0,0,.383.383h.945v-8.912h-1.328v3.725A2.3,2.3,0,0,0-185.343,512.475Zm.237,1.215a1.818,1.818,0,0,1,1.769,1.89,1.833,1.833,0,0,1-1.766,1.89,1.8,1.8,0,0,1-1.746-1.9A1.771,1.771,0,0,1-185.107,513.69Z", transform: "translate(223.108 -509.573)" }), /* @__PURE__ */ k.createElement("circle", { className: "a", cx: 0.878, cy: 0.878, r: 0.878, transform: "translate(32.32 0)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-247.292,527.933a3.058,3.058,0,0,0-3.1,3.1,3.024,3.024,0,0,0,3.094,3.094,3.065,3.065,0,0,0,3.142-3.083A3.085,3.085,0,0,0-247.292,527.933Zm0,1.24a1.793,1.793,0,0,1,1.782,1.861,1.82,1.82,0,0,1-1.779,1.872,1.806,1.806,0,0,1-1.777-1.854A1.79,1.79,0,0,1-247.288,529.173Z", transform: "translate(275.663 -525.033)" })), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M97.6,268.836l3.4-5.885a.69.69,0,0,0-.25-.941.681.681,0,0,0-.936.25l-3.442,5.961a21.477,21.477,0,0,0-17.522,0L75.4,262.26a.688.688,0,0,0-1.19.691l3.4,5.885a20.284,20.284,0,0,0-10.482,16.046h40.956A20.279,20.279,0,0,0,97.6,268.836ZM78.2,279.131a1.717,1.717,0,1,1,1.717-1.717A1.717,1.717,0,0,1,78.2,279.131Zm18.8,0a1.717,1.717,0,1,1,1.717-1.717A1.717,1.717,0,0,1,97.006,279.131Z", transform: "translate(-0.13 0)" }))), xtt = [
  "day",
  "week",
  "month",
  "year",
  "P",
  "A",
  "E",
  "default",
  "weekly",
  "2week",
  "monthly",
  "3months",
  "3-months",
  "6months",
  "6-months",
  "annual",
  "2weeks",
  "48",
  "72",
  "168",
  "720",
  "2160",
  "seasonal",
  "season"
], Ett = (e) => xtt.some((t) => t === e), wc = {
  // Subscription and season pass
  day: {
    label: "D",
    color: "#D5749B",
    bg: "#FFF0FB",
    border: "#D980A42B",
    chargedForEveryText: "day",
    accessText: "Daily"
  },
  week: {
    label: "W",
    color: "#D5749B",
    bg: "#FFF0FB",
    border: "#D980A42B",
    chargedForEveryText: "week",
    accessText: "Weekly"
  },
  weekly: {
    label: "W",
    color: "#D5749B",
    bg: "#FFF0FB",
    border: "#D980A42B",
    chargedForEveryText: "week",
    accessText: "Weekly"
  },
  "2week": {
    label: "2",
    color: "#D5749B",
    bg: "#FFF0FB",
    border: "#D980A42B",
    chargedForEveryText: "2 weeks"
  },
  month: {
    label: "1",
    color: "#AB68BC",
    bg: "#FBF0FF",
    border: "#AC61BF2B",
    chargedForEveryText: "month",
    accessText: "Monthly"
  },
  monthly: {
    label: "1",
    color: "#AB68BC",
    bg: "#FBF0FF",
    border: "#AC61BF2B",
    chargedForEveryText: "month",
    accessText: "Monthly"
  },
  "3months": {
    label: "3",
    color: "#6399E3",
    bg: "#EDF3FF",
    border: "#DAE4FD",
    chargedForEveryText: "3 months",
    accessText: "Three months of a"
  },
  "3-months": {
    label: "3",
    color: "#6399E3",
    bg: "#EDF3FF",
    border: "#DAE4FD",
    chargedForEveryText: "3 months",
    accessText: "Three months of a"
  },
  "6months": {
    label: "6",
    color: "#7172C9",
    bg: "#F0F0FF",
    border: "#6163CD2E",
    chargedForEveryText: "6 months",
    accessText: "Six months of a"
  },
  "6-months": {
    label: "6",
    color: "#7172C9",
    bg: "#F0F0FF",
    border: "#6163CD2E",
    chargedForEveryText: "6 months",
    accessText: "Six months of a"
  },
  year: {
    label: "12",
    color: "#5971B9",
    bg: "#EDF1FF",
    border: "#39529B2E",
    chargedForEveryText: "year",
    accessText: "Annual"
  },
  annual: {
    label: "12",
    color: "#5971B9",
    bg: "#EDF1FF",
    border: "#39529B2E",
    chargedForEveryText: "year",
    accessText: "Annual"
  },
  season: {
    label: "S",
    color: "#5971B9",
    bg: "#EDF1FF",
    border: "#39529B2E",
    chargedForEveryText: "season",
    accessText: "Season"
  },
  seasonal: {
    label: "S",
    color: "#5971B9",
    bg: "#EDF1FF",
    border: "#39529B2E",
    chargedForEveryText: "season",
    accessText: "Season"
  },
  default: {
    label: "S",
    color: "#5971B9",
    bg: "#EDF1FF",
    border: "#39529B2E"
  },
  // Season Pass
  "2weeks": {
    label: "2",
    color: "#D5749B",
    bg: "#FFF0FB",
    border: "#D980A42B",
    accessText: "Two weeks of"
  },
  P: {
    label: "P",
    color: "#D5749B",
    bg: "#FFF0FB",
    border: "#D980A42B"
  },
  // VOD rental - period in hours
  48: {
    label: "2",
    color: "#D5749B",
    bg: "#FFF0FB",
    border: "#D980A42B",
    accessText: "2 days"
  },
  72: {
    label: "3",
    color: "#AB68BC",
    bg: "#FBF0FF",
    border: "#AC61BF2B",
    accessText: "3 days"
  },
  168: {
    label: "7",
    color: "#6399E3",
    bg: "#EDF3FF",
    border: "#DAE4FD",
    accessText: "7 days"
  },
  720: {
    label: "1",
    color: "#7172C9",
    bg: "#F0F0FF",
    border: "#6163CD2E",
    accessText: "Month"
  },
  2160: {
    label: "3",
    color: "#5971B9",
    bg: "#EDF1FF",
    border: "#39529B2E",
    accessText: "3 months"
  },
  A: {
    label: "A",
    color: "#5971B9",
    bg: "#EDF1FF",
    border: "#39529B2E"
  },
  E: {
    label: "E",
    color: "#5971B9",
    bg: "#EDF1FF",
    border: "#39529B2E"
  }
}, Ta = {
  EUR: "€",
  USD: "$",
  GBP: "£",
  AUD: "A$",
  DKK: "kr.",
  CAD: "C$",
  CHF: "CHF",
  NOK: "kr",
  NZD: "NZ$",
  SEK: "kr",
  TRY: "₺",
  XOF: "CFA",
  ZAR: "R",
  NGN: "₦",
  KES: "Ksh",
  GHS: "GH¢",
  MXN: "Mex$",
  KRW: "₩",
  XAF: "FCFA",
  JPY: "¥",
  PHP: "₱",
  VND: "₫",
  BRL: "R$",
  INR: "₹",
  MNT: "₮",
  EGP: "E£",
  QAR: "QR",
  KWD: "KD",
  AED: "د.إ",
  THB: "฿",
  "€": "€",
  $: "$",
  "£": "£"
};
function Ko(e, t = !1) {
  const n = new Date(e * 1e3), r = n.toLocaleDateString();
  return t ? `${r} ${n.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short"
  })}` : r;
}
const xc = 2145913200, br = (e, t = 2) => Number(e).toFixed(t), Itt = [
  "card",
  "paypal",
  "applepay",
  "googlepay",
  "ideal",
  "bancontact_card",
  "bancontact_mobile"
], hN = [
  "ideal",
  "bancontact_mobile",
  // Bancontact Mobile name in cleeng-admin
  "bcmc_mobile"
  // Bancontact Mobile name in Adyen
], ktt = [
  "card",
  "scheme",
  "applepay",
  "googlepay",
  "bancontact_card",
  "bcmc"
], Att = {
  bcmc_mobile: "bancontact_mobile",
  bcmc: "bancontact_card"
}, mN = "zeroPaymentSupported", Op = "zeroPaymentNotSupported", Ptt = {
  card: "Card",
  paypal: "PayPal",
  applepay: "ApplePay",
  googlepay: "GooglePay",
  ideal: "iDEAL",
  bancontact_card: "Bancontact Card",
  bancontact_mobile: "Bancontact Mobile"
}, Ntt = ["adyen", "paypal"], cq = {
  card: wtt,
  paypal: bD,
  applepay: JO,
  apple: JO,
  googlepay: ele,
  ideal: Stt,
  bancontact_card: uq,
  bancontact_mobile: uq,
  gift: tle,
  roku: nle,
  amazon: rle,
  android: _D
}, ale = (e, t) => {
  const {
    publisherConfig: { hiddenPaymentMethods: n }
  } = Mo.getState();
  return e ? e.filter((r) => {
    const { id: a, methodName: o, paymentGateway: s } = r;
    return n.includes(a) ? !1 : Itt.includes(o) && Ntt.includes(s) ? !0 : (t && console.error(`Payment method not supported (id: ${a})`), !1);
  }) : [];
}, h6 = (e, t) => !!t.find(({ paymentGateway: n }) => n === e), ole = (e, t) => t.length ? e.filter(
  ({ methodName: r }) => t.includes(r)
) : e, ile = (e, t, n, r) => {
  const { period: a, customerPriceExclTax: o } = t, { discount: s, currency: c, offerId: u } = n, f = (u == null ? void 0 : u.charAt(0)) === "S", m = a && Ett(a) ? wc[a].chargedForEveryText : null, v = `${Ta[c]}${br(
    o
  )}`, y = m ? `/${m}` : "";
  return r ? ca.t(
    "offer-standard-consent-copy.checkout-not-subscription",
    "By ticking this, you agree to the Terms and Conditions of our service."
  ) : e ? ca.t(
    "offer-standard-consent-copy.my-account",
    "By ticking this, you agree to the Terms and Conditions of our service. Your account will be charged on a recurring basis for the full subscription amount. Your subscription will continue until you cancel."
  ) : f ? s != null && s.applied && s.type === "trial" ? ca.t(
    `offer-standard-consent-copy.trial.period-${a}`,
    "After any free trial and/or promotional period, you will be charged {{readablePrice}}{{readablePeriod}} or the then-current price, plus applicable taxes, on a recurring basis. Your subscription will automatically continue until you cancel. To cancel, log into your account, click 'Manage' next to your subscription and then click 'Cancel'. By checking the box, you expressly acknowledge and agree to these terms as well as the full Terms of Service.",
    { readablePrice: v, readablePeriod: y }
  ) : s != null && s.applied && s.type !== "trial" ? ca.t(
    `offer-standard-consent-copy.discount.period-${a}`,
    "After any promotional period, you will be charged {{readablePrice}}{{readablePeriod}} or the then-current price, plus applicable taxes, on a recurring basis. Your subscription will automatically continue until you cancel. To cancel, log into your account, click 'Manage' next to your subscription and then click 'Cancel'. By checking the box, you expressly acknowledge and agree to these terms as well as the full Terms of Service.",
    { readablePrice: v, readablePeriod: y }
  ) : ca.t(
    `offer-standard-consent-copy.checkout-subscription.period-${a}`,
    "You will be charged {{readablePrice}}{{readablePeriod}} or the then-current price, plus applicable taxes, on a recurring basis. Your subscription will automatically continue until you cancel. To cancel, log into your account, click 'Manage' next to your subscription and then click ‘Cancel.’ By checking the box, you expressly acknowledge and agree to these terms as well as the full Terms of Service.",
    { readablePrice: v, readablePeriod: y }
  ) : ca.t(
    "offer-standard-consent-copy.checkout-not-subscription",
    "By ticking this, you agree to the Terms and Conditions of our service."
  );
}, Ttt = W.div.attrs((e) => ({
  className: `msd__consents ${e.$disabled ? "msd__consents--disabled" : ""}`
}))`
  display: flex;
  width: 100%;
  height: 100%;
  cursor: pointer;
  margin-top: 10px;

  align-items: center;
  font-size: 13px;
  color: ${Et};

  &:focus {
    outline: none;
  }
  &:first-of-type {
    margin-top: 0;
  }
  ${(e) => e.$disabled && ot`
      opacity: 0.7;
    `}
`, Ott = W.input`
  position: absolute;
  width: 1em;
  height: 1em;
  opacity: 0;
  pointer-events: none;
`, Rtt = W.div.attrs((e) => ({
  className: `msd__consents__text ${e.$checked ? "msd__consents__text--checked" : ""}`
}))`
  position: relative;
  padding-inline-start: 10px;
  margin-top: 0;

  font-weight: 400;
  text-align: left;
  pointer-events: none;
  user-select: none;

  a {
    color: ${Et};

    text-decoration: underline;
    &:focus {
      outline: 2px solid ${Vm};
    }
  }
  opacity: 0.8;
  ${(e) => e.$checked && ot`
      opacity: 1;
    `}
`, Mtt = W.div.attrs((e) => ({
  className: `msd__consents__frame ${e.$error ? "msd__consents__frame--error" : ""} ${e.$checked ? "msd__consents__frame--checked" : ""}
  ${e.$isRadioButton ? "msd__consents__frame--radio" : ""} ${e.$isMyAccount ? "msd__consents__frame--account" : ""}`
}))`
  position: relative;
  box-sizing: border-box;

  border: 1px solid ${Gn};
  border-radius: 2px;
  width: 20px;
  min-width: 20px;
  height: 20px;
  pointer-events: none;

  &:focus {
    outline: 2px solid ${Vm};
  }
  ${(e) => e.$error && ot`
      border-color: ${wa};
    `}
  ${(e) => e.$isRadioButton && ot`
      border-radius: 50%;
    `}
  ${(e) => e.$isRadioButton && e.$checked && ot`
      border: 1px solid ${An};
    `}

  ${(e) => e.$isMyAccount && e.$checked && ot`
      border-color: ${An};
    `}
`, Dtt = W.div.attrs((e) => ({
  className: `msd__consents__check-mark ${e.$isRadioButton ? "msd__consents__check-mark--radio" : ""} ${e.$isMyAccount ? "msd__consents__check-mark--account" : ""}`
}))`
  position: absolute;
  pointer-events: none;

  width: 13px;
  height: 10px;
  top: 4px;
  left: 3px;
  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi44MjgiIGhlaWdodD0iOS44MjgiIHZpZXdCb3g9IjAgMCAxMi44MjggOS44MjgiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOm5vbmU7c3Ryb2tlOiM3YzhjYTU7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE4My4wODYgLTM5OS4wODYpIj48bGluZSBjbGFzcz0iYSIgeDI9IjMiIHkyPSIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODQuNSA0MDQuNSkiLz48bGluZSBjbGFzcz0iYSIgeDE9IjciIHkyPSI3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODcuNSA0MDAuNSkiLz48L2c+PC9zdmc+');
  background-repeat: no-repeat;
  ${(e) => e.$isRadioButton && ot`
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      width: 12px;
      height: 12px;

      background: ${An};
      border-radius: 50%;
    `}
  ${(e) => e.$isMyAccount && ot`
      width: 20px;
      height: 20px;
      top: -1px;
      left: -1px;
      background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMyIgaGVpZ2h0PSIyMyIgdmlld0JveD0iMCAwIDIzIDIzIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjNEVCN0ExOwogICAgICB9CgogICAgICAuY2xzLTIgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgICAgc3Ryb2tlOiAjZmZmOwogICAgICAgIHN0cm9rZS1saW5lY2FwOiByb3VuZDsKICAgICAgICBzdHJva2UtbGluZWpvaW46IHJvdW5kOwogICAgICAgIHN0cm9rZS13aWR0aDogMi4zcHg7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSJHcm91cF8yNDQ0IiBkYXRhLW5hbWU9Ikdyb3VwIDI0NDQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNjMwIC0zMjUpIj4KICAgIDxnIGlkPSJHcm91cF8yNDM5IiBkYXRhLW5hbWU9Ikdyb3VwIDI0MzkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjYwIC01MzYpIj4KICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8yOTA3IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAyOTA3IiBjbGFzcz0iY2xzLTEiIHdpZHRoPSIyMyIgaGVpZ2h0PSIyMyIgcng9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ4OTAgODYxKSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF8xOTQyIiBkYXRhLW5hbWU9IlBhdGggMTk0MiIgY2xhc3M9ImNscy0yIiBkPSJNOTYzNS40MzItNzE0NS40MjdsMy43NjQsMy43OTEsNC4yMTUtNC4yNDQsMy45ODktNC4wMTgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NzM5LjkzMSA4MDE4LjM5NykiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=');
      background-position: center;
      background-size: cover;
    `}
`;
W.div`
  position: relative;

  width: 100%;
  margin-top: 10px;

  color: ${wa};

  font-size: 12px;
  font-weight: 300;
  text-align: center;
`;
const Ltt = W.a`
  padding-inline-start: ${(e) => e.$isPayPal ? "31px" : "33px"};
  position: relative;
  top: ${({ isPayPal: e }) => e ? "0" : "-20px"};
  font-weight: 400;
  font-size: 11px;
  line-height: 17px;
  text-align: left;
  color: #515364;
  text-decoration: underline;
  opacity: 0.8;
  user-select: none;

  ${(e) => e.$checked && ot`
      opacity: 1;
    `}
`, F8 = ({
  children: e,
  onClickFn: t,
  error: n,
  checked: r,
  required: a,
  isMyAccount: o,
  className: s,
  disabled: c,
  isRadioButton: u,
  termsUrl: f,
  isPayPal: m,
  id: v
}) => {
  const [y, b] = mt(r), { t: S } = tn();
  mn(() => {
    b(r);
  }, [r]);
  const x = " ";
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(
      Ttt,
      {
        onClick: (E) => {
          E.stopPropagation(), t(E, c, b);
        },
        tabIndex: "-1",
        "aria-checked": y,
        checked: y,
        "aria-label": e,
        className: s,
        $disabled: c,
        "data-testid": "checkbox-legacy",
        children: [
          /* @__PURE__ */ C.jsx(
            Ott,
            {
              id: v,
              type: "checkbox",
              checked: y,
              disabled: c,
              required: a
            }
          ),
          /* @__PURE__ */ C.jsx(
            Mtt,
            {
              $error: n && a && !y,
              tabIndex: "0",
              checked: y,
              onKeyDown: (E) => E.key === x ? t(E, c, b) : null,
              $isMyAccount: o,
              $isRadioButton: u,
              $checked: y,
              children: y && /* @__PURE__ */ C.jsx(
                Dtt,
                {
                  "data-testid": "checkmark",
                  $isMyAccount: o,
                  $isRadioButton: u
                }
              )
            }
          ),
          /* @__PURE__ */ C.jsx(
            Rtt,
            {
              dangerouslySetInnerHTML: {
                __html: `${e}${a && o ? "*" : ""}`
              },
              $checked: y
            }
          )
        ]
      }
    ),
    f && /* @__PURE__ */ C.jsx(
      Ltt,
      {
        href: f,
        target: "_blank",
        rel: "noreferrer",
        $checked: y,
        $isPayPal: m,
        children: S("checkbox.terms-link", "Terms & Conditions")
      }
    )
  ] });
};
F8.propTypes = {
  checked: de.bool,
  required: de.bool,
  onClickFn: de.func,
  error: de.string,
  children: de.oneOfType([de.string, de.element]),
  isMyAccount: de.bool,
  className: de.string,
  disabled: de.bool,
  isRadioButton: de.bool,
  termsUrl: de.string,
  isPayPal: de.bool,
  id: de.string
};
F8.defaultProps = {
  error: "",
  checked: !1,
  required: !1,
  onClickFn: (e) => e,
  children: "",
  isMyAccount: !1,
  className: "",
  disabled: !1,
  isRadioButton: !1,
  termsUrl: "",
  isPayPal: !1,
  id: null
};
const vN = W.section.attrs(() => ({
  className: "msd__payment"
}))`
  padding: 20px 35px 70px 35px;
  width: 100%;
  background-color: ${Br};
  border-bottom: 1px solid ${Gn};
`, $tt = W.div.attrs(() => ({
  className: "msd__payment__wrapper"
}))`
  max-width: 376px;
  margin: 12px auto 0 auto;
`, Vy = W.div.attrs(() => ({
  className: "msd__payment--error"
}))`
  text-align: center;
  font-size: 15px;
  color: ${wa};
  margin: 30px auto;
`, sle = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, lle = /(^[+]?(\d[-|\s]?){4,16})$/, dq = /<a(.|\n)*?>/, fq = /<\/a(.|\n)*?>/;
function jtt(e) {
  return sle.test(String(e).toLowerCase());
}
function Ftt(e, t) {
  return t.every(
    (n, r) => !(n.required && !e[r])
  );
}
function Btt(e, t) {
  return Ftt(e, t) ? "" : ca.t(
    "validators.consents",
    "Please agree on all required consents to use this service"
  );
}
function pq(e) {
  return e === "" ? ca.t("validators.password", "Please fill out this field.") : "";
}
function hq(e) {
  const n = /[0-9]+/.test(e) && e.length >= 8;
  return e === "" ? ca.t("validators.password", "Please fill out this field.") : n ? "" : ca.t(
    "validators.password-invalid",
    "Your password must contain at least 8 characters, including 1 digit."
  );
}
function Nf(e) {
  return e === "" ? ca.t("validators.email", "Please fill out this field.") : jtt(e) ? "" : ca.t(
    "validators.email-invalid",
    "The email address is not properly formatted."
  );
}
const ule = (e) => {
  const t = Nf(e), n = e ? "recipientForm.error.bad-email-format" : "recipientForm.error.missing-value";
  return Mo.dispatch(
    s2({
      name: "recipientEmail",
      error: t,
      translationKey: t ? n : ""
    })
  ), !t;
}, cle = (e) => e ? e < /* @__PURE__ */ new Date() : !1, dle = (e) => {
  if (!e) return !1;
  const t = /* @__PURE__ */ new Date();
  return e.setHours(0, 0, 0, 0) > t.setHours(0, 0, 0, 0);
}, fle = (e, t) => {
  const n = /* @__PURE__ */ new Date(`${e}T${t}`);
  let r = "";
  return e || (r = "Missing delivery date"), cle(n) && (r = "Invalid delivery date"), Mo.dispatch(
    s2({
      name: "deliveryDate",
      error: r,
      translationKey: e ? "" : "recipientForm.error.delivery-date"
    })
  ), !r;
}, Vtt = (e, t) => {
  let n = "";
  if (e || (n = "Missing delivery time"), Mo.dispatch(
    s2({
      name: "deliveryTime",
      error: n,
      translationKey: e ? "" : "recipientForm.error.delivery-time"
    })
  ), t) {
    const r = /* @__PURE__ */ new Date(`${t}T${e}`);
    cle(r) && (n = "Invalid delivery date"), Mo.dispatch(
      s2({
        name: "deliveryDate",
        error: n,
        translationKey: e ? "" : "recipientForm.error.delivery-date"
      })
    );
  }
  return !n;
}, QO = (e) => {
  if (Nf(e))
    return Mo.dispatch(
      s2({
        name: "confirmRecipientEmail",
        error: Nf(e),
        translationKey: e ? "recipientForm.error.bad-email-format" : "recipientForm.error.missing-value"
      })
    ), !1;
  const {
    deliveryDetails: { recipientEmail: t, confirmRecipientEmail: n }
  } = Mo.getState(), r = t.value === n.value;
  return Mo.dispatch(
    s2({
      name: "confirmRecipientEmail",
      error: r ? "" : "Email address doesn’t match",
      translationKey: r ? "" : "recipientForm.error.confirm-recipient-email.doesnt-match"
    })
  ), r;
}, CD = () => {
  const {
    deliveryDetails: {
      recipientEmail: e,
      confirmRecipientEmail: t,
      deliveryDate: n,
      deliveryTime: r
    }
  } = Mo.getState(), a = ule(
    e.value
  ), o = QO(
    t.value
  ), s = fle(
    n.value,
    r.value
  );
  return a && o && s;
}, Utt = W.div.attrs(() => ({
  className: "msd__payment__adyen"
}))`
  max-width: 376px;
  margin: 12px auto 0 auto;

  ${(e) => e.$isMyAccount && ot`
      .adyen-checkout__label__text {
        color: ${Et};
        font-size: 12px;
        opacity: 0.8;
      }
    `}
  .adyen-checkout__button.adyen-checkout__button--pay {
    background: ${An};
  }
  .adyen-checkout__payment-method__details__content {
    margin: 2px 0 20px;
  }

  .adyen-checkout__label--focused .adyen-checkout__label__text {
    color: ${Et};
    opacity: 1;
  }

  .adyen-checkout__input--error,
  .adyen-checkout__input--error:hover,
  .adyen-checkout__input--invalid,
  .adyen-checkout__input--invalid:hover {
    border-color: ${wa};
  }

  .adyen-checkout__error-text {
    color: ${wa};
  }

  .adyen-checkout__input--focus,
  .adyen-checkout__input--focus:hover,
  .adyen-checkout__input:active,
  .adyen-checkout__input:active:hover,
  .adyen-checkout__input:focus,
  .adyen-checkout__input:focus:hover {
    border: 1px solid ${An};
    box-shadow: 0 0 5px 2px #f3f3f3;
  }

  .adyen-checkout__spinner {
    border: 3px solid ${Et};
    border-top-color: transparent;
  }

  .adyen-checkout__input--valid {
    border-bottom-color: ${An};
  }

  .adyen-checkout__input,
  .adyen-checkout__dropdown__button {
    border-color: #d8ddea;
    box-shadow: none;
  }
  .adyen-checkout__dropdown__button--active {
    border: 1px solid ${An};
    box-shadow: 0 0 5px 2px #f3f3f3;
  }

  .input-field,
  .adyen-checkout__dropdown__list {
    color: ${Et} !important;
  }

  .adyen-checkout__payment-method {
    border: 1px solid ${Gn};
    margin-bottom: 10px;
    border-radius: 12px;
    overflow: hidden;
  }

  .adyen-checkout__payment-method.adyen-checkout__payment-method--selected {
    overflow: visible;
  }

  .adyen-checkout__payment-method--selected {
    border-color: ${An};
    background-color: ${cu};
  }
  .adyen-checkout__payment-method__radio--selected {
    background-color: ${An};
  }

  .checkbox-wrapper {
    display: flex;
    flex-direction: column;
    margin: 10px 20px 20px 20px;
  }

  .adyen-checkout__card-input {
    text-align: start;
  }

  .adyen-checkout__bank-checkbox {
    align-items: flex-start;
    font-size: 11px;
    font-weight: 400;
    line-height: 17px;
    color: #515364;
    gap: 3px;
    margin-bottom: 20px;
  }

  .adyen-checkout__bank-checkbox--error {
    .msd__consents__frame {
      border-color: ${wa};
    }
    .msd__consents__text {
      color: ${wa};
    }
  }

  .adyen-checkout__payment-method--standalone {
    .adyen-checkout__payment-method__header {
      padding: 13px 16px;
    }
  }

  ${(e) => e.$isAdditionalPayment && ot`
      .adyen-checkout__payment-method--standalone {
        .adyen-checkout__payment-method__header {
          padding-block: 12px;
          padding-inline: 44px 16px;
        }

        .adyen-checkout__payment-method__radio {
          display: block;
        }
      }
    `}
`, Gtt = "live_BQDOFBYTGZB3XKF62GBYSLPUJ4YW2TPL", ztt = "test_I4OFGUUCEVB5TI222AS3N2Y2LY6PJM3K", wD = () => En("CLEENG_ENVIRONMENT") !== "production" ? "test" : "live", Htt = () => wD() === "test" ? ztt : Gtt, Wtt = () => wD() === "test" ? "TEST" : "PRODUCTION", Ztt = {
  "en-US": {
    "creditCard.holderName.invalid": "Cardholder name is not valid",
    "error.va.sf-cc-dat.01": "Expiry date is in the past"
  }
}, B8 = ({
  onSubmit: e,
  isMyAccount: t,
  selectPaymentMethod: n,
  isPayPalAvailable: r,
  getDropIn: a,
  onAdditionalDetails: o
}) => {
  const s = Ot(Bm), c = Ot(A_), u = Ot(bee), {
    id: f,
    buyAsAGift: m,
    discount: v,
    totalPrice: y,
    offerId: b,
    priceBreakdown: { discountAmount: S }
  } = s, {
    adyenConfiguration: x,
    paymentMethods: E,
    visiblePaymentMethods: N
  } = Ot((tt) => tt.publisherConfig), [R, O] = mt(!0), { selectedPaymentMethod: D } = Ot(
    (tt) => tt.paymentMethods
  ), $ = Yo(D), B = Ot(I2), G = Yo(null), Z = Yo(m || null);
  mn(() => {
    G.current = B, Z.current = m;
  }, [B, m]), mn(() => {
    $.current = D;
  }, [D]);
  const K = Yo(null), q = Yo(null), [pe, he] = mt(null), [_e, ge] = mt(null), [Y, ee] = mt(!1), [oe, me] = mt(null), [xe, X] = mt(null), [ye, ce] = mt(!1), [se, Ie] = mt(!1), [Le, ie] = mt(!1), [$e, we] = mt(!1), [Ne, Ee] = mt(!1);
  Ctt("https://pay.google.com/gp/p/js/pay.js");
  const { t: le, i18n: be } = tn(), He = Va(), Ae = () => {
    const tt = y === 0, bt = (b == null ? void 0 : b.charAt(0)) === "S";
    return t || tt && bt ? le(
      "offer-bank-consent-copy.free-subscription",
      "By ticking this, you agree to the Terms and Conditions of our service. Your account will be charged €0.10 for authentication purposes. This amount will be refunded once the transaction is completed. Your account will be charged on a recurring basis for the full subscription amount. Your subscription will continue until you cancel."
    ) : bt ? le(
      "offer-bank-consent-copy.paid-subscription",
      "By ticking this, you agree to the Terms and Conditions of our service. Your account will be charged on a recurring basis for the full subscription amount. Your subscription will continue until you cancel."
    ) : le(
      // TODO: add link to T&C
      "offer-bank-consent-copy.paid-not-subscription",
      "By ticking this, you agree to the Terms and Conditions of our service."
    );
  }, it = (tt, bt = "standard") => {
    const rn = document.querySelector(
      `.adyen-checkout__payment-method--${tt}`
    ), Rn = /* @__PURE__ */ C.jsx(
      F8,
      {
        className: `adyen-checkout__bank-checkbox ${tt}-inputWrapper`,
        checked: !1,
        id: `${tt}-input`,
        onClickFn: (Cn, Qn, er) => {
          Cn.target.classList.remove("adyen-checkout__bank-checkbox--error"), Cn.key === " " && Cn.target.parentElement.classList.remove(
            "adyen-checkout__bank-checkbox--error"
          ), er(!Cn.target.checked);
        },
        termsUrl: u,
        children: bt === "bank" ? Ae() : ile(t, c, s, B == null ? void 0 : B.isGift)
      }
    );
    if (rn) {
      const Cn = rn.querySelector(
        ".adyen-checkout__payment-method__details"
      );
      if (!document.querySelector(`#${tt}-input`)) {
        const er = document.createElement("div");
        er.classList.add("checkbox-wrapper"), Bee.render(Rn, er), rn.insertBefore(er, Cn);
      }
    }
  }, ut = () => {
    q != null && q.current && hN.forEach(
      (tt) => it(tt, "bank")
    ), K != null && K.current && ktt.forEach(
      (tt) => it(tt)
    );
  }, St = (bt) => st(void 0, [bt], function* ({ type: tt }) {
    return n(Att[tt] || tt);
  }), sn = (tt) => {
    if (K != null && K.current) {
      const bt = tt.create("dropin", {
        onSelect: St,
        openFirstPaymentMethod: (x == null ? void 0 : x.openFirstPaymentMethod) == null ? !window.matchMedia("(max-width:991px)").matches : x == null ? void 0 : x.openFirstPaymentMethod,
        onReady: ut
      });
      bt.mount(K.current), he(bt), a(bt, mN);
    }
  }, zn = (tt) => {
    if (q != null && q.current) {
      const bt = tt.create("dropin", {
        onSelect: St,
        onReady: ut,
        openFirstPaymentMethod: !1
      });
      bt.mount(q.current), ge(bt), a(bt, Op);
    }
  }, dn = ({ error: tt, fieldType: bt }) => {
    ur(xye, {
      error: tt,
      fieldType: bt
    });
  }, $t = () => st(void 0, null, function* () {
    const { isGift: tt } = G.current;
    if (tt) {
      if (!CD())
        return !1;
      const { recipientEmail: rn, deliveryDate: Rn, deliveryTime: Cn, message: Qn } = G.current;
      return yield He(
        xd({
          id: f,
          payload: {
            buyAsAGift: !0,
            deliveryDetails: {
              recipientEmail: rn.value,
              deliveryDate: (/* @__PURE__ */ new Date(
                `${Rn.value}T${Cn.value}`
              )).valueOf() / 1e3,
              personalNote: Qn.value
            }
          }
        })
      ).unwrap().catch((er) => {
        throw new Error(er);
      }), !0;
    }
    return Z.current && !tt && (yield He(
      xd({
        id: f,
        payload: {
          buyAsAGift: !1
        }
      })
    ).unwrap().catch((bt) => {
      throw new Error(bt);
    })), !0;
  }), qt = (tt) => {
    var Cn;
    const bt = ((Cn = $ == null ? void 0 : $.current) == null ? void 0 : Cn.methodName) === "bancontact_card";
    let rn = document.querySelector(`#${tt}-input`), Rn = document.querySelector(`.${tt}-inputWrapper`);
    if (tt === "scheme") {
      const Qn = document.querySelector(
        `#${bt ? "bcmc" : "card"}-input`
      ), er = document.querySelector(
        `.${bt ? "bcmc" : "card"}-inputWrapper`
      );
      rn = Qn, Rn = er;
    }
    return rn != null && rn.checked ? !0 : (Rn.classList.add("adyen-checkout__bank-checkbox--error"), !1);
  }, fn = (oo, Lr) => st(void 0, [oo, Lr], function* ({
    id: tt,
    sessionData: bt,
    shopperStatement: rn,
    amount: Rn,
    countryCode: Cn,
    paymentMethods: Qn
  }, er) {
    var ti, bs, _s, ni, Ka, So, Fo;
    const ia = {
      amount: Rn,
      countryCode: Cn
    }, ir = Qn && ((ti = Qn.find((Pa) => Pa.type === "applepay")) == null ? void 0 : ti.configuration), xr = Qn && ((bs = Qn.find((Pa) => Pa.type === "googlepay")) == null ? void 0 : bs.configuration), wo = {
      locale: (x == null ? void 0 : x.locale) || (be == null ? void 0 : be.language) || "en-US",
      translations: Fe(Fe({}, Ztt), x == null ? void 0 : x.translations),
      environment: wD(),
      analytics: (x == null ? void 0 : x.analytics) || {
        enabled: !0
        //  analytics data for Adyen
      },
      setStatusAutomatically: !1,
      session: {
        id: tt,
        sessionData: bt
      },
      clientKey: Htt(),
      onSubmit: (Pa, ri) => st(void 0, null, function* () {
        const {
          data: { paymentMethod: xo }
        } = Pa, qa = xo == null ? void 0 : xo.type;
        return qt(qa) ? (ri.setStatus("loading"), (yield $t()) ? (er === Op ? Ie(!0) : ie(!0), e(Pa, ri)) : (ri.setStatus("ready"), !1)) : !1;
      }),
      onActionHandled: () => {
        er === Op ? we(!0) : Ee(!0);
      },
      onAdditionalDetails: o,
      onError: dn,
      paymentMethodsConfiguration: {
        card: Fe({
          hasHolderName: !0,
          holderNameRequired: !0
        }, (_s = x == null ? void 0 : x.paymentMethodsConfiguration) == null ? void 0 : _s.card),
        applepay: Fe(Fe(Fe({
          onClick: (Pa) => st(void 0, null, function* () {
            !qt("applepay") || !(yield $t()) || Pa();
          })
        }, ia), ir && {
          configuration: {
            merchantName: rn,
            merchantId: ir.merchantId
          }
        }), (ni = x == null ? void 0 : x.paymentMethodsConfiguration) == null ? void 0 : ni.applePay),
        googlepay: Fe(Fe(Fe({
          onClick: (Pa) => st(void 0, null, function* () {
            !qt("googlepay") || !(yield $t()) || Pa();
          }),
          environment: Wtt()
        }, xr && {
          configuration: {
            merchantName: rn,
            gatewayMerchantId: xr.gatewayMerchantId,
            merchantId: xr.merchantId
          }
        }), (Ka = x == null ? void 0 : x.paymentMethodsConfiguration) == null ? void 0 : Ka.googlePay), ia),
        ideal: Fe({}, (So = x == null ? void 0 : x.paymentMethodsConfiguration) == null ? void 0 : So.ideal),
        bcmc: Xn(Fe({}, (Fo = x == null ? void 0 : x.paymentMethodsConfiguration) == null ? void 0 : Fo.bancontactCard), {
          hasHolderName: !0,
          holderNameRequired: !0,
          positionHolderNameOnTop: !0
        })
      }
    }, es = yield btt(wo);
    if (er === Op) {
      zn(es), O(!1);
      return;
    }
    sn(es), O(!1);
  }), At = (tt) => st(void 0, null, function* () {
    try {
      const bt = yield _tt(
        tt,
        N,
        t
      );
      bt != null && bt.id && fn(bt, tt);
    } catch (bt) {
      tt === Op ? X(bt.message) : me(bt.message), O(!1);
    }
  }), Wt = () => {
    const tt = ole(
      E,
      N
    );
    if (!tt.length) {
      ce(!0), O(!1);
      return;
    }
    t || y === 0 ? (tt.some(
      ({ methodName: Rn }) => !hN.includes(Rn)
    ) && (ee(!0), At(mN)), tt.some(
      ({ methodName: Rn }) => hN.includes(Rn)
    ) && At(Op)) : At();
  };
  mn(() => (Wt(), () => {
    he(null), ge(null);
  }), []);
  const Xr = Yi(() => {
    _e && _e.closeActivePaymentMethod();
  }, [_e]), Kn = Yi(() => {
    pe && pe.closeActivePaymentMethod();
  }, [pe]), Sr = () => {
    q.current.removeEventListener("click", Kn), K.current.removeEventListener("click", Xr), pe && (pe.unmount(), he(null), a(null, mN)), _e && (_e.unmount(), ge(null), a(null, Op)), O(!0), Wt();
  }, jo = pe || _e;
  return mn(() => {
    _e && pe && (K.current.addEventListener("click", Xr), q.current.addEventListener("click", Kn));
  }, [pe, _e]), mn(() => {
    jo && (v != null && v.applied) && Sr();
  }, [v.applied, v.type, S]), mn(() => {
    jo && Sr();
  }, [be.language, B == null ? void 0 : B.isGift]), mn(() => {
    (D == null ? void 0 : D.methodName) === "paypal" && (pe && pe.closeActivePaymentMethod(), _e && _e.closeActivePaymentMethod());
  }, [D]), ye ? /* @__PURE__ */ C.jsx(Vy, { children: le(
    "payment-methods.error.not-available",
    "Payment methods not available"
  ) }) : (oe && xe || xe && !Y) && !r ? /* @__PURE__ */ C.jsx(Vy, { children: xe }) : /* @__PURE__ */ C.jsxs(Utt, { $isMyAccount: !0, $isAdditionalPayment: r, children: [
    R && /* @__PURE__ */ C.jsx(cr, {}),
    /* @__PURE__ */ C.jsx(
      "div",
      {
        ref: K,
        style: Fe(Fe({}, $e && { display: "none" }), se && {
          opacity: "0.2",
          pointerEvents: "none"
        })
      }
    ),
    /* @__PURE__ */ C.jsx(
      "div",
      {
        ref: q,
        style: Fe(Fe({}, Ne && { display: "none" }), Le && {
          opacity: "0.2",
          pointerEvents: "none"
        })
      }
    )
  ] });
};
B8.propTypes = {
  onSubmit: de.func.isRequired,
  isMyAccount: de.bool,
  selectPaymentMethod: de.func.isRequired,
  isPayPalAvailable: de.bool.isRequired,
  getDropIn: de.func.isRequired,
  onAdditionalDetails: de.func.isRequired
};
B8.defaultProps = {
  isMyAccount: !1
};
const Ytt = W.h1.attrs(() => ({
  className: "msd__section-header"
}))`
  padding-bottom: ${(e) => e.$paddingBottom};
  font-size: ${t8};
  font-weight: ${Nd};
  color: ${Et};
  text-transform: uppercase;
  ${(e) => e.$center && ot`
      text-align: center;
    `}
  ${(e) => e.$marginTop && ot`
      margin-top: ${e.$marginTop};
    `};
`, Xi = ({ children: e, center: t, marginTop: n, paddingBottom: r }) => /* @__PURE__ */ C.jsx(
  Ytt,
  {
    $center: t,
    $marginTop: n,
    $paddingBottom: r,
    children: e
  }
);
Xi.propTypes = {
  children: de.node,
  center: de.bool,
  marginTop: de.string,
  paddingBottom: de.string
};
Xi.defaultProps = {
  children: "",
  center: !1,
  marginTop: null,
  paddingBottom: "25px"
};
const Xtt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ id: "PayPal", xmlns: "http://www.w3.org/2000/svg", width: 97.336, height: 23.768, viewBox: "0 0 97.336 23.768" }, e), /* @__PURE__ */ k.createElement("path", { id: "Path_2600", "data-name": "Path 2600", d: "M43.97,6.749H38.584a.748.748,0,0,0-.74.632L35.665,21.193a.448.448,0,0,0,.444.518h2.572a.748.748,0,0,0,.74-.632l.588-3.725a.748.748,0,0,1,.739-.632h1.705c3.548,0,5.6-1.717,6.131-5.119A4.149,4.149,0,0,0,47.9,8.124,5,5,0,0,0,43.97,6.749Zm.621,5.045c-.295,1.933-1.771,1.933-3.2,1.933h-.813l.57-3.61a.449.449,0,0,1,.443-.379h.373c.973,0,1.89,0,2.364.554A1.8,1.8,0,0,1,44.591,11.794Z", transform: "translate(-7.574 -1.434)", fill: "#253b80" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2601", "data-name": "Path 2601", d: "M63.364,13.01H60.784a.449.449,0,0,0-.443.379l-.114.721-.18-.261A3.671,3.671,0,0,0,57,12.767a5.932,5.932,0,0,0-5.759,5.187,4.869,4.869,0,0,0,.961,3.962,4.036,4.036,0,0,0,3.249,1.312,4.935,4.935,0,0,0,3.57-1.477l-.115.717a.449.449,0,0,0,.443.52h2.323a.748.748,0,0,0,.74-.632l1.394-8.828A.447.447,0,0,0,63.364,13.01Zm-3.6,5.02a2.875,2.875,0,0,1-2.91,2.463,2,2,0,0,1-2.137-2.508,2.887,2.887,0,0,1,2.89-2.483,2.176,2.176,0,0,1,1.72.7A2.233,2.233,0,0,1,59.768,18.03Z", transform: "translate(-10.867 -2.712)", fill: "#253b80" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2602", "data-name": "Path 2602", d: "M80.855,13.075H78.263a.751.751,0,0,0-.62.328l-3.575,5.266-1.515-5.06a.751.751,0,0,0-.718-.534H69.288a.449.449,0,0,0-.426.594l2.855,8.378-2.684,3.789a.449.449,0,0,0,.366.709h2.589a.747.747,0,0,0,.615-.321L81.224,13.78A.449.449,0,0,0,80.855,13.075Z", transform: "translate(-14.621 -2.777)", fill: "#253b80" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2603", "data-name": "Path 2603", d: "M92.751,6.749H87.364a.748.748,0,0,0-.739.632L84.446,21.193a.448.448,0,0,0,.443.518h2.764a.524.524,0,0,0,.517-.443l.618-3.915a.748.748,0,0,1,.739-.632h1.7c3.549,0,5.6-1.717,6.131-5.119a4.146,4.146,0,0,0-.688-3.477A4.992,4.992,0,0,0,92.751,6.749Zm.621,5.045c-.294,1.933-1.771,1.933-3.2,1.933h-.812l.571-3.61a.447.447,0,0,1,.443-.379h.373c.972,0,1.89,0,2.364.554A1.8,1.8,0,0,1,93.372,11.794Z", transform: "translate(-17.936 -1.434)", fill: "#179bd7" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2604", "data-name": "Path 2604", d: "M112.145,13.01h-2.578a.447.447,0,0,0-.443.379l-.114.721-.181-.261a3.67,3.67,0,0,0-3.046-1.081,5.931,5.931,0,0,0-5.758,5.187,4.871,4.871,0,0,0,.96,3.962,4.038,4.038,0,0,0,3.249,1.312,4.935,4.935,0,0,0,3.57-1.477l-.115.717a.449.449,0,0,0,.444.52h2.323a.748.748,0,0,0,.739-.632l1.395-8.828A.45.45,0,0,0,112.145,13.01Zm-3.6,5.02a2.874,2.874,0,0,1-2.91,2.463,2,2,0,0,1-2.137-2.508,2.888,2.888,0,0,1,2.89-2.483,2.176,2.176,0,0,1,1.72.7A2.221,2.221,0,0,1,108.549,18.03Z", transform: "translate(-21.229 -2.712)", fill: "#179bd7" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2605", "data-name": "Path 2605", d: "M118.7,7.128l-2.211,14.065a.448.448,0,0,0,.443.518h2.223a.747.747,0,0,0,.74-.632l2.18-13.811a.449.449,0,0,0-.443-.519H119.14A.45.45,0,0,0,118.7,7.128Z", transform: "translate(-24.741 -1.434)", fill: "#179bd7" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2606", "data-name": "Path 2606", d: "M5.948,23.179l.412-2.616-.918-.021H1.061L4.106,1.235a.255.255,0,0,1,.085-.151.249.249,0,0,1,.162-.06h7.388c2.453,0,4.145.51,5.029,1.518a3.46,3.46,0,0,1,.806,1.51,5.451,5.451,0,0,1,.006,2.082l-.009.061v.532l.414.235a2.906,2.906,0,0,1,.839.64,2.978,2.978,0,0,1,.68,1.526,6.457,6.457,0,0,1-.1,2.215,7.8,7.8,0,0,1-.907,2.507,5.156,5.156,0,0,1-1.437,1.575,5.831,5.831,0,0,1-1.936.873,9.654,9.654,0,0,1-2.419.28h-.575a1.729,1.729,0,0,0-1.71,1.459l-.043.235-.728,4.611-.033.169a.146.146,0,0,1-.046.1.122.122,0,0,1-.076.028H5.948Z", transform: "translate(-0.226 -0.218)", fill: "#253b80" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2607", "data-name": "Path 2607", d: "M19.467,7.667h0q-.033.211-.076.433c-.974,5-4.307,6.73-8.564,6.73H8.66a1.053,1.053,0,0,0-1.04.892h0L6.509,22.76,6.2,24.755a.555.555,0,0,0,.547.641h3.844a.925.925,0,0,0,.914-.78l.038-.2.724-4.593.046-.252a.924.924,0,0,1,.914-.781H13.8c3.725,0,6.64-1.512,7.492-5.888.356-1.828.172-3.354-.77-4.428A3.676,3.676,0,0,0,19.467,7.667Z", transform: "translate(-1.314 -1.628)", fill: "#179bd7" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2608", "data-name": "Path 2608", d: "M18.834,7.057q-.223-.065-.46-.118t-.488-.092a12.038,12.038,0,0,0-1.911-.139h-5.79a.923.923,0,0,0-.913.781L8.04,15.29l-.035.228a1.053,1.053,0,0,1,1.04-.892h2.167c4.257,0,7.59-1.729,8.564-6.73.029-.148.054-.292.076-.433a5.193,5.193,0,0,0-.8-.338C18.981,7.1,18.908,7.079,18.834,7.057Z", transform: "translate(-1.7 -1.425)", fill: "#222d65" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2609", "data-name": "Path 2609", d: "M7.572,6.064a.924.924,0,0,1,.913-.781h5.79a12.038,12.038,0,0,1,1.911.139q.25.04.488.092t.46.118l.219.068a5.272,5.272,0,0,1,.8.338,4.724,4.724,0,0,0-1-4.247C16.05.537,14.061,0,11.516,0H4.129A1.056,1.056,0,0,0,3.085.892L.008,20.4a.635.635,0,0,0,.626.734H5.195L6.34,13.866Z", fill: "#253b80" })), Ktt = W.div.attrs(() => ({
  className: "msd__paypal--wrapper"
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  padding-left: 16px;
  padding-right: 16px;
  font-size: 11px;
  button {
    height: 48px;
  }
`, qtt = W.p.attrs(() => ({
  className: "msd__paypal--text"
}))`
  font-size: 11px;
  margin: 20px 15px;
  line-height: 17px;
  font-weight: 400;
  color: #7b849d;
  text-align: center;
`;
W.div.attrs(() => ({
  className: "msd__paypal--icon"
}))`
  padding-bottom: 20px;
`;
const Jtt = W.div`
  display: flex;
  flex-direction: column;

  .msd__consents__text {
    font-size: 11px;
    line-height: 17px;
  }

  .msd__consents__frame {
    align-self: start;
  }

  .adyen-checkout__bank-checkbox {
    color: #515364;
    margin-bottom: 20px;
  }

  .adyen-checkout__bank-checkbox--error {
    .msd__consents__frame {
      border-color: ${wa};
    }

    .msd__consents__text {
      color: ${wa};
    }
  }
`, ple = ({
  isMyAccount: e = !1,
  totalPrice: t,
  offerId: n,
  onSubmit: r,
  isLoading: a
}) => {
  const { t: o } = tn(), s = Ot(Bm), c = Ot(A_), u = Ot(bee), { isGift: f } = Ot(I2), [m, v] = mt(!1), y = () => {
    const b = document.querySelector("#paypal-input"), S = document.querySelector(".paypal-inputLabel");
    if (!(b != null && b.checked)) {
      S == null || S.classList.add("adyen-checkout__bank-checkbox--error");
      return;
    }
    r();
  };
  return /* @__PURE__ */ C.jsxs(Ktt, { children: [
    /* @__PURE__ */ C.jsxs(qtt, { children: [
      !n && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
        o(
          "paypal.update-payment-details",
          "We'll redirect you to PayPal to update your payment details."
        ),
        /* @__PURE__ */ C.jsx("br", {}),
        /* @__PURE__ */ C.jsx("br", {}),
        o(
          "paypal.fee-note",
          "Note, PayPal is subject to an additional 8% fee that will be added to your next payments."
        )
      ] }),
      n && t !== 0 && o(
        "paypal.complete-purchase",
        "We'll redirect you to PayPal to complete your purchase."
      ),
      (n == null ? void 0 : n.charAt(0)) === "S" && t === 0 && o(
        "paypal.fee-note-complete-purchase",
        "We'll redirect you to PayPal to complete your purchase. Note, PayPal is subject to an additional 8% fee that will be added to your next payments."
      )
    ] }),
    /* @__PURE__ */ C.jsx(Jtt, { children: /* @__PURE__ */ C.jsx(
      F8,
      {
        className: "adyen-checkout__bank-checkbox paypal-inputLabel",
        checked: m,
        id: "paypal-input",
        onClickFn: (b) => {
          var S;
          b && (b.nativeEvent instanceof KeyboardEvent && b.nativeEvent.key === " " && ((S = b.target.parentElement) == null || S.classList.remove(
            "adyen-checkout__bank-checkbox--error"
          )), b.target.classList.remove(
            "adyen-checkout__bank-checkbox--error"
          ), v(!b.target.checked));
        },
        termsUrl: u,
        isPayPal: !0,
        children: ile(e, c, s, f)
      }
    ) }),
    /* @__PURE__ */ C.jsx(
      zt,
      {
        theme: "paypal",
        onClickFn: y,
        disabled: a,
        size: "big",
        margin: "20px auto auto auto",
        fontSize: "15px",
        fontWeight: "400",
        children: /* @__PURE__ */ C.jsx(Xtt, {})
      }
    )
  ] });
}, Qtt = W.div.attrs(() => ({
  className: "msd__custom-dropin--wrapper"
}))`
  max-width: 376px;
  margin: 0 auto;
  min-height: 58px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${cu};
  border-radius: 12px;
  border: 1px solid ${(e) => e.$isSelected ? An : "#D3DBE6"};
  cursor: ${(e) => e.$fadeOutSection ? "default" : "pointer"};
  opacity: ${(e) => e.$fadeOutSection ? ".2" : "1"};

  &:hover .adyen-checkout__payment-method__radio {
    box-shadow: 0 0 3px 1px #808080;
  }
  .adyen-checkout__payment-method__radio--selected {
    background-color: ${An};
  }
`, ent = W.div.attrs(() => ({
  className: "msd__custom-dropin-text"
}))`
  max-width: 550px;
  margin: 0;
  text-align: center;
  line-height: 1.4em;
  color: #00112c;
  font-size: 1em;
  font-weight: 400;
  display: flex;
  align-items: center;
  position: relative;
  padding-block: 12px;
  padding-inline: 50px 16px;

  ${pr.small`
    max-width: 400px;
  `}
`, tnt = W.span.attrs(() => ({
  className: "msd__custom-dropin-title"
}))`
  margin-inline-start: 10px;
`, nnt = W.div.attrs(() => ({
  className: "msd__custom-dropin--payment-icon"
}))`
  border: 1px solid #a9a9bf;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 26px;
  border-radius: 4px;
  svg {
    max-height: 100%;
    max-width: 100%;
    height: 26px;
    width: 31px;
  }
`, hle = ({
  children: e,
  selectPaymentMethod: t,
  title: n,
  logo: r,
  isLoading: a
}) => {
  const { selectedPaymentMethod: o } = Ot(abe), s = (o == null ? void 0 : o.methodName) === n.toLowerCase(), c = a && (o == null ? void 0 : o.methodName) !== n.toLowerCase(), f = r === "paypal" ? {
    paypal: bD
  }[r] : null, m = () => {
    !c && (o == null ? void 0 : o.methodName) !== "paypal" && t("paypal");
  };
  return /* @__PURE__ */ C.jsxs(
    Qtt,
    {
      $isSelected: s,
      onClick: m,
      $fadeOutSection: c,
      children: [
        /* @__PURE__ */ C.jsxs(ent, { children: [
          /* @__PURE__ */ C.jsx(
            "span",
            {
              className: Tt("adyen-checkout__payment-method__radio", {
                "adyen-checkout__payment-method__radio--selected": s
              }),
              "aria-hidden": !s
            }
          ),
          /* @__PURE__ */ C.jsx(nnt, { children: f && /* @__PURE__ */ C.jsx(f, {}) }),
          /* @__PURE__ */ C.jsx(tnt, { children: n })
        ] }),
        s && e
      ]
    }
  );
}, rnt = ({ onPaymentComplete: e }) => {
  const {
    paymentMethods: t,
    isPayPalHidden: n,
    visiblePaymentMethods: r
  } = Ot(FR), a = Ot(Bm), o = Ot(I2), { t: s } = tn(), { requiredPaymentDetails: c } = a, { loading: u } = Ot(
    _2e
  ), [f, m] = mt(!1), [v, y] = mt(""), [b, S] = mt(null), [x, E] = mt(null), [N, R] = mt(null), [O, D] = mt(!1), $ = Va(), B = (X) => {
    y("");
    const { id: ye } = a;
    ye && X && $(
      xd({
        id: ye,
        payload: { paymentMethodId: X }
      })
    ).unwrap().catch((ce) => {
      ce.includes("JWT") && (ur(i_), Ec.logout());
    });
  }, G = (X) => {
    const ye = t.find(
      ({ methodName: ce }) => ce === X
    );
    ye && ($(lee(ye)), B(ye.id));
  }, Z = () => st(void 0, null, function* () {
    m(!0);
    const X = yield j7(), { paymentMethods: ye } = X.responseData, ce = ale(
      ye,
      !1
    );
    if (X.errors.length) {
      y(
        s(
          "payment.error.cannot-fetch-payment-methods",
          "Cannot fetch payment methods"
        )
      );
      return;
    }
    $(_ee(ce)), m(!1), ce != null && ce.length || y(
      s(
        "payment.error.payment-methods-not-defined",
        "Payment methods are not defined"
      )
    );
  });
  mn(() => {
    if (t.length === 1) {
      const [X] = t;
      G(X.methodName);
    }
  }, [t]);
  const K = () => {
    const { search: X } = window.location;
    X != null && X.includes("message") && y(
      s(
        "payment.error.paypal-not-processed",
        "Your payment was not processed. Please, try again"
      )
    );
  };
  mn(() => {
    Z(), K(), ur(jye);
  }, []);
  const q = () => st(void 0, null, function* () {
    const { isGift: X } = o, { id: ye, buyAsAGift: ce } = a;
    if (X) {
      if (!CD())
        return;
      const { recipientEmail: Le, deliveryDate: ie, deliveryTime: $e, message: we } = o;
      yield $(
        xd({
          id: a.id,
          payload: {
            buyAsAGift: !0,
            deliveryDetails: {
              recipientEmail: Le.value,
              personalNote: we.value,
              deliveryDate: (/* @__PURE__ */ new Date(
                `${ie.value}T${$e.value}`
              )).valueOf() / 1e3
            }
          }
        })
      ).unwrap().catch((Ne) => {
        throw new Error(Ne);
      });
    }
    ce && !X && (yield $(
      xd({
        id: ye,
        payload: {
          buyAsAGift: !1
        }
      })
    ).unwrap().catch((Ie) => {
      throw new Error(Ie);
    })), m(!0);
    const { responseData: se } = yield Qye();
    se != null && se.redirectUrl ? window.location.href = se.redirectUrl : (m(!1), y(
      s(
        "payment.error.paypal-failed",
        "The payment failed. Please try again."
      )
    ));
  }), pe = (X) => st(void 0, null, function* () {
    const {
      data: { details: ye }
    } = X;
    $(O4({ orderId: a.id, details: ye }));
  }), he = (X, ye) => st(void 0, null, function* () {
    const {
      data: { paymentMethod: ce, browserInfo: se, billingAddress: Ie }
    } = X;
    y(""), m(!0);
    const { errors: Le, responseData: ie } = yield Yye(
      ce,
      se,
      Ie
    );
    if (Le != null && Le.length) {
      ur(WQ, {
        reason: Le[0]
      });
      const Ne = Le[0].includes(
        "Payment details are not supported"
      );
      y(
        Ne ? s(
          "payment.error.payment-method-not-supported",
          "Payment method not supported. Try different payment method"
        ) : s(
          "payment.error.payment-not-processed",
          "The payment has not been processed. Please, try again with a different payment method."
        )
      ), m(!1), E(null), R(null), S((Ee) => Ee ? null : 1);
      return;
    }
    const { action: $e, payment: we } = ie;
    if ($e) {
      $e.type !== "redirect" && D(!0), ye.handleAction($e);
      return;
    }
    ur(M7, {
      payment: we
    }), e && e();
  }), _e = (X, ye) => {
    ye === Op ? R(X) : E(X);
  }, ge = () => st(void 0, null, function* () {
    m(!0), y(""), $(j4()).unwrap().then((X) => {
      ur(M7, {
        payment: Xn(Fe({}, X), {
          offerId: a == null ? void 0 : a.offerId
        })
      }), e && e();
    }).catch(() => {
      m(!1), y(
        s("payment.error.failed", "The payment failed. Please try again.")
      );
    });
  }), Y = n ? !1 : h6("paypal", t), ee = ole(
    t,
    r
  ), oe = h6(
    "adyen",
    ee
  ), me = !t.length || !ee.length && !Y, xe = () => oe ? !!x || !!N : !0;
  return me && !f ? /* @__PURE__ */ C.jsxs(vN, { children: [
    /* @__PURE__ */ C.jsx(Xi, { marginTop: "25px", center: !0, children: /* @__PURE__ */ C.jsx(C.Fragment, { children: s("payment.purchase-using", "Purchase using") }) }),
    v ? /* @__PURE__ */ C.jsx(Vy, { children: v }) : /* @__PURE__ */ C.jsx(Vy, { children: s(
      "payment.error.payment-methods-not-available",
      "Payment methods not available"
    ) })
  ] }) : c ? /* @__PURE__ */ C.jsxs(vN, { children: [
    /* @__PURE__ */ C.jsx(Xi, { marginTop: "25px", paddingBottom: "33px", center: !0, children: /* @__PURE__ */ C.jsx(C.Fragment, { children: s("payment.purchase-using", "Purchase using") }) }),
    /* @__PURE__ */ C.jsxs($tt, { children: [
      u && /* @__PURE__ */ C.jsx(cr, {}),
      oe && /* @__PURE__ */ C.jsx(
        B8,
        {
          onSubmit: he,
          selectPaymentMethod: G,
          isPayPalAvailable: Y,
          getDropIn: _e,
          onAdditionalDetails: pe
        },
        b
      ),
      Y && xe() && !O && /* @__PURE__ */ C.jsx(
        hle,
        {
          selectPaymentMethod: G,
          title: "PayPal",
          logo: "paypal",
          isLoading: f,
          children: /* @__PURE__ */ C.jsx(
            ple,
            {
              totalPrice: a.totalPrice,
              offerId: a.offerId,
              onSubmit: q,
              isLoading: f
            }
          )
        }
      ),
      v && /* @__PURE__ */ C.jsx(Vy, { children: v })
    ] })
  ] }) : /* @__PURE__ */ C.jsxs(vN, { children: [
    v && /* @__PURE__ */ C.jsx(Vy, { children: v }),
    /* @__PURE__ */ C.jsx(
      zt,
      {
        onClickFn: ge,
        theme: "confirm",
        width: "250px",
        size: "big",
        margin: "20px auto 0 auto",
        children: f ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : /* @__PURE__ */ C.jsx(C.Fragment, { children: s("payment.complete-purchase", "Complete purchase") })
      }
    )
  ] });
}, h1 = () => typeof window == "object" ? document.dir === "rtl" : !1, ant = "data:image/png;base64,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", ont = W.header.attrs(() => ({
  className: "msd__header"
}))`
  display: flex;
  position: relative;

  padding: 0 40px;

  background-color: ${Br};
  border-bottom: 1px ${Gn} solid;

  text-align: center;

  ${(e) => e.switchOff && ot`
      display: none;
    `}
`, int = W.div.attrs(() => ({
  className: "msd__header__logo"
}))`
  height: 80px;
  width: 100%;

  background-image: url(${g3e || ant});
  background-size: auto 35%;
  background-position: center;
  background-repeat: no-repeat;
`, snt = W.span`
  width: 13px;
  height: 13px;
  align-self: center;

  border-top: 2px solid ${Gn};
  border-right: 2px solid ${Gn};

  transform: rotate(225deg);

  &:hover {
    cursor: pointer;
  }
  /* 
  ${h1() && ot`
    transform: translateX(-25%) rotate(225deg);
  `} */
`, pl = ({ children: e, onBackClick: t }) => /* @__PURE__ */ C.jsxs(ont, { children: [
  t && /* @__PURE__ */ C.jsx(snt, { onClick: t }),
  /* @__PURE__ */ C.jsx(int, {}),
  e
] });
pl.propTypes = {
  children: de.node,
  onBackClick: de.func
};
pl.defaultProps = {
  children: null,
  onBackClick: null
};
const lnt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 20, height: 13, viewBox: "0 0 92.72 114.87" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".d{fill:#5db98f;}")), /* @__PURE__ */ k.createElement("g", { id: "a" }), /* @__PURE__ */ k.createElement("g", { id: "b" }, /* @__PURE__ */ k.createElement("g", { id: "c" }, /* @__PURE__ */ k.createElement("path", { className: "d", d: "M86.78,49.82c.43-2.44,.66-4.95,.66-7.52,0-23.33-18.43-42.31-41.08-42.31S5.28,18.98,5.28,42.31c0,2.57,.24,5.07,.66,7.52-3.57,2.28-5.94,6.26-5.94,10.81v41.42c0,7.08,5.74,12.83,12.82,12.83H79.89c7.08,0,12.82-5.74,12.82-12.83h0V60.63c0-4.55-2.37-8.53-5.94-10.81Zm-34.76,36.16v9c0,3.13-2.53,5.66-5.66,5.66s-5.66-2.53-5.66-5.66v-9c-3.63-2-6.09-5.86-6.09-10.3,0-6.49,5.26-11.76,11.76-11.76s11.76,5.26,11.76,11.76c0,4.44-2.47,8.31-6.1,10.31Zm19.79-38.18H20.91c-.35-1.78-.53-3.62-.53-5.5,0-15,11.66-27.21,25.99-27.21s25.98,12.2,25.98,27.21c0,1.88-.18,3.72-.53,5.5Z" })))), unt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ id: "Group_10280", "data-name": "Group 10280", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 94, height: 12, viewBox: "0 0 193.217 24.755" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_10279", "data-name": "Group 10279", transform: "translate(0 0)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_15504", "data-name": "Path 15504", d: "M20.653,9.51a20.01,20.01,0,0,1,7.393,1c1.459.529,4.791,1.773,4.8,3.589.014,1.487-1.788,2.474-3.661,2.3-1.173-.114-2.088-.887-3.16-1.359-5.749-2.574-13.714.358-13.771,6.75a5.968,5.968,0,0,0,.572,2.66c1.216,2.817,4.419,5.12,8.823,5.091a10.827,10.827,0,0,0,4.161-.858c1.073-.458,2.074-1.387,3.446-1.5,1.673-.143,3.589.729,3.589,2.3,0,1.273-1.344,1.9-2.374,2.445a19.584,19.584,0,0,1-11.984,2c-5.148-.758-9.5-3.518-11.555-7.608-2.317-4.59-.415-9.4,2.145-12.055a15.6,15.6,0,0,1,4.876-3.232A19.873,19.873,0,0,1,20.653,9.51Z", transform: "translate(-5.894 -9.47)", style: {
  fill: "#65BD72"
} }), /* @__PURE__ */ k.createElement("path", { id: "Path_15505", "data-name": "Path 15505", d: "M214.322,9.695a3.344,3.344,0,0,1,3.089,1.645c.4,1.015.143,2.932.143,4.161V24.11c0,2.345-.343,4.619,1.359,5.377,1.416.629,5.177.215,7.179.215h3.661a9.8,9.8,0,0,1,3.446.215,2.443,2.443,0,0,1,1.716,2c.043,2.045-2.474,2.374-4.59,2.374H216.41c-2.36,0-4.6-.1-5.162-1.788-.386-1.158-.072-3.7-.072-5.305V16.588c0-1.6-.215-4.147.143-5.162A3.077,3.077,0,0,1,214.322,9.695Z", transform: "translate(-181.716 -9.654)", style: {
  fill: "#65BD72"
} }), /* @__PURE__ */ k.createElement("path", { id: "Path_15506", "data-name": "Path 15506", d: "M399.755,9.477c6.75-.429,13.142,2.889,15.573,7.679.572,1.13,1.5,3.4,1,5.091-.758,2.588-6.807,1.788-10.468,1.788a12.967,12.967,0,0,1-3.8-.215,2.663,2.663,0,0,1-1.716-2,2.329,2.329,0,0,1,1.716-2.074c1.988-.787,5.877.829,5.877-2.074,0-1.33-1.487-2.031-2.445-2.517a9.832,9.832,0,0,0-3.8-1.073c-4.548-.358-8.18,1.816-9.61,4.733a7.082,7.082,0,0,0,.358,6.521,9.48,9.48,0,0,0,7.036,4.018c1.888.243,4.176.515,4.233,2.374.1,2.932-4.619,2.474-7.107,1.931-4.791-1.03-8.78-3.747-10.611-7.465a9.827,9.827,0,0,1-1-3.518c-.5-6.407,4.276-10.2,8.895-11.984A19.957,19.957,0,0,1,399.755,9.477Z", transform: "translate(-330.741 -9.436)", style: {
  fill: "#65BD77"
} }), /* @__PURE__ */ k.createElement("path", { id: "Path_15507", "data-name": "Path 15507", d: "M637.611,9.458C644.7,9,650.824,12.49,653.184,17.137c.586,1.144,1.5,3.418,1,5.091-.686,2.331-4.462,1.788-7.894,1.788-2.288,0-5.005.329-6.378-.215a2.694,2.694,0,0,1-1.716-2,2.469,2.469,0,0,1,1.931-2.145,31.055,31.055,0,0,1,3.732-.143c1.23-.114,1.931-.715,1.931-1.859,0-1.416-1.816-2.288-3.089-2.8-5.048-2.031-10.9.072-12.77,3.875a7.48,7.48,0,0,0-.215,5.591,9.124,9.124,0,0,0,5.091,4.519c2.717.958,6.678.215,6.75,2.874a2.451,2.451,0,0,1-1.645,2.074c-1.773.729-4.5.1-6.306-.358-5.22-1.316-10.325-5.177-10.754-10.754a9.678,9.678,0,0,1,1.073-5.52,13.333,13.333,0,0,1,5.305-5.305A18.649,18.649,0,0,1,637.611,9.458Z", transform: "translate(-534.59 -9.418)", style: {
  fill: "#66BD87"
} }), /* @__PURE__ */ k.createElement("path", { id: "Path_15508", "data-name": "Path 15508", d: "M870.8,10.077a5.436,5.436,0,0,1,1.788.143c1.745.558,3.3,2.36,4.733,3.518,3.818,3.089,7.436,5.892,11.412,9.038.787.629,1.516,1.573,2.517,1.573,2.646,0,1.931-4.1,1.931-6.821,0-1.9-.358-4.419.071-5.734.8-2.46,5.606-2.088,6.235.072.4,1.387.071,3.7.071,5.234V27.71c0,1.544.343,3.89-.071,5.162-.4,1.23-2.417,2.188-4.3,1.645-1.559-.443-3.5-2.531-4.733-3.518-3.79-3.046-7.579-6.006-11.483-9.109-.729-.572-1.673-1.587-2.517-1.573-2.617.029-1.931,3.775-1.931,6.821,0,1.916.286,4.347-.143,5.663-.686,2.116-5.134,2.6-6.092.143-.429-1.1-.143-3.532-.143-5.234V16.956c0-1.616-.229-4.033.143-5.162A2.79,2.79,0,0,1,870.8,10.077Z", transform: "translate(-744.756 -9.965)", style: {
  fill: "#63BC97"
} }), /* @__PURE__ */ k.createElement("path", { id: "Path_15509", "data-name": "Path 15509", d: "M1151.706,10.006a19.881,19.881,0,0,1,6.449.715c1.444.415,4.3,1.087,4.376,2.8.072,1.659-1.959,2.5-3.589,2.445a11.486,11.486,0,0,1-2.8-.858c-4.991-1.6-10.425.6-12.127,4.519a7.453,7.453,0,0,0,.143,5.663c1.8,3.647,7.493,5.949,12.7,3.947,1.373-.529,3.16-1.487,3.16-2.874,0-2.889-3.875-1.287-5.877-2.074a2.386,2.386,0,0,1-1.716-2,2.329,2.329,0,0,1,1.645-2,10.5,10.5,0,0,1,3.875-.286c3.418,0,9.7-.858,10.468,1.788a7.007,7.007,0,0,1-.286,3.089,11.72,11.72,0,0,1-4.3,6.163,17.072,17.072,0,0,1-10.325,3.589,18.366,18.366,0,0,1-10.9-3.017c-2.588-1.745-5.22-4.462-5.52-8.394-.358-4.576,1.916-7.45,4.376-9.467A18.55,18.55,0,0,1,1151.706,10.006Z", transform: "translate(-975.282 -9.894)", style: {
  fill: "#64BCA3"
} }))), cnt = W.footer.attrs((e) => ({
  className: `msd__footer ${e.$isTransparent ? "msd__footer--transparent" : ""}`
}))`
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding: 10px 34px;

  border-top: 1px solid ${Gn};
  background-color: ${(e) => e.$isTransparent ? "transparent" : Br};

  ${(e) => e.$isTransparent && ot`
      border: none;
    `}

  ${(e) => e.$isInPopup && ot`
      position: fixed;
      left: 0;
    `}
`, dnt = W.span.attrs(() => ({
  className: "msd__footer__label--left"
}))`
  display: flex;
  align-items: center;

  color: ${Et};

  font-size: 12px;
  font-weight: 300;
  & a {
    padding: 0 5px;
  }
`, fnt = W.div.attrs(() => ({
  className: "msd__footer__label--right"
}))`
  color: ${An};

  font-size: 14px;
  min-width: 135px;

  & svg {
    padding-right: 5px;
    margin-bottom: -1px;
    max-height: 13px;

    path {
      fill: ${An} !important;
    }
  }
`, pnt = W.a`
  svg {
    max-height: 12px;
    margin-bottom: -1px;
    width: 100%;
  }
`, yu = ({
  isInPopup: e = !1,
  isCheckout: t = !0,
  isTransparent: n = !1
}) => {
  const { t: r } = tn();
  return /* @__PURE__ */ C.jsxs(cnt, { $isInPopup: e, $isTransparent: n, children: [
    /* @__PURE__ */ C.jsxs(dnt, { children: [
      "Powered by",
      /* @__PURE__ */ C.jsx(
        pnt,
        {
          href: "https://cleeng.com/who-are-cleeng",
          rel: "noopener noreferrer",
          target: "_blank",
          children: /* @__PURE__ */ C.jsx(unt, { title: "Cleeng logo" })
        }
      )
    ] }),
    t && /* @__PURE__ */ C.jsxs(fnt, { children: [
      /* @__PURE__ */ C.jsx(
        lnt,
        {
          title: r("footer.secured-checkout", "Secured checkout")
        }
      ),
      r("footer.secured-checkout", "Secured checkout")
    ] })
  ] });
}, hnt = (e, t, n) => {
  const r = e * t;
  return n === Number((e + t * e).toFixed(2)) ? r.toFixed(2) : (Math.trunc(Math.ceil(r * 100)) / 100).toFixed(2);
}, mnt = W.div`
  position: relative;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
`, mle = W.main`
  width: 100%;
  margin: 0 auto;
  padding: 50px 20px 80px;
  text-align: center;
  line-height: 1.3em;
  font-size: 15px;
  background-color: ${Br};
  color: ${Et};
  font-weight: bold;
`, vle = W.h1`
  font-size: 25px;
  margin: 30px 0;
  font-weight: 600;
`, m6 = W.p`
  font-weight: 300;
  margin: 0;
  & strong {
    font-weight: bold;
  }
`, _2 = W.a`
  color: ${Et};
  padding-left: 4px;
  font-weight: bold;
  outline: none;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0 5px;
  &:hover {
    text-decoration: underline;
  }
`, vnt = W.img``, Py = W.span.attrs(() => ({
  className: "msd__price-summary__label"
}))`
  font-size: 16px;
  color: ${Et};
`, Ny = W.span.attrs(() => ({
  className: "msd__price-summary__ammount"
}))`
  font-size: 16px;
  font-weight: bold;
  color: ${Et};
  margin: 16px 0;

  & span {
    font-size: 12px;
  }

  ${pr.small`
    width: auto;
  `}
`, gnt = W.strong`
  border-top: 1px solid ${Gn};
`, ynt = W(Py).attrs(
  () => ({
    className: "msd__price-summary__total--label"
  })
)`
  font-weight: ${Nd};
  text-transform: uppercase;
`, bnt = W(
  Ny
).attrs(() => ({
  className: "msd__price-summary__total--ammount"
}))`
  font-size: 25px;
  font-weight: ${Yp};
`, _nt = W.ul.attrs(() => ({
  className: "msd__price-summary"
}))`
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px 0;
`, Cnt = W.div`
  display: flex;
  justify-content: flex-end;

  ${pr.small`
    width: 100%;
  `}
`, Sy = W.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  position: relative;

  &:last-of-type {
    margin-bottom: unset;
  }

  strong {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
`, wnt = W.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`, Snt = W.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`, xnt = W.div.attrs(() => ({
  className: "msd__price-coupon__note"
}))`
  color: ${An};
  border-radius: 5px;

  font-size: 12px;
`, Ent = W.div`
  > span {
    font-size: 13px;
    color: ${Et};
    font-weight: 400;
  }

  > button {
    color: ${An};
    text-decoration: underline;
  }
`, Int = W.button.attrs(() => ({
  className: "msd__price-coupon__remove-button"
}))`
  border: none;
  background-color: inherit;
  cursor: pointer;
  font-family: inherit;
  font-size: ${t8};
  font-weight: ${Yp};
  color: ${Et};

  &:hover {
    color: ${e8};
  }
`, knt = ({
  hideRedeemButton: e,
  isCheckout: t,
  onRedeemClick: n
}) => {
  const r = Va(), { customerPriceInclTax: a, trialAvailable: o } = Ot(A_), {
    priceBreakdown: {
      offerPrice: s,
      discountAmount: c,
      taxValue: u,
      customerServiceFee: f,
      paymentMethodFee: m
    },
    discount: {
      applied: v,
      type: y,
      periods: b
    },
    taxRate: S,
    country: x,
    totalPrice: E,
    currency: N,
    id: R
  } = Ot(Bm), O = Ta[N], { t: D } = tn(), $ = o && y === "trial", B = () => b === 999 ? !1 : D(
    "checkout-price-box.coupon-note-applied",
    "Promotional Pricing applied!"
  ), G = Yi(() => st(void 0, null, function* () {
    yield r(Zy({ id: R, couponCode: null }));
  }), [r, Zy, R]), Z = !e && t;
  return /* @__PURE__ */ C.jsx(Cnt, { children: /* @__PURE__ */ C.jsxs(_nt, { children: [
    /* @__PURE__ */ C.jsxs(Sy, { children: [
      /* @__PURE__ */ C.jsx(Py, { id: "offerPriceLabel", children: D("checkout-price-box.price", "Price") }),
      /* @__PURE__ */ C.jsxs(Ny, { id: "offerPriceValue", children: [
        `${O}${br(s)} `,
        /* @__PURE__ */ C.jsx("span", { children: x === "US" ? D("checkout-price-box.excl-tax", "excl. Tax") : D("checkout-price-box.excl-vat", "excl. VAT") })
      ] })
    ] }),
    v && /* @__PURE__ */ C.jsx(Sy, { children: /* @__PURE__ */ C.jsxs(wnt, { children: [
      /* @__PURE__ */ C.jsxs(Snt, { children: [
        /* @__PURE__ */ C.jsx(Py, { id: "discountAmountLabel", children: $ ? D("checkout-price-box.trial-discount", "Trial Discount") : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          D(
            "checkout-price-box.coupon-discount",
            "Coupon Discount"
          ),
          " ",
          /* @__PURE__ */ C.jsx(Int, { onClick: G, children: D(
            "checkout-price-box.remove-coupon-discount",
            "[Remove]"
          ) })
        ] }) }),
        /* @__PURE__ */ C.jsxs(Ny, { id: "discountAmount", children: [
          "- ",
          O,
          br(c)
        ] })
      ] }),
      y === "coupon" && /* @__PURE__ */ C.jsx(xnt, { "data-testid": "coupon-notes", children: B() })
    ] }) }),
    /* @__PURE__ */ C.jsxs(Sy, { children: [
      /* @__PURE__ */ C.jsx(Py, { id: "taxValueLabel", children: x === "US" ? D("checkout-price-box.applicable-tax", "Applicable Tax") : D("checkout-price-box.applicable-vat", "Applicable VAT") }),
      /* @__PURE__ */ C.jsx(Ny, { id: "taxValue", children: !u && v ? /* @__PURE__ */ C.jsxs("p", { style: { textDecoration: "line-through" }, children: [
        O,
        " ",
        hnt(
          s,
          S,
          a
        )
      ] }) : `${O}${br(u)}` })
    ] }),
    f !== 0 && /* @__PURE__ */ C.jsxs(Sy, { children: [
      /* @__PURE__ */ C.jsx(Py, { id: "customerServiceFeeLabel", children: D("checkout-price-box.service-fee", "Service Fee") }),
      /* @__PURE__ */ C.jsx(Ny, { id: "customerServiceFee", children: `${O}${br(f)}` })
    ] }),
    m !== 0 && /* @__PURE__ */ C.jsxs(Sy, { children: [
      /* @__PURE__ */ C.jsx(Py, { id: "paymentMethodFeeLabel", children: D("checkout-price-box.payment-method-fee", "Payment Method Fee") }),
      /* @__PURE__ */ C.jsx(Ny, { id: "paymentMethodFee", children: `${O}${br(m)}` })
    ] }),
    /* @__PURE__ */ C.jsx(Sy, { children: /* @__PURE__ */ C.jsxs(gnt, { children: [
      /* @__PURE__ */ C.jsx(ynt, { id: "finalPriceLabel", children: D("checkout-price-box.total", "Today`s total") }),
      /* @__PURE__ */ C.jsx(bnt, { id: "finalPrice", children: `${O}${br(E)}` })
    ] }) }),
    Z && /* @__PURE__ */ C.jsxs(Ent, { children: [
      /* @__PURE__ */ C.jsx("span", { children: D("checkout-price-box.gift-code-label", "Have a gift code?") }),
      /* @__PURE__ */ C.jsx(_2, { as: "button", onClick: n, children: D("checkout-price-box.button.redeem", "Redeem here") })
    ] })
  ] }) });
}, Ant = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 43.864 43.863" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_3649", "data-name": "Group 3649", transform: "translate(-7.492 -7.068)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_2622", "data-name": "Path 2622", d: "M21.889.951a2,2,0,0,1,2.7.722l1.353,2.273a2,2,0,0,0,1.692.977l2.645.035a2,2,0,0,1,1.973,1.973l.035,2.645a2,2,0,0,0,.977,1.692l2.273,1.353a2,2,0,0,1,.722,2.7l-1.292,2.308a2,2,0,0,0,0,1.954l1.292,2.308a2,2,0,0,1-.722,2.7l-2.273,1.353a2,2,0,0,0-.977,1.692l-.035,2.645a2,2,0,0,1-1.973,1.973l-2.645.035a2,2,0,0,0-1.692.977l-1.353,2.273a2,2,0,0,1-2.7.722l-2.309-1.292a2,2,0,0,0-1.954,0l-2.309,1.292a2,2,0,0,1-2.7-.722L11.27,33.259a2,2,0,0,0-1.692-.977l-2.645-.035a2,2,0,0,1-1.973-1.973l-.035-2.645a2,2,0,0,0-.977-1.692L1.674,24.584a2,2,0,0,1-.722-2.7L2.244,19.58a2,2,0,0,0,0-1.954L.951,15.318a2,2,0,0,1,.722-2.7l2.273-1.353a2,2,0,0,0,.977-1.692l.035-2.645A2,2,0,0,1,6.932,4.959l2.645-.035a2,2,0,0,0,1.692-.977l1.353-2.273a2,2,0,0,1,2.7-.722l2.309,1.292a2,2,0,0,0,1.954,0Z", transform: "matrix(0.966, 0.259, -0.259, 0.966, 16.269, 6.216)", fill: "#3550a0" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2621", "data-name": "Path 2621", d: "M-8.407-13.727V-27.841h4.194v14.114Zm8.243,0V-27.841H4.031v14.114Z", transform: "translate(31.611 49.652)", fill: "#f5f2fd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2621_-_Outline", "data-name": "Path 2621 - Outline", d: "M4.331-13.427H-.464V-28.141H4.331Zm-4.194-.6H3.731V-27.541H.136Zm-4.049.6H-8.707V-28.141h4.794Zm-4.194-.6h3.594V-27.541H-8.107Z", transform: "translate(31.611 49.652)", fill: "#3550a0" }))), Pnt = W.figure.attrs(() => ({
  className: "msd__subscription-card__icon"
}))`
  display: flex;
  justify-content: center;
  position: relative;
  padding: 10px;
  margin-inline-end: 10px;
  border-radius: 8px;
  flex: 0 0 40px;

  max-width: 50px;

  font-size: 16px;
  font-weight: ${Nd};
  text-align: center;

  background-color: ${(e) => e.$bg};
  color: ${(e) => e.$color};
  border: 1px solid ${(e) => e.$border};

  svg {
    path:first-of-type,
    path:last-of-type {
      fill: ${An};
    }
  }

  ${Zr.small`
    flex: 0 0 50px;
    margin-inline-end: 15px;
    padding: 14px 10px;
    
    font-size: 20px;
  `}
`, Nnt = W.span`
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  top: 0;
  left: 50%;
  height: 18px;
  width: 48px;

  background: ${(e) => e.$label === "New" ? An : Et};
  border-radius: 10px;

  color: ${cu};
  font-size: 9px;
  font-weight: 600;

  transform: translate(-50%, -10px);
`, th = ({ period: e, showLabel: t, className: n, isPaused: r }) => {
  const { color: a, bg: o, label: s, border: c } = wc[e] || wc.default;
  return /* @__PURE__ */ C.jsx(C.Fragment, { children: /* @__PURE__ */ C.jsxs(
    Pnt,
    {
      $color: a || null,
      $bg: o || null,
      $border: c || null,
      className: n,
      children: [
        t && /* @__PURE__ */ C.jsx(Nnt, { $label: t, children: t }),
        r ? /* @__PURE__ */ C.jsx(Ant, {}) : s || ""
      ]
    }
  ) });
};
th.propTypes = {
  period: de.string,
  showLabel: de.string,
  className: de.string,
  isPaused: de.bool
};
th.defaultProps = {
  period: "default",
  showLabel: "",
  className: "",
  isPaused: !1
};
const Tnt = W.div`
  padding: 50px 30px 86px 30px;
`, Ont = W.div.attrs(() => ({
  className: "msd__checkout-card"
}))`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 400px;

  margin: auto;
  padding: 40px 30px;

  border: 1px solid ${Gn};
  border-radius: 12px;
  background: ${Br};

  text-align: center;
  color: ${Et};
`, Rnt = W.h1.attrs(() => ({
  className: "msd__checkout-card__title"
}))`
  margin: 20px 0 15px 0;

  font-weight: ${Nd};
  font-size: ${UR};
  line-height: 1.2em;
`, Mnt = W.p.attrs(() => ({
  className: "msd__checkout-card__description"
}))`
  color: ${Et};
  font-size: ${n8};
  font-weight: ${Nd};
  margin: 0 0 30px 0;
`, Dnt = W.p.attrs(() => ({
  className: "msd__checkout-card__description"
}))`
  color: ${Et};
  font-size: ${A2};
  font-weight: ${Nd};
  margin-bottom: 32px;
`, Lnt = W.p.attrs(() => ({
  className: "msd__checkout-card__subtext"
}))`
  margin: 20px 0 0 0;

  font-size: ${A2};
  color: ${u2};
`, $nt = W(th).attrs(() => ({
  className: "msd__checkout-card__icon"
}))`
  flex: 0 0 75px;
  min-width: 75px;

  margin: 0;
  padding: 23px 15px;

  font-size: ${UR};
`, jnt = W.div`
  max-width: 200px;
`, Fnt = W.div.attrs(() => ({
  className: "msd__checkout-card__message--error"
}))`
  margin-top: 10px;
  color: ${wa};
  font-size: 12px;
  line-height: 1.3em;
`, Bnt = ({
  expiresAt: e,
  offerType: t,
  period: n,
  startTime: r,
  t: a
}) => {
  switch (t) {
    case "S":
      return a("free-offer.subscription", "Free subscription");
    case "P":
      return n ? `${a(
        `period.${n}`,
        wc[n].accessText
      )} ${a("free-offer.free-pass", "free pass")}` : a("free-offer.pass", "Access until {{date}}", {
        date: Ko(e, !0)
      });
    case "E":
      return a("free-offer.event", "Free event {{date}}", {
        date: r ? Ko(r, !0) : ""
      });
    case "R":
      return `${a(
        `period.${n}`,
        wc[n].accessText
      )} ${a("free-offer.free-access", "free access")}`;
    case "A":
      return a("free-offer.unlimited-access", "Unlimited access");
    default:
      return "";
  }
}, Vnt = ({ onPaymentComplete: e }) => {
  const { loading: t, error: n } = Ot(q2e), {
    period: r,
    expiresAt: a,
    startTime: o,
    offerTitle: s,
    offerId: c,
    offerDescription: u
  } = Ot(A_), f = Va(), { t: m } = tn(), v = c == null ? void 0 : c.charAt(0), y = r || v, b = Bnt({
    expiresAt: a,
    offerType: v,
    period: r,
    startTime: o,
    t: m
  }), S = Yi(() => {
    f(j4()).unwrap().then(e);
  }, []);
  return /* @__PURE__ */ C.jsx(Tnt, { children: /* @__PURE__ */ C.jsxs(Ont, { children: [
    /* @__PURE__ */ C.jsx($nt, { icon: y }),
    /* @__PURE__ */ C.jsx(Rnt, { children: m(`offer-title-${c}`, s) }),
    b && /* @__PURE__ */ C.jsx(Mnt, { children: b }),
    u && /* @__PURE__ */ C.jsx(Dnt, { children: m("free-offer.publisher-description", u) }),
    /* @__PURE__ */ C.jsxs(jnt, { children: [
      /* @__PURE__ */ C.jsx(
        zt,
        {
          theme: "confirm",
          width: "200px",
          onClickFn: S,
          disabled: t,
          children: /* @__PURE__ */ C.jsx(C.Fragment, { children: t ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : m("free-offer.get-access", "Get Access") })
        }
      ),
      n && /* @__PURE__ */ C.jsx(Fnt, { children: m(n.translationKey, n.message) })
    ] }),
    /* @__PURE__ */ C.jsx(Lnt, { children: m("free-offer.no-cost", "Free, no additional cost") })
  ] }) });
}, Unt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ width: 30, height: 24, viewBox: "0 0 30 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), /* @__PURE__ */ k.createElement("path", { opacity: 0.75, d: "M27 1.67801e-05H3.00002C2.60646 -0.00105258 2.21659 0.0759249 1.85297 0.226496C1.48935 0.377068 1.15919 0.598244 0.881602 0.877231C0.60401 1.15622 0.384491 1.48748 0.235744 1.85185C0.086997 2.21622 0.0119748 2.60647 0.0150169 3.00002L1.67801e-05 21C-0.00130429 21.3944 0.0753912 21.7851 0.225687 22.1496C0.375984 22.5142 0.596911 22.8454 0.875751 23.1243C1.15459 23.4031 1.48583 23.6241 1.85041 23.7743C2.21498 23.9246 2.60568 24.0013 3.00002 24H27C27.3944 24.0013 27.7851 23.9246 28.1496 23.7743C28.5142 23.6241 28.8454 23.4031 29.1243 23.1243C29.4031 22.8454 29.6241 22.5142 29.7743 22.1496C29.9246 21.7851 30.0013 21.3944 30 21V3.00002C30.0013 2.60568 29.9246 2.21498 29.7743 1.85041C29.6241 1.48583 29.4031 1.15459 29.1243 0.875751C28.8454 0.596911 28.5142 0.375984 28.1496 0.225688C27.7851 0.0753914 27.3944 -0.00130429 27 1.67801e-05ZM27 21H3.00002V12H27V21ZM27 6.00002H3.00002V3.00002H27V6.00002Z", fill: "#BCC3CD" })), Gnt = W.div.attrs(() => ({
  className: "msd__account-input__wrapper"
}))`
  position: relative;
  margin-bottom: 12px;

  ${(e) => e.$hideInput && ot`
      display: none;
    `};

  ${(e) => e.$width && ot`
      width: ${e.$width};
    `};

  .msd__error {
    color: ${wa};
  }

  input[type='date'] {
    text-transform: uppercase;

    &::-webkit-calendar-picker-indicator {
      font-size: 20px;
      opacity: 0.7;
    }
  }
`, znt = W.label.attrs(() => ({
  className: "msd__account-input__label"
}))`
  display: block;
  margin-bottom: 12px;
  color: ${Et};
  font-size: 13px;
`, Hnt = W.input.attrs(() => ({
  className: "msd__account-input"
}))`
  width: 100%;
  padding: 10px 16px;

  border: 1px solid ${Gn};
  border-radius: 4px;
  font-size: 13px;
  line-height: 13px;

  ${h1() && ot`
    text-align: right;
  `}

  &:focus,
  &:active {
    border: 1px solid ${Gn};
  }

  &:disabled {
    background-color: ${Br};
    color: ${Et};
  }

  ${(e) => e.$error && ot`
      border: 1px solid ${wa};
    `}
`;
class du extends Nc {
  constructor(t) {
    super(t), this.state = {};
  }
  render() {
    const {
      id: t,
      placeholder: n,
      type: r,
      min: a,
      value: o,
      label: s,
      onChange: c,
      onSubmit: u,
      disabled: f,
      hideInput: m,
      error: v,
      onBlur: y,
      name: b,
      autoComplete: S,
      required: x,
      width: E
    } = this.props;
    return /* @__PURE__ */ C.jsxs(Gnt, { $hideInput: m, $width: E, children: [
      /* @__PURE__ */ C.jsxs(znt, { htmlFor: t, children: [
        s,
        x && " *"
      ] }),
      /* @__PURE__ */ C.jsx(
        Hnt,
        {
          $error: v,
          id: t,
          placeholder: n,
          type: r,
          min: a,
          value: o,
          disabled: f,
          onSubmit: u,
          onChange: c,
          onBlur: y,
          name: b,
          autoComplete: S
        }
      ),
      /* @__PURE__ */ C.jsx(aee, { id: `${t}-desc`, children: v })
    ] });
  }
}
du.propTypes = {
  id: de.string,
  placeholder: de.string,
  type: de.string,
  value: de.string,
  min: de.string,
  label: de.string,
  onChange: de.func,
  onSubmit: de.func,
  disabled: de.bool,
  hideInput: de.bool,
  error: de.string,
  onBlur: de.func,
  name: de.string,
  autoComplete: de.string,
  required: de.bool,
  width: de.string
};
du.defaultProps = {
  id: "",
  placeholder: "",
  type: "text",
  value: "",
  min: "",
  label: "",
  onChange: () => null,
  onSubmit: () => null,
  onBlur: () => null,
  disabled: !1,
  hideInput: !1,
  error: "",
  name: "",
  autoComplete: "",
  required: !1,
  width: ""
};
const gle = vo.createContext({}), yle = !0;
function Wnt({ baseColor: e, highlightColor: t, width: n, height: r, borderRadius: a, circle: o, direction: s, duration: c, enableAnimation: u = yle }) {
  const f = {};
  return s === "rtl" && (f["--animation-direction"] = "reverse"), typeof c == "number" && (f["--animation-duration"] = `${c}s`), u || (f["--pseudo-element-display"] = "none"), (typeof n == "string" || typeof n == "number") && (f.width = n), (typeof r == "string" || typeof r == "number") && (f.height = r), (typeof a == "string" || typeof a == "number") && (f.borderRadius = a), o && (f.borderRadius = "50%"), typeof e != "undefined" && (f["--base-color"] = e), typeof t != "undefined" && (f["--highlight-color"] = t), f;
}
function Znt(u) {
  var f = u, { count: e = 1, wrapper: t, className: n, containerClassName: r, containerTestId: a, circle: o = !1, style: s } = f, c = u0(f, ["count", "wrapper", "className", "containerClassName", "containerTestId", "circle", "style"]);
  var m, v, y;
  const b = vo.useContext(gle), S = Fe({}, c);
  for (const [$, B] of Object.entries(c))
    typeof B == "undefined" && delete S[$];
  const x = Xn(Fe(Fe({}, b), S), {
    circle: o
  }), E = Fe(Fe({}, s), Wnt(x));
  let N = "react-loading-skeleton";
  n && (N += ` ${n}`);
  const R = (m = x.inline) !== null && m !== void 0 ? m : !1, O = [], D = Math.ceil(e);
  for (let $ = 0; $ < D; $++) {
    let B = E;
    if (D > e && $ === D - 1) {
      const Z = (v = B.width) !== null && v !== void 0 ? v : "100%", K = e % 1, q = typeof Z == "number" ? Z * K : `calc(${Z} * ${K})`;
      B = Xn(Fe({}, B), { width: q });
    }
    const G = vo.createElement("span", { className: N, style: B, key: $ }, "‌");
    R ? O.push(G) : O.push(vo.createElement(
      vo.Fragment,
      { key: $ },
      G,
      vo.createElement("br", null)
    ));
  }
  return vo.createElement("span", { className: r, "data-testid": a, "aria-live": "polite", "aria-busy": (y = x.enableAnimation) !== null && y !== void 0 ? y : yle }, t ? O.map(($, B) => vo.createElement(t, { key: B }, $)) : O);
}
function Ynt(n) {
  var r = n, { children: e } = r, t = u0(r, ["children"]);
  return vo.createElement(gle.Provider, { value: t }, e);
}
const Xnt = W.div.attrs(
  () => ({
    className: "msd__skeleton"
  })
)`
  width: 100%;
  max-width: 100%;
  margin: 0 0 10px;
  overflow: hidden;
  text-align: center;

  ${(e) => e.$width && ot`
      width: ${e.$width}px;
    `}

  ${(e) => e.$margin && ot`
      margin: ${e.$margin};
    `}

  ${(e) => e.$align && ot`
      text-align: ${e.$align};
    `}
`, Knt = W(Znt)`
  border-radius: 16px !important;

  ${(e) => e.circle && ot`
      border-radius: 50% !important;
    `}
`, Zn = (o) => {
  var s = o, {
    showChildren: e = !1,
    children: t = null,
    margin: n = "",
    width: r = null
  } = s, a = u0(s, [
    "showChildren",
    "children",
    "margin",
    "width"
  ]);
  return e ? /* @__PURE__ */ C.jsx(C.Fragment, { children: t }) : /* @__PURE__ */ C.jsx(Xnt, { $width: r, $margin: n, children: /* @__PURE__ */ C.jsx(Ynt, { baseColor: h3e, children: /* @__PURE__ */ C.jsx(Knt, Fe({}, a)) }) });
}, qnt = (e) => new Date(e * 1e3).toISOString().split("T")[0], Jnt = (e) => new Date(e * 1e3).toISOString().split("T")[1].substring(0, 5), Qnt = W.form.attrs(() => ({
  className: "msd__recipientForm"
}))`
  display: flex;
  flex-direction: column;
  max-width: 376px;
  background-color: white;
  border: 1px solid ${Gn};
  border-radius: 12px;
  width: 100%;
  max-width: 376px;
  align-self: center;
  margin-top: 18px;
  padding: 24px 16px;

  .msd__account-input__wrapper {
    margin-bottom: 2px;

    .msd__account-input__label {
      margin-bottom: 5px;
    }

    .msd__account-input {
      font-family: inherit;
      font-size: 16px;
      padding: 5px 8px;
      height: 40px;

      &[value=''] {
        color: rgb(112, 112, 112);
        font-weight: 300;
      }
    }

    .msd__error {
      color: #cb4477;
    }
  }
`, ert = W.p`
  font-size: 13px;
  font-weight: 300;
  font-style: italic;
  color: ${Et};

  opacity: 0.7;
  margin-top: 12px;
`, trt = W.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`, nrt = W.label`
  color: ${Et};
  font-size: 13px;
`, rrt = W.textarea`
  width: 100%;
  padding: 10px 8px;
  min-height: 92px;
  border: 1px solid ${Gn};
  border-radius: 4px;
  font-family: inherit;
  font-size: 16px;
  line-height: 20px;
  resize: none;

  ${h1() && ot`
    text-align: right;
  `}

  &:focus,
  &:active {
    border: 1px solid ${Gn};
  }

  &:disabled {
    background-color: ${Br};
    color: ${Et};
  }

  &::placeholder {
    color: rgb(112, 112, 112);
    font-weight: 300;
  }
`, art = W.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`, eR = ({ isMyAccount: e = !1 }) => {
  const {
    recipientEmail: t,
    confirmRecipientEmail: n,
    deliveryDate: r,
    deliveryTime: a,
    message: o
  } = Ot(I2), {
    loading: s,
    gift: { deliveryDetails: c, redeemedAt: u, sentAt: f }
  } = Ot(q6), { isOpen: m, currentType: v } = Ot(N_), y = Va(), { t: b } = tn(), S = (D) => {
    const {
      target: { name: $, value: B }
    } = D;
    switch ($) {
      case "recipientEmail":
        ule(B), n.value && QO(n.value);
        break;
      case "confirmRecipientEmail":
        QO(B);
        break;
      case "deliveryDate":
        fle(B, a.value);
        break;
      case "deliveryTime":
        Vtt(B, r.value);
        break;
    }
  }, x = (D) => {
    if (O)
      return;
    const {
      target: { name: $, value: B }
    } = D;
    y(ly({ name: $, value: B })), $ === "deliveryDate" && !a.value && y(ly({ name: "deliveryTime", value: "00:00" }));
  };
  mn(() => {
    e && c && (y(
      ly({
        name: "recipientEmail",
        value: c == null ? void 0 : c.recipientEmail
      })
    ), y(
      ly({
        name: "deliveryDate",
        value: qnt(c == null ? void 0 : c.deliveryDate)
      })
    ), y(
      ly({
        name: "deliveryTime",
        value: Jnt(c == null ? void 0 : c.deliveryDate)
      })
    ), y(
      ly({
        name: "message",
        value: c == null ? void 0 : c.personalNote
      })
    ));
  }, [c]);
  const E = dle(new Date((c == null ? void 0 : c.deliveryDate) * 1e3)) && !f && !u, N = e && !E, R = m && v === su.EDIT_DELIVERY_DETAILS_POPUP, O = !e && R;
  return /* @__PURE__ */ C.jsx(Qnt, { noValidate: !0, children: s ? /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(Zn, { width: 100, margin: "0 0 12px 0" }),
      /* @__PURE__ */ C.jsx(Zn, { height: 40, margin: "0 0 28px 0" })
    ] }),
    /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(Zn, { width: 100, margin: "0 0 12px 0" }),
      /* @__PURE__ */ C.jsx(Zn, { height: 40, margin: "0 0 28px 0" })
    ] }),
    /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(Zn, { width: 100, margin: "0 0 12px 0" }),
      /* @__PURE__ */ C.jsx(Zn, { height: 92, margin: "0 0 28px 0" })
    ] })
  ] }) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsx(
      du,
      {
        disabled: N,
        error: b(t.translationKey, t.error),
        label: b("recipientForm.label.recipient-email", "Recipient email"),
        name: "recipientEmail",
        onBlur: S,
        onChange: x,
        placeholder: b(
          "recipientForm.label.recipient-email",
          "jdoe@cleeng.com"
        ),
        type: "email",
        value: O ? "" : t.value
      }
    ),
    !N && /* @__PURE__ */ C.jsx(
      du,
      {
        error: b(
          n.translationKey,
          n.error
        ),
        label: b(
          "recipientForm.label.confirm-recipient-email",
          "Confirm recipient email"
        ),
        name: "confirmRecipientEmail",
        onBlur: S,
        onChange: x,
        placeholder: b(
          "recipientForm.label.confirm-recipient-email",
          "jdoe@cleeng.com"
        ),
        type: "email",
        value: O ? "" : n.value
      }
    ),
    /* @__PURE__ */ C.jsxs(art, { children: [
      /* @__PURE__ */ C.jsx(
        du,
        {
          disabled: N,
          error: b(r.translationKey, r.error),
          label: b("recipientForm.label.delivery-date", "Delivery date"),
          min: (/* @__PURE__ */ new Date()).toISOString().split("T")[0],
          name: "deliveryDate",
          onBlur: S,
          onChange: x,
          type: "date",
          value: O ? "" : r.value,
          width: "50%"
        }
      ),
      /* @__PURE__ */ C.jsx(
        du,
        {
          disabled: N,
          error: b(a.translationKey, a.error),
          label: b("recipientForm.label.delivery-time", "Delivery time"),
          name: "deliveryTime",
          onBlur: S,
          onChange: x,
          type: "time",
          value: O ? "" : a.value,
          width: "50%"
        }
      )
    ] }),
    /* @__PURE__ */ C.jsxs(trt, { children: [
      /* @__PURE__ */ C.jsx(nrt, { children: N ? /* @__PURE__ */ C.jsx(C.Fragment, { children: b("recipientForm.label.message", "Message") }) : /* @__PURE__ */ C.jsx(C.Fragment, { children: b("recipientForm.label.add-message", "Add a message") }) }),
      /* @__PURE__ */ C.jsx(
        rrt,
        {
          disabled: N,
          maxLength: 150,
          name: "message",
          onChange: x,
          placeholder: N ? "" : b(
            "recipientForm.placeholder.message",
            "I’d give you the gift of never having to leave the house again! Enjoy your new subscription plan. Happy streaming!"
          ),
          rows: 3,
          value: O ? "" : o.value
        }
      )
    ] }),
    !e && /* @__PURE__ */ C.jsx(ert, { children: b(
      "recipientForm.info-text",
      "To edit your gift delivery details, access MyAccount and click on the corresponding transaction."
    ) })
  ] }) });
}, ort = W.section.attrs(() => ({
  className: "msd__deliveryDetails"
}))`
  display: flex;
  flex-direction: column;
`, irt = W.div`
  display: flex;
  justify-content: center;
  gap: 24px;
`, mq = W.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 176px;
  height: 96px;
  border-radius: 12px;
  border: 1px solid;
  border-color: ${(e) => e.$isActive ? An : Gn};
  color: ${(e) => e.$isActive ? An : "#CCD5E2"};
  background-color: white;
  font-size: 12px;
  font-weight: 400;

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    opacity: 50%;
  }

  svg {
    overflow: visible;

    path {
      fill: ${(e) => e.$isActive ? An : "#CCD5E2"};
    }
  }
`, srt = ({ giftable: e }) => {
  const t = Va(), { t: n } = tn(), { isGift: r } = Ot(I2), { id: a } = Ot(Bm), o = () => {
    t(Gk(!0)), t(
      xd({
        id: a,
        payload: {
          buyAsAGift: !0
        }
      })
    ).unwrap().catch((u) => {
      throw new Error(u);
    });
  }, s = () => {
    t(Gk(!1)), t(
      xd({
        id: a,
        payload: {
          buyAsAGift: !1
        }
      })
    ).unwrap().catch((u) => {
      throw new Error(u);
    });
  }, {
    offer: { accessGranted: c }
  } = Ot(k2);
  return mn(() => {
    const f = new URLSearchParams(window.location.search).get("purchaseAsGift");
    return c || f === "true" ? t(Gk(!0)) : s(), () => {
      t(zQ());
    };
  }, [c, window.location.search]), /* @__PURE__ */ C.jsxs(ort, { children: [
    /* @__PURE__ */ C.jsx(Xi, { marginTop: "25px", center: !0, children: /* @__PURE__ */ C.jsx(C.Fragment, { children: n("deliverydetails.title", "Delivery details") }) }),
    /* @__PURE__ */ C.jsxs(irt, { children: [
      /* @__PURE__ */ C.jsxs(
        mq,
        {
          $isActive: !r,
          onClick: s,
          disabled: c,
          children: [
            /* @__PURE__ */ C.jsx(Unt, {}),
            /* @__PURE__ */ C.jsx(C.Fragment, { children: n(
              "deliverydetails.button.purchase-for-myself",
              "Purchase for myself"
            ) })
          ]
        }
      ),
      /* @__PURE__ */ C.jsxs(
        mq,
        {
          $isActive: r,
          onClick: o,
          disabled: !e,
          children: [
            /* @__PURE__ */ C.jsx(tle, {}),
            n("deliverydetails.button.purchase-as-gift", "Purchase as a gift")
          ]
        }
      )
    ] }),
    /* @__PURE__ */ C.jsx(C.Fragment, { children: r && /* @__PURE__ */ C.jsx(eR, {}) })
  ] });
}, v6 = W.div`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  position: relative;
  width: 100%;
  background: ${Br};
`, lrt = W.div`
  margin: 16px 0;
`, urt = W.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 12px;
`, crt = W.section.attrs(() => ({
  className: "msd__checkout-wrapper"
}))`
  padding: 25px 35px;
  border-bottom: 1px solid ${Gn};

  ${pr.small`
    padding: 0 10px;
  `};
`, drt = W.article.attrs(() => ({
  className: "msd__offer-card"
}))`
  width: 100%;
  background: ${Br};
  border: 1px solid ${Gn};
  border-radius: 12px;

  padding: 20px;
`, ble = (e, t, n) => {
  if (t === 0) return e.toFixed(2);
  const r = e + t * e;
  return n === Number(r.toFixed(2)) ? r.toFixed(2) : (Math.trunc(Math.ceil(r * 100)) / 100).toFixed(2);
}, vq = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), /* @__PURE__ */ k.createElement("path", { d: "M12.5489 2.14398H1.44892C1.14268 2.14451 0.849159 2.26654 0.632799 2.48327C0.416439 2.70001 0.294921 2.99374 0.294922 3.29998V10.7C0.294922 11.0066 0.416715 11.3006 0.633507 11.5174C0.850299 11.7342 1.14433 11.856 1.45092 11.856H12.5509C12.8575 11.856 13.1515 11.7342 13.3683 11.5174C13.5851 11.3006 13.7069 11.0066 13.7069 10.7V3.29998C13.7069 3.14801 13.677 2.99752 13.6187 2.85714C13.5605 2.71675 13.4752 2.58923 13.3676 2.48186C13.2601 2.37449 13.1324 2.28938 12.9919 2.23141C12.8514 2.17343 12.7009 2.14372 12.5489 2.14398ZM12.3179 3.53098V4.68698H1.68192V3.53098H12.3179ZM1.68192 10.467V6.07498H12.3179V10.468L1.68192 10.467ZM11.6239 9.07998C11.6239 9.26404 11.5508 9.44056 11.4207 9.57071C11.2905 9.70087 11.114 9.77398 10.9299 9.77398H9.07992C8.98663 9.77753 8.89359 9.76221 8.80636 9.72896C8.71913 9.6957 8.6395 9.64519 8.57225 9.58044C8.505 9.5157 8.4515 9.43805 8.41496 9.35214C8.37842 9.26623 8.35958 9.17384 8.35958 9.08048C8.35958 8.98713 8.37842 8.89473 8.41496 8.80883C8.4515 8.72292 8.505 8.64527 8.57225 8.58053C8.6395 8.51578 8.71913 8.46527 8.80636 8.43201C8.89359 8.39876 8.98663 8.38344 9.07992 8.38698H10.9299C11.1138 8.38698 11.2902 8.45997 11.4203 8.5899C11.5504 8.71983 11.6237 8.8961 11.6239 9.07998ZM7.69292 9.07998C7.69292 9.26404 7.6198 9.44056 7.48965 9.57071C7.3595 9.70087 7.18298 9.77398 6.99892 9.77398H6.30492C6.21163 9.77753 6.11859 9.76221 6.03136 9.72896C5.94413 9.6957 5.86451 9.64519 5.79725 9.58044C5.73 9.5157 5.6765 9.43805 5.63996 9.35214C5.60342 9.26623 5.58458 9.17384 5.58458 9.08048C5.58458 8.98713 5.60342 8.89473 5.63996 8.80883C5.6765 8.72292 5.73 8.64527 5.79725 8.58053C5.86451 8.51578 5.94413 8.46527 6.03136 8.43201C6.11859 8.39876 6.21163 8.38344 6.30492 8.38698H6.99892C7.09014 8.38672 7.18052 8.40445 7.26489 8.43914C7.34925 8.47384 7.42595 8.52483 7.49059 8.58919C7.55524 8.65355 7.60656 8.73003 7.64162 8.81425C7.67668 8.89846 7.69479 8.98876 7.69492 9.07998H7.69292Z", fill: "#727583" })), frt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), /* @__PURE__ */ k.createElement("g", { clipPath: "url(#clip0_3514_8)" }, /* @__PURE__ */ k.createElement("path", { d: "M7.75863 1.51398C6.52388 1.51398 5.31686 1.88012 4.2902 2.56611C3.26355 3.2521 2.46337 4.22712 1.99085 5.36788C1.51833 6.50864 1.3947 7.7639 1.63559 8.97493C1.87647 10.1859 2.47106 11.2983 3.34416 12.1714C4.21726 13.0445 5.32966 13.6391 6.54068 13.88C7.7517 14.1209 9.00696 13.9973 10.1477 13.5248C11.2885 13.0522 12.2635 12.2521 12.9495 11.2254C13.6355 10.1987 14.0016 8.99173 14.0016 7.75698C14.0016 6.10123 13.3439 4.5133 12.1731 3.34251C11.0023 2.17172 9.41437 1.51398 7.75863 1.51398ZM7.75863 12.614C6.79857 12.6136 5.86018 12.3286 5.06209 11.7949C4.26399 11.2613 3.64203 10.503 3.27481 9.61598C2.90759 8.72893 2.81162 7.75291 2.99901 6.81132C3.18641 5.86973 3.64876 5.00484 4.32762 4.32597C5.00649 3.64711 5.87138 3.18476 6.81297 2.99736C7.75457 2.80997 8.73058 2.90594 9.61763 3.27316C10.5047 3.64037 11.263 4.26234 11.7966 5.06044C12.3302 5.85853 12.6152 6.79692 12.6156 7.75698C12.6159 8.39488 12.4904 9.02659 12.2464 9.61598C12.0025 10.2054 11.6447 10.7409 11.1936 11.192C10.7426 11.643 10.207 12.0008 9.61763 12.2448C9.02824 12.4888 8.39653 12.6142 7.75863 12.614ZM11.6896 7.75898C11.6896 7.94304 11.6165 8.11956 11.4864 8.24971C11.3562 8.37986 11.1797 8.45298 10.9956 8.45298H7.75863C7.57457 8.45298 7.39805 8.37986 7.2679 8.24971C7.13775 8.11956 7.06463 7.94304 7.06463 7.75898V4.51998C7.07144 4.34061 7.14749 4.17085 7.2768 4.04636C7.40611 3.92186 7.57863 3.85232 7.75813 3.85232C7.93763 3.85232 8.11015 3.92186 8.23946 4.04636C8.36877 4.17085 8.44482 4.34061 8.45163 4.51998V7.06298H10.9956C11.1795 7.06324 11.3558 7.13648 11.4857 7.2666C11.6156 7.39672 11.6886 7.57309 11.6886 7.75698L11.6896 7.75898Z", fill: "#727583" })), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", { id: "clip0_3514_8" }, /* @__PURE__ */ k.createElement("rect", { width: 14, height: 14, fill: "white", transform: "translate(0.757812 0.756958)" })))), gN = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), /* @__PURE__ */ k.createElement("g", { clipPath: "url(#clip0_3519_4)" }, /* @__PURE__ */ k.createElement("path", { d: "M12.6 1.03722H11.1953V0.778184C11.1995 0.673618 11.1809 0.569338 11.1406 0.471581C11.1003 0.373825 11.0391 0.284599 10.9607 0.20924C10.8823 0.133881 10.7883 0.073938 10.6843 0.0329942C10.5803 -0.00794965 10.4684 -0.0290527 10.3554 -0.0290527C10.2424 -0.0290527 10.1306 -0.00794965 10.0266 0.0329942C9.92257 0.073938 9.82855 0.133881 9.75015 0.20924C9.67174 0.284599 9.61055 0.373825 9.57025 0.471581C9.52994 0.569338 9.51134 0.673618 9.51555 0.778184V1.03722H4.47977V0.778184C4.48398 0.673618 4.46538 0.569338 4.42507 0.471581C4.38476 0.373825 4.32358 0.284599 4.24517 0.20924C4.16676 0.133881 4.07275 0.073938 3.96875 0.0329942C3.86475 -0.00794965 3.7529 -0.0290527 3.63988 -0.0290527C3.52687 -0.0290527 3.41502 -0.00794965 3.31102 0.0329942C3.20702 0.073938 3.113 0.133881 3.0346 0.20924C2.95619 0.284599 2.895 0.373825 2.85469 0.471581C2.81439 0.569338 2.79578 0.673618 2.8 0.778184V1.03722H1.40468C1.03214 1.03722 0.67485 1.17425 0.411421 1.41816C0.147992 1.66207 0 1.99289 0 2.33783V12.708C0 13.053 0.147992 13.3838 0.411421 13.6277C0.67485 13.8716 1.03214 14.0087 1.40468 14.0087H12.6047C12.9772 14.0087 13.3345 13.8716 13.5979 13.6277C13.8614 13.3838 14.0094 13.053 14.0094 12.708V2.3335C14.0087 2.1627 13.9718 1.99368 13.9006 1.8361C13.8295 1.67852 13.7255 1.53546 13.5946 1.41509C13.4638 1.29472 13.3086 1.1994 13.1379 1.13456C12.9672 1.06973 12.7845 1.03665 12.6 1.03722ZM2.8 2.59254C2.80812 2.79376 2.90015 2.98424 3.05677 3.12394C3.2134 3.26365 3.42241 3.3417 3.63988 3.3417C3.85736 3.3417 4.06637 3.26365 4.22299 3.12394C4.37961 2.98424 4.47165 2.79376 4.47977 2.59254H9.52023C9.51602 2.6971 9.53462 2.80138 9.57493 2.89914C9.61524 2.9969 9.67642 3.08612 9.75483 3.16148C9.83324 3.23684 9.92725 3.29678 10.0313 3.33773C10.1353 3.37867 10.2471 3.39977 10.3601 3.39977C10.4731 3.39977 10.585 3.37867 10.689 3.33773C10.793 3.29678 10.887 3.23684 10.9654 3.16148C11.0438 3.08612 11.105 2.9969 11.1453 2.89914C11.1856 2.80138 11.2042 2.6971 11.2 2.59254H12.3202V4.14785H1.67977V2.59254H2.8ZM1.67977 12.4447V5.70425H12.3202V12.4447H1.67977Z", fill: "#727583" }), /* @__PURE__ */ k.createElement("path", { d: "M4.63027 8.28357C4.78262 8.14251 4.86821 7.95119 4.86821 7.7517H4.87055C4.8704 7.65283 4.8492 7.55495 4.80816 7.46368C4.76711 7.3724 4.70704 7.28951 4.63137 7.21975C4.5557 7.14999 4.46592 7.09473 4.36717 7.05712C4.26841 7.01952 4.16262 7.00031 4.05584 7.00059H3.59101C3.48181 6.99675 3.3729 7.01335 3.27079 7.0494C3.16868 7.08544 3.07547 7.14019 2.99675 7.21036C2.91803 7.28054 2.8554 7.3647 2.81263 7.45781C2.76985 7.55091 2.74781 7.65106 2.74781 7.75224C2.74781 7.85342 2.76985 7.95356 2.81263 8.04667C2.8554 8.13978 2.91803 8.22394 2.99675 8.29411C3.07547 8.36429 3.16868 8.41904 3.27079 8.45508C3.3729 8.49112 3.48181 8.50772 3.59101 8.50388H4.05584C4.27129 8.50388 4.47792 8.42463 4.63027 8.28357Z", fill: "#727583" }), /* @__PURE__ */ k.createElement("path", { d: "M4.63027 10.5079C4.78262 10.3668 4.86821 10.1755 4.86821 9.97601H4.87055C4.8704 9.87714 4.8492 9.77926 4.80816 9.68799C4.76711 9.59671 4.70704 9.51382 4.63137 9.44406C4.5557 9.3743 4.46592 9.31904 4.36717 9.28144C4.26841 9.24383 4.16262 9.22462 4.05584 9.2249H3.59101C3.48181 9.22106 3.3729 9.23766 3.27079 9.27371C3.16868 9.30975 3.07547 9.3645 2.99675 9.43467C2.91803 9.50485 2.8554 9.58901 2.81263 9.68212C2.76985 9.77523 2.74781 9.87537 2.74781 9.97655C2.74781 10.0777 2.76985 10.1779 2.81263 10.271C2.8554 10.3641 2.91803 10.4483 2.99675 10.5184C3.07547 10.5886 3.16868 10.6433 3.27079 10.6794C3.3729 10.7154 3.48181 10.732 3.59101 10.7282H4.05584C4.27129 10.7282 4.47792 10.6489 4.63027 10.5079Z", fill: "#727583" }), /* @__PURE__ */ k.createElement("path", { d: "M7.81976 8.28357C7.97211 8.14251 8.0577 7.95119 8.0577 7.7517H8.06004C8.05988 7.65283 8.03868 7.55495 7.99764 7.46368C7.9566 7.3724 7.89653 7.28951 7.82086 7.21975C7.74519 7.14999 7.65541 7.09473 7.55665 7.05712C7.4579 7.01952 7.3521 7.00031 7.24532 7.00059H6.7805C6.6713 6.99675 6.56238 7.01335 6.46028 7.0494C6.35817 7.08544 6.26496 7.14019 6.18624 7.21036C6.10751 7.28054 6.04489 7.3647 6.00211 7.45781C5.95934 7.55091 5.93729 7.65106 5.93729 7.75224C5.93729 7.85342 5.95934 7.95356 6.00211 8.04667C6.04489 8.13978 6.10751 8.22394 6.18624 8.29411C6.26496 8.36429 6.35817 8.41904 6.46028 8.45508C6.56238 8.49112 6.6713 8.50772 6.7805 8.50388H7.24532C7.46078 8.50388 7.66741 8.42463 7.81976 8.28357Z", fill: "#727583" }), /* @__PURE__ */ k.createElement("path", { d: "M7.81962 10.5079C7.97196 10.3668 8.05755 10.1755 8.05755 9.97601H8.05989C8.05974 9.87714 8.03854 9.77926 7.9975 9.68799C7.95646 9.59671 7.89638 9.51382 7.82071 9.44406C7.74504 9.3743 7.65526 9.31904 7.55651 9.28144C7.45775 9.24383 7.35196 9.22462 7.24518 9.2249H6.78036C6.67116 9.22106 6.56224 9.23766 6.46013 9.27371C6.35802 9.30975 6.26482 9.3645 6.18609 9.43467C6.10737 9.50485 6.04475 9.58901 6.00197 9.68212C5.9592 9.77523 5.93715 9.87537 5.93715 9.97655C5.93715 10.0777 5.9592 10.1779 6.00197 10.271C6.04475 10.3641 6.10737 10.4483 6.18609 10.5184C6.26482 10.5886 6.35802 10.6433 6.46013 10.6794C6.56224 10.7154 6.67116 10.732 6.78036 10.7282H7.24518C7.46063 10.7282 7.66727 10.6489 7.81962 10.5079Z", fill: "#727583" }), /* @__PURE__ */ k.createElement("path", { d: "M10.9971 8.28357C11.1494 8.14251 11.235 7.95119 11.235 7.7517H11.2374C11.2372 7.65283 11.216 7.55495 11.175 7.46368C11.1339 7.3724 11.0739 7.28951 10.9982 7.21975C10.9225 7.14999 10.8327 7.09473 10.734 7.05712C10.6352 7.01952 10.5294 7.00031 10.4227 7.00059H9.95784C9.84864 6.99675 9.73972 7.01335 9.63761 7.0494C9.53551 7.08544 9.4423 7.14019 9.36358 7.21036C9.28485 7.28054 9.22223 7.3647 9.17945 7.45781C9.13668 7.55091 9.11463 7.65106 9.11463 7.75224C9.11463 7.85342 9.13668 7.95356 9.17945 8.04667C9.22223 8.13978 9.28485 8.22394 9.36358 8.29411C9.4423 8.36429 9.53551 8.41904 9.63761 8.45508C9.73972 8.49112 9.84864 8.50772 9.95784 8.50388H10.4227C10.6381 8.50388 10.8447 8.42463 10.9971 8.28357Z", fill: "#727583" })), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", { id: "clip0_3519_4" }, /* @__PURE__ */ k.createElement("rect", { width: 14, height: 14, fill: "white" })))), prt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), /* @__PURE__ */ k.createElement("g", { clipPath: "url(#clip0_3519_2)" }, /* @__PURE__ */ k.createElement("path", { d: "M13.6344 6.57386L7.42719 0.366611C7.31149 0.250072 7.17381 0.157658 7.02213 0.0947269C6.87045 0.0317958 6.70779 -0.000400113 6.54357 3.75295e-06H0.74993C0.551037 3.75295e-06 0.360289 0.0790128 0.219651 0.219651C0.0790128 0.360289 3.75295e-06 0.551037 3.75295e-06 0.74993V6.54357C-0.000400113 6.70779 0.0317958 6.87045 0.0947269 7.02213C0.157658 7.17381 0.250072 7.31149 0.366611 7.42719L6.57386 13.6344C6.80869 13.8679 7.12636 13.9989 7.45748 13.9989C7.7886 13.9989 8.10626 13.8679 8.3411 13.6344L13.6344 8.3411C13.8679 8.10626 13.9989 7.7886 13.9989 7.45748C13.9989 7.12636 13.8679 6.80869 13.6344 6.57386ZM7.45748 12.3968L1.50403 6.43704V1.49986H6.44122L12.3947 7.4533L7.45748 12.3968ZM4.49956 3.5C4.49956 3.6977 4.44093 3.89095 4.3311 4.05533C4.22127 4.2197 4.06516 4.34782 3.88252 4.42347C3.69987 4.49912 3.4989 4.51892 3.305 4.48035C3.11111 4.44178 2.933 4.34659 2.79321 4.2068C2.65342 4.06701 2.55822 3.8889 2.51966 3.69501C2.48109 3.50111 2.50088 3.30014 2.57654 3.11749C2.65219 2.93485 2.78031 2.77874 2.94468 2.66891C3.10906 2.55908 3.30231 2.50045 3.5 2.50045C3.7651 2.50045 4.01934 2.60576 4.2068 2.79321C4.39425 2.98067 4.49956 3.23491 4.49956 3.5Z", fill: "#727583" })), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", { id: "clip0_3519_2" }, /* @__PURE__ */ k.createElement("rect", { width: 14, height: 14, fill: "white" })))), yN = (e) => {
  switch (e) {
    case "week":
      return "week";
    case "month":
      return "month";
    case "3months":
      return "3 months";
    case "6months":
      return "6 months";
    case "year":
      return "year";
    default:
      return "";
  }
}, gq = W.div`
  margin: 9px 0;
`, b0 = W.div.attrs(() => ({
  className: "msd__checkout-card-details__description"
}))`
  white-space: pre-line;
  margin: 6px 0;
`, _0 = W.span.attrs(() => ({
  className: "msd__checkout-card-details__icon"
}))`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 6px;
  ${pr.smallest`
          display: none;
  `}
`, C0 = W.div`
  display: flex;
  align-items: center;
`, hrt = W.div``, w0 = W.p`
  font-size: ${i1};
  font-weight: ${b3e};
  line-height: 17px;
  white-space: pre-line;
  color: ${Et};
`, mrt = ({
  period: e,
  freeDays: t,
  currencySymbol: n,
  grossPrice: r,
  taxCopy: a,
  freePeriods: o,
  totalPrice: s,
  offerPrice: c,
  taxRate: u,
  customerPriceInclTax: f,
  discountedPeriods: m,
  discountType: v,
  isTrialAvailable: y,
  offerType: b,
  startTime: S,
  expiresAt: x,
  isRedeemGift: E
}) => {
  const { t: N } = tn(), {
    verifiedGift: { redeemMode: R, redeemRefusalReason: O }
  } = Ot(q6), D = () => {
    if (R === "EXTEND")
      return N(
        `redeem-gift.description.existing-subscription.period-${e}`,
        `Your existing subscription will be extended for additional ${yN(
          e
        )} for free.`
      );
    switch (O) {
      case "EXTERNALLY_MANAGED_SUBSCRIPTION":
        return N(
          "redeem-gift.description.refusal.external",
          "You already have an active subscription in a different store, perhaps through a mobile app. Once that subscription expires, you can come back and redeem your gift code here."
        );
      case "REDEEMED":
        return N(
          "redeem-gift.description.refusal.redeemed",
          "This gift code has already been used."
        );
      case "INACTIVE_OFFER":
        return N(
          "redeem-gift.description.refusal.offer-inactive",
          "Sorry, but the offer linked to your gift code is no longer available."
        );
      case "OFFER_GEO_RESTRICTED":
        return N(
          "redeem-gift.description.refusal.offer-georestricted",
          "Sorry, this gift code can't be used in your current location due to geographic restrictions."
        );
      case "RECURRING_PROCESS_ALREADY_STARTED":
        return N(
          "redeem-gift.description.refusal.recurring-process-started",
          "You’ll be able to redeem your gift code once we've finished processing a payment on your existing subscription"
        );
      case "MORE_THAN_ONE_MATCHING_SUBSCRIPTION":
        return N(
          "redeem-gift.description.refusal.more-than-one-matching-subscription",
          "You currently have multiple subscriptions granting you access to the content this gift provides. When one of those subscriptions expires, you can come back and redeem your gift code here."
        );
      case "PUBLISHER_GEO_RESTRICTED":
        return N(
          "redeem-gift.description.refusal.publisher-georestricted",
          "Sorry, this gift code can't be used in your current location due to geographic restrictions."
        );
      default:
        return "";
    }
  }, $ = () => {
    const pe = () => {
      if (e === "season" && t)
        return N(
          "subscription-desc.trial-days.period-season",
          `You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}) after {{freeDays}} days
Next payment will occur on the next season start date.`,
          {
            currencySymbol: n,
            grossPrice: r,
            taxCopy: a,
            freeDays: t
          }
        );
      if (t) {
        const oe = `You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}) after {{freeDays}} days.
Next payments will occur every ${yN(
          e
        )}`;
        return N(`subscription-desc.trial-days.period-${e}`, oe, {
          currencySymbol: n,
          grossPrice: r,
          taxCopy: a,
          freeDays: t
        });
      }
      let ee = "You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}) ";
      return e === "month" ? ee += o === 1 ? `after month.
Next payments will occur every month.` : `after {{freePeriods}} months.
Next payments will occur every month.` : e === "week" && (ee += o === 1 ? `after week.
Next payments will occur every week.` : `after {{freePeriods}} weeks.
Next payments will occur every week.`), N(
        `subscription-desc.trial-period${o === 1 ? "" : "s"}.period-${e}`,
        ee,
        {
          currencySymbol: n,
          grossPrice: r,
          taxCopy: a,
          freePeriods: o
        }
      );
    }, he = () => {
      const ee = br(s), oe = ble(
        c,
        u,
        f
      );
      if (m === 1)
        return N(
          `subscription-desc-coupon-${e}`,
          `You will be charged ${n}${ee} (incl. ${a}) now.
After ${e === "3months" || e === "6months" ? "" : "a"} ${wc[e].chargedForEveryText} you will be charged a regular price of ${n}${oe}.`,
          { currencySymbol: n, formattedTotalPrice: ee, taxCopy: a, period: e, regularPrice: oe }
        );
      if (e === "3months" || e === "6months") {
        const me = `You will be charged ${n}${ee} (incl. ${a}) per ${wc[e].chargedForEveryText} for the next ${m} billing periods.
After that time you will be charged a regular price of ${n}${oe}.`;
        return N(`subscription-desc-coupon.periods-${e}`, me, {
          formattedTotalPrice: ee,
          taxCopy: a,
          discountedPeriods: m,
          currencySymbol: n,
          regularPrice: oe
        });
      }
      return N(
        `subscription-desc-coupon-${e}s`,
        `You will be charged ${n}${ee} (incl. ${a}) per ${e} for the next ${m} ${e}s.
After that time you will be charged a regular price of ${n}${oe}.`,
        {
          currencySymbol: n,
          formattedTotalPrice: ee,
          taxCopy: a,
          period: e,
          discountedPeriods: m,
          regularPrice: oe
        }
      );
    }, ge = (() => {
      if (v === "coupon")
        return he();
      if (!y) {
        if (e === "season")
          return N("subscription-desc.period-season", `You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}})
Next payment will occur the next season start date.`, {
            currencySymbol: n,
            grossPrice: r,
            taxCopy: a
          });
        const ee = `You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}) every ${yN(
          e
        )}`;
        return N(`subscription-desc.period-${e}`, ee, {
          currencySymbol: n,
          grossPrice: r,
          taxCopy: a
        });
      }
      return pe();
    })(), Y = ge.split(`
`);
    return Y.length > 1 ? /* @__PURE__ */ C.jsxs(gq, { children: [
      /* @__PURE__ */ C.jsx(b0, { children: /* @__PURE__ */ C.jsxs(C0, { children: [
        /* @__PURE__ */ C.jsx(_0, { children: /* @__PURE__ */ C.jsx(vq, {}) }),
        /* @__PURE__ */ C.jsx(w0, { children: Y[0] })
      ] }) }),
      /* @__PURE__ */ C.jsx(b0, { children: /* @__PURE__ */ C.jsxs(C0, { children: [
        /* @__PURE__ */ C.jsx(_0, { children: /* @__PURE__ */ C.jsx(frt, {}) }),
        /* @__PURE__ */ C.jsx(w0, { children: Y[1] })
      ] }) })
    ] }) : /* @__PURE__ */ C.jsx(gq, { children: /* @__PURE__ */ C.jsx(b0, { children: /* @__PURE__ */ C.jsxs(C0, { children: [
      /* @__PURE__ */ C.jsx(_0, { children: /* @__PURE__ */ C.jsx(vq, {}) }),
      /* @__PURE__ */ C.jsx(w0, { children: ge })
    ] }) }) });
  }, B = () => {
    const pe = () => {
      const ge = /* @__PURE__ */ C.jsx(gN, {});
      if (!e) {
        const ee = Ko(x, !0), oe = N("pass-desc.date", "Access until {{date}}", {
          date: ee
        });
        return { icon: ge, description: oe };
      }
      const Y = wc[e] ? `${N(
        `period.${e}`,
        wc[e].accessText
      )} ${N("offer-checkout-card.season-pass", "season pass")}` : "";
      return { icon: ge, description: Y };
    }, { icon: he, description: _e } = pe();
    return /* @__PURE__ */ C.jsx(b0, { children: /* @__PURE__ */ C.jsxs(C0, { children: [
      /* @__PURE__ */ C.jsx(_0, { children: he }),
      /* @__PURE__ */ C.jsx(w0, { children: _e })
    ] }) });
  }, G = () => /* @__PURE__ */ C.jsx(b0, { children: /* @__PURE__ */ C.jsxs(C0, { children: [
    /* @__PURE__ */ C.jsx(_0, { children: /* @__PURE__ */ C.jsx(gN, {}) }),
    /* @__PURE__ */ C.jsx(w0, { children: `Pay-per-view event ${S ? Ko(S, !0) : ""}` })
  ] }) }), Z = () => /* @__PURE__ */ C.jsx(b0, { children: /* @__PURE__ */ C.jsxs(C0, { children: [
    /* @__PURE__ */ C.jsx(_0, { children: /* @__PURE__ */ C.jsx(gN, {}) }),
    /* @__PURE__ */ C.jsx(w0, { children: wc[e] ? `${N(
      `period.${e}`,
      wc[e].accessText
    )} ${N("offer-checkout-card.access", "access")}` : "" })
  ] }) }), K = () => /* @__PURE__ */ C.jsx(b0, { children: /* @__PURE__ */ C.jsxs(C0, { children: [
    /* @__PURE__ */ C.jsx(_0, { children: /* @__PURE__ */ C.jsx(prt, {}) }),
    /* @__PURE__ */ C.jsx(w0, { children: N("offer-checkout-card.unlimited-access", "Unlimited access") })
  ] }) }), q = () => E ? D() : b === "S" ? $() : b === "P" ? B() : b === "E" ? G() : b === "R" ? Z() : b === "A" ? K() : !1;
  return /* @__PURE__ */ C.jsx(hrt, { children: q() });
}, vrt = W.section`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
`, grt = W.div.attrs(() => ({
  className: "msd__checkout-card-text__wrapper"
}))`
  max-width: 50%;
  color: ${Et};
  margin-right: 15px;

  ${Zr.small`
    max-width: none;
    margin-right: 20px;
  `}
`, yrt = W.h2.attrs(() => ({
  className: "msd__checkout-card-text__title"
}))`
  margin: 0 auto 3px 0;

  font-weight: ${Nd};
  font-size: ${A2};
  line-height: 15px;

  ${Zr.small`
    font-size: ${n8};
    line-height: 19px;
  `};
`, brt = W.p.attrs(() => ({
  className: "msd__checkout-card-text__description"
}))`
  font-size: ${i1};
  font-weight: ${Yp};
  line-height: 17px;
  white-space: pre-line;
  margin: 9px 0;
`, _rt = W.div.attrs(() => ({
  className: "msd__checkout-card-price__wrapper"
}))`
  display: flex;
  flex-direction: column;
  margin-inline: auto 0;
  margin-block: auto;
`, Crt = W.div.attrs(() => ({
  className: "msd__checkout-card-price__badge"
}))`
  max-width: 120px;
  padding: 4px 8px;
  margin-bottom: 12px;
  background-color: ${cu};
  color: ${Et};
  border: 1px solid ${Gn};
  border-radius: 10px;
  font-size: 9px;
  font-size: ${Mee};
  font-weight: ${Yp};
  text-transform: uppercase;
  text-align: center;
`, wrt = W.h3.attrs(() => ({
  className: "msd__subscription-price"
}))`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;

  align-items: center;

  color: ${Et};

  ${Zr.small`
    flex-wrap: nowrap;
  `}
`, yq = W.span.attrs(() => ({
  className: "msd__subscription-price__currency"
}))`
  margin-right: 2px;

  font-size: ${i1};
  font-weight: ${Yp};

  ${Zr.small`
    font-size: ${t8};
  `}
`, Srt = W.span.attrs(() => ({
  className: "msd__subscription-price__amount"
}))`
  font-size: ${t8};

  font-weight: ${Yp};

  ${Zr.small`
    font-size: ${UR};
  `}
`, xrt = W.span.attrs(() => ({
  className: "msd__subscription-price__period"
}))`
  margin: auto 0 auto 5px;

  font-size: ${i1};
`, Ert = W.div`
  line-height: 1rem;
`, Irt = W.p.attrs(() => ({
  className: "msd__subscription-price__additional-label"
}))`
  font-size: 10px;
  line-height: 10px;
  text-align: right;
  color: inherit;
  margin-top: 2px;
`, krt = W.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`, Art = W.div`
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
`, Prt = W.div`
  color: #a2a6b7;
  font-family: inherit;
  font-size: 13px;
  font-style: normal;
  font-weight: ${Nd};
  line-height: normal;
  text-decoration: line-through;
`, Nrt = W.div.attrs(() => ({
  className: "msd__subscription-price__discount-value"
}))`
  background-color: ${e8};
  color: ${cu};
  border-radius: 4px;
  text-align: center;
  text-transform: uppercase;
  font-family: inherit;
  font-size: 13px;
  font-style: normal;
  font-weight: ${Nd};
  line-height: normal;
  padding: 2px 6px;
`, Trt = (e) => /\d/.test(e.charAt(0)) ? `${e.charAt(0)} ${e.substring(1)}` : e, _le = (e) => {
  var n;
  const t = Math.ceil(Date.now() / 1e3);
  return (n = e == null ? void 0 : e.some(
    ({ from: r, to: a }) => r <= t && a >= t
  )) != null ? n : !1;
}, SD = ({
  currency: e,
  nextPaymentPrice: t,
  totalPrice: n,
  period: r,
  isTrialBadgeVisible: a,
  isPromoPriceActive: o
}) => {
  const { t: s } = tn(), {
    discount: { applied: c }
  } = Ot(Bm), u = c && typeof t == "number" && t < n, f = Math.round((1 - (t || n) / n) * 100) || 100, m = o ? s("checkout-price-box.promo", "Promo") : `-${f}%`;
  return /* @__PURE__ */ C.jsxs(krt, { children: [
    u && !a && /* @__PURE__ */ C.jsxs(Art, { children: [
      /* @__PURE__ */ C.jsxs(Prt, { children: [
        /* @__PURE__ */ C.jsx(yq, { children: e }),
        br(n)
      ] }),
      /* @__PURE__ */ C.jsx(Nrt, { children: m })
    ] }),
    /* @__PURE__ */ C.jsxs(wrt, { children: [
      /* @__PURE__ */ C.jsxs(Ert, { children: [
        /* @__PURE__ */ C.jsx(yq, { children: e }),
        /* @__PURE__ */ C.jsx(Srt, { children: br(t || 0) }),
        /* @__PURE__ */ C.jsx(Irt, { children: /* @__PURE__ */ C.jsx(Ia, { i18nKey: "price-additional-label", children: " " }) })
      ] }),
      r && /* @__PURE__ */ C.jsxs(xrt, { children: [
        "/ ",
        Trt(r)
      ] })
    ] })
  ] });
}, Cle = ({
  isRedeemGift: e = !1
}) => {
  const {
    offerTitle: t,
    trialAvailable: n,
    period: r,
    offerId: a,
    freePeriods: o,
    freeDays: s,
    expiresAt: c,
    startTime: u,
    customerPriceInclTax: f,
    offerDescription: m
  } = Ot(A_), {
    loading: v,
    offerV2: { title: y, price: b }
  } = Ot(k2), S = (b == null ? void 0 : b.amount) || 0, x = b == null ? void 0 : b.rules, {
    priceBreakdown: { offerPrice: E },
    taxRate: N,
    country: R,
    currency: O,
    totalPrice: D,
    discount: {
      applied: $,
      type: B,
      periods: G
    }
  } = Ot(Bm), Z = a == null ? void 0 : a.charAt(0), K = Ta[O], pe = n || $ && D === 0 ? ble(E, N, f) : br(D), he = n && B === "trial", { t: _e } = tn(), ge = R === "US" ? "Tax" : "VAT", Y = Z === "S" && r !== "season" ? _e(`offer-price.period-${r}`, r) : null, ee = () => s ? _e("trial-badge-days", "{{freeDays}} days free trial", {
    freeDays: s
  }) : o === 1 ? _e(`trial-badge.period-${r}`, "1 {{period}} free trial", {
    period: r
  }) : _e(
    `trial-badge.periods-${r}`,
    "{{freePeriods}} {{period}}s free trial",
    { freePeriods: o, period: r }
  );
  return /* @__PURE__ */ C.jsxs(vrt, { children: [
    /* @__PURE__ */ C.jsx(Zn, { showChildren: !v, width: 50, height: 50, children: /* @__PURE__ */ C.jsx(th, { period: r || Z }) }),
    /* @__PURE__ */ C.jsxs(grt, { children: [
      /* @__PURE__ */ C.jsxs(
        Zn,
        {
          showChildren: !v,
          width: 200,
          margin: "0 0 10px 10px",
          children: [
            /* @__PURE__ */ C.jsx(yrt, { children: _e(`offer-title-${a}`, t || y) }),
            m && /* @__PURE__ */ C.jsx(brt, { children: _e(`offer-description-${a}`, m) })
          ]
        }
      ),
      /* @__PURE__ */ C.jsx(
        Zn,
        {
          showChildren: !v,
          width: 300,
          margin: "0 0 10px 10px",
          children: /* @__PURE__ */ C.jsx(
            mrt,
            {
              period: r,
              freeDays: s,
              currencySymbol: K,
              grossPrice: pe,
              taxCopy: ge,
              freePeriods: o,
              totalPrice: D,
              offerPrice: E,
              taxRate: N,
              customerPriceInclTax: f,
              discountedPeriods: G,
              discountType: B,
              isTrialAvailable: n,
              offerType: Z,
              startTime: u,
              expiresAt: c,
              isRedeemGift: e
            }
          )
        }
      )
    ] }),
    !e && /* @__PURE__ */ C.jsx(_rt, { children: /* @__PURE__ */ C.jsxs(Zn, { showChildren: !v, width: 80, height: 30, children: [
      he && /* @__PURE__ */ C.jsx(Crt, { children: ee() }),
      /* @__PURE__ */ C.jsx(
        SD,
        {
          currency: Ta[O],
          nextPaymentPrice: D,
          totalPrice: S,
          period: Y,
          isTrialBadgeVisible: he,
          isPromoPriceActive: _le(x)
        }
      )
    ] }) })
  ] });
}, Ort = ({
  isCheckout: e = !1,
  onCouponSubmit: t,
  onPaymentComplete: n,
  onRedeemClick: r,
  hideRedeemButton: a
}) => {
  const { t: o } = tn(), [s, c] = mt(""), { isCouponLoading: u, couponDetails: f } = Ot(iee), {
    offerV2: { giftable: m = !1 }
  } = Ot(k2), {
    totalPrice: v,
    discount: { applied: y }
  } = Ot(Bm), { couponCode: b } = f, S = v === 0 && !y;
  return mn(() => {
    c(b);
  }, [b]), S ? /* @__PURE__ */ C.jsxs(v6, { children: [
    /* @__PURE__ */ C.jsx(pl, {}),
    /* @__PURE__ */ C.jsx("main", { children: /* @__PURE__ */ C.jsx(Vnt, { onPaymentComplete: n }) })
  ] }) : /* @__PURE__ */ C.jsxs(v6, { children: [
    /* @__PURE__ */ C.jsx(pl, {}),
    /* @__PURE__ */ C.jsxs("main", { children: [
      /* @__PURE__ */ C.jsxs(crt, { children: [
        /* @__PURE__ */ C.jsx(Xi, { center: !0, children: o("offer.complete-purchase", "Complete your purchase") }),
        /* @__PURE__ */ C.jsxs(urt, { children: [
          /* @__PURE__ */ C.jsx(drt, { children: /* @__PURE__ */ C.jsx(Cle, { isRedeemGift: !1 }) }),
          /* @__PURE__ */ C.jsx(lrt, { children: /* @__PURE__ */ C.jsx(
            $ee,
            {
              onSubmit: t,
              value: s,
              onChange: (x) => c(x),
              source: "checkout",
              couponLoading: u,
              couponDetails: f
            }
          ) })
        ] }),
        /* @__PURE__ */ C.jsx(
          knt,
          {
            hideRedeemButton: a,
            isCheckout: e,
            onRedeemClick: r
          }
        )
      ] }),
      m && /* @__PURE__ */ C.jsx(srt, { giftable: m }),
      /* @__PURE__ */ C.jsx(rnt, { onPaymentComplete: n })
    ] }),
    /* @__PURE__ */ C.jsx(yu, {})
  ] });
}, X0 = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 93.667, height: 91.963, viewBox: "0 0 93.667 91.963" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#cb4477;}")), /* @__PURE__ */ k.createElement("g", { transform: "translate(0 -0.5)" }, /* @__PURE__ */ k.createElement("path", { className: "a", d: "M83.448,14.124V.5H0V80.542H11.921V92.463H93.666V14.124ZM3.406,77.136V3.906H80.042V14.124H11.921V77.136ZM90.26,89.057H15.327V17.53H90.26Z", transform: "translate(0 0)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M51.622,23.221a1.7,1.7,0,0,0-2.408,0L37.171,35.263,25.129,23.221a1.7,1.7,0,0,0-2.408,2.408L34.763,37.671,22.721,49.713a1.7,1.7,0,1,0,2.408,2.408L37.171,40.079,49.213,52.122a1.7,1.7,0,0,0,2.408-2.408L39.579,37.671,51.622,25.629A1.7,1.7,0,0,0,51.622,23.221Z", transform: "translate(15.622 15.622)" }))), bq = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 98.867, height: 82.439, viewBox: "0 0 98.867 82.439" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#cb4477;}")), /* @__PURE__ */ k.createElement("g", { transform: "translate(-2 -12)" }, /* @__PURE__ */ k.createElement("path", { className: "a", d: "M12.943,34.475h9.885a4.943,4.943,0,0,0,4.943-4.943v-6.59A4.943,4.943,0,0,0,22.828,18H12.943A4.943,4.943,0,0,0,8,22.943v6.59a4.943,4.943,0,0,0,4.943,4.943Zm9.885-3.3H21.18v-3.3h3.3v1.648A1.648,1.648,0,0,1,22.828,31.18Zm1.648-8.238V24.59h-3.3V21.3h1.648A1.648,1.648,0,0,1,24.475,22.943Zm-13.18,0A1.648,1.648,0,0,1,12.943,21.3h4.943V31.18H12.943A1.648,1.648,0,0,1,11.3,29.533Z", transform: "translate(3.885 3.885)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M36,20h3.3v6.59H36Z", transform: "translate(22.016 5.18)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M40,20h3.3v6.59H40Z", transform: "translate(24.607 5.18)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M44,20h3.3v6.59H44Z", transform: "translate(27.197 5.18)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M26.123,36a8.218,8.218,0,0,0-4.961,1.674,8.238,8.238,0,1,0,0,13.128A8.238,8.238,0,1,0,26.123,36ZM16.238,49.18a4.943,4.943,0,1,1,4.943-4.943A4.943,4.943,0,0,1,16.238,49.18Zm9.885,0a4.91,4.91,0,0,1-2.768-.873,7.951,7.951,0,0,0,0-8.139,4.934,4.934,0,1,1,2.768,9.012Z", transform: "translate(3.885 15.541)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M26,30h6.59v3.3H26Z", transform: "translate(15.541 11.656)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M34,30h6.59v3.3H34Z", transform: "translate(20.721 11.656)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M42,30h6.59v3.3H42Z", transform: "translate(25.902 11.656)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M50,30h6.59v3.3H50Z", transform: "translate(31.082 11.656)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M97.557,65.875V20.238A8.248,8.248,0,0,0,89.32,12H10.238A8.248,8.248,0,0,0,2,20.238V69.664A8.248,8.248,0,0,0,10.238,77.9H64.691A18.123,18.123,0,1,0,97.557,65.875ZM5.3,69.664V20.238A4.943,4.943,0,0,1,10.238,15.3H89.32a4.943,4.943,0,0,1,4.943,4.943V62.285A18.106,18.106,0,0,0,64.691,74.607H10.238A4.943,4.943,0,0,1,5.3,69.664ZM82.73,91.082A14.828,14.828,0,1,1,97.557,76.254,14.828,14.828,0,0,1,82.73,91.082Z", transform: "translate(0 0)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M59.305,47.654a1.648,1.648,0,0,0-2.33,0l-3.5,3.5-3.5-3.5a1.647,1.647,0,1,0-2.33,2.33l3.5,3.5-3.5,3.5a1.647,1.647,0,1,0,2.33,2.33l3.5-3.5,3.5,3.5a1.647,1.647,0,1,0,2.33-2.33l-3.5-3.5,3.5-3.5A1.648,1.648,0,0,0,59.305,47.654Z", transform: "translate(29.25 22.775)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M48,20h3.3v6.59H48Z", transform: "translate(29.787 5.18)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M52,20h3.3v6.59H52Z", transform: "translate(32.377 5.18)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M46.123,38H29.648A1.648,1.648,0,0,0,28,39.648v6.59a1.648,1.648,0,0,0,1.648,1.648H46.123a1.648,1.648,0,0,0,1.648-1.648v-6.59A1.648,1.648,0,0,0,46.123,38Zm-1.648,6.59H31.3V41.3h13.18Z", transform: "translate(16.836 16.836)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M32,20h3.3v6.59H32Z", transform: "translate(19.426 5.18)" }))), Rrt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 92.25, height: 102.5, viewBox: "0 0 92.25 102.5" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#5db98f;}")), /* @__PURE__ */ k.createElement("g", { transform: "translate(-3)" }, /* @__PURE__ */ k.createElement("path", { className: "a", d: "M48.042,18.25a10.25,10.25,0,1,0-20.5,0v1.708a1.708,1.708,0,1,0,3.417,0V18.25a6.833,6.833,0,1,1,13.667,0V30.208H19V62.667H56.583V30.208H48.042Zm5.125,41H22.417V33.625h30.75Z", transform: "translate(11.333 5.667)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M32.833,25a6.819,6.819,0,0,0-1.708,13.424v3.659a1.708,1.708,0,0,0,3.417,0V38.424A6.819,6.819,0,0,0,32.833,25Zm0,10.25a3.417,3.417,0,1,1,3.417-3.417A3.42,3.42,0,0,1,32.833,35.25Z", transform: "translate(16.292 17.708)" }), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M49.125,0A46.12,46.12,0,0,0,45.18,92.071l-7.513,7.513A1.708,1.708,0,1,0,40.083,102L50.331,91.751a1.692,1.692,0,0,0,.371-.557,1.713,1.713,0,0,0-.371-1.862L40.083,79.084A1.708,1.708,0,1,0,37.667,81.5l7.114,7.114A42.71,42.71,0,1,1,79.468,76.18,1.709,1.709,0,1,0,81.9,78.585,46.126,46.126,0,0,0,49.125,0Z" }))), V8 = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 100.718, height: 73.237, viewBox: "0 0 100.718 73.237" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_2848", "data-name": "Group 2848", transform: "translate(-5561 1412.838)" }, /* @__PURE__ */ k.createElement("g", { id: "Component_10_2", "data-name": "Component 10 \\u2013 2", transform: "translate(5561 -1412.838)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2086", "data-name": "Group 2086", transform: "translate(-3337 -4026.162)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2085", "data-name": "Group 2085", transform: "translate(1350.47 -277)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2081", "data-name": "Group 2081", transform: "translate(2 6)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1882", "data-name": "Group 1882", transform: "translate(51.001 3405)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1360", "data-name": "Path 1360", d: "M4165.574-315.591", transform: "translate(-2154.01 1261.792)", fill: "#cb4477", stroke: "#838eaa", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 17 }), /* @__PURE__ */ k.createElement("g", { id: "Group_1848", "data-name": "Group 1848", transform: "translate(2024.843 892.162)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1844", "data-name": "Group 1844", transform: "translate(0 3.94)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1842", "data-name": "Group 1842" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1392", "data-name": "Path 1392", d: "M4661.925-156.765h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,4661.925-156.765Z", transform: "translate(-4659.591 158.289)", fill: "#cb4477" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1843", "data-name": "Group 1843", transform: "translate(6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1393", "data-name": "Path 1393", d: "M4753.007-156.765h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,4753.007-156.765Z", transform: "translate(-4750.673 158.289)", fill: "#cb4477" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1847", "data-name": "Group 1847", transform: "translate(3.94 0)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1845", "data-name": "Group 1845" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1394", "data-name": "Path 1394", d: "M4717.243-212.082a.761.761,0,0,1-.762-.762v-1.572a.761.761,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,4717.243-212.082Z", transform: "translate(-4716.481 215.178)", fill: "#cb4477" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1846", "data-name": "Group 1846", transform: "translate(0 6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1395", "data-name": "Path 1395", d: "M4717.243-121a.761.761,0,0,1-.762-.762v-1.572a.761.761,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,4717.243-121Z", transform: "translate(-4716.481 124.097)", fill: "#cb4477" })))), /* @__PURE__ */ k.createElement("g", { id: "Group_1855", "data-name": "Group 1855", transform: "translate(1940.178 952.099) rotate(45)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1851", "data-name": "Group 1851", transform: "translate(0 3.94)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1849", "data-name": "Group 1849" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1396", "data-name": "Path 1396", d: "M3515.983-822.6h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,3515.983-822.6Z", transform: "translate(-3513.649 824.122)", fill: "#cb4477" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1850", "data-name": "Group 1850", transform: "translate(6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1397", "data-name": "Path 1397", d: "M3607.064-822.6h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,3607.064-822.6Z", transform: "translate(-3604.73 824.122)", fill: "#cb4477" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1854", "data-name": "Group 1854", transform: "translate(3.94 0)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1852", "data-name": "Group 1852" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1398", "data-name": "Path 1398", d: "M3571.3-877.916a.762.762,0,0,1-.762-.762v-1.572a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,3571.3-877.916Z", transform: "translate(-3570.539 881.012)", fill: "#cb4477" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1853", "data-name": "Group 1853", transform: "translate(0 6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1399", "data-name": "Path 1399", d: "M3571.3-786.834a.762.762,0,0,1-.762-.762v-1.572a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,3571.3-786.834Z", transform: "translate(-3570.539 789.93)", fill: "#cb4477" }))))), /* @__PURE__ */ k.createElement("g", { id: "Path_1978", "data-name": "Path 1978", transform: "translate(1991.001 4303)", fill: "none" }, /* @__PURE__ */ k.createElement("path", { d: "M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z", stroke: "none" }), /* @__PURE__ */ k.createElement("path", { d: "M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z", stroke: "none", fill: "#cb4477" })), /* @__PURE__ */ k.createElement("g", { id: "Path_1977", "data-name": "Path 1977", transform: "translate(2078.001 4357)", fill: "none" }, /* @__PURE__ */ k.createElement("path", { d: "M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z", stroke: "none" }), /* @__PURE__ */ k.createElement("path", { d: "M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z", stroke: "none", fill: "#cb4477" })))))), /* @__PURE__ */ k.createElement("g", { id: "attention", transform: "translate(5592 -1422.333)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2847", "data-name": "Group 2847", transform: "translate(0 21.333)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2846", "data-name": "Group 2846", transform: "translate(0 0)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1975", "data-name": "Path 1975", d: "M44.767,56.917h0c-3.008-6.169-8.049-14.92-12.5-22.64-2.327-4.041-4.526-7.856-6.115-10.756a4,4,0,0,0-7.129,0c-1.59,2.9-3.79,6.721-6.12,10.764C8.458,42,3.418,50.75.412,56.917A4.012,4.012,0,0,0,0,58.683a4.054,4.054,0,0,0,4.035,4.064l18.554,0,18.554,0a4.054,4.054,0,0,0,4.035-4.064A4.011,4.011,0,0,0,44.767,56.917Zm-3.623,3.948H4.037a2.171,2.171,0,0,1-2.153-2.182,2.14,2.14,0,0,1,.221-.941c2.978-6.109,8-14.826,12.431-22.517,2.335-4.053,4.54-7.881,6.139-10.8a2.18,2.18,0,0,1,3.827,0c1.6,2.917,3.8,6.742,6.135,10.791,4.433,7.693,9.457,16.414,12.436,22.525a2.135,2.135,0,0,1,.222.942A2.171,2.171,0,0,1,41.144,60.865Z", transform: "translate(0 -21.333)", fill: "#cb4477", stroke: "#cb4477", strokeWidth: 1 }), /* @__PURE__ */ k.createElement("path", { id: "Path_1976", "data-name": "Path 1976", d: "M246.274,128.01a.941.941,0,0,0-.941.941v18.824a.941.941,0,1,0,1.883,0V128.951A.941.941,0,0,0,246.274,128.01Z", transform: "translate(-223.685 -118.597)", fill: "#cb4477", stroke: "#cb4477", strokeWidth: 1 }), /* @__PURE__ */ k.createElement("circle", { id: "Ellipse_384", "data-name": "Ellipse 384", cx: 0.941, cy: 0.941, r: 0.941, transform: "translate(21.648 33.884)", fill: "#cb4477", stroke: "#cb4477", strokeWidth: 1 })))))), Mrt = W.div.attrs(() => ({
  className: "msd__error-page"
}))`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
`, Drt = W.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  width: 100%;
  min-height: 350px;
  margin: 0 auto;
  padding: 80px 120px 70px;

  background-color: ${Br};
  color: ${Et};

  font-size: 15px;
`, Lrt = W.div`
  margin-top: 30px;

  font-size: 25px;
  font-weight: 300;
  line-height: 1.3em;
  text-align: center;
`, $rt = W.div`
  width: 100px;
  height: auto;
`, jrt = {
  offerNotExist: {
    icon: X0,
    description: "Offer does not exist or is not provided.",
    translationKey: "offer-error.not-exist"
  },
  generalError: {
    icon: V8,
    description: "Whoops",
    translationKey: "whoops"
  },
  alreadyHaveAccess: {
    icon: Rrt,
    description: "Good news! Your account already gives you access to the content that comes with this plan.",
    translationKey: "offer-error.access-granted"
  },
  cannotPurchase: {
    icon: bq,
    description: "We are sorry! The content you are trying to access is not available in your country.",
    translationKey: "offer-error.geo-restrictions"
  },
  inactive: {
    icon: X0,
    description: "We are sorry! This offer is no longer available",
    translationKey: "offer-error.not-available"
  },
  isNotAuth: {
    icon: X0,
    description: "User not authorized",
    translationKey: "redeem-gift-error.not-authorized"
  },
  paymentMethodNotFound: {
    icon: bq,
    description: "No payment method found",
    translationKey: "offer-error.no-payment-method-found"
  }
}, wle = ({
  type: e = "generalError",
  error: t = "",
  isRedeemGift: n = !1
}) => {
  const { t: r } = tn(), a = jrt[e], o = a.icon;
  return /* @__PURE__ */ C.jsxs(Mrt, { children: [
    !n && /* @__PURE__ */ C.jsx(pl, {}),
    /* @__PURE__ */ C.jsxs(Drt, { children: [
      /* @__PURE__ */ C.jsx($rt, { children: /* @__PURE__ */ C.jsx(o, {}) }),
      /* @__PURE__ */ C.jsx(Lrt, { id: "offer-error-description", children: t || r(a.translationKey, a.description) })
    ] })
  ] });
}, Frt = W.div`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  position: relative;
`, Sle = W.div`
  position: relative;

  width: 100%;
  margin: 0 auto;
  padding: 80px 120px 120px;

  background-color: ${Br};

  text-align: center;

  ${pr.small`
    width: 80%;
  `}
`, nh = "data:image/svg+xml;base64,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", _q = typeof window != "undefined" ? window.location.origin === "https://mediastore-sdk-hosted-sandbox.cleeng.com" : !1, Brt = (e) => {
  typeof window != "undefined" && window.top && (window.top.location.href = e);
}, Cq = En("CLEENG_MY_ACCOUNT_URL"), U8 = ({ onSuccess: e }) => {
  const {
    payment: { paymentMethod: t, totalAmount: n, currency: r }
  } = wr((f) => f.finalizeInitialPayment), { t: a } = tn(), o = {
    card: a("paymentmethod.card", "Card"),
    paypa: "PayPal",
    googlepay: "GooglePay",
    applepay: "ApplePay"
  }, s = o[t], c = Ta[r], u = br(n);
  return mn(() => {
    const f = setTimeout(() => {
      e();
    }, 3e3);
    return () => clearTimeout(f);
  }, []), /* @__PURE__ */ C.jsxs(mnt, { "data-testid": "ThankYouPage-component", children: [
    /* @__PURE__ */ C.jsx(pl, {}),
    /* @__PURE__ */ C.jsxs(mle, { children: [
      /* @__PURE__ */ C.jsx(vnt, { src: nh, alt: "" }),
      /* @__PURE__ */ C.jsx(vle, { id: "title-thankyou", children: a("thank-you-page.header", "Thank You!") }),
      /* @__PURE__ */ C.jsx(m6, { id: "message-payment-method", children: o[t] ? /* @__PURE__ */ C.jsx("strong", { children: a(
        "thank-you-page.text-with-payment-method",
        "Your purchase was successfully processed using {{paymentMethodName}}!",
        { paymentMethodName: s }
      ) }) : /* @__PURE__ */ C.jsx("strong", { children: a(
        "thank-you-page.text",
        "Your purchase was successfully processed!"
      ) }) }),
      /* @__PURE__ */ C.jsxs(m6, { id: "message-total-amount", children: [
        u ? c && a(
          "thank-you-page.sub-text-with-price",
          "You have been charged {{currencySymbol}}{{totalAmount}}.",
          {
            currencySymbol: c,
            totalAmount: u
          }
        ) : null,
        /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "thank-you-page.manage-text", children: [
          "You can manage your account from",
          /* @__PURE__ */ C.jsx(
            _2,
            {
              href: _q ? "#" : Cq,
              rel: "noopener noreferrer",
              onClick: () => _q && Brt(Cq),
              children: "here."
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ C.jsx(yu, {})
  ] });
};
U8.propTypes = {
  onSuccess: de.func
};
U8.defaultProps = {
  onSuccess: (e) => e
};
const Vrt = () => {
  const { error: e } = wr((r) => r.finalizeInitialPayment), t = Jo(), { t: n } = tn();
  return /* @__PURE__ */ C.jsxs(v6, { "data-testid": "FailedPaymentPage-component", children: [
    /* @__PURE__ */ C.jsx(pl, {}),
    /* @__PURE__ */ C.jsxs(mle, { children: [
      /* @__PURE__ */ C.jsx(V8, {}),
      /* @__PURE__ */ C.jsx(vle, { children: n("oops-something-went-wrong", "Oops! Something went wrong") }),
      /* @__PURE__ */ C.jsx(m6, { children: /* @__PURE__ */ C.jsx("strong", { children: n(
        "failed-payment-page.subtitle",
        "We weren't able to process your payment."
      ) }) }),
      /* @__PURE__ */ C.jsx(m6, { children: e.includes("Refused") ? /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "failed-payment-page.desc-refused", children: [
        "To complete your purchase, please",
        /* @__PURE__ */ C.jsx(
          _2,
          {
            as: "button",
            onClick: () => t(hT(!1)),
            target: "_blank",
            rel: "noopener noreferrer",
            children: "try again"
          }
        ),
        "using a different payment method."
      ] }) : /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "failed-payment-page.desc-error", children: [
        "To complete your purchase, please",
        /* @__PURE__ */ C.jsx(
          _2,
          {
            as: "button",
            onClick: () => t(hT(!1)),
            target: "_blank",
            rel: "noopener noreferrer",
            children: "try again."
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ C.jsx(yu, {})
  ] });
}, g6 = ({ onSuccess: e }) => {
  const t = new URLSearchParams(window.location.search).get(
    "redirectResult"
  ), n = new URLSearchParams(window.location.search).get("orderId"), r = Jo(), a = () => {
    r(
      O4({
        orderId: n,
        details: { redirectResult: t }
      })
    ).then(() => {
      window.history.replaceState(null, null, window.location.pathname);
    });
  }, { error: o, payment: s } = wr(
    (c) => c.finalizeInitialPayment
  );
  return mn(() => {
    t && n && a();
  }, []), o ? /* @__PURE__ */ C.jsx(Vrt, {}) : s.id ? e ? (e(), null) : /* @__PURE__ */ C.jsx(U8, {}) : /* @__PURE__ */ C.jsxs(v6, { "data-testid": "PaymentFinalizationPage-loader", children: [
    /* @__PURE__ */ C.jsx(pl, {}),
    /* @__PURE__ */ C.jsx(Sle, { children: /* @__PURE__ */ C.jsx(cr, {}) }),
    /* @__PURE__ */ C.jsx(yu, {})
  ] });
};
g6.propTypes = {
  onSuccess: de.func
};
g6.defaultProps = {
  onSuccess: null
};
const Urt = (e) => function(a) {
  var o = a, { onSuccess: n } = o, r = u0(o, ["onSuccess"]);
  const s = Jo(), { error: c, shouldShowFinalizePaymentComponent: u } = wr(
    (v) => v.finalizeInitialPayment
  ), f = new URLSearchParams(window.location.search).get(
    "redirectResult"
  ), m = new URLSearchParams(window.location.search).get("orderId");
  return f && m && !c ? (s(hT(!0)), /* @__PURE__ */ C.jsx(g6, { onSuccess: n })) : u ? /* @__PURE__ */ C.jsx(g6, { onSuccess: n }) : /* @__PURE__ */ C.jsx(e, Fe({ onSuccess: n }, r));
}, Grt = ({
  adyenConfiguration: e,
  couponCode: t,
  isCheckout: n = !1,
  offerId: r,
  onSuccess: a,
  onRedeemClick: o,
  hideRedeemButton: s
}) => {
  const [c, u] = mt(), f = Va(), { offerId: m, adyenConfiguration: v } = Ot(FR), {
    order: y,
    loading: b,
    error: S
  } = Ot(iee), { error: x } = Ot(k2), E = r || m, N = e || v, R = (Z) => {
    j7().then((K) => {
      const {
        responseData: { paymentMethods: q }
      } = K, pe = q.find(
        (he) => he.paymentGateway === "free-offer"
      );
      pe && MR(Z, {
        paymentMethodId: pe.id
      });
    });
  }, O = (Z, K, q) => st(void 0, null, function* () {
    const he = new URLSearchParams(window.location.search).get("purchaseAsGift");
    let _e;
    q && (K || he === "true") ? _e = yield f(
      $4({ offerId: Z, buyAsAGift: !0 })
    ) : _e = yield f(
      $4({ offerId: Z, buyAsAGift: !1 })
    );
    const {
      id: ge,
      totalPrice: Y,
      discount: { applied: ee }
    } = Mx(_e);
    Y === 0 && !ee && (R(ge), f(O2e(!0))), Ba("CLEENG_ORDER_ID", ge);
  }), D = (Z, K) => st(void 0, null, function* () {
    yield f(Fx(Z)).unwrap().then((q) => {
      $(q);
      const { customerId: pe } = qi(
        En("CLEENG_AUTH_TOKEN")
      );
      (!(q.offerId === K && q.customerId === pe) || (q == null ? void 0 : q.paymentMethodId) === void 0) && (Pl("CLEENG_ORDER_ID"), O(K));
    }).catch(() => {
      Pl("CLEENG_ORDER_ID"), O(K);
    });
  }), $ = (Z) => {
    const {
      id: K,
      totalPrice: q,
      requiredPaymentDetails: pe,
      discount: { applied: he }
    } = Z;
    he && q === 0 && !pe && j7().then((_e) => {
      const {
        responseData: { paymentMethods: ge }
      } = _e, Y = ge.find(
        (ee) => ee.paymentGateway === "coupon"
      );
      if (!(Y != null && Y.id)) {
        u("No payment method found");
        return;
      }
      f(
        xd({
          id: K,
          payload: {
            paymentMethodId: Y == null ? void 0 : Y.id
          }
        })
      );
    });
  }, B = (Z) => {
    if (Z === void 0 || Z === "") {
      f(
        W2e({
          messageType: "fail",
          translationKey: "coupon-input.error",
          showMessage: !0,
          message: "Please provide a valid coupon code."
        })
      );
      return;
    }
    f(
      Zy({
        id: y.id,
        couponCode: Z
      })
    ).unwrap().then((K) => {
      $(K), ur(Aye, {
        detail: {
          coupon: Z,
          source: "checkout"
        },
        order: y
      });
    }).catch(() => {
      ur(Pye, {
        detail: {
          coupon: Z,
          source: "checkout"
        }
      });
    });
  };
  mn(() => () => {
    f(H2e());
  }, []), mn(() => {
    if (f(
      $u({
        offerId: E,
        adyenConfiguration: N
      })
    ), !E) {
      u("Offer not set");
      return;
    }
    st(void 0, null, function* () {
      const K = yield f(M4(E)), q = yield f(
        D4(E.split("_")[0])
      ), { accessGranted: pe, offerId: he } = Mx(K), { giftable: _e } = Mx(q);
      Ba("CLEENG_OFFER_ID", he), Ba("CLEENG_OFFER_TYPE", he.charAt(0));
      const ge = En("CLEENG_ORDER_ID");
      ge ? yield D(ge, he) : yield O(he, pe, _e);
    }), E === "" && !En("CLEENG_OFFER_ID") && u("Offer not set");
  }, [r]), mn(() => {
    (!b || c || x || S) && ur(Nye, {
      order: y
    });
  }, [b, c, x, x]), mn(() => {
    (t || t === null) && y.id !== 0 && B(t);
  }, [t, y.id]);
  const G = (Z) => {
    const K = {
      cannotPurchase: ["Offer is blocked for country"],
      offerNotExist: [
        "doesn't exist",
        "does not exist",
        "Invalid param offerId",
        "Offer not set"
      ],
      alreadyHaveAccess: ["Access already granted"],
      generalError: ["Request failed with status code 500"],
      inactive: ["inactive"],
      isNotAuth: [""],
      paymentMethodNotFound: ["No payment method found"]
    }, q = Object.keys(K);
    if (Z)
      return q.find(
        (pe) => K[pe].find((he) => he.includes(Z) || Z.includes(he))
      );
  };
  if (c || x || S) {
    const Z = G(c || x || S);
    return Z === "alreadyHaveAccess" && ur($ye), /* @__PURE__ */ C.jsx(wle, { type: Z });
  }
  return b ? /* @__PURE__ */ C.jsxs(Frt, { children: [
    /* @__PURE__ */ C.jsx(pl, {}),
    /* @__PURE__ */ C.jsx(Sle, { children: /* @__PURE__ */ C.jsx(cr, {}) }),
    /* @__PURE__ */ C.jsx(yu, {})
  ] }) : /* @__PURE__ */ C.jsx(
    Ort,
    {
      hideRedeemButton: s,
      isCheckout: n,
      onCouponSubmit: B,
      onPaymentComplete: a,
      onRedeemClick: o
    }
  );
}, zrt = Urt(Grt), Hrt = (e, t) => {
  const n = new URLSearchParams(e.search).get("offer");
  n ? (t(n), Ba("CLEENG_OFFER_ID", n)) : t(En("CLEENG_OFFER_ID") || "");
}, xle = (e, t) => {
  const n = new URLSearchParams(e.search).get(
    "publisher"
  );
  n ? (t(n), Ba("CLEENG_PUBLISHER_ID", n)) : t(En("CLEENG_PUBLISHER_ID") || "");
}, Ele = W.div.attrs(() => ({
  className: "msd__auth-wrapper"
}))`
  position: relative;
  background: ${Br};
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
`, Ile = W.main.attrs(() => ({
  className: "msd__auth-content"
}))`
  position: relative;

  width: 55%;
  margin: 0 auto;
  padding-bottom: 70px;

  text-align: center;

  ${pr.small`
    width: 80%;
  `}
`, kle = W.form.attrs(() => ({
  className: "msd__auth-wrapper__form"
}))`
  padding-top: 40px;
  & input {
    position: relative;
  }
`;
W.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  width: 100%;
  margin-top: 10px;

  p {
    margin-top: 20px;
  }

  button {
    width: 48%;
    margin: 10px 0 0 0;
  }

  ${pr.smallest`
    flex-direction: column;
    
    margin-bottom: 20px;
    
    button{
      width: 100%;

      margin: 5px 0;
    }
  `}
`;
W.div`
  display: block;
  width: 100%;

  padding: 20px 0;

  color: ${Et};

  text-align: center;
  font-size: 13px;

  overflow: hidden;

  &::before,
  &::after {
    position: relative;
    display: inline-block;
    vertical-align: middle;

    content: '';
    height: 1px;
    width: 40%;

    background-color: ${u2};
  }
  &::before {
    right: 5%;

    margin-left: -50%;
  }
  &::after {
    left: 5%;
    margin-right: -50%;
  }
`;
const Ale = W.div.attrs(() => ({
  className: "msd__form__message--error"
}))`
  position: absolute;
  top: 20px;
  width: 100%;

  color: ${wa};

  font-size: 13px;
  font-weight: 600;

  a {
    color: ${wa};
    font-weight: 600;
    text-decoration: underline;
  }
`, Wrt = W.h1.attrs(() => ({
  className: "msd__form__message--success"
}))`
  color: ${An};
  position: absolute;
  top: 20px;
  width: 100%;
  font-size: 13px;
  font-weight: 600;
`, pC = ({
  value: e,
  onChange: t,
  onBlur: n,
  error: r,
  label: a,
  floatingLabels: o,
  required: s,
  reference: c
}) => /* @__PURE__ */ C.jsx(
  Q6,
  {
    placeholder: a,
    floatingLabels: o,
    type: "email",
    value: e,
    onChange: t,
    onBlur: n,
    error: r,
    required: s,
    reference: c,
    ariaRequired: s,
    ariaInvalid: !!r
  }
);
pC.propTypes = {
  value: de.string,
  onChange: de.func,
  onBlur: de.func,
  error: de.string,
  label: de.string,
  floatingLabels: de.bool,
  required: de.bool,
  reference: de.oneOfType([de.func, de.shape()])
};
pC.defaultProps = {
  value: "",
  onChange: () => null,
  onBlur: () => null,
  error: "",
  label: "Email",
  floatingLabels: !0,
  required: !1,
  reference: () => null
};
class G8 extends vo.Component {
  constructor(n) {
    super(n);
    Er(this, "onChangeFunction", (n) => {
      const { onChange: r, showPasswordStrength: a } = this.props;
      if (a) {
        const o = this.validateNewPassword(n);
        this.setState({
          passError: this.getErrorMessage(o),
          errorLabel: o
        });
      }
      r(n);
    });
    Er(this, "validateNewPassword", (n) => {
      let r = 0;
      if (n && n.length >= 8 && n.match(/\d+/) && n.match(/[a-zA-Z]/)) {
        if (n.match(/[a-z]/) && (r += 1), n.match(/[A-Z]/) && (r += 5), n.match(/\d+/) && !n.match(/^[0-9]*$/) && (r += 5), n.match(/(\d.*\d)/) && (r += 5), n.match(/[!,@#$%^&*?_~]/) && (r += 5), n.match(/([!,@#$%^&*?_~].*[!,@#$%^&*?_~])/) && (r += 5), n.match(/[a-z]/) && n.match(/[A-Z]/) && (r += 2), n.match(/\d/) && n.match(/\D/) && (r += 2), n.match(/[a-z]/) && n.match(/[A-Z]/) && n.match(/\d/) && n.match(/[!,@#$%^&*?_~]/) && (r += 2), r <= 8)
          return "Weak";
        if (r > 8 && r <= 16)
          return "Fair";
        if (r > 16 && r <= 24)
          return "Good";
        if (r > 24 && r <= 32)
          return "Strong";
      }
      return "NotValid";
    });
    Er(this, "getErrorMessage", (n) => {
      const { t: r } = this.props;
      return {
        Weak: r("password-input.error.weak", "Weak"),
        Fair: r("password-input.error.fair", "Could be stronger"),
        Good: r("password-input.error.good", "Good password"),
        Strong: r("password-input.error.strong", "Strong password"),
        NotValid: r(
          "password-input.error.not-valid",
          "Your password must contain at least 8 characters, including 1 digit."
        )
      }[n];
    });
    this.state = {
      passError: "",
      errorLabel: ""
    };
  }
  render() {
    const {
      value: n,
      onBlur: r,
      error: a,
      showVisibilityIcon: o,
      showPassword: s,
      handleClickShowPassword: c,
      label: u,
      floatingLabels: f
    } = this.props, { passError: m, errorLabel: v } = this.state, y = a || m;
    return /* @__PURE__ */ C.jsx(C.Fragment, { children: /* @__PURE__ */ C.jsx(
      Q6,
      {
        placeholder: u,
        floatingLabels: f,
        type: s ? "text" : "password",
        value: n,
        onChange: this.onChangeFunction,
        onBlur: r,
        error: y,
        showVisibilityIcon: o,
        handleClickShowPassword: c,
        showPassword: s,
        passwordStrength: v,
        ariaRequired: !0,
        ariaInvalid: v === "NotValid"
      }
    ) });
  }
}
G8.propTypes = {
  value: de.string,
  onChange: de.func,
  onBlur: de.func,
  error: de.string,
  showVisibilityIcon: de.bool,
  showPassword: de.bool,
  handleClickShowPassword: de.func,
  label: de.string,
  floatingLabels: de.bool,
  showPasswordStrength: de.bool,
  t: de.func
};
G8.defaultProps = {
  value: "",
  onChange: () => null,
  onBlur: () => null,
  error: "",
  showVisibilityIcon: !1,
  showPassword: !1,
  handleClickShowPassword: () => null,
  label: "Password",
  floatingLabels: !0,
  showPasswordStrength: !1,
  t: (e) => e
};
class xD extends Nc {
  constructor(n) {
    super(n);
    Er(this, "validateEmail", () => {
      const { email: n, errors: r } = this.state, { t: a } = this.props, o = Nf(n);
      this.setState(() => ({
        errors: Xn(Fe({}, r), {
          email: a(o)
        })
      }));
    });
    Er(this, "validatePassword", () => {
      const { password: n, errors: r } = this.state, { t: a } = this.props, o = pq(n);
      this.setState(() => ({
        errors: Xn(Fe({}, r), {
          password: a(o)
        })
      }));
    });
    Er(this, "validateFields", () => {
      const { email: n, password: r } = this.state, { t: a } = this.props, o = {
        email: a(Nf(n)),
        password: a(pq(r))
      };
      return this.setState({ errors: o, generalError: "" }), !Object.keys(o).find((s) => o[s] !== "");
    });
    Er(this, "handleSubmit", (n) => {
      n.preventDefault(), this.validateFields() && this.login();
    });
    Er(this, "login", () => st(this, null, function* () {
      const { offerId: n, isMyAccount: r, publisherId: a, onSuccess: o } = this.props, { email: s, password: c } = this.state, { t: u } = this.props;
      this.setState({
        processing: !0,
        hideSuccessMessage: !0
      });
      const f = yield Wye(
        s,
        c,
        a ? { publisherId: a } : { offerId: n }
      );
      return f.status === 200 ? Ec.login(
        !!r,
        !1,
        s,
        f.responseData.jwt,
        f.responseData.refreshToken,
        null,
        null,
        o
      ) : f.status === 401 || f.status === 422 ? this.renderError(
        u("login-form.error.wrong-email-or-password", "Wrong email or password")
      ) : f.status === 429 ? (this.setState({ overloaded: !0 }), this.renderError(
        u(
          "login-form.error.server-overloaded",
          "Server overloaded. Please try again later."
        )
      ), setTimeout(() => {
        this.setState({
          overloaded: !1,
          generalError: ""
        });
      }, 10 * 1e3)) : this.renderError(), !0;
    }));
    Er(this, "renderError", (n) => {
      const { t: r } = this.props;
      this.setState({
        processing: !1,
        generalError: n || r("login-form.error.general-error", "An error occurred.")
      });
    });
    this.emailInput = vo.createRef(), this.state = {
      email: "",
      password: "",
      errors: {
        email: "",
        password: ""
      },
      generalError: "",
      processing: !1,
      overloaded: !1,
      hideSuccessMessage: !1
    };
  }
  componentDidMount() {
    this.emailInput && this.emailInput.current && this.emailInput.current.focus();
  }
  render() {
    const {
      email: n,
      password: r,
      errors: a,
      generalError: o,
      processing: s,
      overloaded: c,
      hideSuccessMessage: u
    } = this.state, { emailChanged: f, t: m } = this.props;
    return /* @__PURE__ */ C.jsxs(kle, { onSubmit: this.handleSubmit, noValidate: !0, children: [
      f && !o && !u ? /* @__PURE__ */ C.jsx(Wrt, { children: m(
        "login-form.email-change-success",
        "Your email has been changed successfully"
      ) }) : /* @__PURE__ */ C.jsx(Ale, { children: o }),
      /* @__PURE__ */ C.jsx(
        pC,
        {
          reference: this.emailInput,
          label: m("Email"),
          floatingLabels: !1,
          value: n,
          onChange: (v) => this.setState({ email: v }),
          onBlur: this.validateEmail,
          error: a.email
        }
      ),
      /* @__PURE__ */ C.jsx(
        G8,
        {
          label: m("Password"),
          floatingLabels: !1,
          value: r,
          onChange: (v) => this.setState({ password: v }),
          onBlur: this.validatePassword,
          error: a.password
        }
      ),
      /* @__PURE__ */ C.jsx(
        zt,
        {
          type: "submit",
          size: "big",
          theme: "confirm",
          margin: "10px 0",
          disabled: s || c,
          children: s ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : m("login-form.button.sign-in", "Sign in")
        }
      )
    ] });
  }
}
xD.propTypes = {
  offerId: de.string,
  publisherId: de.string,
  isMyAccount: de.bool,
  emailChanged: de.bool,
  onSuccess: de.func,
  t: de.func
};
xD.defaultProps = {
  offerId: "",
  publisherId: "",
  isMyAccount: !1,
  emailChanged: !1,
  onSuccess: () => null,
  t: (e) => e
};
class ED extends Nc {
  constructor(n) {
    super(n);
    Er(this, "setOfferId", (n) => this.setState({ offerId: n }));
    Er(this, "setPublisherId", (n) => this.setState({ publisherId: n }));
    this.state = {
      offerId: "",
      publisherId: "",
      emailChanged: !1
    };
  }
  componentDidMount() {
    const { urlProps: n } = this.props;
    n.location ? (Hrt(n.location, this.setOfferId), xle(n.location, this.setPublisherId), n.location.search.includes("emailChanged=true") && this.setState({
      emailChanged: !0
    })) : (this.setOfferId(En("CLEENG_OFFER_ID")), this.setPublisherId(En("CLEENG_PUBLISHER_ID")));
  }
  render() {
    const { offerId: n, publisherId: r, emailChanged: a } = this.state, { isMyAccount: o, onSuccess: s, onPasswordResetClick: c, onRegisterClick: u, t: f } = this.props;
    return /* @__PURE__ */ C.jsxs(Ele, { children: [
      /* @__PURE__ */ C.jsx(pl, {}),
      /* @__PURE__ */ C.jsxs(Ile, { children: [
        /* @__PURE__ */ C.jsx(
          xD,
          {
            t: f,
            offerId: n,
            publisherId: r,
            isMyAccount: o,
            emailChanged: a,
            onSuccess: s
          }
        ),
        !o && /* @__PURE__ */ C.jsx(C.Fragment, { children: /* @__PURE__ */ C.jsx(
          zt,
          {
            theme: "secondary",
            size: "big",
            onClickFn: () => u(),
            children: f("login.button.go-to-register", "Go to register")
          }
        ) }),
        !o && /* @__PURE__ */ C.jsx(
          zt,
          {
            theme: "link",
            margin: "20px auto 0 auto",
            onClickFn: () => c(),
            children: f("login.button.forgot-password", "Forgot password?")
          }
        )
      ] }),
      /* @__PURE__ */ C.jsx(yu, { isCheckout: !o })
    ] });
  }
}
ED.propTypes = {
  urlProps: de.shape({
    location: de.shape({ search: de.string })
  }),
  isMyAccount: de.bool,
  onSuccess: de.func,
  onRegisterClick: de.func,
  onPasswordResetClick: de.func,
  t: de.func
};
ED.defaultProps = {
  urlProps: {},
  isMyAccount: !1,
  onSuccess: () => null,
  onRegisterClick: () => null,
  onPasswordResetClick: () => null,
  t: (e) => e
};
const Ple = o1()(ED), Zrt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 23 23" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, `
      .cls-2 {
        fill: none;
        stroke: #fff;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 2.3px;
      }
    `)), /* @__PURE__ */ k.createElement("g", { id: "Group_2444", "data-name": "Group 2444", transform: "translate(-2630 -325)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2439", "data-name": "Group 2439", transform: "translate(-2260 -536)" }, /* @__PURE__ */ k.createElement("rect", { id: "Rectangle_2907", "data-name": "Rectangle 2907", className: "cls-1", width: 23, height: 23, rx: 4, transform: "translate(4890 861)" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1942", "data-name": "Path 1942", className: "cls-2", d: "M9635.432-7145.427l3.764,3.791,4.215-4.244,3.989-4.018", transform: "translate(-4739.931 8018.397)" })))), Yrt = W.input`
  position: absolute;
  width: 1em;
  height: 1em;
  opacity: 0;
`, Xrt = W.label.attrs(
  (e) => ({
    className: `msd__consents ${e.$disabled ? "msd__consents--disabled" : ""} ${e.$className}`
  })
)`
  display: flex;
  width: 100%;
  height: 100%;
  cursor: pointer;
  margin-top: 10px;

  align-items: center;
  font-size: 13px;
  color: ${Et};

  &:focus {
    outline: none;
  }
  &:first-of-type {
    margin-top: 0;
  }
  ${(e) => e.$disabled && ot`
      opacity: 0.7;
    `}
`, Krt = W.div.attrs(
  (e) => ({
    className: `msd__consents__text ${e.$checked ? "msd__consents__text--checked" : ""}`
  })
)`
  position: relative;
  padding-inline-start: 10px;
  margin-top: 0;

  font-weight: 400;
  text-align: left;

  user-select: none;
  a {
    color: ${Et};

    text-decoration: underline;
    &:focus {
      outline: 2px solid ${Vm};
    }
  }
  opacity: 0.8;
  ${(e) => e.$checked && ot`
      opacity: 1;
    `}
`, qrt = W.div.attrs(
  (e) => ({
    className: `msd__consents__frame ${e.$error ? "msd__consents__frame--error" : ""} ${e.$checked ? "msd__consents__frame--checked" : ""}
  ${e.$isRadioButton ? "msd__consents__frame--radio" : ""}`
  })
)`
  position: relative;
  box-sizing: border-box;

  border: 1px solid ${Gn};
  border-radius: 2px;
  width: 20px;
  min-width: 20px;
  height: 20px;

  &:focus {
    outline: 2px solid ${Vm};
  }
  ${(e) => e.$error && ot`
      border-color: ${wa};
    `}
  ${(e) => e.$isRadioButton && ot`
      border-radius: 50%;
    `}
  ${(e) => e.$isRadioButton && e.$checked && ot`
      border: 1px solid ${An};
    `}
`, Jrt = W.div.attrs(
  (e) => ({
    className: `msd__consents__check-mark ${e.$isRadioButton ? "msd__consents__check-mark--radio" : ""} ${e.$isMyAccount ? "msd__consents__check-mark--account" : ""}`
  })
)`
  position: absolute;

  width: 13px;
  height: 10px;
  top: -1px;
  left: -1px;

  svg {
    fill: ${An};
  }

  ${(e) => e.$isRadioButton && ot`
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      width: 12px;
      height: 12px;

      background: ${An};
      border-radius: 50%;
    `}
  ${(e) => e.$isMyAccount && ot`
      width: 20px;
      height: 20px;
      top: -1px;
      left: -1px;
    `}
`;
W.div`
  position: relative;

  width: 100%;
  margin-top: 10px;

  color: ${wa};

  font-size: 12px;
  font-weight: 300;
  text-align: center;
`;
const Qrt = W.a`
  padding-inline-start: ${(e) => e.$isPayPal ? "31px" : "33px"};
  position: relative;
  top: ${({ $isPayPal: e }) => e ? "0" : "-20px"};
  font-weight: 400;
  font-size: 11px;
  line-height: 17px;
  text-align: left;
  color: ${Et};
  text-decoration: underline;
  opacity: 0.8;

  ${(e) => e.$checked && ot`
      opacity: 1;
    `}
`, kf = ({
  children: e,
  onClickFn: t,
  error: n,
  isChecked: r,
  required: a,
  isMyAccount: o,
  className: s = "",
  disabled: c = !1,
  isRadioButton: u,
  termsUrl: f,
  isPayPal: m,
  id: v
}) => {
  const { t: y } = tn(), b = " ", S = `${e}${a && o ? "*" : ""}`;
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(
      Xrt,
      {
        "data-testid": `${v}-label`,
        htmlFor: v,
        "aria-label": e,
        $className: s,
        $disabled: c,
        children: [
          /* @__PURE__ */ C.jsx(
            Yrt,
            {
              id: v,
              type: "checkbox",
              checked: r,
              disabled: c,
              required: a,
              onChange: (x) => {
                x.stopPropagation(), t(x, c);
              }
            }
          ),
          /* @__PURE__ */ C.jsx(
            qrt,
            {
              $error: !!n && a && !r,
              tabIndex: 0,
              onKeyDown: (x) => x.key === b ? t() : null,
              $isMyAccount: o,
              $isRadioButton: u,
              $checked: r,
              children: r && /* @__PURE__ */ C.jsx(
                Jrt,
                {
                  "data-testid": "checkmark",
                  $isMyAccount: o,
                  $isRadioButton: u,
                  children: !u && /* @__PURE__ */ C.jsx(Zrt, {})
                }
              )
            }
          ),
          /* @__PURE__ */ C.jsx(
            Krt,
            {
              dangerouslySetInnerHTML: {
                __html: S
              },
              $checked: r
            }
          )
        ]
      }
    ),
    f && /* @__PURE__ */ C.jsx(
      Qrt,
      {
        href: f,
        target: "_blank",
        rel: "noreferrer",
        $checked: r,
        $isPayPal: m,
        children: y("checkbox.terms-link", "Terms & Conditions")
      }
    )
  ] });
}, ID = (e, t) => {
  const n = dq.exec(e), r = fq.exec(e);
  if (n) {
    let a = e.replace(
      dq,
      "{{htmltag}}"
    );
    return a = a.replace(
      fq,
      "{{endhtmltag}}"
    ), `${t(a, {
      htmltag: n[0],
      endhtmltag: r[0]
    })}`;
  }
  return t(e);
}, wq = W.div`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  position: relative;

  padding: 10px;

  font-weight: 300;

  & button {
    margin-top: 35px;
  }
  & a {
    font-weight: 600;
  }
`, eat = W.div.attrs(() => ({
  className: "msd__consents__error"
}))`
  width: 100%;
  height: 13px;

  color: ${wa};

  font-size: 13px;
`, tat = W.legend`
  position: absolute;
  clip: rect(0 0 0 0);

  height: 1px;
  width: 1px;

  margin: -1px;
  padding: 0;

  overflow: hidden;
`, nat = W.p`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  margin-bottom: 30px;
  color: ${wa};
  font-size: 13px;
`, rat = W.fieldset`
  border: none;
`, aat = ({ error: e, onChangeFn: t }) => {
  const {
    publisherConsents: n,
    checked: r,
    loading: a,
    error: o
  } = Ot((f) => f.publisherConsents), { publisherId: s } = Ot((f) => f.publisherConfig), { t: c } = tn(), u = Va();
  return mn(() => {
    function f() {
      return st(this, null, function* () {
        s ? (yield u(Bx(s)).unwrap().catch((v) => {
          throw new Error(v);
        })).forEach((v, y) => {
          v.enabledByDefault && u(LV(y));
        }) : console.error("Unable to get publisherId from redux store");
      });
    }
    f();
  }, [s]), mn(() => {
    t(r, n);
  }, [r, n]), o === "noPublisherId" ? /* @__PURE__ */ C.jsx(nat, { "data-testid": "consents__general-error", children: c(
    "consents-general-error",
    "Unable to fetch terms & conditions. Publisher is not recognized"
  ) }) : a ? /* @__PURE__ */ C.jsx(wq, { "data-testid": "consents__loader", children: /* @__PURE__ */ C.jsx(cr, {}) }) : /* @__PURE__ */ C.jsxs(wq, { children: [
    /* @__PURE__ */ C.jsxs(rat, { children: [
      /* @__PURE__ */ C.jsx(tat, { children: "Consents " }),
      n.map(({ label: f, required: m, name: v }, y) => /* @__PURE__ */ C.jsx(
        kf,
        {
          onClickFn: () => u(LV(y)),
          isChecked: r[y],
          id: v,
          error: e,
          required: m && !r[y],
          children: ID(f, c) + (m ? "*" : "")
        },
        v
      ))
    ] }),
    e && /* @__PURE__ */ C.jsx(eat, { children: e })
  ] });
}, oat = () => {
  const e = or();
  return fetch(`${e}/locales`, {}).then((t) => t.json());
};
class kD extends Nc {
  constructor(n) {
    super(n);
    Er(this, "handleClickShowPassword", () => {
      const { showPassword: n } = this.state;
      this.setState({ showPassword: !n });
    });
    Er(this, "validateEmail", () => {
      const { email: n, errors: r } = this.state, { t: a } = this.props, o = Nf(n);
      this.setState(() => ({
        errors: Xn(Fe({}, r), {
          email: a(o)
        })
      }));
    });
    Er(this, "validatePassword", () => {
      const { password: n, errors: r } = this.state, { t: a } = this.props, o = hq(n);
      this.setState(() => ({
        errors: Xn(Fe({}, r), {
          password: a(o)
        })
      }));
    });
    Er(this, "validateFields", () => {
      const { email: n, password: r, consents: a, consentDefinitions: o } = this.state, { t: s } = this.props, c = {
        email: s(Nf(n)),
        password: s(hq(r)),
        consents: s(Btt(a, o))
      };
      return this.setState({ errors: c }), !Object.keys(c).find((u) => c[u] !== "");
    });
    Er(this, "handleConsentsChange", (n, r) => {
      this.setState((a) => ({
        consents: n,
        consentDefinitions: r,
        errors: Xn(Fe({}, a.errors), {
          consents: ""
        })
      }));
    });
    Er(this, "handleSubmit", (n) => {
      n.preventDefault(), this.validateFields() && this.register();
    });
    Er(this, "register", () => st(this, null, function* () {
      const { email: n, password: r, consents: a, consentDefinitions: o } = this.state, { onSuccess: s, publisherId: c, t: u } = this.props;
      this.setState({
        processing: !0
      });
      const f = yield oat();
      if (!f.responseData)
        return this.setState({
          processing: !1,
          generalError: u("register-form.error.general", "An error occurred.")
        }), !1;
      const m = f.responseData, v = yield Zye(
        n,
        r,
        c,
        m.locale,
        m.country,
        m.currency
      );
      return v.status === 200 ? Ec.login(
        !1,
        !0,
        n,
        v.responseData.jwt,
        v.responseData.refreshToken,
        K6,
        [a, o],
        s
      ) : v.status === 422 ? v.errors[0].includes("Enterprise account is required") ? this.renderError(
        u(
          "register-form.error.account",
          'You would need our product <a href="https://cleeng.com/core-ott-subscriber-management" target="_blank">Core</a> to call this API'
        )
      ) : this.renderError(
        u("register-form.error.customer-exists", "Customer already exists.")
      ) : v.status === 429 ? (this.setState({ disableActionButton: !0 }), this.renderError(
        u(
          "register-form.error.server-overloaded",
          "Server overloaded. Please try again later."
        )
      ), setTimeout(() => {
        this.setState({
          disableActionButton: !1,
          generalError: ""
        });
      }, 10 * 1e3)) : this.setState({
        processing: !1,
        generalError: u("register-form.error.general", "An error occurred.")
      }), !0;
    }));
    Er(this, "renderError", (n = "An error occurred.") => {
      const { t: r } = this.props;
      this.setState({
        processing: !1,
        generalError: n || r("register-form.error.general", "An error occurred.")
      });
    });
    Er(this, "handlePasswordChange", (n) => {
      const { errors: r } = this.state;
      this.setState({
        password: n,
        errors: Xn(Fe({}, r), {
          password: ""
        })
      });
    });
    Er(this, "disabledRegisterButton", () => {
      this.setState({
        disableActionButton: !0
      });
    });
    this.state = {
      email: "",
      password: "",
      consents: [],
      errors: {
        email: "",
        password: "",
        consents: ""
      },
      generalError: "",
      showPassword: !1,
      consentDefinitions: [],
      processing: !1,
      disableActionButton: !1
    };
  }
  render() {
    const {
      email: n,
      password: r,
      errors: a,
      generalError: o,
      showPassword: s,
      disableActionButton: c,
      processing: u,
      publisherConsentsError: f
    } = this.state, { t: m } = this.props;
    return /* @__PURE__ */ C.jsxs(kle, { onSubmit: this.handleSubmit, noValidate: !0, children: [
      /* @__PURE__ */ C.jsx(Ale, { dangerouslySetInnerHTML: { __html: o } }),
      /* @__PURE__ */ C.jsx(
        pC,
        {
          label: m("register-form.label.email", "Email"),
          floatingLabels: !1,
          value: n,
          onChange: (v) => this.setState({ email: v }),
          onBlur: this.validateEmail,
          error: a.email
        }
      ),
      /* @__PURE__ */ C.jsx(
        G8,
        {
          label: m("register-form.label.password", "Password"),
          floatingLabels: !1,
          value: r,
          onChange: this.handlePasswordChange,
          onBlur: this.validatePassword,
          error: a.password,
          showVisibilityIcon: !0,
          showPassword: s,
          handleClickShowPassword: this.handleClickShowPassword,
          showPasswordStrength: !0,
          t: m
        }
      ),
      /* @__PURE__ */ C.jsx(
        aat,
        {
          t: m,
          error: a.consents,
          onChangeFn: this.handleConsentsChange
        }
      ),
      /* @__PURE__ */ C.jsx(
        zt,
        {
          type: "submit",
          size: "big",
          theme: "confirm",
          margin: "10px 0",
          disabled: u || c || f,
          children: u ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : m("register-form.button.register", "Register")
        }
      )
    ] });
  }
}
kD.propTypes = {
  publisherId: de.string,
  onSuccess: de.func,
  t: de.func
};
kD.defaultProps = {
  publisherId: "",
  onSuccess: () => null,
  t: (e) => e
};
const iat = (e) => ({
  publisherConsentsError: e.publisherConsents.error
}), sat = V6(iat)(kD);
class AD extends Nc {
  constructor(n) {
    super(n);
    Er(this, "setPublisherId", (n) => this.setState({ publisherId: n }));
    this.state = {
      publisherId: null
    };
  }
  componentDidMount() {
    const { urlProps: n } = this.props;
    n.location ? xle(n.location, this.setPublisherId) : this.setPublisherId(En("CLEENG_PUBLISHER_ID"));
  }
  render() {
    const { publisherId: n } = this.state, { t: r, onSuccess: a, onHaveAccountClick: o } = this.props;
    return /* @__PURE__ */ C.jsxs(Ele, { children: [
      /* @__PURE__ */ C.jsx(pl, {}),
      /* @__PURE__ */ C.jsxs(Ile, { children: [
        /* @__PURE__ */ C.jsx(sat, { t: r, publisherId: n, onSuccess: a }),
        /* @__PURE__ */ C.jsx(
          zt,
          {
            theme: "secondary",
            size: "big",
            onClickFn: () => o(),
            children: r("register.button.have-an-account", "Have an account?")
          }
        )
      ] }),
      /* @__PURE__ */ C.jsx(yu, {})
    ] });
  }
}
AD.propTypes = {
  urlProps: de.shape({
    location: de.shape({ search: de.string })
  }),
  onSuccess: de.func,
  onHaveAccountClick: de.func,
  t: de.func
};
AD.defaultProps = {
  urlProps: {},
  onSuccess: () => null,
  onHaveAccountClick: () => null,
  t: (e) => e
};
const lat = o1()(AD), Nle = (e) => (n) => {
  var t = u0(n, []);
  var s, c;
  const r = Jo(), a = typeof window == "object" && ((s = new URLSearchParams(window.location.search)) == null ? void 0 : s.get("redirectResult")), o = typeof window == "object" && ((c = new URLSearchParams(window == null ? void 0 : window.location.search)) == null ? void 0 : c.get("paymentMethodId"));
  return mn(() => {
    a && o && (r(LR(R4.paymentInfo)), r(
      pi({
        isOpen: !0,
        isLoading: !0,
        step: js.FINALIZE_ADYEN
      })
    ));
  }, []), /* @__PURE__ */ C.jsx(e, Fe({}, t));
}, uat = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 24.713, height: 24.713, viewBox: "0 0 24.713 24.713" }, e), /* @__PURE__ */ k.createElement("path", { id: "Icon_material-subscriptions", "data-name": "Icon material-subscriptions", d: "M25.242,10.414H5.471V7.943h19.77ZM22.77,3H7.943V5.471H22.77Zm4.943,12.356v9.885a2.479,2.479,0,0,1-2.471,2.471H5.471A2.479,2.479,0,0,1,3,25.242V15.356a2.479,2.479,0,0,1,2.471-2.471h19.77A2.479,2.479,0,0,1,27.713,15.356ZM20.3,20.3l-7.414-4.041v8.069Z", transform: "translate(-3 -3)", fill: "#fff" })), cat = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 30, height: 24, viewBox: "0 0 30 24" }, e), /* @__PURE__ */ k.createElement("path", { id: "Icon_material-payment", "data-name": "Icon material-payment", d: "M30,6H6A2.977,2.977,0,0,0,3.015,9L3,27a2.99,2.99,0,0,0,3,3H30a2.99,2.99,0,0,0,3-3V9A2.99,2.99,0,0,0,30,6Zm0,21H6V18H30Zm0-15H6V9H30Z", transform: "translate(-3 -6)", fill: "#fff" })), dat = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 26.992, height: 20.244, viewBox: "0 0 26.992 20.244" }, e), /* @__PURE__ */ k.createElement("path", { id: "Icon_metro-profile", "data-name": "Icon metro-profile", d: "M29.563,9.6l-1.888,1V7.772l-3.9-.06L23.8,10.6H12.09l.08-2.892-3.816.06v2.892L6.427,10.6A1.929,1.929,0,0,0,4.5,12.532v13.5a1.929,1.929,0,0,0,1.928,1.928H29.563a1.929,1.929,0,0,0,1.928-1.928v-13.5C31.491,11.468,30.627,9.6,29.563,9.6Zm-4.82-.928h1.928v3.856H24.743ZM12.211,15.243c1.165,0,2.109,1.241,2.109,2.772s-.945,2.772-2.109,2.772S10.1,19.545,10.1,18.015s.945-2.772,2.109-2.772ZM9.319,8.676h1.928v3.856H9.319ZM8.034,24.05s.228-1.834.748-2.18a7.393,7.393,0,0,1,2.015-.576s.97,1.036,1.382,1.036,1.381-1.036,1.381-1.036a7.371,7.371,0,0,1,2.016.576c.61.407.763,2.18.763,2.18H8.034Zm19.6-.914H18.959v-.964h8.676Zm0-1.928H18.959v-.964h8.676Zm0-1.928H18.959v-.964h8.676Zm0-1.928H18.959v-.964h8.676Z", transform: "translate(-4.499 -7.712)", fill: "#fff" })), fat = [
  {
    id: "planDetails",
    icon: uat,
    label: "Plan Details",
    link: "plan-details",
    translationKey: "menuitem.plan-details",
    visibleOnDesktop: !0
  },
  {
    id: "paymentInfo",
    icon: cat,
    label: "Your Payments",
    link: "payment-info",
    translationKey: "menuitem.your-payments",
    visibleOnDesktop: !0
  },
  {
    id: "updateProfile",
    icon: dat,
    label: "Update Profile",
    link: "update-profile",
    translationKey: "menuitem.update-profile",
    visibleOnDesktop: !0
  }
], pat = W.nav`
  padding: 10px 0;

  ${Zr.small`
    padding: 26px 0;
  `}
`, hat = W.div.attrs(() => ({
  className: "msd__account-sidebar__items"
}))`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${Zr.smallest`
    justify-content: flex-start;
  `}

  ${Zr.small`
    flex-direction: column;
  `}
`, mat = W.div.attrs(() => ({
  className: "msd__account-sidebar__item"
}))`
  ${(e) => !e.$visibleOnDesktop && ot`
      ${Zr.small`
        display: none;
      `}
    `}

  &.active {
    opacity: 1;
  }

  ${Zr.smallest`
      margin-right: 16px;
  `}

  ${Zr.small`
    margin-right: 0;
  `}
`, Tle = W.div.attrs(() => ({
  className: "msd__account-sidebar__icon"
}))`
  display: none;
  justify-content: center;
  align-items: center;

  path {
    opacity: 0.4;
    fill: ${Oee};
  }

  ${Zr.small`
    display: flex;
    border: 0;
    height: 50px;
    width: 30px;
  `}
`, tR = W.div.attrs(() => ({
  className: "msd__account-sidebar__label"
}))`
  opacity: 0.4;
  width: auto;
  margin: auto;

  color: ${Et};
  font-size: 13px;

  font-weight: 700;
  line-height: 21px;

  transition: all 0.1s ease-in-out;

  &:after {
    display: block;
    content: '';
    border-bottom: 2px solid ${An};
    transform: scaleX(0);
    transition: transform 250ms ease-in-out;
    transform-origin: 0% 50%;

    ${h1() && ot`
      transform-origin: 100% 50%;
    `}
  }

  ${Zr.small`
    margin: auto 20px auto 20px;
    font-size: 15px;
  `}
`, vat = W.div.attrs(() => ({
  className: "msd__account-sidebar__item"
}))`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 12px 0;
  border-radius: 12px;

  transition: opacity 0.1s;

  &:hover {
    cursor: pointer;
    ${tR} {
      &:after {
        transform: scaleX(1);
      }
      opacity: 1;
    }
  }

  ${(e) => e.$isActive && ot`
      ${Tle} {
        path {
          opacity: 1;
          fill: ${An};
        }
      }

      ${tR} {
        &:after {
          transform: scaleX(1);
        }
        opacity: 1;
      }
    `}

  ${Zr.small`
    flex-direction: row;
    align-items: center;

    padding: 0 26px 0 0;
    margin-bottom: 16px;

    border-radius: 8px;
  `}
`, gat = () => {
  const { activeTab: e } = wr((a) => a.myaccount), t = Jo(), n = (a) => {
    t(LR(a));
  }, { t: r } = tn();
  return /* @__PURE__ */ C.jsx(pat, { children: /* @__PURE__ */ C.jsx(hat, { children: fat.map(
    ({ icon: a, label: o, visibleOnDesktop: s, id: c, translationKey: u }) => {
      const f = a || vo.Fragment;
      return /* @__PURE__ */ C.jsx(
        mat,
        {
          $visibleOnDesktop: s,
          onClick: () => n(c),
          children: /* @__PURE__ */ C.jsxs(vat, { $isActive: e === c, children: [
            /* @__PURE__ */ C.jsx(Tle, { children: /* @__PURE__ */ C.jsx(f, {}) }),
            /* @__PURE__ */ C.jsx(tR, { children: r(u, o) })
          ] })
        },
        o
      );
    }
  ) }) });
}, yat = "data:image/svg+xml;base64,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", bat = W.header.attrs(() => ({
  className: "msd__account-header"
}))`
  display: flex;
  flex-direction: row;

  padding-bottom: 10px;

  ${Zr.small`
    flex-direction: column;
    align-items: center;
    border-bottom: 1px solid ${Gn};
    padding-bottom: 26px;
  `}
`, _at = W.div.attrs(() => ({
  className: "msd__account-header__avatar"
}))`
  width: 64px;
  height: 64px;
  min-width: 64px;

  border-radius: 50%;
  background-image: url(${yat});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  ${Zr.small`
    width: 84px;
    height: 84px;
    margin-bottom: 20px;
  `}
`, Ole = W.div.attrs(() => ({
  className: "msd__account-header__name"
}))`
  max-width: 100%;

  margin-bottom: 6px;

  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  color: ${Et};
  text-overflow: ellipsis;
  overflow: hidden;

  ${Zr.small`
    font-size: 26px;
    line-height: 29px;
    margin-bottom: 10px;
    text-align: center;
  `};
`, Rle = W.div.attrs(() => ({
  className: "msd__account-header__mail"
}))`
  max-width: 100%;

  margin-bottom: 6px;

  color: ${Et};

  font-size: ${A2};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;

  ${(e) => e.$bigger && ot`
      font-size: 14px;
      font-weight: 700;
    `}

  ${Zr.small`
    margin-bottom: 14px;
  `}
`, Mle = W.div.attrs(() => ({
  className: "msd__account-header__label"
}))`
  padding: 5px 16px;
  background-color: #f0f0ff;
  border-radius: 14px;
  border: 1px solid #d7d7f5;
  color: #7172c9;
  font-size: 9px;
  line-height: 12px;
  text-align: center;
  font-weight: ${Yp};
  min-height: 19px;
  max-width: max-content;
`, Cat = W.div.attrs(() => ({
  className: "msd__account-header__wrapper"
}))`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;

  max-width: calc(100% - 78px);
  margin-left: 14px;

  color: ${Et};

  ${(e) => e.$isEmpty && ot`
      ${Ole} {
        background-color: ${FV};
        width: 100%;
        border-radius: 10px;

        min-height: 24px;
      }
      ${Rle} {
        background-color: ${FV};
        width: 100%;
        border-radius: 5px;
      }
      ${Mle} {
        width: 100%;
      }
    `}

  ${Zr.small`
    width: 100%;
    max-width: unset;
    align-items: center;
  
    margin-left: 0;
  `}
`, wat = () => {
  const { user: e } = wr((s) => s.userProfile), {
    data: [t]
  } = wr((s) => s.plan.currentPlan), { t: n } = tn(), r = !!e, a = t && n(`offer-title-${t.offerId}`, t.offerTitle), o = (e == null ? void 0 : e.firstName) || (e == null ? void 0 : e.lastName);
  return /* @__PURE__ */ C.jsxs(bat, { children: [
    /* @__PURE__ */ C.jsx(
      Zn,
      {
        showChildren: r,
        circle: !0,
        width: 80,
        height: 80,
        children: /* @__PURE__ */ C.jsx(_at, {})
      }
    ),
    /* @__PURE__ */ C.jsxs(Cat, { $isEmpty: !(e != null && e.email), children: [
      /* @__PURE__ */ C.jsx(Zn, { showChildren: r, height: 26, children: o && /* @__PURE__ */ C.jsx(Ole, { children: `${e == null ? void 0 : e.firstName} ${e == null ? void 0 : e.lastName}` }) }),
      /* @__PURE__ */ C.jsx(Zn, { showChildren: r, children: /* @__PURE__ */ C.jsx(Rle, { $bigger: !o, children: e == null ? void 0 : e.email }) }),
      /* @__PURE__ */ C.jsx(Zn, { showChildren: r, height: 36, margin: "0", children: a && /* @__PURE__ */ C.jsx(Mle, { children: a }) })
    ] })
  ] });
}, Sat = W.main.attrs(() => ({
  className: "msd__account-content"
}))`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 100%;

  padding: 35px 26px;

  background-color: ${Br};
  border-top: 1px solid ${Gn};
  border-left: none;

  ${Zr.small`
    border-left: 1px solid ${Gn};
    border-top: none;
    padding: 35px;
  `}
`, PD = ({ children: e }) => /* @__PURE__ */ C.jsx(Sat, { children: e });
PD.propTypes = {
  children: de.oneOfType([de.string, de.element])
};
PD.defaultProps = {
  children: ""
};
const xat = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 88.77, height: 55.519, viewBox: "0 0 88.77 55.519" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_1866", "data-name": "Group 1866", transform: "translate(-1938.476 -906.047)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1360", "data-name": "Path 1360", d: "M4165.574-315.591", transform: "translate(-2154.01 1261.792)", fill: "#f2f5fc", stroke: "#838eaa", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 17 }), /* @__PURE__ */ k.createElement("g", { id: "Group_1841", "data-name": "Group 1841", transform: "translate(1948.127 912.044)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1838", "data-name": "Group 1838", transform: "translate(0)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1807", "data-name": "Group 1807", transform: "translate(9.836)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1796", "data-name": "Group 1796" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1793", "data-name": "Group 1793" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1792", "data-name": "Group 1792" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1374", "data-name": "Path 1374", d: "M3853.291-757.214h-4.766a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h4.766a1.382,1.382,0,0,0,1.381-1.38v-7.907a7.824,7.824,0,0,1-4.821-2.467,7.826,7.826,0,0,1-2.084-5.326,7.826,7.826,0,0,1,2.084-5.326,7.824,7.824,0,0,1,4.821-2.467v-7.907a1.382,1.382,0,0,0-1.381-1.38h-55.372a1.382,1.382,0,0,0-1.38,1.38v1.033a.762.762,0,0,1-.762.762.762.762,0,0,1-.762-.762v-1.033a2.908,2.908,0,0,1,2.9-2.9h55.372a2.908,2.908,0,0,1,2.9,2.9v8.183a1.224,1.224,0,0,1-1.115,1.213,6.3,6.3,0,0,0-4.111,2.011,6.307,6.307,0,0,0-1.679,4.292,6.307,6.307,0,0,0,1.679,4.292,6.3,6.3,0,0,0,4.111,2.011,1.224,1.224,0,0,1,1.115,1.213v8.183A2.908,2.908,0,0,1,3853.291-757.214Z", transform: "translate(-3795.015 794.422)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1795", "data-name": "Group 1795", transform: "translate(0 10.777)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1794", "data-name": "Group 1794" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1375", "data-name": "Path 1375", d: "M3797.919-612.382a2.908,2.908,0,0,1-2.9-2.9v-8.181a1.223,1.223,0,0,1,1.12-1.214,6.3,6.3,0,0,0,4.129-2,6.3,6.3,0,0,0,1.688-4.3,6.3,6.3,0,0,0-1.688-4.3,6.3,6.3,0,0,0-4.129-2,.762.762,0,0,1-.7-.82.762.762,0,0,1,.82-.7,7.823,7.823,0,0,1,5.125,2.486,7.823,7.823,0,0,1,2.094,5.338,7.823,7.823,0,0,1-2.094,5.338,7.823,7.823,0,0,1-4.843,2.459v7.9a1.382,1.382,0,0,0,1.38,1.38.762.762,0,0,1,.762.762A.762.762,0,0,1,3797.919-612.382Z", transform: "translate(-3795.015 638.812)", fill: "#838eaa" })))), /* @__PURE__ */ k.createElement("g", { id: "Group_1798", "data-name": "Group 1798", transform: "translate(13.267 0.244)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1797", "data-name": "Group 1797" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1376", "data-name": "Path 1376", d: "M3987.337-786.524a.762.762,0,0,1-.762-.762v-2.851a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v2.851A.762.762,0,0,1,3987.337-786.524Z", transform: "translate(-3986.575 790.899)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1800", "data-name": "Group 1800", transform: "translate(13.267 7.901)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1799", "data-name": "Group 1799" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1377", "data-name": "Path 1377", d: "M3987.337-674.211a.762.762,0,0,1-.762-.762v-4.605a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v4.605A.762.762,0,0,1,3987.337-674.211Z", transform: "translate(-3986.575 680.34)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1802", "data-name": "Group 1802", transform: "translate(13.267 15.558)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1801", "data-name": "Group 1801" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1378", "data-name": "Path 1378", d: "M3987.337-563.651a.762.762,0,0,1-.762-.762v-4.605a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v4.605A.762.762,0,0,1,3987.337-563.651Z", transform: "translate(-3986.575 569.78)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1804", "data-name": "Group 1804", transform: "translate(13.267 23.216)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1803", "data-name": "Group 1803" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1379", "data-name": "Path 1379", d: "M3987.337-453.092a.762.762,0,0,1-.762-.762v-4.605a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v4.605A.762.762,0,0,1,3987.337-453.092Z", transform: "translate(-3986.575 459.221)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1806", "data-name": "Group 1806", transform: "translate(13.267 30.873)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1805", "data-name": "Group 1805", transform: "translate(0 0)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1380", "data-name": "Path 1380", d: "M3987.337-342.533a.762.762,0,0,1-.762-.762V-347.9a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v4.605A.762.762,0,0,1,3987.337-342.533Z", transform: "translate(-3986.575 348.662)", fill: "#838eaa" })))), /* @__PURE__ */ k.createElement("g", { id: "Group_1827", "data-name": "Group 1827", transform: "translate(0 5.917)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1811", "data-name": "Group 1811" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1810", "data-name": "Group 1810" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1808", "data-name": "Group 1808", transform: "translate(0.762 0.762)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1381", "data-name": "Path 1381", d: "M3716.749-680.154a7.088,7.088,0,0,1,6.488-7.062.455.455,0,0,0,.417-.454v-8.183a2.142,2.142,0,0,0-2.143-2.142h-55.372a2.142,2.142,0,0,0-2.142,2.142v8.181a.455.455,0,0,0,.418.454,7.088,7.088,0,0,1,6.518,7.065,7.088,7.088,0,0,1-6.518,7.065.455.455,0,0,0-.418.454v8.181a2.142,2.142,0,0,0,2.142,2.142h55.372a2.142,2.142,0,0,0,2.143-2.142v-8.184a.455.455,0,0,0-.417-.454A7.088,7.088,0,0,1,3716.749-680.154Z", transform: "translate(-3663.997 697.996)", fill: "#f2f5fc" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1809", "data-name": "Group 1809" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1382", "data-name": "Path 1382", d: "M3711.274-671.788H3655.9a2.907,2.907,0,0,1-2.9-2.9v-8.181a1.223,1.223,0,0,1,1.12-1.214,6.3,6.3,0,0,0,4.129-2,6.3,6.3,0,0,0,1.688-4.3,6.3,6.3,0,0,0-1.688-4.3,6.3,6.3,0,0,0-4.129-2,1.223,1.223,0,0,1-1.12-1.214v-8.181a2.907,2.907,0,0,1,2.9-2.9h55.372a2.907,2.907,0,0,1,2.9,2.9v8.183a1.224,1.224,0,0,1-1.115,1.213,6.3,6.3,0,0,0-4.111,2.011,6.3,6.3,0,0,0-1.679,4.292,6.3,6.3,0,0,0,1.679,4.292,6.3,6.3,0,0,0,4.111,2.011,1.224,1.224,0,0,1,1.115,1.213v8.183A2.907,2.907,0,0,1,3711.274-671.788ZM3654.521-682.6v7.9a1.382,1.382,0,0,0,1.381,1.38h55.372a1.382,1.382,0,0,0,1.38-1.38V-682.6a7.823,7.823,0,0,1-4.821-2.467,7.825,7.825,0,0,1-2.084-5.326,7.825,7.825,0,0,1,2.084-5.326,7.823,7.823,0,0,1,4.821-2.467v-7.907a1.382,1.382,0,0,0-1.38-1.38H3655.9a1.382,1.382,0,0,0-1.381,1.38v7.9a7.823,7.823,0,0,1,4.842,2.459,7.824,7.824,0,0,1,2.094,5.338,7.824,7.824,0,0,1-2.094,5.338A7.823,7.823,0,0,1,3654.521-682.6Zm58.415.025h0Z", transform: "translate(-3652.998 708.996)", fill: "#838eaa" })))), /* @__PURE__ */ k.createElement("g", { id: "Group_1814", "data-name": "Group 1814", transform: "translate(13.267 0.244)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1812", "data-name": "Group 1812", transform: "translate(0.762 0.762)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_11", "data-name": "Line 11", y2: 4.605, fill: "#fff" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1813", "data-name": "Group 1813" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1383", "data-name": "Path 1383", d: "M3845.318-699.344a.762.762,0,0,1-.762-.762v-4.605a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v4.605A.762.762,0,0,1,3845.318-699.344Z", transform: "translate(-3844.556 705.473)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1817", "data-name": "Group 1817", transform: "translate(13.267 7.901)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1815", "data-name": "Group 1815", transform: "translate(0.762 0.762)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_12", "data-name": "Line 12", y2: 4.605, fill: "#fff" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1816", "data-name": "Group 1816" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1384", "data-name": "Path 1384", d: "M3845.318-588.784a.762.762,0,0,1-.762-.762v-4.605a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v4.605A.762.762,0,0,1,3845.318-588.784Z", transform: "translate(-3844.556 594.913)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1820", "data-name": "Group 1820", transform: "translate(13.267 15.558)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1818", "data-name": "Group 1818", transform: "translate(0.762 0.762)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_13", "data-name": "Line 13", y2: 4.605, fill: "#fff" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1819", "data-name": "Group 1819" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1385", "data-name": "Path 1385", d: "M3845.318-478.225a.762.762,0,0,1-.762-.762v-4.605a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v4.605A.762.762,0,0,1,3845.318-478.225Z", transform: "translate(-3844.556 484.354)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1823", "data-name": "Group 1823", transform: "translate(13.267 23.216)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1821", "data-name": "Group 1821", transform: "translate(0.762 0.762)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_14", "data-name": "Line 14", y2: 4.605, fill: "#fff" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1822", "data-name": "Group 1822" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1386", "data-name": "Path 1386", d: "M3845.318-367.666a.762.762,0,0,1-.762-.762v-4.605a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v4.605A.762.762,0,0,1,3845.318-367.666Z", transform: "translate(-3844.556 373.795)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1826", "data-name": "Group 1826", transform: "translate(13.267 30.873)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1824", "data-name": "Group 1824", transform: "translate(0.762 0.762)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_15", "data-name": "Line 15", y2: 4.605, fill: "#fff" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1825", "data-name": "Group 1825" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1387", "data-name": "Path 1387", d: "M3845.318-257.106a.762.762,0,0,1-.762-.762v-4.605a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v4.605A.762.762,0,0,1,3845.318-257.106Z", transform: "translate(-3844.556 263.235)", fill: "#838eaa" })))), /* @__PURE__ */ k.createElement("g", { id: "Group_1837", "data-name": "Group 1837", transform: "translate(24.984 17.428)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1829", "data-name": "Group 1829", transform: "translate(0.362 7.298)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1828", "data-name": "Group 1828" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1388", "data-name": "Path 1388", d: "M4036.681-429.791a.762.762,0,0,1-.722-.52,8.177,8.177,0,0,0-7.76-5.577,8.179,8.179,0,0,0-7.756,5.564.762.762,0,0,1-.966.478.762.762,0,0,1-.478-.966,9.7,9.7,0,0,1,9.2-6.6,9.7,9.7,0,0,1,9.2,6.616.762.762,0,0,1-.48.965A.759.759,0,0,1,4036.681-429.791Z", transform: "translate(-4018.959 437.412)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1836", "data-name": "Group 1836" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1832", "data-name": "Group 1832" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1830", "data-name": "Group 1830", transform: "translate(0.028 0.028)" }, /* @__PURE__ */ k.createElement("circle", { id: "Ellipse_371", "data-name": "Ellipse 371", cx: 2.039, cy: 2.039, r: 2.039, fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1831", "data-name": "Group 1831" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1389", "data-name": "Path 1389", d: "M4015.8-538.648a2.069,2.069,0,0,1-2.067-2.067,2.069,2.069,0,0,1,2.067-2.067,2.069,2.069,0,0,1,2.067,2.067A2.069,2.069,0,0,1,4015.8-538.648Zm0-4.078a2.013,2.013,0,0,0-2.011,2.011,2.013,2.013,0,0,0,2.011,2.011,2.013,2.013,0,0,0,2.011-2.011A2.013,2.013,0,0,0,4015.8-542.726Z", transform: "translate(-4013.731 542.782)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1835", "data-name": "Group 1835", transform: "translate(15.075)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1833", "data-name": "Group 1833", transform: "translate(0.028 0.028)" }, /* @__PURE__ */ k.createElement("circle", { id: "Ellipse_372", "data-name": "Ellipse 372", cx: 2.039, cy: 2.039, r: 2.039, fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1834", "data-name": "Group 1834" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1390", "data-name": "Path 1390", d: "M4233.462-538.648a2.069,2.069,0,0,1-2.067-2.067,2.069,2.069,0,0,1,2.067-2.067,2.069,2.069,0,0,1,2.066,2.067A2.069,2.069,0,0,1,4233.462-538.648Zm0-4.078a2.014,2.014,0,0,0-2.012,2.011,2.014,2.014,0,0,0,2.012,2.011,2.013,2.013,0,0,0,2.011-2.011A2.013,2.013,0,0,0,4233.462-542.726Z", transform: "translate(-4231.396 542.782)", fill: "#838eaa" })))))), /* @__PURE__ */ k.createElement("g", { id: "Group_1840", "data-name": "Group 1840", transform: "translate(62.309 37.098)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1839", "data-name": "Group 1839" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1391", "data-name": "Path 1391", d: "M4552.656-258.784", transform: "translate(-4552.656 258.784)", fill: "#f2f5fc", stroke: "#838eaa", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 17 })))), /* @__PURE__ */ k.createElement("g", { id: "Group_1848", "data-name": "Group 1848", transform: "translate(2017.843 952.162)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1844", "data-name": "Group 1844", transform: "translate(0 3.94)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1842", "data-name": "Group 1842" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1392", "data-name": "Path 1392", d: "M4661.925-156.765h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,4661.925-156.765Z", transform: "translate(-4659.591 158.289)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1843", "data-name": "Group 1843", transform: "translate(6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1393", "data-name": "Path 1393", d: "M4753.007-156.765h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,4753.007-156.765Z", transform: "translate(-4750.673 158.289)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1847", "data-name": "Group 1847", transform: "translate(3.94 0)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1845", "data-name": "Group 1845" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1394", "data-name": "Path 1394", d: "M4717.243-212.082a.761.761,0,0,1-.762-.762v-1.572a.761.761,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,4717.243-212.082Z", transform: "translate(-4716.481 215.178)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1846", "data-name": "Group 1846", transform: "translate(0 6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1395", "data-name": "Path 1395", d: "M4717.243-121a.761.761,0,0,1-.762-.762v-1.572a.761.761,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,4717.243-121Z", transform: "translate(-4716.481 124.097)", fill: "#838eaa" })))), /* @__PURE__ */ k.createElement("g", { id: "Group_1855", "data-name": "Group 1855", transform: "translate(1938.476 906.047)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1851", "data-name": "Group 1851", transform: "translate(0 3.94)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1849", "data-name": "Group 1849" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1396", "data-name": "Path 1396", d: "M3515.983-822.6h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,3515.983-822.6Z", transform: "translate(-3513.649 824.122)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1850", "data-name": "Group 1850", transform: "translate(6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1397", "data-name": "Path 1397", d: "M3607.064-822.6h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,3607.064-822.6Z", transform: "translate(-3604.73 824.122)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1854", "data-name": "Group 1854", transform: "translate(3.94 0)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1852", "data-name": "Group 1852" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1398", "data-name": "Path 1398", d: "M3571.3-877.916a.762.762,0,0,1-.762-.762v-1.572a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,3571.3-877.916Z", transform: "translate(-3570.539 881.012)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1853", "data-name": "Group 1853", transform: "translate(0 6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1399", "data-name": "Path 1399", d: "M3571.3-786.834a.762.762,0,0,1-.762-.762v-1.572a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,3571.3-786.834Z", transform: "translate(-3570.539 789.93)", fill: "#838eaa" })))))), Dle = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 97.932, height: 72.207, viewBox: "0 0 97.932 72.207" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_2086", "data-name": "Group 2086", transform: "translate(-3317.786 -3998.162)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2085", "data-name": "Group 2085", transform: "translate(1330.47 -299)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2056", "data-name": "Group 2056", transform: "translate(2013.706 4365.977)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1566", "data-name": "Path 1566", d: "M6693.526,6134.149h0l-46.214-.058a.622.622,0,1,1,0-1.245h0l46.214.058a.623.623,0,0,1,0,1.245Z", transform: "translate(-6646.689 -6132.846)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2081", "data-name": "Group 2081" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1882", "data-name": "Group 1882", transform: "translate(51.001 3405)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1360", "data-name": "Path 1360", d: "M4165.574-315.591", transform: "translate(-2154.01 1261.792)", fill: "#f2f5fc", stroke: "#838eaa", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 17 }), /* @__PURE__ */ k.createElement("g", { id: "Group_1848", "data-name": "Group 1848", transform: "translate(2024.843 892.162)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1844", "data-name": "Group 1844", transform: "translate(0 3.94)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1842", "data-name": "Group 1842" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1392", "data-name": "Path 1392", d: "M4661.925-156.765h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,4661.925-156.765Z", transform: "translate(-4659.591 158.289)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1843", "data-name": "Group 1843", transform: "translate(6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1393", "data-name": "Path 1393", d: "M4753.007-156.765h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,4753.007-156.765Z", transform: "translate(-4750.673 158.289)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1847", "data-name": "Group 1847", transform: "translate(3.94 0)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1845", "data-name": "Group 1845" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1394", "data-name": "Path 1394", d: "M4717.243-212.082a.761.761,0,0,1-.762-.762v-1.572a.761.761,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,4717.243-212.082Z", transform: "translate(-4716.481 215.178)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1846", "data-name": "Group 1846", transform: "translate(0 6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1395", "data-name": "Path 1395", d: "M4717.243-121a.761.761,0,0,1-.762-.762v-1.572a.761.761,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,4717.243-121Z", transform: "translate(-4716.481 124.097)", fill: "#838eaa" })))), /* @__PURE__ */ k.createElement("g", { id: "Group_1855", "data-name": "Group 1855", transform: "translate(1940.178 952.099) rotate(45)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1851", "data-name": "Group 1851", transform: "translate(0 3.94)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1849", "data-name": "Group 1849" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1396", "data-name": "Path 1396", d: "M3515.983-822.6h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,3515.983-822.6Z", transform: "translate(-3513.649 824.122)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1850", "data-name": "Group 1850", transform: "translate(6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1397", "data-name": "Path 1397", d: "M3607.064-822.6h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,3607.064-822.6Z", transform: "translate(-3604.73 824.122)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1854", "data-name": "Group 1854", transform: "translate(3.94 0)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1852", "data-name": "Group 1852" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1398", "data-name": "Path 1398", d: "M3571.3-877.916a.762.762,0,0,1-.762-.762v-1.572a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,3571.3-877.916Z", transform: "translate(-3570.539 881.012)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1853", "data-name": "Group 1853", transform: "translate(0 6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1399", "data-name": "Path 1399", d: "M3571.3-786.834a.762.762,0,0,1-.762-.762v-1.572a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,3571.3-786.834Z", transform: "translate(-3570.539 789.93)", fill: "#838eaa" }))))), /* @__PURE__ */ k.createElement("g", { id: "Ellipse_378", "data-name": "Ellipse 378", transform: "translate(1991.001 4303)", fill: "none", stroke: "#838eaa", strokeWidth: 1 }, /* @__PURE__ */ k.createElement("circle", { cx: 3, cy: 3, r: 3, stroke: "none" }), /* @__PURE__ */ k.createElement("circle", { cx: 3, cy: 3, r: 2.5, fill: "none" })), /* @__PURE__ */ k.createElement("g", { id: "Ellipse_383", "data-name": "Ellipse 383", transform: "translate(2078.001 4357)", fill: "none", stroke: "#838eaa", strokeWidth: 1 }, /* @__PURE__ */ k.createElement("circle", { cx: 3, cy: 3, r: 3, stroke: "none" }), /* @__PURE__ */ k.createElement("circle", { cx: 3, cy: 3, r: 2.5, fill: "none" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2055", "data-name": "Group 2055", transform: "translate(2036.813 4359.766)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1565", "data-name": "Path 1565", d: "M6962.974,6055.68a.623.623,0,0,1-.623-.623v-6.434a.622.622,0,0,1,1.245,0v6.434A.622.622,0,0,1,6962.974,6055.68Z", transform: "translate(-6962.351 -6048.002)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2060", "data-name": "Group 2060", transform: "translate(2045.232 4331.462)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2059", "data-name": "Group 2059" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1568", "data-name": "Path 1568", d: "M7087.538,5666.02a.624.624,0,0,1-.59-.424,4.417,4.417,0,0,0-8.37-.008.622.622,0,1,1-1.179-.4,5.662,5.662,0,0,1,10.729.009.624.624,0,0,1-.591.821Z", transform: "translate(-7077.366 -5661.342)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_2061", "data-name": "Group 2061", transform: "translate(2008 4325.831)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1569", "data-name": "Path 1569", d: "M6625.2,5600.334h-54.024a2.426,2.426,0,0,1-2.423-2.423v-11.074a2.425,2.425,0,0,1,2.423-2.423H6625.2a2.425,2.425,0,0,1,2.423,2.423v11.074A2.426,2.426,0,0,1,6625.2,5600.334Zm-54.024-14.675a1.18,1.18,0,0,0-1.179,1.178v11.074a1.18,1.18,0,0,0,1.179,1.179H6625.2a1.18,1.18,0,0,0,1.178-1.179v-11.074a1.18,1.18,0,0,0-1.178-1.178Z", transform: "translate(-6568.748 -5584.415)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2062", "data-name": "Group 2062", transform: "translate(2013.619 4330.577)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1570", "data-name": "Path 1570", d: "M6646.347,5655.7a.842.842,0,0,1-.842-.842V5650.1a.842.842,0,0,1,1.684,0v4.763A.842.842,0,0,1,6646.347,5655.7Z", transform: "translate(-6645.505 -5649.257)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2063", "data-name": "Group 2063", transform: "translate(2018.228 4330.577)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1571", "data-name": "Path 1571", d: "M6709.313,5655.7a.842.842,0,0,1-.842-.842V5650.1a.842.842,0,0,1,1.684,0v4.763A.842.842,0,0,1,6709.313,5655.7Z", transform: "translate(-6708.471 -5649.257)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2064", "data-name": "Group 2064", transform: "translate(2022.53 4330.577)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1572", "data-name": "Path 1572", d: "M6768.08,5655.7a.842.842,0,0,1-.842-.842V5650.1a.842.842,0,0,1,1.684,0v4.763A.842.842,0,0,1,6768.08,5655.7Z", transform: "translate(-6767.238 -5649.257)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2065", "data-name": "Group 2065", transform: "translate(2027.447 4330.577)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1573", "data-name": "Path 1573", d: "M6835.243,5655.7a.842.842,0,0,1-.841-.842V5650.1a.842.842,0,1,1,1.683,0v4.763A.842.842,0,0,1,6835.243,5655.7Z", transform: "translate(-6834.402 -5649.257)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2067", "data-name": "Group 2067", transform: "translate(2008 4342.931)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1574", "data-name": "Path 1574", d: "M6625.2,5833.938h-54.024a2.426,2.426,0,0,1-2.423-2.423v-11.073a2.426,2.426,0,0,1,2.423-2.424H6625.2a2.426,2.426,0,0,1,2.423,2.424v11.073A2.426,2.426,0,0,1,6625.2,5833.938Zm-54.024-14.676a1.181,1.181,0,0,0-1.179,1.18v11.073a1.18,1.18,0,0,0,1.179,1.178H6625.2a1.179,1.179,0,0,0,1.178-1.178v-11.073a1.181,1.181,0,0,0-1.178-1.18Z", transform: "translate(-6568.748 -5818.018)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2068", "data-name": "Group 2068", transform: "translate(2013.619 4347.677)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1575", "data-name": "Path 1575", d: "M6646.347,5889.3a.841.841,0,0,1-.842-.841V5883.7a.842.842,0,1,1,1.684,0v4.763A.841.841,0,0,1,6646.347,5889.3Z", transform: "translate(-6645.505 -5882.858)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2069", "data-name": "Group 2069", transform: "translate(2018.228 4347.677)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1576", "data-name": "Path 1576", d: "M6709.313,5889.3a.841.841,0,0,1-.842-.841V5883.7a.842.842,0,1,1,1.684,0v4.763A.841.841,0,0,1,6709.313,5889.3Z", transform: "translate(-6708.471 -5882.858)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2070", "data-name": "Group 2070", transform: "translate(2022.53 4347.677)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1577", "data-name": "Path 1577", d: "M6768.08,5889.3a.841.841,0,0,1-.842-.841V5883.7a.842.842,0,1,1,1.684,0v4.763A.841.841,0,0,1,6768.08,5889.3Z", transform: "translate(-6767.238 -5882.858)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2071", "data-name": "Group 2071", transform: "translate(2027.447 4347.677)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1578", "data-name": "Path 1578", d: "M6835.243,5889.3a.841.841,0,0,1-.841-.841V5883.7a.842.842,0,1,1,1.683,0v4.763A.841.841,0,0,1,6835.243,5889.3Z", transform: "translate(-6834.402 -5882.858)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2073", "data-name": "Group 2073", transform: "translate(2008 4308.73)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1579", "data-name": "Path 1579", d: "M6625.2,5366.733h-54.024a2.426,2.426,0,0,1-2.423-2.423v-11.073a2.426,2.426,0,0,1,2.423-2.423H6625.2a2.426,2.426,0,0,1,2.423,2.423v11.073A2.426,2.426,0,0,1,6625.2,5366.733Zm-54.024-14.675a1.18,1.18,0,0,0-1.179,1.179v11.073a1.18,1.18,0,0,0,1.179,1.179H6625.2a1.18,1.18,0,0,0,1.178-1.179v-11.073a1.18,1.18,0,0,0-1.178-1.179Z", transform: "translate(-6568.748 -5350.813)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2074", "data-name": "Group 2074", transform: "translate(2013.619 4313.503)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1580", "data-name": "Path 1580", d: "M6646.347,5422.453a.842.842,0,0,1-.842-.842v-4.763a.842.842,0,0,1,1.684,0v4.763A.842.842,0,0,1,6646.347,5422.453Z", transform: "translate(-6645.505 -5416.007)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2075", "data-name": "Group 2075", transform: "translate(2018.228 4313.503)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1581", "data-name": "Path 1581", d: "M6709.313,5422.453a.842.842,0,0,1-.842-.842v-4.763a.842.842,0,0,1,1.684,0v4.763A.842.842,0,0,1,6709.313,5422.453Z", transform: "translate(-6708.471 -5416.007)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2076", "data-name": "Group 2076", transform: "translate(2022.53 4313.503)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1582", "data-name": "Path 1582", d: "M6768.08,5422.453a.842.842,0,0,1-.842-.842v-4.763a.842.842,0,0,1,1.684,0v4.763A.842.842,0,0,1,6768.08,5422.453Z", transform: "translate(-6767.238 -5416.007)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2077", "data-name": "Group 2077", transform: "translate(2027.447 4313.503)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1583", "data-name": "Path 1583", d: "M6835.243,5422.453a.842.842,0,0,1-.841-.842v-4.763a.842.842,0,1,1,1.683,0v4.763A.842.842,0,0,1,6835.243,5422.453Z", transform: "translate(-6834.402 -5416.007)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2080", "data-name": "Group 2080", transform: "translate(2044.814 4315.014)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2078", "data-name": "Group 2078" }, /* @__PURE__ */ k.createElement("circle", { id: "Ellipse_393", "data-name": "Ellipse 393", cx: 1.712, cy: 1.712, r: 1.712, fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2079", "data-name": "Group 2079", transform: "translate(8.207)" }, /* @__PURE__ */ k.createElement("circle", { id: "Ellipse_394", "data-name": "Ellipse 394", cx: 1.712, cy: 1.712, r: 1.712, fill: "#838eaa" })))), /* @__PURE__ */ k.createElement("g", { id: "Group_2057", "data-name": "Group 2057", transform: "translate(2034.888 4364.275)" }, /* @__PURE__ */ k.createElement("circle", { id: "Ellipse_392", "data-name": "Ellipse 392", cx: 1.924, cy: 1.924, r: 1.924, transform: "translate(0.622 0.622)", fill: "#f2f5fc" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1567", "data-name": "Path 1567", d: "M6938.609,6114.7a2.547,2.547,0,1,1,2.546-2.547A2.55,2.55,0,0,1,6938.609,6114.7Zm0-3.849a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,6938.609,6110.848Z", transform: "translate(-6936.062 -6109.603)", fill: "#838eaa" }))))), y6 = W.div.attrs(() => ({
  className: "msd__info-box__title"
}))`
  max-width: 380px;
  margin: 10px auto 0 auto;

  color: ${Et};

  font-size: 16px;
`, ND = W.div.attrs(() => ({
  className: "msd__info-box__subtitle"
}))`
  color: ${Et};

  font-size: 13px;

  max-width: 310px;
  margin: 5px auto 0 auto;

  a {
    text-decoration: underline;
  }
`, b6 = W.div.attrs(() => ({
  className: "msd__info-box__icon"
}))`
  display: flex;
  justify-content: center;
  margin: auto auto 10px auto;

  svg {
    max-width: 490px;

    ellipse {
      fill: ${An};
      stroke: ${An};
    }
  }
`, Lle = W.div.attrs(() => ({
  className: "msd__info-details"
}))``, $le = W.div.attrs(() => ({
  className: "msd__info-box"
}))`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  position: relative;
  max-width: 320px;

  padding: 18px;
  margin: ${(e) => e.$margin ? e.$margin : "0 auto 32px auto"};

  text-align: center;
  line-height: 1.4;

  ${(e) => e.$fullWidth && ot`
      width: 100%;
      max-width: unset;
    `}

  ${(e) => e.$withBorder && ot`
      border: 1px dashed ${Ree};
      border-radius: 20px;
      padding: 35px 0;
    `}

  ${(e) => e.$direction === "row" && ot`
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      padding: 20px 0;

      ${Lle} {
        text-align: left;
        margin: auto 20px auto 20px;
      }
      ${y6} {
        margin: auto 0 auto 0;
      }
      ${b6} {
        margin: auto 20px auto 20px;
      }
    `}

  ${(e) => e.$fullHeight && ot`
      height: 100%;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      ${pr.small`
        min-height: 100vh;
      `}
    `}

    ${(e) => e.$centered && ot`
      margin: auto;
    `}

  ${(e) => e.onClick && ot`
      cursor: pointer;
      &:after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        content: '';
        opacity: 0;
        border-radius: 20px;
        box-shadow: 0px 0px 14px 0px #86868642;
        transition: opacity 0.2s ease-in-out;
      }
      &:hover {
        &:after {
          opacity: 1;
        }
      }
    `}
    ${(e) => e.$isSmallCard && ot`
      width: 265px;
      padding: 26px 0;
      height: 160px;
      margin: 0 auto;
      ${y6} {
        font-size: 14px;
      }
      ${ND} {
        font-size: 12px;
      }
      ${b6} {
        margin: auto auto 5px auto;
      }
    `}
`, Ml = ({
  title: e = "",
  subtitle: t = "",
  icon: n = "",
  generalError: r = !1,
  withBorder: a = !1,
  fullHeight: o = !1,
  centered: s = !1,
  margin: c = "",
  fullWidth: u = !1,
  onClick: f,
  isSmallCard: m = !1,
  direction: v = "column"
}) => {
  const { t: y } = tn(), b = r ? Dle : n;
  return /* @__PURE__ */ C.jsxs(
    $le,
    {
      $withBorder: a,
      $fullHeight: o,
      $centered: s,
      $margin: c,
      $fullWidth: u,
      onClick: f,
      $isSmallCard: m,
      $direction: v,
      children: [
        (n || r) && /* @__PURE__ */ C.jsx(b6, { children: /* @__PURE__ */ C.jsx(b, {}) }),
        /* @__PURE__ */ C.jsxs(Lle, { children: [
          /* @__PURE__ */ C.jsx(y6, { children: r ? y("oops-something-went-wrong", "Oops! Something went wrong.") : e }),
          /* @__PURE__ */ C.jsx(ND, { children: r ? y(
            "myaccounterror.try-again",
            "Please try again in a few moments."
          ) : t })
        ] }),
        r && /* @__PURE__ */ C.jsx(
          zt,
          {
            margin: "20px auto auto auto",
            width: "auto",
            onClickFn: () => window.location.reload(),
            children: y("myaccounterror.button.try-again", "Try again")
          }
        )
      ]
    }
  );
}, Eat = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#d3dbe6;}.b{fill:#f8fafd;}.c{fill:none;}.d,.e{stroke:none;}.e{fill:#d3dbe6;}")), /* @__PURE__ */ k.createElement("g", { transform: "translate(-421 -539)" }, /* @__PURE__ */ k.createElement("rect", { className: "a", width: 18, height: 18, rx: 3, transform: "translate(421 539)" })), /* @__PURE__ */ k.createElement("path", { className: "b", d: "M12.3,1.928a1.8,1.8,0,0,1,1.441,2.883l-.721.721L11.929,4.439,10.5,3.009l.721-.721a1.794,1.794,0,0,1,1.081-.36ZM3.291,10.216l-.721,3.243,3.243-.721,6.667-6.667L9.958,3.55Zm7.338-4.194L5.584,11.067l-.621-.621L10.008,5.4l.621.621Z", transform: "translate(0.479 1.396)" }), /* @__PURE__ */ k.createElement("rect", { className: "b", width: 1.869, height: 7.476, transform: "translate(10.139 6.289) rotate(45)" }), /* @__PURE__ */ k.createElement("rect", { className: "a", width: 7.476, height: 1.2, rx: 0.6, transform: "translate(6.123 6.949) rotate(45)" }), /* @__PURE__ */ k.createElement("rect", { className: "b", width: 14.448, height: 1.4, rx: 0.7, transform: "translate(4.392 3.363) rotate(45)" }), /* @__PURE__ */ k.createElement("g", { className: "c", transform: "translate(4.499 14.856) rotate(-135)" }, /* @__PURE__ */ k.createElement("path", { className: "d", d: "M1,0,2,1.707H0Z" }), /* @__PURE__ */ k.createElement("path", { className: "e", d: "M 1 -3.099441528320312e-06 L 2 1.706776976585388 L 0 1.706776976585388 L 1 -3.099441528320312e-06 Z" })), /* @__PURE__ */ k.createElement("path", { className: "b", d: "M0,0H1.127A2.387,2.387,0,0,1,.664.9.7.7,0,0,1,0,1.01Z", transform: "translate(3.977 13.316) rotate(45)" })), Iat = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_3430", "data-name": "Group 3430", transform: "translate(-421 -280)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_3303", "data-name": "Group 3303", transform: "translate(0 1)" }, /* @__PURE__ */ k.createElement("rect", { id: "Rectangle_3630", "data-name": "Rectangle 3630", width: 18, height: 18, rx: 3, transform: "translate(421 279)", fill: "#d3dbe6" }), /* @__PURE__ */ k.createElement("g", { id: "Group_3302", "data-name": "Group 3302", transform: "translate(424.657 306.552)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_2450", "data-name": "Path 2450", d: "M9.089-16.066a.24.24,0,0,0,.157.056h.007a.232.232,0,0,0,.172-.075l1.966-1.688a.175.175,0,0,0,0-.273.247.247,0,0,0-.315,0l-1.6,1.376V-22.9a.209.209,0,0,0-.223-.193.209.209,0,0,0-.223.193v6.242L7.414-18.048a.248.248,0,0,0-.315,0,.175.175,0,0,0,0,.273Z", transform: "translate(-3.902 1)", fill: "#f8fafd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2450_-_Outline", "data-name": "Path 2450 - Outline", d: "M9.253-15.81H9.221a.436.436,0,0,1-.263-.1L6.971-17.622a.382.382,0,0,1-.136-.287.382.382,0,0,1,.133-.288.442.442,0,0,1,.29-.106.439.439,0,0,1,.287.1l1.286,1.1V-22.9a.409.409,0,0,1,.423-.393.409.409,0,0,1,.423.393v5.795L10.947-18.2a.436.436,0,0,1,.287-.1.44.44,0,0,1,.29.107.382.382,0,0,1,.133.288.382.382,0,0,1-.135.287L9.564-15.94A.435.435,0,0,1,9.253-15.81Zm-.007-.409.022.006a.031.031,0,0,0,.01-.007l.017-.017,1.94-1.666a.043.043,0,0,0-.026.007l-1.933,1.66V-22.89a.075.075,0,0,0-.045,0v6.665L7.284-17.9a.043.043,0,0,0-.027-.008L9.22-16.218l.008,0Z", transform: "translate(-3.902 1)", fill: "#f8fafd" }))), /* @__PURE__ */ k.createElement("path", { id: "Ellipse_461", "data-name": "Ellipse 461", d: "M7,0h.007A.55.55,0,0,1,7,1.1H7A.55.55,0,0,1,7,0ZM9.81.642A.548.548,0,0,1,10.05.7l.007,0a.55.55,0,0,1-.482.989l0,0A.55.55,0,0,1,9.81.642Zm2.248,1.806a.549.549,0,0,1,.431.209l0,0,0,0a.55.55,0,0,1-.864.681l0,0a.55.55,0,0,1,.431-.892Zm1.24,2.6a.55.55,0,0,1,.536.429l0,.007h0a.55.55,0,1,1-1.074.237v0A.551.551,0,0,1,13.3,5.05Zm-.02,2.885a.55.55,0,0,1,.536.674l0,.007h0a.55.55,0,1,1-1.071-.253v0A.55.55,0,0,1,13.278,7.935ZM12,10.52a.55.55,0,0,1,.427.9l0,0,0,0a.55.55,0,1,1-.852-.7l0,0A.549.549,0,0,1,12,10.52ZM9.731,12.295a.55.55,0,0,1,.234,1.048l-.005,0a.55.55,0,0,1-.466-1l0,0A.548.548,0,0,1,9.731,12.295Zm-2.823.6H6.92A.55.55,0,0,1,6.906,14H6.9a.55.55,0,0,1,.008-1.1Zm-2.8-.683a.548.548,0,0,1,.246.059l0,0a.55.55,0,0,1-.492.984l-.006,0a.55.55,0,0,1,.248-1.041ZM1.884,10.379a.549.549,0,0,1,.436.215l0,0a.55.55,0,0,1-.871.672l0,0h0a.55.55,0,0,1,.435-.885Zm-1.2-2.62a.55.55,0,0,1,.538.439v0a.55.55,0,0,1-1.077.225V8.42a.55.55,0,0,1,.539-.661Zm.06-2.884a.551.551,0,0,1,.534.684v0A.55.55,0,0,1,.209,5.3V5.289A.55.55,0,0,1,.743,4.875ZM2.055,2.309a.55.55,0,0,1,.421.9l0,0a.55.55,0,0,1-.844-.705l0,0h0A.549.549,0,0,1,2.055,2.309ZM4.353.566a.55.55,0,0,1,.226,1.052l0,0a.55.55,0,0,1-.453-1h0l.005,0A.548.548,0,0,1,4.353.566Z", transform: "translate(423 282)", fill: "#f8fafd" }))), kat = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_3431", "data-name": "Group 3431", transform: "translate(439 298) rotate(180)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_3303", "data-name": "Group 3303", transform: "translate(0 1)" }, /* @__PURE__ */ k.createElement("rect", { id: "Rectangle_3630", "data-name": "Rectangle 3630", width: 18, height: 18, rx: 3, transform: "translate(421 279)", fill: "#d3dbe6" }), /* @__PURE__ */ k.createElement("g", { id: "Group_3302", "data-name": "Group 3302", transform: "translate(424.657 306.552)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_2450", "data-name": "Path 2450", d: "M9.089-16.066a.24.24,0,0,0,.157.056h.007a.232.232,0,0,0,.172-.075l1.966-1.688a.175.175,0,0,0,0-.273.247.247,0,0,0-.315,0l-1.6,1.376V-22.9a.209.209,0,0,0-.223-.193.209.209,0,0,0-.223.193v6.242L7.414-18.048a.248.248,0,0,0-.315,0,.175.175,0,0,0,0,.273Z", transform: "translate(-3.902 1)", fill: "#f8fafd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2450_-_Outline", "data-name": "Path 2450 - Outline", d: "M9.253-15.81H9.221a.436.436,0,0,1-.263-.1L6.971-17.622a.382.382,0,0,1-.136-.287.382.382,0,0,1,.133-.288.442.442,0,0,1,.29-.106.439.439,0,0,1,.287.1l1.286,1.1V-22.9a.409.409,0,0,1,.423-.393.409.409,0,0,1,.423.393v5.795L10.947-18.2a.436.436,0,0,1,.287-.1.44.44,0,0,1,.29.107.382.382,0,0,1,.133.288.382.382,0,0,1-.135.287L9.564-15.94A.435.435,0,0,1,9.253-15.81Zm-.007-.409.022.006a.031.031,0,0,0,.01-.007l.017-.017,1.94-1.666a.043.043,0,0,0-.026.007l-1.933,1.66V-22.89a.075.075,0,0,0-.045,0v6.665L7.284-17.9a.043.043,0,0,0-.027-.008L9.22-16.218l.008,0Z", transform: "translate(-3.902 1)", fill: "#f8fafd" }))), /* @__PURE__ */ k.createElement("path", { id: "Ellipse_461", "data-name": "Ellipse 461", d: "M7,0h.007A.55.55,0,0,1,7,1.1H7A.55.55,0,0,1,7,0ZM9.81.642A.548.548,0,0,1,10.05.7l.007,0a.55.55,0,0,1-.482.989l0,0A.55.55,0,0,1,9.81.642Zm2.248,1.806a.549.549,0,0,1,.431.209l0,0,0,0a.55.55,0,0,1-.864.681l0,0a.55.55,0,0,1,.431-.892Zm1.24,2.6a.55.55,0,0,1,.536.429l0,.007h0a.55.55,0,1,1-1.074.237v0A.551.551,0,0,1,13.3,5.05Zm-.02,2.885a.55.55,0,0,1,.536.674l0,.007h0a.55.55,0,1,1-1.071-.253v0A.55.55,0,0,1,13.278,7.935ZM12,10.52a.55.55,0,0,1,.427.9l0,0,0,0a.55.55,0,1,1-.852-.7l0,0A.549.549,0,0,1,12,10.52ZM9.731,12.295a.55.55,0,0,1,.234,1.048l-.005,0a.55.55,0,0,1-.466-1l0,0A.548.548,0,0,1,9.731,12.295Zm-2.823.6H6.92A.55.55,0,0,1,6.906,14H6.9a.55.55,0,0,1,.008-1.1Zm-2.8-.683a.548.548,0,0,1,.246.059l0,0a.55.55,0,0,1-.492.984l-.006,0a.55.55,0,0,1,.248-1.041ZM1.884,10.379a.549.549,0,0,1,.436.215l0,0a.55.55,0,0,1-.871.672l0,0h0a.55.55,0,0,1,.435-.885Zm-1.2-2.62a.55.55,0,0,1,.538.439v0a.55.55,0,0,1-1.077.225V8.42a.55.55,0,0,1,.539-.661Zm.06-2.884a.551.551,0,0,1,.534.684v0A.55.55,0,0,1,.209,5.3V5.289A.55.55,0,0,1,.743,4.875ZM2.055,2.309a.55.55,0,0,1,.421.9l0,0a.55.55,0,0,1-.844-.705l0,0h0A.549.549,0,0,1,2.055,2.309ZM4.353.566a.55.55,0,0,1,.226,1.052l0,0a.55.55,0,0,1-.453-1h0l.005,0A.548.548,0,0,1,4.353.566Z", transform: "translate(423 282)", fill: "#f8fafd" }))), Aat = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 22" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_3653", "data-name": "Group 3653", transform: "translate(-819 -375)" }, /* @__PURE__ */ k.createElement("rect", { id: "Rectangle_4", "data-name": "Rectangle 4", width: 22, height: 22, rx: 3, transform: "translate(819 375)", fill: "#d3dbe6", opacity: 0.679 }), /* @__PURE__ */ k.createElement("path", { id: "Path_2620", "data-name": "Path 2620", d: "M-8.407-16.337v-11.5h3.419v11.5Zm6.719,0v-11.5H1.731v11.5Z", transform: "translate(833.339 408.089)", fill: "#f8fafd", stroke: "#dde4ee", strokeWidth: 0.6 }))), jle = W.section`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
`, Fle = W.div.attrs(() => ({
  className: "msd__subscription-text__wrapper"
}))`
  max-width: 50%;
  color: ${Et};
  margin-inline-end: 15px;

  ${Zr.small`
    max-width: none;
    margin-inline-end: 20px;
  `}
`, Pat = W.h2.attrs(() => ({
  className: "msd__subscription-text__title"
}))`
  margin: 0 auto 3px 0;

  font-weight: ${Nd};
  font-size: ${A2};
  line-height: 15px;

  ${Zr.small`
    font-size: ${n8};
    line-height: 19px;
  `};
`, Nat = W.p.attrs(() => ({
  className: "msd__subscription-text__description"
}))`
  font-size: ${i1};
  font-weight: ${Yp};
  line-height: 17px;
  margin: 9px 0;
`, Ble = W.div.attrs(() => ({
  className: "msd__subscription-price__wrapper"
}))`
  display: flex;
  flex-direction: column;
  margin-inline: auto 0;
`, Tat = W.div.attrs(() => ({
  className: "msd__subscription-subcard"
}))`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  margin: 15px 0;
  padding: 12px;
  border: 1px solid ${Gn};
  background: ${Br};
  border-radius: 4px;
  svg {
    min-width: 18px;
    width: 18px;
  }
`, Oat = W.p.attrs(() => ({
  className: "msd__subscription-subcard__title"
}))`
  font-size: ${i1};
  color: ${Et};
  margin-inline: 10px 0;
  line-height: initial;
`, Rat = W.div``, Mat = W.button`
  padding: 0;
  margin: 8px 0 0 10px;
  background-color: transparent;
  color: ${An};
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`, Dat = ({ offerId: e }) => {
  const { t } = tn(), n = Va(), { data: r, loading: a } = Ot($R), { pauseOffersIDs: o, offers: s } = Ot(J6), { data: c } = Ot(dee), {
    offerType: u,
    offerTitle: f,
    nextPaymentPrice: m,
    totalPrice: v,
    nextPaymentCurrency: y,
    customerCurrency: b,
    paymentMethod: S,
    pendingSwitchId: x,
    expiresAt: E,
    period: N,
    status: R,
    isExternallyManaged: O
  } = r.find((ee) => ee.offerId === e) || {}, {
    offerV2: { price: D }
  } = Ot(k2), $ = D == null ? void 0 : D.rules, B = Ta[y || b], G = x ? c[x] : {}, Z = o.includes(e), K = G ? o == null ? void 0 : o.includes(G == null ? void 0 : G.toOfferId) : !1, q = () => {
    const ee = E === xc ? t("currentplan.next-season-start", "the next season start") : Ko(E);
    return u === "S" && R === "active" && !x ? `${t(
      "currentplan.subscription.renews-info",
      "Renews automatically on {{renewalDate}}",
      {
        renewalDate: ee
      }
    )}` : u === "S" && R === "cancelled" ? `${t(
      "currentplan.subscription.expire-info",
      "This plan will expire on {{renewalDate}}",
      {
        renewalDate: ee
      }
    )}` : u === "P" ? `${t("currentplan.pass.expires-on", "Expires on")} ${Ko(
      E
    )}` : "";
  }, pe = () => {
    var Ie;
    if (!G) return null;
    const ee = E === xc ? t("offer-card.next-season-start", "the next season start") : Ko(E), { fromOfferId: oe, toOfferId: me } = G, xe = ((Ie = s.find(({ longId: Le }) => Le === me)) == null ? void 0 : Ie.title) || "", X = t(`offer-title-${oe}`, f), ye = t(`offer-title-${me}`, xe);
    if (K)
      return t(
        "offer-card.info-box.pause-information-text",
        "Your current plan will be paused starting on {{subscriptionExpirationDate}}. While your subscription is paused, you won’t be charged for, and you won’t have access to, {{ translatedTitle }}. You can cancel this pause request at any time.",
        {
          subscriptionExpirationDate: ee,
          translatedTitle: X
        }
      );
    const { algorithm: ce, direction: se } = G;
    switch (ce) {
      case "IMMEDIATE_WITHOUT_PRORATION":
        return t(
          `offer-card.switch-details-${se}.immediate-without-proration`,
          `Your ${se} is pending and should be completed within few minutes. You will be charged a new price starting {{subscriptionExpirationDate}}.{{translatedSwitchTitle}} renews automatically. You can cancel anytime.`,
          { subscriptionExpirationDate: ee, translatedSwitchTitle: ye }
        );
      case "IMMEDIATE_AND_CHARGE_WITH_REFUND":
      case "IMMEDIATE_AND_CHARGE_WITHOUT_PRORATION":
        return t(
          `offer-card.switch-details-${se}.immediate-and-charge-with-refund-or-without-proration`,
          `Your ${se} is pending and should be completed within few minutes. You will be charged a new price immediately and get access to {{translatedSwitchTitle}}. You can cancel anytime.`,
          { translatedSwitchTitle: ye }
        );
      case "DEFERRED":
        return t(
          `offer-card.switch-details-${se}.deferred`,
          `Your ${se} is pending. You will have access to {{translatedTitle}} until {{subscriptionExpirationDate}}. From that time you will be charged your new price and will have access to {{translatedSwitchTitle}}. You can cancel this at any time.`,
          {
            translatedTitle: X,
            subscriptionExpirationDate: ee,
            translatedSwitchTitle: ye
          }
        );
      default:
        return "";
    }
  }, he = () => x ? pe() : O ? S ? t(
    "offer-card.error.inapp-external",
    `${S ? `Subscription purchased via ${S}. ` : ""} Use an external service to edit the plan.`,
    { paymentMethod: S }
  ) : t(
    "offer-card.error.inapp-external-no-pmt-method",
    "Use an external service to edit the plan."
  ) : "", ge = K ? Aat : (G == null ? void 0 : G.direction) === "downgrade" ? Iat : (G == null ? void 0 : G.direction) === "upgrade" ? kat : Eat, Y = q();
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(jle, { children: [
      /* @__PURE__ */ C.jsx(Zn, { showChildren: !a, width: 50, height: 50, children: /* @__PURE__ */ C.jsx(th, { period: N || u, isPaused: Z }) }),
      /* @__PURE__ */ C.jsxs(Fle, { children: [
        /* @__PURE__ */ C.jsx(
          Zn,
          {
            showChildren: !a,
            width: 200,
            margin: "0 10px 10px 10px",
            children: /* @__PURE__ */ C.jsx(Pat, { children: /* @__PURE__ */ C.jsx(C.Fragment, { children: t(`offer-title-${e}`, f) }) })
          }
        ),
        /* @__PURE__ */ C.jsx(
          Zn,
          {
            showChildren: !a,
            width: 300,
            margin: "0 10px 10px 10px",
            children: Y && /* @__PURE__ */ C.jsx(
              Nat,
              {
                dangerouslySetInnerHTML: { __html: Y }
              }
            )
          }
        )
      ] }),
      !Z && /* @__PURE__ */ C.jsx(Ble, { children: /* @__PURE__ */ C.jsx(Zn, { showChildren: !a, width: 80, height: 30, children: N && /* @__PURE__ */ C.jsx(
        SD,
        {
          currency: B,
          nextPaymentPrice: m,
          totalPrice: v,
          period: N !== "season" ? t(`offer-price.period-${N}`, N) : null,
          isPromoPriceActive: _le($)
        }
      ) }) })
    ] }),
    he() && /* @__PURE__ */ C.jsxs(Tat, { children: [
      /* @__PURE__ */ C.jsx(ge, {}),
      /* @__PURE__ */ C.jsxs(Rat, { children: [
        /* @__PURE__ */ C.jsx(
          Oat,
          {
            dangerouslySetInnerHTML: {
              __html: he() || ""
            }
          }
        ),
        x && (G == null ? void 0 : G.algorithm) === "DEFERRED" && /* @__PURE__ */ C.jsx(
          Mat,
          {
            onClick: () => {
              var ee;
              ur(Dye, {
                pendingSwitchId: x,
                fromOfferId: G.fromOfferId,
                toOfferId: G.toOfferId
              }), n(
                Ed({
                  type: K ? su.CANCEL_PAUSE_POPUP : su.CANCEL_SWITCH_POPUP,
                  data: {
                    pendingSwitchId: x,
                    switchDirection: G.direction,
                    switchOfferTitle: G && ((ee = s.find(
                      ({ longId: oe }) => oe === G.toOfferId
                    )) == null ? void 0 : ee.title) || "",
                    baseOfferTitle: f,
                    baseOfferExpirationDate: E,
                    baseOfferPrice: `${B}${m}`
                  }
                })
              );
            },
            children: K ? t("offer-card.cancel-pause-button", "Cancel pause") : t(
              `offer-card.cancel-${G.direction}`,
              `Cancel ${G.direction}`
            )
          }
        )
      ] })
    ] })
  ] });
}, Lat = () => /* @__PURE__ */ C.jsx(C.Fragment, { children: /* @__PURE__ */ C.jsxs(jle, { children: [
  /* @__PURE__ */ C.jsx(Zn, { showChildren: !1, width: 50, height: 50 }),
  /* @__PURE__ */ C.jsxs(Fle, { children: [
    /* @__PURE__ */ C.jsx(
      Zn,
      {
        showChildren: !1,
        width: 200,
        margin: "0 10px 10px 10px"
      }
    ),
    /* @__PURE__ */ C.jsx(
      Zn,
      {
        showChildren: !1,
        width: 300,
        margin: "0 10px 10px 10px"
      }
    )
  ] }),
  /* @__PURE__ */ C.jsx(Ble, { children: /* @__PURE__ */ C.jsx(Zn, { showChildren: !1, width: 80, height: 30 }) })
] }) });
var Ai;
(function(e) {
  e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment";
})(Ai || (Ai = {}));
function $at(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function X4(e) {
  const t = e == null ? void 0 : e.host;
  return (t == null ? void 0 : t.shadowRoot) === e;
}
function K4(e) {
  return Object.prototype.toString.call(e) === "[object ShadowRoot]";
}
function jat(e) {
  return e.includes(" background-clip: text;") && !e.includes(" -webkit-background-clip: text;") && (e = e.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;")), e;
}
function Fat(e) {
  const { cssText: t } = e;
  if (t.split('"').length < 3)
    return t;
  const n = ["@import", `url(${JSON.stringify(e.href)})`];
  return e.layerName === "" ? n.push("layer") : e.layerName && n.push(`layer(${e.layerName})`), e.supportsText && n.push(`supports(${e.supportsText})`), e.media.length && n.push(e.media.mediaText), n.join(" ") + ";";
}
function _6(e) {
  try {
    const t = e.rules || e.cssRules;
    return t ? jat(Array.from(t, Vle).join("")) : null;
  } catch (t) {
    return null;
  }
}
function Vle(e) {
  let t;
  if (Vat(e))
    try {
      t = _6(e.styleSheet) || Fat(e);
    } catch (n) {
    }
  else if (Uat(e) && e.selectorText.includes(":"))
    return Bat(e.cssText);
  return t || e.cssText;
}
function Bat(e) {
  const t = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return e.replace(t, "$1\\$2");
}
function Vat(e) {
  return "styleSheet" in e;
}
function Uat(e) {
  return "selectorText" in e;
}
class Ule {
  constructor() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t) {
    var n;
    if (!t)
      return -1;
    const r = (n = this.getMeta(t)) === null || n === void 0 ? void 0 : n.id;
    return r != null ? r : -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  removeNodeFromMap(t) {
    const n = this.getId(t);
    this.idNodeMap.delete(n), t.childNodes && t.childNodes.forEach((r) => this.removeNodeFromMap(r));
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, n) {
    const r = n.id;
    this.idNodeMap.set(r, t), this.nodeMetaMap.set(t, n);
  }
  replace(t, n) {
    const r = this.getNode(t);
    if (r) {
      const a = this.nodeMetaMap.get(r);
      a && this.nodeMetaMap.set(n, a);
    }
    this.idNodeMap.set(t, n);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function Gat() {
  return new Ule();
}
function TD({ element: e, maskInputOptions: t, tagName: n, type: r, value: a, maskInputFn: o }) {
  let s = a || "";
  const c = r && n1(r);
  return (t[n.toLowerCase()] || c && t[c]) && (o ? s = o(s, e) : s = "*".repeat(s.length)), s;
}
function n1(e) {
  return e.toLowerCase();
}
const Sq = "__rrweb_original__";
function zat(e) {
  const t = e.getContext("2d");
  if (!t)
    return !0;
  const n = 50;
  for (let r = 0; r < e.width; r += n)
    for (let a = 0; a < e.height; a += n) {
      const o = t.getImageData, s = Sq in o ? o[Sq] : o;
      if (new Uint32Array(s.call(t, r, a, Math.min(n, e.width - r), Math.min(n, e.height - a)).data.buffer).some((u) => u !== 0))
        return !1;
    }
  return !0;
}
function OD(e) {
  const t = e.type;
  return e.hasAttribute("data-rr-is-password") ? "password" : t ? n1(t) : null;
}
function Gle(e, t) {
  var n;
  let r;
  try {
    r = new URL(e, t != null ? t : window.location.href);
  } catch (s) {
    return null;
  }
  const a = /\.([0-9a-z]+)(?:$)/i, o = r.pathname.match(a);
  return (n = o == null ? void 0 : o[1]) !== null && n !== void 0 ? n : null;
}
let Hat = 1;
const Wat = new RegExp("[^a-z0-9-_:]"), y_ = -2;
function zle() {
  return Hat++;
}
function Zat(e) {
  if (e instanceof HTMLFormElement)
    return "form";
  const t = n1(e.tagName);
  return Wat.test(t) ? "div" : t;
}
function Yat(e) {
  let t = "";
  return e.indexOf("//") > -1 ? t = e.split("/").slice(0, 3).join("/") : t = e.split("/")[0], t = t.split("?")[0], t;
}
let xy, xq;
const Xat = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, Kat = /^(?:[a-z+]+:)?\/\//i, qat = /^www\..*/i, Jat = /^(data:)([^,]*),(.*)/i;
function C6(e, t) {
  return (e || "").replace(Xat, (n, r, a, o, s, c) => {
    const u = a || s || c, f = r || o || "";
    if (!u)
      return n;
    if (Kat.test(u) || qat.test(u))
      return `url(${f}${u}${f})`;
    if (Jat.test(u))
      return `url(${f}${u}${f})`;
    if (u[0] === "/")
      return `url(${f}${Yat(t) + u}${f})`;
    const m = t.split("/"), v = u.split("/");
    m.pop();
    for (const y of v)
      y !== "." && (y === ".." ? m.pop() : m.push(y));
    return `url(${f}${m.join("/")}${f})`;
  });
}
const Qat = /^[^ \t\n\r\u000c]+/, eot = /^[, \t\n\r\u000c]+/;
function tot(e, t) {
  if (t.trim() === "")
    return t;
  let n = 0;
  function r(o) {
    let s;
    const c = o.exec(t.substring(n));
    return c ? (s = c[0], n += s.length, s) : "";
  }
  const a = [];
  for (; r(eot), !(n >= t.length); ) {
    let o = r(Qat);
    if (o.slice(-1) === ",")
      o = Uy(e, o.substring(0, o.length - 1)), a.push(o);
    else {
      let s = "";
      o = Uy(e, o);
      let c = !1;
      for (; ; ) {
        const u = t.charAt(n);
        if (u === "") {
          a.push((o + s).trim());
          break;
        } else if (c)
          u === ")" && (c = !1);
        else if (u === ",") {
          n += 1, a.push((o + s).trim());
          break;
        } else u === "(" && (c = !0);
        s += u, n += 1;
      }
    }
  }
  return a.join(", ");
}
function Uy(e, t) {
  if (!t || t.trim() === "")
    return t;
  const n = e.createElement("a");
  return n.href = t, n.href;
}
function not(e) {
  return !!(e.tagName === "svg" || e.ownerSVGElement);
}
function RD() {
  const e = document.createElement("a");
  return e.href = "", e.href;
}
function Hle(e, t, n, r) {
  return r && (n === "src" || n === "href" && !(t === "use" && r[0] === "#") || n === "xlink:href" && r[0] !== "#" || n === "background" && (t === "table" || t === "td" || t === "th") ? Uy(e, r) : n === "srcset" ? tot(e, r) : n === "style" ? C6(r, RD()) : t === "object" && n === "data" ? Uy(e, r) : r);
}
function Wle(e, t, n) {
  return (e === "video" || e === "audio") && t === "autoplay";
}
function rot(e, t, n) {
  try {
    if (typeof t == "string") {
      if (e.classList.contains(t))
        return !0;
    } else
      for (let r = e.classList.length; r--; ) {
        const a = e.classList[r];
        if (t.test(a))
          return !0;
      }
    if (n)
      return e.matches(n);
  } catch (r) {
  }
  return !1;
}
function w6(e, t, n) {
  if (!e)
    return !1;
  if (e.nodeType !== e.ELEMENT_NODE)
    return n ? w6(e.parentNode, t, n) : !1;
  for (let r = e.classList.length; r--; ) {
    const a = e.classList[r];
    if (t.test(a))
      return !0;
  }
  return n ? w6(e.parentNode, t, n) : !1;
}
function Zle(e, t, n, r) {
  try {
    const a = e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
    if (a === null)
      return !1;
    if (typeof t == "string") {
      if (r) {
        if (a.closest(`.${t}`))
          return !0;
      } else if (a.classList.contains(t))
        return !0;
    } else if (w6(a, t, r))
      return !0;
    if (n) {
      if (r) {
        if (a.closest(n))
          return !0;
      } else if (a.matches(n))
        return !0;
    }
  } catch (a) {
  }
  return !1;
}
function aot(e, t, n) {
  const r = e.contentWindow;
  if (!r)
    return;
  let a = !1, o;
  try {
    o = r.document.readyState;
  } catch (c) {
    return;
  }
  if (o !== "complete") {
    const c = setTimeout(() => {
      a || (t(), a = !0);
    }, n);
    e.addEventListener("load", () => {
      clearTimeout(c), a = !0, t();
    });
    return;
  }
  const s = "about:blank";
  if (r.location.href !== s || e.src === s || e.src === "")
    return setTimeout(t, 0), e.addEventListener("load", t);
  e.addEventListener("load", t);
}
function oot(e, t, n) {
  let r = !1, a;
  try {
    a = e.sheet;
  } catch (s) {
    return;
  }
  if (a)
    return;
  const o = setTimeout(() => {
    r || (t(), r = !0);
  }, n);
  e.addEventListener("load", () => {
    clearTimeout(o), r = !0, t();
  });
}
function iot(e, t) {
  const { doc: n, mirror: r, blockClass: a, blockSelector: o, needsMask: s, inlineStylesheet: c, maskInputOptions: u = {}, maskTextFn: f, maskInputFn: m, dataURLOptions: v = {}, inlineImages: y, recordCanvas: b, keepIframeSrcFn: S, newlyAddedElement: x = !1 } = t, E = sot(n, r);
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return e.compatMode !== "CSS1Compat" ? {
        type: Ai.Document,
        childNodes: [],
        compatMode: e.compatMode
      } : {
        type: Ai.Document,
        childNodes: []
      };
    case e.DOCUMENT_TYPE_NODE:
      return {
        type: Ai.DocumentType,
        name: e.name,
        publicId: e.publicId,
        systemId: e.systemId,
        rootId: E
      };
    case e.ELEMENT_NODE:
      return uot(e, {
        doc: n,
        blockClass: a,
        blockSelector: o,
        inlineStylesheet: c,
        maskInputOptions: u,
        maskInputFn: m,
        dataURLOptions: v,
        inlineImages: y,
        recordCanvas: b,
        keepIframeSrcFn: S,
        newlyAddedElement: x,
        rootId: E
      });
    case e.TEXT_NODE:
      return lot(e, {
        needsMask: s,
        maskTextFn: f,
        rootId: E
      });
    case e.CDATA_SECTION_NODE:
      return {
        type: Ai.CDATA,
        textContent: "",
        rootId: E
      };
    case e.COMMENT_NODE:
      return {
        type: Ai.Comment,
        textContent: e.textContent || "",
        rootId: E
      };
    default:
      return !1;
  }
}
function sot(e, t) {
  if (!t.hasNode(e))
    return;
  const n = t.getId(e);
  return n === 1 ? void 0 : n;
}
function lot(e, t) {
  var n;
  const { needsMask: r, maskTextFn: a, rootId: o } = t, s = e.parentNode && e.parentNode.tagName;
  let c = e.textContent;
  const u = s === "STYLE" ? !0 : void 0, f = s === "SCRIPT" ? !0 : void 0;
  if (u && c) {
    try {
      e.nextSibling || e.previousSibling || !((n = e.parentNode.sheet) === null || n === void 0) && n.cssRules && (c = _6(e.parentNode.sheet));
    } catch (m) {
      console.warn(`Cannot get CSS styles from text's parentNode. Error: ${m}`, e);
    }
    c = C6(c, RD());
  }
  return f && (c = "SCRIPT_PLACEHOLDER"), !u && !f && c && r && (c = a ? a(c, e.parentElement) : c.replace(/[\S]/g, "*")), {
    type: Ai.Text,
    textContent: c || "",
    isStyle: u,
    rootId: o
  };
}
function uot(e, t) {
  const { doc: n, blockClass: r, blockSelector: a, inlineStylesheet: o, maskInputOptions: s = {}, maskInputFn: c, dataURLOptions: u = {}, inlineImages: f, recordCanvas: m, keepIframeSrcFn: v, newlyAddedElement: y = !1, rootId: b } = t, S = rot(e, r, a), x = Zat(e);
  let E = {};
  const N = e.attributes.length;
  for (let O = 0; O < N; O++) {
    const D = e.attributes[O];
    Wle(x, D.name, D.value) || (E[D.name] = Hle(n, x, n1(D.name), D.value));
  }
  if (x === "link" && o) {
    const O = Array.from(n.styleSheets).find(($) => $.href === e.href);
    let D = null;
    O && (D = _6(O)), D && (delete E.rel, delete E.href, E._cssText = C6(D, O.href));
  }
  if (x === "style" && e.sheet && !(e.innerText || e.textContent || "").trim().length) {
    const O = _6(e.sheet);
    O && (E._cssText = C6(O, RD()));
  }
  if (x === "input" || x === "textarea" || x === "select") {
    const O = e.value, D = e.checked;
    E.type !== "radio" && E.type !== "checkbox" && E.type !== "submit" && E.type !== "button" && O ? E.value = TD({
      element: e,
      type: OD(e),
      tagName: x,
      value: O,
      maskInputOptions: s,
      maskInputFn: c
    }) : D && (E.checked = D);
  }
  if (x === "option" && (e.selected && !s.select ? E.selected = !0 : delete E.selected), x === "canvas" && m) {
    if (e.__context === "2d")
      zat(e) || (E.rr_dataURL = e.toDataURL(u.type, u.quality));
    else if (!("__context" in e)) {
      const O = e.toDataURL(u.type, u.quality), D = document.createElement("canvas");
      D.width = e.width, D.height = e.height;
      const $ = D.toDataURL(u.type, u.quality);
      O !== $ && (E.rr_dataURL = O);
    }
  }
  if (x === "img" && f) {
    xy || (xy = n.createElement("canvas"), xq = xy.getContext("2d"));
    const O = e, D = O.crossOrigin;
    O.crossOrigin = "anonymous";
    const $ = () => {
      O.removeEventListener("load", $);
      try {
        xy.width = O.naturalWidth, xy.height = O.naturalHeight, xq.drawImage(O, 0, 0), E.rr_dataURL = xy.toDataURL(u.type, u.quality);
      } catch (B) {
        console.warn(`Cannot inline img src=${O.currentSrc}! Error: ${B}`);
      }
      D ? E.crossOrigin = D : O.removeAttribute("crossorigin");
    };
    O.complete && O.naturalWidth !== 0 ? $() : O.addEventListener("load", $);
  }
  if (x === "audio" || x === "video") {
    const O = E;
    O.rr_mediaState = e.paused ? "paused" : "played", O.rr_mediaCurrentTime = e.currentTime, O.rr_mediaPlaybackRate = e.playbackRate, O.rr_mediaMuted = e.muted, O.rr_mediaLoop = e.loop, O.rr_mediaVolume = e.volume;
  }
  if (y || (e.scrollLeft && (E.rr_scrollLeft = e.scrollLeft), e.scrollTop && (E.rr_scrollTop = e.scrollTop)), S) {
    const { width: O, height: D } = e.getBoundingClientRect();
    E = {
      class: E.class,
      rr_width: `${O}px`,
      rr_height: `${D}px`
    };
  }
  x === "iframe" && !v(E.src) && (e.contentDocument || (E.rr_src = E.src), delete E.src);
  let R;
  try {
    customElements.get(x) && (R = !0);
  } catch (O) {
  }
  return {
    type: Ai.Element,
    tagName: x,
    attributes: E,
    childNodes: [],
    isSVG: not(e) || void 0,
    needBlock: S,
    rootId: b,
    isCustom: R
  };
}
function Wa(e) {
  return e == null ? "" : e.toLowerCase();
}
function cot(e, t) {
  if (t.comment && e.type === Ai.Comment)
    return !0;
  if (e.type === Ai.Element) {
    if (t.script && (e.tagName === "script" || e.tagName === "link" && (e.attributes.rel === "preload" || e.attributes.rel === "modulepreload") && e.attributes.as === "script" || e.tagName === "link" && e.attributes.rel === "prefetch" && typeof e.attributes.href == "string" && Gle(e.attributes.href) === "js"))
      return !0;
    if (t.headFavicon && (e.tagName === "link" && e.attributes.rel === "shortcut icon" || e.tagName === "meta" && (Wa(e.attributes.name).match(/^msapplication-tile(image|color)$/) || Wa(e.attributes.name) === "application-name" || Wa(e.attributes.rel) === "icon" || Wa(e.attributes.rel) === "apple-touch-icon" || Wa(e.attributes.rel) === "shortcut icon")))
      return !0;
    if (e.tagName === "meta") {
      if (t.headMetaDescKeywords && Wa(e.attributes.name).match(/^description|keywords$/))
        return !0;
      if (t.headMetaSocial && (Wa(e.attributes.property).match(/^(og|twitter|fb):/) || Wa(e.attributes.name).match(/^(og|twitter):/) || Wa(e.attributes.name) === "pinterest"))
        return !0;
      if (t.headMetaRobots && (Wa(e.attributes.name) === "robots" || Wa(e.attributes.name) === "googlebot" || Wa(e.attributes.name) === "bingbot"))
        return !0;
      if (t.headMetaHttpEquiv && e.attributes["http-equiv"] !== void 0)
        return !0;
      if (t.headMetaAuthorship && (Wa(e.attributes.name) === "author" || Wa(e.attributes.name) === "generator" || Wa(e.attributes.name) === "framework" || Wa(e.attributes.name) === "publisher" || Wa(e.attributes.name) === "progid" || Wa(e.attributes.property).match(/^article:/) || Wa(e.attributes.property).match(/^product:/)))
        return !0;
      if (t.headMetaVerification && (Wa(e.attributes.name) === "google-site-verification" || Wa(e.attributes.name) === "yandex-verification" || Wa(e.attributes.name) === "csrf-token" || Wa(e.attributes.name) === "p:domain_verify" || Wa(e.attributes.name) === "verify-v1" || Wa(e.attributes.name) === "verification" || Wa(e.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function Gy(e, t) {
  const { doc: n, mirror: r, blockClass: a, blockSelector: o, maskTextClass: s, maskTextSelector: c, skipChild: u = !1, inlineStylesheet: f = !0, maskInputOptions: m = {}, maskTextFn: v, maskInputFn: y, slimDOMOptions: b, dataURLOptions: S = {}, inlineImages: x = !1, recordCanvas: E = !1, onSerialize: N, onIframeLoad: R, iframeLoadTimeout: O = 5e3, onStylesheetLoad: D, stylesheetLoadTimeout: $ = 5e3, keepIframeSrcFn: B = () => !1, newlyAddedElement: G = !1 } = t;
  let { needsMask: Z } = t, { preserveWhiteSpace: K = !0 } = t;
  !Z && e.childNodes && (Z = Zle(e, s, c, Z === void 0));
  const q = iot(e, {
    doc: n,
    mirror: r,
    blockClass: a,
    blockSelector: o,
    needsMask: Z,
    inlineStylesheet: f,
    maskInputOptions: m,
    maskTextFn: v,
    maskInputFn: y,
    dataURLOptions: S,
    inlineImages: x,
    recordCanvas: E,
    keepIframeSrcFn: B,
    newlyAddedElement: G
  });
  if (!q)
    return console.warn(e, "not serialized"), null;
  let pe;
  r.hasNode(e) ? pe = r.getId(e) : cot(q, b) || !K && q.type === Ai.Text && !q.isStyle && !q.textContent.replace(/^\s+|\s+$/gm, "").length ? pe = y_ : pe = zle();
  const he = Object.assign(q, { id: pe });
  if (r.add(e, he), pe === y_)
    return null;
  N && N(e);
  let _e = !u;
  if (he.type === Ai.Element) {
    _e = _e && !he.needBlock, delete he.needBlock;
    const ge = e.shadowRoot;
    ge && K4(ge) && (he.isShadowHost = !0);
  }
  if ((he.type === Ai.Document || he.type === Ai.Element) && _e) {
    b.headWhitespace && he.type === Ai.Element && he.tagName === "head" && (K = !1);
    const ge = {
      doc: n,
      mirror: r,
      blockClass: a,
      blockSelector: o,
      needsMask: Z,
      maskTextClass: s,
      maskTextSelector: c,
      skipChild: u,
      inlineStylesheet: f,
      maskInputOptions: m,
      maskTextFn: v,
      maskInputFn: y,
      slimDOMOptions: b,
      dataURLOptions: S,
      inlineImages: x,
      recordCanvas: E,
      preserveWhiteSpace: K,
      onSerialize: N,
      onIframeLoad: R,
      iframeLoadTimeout: O,
      onStylesheetLoad: D,
      stylesheetLoadTimeout: $,
      keepIframeSrcFn: B
    };
    if (!(he.type === Ai.Element && he.tagName === "textarea" && he.attributes.value !== void 0)) for (const Y of Array.from(e.childNodes)) {
      const ee = Gy(Y, ge);
      ee && he.childNodes.push(ee);
    }
    if ($at(e) && e.shadowRoot)
      for (const Y of Array.from(e.shadowRoot.childNodes)) {
        const ee = Gy(Y, ge);
        ee && (K4(e.shadowRoot) && (ee.isShadow = !0), he.childNodes.push(ee));
      }
  }
  return e.parentNode && X4(e.parentNode) && K4(e.parentNode) && (he.isShadow = !0), he.type === Ai.Element && he.tagName === "iframe" && aot(e, () => {
    const ge = e.contentDocument;
    if (ge && R) {
      const Y = Gy(ge, {
        doc: ge,
        mirror: r,
        blockClass: a,
        blockSelector: o,
        needsMask: Z,
        maskTextClass: s,
        maskTextSelector: c,
        skipChild: !1,
        inlineStylesheet: f,
        maskInputOptions: m,
        maskTextFn: v,
        maskInputFn: y,
        slimDOMOptions: b,
        dataURLOptions: S,
        inlineImages: x,
        recordCanvas: E,
        preserveWhiteSpace: K,
        onSerialize: N,
        onIframeLoad: R,
        iframeLoadTimeout: O,
        onStylesheetLoad: D,
        stylesheetLoadTimeout: $,
        keepIframeSrcFn: B
      });
      Y && R(e, Y);
    }
  }, O), he.type === Ai.Element && he.tagName === "link" && typeof he.attributes.rel == "string" && (he.attributes.rel === "stylesheet" || he.attributes.rel === "preload" && typeof he.attributes.href == "string" && Gle(he.attributes.href) === "css") && oot(e, () => {
    if (D) {
      const ge = Gy(e, {
        doc: n,
        mirror: r,
        blockClass: a,
        blockSelector: o,
        needsMask: Z,
        maskTextClass: s,
        maskTextSelector: c,
        skipChild: !1,
        inlineStylesheet: f,
        maskInputOptions: m,
        maskTextFn: v,
        maskInputFn: y,
        slimDOMOptions: b,
        dataURLOptions: S,
        inlineImages: x,
        recordCanvas: E,
        preserveWhiteSpace: K,
        onSerialize: N,
        onIframeLoad: R,
        iframeLoadTimeout: O,
        onStylesheetLoad: D,
        stylesheetLoadTimeout: $,
        keepIframeSrcFn: B
      });
      ge && D(e, ge);
    }
  }, $), he;
}
function dot(e, t) {
  const { mirror: n = new Ule(), blockClass: r = "rr-block", blockSelector: a = null, maskTextClass: o = "rr-mask", maskTextSelector: s = null, inlineStylesheet: c = !0, inlineImages: u = !1, recordCanvas: f = !1, maskAllInputs: m = !1, maskTextFn: v, maskInputFn: y, slimDOM: b = !1, dataURLOptions: S, preserveWhiteSpace: x, onSerialize: E, onIframeLoad: N, iframeLoadTimeout: R, onStylesheetLoad: O, stylesheetLoadTimeout: D, keepIframeSrcFn: $ = () => !1 } = t || {};
  return Gy(e, {
    doc: e,
    mirror: n,
    blockClass: r,
    blockSelector: a,
    maskTextClass: o,
    maskTextSelector: s,
    skipChild: !1,
    inlineStylesheet: c,
    maskInputOptions: m === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0,
      password: !0
    } : m === !1 ? {
      password: !0
    } : m,
    maskTextFn: v,
    maskInputFn: y,
    slimDOMOptions: b === !0 || b === "all" ? {
      script: !0,
      comment: !0,
      headFavicon: !0,
      headWhitespace: !0,
      headMetaDescKeywords: b === "all",
      headMetaSocial: !0,
      headMetaRobots: !0,
      headMetaHttpEquiv: !0,
      headMetaAuthorship: !0,
      headMetaVerification: !0
    } : b === !1 ? {} : b,
    dataURLOptions: S,
    inlineImages: u,
    recordCanvas: f,
    preserveWhiteSpace: x,
    onSerialize: E,
    onIframeLoad: N,
    iframeLoadTimeout: R,
    onStylesheetLoad: O,
    stylesheetLoadTimeout: D,
    keepIframeSrcFn: $,
    newlyAddedElement: !1
  });
}
function Dl(e, t, n = document) {
  const r = { capture: !0, passive: !0 };
  return n.addEventListener(e, t, r), () => n.removeEventListener(e, t, r);
}
const Ty = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let Eq = {
  map: {},
  getId() {
    return console.error(Ty), -1;
  },
  getNode() {
    return console.error(Ty), null;
  },
  removeNodeFromMap() {
    console.error(Ty);
  },
  has() {
    return console.error(Ty), !1;
  },
  reset() {
    console.error(Ty);
  }
};
typeof window != "undefined" && window.Proxy && window.Reflect && (Eq = new Proxy(Eq, {
  get(e, t, n) {
    return t === "map" && console.error(Ty), Reflect.get(e, t, n);
  }
}));
function b_(e, t, n = {}) {
  let r = null, a = 0;
  return function(...o) {
    const s = Date.now();
    !a && n.leading === !1 && (a = s);
    const c = t - (s - a), u = this;
    c <= 0 || c > t ? (r && (clearTimeout(r), r = null), a = s, e.apply(u, o)) : !r && n.trailing !== !1 && (r = setTimeout(() => {
      a = n.leading === !1 ? 0 : Date.now(), r = null, e.apply(u, o);
    }, c));
  };
}
function z8(e, t, n, r, a = window) {
  const o = a.Object.getOwnPropertyDescriptor(e, t);
  return a.Object.defineProperty(e, t, r ? n : {
    set(s) {
      setTimeout(() => {
        n.set.call(this, s);
      }, 0), o && o.set && o.set.call(this, s);
    }
  }), () => z8(e, t, o || {}, !0);
}
function H2(e, t, n) {
  try {
    if (!(t in e))
      return () => {
      };
    const r = e[t], a = n(r);
    return typeof a == "function" && (a.prototype = a.prototype || {}, Object.defineProperties(a, {
      __rrweb_original__: {
        enumerable: !1,
        value: r
      }
    })), e[t] = a, () => {
      e[t] = r;
    };
  } catch (r) {
    return () => {
    };
  }
}
let S6 = Date.now;
/[1-9][0-9]{12}/.test(Date.now().toString()) || (S6 = () => (/* @__PURE__ */ new Date()).getTime());
function Yle(e) {
  var t, n, r, a, o, s;
  const c = e.document;
  return {
    left: c.scrollingElement ? c.scrollingElement.scrollLeft : e.pageXOffset !== void 0 ? e.pageXOffset : (c == null ? void 0 : c.documentElement.scrollLeft) || ((n = (t = c == null ? void 0 : c.body) === null || t === void 0 ? void 0 : t.parentElement) === null || n === void 0 ? void 0 : n.scrollLeft) || ((r = c == null ? void 0 : c.body) === null || r === void 0 ? void 0 : r.scrollLeft) || 0,
    top: c.scrollingElement ? c.scrollingElement.scrollTop : e.pageYOffset !== void 0 ? e.pageYOffset : (c == null ? void 0 : c.documentElement.scrollTop) || ((o = (a = c == null ? void 0 : c.body) === null || a === void 0 ? void 0 : a.parentElement) === null || o === void 0 ? void 0 : o.scrollTop) || ((s = c == null ? void 0 : c.body) === null || s === void 0 ? void 0 : s.scrollTop) || 0
  };
}
function Xle() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function Kle() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function qle(e) {
  return e ? e.nodeType === e.ELEMENT_NODE ? e : e.parentElement : null;
}
function Ll(e, t, n, r) {
  if (!e)
    return !1;
  const a = qle(e);
  if (!a)
    return !1;
  try {
    if (typeof t == "string") {
      if (a.classList.contains(t) || r && a.closest("." + t) !== null)
        return !0;
    } else if (w6(a, t, r))
      return !0;
  } catch (o) {
  }
  return !!(n && (a.matches(n) || r && a.closest(n) !== null));
}
function fot(e, t) {
  return t.getId(e) !== -1;
}
function bN(e, t) {
  return t.getId(e) === y_;
}
function Jle(e, t) {
  if (X4(e))
    return !1;
  const n = t.getId(e);
  return t.has(n) ? e.parentNode && e.parentNode.nodeType === e.DOCUMENT_NODE ? !1 : e.parentNode ? Jle(e.parentNode, t) : !0 : !0;
}
function nR(e) {
  return !!e.changedTouches;
}
function pot(e = window) {
  "NodeList" in e && !e.NodeList.prototype.forEach && (e.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in e && !e.DOMTokenList.prototype.forEach && (e.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...t) => {
    let n = t[0];
    if (!(0 in t))
      throw new TypeError("1 argument is required");
    do
      if (this === n)
        return !0;
    while (n = n && n.parentNode);
    return !1;
  });
}
function Qle(e, t) {
  return !!(e.nodeName === "IFRAME" && t.getMeta(e));
}
function eue(e, t) {
  return !!(e.nodeName === "LINK" && e.nodeType === e.ELEMENT_NODE && e.getAttribute && e.getAttribute("rel") === "stylesheet" && t.getMeta(e));
}
function rR(e) {
  return !!(e != null && e.shadowRoot);
}
class hot {
  constructor() {
    this.id = 1, this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map();
  }
  getId(t) {
    var n;
    return (n = this.styleIDMap.get(t)) !== null && n !== void 0 ? n : -1;
  }
  has(t) {
    return this.styleIDMap.has(t);
  }
  add(t, n) {
    if (this.has(t))
      return this.getId(t);
    let r;
    return n === void 0 ? r = this.id++ : r = n, this.styleIDMap.set(t, r), this.idStyleMap.set(r, t), r;
  }
  getStyle(t) {
    return this.idStyleMap.get(t) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function tue(e) {
  var t, n;
  let r = null;
  return ((n = (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e)) === null || n === void 0 ? void 0 : n.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && e.getRootNode().host && (r = e.getRootNode().host), r;
}
function mot(e) {
  let t = e, n;
  for (; n = tue(t); )
    t = n;
  return t;
}
function vot(e) {
  const t = e.ownerDocument;
  if (!t)
    return !1;
  const n = mot(e);
  return t.contains(n);
}
function nue(e) {
  const t = e.ownerDocument;
  return t ? t.contains(e) || vot(e) : !1;
}
var qr = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(qr || {}), jr = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(jr || {}), iu = /* @__PURE__ */ ((e) => (e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e))(iu || {}), Tp = /* @__PURE__ */ ((e) => (e[e.Mouse = 0] = "Mouse", e[e.Pen = 1] = "Pen", e[e.Touch = 2] = "Touch", e))(Tp || {}), C2 = /* @__PURE__ */ ((e) => (e[e["2D"] = 0] = "2D", e[e.WebGL = 1] = "WebGL", e[e.WebGL2 = 2] = "WebGL2", e))(C2 || {});
function Iq(e) {
  return "__ln" in e;
}
class got {
  constructor() {
    this.length = 0, this.head = null, this.tail = null;
  }
  get(t) {
    if (t >= this.length)
      throw new Error("Position outside of list range");
    let n = this.head;
    for (let r = 0; r < t; r++)
      n = (n == null ? void 0 : n.next) || null;
    return n;
  }
  addNode(t) {
    const n = {
      value: t,
      previous: null,
      next: null
    };
    if (t.__ln = n, t.previousSibling && Iq(t.previousSibling)) {
      const r = t.previousSibling.__ln.next;
      n.next = r, n.previous = t.previousSibling.__ln, t.previousSibling.__ln.next = n, r && (r.previous = n);
    } else if (t.nextSibling && Iq(t.nextSibling) && t.nextSibling.__ln.previous) {
      const r = t.nextSibling.__ln.previous;
      n.previous = r, n.next = t.nextSibling.__ln, t.nextSibling.__ln.previous = n, r && (r.next = n);
    } else
      this.head && (this.head.previous = n), n.next = this.head, this.head = n;
    n.next === null && (this.tail = n), this.length++;
  }
  removeNode(t) {
    const n = t.__ln;
    this.head && (n.previous ? (n.previous.next = n.next, n.next ? n.next.previous = n.previous : this.tail = n.previous) : (this.head = n.next, this.head ? this.head.previous = null : this.tail = null), t.__ln && delete t.__ln, this.length--);
  }
}
const kq = (e, t) => `${e}@${t}`;
class yot {
  constructor() {
    this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.processMutations = (t) => {
      t.forEach(this.processMutation), this.emit();
    }, this.emit = () => {
      if (this.frozen || this.locked)
        return;
      const t = [], n = /* @__PURE__ */ new Set(), r = new got(), a = (u) => {
        let f = u, m = y_;
        for (; m === y_; )
          f = f && f.nextSibling, m = f && this.mirror.getId(f);
        return m;
      }, o = (u) => {
        if (!u.parentNode || !nue(u) || u.parentNode.tagName === "TEXTAREA")
          return;
        const f = X4(u.parentNode) ? this.mirror.getId(tue(u)) : this.mirror.getId(u.parentNode), m = a(u);
        if (f === -1 || m === -1)
          return r.addNode(u);
        const v = Gy(u, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskTextClass: this.maskTextClass,
          maskTextSelector: this.maskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: (y) => {
            Qle(y, this.mirror) && this.iframeManager.addIframe(y), eue(y, this.mirror) && this.stylesheetManager.trackLinkElement(y), rR(u) && this.shadowDomManager.addShadowRoot(u.shadowRoot, this.doc);
          },
          onIframeLoad: (y, b) => {
            this.iframeManager.attachIframe(y, b), this.shadowDomManager.observeAttachShadow(y);
          },
          onStylesheetLoad: (y, b) => {
            this.stylesheetManager.attachLinkElement(y, b);
          }
        });
        v && (t.push({
          parentId: f,
          nextId: m,
          node: v
        }), n.add(v.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const u of this.movedSet)
        Aq(this.removes, u, this.mirror) && !this.movedSet.has(u.parentNode) || o(u);
      for (const u of this.addedSet)
        !Pq(this.droppedSet, u) && !Aq(this.removes, u, this.mirror) || Pq(this.movedSet, u) ? o(u) : this.droppedSet.add(u);
      let s = null;
      for (; r.length; ) {
        let u = null;
        if (s) {
          const f = this.mirror.getId(s.value.parentNode), m = a(s.value);
          f !== -1 && m !== -1 && (u = s);
        }
        if (!u) {
          let f = r.tail;
          for (; f; ) {
            const m = f;
            if (f = f.previous, m) {
              const v = this.mirror.getId(m.value.parentNode);
              if (a(m.value) === -1)
                continue;
              if (v !== -1) {
                u = m;
                break;
              } else {
                const b = m.value;
                if (b.parentNode && b.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const S = b.parentNode.host;
                  if (this.mirror.getId(S) !== -1) {
                    u = m;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!u) {
          for (; r.head; )
            r.removeNode(r.head.value);
          break;
        }
        s = u.previous, r.removeNode(u.value), o(u.value);
      }
      const c = {
        texts: this.texts.map((u) => {
          const f = u.node;
          return f.parentNode && f.parentNode.tagName === "TEXTAREA" && this.genTextAreaValueMutation(f.parentNode), {
            id: this.mirror.getId(f),
            value: u.value
          };
        }).filter((u) => !n.has(u.id)).filter((u) => this.mirror.has(u.id)),
        attributes: this.attributes.map((u) => {
          const { attributes: f } = u;
          if (typeof f.style == "string") {
            const m = JSON.stringify(u.styleDiff), v = JSON.stringify(u._unchangedStyles);
            m.length < f.style.length && (m + v).split("var(").length === f.style.split("var(").length && (f.style = u.styleDiff);
          }
          return {
            id: this.mirror.getId(u.node),
            attributes: f
          };
        }).filter((u) => !n.has(u.id)).filter((u) => this.mirror.has(u.id)),
        removes: this.removes,
        adds: t
      };
      !c.texts.length && !c.attributes.length && !c.removes.length && !c.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(c));
    }, this.genTextAreaValueMutation = (t) => {
      let n = this.attributeMap.get(t);
      n || (n = {
        node: t,
        attributes: {},
        styleDiff: {},
        _unchangedStyles: {}
      }, this.attributes.push(n), this.attributeMap.set(t, n)), n.attributes.value = Array.from(t.childNodes, (r) => r.textContent || "").join("");
    }, this.processMutation = (t) => {
      if (!bN(t.target, this.mirror))
        switch (t.type) {
          case "characterData": {
            const n = t.target.textContent;
            !Ll(t.target, this.blockClass, this.blockSelector, !1) && n !== t.oldValue && this.texts.push({
              value: Zle(t.target, this.maskTextClass, this.maskTextSelector, !0) && n ? this.maskTextFn ? this.maskTextFn(n, qle(t.target)) : n.replace(/[\S]/g, "*") : n,
              node: t.target
            });
            break;
          }
          case "attributes": {
            const n = t.target;
            let r = t.attributeName, a = t.target.getAttribute(r);
            if (r === "value") {
              const s = OD(n);
              a = TD({
                element: n,
                maskInputOptions: this.maskInputOptions,
                tagName: n.tagName,
                type: s,
                value: a,
                maskInputFn: this.maskInputFn
              });
            }
            if (Ll(t.target, this.blockClass, this.blockSelector, !1) || a === t.oldValue)
              return;
            let o = this.attributeMap.get(t.target);
            if (n.tagName === "IFRAME" && r === "src" && !this.keepIframeSrcFn(a))
              if (!n.contentDocument)
                r = "rr_src";
              else
                return;
            if (o || (o = {
              node: t.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(o), this.attributeMap.set(t.target, o)), r === "type" && n.tagName === "INPUT" && (t.oldValue || "").toLowerCase() === "password" && n.setAttribute("data-rr-is-password", "true"), !Wle(n.tagName, r) && (o.attributes[r] = Hle(this.doc, n1(n.tagName), n1(r), a), r === "style")) {
              if (!this.unattachedDoc)
                try {
                  this.unattachedDoc = document.implementation.createHTMLDocument();
                } catch (c) {
                  this.unattachedDoc = this.doc;
                }
              const s = this.unattachedDoc.createElement("span");
              t.oldValue && s.setAttribute("style", t.oldValue);
              for (const c of Array.from(n.style)) {
                const u = n.style.getPropertyValue(c), f = n.style.getPropertyPriority(c);
                u !== s.style.getPropertyValue(c) || f !== s.style.getPropertyPriority(c) ? f === "" ? o.styleDiff[c] = u : o.styleDiff[c] = [u, f] : o._unchangedStyles[c] = [u, f];
              }
              for (const c of Array.from(s.style))
                n.style.getPropertyValue(c) === "" && (o.styleDiff[c] = !1);
            }
            break;
          }
          case "childList": {
            if (Ll(t.target, this.blockClass, this.blockSelector, !0))
              return;
            if (t.target.tagName === "TEXTAREA") {
              this.genTextAreaValueMutation(t.target);
              return;
            }
            t.addedNodes.forEach((n) => this.genAdds(n, t.target)), t.removedNodes.forEach((n) => {
              const r = this.mirror.getId(n), a = X4(t.target) ? this.mirror.getId(t.target.host) : this.mirror.getId(t.target);
              Ll(t.target, this.blockClass, this.blockSelector, !1) || bN(n, this.mirror) || !fot(n, this.mirror) || (this.addedSet.has(n) ? (aR(this.addedSet, n), this.droppedSet.add(n)) : this.addedSet.has(t.target) && r === -1 || Jle(t.target, this.mirror) || (this.movedSet.has(n) && this.movedMap[kq(r, a)] ? aR(this.movedSet, n) : this.removes.push({
                parentId: a,
                id: r,
                isShadow: X4(t.target) && K4(t.target) ? !0 : void 0
              })), this.mapRemoves.push(n));
            });
            break;
          }
        }
    }, this.genAdds = (t, n) => {
      if (!this.processedNodeManager.inOtherBuffer(t, this) && !(this.addedSet.has(t) || this.movedSet.has(t))) {
        if (this.mirror.hasNode(t)) {
          if (bN(t, this.mirror))
            return;
          this.movedSet.add(t);
          let r = null;
          n && this.mirror.hasNode(n) && (r = this.mirror.getId(n)), r && r !== -1 && (this.movedMap[kq(this.mirror.getId(t), r)] = !0);
        } else
          this.addedSet.add(t), this.droppedSet.delete(t);
        Ll(t, this.blockClass, this.blockSelector, !1) || (t.childNodes.forEach((r) => this.genAdds(r)), rR(t) && t.shadowRoot.childNodes.forEach((r) => {
          this.processedNodeManager.add(r, this), this.genAdds(r, t);
        }));
      }
    };
  }
  init(t) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "maskTextClass",
      "maskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((n) => {
      this[n] = t[n];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function aR(e, t) {
  e.delete(t), t.childNodes.forEach((n) => aR(e, n));
}
function Aq(e, t, n) {
  return e.length === 0 ? !1 : rue(e, t, n);
}
function rue(e, t, n) {
  const { parentNode: r } = t;
  if (!r)
    return !1;
  const a = n.getId(r);
  return e.some((o) => o.id === a) ? !0 : rue(e, r, n);
}
function Pq(e, t) {
  return e.size === 0 ? !1 : aue(e, t);
}
function aue(e, t) {
  const { parentNode: n } = t;
  return n ? e.has(n) ? !0 : aue(e, n) : !1;
}
let q4;
function bot(e) {
  q4 = e;
}
function _ot() {
  q4 = void 0;
}
const Wr = (e) => q4 ? (...n) => {
  try {
    return e(...n);
  } catch (r) {
    if (q4 && q4(r) === !0)
      return;
    throw r;
  }
} : e, R0 = [];
function hC(e) {
  try {
    if ("composedPath" in e) {
      const t = e.composedPath();
      if (t.length)
        return t[0];
    } else if ("path" in e && e.path.length)
      return e.path[0];
  } catch (t) {
  }
  return e && e.target;
}
function oue(e, t) {
  var n, r;
  const a = new yot();
  R0.push(a), a.init(e);
  let o = window.MutationObserver || window.__rrMutationObserver;
  const s = (r = (n = window == null ? void 0 : window.Zone) === null || n === void 0 ? void 0 : n.__symbol__) === null || r === void 0 ? void 0 : r.call(n, "MutationObserver");
  s && window[s] && (o = window[s]);
  const c = new o(Wr(a.processMutations.bind(a)));
  return c.observe(t, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), c;
}
function Cot({ mousemoveCb: e, sampling: t, doc: n, mirror: r }) {
  if (t.mousemove === !1)
    return () => {
    };
  const a = typeof t.mousemove == "number" ? t.mousemove : 50, o = typeof t.mousemoveCallback == "number" ? t.mousemoveCallback : 500;
  let s = [], c;
  const u = b_(Wr((v) => {
    const y = Date.now() - c;
    e(s.map((b) => (b.timeOffset -= y, b)), v), s = [], c = null;
  }), o), f = Wr(b_(Wr((v) => {
    const y = hC(v), { clientX: b, clientY: S } = nR(v) ? v.changedTouches[0] : v;
    c || (c = S6()), s.push({
      x: b,
      y: S,
      id: r.getId(y),
      timeOffset: S6() - c
    }), u(typeof DragEvent != "undefined" && v instanceof DragEvent ? jr.Drag : v instanceof MouseEvent ? jr.MouseMove : jr.TouchMove);
  }), a, {
    trailing: !1
  })), m = [
    Dl("mousemove", f, n),
    Dl("touchmove", f, n),
    Dl("drag", f, n)
  ];
  return Wr(() => {
    m.forEach((v) => v());
  });
}
function wot({ mouseInteractionCb: e, doc: t, mirror: n, blockClass: r, blockSelector: a, sampling: o }) {
  if (o.mouseInteraction === !1)
    return () => {
    };
  const s = o.mouseInteraction === !0 || o.mouseInteraction === void 0 ? {} : o.mouseInteraction, c = [];
  let u = null;
  const f = (m) => (v) => {
    const y = hC(v);
    if (Ll(y, r, a, !0))
      return;
    let b = null, S = m;
    if ("pointerType" in v) {
      switch (v.pointerType) {
        case "mouse":
          b = Tp.Mouse;
          break;
        case "touch":
          b = Tp.Touch;
          break;
        case "pen":
          b = Tp.Pen;
          break;
      }
      b === Tp.Touch ? iu[m] === iu.MouseDown ? S = "TouchStart" : iu[m] === iu.MouseUp && (S = "TouchEnd") : Tp.Pen;
    } else nR(v) && (b = Tp.Touch);
    b !== null ? (u = b, (S.startsWith("Touch") && b === Tp.Touch || S.startsWith("Mouse") && b === Tp.Mouse) && (b = null)) : iu[m] === iu.Click && (b = u, u = null);
    const x = nR(v) ? v.changedTouches[0] : v;
    if (!x)
      return;
    const E = n.getId(y), { clientX: N, clientY: R } = x;
    Wr(e)(Object.assign({ type: iu[S], id: E, x: N, y: R }, b !== null && { pointerType: b }));
  };
  return Object.keys(iu).filter((m) => Number.isNaN(Number(m)) && !m.endsWith("_Departed") && s[m] !== !1).forEach((m) => {
    let v = n1(m);
    const y = f(m);
    if (window.PointerEvent)
      switch (iu[m]) {
        case iu.MouseDown:
        case iu.MouseUp:
          v = v.replace("mouse", "pointer");
          break;
        case iu.TouchStart:
        case iu.TouchEnd:
          return;
      }
    c.push(Dl(v, y, t));
  }), Wr(() => {
    c.forEach((m) => m());
  });
}
function iue({ scrollCb: e, doc: t, mirror: n, blockClass: r, blockSelector: a, sampling: o }) {
  const s = Wr(b_(Wr((c) => {
    const u = hC(c);
    if (!u || Ll(u, r, a, !0))
      return;
    const f = n.getId(u);
    if (u === t && t.defaultView) {
      const m = Yle(t.defaultView);
      e({
        id: f,
        x: m.left,
        y: m.top
      });
    } else
      e({
        id: f,
        x: u.scrollLeft,
        y: u.scrollTop
      });
  }), o.scroll || 100));
  return Dl("scroll", s, t);
}
function Sot({ viewportResizeCb: e }, { win: t }) {
  let n = -1, r = -1;
  const a = Wr(b_(Wr(() => {
    const o = Xle(), s = Kle();
    (n !== o || r !== s) && (e({
      width: Number(s),
      height: Number(o)
    }), n = o, r = s);
  }), 200));
  return Dl("resize", a, t);
}
const xot = ["INPUT", "TEXTAREA", "SELECT"], Nq = /* @__PURE__ */ new WeakMap();
function Eot({ inputCb: e, doc: t, mirror: n, blockClass: r, blockSelector: a, ignoreClass: o, ignoreSelector: s, maskInputOptions: c, maskInputFn: u, sampling: f, userTriggeredOnInput: m }) {
  function v(R) {
    let O = hC(R);
    const D = R.isTrusted, $ = O && O.tagName;
    if (O && $ === "OPTION" && (O = O.parentElement), !O || !$ || xot.indexOf($) < 0 || Ll(O, r, a, !0) || O.classList.contains(o) || s && O.matches(s))
      return;
    let B = O.value, G = !1;
    const Z = OD(O) || "";
    Z === "radio" || Z === "checkbox" ? G = O.checked : (c[$.toLowerCase()] || c[Z]) && (B = TD({
      element: O,
      maskInputOptions: c,
      tagName: $,
      type: Z,
      value: B,
      maskInputFn: u
    })), y(O, m ? { text: B, isChecked: G, userTriggered: D } : { text: B, isChecked: G });
    const K = O.name;
    Z === "radio" && K && G && t.querySelectorAll(`input[type="radio"][name="${K}"]`).forEach((q) => {
      if (q !== O) {
        const pe = q.value;
        y(q, m ? { text: pe, isChecked: !G, userTriggered: !1 } : { text: pe, isChecked: !G });
      }
    });
  }
  function y(R, O) {
    const D = Nq.get(R);
    if (!D || D.text !== O.text || D.isChecked !== O.isChecked) {
      Nq.set(R, O);
      const $ = n.getId(R);
      Wr(e)(Object.assign(Object.assign({}, O), { id: $ }));
    }
  }
  const S = (f.input === "last" ? ["change"] : ["input", "change"]).map((R) => Dl(R, Wr(v), t)), x = t.defaultView;
  if (!x)
    return () => {
      S.forEach((R) => R());
    };
  const E = x.Object.getOwnPropertyDescriptor(x.HTMLInputElement.prototype, "value"), N = [
    [x.HTMLInputElement.prototype, "value"],
    [x.HTMLInputElement.prototype, "checked"],
    [x.HTMLSelectElement.prototype, "value"],
    [x.HTMLTextAreaElement.prototype, "value"],
    [x.HTMLSelectElement.prototype, "selectedIndex"],
    [x.HTMLOptionElement.prototype, "selected"]
  ];
  return E && E.set && S.push(...N.map((R) => z8(R[0], R[1], {
    set() {
      Wr(v)({
        target: this,
        isTrusted: !1
      });
    }
  }, !1, x))), Wr(() => {
    S.forEach((R) => R());
  });
}
function x6(e) {
  const t = [];
  function n(r, a) {
    if (gx("CSSGroupingRule") && r.parentRule instanceof CSSGroupingRule || gx("CSSMediaRule") && r.parentRule instanceof CSSMediaRule || gx("CSSSupportsRule") && r.parentRule instanceof CSSSupportsRule || gx("CSSConditionRule") && r.parentRule instanceof CSSConditionRule) {
      const s = Array.from(r.parentRule.cssRules).indexOf(r);
      a.unshift(s);
    } else if (r.parentStyleSheet) {
      const s = Array.from(r.parentStyleSheet.cssRules).indexOf(r);
      a.unshift(s);
    }
    return a;
  }
  return n(e, t);
}
function bm(e, t, n) {
  let r, a;
  return e ? (e.ownerNode ? r = t.getId(e.ownerNode) : a = n.getId(e), {
    styleId: a,
    id: r
  }) : {};
}
function Iot({ styleSheetRuleCb: e, mirror: t, stylesheetManager: n }, { win: r }) {
  if (!r.CSSStyleSheet || !r.CSSStyleSheet.prototype)
    return () => {
    };
  const a = r.CSSStyleSheet.prototype.insertRule;
  r.CSSStyleSheet.prototype.insertRule = new Proxy(a, {
    apply: Wr((m, v, y) => {
      const [b, S] = y, { id: x, styleId: E } = bm(v, t, n.styleMirror);
      return (x && x !== -1 || E && E !== -1) && e({
        id: x,
        styleId: E,
        adds: [{ rule: b, index: S }]
      }), m.apply(v, y);
    })
  });
  const o = r.CSSStyleSheet.prototype.deleteRule;
  r.CSSStyleSheet.prototype.deleteRule = new Proxy(o, {
    apply: Wr((m, v, y) => {
      const [b] = y, { id: S, styleId: x } = bm(v, t, n.styleMirror);
      return (S && S !== -1 || x && x !== -1) && e({
        id: S,
        styleId: x,
        removes: [{ index: b }]
      }), m.apply(v, y);
    })
  });
  let s;
  r.CSSStyleSheet.prototype.replace && (s = r.CSSStyleSheet.prototype.replace, r.CSSStyleSheet.prototype.replace = new Proxy(s, {
    apply: Wr((m, v, y) => {
      const [b] = y, { id: S, styleId: x } = bm(v, t, n.styleMirror);
      return (S && S !== -1 || x && x !== -1) && e({
        id: S,
        styleId: x,
        replace: b
      }), m.apply(v, y);
    })
  }));
  let c;
  r.CSSStyleSheet.prototype.replaceSync && (c = r.CSSStyleSheet.prototype.replaceSync, r.CSSStyleSheet.prototype.replaceSync = new Proxy(c, {
    apply: Wr((m, v, y) => {
      const [b] = y, { id: S, styleId: x } = bm(v, t, n.styleMirror);
      return (S && S !== -1 || x && x !== -1) && e({
        id: S,
        styleId: x,
        replaceSync: b
      }), m.apply(v, y);
    })
  }));
  const u = {};
  yx("CSSGroupingRule") ? u.CSSGroupingRule = r.CSSGroupingRule : (yx("CSSMediaRule") && (u.CSSMediaRule = r.CSSMediaRule), yx("CSSConditionRule") && (u.CSSConditionRule = r.CSSConditionRule), yx("CSSSupportsRule") && (u.CSSSupportsRule = r.CSSSupportsRule));
  const f = {};
  return Object.entries(u).forEach(([m, v]) => {
    f[m] = {
      insertRule: v.prototype.insertRule,
      deleteRule: v.prototype.deleteRule
    }, v.prototype.insertRule = new Proxy(f[m].insertRule, {
      apply: Wr((y, b, S) => {
        const [x, E] = S, { id: N, styleId: R } = bm(b.parentStyleSheet, t, n.styleMirror);
        return (N && N !== -1 || R && R !== -1) && e({
          id: N,
          styleId: R,
          adds: [
            {
              rule: x,
              index: [
                ...x6(b),
                E || 0
              ]
            }
          ]
        }), y.apply(b, S);
      })
    }), v.prototype.deleteRule = new Proxy(f[m].deleteRule, {
      apply: Wr((y, b, S) => {
        const [x] = S, { id: E, styleId: N } = bm(b.parentStyleSheet, t, n.styleMirror);
        return (E && E !== -1 || N && N !== -1) && e({
          id: E,
          styleId: N,
          removes: [
            { index: [...x6(b), x] }
          ]
        }), y.apply(b, S);
      })
    });
  }), Wr(() => {
    r.CSSStyleSheet.prototype.insertRule = a, r.CSSStyleSheet.prototype.deleteRule = o, s && (r.CSSStyleSheet.prototype.replace = s), c && (r.CSSStyleSheet.prototype.replaceSync = c), Object.entries(u).forEach(([m, v]) => {
      v.prototype.insertRule = f[m].insertRule, v.prototype.deleteRule = f[m].deleteRule;
    });
  });
}
function sue({ mirror: e, stylesheetManager: t }, n) {
  var r, a, o;
  let s = null;
  n.nodeName === "#document" ? s = e.getId(n) : s = e.getId(n.host);
  const c = n.nodeName === "#document" ? (r = n.defaultView) === null || r === void 0 ? void 0 : r.Document : (o = (a = n.ownerDocument) === null || a === void 0 ? void 0 : a.defaultView) === null || o === void 0 ? void 0 : o.ShadowRoot, u = c != null && c.prototype ? Object.getOwnPropertyDescriptor(c == null ? void 0 : c.prototype, "adoptedStyleSheets") : void 0;
  return s === null || s === -1 || !c || !u ? () => {
  } : (Object.defineProperty(n, "adoptedStyleSheets", {
    configurable: u.configurable,
    enumerable: u.enumerable,
    get() {
      var f;
      return (f = u.get) === null || f === void 0 ? void 0 : f.call(this);
    },
    set(f) {
      var m;
      const v = (m = u.set) === null || m === void 0 ? void 0 : m.call(this, f);
      if (s !== null && s !== -1)
        try {
          t.adoptStyleSheets(f, s);
        } catch (y) {
        }
      return v;
    }
  }), Wr(() => {
    Object.defineProperty(n, "adoptedStyleSheets", {
      configurable: u.configurable,
      enumerable: u.enumerable,
      get: u.get,
      set: u.set
    });
  }));
}
function kot({ styleDeclarationCb: e, mirror: t, ignoreCSSAttributes: n, stylesheetManager: r }, { win: a }) {
  const o = a.CSSStyleDeclaration.prototype.setProperty;
  a.CSSStyleDeclaration.prototype.setProperty = new Proxy(o, {
    apply: Wr((c, u, f) => {
      var m;
      const [v, y, b] = f;
      if (n.has(v))
        return o.apply(u, [v, y, b]);
      const { id: S, styleId: x } = bm((m = u.parentRule) === null || m === void 0 ? void 0 : m.parentStyleSheet, t, r.styleMirror);
      return (S && S !== -1 || x && x !== -1) && e({
        id: S,
        styleId: x,
        set: {
          property: v,
          value: y,
          priority: b
        },
        index: x6(u.parentRule)
      }), c.apply(u, f);
    })
  });
  const s = a.CSSStyleDeclaration.prototype.removeProperty;
  return a.CSSStyleDeclaration.prototype.removeProperty = new Proxy(s, {
    apply: Wr((c, u, f) => {
      var m;
      const [v] = f;
      if (n.has(v))
        return s.apply(u, [v]);
      const { id: y, styleId: b } = bm((m = u.parentRule) === null || m === void 0 ? void 0 : m.parentStyleSheet, t, r.styleMirror);
      return (y && y !== -1 || b && b !== -1) && e({
        id: y,
        styleId: b,
        remove: {
          property: v
        },
        index: x6(u.parentRule)
      }), c.apply(u, f);
    })
  }), Wr(() => {
    a.CSSStyleDeclaration.prototype.setProperty = o, a.CSSStyleDeclaration.prototype.removeProperty = s;
  });
}
function Aot({ mediaInteractionCb: e, blockClass: t, blockSelector: n, mirror: r, sampling: a, doc: o }) {
  const s = Wr((u) => b_(Wr((f) => {
    const m = hC(f);
    if (!m || Ll(m, t, n, !0))
      return;
    const { currentTime: v, volume: y, muted: b, playbackRate: S, loop: x } = m;
    e({
      type: u,
      id: r.getId(m),
      currentTime: v,
      volume: y,
      muted: b,
      playbackRate: S,
      loop: x
    });
  }), a.media || 500)), c = [
    Dl("play", s(0), o),
    Dl("pause", s(1), o),
    Dl("seeked", s(2), o),
    Dl("volumechange", s(3), o),
    Dl("ratechange", s(4), o)
  ];
  return Wr(() => {
    c.forEach((u) => u());
  });
}
function Pot({ fontCb: e, doc: t }) {
  const n = t.defaultView;
  if (!n)
    return () => {
    };
  const r = [], a = /* @__PURE__ */ new WeakMap(), o = n.FontFace;
  n.FontFace = function(u, f, m) {
    const v = new o(u, f, m);
    return a.set(v, {
      family: u,
      buffer: typeof f != "string",
      descriptors: m,
      fontSource: typeof f == "string" ? f : JSON.stringify(Array.from(new Uint8Array(f)))
    }), v;
  };
  const s = H2(t.fonts, "add", function(c) {
    return function(u) {
      return setTimeout(Wr(() => {
        const f = a.get(u);
        f && (e(f), a.delete(u));
      }), 0), c.apply(this, [u]);
    };
  });
  return r.push(() => {
    n.FontFace = o;
  }), r.push(s), Wr(() => {
    r.forEach((c) => c());
  });
}
function Not(e) {
  const { doc: t, mirror: n, blockClass: r, blockSelector: a, selectionCb: o } = e;
  let s = !0;
  const c = Wr(() => {
    const u = t.getSelection();
    if (!u || s && (u != null && u.isCollapsed))
      return;
    s = u.isCollapsed || !1;
    const f = [], m = u.rangeCount || 0;
    for (let v = 0; v < m; v++) {
      const y = u.getRangeAt(v), { startContainer: b, startOffset: S, endContainer: x, endOffset: E } = y;
      Ll(b, r, a, !0) || Ll(x, r, a, !0) || f.push({
        start: n.getId(b),
        startOffset: S,
        end: n.getId(x),
        endOffset: E
      });
    }
    o({ ranges: f });
  });
  return c(), Dl("selectionchange", c);
}
function Tot({ doc: e, customElementCb: t }) {
  const n = e.defaultView;
  return !n || !n.customElements ? () => {
  } : H2(n.customElements, "define", function(a) {
    return function(o, s, c) {
      try {
        t({
          define: {
            name: o
          }
        });
      } catch (u) {
        console.warn(`Custom element callback failed for ${o}`);
      }
      return a.apply(this, [o, s, c]);
    };
  });
}
function Oot(e, t) {
  const { mutationCb: n, mousemoveCb: r, mouseInteractionCb: a, scrollCb: o, viewportResizeCb: s, inputCb: c, mediaInteractionCb: u, styleSheetRuleCb: f, styleDeclarationCb: m, canvasMutationCb: v, fontCb: y, selectionCb: b, customElementCb: S } = e;
  e.mutationCb = (...x) => {
    t.mutation && t.mutation(...x), n(...x);
  }, e.mousemoveCb = (...x) => {
    t.mousemove && t.mousemove(...x), r(...x);
  }, e.mouseInteractionCb = (...x) => {
    t.mouseInteraction && t.mouseInteraction(...x), a(...x);
  }, e.scrollCb = (...x) => {
    t.scroll && t.scroll(...x), o(...x);
  }, e.viewportResizeCb = (...x) => {
    t.viewportResize && t.viewportResize(...x), s(...x);
  }, e.inputCb = (...x) => {
    t.input && t.input(...x), c(...x);
  }, e.mediaInteractionCb = (...x) => {
    t.mediaInteaction && t.mediaInteaction(...x), u(...x);
  }, e.styleSheetRuleCb = (...x) => {
    t.styleSheetRule && t.styleSheetRule(...x), f(...x);
  }, e.styleDeclarationCb = (...x) => {
    t.styleDeclaration && t.styleDeclaration(...x), m(...x);
  }, e.canvasMutationCb = (...x) => {
    t.canvasMutation && t.canvasMutation(...x), v(...x);
  }, e.fontCb = (...x) => {
    t.font && t.font(...x), y(...x);
  }, e.selectionCb = (...x) => {
    t.selection && t.selection(...x), b(...x);
  }, e.customElementCb = (...x) => {
    t.customElement && t.customElement(...x), S(...x);
  };
}
function Rot(e, t = {}) {
  const n = e.doc.defaultView;
  if (!n)
    return () => {
    };
  Oot(e, t);
  let r;
  e.recordDOM && (r = oue(e, e.doc));
  const a = Cot(e), o = wot(e), s = iue(e), c = Sot(e, {
    win: n
  }), u = Eot(e), f = Aot(e);
  let m = () => {
  }, v = () => {
  }, y = () => {
  }, b = () => {
  };
  e.recordDOM && (m = Iot(e, { win: n }), v = sue(e, e.doc), y = kot(e, {
    win: n
  }), e.collectFonts && (b = Pot(e)));
  const S = Not(e), x = Tot(e), E = [];
  for (const N of e.plugins)
    E.push(N.observer(N.callback, n, N.options));
  return Wr(() => {
    R0.forEach((N) => N.reset()), r == null || r.disconnect(), a(), o(), s(), c(), u(), f(), m(), v(), y(), b(), S(), x(), E.forEach((N) => N());
  });
}
function gx(e) {
  return typeof window[e] != "undefined";
}
function yx(e) {
  return !!(typeof window[e] != "undefined" && window[e].prototype && "insertRule" in window[e].prototype && "deleteRule" in window[e].prototype);
}
class Tq {
  constructor(t) {
    this.generateIdFn = t, this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t, n, r, a) {
    const o = r || this.getIdToRemoteIdMap(t), s = a || this.getRemoteIdToIdMap(t);
    let c = o.get(n);
    return c || (c = this.generateIdFn(), o.set(n, c), s.set(c, n)), c;
  }
  getIds(t, n) {
    const r = this.getIdToRemoteIdMap(t), a = this.getRemoteIdToIdMap(t);
    return n.map((o) => this.getId(t, o, r, a));
  }
  getRemoteId(t, n, r) {
    const a = r || this.getRemoteIdToIdMap(t);
    if (typeof n != "number")
      return n;
    const o = a.get(n);
    return o || -1;
  }
  getRemoteIds(t, n) {
    const r = this.getRemoteIdToIdMap(t);
    return n.map((a) => this.getRemoteId(t, a, r));
  }
  reset(t) {
    if (!t) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(t), this.iframeRemoteIdToIdMap.delete(t);
  }
  getIdToRemoteIdMap(t) {
    let n = this.iframeIdToRemoteIdMap.get(t);
    return n || (n = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(t, n)), n;
  }
  getRemoteIdToIdMap(t) {
    let n = this.iframeRemoteIdToIdMap.get(t);
    return n || (n = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(t, n)), n;
  }
}
class Mot {
  constructor(t) {
    this.iframes = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMirror = new Tq(zle), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap(), this.mutationCb = t.mutationCb, this.wrappedEmit = t.wrappedEmit, this.stylesheetManager = t.stylesheetManager, this.recordCrossOriginIframes = t.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new Tq(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror)), this.mirror = t.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(t) {
    this.iframes.set(t, !0), t.contentWindow && this.crossOriginIframeMap.set(t.contentWindow, t);
  }
  addLoadListener(t) {
    this.loadListener = t;
  }
  attachIframe(t, n) {
    var r;
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(t),
          nextId: null,
          node: n
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), (r = this.loadListener) === null || r === void 0 || r.call(this, t), t.contentDocument && t.contentDocument.adoptedStyleSheets && t.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(t.contentDocument.adoptedStyleSheets, this.mirror.getId(t.contentDocument));
  }
  handleMessage(t) {
    const n = t;
    if (n.data.type !== "rrweb" || n.origin !== n.data.origin || !t.source)
      return;
    const a = this.crossOriginIframeMap.get(t.source);
    if (!a)
      return;
    const o = this.transformCrossOriginEvent(a, n.data.event);
    o && this.wrappedEmit(o, n.data.isCheckout);
  }
  transformCrossOriginEvent(t, n) {
    var r;
    switch (n.type) {
      case qr.FullSnapshot: {
        this.crossOriginIframeMirror.reset(t), this.crossOriginIframeStyleMirror.reset(t), this.replaceIdOnNode(n.data.node, t);
        const a = n.data.node.id;
        return this.crossOriginIframeRootIdMap.set(t, a), this.patchRootIdOnNode(n.data.node, a), {
          timestamp: n.timestamp,
          type: qr.IncrementalSnapshot,
          data: {
            source: jr.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(t),
                nextId: null,
                node: n.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case qr.Meta:
      case qr.Load:
      case qr.DomContentLoaded:
        return !1;
      case qr.Plugin:
        return n;
      case qr.Custom:
        return this.replaceIds(n.data.payload, t, ["id", "parentId", "previousId", "nextId"]), n;
      case qr.IncrementalSnapshot:
        switch (n.data.source) {
          case jr.Mutation:
            return n.data.adds.forEach((a) => {
              this.replaceIds(a, t, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(a.node, t);
              const o = this.crossOriginIframeRootIdMap.get(t);
              o && this.patchRootIdOnNode(a.node, o);
            }), n.data.removes.forEach((a) => {
              this.replaceIds(a, t, ["parentId", "id"]);
            }), n.data.attributes.forEach((a) => {
              this.replaceIds(a, t, ["id"]);
            }), n.data.texts.forEach((a) => {
              this.replaceIds(a, t, ["id"]);
            }), n;
          case jr.Drag:
          case jr.TouchMove:
          case jr.MouseMove:
            return n.data.positions.forEach((a) => {
              this.replaceIds(a, t, ["id"]);
            }), n;
          case jr.ViewportResize:
            return !1;
          case jr.MediaInteraction:
          case jr.MouseInteraction:
          case jr.Scroll:
          case jr.CanvasMutation:
          case jr.Input:
            return this.replaceIds(n.data, t, ["id"]), n;
          case jr.StyleSheetRule:
          case jr.StyleDeclaration:
            return this.replaceIds(n.data, t, ["id"]), this.replaceStyleIds(n.data, t, ["styleId"]), n;
          case jr.Font:
            return n;
          case jr.Selection:
            return n.data.ranges.forEach((a) => {
              this.replaceIds(a, t, ["start", "end"]);
            }), n;
          case jr.AdoptedStyleSheet:
            return this.replaceIds(n.data, t, ["id"]), this.replaceStyleIds(n.data, t, ["styleIds"]), (r = n.data.styles) === null || r === void 0 || r.forEach((a) => {
              this.replaceStyleIds(a, t, ["styleId"]);
            }), n;
        }
    }
    return !1;
  }
  replace(t, n, r, a) {
    for (const o of a)
      !Array.isArray(n[o]) && typeof n[o] != "number" || (Array.isArray(n[o]) ? n[o] = t.getIds(r, n[o]) : n[o] = t.getId(r, n[o]));
    return n;
  }
  replaceIds(t, n, r) {
    return this.replace(this.crossOriginIframeMirror, t, n, r);
  }
  replaceStyleIds(t, n, r) {
    return this.replace(this.crossOriginIframeStyleMirror, t, n, r);
  }
  replaceIdOnNode(t, n) {
    this.replaceIds(t, n, ["id", "rootId"]), "childNodes" in t && t.childNodes.forEach((r) => {
      this.replaceIdOnNode(r, n);
    });
  }
  patchRootIdOnNode(t, n) {
    t.type !== Ai.Document && !t.rootId && (t.rootId = n), "childNodes" in t && t.childNodes.forEach((r) => {
      this.patchRootIdOnNode(r, n);
    });
  }
}
class Dot {
  constructor(t) {
    this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.restoreHandlers = [], this.mutationCb = t.mutationCb, this.scrollCb = t.scrollCb, this.bypassOptions = t.bypassOptions, this.mirror = t.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(t, n) {
    if (!K4(t) || this.shadowDoms.has(t))
      return;
    this.shadowDoms.add(t);
    const r = oue(Object.assign(Object.assign({}, this.bypassOptions), { doc: n, mutationCb: this.mutationCb, mirror: this.mirror, shadowDomManager: this }), t);
    this.restoreHandlers.push(() => r.disconnect()), this.restoreHandlers.push(iue(Object.assign(Object.assign({}, this.bypassOptions), { scrollCb: this.scrollCb, doc: t, mirror: this.mirror }))), setTimeout(() => {
      t.adoptedStyleSheets && t.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(t.adoptedStyleSheets, this.mirror.getId(t.host)), this.restoreHandlers.push(sue({
        mirror: this.mirror,
        stylesheetManager: this.bypassOptions.stylesheetManager
      }, t));
    }, 0);
  }
  observeAttachShadow(t) {
    !t.contentWindow || !t.contentDocument || this.patchAttachShadow(t.contentWindow.Element, t.contentDocument);
  }
  patchAttachShadow(t, n) {
    const r = this;
    this.restoreHandlers.push(H2(t.prototype, "attachShadow", function(a) {
      return function(o) {
        const s = a.call(this, o);
        return this.shadowRoot && nue(this) && r.addShadowRoot(this.shadowRoot, n), s;
      };
    }));
  }
  reset() {
    this.restoreHandlers.forEach((t) => {
      try {
        t();
      } catch (n) {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
  }
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function Lot(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function $ot(e, t, n, r) {
  function a(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function c(m) {
      try {
        f(r.next(m));
      } catch (v) {
        s(v);
      }
    }
    function u(m) {
      try {
        f(r.throw(m));
      } catch (v) {
        s(v);
      }
    }
    function f(m) {
      m.done ? o(m.value) : a(m.value).then(c, u);
    }
    f((r = r.apply(e, [])).next());
  });
}
var zy = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", jot = typeof Uint8Array == "undefined" ? [] : new Uint8Array(256);
for (var bx = 0; bx < zy.length; bx++)
  jot[zy.charCodeAt(bx)] = bx;
var Fot = function(e) {
  var t = new Uint8Array(e), n, r = t.length, a = "";
  for (n = 0; n < r; n += 3)
    a += zy[t[n] >> 2], a += zy[(t[n] & 3) << 4 | t[n + 1] >> 4], a += zy[(t[n + 1] & 15) << 2 | t[n + 2] >> 6], a += zy[t[n + 2] & 63];
  return r % 3 === 2 ? a = a.substring(0, a.length - 1) + "=" : r % 3 === 1 && (a = a.substring(0, a.length - 2) + "=="), a;
};
const Oq = /* @__PURE__ */ new Map();
function Bot(e, t) {
  let n = Oq.get(e);
  return n || (n = /* @__PURE__ */ new Map(), Oq.set(e, n)), n.has(t) || n.set(t, []), n.get(t);
}
const lue = (e, t, n) => {
  if (!e || !(cue(e, t) || typeof e == "object"))
    return;
  const r = e.constructor.name, a = Bot(n, r);
  let o = a.indexOf(e);
  return o === -1 && (o = a.length, a.push(e)), o;
};
function p7(e, t, n) {
  if (e instanceof Array)
    return e.map((r) => p7(r, t, n));
  if (e === null)
    return e;
  if (e instanceof Float32Array || e instanceof Float64Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Uint8Array || e instanceof Uint16Array || e instanceof Int16Array || e instanceof Int8Array || e instanceof Uint8ClampedArray)
    return {
      rr_type: e.constructor.name,
      args: [Object.values(e)]
    };
  if (e instanceof ArrayBuffer) {
    const r = e.constructor.name, a = Fot(e);
    return {
      rr_type: r,
      base64: a
    };
  } else {
    if (e instanceof DataView)
      return {
        rr_type: e.constructor.name,
        args: [
          p7(e.buffer, t, n),
          e.byteOffset,
          e.byteLength
        ]
      };
    if (e instanceof HTMLImageElement) {
      const r = e.constructor.name, { src: a } = e;
      return {
        rr_type: r,
        src: a
      };
    } else if (e instanceof HTMLCanvasElement) {
      const r = "HTMLImageElement", a = e.toDataURL();
      return {
        rr_type: r,
        src: a
      };
    } else {
      if (e instanceof ImageData)
        return {
          rr_type: e.constructor.name,
          args: [p7(e.data, t, n), e.width, e.height]
        };
      if (cue(e, t) || typeof e == "object") {
        const r = e.constructor.name, a = lue(e, t, n);
        return {
          rr_type: r,
          index: a
        };
      }
    }
  }
  return e;
}
const uue = (e, t, n) => e.map((r) => p7(r, t, n)), cue = (e, t) => !![
  "WebGLActiveInfo",
  "WebGLBuffer",
  "WebGLFramebuffer",
  "WebGLProgram",
  "WebGLRenderbuffer",
  "WebGLShader",
  "WebGLShaderPrecisionFormat",
  "WebGLTexture",
  "WebGLUniformLocation",
  "WebGLVertexArrayObject",
  "WebGLVertexArrayObjectOES"
].filter((a) => typeof t[a] == "function").find((a) => e instanceof t[a]);
function Vot(e, t, n, r) {
  const a = [], o = Object.getOwnPropertyNames(t.CanvasRenderingContext2D.prototype);
  for (const s of o)
    try {
      if (typeof t.CanvasRenderingContext2D.prototype[s] != "function")
        continue;
      const c = H2(t.CanvasRenderingContext2D.prototype, s, function(u) {
        return function(...f) {
          return Ll(this.canvas, n, r, !0) || setTimeout(() => {
            const m = uue(f, t, this);
            e(this.canvas, {
              type: C2["2D"],
              property: s,
              args: m
            });
          }, 0), u.apply(this, f);
        };
      });
      a.push(c);
    } catch (c) {
      const u = z8(t.CanvasRenderingContext2D.prototype, s, {
        set(f) {
          e(this.canvas, {
            type: C2["2D"],
            property: s,
            args: [f],
            setter: !0
          });
        }
      });
      a.push(u);
    }
  return () => {
    a.forEach((s) => s());
  };
}
function Uot(e) {
  return e === "experimental-webgl" ? "webgl" : e;
}
function Rq(e, t, n, r) {
  const a = [];
  try {
    const o = H2(e.HTMLCanvasElement.prototype, "getContext", function(s) {
      return function(c, ...u) {
        if (!Ll(this, t, n, !0)) {
          const f = Uot(c);
          if ("__context" in this || (this.__context = f), r && ["webgl", "webgl2"].includes(f))
            if (u[0] && typeof u[0] == "object") {
              const m = u[0];
              m.preserveDrawingBuffer || (m.preserveDrawingBuffer = !0);
            } else
              u.splice(0, 1, {
                preserveDrawingBuffer: !0
              });
        }
        return s.apply(this, [c, ...u]);
      };
    });
    a.push(o);
  } catch (o) {
    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
  }
  return () => {
    a.forEach((o) => o());
  };
}
function Mq(e, t, n, r, a, o, s) {
  const c = [], u = Object.getOwnPropertyNames(e);
  for (const f of u)
    if (![
      "isContextLost",
      "canvas",
      "drawingBufferWidth",
      "drawingBufferHeight"
    ].includes(f))
      try {
        if (typeof e[f] != "function")
          continue;
        const m = H2(e, f, function(v) {
          return function(...y) {
            const b = v.apply(this, y);
            if (lue(b, s, this), "tagName" in this.canvas && !Ll(this.canvas, r, a, !0)) {
              const S = uue(y, s, this), x = {
                type: t,
                property: f,
                args: S
              };
              n(this.canvas, x);
            }
            return b;
          };
        });
        c.push(m);
      } catch (m) {
        const v = z8(e, f, {
          set(y) {
            n(this.canvas, {
              type: t,
              property: f,
              args: [y],
              setter: !0
            });
          }
        });
        c.push(v);
      }
  return c;
}
function Got(e, t, n, r, a) {
  const o = [];
  return o.push(...Mq(t.WebGLRenderingContext.prototype, C2.WebGL, e, n, r, a, t)), typeof t.WebGL2RenderingContext != "undefined" && o.push(...Mq(t.WebGL2RenderingContext.prototype, C2.WebGL2, e, n, r, a, t)), () => {
    o.forEach((s) => s());
  };
}
function zot(e, t) {
  var n = e.toString(), r = n.split(`
`);
  r.pop(), r.shift();
  for (var a = r[0].search(/\S/), o = /(['"])__worker_loader_strict__(['"])/g, s = 0, c = r.length; s < c; ++s)
    r[s] = r[s].substring(a).replace(o, "$1use strict$2") + `
`;
  return r;
}
function Hot(e, t) {
  var n = zot(e), r = new Blob(n, { type: "application/javascript" });
  return URL.createObjectURL(r);
}
function Wot(e, t) {
  var n;
  return function(a) {
    return n = n || Hot(e), new Worker(n, a);
  };
}
var Zot = Wot(
  /* rollup-plugin-web-worker-loader */
  function() {
    (function() {
      "__worker_loader_strict__";
      /*! *****************************************************************************
          Copyright (c) Microsoft Corporation.
      
          Permission to use, copy, modify, and/or distribute this software for any
          purpose with or without fee is hereby granted.
      
          THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
          REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
          AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
          INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
          LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
          OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
          PERFORMANCE OF THIS SOFTWARE.
          ***************************************************************************** */
      function e(f, m, v, y) {
        function b(S) {
          return S instanceof v ? S : new v(function(x) {
            x(S);
          });
        }
        return new (v || (v = Promise))(function(S, x) {
          function E(O) {
            try {
              R(y.next(O));
            } catch (D) {
              x(D);
            }
          }
          function N(O) {
            try {
              R(y.throw(O));
            } catch (D) {
              x(D);
            }
          }
          function R(O) {
            O.done ? S(O.value) : b(O.value).then(E, N);
          }
          R((y = y.apply(f, [])).next());
        });
      }
      for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = typeof Uint8Array == "undefined" ? [] : new Uint8Array(256), r = 0; r < t.length; r++)
        n[t.charCodeAt(r)] = r;
      var a = function(f) {
        var m = new Uint8Array(f), v, y = m.length, b = "";
        for (v = 0; v < y; v += 3)
          b += t[m[v] >> 2], b += t[(m[v] & 3) << 4 | m[v + 1] >> 4], b += t[(m[v + 1] & 15) << 2 | m[v + 2] >> 6], b += t[m[v + 2] & 63];
        return y % 3 === 2 ? b = b.substring(0, b.length - 1) + "=" : y % 3 === 1 && (b = b.substring(0, b.length - 2) + "=="), b;
      };
      const o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
      function c(f, m, v) {
        return e(this, void 0, void 0, function* () {
          const y = `${f}-${m}`;
          if ("OffscreenCanvas" in globalThis) {
            if (s.has(y))
              return s.get(y);
            const b = new OffscreenCanvas(f, m);
            b.getContext("2d");
            const x = yield (yield b.convertToBlob(v)).arrayBuffer(), E = a(x);
            return s.set(y, E), E;
          } else
            return "";
        });
      }
      const u = self;
      u.onmessage = function(f) {
        return e(this, void 0, void 0, function* () {
          if ("OffscreenCanvas" in globalThis) {
            const { id: m, bitmap: v, width: y, height: b, dataURLOptions: S } = f.data, x = c(y, b, S), E = new OffscreenCanvas(y, b);
            E.getContext("2d").drawImage(v, 0, 0), v.close();
            const R = yield E.convertToBlob(S), O = R.type, D = yield R.arrayBuffer(), $ = a(D);
            if (!o.has(m) && (yield x) === $)
              return o.set(m, $), u.postMessage({ id: m });
            if (o.get(m) === $)
              return u.postMessage({ id: m });
            u.postMessage({
              id: m,
              type: O,
              base64: $,
              width: y,
              height: b
            }), o.set(m, $);
          } else
            return u.postMessage({ id: f.data.id });
        });
      };
    })();
  }
);
class Yot {
  reset() {
    this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers();
  }
  freeze() {
    this.frozen = !0;
  }
  unfreeze() {
    this.frozen = !1;
  }
  lock() {
    this.locked = !0;
  }
  unlock() {
    this.locked = !1;
  }
  constructor(t) {
    this.pendingCanvasMutations = /* @__PURE__ */ new Map(), this.rafStamps = { latestId: 0, invokeId: null }, this.frozen = !1, this.locked = !1, this.processMutation = (u, f) => {
      (this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId || !this.rafStamps.invokeId) && (this.rafStamps.invokeId = this.rafStamps.latestId), this.pendingCanvasMutations.has(u) || this.pendingCanvasMutations.set(u, []), this.pendingCanvasMutations.get(u).push(f);
    };
    const { sampling: n = "all", win: r, blockClass: a, blockSelector: o, recordCanvas: s, dataURLOptions: c } = t;
    this.mutationCb = t.mutationCb, this.mirror = t.mirror, s && n === "all" && this.initCanvasMutationObserver(r, a, o), s && typeof n == "number" && this.initCanvasFPSObserver(n, r, a, o, {
      dataURLOptions: c
    });
  }
  initCanvasFPSObserver(t, n, r, a, o) {
    const s = Rq(n, r, a, !0), c = /* @__PURE__ */ new Map(), u = new Zot();
    u.onmessage = (S) => {
      const { id: x } = S.data;
      if (c.set(x, !1), !("base64" in S.data))
        return;
      const { base64: E, type: N, width: R, height: O } = S.data;
      this.mutationCb({
        id: x,
        type: C2["2D"],
        commands: [
          {
            property: "clearRect",
            args: [0, 0, R, O]
          },
          {
            property: "drawImage",
            args: [
              {
                rr_type: "ImageBitmap",
                args: [
                  {
                    rr_type: "Blob",
                    data: [{ rr_type: "ArrayBuffer", base64: E }],
                    type: N
                  }
                ]
              },
              0,
              0
            ]
          }
        ]
      });
    };
    const f = 1e3 / t;
    let m = 0, v;
    const y = () => {
      const S = [];
      return n.document.querySelectorAll("canvas").forEach((x) => {
        Ll(x, r, a, !0) || S.push(x);
      }), S;
    }, b = (S) => {
      if (m && S - m < f) {
        v = requestAnimationFrame(b);
        return;
      }
      m = S, y().forEach((x) => $ot(this, void 0, void 0, function* () {
        var E;
        const N = this.mirror.getId(x);
        if (c.get(N) || x.width === 0 || x.height === 0)
          return;
        if (c.set(N, !0), ["webgl", "webgl2"].includes(x.__context)) {
          const O = x.getContext(x.__context);
          ((E = O == null ? void 0 : O.getContextAttributes()) === null || E === void 0 ? void 0 : E.preserveDrawingBuffer) === !1 && O.clear(O.COLOR_BUFFER_BIT);
        }
        const R = yield createImageBitmap(x);
        u.postMessage({
          id: N,
          bitmap: R,
          width: x.width,
          height: x.height,
          dataURLOptions: o.dataURLOptions
        }, [R]);
      })), v = requestAnimationFrame(b);
    };
    v = requestAnimationFrame(b), this.resetObservers = () => {
      s(), cancelAnimationFrame(v);
    };
  }
  initCanvasMutationObserver(t, n, r) {
    this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
    const a = Rq(t, n, r, !1), o = Vot(this.processMutation.bind(this), t, n, r), s = Got(this.processMutation.bind(this), t, n, r, this.mirror);
    this.resetObservers = () => {
      a(), o(), s();
    };
  }
  startPendingCanvasMutationFlusher() {
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  startRAFTimestamping() {
    const t = (n) => {
      this.rafStamps.latestId = n, requestAnimationFrame(t);
    };
    requestAnimationFrame(t);
  }
  flushPendingCanvasMutations() {
    this.pendingCanvasMutations.forEach((t, n) => {
      const r = this.mirror.getId(n);
      this.flushPendingCanvasMutationFor(n, r);
    }), requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  flushPendingCanvasMutationFor(t, n) {
    if (this.frozen || this.locked)
      return;
    const r = this.pendingCanvasMutations.get(t);
    if (!r || n === -1)
      return;
    const a = r.map((s) => Lot(s, ["type"])), { type: o } = r[0];
    this.mutationCb({ id: n, type: o, commands: a }), this.pendingCanvasMutations.delete(t);
  }
}
class Xot {
  constructor(t) {
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet(), this.styleMirror = new hot(), this.mutationCb = t.mutationCb, this.adoptedStyleSheetCb = t.adoptedStyleSheetCb;
  }
  attachLinkElement(t, n) {
    "_cssText" in n.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: n.id,
          attributes: n.attributes
        }
      ]
    }), this.trackLinkElement(t);
  }
  trackLinkElement(t) {
    this.trackedLinkElements.has(t) || (this.trackedLinkElements.add(t), this.trackStylesheetInLinkElement(t));
  }
  adoptStyleSheets(t, n) {
    if (t.length === 0)
      return;
    const r = {
      id: n,
      styleIds: []
    }, a = [];
    for (const o of t) {
      let s;
      this.styleMirror.has(o) ? s = this.styleMirror.getId(o) : (s = this.styleMirror.add(o), a.push({
        styleId: s,
        rules: Array.from(o.rules || CSSRule, (c, u) => ({
          rule: Vle(c),
          index: u
        }))
      })), r.styleIds.push(s);
    }
    a.length > 0 && (r.styles = a), this.adoptedStyleSheetCb(r);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  trackStylesheetInLinkElement(t) {
  }
}
class Kot {
  constructor() {
    this.nodeMap = /* @__PURE__ */ new WeakMap(), this.loop = !0, this.periodicallyClear();
  }
  periodicallyClear() {
    requestAnimationFrame(() => {
      this.clear(), this.loop && this.periodicallyClear();
    });
  }
  inOtherBuffer(t, n) {
    const r = this.nodeMap.get(t);
    return r && Array.from(r).some((a) => a !== n);
  }
  add(t, n) {
    this.nodeMap.set(t, (this.nodeMap.get(t) || /* @__PURE__ */ new Set()).add(n));
  }
  clear() {
    this.nodeMap = /* @__PURE__ */ new WeakMap();
  }
  destroy() {
    this.loop = !1;
  }
}
function ki(e) {
  return Object.assign(Object.assign({}, e), { timestamp: S6() });
}
let Wo, h7, _N, E6 = !1;
const fd = Gat();
function mC(e = {}) {
  const { emit: t, checkoutEveryNms: n, checkoutEveryNth: r, blockClass: a = "rr-block", blockSelector: o = null, ignoreClass: s = "rr-ignore", ignoreSelector: c = null, maskTextClass: u = "rr-mask", maskTextSelector: f = null, inlineStylesheet: m = !0, maskAllInputs: v, maskInputOptions: y, slimDOMOptions: b, maskInputFn: S, maskTextFn: x, hooks: E, packFn: N, sampling: R = {}, dataURLOptions: O = {}, mousemoveWait: D, recordDOM: $ = !0, recordCanvas: B = !1, recordCrossOriginIframes: G = !1, recordAfter: Z = e.recordAfter === "DOMContentLoaded" ? e.recordAfter : "load", userTriggeredOnInput: K = !1, collectFonts: q = !1, inlineImages: pe = !1, plugins: he, keepIframeSrcFn: _e = () => !1, ignoreCSSAttributes: ge = /* @__PURE__ */ new Set([]), errorHandler: Y } = e;
  bot(Y);
  const ee = G ? window.parent === window : !0;
  let oe = !1;
  if (!ee)
    try {
      window.parent.document && (oe = !1);
    } catch (le) {
      oe = !0;
    }
  if (ee && !t)
    throw new Error("emit function is required");
  D !== void 0 && R.mousemove === void 0 && (R.mousemove = D), fd.reset();
  const me = v === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    password: !0
  } : y !== void 0 ? y : { password: !0 }, xe = b === !0 || b === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    headMetaAuthorship: b === "all",
    headMetaDescKeywords: b === "all"
  } : b || {};
  pot();
  let X, ye = 0;
  const ce = (le) => {
    for (const be of he || [])
      be.eventProcessor && (le = be.eventProcessor(le));
    return N && !oe && (le = N(le)), le;
  };
  Wo = (le, be) => {
    var He;
    if (!((He = R0[0]) === null || He === void 0) && He.isFrozen() && le.type !== qr.FullSnapshot && !(le.type === qr.IncrementalSnapshot && le.data.source === jr.Mutation) && R0.forEach((Ae) => Ae.unfreeze()), ee)
      t == null || t(ce(le), be);
    else if (oe) {
      const Ae = {
        type: "rrweb",
        event: ce(le),
        origin: window.location.origin,
        isCheckout: be
      };
      window.parent.postMessage(Ae, "*");
    }
    if (le.type === qr.FullSnapshot)
      X = le, ye = 0;
    else if (le.type === qr.IncrementalSnapshot) {
      if (le.data.source === jr.Mutation && le.data.isAttachIframe)
        return;
      ye++;
      const Ae = r && ye >= r, it = n && le.timestamp - X.timestamp > n;
      (Ae || it) && h7(!0);
    }
  };
  const se = (le) => {
    Wo(ki({
      type: qr.IncrementalSnapshot,
      data: Object.assign({ source: jr.Mutation }, le)
    }));
  }, Ie = (le) => Wo(ki({
    type: qr.IncrementalSnapshot,
    data: Object.assign({ source: jr.Scroll }, le)
  })), Le = (le) => Wo(ki({
    type: qr.IncrementalSnapshot,
    data: Object.assign({ source: jr.CanvasMutation }, le)
  })), ie = (le) => Wo(ki({
    type: qr.IncrementalSnapshot,
    data: Object.assign({ source: jr.AdoptedStyleSheet }, le)
  })), $e = new Xot({
    mutationCb: se,
    adoptedStyleSheetCb: ie
  }), we = new Mot({
    mirror: fd,
    mutationCb: se,
    stylesheetManager: $e,
    recordCrossOriginIframes: G,
    wrappedEmit: Wo
  });
  for (const le of he || [])
    le.getMirror && le.getMirror({
      nodeMirror: fd,
      crossOriginIframeMirror: we.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: we.crossOriginIframeStyleMirror
    });
  const Ne = new Kot();
  _N = new Yot({
    recordCanvas: B,
    mutationCb: Le,
    win: window,
    blockClass: a,
    blockSelector: o,
    mirror: fd,
    sampling: R.canvas,
    dataURLOptions: O
  });
  const Ee = new Dot({
    mutationCb: se,
    scrollCb: Ie,
    bypassOptions: {
      blockClass: a,
      blockSelector: o,
      maskTextClass: u,
      maskTextSelector: f,
      inlineStylesheet: m,
      maskInputOptions: me,
      dataURLOptions: O,
      maskTextFn: x,
      maskInputFn: S,
      recordCanvas: B,
      inlineImages: pe,
      sampling: R,
      slimDOMOptions: xe,
      iframeManager: we,
      stylesheetManager: $e,
      canvasManager: _N,
      keepIframeSrcFn: _e,
      processedNodeManager: Ne
    },
    mirror: fd
  });
  h7 = (le = !1) => {
    if (!$)
      return;
    Wo(ki({
      type: qr.Meta,
      data: {
        href: window.location.href,
        width: Kle(),
        height: Xle()
      }
    }), le), $e.reset(), Ee.init(), R0.forEach((He) => He.lock());
    const be = dot(document, {
      mirror: fd,
      blockClass: a,
      blockSelector: o,
      maskTextClass: u,
      maskTextSelector: f,
      inlineStylesheet: m,
      maskAllInputs: me,
      maskTextFn: x,
      slimDOM: xe,
      dataURLOptions: O,
      recordCanvas: B,
      inlineImages: pe,
      onSerialize: (He) => {
        Qle(He, fd) && we.addIframe(He), eue(He, fd) && $e.trackLinkElement(He), rR(He) && Ee.addShadowRoot(He.shadowRoot, document);
      },
      onIframeLoad: (He, Ae) => {
        we.attachIframe(He, Ae), Ee.observeAttachShadow(He);
      },
      onStylesheetLoad: (He, Ae) => {
        $e.attachLinkElement(He, Ae);
      },
      keepIframeSrcFn: _e
    });
    if (!be)
      return console.warn("Failed to snapshot the document");
    Wo(ki({
      type: qr.FullSnapshot,
      data: {
        node: be,
        initialOffset: Yle(window)
      }
    }), le), R0.forEach((He) => He.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && $e.adoptStyleSheets(document.adoptedStyleSheets, fd.getId(document));
  };
  try {
    const le = [], be = (Ae) => {
      var it;
      return Wr(Rot)({
        mutationCb: se,
        mousemoveCb: (ut, St) => Wo(ki({
          type: qr.IncrementalSnapshot,
          data: {
            source: St,
            positions: ut
          }
        })),
        mouseInteractionCb: (ut) => Wo(ki({
          type: qr.IncrementalSnapshot,
          data: Object.assign({ source: jr.MouseInteraction }, ut)
        })),
        scrollCb: Ie,
        viewportResizeCb: (ut) => Wo(ki({
          type: qr.IncrementalSnapshot,
          data: Object.assign({ source: jr.ViewportResize }, ut)
        })),
        inputCb: (ut) => Wo(ki({
          type: qr.IncrementalSnapshot,
          data: Object.assign({ source: jr.Input }, ut)
        })),
        mediaInteractionCb: (ut) => Wo(ki({
          type: qr.IncrementalSnapshot,
          data: Object.assign({ source: jr.MediaInteraction }, ut)
        })),
        styleSheetRuleCb: (ut) => Wo(ki({
          type: qr.IncrementalSnapshot,
          data: Object.assign({ source: jr.StyleSheetRule }, ut)
        })),
        styleDeclarationCb: (ut) => Wo(ki({
          type: qr.IncrementalSnapshot,
          data: Object.assign({ source: jr.StyleDeclaration }, ut)
        })),
        canvasMutationCb: Le,
        fontCb: (ut) => Wo(ki({
          type: qr.IncrementalSnapshot,
          data: Object.assign({ source: jr.Font }, ut)
        })),
        selectionCb: (ut) => {
          Wo(ki({
            type: qr.IncrementalSnapshot,
            data: Object.assign({ source: jr.Selection }, ut)
          }));
        },
        customElementCb: (ut) => {
          Wo(ki({
            type: qr.IncrementalSnapshot,
            data: Object.assign({ source: jr.CustomElement }, ut)
          }));
        },
        blockClass: a,
        ignoreClass: s,
        ignoreSelector: c,
        maskTextClass: u,
        maskTextSelector: f,
        maskInputOptions: me,
        inlineStylesheet: m,
        sampling: R,
        recordDOM: $,
        recordCanvas: B,
        inlineImages: pe,
        userTriggeredOnInput: K,
        collectFonts: q,
        doc: Ae,
        maskInputFn: S,
        maskTextFn: x,
        keepIframeSrcFn: _e,
        blockSelector: o,
        slimDOMOptions: xe,
        dataURLOptions: O,
        mirror: fd,
        iframeManager: we,
        stylesheetManager: $e,
        shadowDomManager: Ee,
        processedNodeManager: Ne,
        canvasManager: _N,
        ignoreCSSAttributes: ge,
        plugins: ((it = he == null ? void 0 : he.filter((ut) => ut.observer)) === null || it === void 0 ? void 0 : it.map((ut) => ({
          observer: ut.observer,
          options: ut.options,
          callback: (St) => Wo(ki({
            type: qr.Plugin,
            data: {
              plugin: ut.name,
              payload: St
            }
          }))
        }))) || []
      }, E);
    };
    we.addLoadListener((Ae) => {
      try {
        le.push(be(Ae.contentDocument));
      } catch (it) {
        console.warn(it);
      }
    });
    const He = () => {
      h7(), le.push(be(document)), E6 = !0;
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? He() : (le.push(Dl("DOMContentLoaded", () => {
      Wo(ki({
        type: qr.DomContentLoaded,
        data: {}
      })), Z === "DOMContentLoaded" && He();
    })), le.push(Dl("load", () => {
      Wo(ki({
        type: qr.Load,
        data: {}
      })), Z === "load" && He();
    }, window))), () => {
      le.forEach((Ae) => Ae()), Ne.destroy(), E6 = !1, _ot();
    };
  } catch (le) {
    console.warn(le);
  }
}
mC.addCustomEvent = (e, t) => {
  if (!E6)
    throw new Error("please add custom event after start recording");
  Wo(ki({
    type: qr.Custom,
    data: {
      tag: e,
      payload: t
    }
  }));
};
mC.freezePage = () => {
  R0.forEach((e) => e.freeze());
};
mC.takeFullSnapshot = (e) => {
  if (!E6)
    throw new Error("please take full snapshot after start recording");
  h7(e);
};
mC.mirror = fd;
var due = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(due || {}), bf = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(bf || {}), Fp = {
  DEBUG: !1,
  LIB_VERSION: "2.55.0"
}, lr;
if (typeof window == "undefined") {
  var Dq = {
    hostname: ""
  };
  lr = {
    navigator: { userAgent: "" },
    document: {
      location: Dq,
      referrer: ""
    },
    screen: { width: 0, height: 0 },
    location: Dq
  };
} else
  lr = window;
var J4 = 24 * 60 * 60 * 1e3, H8 = Array.prototype, qot = Function.prototype, fue = Object.prototype, Im = H8.slice, vC = fue.toString, W8 = fue.hasOwnProperty, Ii = lr.console, km = lr.navigator, Fa = lr.document, _x = lr.opera, I6 = lr.screen, Cf = km.userAgent, CN = qot.bind, Lq = H8.forEach, $q = H8.indexOf, jq = H8.map, Jot = Array.isArray, oR = {}, H = {
  trim: function(e) {
    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  }
}, fa = {
  /** @type {function(...*)} */
  log: function() {
    if (Fp.DEBUG && !H.isUndefined(Ii) && Ii)
      try {
        Ii.log.apply(Ii, arguments);
      } catch (e) {
        H.each(arguments, function(t) {
          Ii.log(t);
        });
      }
  },
  /** @type {function(...*)} */
  warn: function() {
    if (Fp.DEBUG && !H.isUndefined(Ii) && Ii) {
      var e = ["Mixpanel warning:"].concat(H.toArray(arguments));
      try {
        Ii.warn.apply(Ii, e);
      } catch (t) {
        H.each(e, function(n) {
          Ii.warn(n);
        });
      }
    }
  },
  /** @type {function(...*)} */
  error: function() {
    if (Fp.DEBUG && !H.isUndefined(Ii) && Ii) {
      var e = ["Mixpanel error:"].concat(H.toArray(arguments));
      try {
        Ii.error.apply(Ii, e);
      } catch (t) {
        H.each(e, function(n) {
          Ii.error(n);
        });
      }
    }
  },
  /** @type {function(...*)} */
  critical: function() {
    if (!H.isUndefined(Ii) && Ii) {
      var e = ["Mixpanel error:"].concat(H.toArray(arguments));
      try {
        Ii.error.apply(Ii, e);
      } catch (t) {
        H.each(e, function(n) {
          Ii.error(n);
        });
      }
    }
  }
}, wN = function(e, t) {
  return function() {
    return arguments[0] = "[" + t + "] " + arguments[0], e.apply(fa, arguments);
  };
}, Z8 = function(e) {
  return {
    log: wN(fa.log, e),
    error: wN(fa.error, e),
    critical: wN(fa.critical, e)
  };
};
H.bind = function(e, t) {
  var n, r;
  if (CN && e.bind === CN)
    return CN.apply(e, Im.call(arguments, 1));
  if (!H.isFunction(e))
    throw new TypeError();
  return n = Im.call(arguments, 2), r = function() {
    if (!(this instanceof r))
      return e.apply(t, n.concat(Im.call(arguments)));
    var a = {};
    a.prototype = e.prototype;
    var o = new a();
    a.prototype = null;
    var s = e.apply(o, n.concat(Im.call(arguments)));
    return Object(s) === s ? s : o;
  }, r;
};
H.each = function(e, t, n) {
  if (e != null) {
    if (Lq && e.forEach === Lq)
      e.forEach(t, n);
    else if (e.length === +e.length) {
      for (var r = 0, a = e.length; r < a; r++)
        if (r in e && t.call(n, e[r], r, e) === oR)
          return;
    } else
      for (var o in e)
        if (W8.call(e, o) && t.call(n, e[o], o, e) === oR)
          return;
  }
};
H.extend = function(e) {
  return H.each(Im.call(arguments, 1), function(t) {
    for (var n in t)
      t[n] !== void 0 && (e[n] = t[n]);
  }), e;
};
H.isArray = Jot || function(e) {
  return vC.call(e) === "[object Array]";
};
H.isFunction = function(e) {
  try {
    return /^\s*\bfunction\b/.test(e);
  } catch (t) {
    return !1;
  }
};
H.isArguments = function(e) {
  return !!(e && W8.call(e, "callee"));
};
H.toArray = function(e) {
  return e ? e.toArray ? e.toArray() : H.isArray(e) || H.isArguments(e) ? Im.call(e) : H.values(e) : [];
};
H.map = function(e, t, n) {
  if (jq && e.map === jq)
    return e.map(t, n);
  var r = [];
  return H.each(e, function(a) {
    r.push(t.call(n, a));
  }), r;
};
H.keys = function(e) {
  var t = [];
  return e === null || H.each(e, function(n, r) {
    t[t.length] = r;
  }), t;
};
H.values = function(e) {
  var t = [];
  return e === null || H.each(e, function(n) {
    t[t.length] = n;
  }), t;
};
H.include = function(e, t) {
  var n = !1;
  return e === null ? n : $q && e.indexOf === $q ? e.indexOf(t) != -1 : (H.each(e, function(r) {
    if (n || (n = r === t))
      return oR;
  }), n);
};
H.includes = function(e, t) {
  return e.indexOf(t) !== -1;
};
H.inherit = function(e, t) {
  return e.prototype = new t(), e.prototype.constructor = e, e.superclass = t.prototype, e;
};
H.isObject = function(e) {
  return e === Object(e) && !H.isArray(e);
};
H.isEmptyObject = function(e) {
  if (H.isObject(e)) {
    for (var t in e)
      if (W8.call(e, t))
        return !1;
    return !0;
  }
  return !1;
};
H.isUndefined = function(e) {
  return e === void 0;
};
H.isString = function(e) {
  return vC.call(e) == "[object String]";
};
H.isDate = function(e) {
  return vC.call(e) == "[object Date]";
};
H.isNumber = function(e) {
  return vC.call(e) == "[object Number]";
};
H.isElement = function(e) {
  return !!(e && e.nodeType === 1);
};
H.encodeDates = function(e) {
  return H.each(e, function(t, n) {
    H.isDate(t) ? e[n] = H.formatDate(t) : H.isObject(t) && (e[n] = H.encodeDates(t));
  }), e;
};
H.timestamp = function() {
  return Date.now = Date.now || function() {
    return +/* @__PURE__ */ new Date();
  }, Date.now();
};
H.formatDate = function(e) {
  function t(n) {
    return n < 10 ? "0" + n : n;
  }
  return e.getUTCFullYear() + "-" + t(e.getUTCMonth() + 1) + "-" + t(e.getUTCDate()) + "T" + t(e.getUTCHours()) + ":" + t(e.getUTCMinutes()) + ":" + t(e.getUTCSeconds());
};
H.strip_empty_properties = function(e) {
  var t = {};
  return H.each(e, function(n, r) {
    H.isString(n) && n.length > 0 && (t[r] = n);
  }), t;
};
H.truncate = function(e, t) {
  var n;
  return typeof e == "string" ? n = e.slice(0, t) : H.isArray(e) ? (n = [], H.each(e, function(r) {
    n.push(H.truncate(r, t));
  })) : H.isObject(e) ? (n = {}, H.each(e, function(r, a) {
    n[a] = H.truncate(r, t);
  })) : n = e, n;
};
H.JSONEncode = /* @__PURE__ */ function() {
  return function(e) {
    var t = e, n = function(a) {
      var o = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, s = {
        // table of character substitutions
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
      };
      return o.lastIndex = 0, o.test(a) ? '"' + a.replace(o, function(c) {
        var u = s[c];
        return typeof u == "string" ? u : "\\u" + ("0000" + c.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + a + '"';
    }, r = function(a, o) {
      var s = "", c = "    ", u = 0, f = "", m = "", v = 0, y = s, b = [], S = o[a];
      switch (S && typeof S == "object" && typeof S.toJSON == "function" && (S = S.toJSON(a)), typeof S) {
        case "string":
          return n(S);
        case "number":
          return isFinite(S) ? String(S) : "null";
        case "boolean":
        case "null":
          return String(S);
        case "object":
          if (!S)
            return "null";
          if (s += c, b = [], vC.apply(S) === "[object Array]") {
            for (v = S.length, u = 0; u < v; u += 1)
              b[u] = r(u, S) || "null";
            return m = b.length === 0 ? "[]" : s ? `[
` + s + b.join(`,
` + s) + `
` + y + "]" : "[" + b.join(",") + "]", s = y, m;
          }
          for (f in S)
            W8.call(S, f) && (m = r(f, S), m && b.push(n(f) + (s ? ": " : ":") + m));
          return m = b.length === 0 ? "{}" : s ? "{" + b.join(",") + y + "}" : "{" + b.join(",") + "}", s = y, m;
      }
    };
    return r("", {
      "": t
    });
  };
}();
H.JSONDecode = function() {
  var e, t, n = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, r, a = function(b) {
    var S = new SyntaxError(b);
    throw S.at = e, S.text = r, S;
  }, o = function(b) {
    return b && b !== t && a("Expected '" + b + "' instead of '" + t + "'"), t = r.charAt(e), e += 1, t;
  }, s = function() {
    var b, S = "";
    for (t === "-" && (S = "-", o("-")); t >= "0" && t <= "9"; )
      S += t, o();
    if (t === ".")
      for (S += "."; o() && t >= "0" && t <= "9"; )
        S += t;
    if (t === "e" || t === "E")
      for (S += t, o(), (t === "-" || t === "+") && (S += t, o()); t >= "0" && t <= "9"; )
        S += t, o();
    if (b = +S, !isFinite(b))
      a("Bad number");
    else
      return b;
  }, c = function() {
    var b, S, x = "", E;
    if (t === '"')
      for (; o(); ) {
        if (t === '"')
          return o(), x;
        if (t === "\\")
          if (o(), t === "u") {
            for (E = 0, S = 0; S < 4 && (b = parseInt(o(), 16), !!isFinite(b)); S += 1)
              E = E * 16 + b;
            x += String.fromCharCode(E);
          } else if (typeof n[t] == "string")
            x += n[t];
          else
            break;
        else
          x += t;
      }
    a("Bad string");
  }, u = function() {
    for (; t && t <= " "; )
      o();
  }, f = function() {
    switch (t) {
      case "t":
        return o("t"), o("r"), o("u"), o("e"), !0;
      case "f":
        return o("f"), o("a"), o("l"), o("s"), o("e"), !1;
      case "n":
        return o("n"), o("u"), o("l"), o("l"), null;
    }
    a('Unexpected "' + t + '"');
  }, m, v = function() {
    var b = [];
    if (t === "[") {
      if (o("["), u(), t === "]")
        return o("]"), b;
      for (; t; ) {
        if (b.push(m()), u(), t === "]")
          return o("]"), b;
        o(","), u();
      }
    }
    a("Bad array");
  }, y = function() {
    var b, S = {};
    if (t === "{") {
      if (o("{"), u(), t === "}")
        return o("}"), S;
      for (; t; ) {
        if (b = c(), u(), o(":"), Object.hasOwnProperty.call(S, b) && a('Duplicate key "' + b + '"'), S[b] = m(), u(), t === "}")
          return o("}"), S;
        o(","), u();
      }
    }
    a("Bad object");
  };
  return m = function() {
    switch (u(), t) {
      case "{":
        return y();
      case "[":
        return v();
      case '"':
        return c();
      case "-":
        return s();
      default:
        return t >= "0" && t <= "9" ? s() : f();
    }
  }, function(b) {
    var S;
    return r = b, e = 0, t = " ", S = m(), u(), t && a("Syntax error"), S;
  };
}();
H.base64Encode = function(e) {
  var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", n, r, a, o, s, c, u, f, m = 0, v = 0, y = "", b = [];
  if (!e)
    return e;
  e = H.utf8Encode(e);
  do
    n = e.charCodeAt(m++), r = e.charCodeAt(m++), a = e.charCodeAt(m++), f = n << 16 | r << 8 | a, o = f >> 18 & 63, s = f >> 12 & 63, c = f >> 6 & 63, u = f & 63, b[v++] = t.charAt(o) + t.charAt(s) + t.charAt(c) + t.charAt(u);
  while (m < e.length);
  switch (y = b.join(""), e.length % 3) {
    case 1:
      y = y.slice(0, -2) + "==";
      break;
    case 2:
      y = y.slice(0, -1) + "=";
      break;
  }
  return y;
};
H.utf8Encode = function(e) {
  e = (e + "").replace(/\r\n/g, `
`).replace(/\r/g, `
`);
  var t = "", n, r, a = 0, o;
  for (n = r = 0, a = e.length, o = 0; o < a; o++) {
    var s = e.charCodeAt(o), c = null;
    s < 128 ? r++ : s > 127 && s < 2048 ? c = String.fromCharCode(s >> 6 | 192, s & 63 | 128) : c = String.fromCharCode(s >> 12 | 224, s >> 6 & 63 | 128, s & 63 | 128), c !== null && (r > n && (t += e.substring(n, r)), t += c, n = r = o + 1);
  }
  return r > n && (t += e.substring(n, e.length)), t;
};
H.UUID = /* @__PURE__ */ function() {
  var e = function() {
    var r = 1 * /* @__PURE__ */ new Date(), a;
    if (lr.performance && lr.performance.now)
      a = lr.performance.now();
    else
      for (a = 0; r == 1 * /* @__PURE__ */ new Date(); )
        a++;
    return r.toString(16) + Math.floor(a).toString(16);
  }, t = function() {
    return Math.random().toString(16).replace(".", "");
  }, n = function() {
    var r = Cf, a, o, s = [], c = 0;
    function u(f, m) {
      var v, y = 0;
      for (v = 0; v < m.length; v++)
        y |= s[v] << v * 8;
      return f ^ y;
    }
    for (a = 0; a < r.length; a++)
      o = r.charCodeAt(a), s.unshift(o & 255), s.length >= 4 && (c = u(c, s), s = []);
    return s.length > 0 && (c = u(c, s)), c.toString(16);
  };
  return function() {
    var r = (I6.height * I6.width).toString(16);
    return e() + "-" + t() + "-" + n() + "-" + r + "-" + e();
  };
}();
var Fq = [
  "ahrefsbot",
  "ahrefssiteaudit",
  "baiduspider",
  "bingbot",
  "bingpreview",
  "chrome-lighthouse",
  "facebookexternal",
  "petalbot",
  "pinterest",
  "screaming frog",
  "yahoo! slurp",
  "yandexbot",
  // a whole bunch of goog-specific crawlers
  // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
  "adsbot-google",
  "apis-google",
  "duplexweb-google",
  "feedfetcher-google",
  "google favicon",
  "google web preview",
  "google-read-aloud",
  "googlebot",
  "googleweblight",
  "mediapartners-google",
  "storebot-google"
];
H.isBlockedUA = function(e) {
  var t;
  for (e = e.toLowerCase(), t = 0; t < Fq.length; t++)
    if (e.indexOf(Fq[t]) !== -1)
      return !0;
  return !1;
};
H.HTTPBuildQuery = function(e, t) {
  var n, r, a = [];
  return H.isUndefined(t) && (t = "&"), H.each(e, function(o, s) {
    n = encodeURIComponent(o.toString()), r = encodeURIComponent(s), a[a.length] = r + "=" + n;
  }), a.join(t);
};
H.getQueryParam = function(e, t) {
  t = t.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var n = "[\\?&]" + t + "=([^&#]*)", r = new RegExp(n), a = r.exec(e);
  if (a === null || a && typeof a[1] != "string" && a[1].length)
    return "";
  var o = a[1];
  try {
    o = decodeURIComponent(o);
  } catch (s) {
    fa.error("Skipping decoding for malformed query param: " + o);
  }
  return o.replace(/\+/g, " ");
};
H.cookie = {
  get: function(e) {
    for (var t = e + "=", n = Fa.cookie.split(";"), r = 0; r < n.length; r++) {
      for (var a = n[r]; a.charAt(0) == " "; )
        a = a.substring(1, a.length);
      if (a.indexOf(t) === 0)
        return decodeURIComponent(a.substring(t.length, a.length));
    }
    return null;
  },
  parse: function(e) {
    var t;
    try {
      t = H.JSONDecode(H.cookie.get(e)) || {};
    } catch (n) {
    }
    return t;
  },
  set_seconds: function(e, t, n, r, a, o, s) {
    var c = "", u = "", f = "";
    if (s)
      c = "; domain=" + s;
    else if (r) {
      var m = Bq(Fa.location.hostname);
      c = m ? "; domain=." + m : "";
    }
    if (n) {
      var v = /* @__PURE__ */ new Date();
      v.setTime(v.getTime() + n * 1e3), u = "; expires=" + v.toGMTString();
    }
    o && (a = !0, f = "; SameSite=None"), a && (f += "; secure"), Fa.cookie = e + "=" + encodeURIComponent(t) + u + "; path=/" + c + f;
  },
  set: function(e, t, n, r, a, o, s) {
    var c = "", u = "", f = "";
    if (s)
      c = "; domain=" + s;
    else if (r) {
      var m = Bq(Fa.location.hostname);
      c = m ? "; domain=." + m : "";
    }
    if (n) {
      var v = /* @__PURE__ */ new Date();
      v.setTime(v.getTime() + n * 24 * 60 * 60 * 1e3), u = "; expires=" + v.toGMTString();
    }
    o && (a = !0, f = "; SameSite=None"), a && (f += "; secure");
    var y = e + "=" + encodeURIComponent(t) + u + "; path=/" + c + f;
    return Fa.cookie = y, y;
  },
  remove: function(e, t, n) {
    H.cookie.set(e, "", -1, t, !1, !1, n);
  }
};
var SN = null, k6 = function(e, t) {
  if (SN !== null && !t)
    return SN;
  var n = !0;
  try {
    e = e || window.localStorage;
    var r = "__mplss_" + MD(8), a = "xyz";
    e.setItem(r, a), e.getItem(r) !== a && (n = !1), e.removeItem(r);
  } catch (o) {
    n = !1;
  }
  return SN = n, n;
};
H.localStorage = {
  is_supported: function(e) {
    var t = k6(null, e);
    return t || fa.error("localStorage unsupported; falling back to cookie store"), t;
  },
  error: function(e) {
    fa.error("localStorage error: " + e);
  },
  get: function(e) {
    try {
      return window.localStorage.getItem(e);
    } catch (t) {
      H.localStorage.error(t);
    }
    return null;
  },
  parse: function(e) {
    try {
      return H.JSONDecode(H.localStorage.get(e)) || {};
    } catch (t) {
    }
    return null;
  },
  set: function(e, t) {
    try {
      window.localStorage.setItem(e, t);
    } catch (n) {
      H.localStorage.error(n);
    }
  },
  remove: function(e) {
    try {
      window.localStorage.removeItem(e);
    } catch (t) {
      H.localStorage.error(t);
    }
  }
};
H.register_event = function() {
  var e = function(r, a, o, s, c) {
    if (!r) {
      fa.error("No valid element provided to register_event");
      return;
    }
    if (r.addEventListener && !s)
      r.addEventListener(a, o, !!c);
    else {
      var u = "on" + a, f = r[u];
      r[u] = t(r, o, f);
    }
  };
  function t(r, a, o) {
    var s = function(c) {
      if (c = c || n(window.event), !!c) {
        var u = !0, f, m;
        return H.isFunction(o) && (f = o(c)), m = a.call(r, c), (f === !1 || m === !1) && (u = !1), u;
      }
    };
    return s;
  }
  function n(r) {
    return r && (r.preventDefault = n.preventDefault, r.stopPropagation = n.stopPropagation), r;
  }
  return n.preventDefault = function() {
    this.returnValue = !1;
  }, n.stopPropagation = function() {
    this.cancelBubble = !0;
  }, e;
}();
var Qot = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
H.dom_query = /* @__PURE__ */ function() {
  function e(a) {
    return a.all ? a.all : a.getElementsByTagName("*");
  }
  var t = /[\t\r\n]/g;
  function n(a, o) {
    var s = " " + o + " ";
    return (" " + a.className + " ").replace(t, " ").indexOf(s) >= 0;
  }
  function r(a) {
    if (!Fa.getElementsByTagName)
      return [];
    var o = a.split(" "), s, c, u, f, m, v, y, b, S, x, E = [Fa];
    for (v = 0; v < o.length; v++) {
      if (s = o[v].replace(/^\s+/, "").replace(/\s+$/, ""), s.indexOf("#") > -1) {
        c = s.split("#"), u = c[0];
        var N = c[1], R = Fa.getElementById(N);
        if (!R || u && R.nodeName.toLowerCase() != u)
          return [];
        E = [R];
        continue;
      }
      if (s.indexOf(".") > -1) {
        c = s.split("."), u = c[0];
        var O = c[1];
        for (u || (u = "*"), f = [], m = 0, y = 0; y < E.length; y++)
          for (u == "*" ? S = e(E[y]) : S = E[y].getElementsByTagName(u), b = 0; b < S.length; b++)
            f[m++] = S[b];
        for (E = [], x = 0, y = 0; y < f.length; y++)
          f[y].className && H.isString(f[y].className) && // some SVG elements have classNames which are not strings
          n(f[y], O) && (E[x++] = f[y]);
        continue;
      }
      var D = s.match(Qot);
      if (D) {
        u = D[1];
        var $ = D[2], B = D[3], G = D[4];
        for (u || (u = "*"), f = [], m = 0, y = 0; y < E.length; y++)
          for (u == "*" ? S = e(E[y]) : S = E[y].getElementsByTagName(u), b = 0; b < S.length; b++)
            f[m++] = S[b];
        E = [], x = 0;
        var Z;
        switch (B) {
          case "=":
            Z = function(K) {
              return K.getAttribute($) == G;
            };
            break;
          case "~":
            Z = function(K) {
              return K.getAttribute($).match(new RegExp("\\b" + G + "\\b"));
            };
            break;
          case "|":
            Z = function(K) {
              return K.getAttribute($).match(new RegExp("^" + G + "-?"));
            };
            break;
          case "^":
            Z = function(K) {
              return K.getAttribute($).indexOf(G) === 0;
            };
            break;
          case "$":
            Z = function(K) {
              return K.getAttribute($).lastIndexOf(G) == K.getAttribute($).length - G.length;
            };
            break;
          case "*":
            Z = function(K) {
              return K.getAttribute($).indexOf(G) > -1;
            };
            break;
          default:
            Z = function(K) {
              return K.getAttribute($);
            };
        }
        for (E = [], x = 0, y = 0; y < f.length; y++)
          Z(f[y]) && (E[x++] = f[y]);
        continue;
      }
      for (u = s, f = [], m = 0, y = 0; y < E.length; y++)
        for (S = E[y].getElementsByTagName(u), b = 0; b < S.length; b++)
          f[m++] = S[b];
      E = f;
    }
    return E;
  }
  return function(a) {
    return H.isElement(a) ? [a] : H.isObject(a) && !H.isUndefined(a.length) ? a : r.call(this, a);
  };
}();
var eit = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"], tit = ["dclid", "fbclid", "gclid", "ko_click_id", "li_fat_id", "msclkid", "ttclid", "twclid", "wbraid"];
H.info = {
  campaignParams: function(e) {
    var t = "", n = {};
    return H.each(eit, function(r) {
      t = H.getQueryParam(Fa.URL, r), t.length ? n[r] = t : e !== void 0 && (n[r] = e);
    }), n;
  },
  clickParams: function() {
    var e = "", t = {};
    return H.each(tit, function(n) {
      e = H.getQueryParam(Fa.URL, n), e.length && (t[n] = e);
    }), t;
  },
  marketingParams: function() {
    return H.extend(H.info.campaignParams(), H.info.clickParams());
  },
  searchEngine: function(e) {
    return e.search("https?://(.*)google.([^/?]*)") === 0 ? "google" : e.search("https?://(.*)bing.com") === 0 ? "bing" : e.search("https?://(.*)yahoo.com") === 0 ? "yahoo" : e.search("https?://(.*)duckduckgo.com") === 0 ? "duckduckgo" : null;
  },
  searchInfo: function(e) {
    var t = H.info.searchEngine(e), n = t != "yahoo" ? "q" : "p", r = {};
    if (t !== null) {
      r.$search_engine = t;
      var a = H.getQueryParam(e, n);
      a.length && (r.mp_keyword = a);
    }
    return r;
  },
  /**
   * This function detects which browser is running this script.
   * The order of the checks are important since many user agents
   * include key words used in later checks.
   */
  browser: function(e, t, n) {
    return t = t || "", n || H.includes(e, " OPR/") ? H.includes(e, "Mini") ? "Opera Mini" : "Opera" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : H.includes(e, "IEMobile") || H.includes(e, "WPDesktop") ? "Internet Explorer Mobile" : H.includes(e, "SamsungBrowser/") ? "Samsung Internet" : H.includes(e, "Edge") || H.includes(e, "Edg/") ? "Microsoft Edge" : H.includes(e, "FBIOS") ? "Facebook Mobile" : H.includes(e, "Chrome") ? "Chrome" : H.includes(e, "CriOS") ? "Chrome iOS" : H.includes(e, "UCWEB") || H.includes(e, "UCBrowser") ? "UC Browser" : H.includes(e, "FxiOS") ? "Firefox iOS" : H.includes(t, "Apple") ? H.includes(e, "Mobile") ? "Mobile Safari" : "Safari" : H.includes(e, "Android") ? "Android Mobile" : H.includes(e, "Konqueror") ? "Konqueror" : H.includes(e, "Firefox") ? "Firefox" : H.includes(e, "MSIE") || H.includes(e, "Trident/") ? "Internet Explorer" : H.includes(e, "Gecko") ? "Mozilla" : "";
  },
  /**
   * This function detects which browser version is running this script,
   * parsing major and minor version (e.g., 42.1). User agent strings from:
   * http://www.useragentstring.com/pages/useragentstring.php
   */
  browserVersion: function(e, t, n) {
    var r = H.info.browser(e, t, n), a = {
      "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
      "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
      Chrome: /Chrome\/(\d+(\.\d+)?)/,
      "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
      "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
      Safari: /Version\/(\d+(\.\d+)?)/,
      "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
      Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
      Firefox: /Firefox\/(\d+(\.\d+)?)/,
      "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
      Konqueror: /Konqueror:(\d+(\.\d+)?)/,
      BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
      "Android Mobile": /android\s(\d+(\.\d+)?)/,
      "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
      "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
      Mozilla: /rv:(\d+(\.\d+)?)/
    }, o = a[r];
    if (o === void 0)
      return null;
    var s = e.match(o);
    return s ? parseFloat(s[s.length - 2]) : null;
  },
  os: function() {
    var e = Cf;
    return /Windows/i.test(e) ? /Phone/.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : "Windows" : /(iPhone|iPad|iPod)/.test(e) ? "iOS" : /Android/.test(e) ? "Android" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Mac/i.test(e) ? "Mac OS X" : /Linux/.test(e) ? "Linux" : /CrOS/.test(e) ? "Chrome OS" : "";
  },
  device: function(e) {
    return /Windows Phone/i.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : /iPad/.test(e) ? "iPad" : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Android/.test(e) ? "Android" : "";
  },
  referringDomain: function(e) {
    var t = e.split("/");
    return t.length >= 3 ? t[2] : "";
  },
  currentUrl: function() {
    return lr.location.href;
  },
  properties: function(e) {
    return typeof e != "object" && (e = {}), H.extend(H.strip_empty_properties({
      $os: H.info.os(),
      $browser: H.info.browser(Cf, km.vendor, _x),
      $referrer: Fa.referrer,
      $referring_domain: H.info.referringDomain(Fa.referrer),
      $device: H.info.device(Cf)
    }), {
      $current_url: H.info.currentUrl(),
      $browser_version: H.info.browserVersion(Cf, km.vendor, _x),
      $screen_height: I6.height,
      $screen_width: I6.width,
      mp_lib: "web",
      $lib_version: Fp.LIB_VERSION,
      $insert_id: MD(),
      time: H.timestamp() / 1e3
      // epoch time in seconds
    }, H.strip_empty_properties(e));
  },
  people_properties: function() {
    return H.extend(H.strip_empty_properties({
      $os: H.info.os(),
      $browser: H.info.browser(Cf, km.vendor, _x)
    }), {
      $browser_version: H.info.browserVersion(Cf, km.vendor, _x)
    });
  },
  mpPageViewProperties: function() {
    return H.strip_empty_properties({
      current_page_title: Fa.title,
      current_domain: lr.location.hostname,
      current_url_path: lr.location.pathname,
      current_url_protocol: lr.location.protocol,
      current_url_search: lr.location.search
    });
  }
};
var MD = function(e) {
  var t = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
  return e ? t.substring(0, e) : t;
}, nit = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i, rit = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i, Bq = function(e) {
  var t = rit, n = e.split("."), r = n[n.length - 1];
  (r.length > 4 || r === "com" || r === "org") && (t = nit);
  var a = e.match(t);
  return a ? a[0] : "";
}, A6 = null, P6 = null;
typeof JSON != "undefined" && (A6 = JSON.stringify, P6 = JSON.parse);
A6 = A6 || H.JSONEncode;
P6 = P6 || H.JSONDecode;
H.toArray = H.toArray;
H.isObject = H.isObject;
H.JSONEncode = H.JSONEncode;
H.JSONDecode = H.JSONDecode;
H.isBlockedUA = H.isBlockedUA;
H.isEmptyObject = H.isEmptyObject;
H.info = H.info;
H.info.device = H.info.device;
H.info.browser = H.info.browser;
H.info.browserVersion = H.info.browserVersion;
H.info.properties = H.info.properties;
var ait = "__mp_opt_in_out_";
function oit(e, t) {
  mue(!0, e, t);
}
function iit(e, t) {
  mue(!1, e, t);
}
function sit(e, t) {
  return hue(e, t) === "1";
}
function pue(e, t) {
  if (uit(t))
    return fa.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"'), !0;
  var n = hue(e, t) === "0";
  return n && fa.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data."), n;
}
function ov(e) {
  return $D(e, function(t) {
    return this.get_config(t);
  });
}
function iv(e) {
  return $D(e, function(t) {
    return this._get_config(t);
  });
}
function W2(e) {
  return $D(e, function(t) {
    return this._get_config(t);
  });
}
function lit(e, t) {
  t = t || {}, DD(t).remove(
    LD(e, t),
    !!t.crossSubdomainCookie,
    t.cookieDomain
  );
}
function DD(e) {
  return e = e || {}, e.persistenceType === "localStorage" ? H.localStorage : H.cookie;
}
function LD(e, t) {
  return t = t || {}, (t.persistencePrefix || ait) + e;
}
function hue(e, t) {
  return DD(t).get(LD(e, t));
}
function uit(e) {
  if (e && e.ignoreDnt)
    return !1;
  var t = e && e.window || lr, n = t.navigator || {}, r = !1;
  return H.each([
    n.doNotTrack,
    // standard
    n.msDoNotTrack,
    t.doNotTrack
  ], function(a) {
    H.includes([!0, 1, "1", "yes"], a) && (r = !0);
  }), r;
}
function mue(e, t, n) {
  if (!H.isString(t) || !t.length) {
    fa.error("gdpr." + (e ? "optIn" : "optOut") + " called with an invalid token");
    return;
  }
  n = n || {}, DD(n).set(
    LD(t, n),
    e ? 1 : 0,
    H.isNumber(n.cookieExpiration) ? n.cookieExpiration : null,
    !!n.crossSubdomainCookie,
    !!n.secureCookie,
    !!n.crossSiteCookie,
    n.cookieDomain
  ), n.track && e && n.track(n.trackEventName || "$opt_in", n.trackProperties, {
    send_immediately: !0
  });
}
function $D(e, t) {
  return function() {
    var n = !1;
    try {
      var r = t.call(this, "token"), a = t.call(this, "ignore_dnt"), o = t.call(this, "opt_out_tracking_persistence_type"), s = t.call(this, "opt_out_tracking_cookie_prefix"), c = t.call(this, "window");
      r && (n = pue(r, {
        ignoreDnt: a,
        persistenceType: o,
        persistencePrefix: s,
        window: c
      }));
    } catch (f) {
      fa.error("Unexpected error when checking tracking opt-out status: " + f);
    }
    if (!n)
      return e.apply(this, arguments);
    var u = arguments[arguments.length - 1];
    typeof u == "function" && u(0);
  };
}
var cit = Z8("lock"), vue = function(e, t) {
  t = t || {}, this.storageKey = e, this.storage = t.storage || window.localStorage, this.pollIntervalMS = t.pollIntervalMS || 100, this.timeoutMS = t.timeoutMS || 2e3;
};
vue.prototype.withLock = function(e, t, n) {
  !n && typeof t != "function" && (n = t, t = null);
  var r = n || (/* @__PURE__ */ new Date()).getTime() + "|" + Math.random(), a = (/* @__PURE__ */ new Date()).getTime(), o = this.storageKey, s = this.pollIntervalMS, c = this.timeoutMS, u = this.storage, f = o + ":X", m = o + ":Y", v = o + ":Z", y = function(R) {
    t && t(R);
  }, b = function(R) {
    if ((/* @__PURE__ */ new Date()).getTime() - a > c) {
      cit.error("Timeout waiting for mutex on " + o + "; clearing lock. [" + r + "]"), u.removeItem(v), u.removeItem(m), E();
      return;
    }
    setTimeout(function() {
      try {
        R();
      } catch (O) {
        y(O);
      }
    }, s * (Math.random() + 0.1));
  }, S = function(R, O) {
    R() ? O() : b(function() {
      S(R, O);
    });
  }, x = function() {
    var R = u.getItem(m);
    if (R && R !== r)
      return !1;
    if (u.setItem(m, r), u.getItem(m) === r)
      return !0;
    if (!k6(u, !0))
      throw new Error("localStorage support dropped while acquiring lock");
    return !1;
  }, E = function() {
    u.setItem(f, r), S(x, function() {
      if (u.getItem(f) === r) {
        N();
        return;
      }
      b(function() {
        if (u.getItem(m) !== r) {
          E();
          return;
        }
        S(function() {
          return !u.getItem(v);
        }, N);
      });
    });
  }, N = function() {
    u.setItem(v, "1");
    try {
      e();
    } finally {
      u.removeItem(v), u.getItem(m) === r && u.removeItem(m), u.getItem(f) === r && u.removeItem(f);
    }
  };
  try {
    if (k6(u, !0))
      E();
    else
      throw new Error("localStorage support check failed");
  } catch (R) {
    y(R);
  }
};
var Vq = Z8("batch"), sv = function(e, t) {
  t = t || {}, this.storageKey = e, this.storage = t.storage || window.localStorage, this.reportError = t.errorReporter || H.bind(Vq.error, Vq), this.lock = new vue(e, { storage: this.storage }), this.usePersistence = t.usePersistence, this.pid = t.pid || null, this.memQueue = [];
};
sv.prototype.enqueue = function(e, t, n) {
  var r = {
    id: MD(),
    flushAfter: (/* @__PURE__ */ new Date()).getTime() + t * 2,
    payload: e
  };
  this.usePersistence ? this.lock.withLock(H.bind(function() {
    var o;
    try {
      var s = this.readFromStorage();
      s.push(r), o = this.saveToStorage(s), o && this.memQueue.push(r);
    } catch (c) {
      this.reportError("Error enqueueing item", e), o = !1;
    }
    n && n(o);
  }, this), H.bind(function(o) {
    this.reportError("Error acquiring storage lock", o), n && n(!1);
  }, this), this.pid) : (this.memQueue.push(r), n && n(!0));
};
sv.prototype.fillBatch = function(e) {
  var t = this.memQueue.slice(0, e);
  if (this.usePersistence && t.length < e) {
    var n = this.readFromStorage();
    if (n.length) {
      var r = {};
      H.each(t, function(s) {
        r[s.id] = !0;
      });
      for (var a = 0; a < n.length; a++) {
        var o = n[a];
        if ((/* @__PURE__ */ new Date()).getTime() > o.flushAfter && !r[o.id] && (o.orphaned = !0, t.push(o), t.length >= e))
          break;
      }
    }
  }
  return t;
};
var Uq = function(e, t) {
  var n = [];
  return H.each(e, function(r) {
    r.id && !t[r.id] && n.push(r);
  }), n;
};
sv.prototype.removeItemsByID = function(e, t) {
  var n = {};
  if (H.each(e, function(a) {
    n[a] = !0;
  }), this.memQueue = Uq(this.memQueue, n), !this.usePersistence)
    t && t(!0);
  else {
    var r = H.bind(function() {
      var a;
      try {
        var o = this.readFromStorage();
        if (o = Uq(o, n), a = this.saveToStorage(o), a) {
          o = this.readFromStorage();
          for (var s = 0; s < o.length; s++) {
            var c = o[s];
            if (c.id && n[c.id])
              return this.reportError("Item not removed from storage"), !1;
          }
        }
      } catch (u) {
        this.reportError("Error removing items", e), a = !1;
      }
      return a;
    }, this);
    this.lock.withLock(function() {
      var o = r();
      t && t(o);
    }, H.bind(function(o) {
      var s = !1;
      if (this.reportError("Error acquiring storage lock", o), !k6(this.storage, !0) && (s = r(), !s))
        try {
          this.storage.removeItem(this.storageKey);
        } catch (c) {
          this.reportError("Error clearing queue", c);
        }
      t && t(s);
    }, this), this.pid);
  }
};
var Gq = function(e, t) {
  var n = [];
  return H.each(e, function(r) {
    var a = r.id;
    if (a in t) {
      var o = t[a];
      o !== null && (r.payload = o, n.push(r));
    } else
      n.push(r);
  }), n;
};
sv.prototype.updatePayloads = function(e, t) {
  this.memQueue = Gq(this.memQueue, e), this.usePersistence ? this.lock.withLock(H.bind(function() {
    var r;
    try {
      var a = this.readFromStorage();
      a = Gq(a, e), r = this.saveToStorage(a);
    } catch (o) {
      this.reportError("Error updating items", e), r = !1;
    }
    t && t(r);
  }, this), H.bind(function(r) {
    this.reportError("Error acquiring storage lock", r), t && t(!1);
  }, this), this.pid) : t && t(!0);
};
sv.prototype.readFromStorage = function() {
  var e;
  try {
    e = this.storage.getItem(this.storageKey), e && (e = P6(e), H.isArray(e) || (this.reportError("Invalid storage entry:", e), e = null));
  } catch (t) {
    this.reportError("Error retrieving queue", t), e = null;
  }
  return e || [];
};
sv.prototype.saveToStorage = function(e) {
  try {
    return this.storage.setItem(this.storageKey, A6(e)), !0;
  } catch (t) {
    return this.reportError("Error saving queue", t), !1;
  }
};
sv.prototype.clear = function() {
  this.memQueue = [], this.usePersistence && this.storage.removeItem(this.storageKey);
};
var dit = 10 * 60 * 1e3, Q4 = Z8("batch"), Rd = function(e, t) {
  this.errorReporter = t.errorReporter, this.queue = new sv(e, {
    errorReporter: H.bind(this.reportError, this),
    storage: t.storage,
    usePersistence: t.usePersistence
  }), this.libConfig = t.libConfig, this.sendRequest = t.sendRequestFunc, this.beforeSendHook = t.beforeSendHook, this.stopAllBatching = t.stopAllBatchingFunc, this.batchSize = this.libConfig.batch_size, this.flushInterval = this.libConfig.batch_flush_interval_ms, this.stopped = !this.libConfig.batch_autostart, this.consecutiveRemovalFailures = 0, this.itemIdsSentSuccessfully = {}, this.flushOnlyOnInterval = t.flushOnlyOnInterval || !1;
};
Rd.prototype.enqueue = function(e, t) {
  this.queue.enqueue(e, this.flushInterval, t);
};
Rd.prototype.start = function() {
  this.stopped = !1, this.consecutiveRemovalFailures = 0, this.flush();
};
Rd.prototype.stop = function() {
  this.stopped = !0, this.timeoutID && (clearTimeout(this.timeoutID), this.timeoutID = null);
};
Rd.prototype.clear = function() {
  this.queue.clear();
};
Rd.prototype.resetBatchSize = function() {
  this.batchSize = this.libConfig.batch_size;
};
Rd.prototype.resetFlush = function() {
  this.scheduleFlush(this.libConfig.batch_flush_interval_ms);
};
Rd.prototype.scheduleFlush = function(e) {
  this.flushInterval = e, this.stopped || (this.timeoutID = setTimeout(H.bind(function() {
    this.stopped || this.flush();
  }, this), this.flushInterval));
};
Rd.prototype.flush = function(e) {
  try {
    if (this.requestInProgress) {
      Q4.log("Flush: Request already in progress");
      return;
    }
    e = e || {};
    var t = this.libConfig.batch_request_timeout_ms, n = (/* @__PURE__ */ new Date()).getTime(), r = this.batchSize, a = this.queue.fillBatch(r), o = a.length === r, s = [], c = {};
    if (H.each(a, function(m) {
      var v = m.payload;
      if (this.beforeSendHook && !m.orphaned && (v = this.beforeSendHook(v)), v) {
        v.event && v.properties && (v.properties = H.extend(
          {},
          v.properties,
          { mp_sent_by_lib_version: Fp.LIB_VERSION }
        ));
        var y = !0, b = m.id;
        b ? (this.itemIdsSentSuccessfully[b] || 0) > 5 && (this.reportError("[dupe] item ID sent too many times, not sending", {
          item: m,
          batchSize: a.length,
          timesSent: this.itemIdsSentSuccessfully[b]
        }), y = !1) : this.reportError("[dupe] found item with no ID", { item: m }), y && s.push(v);
      }
      c[m.id] = v;
    }, this), s.length < 1) {
      this.resetFlush();
      return;
    }
    this.requestInProgress = !0;
    var u = H.bind(function(m) {
      this.requestInProgress = !1;
      try {
        var v = !1;
        if (e.unloading)
          this.queue.updatePayloads(c);
        else if (H.isObject(m) && m.error === "timeout" && (/* @__PURE__ */ new Date()).getTime() - n >= t)
          this.reportError("Network timeout; retrying"), this.flush();
        else if (H.isObject(m) && (m.httpStatusCode >= 500 || m.httpStatusCode === 429 || m.error === "timeout")) {
          var y = this.flushInterval * 2;
          m.retryAfter && (y = parseInt(m.retryAfter, 10) * 1e3 || y), y = Math.min(dit, y), this.reportError("Error; retry in " + y + " ms"), this.scheduleFlush(y);
        } else if (H.isObject(m) && m.httpStatusCode === 413)
          if (a.length > 1) {
            var b = Math.max(1, Math.floor(r / 2));
            this.batchSize = Math.min(this.batchSize, b, a.length - 1), this.reportError("413 response; reducing batch size to " + this.batchSize), this.resetFlush();
          } else
            this.reportError("Single-event request too large; dropping", a), this.resetBatchSize(), v = !0;
        else
          v = !0;
        v && (this.queue.removeItemsByID(
          H.map(a, function(S) {
            return S.id;
          }),
          H.bind(function(S) {
            S ? (this.consecutiveRemovalFailures = 0, this.flushOnlyOnInterval && !o ? this.resetFlush() : this.flush()) : (this.reportError("Failed to remove items from queue"), ++this.consecutiveRemovalFailures > 5 ? (this.reportError("Too many queue failures; disabling batching system."), this.stopAllBatching()) : this.resetFlush());
          }, this)
        ), H.each(a, H.bind(function(S) {
          var x = S.id;
          x ? (this.itemIdsSentSuccessfully[x] = this.itemIdsSentSuccessfully[x] || 0, this.itemIdsSentSuccessfully[x]++, this.itemIdsSentSuccessfully[x] > 5 && this.reportError("[dupe] item ID sent too many times", {
            item: S,
            batchSize: a.length,
            timesSent: this.itemIdsSentSuccessfully[x]
          })) : this.reportError("[dupe] found item with no ID while removing", { item: S });
        }, this)));
      } catch (S) {
        this.reportError("Error handling API response", S), this.resetFlush();
      }
    }, this), f = {
      method: "POST",
      verbose: !0,
      ignore_json_errors: !0,
      // eslint-disable-line camelcase
      timeout_ms: t
      // eslint-disable-line camelcase
    };
    e.unloading && (f.transport = "sendBeacon"), Q4.log("MIXPANEL REQUEST:", s), this.sendRequest(s, f, u);
  } catch (m) {
    this.reportError("Error flushing request queue", m), this.resetFlush();
  }
};
Rd.prototype.reportError = function(e, t) {
  if (Q4.error.apply(Q4.error, arguments), this.errorReporter)
    try {
      t instanceof Error || (t = new Error(e)), this.errorReporter(e, t);
    } catch (n) {
      Q4.error(n);
    }
};
var e2 = Z8("recorder"), zq = lr.CompressionStream, fit = {
  batch_size: 1e3,
  batch_flush_interval_ms: 10 * 1e3,
  batch_request_timeout_ms: 90 * 1e3,
  batch_autostart: !0
}, pit = /* @__PURE__ */ new Set([
  bf.MouseMove,
  bf.MouseInteraction,
  bf.Scroll,
  bf.ViewportResize,
  bf.Input,
  bf.TouchMove,
  bf.MediaInteraction,
  bf.Drag,
  bf.Selection
]);
function hit(e) {
  return e.type === due.IncrementalSnapshot && pit.has(e.data.source);
}
var Md = function(e) {
  this._mixpanel = e, this._stopRecording = null, this.recEvents = [], this.seqNo = 0, this.replayId = null, this.replayStartTime = null, this.sendBatchId = null, this.idleTimeoutId = null, this.maxTimeoutId = null, this.recordMaxMs = J4, this._initBatcher();
};
Md.prototype._initBatcher = function() {
  this.batcher = new Rd("__mprec", {
    libConfig: fit,
    sendRequestFunc: H.bind(this.flushEventsWithOptOut, this),
    errorReporter: H.bind(this.reportError, this),
    flushOnlyOnInterval: !0,
    usePersistence: !1
  });
};
Md.prototype.get_config = function(e) {
  return this._mixpanel.get_config(e);
};
Md.prototype.startRecording = function(e) {
  if (this._stopRecording !== null) {
    e2.log("Recording already in progress, skipping startRecording.");
    return;
  }
  this.recordMaxMs = this.get_config("record_max_ms"), this.recordMaxMs > J4 && (this.recordMaxMs = J4, e2.critical("record_max_ms cannot be greater than " + J4 + "ms. Capping value.")), this.recEvents = [], this.seqNo = 0, this.replayStartTime = null, this.replayId = H.UUID(), e ? this.batcher.stop() : this.batcher.start();
  var t = H.bind(function() {
    clearTimeout(this.idleTimeoutId), this.idleTimeoutId = setTimeout(H.bind(function() {
      e2.log("Idle timeout reached, restarting recording."), this.resetRecording();
    }, this), this.get_config("record_idle_timeout_ms"));
  }, this);
  this._stopRecording = mC({
    emit: H.bind(function(n) {
      this.batcher.enqueue(n), hit(n) && (this.batcher.stopped && this.batcher.start(), t());
    }, this),
    blockClass: this.get_config("record_block_class"),
    blockSelector: this.get_config("record_block_selector"),
    collectFonts: this.get_config("record_collect_fonts"),
    inlineImages: this.get_config("record_inline_images"),
    maskAllInputs: !0,
    maskTextClass: this.get_config("record_mask_text_class"),
    maskTextSelector: this.get_config("record_mask_text_selector")
  }), t(), this.maxTimeoutId = setTimeout(H.bind(this.resetRecording, this), this.recordMaxMs);
};
Md.prototype.resetRecording = function() {
  this.stopRecording(), this.startRecording(!0);
};
Md.prototype.stopRecording = function() {
  this._stopRecording !== null && (this._stopRecording(), this._stopRecording = null), this.batcher.stopped ? this.batcher.clear() : (this.batcher.flush(), this.batcher.stop()), this.replayId = null, clearTimeout(this.idleTimeoutId), clearTimeout(this.maxTimeoutId);
};
Md.prototype.flushEventsWithOptOut = function(e, t, n) {
  this._flushEvents(e, t, n, H.bind(this._onOptOut, this));
};
Md.prototype._onOptOut = function(e) {
  e === 0 && (this.recEvents = [], this.stopRecording());
};
Md.prototype._sendRequest = function(e, t, n) {
  var r = H.bind(function(a, o) {
    a.status === 200 && this.seqNo++, n({
      status: 0,
      httpStatusCode: a.status,
      responseBody: o,
      retryAfter: a.headers.get("Retry-After")
    });
  }, this);
  lr.fetch(this.get_config("api_host") + "/" + this.get_config("api_routes").record + "?" + new URLSearchParams(e), {
    method: "POST",
    headers: {
      Authorization: "Basic " + btoa(this.get_config("token") + ":"),
      "Content-Type": "application/octet-stream"
    },
    body: t
  }).then(function(a) {
    a.json().then(function(o) {
      r(a, o);
    }).catch(function(o) {
      n({ error: o });
    });
  }).catch(function(a) {
    n({ error: a });
  });
};
Md.prototype._flushEvents = ov(function(e, t, n) {
  const r = e.length;
  if (r > 0) {
    var a = e[0].timestamp;
    this.seqNo === 0 && (this.replayStartTime = a);
    var o = e[r - 1].timestamp - this.replayStartTime, s = {
      distinct_id: String(this._mixpanel.get_distinct_id()),
      seq: this.seqNo,
      batch_start_time: a / 1e3,
      replay_id: this.replayId,
      replay_length_ms: o,
      replay_start_time: this.replayStartTime / 1e3
    }, c = H.JSONEncode(e), u = this._mixpanel.get_property("$device_id");
    u && (s.$device_id = u);
    var f = this._mixpanel.get_property("$user_id");
    if (f && (s.$user_id = f), zq) {
      var m = new Blob([c], { type: "application/json" }).stream(), v = m.pipeThrough(new zq("gzip"));
      new Response(v).blob().then(H.bind(function(y) {
        s.format = "gzip", this._sendRequest(s, y, n);
      }, this));
    } else
      s.format = "body", this._sendRequest(s, c, n);
  }
});
Md.prototype.reportError = function(e, t) {
  e2.error.apply(e2.error, arguments);
  try {
    !t && !(e instanceof Error) && (e = new Error(e)), this.get_config("error_reporter")(e, t);
  } catch (n) {
    e2.error(n);
  }
};
lr.__mp_recorder = Md;
var rh = function() {
};
rh.prototype.create_properties = function() {
};
rh.prototype.event_handler = function() {
};
rh.prototype.after_track_handler = function() {
};
rh.prototype.init = function(e) {
  return this.mp = e, this;
};
rh.prototype.track = function(e, t, n, r) {
  var a = this, o = H.dom_query(e);
  if (o.length === 0) {
    fa.error("The DOM query (" + e + ") returned 0 elements");
    return;
  }
  return H.each(o, function(s) {
    H.register_event(s, this.override_event, function(c) {
      var u = {}, f = a.create_properties(n, this), m = a.mp.get_config("track_links_timeout");
      a.event_handler(c, this, u), window.setTimeout(a.track_callback(r, f, u, !0), m), a.mp.track(t, f, a.track_callback(r, f, u));
    });
  }, this), !0;
};
rh.prototype.track_callback = function(e, t, n, r) {
  r = r || !1;
  var a = this;
  return function() {
    n.callback_fired || (n.callback_fired = !0, !(e && e(r, t) === !1) && a.after_track_handler(t, n, r));
  };
};
rh.prototype.create_properties = function(e, t) {
  var n;
  return typeof e == "function" ? n = e(t) : n = H.extend({}, e), n;
};
var w2 = function() {
  this.override_event = "click";
};
H.inherit(w2, rh);
w2.prototype.create_properties = function(e, t) {
  var n = w2.superclass.create_properties.apply(this, arguments);
  return t.href && (n.url = t.href), n;
};
w2.prototype.event_handler = function(e, t, n) {
  n.new_tab = e.which === 2 || e.metaKey || e.ctrlKey || t.target === "_blank", n.href = t.href, n.new_tab || e.preventDefault();
};
w2.prototype.after_track_handler = function(e, t) {
  t.new_tab || setTimeout(function() {
    window.location = t.href;
  }, 0);
};
var Y8 = function() {
  this.override_event = "submit";
};
H.inherit(Y8, rh);
Y8.prototype.event_handler = function(e, t, n) {
  n.element = t, e.preventDefault();
};
Y8.prototype.after_track_handler = function(e, t) {
  setTimeout(function() {
    t.element.submit();
  }, 0);
};
var Fm = "$set", S2 = "$set_once", bd = "$unset", r1 = "$add", Af = "$append", a1 = "$union", Bp = "$remove", mit = "$delete", gue = {
  set_action: function(e, t) {
    var n = {}, r = {};
    return H.isObject(e) ? H.each(e, function(a, o) {
      this._is_reserved_property(o) || (r[o] = a);
    }, this) : r[e] = t, n[Fm] = r, n;
  },
  unset_action: function(e) {
    var t = {}, n = [];
    return H.isArray(e) || (e = [e]), H.each(e, function(r) {
      this._is_reserved_property(r) || n.push(r);
    }, this), t[bd] = n, t;
  },
  set_once_action: function(e, t) {
    var n = {}, r = {};
    return H.isObject(e) ? H.each(e, function(a, o) {
      this._is_reserved_property(o) || (r[o] = a);
    }, this) : r[e] = t, n[S2] = r, n;
  },
  union_action: function(e, t) {
    var n = {}, r = {};
    return H.isObject(e) ? H.each(e, function(a, o) {
      this._is_reserved_property(o) || (r[o] = H.isArray(a) ? a : [a]);
    }, this) : r[e] = H.isArray(t) ? t : [t], n[a1] = r, n;
  },
  append_action: function(e, t) {
    var n = {}, r = {};
    return H.isObject(e) ? H.each(e, function(a, o) {
      this._is_reserved_property(o) || (r[o] = a);
    }, this) : r[e] = t, n[Af] = r, n;
  },
  remove_action: function(e, t) {
    var n = {}, r = {};
    return H.isObject(e) ? H.each(e, function(a, o) {
      this._is_reserved_property(o) || (r[o] = a);
    }, this) : r[e] = t, n[Bp] = r, n;
  },
  delete_action: function() {
    var e = {};
    return e[mit] = "", e;
  }
}, ao = function() {
};
H.extend(ao.prototype, gue);
ao.prototype._init = function(e, t, n) {
  this._mixpanel = e, this._group_key = t, this._group_id = n;
};
ao.prototype.set = W2(function(e, t, n) {
  var r = this.set_action(e, t);
  return H.isObject(e) && (n = t), this._send_request(r, n);
});
ao.prototype.set_once = W2(function(e, t, n) {
  var r = this.set_once_action(e, t);
  return H.isObject(e) && (n = t), this._send_request(r, n);
});
ao.prototype.unset = W2(function(e, t) {
  var n = this.unset_action(e);
  return this._send_request(n, t);
});
ao.prototype.union = W2(function(e, t, n) {
  H.isObject(e) && (n = t);
  var r = this.union_action(e, t);
  return this._send_request(r, n);
});
ao.prototype.delete = W2(function(e) {
  var t = this.delete_action();
  return this._send_request(t, e);
});
ao.prototype.remove = W2(function(e, t, n) {
  var r = this.remove_action(e, t);
  return this._send_request(r, n);
});
ao.prototype._send_request = function(e, t) {
  e.$group_key = this._group_key, e.$group_id = this._group_id, e.$token = this._get_config("token");
  var n = H.encodeDates(e);
  return this._mixpanel._track_or_batch({
    type: "groups",
    data: n,
    endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes").groups,
    batcher: this._mixpanel.request_batchers.groups
  }, t);
};
ao.prototype._is_reserved_property = function(e) {
  return e === "$group_key" || e === "$group_id";
};
ao.prototype._get_config = function(e) {
  return this._mixpanel.get_config(e);
};
ao.prototype.toString = function() {
  return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
ao.prototype.remove = ao.prototype.remove;
ao.prototype.set = ao.prototype.set;
ao.prototype.set_once = ao.prototype.set_once;
ao.prototype.union = ao.prototype.union;
ao.prototype.unset = ao.prototype.unset;
ao.prototype.toString = ao.prototype.toString;
var ar = function() {
};
H.extend(ar.prototype, gue);
ar.prototype._init = function(e) {
  this._mixpanel = e;
};
ar.prototype.set = iv(function(e, t, n) {
  var r = this.set_action(e, t);
  return H.isObject(e) && (n = t), this._get_config("save_referrer") && this._mixpanel.persistence.update_referrer_info(document.referrer), r[Fm] = H.extend(
    {},
    H.info.people_properties(),
    r[Fm]
  ), this._send_request(r, n);
});
ar.prototype.set_once = iv(function(e, t, n) {
  var r = this.set_once_action(e, t);
  return H.isObject(e) && (n = t), this._send_request(r, n);
});
ar.prototype.unset = iv(function(e, t) {
  var n = this.unset_action(e);
  return this._send_request(n, t);
});
ar.prototype.increment = iv(function(e, t, n) {
  var r = {}, a = {};
  return H.isObject(e) ? (H.each(e, function(o, s) {
    if (!this._is_reserved_property(s))
      if (isNaN(parseFloat(o))) {
        fa.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
        return;
      } else
        a[s] = o;
  }, this), n = t) : (H.isUndefined(t) && (t = 1), a[e] = t), r[r1] = a, this._send_request(r, n);
});
ar.prototype.append = iv(function(e, t, n) {
  H.isObject(e) && (n = t);
  var r = this.append_action(e, t);
  return this._send_request(r, n);
});
ar.prototype.remove = iv(function(e, t, n) {
  H.isObject(e) && (n = t);
  var r = this.remove_action(e, t);
  return this._send_request(r, n);
});
ar.prototype.union = iv(function(e, t, n) {
  H.isObject(e) && (n = t);
  var r = this.union_action(e, t);
  return this._send_request(r, n);
});
ar.prototype.track_charge = iv(function(e, t, n) {
  if (!H.isNumber(e) && (e = parseFloat(e), isNaN(e))) {
    fa.error("Invalid value passed to mixpanel.people.track_charge - must be a number");
    return;
  }
  return this.append("$transactions", H.extend({
    $amount: e
  }, t), n);
});
ar.prototype.clear_charges = function(e) {
  return this.set("$transactions", [], e);
};
ar.prototype.delete_user = function() {
  if (!this._identify_called()) {
    fa.error("mixpanel.people.delete_user() requires you to call identify() first");
    return;
  }
  var e = { $delete: this._mixpanel.get_distinct_id() };
  return this._send_request(e);
};
ar.prototype.toString = function() {
  return this._mixpanel.toString() + ".people";
};
ar.prototype._send_request = function(e, t) {
  e.$token = this._get_config("token"), e.$distinct_id = this._mixpanel.get_distinct_id();
  var n = this._mixpanel.get_property("$device_id"), r = this._mixpanel.get_property("$user_id"), a = this._mixpanel.get_property("$had_persisted_distinct_id");
  n && (e.$device_id = n), r && (e.$user_id = r), a && (e.$had_persisted_distinct_id = a);
  var o = H.encodeDates(e);
  return this._identify_called() ? this._mixpanel._track_or_batch({
    type: "people",
    data: o,
    endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes").engage,
    batcher: this._mixpanel.request_batchers.people
  }, t) : (this._enqueue(e), H.isUndefined(t) || (this._get_config("verbose") ? t({ status: -1, error: null }) : t(-1)), H.truncate(o, 255));
};
ar.prototype._get_config = function(e) {
  return this._mixpanel.get_config(e);
};
ar.prototype._identify_called = function() {
  return this._mixpanel._flags.identify_called === !0;
};
ar.prototype._enqueue = function(e) {
  Fm in e ? this._mixpanel.persistence._add_to_people_queue(Fm, e) : S2 in e ? this._mixpanel.persistence._add_to_people_queue(S2, e) : bd in e ? this._mixpanel.persistence._add_to_people_queue(bd, e) : r1 in e ? this._mixpanel.persistence._add_to_people_queue(r1, e) : Af in e ? this._mixpanel.persistence._add_to_people_queue(Af, e) : Bp in e ? this._mixpanel.persistence._add_to_people_queue(Bp, e) : a1 in e ? this._mixpanel.persistence._add_to_people_queue(a1, e) : fa.error("Invalid call to _enqueue():", e);
};
ar.prototype._flush_one_queue = function(e, t, n, r) {
  var a = this, o = H.extend({}, this._mixpanel.persistence.load_queue(e)), s = o;
  !H.isUndefined(o) && H.isObject(o) && !H.isEmptyObject(o) && (a._mixpanel.persistence._pop_from_people_queue(e, o), a._mixpanel.persistence.save(), r && (s = r(o)), t.call(a, s, function(c, u) {
    c === 0 && a._mixpanel.persistence._add_to_people_queue(e, o), H.isUndefined(n) || n(c, u);
  }));
};
ar.prototype._flush = function(e, t, n, r, a, o, s) {
  var c = this;
  this._flush_one_queue(Fm, this.set, e), this._flush_one_queue(S2, this.set_once, r), this._flush_one_queue(bd, this.unset, o, function(E) {
    return H.keys(E);
  }), this._flush_one_queue(r1, this.increment, t), this._flush_one_queue(a1, this.union, a);
  var u = this._mixpanel.persistence.load_queue(Af);
  if (!H.isUndefined(u) && H.isArray(u) && u.length)
    for (var f, m = function(E, N) {
      E === 0 && c._mixpanel.persistence._add_to_people_queue(Af, f), H.isUndefined(n) || n(E, N);
    }, v = u.length - 1; v >= 0; v--)
      u = this._mixpanel.persistence.load_queue(Af), f = u.pop(), c._mixpanel.persistence.save(), H.isEmptyObject(f) || c.append(f, m);
  var y = this._mixpanel.persistence.load_queue(Bp);
  if (!H.isUndefined(y) && H.isArray(y) && y.length)
    for (var b, S = function(E, N) {
      E === 0 && c._mixpanel.persistence._add_to_people_queue(Bp, b), H.isUndefined(s) || s(E, N);
    }, x = y.length - 1; x >= 0; x--)
      y = this._mixpanel.persistence.load_queue(Bp), b = y.pop(), c._mixpanel.persistence.save(), H.isEmptyObject(b) || c.remove(b, S);
};
ar.prototype._is_reserved_property = function(e) {
  return e === "$distinct_id" || e === "$token" || e === "$device_id" || e === "$user_id" || e === "$had_persisted_distinct_id";
};
ar.prototype.set = ar.prototype.set;
ar.prototype.set_once = ar.prototype.set_once;
ar.prototype.unset = ar.prototype.unset;
ar.prototype.increment = ar.prototype.increment;
ar.prototype.append = ar.prototype.append;
ar.prototype.remove = ar.prototype.remove;
ar.prototype.union = ar.prototype.union;
ar.prototype.track_charge = ar.prototype.track_charge;
ar.prototype.clear_charges = ar.prototype.clear_charges;
ar.prototype.delete_user = ar.prototype.delete_user;
ar.prototype.toString = ar.prototype.toString;
var jD = "__mps", FD = "__mpso", BD = "__mpus", VD = "__mpa", UD = "__mpap", GD = "__mpr", zD = "__mpu", yue = "$people_distinct_id", N6 = "__alias", __ = "__timers", vit = [
  jD,
  FD,
  BD,
  VD,
  UD,
  GD,
  zD,
  yue,
  N6,
  __
], kr = function(e) {
  this.props = {}, this.campaign_params_saved = !1, e.persistence_name ? this.name = "mp_" + e.persistence_name : this.name = "mp_" + e.token + "_mixpanel";
  var t = e.persistence;
  t !== "cookie" && t !== "localStorage" && (fa.critical("Unknown persistence type " + t + "; falling back to cookie"), t = e.persistence = "cookie"), t === "localStorage" && H.localStorage.is_supported() ? this.storage = H.localStorage : this.storage = H.cookie, this.load(), this.update_config(e), this.upgrade(), this.save();
};
kr.prototype.properties = function() {
  var e = {};
  return this.load(), H.each(this.props, function(t, n) {
    H.include(vit, n) || (e[n] = t);
  }), e;
};
kr.prototype.load = function() {
  if (!this.disabled) {
    var e = this.storage.parse(this.name);
    e && (this.props = H.extend({}, e));
  }
};
kr.prototype.upgrade = function() {
  var e, t;
  this.storage === H.localStorage ? (e = H.cookie.parse(this.name), H.cookie.remove(this.name), H.cookie.remove(this.name, !0), e && this.register_once(e)) : this.storage === H.cookie && (t = H.localStorage.parse(this.name), H.localStorage.remove(this.name), t && this.register_once(t));
};
kr.prototype.save = function() {
  this.disabled || this.storage.set(
    this.name,
    H.JSONEncode(this.props),
    this.expire_days,
    this.cross_subdomain,
    this.secure,
    this.cross_site,
    this.cookie_domain
  );
};
kr.prototype.load_prop = function(e) {
  return this.load(), this.props[e];
};
kr.prototype.remove = function() {
  this.storage.remove(this.name, !1, this.cookie_domain), this.storage.remove(this.name, !0, this.cookie_domain);
};
kr.prototype.clear = function() {
  this.remove(), this.props = {};
};
kr.prototype.register_once = function(e, t, n) {
  return H.isObject(e) ? (typeof t == "undefined" && (t = "None"), this.expire_days = typeof n == "undefined" ? this.default_expiry : n, this.load(), H.each(e, function(r, a) {
    (!this.props.hasOwnProperty(a) || this.props[a] === t) && (this.props[a] = r);
  }, this), this.save(), !0) : !1;
};
kr.prototype.register = function(e, t) {
  return H.isObject(e) ? (this.expire_days = typeof t == "undefined" ? this.default_expiry : t, this.load(), H.extend(this.props, e), this.save(), !0) : !1;
};
kr.prototype.unregister = function(e) {
  this.load(), e in this.props && (delete this.props[e], this.save());
};
kr.prototype.update_search_keyword = function(e) {
  this.register(H.info.searchInfo(e));
};
kr.prototype.update_referrer_info = function(e) {
  this.register_once({
    $initial_referrer: e || "$direct",
    $initial_referring_domain: H.info.referringDomain(e) || "$direct"
  }, "");
};
kr.prototype.get_referrer_info = function() {
  return H.strip_empty_properties({
    $initial_referrer: this.props.$initial_referrer,
    $initial_referring_domain: this.props.$initial_referring_domain
  });
};
kr.prototype.update_config = function(e) {
  this.default_expiry = this.expire_days = e.cookie_expiration, this.set_disabled(e.disable_persistence), this.set_cookie_domain(e.cookie_domain), this.set_cross_site(e.cross_site_cookie), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie);
};
kr.prototype.set_disabled = function(e) {
  this.disabled = e, this.disabled ? this.remove() : this.save();
};
kr.prototype.set_cookie_domain = function(e) {
  e !== this.cookie_domain && (this.remove(), this.cookie_domain = e, this.save());
};
kr.prototype.set_cross_site = function(e) {
  e !== this.cross_site && (this.cross_site = e, this.remove(), this.save());
};
kr.prototype.set_cross_subdomain = function(e) {
  e !== this.cross_subdomain && (this.cross_subdomain = e, this.remove(), this.save());
};
kr.prototype.get_cross_subdomain = function() {
  return this.cross_subdomain;
};
kr.prototype.set_secure = function(e) {
  e !== this.secure && (this.secure = !!e, this.remove(), this.save());
};
kr.prototype._add_to_people_queue = function(e, t) {
  var n = this._get_queue_key(e), r = t[e], a = this._get_or_create_queue(Fm), o = this._get_or_create_queue(S2), s = this._get_or_create_queue(bd), c = this._get_or_create_queue(r1), u = this._get_or_create_queue(a1), f = this._get_or_create_queue(Bp, []), m = this._get_or_create_queue(Af, []);
  n === jD ? (H.extend(a, r), this._pop_from_people_queue(r1, r), this._pop_from_people_queue(a1, r), this._pop_from_people_queue(bd, r)) : n === FD ? (H.each(r, function(v, y) {
    y in o || (o[y] = v);
  }), this._pop_from_people_queue(bd, r)) : n === BD ? H.each(r, function(v) {
    H.each([a, o, c, u], function(y) {
      v in y && delete y[v];
    }), H.each(m, function(y) {
      v in y && delete y[v];
    }), s[v] = !0;
  }) : n === VD ? (H.each(r, function(v, y) {
    y in a ? a[y] += v : (y in c || (c[y] = 0), c[y] += v);
  }, this), this._pop_from_people_queue(bd, r)) : n === zD ? (H.each(r, function(v, y) {
    H.isArray(v) && (y in u || (u[y] = []), u[y] = u[y].concat(v));
  }), this._pop_from_people_queue(bd, r)) : n === GD ? (f.push(r), this._pop_from_people_queue(Af, r)) : n === UD && (m.push(r), this._pop_from_people_queue(bd, r)), fa.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):"), fa.log(t), this.save();
};
kr.prototype._pop_from_people_queue = function(e, t) {
  var n = this.props[this._get_queue_key(e)];
  H.isUndefined(n) || H.each(t, function(r, a) {
    e === Af || e === Bp ? H.each(n, function(o) {
      o[a] === r && delete o[a];
    }) : delete n[a];
  }, this);
};
kr.prototype.load_queue = function(e) {
  return this.load_prop(this._get_queue_key(e));
};
kr.prototype._get_queue_key = function(e) {
  if (e === Fm)
    return jD;
  if (e === S2)
    return FD;
  if (e === bd)
    return BD;
  if (e === r1)
    return VD;
  if (e === Af)
    return UD;
  if (e === Bp)
    return GD;
  if (e === a1)
    return zD;
  fa.error("Invalid queue:", e);
};
kr.prototype._get_or_create_queue = function(e, t) {
  var n = this._get_queue_key(e);
  return t = H.isUndefined(t) ? {} : t, this.props[n] || (this.props[n] = t);
};
kr.prototype.set_event_timer = function(e, t) {
  var n = this.load_prop(__) || {};
  n[e] = t, this.props[__] = n, this.save();
};
kr.prototype.remove_event_timer = function(e) {
  var t = this.load_prop(__) || {}, n = t[e];
  return H.isUndefined(n) || (delete this.props[__][e], this.save()), n;
};
var HD, bue = function(e, t) {
  throw new Error(e + " not available in this build.");
}, ll, _ue = 0, git = 1, yit = function(e) {
  return e;
}, C_ = function() {
}, Sc = "mixpanel", Cue = "base64", bit = "json", WD = "$device:", t2 = lr.XMLHttpRequest && "withCredentials" in new XMLHttpRequest(), wue = !t2 && Cf.indexOf("MSIE") === -1 && Cf.indexOf("Mozilla") === -1, T6 = null;
km.sendBeacon && (T6 = function() {
  return km.sendBeacon.apply(km, arguments);
});
var Sue = {
  track: "track/",
  engage: "engage/",
  groups: "groups/",
  record: "record/"
}, Hq = {
  api_host: "https://api-js.mixpanel.com",
  api_routes: Sue,
  api_method: "POST",
  api_transport: "XHR",
  api_payload_format: Cue,
  app_host: "https://mixpanel.com",
  cdn: "https://cdn.mxpnl.com",
  cross_site_cookie: !1,
  cross_subdomain_cookie: !0,
  error_reporter: C_,
  persistence: "cookie",
  persistence_name: "",
  cookie_domain: "",
  cookie_name: "",
  loaded: C_,
  mp_loader: null,
  track_marketing: !0,
  track_pageview: !1,
  skip_first_touch_marketing: !1,
  store_google: !0,
  stop_utm_persistence: !1,
  save_referrer: !0,
  test: !1,
  verbose: !1,
  img: !1,
  debug: !1,
  track_links_timeout: 300,
  cookie_expiration: 365,
  upgrade: !1,
  disable_persistence: !1,
  disable_cookie: !1,
  secure_cookie: !1,
  ip: !0,
  opt_out_tracking_by_default: !1,
  opt_out_persistence_by_default: !1,
  opt_out_tracking_persistence_type: "localStorage",
  opt_out_tracking_cookie_prefix: null,
  property_blacklist: [],
  xhr_headers: {},
  // { header: value, header2: value }
  ignore_dnt: !1,
  batch_requests: !0,
  batch_size: 50,
  batch_flush_interval_ms: 5e3,
  batch_request_timeout_ms: 9e4,
  batch_autostart: !0,
  hooks: {},
  record_block_class: new RegExp("^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$"),
  record_block_selector: "img, video",
  record_collect_fonts: !1,
  record_idle_timeout_ms: 30 * 60 * 1e3,
  // 30 minutes
  record_inline_images: !1,
  record_mask_text_class: new RegExp("^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$"),
  record_mask_text_selector: "*",
  record_max_ms: J4,
  record_sessions_percent: 0,
  recorder_src: "https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js"
}, xue = !1, nt = function() {
}, iR = function(e, t, n) {
  var r, a = n === Sc ? ll : ll[n];
  if (a && HD === _ue)
    r = a;
  else {
    if (a && !H.isArray(a)) {
      fa.error("You have already initialized " + n);
      return;
    }
    r = new nt();
  }
  if (r._cached_groups = {}, r._init(e, t, n), r.people = new ar(), r.people._init(r), !r.get_config("skip_first_touch_marketing")) {
    var o = H.info.campaignParams(null), s = {}, c = !1;
    H.each(o, function(u, f) {
      s["initial_" + f] = u, u && (c = !0);
    }), c && r.people.set_once(s);
  }
  return Fp.DEBUG = Fp.DEBUG || r.get_config("debug"), !H.isUndefined(a) && H.isArray(a) && (r._execute_array.call(r.people, a.people), r._execute_array(a)), r;
};
nt.prototype.init = function(e, t, n) {
  if (H.isUndefined(n)) {
    this.report_error("You must name your new library: init(token, config, name)");
    return;
  }
  if (n === Sc) {
    this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
    return;
  }
  var r = iR(e, t, n);
  return ll[n] = r, r._loaded(), r;
};
nt.prototype._init = function(e, t, n) {
  t = t || {}, this.__loaded = !0, this.config = {};
  var r = {};
  if (!("api_payload_format" in t)) {
    var a = t.api_host || Hq.api_host;
    a.match(/\.mixpanel\.com/) && (r.api_payload_format = bit);
  }
  if (this.set_config(H.extend({}, Hq, r, t, {
    name: n,
    token: e,
    callback_fn: (n === Sc ? n : Sc + "." + n) + "._jsc"
  })), this._jsc = C_, this.__dom_loaded_queue = [], this.__request_queue = [], this.__disabled_events = [], this._flags = {
    disable_all_events: !1,
    identify_called: !1
  }, this.request_batchers = {}, this._batch_requests = this.get_config("batch_requests"), this._batch_requests) {
    if (!H.localStorage.is_supported(!0) || !t2)
      this._batch_requests = !1, fa.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support"), H.each(this.get_batcher_configs(), function(u) {
        fa.log("Clearing batch queue " + u.queue_key), H.localStorage.remove(u.queue_key);
      });
    else if (this.init_batchers(), T6 && lr.addEventListener) {
      var o = H.bind(function() {
        this.request_batchers.events.stopped || this.request_batchers.events.flush({ unloading: !0 });
      }, this);
      lr.addEventListener("pagehide", function(u) {
        u.persisted && o();
      }), lr.addEventListener("visibilitychange", function() {
        Fa.visibilityState === "hidden" && o();
      });
    }
  }
  this.persistence = this.cookie = new kr(this.config), this.unpersisted_superprops = {}, this._gdpr_init();
  var s = H.UUID();
  this.get_distinct_id() || this.register_once({
    distinct_id: WD + s,
    $device_id: s
  }, "");
  var c = this.get_config("track_pageview");
  c && this._init_url_change_tracking(c), this.get_config("record_sessions_percent") > 0 && Math.random() * 100 <= this.get_config("record_sessions_percent") && this.start_session_recording();
};
nt.prototype.start_session_recording = ov(function() {
  if (!lr.MutationObserver) {
    fa.critical("Browser does not support MutationObserver; skipping session recording");
    return;
  }
  var e = H.bind(function() {
    this._recorder = this._recorder || new lr.__mp_recorder(this), this._recorder.startRecording();
  }, this);
  H.isUndefined(lr.__mp_recorder) ? bue(this.get_config("recorder_src"), e) : e();
});
nt.prototype.stop_session_recording = function() {
  this._recorder ? this._recorder.stopRecording() : fa.critical("Session recorder module not loaded");
};
nt.prototype.get_session_recording_properties = function() {
  var e = {};
  if (this._recorder) {
    var t = this._recorder.replayId;
    t && (e.$mp_replay_id = t);
  }
  return e;
};
nt.prototype._loaded = function() {
  if (this.get_config("loaded")(this), this._set_default_superprops(), this.people.set_once(this.persistence.get_referrer_info()), this.get_config("store_google") && this.get_config("stop_utm_persistence")) {
    var e = H.info.campaignParams(null);
    H.each(e, function(t, n) {
      this.unregister(n);
    }.bind(this));
  }
};
nt.prototype._set_default_superprops = function() {
  this.persistence.update_search_keyword(Fa.referrer), this.get_config("store_google") && !this.get_config("stop_utm_persistence") && this.register(H.info.campaignParams()), this.get_config("save_referrer") && this.persistence.update_referrer_info(Fa.referrer);
};
nt.prototype._dom_loaded = function() {
  H.each(this.__dom_loaded_queue, function(e) {
    this._track_dom.apply(this, e);
  }, this), this.has_opted_out_tracking() || H.each(this.__request_queue, function(e) {
    this._send_request.apply(this, e);
  }, this), delete this.__dom_loaded_queue, delete this.__request_queue;
};
nt.prototype._track_dom = function(e, t) {
  if (this.get_config("img"))
    return this.report_error("You can't use DOM tracking functions with img = true."), !1;
  if (!xue)
    return this.__dom_loaded_queue.push([e, t]), !1;
  var n = new e().init(this);
  return n.track.apply(n, t);
};
nt.prototype._init_url_change_tracking = function(e) {
  var t = "", n = this.track_pageview();
  if (n && (t = H.info.currentUrl()), H.include(["full-url", "url-with-path-and-query-string", "url-with-path"], e)) {
    lr.addEventListener("popstate", function() {
      lr.dispatchEvent(new Event("mp_locationchange"));
    }), lr.addEventListener("hashchange", function() {
      lr.dispatchEvent(new Event("mp_locationchange"));
    });
    var r = lr.history.pushState;
    typeof r == "function" && (lr.history.pushState = function(o, s, c) {
      r.call(lr.history, o, s, c), lr.dispatchEvent(new Event("mp_locationchange"));
    });
    var a = lr.history.replaceState;
    typeof a == "function" && (lr.history.replaceState = function(o, s, c) {
      a.call(lr.history, o, s, c), lr.dispatchEvent(new Event("mp_locationchange"));
    }), lr.addEventListener("mp_locationchange", function() {
      var o = H.info.currentUrl(), s = !1;
      if (e === "full-url" ? s = o !== t : e === "url-with-path-and-query-string" ? s = o.split("#")[0] !== t.split("#")[0] : e === "url-with-path" && (s = o.split("#")[0].split("?")[0] !== t.split("#")[0].split("?")[0]), s) {
        var c = this.track_pageview();
        c && (t = o);
      }
    }.bind(this));
  }
};
nt.prototype._prepare_callback = function(e, t) {
  if (H.isUndefined(e))
    return null;
  if (t2) {
    var n = function(s) {
      e(s, t);
    };
    return n;
  } else {
    var r = this._jsc, a = "" + Math.floor(Math.random() * 1e8), o = this.get_config("callback_fn") + "[" + a + "]";
    return r[a] = function(s) {
      delete r[a], e(s, t);
    }, o;
  }
};
nt.prototype._send_request = function(e, t, n, r) {
  var a = !0;
  if (wue)
    return this.__request_queue.push(arguments), a;
  var o = {
    method: this.get_config("api_method"),
    transport: this.get_config("api_transport"),
    verbose: this.get_config("verbose")
  }, s = null;
  !r && (H.isFunction(n) || typeof n == "string") && (r = n, n = null), n = H.extend(o, n || {}), t2 || (n.method = "GET");
  var c = n.method === "POST", u = T6 && c && n.transport.toLowerCase() === "sendbeacon", f = n.verbose;
  t.verbose && (f = !0), this.get_config("test") && (t.test = 1), f && (t.verbose = 1), this.get_config("img") && (t.img = 1), t2 || (r ? t.callback = r : (f || this.get_config("test")) && (t.callback = "(function(){})")), t.ip = this.get_config("ip") ? 1 : 0, t._ = (/* @__PURE__ */ new Date()).getTime().toString(), c && (s = "data=" + encodeURIComponent(t.data), delete t.data), e += "?" + H.HTTPBuildQuery(t);
  var m = this;
  if ("img" in t) {
    var v = Fa.createElement("img");
    v.src = e, Fa.body.appendChild(v);
  } else if (u) {
    try {
      a = T6(e, s);
    } catch (N) {
      m.report_error(N), a = !1;
    }
    try {
      r && r(a ? 1 : 0);
    } catch (N) {
      m.report_error(N);
    }
  } else if (t2)
    try {
      var y = new XMLHttpRequest();
      y.open(n.method, e, !0);
      var b = this.get_config("xhr_headers");
      if (c && (b["Content-Type"] = "application/x-www-form-urlencoded"), H.each(b, function(N, R) {
        y.setRequestHeader(R, N);
      }), n.timeout_ms && typeof y.timeout != "undefined") {
        y.timeout = n.timeout_ms;
        var S = (/* @__PURE__ */ new Date()).getTime();
      }
      y.withCredentials = !0, y.onreadystatechange = function() {
        if (y.readyState === 4)
          if (y.status === 200) {
            if (r)
              if (f) {
                var N;
                try {
                  N = H.JSONDecode(y.responseText);
                } catch (D) {
                  if (m.report_error(D), n.ignore_json_errors)
                    N = y.responseText;
                  else
                    return;
                }
                r(N);
              } else
                r(Number(y.responseText));
          } else {
            var R;
            if (y.timeout && !y.status && (/* @__PURE__ */ new Date()).getTime() - S >= y.timeout ? R = "timeout" : R = "Bad HTTP status: " + y.status + " " + y.statusText, m.report_error(R), r)
              if (f) {
                var O = y.responseHeaders || {};
                r({ status: 0, httpStatusCode: y.status, error: R, retryAfter: O["Retry-After"] });
              } else
                r(0);
          }
      }, y.send(s);
    } catch (N) {
      m.report_error(N), a = !1;
    }
  else {
    var x = Fa.createElement("script");
    x.type = "text/javascript", x.async = !0, x.defer = !0, x.src = e;
    var E = Fa.getElementsByTagName("script")[0];
    E.parentNode.insertBefore(x, E);
  }
  return a;
};
nt.prototype._execute_array = function(e) {
  var t, n = [], r = [], a = [];
  H.each(e, function(s) {
    s && (t = s[0], H.isArray(t) ? a.push(s) : typeof s == "function" ? s.call(this) : H.isArray(s) && t === "alias" ? n.push(s) : H.isArray(s) && t.indexOf("track") !== -1 && typeof this[t] == "function" ? a.push(s) : r.push(s));
  }, this);
  var o = function(s, c) {
    H.each(s, function(u) {
      if (H.isArray(u[0])) {
        var f = c;
        H.each(u, function(m) {
          f = f[m[0]].apply(f, m.slice(1));
        });
      } else
        this[u[0]].apply(this, u.slice(1));
    }, c);
  };
  o(n, this), o(r, this), o(a, this);
};
nt.prototype.are_batchers_initialized = function() {
  return !!this.request_batchers.events;
};
nt.prototype.get_batcher_configs = function() {
  var e = "__mpq_" + this.get_config("token"), t = this.get_config("api_routes");
  return this._batcher_configs = this._batcher_configs || {
    events: { type: "events", endpoint: "/" + t.track, queue_key: e + "_ev" },
    people: { type: "people", endpoint: "/" + t.engage, queue_key: e + "_pp" },
    groups: { type: "groups", endpoint: "/" + t.groups, queue_key: e + "_gr" }
  }, this._batcher_configs;
};
nt.prototype.init_batchers = function() {
  if (!this.are_batchers_initialized()) {
    var e = H.bind(function(n) {
      return new Rd(
        n.queue_key,
        {
          libConfig: this.config,
          errorReporter: this.get_config("error_reporter"),
          sendRequestFunc: H.bind(function(r, a, o) {
            this._send_request(
              this.get_config("api_host") + n.endpoint,
              this._encode_data_for_request(r),
              a,
              this._prepare_callback(o, r)
            );
          }, this),
          beforeSendHook: H.bind(function(r) {
            return this._run_hook("before_send_" + n.type, r);
          }, this),
          stopAllBatchingFunc: H.bind(this.stop_batch_senders, this),
          usePersistence: !0
        }
      );
    }, this), t = this.get_batcher_configs();
    this.request_batchers = {
      events: e(t.events),
      people: e(t.people),
      groups: e(t.groups)
    };
  }
  this.get_config("batch_autostart") && this.start_batch_senders();
};
nt.prototype.start_batch_senders = function() {
  this._batchers_were_started = !0, this.are_batchers_initialized() && (this._batch_requests = !0, H.each(this.request_batchers, function(e) {
    e.start();
  }));
};
nt.prototype.stop_batch_senders = function() {
  this._batch_requests = !1, H.each(this.request_batchers, function(e) {
    e.stop(), e.clear();
  });
};
nt.prototype.push = function(e) {
  this._execute_array([e]);
};
nt.prototype.disable = function(e) {
  typeof e == "undefined" ? this._flags.disable_all_events = !0 : this.__disabled_events = this.__disabled_events.concat(e);
};
nt.prototype._encode_data_for_request = function(e) {
  var t = H.JSONEncode(e);
  return this.get_config("api_payload_format") === Cue && (t = H.base64Encode(t)), { data: t };
};
nt.prototype._track_or_batch = function(e, t) {
  var n = H.truncate(e.data, 255), r = e.endpoint, a = e.batcher, o = e.should_send_immediately, s = e.send_request_options || {};
  t = t || C_;
  var c = !0, u = H.bind(function() {
    return s.skip_hooks || (n = this._run_hook("before_send_" + e.type, n)), n ? (fa.log("MIXPANEL REQUEST:"), fa.log(n), this._send_request(
      r,
      this._encode_data_for_request(n),
      s,
      this._prepare_callback(t, n)
    )) : null;
  }, this);
  return this._batch_requests && !o ? a.enqueue(n, function(f) {
    f ? t(1, n) : u();
  }) : c = u(), c && n;
};
nt.prototype.track = ov(function(e, t, n, r) {
  !r && typeof n == "function" && (r = n, n = null), n = n || {};
  var a = n.transport;
  a && (n.transport = a);
  var o = n.send_immediately;
  if (typeof r != "function" && (r = C_), H.isUndefined(e)) {
    this.report_error("No event name provided to mixpanel.track");
    return;
  }
  if (this._event_is_disabled(e)) {
    r(0);
    return;
  }
  t = H.extend({}, t), t.token = this.get_config("token");
  var s = this.persistence.remove_event_timer(e);
  if (!H.isUndefined(s)) {
    var c = (/* @__PURE__ */ new Date()).getTime() - s;
    t.$duration = parseFloat((c / 1e3).toFixed(3));
  }
  this._set_default_superprops();
  var u = this.get_config("track_marketing") ? H.info.marketingParams() : {};
  t = H.extend(
    {},
    H.info.properties({ mp_loader: this.get_config("mp_loader") }),
    u,
    this.persistence.properties(),
    this.unpersisted_superprops,
    this.get_session_recording_properties(),
    t
  );
  var f = this.get_config("property_blacklist");
  H.isArray(f) ? H.each(f, function(y) {
    delete t[y];
  }) : this.report_error("Invalid value for property_blacklist config: " + f);
  var m = {
    event: e,
    properties: t
  }, v = this._track_or_batch({
    type: "events",
    data: m,
    endpoint: this.get_config("api_host") + "/" + this.get_config("api_routes").track,
    batcher: this.request_batchers.events,
    should_send_immediately: o,
    send_request_options: n
  }, r);
  return v;
});
nt.prototype.set_group = ov(function(e, t, n) {
  H.isArray(t) || (t = [t]);
  var r = {};
  return r[e] = t, this.register(r), this.people.set(e, t, n);
});
nt.prototype.add_group = ov(function(e, t, n) {
  var r = this.get_property(e), a = {};
  return r === void 0 ? (a[e] = [t], this.register(a)) : r.indexOf(t) === -1 && (r.push(t), a[e] = r, this.register(a)), this.people.union(e, t, n);
});
nt.prototype.remove_group = ov(function(e, t, n) {
  var r = this.get_property(e);
  if (r !== void 0) {
    var a = r.indexOf(t);
    a > -1 && (r.splice(a, 1), this.register({ group_key: r })), r.length === 0 && this.unregister(e);
  }
  return this.people.remove(e, t, n);
});
nt.prototype.track_with_groups = ov(function(e, t, n, r) {
  var a = H.extend({}, t || {});
  return H.each(n, function(o, s) {
    o != null && (a[s] = o);
  }), this.track(e, a, r);
});
nt.prototype._create_map_key = function(e, t) {
  return e + "_" + JSON.stringify(t);
};
nt.prototype._remove_group_from_cache = function(e, t) {
  delete this._cached_groups[this._create_map_key(e, t)];
};
nt.prototype.get_group = function(e, t) {
  var n = this._create_map_key(e, t), r = this._cached_groups[n];
  return (r === void 0 || r._group_key !== e || r._group_id !== t) && (r = new ao(), r._init(this, e, t), this._cached_groups[n] = r), r;
};
nt.prototype.track_pageview = ov(function(e, t) {
  typeof e != "object" && (e = {}), t = t || {};
  var n = t.event_name || "$mp_web_page_view", r = H.extend(
    H.info.mpPageViewProperties(),
    H.info.campaignParams(),
    H.info.clickParams()
  ), a = H.extend(
    {},
    r,
    e
  );
  return this.track(n, a);
});
nt.prototype.track_links = function() {
  return this._track_dom.call(this, w2, arguments);
};
nt.prototype.track_forms = function() {
  return this._track_dom.call(this, Y8, arguments);
};
nt.prototype.time_event = function(e) {
  if (H.isUndefined(e)) {
    this.report_error("No event name provided to mixpanel.time_event");
    return;
  }
  this._event_is_disabled(e) || this.persistence.set_event_timer(e, (/* @__PURE__ */ new Date()).getTime());
};
var _it = {
  persistent: !0
}, ZD = function(e) {
  var t;
  return H.isObject(e) ? t = e : H.isUndefined(e) ? t = {} : t = { days: e }, H.extend({}, _it, t);
};
nt.prototype.register = function(e, t) {
  var n = ZD(t);
  n.persistent ? this.persistence.register(e, n.days) : H.extend(this.unpersisted_superprops, e);
};
nt.prototype.register_once = function(e, t, n) {
  var r = ZD(n);
  r.persistent ? this.persistence.register_once(e, t, r.days) : (typeof t == "undefined" && (t = "None"), H.each(e, function(a, o) {
    (!this.unpersisted_superprops.hasOwnProperty(o) || this.unpersisted_superprops[o] === t) && (this.unpersisted_superprops[o] = a);
  }, this));
};
nt.prototype.unregister = function(e, t) {
  t = ZD(t), t.persistent ? this.persistence.unregister(e) : delete this.unpersisted_superprops[e];
};
nt.prototype._register_single = function(e, t) {
  var n = {};
  n[e] = t, this.register(n);
};
nt.prototype.identify = function(e, t, n, r, a, o, s, c) {
  var u = this.get_distinct_id();
  if (e && u !== e) {
    if (typeof e == "string" && e.indexOf(WD) === 0)
      return this.report_error("distinct_id cannot have $device: prefix"), -1;
    this.register({ $user_id: e });
  }
  if (!this.get_property("$device_id")) {
    var f = u;
    this.register_once({
      $had_persisted_distinct_id: !0,
      $device_id: f
    }, "");
  }
  e !== u && e !== this.get_property(N6) && (this.unregister(N6), this.register({ distinct_id: e })), this._flags.identify_called = !0, this.people._flush(t, n, r, a, o, s, c), e !== u && this.track("$identify", {
    distinct_id: e,
    $anon_distinct_id: u
  }, { skip_hooks: !0 });
};
nt.prototype.reset = function() {
  this.persistence.clear(), this._flags.identify_called = !1;
  var e = H.UUID();
  this.register_once({
    distinct_id: WD + e,
    $device_id: e
  }, "");
};
nt.prototype.get_distinct_id = function() {
  return this.get_property("distinct_id");
};
nt.prototype.alias = function(e, t) {
  if (e === this.get_property(yue))
    return this.report_error("Attempting to create alias for existing People user - aborting."), -2;
  var n = this;
  return H.isUndefined(t) && (t = this.get_distinct_id()), e !== t ? (this._register_single(N6, e), this.track("$create_alias", {
    alias: e,
    distinct_id: t
  }, {
    skip_hooks: !0
  }, function() {
    n.identify(e);
  })) : (this.report_error("alias matches current distinct_id - skipping api call."), this.identify(e), -1);
};
nt.prototype.name_tag = function(e) {
  this._register_single("mp_name_tag", e);
};
nt.prototype.set_config = function(e) {
  if (H.isObject(e)) {
    H.extend(this.config, e);
    var t = e.batch_size;
    t && H.each(this.request_batchers, function(n) {
      n.resetBatchSize();
    }), this.get_config("persistence_name") || (this.config.persistence_name = this.config.cookie_name), this.get_config("disable_persistence") || (this.config.disable_persistence = this.config.disable_cookie), this.persistence && this.persistence.update_config(this.config), Fp.DEBUG = Fp.DEBUG || this.get_config("debug");
  }
};
nt.prototype.get_config = function(e) {
  return this.config[e];
};
nt.prototype._run_hook = function(e) {
  var t = (this.config.hooks[e] || yit).apply(this, Im.call(arguments, 1));
  return typeof t == "undefined" && (this.report_error(e + " hook did not return a value"), t = null), t;
};
nt.prototype.get_property = function(e) {
  return this.persistence.load_prop([e]);
};
nt.prototype.toString = function() {
  var e = this.get_config("name");
  return e !== Sc && (e = Sc + "." + e), e;
};
nt.prototype._event_is_disabled = function(e) {
  return H.isBlockedUA(Cf) || this._flags.disable_all_events || H.include(this.__disabled_events, e);
};
nt.prototype._gdpr_init = function() {
  var e = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
  e && H.localStorage.is_supported() && (!this.has_opted_in_tracking() && this.has_opted_in_tracking({ persistence_type: "cookie" }) && this.opt_in_tracking({ enable_persistence: !1 }), !this.has_opted_out_tracking() && this.has_opted_out_tracking({ persistence_type: "cookie" }) && this.opt_out_tracking({ clear_persistence: !1 }), this.clear_opt_in_out_tracking({
    persistence_type: "cookie",
    enable_persistence: !1
  })), this.has_opted_out_tracking() ? this._gdpr_update_persistence({ clear_persistence: !0 }) : !this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || H.cookie.get("mp_optout")) && (H.cookie.remove("mp_optout"), this.opt_out_tracking({
    clear_persistence: this.get_config("opt_out_persistence_by_default")
  }));
};
nt.prototype._gdpr_update_persistence = function(e) {
  var t;
  if (e && e.clear_persistence)
    t = !0;
  else if (e && e.enable_persistence)
    t = !1;
  else
    return;
  !this.get_config("disable_persistence") && this.persistence.disabled !== t && this.persistence.set_disabled(t), t ? this.stop_batch_senders() : this._batchers_were_started && this.start_batch_senders();
};
nt.prototype._gdpr_call_func = function(e, t) {
  return t = H.extend({
    track: H.bind(this.track, this),
    persistence_type: this.get_config("opt_out_tracking_persistence_type"),
    cookie_prefix: this.get_config("opt_out_tracking_cookie_prefix"),
    cookie_expiration: this.get_config("cookie_expiration"),
    cross_site_cookie: this.get_config("cross_site_cookie"),
    cross_subdomain_cookie: this.get_config("cross_subdomain_cookie"),
    cookie_domain: this.get_config("cookie_domain"),
    secure_cookie: this.get_config("secure_cookie"),
    ignore_dnt: this.get_config("ignore_dnt")
  }, t), H.localStorage.is_supported() || (t.persistence_type = "cookie"), e(this.get_config("token"), {
    track: t.track,
    trackEventName: t.track_event_name,
    trackProperties: t.track_properties,
    persistenceType: t.persistence_type,
    persistencePrefix: t.cookie_prefix,
    cookieDomain: t.cookie_domain,
    cookieExpiration: t.cookie_expiration,
    crossSiteCookie: t.cross_site_cookie,
    crossSubdomainCookie: t.cross_subdomain_cookie,
    secureCookie: t.secure_cookie,
    ignoreDnt: t.ignore_dnt
  });
};
nt.prototype.opt_in_tracking = function(e) {
  e = H.extend({
    enable_persistence: !0
  }, e), this._gdpr_call_func(oit, e), this._gdpr_update_persistence(e);
};
nt.prototype.opt_out_tracking = function(e) {
  e = H.extend({
    clear_persistence: !0,
    delete_user: !0
  }, e), e.delete_user && this.people && this.people._identify_called() && (this.people.delete_user(), this.people.clear_charges()), this._gdpr_call_func(iit, e), this._gdpr_update_persistence(e);
};
nt.prototype.has_opted_in_tracking = function(e) {
  return this._gdpr_call_func(sit, e);
};
nt.prototype.has_opted_out_tracking = function(e) {
  return this._gdpr_call_func(pue, e);
};
nt.prototype.clear_opt_in_out_tracking = function(e) {
  e = H.extend({
    enable_persistence: !0
  }, e), this._gdpr_call_func(lit, e), this._gdpr_update_persistence(e);
};
nt.prototype.report_error = function(e, t) {
  fa.error.apply(fa.error, arguments);
  try {
    !t && !(e instanceof Error) && (e = new Error(e)), this.get_config("error_reporter")(e, t);
  } catch (n) {
    fa.error(n);
  }
};
nt.prototype.init = nt.prototype.init;
nt.prototype.reset = nt.prototype.reset;
nt.prototype.disable = nt.prototype.disable;
nt.prototype.time_event = nt.prototype.time_event;
nt.prototype.track = nt.prototype.track;
nt.prototype.track_links = nt.prototype.track_links;
nt.prototype.track_forms = nt.prototype.track_forms;
nt.prototype.track_pageview = nt.prototype.track_pageview;
nt.prototype.register = nt.prototype.register;
nt.prototype.register_once = nt.prototype.register_once;
nt.prototype.unregister = nt.prototype.unregister;
nt.prototype.identify = nt.prototype.identify;
nt.prototype.alias = nt.prototype.alias;
nt.prototype.name_tag = nt.prototype.name_tag;
nt.prototype.set_config = nt.prototype.set_config;
nt.prototype.get_config = nt.prototype.get_config;
nt.prototype.get_property = nt.prototype.get_property;
nt.prototype.get_distinct_id = nt.prototype.get_distinct_id;
nt.prototype.toString = nt.prototype.toString;
nt.prototype.opt_out_tracking = nt.prototype.opt_out_tracking;
nt.prototype.opt_in_tracking = nt.prototype.opt_in_tracking;
nt.prototype.has_opted_out_tracking = nt.prototype.has_opted_out_tracking;
nt.prototype.has_opted_in_tracking = nt.prototype.has_opted_in_tracking;
nt.prototype.clear_opt_in_out_tracking = nt.prototype.clear_opt_in_out_tracking;
nt.prototype.get_group = nt.prototype.get_group;
nt.prototype.set_group = nt.prototype.set_group;
nt.prototype.add_group = nt.prototype.add_group;
nt.prototype.remove_group = nt.prototype.remove_group;
nt.prototype.track_with_groups = nt.prototype.track_with_groups;
nt.prototype.start_batch_senders = nt.prototype.start_batch_senders;
nt.prototype.stop_batch_senders = nt.prototype.stop_batch_senders;
nt.prototype.start_session_recording = nt.prototype.start_session_recording;
nt.prototype.stop_session_recording = nt.prototype.stop_session_recording;
nt.prototype.get_session_recording_properties = nt.prototype.get_session_recording_properties;
nt.prototype.DEFAULT_API_ROUTES = Sue;
kr.prototype.properties = kr.prototype.properties;
kr.prototype.update_search_keyword = kr.prototype.update_search_keyword;
kr.prototype.update_referrer_info = kr.prototype.update_referrer_info;
kr.prototype.get_cross_subdomain = kr.prototype.get_cross_subdomain;
kr.prototype.clear = kr.prototype.clear;
var Hy = {}, Cit = function() {
  H.each(Hy, function(e, t) {
    t !== Sc && (ll[t] = e);
  }), ll._ = H;
}, wit = function() {
  ll.init = function(e, t, n) {
    if (n)
      return ll[n] || (ll[n] = Hy[n] = iR(e, t, n), ll[n]._loaded()), ll[n];
    var r = ll;
    Hy[Sc] ? r = Hy[Sc] : e && (r = iR(e, t, Sc), r._loaded(), Hy[Sc] = r), ll = r, HD === git && (lr[Sc] = ll), Cit();
  };
}, Sit = function() {
  function e() {
    e.done || (e.done = !0, xue = !0, wue = !1, H.each(Hy, function(r) {
      r._dom_loaded();
    }));
  }
  function t() {
    try {
      Fa.documentElement.doScroll("left");
    } catch (r) {
      setTimeout(t, 1);
      return;
    }
    e();
  }
  if (Fa.addEventListener)
    Fa.readyState === "complete" ? e() : Fa.addEventListener("DOMContentLoaded", e, !1);
  else if (Fa.attachEvent) {
    Fa.attachEvent("onreadystatechange", e);
    var n = !1;
    try {
      n = lr.frameElement === null;
    } catch (r) {
    }
    Fa.documentElement.doScroll && n && t();
  }
  H.register_event(lr, "load", e, !0);
};
function xit(e) {
  return bue = e, HD = _ue, ll = new nt(), wit(), ll.init(), Sit(), ll;
}
function Eit(e, t) {
  t();
}
var Eue = xit(Eit);
const sR = En("CLEENG_ENVIRONMENT"), Iit = "b0295127740fa6adee7c1e57995a2073", kit = "58fd0d2785acbde61a6c117a642c0360", Ait = sR === "production" ? Iit : kit;
Eue.init(Ait);
const Pit = (e, t) => {
  (sR === "production" || sR === "staging") && Eue.track(e, Xn(Fe({}, t), {
    version: Z6
  }));
}, Iue = W.div.attrs(() => ({
  className: "msd__manage-box__actions-wrapper"
}))`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  border-top: 1px solid ${Ree};
  margin-top: 17px;
  padding-top: 17px;
`, Nit = W.section.attrs(() => ({
  className: "msd__manage-box"
}))`
  width: 100%;
  margin-top: 22px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`, Tit = W.div`
  display: flex;
  justify-content: flex-end;

  button {
    padding-right: 38px;
  }
`, Oit = W.div.attrs(() => ({
  className: "msd__manage-box__actions"
}))`
  width: 100%;
  max-height: 0px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;

  ${(e) => e.$isOpened && ot`
      max-height: 500px;
    `}

  ${pr.small`
    button{
      font-size:11px;
    }
  `}
`, Rit = W.span.attrs(() => ({
  className: "msd__manage-box__button-text"
}))`
  position: relative;
  line-height: 1.2;
  &:after {
    position: absolute;
    right: -17px;
    bottom: 0;
    font-size: 11px;
    transform: scaleY(0.8) rotate(0deg);
    transition: all 0.3s ease-in-out;
    content: '▼';
    ${(e) => e.$isExpanded && ot`
        transform: scaleY(0.8) rotateX(180deg);
      `}
  }
`, O6 = W(zt).attrs(() => ({
  className: "msd__manage-box__button"
}))`
  width: 48%;

  text-transform: capitalize;
  &:disabled:hover {
    opacity: 0.9;
  }
  ${Zr.small && ot`
    margin: 0;
    width: unset;
    max-width: unset;
  `}
`, Mit = W(zt)`
  width: 100%;
  ${Zr.small && ot`
    width: unset;
    max-width: unset;
  `}
`, Dit = W.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`, YD = ({ subscription: e, showMessageBox: t }) => {
  const { pauseOffersIDs: n } = wr((ge) => ge.offers), { data: r } = wr(
    (ge) => ge.plan.switchSettings
  ), a = wr(
    xbe
  ), [o, s] = mt(!1), [c, u] = mt(!1), [f, m] = mt(!1), [v, y] = mt(""), [b, S] = mt(!1), [x, E] = mt(""), N = En("CLEENG_CUSTOMER_ID"), R = En("CLEENG_PUBLISHER_ID"), {
    offerId: O,
    offerTitle: D,
    nextPaymentPrice: $,
    nextPaymentCurrency: B,
    status: G,
    subscriptionId: Z
  } = e, K = n.includes(O), q = Jo(), { t: pe } = tn(), he = (ge) => {
    x ? (S(!0), t2e(ge, x).then((Y) => {
      switch (Y.status) {
        case 200:
          u(!1), S(!1), q(Pd()), t(
            "success",
            pe(
              "subscription-management.coupon-redeemed",
              "Your Coupon has been successfully reedemed."
            ),
            ge
          ), window.dispatchEvent(
            new CustomEvent("MSSDK:redeem-coupon-success", {
              detail: {
                coupon: x,
                source: "myaccount"
              }
            })
          );
          break;
        case 422:
          Y.errors.some(
            (ee) => ee.includes("not found") || ee.includes("cannot be applied on this offer") || ee.includes("cannot be applied on existing subscription") || ee.includes("reserved")
          ) && y(
            pe(
              "subscription-management.invalid-coupon",
              "Invalid coupon code."
            )
          ), Y.errors.some((ee) => ee.includes("already applied")) && y(
            pe(
              "subscription-management.coupon-already-applied",
              "Coupon already applied"
            )
          ), Y.errors.some((ee) => ee.includes("already used")) && y(
            pe(
              "subscription-management.coupon-already-used",
              "Coupon already used"
            )
          ), m(!0), S(!1), window.dispatchEvent(
            new CustomEvent("MSSDK:redeem-coupon-failed", {
              detail: {
                coupon: x,
                source: "myaccount"
              }
            })
          );
          break;
        default:
          y(
            pe(
              "subscription-management.invalid-coupon",
              "Invalid coupon code."
            )
          ), m(!0), S(!1);
          break;
      }
    }).catch(() => {
      window.dispatchEvent(
        new CustomEvent("MSSDK:redeem-coupon-failed", {
          detail: {
            coupon: x,
            source: "myaccount"
          }
        })
      ), y(
        pe("oops-something-went-wrong", "Oops! Something went wrong.")
      ), m(!0), S(!1);
    })) : (y(
      pe("subscription-management.enter-coupon", "Please enter coupon code.")
    ), m(!0));
  }, _e = (ge) => {
    ge.stopPropagation(), s((Y) => !Y);
  };
  return /* @__PURE__ */ C.jsxs(Nit, { children: [
    /* @__PURE__ */ C.jsx(Tit, { children: /* @__PURE__ */ C.jsx(zt, { theme: "simple", width: "unset", onClickFn: (ge) => _e(ge), children: /* @__PURE__ */ C.jsx(Rit, { $isExpanded: o, children: pe("subscription-management.manage-button", "Manage") }) }) }),
    /* @__PURE__ */ C.jsx(Oit, { $isOpened: o, children: /* @__PURE__ */ C.jsxs(Iue, { children: [
      G === "active" && !c && /* @__PURE__ */ C.jsx(
        O6,
        {
          theme: "simple",
          onClickFn: (ge) => {
            ge.stopPropagation(), q(Vx(e.offerId)).then(
              () => {
                q(P_(e)), q(
                  Ed({
                    type: Nm.updateSubscription,
                    data: {
                      action: "unsubscribe",
                      offerData: Fe({}, e)
                    }
                  })
                );
              }
            ), window.dispatchEvent(
              new CustomEvent("MSSDK:unsubscribe-button-clicked", {
                detail: {
                  offerId: O
                }
              })
            ), Pit("Unsubscribe Attempt", {
              distinct_id: N,
              publisherId: R,
              offerId: O,
              offerTitle: D,
              offerPrice: $,
              offerCurrency: B
            });
          },
          children: a ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : pe("subscription-management.unsubscribe-button", "Unsubscribe")
        }
      ),
      G === "cancelled" && !c && /* @__PURE__ */ C.jsx(
        Mit,
        {
          theme: "simple",
          onClickFn: (ge) => {
            ge.stopPropagation(), q(
              Ed({
                type: Nm.updateSubscription,
                data: {
                  action: "resubscribe",
                  offerData: Xn(Fe({}, e), {
                    price: `${$}${Ta[B]}`
                  })
                }
              })
            ), window.dispatchEvent(
              new CustomEvent("MSSDK:resume-button-clicked", {
                detail: {
                  offerId: O
                }
              })
            );
          },
          children: pe("subscription-management.resume-button", "Resume")
        }
      ),
      G !== "cancelled" && !K && /* @__PURE__ */ C.jsx(Dit, { children: /* @__PURE__ */ C.jsx(
        $ee,
        {
          couponDetails: {
            showMessage: f,
            message: v
          },
          fullWidth: !0,
          value: x,
          couponLoading: b,
          onSubmit: () => he(Z),
          onChange: (ge) => E(ge),
          onClose: () => u((ge) => !ge),
          onInputToggle: () => u((ge) => !ge),
          source: "myaccount"
        }
      ) }),
      K && /* @__PURE__ */ C.jsx(
        O6,
        {
          theme: "primary",
          onClickFn: (ge) => {
            ge.stopPropagation(), q(
              Ed({
                type: Nm.resumeSubscription,
                data: {
                  offerData: Fe({}, r[e == null ? void 0 : e.offerId].available[0])
                }
              })
            );
          },
          children: pe(
            "subscription-management.resume-subscription-button",
            "Resume subscription"
          )
        }
      )
    ] }) })
  ] });
};
YD.propTypes = {
  subscription: de.objectOf(de.any),
  showMessageBox: de.func
};
YD.defaultProps = {
  subscription: {},
  showMessageBox: () => null
};
const Wq = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24" }, e), /* @__PURE__ */ k.createElement("path", { d: "M9 21.035l-9-8.638 2.791-2.87 6.156 5.874 12.21-12.436 2.843 2.817z" })), Lit = W.div.attrs(() => ({
  className: "msd__message-box"
}))`
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: ${Br};
  border: 1px solid ${Gn};
  border-radius: 7px;
`, $it = W.div.attrs(() => ({
  className: "msd__message-box__icon"
}))`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 18px;
  height: 18px;
  background-color: ${An};
  border-radius: 3px;

  svg {
    height: 12px;
    fill: #fff;
  }
`, jit = W.div.attrs(() => ({
  className: "msd__message-box__text"
}))`
  margin-left: 13px;
  font-size: 12px;
  color: ${An};
`, XD = ({ type: e, message: t }) => /* @__PURE__ */ C.jsxs(Lit, { type: e, children: [
  /* @__PURE__ */ C.jsx($it, { children: Wq && /* @__PURE__ */ C.jsx(Wq, {}) }),
  /* @__PURE__ */ C.jsx(jit, { children: t })
] });
XD.propTypes = {
  type: de.string,
  message: de.string
};
XD.defaultProps = {
  type: "success",
  message: ""
};
const KD = W.div`
  position: relative;

  margin-bottom: 20px;
`, e_ = W.div.attrs(() => ({
  className: "msd__account__subscription"
}))`
  background: ${VR};
  border: 1px solid ${Gn};
  border-radius: 12px;

  padding: 20px 18px;

  ${(e) => e.onClick && e.$cursorPointer && ot`
      cursor: pointer;
    `}
  &:not(:last-child) {
    margin-bottom: 20px;
    padding-bottom: 20px;
  }

  position: relative;
  z-index: 1;

  &::after {
    position: absolute;
    width: 100%;
    height: 100%;
    top: -1px;
    left: -1px;

    content: '';
    z-index: -1;

    border-radius: 12px;
    border: 1px solid ${An};
    box-shadow: 0px 3px 20px #6767672c;

    opacity: 0;
    transition: opacity 0.2s ease-out;
  }
  ${(e) => e.$isSelected && ot`
      &::after {
        opacity: 1;
      }
    `}

  ${(e) => e.$hide && ot`
      display: none;
    `}
`;
W.div`
  display: flex;
  justify-content: flex-end;
`;
W.span`
  position: relative;
  margin-right: 17px;
  font-family: inherit;
  font-weight: inherit;

  &:after {
    position: absolute;
    right: -17px;
    bottom: 0;
    font-size: 11px;
    ${(e) => e.$isExpanded ? "content: '▲'" : "content: '▼'"};
  }
`;
const Fit = W.div.attrs(() => ({
  className: "msd__account__message"
}))`
  margin-top: 20px;
`, Bit = () => /* @__PURE__ */ C.jsx(e_, { children: /* @__PURE__ */ C.jsx(Lat, {}) }), Vit = () => /* @__PURE__ */ C.jsx(KD, { children: /* @__PURE__ */ C.jsx(Ml, { generalError: !0 }) }), Uit = () => {
  const { t: e } = tn();
  return /* @__PURE__ */ C.jsx(KD, { children: /* @__PURE__ */ C.jsxs($le, { children: [
    /* @__PURE__ */ C.jsx(b6, { children: /* @__PURE__ */ C.jsx(xat, {}) }),
    /* @__PURE__ */ C.jsx(y6, { children: e("currentplan.no-offers-title", "No offers yet!") }),
    /* @__PURE__ */ C.jsx(ND, { children: En("CLEENG_OFFER_SELECTION_URL") ? /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "currentplan.no-offers-text-withlink", children: [
      "If you",
      " ",
      /* @__PURE__ */ C.jsx(
        "a",
        {
          href: En("CLEENG_OFFER_SELECTION_URL"),
          target: "_blank",
          rel: "noreferrer",
          children: "choose your plan"
        }
      ),
      ", you will be able to manage your offers here."
    ] }) : e(
      "currentplan.no-offers-text",
      "If you choose your plan, you will be able to manage your offers here."
    ) })
  ] }) });
}, kue = () => {
  const [e, t] = mt(!1), [n, r] = mt(null), [a, o] = mt(""), [s, c] = mt(null), {
    data: u,
    loading: f,
    error: m
  } = wr((S) => S.plan.currentPlan), { offerToSwitch: v } = wr((S) => S.plan), y = Jo(), b = (S, x, E) => {
    t(!0), r(S), o(x), c(E);
  };
  return f ? /* @__PURE__ */ C.jsx(Bit, {}) : m != null && m.length ? /* @__PURE__ */ C.jsx(Vit, {}) : u.length === 0 ? /* @__PURE__ */ C.jsx(Uit, {}) : /* @__PURE__ */ C.jsx(KD, { children: /* @__PURE__ */ C.jsx(C.Fragment, { children: u.map((S) => /* @__PURE__ */ C.jsxs(
    e_,
    {
      as: "article",
      onClick: () => {
        u.length > 1 && S.offerType === "S" && S.status === "active" && y(P_(S));
      },
      $cursorPointer: u.length > 1 && S.status === "active" && S.offerType === "S",
      $isSelected: u.length > 1 && v.offerId === S.offerId,
      children: [
        /* @__PURE__ */ C.jsx(Dat, { offerId: S.offerId }),
        e && s === S.subscriptionId && /* @__PURE__ */ C.jsx(Fit, { children: /* @__PURE__ */ C.jsx(
          XD,
          {
            type: n,
            message: a
          }
        ) }),
        S.offerType === "S" && !S.isExternallyManaged && /* @__PURE__ */ C.jsx(
          YD,
          {
            subscription: S,
            showMessageBox: b
          }
        )
      ]
    },
    S.offerId
  )) }) });
}, Git = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#d3dbe6;}.b,.c{fill:#f8fafd;}.b{stroke:#f7fafc;stroke-width:0.2px;}.d{fill:none;stroke:#707070;}")), /* @__PURE__ */ k.createElement("g", { transform: "translate(-421 -539)" }, /* @__PURE__ */ k.createElement("rect", { className: "a", width: 18, height: 18, rx: 3, transform: "translate(421 539)" }), /* @__PURE__ */ k.createElement("g", { transform: "translate(425.72 565.666)" }, /* @__PURE__ */ k.createElement("path", { className: "b", d: "M7.717-13.6a.777.777,0,0,1-.781.773H1.708a.77.77,0,0,1-.781-.787l-.45-4.665a.763.763,0,0,1,.78-.762h6.13a.759.759,0,0,1,.781.736ZM2.411-21.418a1.87,1.87,0,0,1,1.912-1.77,1.87,1.87,0,0,1,1.912,1.77v1.894H2.411Zm4.977,1.894H6.713v-1.894a2.353,2.353,0,0,0-2.39-2.248,2.353,2.353,0,0,0-2.39,2.248v1.894H1.257A1.255,1.255,0,0,0,0-18.26L.45-13.6a1.251,1.251,0,0,0,1.258,1.242H6.936a1.25,1.25,0,0,0,1.258-1.228l.452-4.706a1.234,1.234,0,0,0-1.258-1.237", transform: "translate(0)" }), /* @__PURE__ */ k.createElement("path", { className: "c", d: "M9.166-6H8.093L7.8-8.361a.809.809,0,0,1,.824-.791.8.8,0,0,1,.829.736ZM8.628-9.949A1.611,1.611,0,0,0,7.01-8.313l.336,2.754a.4.4,0,0,0,.4.351H9.519a.4.4,0,0,0,.4-.351l.336-2.81a1.6,1.6,0,0,0-1.623-1.58", transform: "translate(-4.308 -8.109)" }), /* @__PURE__ */ k.createElement("path", { className: "d", d: "M.909-18.914" }), /* @__PURE__ */ k.createElement("path", { className: "c", d: "M2.248-19.017H.519l.469,6.2H3.764l-.759-6.387Z" }), /* @__PURE__ */ k.createElement("path", { className: "c", d: "M2.91-19.277l.165,2.01s-1.008.409.207,0,4.867-1.553,4.867-1.553l-1.157-.359-.764.089" }), /* @__PURE__ */ k.createElement("path", { className: "c", d: "M7.935-18.914s.657,1.307-.168,4.877c-.4,1.368-.232,1.232-.232,1.232L3.027-12.95s.215-.722,2.028-.99A5.216,5.216,0,0,0,5.52-16.4c0-.62-.175-.464-.542-.707s-1.7-.193-.923-.693A19.894,19.894,0,0,1,7.935-18.914Z" })))), zit = [
  "S675017829_PL",
  "S117251403_PL",
  "S680269209_US",
  "S179187332_US",
  "S984338192_US",
  "S471401848_US",
  "S869341037_US",
  "S537531369_US",
  "S248815997_US"
], mc = (e) => zit.includes(e), Aue = W.section`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
`, Pue = W.div.attrs(() => ({
  className: "msd__subscription-text__wrapper"
}))`
  max-width: 50%;
  color: ${Et};
  margin-inline-end: 15px;

  ${Zr.small`
    max-width: none;
    margin-inline-end: 20px;
  `}
`, Hit = W.h2.attrs(() => ({
  className: "msd__subscription-text__title"
}))`
  margin: 0 auto 3px 0;

  font-weight: ${Nd};
  font-size: ${A2};
  line-height: 15px;

  ${Zr.small`
    font-size: ${n8};
    line-height: 19px;
  `};
`, Nue = W.div.attrs(() => ({
  className: "msd__subscription-price__wrapper"
}))`
  display: flex;
  flex-direction: column;
  margin-inline: auto 0;
`;
W.div.attrs(() => ({
  className: "msd__subscription-price__badge"
}))`
  width: 80px;
  padding: 4px 8px;
  margin-bottom: 4px;
  background-color: ${cu};
  color: ${Et};
  border: 1px solid ${Gn};
  border-radius: 10px;
  font-size: 9px;
  font-size: ${Mee};
  font-weight: ${Yp};
  text-transform: uppercase;
`;
const Wit = W.div.attrs(() => ({
  className: "msd__subscription-subcard"
}))`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  margin: 15px 0;
  padding: 12px;
  border: 1px solid ${Gn};
  background: ${Br};
  border-radius: 4px;
  svg {
    min-width: 18px;
    width: 18px;
  }
`, Zit = W.p.attrs(() => ({
  className: "msd__subscription-subcard__title"
}))`
  font-size: ${i1};
  color: ${Et};
  margin-inline: 10px 0;
  line-height: initial;
`, Yit = W.div``;
W.button`
  padding: 0;
  margin: 8px 0 0 10px;
  background-color: transparent;
  color: ${An};
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`;
const lR = ({ baseOfferId: e, toOfferId: t }) => {
  var f, m;
  const { t: n } = tn(), { data: r, loading: a } = Ot(cee), o = r[e].available.find(
    (v) => v.toOfferId === t
  ) || r[e].unavailable.find(
    (v) => v.toOfferId === t
  ) || {}, s = (f = wc[o == null ? void 0 : o.period]) == null ? void 0 : f.chargedForEveryText, c = Ta[o == null ? void 0 : o.nextPaymentPriceCurrency], u = () => {
    var v;
    switch ((v = o == null ? void 0 : o.reason) == null ? void 0 : v.code) {
      case "TO_OFFER_COUNTRY_NOT_ALLOWED":
        return n(
          "offer-card.error.geo-restriction",
          "This plan is <strong>currently unavailable</strong> in your country or region"
        );
      case "ALREADY_HAS_ACCESS":
        return n(
          "offer-card.error.already-have-access",
          "It looks like you already have access to this offer"
        );
      case "TO_FREE_OFFER_NOT_ALLOWED":
        return n(
          "offer-card.error.to-free-offer",
          "Downgrading from a paid to a free offer is not possible"
        );
      case "SUBSCRIPTION_WITH_COUPON_NOT_ALLOWED":
        return n(
          "offer-card.error.coupon-applied",
          "You can't change your subscription if a coupon was applied. To change plan, please cancel your current subscription and purchase a new one."
        );
      case "SWITCH_IN_PROGRESS":
        return n(
          "offer-card.error.switch-in-progress",
          "Another switch is already in progress. Wait until the process finalization"
        );
      case "MISSING_PAYMENT_DETAILS":
        return n(
          "offer-card.error.missing-payment-details",
          "Your payment details are missing. Please add them to proceed with a subscription switch."
        );
      case "MISSING_PAYMENT_FOR_PRORATION":
        return n(
          "offer-card.error.missing-payment-for-proration",
          "The upgrade will be available after the renewal date."
        );
      default:
        return "";
    }
  };
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(Aue, { children: [
      /* @__PURE__ */ C.jsx(
        Zn,
        {
          showChildren: !a,
          width: 50,
          height: 50,
          children: /* @__PURE__ */ C.jsx(th, { period: s || "S" })
        }
      ),
      /* @__PURE__ */ C.jsxs(Pue, { children: [
        /* @__PURE__ */ C.jsx(
          Zn,
          {
            showChildren: !a,
            width: 200,
            margin: "0 10px 10px 10px",
            children: /* @__PURE__ */ C.jsx(Hit, { children: n(`offer-title-${t}`, o.title) })
          }
        ),
        /* @__PURE__ */ C.jsx(
          Zn,
          {
            showChildren: !a,
            width: 300,
            margin: "0 10px 10px 10px"
          }
        )
      ] }),
      /* @__PURE__ */ C.jsx(Nue, { children: /* @__PURE__ */ C.jsx(
        Zn,
        {
          showChildren: !a,
          width: 80,
          height: 30,
          children: /* @__PURE__ */ C.jsx(
            SD,
            {
              currency: c,
              nextPaymentPrice: mc(t) && o.algorithm !== "DEFERRED" ? o.price : o.nextPaymentPrice,
              totalPrice: o.price,
              period: o.period !== "season" ? n(
                `offer-price.period-${o.period}`,
                o.period
              ) : null
            }
          )
        }
      ) })
    ] }),
    ((m = o == null ? void 0 : o.reason) == null ? void 0 : m.code) && u() && /* @__PURE__ */ C.jsxs(Wit, { children: [
      /* @__PURE__ */ C.jsx(Git, {}),
      /* @__PURE__ */ C.jsx(Yit, { children: /* @__PURE__ */ C.jsx(
        Zit,
        {
          dangerouslySetInnerHTML: {
            __html: u()
          }
        }
      ) })
    ] })
  ] });
}, Xit = () => /* @__PURE__ */ C.jsxs(Aue, { children: [
  /* @__PURE__ */ C.jsx(Zn, { showChildren: !1, width: 50, height: 50 }),
  /* @__PURE__ */ C.jsxs(Pue, { children: [
    /* @__PURE__ */ C.jsx(
      Zn,
      {
        showChildren: !1,
        width: 200,
        margin: "0 10px 10px 10px"
      }
    ),
    /* @__PURE__ */ C.jsx(
      Zn,
      {
        showChildren: !1,
        width: 300,
        margin: "0 10px 10px 10px"
      }
    )
  ] }),
  /* @__PURE__ */ C.jsx(Nue, { children: /* @__PURE__ */ C.jsx(Zn, { showChildren: !1, width: 80, height: 30 }) })
] }), Zq = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 88.932, height: 70.117, viewBox: "0 0 88.932 70.117" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_3268", "data-name": "Group 3268", transform: "translate(-613.786 -616.883)" }, /* @__PURE__ */ k.createElement("g", { id: "Path_2422", "data-name": "Path 2422", transform: "translate(633 630)", fill: "none" }, /* @__PURE__ */ k.createElement("path", { d: "M3,0H44a3,3,0,0,1,3,3V41a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z", stroke: "none" }), /* @__PURE__ */ k.createElement("path", { d: "M 3 2 C 2.448600769042969 2 2 2.448600769042969 2 3 L 2 41 C 2 41.55139923095703 2.448600769042969 42 3 42 L 44 42 C 44.55139923095703 42 45 41.55139923095703 45 41 L 45 3 C 45 2.448600769042969 44.55139923095703 2 44 2 L 3 2 M 3 0 L 44 0 C 45.6568489074707 0 47 1.343151092529297 47 3 L 47 41 C 47 42.6568489074707 45.6568489074707 44 44 44 L 3 44 C 1.343151092529297 44 0 42.6568489074707 0 41 L 0 3 C 0 1.343151092529297 1.343151092529297 0 3 0 Z", stroke: "none", fill: "#bcc3cd" })), /* @__PURE__ */ k.createElement("path", { id: "Rectangle_3607", "data-name": "Rectangle 3607", d: "M2,0H14.009a2,2,0,0,1,2,2V8a0,0,0,0,1,0,0H0A0,0,0,0,1,0,8V2A2,2,0,0,1,2,0Z", transform: "translate(681.297 616.883) rotate(45)", fill: "#bcc3cd" }), /* @__PURE__ */ k.createElement("path", { id: "Polygon_6", "data-name": "Polygon 6", d: "M8,0l8,13.34H0Z", transform: "translate(649.381 671.716) rotate(-135)", fill: "#bcc3cd" }), /* @__PURE__ */ k.createElement("rect", { id: "Rectangle_3605", "data-name": "Rectangle 3605", width: 21.345, height: 36.019, transform: "translate(672.741 621.667) rotate(45)", fill: "#f8fafd" }), /* @__PURE__ */ k.createElement("rect", { id: "Rectangle_3606", "data-name": "Rectangle 3606", width: 16.009, height: 36.019, transform: "translate(674.627 623.553) rotate(45)", fill: "#bcc3cd" }), /* @__PURE__ */ k.createElement("g", { id: "Group_3260", "data-name": "Group 3260", transform: "translate(693.314 641.102)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1392", "data-name": "Path 1392", d: "M4661.925-156.765h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,4661.925-156.765Z", transform: "translate(-4659.591 158.289)", fill: "#bcc3cd" })), /* @__PURE__ */ k.createElement("g", { id: "Group_3261", "data-name": "Group 3261", transform: "translate(699.622 641.102)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1393", "data-name": "Path 1393", d: "M4753.007-156.765h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,4753.007-156.765Z", transform: "translate(-4750.673 158.289)", fill: "#bcc3cd" })), /* @__PURE__ */ k.createElement("g", { id: "Group_3262", "data-name": "Group 3262", transform: "translate(697.254 637.162)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1394", "data-name": "Path 1394", d: "M4717.243-212.082a.761.761,0,0,1-.762-.762v-1.572a.761.761,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,4717.243-212.082Z", transform: "translate(-4716.481 215.178)", fill: "#bcc3cd" })), /* @__PURE__ */ k.createElement("g", { id: "Group_3263", "data-name": "Group 3263", transform: "translate(697.254 643.47)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1395", "data-name": "Path 1395", d: "M4717.243-121a.761.761,0,0,1-.762-.762v-1.572a.761.761,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,4717.243-121Z", transform: "translate(-4716.481 124.097)", fill: "#bcc3cd" })), /* @__PURE__ */ k.createElement("g", { id: "Group_3256", "data-name": "Group 3256", transform: "translate(614.863 665.885) rotate(45)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1396", "data-name": "Path 1396", d: "M3515.983-822.6h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,3515.983-822.6Z", transform: "translate(-3513.649 824.122)", fill: "#bcc3cd" })), /* @__PURE__ */ k.createElement("g", { id: "Group_3257", "data-name": "Group 3257", transform: "translate(619.324 670.345) rotate(45)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1397", "data-name": "Path 1397", d: "M3607.064-822.6h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,3607.064-822.6Z", transform: "translate(-3604.73 824.122)", fill: "#bcc3cd" })), /* @__PURE__ */ k.createElement("g", { id: "Group_3258", "data-name": "Group 3258", transform: "translate(620.436 665.885) rotate(45)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1398", "data-name": "Path 1398", d: "M3571.3-877.916a.762.762,0,0,1-.762-.762v-1.572a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,3571.3-877.916Z", transform: "translate(-3570.539 881.012)", fill: "#bcc3cd" })), /* @__PURE__ */ k.createElement("g", { id: "Group_3259", "data-name": "Group 3259", transform: "translate(615.975 670.345) rotate(45)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1399", "data-name": "Path 1399", d: "M3571.3-786.834a.762.762,0,0,1-.762-.762v-1.572a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,3571.3-786.834Z", transform: "translate(-3570.539 789.93)", fill: "#bcc3cd" })), /* @__PURE__ */ k.createElement("path", { id: "Path_2423", "data-name": "Path 2423", d: "M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z", transform: "translate(623.471 619)", fill: "#bcc3cd" }), /* @__PURE__ */ k.createElement("circle", { id: "Ellipse_452", "data-name": "Ellipse 452", cx: 3, cy: 3, r: 3, transform: "translate(688.471 681)", fill: "#bcc3cd" }))), Yq = W(Iue)`
  justify-content: flex-end;
`, Cx = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 490 199.005" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#af60aa;opacity:0.338;}.b,.e,.k{fill:#f8fafd;}.c,.j{fill:none;}.d,.f{opacity:0.146;}.d{clip-path:url(#c);}.e,.j{stroke:#d3dbe6;}.e{stroke-width:1.5px;}.f{clip-path:url(#f);}.g,.i,.j{opacity:0.716;}.h,.i{fill:#d3dbe6;}.l,.m,.n{stroke:none;}.m{fill:rgba(211,219,230,0.3);}.n{fill:rgba(211,219,230,0.6);}"), /* @__PURE__ */ k.createElement("filter", { id: "a", x: 22.002, y: 29.494, width: 450.224, height: 169.511, filterUnits: "userSpaceOnUse" }, /* @__PURE__ */ k.createElement("feOffset", { dy: 5, input: "SourceAlpha" }), /* @__PURE__ */ k.createElement("feGaussianBlur", { stdDeviation: 5, result: "b" }), /* @__PURE__ */ k.createElement("feFlood", { floodOpacity: 0.039 }), /* @__PURE__ */ k.createElement("feComposite", { operator: "in", in2: "b" }), /* @__PURE__ */ k.createElement("feComposite", { in: "SourceGraphic" })), /* @__PURE__ */ k.createElement("clipPath", { id: "c" }, /* @__PURE__ */ k.createElement("rect", { className: "a", width: 52.409, height: 52.216, rx: 12, transform: "translate(0)" })), /* @__PURE__ */ k.createElement("filter", { id: "d", x: 0, y: 0, width: 490, height: 181, filterUnits: "userSpaceOnUse" }, /* @__PURE__ */ k.createElement("feOffset", { dy: 5, input: "SourceAlpha" }), /* @__PURE__ */ k.createElement("feGaussianBlur", { stdDeviation: 5, result: "e" }), /* @__PURE__ */ k.createElement("feFlood", { floodOpacity: 0.039 }), /* @__PURE__ */ k.createElement("feComposite", { operator: "in", in2: "e" }), /* @__PURE__ */ k.createElement("feComposite", { in: "SourceGraphic" })), /* @__PURE__ */ k.createElement("clipPath", { id: "f" }, /* @__PURE__ */ k.createElement("rect", { className: "a", width: 54.313, height: 54.113, rx: 12, transform: "translate(0)" }))), /* @__PURE__ */ k.createElement("g", { transform: "translate(-411 -430)" }, /* @__PURE__ */ k.createElement("g", { transform: "translate(448.002 469.494)" }, /* @__PURE__ */ k.createElement("g", { className: "b", transform: "translate(18.319 28.065)" }, /* @__PURE__ */ k.createElement("path", { className: "l", d: "M9.262,0H374.324a9.262,9.262,0,0,1,9.262,9.262V118.086a9.262,9.262,0,0,1-9.262,9.262H9.262A9.262,9.262,0,0,1,0,118.086V9.262A9.262,9.262,0,0,1,9.262,0Z" }), /* @__PURE__ */ k.createElement("path", { className: "m", d: "M 9.2615966796875 1.5 C 4.98187255859375 1.5 1.5 4.981849670410156 1.5 9.261604309082031 L 1.5 118.0857543945312 C 1.5 122.3655548095703 4.98187255859375 125.8474044799805 9.2615966796875 125.8474044799805 L 352.3265075683594 125.8474044799805 L 374.3241577148438 125.8474044799805 C 378.6039428710938 125.8474044799805 382.0858154296875 122.3655548095703 382.0858154296875 118.0857543945312 L 382.0858154296875 9.261604309082031 C 382.0858154296875 4.981849670410156 378.6039428710938 1.5 374.3241577148438 1.5 L 9.2615966796875 1.5 M 9.2615966796875 0 L 374.3241577148438 0 C 379.4392700195312 0 383.5858154296875 4.146553039550781 383.5858154296875 9.261604309082031 L 383.5858154296875 118.0857543945312 C 383.5858154296875 123.2008056640625 379.4392700195312 127.3474044799805 374.3241577148438 127.3474044799805 L 352.3265075683594 127.3474044799805 L 9.2615966796875 127.3474044799805 C 4.14654541015625 127.3474044799805 0 123.2008056640625 0 118.0857543945312 L 0 9.261604309082031 C 0 4.146553039550781 4.14654541015625 0 9.2615966796875 0 Z" })), /* @__PURE__ */ k.createElement("g", { className: "p", transform: "matrix(1, 0, 0, 1, -37, -39.49)" }, /* @__PURE__ */ k.createElement("g", { className: "b", transform: "translate(37 39.49)" }, /* @__PURE__ */ k.createElement("path", { className: "l", d: "M10.146,0H410.077a10.146,10.146,0,0,1,10.146,10.146V129.365a10.146,10.146,0,0,1-10.146,10.146H10.146A10.146,10.146,0,0,1,0,129.365V10.146A10.146,10.146,0,0,1,10.146,0Z" }), /* @__PURE__ */ k.createElement("path", { className: "n", d: "M 10.14627075195312 1.5 C 5.378692626953125 1.5 1.5 5.378692626953125 1.5 10.14620971679688 L 1.5 129.3645782470703 C 1.5 134.1321563720703 5.378692626953125 138.0108489990234 10.14627075195312 138.0108489990234 L 385.978515625 138.0108489990234 L 410.0773010253906 138.0108489990234 C 414.8448791503906 138.0108489990234 418.7235717773438 134.1321563720703 418.7235717773438 129.3645782470703 L 418.7235717773438 10.14620971679688 C 418.7235717773438 5.378692626953125 414.8448791503906 1.5 410.0773010253906 1.5 L 10.14627075195312 1.5 M 10.14627075195312 0 L 410.0773010253906 0 C 415.6809387207031 0 420.2235717773438 4.542633056640625 420.2235717773438 10.14620971679688 L 420.2235717773438 129.3645782470703 C 420.2235717773438 134.9682159423828 415.6809387207031 139.5108489990234 410.0773010253906 139.5108489990234 L 385.978515625 139.5108489990234 L 10.14627075195312 139.5108489990234 C 4.542633056640625 139.5108489990234 0 134.9682159423828 0 129.3645782470703 L 0 10.14620971679688 C 0 4.542633056640625 4.542633056640625 0 10.14627075195312 0 Z" }))), /* @__PURE__ */ k.createElement("g", { transform: "translate(221.526 76.097)" }, /* @__PURE__ */ k.createElement("rect", { className: "c", width: 11, height: 11, transform: "translate(0.472 0.409)" }))), /* @__PURE__ */ k.createElement("g", { className: "o", transform: "matrix(1, 0, 0, 1, 411, 430)" }, /* @__PURE__ */ k.createElement("g", { className: "e", transform: "translate(15 10)" }, /* @__PURE__ */ k.createElement("rect", { className: "l", width: 460, height: 151, rx: 12 }), /* @__PURE__ */ k.createElement("rect", { className: "c", x: 0.75, y: 0.75, width: 458.5, height: 149.5, rx: 11.25 }))), /* @__PURE__ */ k.createElement("g", { transform: "translate(667.819 522.861)" }, /* @__PURE__ */ k.createElement("rect", { className: "c", width: 12, height: 12, transform: "translate(0.181 0.139)" })), /* @__PURE__ */ k.createElement("g", { className: "g", transform: "translate(442.065 460.292)" }, /* @__PURE__ */ k.createElement("rect", { className: "h", width: 49, height: 49, rx: 10, transform: "translate(-0.065 -0.293)" })), /* @__PURE__ */ k.createElement("rect", { className: "i", width: 35, height: 31, rx: 2, transform: "translate(793 468)" }), /* @__PURE__ */ k.createElement("rect", { className: "i", width: 120, height: 31, rx: 15.5, transform: "translate(752 538)" }), /* @__PURE__ */ k.createElement("rect", { className: "i", width: 36, height: 12, rx: 2, transform: "translate(831 487)" }), /* @__PURE__ */ k.createElement("rect", { className: "i", width: 176, height: 16, rx: 2, transform: "translate(504 460)" }), /* @__PURE__ */ k.createElement("rect", { className: "i", width: 191, height: 8, rx: 2, transform: "translate(504 488)" }), /* @__PURE__ */ k.createElement("rect", { className: "i", width: 152, height: 7, rx: 2, transform: "translate(504 502)" }), /* @__PURE__ */ k.createElement("path", { className: "j", d: "M8874,6954.242h427.833", transform: "translate(-8429.38 -6427.894)" }), /* @__PURE__ */ k.createElement("g", { transform: "translate(455 496)" }, /* @__PURE__ */ k.createElement("path", { className: "k", d: "M23-1H1V-17H23Zm.5-17H.5a.5.5,0,0,0-.5.5v17A.5.5,0,0,0,.5,0h23A.5.5,0,0,0,24-.5v-17a.5.5,0,0,0-.5-.5" }), /* @__PURE__ */ k.createElement("path", { className: "k", d: "M2.585-20H22.42a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5H2.585a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5" }), /* @__PURE__ */ k.createElement("path", { className: "k", d: "M4.474-23H19.486a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5H4.474a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5" })))), xN = {
  RECURRING_PROCESS_ALREADY_STARTED: {
    title: {
      text: "You are at the end of the billing cycle for your current offer.",
      translationKey: "subscription-switches-list.error.recurring-process-already-started.title"
    },
    subtitle: {
      text: "Once the new one starts, you can switch to a new offer.",
      translationKey: "subscription-switches-list.error.recurring-process-already-started.subtitle"
    },
    icon: Cx
  },
  PAYMENT_GATEWAY_NOT_SUPPORTED: {
    title: {
      text: "Your payment method does not allow switching to a new plan from here.",
      translationKey: "subscription-switches-list.error.payment-gateway-not-supported.title"
    },
    subtitle: {
      text: "If you signed up via a mobile app, it may be possible to change your plan there.",
      translationKey: "subscription-switches-list.error.payment-gateway-not-supported.subtitle"
    },
    icon: Cx
  },
  SUBSCRIPTION_WITH_COUPON_NOT_ALLOWED: {
    title: {
      text: "You can't change your subscription if a coupon was applied. To change plan, please cancel your current subscription and purchase a new one",
      translationKey: "subscription-switches-list.error.subscription-with-coupon-not-allowed.title"
    },
    subtitle: {
      text: "",
      translationKey: ""
    },
    icon: Cx
  },
  DEFAULT: {
    title: {
      text: "It looks like you can't change your current plan.",
      translationKey: "subscription-switches-list.error.default.title"
    },
    subtitle: {
      text: "Try again later.",
      translationKey: "subscription-switches-list.error.default.subtitle"
    },
    icon: Cx
  }
}, Tue = () => {
  const { t: e } = tn(), { data: t } = Ot(
    (N) => N.plan.switchDetails
  ), { pauseOffersIDs: n } = Ot((N) => N.offers), { offerToSwitch: r } = Ot((N) => N.plan), {
    data: a,
    loading: o,
    error: s
  } = Ot((N) => N.plan.switchSettings), c = !!r.offerId, u = a[r == null ? void 0 : r.offerId] || {}, f = r == null ? void 0 : r.offerId, m = Object.keys(t).map(
    (N) => t[N].toOfferId
  ), v = "Subscription is externally managed", y = Va();
  if (o)
    return /* @__PURE__ */ C.jsx(e_, { children: /* @__PURE__ */ C.jsx(Xit, {}) });
  if (s != null && s.length)
    return s.includes(v) ? /* @__PURE__ */ C.jsx(
      Ml,
      {
        title: e(
          "subscription-switches-list.offer-externally-managed-title",
          "Subscription is externally managed."
        ),
        subtitle: e(
          "subscription-switches-list.offer-externally-managed-subtitle",
          "Use an external service to change the plan."
        ),
        icon: Dle
      }
    ) : /* @__PURE__ */ C.jsx(Ml, { generalError: !0 });
  if (!c)
    return /* @__PURE__ */ C.jsx(
      Ml,
      {
        icon: Zq,
        title: e(
          "subscription-switches-list.offer-not-selected",
          "Click on the plan that you would like to switch from"
        ),
        margin: "0 auto"
      }
    );
  const b = Array.isArray(u.available) ? [...u.available].sort(
    (N, R) => R.price - N.price
  ) : [], S = b == null ? void 0 : b.filter(
    (N) => !n.includes(N.toOfferId)
  ), x = Array.isArray(u.unavailable) ? u.unavailable.filter(
    (N) => !n.includes(N.toOfferId)
  ) : [], E = u.unavailableReason;
  if (E) {
    const N = xN[E.code] ? xN[E.code] : xN.DEFAULT;
    return /* @__PURE__ */ C.jsx(
      Ml,
      {
        icon: N.icon,
        title: e(N.title.translationKey, N.title.text),
        subtitle: e(N.subtitle.translationKey, N.subtitle.text),
        margin: "0 auto",
        fullWidth: !0
      }
    );
  }
  return !(S != null && S.length) && !(x != null && x.length) ? /* @__PURE__ */ C.jsx(
    Ml,
    {
      icon: Zq,
      title: e(
        "subscription-switches-list.switching-unavailable",
        "Looks like there aren't any options for switching from your current plan right now"
      ),
      margin: "0 auto"
    }
  ) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    !!S.length && S.map((N) => (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      /* @__PURE__ */ C.jsxs(
        e_,
        {
          as: "article",
          $hide: m.find(
            (R) => R === N.toOfferId
          ),
          children: [
            /* @__PURE__ */ C.jsx(
              lR,
              {
                baseOfferId: f,
                toOfferId: N.toOfferId
              }
            ),
            /* @__PURE__ */ C.jsx(Yq, { children: /* @__PURE__ */ C.jsx(
              O6,
              {
                onClickFn: () => {
                  ur(Lye, {
                    fromOfferId: f,
                    toOfferId: N.toOfferId,
                    switchDirection: N.switchDirection,
                    algorithm: N.algorithm
                  }), y(
                    Ed({
                      type: su.SWITCH_PLAN_POPUP,
                      data: {
                        offerData: Fe({}, N)
                      }
                    })
                  );
                },
                children: e(
                  `subscription-switches-list.${N.switchDirection}-button`,
                  N.switchDirection
                )
              }
            ) })
          ]
        },
        N.toOfferId
      )
    )),
    !!x.length && x.map((N) => /* @__PURE__ */ C.jsxs(e_, { children: [
      /* @__PURE__ */ C.jsx(
        lR,
        {
          baseOfferId: f,
          toOfferId: N.toOfferId
        }
      ),
      /* @__PURE__ */ C.jsx(Yq, { children: /* @__PURE__ */ C.jsx(O6, { disabled: !0, children: e(
        `subscription-switches-list.${N.switchDirection}-button`,
        N.switchDirection
      ) }) })
    ] }, N.toOfferId))
  ] });
}, Kit = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 24.277, height: 24.744, viewBox: "0 0 24.277 24.744" }, e), /* @__PURE__ */ k.createElement("g", { id: "Icon_feather-alert-circle", "data-name": "Icon feather-alert-circle", transform: "translate(-1.8 -1.8)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_2508", "data-name": "Path 2508", d: "M24.877,14.172A11.057,11.057,0,0,1,13.939,25.344,11.057,11.057,0,0,1,3,14.172,11.057,11.057,0,0,1,13.939,3,11.057,11.057,0,0,1,24.877,14.172Z", transform: "translate(0 0)", fill: "none", stroke: "#e66370", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2.4 }), /* @__PURE__ */ k.createElement("path", { id: "Path_2509", "data-name": "Path 2509", d: "M18,17.909a1.2,1.2,0,0,1-1.2-1.2V12a1.2,1.2,0,0,1,2.4,0v4.709A1.2,1.2,0,0,1,18,17.909Z", transform: "translate(-4.061 -2.537)", fill: "#e66370" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2510", "data-name": "Path 2510", d: "M18,24h0", transform: "translate(-4.061 -5.359)", fill: "none", stroke: "#e66370", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2.4 }))), qit = W.div.attrs(() => ({
  className: "msd__grace-period-error"
}))`
  display: flex;
  align-items: center;
  gap: 13px;
  background-color: #ffd0d7;
  border: 1px solid #edb8c0;
  border-radius: 12px;
  padding: 14px 26px 15px 0;
  text-align: left;
  font-size: 11px;
  color: #515364;
  font-family: 'Open Sans', sans-serif;
  line-height: 17px;
  letter-spacing: 0.28px;
  margin-bottom: 38px;
  ${pr.small`
    border-radius: 0;
    margin: -55px -46px 32px;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 0.25px;
  `}
`, Jit = W.span.attrs(() => ({
  className: "msd__grace-period-error-warning"
}))`
  text-decoration: underline;
  font-weight: bold;
`, Qit = W.div.attrs(() => ({
  className: "msd__grace-period-error-alert-icon"
}))`
  padding-left: 23px;
`, R6 = () => {
  const e = Va(), { data: t } = Ot($R), n = Ot(gbe);
  return mn(() => {
    n && t.length === 0 && e(L0());
  }, [n]), n && (t == null ? void 0 : t.some(
    ({ status: a, expiresAt: o }) => a === "active" && new Date(o * 1e3) < /* @__PURE__ */ new Date()
  )) ? /* @__PURE__ */ C.jsxs(qit, { "data-testid": "grace-period-error", children: [
    /* @__PURE__ */ C.jsx(Qit, { children: /* @__PURE__ */ C.jsx(Kit, { "data-testid": "alert-svg" }) }),
    /* @__PURE__ */ C.jsx("p", { children: /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "grace-period-error", children: [
      "Your subscription couldn't be renewed due to a payment method issue. Please ",
      /* @__PURE__ */ C.jsx(Jit, { children: "update it" }),
      " ",
      "to avoid losing access to the content."
    ] }) })
  ] }) : null;
}, est = W(Uu)`
  border: 1px solid ${Gn};
  display: flex;
  padding: 0;
  margin: 0;
  ${pr.small`
    display: flex;
    align-items: flex-start;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
  `};
`, tst = W.div.attrs(() => ({
  className: "msd__popup"
}))`
  display: flex;
  flex-direction: column;
  padding: 30px;
  width: 100%;

  ${pr.small`
    height: 100%;
    overflow: scroll;
  `}
`, nst = W.div.attrs(() => ({
  className: "msd__popup__dots"
}))`
  display: flex;
  flex-direction: row;
  ${(e) => e.$currentStep && ot`
      span:nth-child(-n + ${e.$currentStep}) {
        background: ${An};
      
    `}
`, rst = W.div.attrs(() => ({
  className: "msd__popup__header"
}))`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${Et};
  ${pr.small`
    margin: 30px 0 0 0;
  `}
`, ast = W.span.attrs(() => ({
  className: "msd__popup__dot"
}))`
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${Gn};
  margin-right: 10px;
`, ost = W.h1.attrs(() => ({
  className: "msd__popup__title"
}))`
  font-size: 14px;
  margin: 0;
  text-transform: capitalize;
`, da = W.div.attrs(() => ({
  className: "msd__popup-content"
}))`
  text-align: center;
  margin: auto;
  width: 80%;

  ${pr.small`
    width: 90%;
  `}
`, Aa = W.h1.attrs(() => ({
  className: "msd__popup-content__title"
}))`
  font-size: 26px;
  color: ${Et};
  font-weight: 600;
  text-transform: ${(e) => e.$textTransform ? e.$textTransform : "none"};
  line-height: 1.2;

  ${pr.small`
    font-size: 27px;
  `}

  ${(e) => e.$step === 2 && ot`
      font-size: 20px;
      ${pr.small`
        font-size: 20px;
      `}
    `}
`, Cr = W.p.attrs(() => ({
  className: "msd__popup-content__text"
}))`
  color: ${Et};
  opacity: 0.8;
  font-size: 14px;
  line-height: 1.5;
  margin: 24px 0;
`, ist = W.span.attrs(() => ({
  className: "msd__popup-content__mail"
}))`
  font-weight: 700;
`, Oa = W.div.attrs(() => ({
  className: "msd__popup-content__buttons"
}))`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: ${(e) => e.$removeMargin ? "0" : "60px"};

  ${(e) => e.$customMargin && ot`
      margin: ${e.$customMargin};
    `}

  ${pr.small`
    margin-bottom: 60px;
  `}

  button {
    text-transform: capitalize;
    width: ${(e) => e.$fillWrapper ? "80%" : "40%"};
    margin: 0 5px;
    &:disabled {
      cursor: not-allowed;
    }
  }
`, sst = W.p.attrs(() => ({
  className: "msd__popup-content__warning"
}))`
  color: ${Et};
  opacity: 0.8;
  font-size: 11px;
  margin: 15px 0 0 0;
  text-align: center;
`, lst = W.div.attrs(() => ({
  className: "msd__popup-content__downgrades-wrapper"
}))``, ust = W.div.attrs(() => ({
  className: "msd__popup-content__downgrade-wrapper"
}))`
  background: ${VR};
  border: 1px solid ${Gn};
  border-radius: 12px;
  padding: 15px;
  max-width: 550px;
  text-align: left;
  ${(e) => e.onClick && ot`
      cursor: pointer;
    `}
  margin: 10px auto 10px auto;
  &:last-child {
    margin: 10px auto 40px auto;
  }
  &:hover {
    transition: 0.3s ease-in-out;
    border: 1px solid #606376;
  }
  .msd__subscription-text__title {
    font-size: 12px;
  }
  .msd__subscription-price__amount {
    font-size: 15px;
  }
  .msd__subscription-price__period {
    font-size: 11px;
  }
`, Oo = ({
  steps: e,
  popupTitle: t,
  currentStep: n,
  children: r,
  isError: a
}) => /* @__PURE__ */ C.jsx(est, { children: a ? /* @__PURE__ */ C.jsx(Ml, { generalError: !0, centered: !0 }) : /* @__PURE__ */ C.jsxs(tst, { children: [
  /* @__PURE__ */ C.jsxs(rst, { children: [
    /* @__PURE__ */ C.jsx(nst, { $currentStep: n, children: e > 1 && Array.from({ length: e }, (o, s) => /* @__PURE__ */ C.jsx(ast, {}, s)) }),
    /* @__PURE__ */ C.jsx(ost, { children: t })
  ] }),
  r
] }) }), cst = ({
  pauseOffer: e,
  handleClick: t
}) => {
  const { t: n } = tn(), r = Va();
  return /* @__PURE__ */ C.jsxs(da, { children: [
    /* @__PURE__ */ C.jsx(Aa, { children: n(
      "unsubscribe-popup.pause-title",
      "Would you like to pause your subscription instead?"
    ) }),
    /* @__PURE__ */ C.jsx(Cr, { children: n(
      "unsubscribe-popup.pause-question",
      "Need to step away? No problem."
    ) }),
    /* @__PURE__ */ C.jsx(Cr, { children: n(
      "unsubscribe-popup.pause-description",
      "Pause your subscription until the beginning of next season, you can resume at any time."
    ) }),
    /* @__PURE__ */ C.jsx(Oa, { $fillWrapper: !0, $customMargin: "80px 0 0", children: /* @__PURE__ */ C.jsx(
      zt,
      {
        theme: "confirm",
        onClickFn: () => r(
          Ed({
            type: "pauseSubscription",
            data: {
              offerData: Fe({}, e),
              isPartOfCancellationFlow: !0
            }
          })
        ),
        children: n("unsubscribe-popup.pause-button-text", "Pause my subscription")
      }
    ) }),
    /* @__PURE__ */ C.jsx(Cr, { children: n("unsubscribe-popup.still-cancel", "Still want to cancel?") }),
    /* @__PURE__ */ C.jsxs(Oa, { $removeMargin: !0, children: [
      /* @__PURE__ */ C.jsx(zt, { theme: "simple", onClickFn: () => r(Za()), children: n("unsubscribe-popup.back-button", "Back to My Account") }),
      /* @__PURE__ */ C.jsx(zt, { theme: "primary", onClickFn: t, children: n("unsubscribe-popup.unsubscribe-button-text", "Unsubscribe") })
    ] })
  ] });
}, dst = ({
  downgradesListFiltered: e,
  handleClick: t
}) => {
  var s;
  const { t: n } = tn(), r = Va(), { updateSubscription: a } = Ot(pbe), o = ((s = a == null ? void 0 : a.offerData) == null ? void 0 : s.offerId) || "";
  return /* @__PURE__ */ C.jsxs(da, { children: [
    /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(Aa, { children: n(
        "unsubscribe-popup.downgrade-instead",
        "How about a plan downgrade instead of cancellation?"
      ) }),
      /* @__PURE__ */ C.jsx(Cr, { children: n(
        "unsubscribe-popup.plans-proposal",
        "Here are the plans that might suit your needs:"
      ) })
    ] }),
    /* @__PURE__ */ C.jsx(lst, { children: e.map((c) => /* @__PURE__ */ C.jsx(
      ust,
      {
        onClick: () => r(
          Ed({
            type: "switchPlan",
            data: {
              offerData: Fe({}, c),
              isPartOfCancellationFlow: !0
            }
          })
        ),
        children: /* @__PURE__ */ C.jsx(
          lR,
          {
            toOfferId: c.toOfferId,
            baseOfferId: o
          }
        )
      },
      c.toOfferId
    )) }),
    /* @__PURE__ */ C.jsx(Cr, { children: n("unsubscribe-popup.still-cancel", "Still want to cancel?") }),
    /* @__PURE__ */ C.jsxs(Oa, { $removeMargin: !0, children: [
      /* @__PURE__ */ C.jsx(zt, { theme: "simple", onClickFn: () => r(Za()), children: n("unsubscribe-popup.back-button", "Back to My Account") }),
      /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: t, children: n("unsubscribe-popup.unsubscribe-button-text", "Unsubscribe") })
    ] })
  ] });
};
W(Uu)`
  border: 1px solid ${Gn};
  height: 100%;
  min-height: 500px;
  display: flex;
  ${pr.small`
    display: flex;
    align-items: flex-start;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
  `};
`;
W.div`
  padding: 30px 10px;
  margin: auto;
`;
const fst = W.ul`
  margin: 30px 0;
  list-style: none;
`, pst = W.li`
  margin: 0 0 20px 0;
  color: ${Et};

  font-size: 13px;
`;
W.div`
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-color: #5cb85c;
  position: relative;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: 7em;
  height: 7em;
  transition: border 500ms ease-out;
  margin-bottom: 20px;
`;
W.strong`
  text-transform: uppercase;
`;
const hst = [
  {
    value: "Poor customer support",
    key: "unsubscribe-popup.cancellation.poor-customer-support"
  },
  {
    value: "Switch to a different service",
    key: "unsubscribe-popup.cancellation.service-switch"
  },
  {
    value: "Subscription is too expensive",
    key: "unsubscribe-popup.cancellation.too-expensive"
  },
  {
    value: "Video streaming issues",
    key: "unsubscribe-popup.cancellation.streaming-issues"
  },
  {
    value: "Not enough interesting content",
    key: "unsubscribe-popup.cancellation.not-interesting-content"
  },
  {
    value: "Service is hard to use",
    key: "unsubscribe-popup.cancellation.hard-to-use"
  },
  {
    value: "Content I like has ended",
    key: "unsubscribe-popup.cancellation.content-ended"
  }
];
var Ls = /* @__PURE__ */ ((e) => (e.FREE_EXTENSION = "FREE_EXTENSION", e.PAUSE = "PAUSE", e.DOWNGRADES = "DOWNGRADES", e.SURVEY = "SURVEY", e.CONFIRMATION = "CONFIRMATION", e))(Ls || {});
const mst = ({
  scheduledSwitch: e,
  customCancellationReasons: t,
  checkedReason: n,
  shouldShowDowngrades: r,
  shouldShowFreeExtension: a,
  setCurrentStep: o,
  handleCheckboxClick: s,
  handleUnsubscribe: c
}) => {
  var B;
  const u = Ot(jR), f = Va(), { offers: m } = Ot(J6), { loading: v } = Ot(Eee), { t: y } = tn(), b = Ko(Number(u == null ? void 0 : u.expiresAt)), S = e(), x = () => {
    window.dispatchEvent(new CustomEvent("MSSDK:unsubscribe-action-cancelled")), f(Za());
  }, E = S !== !1 ? S.toOfferId : null, N = ((B = m.find(({ longId: G }) => G === E)) == null ? void 0 : B.title) || "", R = y(`offer-title-${E}`, N), O = y(
    `offer-title-${u == null ? void 0 : u.offerId}`,
    u ? u.offerTitle : ""
  ), D = t != null && t.length ? t : hst, $ = () => {
    if (a) {
      o(Ls.FREE_EXTENSION);
      return;
    }
    if (r) {
      o(Ls.DOWNGRADES);
      return;
    }
    x();
  };
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(da, { children: [
      /* @__PURE__ */ C.jsx(Aa, { children: y("unsubscribe-popup.survey-title", "We’re sorry to see you go") }),
      (u == null ? void 0 : u.period) === "season" ? /* @__PURE__ */ C.jsx(Cr, { children: y(
        "unsubscribe-popup.survey.access-info",
        "You will keep access to your seasonal subscription until {{formattedExpiresAt}}. Before you go, please let us know why you’re leaving.",
        {
          formattedExpiresAt: (u == null ? void 0 : u.expiresAt) === xc ? y(
            "unsubscribe-popup.next-season-start",
            "the next season start"
          ) : Ko(u == null ? void 0 : u.expiresAt)
        }
      ) }) : /* @__PURE__ */ C.jsxs(Cr, { children: [
        e() ? y(
          "unsubscribe-popup.survey.switch-pending",
          "Your subscription switch is still pending. You will switch to {{scheduledSwitchTitle}} and be charged a new price.",
          { scheduledSwitchTitle: R }
        ) : /* @__PURE__ */ C.jsx(C.Fragment, { children: u != null && u.inTrial ? y(
          "unsubscribe-popup.survey.free-trial",
          "Your {{translatedTitle}} free trial will end on {{formattedExpiresAt}}.",
          { translatedTitle: O, formattedExpiresAt: b }
        ) : y(
          "unsubscribe-popup.survey.subscription-paid",
          "Your {{translatedTitle}} subscription is paid until {{formattedExpiresAt}}.",
          { translatedTitle: O, formattedExpiresAt: b }
        ) }),
        " ",
        /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "unsubscribe-popup.survey.info", children: [
          "If you would like to proceed with cancelling your subscription, please select ‘Unsubscribe’ below, and your subscription will be cancelled as of ",
          { formattedExpiresAt: b },
          ". Until then, you will continue to have access to all of your current subscription features. Before you go, please let us know why you're leaving."
        ] })
      ] }),
      D && /* @__PURE__ */ C.jsx(fst, { children: D.map(({ key: G, value: Z }) => /* @__PURE__ */ C.jsx(pst, { children: /* @__PURE__ */ C.jsx(
        kf,
        {
          id: G,
          isRadioButton: !0,
          onClickFn: () => s(Z),
          isChecked: Z === n,
          children: y(G, Z)
        }
      ) }, G)) })
    ] }),
    /* @__PURE__ */ C.jsxs(Oa, { $removeMargin: !0, children: [
      /* @__PURE__ */ C.jsx(zt, { theme: "simple", onClickFn: $, children: y("unsubscribe-popup.survey.go-back", "Go back") }),
      /* @__PURE__ */ C.jsx(
        zt,
        {
          theme: "confirm",
          onClickFn: c,
          disabled: n === "" || v,
          children: v && /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) || y("unsubscribe-popup.survey.unsubscribe", "Unsubscribe")
        }
      )
    ] })
  ] });
}, vst = () => {
  const e = Ot(jR), { t } = tn(), n = Va();
  return /* @__PURE__ */ C.jsxs(da, { children: [
    /* @__PURE__ */ C.jsx("img", { src: nh, alt: "checkmark icon" }),
    /* @__PURE__ */ C.jsx(Aa, { children: t("unsubscribe-popup.success.title", "Miss you already.") }),
    /* @__PURE__ */ C.jsxs(Cr, { children: [
      t(
        "unsubscribe-popup.success.description",
        "You have been successfully unsubscribed. Your current plan will expire on"
      ),
      " ",
      /* @__PURE__ */ C.jsx("b", { children: (e == null ? void 0 : e.expiresAt) === xc ? t("unsubscribe-popup.next-season-start", "the next season start") : Ko(Number(e == null ? void 0 : e.expiresAt)) }),
      "."
    ] }),
    /* @__PURE__ */ C.jsx(
      zt,
      {
        width: "auto",
        margin: "30px auto 0 auto",
        onClickFn: () => {
          n(Za()), n(Pd());
        },
        children: t("unsubscribe-popup.back-button", "Back to My Account")
      }
    )
  ] });
}, Xq = W(th)`
  flex: 0 0 70px;
  max-width: 70px;
  height: 70px;

  margin: 0 20px;
  padding: 0;

  line-height: 70px;
  font-size: 30px;
  ${(e) => e.gray && ot`
      filter: grayscale(80%);
    `}
`, t_ = W.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  padding-top: 10px;
  margin: 20px auto 40px auto;
`, gst = W.span`
  width: 13px;
  height: 13px;

  border-top: 2px solid ${Gn};
  border-right: 2px solid ${Gn};

  transform: translateX(-25%) rotate(45deg);

  ${h1() && ot`
    transform: translateX(-25%) rotate(225deg);
  `}
`, Oue = W.img``, yst = () => {
  const e = Va(), { t } = tn();
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(da, { children: [
      /* @__PURE__ */ C.jsx(t_, { children: /* @__PURE__ */ C.jsx(X0, {}) }),
      /* @__PURE__ */ C.jsx(Aa, { children: t("free-extension.error.title", "An error occurred.") }),
      /* @__PURE__ */ C.jsx(Cr, { children: t(
        "free-extension.error.description",
        "We have been unable to extend your plan as an error occurred. Sorry for the inconvenience, please try again."
      ) })
    ] }),
    /* @__PURE__ */ C.jsx(Oa, { children: /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: () => e(Za()), children: t("free-extension.error.back-button", "Back to My Account") }) })
  ] });
}, bst = () => {
  const e = Va(), { t } = tn();
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(da, { children: [
      /* @__PURE__ */ C.jsx(t_, { children: /* @__PURE__ */ C.jsx(Oue, { src: nh, alt: "checkmark icon" }) }),
      /* @__PURE__ */ C.jsx(Aa, { children: t("free-extension.success.header", "Thank You!") }),
      /* @__PURE__ */ C.jsx(Cr, { children: t(
        "free-extension.success.description",
        "You have successfully extended your plan"
      ) })
    ] }),
    /* @__PURE__ */ C.jsx(Oa, { children: /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: () => e(Za()), children: t("free-extension.success.back-button", "Back to My Account") }) })
  ] });
}, _st = W.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .msd__popup-content__buttons {
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    > button {
      max-width: 222px;
      width: 100%;

      &:last-child {
        font-weight: 300;
        color: ${Et};
        opacity: 0.8;
        text-decoration: underline;
      }
    }
  }
`, Cst = W.div`
  max-width: 302px;
`, wst = W.div`
  display: flex;
  justify-content: center;

  > button {
    max-width: 200px;
  }
`, Sst = W.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  gap: 16px;

  width: 248px;
  height: 224px;
  margin-top: 8px;
  margin-bottom: 52px;

  border: 1px solid #d8ddea;
  border-radius: 6px;
  background-color: ${Br};

  > div {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  p {
    margin: 0;
  }
`, xst = W.p`
  font-size: 30px;
  font-weight: 600;
`, Est = ({
  handleUnsubscribe: e,
  setIsFreeExtensionSecondStep: t
}) => {
  const { t: n } = tn(), r = Va(), [a, o] = mt(!1), [s, c] = mt(!1), { isApplyLoading: u } = Ot(wee), {
    extensionDetails: { periodUnit: f, amount: m },
    offerId: v
  } = Ot(Sbe), y = () => st(void 0, null, function* () {
    yield r(Ux(v)).unwrap().catch(() => {
      o(!0), t(!0);
    }), c(!0), t(!0);
  }), b = () => m > 1 ? /* @__PURE__ */ C.jsx(C.Fragment, { children: `${m} ${n(
    `free-extension.period.${f}s`,
    "{{periodUnit}}s",
    {
      periodUnit: f
    }
  )}` }) : /* @__PURE__ */ C.jsx(C.Fragment, { children: `${m} ${n(
    `free-extension.period.${f}`,
    "{{periodUnit}}",
    {
      periodUnit: f
    }
  )}` });
  return a ? /* @__PURE__ */ C.jsx(yst, {}) : s ? /* @__PURE__ */ C.jsx(bst, {}) : /* @__PURE__ */ C.jsx(da, { children: /* @__PURE__ */ C.jsxs(_st, { children: [
    /* @__PURE__ */ C.jsxs(Cst, { children: [
      /* @__PURE__ */ C.jsx(Aa, { children: n(
        "free-extension.title",
        "How about a special offer just for you?"
      ) }),
      /* @__PURE__ */ C.jsx(Cr, { children: n(
        "free-extension.secondary-text",
        "No words can express how much we will miss you so we figured that we'll let this offer speak for itself."
      ) })
    ] }),
    /* @__PURE__ */ C.jsxs(Sst, { children: [
      /* @__PURE__ */ C.jsxs("div", { children: [
        /* @__PURE__ */ C.jsx(Cr, { id: "free-extension-card-title", children: n("free-extension.card-title", "FREE EXTENSION") }),
        /* @__PURE__ */ C.jsx(xst, { id: "free-extension-period", children: b() })
      ] }),
      /* @__PURE__ */ C.jsx(wst, { children: /* @__PURE__ */ C.jsx(
        zt,
        {
          theme: "confirm",
          size: "normal",
          onClickFn: y,
          children: u ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : n("free-extension.accept-button", "I accept the offer")
        }
      ) })
    ] }),
    /* @__PURE__ */ C.jsxs(Oa, { $removeMargin: !0, children: [
      /* @__PURE__ */ C.jsx(zt, { theme: "simple", onClickFn: () => r(Za()), children: n("free-extension.back-button", "Back to My Account") }),
      /* @__PURE__ */ C.jsx(_2, { as: "button", onClick: e, children: n(
        "free-extension.unsubscribe-button",
        "I want to unsubscribe anyway"
      ) })
    ] })
  ] }) });
}, Ist = ({
  customCancellationReasons: e,
  skipAvailableDowngradesStep: t,
  skipAvailableFreeExtensionStep: n
}) => {
  const r = [Ls.SURVEY, Ls.CONFIRMATION], [a, o] = mt(
    []
  ), [s, c] = mt(""), [u, f] = mt(!1), [m, v] = mt([]), { pauseOffersIDs: y } = Ot(J6), { data: b } = Ot(cee), { data: S } = Ot(dee), x = Ot(jR), { error: E } = Ot(Eee), { retentionActions: N } = Ot(wee), { t: R } = tn(), O = Va(), D = () => Object.keys(b).length && x ? [...b[x == null ? void 0 : x.offerId].available].filter((X) => X.switchDirection === "downgrade").sort((X, ye) => ye.price - X.price) : [], $ = () => x != null && x.pendingSwitchId ? S[x.pendingSwitchId] : !1, B = D(), G = () => {
    if (t) return !1;
    const xe = $();
    if (xe && xe.direction === "downgrade" && (x != null && x.pendingSwitchId))
      return !1;
    const {
      downgradeDetails: { offers: X }
    } = N;
    return !(x != null && x.inTrial) && X.length ? !!X.filter(
      ({ toOfferId: ce }) => !y.includes(ce)
    ).length : !1;
  }, Z = () => B.length ? !!B.filter(
    ({ toOfferId: X }) => y.includes(X)
  ).length : !1, K = (N == null ? void 0 : N.type) === "FREE_EXTENSION" && !n, q = (N == null ? void 0 : N.type) === "DOWNGRADE" && G(), pe = (N == null ? void 0 : N.type) === "PAUSE" && Z(), [he, _e] = mt(null), ge = a == null ? void 0 : a.filter(
    ({ toOfferId: xe }) => y.includes(xe)
  );
  mn(() => {
    const xe = r.slice();
    q && !xe.includes(Ls.DOWNGRADES) && xe.unshift(Ls.DOWNGRADES), pe && !xe.includes(Ls.PAUSE) && xe.unshift(Ls.PAUSE), K && !xe.includes(Ls.FREE_EXTENSION) && xe.unshift(Ls.FREE_EXTENSION), xe.length !== m.length && v(xe), a.length || o(() => D());
  }, []), mn(() => {
    _e(m[0]);
  }, [m]);
  const Y = a == null ? void 0 : a.filter(
    ({ toOfferId: xe }) => !y.includes(xe)
  ), ee = x != null && x.offerId ? y.includes(x == null ? void 0 : x.offerId) : !1;
  if (!m || !he) return /* @__PURE__ */ C.jsx(C.Fragment, {});
  const oe = () => _e(m[m.indexOf(he) + 1]), me = () => st(void 0, null, function* () {
    ur(Fye, {
      detail: {
        offerId: x == null ? void 0 : x.offerId,
        cancellationReason: s
      }
    }), yield O(
      zx({
        offerId: x == null ? void 0 : x.offerId,
        checkedReason: s,
        isPauseActive: ee
      })
    ), _e(Ls.CONFIRMATION);
  });
  return /* @__PURE__ */ C.jsxs(
    Oo,
    {
      steps: u ? 2 : m.length,
      popupTitle: R("unsubscribe-popup.title", "Manage your plan"),
      isError: !!E,
      currentStep: u ? 2 : m.indexOf(he) + 1,
      children: [
        he === Ls.FREE_EXTENSION && /* @__PURE__ */ C.jsx(
          Est,
          {
            handleUnsubscribe: oe,
            setIsFreeExtensionSecondStep: f
          }
        ),
        he === Ls.PAUSE && /* @__PURE__ */ C.jsx(cst, { pauseOffer: ge[0], handleClick: oe }),
        he === Ls.DOWNGRADES && /* @__PURE__ */ C.jsx(
          dst,
          {
            downgradesListFiltered: Y,
            handleClick: oe
          }
        ),
        he === Ls.SURVEY && /* @__PURE__ */ C.jsx(
          mst,
          {
            customCancellationReasons: e,
            checkedReason: s,
            shouldShowDowngrades: q,
            shouldShowFreeExtension: K,
            handleCheckboxClick: c,
            setCurrentStep: _e,
            scheduledSwitch: $,
            handleUnsubscribe: me
          }
        ),
        he === Ls.CONFIRMATION && /* @__PURE__ */ C.jsx(vst, {})
      ]
    }
  );
}, kst = () => {
  const [e, t] = mt(!1), [n, r] = mt(!1), [a, o] = mt(1), {
    updateSubscription: { offerData: s }
  } = wr((E) => E.popupManager), c = Jo(), { t: u } = tn(), { expiresAt: f, nextPaymentPrice: m, nextPaymentCurrency: v } = s, y = Ta[v], b = br(m), S = () => st(void 0, null, function* () {
    window.dispatchEvent(
      new CustomEvent("MSSDK:resume-action-confirmed", {
        detail: {
          offerId: s.offerId
        }
      })
    );
    try {
      t(!0), (yield xee({
        offerId: s.offerId,
        status: "active"
      })).errors.length ? (t(!1), r(!0)) : (t(!1), o(2));
    } catch (E) {
      r(!0), t(!1);
    }
  }), x = () => {
    window.dispatchEvent(new CustomEvent("MSSDK:resume-action-cancelled")), c(Za());
  };
  return /* @__PURE__ */ C.jsx(
    Oo,
    {
      steps: 2,
      popupTitle: u("resubscribe-popup.title", "Manage your plan"),
      isError: n,
      currentStep: a,
      children: a === 1 ? /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
        /* @__PURE__ */ C.jsxs(da, { children: [
          /* @__PURE__ */ C.jsx(Aa, { children: u("resubscribe-popup.resume-plan", "Resume your plan") }),
          /* @__PURE__ */ C.jsxs(Cr, { children: [
            u(
              "resubscribe-popup.resume-plan-button-info",
              "By clicking the button below you can resume your plan. Your next bill will be on"
            ),
            " ",
            /* @__PURE__ */ C.jsxs("b", { children: [
              f === xc ? u(
                "resubscribe-popup.next-season-start",
                "the next season start"
              ) : Ko(f),
              " "
            ] }),
            u("resubscribe-popup.it-will-be", "and it will be"),
            " ",
            /* @__PURE__ */ C.jsx("b", { children: `${y}${b}` }),
            "."
          ] })
        ] }),
        /* @__PURE__ */ C.jsxs(Oa, { children: [
          /* @__PURE__ */ C.jsx(zt, { theme: "simple", onClickFn: () => x(), children: u("resubscribe-popup.no-thanks", "No, thanks") }),
          /* @__PURE__ */ C.jsx(
            zt,
            {
              theme: "confirm",
              onClickFn: S,
              disabled: e,
              children: e && /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) || u("resubscribe-popup.resume", "Resume")
            }
          )
        ] })
      ] }) : /* @__PURE__ */ C.jsxs(da, { children: [
        /* @__PURE__ */ C.jsx("img", { src: nh, alt: "checkmark icon" }),
        /* @__PURE__ */ C.jsx(Aa, { children: u("resubscribe-popup.success.title", "Your plan has been renewed") }),
        /* @__PURE__ */ C.jsxs(Cr, { children: [
          u(
            "resubscribe-popup.success.description",
            "You have been successfully resubscribed. Your fee will be"
          ),
          " ",
          /* @__PURE__ */ C.jsx("b", { children: `${y}${b}` }),
          " ",
          u("resubscribe-popup.started-from", "started from"),
          " ",
          /* @__PURE__ */ C.jsxs("b", { children: [
            f === xc ? u(
              "resubscribe-popup.next-season-start",
              "the next season start"
            ) : Ko(f),
            "."
          ] })
        ] }),
        /* @__PURE__ */ C.jsx(
          zt,
          {
            width: "auto",
            margin: "30px auto 0 auto",
            onClickFn: () => {
              c(Za()), c(Pd());
            },
            children: u("resubscribe-popup.back-button", "Back to My Account")
          }
        )
      ] })
    }
  );
}, qD = ({
  customCancellationReasons: e,
  skipAvailableDowngradesStep: t,
  skipAvailableFreeExtensionStep: n
}) => {
  const {
    updateSubscription: { action: r }
  } = wr((a) => a.popupManager);
  return r === "unsubscribe" ? /* @__PURE__ */ C.jsx(
    Ist,
    {
      customCancellationReasons: e,
      skipAvailableDowngradesStep: t,
      skipAvailableFreeExtensionStep: n
    }
  ) : r === "resubscribe" ? /* @__PURE__ */ C.jsx(kst, {}) : /* @__PURE__ */ C.jsx(C.Fragment, {});
};
qD.propTypes = {
  customCancellationReasons: de.arrayOf(
    de.shape({
      key: de.string.isRequired,
      value: de.string.isRequired
    })
  ),
  skipAvailableDowngradesStep: de.bool,
  skipAvailableFreeExtensionStep: de.bool
};
qD.defaultProps = {
  customCancellationReasons: null,
  skipAvailableDowngradesStep: !1,
  skipAvailableFreeExtensionStep: !1
};
const JD = ({ onCancel: e, onSwitchSuccess: t, onSwitchError: n }) => {
  const r = {
    SWITCH_DETAILS: "SWITCH_DETAILS",
    CONFIRMATION: "CONFIRMATION"
  }, a = {
    SWITCH_DETAILS: 1,
    CONFIRMATION: 2
  }, [o, s] = mt(r.SWITCH_DETAILS), [c, u] = mt(!1), [f, m] = mt(!1), { offerToSwitch: v } = wr((O) => O.plan), {
    isLoading: y,
    switchPlan: { offerData: b, isPartOfCancellationFlow: S }
  } = wr((O) => O.popupManager), x = Jo(), { t: E } = tn(), N = () => st(void 0, null, function* () {
    u(!0);
    try {
      const O = yield DR(
        v.offerId,
        b.toOfferId,
        b.switchDirection
      );
      O.errors.length ? (window.dispatchEvent(
        new CustomEvent("MSSDK:switch-popup-action-failed", {
          detail: { reason: O.errors[0] }
        })
      ), m(!0), u(!1)) : (ur(OR, {
        fromOfferId: v.offerId,
        toOfferId: b.toOfferId,
        switchDirection: b.switchDirection,
        algorithm: b.algorithm,
        subscriptionSwitchId: O.responseData.id,
        subscriptionId: v.subscriptionId
      }), u(!1), s(r.CONFIRMATION));
    } catch (O) {
      window.dispatchEvent(new CustomEvent("MSSDK:switch-popup-action-failed")), m(!0), u(!1);
    }
  }), R = () => {
    x(Za()), x(Pd());
  };
  return y ? /* @__PURE__ */ C.jsx(
    Oo,
    {
      steps: 2,
      popupTitle: E(
        `switchplan-popup.change-plan.${b.switchDirection}`,
        `${b.switchDirection} Plan`
      ),
      currentStep: 1,
      children: /* @__PURE__ */ C.jsx(
        Zn,
        {
          showChildren: !1,
          height: 200,
          width: 450,
          margin: "auto"
        }
      )
    }
  ) : /* @__PURE__ */ C.jsxs(
    Oo,
    {
      steps: S ? 3 : 2,
      popupTitle: E(
        `switchplan-popup.change-plan.${b.switchDirection}`,
        `${b.switchDirection} Plan`
      ),
      currentStep: S ? a[o] + 1 : a[o],
      children: [
        o === r.SWITCH_DETAILS && !f && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsxs(t_, { children: [
              /* @__PURE__ */ C.jsx(
                Xq,
                {
                  period: v.period,
                  showLabel: "Current",
                  gray: !0
                }
              ),
              /* @__PURE__ */ C.jsx(gst, {}),
              /* @__PURE__ */ C.jsx(Xq, { period: b.period, showLabel: "New" })
            ] }),
            /* @__PURE__ */ C.jsx(Aa, { $step: o, $textTransform: "capitalize", children: E(
              `switchplan-popup.${b.switchDirection}-title`,
              `${b.switchDirection} your plan`
            ) }),
            /* @__PURE__ */ C.jsxs(Cr, { step: o, children: [
              /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "switchplan-popup-info", children: [
                "You are about to change your plan from",
                " ",
                /* @__PURE__ */ C.jsx("strong", { children: {
                  fromOfferTitle: E(
                    `offer-title-${v.offerId}`,
                    v.offerTitle
                  )
                } }),
                " ",
                "to",
                " ",
                /* @__PURE__ */ C.jsx("strong", { children: {
                  toOfferTitle: E(
                    `offer-title-${b.toOfferId}`,
                    b.title
                  )
                } }),
                "."
              ] }),
              " ",
              b.algorithm === "IMMEDIATE_WITHOUT_PRORATION" && /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "switchplan-popup-info-immediatewithoutproration", children: [
                "You will be immediately granted access to your selected plan and charged a new price",
                " ",
                /* @__PURE__ */ C.jsxs("strong", { children: [
                  {
                    currencySymbol: Ta[b.nextPaymentPriceCurrency]
                  },
                  {
                    currentPrice: mc(b.toOfferId) ? br(b.price) : br(b.nextPaymentPrice)
                  }
                ] }),
                " ",
                "on your next billing date",
                " ",
                /* @__PURE__ */ C.jsx("strong", { children: {
                  expiresAt: v.expiresAt === xc ? E(
                    "switchplan-popup.when-next-season-start",
                    "when the next season start"
                  ) : Ko(v.expiresAt)
                } })
              ] }),
              b.algorithm === "IMMEDIATE_AND_CHARGE_WITH_REFUND" && /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "switchplan-popup-info-immediateandchargewithrefund", children: [
                "You will be charged",
                " ",
                /* @__PURE__ */ C.jsxs("strong", { children: [
                  {
                    currencySymbol: Ta[b.nextPaymentPriceCurrency]
                  },
                  {
                    currentPrice: mc(b.toOfferId) ? br(b.price) : br(b.nextPaymentPrice)
                  }
                ] }),
                " ",
                "and immediately granted access to your selected plan. The remaining value from the previous subscription will be refunded. You will continue to be charged",
                " ",
                /* @__PURE__ */ C.jsxs("strong", { children: [
                  {
                    currencySymbol: Ta[b.nextPaymentPriceCurrency]
                  },
                  {
                    nextPaymentPrice: br(b.nextPaymentPrice)
                  }
                ] }),
                " ",
                "on a recurring basis until you cancel."
              ] }),
              b.algorithm === "IMMEDIATE_AND_CHARGE_WITH_FULL_REFUND" && /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "switchplan-popup-info-immediateandchargewithfullrefund", children: [
                "You will be charged",
                " ",
                /* @__PURE__ */ C.jsxs("strong", { children: [
                  {
                    currencySymbol: Ta[b.nextPaymentPriceCurrency]
                  },
                  {
                    currentPrice: mc(b.toOfferId) ? br(b.price) : br(b.nextPaymentPrice)
                  }
                ] }),
                ". You will also be fully refunded for your previous subscription. You will continue to be charged",
                " ",
                /* @__PURE__ */ C.jsxs("strong", { children: [
                  {
                    currencySymbol: Ta[b.nextPaymentPriceCurrency]
                  },
                  {
                    nextPaymentPrice: br(b.nextPaymentPrice)
                  }
                ] }),
                " ",
                "on a recurring basis until you cancel."
              ] }),
              b.algorithm === "DEFERRED" && /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "switchplan-popup-info-deferred", children: [
                "You will continue to have access to",
                " ",
                /* @__PURE__ */ C.jsx("strong", { children: {
                  currentPlan: E(
                    `offer-title-${v.offerId}`,
                    v.offerTitle
                  )
                } }),
                " ",
                "until",
                " ",
                /* @__PURE__ */ C.jsx("strong", { children: {
                  expiresAt: v.expiresAt === xc ? E(
                    "switchplan-popup.next-season-start",
                    "the next season start"
                  ) : Ko(v.expiresAt)
                } }),
                ". From that time you will be charged",
                " ",
                /* @__PURE__ */ C.jsxs("strong", { children: [
                  {
                    currencySymbol: Ta[b.nextPaymentPriceCurrency]
                  },
                  {
                    nextPaymentPrice: br(b.nextPaymentPrice)
                  }
                ] }),
                " ",
                "on a recurring basis for your new subscription."
              ] }),
              b.algorithm === "IMMEDIATE_AND_CHARGE_FULL_PRICE" && /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "switchplan-popup-info-immediateandchargefullprice", children: [
                "You will be charged",
                " ",
                /* @__PURE__ */ C.jsxs("strong", { children: [
                  {
                    currencySymbol: Ta[b.nextPaymentPriceCurrency]
                  },
                  {
                    currentPrice: mc(b.toOfferId) ? br(b.price) : br(b.nextPaymentPrice)
                  }
                ] }),
                " ",
                "and immediately granted access to the selected plan. You will continue to be charged",
                " ",
                /* @__PURE__ */ C.jsxs("strong", { children: [
                  {
                    currencySymbol: Ta[b.nextPaymentPriceCurrency]
                  },
                  {
                    nextPaymentPrice: br(b.nextPaymentPrice)
                  }
                ] }),
                " ",
                "on a recurring basis until you cancel."
              ] }),
              b.algorithm === "IMMEDIATE_AND_CHARGE_WITHOUT_PRORATION" && /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "switchplan-popup-info-immediateandchargewithoutproration", children: [
                "You will be charged",
                " ",
                /* @__PURE__ */ C.jsxs("strong", { children: [
                  {
                    currencySymbol: Ta[b.nextPaymentPriceCurrency]
                  },
                  {
                    currentPrice: mc(b.toOfferId) ? br(b.price) : br(b.nextPaymentPrice)
                  }
                ] }),
                " ",
                "and immediately granted access to the selected plan."
              ] }),
              b.algorithm === "IMMEDIATE_WITH_TIME_PRORATION" && /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "switchplan-popup-info-immediatewithtimeproration", children: [
                "You will be immediately granted access to your selected plan. Your next billing date will be changed and pushed towards, based on the time left on your previous subscription. From that time, you will be charged",
                " ",
                /* @__PURE__ */ C.jsxs("strong", { children: [
                  {
                    currencySymbol: Ta[b.nextPaymentPriceCurrency]
                  },
                  {
                    nextPaymentPrice: br(b.nextPaymentPrice)
                  }
                ] }),
                " ",
                "on a recurring basis."
              ] }),
              b.algorithm === "IMMEDIATE_AND_CHARGE_WITH_TIME_PRORATION" && /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "switchplan-popup-info-immediateandchargewithtimeproration", children: [
                "You will be immediately charged",
                " ",
                /* @__PURE__ */ C.jsxs("strong", { children: [
                  {
                    currencySymbol: Ta[b.nextPaymentPriceCurrency]
                  },
                  {
                    currentPrice: mc(b.toOfferId) ? br(b.price) : br(b.nextPaymentPrice)
                  }
                ] }),
                " ",
                "and granted access to the selected plan. Your next billing date will be changed and pushed towards, based on the time left on your previous subscription.",
                " "
              ] }),
              /* @__PURE__ */ C.jsx("br", {}),
              b.couponNotApplicable && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
                /* @__PURE__ */ C.jsx("br", {}),
                E(
                  "switchplan-popup.coupon-will-not-apply",
                  "Your current coupon will not apply to the new plan. If you have a coupon for your new plan, you can apply it after confirming your switch."
                ),
                /* @__PURE__ */ C.jsx("br", {})
              ] }),
              /* @__PURE__ */ C.jsx("br", {}),
              mc(b.toOfferId) && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
                /* @__PURE__ */ C.jsx("br", {}),
                E(
                  "switchplan-popup.price-without-taxes",
                  "Note, the presented price does not include taxes."
                ),
                /* @__PURE__ */ C.jsx("br", {})
              ] }),
              /* @__PURE__ */ C.jsx("br", {}),
              E(
                "switchplan-popup.apply-change-question",
                "Do you want to apply the change now?"
              )
            ] })
          ] }),
          /* @__PURE__ */ C.jsxs(Oa, { $removeMargin: !0, children: [
            /* @__PURE__ */ C.jsx(
              zt,
              {
                theme: "simple",
                onClickFn: () => {
                  S ? x(
                    Ed({
                      type: Nm.updateSubscription,
                      data: {
                        action: "unsubscribe",
                        offerData: Fe({}, v)
                      }
                    })
                  ) : e ? e() : (window.dispatchEvent(
                    new CustomEvent("MSSDK:switch-popup-action-cancelled", {
                      detail: {
                        fromOfferId: v.offerId,
                        toOfferId: b.toOfferId,
                        switchDirection: b.switchDirection,
                        algorithm: b.algorithm
                      }
                    })
                  ), x(Za()));
                },
                children: E("switchplan-popup.resign-button", "Keep Current Plan")
              }
            ),
            /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: N, children: c ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : E(
              `switchplan-popup.confirm-button.${b.switchDirection}`,
              `${b.switchDirection} Plan`
            ) })
          ] })
        ] }),
        o === r.CONFIRMATION && !f && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsx(t_, { children: /* @__PURE__ */ C.jsx(Oue, { src: nh, alt: "checkmark icon" }) }),
            /* @__PURE__ */ C.jsx(Aa, { $step: o, children: E("switchplan-popup.success.header", "Thank You!") }),
            /* @__PURE__ */ C.jsxs(Cr, { $step: o, children: [
              b.algorithm === "IMMEDIATE_WITHOUT_PRORATION" && /* @__PURE__ */ C.jsxs(
                Ia,
                {
                  i18nKey: `switchplan-popup-confirm-immediatewithoutproration.${b.switchDirection}`,
                  children: [
                    "You have successfully ",
                    b.switchDirection,
                    "d your plan to",
                    " ",
                    /* @__PURE__ */ C.jsx("strong", { children: {
                      newPlan: E(
                        `offer-title-${b.toOfferId}`,
                        b.title
                      )
                    } }),
                    ". Your new fee will be",
                    " ",
                    /* @__PURE__ */ C.jsxs("strong", { children: [
                      {
                        currencySymbol: Ta[b.nextPaymentPriceCurrency]
                      },
                      {
                        nextPaymentPrice: br(b.nextPaymentPrice)
                      }
                    ] }),
                    " ",
                    "starting from",
                    " ",
                    /* @__PURE__ */ C.jsx("strong", { children: {
                      expiresAt: v.expiresAt === xc ? E(
                        "switchplan-popup.next-season-start",
                        "the next season start"
                      ) : Ko(v.expiresAt)
                    } }),
                    "."
                  ]
                }
              ),
              b.algorithm === "IMMEDIATE_AND_CHARGE_WITH_REFUND" && /* @__PURE__ */ C.jsxs(
                Ia,
                {
                  i18nKey: `switchplan-popup-confirm-immediateandchargewithrefund.${b.switchDirection}`,
                  children: [
                    "You have successfully ",
                    b.switchDirection,
                    "d your plan to",
                    " ",
                    /* @__PURE__ */ C.jsx("strong", { children: {
                      newPlan: E(
                        `offer-title-${b.toOfferId}`,
                        b.title
                      )
                    } }),
                    ". Your new fee is",
                    " ",
                    /* @__PURE__ */ C.jsxs("strong", { children: [
                      {
                        currencySymbol: Ta[b.nextPaymentPriceCurrency]
                      },
                      {
                        nextPaymentPrice: mc(
                          b.toOfferId
                        ) ? br(b.price) : br(b.nextPaymentPrice)
                      }
                    ] }),
                    " ",
                    "starting from now."
                  ]
                }
              ),
              b.algorithm === "DEFERRED" && /* @__PURE__ */ C.jsxs(
                Ia,
                {
                  i18nKey: `switchplan-popup-confirm-deferred-${b.switchDirection}`,
                  children: [
                    "You have successfully requested the ",
                    b.switchDirection,
                    " ",
                    "to",
                    " ",
                    /* @__PURE__ */ C.jsx("strong", { children: {
                      newPlan: E(
                        `offer-title-${b.toOfferId}`,
                        b.title
                      )
                    } }),
                    ". You will have access to your new plan on",
                    " ",
                    /* @__PURE__ */ C.jsx("strong", { children: {
                      expiresAt: v.expiresAt === xc ? E(
                        "switchplan-popup.next-season-start",
                        "the next season start"
                      ) : Ko(v.expiresAt)
                    } }),
                    " ",
                    "and be charged",
                    " ",
                    /* @__PURE__ */ C.jsxs("strong", { children: [
                      {
                        currencySymbol: Ta[b.nextPaymentPriceCurrency]
                      },
                      { nextPaymentPrice: b.nextPaymentPrice }
                    ] }),
                    "."
                  ]
                }
              ),
              b.algorithm === "IMMEDIATE_AND_CHARGE_FULL_PRICE" && /* @__PURE__ */ C.jsxs(
                Ia,
                {
                  i18nKey: `switchplan-popup-confirm-immediateandchargefullprice.${b.switchDirection}`,
                  children: [
                    "You have successfully ",
                    b.switchDirection,
                    "d your plan to",
                    " ",
                    /* @__PURE__ */ C.jsx("strong", { children: {
                      newPlan: E(
                        `offer-title-${b.toOfferId}`,
                        b.title
                      )
                    } }),
                    ". Your new fee will be",
                    " ",
                    /* @__PURE__ */ C.jsxs("strong", { children: [
                      {
                        currencySymbol: Ta[b.nextPaymentPriceCurrency]
                      },
                      {
                        nextPaymentPrice: mc(
                          b.toOfferId
                        ) ? br(b.price) : br(b.nextPaymentPrice)
                      }
                    ] }),
                    " ",
                    "starting from now."
                  ]
                }
              ),
              b.algorithm === "IMMEDIATE_AND_CHARGE_WITH_FULL_REFUND" && /* @__PURE__ */ C.jsxs(
                Ia,
                {
                  i18nKey: `switchplan-popup-confirm-immediateandchargewithfullrefund.${b.switchDirection}`,
                  children: [
                    "You have successfully ",
                    b.switchDirection,
                    "d your plan to",
                    " ",
                    /* @__PURE__ */ C.jsx("strong", { children: {
                      newPlan: E(
                        `offer-title-${b.toOfferId}`,
                        b.title
                      )
                    } }),
                    ". Your new fee will be",
                    " ",
                    /* @__PURE__ */ C.jsxs("strong", { children: [
                      {
                        currencySymbol: Ta[b.nextPaymentPriceCurrency]
                      },
                      {
                        nextPaymentPrice: mc(
                          b.toOfferId
                        ) ? br(b.price) : br(b.nextPaymentPrice)
                      }
                    ] }),
                    " ",
                    "starting from now."
                  ]
                }
              ),
              b.algorithm === "IMMEDIATE_AND_CHARGE_WITHOUT_PRORATION" && /* @__PURE__ */ C.jsxs(
                Ia,
                {
                  i18nKey: `switchplan-popup-confirm-immediateandchargewithoutproration.${b.switchDirection}`,
                  children: [
                    "You have successfully ",
                    b.switchDirection,
                    "d your plan to",
                    " ",
                    /* @__PURE__ */ C.jsx("strong", { children: {
                      newPlan: E(
                        `offer-title-${b.toOfferId}`,
                        b.title
                      )
                    } }),
                    ". Your new fee will be",
                    " ",
                    /* @__PURE__ */ C.jsxs("strong", { children: [
                      {
                        currencySymbol: Ta[b.nextPaymentPriceCurrency]
                      },
                      {
                        nextPaymentPrice: mc(
                          b.toOfferId
                        ) ? br(b.price) : br(b.nextPaymentPrice)
                      }
                    ] }),
                    " ",
                    "starting from now."
                  ]
                }
              ),
              b.algorithm === "IMMEDIATE_WITH_TIME_PRORATION" && /* @__PURE__ */ C.jsxs(
                Ia,
                {
                  i18nKey: `switchplan-popup-confirm-immediatewithtimeproration.${b.switchDirection}`,
                  children: [
                    "You have successfully ",
                    b.switchDirection,
                    "d your plan to",
                    " ",
                    /* @__PURE__ */ C.jsx("strong", { children: {
                      newPlan: E(
                        `offer-title-${b.toOfferId}`,
                        b.title
                      )
                    } }),
                    ". Your new fee will be",
                    " ",
                    /* @__PURE__ */ C.jsxs("strong", { children: [
                      {
                        currencySymbol: Ta[b.nextPaymentPriceCurrency]
                      },
                      { nextPaymentPrice: b.nextPaymentPrice }
                    ] }),
                    " ",
                    "and you will be charged on a recurring basis until you cancel."
                  ]
                }
              ),
              b.algorithm === "IMMEDIATE_AND_CHARGE_WITH_TIME_PRORATION" && /* @__PURE__ */ C.jsxs(
                Ia,
                {
                  i18nKey: `switchplan-popup-confirm-immediateandchargewithtimeproration.${b.switchDirection}`,
                  children: [
                    "You have successfully ",
                    b.switchDirection,
                    "d your plan to",
                    " ",
                    /* @__PURE__ */ C.jsx("strong", { children: {
                      newPlan: E(
                        `offer-title-${b.toOfferId}`,
                        b.title
                      )
                    } }),
                    ". Your new fee will be",
                    " ",
                    /* @__PURE__ */ C.jsxs("strong", { children: [
                      {
                        currencySymbol: Ta[b.nextPaymentPriceCurrency]
                      },
                      { nextPaymentPrice: b.nextPaymentPrice }
                    ] }),
                    " ",
                    "and you will be charged on a recurring basis until you cancel."
                  ]
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ C.jsx(Oa, { children: /* @__PURE__ */ C.jsx(
            zt,
            {
              theme: "confirm",
              onClickFn: t || R,
              children: E("switchplan-popup.back-button", "Back to My Account")
            }
          ) })
        ] }),
        f && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsx(t_, { children: /* @__PURE__ */ C.jsx(X0, {}) }),
            /* @__PURE__ */ C.jsx(Aa, { $step: o, children: E("switchplan-popup.error-title", "An error occurred.") }),
            /* @__PURE__ */ C.jsx(Cr, { step: o, children: E(
              "switchplan-popup.error-description",
              "We have been unable to change your plan to {{ title }} as an error occurred. Sorry for the inconvenience, please try again.",
              {
                title: b.title
              }
            ) })
          ] }),
          /* @__PURE__ */ C.jsx(Oa, { children: /* @__PURE__ */ C.jsx(
            zt,
            {
              theme: "confirm",
              onClickFn: n || R,
              children: E("switchplan-popup.back-button", "Back to My Account")
            }
          ) })
        ] })
      ]
    }
  );
};
JD.propTypes = {
  onCancel: de.func,
  onSwitchSuccess: de.func,
  onSwitchError: de.func
};
JD.defaultProps = {
  onCancel: null,
  onSwitchSuccess: null,
  onSwitchError: null
};
const Kq = W(th)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 70px;
  max-width: 70px;
  height: 70px;

  margin: 0 20px;
  padding: 0;

  line-height: 70px;
  font-size: 30px;

  span {
    background: ${An};
  }

  svg {
    height: 50px;
    width: 50px;
    path:first-of-type,
    path:last-of-type {
      fill: ${An};
    }
  }

  ${(e) => e.gray && ot`
      filter: grayscale(80%);
    `}
`, EN = W.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  padding-top: 10px;
  margin: 20px auto 40px auto;
`, Ast = W.span`
  width: 13px;
  height: 13px;

  border-top: 2px solid ${Gn};
  border-right: 2px solid ${Gn};

  transform: translateX(-25%) rotate(45deg);

  ${h1() && ot`
    transform: translateX(-25%) rotate(225deg);
  `}
`, Pst = W.img``, Nst = () => {
  const e = {
    PAUSE_DETAILS: "PAUSE_DETAILS",
    CONFIRMATION: "CONFIRMATION"
  }, t = {
    PAUSE_DETAILS: 1,
    CONFIRMATION: 2
  }, [n, r] = mt(e.PAUSE_DETAILS), [a, o] = mt(!1), [s, c] = mt(!1), { offerToSwitch: u } = wr((N) => N.plan), {
    isLoading: f,
    pauseSubscription: { offerData: m }
  } = wr((N) => N.popupManager), v = Jo(), { t: y } = tn(), b = () => st(void 0, null, function* () {
    o(!0);
    try {
      const N = yield DR(
        u.offerId,
        m.toOfferId,
        m.switchDirection
      );
      N.errors.length ? (ur(D7, {
        reason: N.errors[0]
      }), c(!0), o(!1)) : (ur(OR, {
        fromOfferId: u.offerId,
        toOfferId: m.toOfferId,
        switchDirection: m.switchDirection,
        algorithm: m.algorithm,
        subscriptionSwitchId: N.responseData.id,
        subscriptionId: u.subscriptionId
      }), o(!1), r(e.CONFIRMATION));
    } catch (N) {
      ur(D7), c(!0), o(!1);
    }
  }), S = () => {
    v(Za()), v(Pd());
  };
  if (f)
    return /* @__PURE__ */ C.jsx(
      Oo,
      {
        steps: 2,
        popupTitle: y("pausesubscription-popup.pausing-plan", "Pausing plan"),
        currentStep: 1,
        children: /* @__PURE__ */ C.jsx(
          Zn,
          {
            showChildren: !1,
            height: 200,
            width: 450,
            margin: "auto"
          }
        )
      }
    );
  if (s)
    return /* @__PURE__ */ C.jsx(
      Oo,
      {
        steps: 3,
        popupTitle: y("pausesubscription-popup.pausing-plan", "Pausing plan"),
        currentStep: t[n] + 1,
        children: /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsx(EN, { children: /* @__PURE__ */ C.jsx(X0, {}) }),
            /* @__PURE__ */ C.jsx(Aa, { $step: n, children: y("pausesubscription-popup.error-title", "An error occurred.") }),
            /* @__PURE__ */ C.jsx(Cr, { step: n, children: y(
              "pausesubscription-popup.error-description",
              "We have been unable to pause your plan as an error occurred. Sorry for the inconvenience, please try again."
            ) })
          ] }),
          /* @__PURE__ */ C.jsx(Oa, { children: /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: S, children: y("pausesubscription-popup.back-button", "Back to My Account") }) })
        ] })
      }
    );
  const x = Ko(u.expiresAt), { offerTitle: E } = u;
  return /* @__PURE__ */ C.jsxs(
    Oo,
    {
      steps: 3,
      popupTitle: y("pausesubscription-popup.pausing-plan", "Pausing plan"),
      currentStep: t[n] + 1,
      children: [
        n === e.PAUSE_DETAILS && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsxs(EN, { children: [
              /* @__PURE__ */ C.jsx(
                Kq,
                {
                  period: u.period,
                  showLabel: "Current",
                  gray: !0
                }
              ),
              /* @__PURE__ */ C.jsx(Ast, {}),
              /* @__PURE__ */ C.jsx(Kq, { isPaused: !0, showLabel: "Paused" })
            ] }),
            /* @__PURE__ */ C.jsx(Aa, { $step: n, $textTransform: "capitalize", children: y("pausesubscription-popup.details.title", "Subscription pause") }),
            /* @__PURE__ */ C.jsx(Cr, { children: /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "pausesubscription-popup.details.info", children: [
              "On your next billing cycle (",
              /* @__PURE__ */ C.jsx("strong", { children: { pauseStartingDate: x } }),
              ") your subscription pause will go into effect. While your subscription is paused, you won’t be charged for, and you won’t have access to,",
              " ",
              { offerTitle: E },
              ". You can resume your ",
              { offerTitle: E },
              " ",
              "subscription at any time."
            ] }) }),
            /* @__PURE__ */ C.jsx(Cr, { children: y(
              "pausesubscription-popup.details.note",
              "Or, if you don`t do anything, your subscription will automatically resume at the start of the next season. When your subscription resumes, you will be billed the current monthly subscription fee for your plan."
            ) }),
            /* @__PURE__ */ C.jsx(Cr, { step: n, children: y(
              "pausesubscription-popup.details.question",
              "Would you like to pause?"
            ) })
          ] }),
          /* @__PURE__ */ C.jsxs(Oa, { $removeMargin: !0, children: [
            /* @__PURE__ */ C.jsx(
              zt,
              {
                theme: "simple",
                onClickFn: () => {
                  v(
                    Ed({
                      type: Nm.updateSubscription,
                      data: {
                        action: "unsubscribe",
                        offerData: Fe({}, u)
                      }
                    })
                  );
                },
                children: y("pausesubscription-popup.details.back", "Back")
              }
            ),
            /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: b, children: a ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : y(
              "pausesubscription-popup.confirm-button",
              "Pause subscription"
            ) })
          ] })
        ] }),
        n === e.CONFIRMATION && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsx(EN, { children: /* @__PURE__ */ C.jsx(Pst, { src: nh, alt: "checkmark icon" }) }),
            /* @__PURE__ */ C.jsx(Aa, { $step: n, children: y(
              "pausesubscription-popup.confirmation.title",
              "Your pause request has been confirmed."
            ) }),
            /* @__PURE__ */ C.jsx(Cr, { $step: n, children: /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "pausesubscription-popup.confirmation.info", children: [
              "You will continue to have access to your subscription through your current billing cycle. The pause will go into effect on",
              " ",
              /* @__PURE__ */ C.jsx("strong", { children: { pauseStartingDate: x } })
            ] }) })
          ] }),
          /* @__PURE__ */ C.jsx(Oa, { children: /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: S, children: y("pausesubscription-popup.resign-button", "Back to My Account") }) })
        ] })
      ]
    }
  );
}, qq = W(th)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 70px;
  max-width: 70px;
  height: 70px;

  margin: 0 20px;
  padding: 0;

  line-height: 70px;
  font-size: 30px;

  span {
    background: ${An};
  }

  svg {
    height: 50px;
    width: 50px;
    path:first-of-type,
    path:last-of-type {
      fill: ${An};
    }
  }

  ${(e) => e.gray && ot`
      filter: grayscale(80%);
    `}
`, IN = W.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  padding-top: 10px;
  margin: 20px auto 40px auto;
`, Tst = W.span`
  width: 13px;
  height: 13px;

  border-top: 2px solid ${Gn};
  border-right: 2px solid ${Gn};

  transform: translateX(-25%) rotate(45deg);

  ${h1() && ot`
    transform: translateX(-25%) rotate(225deg);
  `}
`, Ost = W.img``, Rst = () => {
  const e = {
    RESUME_DETAILS: "RESUME_DETAILS",
    CONFIRMATION: "CONFIRMATION"
  }, t = {
    RESUME_DETAILS: 1,
    CONFIRMATION: 2
  }, { t: n } = tn(), [r, a] = mt(e.RESUME_DETAILS), [o, s] = mt(!1), [c, u] = mt(!1), { offerToSwitch: f } = wr((E) => E.plan), {
    isLoading: m,
    resumeSubscription: { offerData: v }
  } = wr((E) => E.popupManager), y = Jo(), b = () => st(void 0, null, function* () {
    s(!0);
    try {
      const E = yield DR(
        f.offerId,
        v.toOfferId,
        v.switchDirection
      );
      E.errors.length ? (ur(D7, {
        reason: E.errors[0]
      }), u(!0), s(!1)) : (ur(OR, {
        fromOfferId: f.offerId,
        toOfferId: v.toOfferId,
        switchDirection: v.switchDirection,
        algorithm: v.algorithm,
        subscriptionSwitchId: E.responseData.id,
        subscriptionId: f.subscriptionId
      }), s(!1), a(e.CONFIRMATION));
    } catch (E) {
      ur(D7), u(!0), s(!1);
    }
  }), S = () => {
    y(Za()), y(Pd());
  };
  if (m)
    return /* @__PURE__ */ C.jsx(
      Oo,
      {
        steps: 2,
        popupTitle: n("resumesubscription-popup.title", "Resume plan"),
        currentStep: 1,
        children: /* @__PURE__ */ C.jsx(
          Zn,
          {
            showChildren: !1,
            height: 200,
            width: 450,
            margin: "auto"
          }
        )
      }
    );
  if (c)
    return /* @__PURE__ */ C.jsx(
      Oo,
      {
        steps: 2,
        popupTitle: n("resumesubscription-popup.title", "Resume plan"),
        currentStep: t[r],
        children: /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsx(IN, { children: /* @__PURE__ */ C.jsx(X0, {}) }),
            /* @__PURE__ */ C.jsx(Aa, { $step: r, children: n("resumesubscription-popup.error-header", "An error occurred.") }),
            /* @__PURE__ */ C.jsx(Cr, { step: r, children: n(
              "resumesubscription-popup.error-text",
              "We have been unable to resume your plan as an error occurred. Sorry for the inconvenience, please try again."
            ) })
          ] }),
          /* @__PURE__ */ C.jsx(Oa, { children: /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: S, children: n(
            "resumesubscription-popup.error-back-button",
            "Back to My Account"
          ) }) })
        ] })
      }
    );
  const x = v == null ? void 0 : v.title;
  return /* @__PURE__ */ C.jsxs(
    Oo,
    {
      steps: 2,
      popupTitle: n("resumesubscription-popup.title", "Resume plan"),
      currentStep: t[r],
      children: [
        r === e.RESUME_DETAILS && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsxs(IN, { children: [
              /* @__PURE__ */ C.jsx(qq, { isPaused: !0, showLabel: "Paused", gray: !0 }),
              /* @__PURE__ */ C.jsx(Tst, {}),
              /* @__PURE__ */ C.jsx(qq, { period: v.period, showLabel: "New" })
            ] }),
            /* @__PURE__ */ C.jsx(Aa, { $step: r, $textTransform: "capitalize", children: n(
              "resumesubscription-popup.header",
              "Resume your {{ planName }} subscription",
              { planName: x }
            ) }),
            /* @__PURE__ */ C.jsx(Cr, { children: n(
              "resumesubscription-popup.info",
              " Click the button below to resume your {{ planName }} subscription.",
              { planName: x }
            ) }),
            /* @__PURE__ */ C.jsx(Cr, { step: r, children: n(
              "resumesubscription-popup.apply-change-question",
              "Do you want to apply the change now?"
            ) })
          ] }),
          /* @__PURE__ */ C.jsxs(Oa, { $removeMargin: !0, children: [
            /* @__PURE__ */ C.jsx(zt, { theme: "simple", onClickFn: S, children: n("resumesubscription-popup.back-button-text", "Continue Pause") }),
            /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: b, children: o ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : n(
              "resumesubscription-popup.confirm-button-text",
              "Resume subscription"
            ) })
          ] })
        ] }),
        r === e.CONFIRMATION && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsx(IN, { children: /* @__PURE__ */ C.jsx(Ost, { src: nh, alt: "checkmark icon" }) }),
            /* @__PURE__ */ C.jsx(Aa, { $step: r, children: n(
              "resumesubscription-popup.success-header",
              "Your {{ planName }} subscription has been resumed",
              { planName: x }
            ) }),
            /* @__PURE__ */ C.jsx(Cr, { $step: r, children: n(
              "resumesubscription-popup.success-text",
              "You can now access your {{ planName }} subscription.",
              { planName: x }
            ) })
          ] }),
          /* @__PURE__ */ C.jsx(Oa, { children: /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: S, children: n("resumesubscription-popup.back-button", "Back to My Account") }) })
        ] })
      ]
    }
  );
}, Mst = () => {
  const [e, t] = mt(!1), [n, r] = mt(!1), [a, o] = mt(1), { data: s } = wr(
    (B) => B.plan.switchDetails
  ), {
    cancelSwitch: {
      pendingSwitchId: c,
      switchDirection: u,
      switchOfferTitle: f,
      baseOfferTitle: m,
      baseOfferExpirationDate: v,
      baseOfferPrice: y
    }
  } = wr((B) => B.popupManager), b = s[c], S = {
    pendingSwitchId: c,
    fromOfferId: b && b.fromOfferId,
    toOfferId: b && b.toOfferId
  }, x = Jo(), [E, N] = mt({}), { t: R } = tn();
  mn(() => {
    b && N({
      fromOfferId: b && b.fromOfferId,
      toOfferId: b && b.toOfferId
    });
  }, [b]);
  const O = R(
    `offer-title-${E.fromOfferId}`,
    m
  ), D = R(
    `offer-title-${E.toOfferId}`,
    f
  ), $ = () => st(void 0, null, function* () {
    window.dispatchEvent(
      new CustomEvent("MSSDK:cancel-switch-action-triggered", {
        detail: S
      })
    ), t(!0);
    try {
      const B = yield qQ(c);
      B.errors.length ? (r(!0), t(!1), window.dispatchEvent(
        new CustomEvent("MSSDK:cancel-switch-action-failed", {
          detail: Xn(Fe({}, S), { reason: B.errors[0] })
        })
      )) : (t(!1), x(
        pee({ details: { pendingSwitchId: c }, type: "delete" })
      ), o(2), window.dispatchEvent(
        new CustomEvent("MSSDK:cancel-switch-action-successful", {
          detail: S
        })
      ));
    } catch (B) {
      r(!0), t(!1), window.dispatchEvent(
        new CustomEvent("MSSDK:cancel-switch-action-failed", {
          detail: S
        })
      );
    }
  });
  return /* @__PURE__ */ C.jsxs(
    Oo,
    {
      steps: 2,
      popupTitle: R(
        `cancelswitch-popup.title.${u}`,
        `Cancel ${u}`
      ),
      currentStep: a,
      isError: n,
      children: [
        a === 1 && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsx(Aa, { $textTransform: "capitalize", children: R(
              `cancelswitch-popup.title.${u}`,
              `Cancel ${u}`
            ) }),
            /* @__PURE__ */ C.jsxs(Cr, { children: [
              R(
                `cancelswitch-popup.pending.${u}`,
                "Your {{switchDirection}} to {{switchOfferTitle}} is still pending and will take effect on {{baseOfferExpirationDate}}. If you decide to cancel the {{switchDirection}}, you will keep access to current plan and be charged {{baseOfferPrice}} on the next billing date.",
                {
                  switchDirection: R(u, u),
                  switchOfferTitle: D,
                  baseOfferExpirationDate: v === xc ? R(
                    "cancelswitch-popup.next-season-start",
                    "the next season start"
                  ) : Ko(v),
                  baseOfferPrice: y
                }
              ),
              /* @__PURE__ */ C.jsx("br", {}),
              /* @__PURE__ */ C.jsx("br", {}),
              R(
                `cancelswitch-popup.question.${u}`,
                `Are you sure you want to cancel the ${u}?`
              )
            ] })
          ] }),
          /* @__PURE__ */ C.jsxs(Oa, { $removeMargin: !0, children: [
            /* @__PURE__ */ C.jsx(
              zt,
              {
                theme: "simple",
                onClickFn: () => {
                  window.dispatchEvent(
                    new CustomEvent("MSSDK:cancel-switch-action-cancelled", {
                      detail: S
                    })
                  ), x(Za());
                },
                children: R("cancelswitch-popup.resign", "No, thanks")
              }
            ),
            /* @__PURE__ */ C.jsx(zt, { theme: "danger", onClickFn: $, children: e ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : R(
              `cancelswitch-popup.confirm-button-text.${u}`,
              `Cancel ${u}`
            ) })
          ] })
        ] }),
        a === 2 && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsx("img", { src: nh, alt: "checkmark icon" }),
            /* @__PURE__ */ C.jsx(Aa, { $textTransform: "capitalize", children: R(
              `cancelswitch-popup.cancelled-title.${u}`,
              `${u} canceled`
            ) }),
            /* @__PURE__ */ C.jsx(Cr, { children: R(
              "cancelswitch-popup.switch-cancelled",
              "You have successfully canceled your {{switchDirection}} to {{switchOfferTitle}}. You will be charged a current price on {{baseOfferExpirationDate}} and keep access to {{baseOfferTitle}}.",
              {
                switchDirection: R(u, u),
                switchOfferTitle: D,
                baseOfferExpirationDate: v === xc ? R(
                  "cancelswitch-popup.next-season-start",
                  "the next season start"
                ) : Ko(v),
                baseOfferTitle: O
              }
            ) })
          ] }),
          /* @__PURE__ */ C.jsx(Oa, { $removeMargin: !0, children: /* @__PURE__ */ C.jsx(
            zt,
            {
              theme: "confirm",
              onClickFn: () => {
                x(Za()), x(Pd());
              },
              children: R("cancelswitch-popup.back-button", "Back to My Account")
            }
          ) })
        ] })
      ]
    }
  );
}, Dst = () => {
  const [e, t] = mt(!1), [n, r] = mt(!1), [a, o] = mt(1), { data: s } = wr(
    (E) => E.plan.switchDetails
  ), {
    cancelPause: {
      pendingSwitchId: c,
      baseOfferExpirationDate: u,
      baseOfferPrice: f,
      baseOfferTitle: m
    }
  } = wr((E) => E.popupManager), v = s[c], { t: y } = tn(), b = {
    pendingSwitchId: c,
    fromOfferId: v == null ? void 0 : v.fromOfferId,
    toOfferId: v == null ? void 0 : v.toOfferId
  }, S = Jo(), x = () => st(void 0, null, function* () {
    ur(Oye, b), t(!0);
    try {
      const { errors: E } = yield qQ(c);
      E.length ? (r(!0), t(!1), ur(PV, Xn(Fe({}, b), {
        reason: E[0]
      }))) : (t(!1), S(
        pee({ details: { pendingSwitchId: c }, type: "delete" })
      ), o(2), ur(Rye, b));
    } catch (E) {
      r(!0), t(!1), ur(PV, b);
    }
  });
  return /* @__PURE__ */ C.jsxs(
    Oo,
    {
      steps: 2,
      popupTitle: y("cancelpause-popup.title", "Cancel pause"),
      currentStep: a,
      isError: n,
      children: [
        a === 1 && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsx(Aa, { children: y("cancelpause-popup.title", "Cancel pause") }),
            /* @__PURE__ */ C.jsx(Cr, { children: y(
              "cancelpause-popup.information-text",
              "Your current plan will be paused starting on {{baseOfferExpirationDate}}. Cancel the pause to resume access to your {{ pausedOfferTitle }} subscription. While your subscription is paused, you won’t be charged for, and you won’t have access to, {{ pausedOfferTitle }}.",
              {
                baseOfferExpirationDate: Ko(u),
                baseOfferPrice: f,
                pausedOfferTitle: m
              }
            ) }),
            /* @__PURE__ */ C.jsx(Cr, { children: y(
              "cancelpause-popup.question-text",
              "Would you like to cancel the pause request?"
            ) })
          ] }),
          /* @__PURE__ */ C.jsxs(Oa, { $removeMargin: !0, children: [
            /* @__PURE__ */ C.jsx(
              zt,
              {
                theme: "simple",
                onClickFn: () => {
                  ur(
                    Mye,
                    b
                  ), S(Za());
                },
                children: y("cancelpause-popup.resign", "No, thanks")
              }
            ),
            /* @__PURE__ */ C.jsx(zt, { theme: "danger", onClickFn: x, children: e ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : y("cancelpause-popup.confirm-button-text", "Cancel pause") })
          ] })
        ] }),
        a === 2 && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsx("img", { src: nh, alt: "checkmark icon" }),
            /* @__PURE__ */ C.jsx(Aa, { children: y(
              "cancelpause-popup.confirmation-title",
              "Your pause request has been canceled."
            ) }),
            /* @__PURE__ */ C.jsx(Cr, { children: y(
              "cancelpause-popup.confirmation-text",
              "Your access to your {{ pausedOfferTitle }} subscription will continue.",
              {
                pausedOfferTitle: m
              }
            ) })
          ] }),
          /* @__PURE__ */ C.jsx(Oa, { $removeMargin: !0, children: /* @__PURE__ */ C.jsx(
            zt,
            {
              theme: "confirm",
              onClickFn: () => {
                S(Pd()), S(Za());
              },
              children: y("cancelpause-popup.back-button", "Back to My Account")
            }
          ) })
        ] })
      ]
    }
  );
}, QD = ({
  customCancellationReasons: e,
  skipAvailableDowngradesStep: t,
  skipAvailableFreeExtensionStep: n,
  onCancel: r,
  onSwitchSuccess: a,
  onSwitchError: o
}) => {
  const { isOpen: s, currentType: c } = Ot(N_);
  if (!s) return /* @__PURE__ */ C.jsx(C.Fragment, {});
  switch (c) {
    case su.UPDATE_SUBSCRIPTION_POPUP:
      return /* @__PURE__ */ C.jsx(
        qD,
        {
          customCancellationReasons: e,
          skipAvailableDowngradesStep: t,
          skipAvailableFreeExtensionStep: n
        }
      );
    case su.SWITCH_PLAN_POPUP:
      return /* @__PURE__ */ C.jsx(
        JD,
        {
          onCancel: r,
          onSwitchSuccess: a,
          onSwitchError: o
        }
      );
    case su.PAUSE_SUBSCRIPTION_POPUP:
      return /* @__PURE__ */ C.jsx(Nst, {});
    case su.RESUME_SUBSCRIPTION_POPUP:
      return /* @__PURE__ */ C.jsx(Rst, {});
    case su.CANCEL_SWITCH_POPUP:
      return /* @__PURE__ */ C.jsx(Mst, {});
    case su.CANCEL_PAUSE_POPUP:
      return /* @__PURE__ */ C.jsx(Dst, {});
    default:
      return /* @__PURE__ */ C.jsx(C.Fragment, {});
  }
}, Lst = W.div`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  background: ${Br};
`, $st = ({
  customCancellationReasons: e,
  skipAvailableDowngradesStep: t,
  skipAvailableFreeExtensionStep: n,
  displayGracePeriodError: r
}) => {
  const { data: a } = Ot($R), {
    offerToSwitch: { offerId: o }
  } = Ot(DV), { updateList: s } = Ot(DV), { isOpen: c } = Ot(N_), { offers: u } = Ot((N) => N.offers), { pauseOffersIDs: f } = Ot((N) => N.offers), { t: m } = tn(), v = Yo(!1), y = Va(), b = (N) => st(void 0, null, function* () {
    N.length > 1 && y(fee()), y(Xy(N));
  }), S = () => st(void 0, null, function* () {
    const R = (yield y(L0()).unwrap()).filter(
      (D) => D.status === "active" && D.offerType === "S"
    ), O = R.filter(
      (D) => D.pendingSwitchId
    );
    y(Yy(O)), R.length === 1 && y(P_(R[0])), R.length > 0 && b(R);
  });
  mn(() => {
    a.length === 0 && S(), r !== null && y(
      $u({
        displayGracePeriodError: r
      })
    ), u.length === 0 && y(Wy()), c && (y(Za()), y(Pd()));
  }, []), mn(() => {
    v.current ? S() : v.current = !0;
  }, [s]);
  const x = a.filter(
    (N) => N.status === "active" && N.offerType === "S"
  ), E = f.includes(o);
  return c ? /* @__PURE__ */ C.jsx(
    QD,
    {
      customCancellationReasons: e,
      skipAvailableDowngradesStep: t,
      skipAvailableFreeExtensionStep: n
    }
  ) : /* @__PURE__ */ C.jsxs(Lst, { children: [
    /* @__PURE__ */ C.jsx(R6, {}),
    /* @__PURE__ */ C.jsx(Xi, { children: /* @__PURE__ */ C.jsx(C.Fragment, { children: m("plandetails.current-plan", "Current Plan") }) }),
    /* @__PURE__ */ C.jsx(kue, {}),
    x.length !== 0 && !E && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(Xi, { children: /* @__PURE__ */ C.jsx(C.Fragment, { children: m("plandetails.change-plan", "Change Plan") }) }),
      /* @__PURE__ */ C.jsx(Tue, {})
    ] })
  ] });
}, jst = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ width: 38, height: 38, xmlns: "http://www.w3.org/2000/svg", "data-name": "Component 10 \\u2013 1", color: "red" }, e), /* @__PURE__ */ k.createElement("g", { id: "Layer_1" }, /* @__PURE__ */ k.createElement("title", null, "Layer 1"), /* @__PURE__ */ k.createElement("ellipse", { stroke: "#5db98f", fill: "#5db98f", cx: 19, cy: 19, id: "svg_1", rx: 18, ry: 18 }), /* @__PURE__ */ k.createElement("line", { transform: "rotate(-5.68434e-14)", fill: "none", x1: 19, y1: 8.23684, x2: 19, y2: 29.76316, id: "svg_2", strokeWidth: 2, stroke: "#f0f3fa" }), /* @__PURE__ */ k.createElement("line", { transform: "rotate(90 19 19)", fill: "none", x1: 19, y1: 9.23684, x2: 19, y2: 28.76316, id: "svg_4", stroke: "#f0f3fa", strokeWidth: 2 }))), Jq = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 38, height: 23, viewBox: "0 0 38 23" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_3668", "data-name": "Group 3668", transform: "translate(-855 -352)" }, /* @__PURE__ */ k.createElement("rect", { id: "Rectangle_3932", "data-name": "Rectangle 3932", width: 38, height: 23, rx: 5, transform: "translate(855 352)", fill: "#29327f" }), /* @__PURE__ */ k.createElement("g", { id: "g4158", transform: "translate(777.834 253.953)" }, /* @__PURE__ */ k.createElement("path", { id: "polygon9", d: "M435.92,120.06h-2.413l1.509-9.333h2.413Z", transform: "translate(-341.846 -5.51)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "path11", d: "M572.418,105.445a5.947,5.947,0,0,0-2.164-.4c-2.383,0-4.061,1.271-4.072,3.088-.02,1.34,1.2,2.085,2.115,2.532.934.457,1.251.755,1.251,1.162-.01.625-.754.913-1.449.913a4.8,4.8,0,0,1-2.264-.5l-.318-.149-.338,2.1a7.344,7.344,0,0,0,2.691.5c2.532,0,4.181-1.251,4.2-3.187.01-1.062-.635-1.877-2.026-2.542-.844-.427-1.361-.715-1.361-1.152.01-.4.437-.8,1.39-.8a4.1,4.1,0,0,1,1.8.357l.218.1.328-2.015Z", transform: "translate(-469.595)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "path13", d: "M794.255,116.753c.2-.536.963-2.611.963-2.611-.01.02.2-.546.318-.894l.169.8s.457,2.234.556,2.7Zm2.979-6.027h-1.867a1.191,1.191,0,0,0-1.261.774l-3.585,8.558h2.532l.507-1.4h3.1c.069.328.288,1.4.288,1.4h2.234l-1.947-9.333Z", transform: "translate(-688.225 -5.51)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "path15", d: "M171.794,110.727l-2.363,6.364-.258-1.291a7.143,7.143,0,0,0-3.336-3.912L168,120.05h2.552l3.793-9.323h-2.552Z", transform: "translate(-82.148 -5.51)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "path17", d: "M85.088,110.727H81.205l-.04.189a8.075,8.075,0,0,1,5.859,4.885l-.844-4.289a1,1,0,0,0-1.092-.785Z", transform: "translate(0 -5.51)", fill: "#fff" })))), Fst = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 41.888, height: 26.754, viewBox: "0 0 41.888 26.754" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_1643", "data-name": "Group 1643", transform: "translate(-2130.556 -4670.123)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1630", "data-name": "Group 1630", transform: "translate(2130.556 4670.123)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1177", "data-name": "Path 1177", d: "M3.783,0H38.1a3.783,3.783,0,0,1,3.783,3.783V22.971A3.783,3.783,0,0,1,38.1,26.754H3.783A3.783,3.783,0,0,1,0,22.971V3.783A3.783,3.783,0,0,1,3.783,0Z", fill: "#2c8cd0" })), /* @__PURE__ */ k.createElement("path", { id: "Path_1178", "data-name": "Path 1178", d: "M115.417,307.855l1.587-1.71v3.471Zm-5.065-1.284v.787h2.277v.884h-2.277v.865H112.9l1.181-1.277-1.136-1.265-2.594.006Zm28.169.652a1.9,1.9,0,0,1,.516,1.419c0,1.3-.871,2.084-2.342,2.084h-2.013a.719.719,0,0,1-.658-.432,2.656,2.656,0,0,1-1.555.432H130.45a.709.709,0,0,1-.31-.077.732.732,0,0,1-.31.077h-3.458a.684.684,0,0,0-.632,0h-1.045a.708.708,0,0,1-.71-.71v-.632c0-.065,0-.155-.006-.232a1.767,1.767,0,0,0-.206-.006h-.387v.871a.709.709,0,0,1-.716.71h-1.045a.708.708,0,0,1-.71-.71v-1.1a3.033,3.033,0,0,1-1.574.361h-.574v.742a.708.708,0,0,1-.71.71h-2.013a.715.715,0,0,1-.535-.239l-.748-.845-.787.858a.712.712,0,0,1-.529.226h-4.09a.713.713,0,0,1-.716-.71v-4.329a.715.715,0,0,1,.716-.716H113.5a.715.715,0,0,1,.535.239l.755.839.787-.845a.7.7,0,0,1,.523-.226h3.31a2.867,2.867,0,0,1,1.6.4.706.706,0,0,1,.632-.4h2.394a3.186,3.186,0,0,1,1.581.29,1.121,1.121,0,0,1,.135.11.708.708,0,0,1,.632-.394h3.452a.693.693,0,0,1,.613.381,2.38,2.38,0,0,1,1.361-.381h2.077a.7.7,0,0,1,.665.477,2.3,2.3,0,0,1,1.484-.477H138.1a.709.709,0,0,1,.71.716v.916a.713.713,0,0,1-.329.606c.019-.013.026-.006.039,0Zm-17.388-.123c0-1.2-.923-1.426-1.748-1.426h-3.3l-1.316,1.419-1.277-1.419H109.32v4.336h4.1l1.329-1.439,1.271,1.439h2.013v-1.452h1.29c.91,0,1.813-.252,1.813-1.458Zm3.923.9a1.216,1.216,0,0,0,.735-1.155,1.008,1.008,0,0,0-.529-.961,2.581,2.581,0,0,0-1.245-.2h-2.394v4.336h1.039v-1.581h1.1c.381,0,.613.039.755.187.2.2.168.587.168.845v.542h1.045v-.858a1.275,1.275,0,0,0-.174-.794,1.128,1.128,0,0,0-.5-.361Zm4.768-2.316h-3.458v4.336h3.458v-.9h-2.432v-.865h2.368v-.884h-2.368v-.787h2.432Zm4.258,2.961a1.205,1.205,0,0,0-.31-.916,1.643,1.643,0,0,0-1.181-.348l-.555-.019a1.336,1.336,0,0,1-.4-.045.367.367,0,0,1-.071-.639.749.749,0,0,1,.413-.077h1.9v-.916h-2.071c-1.09,0-1.484.658-1.484,1.29,0,1.368,1.213,1.31,2.181,1.342a.514.514,0,0,1,.368.1.377.377,0,0,1,.123.284.4.4,0,0,1-.123.284.617.617,0,0,1-.419.11H130.45v.929h2.013c1.039-.006,1.619-.439,1.619-1.374Zm4.232,0a1.205,1.205,0,0,0-.31-.916,1.664,1.664,0,0,0-1.181-.348l-.561-.019a1.364,1.364,0,0,1-.4-.045.367.367,0,0,1-.071-.639.761.761,0,0,1,.419-.077h1.9v-.916h-2.071c-1.09,0-1.484.658-1.484,1.29,0,1.368,1.213,1.31,2.187,1.342a.524.524,0,0,1,.368.1.355.355,0,0,1,.123.284.4.4,0,0,1-.123.284.617.617,0,0,1-.419.11h-2.007v.929H136.7c1.039-.006,1.619-.439,1.619-1.374Zm-18.93-2.071h-1.348v1.1h1.336c.4,0,.645-.2.645-.574s-.252-.529-.632-.529ZM120,300a.445.445,0,0,0,.213-.413A.408.408,0,0,0,120,299.2a1.12,1.12,0,0,0-.49-.077H118.23v.961h1.258A.978.978,0,0,0,120,300Zm4.432,6.658a.972.972,0,0,0-.49-.077h-1.277v.974h1.265a1.015,1.015,0,0,0,.516-.09.46.46,0,0,0,.213-.413.428.428,0,0,0-.226-.394Zm3.832-7.7-.71,1.729h1.432Zm-25.3,1.729h1.413l-.7-1.729Zm5.8,2.587a.714.714,0,0,1-.652-.426l-.135-.31v.019a.708.708,0,0,1-.71.71h-2.11a.714.714,0,0,1-.658-.445l-.213-.523h-1.2l-.219.523a.714.714,0,0,1-.658.445h-1.136a.708.708,0,0,1-.652-.994l1.852-4.336a.722.722,0,0,1,.658-.432h1.536a.719.719,0,0,1,.658.432l.387.91v-.619a.715.715,0,0,1,.716-.716h1.69a.706.706,0,0,1,.645.419l.677,1.471.613-1.452a.718.718,0,0,1,.658-.439h1.729a.679.679,0,0,1,.387.129.664.664,0,0,1,.387-.129h3.452a.65.65,0,0,0,.723,0h2.374a3.081,3.081,0,0,1,1.613.3.965.965,0,0,1,.129.1.713.713,0,0,1,.632-.4H123a.719.719,0,0,1,.7.607,2.835,2.835,0,0,1,1.942-.607h1a.723.723,0,0,1,.432.142.7.7,0,0,1,.426-.142h1.555a.713.713,0,0,1,.652.432l.381.89v-.607a.713.713,0,0,1,.71-.716h1.574a.729.729,0,0,1,.613.348l.5.813v-.452a.709.709,0,0,1,.716-.71h1.058a.708.708,0,0,1,.71.71v4.336a.708.708,0,0,1-.71.71h-1.465a.707.707,0,0,1-.613-.348l-.632-1.052v.684a.708.708,0,0,1-.71.71h-2.1a.716.716,0,0,1-.665-.445l-.213-.523h-1.194l-.206.523a.709.709,0,0,1-.665.445h-1.213a3.043,3.043,0,0,1-1.877-.574.7.7,0,0,1-.684.574h-1.058a.827.827,0,0,1-.329-.084.66.66,0,0,1-.316.084h-1.032a.717.717,0,0,1-.716-.71l-.006-.542.006-.1c0-.052,0-.142-.006-.213a1.653,1.653,0,0,0-.2-.006h-.413v.858a.708.708,0,0,1-.71.71H117.2a.65.65,0,0,0-.723,0h-3.458a.707.707,0,0,1-.387-.123.724.724,0,0,1-.387.123h-1.058a.709.709,0,0,1-.716-.71v-.019l-.135.3a.714.714,0,0,1-.652.426l-.916.013Zm14.749-2.852a1.833,1.833,0,0,0,2.052,2.129h1.226l.387-.968h2.155l.4.968h2.1v-3.252l1.961,3.252h1.465V298.21h-1.052v3.019l-1.826-3.019h-1.574v4.1l-1.748-4.1H127.5l-1.465,3.413h-.465a1,1,0,0,1-.723-.226,1.492,1.492,0,0,1-.284-1.019,1.409,1.409,0,0,1,.3-.981.989.989,0,0,1,.794-.258h.981v-.929H125.63a2.128,2.128,0,0,0-1.574.5,2.417,2.417,0,0,0-.542,1.7Zm2.155-.555c-.245,0-.271.026-.3.052a1.184,1.184,0,0,0-.077.471,1.136,1.136,0,0,0,.077.5.678.678,0,0,0,.2.026l.452-1.045Zm-3.716,2.7h1.058v-4.336h-1.058Zm-4.761,0h1.032v-1.574h1.11c.374,0,.606.032.755.187a1.3,1.3,0,0,1,.161.845l.006.542h1.052v-.845a1.222,1.222,0,0,0-.174-.794,1.176,1.176,0,0,0-.516-.361,1.22,1.22,0,0,0,.729-1.155,1.021,1.021,0,0,0-.523-.961,2.437,2.437,0,0,0-1.252-.2h-2.381v4.316Zm-4.181,0h3.458v-.9h-2.426V300.8h2.368v-.9h-2.368v-.781h2.426v-.9H113.01Zm-4.245,0h.91l1.5-3.394.006,3.394h1.065v-4.336H110.52l-1.245,2.942-1.361-2.942h-1.69v4.1l-1.761-4.1h-1.536l-1.858,4.336H102.2l.4-.968h2.155l.4.968h2.11v-3.4Z", transform: "translate(2031.818 4379.465)", fill: "#fff" }))), Bst = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 41.888, height: 26.754, viewBox: "0 0 41.888 26.754" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_1640", "data-name": "Group 1640", transform: "translate(-2268 -4670)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1633", "data-name": "Group 1633", transform: "translate(2268 4670)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1177", "data-name": "Path 1177", d: "M3.783,0H38.1a3.783,3.783,0,0,1,3.783,3.783V22.971A3.783,3.783,0,0,1,38.1,26.754H3.783A3.783,3.783,0,0,1,0,22.971V3.783A3.783,3.783,0,0,1,3.783,0Z", fill: "none" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1639", "data-name": "Group 1639", transform: "translate(2267.924 4670.825)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1638", "data-name": "Group 1638", transform: "translate(0.076 -0.052)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1634", "data-name": "Group 1634", transform: "translate(1.645 21.296)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1179", "data-name": "Path 1179", d: "M40.28,135.143v.066h.06a.065.065,0,0,0,.033-.008.029.029,0,0,0,.012-.025.028.028,0,0,0-.012-.024.059.059,0,0,0-.033-.008Zm.061-.046a.111.111,0,0,1,.072.021.069.069,0,0,1,.025.057.066.066,0,0,1-.02.05.1.1,0,0,1-.058.024l.08.092h-.062l-.074-.092H40.28v.092h-.052V135.1Zm-.016.329a.2.2,0,0,0,.079-.016.21.21,0,0,0,.065-.044.2.2,0,0,0,.044-.065.21.21,0,0,0,0-.16.206.206,0,0,0-.109-.109.206.206,0,0,0-.079-.015.215.215,0,0,0-.081.015.209.209,0,0,0-.066.044.209.209,0,0,0-.043.226.193.193,0,0,0,.043.065.208.208,0,0,0,.066.044.2.2,0,0,0,.081.016m0-.47a.265.265,0,0,1,.1.021.268.268,0,0,1,.085.057.261.261,0,0,1,.057.084.261.261,0,0,1,0,.2.274.274,0,0,1-.057.084.29.29,0,0,1-.085.057.265.265,0,0,1-.1.021.269.269,0,0,1-.106-.021.277.277,0,0,1-.086-.057.274.274,0,0,1-.057-.084.261.261,0,0,1,0-.2.261.261,0,0,1,.057-.084.257.257,0,0,1,.086-.057.269.269,0,0,1,.106-.021m-24.761-.943a.8.8,0,1,1,.805.85.8.8,0,0,1-.805-.85m2.149,0v-1.327h-.577v.322a1.006,1.006,0,0,0-.838-.389,1.4,1.4,0,0,0,0,2.788,1.006,1.006,0,0,0,.838-.389v.322h.577Zm19.5,0a.8.8,0,1,1,.805.85.8.8,0,0,1-.805-.85m2.149,0v-2.393h-.578v1.388a1.006,1.006,0,0,0-.838-.389,1.4,1.4,0,0,0,0,2.788,1.006,1.006,0,0,0,.838-.389v.322h.578Zm-14.487-.877a.659.659,0,0,1,.672.644H24.17a.683.683,0,0,1,.705-.644m.011-.517a1.395,1.395,0,0,0,.039,2.788,1.613,1.613,0,0,0,1.088-.372l-.283-.428a1.269,1.269,0,0,1-.772.278.737.737,0,0,1-.794-.65h1.971c.006-.072.011-.144.011-.222a1.273,1.273,0,0,0-1.26-1.394m6.968,1.394a.8.8,0,1,1,.805.85.8.8,0,0,1-.805-.85m2.149,0v-1.327h-.577v.322a1.007,1.007,0,0,0-.838-.389,1.4,1.4,0,0,0,0,2.788,1.007,1.007,0,0,0,.838-.389v.322H34Zm-5.408,0a1.341,1.341,0,0,0,1.416,1.394,1.389,1.389,0,0,0,.955-.316l-.277-.467a1.166,1.166,0,0,1-.695.239.851.851,0,0,1,0-1.7,1.166,1.166,0,0,1,.695.239l.277-.467a1.39,1.39,0,0,0-.955-.317,1.341,1.341,0,0,0-1.416,1.394m7.44-1.394a.784.784,0,0,0-.7.389v-.322h-.572v2.654h.578v-1.488c0-.439.189-.683.566-.683a.937.937,0,0,1,.361.067l.178-.544a1.23,1.23,0,0,0-.411-.072m-15.47.278a1.984,1.984,0,0,0-1.082-.278c-.672,0-1.105.322-1.105.85,0,.433.322.7.916.783l.273.039c.317.044.466.128.466.278,0,.205-.211.322-.605.322a1.413,1.413,0,0,1-.883-.278l-.272.449a1.915,1.915,0,0,0,1.149.344c.767,0,1.211-.361,1.211-.866,0-.467-.349-.711-.927-.794l-.272-.039c-.25-.033-.45-.083-.45-.261,0-.195.189-.311.505-.311a1.712,1.712,0,0,1,.827.228Zm7.446-.278a.781.781,0,0,0-.7.389v-.322h-.572v2.654h.577v-1.488c0-.439.189-.683.566-.683a.936.936,0,0,1,.361.067l.178-.544a1.231,1.231,0,0,0-.411-.072m-4.925.067h-.944v-.805h-.583v.805h-.538v.528h.538v1.211c0,.616.239.982.922.982a1.354,1.354,0,0,0,.722-.205l-.167-.494a1.068,1.068,0,0,1-.511.15c-.289,0-.383-.178-.383-.444v-1.2h.944Zm-8.629,2.654v-1.666a.988.988,0,0,0-1.044-1.055,1.028,1.028,0,0,0-.933.472.974.974,0,0,0-.877-.472.878.878,0,0,0-.777.394v-.327H10.25v2.654h.583V133.87a.621.621,0,0,1,.65-.705c.383,0,.577.25.577.7v1.477h.583V133.87a.626.626,0,0,1,.65-.705c.394,0,.583.25.583.7v1.477Z", transform: "translate(-10.25 -131.622)", fill: "#fff" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1635", "data-name": "Group 1635", transform: "translate(31.189 15.801)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1180", "data-name": "Path 1180", d: "M193.765,98.039v-.388h-.1l-.117.266-.116-.266h-.1v.388h.072v-.292l.109.252h.074l.109-.253v.293Zm-.641,0v-.322h.13v-.066h-.33v.066h.13v.322Z", transform: "translate(-192.923 -97.651)", fill: "#f79410" })), /* @__PURE__ */ k.createElement("path", { id: "Path_1181", "data-name": "Path 1181", d: "M81.75,28.889H73V13.171H81.75Z", transform: "translate(-61.209 -11.032)", fill: "#ff5f00" }), /* @__PURE__ */ k.createElement("g", { id: "Group_1636", "data-name": "Group 1636", transform: "translate(0 0)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1182", "data-name": "Path 1182", d: "M12.431,9.944a9.979,9.979,0,0,1,3.818-7.859,10,10,0,1,0,0,15.718,9.979,9.979,0,0,1-3.818-7.859", transform: "translate(-0.076 0.052)", fill: "#eb001b" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1637", "data-name": "Group 1637", transform: "translate(16.163 0)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1183", "data-name": "Path 1183", d: "M116.188,9.944A10,10,0,0,1,100.015,17.8a10,10,0,0,0,0-15.718,10,10,0,0,1,16.173,7.859", transform: "translate(-100.015 0.052)", fill: "#f79e1b" })))))), Vst = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 35.985, height: 32.696, viewBox: "0 0 35.985 32.696" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#fff;}")), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M.068,27.03c.108-.174.28-.186.522-.033a34.862,34.862,0,0,0,17.805,4.749,35.245,35.245,0,0,0,12.67-2.392l.472-.21c.207-.09.351-.15.44-.195a.6.6,0,0,1,.787.195c.18.261.135.5-.18.72-.384.285-.9.615-1.509.981A24.35,24.35,0,0,1,24.8,33.434a26.425,26.425,0,0,1-6.774.915,26.292,26.292,0,0,1-9.653-1.78A26.819,26.819,0,0,1,.226,27.543.452.452,0,0,1,0,27.213a.326.326,0,0,1,.075-.195ZM9.915,17.7a6.6,6.6,0,0,1,1.115-3.865,6.864,6.864,0,0,1,3.06-2.422,16.592,16.592,0,0,1,4.368-1.08c.585-.069,1.549-.155,2.88-.261V9.519a6,6,0,0,0-.45-2.812,2.456,2.456,0,0,0-2.16-.975h-.273a3.6,3.6,0,0,0-1.869.69,2.712,2.712,0,0,0-1.012,1.644.841.841,0,0,1-.653.765l-3.78-.472c-.372-.09-.558-.27-.558-.585a.9.9,0,0,1,.033-.225,6.31,6.31,0,0,1,2.73-4.32,10.492,10.492,0,0,1,5.085-1.575h.81a8.326,8.326,0,0,1,5.832,1.935c.2.225.405.45.608.72a3.888,3.888,0,0,1,.424.675,2.876,2.876,0,0,1,.292.855c.09.381.157.63.2.765a4.321,4.321,0,0,1,.114.923c.015.47.03.739.03.829v7.92a4.891,4.891,0,0,0,.247,1.554,3.577,3.577,0,0,0,.472,1.011l.765,1.011a1.022,1.022,0,0,1,.2.54.577.577,0,0,1-.27.471c-1.8,1.575-2.79,2.43-2.944,2.565a.876.876,0,0,1-.945.067,9.093,9.093,0,0,1-.789-.744l-.465-.521c-.09-.111-.249-.315-.476-.63l-.45-.653a8.039,8.039,0,0,1-3.6,2.5,9.484,9.484,0,0,1-2.745.34,5.756,5.756,0,0,1-4.14-1.551,5.81,5.81,0,0,1-1.62-4.41l-.075-.114Zm5.63-.657a3.1,3.1,0,0,0,.638,2.046,2.156,2.156,0,0,0,1.733.768,2.21,2.21,0,0,0,.292-.03,1.656,1.656,0,0,1,.249-.035,3.365,3.365,0,0,0,2.136-1.767,4.719,4.719,0,0,0,.54-1.365,5.856,5.856,0,0,0,.2-1.2c.022-.292.022-.81.022-1.507v-.81a11.6,11.6,0,0,0-2.88.27,3.515,3.515,0,0,0-2.88,3.645l-.052-.03ZM29.288,27.587a1.088,1.088,0,0,1,.2-.255,5.345,5.345,0,0,1,1.575-.75,12.141,12.141,0,0,1,2.418-.36,1.994,1.994,0,0,1,.615.045c.975.09,1.575.252,1.758.5a1.043,1.043,0,0,1,.135.585v.225a7.494,7.494,0,0,1-.623,2.7,6.53,6.53,0,0,1-1.734,2.52.494.494,0,0,1-.3.135.35.35,0,0,1-.135-.018c-.135-.066-.16-.18-.1-.36a12.311,12.311,0,0,0,1.209-3.96.86.86,0,0,0-.131-.516c-.217-.249-.825-.385-1.836-.385-.365,0-.8.024-1.305.069-.545.067-1.05.135-1.5.2a.4.4,0,0,1-.27-.066c-.045-.045-.054-.07-.03-.115a.247.247,0,0,1,.03-.094v-.09Z", transform: "translate(-0.002 -1.653)" })), Ust = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 23.419, height: 28.102, viewBox: "0 0 23.419 28.102" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#fff;}")), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M25.419,20.617c-.92,2.67-3.676,7.4-6.514,7.448-1.883.036-2.488-1.116-4.64-1.116S11.44,28.03,9.66,28.1C6.649,28.216,2,21.277,2,15.226,2,9.667,5.873,6.912,9.258,6.862c1.815-.033,3.529,1.224,4.636,1.224S17.086,6.575,19.275,6.8A6.567,6.567,0,0,1,24.414,9.58c-4.381,2.859-3.7,8.839,1,11.037ZM19.3,0a6.219,6.219,0,0,0-5.632,6.477C16.731,6.714,19.665,3.286,19.3,0Z", transform: "translate(-2)" })), Gst = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 56.542, height: 26.584, viewBox: "0 0 56.542 26.584" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}"), /* @__PURE__ */ k.createElement("clipPath", { id: "a" }, /* @__PURE__ */ k.createElement("path", { className: "a", d: "M3252.226-5959.234h56.542v-26.584h-56.542Z", transform: "translate(-3252.226 5985.818)" }))), /* @__PURE__ */ k.createElement("g", { transform: "translate(-424.854 1329.887)" }, /* @__PURE__ */ k.createElement("g", { transform: "translate(424.854 -1329.887)" }, /* @__PURE__ */ k.createElement("g", { className: "b" }, /* @__PURE__ */ k.createElement("g", { transform: "translate(5.442 5.746)" }, /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-150.148-97.324a2.331,2.331,0,0,0-2.32-2.342h-1.15V-95h1.15a2.327,2.327,0,0,0,2.32-2.321m5.232,9.3h-4.222l-3.352-4.652h-1.127v4.642h-3.721v-13.946h5.331c3.073,0,5.582,2.09,5.582,4.661a4.53,4.53,0,0,1-2.425,3.826l3.936,5.469", transform: "translate(157.339 101.986)" })), /* @__PURE__ */ k.createElement("g", { transform: "translate(16.354 8.546)" }, /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-119.178-56.336c-.983,0-1.819,1.336-1.819,2.989s.836,2.991,1.819,2.991c1.006,0,1.84-1.337,1.84-2.991s-.835-2.989-1.84-2.989m5.728,2.989a5.7,5.7,0,0,1-5.728,5.688,5.684,5.684,0,0,1-5.708-5.688,5.684,5.684,0,0,1,5.708-5.687,5.7,5.7,0,0,1,5.728,5.687", transform: "translate(124.886 59.034)" })), /* @__PURE__ */ k.createElement("g", { transform: "translate(28.515 8.763)" }, /* @__PURE__ */ k.createElement("path", { className: "a", d: "M-167.191-.3l-4.287,4.286V-.31H-175.2V10.619h3.721V6.186L-167,10.619h4.683l-5.687-5.688L-163.3.222V6.708c0,2.153,1.295,4.141,4.556,4.141a5.171,5.171,0,0,0,3.659-1.673l1.673,1.443h.794V-.3h-3.721V6.771a2.084,2.084,0,0,1-1.9,1.191c-.915,0-1.335-.543-1.335-2.278V-.3Z", transform: "translate(175.199 0.31)" })))))), zst = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 38, height: 23, viewBox: "0 0 38 23" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", { id: "clip-path" }, /* @__PURE__ */ k.createElement("rect", { id: "Rectangle_3916", "data-name": "Rectangle 3916", width: 38, height: 23, rx: 5, transform: "translate(0)", fill: "#fff" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_3631", "data-name": "Group 3631", transform: "translate(-855 -293)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_3626", "data-name": "Group 3626" }, /* @__PURE__ */ k.createElement("g", { id: "Rectangle_3917", "data-name": "Rectangle 3917", transform: "translate(855 293)", fill: "none", stroke: "#d4d4df", strokeWidth: 1 }, /* @__PURE__ */ k.createElement("rect", { width: 38, height: 23, rx: 5, stroke: "none" }), /* @__PURE__ */ k.createElement("rect", { x: 0.5, y: 0.5, width: 37, height: 22, rx: 4.5, fill: "none" }))), /* @__PURE__ */ k.createElement("g", { id: "cdnlogo.com_discover", transform: "translate(791.5 82.7)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_2551", "data-name": "Path 2551", d: "M68.861,220.9H67.5v4.769h1.361a2.482,2.482,0,0,0,1.7-.553,2.384,2.384,0,0,0-1.7-4.216Zm1.089,3.581a1.749,1.749,0,0,1-1.271.38h-.248v-3.152h.248a1.7,1.7,0,0,1,1.271.388,1.6,1.6,0,0,1,.512,1.188A1.632,1.632,0,0,1,69.951,224.481Z", transform: "translate(0 -1.468)", fill: "#231f20" }), /* @__PURE__ */ k.createElement("rect", { id: "XMLID_422_", width: 0.932, height: 4.769, transform: "translate(71.848 219.432)", fill: "#231f20" }), /* @__PURE__ */ k.createElement("path", { id: "XMLID_421_", d: "M137.714,221.906c-.561-.206-.718-.347-.718-.6,0-.3.289-.528.693-.528a.968.968,0,0,1,.751.388l.487-.635a2.089,2.089,0,0,0-1.4-.528,1.4,1.4,0,0,0-1.485,1.361c0,.66.3.99,1.172,1.3a3.935,3.935,0,0,1,.644.272.572.572,0,0,1,.281.5.673.673,0,0,1-.718.668,1.1,1.1,0,0,1-1.015-.635l-.6.578a1.855,1.855,0,0,0,1.65.908,1.537,1.537,0,0,0,1.642-1.568C139.092,222.632,138.779,222.294,137.714,221.906Z", transform: "translate(-62.664 -0.642)", fill: "#231f20" }), /* @__PURE__ */ k.createElement("path", { id: "XMLID_420_", d: "M179.2,222a2.463,2.463,0,0,0,2.517,2.484,2.587,2.587,0,0,0,1.163-.281v-1.1a1.486,1.486,0,0,1-1.122.52,1.558,1.558,0,0,1-1.6-1.642,1.581,1.581,0,0,1,1.559-1.634,1.547,1.547,0,0,1,1.163.536v-1.1a2.366,2.366,0,0,0-1.147-.289A2.516,2.516,0,0,0,179.2,222Z", transform: "translate(-102.483 -0.183)", fill: "#231f20" }), /* @__PURE__ */ k.createElement("path", { id: "XMLID_419_", d: "M287.686,224.1l-1.271-3.2H285.4l2.03,4.893h.5l2.063-4.893h-1.007Z", transform: "translate(-199.921 -1.468)", fill: "#231f20" }), /* @__PURE__ */ k.createElement("path", { id: "XMLID_418_", d: "M346.1,225.669h2.632v-.809h-1.708v-1.287h1.642v-.809h-1.642v-1.056h1.708V220.9H346.1Z", transform: "translate(-255.612 -1.468)", fill: "#231f20" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2552", "data-name": "Path 2552", d: "M388.561,222.311c0-.891-.611-1.411-1.683-1.411H385.5v4.769h.932v-1.914h.124l1.287,1.914h1.147l-1.5-2.005A1.278,1.278,0,0,0,388.561,222.311Zm-1.865.784h-.272v-1.444h.289c.578,0,.891.239.891.71S387.29,223.095,386.7,223.095Z", transform: "translate(-291.761 -1.468)", fill: "#231f20" }), /* @__PURE__ */ k.createElement("circle", { id: "XMLID_415_", cx: 2.533, cy: 2.533, r: 2.533, transform: "translate(80.702 219.3)", fill: "#fff" }), /* @__PURE__ */ k.createElement("circle", { id: "XMLID_414_", cx: 2.533, cy: 2.533, r: 2.533, transform: "translate(80.702 219.3)", fill: "#ee7523" }), /* @__PURE__ */ k.createElement("g", { id: "XMLID_430_", transform: "translate(96.891 219.325)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_2553", "data-name": "Path 2553", d: "M426.589,221.632c0-.083-.058-.132-.157-.132H426.3v.421h.1v-.165l.116.165h.124l-.14-.173A.115.115,0,0,0,426.589,221.632Zm-.173.058H426.4v-.107h.017c.049,0,.074.017.074.058S426.465,221.69,426.416,221.69Z", transform: "translate(-426.085 -221.343)", fill: "#231f20" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2554", "data-name": "Path 2554", d: "M424.063,219.6a.363.363,0,0,0,0,.726.363.363,0,1,0,0-.726Zm0,.668a.3.3,0,0,1,0-.594.3.3,0,0,1,.289.3A.294.294,0,0,1,424.063,220.268Z", transform: "translate(-423.7 -219.6)", fill: "#231f20" }))))), Hst = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 38, height: 23, viewBox: "0 0 38 23" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_3627", "data-name": "Group 3627", transform: "translate(-855 -293)" }, /* @__PURE__ */ k.createElement("rect", { id: "Rectangle_3920", "data-name": "Rectangle 3920", width: 38, height: 23, rx: 5, transform: "translate(855 293)", fill: "#0079be" }), /* @__PURE__ */ k.createElement("g", { id: "Group_3627-2", "data-name": "Group 3627", transform: "translate(874.721 799.566)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_2549", "data-name": "Path 2549", d: "M13.216-486.131c4.885.023,9.343-3.984,9.343-8.858A9.126,9.126,0,0,0,13.216-504h-4.2A8.815,8.815,0,0,0,0-494.989a8.953,8.953,0,0,0,9.012,8.858Z", transform: "translate(-12 0)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_2550", "data-name": "Path 2550", d: "M32.249-483.173a8.181,8.181,0,0,0-8.178,8.181,8.181,8.181,0,0,0,8.178,8.18,8.181,8.181,0,0,0,8.18-8.18A8.181,8.181,0,0,0,32.249-483.173Zm-5.184,8.181a5.194,5.194,0,0,1,3.328-4.839v9.677A5.191,5.191,0,0,1,27.065-474.992Zm7.039,4.84v-9.68a5.191,5.191,0,0,1,3.33,4.84A5.193,5.193,0,0,1,34.1-470.151Z", transform: "translate(-35.217 -20.091)", fill: "#0078c4" })))), Wst = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 22.952, height: 19.901, viewBox: "0 0 22.952 19.901" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_3639", "data-name": "Group 3639", transform: "translate(-862.524 -294.549)" }, /* @__PURE__ */ k.createElement("g", { id: "g10", transform: "translate(833.649 -350.175)" }, /* @__PURE__ */ k.createElement("g", { id: "g12", transform: "translate(28.875 644.724)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_3590", "data-name": "Group 3590", transform: "translate(0 0)" }, /* @__PURE__ */ k.createElement("g", { id: "g24", transform: "translate(6.252 2.157)" }, /* @__PURE__ */ k.createElement("path", { id: "path26", d: "M0-15.974V-1.479H6.31c5.732,0,8.218-3.239,8.218-7.809,0-4.377-2.485-7.779-8.218-7.779H1.093A1.093,1.093,0,0,0,0-15.974", transform: "translate(0 17.067)", fill: "#c06" })), /* @__PURE__ */ k.createElement("g", { id: "g28" }, /* @__PURE__ */ k.createElement("path", { id: "path30", d: "M-23.959-7.984a1.094,1.094,0,0,0-1.093,1.093V9.731a1.094,1.094,0,0,0,1.093,1.093h10.2c6.815,0,10.569-3.348,10.569-9.427,0-8.163-6.622-9.382-10.569-9.382Zm10.2,19.355h-10.2A1.641,1.641,0,0,1-25.6,9.731V-6.891a1.641,1.641,0,0,1,1.639-1.639h10.2c9.671,0,11.116,6.22,11.116,9.928,0,6.431-3.948,9.973-11.116,9.973", transform: "translate(25.599 8.531)" })), /* @__PURE__ */ k.createElement("g", { id: "g32", transform: "translate(6.979 7.979)" }, /* @__PURE__ */ k.createElement("path", { id: "path34", d: "M-21.054-41.256a.986.986,0,0,0,.32-.053.7.7,0,0,0,.276-.177.883.883,0,0,0,.194-.323,1.422,1.422,0,0,0,.073-.485,2.036,2.036,0,0,0-.051-.473.941.941,0,0,0-.167-.361.746.746,0,0,0-.308-.23,1.231,1.231,0,0,0-.473-.08h-.543v2.183ZM-21-44.079a1.783,1.783,0,0,1,.623.107,1.353,1.353,0,0,1,.5.32,1.479,1.479,0,0,1,.33.534,2.163,2.163,0,0,1,.119.752,2.4,2.4,0,0,1-.1.7,1.542,1.542,0,0,1-.293.553,1.373,1.373,0,0,1-.49.366,1.656,1.656,0,0,1-.691.133h-1.494v-3.463Z", transform: "translate(22.495 44.079)", fill: "#fff" })), /* @__PURE__ */ k.createElement("g", { id: "g36", transform: "translate(10.549 7.979)" }, /* @__PURE__ */ k.createElement("path", { id: "path38", d: "M-37.85,0V.64h-1.828v.742H-38v.592h-1.678v.849h1.867v.64H-40.44V0Z", transform: "translate(40.44)", fill: "#fff" })), /* @__PURE__ */ k.createElement("g", { id: "g40", transform: "translate(13.656 7.979)" }, /* @__PURE__ */ k.createElement("path", { id: "path42", d: "M-31.189-31.048l-.437-1.271h-.01l-.451,1.271Zm-.044-2.124,1.295,3.463h-.79l-.262-.771h-1.3l-.272.771h-.766l1.309-3.463Z", transform: "translate(33.323 33.172)", fill: "#fff" })), /* @__PURE__ */ k.createElement("g", { id: "g44", transform: "translate(17.52 7.979)" }, /* @__PURE__ */ k.createElement("path", { id: "path46", d: "M-11.129,0V2.823h1.688v.64h-2.449V0Z", transform: "translate(11.891 0)", fill: "#fff" })), /* @__PURE__ */ k.createElement("g", { id: "g48", transform: "translate(1.802 8.113)" }, /* @__PURE__ */ k.createElement("path", { id: "path50", d: "M-46.694-23.347a1.6,1.6,0,0,1-1.6,1.6,1.6,1.6,0,0,1-1.6-1.6,1.6,1.6,0,0,1,1.6-1.6,1.6,1.6,0,0,1,1.6,1.6", transform: "translate(49.889 24.944)" })), /* @__PURE__ */ k.createElement("g", { id: "g52", transform: "translate(2.19 12.226)" }, /* @__PURE__ */ k.createElement("path", { id: "path54", d: "M-35.376-80.655h0a2.42,2.42,0,0,1-2.42-2.42v-1.888a1.21,1.21,0,0,1,1.21-1.21,1.21,1.21,0,0,1,1.21,1.21Z", transform: "translate(37.796 86.173)" }))))))), Qq = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ id: "Warstwa_2", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 503.7 312.79" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".cls-1{fill:url(#Bancontact_blauw_rgb);}.cls-2{fill:#1e3764;}.cls-3{fill:url(#Bancontact_geel_rgb);}"), /* @__PURE__ */ k.createElement("linearGradient", { id: "Bancontact_blauw_rgb", x1: 50.94, y1: 156.47, x2: 235.18, y2: 88.04, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ k.createElement("stop", { offset: 0, stopColor: "#005ab9" }), /* @__PURE__ */ k.createElement("stop", { offset: 1, stopColor: "#1e3764" })), /* @__PURE__ */ k.createElement("linearGradient", { id: "Bancontact_geel_rgb", x1: 267.1, y1: 109.98, x2: 462.72, y2: 43.24, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ k.createElement("stop", { offset: 0, stopColor: "#fba900" }), /* @__PURE__ */ k.createElement("stop", { offset: 1, stopColor: "#ffd800" }))), /* @__PURE__ */ k.createElement("g", { id: "logo" }, /* @__PURE__ */ k.createElement("path", { id: "Bancontact", className: "cls-2", d: "m0,311.54v-72.76h22.45c16.32,0,26.82,6.13,26.82,18.81,0,7.17-3.33,12.16-8,15.07,6.76,3.12,10.71,9.15,10.71,17.36,0,14.66-10.71,21.52-27.34,21.52H0Zm14.45-42.51h10.71c6.55,0,9.35-3.22,9.35-9.15,0-6.34-5.09-8.42-11.95-8.42h-8.11v17.57Zm0,29.83h8.94c8.73,0,13.82-2.18,13.82-9.04s-4.37-9.56-12.58-9.56h-10.19v18.61Zm65.54,13.93c-14.24,0-21.41-6.96-21.41-16.32,0-10.29,8.42-16.32,20.89-16.42,2.91,0,6.65.42,9.25.83v-2.49c0-6.34-3.64-9.35-10.6-9.35-4.57,0-9.46.73-13.72,2.49l-2.6-11.23c4.47-1.87,11.64-3.12,17.98-3.12,15.28,0,22.87,8.11,22.87,22.14v28.9c-4.26,2.18-12.26,4.57-22.66,4.57Zm8.73-11.75v-11.12c-2.39-.52-4.89-.83-7.38-.83-4.78,0-8.52,1.87-8.52,6.76,0,4.37,3.12,6.65,8.63,6.65,3.12,0,5.72-.62,7.28-1.46Zm24.03,10.5v-49.79c6.55-2.81,15.49-4.57,23.49-4.57,15.18,0,23.91,7.48,23.91,21.31v33.05h-14.34v-32.01c0-7.17-3.33-10.5-9.67-10.5-3.33,0-6.44.62-9.15,1.87v40.64h-14.24Zm97.52-51.24l-2.7,11.33c-3.95-1.66-8.21-2.6-11.75-2.6-8.42,0-12.99,5.92-12.99,15.7,0,10.71,4.78,16.21,13.72,16.21,3.43,0,7.59-.94,11.54-2.7l2.29,11.54c-3.53,1.77-8.94,3.01-14.97,3.01-17.25,0-27.23-10.71-27.23-27.65s9.87-27.96,26.4-27.96c5.92,0,11.85,1.35,15.69,3.12Zm30.99,52.49c-16.01,0-25.99-11.12-25.99-27.86s9.98-27.75,25.99-27.75,25.88,11.12,25.88,27.75-9.77,27.86-25.88,27.86Zm0-11.85c7.38,0,11.23-6.13,11.23-16.01s-3.85-15.9-11.23-15.9-11.33,6.13-11.33,15.9,4.05,16.01,11.33,16.01Zm34.18,10.6v-49.79c6.55-2.81,15.49-4.57,23.49-4.57,15.18,0,23.91,7.48,23.91,21.31v33.05h-14.34v-32.01c0-7.17-3.33-10.5-9.67-10.5-3.33,0-6.44.62-9.15,1.87v40.64h-14.24Zm79.75,1.25c-12.37,0-18.71-6.76-18.71-20.48v-22.45h-7.07v-11.43h7.07v-11.54l14.34-.73v12.26h11.54v11.43h-11.54v22.24c0,6.03,2.49,8.83,7.17,8.83,2.18,0,4.16-.31,5.51-.62l.73,11.54c-2.49.62-5.82.94-9.04.94Zm36.2,0c-14.24,0-21.41-6.96-21.41-16.32,0-10.29,8.42-16.32,20.89-16.42,2.91,0,6.65.42,9.25.83v-2.49c0-6.34-3.64-9.35-10.6-9.35-4.57,0-9.46.73-13.72,2.49l-2.6-11.23c4.47-1.87,11.64-3.12,17.98-3.12,15.28,0,22.87,8.11,22.87,22.14v28.9c-4.26,2.18-12.26,4.57-22.66,4.57Zm8.73-11.75v-11.12c-2.39-.52-4.89-.83-7.38-.83-4.78,0-8.52,1.87-8.52,6.76,0,4.37,3.12,6.65,8.63,6.65,3.12,0,5.72-.62,7.28-1.46Zm63-40.74l-2.7,11.33c-3.95-1.66-8.21-2.6-11.75-2.6-8.42,0-12.99,5.92-12.99,15.7,0,10.71,4.78,16.21,13.72,16.21,3.43,0,7.59-.94,11.54-2.7l2.29,11.54c-3.53,1.77-8.94,3.01-14.97,3.01-17.25,0-27.23-10.71-27.23-27.65s9.87-27.96,26.4-27.96c5.92,0,11.85,1.35,15.7,3.12Zm31.54,52.49c-12.37,0-18.71-6.76-18.71-20.48v-22.45h-7.07v-11.43h7.07v-11.54l14.34-.73v12.26h11.54v11.43h-11.54v22.24c0,6.03,2.49,8.83,7.17,8.83,2.18,0,4.16-.31,5.51-.62l.73,11.54c-2.49.62-5.82.94-9.04.94Z" }), /* @__PURE__ */ k.createElement("path", { id: "blue-symbol", className: "cls-1", d: "m100.05,202.4c75.9,0,113.85-50.6,151.8-101.2H0v101.2h100.05Z" }), /* @__PURE__ */ k.createElement("path", { id: "yellow-symbol", className: "cls-3", d: "m403.65,0c-75.9,0-113.85,50.6-151.8,101.2h251.85V0h-100.05Z" }))), Zst = {
  visa: {
    icon: Jq,
    caption: "Visa",
    title: "Credit Card"
  },
  visacredit: {
    icon: Jq,
    caption: "Visa",
    title: "Credit Card"
  },
  amex: {
    icon: Fst,
    caption: "American Express",
    title: "Credit Card"
  },
  mc: {
    icon: Bst,
    caption: "MasterCard",
    title: "Credit Card"
  },
  paypal: {
    icon: bD,
    caption: "PayPal",
    title: "PayPal"
  },
  apple: {
    icon: Ust,
    caption: "Apple",
    title: "Apple"
  },
  android: {
    icon: _D,
    caption: "Android",
    title: "Android"
  },
  amazon: {
    icon: Vst,
    caption: "Amazon",
    title: "Amazon"
  },
  roku: {
    icon: Gst,
    caption: "Roku",
    title: "Roku"
  },
  applepay: {
    icon: JO,
    caption: "Apple Pay",
    title: "Apple Pay"
  },
  googlepay: {
    icon: ele,
    caption: "Google Pay",
    title: "Google Pay"
  },
  discover: {
    icon: zst,
    caption: "Discover",
    title: "Credit Card"
  },
  diners: {
    icon: Hst,
    caption: "Diners",
    title: "Credit Card"
  },
  ideal: {
    icon: Wst,
    caption: "Ideal",
    title: "iDeal"
  },
  bancontact_card: {
    icon: Qq,
    caption: "Bancontact Card",
    title: "Bancontact Card"
  },
  bancontact_mobile: {
    icon: Qq,
    caption: "Bancontact Mobile",
    title: "Bancontact Mobile"
  }
}, Yst = W.div.attrs(() => ({
  className: "msd__payment-card"
}))`
  height: 100%;
`, Xst = W.figure.attrs(() => ({
  className: "msd__payment-card__type"
}))`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 26px;
  margin: 0;

  svg {
    height: auto;
  }
`, Kst = W.div.attrs(() => ({
  className: "msd__payment-card__number"
}))`
  color: ${Et};
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
`, qst = W.div.attrs(() => ({
  className: "msd__payment-holder__name"
}))`
  color: ${Et};
  font-size: 13px;
  font-weight: 300;
`, Jst = W.div.attrs(() => ({
  className: "msd__payment-data__wrapper"
}))`
  color: ${Et};
  font-size: 12px;

  display: flex;
`, Qst = W.div.attrs(() => ({
  className: "msd__payment-data__label"
}))`
  color: ${Et};
  font-size: 13px;
  font-weight: 300;
  margin-bottom: 4px;
  margin-inline-end: 4px;
`, elt = W.time.attrs(() => ({
  className: "msd__payment-data__value"
}))`
  color: ${Et};
  font-size: 13px;
  font-weight: 300;

  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`, tlt = W.button.attrs(() => ({
  className: "msd__payment-method__button"
}))`
  color: ${cu};

  padding: 11px 25px;
  background-color: ${An};
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  border-radius: 21px;
  border: 0;
  opacity: 0.9;

  &:hover {
    cursor: pointer;
    opacity: 1;
  }
  &:focus {
    cursor: pointer;
    opacity: 1;
    outline: 1px solid ${Vm};
  }
`, nlt = W.div.attrs(() => ({
  className: "msd__payment-method__information"
}))`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;

  ${Zr.medium`
    margin-bottom: 0;
  `}
`, rlt = W.div.attrs(() => ({
  className: "msd__payment-method__details"
}))`
  margin-inline: 20px auto;
`, alt = W.div.attrs(() => ({
  className: "msd__payment-method__name"
}))`
  color: ${Et};
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  margin-inline-end: 4px;
`, olt = W.div.attrs(() => ({
  className: "msd__payment-method__nameWrapper"
}))`
  display: flex;
  margin-bottom: 4px;
`, ilt = W.div.attrs(() => ({
  className: "msd__payment-method__wrapper"
}))`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  ${Zr.medium`
    flex-direction: row;
    align-items: center;
  `};
`, slt = vge`
.visually-hidden {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}
`, llt = ({ details: e }) => {
  const t = Va(), { t: n } = tn(), { paymentMethodSpecificParams: r, paymentMethod: a } = e, s = Zst[a === "card" ? r.variant : a], c = (s == null ? void 0 : s.icon) || null, u = s == null ? void 0 : s.caption, f = (s == null ? void 0 : s.title) || "";
  return /* @__PURE__ */ C.jsx(Uu, { withBorder: !0, children: /* @__PURE__ */ C.jsx(Yst, { children: /* @__PURE__ */ C.jsxs(ilt, { children: [
    /* @__PURE__ */ C.jsxs(nlt, { children: [
      c && /* @__PURE__ */ C.jsxs(Xst, { children: [
        /* @__PURE__ */ C.jsx(c, {}),
        /* @__PURE__ */ C.jsx(slt, {}),
        /* @__PURE__ */ C.jsx("figcaption", { className: "visually-hidden", children: u })
      ] }),
      /* @__PURE__ */ C.jsxs(rlt, { children: [
        /* @__PURE__ */ C.jsxs(olt, { children: [
          /* @__PURE__ */ C.jsx(alt, { children: f }),
          a !== "paypal" && (r == null ? void 0 : r.lastCardFourDigits) && /* @__PURE__ */ C.jsxs(Kst, { children: [
            "(**** ",
            r.lastCardFourDigits,
            ")"
          ] })
        ] }),
        a === "paypal" && /* @__PURE__ */ C.jsxs(qst, { children: [
          "(",
          r.holderName,
          ")"
        ] }),
        a !== "paypal" && (r == null ? void 0 : r.cardExpirationDate) && /* @__PURE__ */ C.jsxs(Jst, { children: [
          /* @__PURE__ */ C.jsx(Qst, { children: n("paymentcard.expiry-date", "Expiry date") }),
          /* @__PURE__ */ C.jsx(
            elt,
            {
              dateTime: r.cardExpirationDate,
              children: r.cardExpirationDate
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ C.jsx(
      tlt,
      {
        type: "button",
        onClick: () => {
          t(
            pi({
              isOpen: !0,
              initPaymentMethod: e
            })
          ), ur(Tye, {
            detail: {
              paymentMethod: a
            }
          });
        },
        children: n("paymentcard.edit-payment-info", "Edit payment info")
      }
    )
  ] }) }) });
}, kN = W.article`
  position: relative;

  margin-bottom: 30px;
`, AN = W.div.attrs(() => ({
  className: "msd__payment-method__wrapper"
}))`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  @media only screen and (max-width: 1550px) {
    grid-template-columns: 1fr;
    > div {
      justify-self: center;
    }
  }
  ${(e) => e.$numberOfItems === 1 && ot`
      grid-template-columns: 1fr;
      > div {
        justify-self: center;
      }
    `}
`, ult = W.div.attrs(() => ({
  className: "msd__payment-method__message"
}))`
  margin-bottom: 24px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  color: ${Oee};
  align-self: center;
`, clt = W.div.attrs(() => ({
  className: "msd__payment-card"
}))``, dlt = W.div.attrs(() => ({
  className: "msd__payment-card__type"
}))`
  display: flex;
  width: 38px;
  height: 26px;

  svg {
    width: 100%;
    height: auto;
  }
`, flt = W.div.attrs(() => ({
  className: "msd__payment-data__wrapper"
}))`
  color: ${Et};
  font-size: 12px;

  display: flex;
`, plt = W.div.attrs(() => ({
  className: "msd__payment-method__information"
}))`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;

  ${Zr.smallest`
    margin-bottom: 0;
  `}
`, hlt = W.div.attrs(() => ({
  className: "msd__payment-method__details"
}))`
  margin-left: 20px;
  margin-right: auto;
`, mlt = W.div.attrs(() => ({
  className: "msd__payment-method__name"
}))`
  color: ${Et};
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  margin-right: 4px;
`, vlt = W.div.attrs(() => ({
  className: "msd__payment-method__nameWrapper"
}))`
  display: flex;
  margin-bottom: 4px;
`, glt = W.div.attrs(() => ({
  className: "msd__payment-method__wrapper"
}))`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${Zr.smallest`
    flex-direction: row;
  `}
`, ylt = () => /* @__PURE__ */ C.jsx(Uu, { withBorder: !0, children: /* @__PURE__ */ C.jsx(clt, { children: /* @__PURE__ */ C.jsxs(glt, { children: [
  /* @__PURE__ */ C.jsxs(plt, { children: [
    /* @__PURE__ */ C.jsx(dlt, { children: /* @__PURE__ */ C.jsx(Zn, { height: 16, width: 28 }) }),
    /* @__PURE__ */ C.jsxs(hlt, { children: [
      /* @__PURE__ */ C.jsx(vlt, { children: /* @__PURE__ */ C.jsx(mlt, { children: /* @__PURE__ */ C.jsx(Zn, { width: 140 }) }) }),
      /* @__PURE__ */ C.jsx(flt, { children: /* @__PURE__ */ C.jsx(Zn, { width: 100 }) })
    ] })
  ] }),
  /* @__PURE__ */ C.jsx(Zn, { height: 43, width: 170 })
] }) }) }), blt = () => {
  const { t: e } = tn(), t = Va(), { paymentDetails: n, error: r, loading: a, activeOrBoundPaymentDetails: o } = Ot(tbe), s = (u) => {
    const { paymentMethod: f, id: m } = u;
    switch (f) {
      case "card":
      case "paypal":
      case "apple":
      case "android":
      case "amazon":
      case "roku":
      case "googlepay":
      case "applepay":
      case "ideal":
      case "bancontact_card":
      case "bancontact_mobile":
        return /* @__PURE__ */ C.jsx(llt, { details: u }, m);
      default:
        return /* @__PURE__ */ C.jsx(ult, { children: e(
          "paymentmethod.managed-by-external-service",
          "Managed by external service"
        ) });
    }
  }, c = o.find((u) => u.active);
  return mn(() => {
    (n == null ? void 0 : n.length) === 0 && t(Tm());
  }, []), a ? /* @__PURE__ */ C.jsx(AN, { $numberOfItems: 1, children: /* @__PURE__ */ C.jsx(ylt, {}) }) : r ? /* @__PURE__ */ C.jsx(kN, { children: /* @__PURE__ */ C.jsx(Ml, { generalError: !0 }) }) : c ? /* @__PURE__ */ C.jsx(kN, { children: /* @__PURE__ */ C.jsx(AN, { $numberOfItems: o.length, children: o.map(
    (u) => s(u)
  ) }) }) : /* @__PURE__ */ C.jsx(kN, { children: /* @__PURE__ */ C.jsx(AN, { $numberOfItems: 1, children: /* @__PURE__ */ C.jsx(
    Ml,
    {
      icon: jst,
      title: e(
        "paymentmethod.no-active-method.title",
        "Add a payment method!"
      ),
      subtitle: e(
        "paymentmethod.no-active-method.subtitle",
        "Set up a new payment method for your account"
      ),
      withBorder: !0,
      onClick: () => {
        t(
          pi({
            isOpen: !0,
            isLoading: !1,
            step: js.PAYMENT_DETAILS_UPDATE
          })
        );
      },
      direction: "row",
      fullWidth: !0
    }
  ) }) });
}, eL = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ width: 100.718, height: 73.237, xmlns: "http://www.w3.org/2000/svg", "data-name": "Component 10 \\u2013 1", color: "red" }, e), /* @__PURE__ */ k.createElement("g", null, /* @__PURE__ */ k.createElement("title", null, "Layer 1"), /* @__PURE__ */ k.createElement("g", { fill: "red", "data-name": "Group 2086", id: "Group_2086" }, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 2085", id: "Group_2085" }, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 2081", id: "Group_2081" }, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1882", id: "Group_1882" }, /* @__PURE__ */ k.createElement("path", { strokeWidth: 17, strokeLinejoin: "round", strokeLinecap: "round", stroke: "#838eaa", fill: "#bcc3cd", d: "m78.03496,54.03888", "data-name": "Path 1360", id: "Path_1360" }), /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1848", id: "Group_1848" }, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1844", id: "Group_1844" }, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1842", id: "Group_1842" }, /* @__PURE__ */ k.createElement("path", { fill: "#bcc3cd", d: "m93.64817,5.46388l-1.572,0a0.762,0.762 0 0 1 -0.762,-0.762a0.762,0.762 0 0 1 0.762,-0.762l1.572,0a0.762,0.762 0 0 1 0.762,0.762a0.762,0.762 0 0 1 -0.762,0.762z", "data-name": "Path 1392", id: "Path_1392" })), /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1843", id: "Group_1843" }, /* @__PURE__ */ k.createElement("path", { fill: "#bcc3cd", d: "m99.95614,5.46388l-1.572,0a0.762,0.762 0 0 1 -0.762,-0.762a0.762,0.762 0 0 1 0.762,-0.762l1.572,0a0.762,0.762 0 0 1 0.762,0.762a0.762,0.762 0 0 1 -0.762,0.762z", "data-name": "Path 1393", id: "Path_1393" }))), /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1847", id: "Group_1847" }, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1845", id: "Group_1845" }, /* @__PURE__ */ k.createElement("path", { fill: "#bcc3cd", d: "m96.01603,3.09587a0.761,0.761 0 0 1 -0.762,-0.762l0,-1.572a0.761,0.761 0 0 1 0.762,-0.762a0.762,0.762 0 0 1 0.762,0.762l0,1.572a0.762,0.762 0 0 1 -0.762,0.762z", "data-name": "Path 1394", id: "Path_1394" })), /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1846", id: "Group_1846" }, /* @__PURE__ */ k.createElement("path", { fill: "#bcc3cd", d: "m96.01603,9.40488a0.761,0.761 0 0 1 -0.762,-0.762l0,-1.572a0.761,0.761 0 0 1 0.762,-0.762a0.762,0.762 0 0 1 0.762,0.762l0,1.572a0.762,0.762 0 0 1 -0.762,0.762z", "data-name": "Path 1395", id: "Path_1395" })))), /* @__PURE__ */ k.createElement("g", { transform: "rotate(45 6.64893 59.9369)", "data-name": "Group 1855", id: "Group_1855" }, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1851", id: "Group_1851" }, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1849", id: "Group_1849" }, /* @__PURE__ */ k.createElement("path", { fill: "#bcc3cd", d: "m8.98302,65.3989l-1.572,0a0.762,0.762 0 0 1 -0.762,-0.762a0.762,0.762 0 0 1 0.762,-0.762l1.572,0a0.762,0.762 0 0 1 0.762,0.762a0.762,0.762 0 0 1 -0.762,0.762z", "data-name": "Path 1396", id: "Path_1396" })), /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1850", id: "Group_1850" }, /* @__PURE__ */ k.createElement("path", { fill: "#bcc3cd", d: "m15.29097,65.3989l-1.572,0a0.762,0.762 0 0 1 -0.762,-0.762a0.762,0.762 0 0 1 0.762,-0.762l1.572,0a0.762,0.762 0 0 1 0.762,0.762a0.762,0.762 0 0 1 -0.762,0.762z", "data-name": "Path 1397", id: "Path_1397" }))), /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1854", id: "Group_1854" }, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1852", id: "Group_1852" }, /* @__PURE__ */ k.createElement("path", { fill: "#bcc3cd", d: "m11.34989,63.03291a0.762,0.762 0 0 1 -0.762,-0.762l0,-1.572a0.762,0.762 0 0 1 0.762,-0.762a0.762,0.762 0 0 1 0.762,0.762l0,1.572a0.762,0.762 0 0 1 -0.762,0.762z", "data-name": "Path 1398", id: "Path_1398" })), /* @__PURE__ */ k.createElement("g", { "data-name": "Group 1853", id: "Group_1853" }, /* @__PURE__ */ k.createElement("path", { fill: "#bcc3cd", d: "m11.34989,69.34088a0.762,0.762 0 0 1 -0.762,-0.762l0,-1.572a0.762,0.762 0 0 1 0.762,-0.762a0.762,0.762 0 0 1 0.762,0.762l0,1.572a0.762,0.762 0 0 1 -0.762,0.762z", "data-name": "Path 1399", id: "Path_1399" }))))), /* @__PURE__ */ k.createElement("g", { stroke: "#838eaa", fill: "none", "data-name": "Ellipse 378", id: "Ellipse_378" }, /* @__PURE__ */ k.createElement("circle", { id: "svg_1", r: 3, cy: 8.83789, cx: 9.47095 }), /* @__PURE__ */ k.createElement("circle", { id: "svg_2", fill: "none", r: 2.5, cy: 8.83789, cx: 9.47095 })), /* @__PURE__ */ k.createElement("g", { stroke: "#838eaa", fill: "none", "data-name": "Ellipse 383", id: "Ellipse_383" }, /* @__PURE__ */ k.createElement("circle", { id: "svg_3", r: 3, cy: 62.83789, cx: 96.47095 }), /* @__PURE__ */ k.createElement("circle", { id: "svg_4", fill: "none", r: 2.5, cy: 62.83789, cx: 96.47095 }))))), /* @__PURE__ */ k.createElement("g", { "data-name": "checked(2)", id: "checked_2_" }, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 2843", id: "Group_2843" }, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 2842", id: "Group_2842" }, /* @__PURE__ */ k.createElement("path", { fill: "#4eb7a1", d: "m71.684,20.127a1.733,1.733 0 0 0 -2.451,0l-20.8,20.743l-7.5,-8.15a1.734,1.734 0 1 0 -2.551,2.349l8.726,9.477a1.732,1.732 0 0 0 1.238,0.559l0.037,0a1.735,1.735 0 0 0 1.224,-0.506l22.075,-22.018a1.733,1.733 0 0 0 0.002,-2.454z", "data-name": "Path 1968", id: "Path_1968" }))), /* @__PURE__ */ k.createElement("g", { "data-name": "Group 2845", id: "Group_2845" }, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 2844", id: "Group_2844" }, /* @__PURE__ */ k.createElement("path", { fill: "#4eb7a1", d: "m71.266,35.104a1.734,1.734 0 0 0 -1.733,1.734a19.533,19.533 0 1 1 -19.533,-19.533a1.734,1.734 0 1 0 0,-3.467a23,23 0 1 0 23,23a1.734,1.734 0 0 0 -1.734,-1.734z", "data-name": "Path 1969", id: "Path_1969" })))))), PN = W.div.attrs(() => ({
  className: "msd__popup-content"
}))`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin: auto;
  width: 80%;
  max-width: 376px;

  form {
    border: unset;
    margin-top: 16px;
  }

  ${pr.small`
      width: 90%;
  `}
`, _lt = W.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 376px;

  gap: 12px;
  margin-top: 24px;
  padding: 0 32px 0 32px;

  button {
    &:first-child {
      flex: 1;
    }

    &:last-child {
      flex: 2;
    }
  }
`, Rue = W.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > button {
    max-width: 320px;
    margin-top: 80px;
  }
`, wx = W.h2`
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  margin: 40px 0 24px 0;
  color: ${Et};
`, uR = W.div`
  font-size: 15px;
  font-weight: 300;
  text-align: center;
  max-width: 380px;
  color: ${Et};
  width: 100%;

  p {
    text-align: center;
    margin-bottom: 24px;
  }
`, Clt = W(uR)`
  max-width: 300px;
`, wlt = W(Rue)``, eJ = W.div`
  font-size: 15px;
  font-weight: 300;
  text-align: center;
  max-width: 420px;
  margin: 5px 0;
  color: ${Et};
`, Mue = () => {
  const { t: e } = tn(), t = Va(), [n, r] = mt(1), [a, o] = mt(!1), { recipientEmail: s, deliveryDate: c, deliveryTime: u, message: f } = Ot(I2), { giftId: m, offerId: v, offerTitle: y } = Ot(
    fbe
  ), {
    gift: { deliveryDetails: b, redeemedAt: S, sentAt: x },
    isUpdateLoading: E,
    loading: N
  } = Ot(q6), R = () => st(void 0, null, function* () {
    CD() && (yield t(
      Lx({
        id: m,
        payload: {
          deliveryDetails: {
            recipientEmail: s.value,
            deliveryDate: (/* @__PURE__ */ new Date(
              `${c.value}T${u.value}`
            )).valueOf() / 1e3,
            personalNote: f.value
          }
        }
      })
    ).unwrap().catch(() => {
      o(!0);
    }), r(2));
  });
  mn(() => (m && t(Dx(m)), () => {
    t(Za()), t(zQ());
  }), [m]);
  const O = dle(new Date((b == null ? void 0 : b.deliveryDate) * 1e3)) && !x && !S, D = !!x || !!S;
  return N ? /* @__PURE__ */ C.jsx(
    Oo,
    {
      steps: 2,
      isError: !1,
      currentStep: 1,
      popupTitle: e(
        "edit-delivery-details-popup.title",
        "Edit Delivery Details"
      ),
      children: /* @__PURE__ */ C.jsxs(PN, { children: [
        /* @__PURE__ */ C.jsx(wx, { children: e("edit-delivery-details-popup.header", "Edit Delivery Details") }),
        /* @__PURE__ */ C.jsx(Clt, { children: /* @__PURE__ */ C.jsx(Zn, { height: 32, margin: "0 0 24px 0" }) }),
        /* @__PURE__ */ C.jsx(eR, { isMyAccount: !0 })
      ] })
    }
  ) : n === 1 ? /* @__PURE__ */ C.jsx(
    Oo,
    {
      steps: 2,
      isError: !1,
      currentStep: n,
      popupTitle: e(
        "edit-delivery-details-popup.title",
        "Edit Delivery Details"
      ),
      children: /* @__PURE__ */ C.jsxs(PN, { children: [
        /* @__PURE__ */ C.jsx(wx, { children: e("edit-delivery-details-popup.header", "Edit Delivery Details") }),
        /* @__PURE__ */ C.jsx(uR, { children: O ? /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          e(
            "edit-delivery-details-popup.info-text-1",
            "You are editing information for your"
          ),
          /* @__PURE__ */ C.jsx("p", { children: e(`offer-title-${v}`, y) }),
          e(
            "edit-delivery-details-popup.info-text-2",
            "Please take a moment to update your gift delivery details."
          )
        ] }) : /* @__PURE__ */ C.jsx(C.Fragment, { children: D ? e(
          "edit-delivery-details-popup.info-text-disabled",
          "It is not possible to edit delivery details as the gift has been already sent out to the recipient."
        ) : e(
          "edit-delivery-details-popup.info-text-disabled2",
          "It is not possible to edit delivery details as the gift will be sent to the recipient soon."
        ) }) }),
        /* @__PURE__ */ C.jsx(eR, { isMyAccount: !0 }),
        /* @__PURE__ */ C.jsx(_lt, { children: O ? /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsx(zt, { theme: "simple", onClickFn: () => t(Za()), children: e("edit-delivery-details-popup.button.cancel", "Back") }),
          /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: R, children: E ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : e(
            "edit-delivery-details-popup.button.confirm",
            "Update details"
          ) })
        ] }) : /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: () => t(Za()), children: e(
          "edit-delivery-details-popup.button.back",
          "Back to settings"
        ) }) })
      ] })
    }
  ) : /* @__PURE__ */ C.jsx(
    Oo,
    {
      steps: 2,
      isError: !1,
      currentStep: n,
      popupTitle: e(
        "edit-delivery-details-popup.title",
        "Edit Delivery Details"
      ),
      children: /* @__PURE__ */ C.jsx(PN, { children: a ? /* @__PURE__ */ C.jsxs(wlt, { children: [
        /* @__PURE__ */ C.jsx(V8, {}),
        /* @__PURE__ */ C.jsx(wx, { children: e(
          "edit-delivery-details-popup.thank-you-page.error-header",
          "Failed to update the delivery details"
        ) }),
        /* @__PURE__ */ C.jsx(eJ, { children: /* @__PURE__ */ C.jsx("strong", { children: e(
          "edit-delivery-details-popup.thank-you-page.error-text-1",
          "We weren't able to process your request."
        ) }) }),
        /* @__PURE__ */ C.jsx(eJ, { children: e(
          "edit-delivery-details-popup.thank-you-page.error-text-2",
          "Please try updating the delivery details again in a few minutes."
        ) }),
        /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: () => t(Za()), children: e("edit-delivery-details-popup.button.back", "Back to settings") })
      ] }) : /* @__PURE__ */ C.jsxs(Rue, { children: [
        /* @__PURE__ */ C.jsx(eL, {}),
        /* @__PURE__ */ C.jsx(wx, { children: e(
          "edit-delivery-details-popup.thank-you-page.header",
          "Delivery Details Updated"
        ) }),
        /* @__PURE__ */ C.jsxs(uR, { children: [
          e(
            "edit-delivery-details-popup.thank-you-page.info-text-1",
            "Thank you for updating your delivery details for your"
          ),
          /* @__PURE__ */ C.jsx("p", { children: e(`offer-title-${v}`, y) }),
          e(
            "edit-delivery-details-popup.thank-you-page.info-text-2",
            "Your changes have been saved and will be reflected in your next delivery."
          )
        ] }),
        /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: () => t(Za()), children: e("edit-delivery-details-popup.button.back", "Back to settings") })
      ] }) })
    }
  );
}, Slt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 93.038, height: 68.519, viewBox: "0 0 93.038 68.519" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_2082", "data-name": "Group 2082", transform: "translate(-2412.366 -4291.047)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2006", "data-name": "Group 2006", transform: "translate(-33.477 -7)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2005", "data-name": "Group 2005", transform: "translate(510 3402)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1360", "data-name": "Path 1360", d: "M4165.574-315.591", transform: "translate(-2154.01 1261.792)", fill: "#f2f5fc", stroke: "#838eaa", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 17 }), /* @__PURE__ */ k.createElement("g", { id: "Group_1848", "data-name": "Group 1848", transform: "translate(1935.843 955.162)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1844", "data-name": "Group 1844", transform: "translate(0 3.94)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1842", "data-name": "Group 1842" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1392", "data-name": "Path 1392", d: "M4661.925-156.765h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,4661.925-156.765Z", transform: "translate(-4659.591 158.289)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1843", "data-name": "Group 1843", transform: "translate(6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1393", "data-name": "Path 1393", d: "M4753.007-156.765h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,4753.007-156.765Z", transform: "translate(-4750.673 158.289)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1847", "data-name": "Group 1847", transform: "translate(3.94 0)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1845", "data-name": "Group 1845" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1394", "data-name": "Path 1394", d: "M4717.243-212.082a.761.761,0,0,1-.762-.762v-1.572a.761.761,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,4717.243-212.082Z", transform: "translate(-4716.481 215.178)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1846", "data-name": "Group 1846", transform: "translate(0 6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1395", "data-name": "Path 1395", d: "M4717.243-121a.761.761,0,0,1-.762-.762v-1.572a.761.761,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,4717.243-121Z", transform: "translate(-4716.481 124.097)", fill: "#838eaa" })))), /* @__PURE__ */ k.createElement("g", { id: "Group_1855", "data-name": "Group 1855", transform: "translate(2019.476 896.047)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1851", "data-name": "Group 1851", transform: "translate(0 3.94)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1849", "data-name": "Group 1849" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1396", "data-name": "Path 1396", d: "M3515.983-822.6h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,3515.983-822.6Z", transform: "translate(-3513.649 824.122)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1850", "data-name": "Group 1850", transform: "translate(6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1397", "data-name": "Path 1397", d: "M3607.064-822.6h-1.572a.762.762,0,0,1-.762-.762.762.762,0,0,1,.762-.762h1.572a.762.762,0,0,1,.762.762A.762.762,0,0,1,3607.064-822.6Z", transform: "translate(-3604.73 824.122)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_1854", "data-name": "Group 1854", transform: "translate(3.94 0)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_1852", "data-name": "Group 1852" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1398", "data-name": "Path 1398", d: "M3571.3-877.916a.762.762,0,0,1-.762-.762v-1.572a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,3571.3-877.916Z", transform: "translate(-3570.539 881.012)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_1853", "data-name": "Group 1853", transform: "translate(0 6.308)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1399", "data-name": "Path 1399", d: "M3571.3-786.834a.762.762,0,0,1-.762-.762v-1.572a.762.762,0,0,1,.762-.762.762.762,0,0,1,.762.762v1.572A.762.762,0,0,1,3571.3-786.834Z", transform: "translate(-3570.539 789.93)", fill: "#838eaa" })))))), /* @__PURE__ */ k.createElement("g", { id: "Group_2054", "data-name": "Group 2054", transform: "translate(-2023.767 -990.733)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2031", "data-name": "Group 2031", transform: "translate(4453.765 5294.31)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1543", "data-name": "Path 1543", d: "M4508.615,5435h-49.222a5.377,5.377,0,0,1-5.613-5.09v-41.1q-.015-.174-.016-.347a.633.633,0,0,1,.016-.141v-.023a5.4,5.4,0,0,1,.931-3.553c.85-1.034,2.323-1.537,4.5-1.537a.641.641,0,1,1,0,1.283c-1.773,0-2.923.35-3.514,1.069a4.337,4.337,0,0,0-.64,2.739v.45a2.757,2.757,0,0,0,.922,1.755,4.691,4.691,0,0,0,3.2,1.023h49.431a5.377,5.377,0,0,1,5.613,5.09v33.287A5.378,5.378,0,0,1,4508.615,5435Zm-53.552-43.587v38.5a4.1,4.1,0,0,0,4.33,3.807h49.222a4.1,4.1,0,0,0,4.33-3.807v-33.287a4.1,4.1,0,0,0-4.33-3.807h-49.431A5.853,5.853,0,0,1,4455.063,5391.412Z", transform: "translate(-4453.765 -5383.213)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2032", "data-name": "Group 2032", transform: "translate(4458.576 5294.31)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1544", "data-name": "Path 1544", d: "M4567.38,5389.65a.641.641,0,0,1-.641-.642v-2.944a1.716,1.716,0,0,0-1.829-1.569h-46.761a.641.641,0,1,1,0-1.283h46.761a2.993,2.993,0,0,1,3.111,2.852v2.944A.641.641,0,0,1,4567.38,5389.65Z", transform: "translate(-4517.508 -5383.213)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2033", "data-name": "Group 2033", transform: "translate(4500.605 5318.54)" }, /* @__PURE__ */ k.createElement("rect", { id: "Rectangle_2771", "data-name": "Rectangle 2771", width: 17.254, height: 9.984, rx: 4.992, transform: "translate(0.641 0.641)", fill: "#f2f5fc" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1545", "data-name": "Path 1545", d: "M5088.83,5715.552H5075.6a1.154,1.154,0,0,1-1.152-1.152v-8.962a1.153,1.153,0,0,1,1.152-1.152h13.232a1.154,1.154,0,0,1,1.152,1.152v8.962A1.154,1.154,0,0,1,5088.83,5715.552Zm-13.1-1.283H5088.7v-8.7h-12.971Z", transform: "translate(-5074.445 -5704.285)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2040", "data-name": "Group 2040", transform: "translate(4459.114 5306.4)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2034", "data-name": "Group 2034", transform: "translate(0)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_43", "data-name": "Line 43", x1: 4.259, y1: 0.018, transform: "translate(0.641 0.641)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1546", "data-name": "Path 1546", d: "M4529.548,5544.723h0l-4.259-.018a.641.641,0,0,1,0-1.283h0l4.259.017a.642.642,0,0,1,0,1.283Z", transform: "translate(-4524.648 -5543.423)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2035", "data-name": "Group 2035", transform: "translate(8.613)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_44", "data-name": "Line 44", x1: 4.259, y1: 0.018, transform: "translate(0.641 0.641)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1547", "data-name": "Path 1547", d: "M4643.68,5544.723h0l-4.259-.018a.641.641,0,0,1,0-1.283h0l4.259.017a.642.642,0,0,1,0,1.283Z", transform: "translate(-4638.78 -5543.423)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2036", "data-name": "Group 2036", transform: "translate(17.226)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_45", "data-name": "Line 45", x1: 4.259, y1: 0.018, transform: "translate(0.641 0.641)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1548", "data-name": "Path 1548", d: "M4757.812,5544.723h0l-4.259-.018a.641.641,0,0,1,0-1.283h0l4.259.017a.642.642,0,0,1,0,1.283Z", transform: "translate(-4752.911 -5543.423)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2037", "data-name": "Group 2037", transform: "translate(25.839)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_46", "data-name": "Line 46", x1: 4.259, y1: 0.018, transform: "translate(0.641 0.641)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1549", "data-name": "Path 1549", d: "M4871.942,5544.723h0l-4.259-.018a.641.641,0,0,1,0-1.283h0l4.259.017a.642.642,0,0,1,0,1.283Z", transform: "translate(-4867.042 -5543.423)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2038", "data-name": "Group 2038", transform: "translate(34.452)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_47", "data-name": "Line 47", x1: 4.259, y1: 0.018, transform: "translate(0.641 0.641)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1550", "data-name": "Path 1550", d: "M4986.073,5544.723h0l-4.259-.018a.641.641,0,0,1,0-1.283h0l4.259.017a.642.642,0,0,1,0,1.283Z", transform: "translate(-4981.173 -5543.423)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2039", "data-name": "Group 2039", transform: "translate(43.065)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_48", "data-name": "Line 48", x1: 4.259, y1: 0.018, transform: "translate(0.641 0.641)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1551", "data-name": "Path 1551", d: "M5100.206,5544.723h0l-4.259-.018a.641.641,0,0,1,0-1.283h0l4.259.017a.642.642,0,0,1,0,1.283Z", transform: "translate(-5095.306 -5543.423)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_2047", "data-name": "Group 2047", transform: "translate(4459.114 5340.95)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2041", "data-name": "Group 2041", transform: "translate(0 0)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_49", "data-name": "Line 49", x1: 4.259, y1: 0.018, transform: "translate(0.641 0.641)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1552", "data-name": "Path 1552", d: "M4529.548,6002.544h0l-4.259-.018a.641.641,0,0,1,0-1.283h0l4.259.018a.641.641,0,0,1,0,1.283Z", transform: "translate(-4524.648 -6001.244)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2042", "data-name": "Group 2042", transform: "translate(8.613 0)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_50", "data-name": "Line 50", x1: 4.259, y1: 0.018, transform: "translate(0.641 0.641)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1553", "data-name": "Path 1553", d: "M4643.68,6002.544h0l-4.259-.018a.641.641,0,0,1,0-1.283h0l4.259.018a.641.641,0,0,1,0,1.283Z", transform: "translate(-4638.78 -6001.244)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2043", "data-name": "Group 2043", transform: "translate(17.226 0)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_51", "data-name": "Line 51", x1: 4.259, y1: 0.018, transform: "translate(0.641 0.641)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1554", "data-name": "Path 1554", d: "M4757.812,6002.544h0l-4.259-.018a.641.641,0,0,1,0-1.283h0l4.259.018a.641.641,0,0,1,0,1.283Z", transform: "translate(-4752.911 -6001.244)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2044", "data-name": "Group 2044", transform: "translate(25.839 0)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_52", "data-name": "Line 52", x1: 4.259, y1: 0.018, transform: "translate(0.641 0.641)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1555", "data-name": "Path 1555", d: "M4871.942,6002.544h0l-4.259-.018a.641.641,0,0,1,0-1.283h0l4.259.018a.641.641,0,0,1,0,1.283Z", transform: "translate(-4867.042 -6001.244)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2045", "data-name": "Group 2045", transform: "translate(34.452 0)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_53", "data-name": "Line 53", x1: 4.259, y1: 0.018, transform: "translate(0.641 0.641)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1556", "data-name": "Path 1556", d: "M4986.073,6002.544h0l-4.259-.018a.641.641,0,0,1,0-1.283h0l4.259.018a.641.641,0,0,1,0,1.283Z", transform: "translate(-4981.173 -6001.244)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2046", "data-name": "Group 2046", transform: "translate(43.065 0)" }, /* @__PURE__ */ k.createElement("line", { id: "Line_54", "data-name": "Line 54", x1: 4.259, y1: 0.018, transform: "translate(0.641 0.641)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1557", "data-name": "Path 1557", d: "M5100.206,6002.544h0l-4.259-.018a.641.641,0,0,1,0-1.283h0l4.259.018a.641.641,0,0,1,0,1.283Z", transform: "translate(-5095.306 -6001.244)", fill: "#838eaa" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_2048", "data-name": "Group 2048", transform: "translate(4459.547 5287.053)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1558", "data-name": "Path 1558", d: "M4538.884,5306.217l27.637-10.664.852,2.3", transform: "translate(-4538.242 -5294.912)", fill: "#fff" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1559", "data-name": "Path 1559", d: "M4531.023,5299a.642.642,0,0,1-.231-1.24l27.637-10.664a.642.642,0,0,1,.833.375l.851,2.3a.642.642,0,1,1-1.2.446l-.625-1.687-27.03,10.43A.651.651,0,0,1,4531.023,5299Z", transform: "translate(-4530.382 -5287.053)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2049", "data-name": "Group 2049", transform: "translate(4472.983 5287.853)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1560", "data-name": "Path 1560", d: "M4716.931,5315.954l25.4-9.8,3.652,9.067", transform: "translate(-4716.29 -5305.514)", fill: "#f2f5fc" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1561", "data-name": "Path 1561", d: "M4709.07,5308.734a.642.642,0,0,1-.231-1.24l25.4-9.8a.64.64,0,0,1,.826.358l3.652,9.067a.641.641,0,0,1-1.19.479l-3.416-8.48-24.806,9.571A.643.643,0,0,1,4709.07,5308.734Z", transform: "translate(-4708.428 -5297.652)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2050", "data-name": "Group 2050", transform: "translate(4468.523 5288.796)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1562", "data-name": "Path 1562", d: "M4656.364,5317.993l-7.039-.591,18.805-7.252,1.059,2.9", transform: "translate(-4649.326 -5310.149)", fill: "#f2f5fc" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2051", "data-name": "Group 2051", transform: "translate(4459.143 5312.722)" }, /* @__PURE__ */ k.createElement("circle", { id: "Ellipse_391", "data-name": "Ellipse 391", cx: 10.962, cy: 10.962, r: 10.962, transform: "translate(0.641 0.642)", fill: "#f2f5fc" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1563", "data-name": "Path 1563", d: "M4536.636,5650.4a11.6,11.6,0,1,1,11.6-11.6A11.617,11.617,0,0,1,4536.636,5650.4Zm0-21.924a10.321,10.321,0,1,0,10.32,10.321A10.332,10.332,0,0,0,4536.636,5628.474Z", transform: "translate(-4525.032 -5627.191)", fill: "#838eaa" })), /* @__PURE__ */ k.createElement("g", { id: "Group_2053", "data-name": "Group 2053", transform: "translate(4469.259 5318.411)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2052", "data-name": "Group 2052", transform: "translate(0 0)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1564", "data-name": "Path 1564", d: "M4660.584,5702.57c.595,0,1.452.1,1.47.77a6.353,6.353,0,0,1-.07.77c-.175,1.12-.683,3.868-.98,6.073h-.84c-.245-2.03-.752-4.812-.962-6.02a4.479,4.479,0,0,1-.123-.823C4659.079,5702.728,4659.954,5702.57,4660.584,5702.57Zm.017,11.83a1.461,1.461,0,1,1,1.435-1.47A1.383,1.383,0,0,1,4660.6,5714.4Z", transform: "translate(-4659.079 -5702.57)", fill: "#838eaa" })))))), NN = W.article.attrs(() => ({
  className: "msd__transactions__wrapper"
}))`
  position: relative;

  margin-bottom: 20px;

  ${pr.small`
    button{
      width: 100%;
    }
  `}
`, Due = W.li.attrs(() => ({
  className: "msd__transactions__item"
}))`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  padding: 18px 0;
  border-bottom: 1px solid ${Gn};
  gap: 6px;

  &:first-child {
    padding: 0 0 18px 0;
  }

  &:last-child {
    padding: 18px 0 0 0;
    border-bottom: none;
  }

  &:only-child {
    border-bottom: none;
    padding: unset;
  }

  ${pr.small`
    flex-direction: column;
  `}
`, xlt = W.ul.attrs(() => ({
  className: "msd__transactions__list"
}))`
  overflow: hidden;
`, Lue = W.div`
  display: flex;
`, $ue = W.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-shrink: 0;
  margin-inline-start: 60px;
  text-align: end;
  justify-content: center;
`, jue = W.h3.attrs(() => ({
  className: "msd__transaction__title"
}))`
  color: ${Et};

  font-size: 13px;
  font-weight: 700;
  line-height: 15px;
  margin: 0;
`, Fue = W.div.attrs(() => ({
  className: "msd__transaction__subtitle"
}))`
  margin-top: 6px;

  color: ${Et};

  font-size: 12px;
`, Bue = W.div.attrs(() => ({
  className: "msd__transaction__id"
}))`
  color: #727583cc;
  margin-top: 6px;

  font-size: 12px;
`, Vue = W.time.attrs(() => ({
  className: "msd__transaction__date"
}))`
  margin-top: 6px;
  color: #727583cc;

  font-size: 12px;
`, Elt = W.span.attrs(() => ({
  className: "msd__transactions__button-text"
}))`
  position: relative;
  line-height: 1.2;
  &:after {
    position: absolute;
    right: -20px;
    bottom: 0;
    font-size: 11px;
    transform: scaleY(0.8) rotate(0deg);
    transition: all 0.3s ease-in-out;
    content: '▼';
    ${(e) => e.$isExpanded && ot`
        transform: scaleY(0.8) rotateX(180deg);
      `}
  }
`, Ilt = W.div`
  display: flex;
  height: 42px;
  width: 42px;
  justify-content: center;
  align-items: center;
  border: 1px solid #d4d4df;
  border-radius: 6px;
  padding: 0 5px;
  svg {
    height: auto;
  }
`, Uue = W.div`
  margin-inline-start: 18px;
`, klt = W.div`
  display: flex;
  align-items: center;
  gap: 4px;
`, tJ = W.span`
  margin-top: 5px;
  font-size: 12px;
  font-weight: 800;
  color: #727583cc;
`, Alt = W.p`
  font-weight: 600;
  font-size: 12px;
  text-decoration: underline;
  color: ${An};

  &:hover {
    cursor: pointer;
  }

  ${pr.small`
    text-align: start;
  `}
`, Plt = () => /* @__PURE__ */ C.jsx(Uu, { withBorder: !0, children: [...Array(3)].map((e, t) => (
  // eslint-disable-next-line react/no-array-index-key
  /* @__PURE__ */ C.jsxs(Due, { children: [
    /* @__PURE__ */ C.jsxs(Lue, { children: [
      /* @__PURE__ */ C.jsx(Zn, { height: 40, width: 40 }),
      /* @__PURE__ */ C.jsxs(Uue, { children: [
        /* @__PURE__ */ C.jsx(jue, { children: /* @__PURE__ */ C.jsx(Zn, { width: 260 }) }),
        /* @__PURE__ */ C.jsx(Fue, { children: /* @__PURE__ */ C.jsx(Zn, { width: 100 }) })
      ] })
    ] }),
    /* @__PURE__ */ C.jsxs($ue, { children: [
      /* @__PURE__ */ C.jsx(Bue, { children: /* @__PURE__ */ C.jsx(Zn, { width: 80 }) }),
      /* @__PURE__ */ C.jsx(Vue, { children: /* @__PURE__ */ C.jsx(Zn, { width: 80 }) })
    ] })
  ] }, `skeleton-item-${t}`)
)) }), Gue = () => {
  const { transactions: e, showToggleButton: t, error: n, loading: r, isListExpanded: a } = Ot((v) => v.transactions), { pauseOffersIDs: o } = Ot(J6), { isOpen: s, currentType: c } = Ot(N_), { t: u } = tn(), f = Va(), m = a ? e : e.slice(0, mT);
  return mn(() => ((e == null ? void 0 : e.length) === 0 && f(Gx()).then(() => {
    f(Abe(o));
  }), () => {
    c === su.EDIT_DELIVERY_DETAILS_POPUP && f(Za());
  }), []), r ? /* @__PURE__ */ C.jsx(Plt, {}) : n.length !== 0 ? /* @__PURE__ */ C.jsx(NN, { children: /* @__PURE__ */ C.jsx(Ml, { generalError: !0 }) }) : e.length === 0 ? /* @__PURE__ */ C.jsx(NN, { children: /* @__PURE__ */ C.jsx(
    Ml,
    {
      icon: Slt,
      title: u(
        "transactions.no-transactions.title",
        "No transactions found!"
      ),
      subtitle: u(
        "transactions.no-transactions.subtitle",
        "The section will show you recent transactions history after first payment"
      )
    }
  ) }) : s && c === su.EDIT_DELIVERY_DETAILS_POPUP ? /* @__PURE__ */ C.jsx(Mue, {}) : /* @__PURE__ */ C.jsx(NN, { children: /* @__PURE__ */ C.jsxs(Uu, { withBorder: !0, children: [
    /* @__PURE__ */ C.jsx(xlt, { children: m.map(
      ({
        paymentMethod: v,
        transactionId: y,
        offerId: b,
        offerTitle: S,
        transactionDate: x,
        targetType: E,
        targetId: N
      }) => {
        const R = E === "giftId" ? cq.gift : cq[v];
        return /* @__PURE__ */ C.jsxs(Due, { children: [
          /* @__PURE__ */ C.jsxs(Lue, { children: [
            /* @__PURE__ */ C.jsx(Ilt, { children: R && /* @__PURE__ */ C.jsx(R, {}) }),
            /* @__PURE__ */ C.jsxs(Uue, { children: [
              /* @__PURE__ */ C.jsx(jue, { children: u(`offer-title-${b}`, S) }),
              /* @__PURE__ */ C.jsxs(klt, { children: [
                /* @__PURE__ */ C.jsx(Fue, { children: u(
                  `paymentmethod.${v}`,
                  Ptt[v]
                ) }),
                /* @__PURE__ */ C.jsx(tJ, { children: "·" }),
                /* @__PURE__ */ C.jsx(Bue, { children: y }),
                /* @__PURE__ */ C.jsx(tJ, { children: "·" }),
                /* @__PURE__ */ C.jsx(Vue, { dateTime: Ko(x), children: Ko(x) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ C.jsx($ue, { children: E === "giftId" && /* @__PURE__ */ C.jsx(
            Alt,
            {
              onClick: () => {
                f(
                  Ed({
                    type: su.EDIT_DELIVERY_DETAILS_POPUP,
                    data: {
                      action: "editDeliveryDetails",
                      giftId: N,
                      offerId: b,
                      offerTitle: S
                    }
                  })
                );
              },
              role: "button",
              children: u(
                "transactions.edit-gift-delivery-details",
                "Edit gift delivery details"
              )
            }
          ) })
        ] }, y);
      }
    ) }),
    t && /* @__PURE__ */ C.jsx(
      zt,
      {
        theme: "primary",
        margin: "20px 0 0 auto",
        width: "unset",
        label: a ? u("transactions.show-less", "Show less") : u("transactions.show-more", "Show more"),
        onClickFn: () => f(kbe()),
        padding: "12px 33px 12px 20px",
        children: /* @__PURE__ */ C.jsx(Elt, { $isExpanded: a, children: a ? u("transactions.show-less", "Show less") : u("transactions.show-more", "Show more") })
      }
    )
  ] }) });
}, Nlt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 26.181, height: 31.416, viewBox: "0 0 26.181 31.416" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#1c1c1c;}")), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M28.181,23.049c-1.029,2.985-4.109,8.269-7.282,8.327-2.1.041-2.782-1.248-5.188-1.248s-3.157,1.208-5.147,1.287C7.2,31.544,2,23.787,2,17.022c0-6.214,4.33-9.294,8.114-9.351,2.029-.037,3.945,1.368,5.183,1.368S18.866,7.35,21.312,7.6a7.342,7.342,0,0,1,5.745,3.112c-4.9,3.2-4.134,9.882,1.123,12.339ZM21.345,0c-3.7.149-6.718,4.031-6.3,7.24C18.468,7.506,21.748,3.673,21.345,0Z", transform: "translate(-2)" })), zue = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 65.556 17.469" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#5a9dd8;}")), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M38.683,24.669H36.228a.709.709,0,0,0-.586.311l-3.386,4.986-1.434-4.791a.71.71,0,0,0-.679-.505H27.73a.425.425,0,0,0-.4.562l2.7,7.933L27.489,36.75a.425.425,0,0,0,.347.671h2.452a.712.712,0,0,0,.583-.3l8.162-11.78a.425.425,0,0,0-.349-.667ZM22.275,29.422a2.723,2.723,0,0,1-2.756,2.332A1.892,1.892,0,0,1,17.5,29.379a2.732,2.732,0,0,1,2.736-2.349,2.056,2.056,0,0,1,1.628.665,2.1,2.1,0,0,1,.414,1.727Zm3.4-4.753H23.237a.425.425,0,0,0-.42.359l-.107.682-.17-.247a3.478,3.478,0,0,0-2.885-1.024,5.615,5.615,0,0,0-5.45,4.912,4.607,4.607,0,0,0,.909,3.751,3.82,3.82,0,0,0,3.075,1.241,4.675,4.675,0,0,0,3.381-1.4l-.109.678a.425.425,0,0,0,.42.491h2.2a.708.708,0,0,0,.7-.6l1.32-8.359a.425.425,0,0,0-.42-.49Zm-14.653.058c-.279,1.83-1.676,1.83-3.029,1.83h-.77l.539-3.417a.424.424,0,0,1,.42-.359H8.54c.92,0,1.79,0,2.238.524a1.7,1.7,0,0,1,.248,1.422Zm-.588-4.776h-5.1a.708.708,0,0,0-.7.6L2.576,33.625a.425.425,0,0,0,.42.491H5.431a.708.708,0,0,0,.7-.6l.557-3.528a.708.708,0,0,1,.7-.6H9c3.359,0,5.3-1.625,5.8-4.847a3.926,3.926,0,0,0-.65-3.29,4.727,4.727,0,0,0-3.716-1.3Zm54.489.359L62.833,33.625a.425.425,0,0,0,.42.491h2.1a.708.708,0,0,0,.7-.6l2.064-13.075a.425.425,0,0,0-.42-.491H65.346a.425.425,0,0,0-.42.359Zm-6.281,9.111a2.723,2.723,0,0,1-2.756,2.332,1.892,1.892,0,0,1-2.022-2.374A2.732,2.732,0,0,1,56.6,27.03a2.056,2.056,0,0,1,1.628.665,2.1,2.1,0,0,1,.414,1.727Zm3.4-4.753H59.606a.425.425,0,0,0-.42.359l-.107.682-.171-.247a3.476,3.476,0,0,0-2.884-1.024,5.615,5.615,0,0,0-5.45,4.912,4.607,4.607,0,0,0,.909,3.751,3.82,3.82,0,0,0,3.075,1.241,4.675,4.675,0,0,0,3.381-1.4l-.109.678a.425.425,0,0,0,.42.491h2.2a.708.708,0,0,0,.7-.6l1.32-8.359a.425.425,0,0,0-.42-.491Zm-14.653.058c-.279,1.83-1.676,1.83-3.029,1.83H43.6l.539-3.417a.424.424,0,0,1,.42-.359h.353c.92,0,1.79,0,2.238.524a1.705,1.705,0,0,1,.247,1.422Zm-.588-4.776h-5.1a.708.708,0,0,0-.7.6L38.946,33.625a.425.425,0,0,0,.42.491h2.616a.5.5,0,0,0,.49-.418l.585-3.707a.708.708,0,0,1,.7-.6h1.613c3.359,0,5.3-1.625,5.8-4.847a3.926,3.926,0,0,0-.65-3.29,4.727,4.727,0,0,0-3.716-1.3Z", transform: "translate(-2.571 -19.952)" })), Tlt = (e, t, n) => st(void 0, null, function* () {
  const a = `${or()}/connectors/adyen/payment-details`, {
    paymentMethods: { selectedPaymentMethod: o }
  } = Mo.getState(), s = o.id;
  try {
    return (yield Mr(a, {
      method: "POST",
      body: JSON.stringify({
        paymentMethod: e,
        paymentMethodId: s,
        browserInfo: t,
        billingAddress: n,
        origin: window.location.origin,
        returnUrl: $7({
          queryParams: { paymentMethodId: s },
          isMyAccount: !0
        })
      })
    })).json();
  } catch (c) {
    return c;
  }
}), Olt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ width: 28, height: 22.519, xmlns: "http://www.w3.org/2000/svg" }, e), /* @__PURE__ */ k.createElement("g", null, /* @__PURE__ */ k.createElement("g", { "data-name": "Group 2833", id: "Group_2833" }, /* @__PURE__ */ k.createElement("path", { fill: "#bcc3cd", d: "m9.43796,22.01889l-2.783,0a0.826,0.826 0 0 1 -0.839,-1.058l0.134,-0.6l1.856,0a1.431,1.431 0 0 0 1.329,-1.061l0.954,-4.117a1.434,1.434 0 0 1 1.327,-1.058l0.791,0q5.1,0 7.926,-2.1a6.529,6.529 0 0 0 2.833,-5.5a5.266,5.266 0 0 0 -0.527,-2.5c0,-0.014 -0.014,-0.028 -0.014,-0.041l0.121,0.067a4.146,4.146 0 0 1 1.534,1.627a5.228,5.228 0 0 1 0.536,2.5a6.513,6.513 0 0 1 -2.837,5.5c-1.883,1.385 -4.533,2.084 -7.921,2.084l-0.806,0a1.432,1.432 0 0 0 -1.331,1.063l-0.954,4.129a1.42,1.42 0 0 1 -1.32,1.046l-0.009,0.019zm-2.401,-2.419l-2.784,0a0.827,0.827 0 0 1 -0.839,-1.058l3.921,-16.982a1.43,1.43 0 0 1 1.328,-1.06l5.8,0a18.264,18.264 0 0 1 3.271,0.259a6.875,6.875 0 0 1 2.407,0.888a4.133,4.133 0 0 1 1.522,1.63a5.4,5.4 0 0 1 0.524,2.508a6.474,6.474 0 0 1 -2.84,5.486c-1.883,1.4 -4.533,2.086 -7.923,2.086l-0.793,0a1.429,1.429 0 0 0 -1.325,1.048l-0.951,4.115a1.43,1.43 0 0 1 -1.332,1.051l0.014,0.029zm6.677,-15.571l-0.909,0a1.427,1.427 0 0 0 -1.327,1.056l-0.831,3.605a0.824,0.824 0 0 0 0.834,1.057l0.687,0a5.857,5.857 0 0 0 3.5,-0.915a3.053,3.053 0 0 0 1.251,-2.611a1.839,1.839 0 0 0 -0.807,-1.65a4.349,4.349 0 0 0 -2.408,-0.542l0.017,0l-0.007,0z", "data-name": "Icon simple-paypal", id: "Icon_simple-paypal" })))), Rlt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 13.748, height: 17.676, viewBox: "0 0 13.748 17.676" }, e), /* @__PURE__ */ k.createElement("path", { id: "Icon_material-delete", "data-name": "Icon material-delete", d: "M8.482,20.212a1.97,1.97,0,0,0,1.964,1.964H18.3a1.97,1.97,0,0,0,1.964-1.964V8.428H8.482ZM21.248,5.482H17.811L16.829,4.5h-4.91l-.982.982H7.5V7.446H21.248Z", transform: "translate(-7.5 -4.5)", fill: "#cb4477" })), Hue = W.div.attrs(() => ({
  className: "msd__popup-content__payment-method-img"
}))`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  margin: 0 auto 40px auto;
`;
W((e) => /* @__PURE__ */ C.jsx(Olt, Fe({}, e)))`
  margin-right: 10px;
  filter: brightness(0) invert(1);
`;
const Mlt = W.p.attrs(() => ({
  className: "msd__popup-content__erro"
}))`
  width: 100%;
  color: ${wa};
  margin: 10px 0;
  text-align: center;
`, Dlt = W.a.attrs(() => ({
  className: "msd__popup-content__error-link"
}))`
  color: ${wa};
  text-decoration: underline;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  &:hover {
    text-decoration: underline;
  }
`, Llt = W((e) => /* @__PURE__ */ C.jsx(Rlt, Fe({}, e)))`
  margin-inline-end: 10px;
  font-size: 9px;
`, Wue = W.div.attrs(() => ({
  className: "msd__popup-content__payment-method-image"
}))`
  border: 1px solid ${Gn};
  border-radius: 10px;
  padding: 15px 25px;
  max-width: 100px;
  margin: auto auto 30px auto;
  display: flex;
  justify-content: center;
  align-items: center;
`, $lt = W.div`
  margin-bottom: 20px;
`, jlt = () => {
  const { t: e } = tn(), t = Jo();
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(da, { children: [
      /* @__PURE__ */ C.jsx(Hue, { children: /* @__PURE__ */ C.jsx(eL, {}) }),
      /* @__PURE__ */ C.jsx(Aa, { children: e("update-payment-details-popup.success.title", "Success") }),
      /* @__PURE__ */ C.jsx(Cr, { children: e(
        "update-payment-details-popup.success.info",
        "Your payment details have been updated and will be visible on your account shortly."
      ) })
    ] }),
    /* @__PURE__ */ C.jsx(Oa, { $removeMargin: !0, children: /* @__PURE__ */ C.jsx(
      zt,
      {
        theme: "simple",
        onClickFn: () => t(gee()),
        children: e(
          "update-payment-details-popup.success.back",
          "Back to Payment Details"
        )
      }
    ) })
  ] });
}, Zue = (e) => st(void 0, null, function* () {
  const n = `${or()}/payment_details/${e}`;
  return (yield Mr(n, {
    method: "DELETE"
  })).json();
}), Flt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 54.665, height: 17.671, viewBox: "0 0 54.665 17.671" }, e), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("style", null, ".a{fill:#344daa;}")), /* @__PURE__ */ k.createElement("path", { className: "a", d: "M11.779,20.811a1.779,1.779,0,0,0-2-1.442H2.623l-.053.346c4.911,1.255,8.942,3.924,10.757,8.969l-1.549-7.874Zm2,10.25-.453-2.376a10.716,10.716,0,0,0-5.767-5.82l3.6,13.614h4.672L22.8,19.369H18.1L13.781,31.061Zm12.466,5.444L29.021,19.37h-4.43L21.815,36.505Zm12.09-17.429c-4.378,0-7.446,2.323-7.473,5.658-.027,2.457,2.189,3.817,3.87,4.646,1.736.827,2.3,1.387,2.3,2.134,0,1.148-1.387,1.656-2.642,1.656a8.4,8.4,0,0,1-4.164-.881l-.588-.294-.614,3.843a12.909,12.909,0,0,0,4.938.909c4.644.027,7.662-2.3,7.714-5.845,0-1.949-1.2-3.417-3.737-4.646-1.547-.772-2.481-1.335-2.481-2.134,0-.72.8-1.469,2.535-1.469a7.362,7.362,0,0,1,3.309.642l.4.212.613-3.71a11.011,11.011,0,0,0-3.977-.721Zm11.905.294a2.191,2.191,0,0,0-2.323,1.442L41.353,36.505H46c.749-2.107.936-2.563.936-2.563h5.658s.135.588.533,2.563h4.111L53.659,19.37H50.243ZM48.186,30.421s.373-.988,1.763-4.778c-.027.027.373-.988.588-1.628l.319,1.469c.827,4.084,1.016,4.938,1.016,4.938H48.186Z", transform: "translate(-2.571 -19.076)" })), TN = {
  paypal: zue,
  visa: Flt
}, tL = ({ paymentDetailsToDelete: e }) => {
  const { t } = tn(), n = Jo(), [r, a] = mt(!1), [o, s] = mt(!1), { initPaymentMethod: c } = wr(
    (y) => y.popupManager.paymentDetails
  ), u = () => {
    window.dispatchEvent(
      new CustomEvent("MSSDK:remove-payment-details-action-confirmed")
    ), a(!1), s(!0), Zue(c.id).then((y) => {
      y.errors.length ? (s(!1), a(!0)) : (s(!1), n(
        pi({ step: js.SUCCESS })
      ), n(Tm()));
    }).catch(() => {
      s(!1), a(!0);
    });
  }, f = () => {
    window.dispatchEvent(
      new CustomEvent("MSSDK:remove-payment-details-action-cancelled")
    ), n(pi({ isOpen: !1 }));
  }, { paymentMethodSpecificParams: m } = e, v = TN[m == null ? void 0 : m.variant] ? TN[m.variant] : TN[e.paymentMethod];
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(da, { children: [
      v && /* @__PURE__ */ C.jsx(Wue, { children: /* @__PURE__ */ C.jsx(v, {}) }),
      /* @__PURE__ */ C.jsx(Aa, { children: t("delete-payment-method.title", "Remove payment method?") }),
      /* @__PURE__ */ C.jsxs(Cr, { children: [
        t(
          "delete-payment-method.remove-info",
          "By clicking the REMOVE button you will delete this payment method."
        ),
        /* @__PURE__ */ C.jsx("br", {}),
        /* @__PURE__ */ C.jsx("br", {}),
        t(
          "delete-payment-method.renewal-info",
          "Any subscriptions connected with this payment method will not be renewed, unless another payment method is added."
        )
      ] }),
      r && /* @__PURE__ */ C.jsx(Mlt, { children: t(
        "oops-something-went-wrong-try-again",
        "Oops, something went wrong! Try again..."
      ) })
    ] }),
    /* @__PURE__ */ C.jsxs(Oa, { $removeMargin: !0, children: [
      /* @__PURE__ */ C.jsx(zt, { theme: "simple", onClickFn: () => f(), children: t("delete-payment-method.resign-button", "No, thanks") }),
      /* @__PURE__ */ C.jsx(zt, { theme: "danger", onClickFn: u, children: o ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : t("delete-payment-method.confirm-button", "Remove") })
    ] })
  ] });
};
tL.propTypes = {
  paymentDetailsToDelete: de.objectOf(de.any)
};
tL.defaultProps = {
  paymentDetailsToDelete: {}
};
const Blt = () => {
  const { t: e } = tn(), t = Jo(), { error: n } = wr((r) => r.finalizeAddPaymentDetails);
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(da, { children: [
      /* @__PURE__ */ C.jsx(Hue, { children: /* @__PURE__ */ C.jsx(V8, {}) }),
      /* @__PURE__ */ C.jsx(Aa, { children: e("oops-something-went-wrong", "Oops! Something went wrong.") }),
      /* @__PURE__ */ C.jsx(Cr, { children: n != null && n.includes("Refused") ? /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "update-payment-details-popup.refused", children: [
        "We weren’t able to update your payment method. ",
        /* @__PURE__ */ C.jsx("br", {}),
        " Please try again."
      ] }) : /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "update-payment-details-popup.error", children: [
        "We weren’t able to update your payment details. ",
        /* @__PURE__ */ C.jsx("br", {}),
        " Please try again using different payment method."
      ] }) })
    ] }),
    /* @__PURE__ */ C.jsx(Oa, { $removeMargin: !0, children: /* @__PURE__ */ C.jsx(
      zt,
      {
        theme: "simple",
        onClickFn: () => t(
          pi({
            step: js.PAYMENT_DETAILS_UPDATE,
            isLoading: !1
          })
        ),
        children: e("update-payment-details-popup.try-again", "Try again")
      }
    ) })
  ] });
}, Vlt = () => {
  const e = new URLSearchParams(window.location.search).get(
    "redirectResult"
  ), t = new URLSearchParams(window.location.search).get(
    "paymentMethodId"
  ), n = Jo(), r = () => {
    n(
      T4({
        paymentMethodId: t,
        details: { redirectResult: e }
      })
    ).unwrap().then(() => {
      n(
        pi({
          step: js.SUCCESS,
          isLoading: !1
        })
      ), n(Tm());
    }).catch(() => {
      n(
        pi({ step: js.ERROR })
      );
    }).finally(() => {
      window.history.replaceState(null, null, window.location.pathname);
    });
  };
  return mn(() => {
    e && t && r();
  }, []), /* @__PURE__ */ C.jsx(cr, {});
}, nJ = {
  amazon: rle,
  apple: Nlt,
  android: _D,
  paypal: zue,
  roku: nle
}, Ult = () => {
  var Z;
  const e = {
    PAYMENT_DETAILS_UPDATE: 1,
    FINALIZE_ADYEN: 2,
    DELETE_PAYMENT_DETAILS: 2,
    SUCCESS: 2,
    ERROR: 2
  }, { isLoading: t, step: n, initPaymentMethod: r } = wr(
    (K) => K.popupManager.paymentDetails
  ), a = Jo(), { t: o } = tn(), [s, c] = mt(null), [u, f] = mt(null), { paymentMethods: m, isPayPalHidden: v } = wr(
    (K) => K.publisherConfig
  ), { paymentDetails: y } = wr((K) => K.paymentDetails), { loading: b } = wr(
    (K) => K.finalizeAddPaymentDetails
  ), [S, x] = mt(!1), E = (K) => {
    const q = m.find(
      ({ methodName: pe }) => pe === K
    );
    a(lee(q));
  };
  if (mn(() => (m.length || j7().then((K) => {
    const { responseData: q } = K;
    if (q) {
      const { paymentMethods: pe } = q;
      a(
        _ee(
          ale(pe)
        )
      );
    }
  }), () => {
    a(gee());
  }), []), r != null && r.bound) {
    const K = nJ[r.paymentMethod];
    return /* @__PURE__ */ C.jsxs(
      Oo,
      {
        steps: 1,
        isError: !1,
        currentStep: e[n],
        popupTitle: o(
          "update-payment-details-popup.title",
          "Update payment details"
        ),
        children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            nJ[r.paymentMethod] && /* @__PURE__ */ C.jsx(Wue, { children: /* @__PURE__ */ C.jsx(K, {}) }),
            /* @__PURE__ */ C.jsx(Aa, { children: o(
              "update-payment-details-popup.cannot-be-managed",
              "It looks like your payments cannot be managed from here"
            ) }),
            /* @__PURE__ */ C.jsxs(Cr, { children: [
              o(
                "update-payment-details-popup.current-method",
                "You are currently paying for your subscription via"
              ),
              " ",
              r.paymentMethod,
              ".",
              /* @__PURE__ */ C.jsx("br", {}),
              /* @__PURE__ */ C.jsx("br", {}),
              o(
                "update-payment-details-popup.cannot-be-changed",
                "This means that your payment information cannot be changed from here right now."
              )
            ] })
          ] }),
          /* @__PURE__ */ C.jsx(Oa, { $removeMargin: !0, children: /* @__PURE__ */ C.jsx(
            zt,
            {
              theme: "simple",
              onClickFn: () => a(pi({ isOpen: !1 })),
              children: o("update-payment-details-popup.back", "Back")
            }
          ) })
        ]
      }
    );
  }
  const N = (K) => {
    const {
      data: { details: q }
    } = K;
    a(
      T4({
        details: q
      })
    ).unwrap().then(() => {
      a(
        pi({
          isOpen: !0,
          isLoading: !1,
          step: js.SUCCESS
        })
      );
    }).catch(() => {
      a(
        pi({
          isOpen: !0,
          isLoading: !1,
          step: js.ERROR
        })
      );
    }).finally(() => {
      x(!1), a(Tm());
    });
  }, R = (K, q) => st(void 0, null, function* () {
    const {
      data: { paymentMethod: pe, browserInfo: he, billingAddress: _e }
    } = K;
    a(pi({ isLoading: !0 }));
    const { errors: ge, responseData: Y } = yield Tlt(
      pe,
      he,
      _e
    );
    if (ge.length) {
      ur(pT), a(
        pi({ step: js.ERROR })
      );
      return;
    }
    if (Y != null && Y.action) {
      Y.action.type !== "redirect" && x(!0), q.handleAction(Y.action);
      return;
    }
    ur(fT), a(
      pi({
        isLoading: !1,
        step: js.SUCCESS
      })
    ), a(Tm());
  }), O = (K, q) => {
    q === Op ? f(K) : c(K);
  }, D = () => {
    var q;
    const K = (q = m.find(
      (pe) => pe.paymentGateway === "paypal" && pe.methodName === "paypal"
    )) == null ? void 0 : q.id;
    a(pi({ isLoading: !0 })), o2e(K).then((pe) => {
      ur(fT), window.location.href = pe.responseData.redirectUrl;
    }).catch(() => {
      ur(pT), a(
        pi({ step: js.ERROR })
      );
    }).finally(() => {
      a(pi({ isLoading: !1 }));
    });
  }, $ = v ? !1 : h6("paypal", m), B = h6("adyen", m), G = () => B ? !!s || !!u : !0;
  return n === js.DELETE_PAYMENT_DETAILS ? /* @__PURE__ */ C.jsx(
    Oo,
    {
      steps: 2,
      isError: !1,
      currentStep: e[n],
      popupTitle: o(
        "update-payment-details-popup.title",
        "Update payment details"
      ),
      children: /* @__PURE__ */ C.jsx(tL, {})
    }
  ) : n === js.FINALIZE_ADYEN ? /* @__PURE__ */ C.jsx(
    Oo,
    {
      steps: 2,
      isError: !1,
      currentStep: e[n],
      popupTitle: o(
        "update-payment-details-popup.title",
        "Update payment details"
      ),
      children: /* @__PURE__ */ C.jsx(da, { children: /* @__PURE__ */ C.jsx(Vlt, {}) })
    }
  ) : n === js.SUCCESS ? /* @__PURE__ */ C.jsx(
    Oo,
    {
      steps: 2,
      isError: !1,
      currentStep: e[n],
      popupTitle: o(
        "update-payment-details-popup.title",
        "Update payment details"
      ),
      children: /* @__PURE__ */ C.jsx(
        jlt,
        {
          hideInnerPopup: () => a(pi({ isOpen: !1 }))
        }
      )
    }
  ) : n === js.ERROR ? /* @__PURE__ */ C.jsx(
    Oo,
    {
      steps: 2,
      isError: !1,
      currentStep: e[n],
      popupTitle: o(
        "update-payment-details-popup.title",
        "Update payment details"
      ),
      children: /* @__PURE__ */ C.jsx(Blt, {})
    }
  ) : b ? /* @__PURE__ */ C.jsx(
    Oo,
    {
      steps: 2,
      isError: !1,
      currentStep: e[n],
      popupTitle: o(
        "update-payment-details-popup.title",
        "Update payment details"
      ),
      children: /* @__PURE__ */ C.jsx(da, { children: /* @__PURE__ */ C.jsx(cr, {}) })
    }
  ) : /* @__PURE__ */ C.jsxs(
    Oo,
    {
      steps: 2,
      isError: !1,
      currentStep: e[n],
      popupTitle: o(
        "update-payment-details-popup.title",
        "Update payment details"
      ),
      children: [
        /* @__PURE__ */ C.jsxs(da, { children: [
          /* @__PURE__ */ C.jsx(Aa, { children: o("update-payment-details-popup.title", "Update payment details") }),
          /* @__PURE__ */ C.jsx(Cr, { children: o(
            "update-payment-details-popup.update-current-method",
            "Update your current payment method, or add a new one."
          ) }),
          /* @__PURE__ */ C.jsxs($lt, { children: [
            B && /* @__PURE__ */ C.jsx(
              B8,
              {
                isMyAccount: !0,
                onSubmit: R,
                selectPaymentMethod: E,
                isPayPalAvailable: $,
                getDropIn: O,
                onAdditionalDetails: N
              }
            ),
            $ && G() && !S && /* @__PURE__ */ C.jsx(
              hle,
              {
                selectPaymentMethod: E,
                title: "PayPal",
                logo: "paypal",
                isLoading: t,
                children: /* @__PURE__ */ C.jsx(
                  ple,
                  {
                    isMyAccount: !0,
                    onSubmit: D,
                    isLoading: t
                  }
                )
              }
            )
          ] }),
          ((Z = y.find((K) => K.active)) == null ? void 0 : Z.id) && /* @__PURE__ */ C.jsxs(
            Dlt,
            {
              onClick: () => {
                ur(Eye), a(
                  pi({
                    step: js.DELETE_PAYMENT_DETAILS
                  })
                );
              },
              children: [
                /* @__PURE__ */ C.jsx(Llt, {}),
                o(
                  "update-payment-details-popup.remove-method",
                  "Remove your payment method"
                )
              ]
            }
          )
        ] }),
        /* @__PURE__ */ C.jsx(Oa, { $removeMargin: !0, children: /* @__PURE__ */ C.jsx(
          zt,
          {
            theme: "simple",
            onClickFn: () => a(
              pi({
                isOpen: !1
              })
            ),
            children: o(
              "update-payment-details-popup.success.back",
              "Back to Payment Details"
            )
          }
        ) }),
        /* @__PURE__ */ C.jsx(sst, { children: o(
          "update-payment-details-popup.warning-message",
          "Your new details will replace the details used for your other active subscriptions."
        ) })
      ]
    }
  );
}, ON = W.article.attrs(() => ({
  className: "msd__payment-details__wrapper"
}))`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  background: ${Br};

  ${pr.small`
    padding: 0;
  `}
`;
W.div`
  color: ${Et};

  font-size: 14px;
  font-weight: 700;
`;
const Glt = ({
  adyenConfiguration: e,
  displayGracePeriodError: t
}) => {
  const n = Va(), r = Ot(vbe), { isOpen: a, currentType: o } = Ot(N_), { t: s } = tn(), c = Ot(dbe), u = e || r, f = a && o === su.EDIT_DELIVERY_DETAILS_POPUP;
  return mn(() => (n($u({ adyenConfiguration: u })), t !== null && n(
    $u({
      displayGracePeriodError: t
    })
  ), () => {
    n(pi({ isOpen: !1 }));
  }), []), f ? /* @__PURE__ */ C.jsx(ON, { children: /* @__PURE__ */ C.jsx(Mue, {}) }) : c.isOpen ? /* @__PURE__ */ C.jsxs(ON, { children: [
    /* @__PURE__ */ C.jsx(R6, {}),
    /* @__PURE__ */ C.jsx("div", { "data-testid": "payment-info__update-payment-details-popup", children: /* @__PURE__ */ C.jsx(Ult, {}) })
  ] }) : /* @__PURE__ */ C.jsxs(ON, { children: [
    /* @__PURE__ */ C.jsx(R6, {}),
    /* @__PURE__ */ C.jsxs("section", { children: [
      /* @__PURE__ */ C.jsx(Xi, { children: s("paymentinfo.current-payment-method", "Current payment method") }),
      /* @__PURE__ */ C.jsx(blt, {})
    ] }),
    /* @__PURE__ */ C.jsxs("section", { children: [
      /* @__PURE__ */ C.jsx(Xi, { marginTop: "25px", children: /* @__PURE__ */ C.jsx(C.Fragment, { children: s("paymentinfo.payment-history", "Payment history") }) }),
      /* @__PURE__ */ C.jsx(Gue, {})
    ] })
  ] });
}, zlt = Nle(Glt), Hlt = W(Uu).attrs(() => ({
  className: "msd__profile-consents__card"
}))`
  margin-bottom: 0;

  ${(e) => e.showConsentsOnly && ot`
      padding: 0 0 20px 0;
      border: none;
      background: transparent;
      &:first-child {
        margin-top: 0;
      }
    `}
`, kc = W(zt).attrs(() => ({
  className: "msd__profile-consents__button"
}))`
  margin: 20px 0 10px 0;
  width: 48%;
  min-width: 100px;

  ${(e) => e.$width && ot`
      width: ${e.$width};
    `}

  ${Zr.small && ot`
    margin: 20px 0 0 5px;
    width: unset;
    max-width: unset;
  `}
`, Wlt = W(kf).attrs(() => ({
  className: "msd__profile-consents__checkbox"
}))`
  align-items: flex-start;
  line-height: 1.3rem;

  ${(e) => e.disabled && ot`
      cursor: default;
    `}

  ${(e) => e.$hide && ot`
      display: none;
    `}
`, X8 = W.div.attrs(() => ({
  className: "msd__profile-buttons__wrapper"
}))`
  display: flex;
  justify-content: flex-end;
`;
W.div.attrs(() => ({
  className: "msd__profile__info"
}))`
  font-size: 13px;
  opacity: 0.6;
  margin-top: 15px;
`;
const Zlt = W.h6.attrs(() => ({
  className: "msd__message--success"
}))`
  color: ${An};
  text-align: center;
  margin: 5px 0 15px 0;
  font-size: 12px;
  position: relative;
`, Ylt = (e) => {
  const t = or(), { customerId: n } = qi(En("CLEENG_AUTH_TOKEN")), r = `${t}/customers/${n}`;
  return Mr(r, {
    method: "PATCH",
    body: JSON.stringify(Fe({}, e))
  }).then((a) => a.json());
}, Xlt = W.div`
  width: 100%;
`, Klt = W.form.attrs(() => ({
  className: "msd__profile__form"
}))``, qlt = [
  {
    id: "firstName",
    label: "First Name",
    onBlur: "areNamesValid",
    type: "text",
    translationKey: "profiledetails.label.first-name"
  },
  {
    id: "lastName",
    label: "Last Name",
    onBlur: "areNamesValid",
    type: "text",
    translationKey: "profiledetails.label.last-name"
  },
  {
    id: "email",
    label: "E-mail",
    onBlur: "areEmailAndPasswordValid",
    type: "email",
    translationKey: "profiledetails.label.email"
  },
  {
    id: "confirmationPassword",
    label: "Password confirmation",
    onBlur: "areEmailAndPasswordValid",
    type: "password",
    translationKey: "profiledetails.label.password-confirmation"
  },
  {
    id: "birthDate",
    label: "Birth Date",
    onBlur: "isBirthDateValid",
    type: "date",
    translationKey: "profiledetails.label.birth-date"
  },
  {
    id: "phoneNumber",
    label: "Phone Number",
    onBlur: "isPhoneNumberValid",
    type: "tel",
    translationKey: "profiledetails.label.phone-number"
  },
  {
    id: "companyName",
    label: "Company Name",
    onBlur: "isCompanyNameValid",
    type: "text",
    translationKey: "profiledetails.label.company-name"
  }
];
class nL extends Nc {
  constructor(n) {
    super(n);
    Er(this, "updateProfile", (n) => {
      n.preventDefault();
      const { updated: r } = this.state, { email: a, setCurrentUser: o, updateCaptureOption: s, t: c } = this.props, u = r.email !== a;
      !this.areNamesValid() || !this.areEmailAndPasswordValid() || !this.isBirthDateValid() || !this.isCompanyNameValid() || !this.isPhoneNumberValid() || (this.setState({
        isSubmittingPending: !0
      }), Ylt({
        firstName: r.firstName,
        lastName: r.lastName,
        email: r.email !== a ? r.email : "",
        confirmationPassword: r.email !== a ? r.confirmationPassword : ""
      }).then((f) => {
        if (this.setState({
          isSubmittingPending: !1
        }), f.errors.length) {
          const m = f.errors[0], v = m.includes("mail"), y = m.includes("confirmationPassword");
          this.setState({
            errors: {
              confirmationPassword: y ? c("profiledetails.error.incorect-password", "Incorect password") : "",
              email: v ? m : ""
            },
            successMessage: !1
          });
        } else
          o(f.responseData), this.setState({
            isSectionDisabled: !0,
            successMessage: !0
          }), u && Ec.logout();
      }), this.setState({
        isSubmittingPending: !0
      }), X6({
        birthDate: r.birthDate,
        companyName: r.companyName,
        phoneNumber: r.phoneNumber
      }).then(() => {
        s({ key: "birthDate", value: r.birthDate }), s({ key: "companyName", value: r.companyName }), s({ key: "phoneNumber", value: r.phoneNumber }), this.setState({
          isSubmittingPending: !1,
          isSectionDisabled: !0,
          successMessage: !0
        });
      }));
    });
    Er(this, "isBirthDateValid", () => {
      const { updated: n } = this.state, { t: r, birthDate: a } = this.props, { enabled: o, required: s } = a || {};
      return o && s && !n.birthDate ? (this.setState({
        errors: {
          birthDate: r(
            "profiledetails.error.birth-date",
            "Birth date is required"
          )
        }
      }), !1) : !0;
    });
    Er(this, "areNamesValid", () => {
      var f;
      const { updated: n } = this.state, { t: r, capture: a } = this.props, o = (f = a == null ? void 0 : a.settings) == null ? void 0 : f.find(
        (m) => m.key === "firstNameLastName"
      ), { enabled: s, required: c } = o || {}, u = s && c;
      return u && !n.firstName.length ? (this.setState({
        errors: {
          firstName: r(
            "profiledetails.error.first-name",
            "First name is required"
          )
        }
      }), !1) : u && !n.lastName.length ? (this.setState({
        errors: {
          lastName: r("profiledetails.error.last-name", "Last name is required")
        }
      }), !1) : n.firstName.length > 50 || n.lastName.length > 50 ? (this.setState({
        errors: {
          firstName: n.firstName.length > 50 ? r(
            "profiledetails.error.first-name-characters",
            "First name can have max 50 characters"
          ) : "",
          lastName: n.lastName.length > 50 ? r(
            "profiledetails.error.last-name-characters",
            "Last name can have max 50 characters"
          ) : ""
        }
      }), !1) : (this.setState({
        errors: {
          firstName: "",
          lastName: ""
        }
      }), !0);
    });
    Er(this, "areEmailAndPasswordValid", () => {
      const { updated: n } = this.state, { email: r, t: a } = this.props;
      if (n.email === r)
        return this.setState({ errors: { email: "" } }), !0;
      const o = !Nf(n.email).length, s = !!n.confirmationPassword;
      return !o || !s ? (this.setState({
        errors: {
          email: Nf(n.email),
          confirmationPassword: n.confirmationPassword ? "" : a(
            "profiledetails.error.password-confirmation",
            "Please confirm your password to proceed with changing your email address."
          )
        }
      }), !1) : (this.setState({
        errors: {
          email: "",
          confirmationPassword: ""
        }
      }), !0);
    });
    Er(this, "isPhoneNumberValid", () => {
      const { updated: n } = this.state, { t: r, phoneNumber: a } = this.props, { enabled: o, required: s } = a || {};
      return o && s && !n.phoneNumber ? (this.setState({
        errors: {
          phoneNumber: r(
            "profiledetails.error.phone-number",
            "Phone number is required"
          )
        }
      }), !1) : n.phoneNumber && !lle.test(n.phoneNumber) ? (this.setState({
        errors: {
          phoneNumber: r(
            "profiledetails.error.phone-number-not-valid",
            "This is not a valid phone number"
          )
        }
      }), !1) : (this.setState({
        errors: {
          phoneNumber: ""
        }
      }), !0);
    });
    Er(this, "isCompanyNameValid", () => {
      const { updated: n } = this.state, { t: r, companyName: a } = this.props, { enabled: o, required: s } = a || {};
      return o && s && !n.companyName ? (this.setState({
        errors: {
          companyName: r(
            "profiledetails.error.company-name",
            "Company name is required"
          )
        }
      }), !1) : n.companyName && n.companyName.length > 50 ? (this.setState({
        errors: {
          companyName: n.companyName.length > 50 ? r(
            "profiledetails.error.company-name-characters",
            "Company name can have max 50 characters"
          ) : ""
        }
      }), !1) : (this.setState({
        errors: {
          companyName: ""
        }
      }), !0);
    });
    Er(this, "handleInputChange", (n, r) => {
      this.setState((a) => ({
        updated: Xn(Fe({}, a.updated), { [n]: r })
      }));
    });
    this.state = {
      updated: {
        firstName: "",
        lastName: "",
        email: "",
        confirmationPassword: "",
        birthDate: "",
        phoneNumber: "",
        companyName: ""
      },
      errors: {
        firstName: "",
        lastName: "",
        email: "",
        confirmationPassword: "",
        birthDate: "",
        phoneNumber: "",
        companyName: ""
      },
      isSectionDisabled: !0,
      isSubmittingPending: !1,
      successMessage: !1
    };
  }
  componentDidMount() {
    const { firstName: n, lastName: r, email: a, birthDate: o, phoneNumber: s, companyName: c } = this.props, { updated: u } = this.state;
    this.setState({
      updated: Xn(Fe({}, u), {
        firstName: n,
        lastName: r,
        email: a,
        birthDate: o ? o.answer : "",
        phoneNumber: s ? s.answer : "",
        companyName: c ? c.answer : ""
      })
    });
  }
  componentDidUpdate() {
    const { updated: n, isSectionDisabled: r } = this.state, { firstName: a, lastName: o, email: s, birthDate: c, phoneNumber: u, companyName: f } = this.props;
    r && (a !== n.firstName || o !== n.lastName || s !== n.email || c && c.answer !== n.birthDate || u && u.answer !== n.phoneNumber || f && f.answer !== n.companyName) && this.setState({
      updated: Xn(Fe({}, n), {
        firstName: a,
        lastName: o,
        email: s,
        confirmationPassword: "",
        birthDate: c ? c.answer : "",
        phoneNumber: u ? u.answer : "",
        companyName: f ? f.answer : ""
      })
    });
  }
  render() {
    var S, x;
    const { firstName: n, lastName: r, capture: a, email: o, isLoading: s, t: c } = this.props, {
      updated: u,
      isSectionDisabled: f,
      isSubmittingPending: m,
      errors: v,
      successMessage: y
    } = this.state, b = (x = (S = a == null ? void 0 : a.settings) == null ? void 0 : S.find(
      (E) => E.key === "firstNameLastName"
    )) == null ? void 0 : x.required;
    return /* @__PURE__ */ C.jsx(Xlt, { children: /* @__PURE__ */ C.jsx(Uu, { withBorder: !0, children: s ? /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      [...Array(3)].map((E, N) => (
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ C.jsxs(vo.Fragment, { children: [
          /* @__PURE__ */ C.jsx(Zn, { width: 100, margin: "0 0 12px 0" }),
          /* @__PURE__ */ C.jsx(Zn, { height: 40, margin: "0 0 28px 0" })
        ] }, `skeleton-item-${N}`)
      )),
      /* @__PURE__ */ C.jsx(Zn, { height: 40, width: 140, margin: "40px 0 0 auto" })
    ] }) : /* @__PURE__ */ C.jsxs(Klt, { onSubmit: this.updateProfile, children: [
      y && /* @__PURE__ */ C.jsx(Zlt, { children: c(
        "profiledetails.success-message",
        "Your profile details have been changed successfully"
      ) }),
      qlt.map((E) => {
        var O;
        const N = typeof this.props[E.id] == "object" && !((O = this.props[E.id]) != null && O.enabled), R = () => {
          var D;
          switch (E.id) {
            case "firstName":
            case "lastName":
              return b;
            case "email":
              return !0;
            default:
              return (D = this.props[E.id]) == null ? void 0 : D.required;
          }
        };
        return N ? null : /* @__PURE__ */ C.jsx(
          du,
          {
            id: E.id,
            value: u[E.id] || "",
            label: c(E.translationKey, E.label),
            onChange: (D) => this.handleInputChange(E.id, D.target.value),
            disabled: f,
            error: v[E.id],
            onBlur: this[E.onBlur],
            type: E.type,
            name: E.id,
            hideInput: E.id === "confirmationPassword" && u.email === o,
            autoComplete: E.id === "confirmationPassword" ? "new-password" : "off",
            required: R()
          },
          E.id
        );
      }),
      /* @__PURE__ */ C.jsx(X8, { children: f ? /* @__PURE__ */ C.jsx(
        kc,
        {
          onClickFn: () => this.setState({ isSectionDisabled: !1 }),
          width: "100%",
          theme: "confirm",
          children: c("profiledetails.button.edit-profile", "Edit Profile")
        }
      ) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
        /* @__PURE__ */ C.jsx(
          kc,
          {
            theme: "simple",
            onClickFn: () => this.setState({
              isSectionDisabled: !0,
              updated: {
                firstName: n,
                lastName: r,
                email: o,
                confirmationPassword: ""
              },
              errors: {
                firstName: "",
                lastName: "",
                email: "",
                confirmationPassword: ""
              }
            }),
            children: c("profiledetails.button.cancel", "Cancel")
          }
        ),
        /* @__PURE__ */ C.jsx(
          kc,
          {
            onClickFn: this.updateProfile,
            disabled: m,
            type: "submit",
            theme: "confirm",
            children: m && /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) || c("profiledetails.button.save", "Save")
          }
        )
      ] }) })
    ] }) }) });
  }
}
nL.propTypes = {
  firstName: de.string,
  lastName: de.string,
  email: de.string,
  birthDate: de.objectOf(de.any),
  phoneNumber: de.objectOf(de.any),
  companyName: de.objectOf(de.any),
  isLoading: de.bool,
  setCurrentUser: de.func,
  updateCaptureOption: de.func,
  capture: de.objectOf(de.any),
  t: de.func
};
nL.defaultProps = {
  firstName: "",
  lastName: "",
  email: "",
  birthDate: null,
  phoneNumber: null,
  companyName: null,
  isLoading: !1,
  capture: null,
  setCurrentUser: () => null,
  updateCaptureOption: () => null,
  t: (e) => e
};
const Jlt = o1()(nL), Yue = () => {
  const [e, t] = mt(""), [n, r] = mt("");
  return [e, n, (s) => {
    t(s.message), r(s.type);
  }, () => {
    t(""), r("");
  }];
}, Qlt = W.div.attrs(() => ({
  className: "msd__profile-address"
}))``, eut = W.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;

  &:first-child {
    margin-right: 25px;
  }

  & > * {
    width: 100%;
    &:first-child {
      margin-right: 25px;
    }
  }
`, tut = W.div.attrs(() => ({
  className: "msd__profile-message--success"
}))`
  color: ${An};
  text-align: center;
  margin: 5px 0 15px 0;
  font-size: 12px;
  position: relative;
`, rL = ({ data: e, isLoading: t, updateCaptureOption: n }) => {
  const { t: r } = tn(), [a, o] = mt(!0), [s, c] = mt(!1), [u, f] = mt(null), [m, v] = mt(null), [y, b, S, x] = Yue();
  mn(() => {
    e && (f(e.answer), v(e.answer));
  }, [e]);
  const E = (O, D) => {
    f(Xn(Fe({}, u), {
      [O]: D
    }));
  }, N = () => {
    f(m), o(!0);
  }, R = () => {
    c(!0), X6(Fe({}, u)).then(() => {
      n({ key: "address", value: u }), S({
        message: r(
          "address-details.success-message",
          "Your address details have been changed successfully"
        ),
        type: "success"
      }), c(!1), o(!0);
    }).catch(() => {
      S({
        message: r(
          "address-details.error.submit",
          "Something went wrong. Try again later."
        ),
        type: "error"
      }), c(!1), o(!0);
    });
  };
  return t ? /* @__PURE__ */ C.jsx(cr, { isMyAccount: !0 }) : /* @__PURE__ */ C.jsx(Qlt, { children: u && /* @__PURE__ */ C.jsxs(Uu, { withBorder: !0, children: [
    y && /* @__PURE__ */ C.jsx(tut, { type: b, children: y }),
    /* @__PURE__ */ C.jsx(
      du,
      {
        id: "address",
        label: r("address-details.label.address-line-1", "Address Line 1"),
        value: u.address || "",
        onChange: (O) => E("address", O.target.value),
        disabled: a
      }
    ),
    /* @__PURE__ */ C.jsx(
      du,
      {
        id: "address2",
        label: r("address-details.label.address-line-2", "Address Line 2"),
        value: u.address2 || "",
        onChange: (O) => E("address2", O.target.value),
        disabled: a
      }
    ),
    /* @__PURE__ */ C.jsx(
      du,
      {
        id: "city",
        label: r("address-details.label.city", "City"),
        value: u.city || "",
        onChange: (O) => E("city", O.target.value),
        disabled: a
      }
    ),
    /* @__PURE__ */ C.jsxs(eut, { children: [
      /* @__PURE__ */ C.jsx(
        du,
        {
          id: "state",
          label: r("address-details.label.state", "State"),
          value: u.state || "",
          onChange: (O) => E("state", O.target.value),
          disabled: a
        }
      ),
      /* @__PURE__ */ C.jsx(
        du,
        {
          id: "postCode",
          label: r(
            "address-details.label.zip-postal-code",
            "Zip/Postal code"
          ),
          value: u.postCode || "",
          onChange: (O) => E("postCode", O.target.value),
          disabled: a
        }
      )
    ] }),
    /* @__PURE__ */ C.jsx(X8, { children: a ? /* @__PURE__ */ C.jsx(
      kc,
      {
        onClickFn: () => {
          o(!1), x();
        },
        width: "100%",
        children: r("address-details.button.edit-address", "Edit Address")
      }
    ) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(kc, { theme: "simple", onClickFn: () => N(), children: r("address-details.button.cancel", "Cancel") }),
      /* @__PURE__ */ C.jsx(
        kc,
        {
          onClickFn: R,
          disabled: s,
          type: "submit",
          theme: "confirm",
          children: s && /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) || r("address-details.button.save", "Save")
        }
      )
    ] }) })
  ] }) });
};
rL.propTypes = {
  isLoading: de.bool,
  data: de.objectOf(de.any),
  updateCaptureOption: de.func
};
rL.defaultProps = {
  isLoading: !1,
  data: {},
  updateCaptureOption: () => null
};
const nut = W.div.attrs(() => ({
  className: "msd__profile-password"
}))``, rut = W.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`, aut = W.span.attrs(() => ({
  className: "msd__profile-password__old"
}))`
  color: ${Et};
  letter-spacing: 2px;
  font-weight: 700;
`, Xue = ({ showInnerPopup: e }) => {
  const { t } = tn();
  return /* @__PURE__ */ C.jsx(nut, { children: /* @__PURE__ */ C.jsx(Uu, { withBorder: !0, children: /* @__PURE__ */ C.jsxs(rut, { children: [
    /* @__PURE__ */ C.jsx(aut, { children: "••••••••" }),
    /* @__PURE__ */ C.jsx(
      zt,
      {
        width: "auto",
        onClickFn: () => e({ type: Nm.editPassword }),
        theme: "confirm",
        children: t("Edit Password")
      }
    )
  ] }) }) });
};
Xue.propTypes = {
  showInnerPopup: de.func.isRequired
};
class aL extends Nc {
  constructor(n) {
    super(n);
    Er(this, "toggleState", (n) => n === "accepted" ? "declined" : "accepted");
    this.state = {
      updatedConsents: [],
      isSectionDisabled: !0,
      isLoading: !1,
      isSubmittingPending: !1,
      showButtonToUpdate: !0
    };
  }
  componentDidMount() {
    const { consents: n } = this.props;
    n.length !== 0 && this.saveConsentsInState();
  }
  componentDidUpdate(n) {
    const { consents: r } = this.props;
    n.consents !== r && this.saveConsentsInState();
  }
  handleClick(n, r, a) {
    const { showConsentsOnly: o, saveConsents: s } = this.props;
    if (n.target.tagName.toLowerCase() === "a" || r || !o && a.required) return;
    const { updatedConsents: c } = this.state, u = c.findIndex((f) => f.name === a.name);
    this.setState((f) => {
      const m = Fe({}, f.updatedConsents[u]);
      m.state = this.toggleState(m.state);
      const v = [...f.updatedConsents];
      return v[u] = m, o && s(v), Xn(Fe({}, f), { updatedConsents: v });
    });
  }
  saveConsentsInState() {
    const { consents: n } = this.props, r = n.find((a) => !a.required);
    this.setState({
      updatedConsents: n,
      showButtonToUpdate: !!r
    });
  }
  updateConsents() {
    const { updatedConsents: n } = this.state, { setConsents: r } = this.props, a = n.map((o) => ({
      name: o.name,
      version: o.newestVersion,
      state: o.state
    }));
    this.setState({
      isSubmittingPending: !0
    }), K6([], [], a).then(() => {
      this.setState({
        isSectionDisabled: !0,
        isSubmittingPending: !1
      }), r(n);
    });
  }
  render() {
    const { t: n, consents: r, isLoading: a, showConsentsOnly: o } = this.props, {
      updatedConsents: s,
      isSectionDisabled: c,
      isSubmittingPending: u,
      showButtonToUpdate: f
    } = this.state, m = s.slice().sort((v, y) => v.required === y.required ? 0 : v.required ? -1 : 1);
    return a ? /* @__PURE__ */ C.jsx(cr, { isMyAccount: !0 }) : /* @__PURE__ */ C.jsxs(Hlt, { showConsentsOnly: o, withBorder: !0, children: [
      m.map((v) => /* @__PURE__ */ C.jsx(
        Wlt,
        {
          isMyAccount: !0,
          onClickFn: (y, b) => this.handleClick(y, b, v),
          isChecked: v.state === "accepted",
          disabled: (c || v.required) && !o,
          required: v.required,
          $hide: o && !v.required,
          children: ID(v.label, n)
        },
        v.name
      )),
      !o && /* @__PURE__ */ C.jsx(C.Fragment, { children: f && /* @__PURE__ */ C.jsx(X8, { children: c ? /* @__PURE__ */ C.jsx(
        kc,
        {
          onClickFn: () => this.setState({ isSectionDisabled: !1 }),
          width: "100%",
          children: n(
            "myaccount-consents.button.update-terms",
            "Update Terms"
          )
        }
      ) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
        /* @__PURE__ */ C.jsx(
          kc,
          {
            theme: "simple",
            onClickFn: () => this.setState({
              isSectionDisabled: !0,
              updatedConsents: r
            }),
            children: n("myaccount-consents.button.cancel", "Cancel")
          }
        ),
        /* @__PURE__ */ C.jsx(
          kc,
          {
            theme: "confirm",
            onClickFn: () => this.updateConsents(),
            disabled: u,
            children: u && /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) || n("myaccount-consents.button.save", "Save")
          }
        )
      ] }) }) })
    ] });
  }
}
aL.propTypes = {
  consents: de.arrayOf(de.object),
  setConsents: de.func.isRequired,
  isLoading: de.bool,
  showConsentsOnly: de.bool,
  saveConsents: de.func,
  t: de.func
};
aL.defaultProps = {
  consents: [],
  isLoading: !1,
  showConsentsOnly: !1,
  saveConsents: () => null,
  t: (e) => e
};
const Kue = o1()(aL), out = ({
  hideInnerPopup: e,
  customerEmail: t,
  handleLogout: n
}) => {
  const [r, a] = mt(1), [o, s] = mt(!1), [c, u] = mt(!1), { resetUrl: f } = Ot(FR), m = () => {
    a((b) => b + 1);
  }, v = () => {
    n(), Ec.logout(), ur(i_, {
      source: "EditPassword"
    });
  }, y = () => st(void 0, null, function* () {
    s(!0);
    try {
      const { publisherId: b } = qi(En("CLEENG_AUTH_TOKEN"));
      (yield KQ(
        t,
        String(b),
        f
      )).errors.length ? (s(!1), u(!0)) : (m(), s(!1));
    } catch (b) {
      s(!1), u(!0);
    }
  });
  return /* @__PURE__ */ C.jsxs(
    Oo,
    {
      steps: 2,
      popupTitle: Ip("edit-password.popup-title", "Edit Password"),
      isError: c,
      currentStep: r,
      children: [
        r === 1 && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsx(Aa, { $step: r, children: Ip("edit-password.title.step1", "Edit Password") }),
            /* @__PURE__ */ C.jsxs(Cr, { children: [
              Ip(
                "edit-password.text.step1",
                "If you want to edit your password, click 'YES, Reset' to receive password reset instruction on your mail"
              ),
              /* @__PURE__ */ C.jsxs(ist, { children: [
                " ",
                t,
                "."
              ] })
            ] })
          ] }),
          /* @__PURE__ */ C.jsxs(Oa, { children: [
            /* @__PURE__ */ C.jsx(zt, { theme: "simple", onClickFn: () => e(), children: Ip("edit-password.button.no-thanks", "No, thanks") }),
            /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: y, children: o && /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) || Ip("edit-password.button.yes-reset", "Yes, reset") })
          ] })
        ] }),
        r === 2 && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsxs(da, { children: [
            /* @__PURE__ */ C.jsx(Aa, { $step: r, children: Ip("edit-password.title.step2", "Email has been sent!") }),
            /* @__PURE__ */ C.jsx(Cr, { children: Ip(
              "edit-password.text.step2",
              "Please check your inbox and follow the instructions to reset your password."
            ) }),
            /* @__PURE__ */ C.jsx(Cr, { children: Ip(
              "edit-password.text2.step2",
              "You will be logged out for security reasons."
            ) })
          ] }),
          /* @__PURE__ */ C.jsx(Oa, { children: /* @__PURE__ */ C.jsx(zt, { theme: "confirm", onClickFn: () => v(), children: o && /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) || Ip("edit-password.button.confirm", "Confirm") }) })
        ] })
      ]
    }
  );
};
function rJ(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rJ(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rJ(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var iut = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function sut(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, r = e.defaultMenuIsOpen, a = r === void 0 ? !1 : r, o = e.defaultValue, s = o === void 0 ? null : o, c = e.inputValue, u = e.menuIsOpen, f = e.onChange, m = e.onInputChange, v = e.onMenuClose, y = e.onMenuOpen, b = e.value, S = Vu(e, iut), x = mt(c !== void 0 ? c : n), E = Sd(x, 2), N = E[0], R = E[1], O = mt(u !== void 0 ? u : a), D = Sd(O, 2), $ = D[0], B = D[1], G = mt(b !== void 0 ? b : s), Z = Sd(G, 2), K = Z[0], q = Z[1], pe = Yi(function(me, xe) {
    typeof f == "function" && f(me, xe), q(me);
  }, [f]), he = Yi(function(me, xe) {
    var X;
    typeof m == "function" && (X = m(me, xe)), R(X !== void 0 ? X : me);
  }, [m]), _e = Yi(function() {
    typeof y == "function" && y(), B(!0);
  }, [y]), ge = Yi(function() {
    typeof v == "function" && v(), B(!1);
  }, [v]), Y = c !== void 0 ? c : N, ee = u !== void 0 ? u : $, oe = b !== void 0 ? b : K;
  return kn(kn({}, S), {}, {
    inputValue: Y,
    menuIsOpen: ee,
    onChange: pe,
    onInputChange: he,
    onMenuClose: ge,
    onMenuOpen: _e,
    value: oe
  });
}
function Fn() {
  return Fn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fn.apply(null, arguments);
}
function que() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t) {
  }
  return (que = function() {
    return !!e;
  })();
}
function lut(e) {
  var t = que();
  return function() {
    var n, r = Ac(e);
    if (t) {
      var a = Ac(this).constructor;
      n = Reflect.construct(r, arguments, a);
    } else n = r.apply(this, arguments);
    return E2(this, n);
  };
}
function uut(e) {
  if (Array.isArray(e)) return zN(e);
}
function cut() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function oL(e) {
  return uut(e) || BJ(e) || gR(e) || cut();
}
var dut = !1;
function fut(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function put(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var hut = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(a) {
      var o;
      r.tags.length === 0 ? r.insertionPoint ? o = r.insertionPoint.nextSibling : r.prepend ? o = r.container.firstChild : o = r.before : o = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(a, o), r.tags.push(a);
    }, this.isSpeedy = n.speedy === void 0 ? !dut : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(put(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var o = fut(a);
      try {
        o.insertRule(r, o.cssRules.length);
      } catch (s) {
      }
    } else
      a.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var a;
      return (a = r.parentNode) == null ? void 0 : a.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), sl = "-ms-", M6 = "-moz-", la = "-webkit-", Jue = "comm", iL = "rule", sL = "decl", mut = "@import", Que = "@keyframes", vut = "@layer", gut = Math.abs, K8 = String.fromCharCode, yut = Object.assign;
function but(e, t) {
  return Fs(e, 0) ^ 45 ? (((t << 2 ^ Fs(e, 0)) << 2 ^ Fs(e, 1)) << 2 ^ Fs(e, 2)) << 2 ^ Fs(e, 3) : 0;
}
function ece(e) {
  return e.trim();
}
function _ut(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function ua(e, t, n) {
  return e.replace(t, n);
}
function cR(e, t) {
  return e.indexOf(t);
}
function Fs(e, t) {
  return e.charCodeAt(t) | 0;
}
function w_(e, t, n) {
  return e.slice(t, n);
}
function wf(e) {
  return e.length;
}
function lL(e) {
  return e.length;
}
function Sx(e, t) {
  return t.push(e), e;
}
function Cut(e, t) {
  return e.map(t).join("");
}
var q8 = 1, x2 = 1, tce = 0, hu = 0, Pi = 0, Z2 = "";
function J8(e, t, n, r, a, o, s) {
  return { value: e, root: t, parent: n, type: r, props: a, children: o, line: q8, column: x2, length: s, return: "" };
}
function v4(e, t) {
  return yut(J8("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function wut() {
  return Pi;
}
function Sut() {
  return Pi = hu > 0 ? Fs(Z2, --hu) : 0, x2--, Pi === 10 && (x2 = 1, q8--), Pi;
}
function Mu() {
  return Pi = hu < tce ? Fs(Z2, hu++) : 0, x2++, Pi === 10 && (x2 = 1, q8++), Pi;
}
function Pf() {
  return Fs(Z2, hu);
}
function m7() {
  return hu;
}
function gC(e, t) {
  return w_(Z2, e, t);
}
function S_(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function nce(e) {
  return q8 = x2 = 1, tce = wf(Z2 = e), hu = 0, [];
}
function rce(e) {
  return Z2 = "", e;
}
function v7(e) {
  return ece(gC(hu - 1, dR(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function xut(e) {
  for (; (Pi = Pf()) && Pi < 33; )
    Mu();
  return S_(e) > 2 || S_(Pi) > 3 ? "" : " ";
}
function Eut(e, t) {
  for (; --t && Mu() && !(Pi < 48 || Pi > 102 || Pi > 57 && Pi < 65 || Pi > 70 && Pi < 97); )
    ;
  return gC(e, m7() + (t < 6 && Pf() == 32 && Mu() == 32));
}
function dR(e) {
  for (; Mu(); )
    switch (Pi) {
      case e:
        return hu;
      case 34:
      case 39:
        e !== 34 && e !== 39 && dR(Pi);
        break;
      case 40:
        e === 41 && dR(e);
        break;
      case 92:
        Mu();
        break;
    }
  return hu;
}
function Iut(e, t) {
  for (; Mu() && e + Pi !== 57; )
    if (e + Pi === 84 && Pf() === 47)
      break;
  return "/*" + gC(t, hu - 1) + "*" + K8(e === 47 ? e : Mu());
}
function kut(e) {
  for (; !S_(Pf()); )
    Mu();
  return gC(e, hu);
}
function Aut(e) {
  return rce(g7("", null, null, null, [""], e = nce(e), 0, [0], e));
}
function g7(e, t, n, r, a, o, s, c, u) {
  for (var f = 0, m = 0, v = s, y = 0, b = 0, S = 0, x = 1, E = 1, N = 1, R = 0, O = "", D = a, $ = o, B = r, G = O; E; )
    switch (S = R, R = Mu()) {
      case 40:
        if (S != 108 && Fs(G, v - 1) == 58) {
          cR(G += ua(v7(R), "&", "&\f"), "&\f") != -1 && (N = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        G += v7(R);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        G += xut(S);
        break;
      case 92:
        G += Eut(m7() - 1, 7);
        continue;
      case 47:
        switch (Pf()) {
          case 42:
          case 47:
            Sx(Put(Iut(Mu(), m7()), t, n), u);
            break;
          default:
            G += "/";
        }
        break;
      case 123 * x:
        c[f++] = wf(G) * N;
      case 125 * x:
      case 59:
      case 0:
        switch (R) {
          case 0:
          case 125:
            E = 0;
          case 59 + m:
            N == -1 && (G = ua(G, /\f/g, "")), b > 0 && wf(G) - v && Sx(b > 32 ? oJ(G + ";", r, n, v - 1) : oJ(ua(G, " ", "") + ";", r, n, v - 2), u);
            break;
          case 59:
            G += ";";
          default:
            if (Sx(B = aJ(G, t, n, f, m, a, c, O, D = [], $ = [], v), o), R === 123)
              if (m === 0)
                g7(G, t, B, B, D, o, v, c, $);
              else
                switch (y === 99 && Fs(G, 3) === 110 ? 100 : y) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    g7(e, B, B, r && Sx(aJ(e, B, B, 0, 0, a, c, O, a, D = [], v), $), a, $, v, c, r ? D : $);
                    break;
                  default:
                    g7(G, B, B, B, [""], $, 0, c, $);
                }
        }
        f = m = b = 0, x = N = 1, O = G = "", v = s;
        break;
      case 58:
        v = 1 + wf(G), b = S;
      default:
        if (x < 1) {
          if (R == 123)
            --x;
          else if (R == 125 && x++ == 0 && Sut() == 125)
            continue;
        }
        switch (G += K8(R), R * x) {
          case 38:
            N = m > 0 ? 1 : (G += "\f", -1);
            break;
          case 44:
            c[f++] = (wf(G) - 1) * N, N = 1;
            break;
          case 64:
            Pf() === 45 && (G += v7(Mu())), y = Pf(), m = v = wf(O = G += kut(m7())), R++;
            break;
          case 45:
            S === 45 && wf(G) == 2 && (x = 0);
        }
    }
  return o;
}
function aJ(e, t, n, r, a, o, s, c, u, f, m) {
  for (var v = a - 1, y = a === 0 ? o : [""], b = lL(y), S = 0, x = 0, E = 0; S < r; ++S)
    for (var N = 0, R = w_(e, v + 1, v = gut(x = s[S])), O = e; N < b; ++N)
      (O = ece(x > 0 ? y[N] + " " + R : ua(R, /&\f/g, y[N]))) && (u[E++] = O);
  return J8(e, t, n, a === 0 ? iL : c, u, f, m);
}
function Put(e, t, n) {
  return J8(e, t, n, Jue, K8(wut()), w_(e, 2, -2), 0);
}
function oJ(e, t, n, r) {
  return J8(e, t, n, sL, w_(e, 0, r), w_(e, r + 1, -1), r);
}
function n2(e, t) {
  for (var n = "", r = lL(e), a = 0; a < r; a++)
    n += t(e[a], a, e, t) || "";
  return n;
}
function Nut(e, t, n, r) {
  switch (e.type) {
    case vut:
      if (e.children.length) break;
    case mut:
    case sL:
      return e.return = e.return || e.value;
    case Jue:
      return "";
    case Que:
      return e.return = e.value + "{" + n2(e.children, r) + "}";
    case iL:
      e.value = e.props.join(",");
  }
  return wf(n = n2(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function Tut(e) {
  var t = lL(e);
  return function(n, r, a, o) {
    for (var s = "", c = 0; c < t; c++)
      s += e[c](n, r, a, o) || "";
    return s;
  };
}
function Out(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var Rut = function(t, n, r) {
  for (var a = 0, o = 0; a = o, o = Pf(), a === 38 && o === 12 && (n[r] = 1), !S_(o); )
    Mu();
  return gC(t, hu);
}, Mut = function(t, n) {
  var r = -1, a = 44;
  do
    switch (S_(a)) {
      case 0:
        a === 38 && Pf() === 12 && (n[r] = 1), t[r] += Rut(hu - 1, n, r);
        break;
      case 2:
        t[r] += v7(a);
        break;
      case 4:
        if (a === 44) {
          t[++r] = Pf() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += K8(a);
    }
  while (a = Mu());
  return t;
}, Dut = function(t, n) {
  return rce(Mut(nce(t), n));
}, iJ = /* @__PURE__ */ new WeakMap(), Lut = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, a = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !iJ.get(r)) && !a) {
      iJ.set(t, !0);
      for (var o = [], s = Dut(n, o), c = r.props, u = 0, f = 0; u < s.length; u++)
        for (var m = 0; m < c.length; m++, f++)
          t.props[f] = o[u] ? s[u].replace(/&\f/g, c[m]) : c[m] + " " + s[u];
    }
  }
}, $ut = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function ace(e, t) {
  switch (but(e, t)) {
    case 5103:
      return la + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return la + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return la + e + M6 + e + sl + e + e;
    case 6828:
    case 4268:
      return la + e + sl + e + e;
    case 6165:
      return la + e + sl + "flex-" + e + e;
    case 5187:
      return la + e + ua(e, /(\w+).+(:[^]+)/, la + "box-$1$2" + sl + "flex-$1$2") + e;
    case 5443:
      return la + e + sl + "flex-item-" + ua(e, /flex-|-self/, "") + e;
    case 4675:
      return la + e + sl + "flex-line-pack" + ua(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return la + e + sl + ua(e, "shrink", "negative") + e;
    case 5292:
      return la + e + sl + ua(e, "basis", "preferred-size") + e;
    case 6060:
      return la + "box-" + ua(e, "-grow", "") + la + e + sl + ua(e, "grow", "positive") + e;
    case 4554:
      return la + ua(e, /([^-])(transform)/g, "$1" + la + "$2") + e;
    case 6187:
      return ua(ua(ua(e, /(zoom-|grab)/, la + "$1"), /(image-set)/, la + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return ua(e, /(image-set\([^]*)/, la + "$1$`$1");
    case 4968:
      return ua(ua(e, /(.+:)(flex-)?(.*)/, la + "box-pack:$3" + sl + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + la + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ua(e, /(.+)-inline(.+)/, la + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (wf(e) - 1 - t > 6) switch (Fs(e, t + 1)) {
        case 109:
          if (Fs(e, t + 4) !== 45) break;
        case 102:
          return ua(e, /(.+:)(.+)-([^]+)/, "$1" + la + "$2-$3$1" + M6 + (Fs(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~cR(e, "stretch") ? ace(ua(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (Fs(e, t + 1) !== 115) break;
    case 6444:
      switch (Fs(e, wf(e) - 3 - (~cR(e, "!important") && 10))) {
        case 107:
          return ua(e, ":", ":" + la) + e;
        case 101:
          return ua(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + la + (Fs(e, 14) === 45 ? "inline-" : "") + "box$3$1" + la + "$2$3$1" + sl + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Fs(e, t + 11)) {
        case 114:
          return la + e + sl + ua(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return la + e + sl + ua(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return la + e + sl + ua(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return la + e + sl + e + e;
  }
  return e;
}
var jut = function(t, n, r, a) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case sL:
      t.return = ace(t.value, t.length);
      break;
    case Que:
      return n2([v4(t, {
        value: ua(t.value, "@", "@" + la)
      })], a);
    case iL:
      if (t.length) return Cut(t.props, function(o) {
        switch (_ut(o, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return n2([v4(t, {
              props: [ua(o, /:(read-\w+)/, ":" + M6 + "$1")]
            })], a);
          case "::placeholder":
            return n2([v4(t, {
              props: [ua(o, /:(plac\w+)/, ":" + la + "input-$1")]
            }), v4(t, {
              props: [ua(o, /:(plac\w+)/, ":" + M6 + "$1")]
            }), v4(t, {
              props: [ua(o, /:(plac\w+)/, sl + "input-$1")]
            })], a);
        }
        return "";
      });
  }
}, Fut = [jut], But = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(x) {
      var E = x.getAttribute("data-emotion");
      E.indexOf(" ") !== -1 && (document.head.appendChild(x), x.setAttribute("data-s", ""));
    });
  }
  var a = t.stylisPlugins || Fut, o = {}, s, c = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(x) {
      for (var E = x.getAttribute("data-emotion").split(" "), N = 1; N < E.length; N++)
        o[E[N]] = !0;
      c.push(x);
    }
  );
  var u, f = [Lut, $ut];
  {
    var m, v = [Nut, Out(function(x) {
      m.insert(x);
    })], y = Tut(f.concat(a, v)), b = function(E) {
      return n2(Aut(E), y);
    };
    u = function(E, N, R, O) {
      m = R, b(E ? E + "{" + N.styles + "}" : N.styles), O && (S.inserted[N.name] = !0);
    };
  }
  var S = {
    key: n,
    sheet: new hut({
      key: n,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: o,
    registered: {},
    insert: u
  };
  return S.sheet.hydrate(c), S;
}, Vut = !0;
function Uut(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(a) {
    e[a] !== void 0 ? t.push(e[a] + ";") : r += a + " ";
  }), r;
}
var oce = function(t, n, r) {
  var a = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Vut === !1) && t.registered[a] === void 0 && (t.registered[a] = n.styles);
}, Gut = function(t, n, r) {
  oce(t, n, r);
  var a = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var o = n;
    do
      t.insert(n === o ? "." + a : "", o, t.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function zut(e) {
  for (var t = 0, n, r = 0, a = e.length; a >= 4; ++r, a -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Hut = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Wut = !1, Zut = /[A-Z]|^ms/g, Yut = /_EMO_([^_]+?)_([^]*?)_EMO_/g, ice = function(t) {
  return t.charCodeAt(1) === 45;
}, sJ = function(t) {
  return t != null && typeof t != "boolean";
}, RN = /* @__PURE__ */ oQ(function(e) {
  return ice(e) ? e : e.replace(Zut, "-$&").toLowerCase();
}), lJ = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Yut, function(r, a, o) {
          return Sf = {
            name: a,
            styles: o,
            next: Sf
          }, a;
        });
  }
  return Hut[t] !== 1 && !ice(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, Xut = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function x_(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var a = n;
      if (a.anim === 1)
        return Sf = {
          name: a.name,
          styles: a.styles,
          next: Sf
        }, a.name;
      var o = n;
      if (o.styles !== void 0) {
        var s = o.next;
        if (s !== void 0)
          for (; s !== void 0; )
            Sf = {
              name: s.name,
              styles: s.styles,
              next: Sf
            }, s = s.next;
        var c = o.styles + ";";
        return c;
      }
      return Kut(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var u = Sf, f = n(e);
        return Sf = u, x_(e, t, f);
      }
      break;
    }
  }
  var m = n;
  return m;
}
function Kut(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var a = 0; a < n.length; a++)
      r += x_(e, t, n[a]) + ";";
  else
    for (var o in n) {
      var s = n[o];
      if (typeof s != "object") {
        var c = s;
        sJ(c) && (r += RN(o) + ":" + lJ(o, c) + ";");
      } else {
        if (o === "NO_COMPONENT_SELECTOR" && Wut)
          throw new Error(Xut);
        if (Array.isArray(s) && typeof s[0] == "string" && t == null)
          for (var u = 0; u < s.length; u++)
            sJ(s[u]) && (r += RN(o) + ":" + lJ(o, s[u]) + ";");
        else {
          var f = x_(e, t, s);
          switch (o) {
            case "animation":
            case "animationName": {
              r += RN(o) + ":" + f + ";";
              break;
            }
            default:
              r += o + "{" + f + "}";
          }
        }
      }
    }
  return r;
}
var uJ = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Sf;
function sce(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, a = "";
  Sf = void 0;
  var o = e[0];
  if (o == null || o.raw === void 0)
    r = !1, a += x_(n, t, o);
  else {
    var s = o;
    a += s[0];
  }
  for (var c = 1; c < e.length; c++)
    if (a += x_(n, t, e[c]), r) {
      var u = o;
      a += u[c];
    }
  uJ.lastIndex = 0;
  for (var f = "", m; (m = uJ.exec(a)) !== null; )
    f += "-" + m[1];
  var v = zut(a) + f;
  return {
    name: v,
    styles: a,
    next: Sf
  };
}
var qut = function(t) {
  return t();
}, Jut = k.useInsertionEffect ? k.useInsertionEffect : !1, Qut = Jut || qut, ect = !1, lce = /* @__PURE__ */ k.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement != "undefined" ? /* @__PURE__ */ But({
    key: "css"
  }) : null
);
lce.Provider;
var tct = function(t) {
  return /* @__PURE__ */ vR(function(n, r) {
    var a = Zp(lce);
    return t(n, a, r);
  });
}, nct = /* @__PURE__ */ k.createContext({}), uL = {}.hasOwnProperty, fR = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", rct = function(t, n) {
  var r = {};
  for (var a in n)
    uL.call(n, a) && (r[a] = n[a]);
  return r[fR] = t, r;
}, act = function(t) {
  var n = t.cache, r = t.serialized, a = t.isStringTag;
  return oce(n, r, a), Qut(function() {
    return Gut(n, r, a);
  }), null;
}, oct = /* @__PURE__ */ tct(
  /* <any, any> */
  function(e, t, n) {
    var r = e.css;
    typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
    var a = e[fR], o = [r], s = "";
    typeof e.className == "string" ? s = Uut(t.registered, o, e.className) : e.className != null && (s = e.className + " ");
    var c = sce(o, void 0, k.useContext(nct));
    s += t.key + "-" + c.name;
    var u = {};
    for (var f in e)
      uL.call(e, f) && f !== "css" && f !== fR && !ect && (u[f] = e[f]);
    return u.className = s, n && (u.ref = n), /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(act, {
      cache: t,
      serialized: c,
      isStringTag: typeof a == "string"
    }), /* @__PURE__ */ k.createElement(a, u));
  }
), ict = oct, Sn = function(t, n) {
  var r = arguments;
  if (n == null || !uL.call(n, "css"))
    return k.createElement.apply(void 0, r);
  var a = r.length, o = new Array(a);
  o[0] = ict, o[1] = rct(t, n);
  for (var s = 2; s < a; s++)
    o[s] = r[s];
  return k.createElement.apply(null, o);
};
function cL() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return sce(t);
}
var sct = function() {
  var t = cL.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
function lct(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
const uct = Math.min, cct = Math.max, D6 = Math.round, xx = Math.floor, L6 = (e) => ({
  x: e,
  y: e
});
function dct(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: a
  } = e;
  return {
    width: r,
    height: a,
    top: n,
    left: t,
    right: t + r,
    bottom: n + a,
    x: t,
    y: n
  };
}
function uce(e) {
  return dce(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Wp(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function cce(e) {
  var t;
  return (t = (dce(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function dce(e) {
  return e instanceof Node || e instanceof Wp(e).Node;
}
function fct(e) {
  return e instanceof Element || e instanceof Wp(e).Element;
}
function dL(e) {
  return e instanceof HTMLElement || e instanceof Wp(e).HTMLElement;
}
function cJ(e) {
  return typeof ShadowRoot == "undefined" ? !1 : e instanceof ShadowRoot || e instanceof Wp(e).ShadowRoot;
}
function fce(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = fL(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function pct() {
  return typeof CSS == "undefined" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function hct(e) {
  return ["html", "body", "#document"].includes(uce(e));
}
function fL(e) {
  return Wp(e).getComputedStyle(e);
}
function mct(e) {
  if (uce(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    cJ(e) && e.host || // Fallback.
    cce(e)
  );
  return cJ(t) ? t.host : t;
}
function pce(e) {
  const t = mct(e);
  return hct(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : dL(t) && fce(t) ? t : pce(t);
}
function $6(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = pce(e), o = a === ((r = e.ownerDocument) == null ? void 0 : r.body), s = Wp(a);
  if (o) {
    const c = pR(s);
    return t.concat(s, s.visualViewport || [], fce(a) ? a : [], c && n ? $6(c) : []);
  }
  return t.concat(a, $6(a, [], n));
}
function pR(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function vct(e) {
  const t = fL(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = dL(e), o = a ? e.offsetWidth : n, s = a ? e.offsetHeight : r, c = D6(n) !== o || D6(r) !== s;
  return c && (n = o, r = s), {
    width: n,
    height: r,
    $: c
  };
}
function pL(e) {
  return fct(e) ? e : e.contextElement;
}
function dJ(e) {
  const t = pL(e);
  if (!dL(t))
    return L6(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: o
  } = vct(t);
  let s = (o ? D6(n.width) : n.width) / r, c = (o ? D6(n.height) : n.height) / a;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const gct = /* @__PURE__ */ L6(0);
function yct(e) {
  const t = Wp(e);
  return !pct() || !t.visualViewport ? gct : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function bct(e, t, n) {
  return !1;
}
function fJ(e, t, n, r) {
  t === void 0 && (t = !1);
  const a = e.getBoundingClientRect(), o = pL(e);
  let s = L6(1);
  t && (s = dJ(e));
  const c = bct() ? yct(o) : L6(0);
  let u = (a.left + c.x) / s.x, f = (a.top + c.y) / s.y, m = a.width / s.x, v = a.height / s.y;
  if (o) {
    const y = Wp(o), b = r;
    let S = y, x = pR(S);
    for (; x && r && b !== S; ) {
      const E = dJ(x), N = x.getBoundingClientRect(), R = fL(x), O = N.left + (x.clientLeft + parseFloat(R.paddingLeft)) * E.x, D = N.top + (x.clientTop + parseFloat(R.paddingTop)) * E.y;
      u *= E.x, f *= E.y, m *= E.x, v *= E.y, u += O, f += D, S = Wp(x), x = pR(S);
    }
  }
  return dct({
    width: m,
    height: v,
    x: u,
    y: f
  });
}
function _ct(e, t) {
  let n = null, r;
  const a = cce(e);
  function o() {
    var c;
    clearTimeout(r), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, u) {
    c === void 0 && (c = !1), u === void 0 && (u = 1), o();
    const {
      left: f,
      top: m,
      width: v,
      height: y
    } = e.getBoundingClientRect();
    if (c || t(), !v || !y)
      return;
    const b = xx(m), S = xx(a.clientWidth - (f + v)), x = xx(a.clientHeight - (m + y)), E = xx(f), R = {
      rootMargin: -b + "px " + -S + "px " + -x + "px " + -E + "px",
      threshold: cct(0, uct(1, u)) || 1
    };
    let O = !0;
    function D($) {
      const B = $[0].intersectionRatio;
      if (B !== u) {
        if (!O)
          return s();
        B ? s(!1, B) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      O = !1;
    }
    try {
      n = new IntersectionObserver(D, Xn(Fe({}, R), {
        // Handle <iframe>s
        root: a.ownerDocument
      }));
    } catch ($) {
      n = new IntersectionObserver(D, R);
    }
    n.observe(e);
  }
  return s(!0), o;
}
function Cct(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, f = pL(e), m = a || o ? [...f ? $6(f) : [], ...$6(t)] : [];
  m.forEach((N) => {
    a && N.addEventListener("scroll", n, {
      passive: !0
    }), o && N.addEventListener("resize", n);
  });
  const v = f && c ? _ct(f, n) : null;
  let y = -1, b = null;
  s && (b = new ResizeObserver((N) => {
    let [R] = N;
    R && R.target === f && b && (b.unobserve(t), cancelAnimationFrame(y), y = requestAnimationFrame(() => {
      var O;
      (O = b) == null || O.observe(t);
    })), n();
  }), f && !u && b.observe(f), b.observe(t));
  let S, x = u ? fJ(e) : null;
  u && E();
  function E() {
    const N = fJ(e);
    x && (N.x !== x.x || N.y !== x.y || N.width !== x.width || N.height !== x.height) && n(), x = N, S = requestAnimationFrame(E);
  }
  return n(), () => {
    var N;
    m.forEach((R) => {
      a && R.removeEventListener("scroll", n), o && R.removeEventListener("resize", n);
    }), v == null || v(), (N = b) == null || N.disconnect(), b = null, u && cancelAnimationFrame(S);
  };
}
var hR = $J, wct = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], j6 = function() {
};
function Sct(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function xct(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    r[a - 2] = arguments[a];
  var o = [].concat(r);
  if (t && e)
    for (var s in t)
      t.hasOwnProperty(s) && t[s] && o.push("".concat(Sct(e, s)));
  return o.filter(function(c) {
    return c;
  }).map(function(c) {
    return String(c).trim();
  }).join(" ");
}
var pJ = function(t) {
  return Rct(t) ? t.filter(Boolean) : Ki(t) === "object" && t !== null ? [t] : [];
}, hce = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = Vu(t, wct);
  return kn({}, n);
}, qo = function(t, n, r) {
  var a = t.cx, o = t.getStyles, s = t.getClassNames, c = t.className;
  return {
    css: o(n, t),
    className: a(r != null ? r : {}, s(n, t), c)
  };
};
function Q8(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function Ect(e) {
  return Q8(e) ? window.innerHeight : e.clientHeight;
}
function mce(e) {
  return Q8(e) ? window.pageYOffset : e.scrollTop;
}
function F6(e, t) {
  if (Q8(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function Ict(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", r = /(auto|scroll)/;
  if (t.position === "fixed") return document.documentElement;
  for (var a = e; a = a.parentElement; )
    if (t = getComputedStyle(a), !(n && t.position === "static") && r.test(t.overflow + t.overflowY + t.overflowX))
      return a;
  return document.documentElement;
}
function kct(e, t, n, r) {
  return n * ((e = e / r - 1) * e * e + 1) + t;
}
function Ex(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : j6, a = mce(e), o = t - a, s = 10, c = 0;
  function u() {
    c += s;
    var f = kct(c, a, o, n);
    F6(e, f), c < n ? window.requestAnimationFrame(u) : r(e);
  }
  u();
}
function hJ(e, t) {
  var n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), a = t.offsetHeight / 3;
  r.bottom + a > n.bottom ? F6(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + a, e.scrollHeight)) : r.top - a < n.top && F6(e, Math.max(t.offsetTop - a, 0));
}
function Act(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function mJ() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch (e) {
    return !1;
  }
}
function Pct() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return !1;
  }
}
var vce = !1, Nct = {
  get passive() {
    return vce = !0;
  }
}, Ix = typeof window != "undefined" ? window : {};
Ix.addEventListener && Ix.removeEventListener && (Ix.addEventListener("p", j6, Nct), Ix.removeEventListener("p", j6, !1));
var Tct = vce;
function Oct(e) {
  return e != null;
}
function Rct(e) {
  return Array.isArray(e);
}
function kx(e, t, n) {
  return e ? t : n;
}
var Mct = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    r[a - 1] = arguments[a];
  var o = Object.entries(t).filter(function(s) {
    var c = Sd(s, 1), u = c[0];
    return !r.includes(u);
  });
  return o.reduce(function(s, c) {
    var u = Sd(c, 2), f = u[0], m = u[1];
    return s[f] = m, s;
  }, {});
}, Dct = ["children", "innerProps"], Lct = ["children", "innerProps"];
function $ct(e) {
  var t = e.maxHeight, n = e.menuEl, r = e.minHeight, a = e.placement, o = e.shouldScroll, s = e.isFixedPosition, c = e.controlHeight, u = Ict(n), f = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent) return f;
  var m = u.getBoundingClientRect(), v = m.height, y = n.getBoundingClientRect(), b = y.bottom, S = y.height, x = y.top, E = n.offsetParent.getBoundingClientRect(), N = E.top, R = s ? window.innerHeight : Ect(u), O = mce(u), D = parseInt(getComputedStyle(n).marginBottom, 10), $ = parseInt(getComputedStyle(n).marginTop, 10), B = N - $, G = R - x, Z = B + O, K = v - O - x, q = b - R + O + D, pe = O + x - $, he = 160;
  switch (a) {
    case "auto":
    case "bottom":
      if (G >= S)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (K >= S && !s)
        return o && Ex(u, q, he), {
          placement: "bottom",
          maxHeight: t
        };
      if (!s && K >= r || s && G >= r) {
        o && Ex(u, q, he);
        var _e = s ? G - D : K - D;
        return {
          placement: "bottom",
          maxHeight: _e
        };
      }
      if (a === "auto" || s) {
        var ge = t, Y = s ? B : Z;
        return Y >= r && (ge = Math.min(Y - D - c, t)), {
          placement: "top",
          maxHeight: ge
        };
      }
      if (a === "bottom")
        return o && F6(u, q), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (B >= S)
        return {
          placement: "top",
          maxHeight: t
        };
      if (Z >= S && !s)
        return o && Ex(u, pe, he), {
          placement: "top",
          maxHeight: t
        };
      if (!s && Z >= r || s && B >= r) {
        var ee = t;
        return (!s && Z >= r || s && B >= r) && (ee = s ? B - $ : Z - $), o && Ex(u, pe, he), {
          placement: "top",
          maxHeight: ee
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(a, '".'));
  }
  return f;
}
function jct(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var gce = function(t) {
  return t === "auto" ? "bottom" : t;
}, Fct = function(t, n) {
  var r, a = t.placement, o = t.theme, s = o.borderRadius, c = o.spacing, u = o.colors;
  return kn((r = {
    label: "menu"
  }, fs(r, jct(a), "100%"), fs(r, "position", "absolute"), fs(r, "width", "100%"), fs(r, "zIndex", 1), r), n ? {} : {
    backgroundColor: u.neutral0,
    borderRadius: s,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: c.menuGutter,
    marginTop: c.menuGutter
  });
}, yce = /* @__PURE__ */ LJ(null), Bct = function(t) {
  var n = t.children, r = t.minMenuHeight, a = t.maxMenuHeight, o = t.menuPlacement, s = t.menuPosition, c = t.menuShouldScrollIntoView, u = t.theme, f = Zp(yce) || {}, m = f.setPortalPlacement, v = Yo(null), y = mt(a), b = Sd(y, 2), S = b[0], x = b[1], E = mt(null), N = Sd(E, 2), R = N[0], O = N[1], D = u.spacing.controlHeight;
  return hR(function() {
    var $ = v.current;
    if ($) {
      var B = s === "fixed", G = c && !B, Z = $ct({
        maxHeight: a,
        menuEl: $,
        minHeight: r,
        placement: o,
        shouldScroll: G,
        isFixedPosition: B,
        controlHeight: D
      });
      x(Z.maxHeight), O(Z.placement), m == null || m(Z.placement);
    }
  }, [a, o, s, c, r, m, D]), n({
    ref: v,
    placerProps: kn(kn({}, t), {}, {
      placement: R || gce(o),
      maxHeight: S
    })
  });
}, Vct = function(t) {
  var n = t.children, r = t.innerRef, a = t.innerProps;
  return Sn("div", Fn({}, qo(t, "menu", {
    menu: !0
  }), {
    ref: r
  }, a), n);
}, Uct = Vct, Gct = function(t, n) {
  var r = t.maxHeight, a = t.theme.spacing.baseUnit;
  return kn({
    maxHeight: r,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: a,
    paddingTop: a
  });
}, zct = function(t) {
  var n = t.children, r = t.innerProps, a = t.innerRef, o = t.isMulti;
  return Sn("div", Fn({}, qo(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": o
  }), {
    ref: a
  }, r), n);
}, bce = function(t, n) {
  var r = t.theme, a = r.spacing.baseUnit, o = r.colors;
  return kn({
    textAlign: "center"
  }, n ? {} : {
    color: o.neutral40,
    padding: "".concat(a * 2, "px ").concat(a * 3, "px")
  });
}, Hct = bce, Wct = bce, Zct = function(t) {
  var n = t.children, r = n === void 0 ? "No options" : n, a = t.innerProps, o = Vu(t, Dct);
  return Sn("div", Fn({}, qo(kn(kn({}, o), {}, {
    children: r,
    innerProps: a
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), a), r);
}, Yct = function(t) {
  var n = t.children, r = n === void 0 ? "Loading..." : n, a = t.innerProps, o = Vu(t, Lct);
  return Sn("div", Fn({}, qo(kn(kn({}, o), {}, {
    children: r,
    innerProps: a
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), a), r);
}, Xct = function(t) {
  var n = t.rect, r = t.offset, a = t.position;
  return {
    left: n.left,
    position: a,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, Kct = function(t) {
  var n = t.appendTo, r = t.children, a = t.controlElement, o = t.innerProps, s = t.menuPlacement, c = t.menuPosition, u = Yo(null), f = Yo(null), m = mt(gce(s)), v = Sd(m, 2), y = v[0], b = v[1], S = k0(function() {
    return {
      setPortalPlacement: b
    };
  }, []), x = mt(null), E = Sd(x, 2), N = E[0], R = E[1], O = Yi(function() {
    if (a) {
      var G = Act(a), Z = c === "fixed" ? 0 : window.pageYOffset, K = G[y] + Z;
      (K !== (N == null ? void 0 : N.offset) || G.left !== (N == null ? void 0 : N.rect.left) || G.width !== (N == null ? void 0 : N.rect.width)) && R({
        offset: K,
        rect: G
      });
    }
  }, [a, c, y, N == null ? void 0 : N.offset, N == null ? void 0 : N.rect.left, N == null ? void 0 : N.rect.width]);
  hR(function() {
    O();
  }, [O]);
  var D = Yi(function() {
    typeof f.current == "function" && (f.current(), f.current = null), a && u.current && (f.current = Cct(a, u.current, O, {
      elementResize: "ResizeObserver" in window
    }));
  }, [a, O]);
  hR(function() {
    D();
  }, [D]);
  var $ = Yi(function(G) {
    u.current = G, D();
  }, [D]);
  if (!n && c !== "fixed" || !N) return null;
  var B = Sn("div", Fn({
    ref: $
  }, qo(kn(kn({}, t), {}, {
    offset: N.offset,
    position: c,
    rect: N.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), o), r);
  return Sn(yce.Provider, {
    value: S
  }, n ? /* @__PURE__ */ Bee.createPortal(B, n) : B);
}, qct = function(t) {
  var n = t.isDisabled, r = t.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, Jct = function(t) {
  var n = t.children, r = t.innerProps, a = t.isDisabled, o = t.isRtl;
  return Sn("div", Fn({}, qo(t, "container", {
    "--is-disabled": a,
    "--is-rtl": o
  }), r), n);
}, Qct = function(t, n) {
  var r = t.theme.spacing, a = t.isMulti, o = t.hasValue, s = t.selectProps.controlShouldRenderValue;
  return kn({
    alignItems: "center",
    display: a && o && s ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px")
  });
}, edt = function(t) {
  var n = t.children, r = t.innerProps, a = t.isMulti, o = t.hasValue;
  return Sn("div", Fn({}, qo(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": a,
    "value-container--has-value": o
  }), r), n);
}, tdt = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, ndt = function(t) {
  var n = t.children, r = t.innerProps;
  return Sn("div", Fn({}, qo(t, "indicatorsContainer", {
    indicators: !0
  }), r), n);
}, vJ, rdt = ["size"], adt = ["innerProps", "isRtl", "size"];
function odt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var idt = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: odt
}, _ce = function(t) {
  var n = t.size, r = Vu(t, rdt);
  return Sn("svg", Fn({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: idt
  }, r));
}, hL = function(t) {
  return Sn(_ce, Fn({
    size: 20
  }, t), Sn("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, Cce = function(t) {
  return Sn(_ce, Fn({
    size: 20
  }, t), Sn("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, wce = function(t, n) {
  var r = t.isFocused, a = t.theme, o = a.spacing.baseUnit, s = a.colors;
  return kn({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: r ? s.neutral60 : s.neutral20,
    padding: o * 2,
    ":hover": {
      color: r ? s.neutral80 : s.neutral40
    }
  });
}, sdt = wce, ldt = function(t) {
  var n = t.children, r = t.innerProps;
  return Sn("div", Fn({}, qo(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), r), n || Sn(Cce, null));
}, udt = wce, cdt = function(t) {
  var n = t.children, r = t.innerProps;
  return Sn("div", Fn({}, qo(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), r), n || Sn(hL, null));
}, ddt = function(t, n) {
  var r = t.isDisabled, a = t.theme, o = a.spacing.baseUnit, s = a.colors;
  return kn({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: r ? s.neutral10 : s.neutral20,
    marginBottom: o * 2,
    marginTop: o * 2
  });
}, fdt = function(t) {
  var n = t.innerProps;
  return Sn("span", Fn({}, n, qo(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, pdt = sct(vJ || (vJ = lct([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), hdt = function(t, n) {
  var r = t.isFocused, a = t.size, o = t.theme, s = o.colors, c = o.spacing.baseUnit;
  return kn({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: a,
    lineHeight: 1,
    marginRight: a,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: r ? s.neutral60 : s.neutral20,
    padding: c * 2
  });
}, MN = function(t) {
  var n = t.delay, r = t.offset;
  return Sn("span", {
    css: /* @__PURE__ */ cL({
      animation: "".concat(pdt, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, mdt = function(t) {
  var n = t.innerProps, r = t.isRtl, a = t.size, o = a === void 0 ? 4 : a, s = Vu(t, adt);
  return Sn("div", Fn({}, qo(kn(kn({}, s), {}, {
    innerProps: n,
    isRtl: r,
    size: o
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), Sn(MN, {
    delay: 0,
    offset: r
  }), Sn(MN, {
    delay: 160,
    offset: !0
  }), Sn(MN, {
    delay: 320,
    offset: !r
  }));
}, vdt = function(t, n) {
  var r = t.isDisabled, a = t.isFocused, o = t.theme, s = o.colors, c = o.borderRadius, u = o.spacing;
  return kn({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: u.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: r ? s.neutral5 : s.neutral0,
    borderColor: r ? s.neutral10 : a ? s.primary : s.neutral20,
    borderRadius: c,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: a ? "0 0 0 1px ".concat(s.primary) : void 0,
    "&:hover": {
      borderColor: a ? s.primary : s.neutral30
    }
  });
}, gdt = function(t) {
  var n = t.children, r = t.isDisabled, a = t.isFocused, o = t.innerRef, s = t.innerProps, c = t.menuIsOpen;
  return Sn("div", Fn({
    ref: o
  }, qo(t, "control", {
    control: !0,
    "control--is-disabled": r,
    "control--is-focused": a,
    "control--menu-is-open": c
  }), s, {
    "aria-disabled": r || void 0
  }), n);
}, ydt = gdt, bdt = ["data"], _dt = function(t, n) {
  var r = t.theme.spacing;
  return n ? {} : {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, Cdt = function(t) {
  var n = t.children, r = t.cx, a = t.getStyles, o = t.getClassNames, s = t.Heading, c = t.headingProps, u = t.innerProps, f = t.label, m = t.theme, v = t.selectProps;
  return Sn("div", Fn({}, qo(t, "group", {
    group: !0
  }), u), Sn(s, Fn({}, c, {
    selectProps: v,
    theme: m,
    getStyles: a,
    getClassNames: o,
    cx: r
  }), f), Sn("div", null, n));
}, wdt = function(t, n) {
  var r = t.theme, a = r.colors, o = r.spacing;
  return kn({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: a.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: o.baseUnit * 3,
    paddingRight: o.baseUnit * 3,
    textTransform: "uppercase"
  });
}, Sdt = function(t) {
  var n = hce(t);
  n.data;
  var r = Vu(n, bdt);
  return Sn("div", Fn({}, qo(t, "groupHeading", {
    "group-heading": !0
  }), r));
}, xdt = Cdt, Edt = ["innerRef", "isDisabled", "isHidden", "inputClassName"], Idt = function(t, n) {
  var r = t.isDisabled, a = t.value, o = t.theme, s = o.spacing, c = o.colors;
  return kn(kn({
    visibility: r ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: a ? "translateZ(0)" : ""
  }, kdt), n ? {} : {
    margin: s.baseUnit / 2,
    paddingBottom: s.baseUnit / 2,
    paddingTop: s.baseUnit / 2,
    color: c.neutral80
  });
}, Sce = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, kdt = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": kn({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, Sce)
}, Adt = function(t) {
  return kn({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, Sce);
}, Pdt = function(t) {
  var n = t.cx, r = t.value, a = hce(t), o = a.innerRef, s = a.isDisabled, c = a.isHidden, u = a.inputClassName, f = Vu(a, Edt);
  return Sn("div", Fn({}, qo(t, "input", {
    "input-container": !0
  }), {
    "data-value": r || ""
  }), Sn("input", Fn({
    className: n({
      input: !0
    }, u),
    ref: o,
    style: Adt(c),
    disabled: s
  }, f)));
}, Ndt = Pdt, Tdt = function(t, n) {
  var r = t.theme, a = r.spacing, o = r.borderRadius, s = r.colors;
  return kn({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: s.neutral10,
    borderRadius: o / 2,
    margin: a.baseUnit / 2
  });
}, Odt = function(t, n) {
  var r = t.theme, a = r.borderRadius, o = r.colors, s = t.cropWithEllipsis;
  return kn({
    overflow: "hidden",
    textOverflow: s || s === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: a / 2,
    color: o.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, Rdt = function(t, n) {
  var r = t.theme, a = r.spacing, o = r.borderRadius, s = r.colors, c = t.isFocused;
  return kn({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: o / 2,
    backgroundColor: c ? s.dangerLight : void 0,
    paddingLeft: a.baseUnit,
    paddingRight: a.baseUnit,
    ":hover": {
      backgroundColor: s.dangerLight,
      color: s.danger
    }
  });
}, xce = function(t) {
  var n = t.children, r = t.innerProps;
  return Sn("div", r, n);
}, Mdt = xce, Ddt = xce;
function Ldt(e) {
  var t = e.children, n = e.innerProps;
  return Sn("div", Fn({
    role: "button"
  }, n), t || Sn(hL, {
    size: 14
  }));
}
var $dt = function(t) {
  var n = t.children, r = t.components, a = t.data, o = t.innerProps, s = t.isDisabled, c = t.removeProps, u = t.selectProps, f = r.Container, m = r.Label, v = r.Remove;
  return Sn(f, {
    data: a,
    innerProps: kn(kn({}, qo(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": s
    })), o),
    selectProps: u
  }, Sn(m, {
    data: a,
    innerProps: kn({}, qo(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: u
  }, n), Sn(v, {
    data: a,
    innerProps: kn(kn({}, qo(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, c),
    selectProps: u
  }));
}, jdt = $dt, Fdt = function(t, n) {
  var r = t.isDisabled, a = t.isFocused, o = t.isSelected, s = t.theme, c = s.spacing, u = s.colors;
  return kn({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: o ? u.primary : a ? u.primary25 : "transparent",
    color: r ? u.neutral20 : o ? u.neutral0 : "inherit",
    padding: "".concat(c.baseUnit * 2, "px ").concat(c.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: r ? void 0 : o ? u.primary : u.primary50
    }
  });
}, Bdt = function(t) {
  var n = t.children, r = t.isDisabled, a = t.isFocused, o = t.isSelected, s = t.innerRef, c = t.innerProps;
  return Sn("div", Fn({}, qo(t, "option", {
    option: !0,
    "option--is-disabled": r,
    "option--is-focused": a,
    "option--is-selected": o
  }), {
    ref: s,
    "aria-disabled": r
  }, c), n);
}, Vdt = Bdt, Udt = function(t, n) {
  var r = t.theme, a = r.spacing, o = r.colors;
  return kn({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: o.neutral50,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
}, Gdt = function(t) {
  var n = t.children, r = t.innerProps;
  return Sn("div", Fn({}, qo(t, "placeholder", {
    placeholder: !0
  }), r), n);
}, zdt = Gdt, Hdt = function(t, n) {
  var r = t.isDisabled, a = t.theme, o = a.spacing, s = a.colors;
  return kn({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: r ? s.neutral40 : s.neutral80,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, Wdt = function(t) {
  var n = t.children, r = t.isDisabled, a = t.innerProps;
  return Sn("div", Fn({}, qo(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": r
  }), a), n);
}, Zdt = Wdt, Ydt = {
  ClearIndicator: cdt,
  Control: ydt,
  DropdownIndicator: ldt,
  DownChevron: Cce,
  CrossIcon: hL,
  Group: xdt,
  GroupHeading: Sdt,
  IndicatorsContainer: ndt,
  IndicatorSeparator: fdt,
  Input: Ndt,
  LoadingIndicator: mdt,
  Menu: Uct,
  MenuList: zct,
  MenuPortal: Kct,
  LoadingMessage: Yct,
  NoOptionsMessage: Zct,
  MultiValue: jdt,
  MultiValueContainer: Mdt,
  MultiValueLabel: Ddt,
  MultiValueRemove: Ldt,
  Option: Vdt,
  Placeholder: zdt,
  SelectContainer: Jct,
  SingleValue: Zdt,
  ValueContainer: edt
}, Xdt = function(t) {
  return kn(kn({}, Ydt), t.components);
}, gJ = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function Kdt(e, t) {
  return !!(e === t || gJ(e) && gJ(t));
}
function qdt(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!Kdt(e[n], t[n]))
      return !1;
  return !0;
}
function Jdt(e, t) {
  t === void 0 && (t = qdt);
  var n = null;
  function r() {
    for (var a = [], o = 0; o < arguments.length; o++)
      a[o] = arguments[o];
    if (n && n.lastThis === this && t(a, n.lastArgs))
      return n.lastResult;
    var s = e.apply(this, a);
    return n = {
      lastResult: s,
      lastArgs: a,
      lastThis: this
    }, s;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
function Qdt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var eft = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: Qdt
}, tft = function(t) {
  return Sn("span", Fn({
    css: eft
  }, t));
}, yJ = tft, nft = {
  guidance: function(t) {
    var n = t.isSearchable, r = t.isMulti, a = t.tabSelectsValue, o = t.context, s = t.isInitialFocus;
    switch (o) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(a ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return s ? "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, r = t.label, a = r === void 0 ? "" : r, o = t.labels, s = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(a, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(o.length > 1 ? "s" : "", " ").concat(o.join(","), ", selected.");
      case "select-option":
        return s ? "option ".concat(a, " is disabled. Select another option.") : "option ".concat(a, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, r = t.focused, a = t.options, o = t.label, s = o === void 0 ? "" : o, c = t.selectValue, u = t.isDisabled, f = t.isSelected, m = t.isAppleDevice, v = function(x, E) {
      return x && x.length ? "".concat(x.indexOf(E) + 1, " of ").concat(x.length) : "";
    };
    if (n === "value" && c)
      return "value ".concat(s, " focused, ").concat(v(c, r), ".");
    if (n === "menu" && m) {
      var y = u ? " disabled" : "", b = "".concat(f ? " selected" : "").concat(y);
      return "".concat(s).concat(b, ", ").concat(v(a, r), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, r = t.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, rft = function(t) {
  var n = t.ariaSelection, r = t.focusedOption, a = t.focusedValue, o = t.focusableOptions, s = t.isFocused, c = t.selectValue, u = t.selectProps, f = t.id, m = t.isAppleDevice, v = u.ariaLiveMessages, y = u.getOptionLabel, b = u.inputValue, S = u.isMulti, x = u.isOptionDisabled, E = u.isSearchable, N = u.menuIsOpen, R = u.options, O = u.screenReaderStatus, D = u.tabSelectsValue, $ = u.isLoading, B = u["aria-label"], G = u["aria-live"], Z = k0(function() {
    return kn(kn({}, nft), v || {});
  }, [v]), K = k0(function() {
    var Y = "";
    if (n && Z.onChange) {
      var ee = n.option, oe = n.options, me = n.removedValue, xe = n.removedValues, X = n.value, ye = function(we) {
        return Array.isArray(we) ? null : we;
      }, ce = me || ee || ye(X), se = ce ? y(ce) : "", Ie = oe || xe || void 0, Le = Ie ? Ie.map(y) : [], ie = kn({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: ce && x(ce, c),
        label: se,
        labels: Le
      }, n);
      Y = Z.onChange(ie);
    }
    return Y;
  }, [n, Z, x, c, y]), q = k0(function() {
    var Y = "", ee = r || a, oe = !!(r && c && c.includes(r));
    if (ee && Z.onFocus) {
      var me = {
        focused: ee,
        label: y(ee),
        isDisabled: x(ee, c),
        isSelected: oe,
        options: o,
        context: ee === r ? "menu" : "value",
        selectValue: c,
        isAppleDevice: m
      };
      Y = Z.onFocus(me);
    }
    return Y;
  }, [r, a, y, x, Z, o, c, m]), pe = k0(function() {
    var Y = "";
    if (N && R.length && !$ && Z.onFilter) {
      var ee = O({
        count: o.length
      });
      Y = Z.onFilter({
        inputValue: b,
        resultsMessage: ee
      });
    }
    return Y;
  }, [o, b, N, Z, R, O, $]), he = (n == null ? void 0 : n.action) === "initial-input-focus", _e = k0(function() {
    var Y = "";
    if (Z.guidance) {
      var ee = a ? "value" : N ? "menu" : "input";
      Y = Z.guidance({
        "aria-label": B,
        context: ee,
        isDisabled: r && x(r, c),
        isMulti: S,
        isSearchable: E,
        tabSelectsValue: D,
        isInitialFocus: he
      });
    }
    return Y;
  }, [B, r, a, S, x, E, N, Z, c, D, he]), ge = Sn(UN, null, Sn("span", {
    id: "aria-selection"
  }, K), Sn("span", {
    id: "aria-focused"
  }, q), Sn("span", {
    id: "aria-results"
  }, pe), Sn("span", {
    id: "aria-guidance"
  }, _e));
  return Sn(UN, null, Sn(yJ, {
    id: f
  }, he && ge), Sn(yJ, {
    "aria-live": G,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, s && !he && ge));
}, aft = rft, mR = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], oft = new RegExp("[" + mR.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), Ece = {};
for (var DN = 0; DN < mR.length; DN++)
  for (var LN = mR[DN], $N = 0; $N < LN.letters.length; $N++)
    Ece[LN.letters[$N]] = LN.base;
var Ice = function(t) {
  return t.replace(oft, function(n) {
    return Ece[n];
  });
}, ift = Jdt(Ice), bJ = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, sft = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, lft = function(t) {
  return function(n, r) {
    if (n.data.__isNew__) return !0;
    var a = kn({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: sft,
      trim: !0,
      matchFrom: "any"
    }, t), o = a.ignoreCase, s = a.ignoreAccents, c = a.stringify, u = a.trim, f = a.matchFrom, m = u ? bJ(r) : r, v = u ? bJ(c(n)) : c(n);
    return o && (m = m.toLowerCase(), v = v.toLowerCase()), s && (m = ift(m), v = Ice(v)), f === "start" ? v.substr(0, m.length) === m : v.indexOf(m) > -1;
  };
}, uft = ["innerRef"];
function cft(e) {
  var t = e.innerRef, n = Vu(e, uft), r = Mct(n, "onExited", "in", "enter", "exit", "appear");
  return Sn("input", Fn({
    ref: t
  }, r, {
    css: /* @__PURE__ */ cL({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var dft = function(t) {
  t.cancelable && t.preventDefault(), t.stopPropagation();
};
function fft(e) {
  var t = e.isEnabled, n = e.onBottomArrive, r = e.onBottomLeave, a = e.onTopArrive, o = e.onTopLeave, s = Yo(!1), c = Yo(!1), u = Yo(0), f = Yo(null), m = Yi(function(E, N) {
    if (f.current !== null) {
      var R = f.current, O = R.scrollTop, D = R.scrollHeight, $ = R.clientHeight, B = f.current, G = N > 0, Z = D - $ - O, K = !1;
      Z > N && s.current && (r && r(E), s.current = !1), G && c.current && (o && o(E), c.current = !1), G && N > Z ? (n && !s.current && n(E), B.scrollTop = D, K = !0, s.current = !0) : !G && -N > O && (a && !c.current && a(E), B.scrollTop = 0, K = !0, c.current = !0), K && dft(E);
    }
  }, [n, r, a, o]), v = Yi(function(E) {
    m(E, E.deltaY);
  }, [m]), y = Yi(function(E) {
    u.current = E.changedTouches[0].clientY;
  }, []), b = Yi(function(E) {
    var N = u.current - E.changedTouches[0].clientY;
    m(E, N);
  }, [m]), S = Yi(function(E) {
    if (E) {
      var N = Tct ? {
        passive: !1
      } : !1;
      E.addEventListener("wheel", v, N), E.addEventListener("touchstart", y, N), E.addEventListener("touchmove", b, N);
    }
  }, [b, y, v]), x = Yi(function(E) {
    E && (E.removeEventListener("wheel", v, !1), E.removeEventListener("touchstart", y, !1), E.removeEventListener("touchmove", b, !1));
  }, [b, y, v]);
  return mn(function() {
    if (t) {
      var E = f.current;
      return S(E), function() {
        x(E);
      };
    }
  }, [t, S, x]), function(E) {
    f.current = E;
  };
}
var _J = ["boxSizing", "height", "overflow", "paddingRight", "position"], CJ = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function wJ(e) {
  e.preventDefault();
}
function SJ(e) {
  e.stopPropagation();
}
function xJ() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function EJ() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var IJ = !!(typeof window != "undefined" && window.document && window.document.createElement), g4 = 0, Ey = {
  capture: !1,
  passive: !1
};
function pft(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, r = n === void 0 ? !0 : n, a = Yo({}), o = Yo(null), s = Yi(function(u) {
    if (IJ) {
      var f = document.body, m = f && f.style;
      if (r && _J.forEach(function(S) {
        var x = m && m[S];
        a.current[S] = x;
      }), r && g4 < 1) {
        var v = parseInt(a.current.paddingRight, 10) || 0, y = document.body ? document.body.clientWidth : 0, b = window.innerWidth - y + v || 0;
        Object.keys(CJ).forEach(function(S) {
          var x = CJ[S];
          m && (m[S] = x);
        }), m && (m.paddingRight = "".concat(b, "px"));
      }
      f && EJ() && (f.addEventListener("touchmove", wJ, Ey), u && (u.addEventListener("touchstart", xJ, Ey), u.addEventListener("touchmove", SJ, Ey))), g4 += 1;
    }
  }, [r]), c = Yi(function(u) {
    if (IJ) {
      var f = document.body, m = f && f.style;
      g4 = Math.max(g4 - 1, 0), r && g4 < 1 && _J.forEach(function(v) {
        var y = a.current[v];
        m && (m[v] = y);
      }), f && EJ() && (f.removeEventListener("touchmove", wJ, Ey), u && (u.removeEventListener("touchstart", xJ, Ey), u.removeEventListener("touchmove", SJ, Ey)));
    }
  }, [r]);
  return mn(function() {
    if (t) {
      var u = o.current;
      return s(u), function() {
        c(u);
      };
    }
  }, [t, s, c]), function(u) {
    o.current = u;
  };
}
function hft() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var mft = function(t) {
  var n = t.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, vft = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: hft
};
function gft(e) {
  var t = e.children, n = e.lockEnabled, r = e.captureEnabled, a = r === void 0 ? !0 : r, o = e.onBottomArrive, s = e.onBottomLeave, c = e.onTopArrive, u = e.onTopLeave, f = fft({
    isEnabled: a,
    onBottomArrive: o,
    onBottomLeave: s,
    onTopArrive: c,
    onTopLeave: u
  }), m = pft({
    isEnabled: n
  }), v = function(b) {
    f(b), m(b);
  };
  return Sn(UN, null, n && Sn("div", {
    onClick: mft,
    css: vft
  }), t(v));
}
function yft() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var bft = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: yft
}, _ft = function(t) {
  var n = t.name, r = t.onFocus;
  return Sn("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: r,
    css: bft,
    value: "",
    onChange: function() {
    }
  });
}, Cft = _ft;
function mL(e) {
  var t;
  return typeof window != "undefined" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function wft() {
  return mL(/^iPhone/i);
}
function kce() {
  return mL(/^Mac/i);
}
function Sft() {
  return mL(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  kce() && navigator.maxTouchPoints > 1;
}
function xft() {
  return wft() || Sft();
}
function Eft() {
  return kce() || xft();
}
var Ift = function(t) {
  return t.label;
}, kft = function(t) {
  return t.label;
}, Aft = function(t) {
  return t.value;
}, Pft = function(t) {
  return !!t.isDisabled;
}, Nft = {
  clearIndicator: udt,
  container: qct,
  control: vdt,
  dropdownIndicator: sdt,
  group: _dt,
  groupHeading: wdt,
  indicatorsContainer: tdt,
  indicatorSeparator: ddt,
  input: Idt,
  loadingIndicator: hdt,
  loadingMessage: Wct,
  menu: Fct,
  menuList: Gct,
  menuPortal: Xct,
  multiValue: Tdt,
  multiValueLabel: Odt,
  multiValueRemove: Rdt,
  noOptionsMessage: Hct,
  option: Fdt,
  placeholder: Udt,
  singleValue: Hdt,
  valueContainer: Qct
}, Tft = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, Oft = 4, Ace = 4, Rft = 38, Mft = Ace * 2, Dft = {
  baseUnit: Ace,
  controlHeight: Rft,
  menuGutter: Mft
}, jN = {
  borderRadius: Oft,
  colors: Tft,
  spacing: Dft
}, Lft = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: mJ(),
  captureMenuScroll: !mJ(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: lft(),
  formatGroupLabel: Ift,
  getOptionLabel: kft,
  getOptionValue: Aft,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: Pft,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !Pct(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function kJ(e, t, n, r) {
  var a = Tce(e, t, n), o = Oce(e, t, n), s = Nce(e, t), c = B6(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: a,
    isSelected: o,
    label: s,
    value: c,
    index: r
  };
}
function y7(e, t) {
  return e.options.map(function(n, r) {
    if ("options" in n) {
      var a = n.options.map(function(s, c) {
        return kJ(e, s, t, c);
      }).filter(function(s) {
        return PJ(e, s);
      });
      return a.length > 0 ? {
        type: "group",
        data: n,
        options: a,
        index: r
      } : void 0;
    }
    var o = kJ(e, n, t, r);
    return PJ(e, o) ? o : void 0;
  }).filter(Oct);
}
function Pce(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, oL(n.options.map(function(r) {
      return r.data;
    }))) : t.push(n.data), t;
  }, []);
}
function AJ(e, t) {
  return e.reduce(function(n, r) {
    return r.type === "group" ? n.push.apply(n, oL(r.options.map(function(a) {
      return {
        data: a.data,
        id: "".concat(t, "-").concat(r.index, "-").concat(a.index)
      };
    }))) : n.push({
      data: r.data,
      id: "".concat(t, "-").concat(r.index)
    }), n;
  }, []);
}
function $ft(e, t) {
  return Pce(y7(e, t));
}
function PJ(e, t) {
  var n = e.inputValue, r = n === void 0 ? "" : n, a = t.data, o = t.isSelected, s = t.label, c = t.value;
  return (!Mce(e) || !o) && Rce(e, {
    label: s,
    value: c,
    data: a
  }, r);
}
function jft(e, t) {
  var n = e.focusedValue, r = e.selectValue, a = r.indexOf(n);
  if (a > -1) {
    var o = t.indexOf(n);
    if (o > -1)
      return n;
    if (a < t.length)
      return t[a];
  }
  return null;
}
function Fft(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var FN = function(t, n) {
  var r, a = (r = t.find(function(o) {
    return o.data === n;
  })) === null || r === void 0 ? void 0 : r.id;
  return a || null;
}, Nce = function(t, n) {
  return t.getOptionLabel(n);
}, B6 = function(t, n) {
  return t.getOptionValue(n);
};
function Tce(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function Oce(e, t, n) {
  if (n.indexOf(t) > -1) return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var r = B6(e, t);
  return n.some(function(a) {
    return B6(e, a) === r;
  });
}
function Rce(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var Mce = function(t) {
  var n = t.hideSelectedOptions, r = t.isMulti;
  return n === void 0 ? r : n;
}, Bft = 1, Dce = /* @__PURE__ */ function(e) {
  E_(n, e);
  var t = lut(n);
  function n(r) {
    var a;
    if (Fu(this, n), a = t.call(this, r), a.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, a.blockOptionHover = !1, a.isComposing = !1, a.commonProps = void 0, a.initialTouchX = 0, a.initialTouchY = 0, a.openAfterFocus = !1, a.scrollToFocusedOptionOnUpdate = !1, a.userIsDragging = void 0, a.isAppleDevice = Eft(), a.controlRef = null, a.getControlRef = function(u) {
      a.controlRef = u;
    }, a.focusedOptionRef = null, a.getFocusedOptionRef = function(u) {
      a.focusedOptionRef = u;
    }, a.menuListRef = null, a.getMenuListRef = function(u) {
      a.menuListRef = u;
    }, a.inputRef = null, a.getInputRef = function(u) {
      a.inputRef = u;
    }, a.focus = a.focusInput, a.blur = a.blurInput, a.onChange = function(u, f) {
      var m = a.props, v = m.onChange, y = m.name;
      f.name = y, a.ariaOnChange(u, f), v(u, f);
    }, a.setValue = function(u, f, m) {
      var v = a.props, y = v.closeMenuOnSelect, b = v.isMulti, S = v.inputValue;
      a.onInputChange("", {
        action: "set-value",
        prevInputValue: S
      }), y && (a.setState({
        inputIsHiddenAfterUpdate: !b
      }), a.onMenuClose()), a.setState({
        clearFocusValueOnUpdate: !0
      }), a.onChange(u, {
        action: f,
        option: m
      });
    }, a.selectOption = function(u) {
      var f = a.props, m = f.blurInputOnSelect, v = f.isMulti, y = f.name, b = a.state.selectValue, S = v && a.isOptionSelected(u, b), x = a.isOptionDisabled(u, b);
      if (S) {
        var E = a.getOptionValue(u);
        a.setValue(b.filter(function(N) {
          return a.getOptionValue(N) !== E;
        }), "deselect-option", u);
      } else if (!x)
        v ? a.setValue([].concat(oL(b), [u]), "select-option", u) : a.setValue(u, "select-option");
      else {
        a.ariaOnChange(u, {
          action: "select-option",
          option: u,
          name: y
        });
        return;
      }
      m && a.blurInput();
    }, a.removeValue = function(u) {
      var f = a.props.isMulti, m = a.state.selectValue, v = a.getOptionValue(u), y = m.filter(function(S) {
        return a.getOptionValue(S) !== v;
      }), b = kx(f, y, y[0] || null);
      a.onChange(b, {
        action: "remove-value",
        removedValue: u
      }), a.focusInput();
    }, a.clearValue = function() {
      var u = a.state.selectValue;
      a.onChange(kx(a.props.isMulti, [], null), {
        action: "clear",
        removedValues: u
      });
    }, a.popValue = function() {
      var u = a.props.isMulti, f = a.state.selectValue, m = f[f.length - 1], v = f.slice(0, f.length - 1), y = kx(u, v, v[0] || null);
      a.onChange(y, {
        action: "pop-value",
        removedValue: m
      });
    }, a.getFocusedOptionId = function(u) {
      return FN(a.state.focusableOptionsWithIds, u);
    }, a.getFocusableOptionsWithIds = function() {
      return AJ(y7(a.props, a.state.selectValue), a.getElementId("option"));
    }, a.getValue = function() {
      return a.state.selectValue;
    }, a.cx = function() {
      for (var u = arguments.length, f = new Array(u), m = 0; m < u; m++)
        f[m] = arguments[m];
      return xct.apply(void 0, [a.props.classNamePrefix].concat(f));
    }, a.getOptionLabel = function(u) {
      return Nce(a.props, u);
    }, a.getOptionValue = function(u) {
      return B6(a.props, u);
    }, a.getStyles = function(u, f) {
      var m = a.props.unstyled, v = Nft[u](f, m);
      v.boxSizing = "border-box";
      var y = a.props.styles[u];
      return y ? y(v, f) : v;
    }, a.getClassNames = function(u, f) {
      var m, v;
      return (m = (v = a.props.classNames)[u]) === null || m === void 0 ? void 0 : m.call(v, f);
    }, a.getElementId = function(u) {
      return "".concat(a.state.instancePrefix, "-").concat(u);
    }, a.getComponents = function() {
      return Xdt(a.props);
    }, a.buildCategorizedOptions = function() {
      return y7(a.props, a.state.selectValue);
    }, a.getCategorizedOptions = function() {
      return a.props.menuIsOpen ? a.buildCategorizedOptions() : [];
    }, a.buildFocusableOptions = function() {
      return Pce(a.buildCategorizedOptions());
    }, a.getFocusableOptions = function() {
      return a.props.menuIsOpen ? a.buildFocusableOptions() : [];
    }, a.ariaOnChange = function(u, f) {
      a.setState({
        ariaSelection: kn({
          value: u
        }, f)
      });
    }, a.onMenuMouseDown = function(u) {
      u.button === 0 && (u.stopPropagation(), u.preventDefault(), a.focusInput());
    }, a.onMenuMouseMove = function(u) {
      a.blockOptionHover = !1;
    }, a.onControlMouseDown = function(u) {
      if (!u.defaultPrevented) {
        var f = a.props.openMenuOnClick;
        a.state.isFocused ? a.props.menuIsOpen ? u.target.tagName !== "INPUT" && u.target.tagName !== "TEXTAREA" && a.onMenuClose() : f && a.openMenu("first") : (f && (a.openAfterFocus = !0), a.focusInput()), u.target.tagName !== "INPUT" && u.target.tagName !== "TEXTAREA" && u.preventDefault();
      }
    }, a.onDropdownIndicatorMouseDown = function(u) {
      if (!(u && u.type === "mousedown" && u.button !== 0) && !a.props.isDisabled) {
        var f = a.props, m = f.isMulti, v = f.menuIsOpen;
        a.focusInput(), v ? (a.setState({
          inputIsHiddenAfterUpdate: !m
        }), a.onMenuClose()) : a.openMenu("first"), u.preventDefault();
      }
    }, a.onClearIndicatorMouseDown = function(u) {
      u && u.type === "mousedown" && u.button !== 0 || (a.clearValue(), u.preventDefault(), a.openAfterFocus = !1, u.type === "touchend" ? a.focusInput() : setTimeout(function() {
        return a.focusInput();
      }));
    }, a.onScroll = function(u) {
      typeof a.props.closeMenuOnScroll == "boolean" ? u.target instanceof HTMLElement && Q8(u.target) && a.props.onMenuClose() : typeof a.props.closeMenuOnScroll == "function" && a.props.closeMenuOnScroll(u) && a.props.onMenuClose();
    }, a.onCompositionStart = function() {
      a.isComposing = !0;
    }, a.onCompositionEnd = function() {
      a.isComposing = !1;
    }, a.onTouchStart = function(u) {
      var f = u.touches, m = f && f.item(0);
      m && (a.initialTouchX = m.clientX, a.initialTouchY = m.clientY, a.userIsDragging = !1);
    }, a.onTouchMove = function(u) {
      var f = u.touches, m = f && f.item(0);
      if (m) {
        var v = Math.abs(m.clientX - a.initialTouchX), y = Math.abs(m.clientY - a.initialTouchY), b = 5;
        a.userIsDragging = v > b || y > b;
      }
    }, a.onTouchEnd = function(u) {
      a.userIsDragging || (a.controlRef && !a.controlRef.contains(u.target) && a.menuListRef && !a.menuListRef.contains(u.target) && a.blurInput(), a.initialTouchX = 0, a.initialTouchY = 0);
    }, a.onControlTouchEnd = function(u) {
      a.userIsDragging || a.onControlMouseDown(u);
    }, a.onClearIndicatorTouchEnd = function(u) {
      a.userIsDragging || a.onClearIndicatorMouseDown(u);
    }, a.onDropdownIndicatorTouchEnd = function(u) {
      a.userIsDragging || a.onDropdownIndicatorMouseDown(u);
    }, a.handleInputChange = function(u) {
      var f = a.props.inputValue, m = u.currentTarget.value;
      a.setState({
        inputIsHiddenAfterUpdate: !1
      }), a.onInputChange(m, {
        action: "input-change",
        prevInputValue: f
      }), a.props.menuIsOpen || a.onMenuOpen();
    }, a.onInputFocus = function(u) {
      a.props.onFocus && a.props.onFocus(u), a.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (a.openAfterFocus || a.props.openMenuOnFocus) && a.openMenu("first"), a.openAfterFocus = !1;
    }, a.onInputBlur = function(u) {
      var f = a.props.inputValue;
      if (a.menuListRef && a.menuListRef.contains(document.activeElement)) {
        a.inputRef.focus();
        return;
      }
      a.props.onBlur && a.props.onBlur(u), a.onInputChange("", {
        action: "input-blur",
        prevInputValue: f
      }), a.onMenuClose(), a.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, a.onOptionHover = function(u) {
      if (!(a.blockOptionHover || a.state.focusedOption === u)) {
        var f = a.getFocusableOptions(), m = f.indexOf(u);
        a.setState({
          focusedOption: u,
          focusedOptionId: m > -1 ? a.getFocusedOptionId(u) : null
        });
      }
    }, a.shouldHideSelectedOptions = function() {
      return Mce(a.props);
    }, a.onValueInputFocus = function(u) {
      u.preventDefault(), u.stopPropagation(), a.focus();
    }, a.onKeyDown = function(u) {
      var f = a.props, m = f.isMulti, v = f.backspaceRemovesValue, y = f.escapeClearsValue, b = f.inputValue, S = f.isClearable, x = f.isDisabled, E = f.menuIsOpen, N = f.onKeyDown, R = f.tabSelectsValue, O = f.openMenuOnFocus, D = a.state, $ = D.focusedOption, B = D.focusedValue, G = D.selectValue;
      if (!x && !(typeof N == "function" && (N(u), u.defaultPrevented))) {
        switch (a.blockOptionHover = !0, u.key) {
          case "ArrowLeft":
            if (!m || b) return;
            a.focusValue("previous");
            break;
          case "ArrowRight":
            if (!m || b) return;
            a.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (b) return;
            if (B)
              a.removeValue(B);
            else {
              if (!v) return;
              m ? a.popValue() : S && a.clearValue();
            }
            break;
          case "Tab":
            if (a.isComposing || u.shiftKey || !E || !R || !$ || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            O && a.isOptionSelected($, G))
              return;
            a.selectOption($);
            break;
          case "Enter":
            if (u.keyCode === 229)
              break;
            if (E) {
              if (!$ || a.isComposing) return;
              a.selectOption($);
              break;
            }
            return;
          case "Escape":
            E ? (a.setState({
              inputIsHiddenAfterUpdate: !1
            }), a.onInputChange("", {
              action: "menu-close",
              prevInputValue: b
            }), a.onMenuClose()) : S && y && a.clearValue();
            break;
          case " ":
            if (b)
              return;
            if (!E) {
              a.openMenu("first");
              break;
            }
            if (!$) return;
            a.selectOption($);
            break;
          case "ArrowUp":
            E ? a.focusOption("up") : a.openMenu("last");
            break;
          case "ArrowDown":
            E ? a.focusOption("down") : a.openMenu("first");
            break;
          case "PageUp":
            if (!E) return;
            a.focusOption("pageup");
            break;
          case "PageDown":
            if (!E) return;
            a.focusOption("pagedown");
            break;
          case "Home":
            if (!E) return;
            a.focusOption("first");
            break;
          case "End":
            if (!E) return;
            a.focusOption("last");
            break;
          default:
            return;
        }
        u.preventDefault();
      }
    }, a.state.instancePrefix = "react-select-" + (a.props.instanceId || ++Bft), a.state.selectValue = pJ(r.value), r.menuIsOpen && a.state.selectValue.length) {
      var o = a.getFocusableOptionsWithIds(), s = a.buildFocusableOptions(), c = s.indexOf(a.state.selectValue[0]);
      a.state.focusableOptionsWithIds = o, a.state.focusedOption = s[c], a.state.focusedOptionId = FN(o, s[c]);
    }
    return a;
  }
  return Bu(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && hJ(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var o = this.props, s = o.isDisabled, c = o.menuIsOpen, u = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (u && !s && a.isDisabled || // ensure focus is on the Input when the menu opens
      u && c && !a.menuIsOpen) && this.focusInput(), u && s && !a.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !u && !s && a.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (hJ(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(a, o) {
      this.props.onInputChange(a, o);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(a) {
      var o = this, s = this.state, c = s.selectValue, u = s.isFocused, f = this.buildFocusableOptions(), m = a === "first" ? 0 : f.length - 1;
      if (!this.props.isMulti) {
        var v = f.indexOf(c[0]);
        v > -1 && (m = v);
      }
      this.scrollToFocusedOptionOnUpdate = !(u && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: f[m],
        focusedOptionId: this.getFocusedOptionId(f[m])
      }, function() {
        return o.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(a) {
      var o = this.state, s = o.selectValue, c = o.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var u = s.indexOf(c);
        c || (u = -1);
        var f = s.length - 1, m = -1;
        if (s.length) {
          switch (a) {
            case "previous":
              u === 0 ? m = 0 : u === -1 ? m = f : m = u - 1;
              break;
            case "next":
              u > -1 && u < f && (m = u + 1);
              break;
          }
          this.setState({
            inputIsHidden: m !== -1,
            focusedValue: s[m]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", o = this.props.pageSize, s = this.state.focusedOption, c = this.getFocusableOptions();
      if (c.length) {
        var u = 0, f = c.indexOf(s);
        s || (f = -1), a === "up" ? u = f > 0 ? f - 1 : c.length - 1 : a === "down" ? u = (f + 1) % c.length : a === "pageup" ? (u = f - o, u < 0 && (u = 0)) : a === "pagedown" ? (u = f + o, u > c.length - 1 && (u = c.length - 1)) : a === "last" && (u = c.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: c[u],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(c[u])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(jN) : kn(kn({}, jN), this.props.theme) : jN;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var a = this.clearValue, o = this.cx, s = this.getStyles, c = this.getClassNames, u = this.getValue, f = this.selectOption, m = this.setValue, v = this.props, y = v.isMulti, b = v.isRtl, S = v.options, x = this.hasValue();
      return {
        clearValue: a,
        cx: o,
        getStyles: s,
        getClassNames: c,
        getValue: u,
        hasValue: x,
        isMulti: y,
        isRtl: b,
        options: S,
        selectOption: f,
        selectProps: v,
        setValue: m,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var a = this.state.selectValue;
      return a.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var a = this.props, o = a.isClearable, s = a.isMulti;
      return o === void 0 ? s : o;
    }
  }, {
    key: "isOptionDisabled",
    value: function(a, o) {
      return Tce(this.props, a, o);
    }
  }, {
    key: "isOptionSelected",
    value: function(a, o) {
      return Oce(this.props, a, o);
    }
  }, {
    key: "filterOption",
    value: function(a, o) {
      return Rce(this.props, a, o);
    }
  }, {
    key: "formatOptionLabel",
    value: function(a, o) {
      if (typeof this.props.formatOptionLabel == "function") {
        var s = this.props.inputValue, c = this.state.selectValue;
        return this.props.formatOptionLabel(a, {
          context: o,
          inputValue: s,
          selectValue: c
        });
      } else
        return this.getOptionLabel(a);
    }
  }, {
    key: "formatGroupLabel",
    value: function(a) {
      return this.props.formatGroupLabel(a);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var a = this.props, o = a.isDisabled, s = a.isSearchable, c = a.inputId, u = a.inputValue, f = a.tabIndex, m = a.form, v = a.menuIsOpen, y = a.required, b = this.getComponents(), S = b.Input, x = this.state, E = x.inputIsHidden, N = x.ariaSelection, R = this.commonProps, O = c || this.getElementId("input"), D = kn(kn(kn({
          "aria-autocomplete": "list",
          "aria-expanded": v,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": y,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, v && {
          "aria-controls": this.getElementId("listbox")
        }), !s && {
          "aria-readonly": !0
        }), this.hasValue() ? (N == null ? void 0 : N.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return s ? /* @__PURE__ */ k.createElement(S, Fn({}, R, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: O,
          innerRef: this.getInputRef,
          isDisabled: o,
          isHidden: E,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: f,
          form: m,
          type: "text",
          value: u
        }, D)) : /* @__PURE__ */ k.createElement(cft, Fn({
          id: O,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: j6,
          onFocus: this.onInputFocus,
          disabled: o,
          tabIndex: f,
          inputMode: "none",
          form: m,
          value: ""
        }, D));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var a = this, o = this.getComponents(), s = o.MultiValue, c = o.MultiValueContainer, u = o.MultiValueLabel, f = o.MultiValueRemove, m = o.SingleValue, v = o.Placeholder, y = this.commonProps, b = this.props, S = b.controlShouldRenderValue, x = b.isDisabled, E = b.isMulti, N = b.inputValue, R = b.placeholder, O = this.state, D = O.selectValue, $ = O.focusedValue, B = O.isFocused;
      if (!this.hasValue() || !S)
        return N ? null : /* @__PURE__ */ k.createElement(v, Fn({}, y, {
          key: "placeholder",
          isDisabled: x,
          isFocused: B,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), R);
      if (E)
        return D.map(function(Z, K) {
          var q = Z === $, pe = "".concat(a.getOptionLabel(Z), "-").concat(a.getOptionValue(Z));
          return /* @__PURE__ */ k.createElement(s, Fn({}, y, {
            components: {
              Container: c,
              Label: u,
              Remove: f
            },
            isFocused: q,
            isDisabled: x,
            key: pe,
            index: K,
            removeProps: {
              onClick: function() {
                return a.removeValue(Z);
              },
              onTouchEnd: function() {
                return a.removeValue(Z);
              },
              onMouseDown: function(_e) {
                _e.preventDefault();
              }
            },
            data: Z
          }), a.formatOptionLabel(Z, "value"));
        });
      if (N)
        return null;
      var G = D[0];
      return /* @__PURE__ */ k.createElement(m, Fn({}, y, {
        data: G,
        isDisabled: x
      }), this.formatOptionLabel(G, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var a = this.getComponents(), o = a.ClearIndicator, s = this.commonProps, c = this.props, u = c.isDisabled, f = c.isLoading, m = this.state.isFocused;
      if (!this.isClearable() || !o || u || !this.hasValue() || f)
        return null;
      var v = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ k.createElement(o, Fn({}, s, {
        innerProps: v,
        isFocused: m
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var a = this.getComponents(), o = a.LoadingIndicator, s = this.commonProps, c = this.props, u = c.isDisabled, f = c.isLoading, m = this.state.isFocused;
      if (!o || !f) return null;
      var v = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ k.createElement(o, Fn({}, s, {
        innerProps: v,
        isDisabled: u,
        isFocused: m
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var a = this.getComponents(), o = a.DropdownIndicator, s = a.IndicatorSeparator;
      if (!o || !s) return null;
      var c = this.commonProps, u = this.props.isDisabled, f = this.state.isFocused;
      return /* @__PURE__ */ k.createElement(s, Fn({}, c, {
        isDisabled: u,
        isFocused: f
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var a = this.getComponents(), o = a.DropdownIndicator;
      if (!o) return null;
      var s = this.commonProps, c = this.props.isDisabled, u = this.state.isFocused, f = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ k.createElement(o, Fn({}, s, {
        innerProps: f,
        isDisabled: c,
        isFocused: u
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var a = this, o = this.getComponents(), s = o.Group, c = o.GroupHeading, u = o.Menu, f = o.MenuList, m = o.MenuPortal, v = o.LoadingMessage, y = o.NoOptionsMessage, b = o.Option, S = this.commonProps, x = this.state.focusedOption, E = this.props, N = E.captureMenuScroll, R = E.inputValue, O = E.isLoading, D = E.loadingMessage, $ = E.minMenuHeight, B = E.maxMenuHeight, G = E.menuIsOpen, Z = E.menuPlacement, K = E.menuPosition, q = E.menuPortalTarget, pe = E.menuShouldBlockScroll, he = E.menuShouldScrollIntoView, _e = E.noOptionsMessage, ge = E.onMenuScrollToTop, Y = E.onMenuScrollToBottom;
      if (!G) return null;
      var ee = function(se, Ie) {
        var Le = se.type, ie = se.data, $e = se.isDisabled, we = se.isSelected, Ne = se.label, Ee = se.value, le = x === ie, be = $e ? void 0 : function() {
          return a.onOptionHover(ie);
        }, He = $e ? void 0 : function() {
          return a.selectOption(ie);
        }, Ae = "".concat(a.getElementId("option"), "-").concat(Ie), it = {
          id: Ae,
          onClick: He,
          onMouseMove: be,
          onMouseOver: be,
          tabIndex: -1,
          role: "option",
          "aria-selected": a.isAppleDevice ? void 0 : we
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ k.createElement(b, Fn({}, S, {
          innerProps: it,
          data: ie,
          isDisabled: $e,
          isSelected: we,
          key: Ae,
          label: Ne,
          type: Le,
          value: Ee,
          isFocused: le,
          innerRef: le ? a.getFocusedOptionRef : void 0
        }), a.formatOptionLabel(se.data, "menu"));
      }, oe;
      if (this.hasOptions())
        oe = this.getCategorizedOptions().map(function(ce) {
          if (ce.type === "group") {
            var se = ce.data, Ie = ce.options, Le = ce.index, ie = "".concat(a.getElementId("group"), "-").concat(Le), $e = "".concat(ie, "-heading");
            return /* @__PURE__ */ k.createElement(s, Fn({}, S, {
              key: ie,
              data: se,
              options: Ie,
              Heading: c,
              headingProps: {
                id: $e,
                data: ce.data
              },
              label: a.formatGroupLabel(ce.data)
            }), ce.options.map(function(we) {
              return ee(we, "".concat(Le, "-").concat(we.index));
            }));
          } else if (ce.type === "option")
            return ee(ce, "".concat(ce.index));
        });
      else if (O) {
        var me = D({
          inputValue: R
        });
        if (me === null) return null;
        oe = /* @__PURE__ */ k.createElement(v, S, me);
      } else {
        var xe = _e({
          inputValue: R
        });
        if (xe === null) return null;
        oe = /* @__PURE__ */ k.createElement(y, S, xe);
      }
      var X = {
        minMenuHeight: $,
        maxMenuHeight: B,
        menuPlacement: Z,
        menuPosition: K,
        menuShouldScrollIntoView: he
      }, ye = /* @__PURE__ */ k.createElement(Bct, Fn({}, S, X), function(ce) {
        var se = ce.ref, Ie = ce.placerProps, Le = Ie.placement, ie = Ie.maxHeight;
        return /* @__PURE__ */ k.createElement(u, Fn({}, S, X, {
          innerRef: se,
          innerProps: {
            onMouseDown: a.onMenuMouseDown,
            onMouseMove: a.onMenuMouseMove
          },
          isLoading: O,
          placement: Le
        }), /* @__PURE__ */ k.createElement(gft, {
          captureEnabled: N,
          onTopArrive: ge,
          onBottomArrive: Y,
          lockEnabled: pe
        }, function($e) {
          return /* @__PURE__ */ k.createElement(f, Fn({}, S, {
            innerRef: function(Ne) {
              a.getMenuListRef(Ne), $e(Ne);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": S.isMulti,
              id: a.getElementId("listbox")
            },
            isLoading: O,
            maxHeight: ie,
            focusedOption: x
          }), oe);
        }));
      });
      return q || K === "fixed" ? /* @__PURE__ */ k.createElement(m, Fn({}, S, {
        appendTo: q,
        controlElement: this.controlRef,
        menuPlacement: Z,
        menuPosition: K
      }), ye) : ye;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var a = this, o = this.props, s = o.delimiter, c = o.isDisabled, u = o.isMulti, f = o.name, m = o.required, v = this.state.selectValue;
      if (m && !this.hasValue() && !c)
        return /* @__PURE__ */ k.createElement(Cft, {
          name: f,
          onFocus: this.onValueInputFocus
        });
      if (!(!f || c))
        if (u)
          if (s) {
            var y = v.map(function(x) {
              return a.getOptionValue(x);
            }).join(s);
            return /* @__PURE__ */ k.createElement("input", {
              name: f,
              type: "hidden",
              value: y
            });
          } else {
            var b = v.length > 0 ? v.map(function(x, E) {
              return /* @__PURE__ */ k.createElement("input", {
                key: "i-".concat(E),
                name: f,
                type: "hidden",
                value: a.getOptionValue(x)
              });
            }) : /* @__PURE__ */ k.createElement("input", {
              name: f,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ k.createElement("div", null, b);
          }
        else {
          var S = v[0] ? this.getOptionValue(v[0]) : "";
          return /* @__PURE__ */ k.createElement("input", {
            name: f,
            type: "hidden",
            value: S
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var a = this.commonProps, o = this.state, s = o.ariaSelection, c = o.focusedOption, u = o.focusedValue, f = o.isFocused, m = o.selectValue, v = this.getFocusableOptions();
      return /* @__PURE__ */ k.createElement(aft, Fn({}, a, {
        id: this.getElementId("live-region"),
        ariaSelection: s,
        focusedOption: c,
        focusedValue: u,
        isFocused: f,
        selectValue: m,
        focusableOptions: v,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var a = this.getComponents(), o = a.Control, s = a.IndicatorsContainer, c = a.SelectContainer, u = a.ValueContainer, f = this.props, m = f.className, v = f.id, y = f.isDisabled, b = f.menuIsOpen, S = this.state.isFocused, x = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ k.createElement(c, Fn({}, x, {
        className: m,
        innerProps: {
          id: v,
          onKeyDown: this.onKeyDown
        },
        isDisabled: y,
        isFocused: S
      }), this.renderLiveRegion(), /* @__PURE__ */ k.createElement(o, Fn({}, x, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: y,
        isFocused: S,
        menuIsOpen: b
      }), /* @__PURE__ */ k.createElement(u, Fn({}, x, {
        isDisabled: y
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ k.createElement(s, Fn({}, x, {
        isDisabled: y
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(a, o) {
      var s = o.prevProps, c = o.clearFocusValueOnUpdate, u = o.inputIsHiddenAfterUpdate, f = o.ariaSelection, m = o.isFocused, v = o.prevWasFocused, y = o.instancePrefix, b = a.options, S = a.value, x = a.menuIsOpen, E = a.inputValue, N = a.isMulti, R = pJ(S), O = {};
      if (s && (S !== s.value || b !== s.options || x !== s.menuIsOpen || E !== s.inputValue)) {
        var D = x ? $ft(a, R) : [], $ = x ? AJ(y7(a, R), "".concat(y, "-option")) : [], B = c ? jft(o, R) : null, G = Fft(o, D), Z = FN($, G);
        O = {
          selectValue: R,
          focusedOption: G,
          focusedOptionId: Z,
          focusableOptionsWithIds: $,
          focusedValue: B,
          clearFocusValueOnUpdate: !1
        };
      }
      var K = u != null && a !== s ? {
        inputIsHidden: u,
        inputIsHiddenAfterUpdate: void 0
      } : {}, q = f, pe = m && v;
      return m && !pe && (q = {
        value: kx(N, R, R[0] || null),
        options: R,
        action: "initial-input-focus"
      }, pe = !v), (f == null ? void 0 : f.action) === "initial-input-focus" && (q = null), kn(kn(kn({}, O), K), {}, {
        prevProps: a,
        ariaSelection: q,
        prevWasFocused: pe
      });
    }
  }]), n;
}(Nc);
Dce.defaultProps = Lft;
var Vft = /* @__PURE__ */ vR(function(e, t) {
  var n = sut(e);
  return /* @__PURE__ */ k.createElement(Dce, Fn({
    ref: t
  }, n));
}), Lce = Vft;
const Uft = W.div.attrs(() => ({
  className: "msd__select__wrapper"
}))`
  display: flex;
  flex-direction: column;
  position: relative;

  width: 100%;
`, Gft = W(Lce).attrs(() => ({
  className: "msd__select"
}))`
  &:focus-within,
  &:focus {
    border-color: ${An};
  }
  .react-select__control {
    background: white;
    border: 1px solid ${u2};
    border-radius: 0;
    transition: 0.2s ease-in-out;
    &--is-focused {
      &:focus-within,
      &:focus {
        border-color: ${An};
        box-shadow: none;
      }
    }
    &--is-disabled {
      background-color: ${Br};
    }
  }
  .react-select__placeholder {
    color: ${Et};
  }
  .react-select__value-container {
    padding: 13px 15px 14px;
    color: ${Et};
  }
  .react-select__menu {
    border-radius: 0px;
  }
  .react-select__menu-list {
  }
  .react-select__option {
    padding: 13px 15px 14px;
    text-align: left;
    &--is-focused {
      background-color: ${u2};
    }
    &--is-selected {
      color: ${An};
      background-color: #fff;
    }
  }
  ${(e) => e.$isMyAccount && ot`
      .react-select__control {
        border: 1px solid #d3dbe6;
        border-radius: 4px;
      }
      .react-select__value-container {
        padding: 0 16px;
        font-size: 13px;
      }
    `}
  ${(e) => e.$required && ot`
      .react-select__value-container {
        &::after {
          display: block;
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translate(0, -50%);
          content: '*';
          height: 9px;
          font-size: 12px;
          line-height: 12px;
          color: ${wa};
        }
      }
    `}
`, zft = (e) => e.map((n) => ({
  label: n,
  value: n
})), vL = ({
  name: e,
  values: t,
  value: n,
  onChange: r,
  label: a,
  required: o,
  disabled: s,
  isMyAccount: c
}) => {
  const u = (f) => {
    r(e, f);
  };
  return /* @__PURE__ */ C.jsx(Uft, { children: /* @__PURE__ */ C.jsx(
    Gft,
    {
      classNamePrefix: "react-select",
      placeholder: a,
      value: n,
      required: o,
      $required: o,
      onChange: u,
      options: t,
      name: e,
      isDisabled: s,
      $isMyAccount: c,
      getOptionLabel: (f) => f.label
    }
  ) });
};
vL.propTypes = {
  values: de.arrayOf(de.any),
  label: de.string,
  required: de.bool,
  value: de.objectOf(de.string),
  name: de.string,
  onChange: de.func,
  disabled: de.bool,
  isMyAccount: de.bool
};
vL.defaultProps = {
  values: [],
  label: "",
  required: !1,
  name: "",
  value: {},
  onChange: () => null,
  disabled: !1,
  isMyAccount: !1
};
const Hft = W.div.attrs(() => ({
  className: "msd__profile-capture__wrapper"
}))``, Wft = W.div.attrs(() => ({
  className: "msd__profile-capture__message"
}))`
  color: ${An};
  text-align: center;
  margin: 5px 0 15px 0;
  font-size: 12px;
  position: relative;
`, Ax = W.div`
  margin-bottom: 20px;
`, Zft = W.div.attrs(() => ({
  className: "msd__profile-capture__label"
}))`
  display: block;
  margin-bottom: 12px;
  color: ${Et};
  font-size: 13px;
`, gL = ({ data: e, isLoading: t, updateCaptureOption: n }) => {
  const { t: r } = tn(), [a, o] = mt(!0), [s, c] = mt(!1), [u, f] = mt(null), [m, v] = mt(null), [y, b, S, x] = Yue();
  mn(() => {
    if (e) {
      const O = e.map((D) => Xn(Fe({}, D), {
        value: D.answer ? D.answer : "",
        values: D.value ? D.value.split(";").map(($) => $.trim()) : []
      }));
      f(O), v(O);
    }
  }, [e]);
  const E = (O, D) => {
    const $ = u.map((B) => Xn(Fe({}, B), {
      value: B.key === O ? D : B.value
    }));
    f($);
  }, N = () => {
    f(m), o(!0);
  }, R = () => {
    c(!0);
    const O = u.map((D) => ({
      questionId: D.key,
      question: D.question,
      value: D.value
    }));
    X6({
      customAnswers: O
    }).then(() => {
      for (let D = 0; D < u.length; D += 1)
        n({
          key: u[D].key,
          value: u[D].value
        });
      S({
        message: r(
          "additional-profile-info.success-message",
          "Your answers have been changed successfully"
        ),
        type: "success"
      }), c(!1), o(!0);
    }).catch(() => {
      S({
        message: r(
          "additional-profile-info.error.submit",
          "Something went wrong. Try again later."
        ),
        type: "error"
      }), c(!1), o(!0);
    });
  };
  return t ? /* @__PURE__ */ C.jsx(cr, { isMyAccount: !0 }) : /* @__PURE__ */ C.jsx(Hft, { children: u && /* @__PURE__ */ C.jsxs(Uu, { withBorder: !0, children: [
    y && /* @__PURE__ */ C.jsx(Wft, { type: b, children: y }),
    u.map((O) => O.values.length === 0 ? /* @__PURE__ */ C.jsx(Ax, { children: /* @__PURE__ */ C.jsx(
      du,
      {
        id: O.key,
        label: O.question,
        value: O.value,
        onChange: (D) => E(O.key, D.target.value),
        disabled: a
      }
    ) }, O.key) : O.values.length === 1 ? /* @__PURE__ */ C.jsx(Ax, { children: /* @__PURE__ */ C.jsx(
      kf,
      {
        isMyAccount: !0,
        id: O.key,
        onClickFn: (D, $) => !$ && E(
          O.key,
          O.value ? "" : O.values[0]
        ),
        isChecked: O.value === O.values[0],
        disabled: a,
        children: O.question
      }
    ) }, O.key) : O.values.length === 2 ? /* @__PURE__ */ C.jsxs(Ax, { children: [
      /* @__PURE__ */ C.jsx(Zft, { children: O.question }),
      /* @__PURE__ */ C.jsx(
        kf,
        {
          id: `${O.key}-01`,
          onClickFn: (D, $) => !$ && E(O.key, O.values[0]),
          isRadioButton: !0,
          disabled: a,
          isChecked: O.value === O.values[0],
          children: O.values[0]
        },
        `${O.key}-01`
      ),
      /* @__PURE__ */ C.jsx(
        kf,
        {
          id: `${O.key}-02`,
          onClickFn: (D, $) => !$ && E(O.key, O.values[1]),
          isRadioButton: !0,
          disabled: a,
          isChecked: O.value === O.values[1],
          children: O.values[1]
        },
        `${O.key}-02`
      )
    ] }, O.key) : /* @__PURE__ */ C.jsx(Ax, { children: /* @__PURE__ */ C.jsx(
      vL,
      {
        isMyAccount: !0,
        id: O.key,
        label: O.question,
        name: O.key,
        value: O.value ? { value: O.value, label: O.value } : null,
        values: zft(O.values),
        disabled: a,
        onChange: (D, $) => E(D, $.value)
      },
      O.key
    ) }, O.key)),
    /* @__PURE__ */ C.jsx(X8, { children: a ? /* @__PURE__ */ C.jsx(
      kc,
      {
        onClickFn: () => {
          o(!1), x();
        },
        width: "100%",
        theme: "confirm",
        children: r(
          "additional-profile-info.button.edit-profile",
          "Edit Profile"
        )
      }
    ) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(kc, { theme: "simple", onClickFn: N, children: r("additional-profile-info.button.cancel", "Cancel") }),
      /* @__PURE__ */ C.jsx(
        kc,
        {
          onClickFn: R,
          disabled: s,
          type: "submit",
          theme: "confirm",
          children: s && /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) || r("additional-profile-info.button.save", "Save")
        }
      )
    ] }) })
  ] }) });
};
gL.propTypes = {
  isLoading: de.bool,
  data: de.arrayOf(de.any),
  updateCaptureOption: de.func
};
gL.defaultProps = {
  isLoading: !1,
  data: null,
  updateCaptureOption: () => null
};
const Yft = W.div.attrs(() => ({
  className: "msd__user-profile__wrapper"
}))`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  background: ${Br};
`, Px = W.section``;
class yL extends Nc {
  constructor(n) {
    super(n);
    Er(this, "getObjectByKey", (n, r) => n.find((a) => a.key === r));
    this.state = {
      detailsError: [],
      isUserDetailsLoading: !1,
      isCaptureLoading: !1,
      isConsentLoading: !1
    };
  }
  componentDidMount() {
    const {
      userProfile: n,
      setCurrentUser: r,
      setUserCapture: a,
      t: o,
      initPublisherConfig: s,
      displayGracePeriodError: c
    } = this.props;
    n.user || (this.setState({
      isUserDetailsLoading: !0
    }), L7().then((u) => {
      u.errors.length ? this.setState({
        detailsError: u.errors
      }) : r(u.responseData), this.setState({
        isUserDetailsLoading: !1
      });
    }).catch(() => {
      this.setState({
        detailsError: [o("updateprofile.error", "Something went wrong..")],
        isUserDetailsLoading: !1
      });
    })), n.capture || (this.setState({
      isCaptureLoading: !0
    }), TR().then((u) => {
      u.errors.length ? this.setState({
        detailsError: u.errors
      }) : a(u.responseData), this.setState({
        isCaptureLoading: !1
      });
    }).catch(() => {
      this.setState({
        detailsError: [o("updateprofile.error", "Something went wrong..")],
        isCaptureLoading: !1
      });
    })), c !== null && s({ displayGracePeriodError: c });
  }
  componentWillUnmount() {
    this.setState({
      detailsError: [],
      isUserDetailsLoading: !1,
      isCaptureLoading: !1,
      isConsentLoading: !1
    });
  }
  render() {
    const {
      detailsError: n,
      isUserDetailsLoading: r,
      isCaptureLoading: a,
      isConsentLoading: o
    } = this.state, {
      userProfile: { user: s, consents: c, capture: u, consentsError: f },
      setConsents: m,
      setCurrentUser: v,
      updateCaptureOption: y,
      showInnerPopup: b,
      hideInnerPopup: S,
      innerPopup: x,
      handleLogout: E,
      t: N
    } = this.props;
    c.length || l2().then((G) => {
      G.errors.length || m(G.responseData.consents);
    }).catch();
    const R = u && u.isCaptureEnabled ? u.settings.filter((G) => G.key === "address")[0] : null, O = u && u.isCaptureEnabled ? u.settings.filter(
      (G) => G.key.startsWith("custom") && G.enabled
    ) : null, D = u && u.isCaptureEnabled ? this.getObjectByKey(u.settings, "birthDate") : null, $ = u && u.isCaptureEnabled ? this.getObjectByKey(u.settings, "companyName") : null, B = u && u.isCaptureEnabled ? this.getObjectByKey(u.settings, "phoneNumber") : null;
    return /* @__PURE__ */ C.jsxs(Yft, { children: [
      /* @__PURE__ */ C.jsx(R6, {}),
      x.isOpen && x.type === "editPassword" ? /* @__PURE__ */ C.jsx(C.Fragment, { children: /* @__PURE__ */ C.jsx(
        out,
        {
          hideInnerPopup: S,
          customerEmail: s.email,
          handleLogout: E
        }
      ) }) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
        /* @__PURE__ */ C.jsx(Xi, { children: N("updateprofile.header.profile-details", "Profile details") }),
        n.length !== 0 ? /* @__PURE__ */ C.jsx(Ml, { generalError: !0 }) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsx(
            Jlt,
            {
              firstName: s ? s.firstName : "",
              lastName: s ? s.lastName : "",
              capture: u || {},
              email: s ? s.email : "",
              isLoading: r || a,
              setCurrentUser: v,
              updateCaptureOption: y,
              birthDate: D,
              companyName: $,
              phoneNumber: B
            }
          ),
          R && R.enabled && /* @__PURE__ */ C.jsxs(Px, { children: [
            /* @__PURE__ */ C.jsx(Xi, { children: N(
              "updateprofile.header.address-details",
              "Address details"
            ) }),
            /* @__PURE__ */ C.jsx(
              rL,
              {
                data: R,
                isLoading: a,
                updateCaptureOption: y
              }
            )
          ] }),
          /* @__PURE__ */ C.jsxs(Px, { children: [
            /* @__PURE__ */ C.jsx(Xi, { marginTop: "25px", children: N("updateprofile.header.password", "Password") }),
            /* @__PURE__ */ C.jsx(
              Xue,
              {
                showInnerPopup: () => b({ type: Nm.editPassword })
              }
            )
          ] }),
          O && O.length > 0 && /* @__PURE__ */ C.jsxs(Px, { children: [
            /* @__PURE__ */ C.jsx(Xi, { children: N(
              "updateprofile.header.additional-options",
              "Additional Options"
            ) }),
            /* @__PURE__ */ C.jsx(
              gL,
              {
                data: O,
                updateCaptureOption: y
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ C.jsxs(Px, { children: [
          /* @__PURE__ */ C.jsx(Xi, { marginTop: "25px", children: N("updateprofile.header.terms-details", "Terms Details") }),
          f.length !== 0 ? /* @__PURE__ */ C.jsx(Ml, { generalError: !0 }) : /* @__PURE__ */ C.jsx(
            Kue,
            {
              consents: c,
              isLoading: o,
              setConsents: m
            }
          )
        ] })
      ] })
    ] });
  }
}
yL.propTypes = {
  setCurrentUser: de.func.isRequired,
  setConsents: de.func.isRequired,
  setUserCapture: de.func.isRequired,
  updateCaptureOption: de.func.isRequired,
  consentsError: de.string,
  userProfile: de.shape({
    user: de.shape({
      id: de.number,
      email: de.string,
      firstName: de.string,
      lastName: de.string,
      country: de.string,
      regDate: de.string,
      lastLoginDate: de.string,
      lastUserIp: de.string,
      externalId: de.string,
      externalData: de.shape()
    }),
    capture: de.shape({
      isCaptureEnabled: de.bool,
      shouldCaptureBeDisplayed: de.bool,
      settings: de.array
    }),
    consents: de.array,
    consentsError: de.string
  }),
  showInnerPopup: de.func.isRequired,
  hideInnerPopup: de.func.isRequired,
  innerPopup: de.shape({
    isOpen: de.bool,
    type: de.string,
    data: de.object
  }).isRequired,
  t: de.func,
  displayGracePeriodError: de.bool,
  initPublisherConfig: de.func.isRequired,
  handleLogout: de.func
};
yL.defaultProps = {
  userProfile: { user: null },
  consentsError: "",
  t: (e) => e,
  displayGracePeriodError: null,
  handleLogout: (e) => e
};
const Xft = o1()(yL), Kft = (e) => ({
  userProfile: e.userProfile,
  userConsents: [],
  consentsError: e.consentsError,
  innerPopup: e.innerPopup
}), qft = (e) => ({
  setCurrentUser: (t) => {
    e(kee(t));
  },
  setUserCapture: (t) => {
    e(Rbe(t));
  },
  updateCaptureOption: (t) => {
    e(Mbe(t));
  },
  setConsents: (t) => {
    e(B7(t));
  },
  showInnerPopup: (t) => {
    e(E2e(t));
  },
  hideInnerPopup: () => {
    e(I2e());
  },
  initPublisherConfig: (t) => {
    e($u(t));
  }
}), Jft = V6(
  Kft,
  qft
)(Xft), Qft = AR`
	0% {
		opacity: 0;
    transform: scale(0.97);
	}
  80%{
    transform: scale(1);
  }
	100% {
		opacity: 1;
	}
`, ept = W.div`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  line-height: normal;

  ${pr.small`
    min-height: 100vh;
  `}

  opacity: 1;
  animation: ${Qft} 1 ease-in 0.4s;
`, tpt = W.div`
  text-align: center;
  margin: auto;
  width: 50%;

  ${pr.small`
    width: 90%;
  `}
`, npt = W.div`
  width: 50%;
  margin: 0 auto 100px auto;

  ${pr.small`
    width: 80%;
  `}
`, rpt = W.h1`
  font-size: 30px;
  color: ${Et};
  font-weight: 700;

  ${pr.small`
    font-size: 27px;
  `}
`, apt = W.p`
  color: ${Et};
  opacity: 0.8;
  font-size: 14px;
  line-height: 1.5;
  margin: 20px 0;

  ${(e) => e.step === 2 && ot`
      opacity: 0.6;
      text-align: left;
    `}
`;
W.img`
  margin-top: 50px;
`;
const opt = W(zt)`
  margin: 0 auto;
  &:disabled {
    cursor: not-allowed;
    background: ${Gn};
  }
`;
W.span`
  color: ${wa};
  font-size: 13px;
  margin-bottom: 25px;
  display: block;
`;
const ipt = W.div`
  display: flex;
  flex-direction: row;
  ${(e) => e.$currentStep && ot`
      span:nth-child(-n + ${e.$currentStep}) {
        background: ${Et};
      }
    `}
`, spt = W.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 90%;
  margin: 50px 0 0 0;
  color: ${Et};
  ${pr.small`
    margin: 30px 0 0 0;
  `}
`, lpt = W.span`
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${Gn};
  margin-right: 10px;
`, upt = W.h1`
  font-size: 14px;
  margin: 0;
`, cpt = W.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`, Nx = {
  notCheckedTerms: {
    steps: [
      {
        headerTitle: "Terms & Conditions",
        icon: !0,
        title: "Hi there!",
        text: "Your brand new account is waiting for you. Just one last step. We would like you to review our terms and conditions before continuing to your account.",
        buttonText: "Let’s do it",
        translationKeys: {
          header: "popup.not-checked-terms.header",
          title: "popup.not-checked-terms.title",
          text: "popup.not-checked-terms.text",
          button: "popup.not-checked-terms.button"
        }
      },
      {
        headerTitle: "Terms & Conditions",
        icon: !0,
        title: "Terms & Conditions",
        text: "Please accept our terms and conditions before continuing to your account.",
        buttonText: "Continue",
        translationKeys: {
          header: "popup.not-checked-terms2.header",
          title: "popup.not-checked-terms2.title",
          text: "popup.not-checked-terms2.text",
          button: "popup.not-checked-terms2.button"
        }
      }
    ]
  },
  termsUpdateRequired: {
    steps: [
      {
        headerTitle: "Terms update",
        icon: !0,
        title: "A change in our terms",
        text: "One of our mandatory terms has been updated. Review the changes to continue.",
        buttonText: "Okey, Go next",
        translationKeys: {
          header: "popup.terms-update-required.header",
          title: "popup.terms-update-required.title",
          text: "popup.terms-update-required.text",
          button: "popup.terms-update-required.button"
        }
      },
      {
        headerTitle: "Terms update",
        icon: null,
        title: "Update to terms & conditions",
        text: "Please review and accept our updated terms and conditions before continuing to your account.",
        buttonText: "Continue",
        translationKeys: {
          header: "popup.terms-update-required2.header",
          title: "popup.terms-update-required2.title",
          text: "popup.terms-update-required2.text",
          button: "popup.terms-update-required2.button"
        }
      }
    ]
  },
  consentsUpdateRequired: {
    steps: [
      {
        headerTitle: "Terms update",
        icon: !0,
        title: "Update to terms & conditions",
        text: "We have updated our terms and conditions. Please take a few minutes to review the changes in your profile section",
        buttonText: "Continue",
        translationKeys: {
          header: "popup.consents-update-required.header",
          title: "popup.consents-update-required.title",
          text: "popup.consents-update-required.text",
          button: "popup.consents-update-required.button"
        }
      }
    ]
  },
  complexUpdate: {
    steps: [
      {
        headerTitle: "Terms update",
        icon: !0,
        title: "A change in our terms",
        text: "One of our mandatory terms has been updated. We’ve also updated our Consents Details which you can find in Update Profile tab.",
        secondText: "Review the changes to continue.",
        buttonText: "Okey, Go next!",
        translationKeys: {
          header: "popup.complex-update.header",
          title: "popup.complex-update.title",
          text: "popup.complex-update.text",
          secondText: "popup.complex-update.secondText",
          button: "popup.complex-update.button"
        }
      },
      {
        headerTitle: "Terms update",
        icon: null,
        title: "Update to terms & conditions",
        text: "Please review and accept our updated terms and conditions before continuing to your account.",
        buttonText: "Continue",
        translationKeys: {
          header: "popup.complex-update2.header",
          title: "popup.complex-update2.title",
          text: "popup.complex-update2.text",
          button: "popup.complex-update2.button"
        }
      }
    ]
  }
}, dpt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 174.192, height: 92.9, viewBox: "0 0 174.192 92.9" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_2367", "data-name": "Group 2367", transform: "translate(-1167.999 -748)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2264", "data-name": "Group 2264", transform: "translate(1167.999 803.096)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1734", "data-name": "Path 1734", d: "M37.6-28.671,34.366-40.737a6.435,6.435,0,0,0-7.881-4.55h0a6.435,6.435,0,0,0-3.907,3,6.435,6.435,0,0,0-.643,4.883l1.251,4.668,4.438,16.564", transform: "translate(14.997 6.622)", fill: "#fff", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1735", "data-name": "Path 1735", d: "M39.109-28.506,35.876-40.572A7.533,7.533,0,0,0,26.65-45.9h0a7.534,7.534,0,0,0-4.574,3.51,7.533,7.533,0,0,0-.752,5.717l5.689,21.232a1.1,1.1,0,0,0,1.346.777,1.1,1.1,0,0,0,.777-1.346L23.445-37.241a5.335,5.335,0,0,1,.533-4.049,5.336,5.336,0,0,1,3.24-2.486h0A5.336,5.336,0,0,1,33.753-40l3.233,12.066a1.1,1.1,0,0,0,1.346.777A1.1,1.1,0,0,0,39.109-28.506Z", transform: "translate(14.548 6.173)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1736", "data-name": "Path 1736", d: "M64.43-27.572l4.293-16.021a6.435,6.435,0,0,0-.643-4.883,6.434,6.434,0,0,0-3.907-3h0a6.434,6.434,0,0,0-4.883.643,6.435,6.435,0,0,0-3,3.907L50.6-25.692", transform: "translate(34.947 2.35)", fill: "#fff", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1737", "data-name": "Path 1737", d: "M65.94-26.839l4.293-16.02a7.533,7.533,0,0,0-.752-5.717,7.534,7.534,0,0,0-4.574-3.51h0a7.533,7.533,0,0,0-5.717.753,7.533,7.533,0,0,0-3.51,4.574L49.989-25.527a1.1,1.1,0,0,0,.777,1.346,1.1,1.1,0,0,0,1.346-.777L57.8-46.19a5.335,5.335,0,0,1,2.486-3.24,5.336,5.336,0,0,1,4.049-.533h0a5.335,5.335,0,0,1,3.24,2.486,5.334,5.334,0,0,1,.533,4.049L63.817-27.408a1.1,1.1,0,0,0,.777,1.346A1.1,1.1,0,0,0,65.94-26.839Z", transform: "translate(34.498 1.902)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1738", "data-name": "Path 1738", d: "M69.6-24.98l5.724-21.364a6.434,6.434,0,0,0-.643-4.883,6.435,6.435,0,0,0-3.907-3h0a6.435,6.435,0,0,0-7.881,4.55L56.639-26.338", transform: "translate(39.117 0.449)", fill: "#fff", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1739", "data-name": "Path 1739", d: "M71.11-24.246l5.725-21.364a7.534,7.534,0,0,0-.753-5.717,7.533,7.533,0,0,0-4.574-3.51h0a7.533,7.533,0,0,0-9.227,5.327L56.027-26.173a1.1,1.1,0,0,0,.777,1.346A1.1,1.1,0,0,0,58.15-25.6L64.4-48.942a5.336,5.336,0,0,1,6.535-3.773h0a5.335,5.335,0,0,1,3.24,2.486,5.336,5.336,0,0,1,.533,4.049L68.987-24.815a1.1,1.1,0,0,0,.777,1.346A1.1,1.1,0,0,0,71.11-24.246Z", transform: "translate(38.668)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1740", "data-name": "Path 1740", d: "M74.292-22.2l6.374-23.788a6.435,6.435,0,0,0-.643-4.883,6.435,6.435,0,0,0-3.907-3h0a6.435,6.435,0,0,0-7.881,4.55L61.981-25.982", transform: "translate(42.806 0.695)", fill: "#fff", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1741", "data-name": "Path 1741", d: "M75.8-21.466l6.374-23.789a7.533,7.533,0,0,0-.753-5.717,7.534,7.534,0,0,0-4.574-3.51h0a7.533,7.533,0,0,0-9.226,5.327L61.369-25.818a1.1,1.1,0,0,0,.777,1.346,1.1,1.1,0,0,0,1.346-.777l6.253-23.337a5.336,5.336,0,0,1,6.535-3.773h0a5.336,5.336,0,0,1,3.24,2.486,5.334,5.334,0,0,1,.533,4.049L73.68-22.035a1.1,1.1,0,0,0,.777,1.346A1.1,1.1,0,0,0,75.8-21.466Z", transform: "translate(42.357 0.246)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1742", "data-name": "Path 1742", d: "M78.561-21.136l4.911-18.327a6.435,6.435,0,0,0-4.55-7.881h0a6.435,6.435,0,0,0-7.881,4.55l-3.9,14.539", transform: "translate(46.371 5.202)", fill: "#fff", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1743", "data-name": "Path 1743", d: "M80.071-20.4l4.911-18.327a7.533,7.533,0,0,0-5.327-9.226h0a7.533,7.533,0,0,0-9.226,5.327l-3.9,14.539a1.1,1.1,0,0,0,.777,1.346,1.1,1.1,0,0,0,1.346-.777l3.9-14.539a5.336,5.336,0,0,1,6.535-3.773h0A5.335,5.335,0,0,1,82.859-39.3l-4.91,18.327a1.1,1.1,0,0,0,.777,1.346A1.1,1.1,0,0,0,80.071-20.4Z", transform: "translate(45.922 4.753)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1744", "data-name": "Path 1744", d: "M74.805-18.922l.709-1.793a37.577,37.577,0,0,1,6.511-10.751l3.218-3.724A5.518,5.518,0,0,1,91.9-36.511l.477.24a5.934,5.934,0,0,1,3.18,4.3,5.934,5.934,0,0,1-1.566,5.111l0,0a38.19,38.19,0,0,0-8.164,12.936L84.137-9.459q-.045.122-.1.24C83.452-7.977,78.994.821,70.778-1.513c-8.835-2.51-12.229-9.094-9-17.975", transform: "translate(41.837 12.428)", fill: "#fff", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1745", "data-name": "Path 1745", d: "M76.276-18.069l.709-1.793A36.478,36.478,0,0,1,83.306-30.3l3.218-3.724a4.419,4.419,0,0,1,5.331-1.058l.477.24a4.836,4.836,0,0,1,2.591,3.5,4.835,4.835,0,0,1-1.276,4.165l0,0a39.29,39.29,0,0,0-8.4,13.309L83.558-9.4c-.024.063-.048.122-.074.18A16.96,16.96,0,0,1,79.969-4.38a8.487,8.487,0,0,1-8.442,2.259c-4.069-1.156-6.916-3.208-8.344-6.036s-1.417-6.405.073-10.506a1.1,1.1,0,0,0-.658-1.408,1.1,1.1,0,0,0-1.408.658c-1.736,4.78-1.637,8.942.031,12.247s4.94,5.806,9.705,7.16A10.593,10.593,0,0,0,81.467-2.772,19.334,19.334,0,0,0,85.481-8.3c.054-.121.1-.223.135-.326L87.3-13.087a37.09,37.09,0,0,1,7.929-12.564l0,0a7.033,7.033,0,0,0,1.856-6.058A7.033,7.033,0,0,0,93.32-36.8l-.477-.24a6.617,6.617,0,0,0-7.982,1.584l-3.218,3.724a38.675,38.675,0,0,0-6.7,11.066l-.709,1.793Z", transform: "translate(41.388 11.979)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1746", "data-name": "Path 1746", d: "M50.792-36.38s-2.949,9.413-1.422,18.059C50.427-12.337,53.579-6.73,61.062-4.585a1.1,1.1,0,0,0,1.359-.754A1.1,1.1,0,0,0,61.667-6.7C55.15-8.566,52.454-13.492,51.534-18.7c-1.439-8.148,1.355-17.018,1.355-17.018a1.1,1.1,0,0,0-.719-1.378A1.1,1.1,0,0,0,50.792-36.38Z", transform: "translate(33.793 12.394)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1747", "data-name": "Path 1747", d: "M50.69-36.047s22.86-6.008,36.951,6.382", transform: "translate(35.008 12.15)", fill: "#fff", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1748", "data-name": "Path 1748", d: "M51.418-34.535a55.4,55.4,0,0,1,17.47-1.186c6.208.61,13.024,2.537,18.476,7.33a1.1,1.1,0,0,0,1.551-.1,1.1,1.1,0,0,0-.1-1.551C82.994-35.16,75.731-37.257,69.1-37.909a57.686,57.686,0,0,0-18.244,1.248,1.1,1.1,0,0,0-.783,1.342A1.1,1.1,0,0,0,51.418-34.535Z", transform: "translate(34.559 11.702)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1749", "data-name": "Path 1749", d: "M44.627-28.272l1.674-9.6a5.586,5.586,0,0,1,5.183-4.617l.407-.023a5.934,5.934,0,0,1,4.9,2.131,5.934,5.934,0,0,1,1.2,5.21v0a38.191,38.191,0,0,0-.6,15.285l.723,4.418a8.364,8.364,0,0,1,.1.963c.062,2.364-.089,11.345-6.406,13.037", transform: "translate(30.82 8.681)", fill: "#fff", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1750", "data-name": "Path 1750", d: "M46.158-27.634l1.674-9.6A4.487,4.487,0,0,1,52-40.948l.407-.023A4.835,4.835,0,0,1,56.4-39.234a4.836,4.836,0,0,1,.977,4.245v0a39.29,39.29,0,0,0-.62,15.725l.723,4.418a7.263,7.263,0,0,1,.088.837,19.709,19.709,0,0,1-1.312,7.9,6.581,6.581,0,0,1-4.281,4.021A1.1,1.1,0,0,0,51.2-.736a1.1,1.1,0,0,0,1.346.777,8.715,8.715,0,0,0,5.723-5.257,22.22,22.22,0,0,0,1.5-8.87,9.483,9.483,0,0,0-.116-1.113l-.723-4.417a37.1,37.1,0,0,1,.585-14.846v0a7.033,7.033,0,0,0-1.421-6.175,7.033,7.033,0,0,0-5.811-2.526l-.407.023a6.685,6.685,0,0,0-6.2,5.526l-1.674,9.6a1.1,1.1,0,0,0,.894,1.271A1.1,1.1,0,0,0,46.158-27.634Z", transform: "translate(30.371 8.232)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1751", "data-name": "Path 1751", d: "M43.5-27.691,38.508-46.306a6.435,6.435,0,0,0-7.881-4.55h0a6.435,6.435,0,0,0-3.907,3,6.435,6.435,0,0,0-.643,4.883l6.211,23.181", transform: "translate(17.857 2.776)", fill: "#fff", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1752", "data-name": "Path 1752", d: "M45.006-27.527,40.018-46.142a7.533,7.533,0,0,0-9.227-5.327h0a7.533,7.533,0,0,0-4.575,3.51,7.533,7.533,0,0,0-.753,5.717l6.211,23.181a1.1,1.1,0,0,0,1.346.777A1.1,1.1,0,0,0,33.8-19.63L27.586-42.81a5.336,5.336,0,0,1,.533-4.049,5.335,5.335,0,0,1,3.24-2.486h0A5.336,5.336,0,0,1,37.9-45.573l4.988,18.615a1.1,1.1,0,0,0,1.346.777A1.1,1.1,0,0,0,45.006-27.527Z", transform: "translate(17.408 2.327)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1753", "data-name": "Path 1753", d: "M49.686-24.881,43.312-48.67a6.435,6.435,0,0,0-3-3.907,6.434,6.434,0,0,0-4.883-.643h0a6.434,6.434,0,0,0-3.907,3,6.434,6.434,0,0,0-.643,4.883L37.5-20.632", transform: "translate(21.175 1.145)", fill: "#fff", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1754", "data-name": "Path 1754", d: "M51.2-24.717,44.822-48.505a7.534,7.534,0,0,0-3.51-4.574,7.534,7.534,0,0,0-5.717-.753h0a7.534,7.534,0,0,0-4.574,3.51,7.534,7.534,0,0,0-.753,5.717L36.888-19.9a1.1,1.1,0,0,0,1.346.777,1.1,1.1,0,0,0,.777-1.346L32.39-45.174a5.336,5.336,0,0,1,.533-4.049,5.336,5.336,0,0,1,3.24-2.486h0a5.336,5.336,0,0,1,4.049.533,5.336,5.336,0,0,1,2.486,3.24l6.374,23.788a1.1,1.1,0,0,0,1.346.777A1.1,1.1,0,0,0,51.2-24.717Z", transform: "translate(20.726 0.696)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1755", "data-name": "Path 1755", d: "M57.443-16.519,49.838-44.9a6.434,6.434,0,0,0-3-3.907,6.435,6.435,0,0,0-4.883-.643h0a6.435,6.435,0,0,0-3.907,3,6.435,6.435,0,0,0-.643,4.883l4.288,16", transform: "translate(25.682 3.747)", fill: "#fff", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1756", "data-name": "Path 1756", d: "M58.953-16.355,51.348-44.737a7.533,7.533,0,0,0-3.51-4.574,7.533,7.533,0,0,0-5.717-.752h0a7.533,7.533,0,0,0-4.574,3.51,7.533,7.533,0,0,0-.752,5.717l4.288,16a1.1,1.1,0,0,0,1.346.777,1.1,1.1,0,0,0,.777-1.346l-4.288-16a5.335,5.335,0,0,1,.533-4.049,5.335,5.335,0,0,1,3.24-2.486h0a5.335,5.335,0,0,1,4.049.533,5.336,5.336,0,0,1,2.486,3.24l7.605,28.382a1.1,1.1,0,0,0,1.346.777A1.1,1.1,0,0,0,58.953-16.355Z", transform: "translate(25.233 3.298)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1757", "data-name": "Path 1757", d: "M42.076-5.325c-5.084-1.031-8.905-4.621-11.65-8.689a45.484,45.484,0,0,1-5.889-13.639,1.1,1.1,0,0,1,.831-1.313,1.1,1.1,0,0,1,1.313.831,43,43,0,0,0,5.567,12.892c2.577,3.819,6.169,7.244,11.091,7.9a1.1,1.1,0,0,1,.952,1.061S44.6,7.155,33.932,12.842A1.1,1.1,0,1,1,32.9,10.9C40.862,6.658,41.938-2.44,42.076-5.325Z", transform: "translate(16.927 18.027)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1758", "data-name": "Path 1758", d: "M68.429-14.993S68.119-1.56,78.788,4.127a1.1,1.1,0,0,0,1.034-1.939c-9.536-5.083-9.2-17.124-9.2-17.124a1.1,1.1,0,0,0-1.07-1.127A1.1,1.1,0,0,0,68.429-14.993Z", transform: "translate(47.258 26.957)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1759", "data-name": "Path 1759", d: "M52.24-17.476c1.032,3.74.6,9.3-1.039,14.68S46.7,7.8,42.741,10.81a1.1,1.1,0,1,0,1.332,1.748c4.289-3.267,7.45-8.883,9.23-14.713s2.174-11.855,1.056-15.907a1.1,1.1,0,0,0-1.352-.767A1.1,1.1,0,0,0,52.24-17.476Z", transform: "translate(29.219 25.02)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1760", "data-name": "Path 1760", d: "M55.859-18.061C54.74-14.01,55.135-7.983,56.914-2.155s4.941,11.447,9.23,14.713a1.1,1.1,0,0,0,1.332-1.748C63.519,7.8,60.658,2.582,59.016-2.8s-2.071-10.94-1.039-14.68a1.1,1.1,0,0,0-.767-1.352A1.1,1.1,0,0,0,55.859-18.061Z", transform: "translate(38.145 25.02)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1761", "data-name": "Path 1761", d: "M26.691-38.375H1.268A1.269,1.269,0,0,0,0-37.107a1.269,1.269,0,0,0,1.268,1.268H26.691a1.269,1.269,0,0,0,1.268-1.268A1.268,1.268,0,0,0,26.691-38.375Z", transform: "translate(0 11.548)", fill: "#4eb7a1", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1762", "data-name": "Path 1762", d: "M18.088-32.141H13.725a1.269,1.269,0,0,0-1.268,1.268A1.269,1.269,0,0,0,13.725-29.6h4.363a1.269,1.269,0,0,0,1.268-1.268A1.268,1.268,0,0,0,18.088-32.141Z", transform: "translate(8.603 15.854)", fill: "#4eb7a1", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1763", "data-name": "Path 1763", d: "M18.875-25.7H12.586a1.269,1.269,0,0,0-1.268,1.268,1.269,1.269,0,0,0,1.268,1.268h6.289a1.269,1.269,0,0,0,1.268-1.268A1.269,1.269,0,0,0,18.875-25.7Z", transform: "translate(7.816 20.304)", fill: "#4eb7a1", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1764", "data-name": "Path 1764", d: "M16.448-32.141H4a1.268,1.268,0,0,0-1.268,1.268A1.269,1.269,0,0,0,4-29.6H16.448a1.269,1.269,0,0,0,1.268-1.268A1.269,1.269,0,0,0,16.448-32.141Z", transform: "translate(1.886 15.854)", fill: "#4eb7a1", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1765", "data-name": "Path 1765", d: "M15.1-25.7H2.618A1.269,1.269,0,0,0,1.35-24.429a1.269,1.269,0,0,0,1.268,1.268H15.1a1.269,1.269,0,0,0,1.268-1.268A1.269,1.269,0,0,0,15.1-25.7Z", transform: "translate(0.933 20.304)", fill: "#4eb7a1", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1766", "data-name": "Path 1766", d: "M87.764-35.839h25.423a1.269,1.269,0,0,0,1.268-1.268,1.268,1.268,0,0,0-1.268-1.268H87.764A1.268,1.268,0,0,0,86.5-37.107,1.269,1.269,0,0,0,87.764-35.839Z", transform: "translate(59.737 11.548)", fill: "#4eb7a1", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1767", "data-name": "Path 1767", d: "M87.764-29.6h4.363a1.269,1.269,0,0,0,1.268-1.268,1.269,1.269,0,0,0-1.268-1.268H87.764A1.268,1.268,0,0,0,86.5-30.873,1.269,1.269,0,0,0,87.764-29.6Z", transform: "translate(59.737 15.854)", fill: "#4eb7a1", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1768", "data-name": "Path 1768", d: "M87.764-23.161h6.289a1.269,1.269,0,0,0,1.268-1.268A1.269,1.269,0,0,0,94.053-25.7H87.764A1.269,1.269,0,0,0,86.5-24.429,1.269,1.269,0,0,0,87.764-23.161Z", transform: "translate(59.737 20.304)", fill: "#4eb7a1", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1769", "data-name": "Path 1769", d: "M92.708-29.6h12.448a1.269,1.269,0,0,0,1.268-1.268,1.269,1.269,0,0,0-1.268-1.268H92.708a1.269,1.269,0,0,0-1.268,1.268A1.269,1.269,0,0,0,92.708-29.6Z", transform: "translate(63.151 15.854)", fill: "#4eb7a1", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1770", "data-name": "Path 1770", d: "M94.068-23.161H106.55a1.269,1.269,0,0,0,1.268-1.268A1.269,1.269,0,0,0,106.55-25.7H94.068A1.269,1.269,0,0,0,92.8-24.429,1.269,1.269,0,0,0,94.068-23.161Z", transform: "translate(64.09 20.304)", fill: "#4eb7a1", fillRule: "evenodd" })))), fpt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 102.469, height: 141.599, viewBox: "0 0 102.469 141.599" }, e), /* @__PURE__ */ k.createElement("g", { id: "Group_2511", "data-name": "Group 2511", transform: "translate(-4791 -2598.401)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2508", "data-name": "Group 2508", transform: "translate(-123.531 458)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1855", "data-name": "Path 1855", d: "M92.392-51.553a3.075,3.075,0,0,0-.9-2.174,3.075,3.075,0,0,0-2.174-.9H24.643a3.075,3.075,0,0,0-2.174.9,3.075,3.075,0,0,0-.9,2.174V41.053a3.074,3.074,0,0,0,3.074,3.074H89.318a3.074,3.074,0,0,0,3.074-3.074Zm-1.685,0V41.053a1.39,1.39,0,0,1-1.39,1.39H24.643a1.39,1.39,0,0,1-1.39-1.39V-51.553a1.39,1.39,0,0,1,.407-.983,1.39,1.39,0,0,1,.983-.407H89.318a1.39,1.39,0,0,1,.983.407A1.39,1.39,0,0,1,90.708-51.553Z", transform: "translate(4903.431 2219.627)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("path", { id: "Path_1854", "data-name": "Path 1854", d: "M107.981-57.386a9,9,0,0,0-2.635-6.362,9,9,0,0,0-6.361-2.635H25.711a9,9,0,0,0-6.362,2.635,9,9,0,0,0-2.635,6.362V62.325a9,9,0,0,0,9,9H98.984a9,9,0,0,0,9-9Zm-3.159,0V62.325a5.838,5.838,0,0,1-5.838,5.838H25.711a5.838,5.838,0,0,1-5.838-5.838V-57.386a5.838,5.838,0,0,1,1.71-4.128,5.838,5.838,0,0,1,4.128-1.71H98.984a5.838,5.838,0,0,1,4.128,1.71A5.838,5.838,0,0,1,104.822-57.386Z", transform: "translate(4897.816 2206.784)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("g", { id: "Ellipse_409", "data-name": "Ellipse 409", transform: "translate(4982.988 2247.988)", fill: "#fff", stroke: "#fff", strokeWidth: 1 }, /* @__PURE__ */ k.createElement("circle", { cx: 17.006, cy: 17.006, r: 17.006, stroke: "none" }), /* @__PURE__ */ k.createElement("circle", { cx: 17.006, cy: 17.006, r: 16.506, fill: "none" })), /* @__PURE__ */ k.createElement("path", { id: "Path_1857", "data-name": "Path 1857", d: "M34.344-57.2H55.323a1.791,1.791,0,0,0,1.79-1.79,1.791,1.791,0,0,0-1.79-1.79H34.344a1.791,1.791,0,0,0-1.79,1.79A1.791,1.791,0,0,0,34.344-57.2Z", transform: "translate(4915.33 2212.979)", fill: "#bcc2d4", fillRule: "evenodd" }), /* @__PURE__ */ k.createElement("g", { id: "Group_2507", "data-name": "Group 2507", transform: "translate(4998.043 2256.445)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1992", "data-name": "Path 1992", d: "M40.064-30.13c.968,0,2.363.163,2.393,1.253a10.412,10.412,0,0,1-.114,1.253c-.285,1.823-1.112,6.295-1.595,9.884H39.38c-.4-3.3-1.224-7.831-1.566-9.8a7.291,7.291,0,0,1-.2-1.339C37.614-29.873,39.038-30.13,40.064-30.13Zm.028,19.253h-.042a2.389,2.389,0,0,1-2.378-2.378,2.389,2.389,0,0,1,2.378-2.378,2.389,2.389,0,0,1,2.378,2.363q0,.072,0,.143a2.262,2.262,0,0,1-2.251,2.251l-.091,0Z", transform: "translate(-37.821 29.309)", fill: "#4eb6a1" })), /* @__PURE__ */ k.createElement("g", { id: "Ellipse_410", "data-name": "Ellipse 410", transform: "translate(4982.988 2247.988)", fill: "none", stroke: "#4eb6a1", strokeWidth: 2.7 }, /* @__PURE__ */ k.createElement("circle", { cx: 17.006, cy: 17.006, r: 17.006, stroke: "none" }), /* @__PURE__ */ k.createElement("circle", { cx: 17.006, cy: 17.006, r: 15.656, fill: "none" }))), /* @__PURE__ */ k.createElement("g", { id: "Group_2509", "data-name": "Group 2509", transform: "translate(-1)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2510", "data-name": "Group 2510", transform: "translate(1 -3)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2506", "data-name": "Group 2506", transform: "translate(-123.217 460)" }, /* @__PURE__ */ k.createElement("g", { id: "Group_2504", "data-name": "Group 2504", transform: "translate(0 -1.77)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1987", "data-name": "Path 1987", d: "M8831.685-5831.23h24.421", transform: "translate(-3872.278 8051)", fill: "none", stroke: "#bcc2d4", strokeLinecap: "round", strokeWidth: 4 }), /* @__PURE__ */ k.createElement("path", { id: "Path_1986", "data-name": "Path 1986", d: "M8831.686-5831.23h6.143", transform: "translate(-3885.194 8051)", fill: "none", stroke: "#bcc2d4", strokeLinecap: "round", strokeWidth: 4 }), /* @__PURE__ */ k.createElement("path", { id: "Path_1982", "data-name": "Path 1982", d: "M8831.686-5831.23h3.1", transform: "translate(-3896 8044)", fill: "none", stroke: "#bcc2d4", strokeLinecap: "round", strokeWidth: 4 }), /* @__PURE__ */ k.createElement("path", { id: "Path_1979", "data-name": "Path 1979", d: "M8831.685-5831.23h37.337", transform: "translate(-3885.193 8044)", fill: "none", stroke: "#bcc2d4", strokeLinecap: "round", strokeWidth: 4 })), /* @__PURE__ */ k.createElement("g", { id: "Group_2505", "data-name": "Group 2505", transform: "translate(0 0.23)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1984", "data-name": "Path 1984", d: "M8831.687-5831.23h25.027", transform: "translate(-3885.194 8062)", fill: "none", stroke: "#bcc2d4", strokeLinecap: "round", strokeWidth: 4 }), /* @__PURE__ */ k.createElement("path", { id: "Path_1985", "data-name": "Path 1985", d: "M8831.686-5831.23h6.143", transform: "translate(-3854 8062)", fill: "none", stroke: "#bcc2d4", strokeLinecap: "round", strokeWidth: 4 }), /* @__PURE__ */ k.createElement("path", { id: "Path_1983", "data-name": "Path 1983", d: "M8831.686-5831.23h3.1", transform: "translate(-3896 8062)", fill: "none", stroke: "#bcc2d4", strokeLinecap: "round", strokeWidth: 4 }), /* @__PURE__ */ k.createElement("path", { id: "Path_1988", "data-name": "Path 1988", d: "M8831.685-5831.23h37.337", transform: "translate(-3885.193 8069)", fill: "none", stroke: "#bcc2d4", strokeLinecap: "round", strokeWidth: 4 })), /* @__PURE__ */ k.createElement("g", { id: "Group_2503", "data-name": "Group 2503", transform: "translate(0 0.23)" }, /* @__PURE__ */ k.createElement("path", { id: "Path_1978", "data-name": "Path 1978", d: "M8831.685-5831.23h37.337", transform: "translate(-3885.275 8022)", fill: "none", stroke: "#bcc2d4", strokeLinecap: "round", strokeWidth: 4 }), /* @__PURE__ */ k.createElement("path", { id: "Path_1989", "data-name": "Path 1989", d: "M8831.686-5831.23h17.448", transform: "translate(-3885.276 8029)", fill: "none", stroke: "#bcc2d4", strokeLinecap: "round", strokeWidth: 4 }), /* @__PURE__ */ k.createElement("path", { id: "Path_1990", "data-name": "Path 1990", d: "M8831.688-5831.23h13.221", transform: "translate(-3861.181 8029)", fill: "none", stroke: "#bcc2d4", strokeLinecap: "round", strokeWidth: 4 }), /* @__PURE__ */ k.createElement("path", { id: "Path_1981", "data-name": "Path 1981", d: "M8831.686-5831.23h3.419", transform: "translate(-3896 8022)", fill: "none", stroke: "#bcc2d4", strokeLinecap: "round", strokeWidth: 4 }))))))), ppt = () => {
  const [e, t] = mt(1), [n, r] = mt([]), [a, o] = mt(!1), [s, c] = mt(!1), { popupType: u, consents: f } = wr((R) => R.popup), m = Jo(), { t: v } = tn(), y = (R) => {
    const O = R.find(
      ({ required: D, state: $ }) => D && $ === "declined"
    );
    c(!O);
  };
  mn(() => {
    r(f), y(f);
  }, []);
  const b = () => {
    const R = n.map(({ name: O, newestVersion: D, state: $ }) => ({
      name: O,
      version: D,
      state: $
    }));
    o(!0), K6([], [], R).then(() => {
      l2().then(({ responseData: O }) => {
        m(B7(O.consents));
      });
    });
  }, S = () => {
    if (Nx[u] === "consentsUpdateRequired" || e === 2) {
      b();
      return;
    }
    t((R) => R + 1);
  }, x = Nx[u].steps[e - 1], { steps: E } = Nx[u], N = () => x.icon ? Nx[u] === "notCheckedTerms" ? /* @__PURE__ */ C.jsx(dpt, {}) : /* @__PURE__ */ C.jsx(fpt, {}) : null;
  return /* @__PURE__ */ C.jsxs(ept, { children: [
    /* @__PURE__ */ C.jsxs(spt, { children: [
      /* @__PURE__ */ C.jsx(ipt, { $currentStep: e, children: E.length > 1 && E.map(({ title: R }) => /* @__PURE__ */ C.jsx(lpt, {}, R)) }),
      /* @__PURE__ */ C.jsx(upt, { children: v(x.translationKeys.header, x.headerTitle) })
    ] }),
    /* @__PURE__ */ C.jsxs(tpt, { step: f.length ? e : 1, children: [
      N(),
      /* @__PURE__ */ C.jsx(rpt, { step: e, children: v(x.translationKeys.title, x.title) }),
      /* @__PURE__ */ C.jsx(apt, { step: e, children: v(x.translationKeys.text, x.text) }),
      e === 2 && f && // TODO: Remove setConsents and consents props and use redux in MyAccountConsents
      /* @__PURE__ */ C.jsx(
        Kue,
        {
          consents: f,
          showConsentsOnly: !0,
          saveConsents: (R) => {
            r(R), y(R);
          },
          setConsents: B7
        }
      )
    ] }),
    /* @__PURE__ */ C.jsx(npt, { children: /* @__PURE__ */ C.jsx(cpt, { children: /* @__PURE__ */ C.jsx(
      opt,
      {
        onClickFn: S,
        disabled: e === 2 && !s,
        width: "auto",
        children: a && /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) || v(x.translationKeys.button, x.buttonText)
      }
    ) }) }),
    /* @__PURE__ */ C.jsx(yu, { isCheckout: !1 })
  ] });
}, hpt = W.div.attrs(() => ({
  className: "msd__account-wrapper"
}))`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;

  height: 100%;

  padding-top: 44px;

  background-color: ${cu};

  ${Zr.small`
    flex-direction: row;
    min-height: unset;

    padding: 0;
  `}
`, mpt = W.div.attrs(() => ({
  className: "msd__account-sidebar"
}))`
  position: relative;
  padding: 0 26px;

  background: ${Br};

  footer {
    display: none;
  }

  ${Zr.small`
    width: 288px;
    padding: 30px 34px;

    footer {
      display: block;
      padding: 23px 34px;
    }
  `}
`;
W.div`
  width: 100%;
`;
const Tx = {
  notCheckedTerms: "notCheckedTerms",
  complexUpdate: "complexUpdate",
  termsUpdateRequired: "termsUpdateRequired",
  consentsUpdateRequired: "consentsUpdateRequired"
};
class bL extends Nc {
  constructor(n) {
    super(n);
    Er(this, "handleLogout", () => {
      this.setState({ isLogged: !1 });
    });
    Er(this, "renderMyAccountContent", () => {
      const {
        customCancellationReasons: n,
        skipAvailableDowngradesStep: r,
        skipAvailableFreeExtensionStep: a,
        myaccountState: { activeTab: o }
      } = this.props;
      switch (o) {
        case R4.planDetails:
          return /* @__PURE__ */ C.jsx(
            $st,
            {
              customCancellationReasons: n,
              skipAvailableDowngradesStep: r,
              skipAvailableFreeExtensionStep: a
            }
          );
        case R4.paymentInfo:
          return /* @__PURE__ */ C.jsx(zlt, {});
        case R4.updateProfile:
          return /* @__PURE__ */ C.jsx(Jft, { handleLogout: this.handleLogout });
        default:
          return null;
      }
    });
    this.state = {
      isLogged: !1,
      errors: []
    };
  }
  componentDidMount() {
    const {
      userProfile: n,
      setCurrentUser: r,
      setConsents: a,
      setConsentsError: o,
      initPublisherConfig: s,
      adyenConfiguration: c,
      displayGracePeriodError: u
    } = this.props;
    document.title = "My Account", Ec.isLogged() && (n.consents.length === 0 && l2().then((f) => {
      f.errors.length ? o(f.errors[0]) : (a(f.responseData.consents), this.checkTerms());
    }).catch(() => o("Something went wrong..")), n.user || L7().then((f) => {
      f.errors.length ? this.setState({
        errors: f.errors
      }) : r(f.responseData);
    }), c && s({
      adyenConfiguration: c
    })), u !== null && s({ displayGracePeriodError: u });
  }
  componentDidUpdate(n) {
    const {
      userProfile: { consents: r },
      userProfile: a,
      setCurrentUser: o,
      setConsents: s,
      setConsentsError: c
    } = this.props;
    if (n.userProfile.consents !== r && this.checkTerms(), Ec.isLogged()) {
      a.consents.length === 0 && l2().then((f) => {
        f.errors.length ? c(f.errors[0]) : (s(f.responseData.consents), this.checkTerms());
      }).catch(() => c("Something went wrong..")), a.user || L7().then((f) => {
        f.errors.length ? this.setState({
          errors: f.errors
        }) : o(f.responseData);
      });
      const u = new URLSearchParams(
        window.location.search
      ).get("deletepd");
      parseInt(u, 10) && Zue(u);
    }
  }
  checkTerms() {
    const {
      userProfile: { consents: n }
    } = this.props;
    if (n.length !== 0) {
      const r = n.filter(
        (s) => s.required && s.state === "declined" && s.version === s.newestVersion
      );
      if (r.length) {
        this.renderPopup(!0, Tx.notCheckedTerms, r);
        return;
      }
      const a = n.filter(
        (s) => !s.required && s.needsUpdate === !0
      ), o = n.filter(
        (s) => s.required && s.version !== s.newestVersion
      );
      o.length && a.length ? this.renderPopup(!0, Tx.complexUpdate, [
        ...o,
        ...a
      ]) : o.length ? this.renderPopup(
        !0,
        Tx.termsUpdateRequired,
        o
      ) : a.length ? this.renderPopup(
        !0,
        Tx.consentsUpdateRequired,
        a
      ) : this.renderPopup(!1);
    }
  }
  renderPopup(n, r = "", a = []) {
    const { showPopup: o, hidePopup: s } = this.props;
    n ? o({ type: r, consents: a }) : s();
  }
  render() {
    const {
      userProfile: { consentsError: n },
      popup: { isPopupShown: r },
      myaccountState: { activeTab: a }
    } = this.props;
    return n ? /* @__PURE__ */ C.jsx(Ml, { generalError: !0, fullHeight: !0 }) : r ? /* @__PURE__ */ C.jsx(ppt, {}) : Ec.isLogged() ? /* @__PURE__ */ C.jsxs(hpt, { children: [
      /* @__PURE__ */ C.jsxs(mpt, { children: [
        /* @__PURE__ */ C.jsx(wat, {}),
        /* @__PURE__ */ C.jsx(gat, {}),
        /* @__PURE__ */ C.jsx(yu, { isCheckout: !1, isTransparent: !0 })
      ] }),
      /* @__PURE__ */ C.jsx(PD, { children: this.renderMyAccountContent(a) })
    ] }) : /* @__PURE__ */ C.jsx(Ple, { isMyAccount: !0, onSuccess: () => this.setState({ isLogged: !0 }) });
  }
}
bL.propTypes = {
  setCurrentUser: de.func.isRequired,
  setConsents: de.func.isRequired,
  setConsentsError: de.func.isRequired,
  userProfile: de.objectOf(de.any),
  popup: de.objectOf(de.any),
  showPopup: de.func.isRequired,
  hidePopup: de.func.isRequired,
  customCancellationReasons: de.arrayOf(
    de.shape({
      key: de.string.isRequired,
      value: de.string.isRequired
    })
  ),
  skipAvailableDowngradesStep: de.bool,
  skipAvailableFreeExtensionStep: de.bool,
  initPublisherConfig: de.func.isRequired,
  adyenConfiguration: de.objectOf(de.any),
  displayGracePeriodError: de.bool,
  myaccountState: de.shape({
    activeTab: de.string.isRequired
  }).isRequired
};
bL.defaultProps = {
  userProfile: { user: null },
  adyenConfiguration: null,
  popup: { isPopupShown: !1 },
  customCancellationReasons: null,
  skipAvailableDowngradesStep: !1,
  skipAvailableFreeExtensionStep: !1,
  displayGracePeriodError: null
};
const vpt = o1()(
  Nle(bL)
), gpt = (e) => ({
  userProfile: e.userProfile,
  consents: e.consents,
  popup: e.popup,
  myaccountState: e.myaccount
}), ypt = (e) => ({
  setCurrentUser: (t) => {
    e(kee(t));
  },
  setConsents: (t) => {
    e(B7(t));
  },
  setConsentsError: (t) => {
    e(Dbe(t));
  },
  showPopup: (t, n) => {
    e(sbe(t, n));
  },
  hidePopup: () => {
    e(lbe());
  },
  initPublisherConfig: (t) => {
    e($u(t));
  },
  setActiveTab: (t) => {
    e(LR(t));
  }
}), Sht = V6(
  gpt,
  ypt
)(vpt), bpt = W.div.attrs(() => ({
  className: "msd__transactions-list__wrapper"
}))`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  background: ${Br};
`;
W.div`
  color: ${Et};

  font-size: 14px;
  font-weight: 700;
`;
const xht = () => {
  const { t: e } = tn();
  return /* @__PURE__ */ C.jsxs(bpt, { children: [
    /* @__PURE__ */ C.jsx(Xi, { marginTop: "25px", children: e("transaction-list.header", "Transactions") }),
    /* @__PURE__ */ C.jsx(Gue, {})
  ] });
}, _pt = W.div.attrs(() => ({
  className: "msd__subscriptions__wrapper"
}))`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  background: ${Br};
`, $ce = ({
  customCancellationReasons: e,
  skipAvailableDowngradesStep: t,
  skipAvailableFreeExtensionStep: n
}) => {
  const { data: r } = wr((y) => y.plan.currentPlan), { updateList: a } = wr((y) => y.plan), { offers: o } = wr((y) => y.offers), { isOpen: s } = wr((y) => y.popupManager), { t: c } = tn(), u = Yo(!1), f = Jo(), m = (y) => st(void 0, null, function* () {
    y.length > 1 && f(fee()), f(Xy(y));
  }), v = () => st(void 0, null, function* () {
    const b = (yield f(L0()).unwrap()).filter(
      (x) => x.status === "active" && x.offerType === "S"
    ), S = b.filter(
      (x) => x.pendingSwitchId
    );
    f(Yy(S)), b.length === 1 && f(P_(b[0])), b.length > 0 && m(b);
  });
  return mn(() => {
    r.length === 0 && v(), o.length === 0 && f(Wy()), s && (f(Za()), f(Pd()));
  }, []), mn(() => {
    u.current ? v() : u.current = !0;
  }, [a]), s ? /* @__PURE__ */ C.jsx(
    QD,
    {
      customCancellationReasons: e,
      skipAvailableDowngradesStep: t,
      skipAvailableFreeExtensionStep: n
    }
  ) : /* @__PURE__ */ C.jsxs(_pt, { children: [
    /* @__PURE__ */ C.jsx(Xi, { children: /* @__PURE__ */ C.jsx(C.Fragment, { children: c("subscriptions.current-plan", "Current plan") }) }),
    /* @__PURE__ */ C.jsx(kue, {})
  ] });
};
$ce.propTypes = {
  customCancellationReasons: _c.PropTypes.arrayOf(
    _c.PropTypes.shape({
      key: _c.PropTypes.string.isRequired,
      value: _c.PropTypes.string.isRequired
    })
  ),
  skipAvailableDowngradesStep: _c.PropTypes.bool,
  skipAvailableFreeExtensionStep: _c.PropTypes.bool
};
$ce.defaultProps = {
  customCancellationReasons: null,
  skipAvailableDowngradesStep: !1,
  skipAvailableFreeExtensionStep: !1
};
const NJ = W.div.attrs(() => ({
  className: "msd__subscription-switches__wrapper"
}))`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  background: ${Br};
`, jce = ({
  offerId: e,
  onCancel: t,
  toOfferId: n,
  onSwitchSuccess: r,
  onSwitchError: a
}) => {
  const { isOpen: o } = wr((x) => x.popupManager), { data: s } = wr(
    (x) => x.plan.switchSettings
  ), { offers: c } = wr((x) => x.offers), [u, f] = mt(!1), m = Jo(), { t: v } = tn(), y = (x) => st(void 0, null, function* () {
    yield m(Xy([x]));
  }), b = () => st(void 0, null, function* () {
    const E = (yield m(L0()).unwrap()).filter(
      ({ status: O, offerType: D }) => O === "active" && D === "S"
    ), N = E.filter(
      ({ pendingSwitchId: O }) => O
    );
    m(Yy(N));
    const R = E.find(
      (O) => O.offerId === e
    );
    if (!R) {
      f(!0);
      return;
    }
    m(P_(R)), y(R);
  }), S = () => {
    var x;
    if (e && n) {
      const E = (x = s[e]) == null ? void 0 : x.available.find(
        (N) => N.toOfferId === n
      );
      if (!E) return;
      m(
        Ed({
          type: Nm.switchPlan,
          data: {
            offerData: Fe({}, E)
          }
        })
      );
    }
  };
  return mn(() => {
    e && b(), o && (m(Za()), m(Pd())), c.length === 0 && m(Wy());
  }, []), mn(() => {
    e && !s[e] && b();
  }, [e]), mn(() => {
    S();
  }, [s]), u ? /* @__PURE__ */ C.jsxs(NJ, { children: [
    /* @__PURE__ */ C.jsx(Ml, { generalError: !0 }),
    ";"
  ] }) : o ? /* @__PURE__ */ C.jsx(
    QD,
    {
      onCancel: t,
      onSwitchSuccess: r,
      onSwitchError: a
    }
  ) : /* @__PURE__ */ C.jsxs(NJ, { children: [
    /* @__PURE__ */ C.jsx(Xi, { children: v("subscription-switches.change-plan", "Change Plan") }),
    /* @__PURE__ */ C.jsx(Tue, {})
  ] });
};
jce.propTypes = {
  offerId: _c.PropTypes.string.isRequired,
  onCancel: _c.PropTypes.func,
  onSwitchSuccess: _c.PropTypes.func,
  onSwitchError: _c.PropTypes.func,
  toOfferId: _c.PropTypes.string
};
jce.defaultProps = {
  onCancel: null,
  onSwitchSuccess: null,
  onSwitchError: null,
  toOfferId: null
};
const Cpt = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDE2Ij48cGF0aCBkPSJNMTUsMTJhMywzLDAsMSwxLTMtM0EzLDMsMCwwLDEsMTUsMTJabTktLjQ0OVMxOS43NDgsMjAsMTIuMDE1LDIwQzQuODM1LDIwLDAsMTEuNTUxLDAsMTEuNTUxUzQuNDQ2LDQsMTIuMDE1LDRDMTkuNzA5LDQsMjQsMTEuNTUxLDI0LDExLjU1MVpNMTcsMTJhNSw1LDAsMSwwLTUsNUE1LjAwNiw1LjAwNiwwLDAsMCwxNywxMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTQpIi8+PC9zdmc+", wpt = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDIwIj48cGF0aCBkPSJNMTEuODg1LDE0Ljk4OGwzLjEtMy4xTDE1LDEyYTMsMywwLDAsMS0zLDNsLS4xMTUtLjAxMlptOC4wNDgtOC4wMzItMy4yNzQsMy4yNjhBNC45NTIsNC45NTIsMCwwLDEsMTcsMTJhNS4wMDYsNS4wMDYsMCwwLDEtNSw1LDQuOTUxLDQuOTUxLDAsMCwxLTEuNzg1LS4zNDRMNy44MzgsMTkuMDI4QTkuOTI3LDkuOTI3LDAsMCwwLDEyLjAxNSwyMEMxOS43NDgsMjAsMjQsMTEuNTUxLDI0LDExLjU1MWExOC4xLDE4LjEsMCwwLDAtNC4wNjctNC41OTVaTTIxLjM2NCwzLjQyLDIuNzQ1LDIyLDEuMzYzLDIwLjU3OGwzLjQ1NS0zLjQ0N0EyMi41NjksMjIuNTY5LDAsMCwxLDAsMTEuNTUxUzQuNDQ2LDQsMTIuMDE1LDRBMTEuNzI3LDExLjcyNywwLDAsMSwxNi45LDUuMDc1TDE5Ljk4MiwybDEuMzgyLDEuNDJaTTcuNjEzLDE0LjM0MmwxLjUxOS0xLjUxNUEyLjkzOCwyLjkzOCwwLDAsMSw5LDEyYTMsMywwLDAsMSwzLTMsMi45MSwyLjkxLDAsMCwxLC44MzMuMTM0bDEuNTE4LTEuNTE1QTQuOTA2LDQuOTA2LDAsMCwwLDEyLDdhNS4wMDYsNS4wMDYsMCwwLDAtNSw1QTQuOTExLDQuOTExLDAsMCwwLDcuNjEzLDE0LjM0MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTIpIi8+PC9zdmc+", Spt = W.div`
  display: flex;
  flex-direction: column;
  position: relative;

  padding: 10px;
  width: 100%;
`, Fce = W.label.attrs(() => ({
  className: "msd__input__label"
}))`
  position: absolute;
  inset-block-start: 17px;
  inset-inline-start: 14px;

  margin: 0;
  padding-inline: 3px;

  color: ${({ theme: e }) => e.FontColor};
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;

  ${(e) => e.$withIcon && ot`
      inset-inline-start: 40px;
    `}

  &::after {
    position: absolute;
    content: '';
    inset-block-start: 0;
    inset-inline-start: 0;

    width: 100%;
    height: 15px;

    background: ${({ theme: e }) => e.BackgroundColor};

    z-index: -1;
    opacity: 0;
  }

  ${(e) => e.$hasValue && ot`
      transform: translate(0, -25px) scaleY(0.9);
      &::after {
        opacity: 1;
      }
    `}

  ${(e) => e.$hasValue && e.$withIcon && ot`
      transform: translate(-26px, -25px) scaleY(0.9);
    `}
`, xpt = W.div.attrs(() => ({
  className: "msd__input__wrapper"
}))`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  padding: 13px 0 14px;

  background: transparent;
  border: 1px solid #b7bfca;
  transition: 0.2s ease-in-out;

  &:focus-within {
    border-color: ${({ theme: e }) => e.ConfirmColor};
    ${Fce} {
      color: ${({ theme: e }) => e.ConfirmColor};
      transform: translate(0, -25px) scaleY(0.9);
      &::after {
        opacity: 1;
      }
    }
  }
`, Ept = W.input.attrs(() => ({
  className: "msd__input"
}))`
  flex-grow: 1;
  position: relative;
  width: auto;

  margin: 0 15px;

  color: ${({ theme: e }) => e.FontColor};
  background: transparent;
  border: none;
  outline: none;

  font-size: 15px;
  line-height: 1.3;

  &:focus + label {
    transform: translate(0, -25px) scaleY(0.9);
    color: ${({ theme: e }) => e.ConfirmColor};
    ${(e) => e.$withIcon && ot`
        transform: translate(-26px, -25px) scaleY(0.9);
      `}
    &::after {
      opacity: 1;
    }
  }

  ${(e) => e.$floatingLabels === !1 && ot`
      & + label {
        transform: translate(0, -25px) scaleY(0.9);
        &::after {
          opacity: 1;
        }
      }
    `}

  ${pr.small`
    width: 100%;
  `}

  ${(e) => e.type === "date" && ot`
      text-transform: uppercase;
      &::-webkit-inner-spin-button,
      &::-webkit-calendar-picker-indicator {
        display: none;
        -webkit-appearance: none;
      }
      & + label {
        transform: translate(-26px, -25px) scaleY(0.9);
        &::after {
          opacity: 1;
        }
      }
    `}
`, Ipt = W.div.attrs(() => ({
  className: "msd__error"
}))`
  width: 100%;
  height: 13px;
  margin-top: 8px;

  content: '';
  color: ${({ theme: e }) => e.ErrorColor};
  transition: 0.2s ease-in-out;

  ${(e) => e.$passwordStrength && ot`
      color: ${e.theme.PasswordStrengthColors[e.$passwordStrength]};
    `}

  font-size: 13px;
  text-align: start;
`, TJ = W.img.attrs(() => ({
  className: "msd__icon--password"
}))`
  height: 20px;
  width: 20px;
  filter: ${({ theme: e }) => e.TextFieldBorderFilter};
`, kpt = W.button`
  background: transparent;
  border: none;
  border-radius: 50%;
  display: flex;
  padding: 0;
  position: relative;
  margin-inline-end: 15px;
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transform: scale(1.5);
    height: 100%;
    background-color: rgba(0, 0, 0, 0.08);
    z-index: 0;
    content: '';
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  &:hover::after,
  &:focus::after {
    opacity: 1;
  }
`, Apt = W.span.attrs(() => ({
  className: "msd__icon__required--error"
}))`
  display: block;
  position: absolute;
  right: 16px;
  height: 9px;
  font-size: 12px;
  line-height: 12px;
  top: 50%;
  color: ${({ theme: e }) => e.ErrorColor};
  transform: translate(0, -50%);
  z-index: 1;
`, vc = ({
  type: e = "text",
  placeholder: t,
  value: n,
  onChange: r,
  onBlur: a,
  error: o,
  showVisibilityIcon: s,
  handleClickShowPassword: c,
  showPassword: u,
  passwordStrength: f,
  invalid: m,
  icon: v,
  required: y,
  floatingLabels: b,
  reference: S,
  format: x
}) => /* @__PURE__ */ C.jsx(bQ, { theme: Dee, children: /* @__PURE__ */ C.jsxs(Spt, { children: [
  /* @__PURE__ */ C.jsxs(xpt, { children: [
    y && /* @__PURE__ */ C.jsx(Apt, { children: "*" }),
    /* @__PURE__ */ C.jsx(
      Ept,
      {
        "data-testid": "input",
        id: t,
        autoComplete: "off",
        value: n,
        onChange: (E) => r(E.target.value),
        type: e,
        onBlur: a,
        ref: S,
        required: y,
        "aria-invalid": m,
        $withIcon: !!v,
        $floatingLabels: !!b,
        format: x
      }
    ),
    /* @__PURE__ */ C.jsx(
      Fce,
      {
        "data-testid": "input-label",
        htmlFor: t,
        $hasValue: !!n,
        $withIcon: !!v,
        children: t
      }
    ),
    s && /* @__PURE__ */ C.jsx(
      kpt,
      {
        "data-testid": "input-visibility-icon",
        onClick: c,
        tabIndex: 0,
        "aria-label": "toggle password visibility",
        type: "button",
        children: u ? /* @__PURE__ */ C.jsx(TJ, { src: wpt, alt: "" }) : /* @__PURE__ */ C.jsx(TJ, { src: Cpt, alt: "" })
      }
    )
  ] }),
  /* @__PURE__ */ C.jsx(
    Ipt,
    {
      $passwordStrength: f,
      id: `${t}-desc`,
      children: o
    }
  )
] }) }), Ppt = ({
  value: e,
  onChange: t,
  onBlur: n,
  error: r,
  label: a = "Email",
  floatingLabels: o,
  required: s,
  reference: c
}) => /* @__PURE__ */ C.jsx(
  vc,
  {
    placeholder: a,
    floatingLabels: o,
    type: "email",
    value: e,
    onChange: t,
    onBlur: n,
    error: r,
    required: s,
    reference: c,
    invalid: !!r
  }
), Npt = (e) => /* @__PURE__ */ k.createElement("svg", Fe({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24" }, e), /* @__PURE__ */ k.createElement("path", { d: "M20 20h-4v-4h4v4zm-6-10h-4v4h4v-4zm6 0h-4v4h4v-4zm-12 6h-4v4h4v-4zm6 0h-4v4h4v-4zm-6-6h-4v4h4v-4zm16-8v22h-24v-22h3v1c0 1.103.897 2 2 2s2-.897 2-2v-1h10v1c0 1.103.897 2 2 2s2-.897 2-2v-1h3zm-2 6h-20v14h20v-14zm-2-7c0-.552-.447-1-1-1s-1 .448-1 1v2c0 .552.447 1 1 1s1-.448 1-1v-2zm-14 2c0 .552-.447 1-1 1s-1-.448-1-1v-2c0-.552.447-1 1-1s1 .448 1 1v2z" })), Tpt = ({
  value: e,
  onChange: t,
  onBlur: n,
  error: r,
  label: a,
  required: o
}) => /* @__PURE__ */ C.jsx(
  vc,
  {
    type: "date",
    placeholder: a,
    format: "dd/mm/yyyy",
    value: e,
    icon: Npt,
    onChange: t,
    onBlur: n,
    error: r,
    required: o
  }
), Opt = W.div.attrs(() => ({
  className: "msd__select__wrapper"
}))`
  display: flex;
  flex-direction: column;
  position: relative;

  width: 100%;
`, Rpt = W(Lce).attrs(() => ({
  className: "msd__select"
}))`
  &:focus-within,
  &:focus {
    border-color: ${An};
  }
  .react-select__control {
    background: white;
    border: 1px solid ${u2};
    border-radius: 0;
    transition: 0.2s ease-in-out;
    &--is-focused {
      &:focus-within,
      &:focus {
        border-color: ${An};
        box-shadow: none;
      }
    }
    &--is-disabled {
      background-color: ${Br};
    }
  }
  .react-select__placeholder {
    color: ${Et};
  }
  .react-select__value-container {
    padding: 13px 15px 14px;
    color: ${Et};
  }
  .react-select__menu {
    border-radius: 0px;
  }
  .react-select__menu-list {
  }
  .react-select__option {
    padding: 13px 15px 14px;
    text-align: left;
    &--is-focused {
      background-color: ${u2};
    }
    &--is-selected {
      color: ${An};
      background-color: #fff;
    }
  }
  ${(e) => e.$isMyAccount && ot`
      .react-select__control {
        border: 1px solid #d3dbe6;
        border-radius: 4px;
      }
      .react-select__value-container {
        padding: 0 16px;
        font-size: 13px;
      }
    `}
  ${(e) => e.$required && ot`
      .react-select__value-container {
        &::after {
          display: block;
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translate(0, -50%);
          content: '*';
          height: 9px;
          font-size: 12px;
          line-height: 12px;
          color: ${wa};
        }
      }
    `}
`, Mpt = ({
  name: e,
  values: t,
  value: n,
  onChange: r,
  label: a,
  required: o,
  disabled: s,
  isMyAccount: c
}) => {
  const u = (f) => {
    f && r(e, f);
  };
  return /* @__PURE__ */ C.jsx(Opt, { children: /* @__PURE__ */ C.jsx(
    Rpt,
    {
      classNamePrefix: "react-select",
      placeholder: a,
      value: n,
      required: o,
      $required: o,
      onChange: (f) => u(f),
      options: t,
      name: e,
      isDisabled: s,
      $isMyAccount: c,
      getOptionLabel: (f) => f.label
    }
  ) });
}, dd = (e) => {
  const [t, n] = mt(e), [r, a] = mt(""), o = (c) => {
    const u = c || "";
    a(""), n(u);
  };
  return { value: t, setValue: o, error: r, setError: a, onChange: (c) => {
    o(c);
  } };
}, OJ = W.div`
  display: flex;

  ${pr.small`
    display: block;
  `}
`, BN = W.div`
  padding: 10px;
`, RJ = W.div`
  text-align: left;
  ${(e) => e.required && ot`
      &::after {
        content: '*';
        margin-left: 4px;
        height: 9px;
        font-size: 12px;
        line-height: 12px;
        color: ${wa};
      }
    `}
`, VN = W.div`
  width: 100%;
  height: 13px;
  margin-top: 8px;
  content: '';
  color: ${wa};
  -webkit-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
  font-size: 13px;
  text-align: left;
`, MJ = (e) => e.key.startsWith("custom_"), Dpt = ({ settings: e, onSuccess: t }) => {
  const { t: n } = tn(), [r, a] = mt(!1), [o, s] = mt([]), c = dd(""), u = dd(""), f = dd(""), m = dd(""), v = dd(""), y = dd(""), b = dd(""), S = dd(""), x = dd(""), E = dd(""), N = dd("");
  let R = !1;
  const O = (oe) => {
    R = oe;
  };
  mn(() => {
    for (let xe = 0; xe < e.length; xe += 1) {
      const X = e[xe];
      X.key === "firstNameLastName" && X.answer && (c.setValue(X.answer.firstName), u.setValue(X.answer.lastName)), X.key === "birthDate" && X.answer && m.setValue(X.answer), X.key === "companyName" && X.answer && v.setValue(X.answer), X.key === "phoneNumber" && X.answer && y.setValue(X.answer), X.key === "address" && X.answer && (b.setValue(X.answer.address), S.setValue(X.answer.address2), x.setValue(X.answer.city), E.setValue(X.answer.state), N.setValue(X.answer.postCode));
    }
    const me = e.filter(
      (xe) => MJ(xe) && xe.enabled
    ).map(
      (xe) => Xn(Fe({}, xe), {
        value: xe.answer ? xe.answer : "",
        values: MJ(xe) ? xe.value.split(";").map((X) => {
          const ye = X.trim();
          return {
            value: ye,
            label: ye
          };
        }) : []
      })
    );
    s(me);
  }, []);
  const D = (oe) => e.find((me) => me.key === oe), $ = (oe) => {
    var xe;
    const me = D(oe);
    return (xe = me == null ? void 0 : me.enabled) != null ? xe : !1;
  }, B = (oe) => {
    var xe;
    const me = D(oe);
    return (xe = me == null ? void 0 : me.required) != null ? xe : !1;
  }, G = (oe) => {
    oe === "firstName" && !c.value && (c.setError(
      n("captureform.error.first-name", "First Name is required")
    ), O(!0)), oe === "lastName" && !u.value && (u.setError(
      n("captureform.error.last-name", "Last Name is required")
    ), O(!0)), oe || (G("firstName"), G("lastName"));
  }, Z = () => {
    B("address") && ((!b.value || !x || !E || !N) && O(!0), b.value || b.setError(n("captureform.error.address", "Address is required")), x.value || x.setError(n("captureform.error.city", "City is required")), E.value || E.setError(n("captureform.error.state", "State is required")), N.value || N.setError(
      n("captureform.error.post-code", "Post code is required")
    ));
  }, K = () => {
    const oe = Nf(f.value);
    oe && (f.setError(oe), O(!0));
  }, q = () => {
    v.value || (v.setError(
      n("captureform.error.company-name", "Company name is required")
    ), O(!0));
  }, pe = () => {
    if (!y.value) {
      y.setError(
        n("captureform.error.phone-number", "Phone number is required")
      ), O(!0);
      return;
    }
    lle.test(y.value) || (y.setError(
      n("captureform.error.phone-number-invalid", "Phone number is invalid")
    ), O(!0));
  }, he = () => {
    m.value || (m.setError(
      n("captureform.error.birth-date", "Birth date is required")
    ), O(!0));
  }, _e = () => {
    const oe = o.map((me) => me.enabled && me.required && !me.value ? (O(!0), Xn(Fe({}, me), {
      error: n(
        "captureform.error.custom-question",
        "Answer on that question is required"
      )
    })) : Xn(Fe({}, me), { error: "" }));
    s(oe);
  }, ge = () => {
    O(!1), $("firstNameLastName") && B("firstNameLastName") && G(), $("address") && B("address") && Z(), $("email") && B("email") && K(), $("companyName") && B("companyName") && q(), $("phoneNumber") && B("phoneNumber") && pe(), $("birthDate") && B("birthDate") && he(), _e();
  }, Y = (oe, me) => {
    const xe = o.map((X) => Xn(Fe({}, X), {
      value: X.key === oe ? me.value : X.value
    }));
    s(xe);
  }, ee = (oe) => {
    if (oe.preventDefault(), ge(), !R) {
      const me = o.map((xe) => ({
        questionId: xe.key,
        question: xe.question,
        value: xe.value
      }));
      a(!0), X6({
        firstName: c.value,
        lastName: u.value,
        address: b.value,
        address2: b.value,
        city: x.value,
        state: E.value,
        postCode: N.value,
        email: f.value,
        birthDate: m.value,
        companyName: v.value,
        phoneNumber: y.value,
        customAnswers: me
      }).then(() => {
        a(!1), t();
      });
    }
  };
  return /* @__PURE__ */ C.jsx(C.Fragment, { children: /* @__PURE__ */ C.jsxs("form", { onSubmit: ee, noValidate: !0, children: [
    $("firstNameLastName") && /* @__PURE__ */ C.jsxs(OJ, { children: [
      /* @__PURE__ */ C.jsx(
        vc,
        {
          placeholder: n(
            "captureform.placeholder.first-name",
            "First Name"
          ),
          value: c.value,
          error: c.error,
          onChange: (oe) => c.setValue(oe),
          onBlur: () => G("firstName"),
          required: B("firstNameLastName")
        }
      ),
      /* @__PURE__ */ C.jsx(
        vc,
        {
          placeholder: n("captureform.placeholder.last-name", "Last Name"),
          value: u.value,
          error: u.error,
          onChange: (oe) => u.setValue(oe),
          onBlur: () => G("lastName"),
          required: B("firstNameLastName")
        }
      )
    ] }),
    $("email") && /* @__PURE__ */ C.jsx(
      Ppt,
      {
        label: n("captureform.placeholder.confirm-email", "Confirm Email"),
        value: f.value,
        error: f.error,
        onChange: (oe) => f.setValue(oe),
        onBlur: () => K(),
        required: B("email")
      }
    ),
    $("birthDate") && /* @__PURE__ */ C.jsx(
      Tpt,
      {
        label: n("captureform.placeholder.date-of-birth", "Date of Birth"),
        value: m.value,
        error: m.error,
        onChange: (oe) => m.setValue(oe),
        onBlur: () => he(),
        required: B("birthDate")
      }
    ),
    $("companyName") && /* @__PURE__ */ C.jsx(
      vc,
      {
        placeholder: n("captureform.placeholder.company", "Company"),
        value: v.value,
        error: v.error,
        onChange: (oe) => v.setValue(oe),
        onBlur: () => q(),
        required: B("companyName")
      }
    ),
    $("phoneNumber") && /* @__PURE__ */ C.jsx(
      vc,
      {
        placeholder: n(
          "captureform.placeholder.mobile-phone",
          "Mobile phone"
        ),
        value: y.value,
        error: y.error,
        onChange: (oe) => y.setValue(oe),
        onBlur: () => pe(),
        required: B("phoneNumber")
      }
    ),
    $("address") && /* @__PURE__ */ C.jsxs("div", { children: [
      /* @__PURE__ */ C.jsx(
        vc,
        {
          placeholder: n(
            "captureform.placeholder.addres-line-1",
            "Address line 1"
          ),
          value: b.value,
          error: b.error,
          onChange: (oe) => b.setValue(oe),
          onBlur: () => Z(),
          required: B("address")
        }
      ),
      /* @__PURE__ */ C.jsx(
        vc,
        {
          placeholder: n(
            "captureform.placeholder.address-line-2",
            "Address line 2"
          ),
          value: S.value,
          onChange: (oe) => S.setValue(oe)
        }
      ),
      /* @__PURE__ */ C.jsx(
        vc,
        {
          placeholder: n("captureform.placeholder.city", "City"),
          value: x.value,
          error: x.error,
          onChange: (oe) => x.setValue(oe),
          onBlur: () => Z(),
          required: B("address")
        }
      ),
      /* @__PURE__ */ C.jsxs(OJ, { children: [
        /* @__PURE__ */ C.jsx(
          vc,
          {
            placeholder: n(
              "captureform.placeholder.state-region",
              "State/Region"
            ),
            value: E.value,
            error: E.error,
            onChange: (oe) => E.setValue(oe),
            onBlur: () => Z(),
            required: B("address")
          }
        ),
        /* @__PURE__ */ C.jsx(
          vc,
          {
            placeholder: n(
              "captureform.placeholder.zip-postal-code",
              "ZIP/Postal code"
            ),
            value: N.value,
            error: N.error,
            onChange: (oe) => N.setValue(oe),
            onBlur: () => Z(),
            required: B("address")
          }
        )
      ] })
    ] }),
    o.map((oe) => oe.values.length === 1 && $(oe.key) ? /* @__PURE__ */ C.jsxs(BN, { children: [
      /* @__PURE__ */ C.jsx(RJ, { required: oe.required, children: oe.question }),
      /* @__PURE__ */ C.jsx(
        kf,
        {
          id: oe.key,
          onClickFn: () => Y(oe.key, {
            value: oe.value ? "" : oe.values[0].value,
            label: oe.value ? "" : oe.values[0].value
          }),
          isChecked: oe.value === oe.values[0].value,
          children: oe.values[0].value
        },
        oe.key
      ),
      /* @__PURE__ */ C.jsx(VN, { children: oe.error })
    ] }, oe.key) : oe.values.length === 2 && $(oe.key) ? /* @__PURE__ */ C.jsxs(BN, { children: [
      /* @__PURE__ */ C.jsx(RJ, { required: oe.required, children: oe.question }),
      /* @__PURE__ */ C.jsx(
        kf,
        {
          id: `${oe.key}-01`,
          onClickFn: () => Y(oe.key, {
            value: oe.values[0].value,
            label: oe.values[0].value
          }),
          isRadioButton: !0,
          isChecked: oe.value === oe.values[0].value,
          children: oe.values[0].value
        },
        `${oe.key}-01`
      ),
      /* @__PURE__ */ C.jsx(
        kf,
        {
          id: `${oe.key}-02`,
          onClickFn: () => Y(oe.key, {
            value: oe.values[1].value,
            label: oe.values[1].value
          }),
          isRadioButton: !0,
          isChecked: oe.value === oe.values[1].value,
          children: oe.values[1].value
        },
        `${oe.key}-02`
      ),
      /* @__PURE__ */ C.jsx(VN, { children: oe.error })
    ] }, oe.key) : oe.values.length > 2 && $(oe.key) ? /* @__PURE__ */ C.jsxs(BN, { children: [
      /* @__PURE__ */ C.jsx(
        Mpt,
        {
          label: oe.question,
          name: oe.key,
          value: oe.value ? { value: oe.value, label: oe.value } : null,
          values: oe.values,
          required: oe.required,
          onChange: Y
        }
      ),
      /* @__PURE__ */ C.jsx(VN, { children: oe.error })
    ] }, oe.key) : $(oe.key) ? /* @__PURE__ */ C.jsx(
      vc,
      {
        placeholder: oe.question,
        value: oe.value,
        error: oe.error,
        onChange: (me) => Y(oe.key, { value: me }),
        onBlur: () => _e(),
        required: oe.required
      },
      oe.key
    ) : /* @__PURE__ */ C.jsx("div", {})),
    /* @__PURE__ */ C.jsx(zt, { type: "submit", size: "big", theme: "confirm", margin: "10px 0", children: r ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : n("captureform.button.continue", "Continue") })
  ] }) });
}, Lpt = W.div.attrs(() => ({
  className: "msd__capture"
}))`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  position: relative;
`, $pt = W.div`
  position: relative;

  width: 100%;
  margin: 0 auto;
  padding: 80px 120px 120px;

  background-color: ${Br};

  text-align: center;

  ${pr.medium`
    padding-inline: 5%;
  `}

  ${pr.small`
    width: 80%;
  `}
`, jpt = W.div`
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;

  color: ${Et};
`, Fpt = () => null, Bpt = ({ settings: e = [], onSuccess: t = Fpt }) => {
  const { t: n } = tn(), [r, a] = mt([]), [o, s] = mt(!0);
  return mn(() => {
    e.length ? (a(e), s(!1)) : TR().then((c) => {
      c.responseData.shouldCaptureBeDisplayed === !0 ? (a(c.responseData.settings), s(!1)) : t();
    });
  }, []), /* @__PURE__ */ C.jsxs(Lpt, { children: [
    /* @__PURE__ */ C.jsx(pl, {}),
    /* @__PURE__ */ C.jsx($pt, { children: o ? /* @__PURE__ */ C.jsx(cr, {}) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(jpt, { children: n("capture.confirm-registration", "Confirm Registration") }),
      /* @__PURE__ */ C.jsx(
        Dpt,
        {
          settings: r || [],
          onSuccess: t
        }
      )
    ] }) }),
    !o && r && /* @__PURE__ */ C.jsx(yu, { isCheckout: !1 })
  ] });
}, Vpt = W.div.attrs(() => ({
  className: "msd__consents"
}))`
  * {
    box-sizing: border-box;
  }
  box-sizing: border-box;
  position: relative;
  background: ${Br};
`, Upt = W.div.attrs(() => ({
  className: "msd__consents__wrapper"
}))`
  position: relative;

  width: 55%;
  margin: 0 auto;
  padding-top: 80px;
  padding-bottom: 120px;

  text-align: center;

  ${pr.small`
  width: 80%;
`}
`, Gpt = W.h2.attrs(() => ({
  className: "msd__consents__title"
}))`
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  font-weight: 700;

  color: ${Et};
`, zpt = W.p.attrs(() => ({
  className: "msd__consents__subtitle"
}))`
  margin-bottom: 16px;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  font-weight: 700;

  color: ${Et};
  filter: brightness(1.7);
`, Hpt = W.ul.attrs(() => ({
  className: "msd__consents__list"
}))`
  margin-bottom: 36px;
  list-style: none;
`, Wpt = W.li``, DJ = W.div.attrs(() => ({
  className: "msd__consents__error"
}))`
  width: 100%;
  height: 13px;
  margin-top: 8px;
  content: '';
  color: ${wa};
  transition: 0.2s ease-in-out;
  font-size: 13px;
  text-align: left;

  ${(e) => e.center && ot`
      text-align: center;
    `}
`, _L = ({ onSuccess: e }) => {
  const { t } = tn(), [n, r] = mt(null), [a, o] = mt(!1), [s, c] = mt(!0), [u, f] = mt("");
  mn(() => {
    l2().then((b) => {
      const S = b.responseData.consents.filter(
        (x) => x.newestVersion > x.version || x.needsUpdate === !0
      );
      S.length === 0 ? e() : r(S);
    }).finally(() => c(!1));
  }, []);
  const m = (b, S, x) => {
    const E = n.map((N) => N.name === x.name ? Xn(Fe({}, N), {
      state: x.state === "accepted" ? "declined" : "accepted"
    }) : N);
    r(E);
  }, v = () => {
    let b = !1;
    const S = n.map((x) => x.required && x.state === "declined" ? (b = !0, Xn(Fe({}, x), {
      error: t(
        "checkout-consents.error.required",
        "This consent is required"
      )
    })) : x);
    return r(S), !b;
  }, y = () => {
    if (v()) {
      const b = n.map((S) => ({
        name: S.name,
        version: S.newestVersion,
        state: S.state
      }));
      o(!0), K6([], [], b).then(() => {
        o(!1), e();
      }).catch(() => {
        f(
          t(
            "checkout-consents.error.submit",
            "Something went wrong. Try again later"
          )
        );
      });
    }
  };
  return /* @__PURE__ */ C.jsx(C.Fragment, { children: /* @__PURE__ */ C.jsxs(Vpt, { children: [
    /* @__PURE__ */ C.jsx(pl, {}),
    /* @__PURE__ */ C.jsx(Upt, { children: s || !n ? /* @__PURE__ */ C.jsx(cr, {}) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(Gpt, { children: t("checkout-consents.title", "Terms & Conditions") }),
      /* @__PURE__ */ C.jsx(zpt, { children: t(
        "checkout-consents.subtitle",
        "Please accept Terms & Conditions"
      ) }),
      /* @__PURE__ */ C.jsxs(Hpt, { role: "list", children: [
        n.map((b) => /* @__PURE__ */ C.jsxs(Wpt, { children: [
          /* @__PURE__ */ C.jsx(
            kf,
            {
              isMyAccount: !0,
              id: b.name,
              onClickFn: (S, x) => m(S, x, b),
              isChecked: b.state === "accepted",
              required: b.required,
              children: ID(b.label, t)
            }
          ),
          /* @__PURE__ */ C.jsx(DJ, { children: b.error })
        ] }, b.name)),
        u && /* @__PURE__ */ C.jsx(DJ, { center: !0, children: u })
      ] }),
      /* @__PURE__ */ C.jsx(zt, { size: "big", theme: "confirm", onClickFn: y, children: a ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : t("checkout-consents.button.continue", "Continue") })
    ] }) }),
    !s && n && /* @__PURE__ */ C.jsx(yu, { isCheckout: !1 })
  ] }) });
};
_L.propTypes = {
  onSuccess: de.func
};
_L.defaultProps = {
  onSuccess: () => null
};
const Bce = W.div`
  position: relative;
  background: ${Br};
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
`, Zpt = W.main.attrs(() => ({
  className: "msd__reset-password"
}))`
  width: 100%;
  margin: 0 auto;
  padding: 40px 10%;

  color: ${Et};

  text-align: center;
  line-height: 1.3em;
  font-size: 15px;

  font-weight: bold;
  & button {
    margin-top: 30px;
  }

  ${pr.smallest`
    width:90%;
    & button {
      margin-top: 50px;
    }
  `}
`, Ypt = W.div.attrs(() => ({
  className: "msd__reset-password__title"
}))`
  margin: 40px 0 25px 0;

  font-size: 25px;
  font-weight: 600;
`, Xpt = W.div.attrs(() => ({
  className: "msd__reset-password__message"
}))`
  font-weight: 300;
  & strong {
    font-weight: bold;
  }
`, Kpt = W.form.attrs(() => ({
  className: "msd__reset-password__form"
}))`
  width: 80%;

  margin: 30px auto 50px auto;

  ${pr.smallest`
    width:100%;
  `}
`;
class CL extends Nc {
  constructor(n) {
    super(n);
    Er(this, "onSubmit", (n) => st(this, null, function* () {
      n.preventDefault();
      const r = En("CLEENG_PUBLISHER_ID"), { value: a } = this.state, { onSuccess: o, t: s } = this.props, {
        publisherConfig: { resetUrl: c }
      } = Mo.getState();
      if (this.validateFields()) {
        this.setState({
          processing: !0
        });
        const u = yield KQ(a, r, c);
        u.errors.length ? u.status === 429 ? (this.setState({
          overloaded: !0,
          processing: !1,
          message: s(
            "password-reset.error.server-overloaded",
            "Server overloaded. Please try again later."
          )
        }), setTimeout(() => {
          this.setState({
            overloaded: !1,
            message: ""
          });
        }, 10 * 1e3)) : this.setState({
          processing: !1,
          message: s(u.errors[0])
        }) : (Ba("CLEENG_CUSTOMER_EMAIL", a), o(a));
      }
      return !0;
    }));
    this.state = {
      value: "",
      message: "",
      processing: !1,
      overloaded: !1
    };
  }
  validateFields() {
    const { value: n } = this.state, { t: r } = this.props, a = {
      email: sle.test(n) ? "" : r(
        "password-reset.error.invalid-email",
        "This address does not seem to have a normal email format."
      )
    };
    return this.setState({
      message: a.email
    }), !Object.keys(a).find((o) => a[o] !== "");
  }
  render() {
    const { value: n, message: r, processing: a, overloaded: o } = this.state, { t: s } = this.props;
    return /* @__PURE__ */ C.jsxs(Bce, { children: [
      /* @__PURE__ */ C.jsx(pl, {}),
      /* @__PURE__ */ C.jsxs(Zpt, { children: [
        /* @__PURE__ */ C.jsx(Ypt, { children: s("password-reset.error.title", "Forgot your password?") }),
        /* @__PURE__ */ C.jsx(Xpt, { children: s(
          "password-reset.error.message",
          "Just enter your email address below and we will send you a link to reset your password"
        ) }),
        /* @__PURE__ */ C.jsxs(Kpt, { onSubmit: this.onSubmit, noValidate: !0, children: [
          /* @__PURE__ */ C.jsx(
            pC,
            {
              label: s("password-reset.label.email", "Email"),
              error: r,
              value: n,
              onChange: (c) => this.setState({ value: c })
            }
          ),
          /* @__PURE__ */ C.jsx(
            zt,
            {
              type: "submit",
              theme: "confirm",
              size: "big",
              disabled: a || o,
              children: a ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : s("password-reset.button.reset-password", "Reset Password")
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ C.jsx(yu, {})
    ] });
  }
}
CL.propTypes = {
  onSuccess: de.func.isRequired,
  urlProps: de.shape({
    location: de.shape({
      search: de.string,
      state: de.shape({
        fromMyAccount: de.bool
      })
    })
  }),
  t: de.func
};
CL.defaultProps = {
  urlProps: {},
  t: (e) => e
};
const qpt = o1()(CL), Jpt = W.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0 80px 0;

  > button {
    max-width: 320px;
    margin-top: 96px;
  }
`, Qpt = W.div`
  font-size: 15px;
  font-weight: 300;
  text-align: center;
  max-width: 530px;
  color: ${Et};
  width: 100%;

  p {
    font-weight: 500;
    text-align: center;
  }
`, eht = W.div`
  margin-top: 24px;

  a {
    font-weight: 500;
  }
`, tht = W.h2`
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  margin: 40px 0 24px 0;
  color: ${Et};
`, nht = () => {
  const { t: e } = tn();
  return /* @__PURE__ */ C.jsxs(Jpt, { children: [
    /* @__PURE__ */ C.jsx(eL, {}),
    /* @__PURE__ */ C.jsx(tht, { children: e("redeem-gift.thank-you-page.header", "Thank You!") }),
    /* @__PURE__ */ C.jsxs(Qpt, { children: [
      /* @__PURE__ */ C.jsx("p", { children: e(
        "redeem-gift.thank-you-page.manage-text1",
        "Your gift have been successfully redeemed."
      ) }),
      e(
        "redeem-gift.thank-you-page.payment-method-text",
        "We hope you love it. Remember that in order to keep your access after your gift expires, you will need to add a payment method to your account."
      ),
      /* @__PURE__ */ C.jsx(eht, { children: /* @__PURE__ */ C.jsxs(Ia, { i18nKey: "redeem-gift.thank-you-page.manage-text2", children: [
        "If you need help from us with your account, you can always find it",
        /* @__PURE__ */ C.jsx(
          _2,
          {
            href: En("CLEENG_MY_ACCOUNT_URL"),
            target: "_blank",
            rel: "noopener noreferrer",
            children: "here."
          }
        )
      ] }) })
    ] })
  ] });
}, rht = W.div`
  position: relative;
  background: ${Br};
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
`, aht = W.div`
  display: flex;
  flex-direction: column;
  padding: 34px 40px 92px 40px;
  align-items: center;
  width: 100%;
  position: relative;

  > button {
    max-width: 320px;
    align-self: center;
  }
`, oht = W.div`
  display: flex;
  position: relative;
  width: 100%;
  max-width: 562px;

  .msd__account-input__wrapper {
    flex: 1;
  }

  .msd__error {
    color: ${wa};
  }

  .msd__button {
    height: 33px;
    position: absolute;
    right: 0;
    top: 14px;
    right: 2px;
    max-width: 96px;
    border-radius: 4px;
    background-color: ${Et};
  }
`, iht = W.div`
  width: 100%;
  max-width: 562px;
  background: ${Br};
  border: 1px solid ${Gn};
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 33px;
`, sht = ({ onBackClick: e, onSuccess: t }) => {
  const [n, r] = mt(""), [a, o] = mt(!1), [s, c] = mt(!1), { t: u } = tn(), f = Va(), {
    error: m,
    isRedeemLoading: v,
    isVerifyLoading: y,
    verifiedGift: { redeemable: b }
  } = Ot(q6), { loading: S } = Ot(k2), x = (D) => r(D.target.value), E = () => st(void 0, null, function* () {
    const { offerId: D } = yield f($x(n)).unwrap().catch(($) => {
      throw o(!1), new Error($);
    });
    D && (o(!0), yield f(M4(D)), yield f(D4(D.split("_")[0])));
  }), N = () => st(void 0, null, function* () {
    yield f(jx(n)).unwrap().catch((D) => {
      throw new Error(D);
    }), c(!0);
  });
  mn(() => {
    const $ = new URLSearchParams(window.location.search).get("giftCode");
    $ && r($);
  }, [window.location.search]), mn(() => {
    let D;
    return s && (D = setTimeout(() => {
      t();
    }, 3e3)), () => clearTimeout(D);
  }, [s]);
  const R = !b || y || S, O = () => Ec.isLogged() ? s ? /* @__PURE__ */ C.jsx(nht, {}) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(aht, { children: [
      /* @__PURE__ */ C.jsx(Xi, { center: !0, paddingBottom: "10px", children: u("redeem-gift.button.header", "Redeem your gift") }),
      /* @__PURE__ */ C.jsxs(oht, { children: [
        /* @__PURE__ */ C.jsx(
          du,
          {
            error: m,
            onChange: x,
            name: "giftCode",
            type: "text",
            value: n,
            placeholder: "XXXX-XXXX"
          }
        ),
        /* @__PURE__ */ C.jsx(
          zt,
          {
            disabled: !n,
            theme: "confirm",
            onClickFn: E,
            children: y ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : u("redeem-gift.button.verify", "Verify")
          }
        )
      ] }),
      a && /* @__PURE__ */ C.jsx(iht, { children: /* @__PURE__ */ C.jsx(Cle, { isRedeemGift: !0 }) }),
      /* @__PURE__ */ C.jsx(
        zt,
        {
          disabled: R,
          theme: "confirm",
          onClickFn: N,
          children: v ? /* @__PURE__ */ C.jsx(cr, { buttonLoader: !0, color: "#ffffff" }) : u("redeem-gift.button.confirm", "Confirm & proceed")
        }
      )
    ] }),
    /* @__PURE__ */ C.jsx(yu, {})
  ] }) : (ur(i_, {
    source: "RedeemGift"
  }), /* @__PURE__ */ C.jsx(wle, { type: "isNotAuth", isRedeemGift: !0 }));
  return /* @__PURE__ */ C.jsxs(rht, { children: [
    /* @__PURE__ */ C.jsx(pl, { onBackClick: e }),
    O()
  ] });
}, lht = W.div`
  width: 80%;
  margin: 0 auto;
  padding: 40px 0 60px 0;
  text-align: center;
  line-height: 1.3em;
  font-size: 15px;
  color: ${Et};

  font-weight: bold;
`, uht = W.div`
  font-size: 25px;
  margin-top: 35px;
  margin-bottom: 25px;
  font-weight: 600;
`, cht = W.div`
  font-weight: 300;
  & strong {
    font-weight: bold;
  }
`;
W.span`
  color: ${Et};
  font-weight: bold;
  &:hover {
    text-decoration: underline;
  }
`;
const dht = W.div`
  margin: 5px auto 20px;
  font-size: 13px;
`, fht = W.div`
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-color: #5cb85c;
  position: relative;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: 7em;
  height: 7em;
  transition: border 500ms ease-out;
`, pht = AR`
    0% {
      height: 0;
      width: 0;
      opacity: 1;
    }

    20% {
      height: 0;
      width: 1.75em;
      opacity: 1;
    }

    40% {
      height: 3.5em;
      width: 1.75em;
      opacity: 1;
    }

    100% {
      height: 3.5em;
      width: 1.75em;
      opacity: 1;
    }
  `, hht = W.div`
  animation-duration: 800ms;
  animation-timing-function: ease;
  animation-name: ${pht};
  transform: scaleX(-1) rotate(135deg);
  opacity: 1;
  height: 3.5em;
  width: 1.75em;
  transform-origin: left top;
  border-right: 3px solid #5cb85c;
  border-top: 3px solid #5cb85c;
  content: '';
  left: 1.75em;
  top: 3.5em;
  position: absolute;
`, wL = ({ email: e, resetPasswordCallback: t }) => {
  const { t: n } = tn();
  return /* @__PURE__ */ C.jsxs(Bce, { children: [
    /* @__PURE__ */ C.jsx(pl, {}),
    /* @__PURE__ */ C.jsxs(lht, { children: [
      /* @__PURE__ */ C.jsx(fht, { children: /* @__PURE__ */ C.jsx(hht, {}) }),
      /* @__PURE__ */ C.jsx(uht, { children: n("password-reset-success.title", "Password link sent") }),
      /* @__PURE__ */ C.jsx(cht, { children: e ? n(
        "password-reset-success.check-inbox-with-email",
        "Please check your inbox at {{email}}",
        { email: e }
      ) : n(
        "password-reset-success.check-inbox",
        "Please check your inbox"
      ) }),
      /* @__PURE__ */ C.jsxs(dht, { children: [
        /* @__PURE__ */ C.jsx(zt, { theme: "link", onClickFn: t, children: n(
          "password-reset-success.button.back",
          "Go back to the login page"
        ) }),
        " "
      ] })
    ] }),
    /* @__PURE__ */ C.jsx(yu, {})
  ] });
};
wL.propTypes = {
  email: de.string.isRequired,
  resetPasswordCallback: de.func
};
wL.defaultProps = {
  resetPasswordCallback: () => null
};
const Pp = {
  LOGIN: {
    stepNumber: 0,
    nextStep: 2
  },
  REGISTER: {
    stepNumber: 1,
    nextStep: 2
  },
  CAPTURE: {
    stepNumber: 2,
    nextStep: 3
  },
  CONSENTS: {
    stepNumber: 3,
    nextStep: 4
  },
  PURCHASE: {
    stepNumber: 4,
    nextStep: 5
  },
  PASSWORD_SUCCESS: {
    stepNumber: 6,
    nextStep: 7
  },
  REDEEM_GIFT: {
    stepNumber: 8
  }
};
class SL extends Nc {
  constructor(n) {
    super(n);
    Er(this, "goToStep", (n) => {
      this.setState({
        currentStep: n
      });
    });
    this.state = {
      currentStep: 0,
      giftCode: ""
    };
  }
  componentDidMount() {
    const { initValues: n, offerId: r, adyenConfiguration: a } = this.props, s = new URLSearchParams(window.location.search).get("giftCode");
    s && this.setState({
      giftCode: s
    }), n({
      offerId: r,
      adyenConfiguration: a
    }), Ec.isLogged() && this.setState({
      currentStep: 3
    });
  }
  render() {
    const { currentStep: n, giftCode: r } = this.state, {
      couponCode: a,
      onSuccess: o,
      offerId: s,
      resetPasswordCallback: c,
      hideRedeemButton: u
    } = this.props;
    switch (n) {
      case 0:
        return /* @__PURE__ */ C.jsx(
          Ple,
          {
            onSuccess: () => this.goToStep(Pp.LOGIN.nextStep),
            onRegisterClick: () => this.goToStep(1),
            onPasswordResetClick: () => this.goToStep(6)
          }
        );
      case 1:
        return /* @__PURE__ */ C.jsx(
          lat,
          {
            onSuccess: () => this.goToStep(Pp.REGISTER.nextStep),
            onHaveAccountClick: () => this.goToStep(0)
          }
        );
      case 2:
        return /* @__PURE__ */ C.jsx(
          Bpt,
          {
            onSuccess: () => this.goToStep(Pp.CAPTURE.nextStep)
          }
        );
      case 3:
        return /* @__PURE__ */ C.jsx(
          _L,
          {
            onSuccess: () => r ? this.goToStep(Pp.REDEEM_GIFT.stepNumber) : this.goToStep(Pp.CONSENTS.nextStep)
          }
        );
      case 4:
        return /* @__PURE__ */ C.jsx(
          zrt,
          {
            isCheckout: !0,
            offerId: s,
            couponCode: a,
            onSuccess: () => this.goToStep(Pp.PURCHASE.nextStep),
            onRedeemClick: () => this.goToStep(Pp.REDEEM_GIFT.stepNumber),
            hideRedeemButton: u
          }
        );
      case 5:
        return /* @__PURE__ */ C.jsx(U8, { onSuccess: o });
      case 6:
        return /* @__PURE__ */ C.jsx(
          qpt,
          {
            onSuccess: () => this.goToStep(Pp.PASSWORD_SUCCESS.nextStep)
          }
        );
      case 7:
        return /* @__PURE__ */ C.jsx(
          wL,
          {
            email: En("CLEENG_CUSTOMER_EMAIL"),
            resetPasswordCallback: c
          }
        );
      case 8:
        return /* @__PURE__ */ C.jsx(
          sht,
          {
            onBackClick: () => {
              this.goToStep(Pp.PURCHASE.stepNumber);
            },
            onSuccess: o
          }
        );
      default:
        return null;
    }
  }
}
SL.propTypes = {
  adyenConfiguration: de.objectOf(de.any),
  couponCode: de.oneOfType([de.string, void 0, null]),
  hideRedeemButton: de.bool,
  initValues: de.func.isRequired,
  offerId: de.string,
  onSuccess: de.func,
  resetPasswordCallback: de.func
};
SL.defaultProps = {
  adyenConfiguration: null,
  couponCode: void 0,
  hideRedeemButton: !1,
  offerId: null,
  onSuccess: () => null,
  resetPasswordCallback: () => null
};
const mht = (e) => ({
  initValues: (t) => {
    e($u(t));
  }
}), Eht = V6(null, mht)(SL);
typeof window != "undefined" && (window.onload = () => {
  const e = window.location.search, n = new URLSearchParams(e).get("externalPaymentId");
  n && ur(M7, {
    payment: {
      externalPaymentId: n
    }
  });
});
export {
  Ec as Auth,
  Bpt as Capture,
  Uu as Card,
  Eht as Checkout,
  _L as CheckoutConsents,
  wht as Config,
  Ple as Login,
  Sht as MyAccount,
  $ce as Offers,
  qpt as PasswordReset,
  zlt as PaymentInfo,
  $st as PlanDetails,
  zrt as Purchase,
  sht as RedeemGift,
  lat as Register,
  jce as SubscriptionSwitches,
  $ce as Subscriptions,
  U8 as ThankYouPage,
  xht as TransactionList,
  Jft as UpdateProfile,
  Mo as store
};
